
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("6Kdw4", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClientPromise", () => $8abcffbae21b9b07$export$799525ac94ca811d);
$parcel$export(module.exports, "resolveAnalyticsWebClientPromise", () => $8abcffbae21b9b07$export$2b194038750b3976);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $8abcffbae21b9b07$var$markAnalyticsClientAsReady;
const $8abcffbae21b9b07$var$analyticsClientPromise = new Promise((resolve)=>{
    $8abcffbae21b9b07$var$markAnalyticsClientAsReady = resolve;
});
const $8abcffbae21b9b07$export$799525ac94ca811d = ()=>$8abcffbae21b9b07$var$analyticsClientPromise;
const $8abcffbae21b9b07$export$2b194038750b3976 = (client)=>$8abcffbae21b9b07$var$markAnalyticsClientAsReady(client);

});

parcelRegister("i860n", function(module, exports) {
$parcel$export(module.exports, "withoutFeatureExistenceCheck", () => $d73cebfbf74dc498$export$ede4c4e7e9dad3f2);
$parcel$export(module.exports, "fg", () => $d73cebfbf74dc498$export$b40ec24ac8275656);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4LDqh = parcelRequire("4LDqh");

var $hbvZL = parcelRequire("hbvZL");

var $hjhet = parcelRequire("hjhet");

var $fEmTm = parcelRequire("fEmTm");

var $gXtG2 = parcelRequire("gXtG2");

var $gIMgJ = parcelRequire("gIMgJ");
class $d73cebfbf74dc498$var$ErrorPointingUp extends Error {
    constructor(message){
        super(message);
        // Capture the stack without the error construction
        if (this.stack) {
            const stackLines = this.stack.split('\n');
            // Remove the error creation line and preserve caller stack
            // 1 - checkIfGateExists
            // 2 - featureGate
            // 3 - fg
            this.stack = [
                ...stackLines.slice(3)
            ].join('\n');
        }
    }
}
$d73cebfbf74dc498$var$ErrorPointingUp.displayName = "ErrorPointingUp";
const $d73cebfbf74dc498$var$checkedGates = new Set();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $d73cebfbf74dc498$var$checkedGates.clear();
});
const $d73cebfbf74dc498$var$checkIfGateExists = (gateName)=>{
    // perform early exist to minimize performance impact
    if ($d73cebfbf74dc498$var$checkedGates.has(gateName)) return;
    $d73cebfbf74dc498$var$checkedGates.add(gateName);
    if ((0, $4LDqh.default).checkGate('jfp_magma_jira-report-incorrect-gates', {
        fireGateExposure: false
    })) {
        if (!(0, $4LDqh.default).isGateExists(gateName)) {
            const error = new $d73cebfbf74dc498$var$ErrorPointingUp(`Feature gate ${gateName} does not exist`);
            (0, $fEmTm.captureException)('FeatureGates.isGateExists', error);
            // eslint-disable-next-line no-console
            console.error(`Feature gate ${gateName} does not exist in StatSig. It was archived or hasn't been created yet`);
        }
    }
};
let $d73cebfbf74dc498$var$shouldPerformGateExistenceCheck = true;
const $d73cebfbf74dc498$export$ede4c4e7e9dad3f2 = (fn)=>{
    $d73cebfbf74dc498$var$shouldPerformGateExistenceCheck = false;
    const result = fn();
    $d73cebfbf74dc498$var$shouldPerformGateExistenceCheck = true;
    return result;
};
const $d73cebfbf74dc498$var$featureGate = (gateName)=>{
    // Handle vendorless scripts use of gates
    (0, $hjhet.UNSAFE_initIfNeeded)();
    const value = (0, $4LDqh.default).checkGate(gateName);
    (0, $hbvZL.addFeatureFlagAccessed)(gateName, value);
    if ($d73cebfbf74dc498$var$shouldPerformGateExistenceCheck) $d73cebfbf74dc498$var$checkIfGateExists(gateName);
    return value;
};
const $d73cebfbf74dc498$export$b40ec24ac8275656 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    /**
	 * On server: These overrides are set by the server-side code in jira/src/entry-fs
	 * On client: Check SSR overrides on client-side for shareable debug URLs
	 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
    if (false) {
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This is the codepath before _statsigValues is initilaised.
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar.__SSR_SYNC_FG__ === 'function' && // if global variable is ready, then don't reach out to native
        !globalVar._statsigValuesReady) return globalVar.__SSR_SYNC_FG__(gateName);
        return $d73cebfbf74dc498$var$featureGate(gateName);
    }
    if (globalVar.__MCOND_EVALUATED && gateName in globalVar.__MCOND_EVALUATED) {
        const serverResult = globalVar.__MCOND_EVALUATED[gateName];
        const browserResult = $d73cebfbf74dc498$var$featureGate(gateName);
        if (serverResult !== browserResult) {
            let errorMessage = `Conditional import mismatch (returning server result), cond: ${gateName}, ${browserResult} !== ${serverResult} (browser !== server).`;
            if ($gIMgJ?.env?.NODE_ENV === 'development' || globalThis.BUILD_KEY?.startsWith('MRJF-BB')) errorMessage = `${errorMessage} Do not introduce this error into the codebase. Please see https://hello.atlassian.net/wiki/x/_hjGRAE for details and context.`;
            else {
                // We can proceed with the server result, but we should log the error to help us debug the issue
                // eslint-disable-next-line no-console
                console.error(errorMessage);
                (0, $fEmTm.captureException)('FeatureGates.fg', new Error('Conditional import mismatch (returning server result)'), {
                    teamName: 'uip-app-framework-bundler',
                    gateName: gateName,
                    serverResult: serverResult.toString(),
                    browserResult: browserResult.toString()
                });
            }
        }
        // Return the server-evaluated result
        return globalVar.__MCOND_EVALUATED[gateName];
    }
    return $d73cebfbf74dc498$var$featureGate(gateName);
};
const $d73cebfbf74dc498$var$featureGateNoExposure = (gateName)=>{
    if (false) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const globalVar = typeof window !== 'undefined' ? window : globalThis;
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This is the codepath before _statsigValues is initilaised.
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar?.__SSR_SYNC_FG__ === 'function' && // if global variable is ready, then don't reach out to native
        // API, stay within js runtime as it is faster
        !globalVar._statsigValuesReady) return globalVar.__SSR_SYNC_FG__(gateName);
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    // Check SSR overrides on client-side for shareable debug URLs
    // These overrides are set by SSR from URL params (e.g., ?fg=flag_name:true)
    if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
    // Handle vendorless scripts use of gates
    (0, $hjhet.UNSAFE_initIfNeeded)();
    const value = (0, $4LDqh.default).checkGate(gateName, {
        fireGateExposure: false
    });
    return value;
};
const $d73cebfbf74dc498$export$c7fa95c00de0c062 = (gateName)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    if (false) {
        /**
		 * These overrides are set by the server-side code in jira/src/entry-fs
		 */ if (globalVar?.__SSR_STATSIG_OVERRIDES__?.gates?.[gateName] !== undefined) return globalVar.__SSR_STATSIG_OVERRIDES__.gates[gateName];
        // for smoke tests to test when all gates are on
        if (globalVar?.__SSR_STATSIG_OVERRIDES__?.allGatesTrue) return true;
        /**
		 * This function is defined within jira/src/entry-fs
		 */ if (typeof globalVar.__SSR_SYNC_FG_NO_EXPOSURE__ === 'function') return globalVar.__SSR_SYNC_FG_NO_EXPOSURE__(gateName);
    }
    return $d73cebfbf74dc498$var$featureGateNoExposure(gateName);
};

});
parcelRegister("hjhet", function(module, exports) {
$parcel$export(module.exports, "UNSAFE_initIfNeeded", () => $64a38f7c69f65ca0$export$c9517ca8c289160f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $dJ3NQ = parcelRequire("dJ3NQ");

var $4LDqh = parcelRequire("4LDqh");
var $jNPuf = parcelRequire("jNPuf");

var $6bEm8 = parcelRequire("6bEm8");

var $aFBfN = parcelRequire("aFBfN");

var $7IT3k = parcelRequire("7IT3k");

var $eiBCS = parcelRequire("eiBCS");
// This script is part of early scripts, where analytics clients are too heavy to be included.
// Therefore, we just record the error in a global variable. Downstream code will report this.
const $64a38f7c69f65ca0$var$captureStatsigInitError = (error)=>{
    (0, $eiBCS.setUnreportedStatsigInitialisationError)(new Error('Statsig initialisation failed', {
        cause: error
    }));
};
const $64a38f7c69f65ca0$var$initIfNeeded = ()=>{
    if (!(0, $4LDqh.default).initializeCalled()) try {
        const gateValues = (0, $7IT3k.getGateValues)();
        const initPromise = (0, $4LDqh.default).initializeFromValues({
            sdkKey: 'client-7hFqlBhHaY5b2zA7LaaHDy1QKH7yZigbikmrwNpCuRy',
            // this environment variable is defined in webpack.config.js
            environment: (0, $6bEm8.default)('ajs-environment') === 'prod' ? (0, $jNPuf.FeatureGateEnvironment).Production : (0, $jNPuf.FeatureGateEnvironment).Staging,
            targetApp: 'jira_web',
            // Enable exposure firing from server side
            ...false && !(0, $dJ3NQ.default)() ? {
                ignoreWindowUndefined: true
            } : null
        }, {
            // These getMeta functions should only be called once due to performance implications
            // Ideally we should get these passed through from react which memoizes this call already
            atlassianAccountId: (0, $6bEm8.default)('ajs-atlassian-account-id') || undefined,
            tenantId: (0, $6bEm8.default)('ajs-cloud-id') ?? undefined,
            atlassianOrgId: (0, $6bEm8.default)('ajs-org-id') ?? undefined
        }, (0, $7IT3k.getCustomAttributes)(), gateValues);
        initPromise.catch($64a38f7c69f65ca0$var$captureStatsigInitError);
    } catch (error) {
        $64a38f7c69f65ca0$var$captureStatsigInitError(error);
        if (error instanceof Error) // eslint-disable-next-line no-console
        console.error('statsig.client.initialization', error.message);
    }
};
const $64a38f7c69f65ca0$export$c9517ca8c289160f = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    // If on entry-fs, we need to check if the statsig values are ready
    // Mainly avoid the statsig initialisation is trying to use a default value
    // which is an empty object.
    if ((0, $aFBfN.IS_MODERN_SSR) && globalVar._statsigValuesReady !== true) return;
    $64a38f7c69f65ca0$var$initIfNeeded();
};

});
parcelRegister("dJ3NQ", function(module, exports) {
$parcel$export(module.exports, "default", () => $0f48e10b8a18d164$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - process.env types are cursed
const $0f48e10b8a18d164$var$pillarLocalDev = false;
function $0f48e10b8a18d164$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    globalThis.localDevContext?.PILLAR_LOCAL_DEVELOPMENT ?? $0f48e10b8a18d164$var$pillarLocalDev);
}

});

parcelRegister("6bEm8", function(module, exports) {
$parcel$export(module.exports, "getMeta", () => $8027ba0daf92c714$export$c47913ca32a5c6f7);
$parcel$export(module.exports, "default", () => $8027ba0daf92c714$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $8027ba0daf92c714$export$c47913ca32a5c6f7 = (name)=>{
    // In Jira SSR, we store metadata on globalThis so we read from there
    if (false) {
        const globalThisWithMetadata = globalThis;
        const value = globalThisWithMetadata.ssr__metadata && globalThisWithMetadata.ssr__metadata[name];
        return value !== undefined ? value : null;
    }
    // In Jira FE client, metadata is provided via `meta` tags in the document so we read from there
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector(`meta[name="${name}"]`);
    const metaValue = node && node.getAttribute('content');
    return metaValue !== undefined ? metaValue : null;
};
var $8027ba0daf92c714$export$2e2bcd8739ae039 = $8027ba0daf92c714$export$c47913ca32a5c6f7;

});

parcelRegister("aFBfN", function(module, exports) {
$parcel$export(module.exports, "IS_MODERN_SSR", () => $a1628c314977165e$export$19d68f5aa485d903);
/* eslint-disable jira/filename-case, jira/jira-ssr/no-server-variable */ // This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $a1628c314977165e$export$19d68f5aa485d903 = (typeof false !== 'undefined' ? false : false) && false;

});

parcelRegister("7IT3k", function(module, exports) {
$parcel$export(module.exports, "getCustomAttributes", () => $3e6d30ba7de38b5f$export$1ef2b1f78c9e40d9);
$parcel$export(module.exports, "getGateValues", () => $3e6d30ba7de38b5f$export$fc7c61934a5b05);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6bEm8 = parcelRequire("6bEm8");

var $bMqRl = parcelRequire("bMqRl");
const $3e6d30ba7de38b5f$export$1ef2b1f78c9e40d9 = ()=>({
        ...(0, $bMqRl.getProductEditions)(),
        exposureSource: false ? 'server' : 'client'
    });
const $3e6d30ba7de38b5f$var$valuesFromGlobal = (()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    return {
        locator: ()=>'_statsigValues' in globalVar,
        processor: ()=>globalVar._statsigValues
    };
})();
const $3e6d30ba7de38b5f$var$valuesFromMeta = (()=>{
    // If parsing fails once, it will always fail. Avoid overhead of parsing again & again.
    let parsingFailed = false;
    const locator = ()=>{
        if (parsingFailed) return null;
        const statsigValues = (0, $6bEm8.default)('ajs-fe-statsig-values');
        try {
            const statsigValues2 = (0, $6bEm8.default)('ajs-fe-statsig-values-2');
            if (statsigValues && statsigValues2) {
                const statsigValuesObject = JSON.parse(statsigValues);
                const statsigValues2Object = JSON.parse(statsigValues2);
                Object.assign(statsigValuesObject.feature_gates, statsigValues2Object);
                return JSON.stringify(statsigValuesObject);
            }
            return statsigValues;
        } catch (e) {
            return statsigValues;
        }
    };
    return {
        locator: locator,
        processor: ()=>{
            if (parsingFailed) throw new Error("Can't parse 'ajs-fe-statsig-values' value");
            const featureFlags = locator();
            if (featureFlags != null && featureFlags !== '') {
                globalThis.performance?.mark?.('statsig-parse:start');
                try {
                    const result = JSON.parse(featureFlags);
                    globalThis.performance?.mark?.('statsig-parse:end');
                    return result;
                } catch  {
                    parsingFailed = true;
                    throw new Error("Can't parse 'ajs-fe-statsig-values' value");
                }
            }
        }
    };
})();
const $3e6d30ba7de38b5f$export$8ece9c90e8293278 = ()=>{
    return Boolean($3e6d30ba7de38b5f$var$valuesFromGlobal.locator() || $3e6d30ba7de38b5f$var$valuesFromMeta.locator());
};
const $3e6d30ba7de38b5f$export$fc7c61934a5b05 = ()=>{
    if ($3e6d30ba7de38b5f$var$valuesFromGlobal.locator()) return $3e6d30ba7de38b5f$var$valuesFromGlobal.processor();
    if ($3e6d30ba7de38b5f$var$valuesFromMeta.locator()) return $3e6d30ba7de38b5f$var$valuesFromMeta.processor();
    return undefined;
};

});
parcelRegister("bMqRl", function(module, exports) {
$parcel$export(module.exports, "getProductEditions", () => $a4500cffd05fdb5b$export$61e1423c6d76fbe3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6bEm8 = parcelRequire("6bEm8");
const $a4500cffd05fdb5b$var$TAP_VALUES = {
    f: 'free',
    s: 'standard',
    p: 'premium'
};
const $a4500cffd05fdb5b$var$getTapValue = (editionShorthand)=>$a4500cffd05fdb5b$var$TAP_VALUES[editionShorthand] ?? 'UNLICENSED';
const $a4500cffd05fdb5b$export$61e1423c6d76fbe3 = ()=>{
    try {
        const tenantContextEditions = JSON.parse((0, $6bEm8.default)('ajs-product-editions') || '{}');
        return {
            'jira-software_edition': $a4500cffd05fdb5b$var$getTapValue(tenantContextEditions['jira-software']),
            'jira-servicedesk_edition': $a4500cffd05fdb5b$var$getTapValue(tenantContextEditions['jira-servicedesk']),
            'jira-workmanagement_edition': $a4500cffd05fdb5b$var$getTapValue(tenantContextEditions['jira-core'])
        };
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return {
            'jira-software_edition': 'UNLICENSED',
            'jira-servicedesk_edition': 'UNLICENSED',
            'jira-workmanagement_edition': 'UNLICENSED'
        };
    }
};

});


parcelRegister("eiBCS", function(module, exports) {
$parcel$export(module.exports, "unreportedStatsigInitialisationError", () => $55d2adbf52995990$export$2f1d868dc4cd45f5);
$parcel$export(module.exports, "setUnreportedStatsigInitialisationError", () => $55d2adbf52995990$export$f0253a32470c87a6);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line import/no-mutable-exports
let $55d2adbf52995990$export$2f1d868dc4cd45f5;
const $55d2adbf52995990$export$f0253a32470c87a6 = (error)=>{
    $55d2adbf52995990$export$2f1d868dc4cd45f5 = error;
};

});


parcelRegister("fEmTm", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $d497b06f93858b35$export$f5282963edea4a68);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aHimX = parcelRequire("aHimX");
const $d497b06f93858b35$export$f5282963edea4a68 = (location, error, details = {})=>false ? undefined : (0, $aHimX.captureException)(location, error, details);

});
parcelRegister("aHimX", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $49717cd34e184830$export$f5282963edea4a68);
/* eslint-disable jira/filename-case */ 
var $dmS7i = parcelRequire("dmS7i");
// structured tags that we send to Sentry
// everything else from details object will go into "extras"
const $49717cd34e184830$var$tags = [
    'packageName',
    'teamName',
    'hash',
    'userLocation'
];
const $49717cd34e184830$var$teamsToFingerprint = [
    'gryffindor',
    'jira-werewolves'
];
const $49717cd34e184830$export$f5282963edea4a68 = (location, error, details)=>{
    if (!error) return;
    (0, $dmS7i.withScope)((scope)=>{
        scope.setTag('logger', location);
        // Experimenting with sentry fingerprint for gryffindor team only
        // This is being done to improve the efficiency of sentry error segregation
        const shouldUseFingerprint = $49717cd34e184830$var$teamsToFingerprint.includes(details?.teamName ?? '') || location && location.startsWith('jiraIssueCreate');
        if (shouldUseFingerprint) {
            const fingerprint = [
                // using {{ default }} as the first value to ensure that we are not
                // completely overriding the fingerprint from Sentry
                // https://docs.sentry.io/platforms/javascript/enriching-events/fingerprinting/#group-errors-with-greater-granularity
                '{{ default }}',
                error.name,
                error.message,
                location
            ].filter((part)=>Boolean(part));
            scope.setFingerprint(fingerprint);
        }
        if (details) Object.keys(details).forEach((key)=>{
            if ($49717cd34e184830$var$tags.includes(key)) {
                const tagValue = details[key];
                if (typeof tagValue === 'string') scope.setTag(key, tagValue);
            } else scope.setExtra(key, details[key]);
        });
        (0, $dmS7i.captureException)(error);
    });
};

});
parcelRegister("dmS7i", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $9bb74edd40f2005f$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $9bb74edd40f2005f$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $9bb74edd40f2005f$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "configureScope", () => $9bb74edd40f2005f$export$99d44f04437e9cb8);
$parcel$export(module.exports, "addBreadcrumb", () => $9bb74edd40f2005f$export$efda9a273d7a036d);
$parcel$export(module.exports, "setContext", () => $9bb74edd40f2005f$export$2f04de43fe27971a);
$parcel$export(module.exports, "setExtras", () => $9bb74edd40f2005f$export$bb4922da0dd51b92);
$parcel$export(module.exports, "setExtra", () => $9bb74edd40f2005f$export$8e8e7789d42ed61d);
$parcel$export(module.exports, "setTags", () => $9bb74edd40f2005f$export$74a8fb34822092e6);
$parcel$export(module.exports, "setTag", () => $9bb74edd40f2005f$export$a37d07ee78eb4569);
$parcel$export(module.exports, "setUser", () => $9bb74edd40f2005f$export$8b6bb3dd62a01be2);
$parcel$export(module.exports, "withScope", () => $9bb74edd40f2005f$export$ec58d9285c204497);
$parcel$export(module.exports, "withIsolationScope", () => $9bb74edd40f2005f$export$9a4fed82c350c2bd);
$parcel$export(module.exports, "withActiveSpan", () => $9bb74edd40f2005f$export$e57ac09b143d92a2);
$parcel$export(module.exports, "startTransaction", () => $9bb74edd40f2005f$export$e262da7ae6480481);
$parcel$export(module.exports, "getCurrentScope", () => $9bb74edd40f2005f$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $9bb74edd40f2005f$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "flush", () => $9bb74edd40f2005f$export$4909b86c8034bf73);
$parcel$export(module.exports, "close", () => $9bb74edd40f2005f$export$8360e631d277ea4d);
$parcel$export(module.exports, "lastEventId", () => $9bb74edd40f2005f$export$5d4e9fd7fac8e617);
$parcel$export(module.exports, "isInitialized", () => $9bb74edd40f2005f$export$3f95c6f800b78024);
$parcel$export(module.exports, "startSession", () => $9bb74edd40f2005f$export$c0d84948cecf78d8);
$parcel$export(module.exports, "endSession", () => $9bb74edd40f2005f$export$17a5be43989a0bc1);
$parcel$export(module.exports, "captureSession", () => $9bb74edd40f2005f$export$667e7b4d445d566b);

var $hi3E4 = parcelRequire("hi3E4");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");
var $8t2EY = parcelRequire("8t2EY");
var $h7F1u = parcelRequire("h7F1u");

var $gh9LO = parcelRequire("gh9LO");

var $aCaWa = parcelRequire("aCaWa");

var $84Maa = parcelRequire("84Maa");

var $8Ly0x = parcelRequire("8Ly0x");

var $1jkNj = parcelRequire("1jkNj");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $9bb74edd40f2005f$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().captureException(exception, (0, $1jkNj.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $9bb74edd40f2005f$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $9bb74edd40f2005f$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $9bb74edd40f2005f$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $9bb74edd40f2005f$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $84Maa.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $9bb74edd40f2005f$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $84Maa.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $9bb74edd40f2005f$export$9a4fed82c350c2bd(callback) {
    return (0, $84Maa.runWithAsyncContext)(()=>{
        return callback((0, $84Maa.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $9bb74edd40f2005f$export$e57ac09b143d92a2(span, callback) {
    return $9bb74edd40f2005f$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $9bb74edd40f2005f$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $9bb74edd40f2005f$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $9bb74edd40f2005f$export$c7be4b0125a10cba();
    const client = $9bb74edd40f2005f$export$6bb76d6eba7e258c();
    if (!client) (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $h7F1u.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $9bb74edd40f2005f$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $9bb74edd40f2005f$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $8t2EY.timestampInSeconds)();
    function finishCheckIn(status) {
        $9bb74edd40f2005f$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $8t2EY.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $9r1pX.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $9bb74edd40f2005f$export$4909b86c8034bf73(timeout) {
    const client = $9bb74edd40f2005f$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $9bb74edd40f2005f$export$8360e631d277ea4d(timeout) {
    const client = $9bb74edd40f2005f$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $9bb74edd40f2005f$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $9bb74edd40f2005f$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $9bb74edd40f2005f$export$3f95c6f800b78024() {
    return !!$9bb74edd40f2005f$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $9bb74edd40f2005f$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $84Maa.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $9bb74edd40f2005f$export$c0d84948cecf78d8(context) {
    const client = $9bb74edd40f2005f$export$6bb76d6eba7e258c();
    const isolationScope = (0, $84Maa.getIsolationScope)();
    const currentScope = $9bb74edd40f2005f$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $gh9LO.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $hi3E4.GLOBAL_OBJ).navigator || {};
    const session = (0, $8Ly0x.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $8Ly0x.updateSession)(currentSession, {
        status: 'exited'
    });
    $9bb74edd40f2005f$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $9bb74edd40f2005f$export$17a5be43989a0bc1() {
    const isolationScope = (0, $84Maa.getIsolationScope)();
    const currentScope = $9bb74edd40f2005f$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $8Ly0x.closeSession)(session);
    $9bb74edd40f2005f$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $9bb74edd40f2005f$var$_sendSessionUpdate() {
    const isolationScope = (0, $84Maa.getIsolationScope)();
    const currentScope = $9bb74edd40f2005f$export$c7be4b0125a10cba();
    const client = $9bb74edd40f2005f$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $9bb74edd40f2005f$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $9bb74edd40f2005f$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $9bb74edd40f2005f$var$_sendSessionUpdate();
}

});
parcelRegister("hi3E4", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $c966f1ffb605f02b$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $c966f1ffb605f02b$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $c966f1ffb605f02b$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $c966f1ffb605f02b$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $c966f1ffb605f02b$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $c966f1ffb605f02b$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $c966f1ffb605f02b$var$isGlobalObj(window) || typeof self == 'object' && $c966f1ffb605f02b$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $c966f1ffb605f02b$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $c966f1ffb605f02b$export$256479dc0cea61c4() {
    return $c966f1ffb605f02b$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $c966f1ffb605f02b$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $c966f1ffb605f02b$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("9r1pX", function(module, exports) {
$parcel$export(module.exports, "isError", () => $6de7bc2ce2c11d3f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $6de7bc2ce2c11d3f$export$49034edbe6b62415);
$parcel$export(module.exports, "isErrorEvent", () => $6de7bc2ce2c11d3f$export$9f9636d330b71954);
$parcel$export(module.exports, "isDOMError", () => $6de7bc2ce2c11d3f$export$ef9e2056653f0c8e);
$parcel$export(module.exports, "isDOMException", () => $6de7bc2ce2c11d3f$export$12e869b2a583f783);
$parcel$export(module.exports, "isString", () => $6de7bc2ce2c11d3f$export$844ec244b1367d54);
$parcel$export(module.exports, "isParameterizedString", () => $6de7bc2ce2c11d3f$export$dbcbffa59149b824);
$parcel$export(module.exports, "isPrimitive", () => $6de7bc2ce2c11d3f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $6de7bc2ce2c11d3f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $6de7bc2ce2c11d3f$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $6de7bc2ce2c11d3f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $6de7bc2ce2c11d3f$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $6de7bc2ce2c11d3f$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $6de7bc2ce2c11d3f$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $6de7bc2ce2c11d3f$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $6de7bc2ce2c11d3f$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $6de7bc2ce2c11d3f$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$e6127cc7fe7395c3(wat) {
    switch($6de7bc2ce2c11d3f$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $6de7bc2ce2c11d3f$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$var$isBuiltin(wat, className) {
    return $6de7bc2ce2c11d3f$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$9f9636d330b71954(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$ef9e2056653f0c8e(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$12e869b2a583f783(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$844ec244b1367d54(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$c3825b437cbdea5c(wat) {
    return wat === null || $6de7bc2ce2c11d3f$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$53b83ca8eaab0383(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $6de7bc2ce2c11d3f$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $6de7bc2ce2c11d3f$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$49841c62b9eff15(wat) {
    return $6de7bc2ce2c11d3f$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $6de7bc2ce2c11d3f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$bc2894c7158efbac(wat) {
    return $6de7bc2ce2c11d3f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $6de7bc2ce2c11d3f$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("7I6pg", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $59d19caefa8355c3$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $59d19caefa8355c3$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $59d19caefa8355c3$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $59d19caefa8355c3$export$af88d00dbe7f521);

var $fmZZ6 = parcelRequire("fmZZ6");

var $hi3E4 = parcelRequire("hi3E4");
/** Prefix for logging strings */ const $59d19caefa8355c3$var$PREFIX = 'Sentry Logger ';
const $59d19caefa8355c3$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $59d19caefa8355c3$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $59d19caefa8355c3$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $hi3E4.GLOBAL_OBJ))) return callback();
    const console = (0, $hi3E4.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($59d19caefa8355c3$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $59d19caefa8355c3$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $59d19caefa8355c3$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $fmZZ6.DEBUG_BUILD) $59d19caefa8355c3$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $59d19caefa8355c3$export$cda52e2a8927a2ca(()=>{
                (0, $hi3E4.GLOBAL_OBJ).console[name](`${$59d19caefa8355c3$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $59d19caefa8355c3$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $59d19caefa8355c3$export$af88d00dbe7f521 = $59d19caefa8355c3$var$makeLogger();

});
parcelRegister("fmZZ6", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $b308fdedf86dcc03$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $b308fdedf86dcc03$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("8t2EY", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $62a3185a4f50898b$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $62a3185a4f50898b$export$ee52dced521e3e18);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => $62a3185a4f50898b$export$baf075a948ffc0bf);

var $hi3E4 = parcelRequire("hi3E4");
const $62a3185a4f50898b$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $62a3185a4f50898b$export$7740643b9eeaf0c4() {
    return Date.now() / $62a3185a4f50898b$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $62a3185a4f50898b$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $hi3E4.GLOBAL_OBJ);
    if (!performance || !performance.now) return $62a3185a4f50898b$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $62a3185a4f50898b$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $62a3185a4f50898b$export$ee52dced521e3e18 = $62a3185a4f50898b$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $62a3185a4f50898b$export$c5907b5a8838db13 = $62a3185a4f50898b$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $62a3185a4f50898b$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $62a3185a4f50898b$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $hi3E4.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $62a3185a4f50898b$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $62a3185a4f50898b$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $62a3185a4f50898b$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $62a3185a4f50898b$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("h7F1u", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $c772e96e60486fb3$export$19f53698e68b2496);
$parcel$export(module.exports, "getEventDescription", () => $c772e96e60486fb3$export$4157119e2b157127);
$parcel$export(module.exports, "addExceptionTypeValue", () => $c772e96e60486fb3$export$f26508487bf83ee7);
$parcel$export(module.exports, "addExceptionMechanism", () => $c772e96e60486fb3$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "addContextToFrame", () => $c772e96e60486fb3$export$ec2291bfc64632f0);
$parcel$export(module.exports, "checkOrSetAlreadyCaught", () => $c772e96e60486fb3$export$6de4ffac6a2f1098);
$parcel$export(module.exports, "arrayify", () => $c772e96e60486fb3$export$3131421a7d01b4fb);

var $iiQEB = parcelRequire("iiQEB");

var $4TtIy = parcelRequire("4TtIy");

var $hi3E4 = parcelRequire("hi3E4");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $c772e96e60486fb3$export$19f53698e68b2496() {
    const gbl = (0, $hi3E4.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $c772e96e60486fb3$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $c772e96e60486fb3$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $c772e96e60486fb3$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $c772e96e60486fb3$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $c772e96e60486fb3$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $c772e96e60486fb3$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $c772e96e60486fb3$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $c772e96e60486fb3$export$d364f2020ab30578(input) {
    const match = input.match($c772e96e60486fb3$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $c772e96e60486fb3$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4TtIy.snipLine)(line, 0));
    frame.context_line = (0, $4TtIy.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4TtIy.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $c772e96e60486fb3$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $iiQEB.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $c772e96e60486fb3$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("iiQEB", function(module, exports) {
$parcel$export(module.exports, "fill", () => $d532c0617e90f61c$export$9563e054e6f787fb);
$parcel$export(module.exports, "markFunctionWrapped", () => $d532c0617e90f61c$export$5c1499e2e5d010ae);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $d532c0617e90f61c$export$e73679ffaf56810e);
$parcel$export(module.exports, "getOriginalFunction", () => $d532c0617e90f61c$export$e6cc1e135e2092e5);
$parcel$export(module.exports, "urlEncode", () => $d532c0617e90f61c$export$9ef804feabbcbaf1);
$parcel$export(module.exports, "convertToPlainObject", () => $d532c0617e90f61c$export$62ff257738bf57f5);
$parcel$export(module.exports, "extractExceptionKeysForMessage", () => $d532c0617e90f61c$export$b0244d5063c0b61b);
$parcel$export(module.exports, "dropUndefinedKeys", () => $d532c0617e90f61c$export$d25f2688db1bb433);

var $cx9zm = parcelRequire("cx9zm");

var $fmZZ6 = parcelRequire("fmZZ6");

var $9r1pX = parcelRequire("9r1pX");

var $7I6pg = parcelRequire("7I6pg");

var $4TtIy = parcelRequire("4TtIy");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $d532c0617e90f61c$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $d532c0617e90f61c$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $d532c0617e90f61c$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $fmZZ6.DEBUG_BUILD) && (0, $7I6pg.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $d532c0617e90f61c$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $d532c0617e90f61c$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $d532c0617e90f61c$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $d532c0617e90f61c$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $d532c0617e90f61c$export$62ff257738bf57f5(value) {
    if ((0, $9r1pX.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$d532c0617e90f61c$var$getOwnProperties(value)
    };
    else if ((0, $9r1pX.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $d532c0617e90f61c$var$serializeEventTarget(value.target),
            currentTarget: $d532c0617e90f61c$var$serializeEventTarget(value.currentTarget),
            ...$d532c0617e90f61c$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $9r1pX.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $d532c0617e90f61c$var$serializeEventTarget(target) {
    try {
        return (0, $9r1pX.isElement)(target) ? (0, $cx9zm.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $d532c0617e90f61c$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $d532c0617e90f61c$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($d532c0617e90f61c$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4TtIy.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4TtIy.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $d532c0617e90f61c$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $d532c0617e90f61c$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $d532c0617e90f61c$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($d532c0617e90f61c$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $d532c0617e90f61c$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($d532c0617e90f61c$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $d532c0617e90f61c$var$isPojo(input) {
    if (!(0, $9r1pX.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $d532c0617e90f61c$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $9r1pX.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("cx9zm", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $91fffd6074353fa9$export$5647df6b7814ac86);
$parcel$export(module.exports, "getLocationHref", () => $91fffd6074353fa9$export$1cfafeee2987818b);
$parcel$export(module.exports, "getDomElement", () => $91fffd6074353fa9$export$c660c1f3ab49225c);
$parcel$export(module.exports, "getComponentName", () => $91fffd6074353fa9$export$26727cfcc4d7e0fc);

var $9r1pX = parcelRequire("9r1pX");

var $hi3E4 = parcelRequire("hi3E4");
// eslint-disable-next-line deprecation/deprecation
const $91fffd6074353fa9$var$WINDOW = (0, $hi3E4.getGlobalObject)();
const $91fffd6074353fa9$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $91fffd6074353fa9$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $91fffd6074353fa9$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $91fffd6074353fa9$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $91fffd6074353fa9$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($91fffd6074353fa9$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $9r1pX.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $91fffd6074353fa9$export$1cfafeee2987818b() {
    try {
        return $91fffd6074353fa9$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $91fffd6074353fa9$export$c660c1f3ab49225c(selector) {
    if ($91fffd6074353fa9$var$WINDOW.document && $91fffd6074353fa9$var$WINDOW.document.querySelector) return $91fffd6074353fa9$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $91fffd6074353fa9$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$91fffd6074353fa9$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("4TtIy", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $390359cd44f5fc48$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $390359cd44f5fc48$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $390359cd44f5fc48$export$465e9d514283d4fd);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $390359cd44f5fc48$export$a7a5ec66062ea5d);

var $9r1pX = parcelRequire("9r1pX");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $390359cd44f5fc48$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $390359cd44f5fc48$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $390359cd44f5fc48$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $9r1pX.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $390359cd44f5fc48$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $9r1pX.isString)(value)) return false;
    if ((0, $9r1pX.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $9r1pX.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $390359cd44f5fc48$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$390359cd44f5fc48$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("gh9LO", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $bd95d002bacf92d2$export$849dbeeeda01ae98);
const $bd95d002bacf92d2$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("aCaWa", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $7ba5efe09f392870$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $7ba5efe09f392870$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("84Maa", function(module, exports) {
$parcel$export(module.exports, "Hub", () => $5e140ea31b6d6f32$export$8c41bb232f1008b1);
$parcel$export(module.exports, "makeMain", () => $5e140ea31b6d6f32$export$4188a14ad302d1bc);
$parcel$export(module.exports, "getMainCarrier", () => $5e140ea31b6d6f32$export$19eade501500c6c1);
$parcel$export(module.exports, "getHubFromCarrier", () => $5e140ea31b6d6f32$export$bfa8a924a84a76b7);
$parcel$export(module.exports, "getCurrentHub", () => $5e140ea31b6d6f32$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $5e140ea31b6d6f32$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $5e140ea31b6d6f32$export$70d775fb1f267027);

var $7I6pg = parcelRequire("7I6pg");
var $8t2EY = parcelRequire("8t2EY");
var $hi3E4 = parcelRequire("hi3E4");
var $9r1pX = parcelRequire("9r1pX");
var $h7F1u = parcelRequire("h7F1u");

var $gh9LO = parcelRequire("gh9LO");

var $aCaWa = parcelRequire("aCaWa");

var $dmR7m = parcelRequire("dmR7m");

var $8Ly0x = parcelRequire("8Ly0x");

var $gLE2H = parcelRequire("gLE2H");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $5e140ea31b6d6f32$export$24a86ef7798177e4 = parseFloat((0, $gLE2H.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $5e140ea31b6d6f32$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $5e140ea31b6d6f32$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $5e140ea31b6d6f32$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $dmR7m.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $dmR7m.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $9r1pX.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5e140ea31b6d6f32$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $8t2EY.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $7I6pg.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $5e140ea31b6d6f32$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $5e140ea31b6d6f32$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $aCaWa.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $7I6pg.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $7I6pg.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8Ly0x.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $gh9LO.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $hi3E4.GLOBAL_OBJ).navigator || {};
        const session = (0, $8Ly0x.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $8Ly0x.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $5e140ea31b6d6f32$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $aCaWa.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $5e140ea31b6d6f32$export$19eade501500c6c1() {
    (0, $hi3E4.GLOBAL_OBJ).__SENTRY__ = (0, $hi3E4.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $hi3E4.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$export$4188a14ad302d1bc(hub) {
    const registry = $5e140ea31b6d6f32$export$19eade501500c6c1();
    const oldHub = $5e140ea31b6d6f32$export$bfa8a924a84a76b7(registry);
    $5e140ea31b6d6f32$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $5e140ea31b6d6f32$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $5e140ea31b6d6f32$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $5e140ea31b6d6f32$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $5e140ea31b6d6f32$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$var$getGlobalHub(registry = $5e140ea31b6d6f32$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$5e140ea31b6d6f32$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $5e140ea31b6d6f32$export$bfa8a924a84a76b7(registry).isOlderThan($5e140ea31b6d6f32$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $5e140ea31b6d6f32$export$849f05434e95d2f2(registry, new $5e140ea31b6d6f32$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $5e140ea31b6d6f32$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$export$236689a79f5aa020(carrier, parent = $5e140ea31b6d6f32$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$5e140ea31b6d6f32$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $5e140ea31b6d6f32$export$bfa8a924a84a76b7(carrier).isOlderThan($5e140ea31b6d6f32$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $5e140ea31b6d6f32$export$849f05434e95d2f2(carrier, new $5e140ea31b6d6f32$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $5e140ea31b6d6f32$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $5e140ea31b6d6f32$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $5e140ea31b6d6f32$export$70d775fb1f267027(callback, options = {}) {
    const registry = $5e140ea31b6d6f32$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $5e140ea31b6d6f32$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $hi3E4.getGlobalSingleton)('hub', ()=>new $5e140ea31b6d6f32$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $5e140ea31b6d6f32$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("dmR7m", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $9bb6887c5b4e2047$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $9bb6887c5b4e2047$export$aa55d5ab8e05984f);

var $8t2EY = parcelRequire("8t2EY");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");
var $h7F1u = parcelRequire("h7F1u");

var $d86W5 = parcelRequire("d86W5");

var $8Ly0x = parcelRequire("8Ly0x");

var $fuzal = parcelRequire("fuzal");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $9bb6887c5b4e2047$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $9bb6887c5b4e2047$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $9bb6887c5b4e2047$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $9bb6887c5b4e2047$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $9bb6887c5b4e2047$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $9bb6887c5b4e2047$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $8Ly0x.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $9bb6887c5b4e2047$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $9r1pX.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $9bb6887c5b4e2047$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $9bb6887c5b4e2047$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $8t2EY.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $fuzal.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $d86W5.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $d86W5.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        if (!this._client) {
            (0, $7I6pg.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        if (!this._client) {
            (0, $7I6pg.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $h7F1u.uuid4)();
        if (!this._client) {
            (0, $7I6pg.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $9bb6887c5b4e2047$export$aa55d5ab8e05984f() {
    if (!$9bb6887c5b4e2047$var$globalScope) $9bb6887c5b4e2047$var$globalScope = new $9bb6887c5b4e2047$export$775b6bb06e53a214();
    return $9bb6887c5b4e2047$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $9bb6887c5b4e2047$export$c83048efd17527d6(scope) {
    $9bb6887c5b4e2047$var$globalScope = scope;
}
function $9bb6887c5b4e2047$var$generatePropagationContext() {
    return {
        traceId: (0, $h7F1u.uuid4)(),
        spanId: (0, $h7F1u.uuid4)().substring(16)
    };
}

});
parcelRegister("d86W5", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventProcessors", () => $98f16709e0409494$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $98f16709e0409494$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $98f16709e0409494$export$bf2a096c3e883e79);

var $hi3E4 = parcelRequire("hi3E4");
var $9r1pX = parcelRequire("9r1pX");
var $7I6pg = parcelRequire("7I6pg");
var $2VQuW = parcelRequire("2VQuW");

var $aCaWa = parcelRequire("aCaWa");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $98f16709e0409494$export$3c4238858b85e8ac() {
    return (0, $hi3E4.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $98f16709e0409494$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $98f16709e0409494$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $98f16709e0409494$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $2VQuW.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $aCaWa.DEBUG_BUILD) && processor.id && result === null && (0, $7I6pg.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $9r1pX.isThenable)(result)) result.then((final)=>$98f16709e0409494$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $98f16709e0409494$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("2VQuW", function(module, exports) {
$parcel$export(module.exports, "resolvedSyncPromise", () => $2229a0ade6c23e5c$export$1fda8aa4d135f8aa);
$parcel$export(module.exports, "SyncPromise", () => $2229a0ade6c23e5c$export$6f292d4960313241);
$parcel$export(module.exports, "rejectedSyncPromise", () => $2229a0ade6c23e5c$export$78e43115b553f358);

var $9r1pX = parcelRequire("9r1pX");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $2229a0ade6c23e5c$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($2229a0ade6c23e5c$var$States || ($2229a0ade6c23e5c$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $2229a0ade6c23e5c$export$1fda8aa4d135f8aa(value) {
    return new $2229a0ade6c23e5c$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $2229a0ade6c23e5c$export$78e43115b553f358(reason) {
    return new $2229a0ade6c23e5c$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $2229a0ade6c23e5c$export$6f292d4960313241 {
    constructor(executor){
        $2229a0ade6c23e5c$export$6f292d4960313241.prototype.__init.call(this);
        $2229a0ade6c23e5c$export$6f292d4960313241.prototype.__init2.call(this);
        $2229a0ade6c23e5c$export$6f292d4960313241.prototype.__init3.call(this);
        $2229a0ade6c23e5c$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $2229a0ade6c23e5c$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $2229a0ade6c23e5c$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $2229a0ade6c23e5c$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($2229a0ade6c23e5c$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($2229a0ade6c23e5c$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $2229a0ade6c23e5c$var$States.PENDING) return;
            if ((0, $9r1pX.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $2229a0ade6c23e5c$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $2229a0ade6c23e5c$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $2229a0ade6c23e5c$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("8Ly0x", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $661d17bedc41b7c9$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $661d17bedc41b7c9$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $661d17bedc41b7c9$export$56521d9ba90f62ee);

var $iiQEB = parcelRequire("iiQEB");
var $8t2EY = parcelRequire("8t2EY");
var $h7F1u = parcelRequire("h7F1u");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $661d17bedc41b7c9$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $8t2EY.timestampInSeconds)();
    const session = {
        sid: (0, $h7F1u.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$661d17bedc41b7c9$var$sessionToJSON(session)
    };
    if (context) $661d17bedc41b7c9$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $661d17bedc41b7c9$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $8t2EY.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $h7F1u.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $661d17bedc41b7c9$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $661d17bedc41b7c9$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $661d17bedc41b7c9$var$sessionToJSON(session) {
    return (0, $iiQEB.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("fuzal", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $b474ef92f3525e50$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $b474ef92f3525e50$export$25ac7e259a513db4);

var $h7F1u = parcelRequire("h7F1u");
var $iiQEB = parcelRequire("iiQEB");

var $aw8s7 = parcelRequire("aw8s7");

var $kdA50 = parcelRequire("kdA50");

var $ajbYg = parcelRequire("ajbYg");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $b474ef92f3525e50$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $b474ef92f3525e50$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $b474ef92f3525e50$var$applySpanToEvent(event, span);
    $b474ef92f3525e50$var$applyFingerprintToEvent(event, fingerprint);
    $b474ef92f3525e50$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $b474ef92f3525e50$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $b474ef92f3525e50$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $b474ef92f3525e50$export$b1a120a2871faa46(data, 'extra', extra);
    $b474ef92f3525e50$export$b1a120a2871faa46(data, 'tags', tags);
    $b474ef92f3525e50$export$b1a120a2871faa46(data, 'user', user);
    $b474ef92f3525e50$export$b1a120a2871faa46(data, 'contexts', contexts);
    $b474ef92f3525e50$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $b474ef92f3525e50$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $b474ef92f3525e50$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $iiQEB.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $iiQEB.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $iiQEB.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $iiQEB.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $b474ef92f3525e50$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $b474ef92f3525e50$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $b474ef92f3525e50$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $ajbYg.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $kdA50.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $aw8s7.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $ajbYg.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $b474ef92f3525e50$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $h7F1u.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("aw8s7", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromClient", () => $7a83730329e56963$export$366bad00d6815eed);
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $7a83730329e56963$export$a117f995597e25df);

var $iiQEB = parcelRequire("iiQEB");

var $gh9LO = parcelRequire("gh9LO");

var $dmS7i = parcelRequire("dmS7i");

var $kdA50 = parcelRequire("kdA50");

var $ajbYg = parcelRequire("ajbYg");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $7a83730329e56963$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $iiQEB.dropUndefinedKeys)({
        environment: options.environment || (0, $gh9LO.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $7a83730329e56963$export$a117f995597e25df(span) {
    const client = (0, $dmS7i.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $7a83730329e56963$export$366bad00d6815eed((0, $ajbYg.spanToJSON)(span).trace_id || '', client, (0, $dmS7i.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $kdA50.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $ajbYg.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $ajbYg.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("kdA50", function(module, exports) {
$parcel$export(module.exports, "getRootSpan", () => $eb810237f405b890$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $eb810237f405b890$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("ajbYg", function(module, exports) {
$parcel$export(module.exports, "TRACE_FLAG_NONE", () => $7814f6f03d6b32da$export$208d5b368507fb8b);
$parcel$export(module.exports, "TRACE_FLAG_SAMPLED", () => $7814f6f03d6b32da$export$eb571cd9b5d98de8);
$parcel$export(module.exports, "spanToTraceContext", () => $7814f6f03d6b32da$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $7814f6f03d6b32da$export$92d8c23565496537);
$parcel$export(module.exports, "spanToTraceHeader", () => $7814f6f03d6b32da$export$7e9f8ae9e4a328ab);
$parcel$export(module.exports, "spanIsSampled", () => $7814f6f03d6b32da$export$5caecac1caaf3a71);
$parcel$export(module.exports, "spanTimeInputToSeconds", () => $7814f6f03d6b32da$export$3f7581298f56c6d7);

var $iiQEB = parcelRequire("iiQEB");
var $eUr7O = parcelRequire("eUr7O");
var $8t2EY = parcelRequire("8t2EY");
// These are aligned with OpenTelemetry trace flags
const $7814f6f03d6b32da$export$208d5b368507fb8b = 0x0;
const $7814f6f03d6b32da$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $7814f6f03d6b32da$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $7814f6f03d6b32da$export$92d8c23565496537(span);
    return (0, $iiQEB.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $7814f6f03d6b32da$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $7814f6f03d6b32da$export$5caecac1caaf3a71(span);
    return (0, $eUr7O.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $7814f6f03d6b32da$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $7814f6f03d6b32da$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $7814f6f03d6b32da$var$ensureTimestampInSeconds(input.getTime());
    return (0, $8t2EY.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $7814f6f03d6b32da$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $7814f6f03d6b32da$export$92d8c23565496537(span) {
    if ($7814f6f03d6b32da$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $7814f6f03d6b32da$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $7814f6f03d6b32da$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $7814f6f03d6b32da$export$eb571cd9b5d98de8);
}

});
parcelRegister("eUr7O", function(module, exports) {
$parcel$export(module.exports, "extractTraceparentData", () => $adab56168f368b98$export$8e9a29865c0a1226);
$parcel$export(module.exports, "tracingContextFromHeaders", () => $adab56168f368b98$export$ca5c066532785b6e);
$parcel$export(module.exports, "propagationContextFromHeaders", () => $adab56168f368b98$export$261f383d16a93e39);
$parcel$export(module.exports, "generateSentryTraceHeader", () => $adab56168f368b98$export$f35d907436da45cf);

var $94mso = parcelRequire("94mso");

var $h7F1u = parcelRequire("h7F1u");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $adab56168f368b98$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $adab56168f368b98$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($adab56168f368b98$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $adab56168f368b98$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $adab56168f368b98$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $94mso.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $h7F1u.uuid4)(),
            spanId: (0, $h7F1u.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $h7F1u.uuid4)(),
            parentSpanId: parentSpanId || (0, $h7F1u.uuid4)().substring(16),
            spanId: (0, $h7F1u.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $adab56168f368b98$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $adab56168f368b98$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $94mso.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $h7F1u.uuid4)(),
        spanId: (0, $h7F1u.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $h7F1u.uuid4)(),
        parentSpanId: parentSpanId || (0, $h7F1u.uuid4)().substring(16),
        spanId: (0, $h7F1u.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $adab56168f368b98$export$f35d907436da45cf(traceId = (0, $h7F1u.uuid4)(), spanId = (0, $h7F1u.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("94mso", function(module, exports) {
$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $69a5e8452267cf56$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $69a5e8452267cf56$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $69a5e8452267cf56$export$56766feef403f365);

var $fmZZ6 = parcelRequire("fmZZ6");

var $9r1pX = parcelRequire("9r1pX");

var $7I6pg = parcelRequire("7I6pg");
const $69a5e8452267cf56$export$9ca9946bd449ac06 = 'baggage';
const $69a5e8452267cf56$export$6e69537d67fa20f = 'sentry-';
const $69a5e8452267cf56$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $69a5e8452267cf56$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $69a5e8452267cf56$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $9r1pX.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $69a5e8452267cf56$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $69a5e8452267cf56$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($69a5e8452267cf56$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($69a5e8452267cf56$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $69a5e8452267cf56$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$69a5e8452267cf56$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $69a5e8452267cf56$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $69a5e8452267cf56$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $69a5e8452267cf56$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $69a5e8452267cf56$export$bdd844ddb2def819) {
            (0, $fmZZ6.DEBUG_BUILD) && (0, $7I6pg.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("gLE2H", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $c35018bb3236bf8a$export$31499a9cd224b78c);
const $c35018bb3236bf8a$export$31499a9cd224b78c = '7.119.0';

});


parcelRegister("1jkNj", function(module, exports) {
$parcel$export(module.exports, "prepareEvent", () => $0f47b22062a61e8b$export$2d67fb380bd11267);
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $0f47b22062a61e8b$export$76b5f966996d1653);

var $h7F1u = parcelRequire("h7F1u");
var $8t2EY = parcelRequire("8t2EY");
var $hi3E4 = parcelRequire("hi3E4");
var $bsqJK = parcelRequire("bsqJK");
var $4TtIy = parcelRequire("4TtIy");

var $gh9LO = parcelRequire("gh9LO");

var $d86W5 = parcelRequire("d86W5");

var $dmR7m = parcelRequire("dmR7m");

var $fuzal = parcelRequire("fuzal");

var $ajbYg = parcelRequire("ajbYg");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $0f47b22062a61e8b$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $h7F1u.uuid4)(),
        timestamp: event.timestamp || (0, $8t2EY.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $0f47b22062a61e8b$var$applyClientOptions(prepared, options);
    $0f47b22062a61e8b$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $0f47b22062a61e8b$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $0f47b22062a61e8b$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $h7F1u.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $dmR7m.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $fuzal.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $fuzal.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $fuzal.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $d86W5.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $d86W5.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $0f47b22062a61e8b$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $0f47b22062a61e8b$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $0f47b22062a61e8b$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $gh9LO.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $4TtIy.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $4TtIy.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $4TtIy.truncate)(request.url, maxValueLength);
}
const $0f47b22062a61e8b$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $0f47b22062a61e8b$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $hi3E4.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $0f47b22062a61e8b$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $0f47b22062a61e8b$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $0f47b22062a61e8b$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $0f47b22062a61e8b$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $0f47b22062a61e8b$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $bsqJK.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $bsqJK.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $bsqJK.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $bsqJK.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $bsqJK.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $ajbYg.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $bsqJK.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $0f47b22062a61e8b$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $dmR7m.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $0f47b22062a61e8b$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($0f47b22062a61e8b$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($0f47b22062a61e8b$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $0f47b22062a61e8b$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $dmR7m.Scope) || typeof hint === 'function';
}
const $0f47b22062a61e8b$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $0f47b22062a61e8b$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$0f47b22062a61e8b$var$captureContextKeys.includes(key));
}

});
parcelRegister("bsqJK", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $85770c9a36058635$export$a3295358bff77e);
$parcel$export(module.exports, "normalizeToSize", () => $85770c9a36058635$export$23fbbb20bed71033);

var $9r1pX = parcelRequire("9r1pX");

var $fIngb = parcelRequire("fIngb");

var $iiQEB = parcelRequire("iiQEB");

var $lnX7A = parcelRequire("lnX7A");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $85770c9a36058635$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $85770c9a36058635$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $85770c9a36058635$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $85770c9a36058635$export$a3295358bff77e(object, depth);
    if ($85770c9a36058635$var$jsonSize(normalized) > maxSize) return $85770c9a36058635$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $85770c9a36058635$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $fIngb.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $9r1pX.isNaN)(value)) return value;
    const stringified = $85770c9a36058635$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $85770c9a36058635$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $iiQEB.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $85770c9a36058635$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $85770c9a36058635$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $9r1pX.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $9r1pX.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $lnX7A.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $85770c9a36058635$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $85770c9a36058635$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $85770c9a36058635$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $85770c9a36058635$var$jsonSize(value) {
    return $85770c9a36058635$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $85770c9a36058635$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("fIngb", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $b70d02049b56a78c$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $b70d02049b56a78c$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("lnX7A", function(module, exports) {
$parcel$export(module.exports, "createStackParser", () => $f9199b341225b49a$export$a5739666fb2d03d4);
$parcel$export(module.exports, "stackParserFromStackParserOptions", () => $f9199b341225b49a$export$1d5cf88b347146d4);
$parcel$export(module.exports, "getFunctionName", () => $f9199b341225b49a$export$aad197c7121a6651);

var $ljvID = parcelRequire("ljvID");
const $f9199b341225b49a$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $f9199b341225b49a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $f9199b341225b49a$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $f9199b341225b49a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $f9199b341225b49a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($f9199b341225b49a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $f9199b341225b49a$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $f9199b341225b49a$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $f9199b341225b49a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $f9199b341225b49a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $f9199b341225b49a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($f9199b341225b49a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($f9199b341225b49a$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $f9199b341225b49a$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $f9199b341225b49a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $f9199b341225b49a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $f9199b341225b49a$var$defaultFunctionName;
        return fn.name || $f9199b341225b49a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $f9199b341225b49a$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $f9199b341225b49a$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $ljvID.node)(getModule)
    ];
}

});
parcelRegister("ljvID", function(module, exports) {
$parcel$export(module.exports, "node", () => $f843fa03fc603e64$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $f843fa03fc603e64$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $f843fa03fc603e64$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $f843fa03fc603e64$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});







parcelRegister("gXtG2", function(module, exports) {
$parcel$export(module.exports, "autoBeforeEachTest", () => $5bb31837020f8a72$export$720b76bfb5694d3e);
/* eslint-disable jira/filename-case */ let $5bb31837020f8a72$var$isTestEnvironment = false;
const $5bb31837020f8a72$export$c6b22c43dfccffc1 = (value)=>{
    $5bb31837020f8a72$var$isTestEnvironment = value;
};
const $5bb31837020f8a72$var$autoBeforeEachActions = [];
const $5bb31837020f8a72$export$720b76bfb5694d3e = (fn)=>{
    if ($5bb31837020f8a72$var$isTestEnvironment) $5bb31837020f8a72$var$autoBeforeEachActions.push(fn);
};
const $5bb31837020f8a72$export$51eb38a36a7defc6 = ()=>{
    $5bb31837020f8a72$var$autoBeforeEachActions.forEach((action)=>action());
};

});

parcelRegister("gIMgJ", function(module, exports) {
// shim for using process in browser
var $c2c6329d26f13c8a$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $c2c6329d26f13c8a$var$cachedSetTimeout;
var $c2c6329d26f13c8a$var$cachedClearTimeout;
function $c2c6329d26f13c8a$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $c2c6329d26f13c8a$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $c2c6329d26f13c8a$var$cachedSetTimeout = setTimeout;
        else $c2c6329d26f13c8a$var$cachedSetTimeout = $c2c6329d26f13c8a$var$defaultSetTimout;
    } catch (e) {
        $c2c6329d26f13c8a$var$cachedSetTimeout = $c2c6329d26f13c8a$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $c2c6329d26f13c8a$var$cachedClearTimeout = clearTimeout;
        else $c2c6329d26f13c8a$var$cachedClearTimeout = $c2c6329d26f13c8a$var$defaultClearTimeout;
    } catch (e) {
        $c2c6329d26f13c8a$var$cachedClearTimeout = $c2c6329d26f13c8a$var$defaultClearTimeout;
    }
})();
function $c2c6329d26f13c8a$var$runTimeout(fun) {
    if ($c2c6329d26f13c8a$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($c2c6329d26f13c8a$var$cachedSetTimeout === $c2c6329d26f13c8a$var$defaultSetTimout || !$c2c6329d26f13c8a$var$cachedSetTimeout) && setTimeout) {
        $c2c6329d26f13c8a$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c2c6329d26f13c8a$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $c2c6329d26f13c8a$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $c2c6329d26f13c8a$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $c2c6329d26f13c8a$var$runClearTimeout(marker) {
    if ($c2c6329d26f13c8a$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($c2c6329d26f13c8a$var$cachedClearTimeout === $c2c6329d26f13c8a$var$defaultClearTimeout || !$c2c6329d26f13c8a$var$cachedClearTimeout) && clearTimeout) {
        $c2c6329d26f13c8a$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $c2c6329d26f13c8a$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $c2c6329d26f13c8a$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $c2c6329d26f13c8a$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $c2c6329d26f13c8a$var$queue = [];
var $c2c6329d26f13c8a$var$draining = false;
var $c2c6329d26f13c8a$var$currentQueue;
var $c2c6329d26f13c8a$var$queueIndex = -1;
function $c2c6329d26f13c8a$var$cleanUpNextTick() {
    if (!$c2c6329d26f13c8a$var$draining || !$c2c6329d26f13c8a$var$currentQueue) return;
    $c2c6329d26f13c8a$var$draining = false;
    if ($c2c6329d26f13c8a$var$currentQueue.length) $c2c6329d26f13c8a$var$queue = $c2c6329d26f13c8a$var$currentQueue.concat($c2c6329d26f13c8a$var$queue);
    else $c2c6329d26f13c8a$var$queueIndex = -1;
    if ($c2c6329d26f13c8a$var$queue.length) $c2c6329d26f13c8a$var$drainQueue();
}
function $c2c6329d26f13c8a$var$drainQueue() {
    if ($c2c6329d26f13c8a$var$draining) return;
    var timeout = $c2c6329d26f13c8a$var$runTimeout($c2c6329d26f13c8a$var$cleanUpNextTick);
    $c2c6329d26f13c8a$var$draining = true;
    var len = $c2c6329d26f13c8a$var$queue.length;
    while(len){
        $c2c6329d26f13c8a$var$currentQueue = $c2c6329d26f13c8a$var$queue;
        $c2c6329d26f13c8a$var$queue = [];
        while(++$c2c6329d26f13c8a$var$queueIndex < len)if ($c2c6329d26f13c8a$var$currentQueue) $c2c6329d26f13c8a$var$currentQueue[$c2c6329d26f13c8a$var$queueIndex].run();
        $c2c6329d26f13c8a$var$queueIndex = -1;
        len = $c2c6329d26f13c8a$var$queue.length;
    }
    $c2c6329d26f13c8a$var$currentQueue = null;
    $c2c6329d26f13c8a$var$draining = false;
    $c2c6329d26f13c8a$var$runClearTimeout(timeout);
}
$c2c6329d26f13c8a$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $c2c6329d26f13c8a$var$queue.push(new $c2c6329d26f13c8a$var$Item(fun, args));
    if ($c2c6329d26f13c8a$var$queue.length === 1 && !$c2c6329d26f13c8a$var$draining) $c2c6329d26f13c8a$var$runTimeout($c2c6329d26f13c8a$var$drainQueue);
};
// v8 likes predictible objects
function $c2c6329d26f13c8a$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$c2c6329d26f13c8a$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$c2c6329d26f13c8a$var$process.title = 'browser';
$c2c6329d26f13c8a$var$process.browser = true;
$c2c6329d26f13c8a$var$process.env = {};
$c2c6329d26f13c8a$var$process.argv = [];
$c2c6329d26f13c8a$var$process.version = ''; // empty string to avoid regexp issues
$c2c6329d26f13c8a$var$process.versions = {};
function $c2c6329d26f13c8a$var$noop() {}
$c2c6329d26f13c8a$var$process.on = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.addListener = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.once = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.off = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.removeListener = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.removeAllListeners = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.emit = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.prependListener = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.prependOnceListener = $c2c6329d26f13c8a$var$noop;
$c2c6329d26f13c8a$var$process.listeners = function(name) {
    return [];
};
$c2c6329d26f13c8a$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$c2c6329d26f13c8a$var$process.cwd = function() {
    return '/';
};
$c2c6329d26f13c8a$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$c2c6329d26f13c8a$var$process.umask = function() {
    return 0;
};

});


parcelRegister("f9W1l", function(module, exports) {
"use strict";
var $b094b3fb91744e0f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b094b3fb91744e0f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $b094b3fb91744e0f$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClient = void 0;


var $ca1MY = parcelRequire("ca1MY");
module.exports.StatsigClient = $ca1MY.default;

$b094b3fb91744e0f$var$__exportStar((parcelRequire("pWbzR")), module.exports);
const $b094b3fb91744e0f$var$__STATSIG__ = Object.assign((0, (parcelRequire("pWbzR"))._getStatsigGlobal)(), {
    StatsigClient: $ca1MY.default
});
module.exports.default = $b094b3fb91744e0f$var$__STATSIG__;

});
parcelRegister("pWbzR", function(module, exports) {
"use strict";
var $04df78637ea9994c$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $04df78637ea9994c$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $04df78637ea9994c$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Storage = module.exports.Log = module.exports.EventLogger = module.exports.Diagnostics = void 0;



Object.defineProperty(module.exports, "Diagnostics", {
    enumerable: true,
    get: function() {
        return (parcelRequire("eQLXH")).Diagnostics;
    }
});

var $9yrlC = parcelRequire("9yrlC");
Object.defineProperty(module.exports, "EventLogger", {
    enumerable: true,
    get: function() {
        return $9yrlC.EventLogger;
    }
});

Object.defineProperty(module.exports, "Log", {
    enumerable: true,
    get: function() {
        return (parcelRequire("8zS3F")).Log;
    }
});


Object.defineProperty(module.exports, "Storage", {
    enumerable: true,
    get: function() {
        return (parcelRequire("9Kt1W")).Storage;
    }
});

$04df78637ea9994c$var$__exportStar((parcelRequire("dizc4")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("dOVey")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("4WEZS")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("dRUZU")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("eQLXH")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("al1Ro")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("bLgjg")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("jLdeg")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("aPNtF")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("gD7am")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("RDWWP")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("8zS3F")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("6ktTX")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("aZSmg")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("dGL4U")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("m5DF9")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("iYRdY")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("e9CWO")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("6LIjG")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9Zsep")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("5f4KD")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("96q1S")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("96wjI")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("f7Pc3")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("5wjr2")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("knJV8")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("7K2uC")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9HcT0")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("vMPTB")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("eCWJg")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("irrNm")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9PGpW")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9Kt1W")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9jpT3")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("9mTS6")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("e9Hsx")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("axqyl")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("4afAt")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("cQQIC")), module.exports);

$04df78637ea9994c$var$__exportStar((parcelRequire("2hBO7")), module.exports);
Object.assign((0, (parcelRequire("dizc4"))._getStatsigGlobal)(), {
    Log: (parcelRequire("8zS3F")).Log,
    SDK_VERSION: (parcelRequire("7K2uC")).SDK_VERSION
});

});
parcelRegister("dizc4", function(module, exports) {
"use strict";
/* eslint-disable @typescript-eslint/no-unsafe-assignment */ var $9ae8418d13585b1b$var$_a, $9ae8418d13585b1b$var$_b, $9ae8418d13585b1b$var$_c;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getInstance = module.exports._getStatsigGlobalFlag = module.exports._getStatsigGlobal = void 0;

var $8zS3F = parcelRequire("8zS3F");
const $9ae8418d13585b1b$var$_getStatsigGlobal = ()=>{
    // Avoid ReferenceError, which is happening with Cloudflare pages
    try {
        return typeof __STATSIG__ !== 'undefined' ? __STATSIG__ : $9ae8418d13585b1b$var$statsigGlobal;
    } catch (e) {
        return $9ae8418d13585b1b$var$statsigGlobal;
    }
};
module.exports._getStatsigGlobal = $9ae8418d13585b1b$var$_getStatsigGlobal;
const $9ae8418d13585b1b$var$_getStatsigGlobalFlag = (flag)=>{
    return (0, module.exports._getStatsigGlobal)()[flag];
};
module.exports._getStatsigGlobalFlag = $9ae8418d13585b1b$var$_getStatsigGlobalFlag;
const $9ae8418d13585b1b$var$_getInstance = (sdkKey)=>{
    const gbl = (0, module.exports._getStatsigGlobal)();
    if (!sdkKey) {
        if (gbl.instances && Object.keys(gbl.instances).length > 1) $8zS3F.Log.warn('Call made to Statsig global instance without an SDK key but there is more than one client instance. If you are using mulitple clients, please specify the SDK key.');
        return gbl.firstInstance;
    }
    return gbl.instances && gbl.instances[sdkKey];
};
module.exports._getInstance = $9ae8418d13585b1b$var$_getInstance;
const $9ae8418d13585b1b$var$GLOBAL_KEY = '__STATSIG__';
const $9ae8418d13585b1b$var$_window = typeof window !== 'undefined' ? window : {};
const $9ae8418d13585b1b$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : {};
const $9ae8418d13585b1b$var$_globalThis = typeof globalThis !== 'undefined' ? globalThis : {};
const $9ae8418d13585b1b$var$statsigGlobal = ($9ae8418d13585b1b$var$_c = ($9ae8418d13585b1b$var$_b = ($9ae8418d13585b1b$var$_a = $9ae8418d13585b1b$var$_window[$9ae8418d13585b1b$var$GLOBAL_KEY]) !== null && $9ae8418d13585b1b$var$_a !== void 0 ? $9ae8418d13585b1b$var$_a : $9ae8418d13585b1b$var$_global[$9ae8418d13585b1b$var$GLOBAL_KEY]) !== null && $9ae8418d13585b1b$var$_b !== void 0 ? $9ae8418d13585b1b$var$_b : $9ae8418d13585b1b$var$_globalThis[$9ae8418d13585b1b$var$GLOBAL_KEY]) !== null && $9ae8418d13585b1b$var$_c !== void 0 ? $9ae8418d13585b1b$var$_c : {
    instance: module.exports._getInstance
};
$9ae8418d13585b1b$var$_window[$9ae8418d13585b1b$var$GLOBAL_KEY] = $9ae8418d13585b1b$var$statsigGlobal;
$9ae8418d13585b1b$var$_global[$9ae8418d13585b1b$var$GLOBAL_KEY] = $9ae8418d13585b1b$var$statsigGlobal;
$9ae8418d13585b1b$var$_globalThis[$9ae8418d13585b1b$var$GLOBAL_KEY] = $9ae8418d13585b1b$var$statsigGlobal;

});
parcelRegister("8zS3F", function(module, exports) {
"use strict";
/* eslint-disable no-console */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Log = module.exports.LogLevel = void 0;
// intentionally spaced for formatting
const $63eb86764487d4d7$var$DEBUG = ' DEBUG ';
const $63eb86764487d4d7$var$_INFO = '  INFO ';
const $63eb86764487d4d7$var$_WARN = '  WARN ';
const $63eb86764487d4d7$var$ERROR = ' ERROR ';
function $63eb86764487d4d7$var$addTag(args) {
    args.unshift('[Statsig]');
    return args; // ['[Statsig]', ...args];
}
module.exports.LogLevel = {
    None: 0,
    Error: 1,
    Warn: 2,
    Info: 3,
    Debug: 4
};
class $63eb86764487d4d7$var$Log {
    static info(...args) {
        if ($63eb86764487d4d7$var$Log.level >= module.exports.LogLevel.Info) console.info($63eb86764487d4d7$var$_INFO, ...$63eb86764487d4d7$var$addTag(args));
    }
    static debug(...args) {
        if ($63eb86764487d4d7$var$Log.level >= module.exports.LogLevel.Debug) console.debug($63eb86764487d4d7$var$DEBUG, ...$63eb86764487d4d7$var$addTag(args));
    }
    static warn(...args) {
        if ($63eb86764487d4d7$var$Log.level >= module.exports.LogLevel.Warn) console.warn($63eb86764487d4d7$var$_WARN, ...$63eb86764487d4d7$var$addTag(args));
    }
    static error(...args) {
        if ($63eb86764487d4d7$var$Log.level >= module.exports.LogLevel.Error) console.error($63eb86764487d4d7$var$ERROR, ...$63eb86764487d4d7$var$addTag(args));
    }
}
module.exports.Log = $63eb86764487d4d7$var$Log;
$63eb86764487d4d7$var$Log.level = module.exports.LogLevel.Warn;

});


parcelRegister("eQLXH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Diagnostics = void 0;
const $acfb204073ed7716$var$MARKER_MAP = new Map();
const $acfb204073ed7716$var$ACT_START = 'start';
const $acfb204073ed7716$var$ACT_END = 'end';
const $acfb204073ed7716$var$DIAGNOSTICS_EVENT = 'statsig::diagnostics';
module.exports.Diagnostics = {
    _getMarkers: (sdkKey)=>{
        return $acfb204073ed7716$var$MARKER_MAP.get(sdkKey);
    },
    _markInitOverallStart: (sdkKey)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker({}, $acfb204073ed7716$var$ACT_START, 'overall'));
    },
    _markInitOverallEnd: (sdkKey, success, evaluationDetails)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker({
            success: success,
            error: success ? undefined : {
                name: 'InitializeError',
                message: 'Failed to initialize'
            },
            evaluationDetails: evaluationDetails
        }, $acfb204073ed7716$var$ACT_END, 'overall'));
    },
    _markInitNetworkReqStart: (sdkKey, data)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker(data, $acfb204073ed7716$var$ACT_START, 'initialize', 'network_request'));
    },
    _markInitNetworkReqEnd: (sdkKey, data)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker(data, $acfb204073ed7716$var$ACT_END, 'initialize', 'network_request'));
    },
    _markInitProcessStart: (sdkKey)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker({}, $acfb204073ed7716$var$ACT_START, 'initialize', 'process'));
    },
    _markInitProcessEnd: (sdkKey, data)=>{
        $acfb204073ed7716$var$_addMarker(sdkKey, $acfb204073ed7716$var$_createMarker(data, $acfb204073ed7716$var$ACT_END, 'initialize', 'process'));
    },
    _clearMarkers: (sdkKey)=>{
        $acfb204073ed7716$var$MARKER_MAP.delete(sdkKey);
    },
    _formatError (e) {
        if (!(e && typeof e === 'object')) return;
        return {
            code: $acfb204073ed7716$var$_safeGetField(e, 'code'),
            name: $acfb204073ed7716$var$_safeGetField(e, 'name'),
            message: $acfb204073ed7716$var$_safeGetField(e, 'message')
        };
    },
    _getDiagnosticsData (res, attempt, body, e) {
        var _a;
        return {
            success: (res === null || res === void 0 ? void 0 : res.ok) === true,
            statusCode: res === null || res === void 0 ? void 0 : res.status,
            sdkRegion: (_a = res === null || res === void 0 ? void 0 : res.headers) === null || _a === void 0 ? void 0 : _a.get('x-statsig-region'),
            isDelta: body.includes('"is_delta":true') === true ? true : undefined,
            attempt: attempt,
            error: module.exports.Diagnostics._formatError(e)
        };
    },
    _enqueueDiagnosticsEvent (user, logger, sdk, options) {
        const markers = module.exports.Diagnostics._getMarkers(sdk);
        if (markers == null || markers.length <= 0) return -1;
        const overallInitDuration = markers[markers.length - 1].timestamp - markers[0].timestamp;
        module.exports.Diagnostics._clearMarkers(sdk);
        const event = $acfb204073ed7716$var$_makeDiagnosticsEvent(user, {
            context: 'initialize',
            markers: markers.slice(),
            statsigOptions: options
        });
        logger.enqueue(event);
        return overallInitDuration;
    }
};
function $acfb204073ed7716$var$_createMarker(data, action, key, step) {
    return Object.assign({
        key: key,
        action: action,
        step: step,
        timestamp: Date.now()
    }, data);
}
function $acfb204073ed7716$var$_makeDiagnosticsEvent(user, data) {
    const latencyEvent = {
        eventName: $acfb204073ed7716$var$DIAGNOSTICS_EVENT,
        user: user,
        value: null,
        metadata: data,
        time: Date.now()
    };
    return latencyEvent;
}
function $acfb204073ed7716$var$_addMarker(sdkKey, marker) {
    var _a;
    const markers = (_a = $acfb204073ed7716$var$MARKER_MAP.get(sdkKey)) !== null && _a !== void 0 ? _a : [];
    markers.push(marker);
    $acfb204073ed7716$var$MARKER_MAP.set(sdkKey, markers);
}
function $acfb204073ed7716$var$_safeGetField(data, field) {
    if (field in data) return data[field];
    return undefined;
}

});

parcelRegister("9yrlC", function(module, exports) {
"use strict";
var $6f4c80b31b8ae9b0$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.EventLogger = void 0;

var $dOVey = parcelRequire("dOVey");

var $gD7am = parcelRequire("gD7am");

var $8zS3F = parcelRequire("8zS3F");

var $aZSmg = parcelRequire("aZSmg");

var $e9CWO = parcelRequire("e9CWO");

var $knJV8 = parcelRequire("knJV8");

var $9HcT0 = parcelRequire("9HcT0");

var $9Kt1W = parcelRequire("9Kt1W");

var $e9Hsx = parcelRequire("e9Hsx");

var $4afAt = parcelRequire("4afAt");
const $6f4c80b31b8ae9b0$var$DEFAULT_QUEUE_SIZE = 100;
const $6f4c80b31b8ae9b0$var$DEFAULT_FLUSH_INTERVAL_MS = 10000;
const $6f4c80b31b8ae9b0$var$MAX_DEDUPER_KEYS = 1000;
const $6f4c80b31b8ae9b0$var$DEDUPER_WINDOW_DURATION_MS = 600000;
const $6f4c80b31b8ae9b0$var$MAX_FAILED_LOGS = 500;
const $6f4c80b31b8ae9b0$var$QUICK_FLUSH_WINDOW_MS = 200;
const $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP = {};
class $6f4c80b31b8ae9b0$var$EventLogger {
    static _safeFlushAndForget(sdkKey) {
        var _a;
        (_a = $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a.flush().catch(()=>{
        // noop
        });
    }
    static _safeRetryFailedLogs(sdkKey) {
        var _a;
        (_a = $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP[sdkKey]) === null || _a === void 0 || _a._retryFailedLogs();
    }
    constructor(_sdkKey, _emitter, _network, _options){
        var _a, _b;
        this._sdkKey = _sdkKey;
        this._emitter = _emitter;
        this._network = _network;
        this._options = _options;
        this._queue = [];
        this._lastExposureTimeMap = {};
        this._nonExposedChecks = {};
        this._hasRunQuickFlush = false;
        this._creationTime = Date.now();
        this._loggingEnabled = (_a = _options === null || _options === void 0 ? void 0 : _options.loggingEnabled) !== null && _a !== void 0 ? _a : (_options === null || _options === void 0 ? void 0 : _options.disableLogging) === true ? $9HcT0.LoggingEnabledOption.disabled : $9HcT0.LoggingEnabledOption.browserOnly;
        if ((_options === null || _options === void 0 ? void 0 : _options.loggingEnabled) && _options.disableLogging !== undefined) $8zS3F.Log.warn('Detected both loggingEnabled and disableLogging options. loggingEnabled takes precedence - please remove disableLogging.');
        this._maxQueueSize = (_b = _options === null || _options === void 0 ? void 0 : _options.loggingBufferMaxSize) !== null && _b !== void 0 ? _b : $6f4c80b31b8ae9b0$var$DEFAULT_QUEUE_SIZE;
        const config = _options === null || _options === void 0 ? void 0 : _options.networkConfig;
        this._logEventUrlConfig = new $e9Hsx.UrlConfiguration($aZSmg.Endpoint._rgstr, config === null || config === void 0 ? void 0 : config.logEventUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.logEventFallbackUrls);
    }
    setLogEventCompressionMode(mode) {
        this._network.setLogEventCompressionMode(mode);
    }
    setLoggingEnabled(loggingEnabled) {
        if (this._loggingEnabled === 'disabled' && loggingEnabled !== 'disabled') {
            // load any pre consented events into memory
            const storageKey = this._getStorageKey();
            const events = (0, $9Kt1W._getObjectFromStorage)(storageKey);
            if (events) this._queue.push(...events);
            $9Kt1W.Storage.removeItem(storageKey);
        }
        this._loggingEnabled = loggingEnabled;
    }
    enqueue(event) {
        if (!this._shouldLogEvent(event)) return;
        this._normalizeAndAppendEvent(event);
        this._quickFlushIfNeeded();
        if (this._queue.length > this._maxQueueSize) $6f4c80b31b8ae9b0$var$EventLogger._safeFlushAndForget(this._sdkKey);
    }
    incrementNonExposureCount(name) {
        var _a;
        const current = (_a = this._nonExposedChecks[name]) !== null && _a !== void 0 ? _a : 0;
        this._nonExposedChecks[name] = current + 1;
    }
    reset() {
        // attempt to flush any remaining events
        this.flush().catch(()=>{
        // noop
        });
        this._lastExposureTimeMap = {};
    }
    start() {
        var _a;
        const isServerEnv = (0, $e9CWO._isServerEnv)();
        if (isServerEnv && ((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always') return;
        $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP[this._sdkKey] = this;
        if (!isServerEnv) (0, $4afAt._subscribeToVisiblityChanged)((visibility)=>{
            if (visibility === 'background') $6f4c80b31b8ae9b0$var$EventLogger._safeFlushAndForget(this._sdkKey);
            else if (visibility === 'foreground') $6f4c80b31b8ae9b0$var$EventLogger._safeRetryFailedLogs(this._sdkKey);
        });
        this._retryFailedLogs();
        this._startBackgroundFlushInterval();
    }
    stop() {
        return $6f4c80b31b8ae9b0$var$__awaiter(this, void 0, void 0, function*() {
            if (this._flushIntervalId) {
                clearInterval(this._flushIntervalId);
                this._flushIntervalId = null;
            }
            delete $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP[this._sdkKey];
            yield this.flush();
        });
    }
    flush() {
        return $6f4c80b31b8ae9b0$var$__awaiter(this, void 0, void 0, function*() {
            this._appendAndResetNonExposedChecks();
            if (this._queue.length === 0) return;
            const events = this._queue;
            this._queue = [];
            yield this._sendEvents(events);
        });
    }
    /**
     * We 'Quick Flush' following the very first event enqueued
     * within the quick flush window
     */ _quickFlushIfNeeded() {
        if (this._hasRunQuickFlush) return;
        this._hasRunQuickFlush = true;
        if (Date.now() - this._creationTime > $6f4c80b31b8ae9b0$var$QUICK_FLUSH_WINDOW_MS) return;
        setTimeout(()=>$6f4c80b31b8ae9b0$var$EventLogger._safeFlushAndForget(this._sdkKey), $6f4c80b31b8ae9b0$var$QUICK_FLUSH_WINDOW_MS);
    }
    _shouldLogEvent(event) {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingEnabled) !== 'always' && (0, $e9CWO._isServerEnv)()) return false;
        if (!(0, $knJV8._isExposureEvent)(event)) return true;
        const user = event.user ? event.user : {
            statsigEnvironment: undefined
        };
        const userKey = (0, $dOVey._getUserStorageKey)(this._sdkKey, user);
        const metadata = event.metadata ? event.metadata : {};
        const key = [
            event.eventName,
            userKey,
            metadata['gate'],
            metadata['config'],
            metadata['ruleID'],
            metadata['allocatedExperiment'],
            metadata['parameterName'],
            String(metadata['isExplicitParameter']),
            metadata['reason']
        ].join('|');
        const previous = this._lastExposureTimeMap[key];
        const now = Date.now();
        if (previous && now - previous < $6f4c80b31b8ae9b0$var$DEDUPER_WINDOW_DURATION_MS) return false;
        if (Object.keys(this._lastExposureTimeMap).length > $6f4c80b31b8ae9b0$var$MAX_DEDUPER_KEYS) this._lastExposureTimeMap = {};
        this._lastExposureTimeMap[key] = now;
        return true;
    }
    _sendEvents(events) {
        return $6f4c80b31b8ae9b0$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (this._loggingEnabled === 'disabled') {
                this._saveFailedLogsToStorage(events);
                return false;
            }
            try {
                const isClosing = (0, $4afAt._isUnloading)();
                const shouldUseBeacon = isClosing && this._network.isBeaconSupported() && ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.networkOverrideFunc) == null;
                this._emitter({
                    name: 'pre_logs_flushed',
                    events: events
                });
                const response = shouldUseBeacon ? this._sendEventsViaBeacon(events) : yield this._sendEventsViaPost(events);
                if (response.success) {
                    this._emitter({
                        name: 'logs_flushed',
                        events: events
                    });
                    return true;
                } else {
                    $8zS3F.Log.warn('Failed to flush events.');
                    this._saveFailedLogsToStorage(events);
                    return false;
                }
            } catch (_c) {
                $8zS3F.Log.warn('Failed to flush events.');
                return false;
            }
        });
    }
    _sendEventsViaPost(events) {
        return $6f4c80b31b8ae9b0$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield this._network.post(this._getRequestData(events));
            const code = (_a = result === null || result === void 0 ? void 0 : result.code) !== null && _a !== void 0 ? _a : -1;
            return {
                success: code >= 200 && code < 300
            };
        });
    }
    _sendEventsViaBeacon(events) {
        return {
            success: this._network.beacon(this._getRequestData(events))
        };
    }
    _getRequestData(events) {
        return {
            sdkKey: this._sdkKey,
            data: {
                events: events
            },
            urlConfig: this._logEventUrlConfig,
            retries: 3,
            isCompressable: true,
            params: {
                [$aZSmg.NetworkParam.EventCount]: String(events.length)
            },
            credentials: 'same-origin'
        };
    }
    _saveFailedLogsToStorage(events) {
        while(events.length > $6f4c80b31b8ae9b0$var$MAX_FAILED_LOGS)events.shift();
        const storageKey = this._getStorageKey();
        try {
            const savedEvents = this._getFailedLogsFromStorage(storageKey);
            (0, $9Kt1W._setObjectInStorage)(storageKey, [
                ...savedEvents,
                ...events
            ]);
        } catch (_a) {
            $8zS3F.Log.warn('Unable to save failed logs to storage');
        }
    }
    _getFailedLogsFromStorage(storageKey) {
        let savedEvents = [];
        try {
            const retrieved = (0, $9Kt1W._getObjectFromStorage)(storageKey);
            if (Array.isArray(retrieved)) savedEvents = retrieved;
            return savedEvents;
        } catch (_a) {
            return [];
        }
    }
    _retryFailedLogs() {
        const storageKey = this._getStorageKey();
        (()=>$6f4c80b31b8ae9b0$var$__awaiter(this, void 0, void 0, function*() {
                if (!$9Kt1W.Storage.isReady()) yield $9Kt1W.Storage.isReadyResolver();
                const events = (0, $9Kt1W._getObjectFromStorage)(storageKey);
                if (!events) return;
                $9Kt1W.Storage.removeItem(storageKey);
                yield this._sendEvents(events);
            }))().catch(()=>{
            $8zS3F.Log.warn('Failed to flush stored logs');
        });
    }
    _getStorageKey() {
        return `statsig.failed_logs.${(0, $gD7am._DJB2)(this._sdkKey)}`;
    }
    _normalizeAndAppendEvent(event) {
        if (event.user) {
            event.user = Object.assign({}, event.user);
            delete event.user.privateAttributes;
        }
        const extras = {};
        const currentPage = this._getCurrentPageUrl();
        if (currentPage) extras.statsigMetadata = {
            currentPage: currentPage
        };
        const final = Object.assign(Object.assign({}, event), extras);
        $8zS3F.Log.debug('Enqueued Event:', final);
        this._queue.push(final);
    }
    _appendAndResetNonExposedChecks() {
        if (Object.keys(this._nonExposedChecks).length === 0) return;
        this._normalizeAndAppendEvent({
            eventName: 'statsig::non_exposed_checks',
            user: null,
            time: Date.now(),
            metadata: {
                checks: Object.assign({}, this._nonExposedChecks)
            }
        });
        this._nonExposedChecks = {};
    }
    _getCurrentPageUrl() {
        var _a;
        if (((_a = this._options) === null || _a === void 0 ? void 0 : _a.includeCurrentPageUrlWithEvents) === false) return;
        return (0, $e9CWO._getCurrentPageUrlSafe)();
    }
    _startBackgroundFlushInterval() {
        var _a, _b;
        const flushInterval = (_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.loggingIntervalMs) !== null && _b !== void 0 ? _b : $6f4c80b31b8ae9b0$var$DEFAULT_FLUSH_INTERVAL_MS;
        const intervalId = setInterval(()=>{
            const logger = $6f4c80b31b8ae9b0$var$EVENT_LOGGER_MAP[this._sdkKey];
            if (!logger || logger._flushIntervalId !== intervalId) clearInterval(intervalId);
            else $6f4c80b31b8ae9b0$var$EventLogger._safeFlushAndForget(this._sdkKey);
        }, flushInterval);
        this._flushIntervalId = intervalId;
    }
}
module.exports.EventLogger = $6f4c80b31b8ae9b0$var$EventLogger;

});
parcelRegister("dOVey", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getStorageKey = module.exports._getUserStorageKey = void 0;

var $gD7am = parcelRequire("gD7am");
function $a0fc574a48dbf2c8$var$_getUserStorageKey(sdkKey, user, customKeyGenerator) {
    var _a;
    if (customKeyGenerator) return customKeyGenerator(sdkKey, user);
    const cids = user && user.customIDs ? user.customIDs : {};
    const parts = [
        `uid:${(_a = user === null || user === void 0 ? void 0 : user.userID) !== null && _a !== void 0 ? _a : ''}`,
        `cids:${Object.keys(cids).sort((leftKey, rightKey)=>leftKey.localeCompare(rightKey)).map((key)=>`${key}-${cids[key]}`).join(',')}`,
        `k:${sdkKey}`
    ];
    return (0, $gD7am._DJB2)(parts.join('|'));
}
module.exports._getUserStorageKey = $a0fc574a48dbf2c8$var$_getUserStorageKey;
function $a0fc574a48dbf2c8$var$_getStorageKey(sdkKey, user, customKeyGenerator) {
    if (user) return $a0fc574a48dbf2c8$var$_getUserStorageKey(sdkKey, user, customKeyGenerator);
    return (0, $gD7am._DJB2)(`k:${sdkKey}`);
}
module.exports._getStorageKey = $a0fc574a48dbf2c8$var$_getStorageKey;

});
parcelRegister("gD7am", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getSortedObject = module.exports._DJB2Object = module.exports._DJB2 = void 0;

var $9mTS6 = parcelRequire("9mTS6");
const $c1b5d8e52ec557d0$var$_DJB2 = (value)=>{
    let hash = 0;
    for(let i = 0; i < value.length; i++){
        const character = value.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return String(hash >>> 0);
};
module.exports._DJB2 = $c1b5d8e52ec557d0$var$_DJB2;
const $c1b5d8e52ec557d0$var$_DJB2Object = (value, maxLevels)=>{
    return (0, module.exports._DJB2)(JSON.stringify((0, module.exports._getSortedObject)(value, maxLevels)));
};
module.exports._DJB2Object = $c1b5d8e52ec557d0$var$_DJB2Object;
const $c1b5d8e52ec557d0$var$_getSortedObject = (object, maxDepth)=>{
    if (object == null) return null;
    const keys = Object.keys(object).sort();
    const sortedObject = {};
    keys.forEach((key)=>{
        const value = object[key];
        if (maxDepth === 0 || (0, $9mTS6._typeOf)(value) !== 'object') {
            sortedObject[key] = value;
            return;
        }
        sortedObject[key] = (0, module.exports._getSortedObject)(value, maxDepth != null ? maxDepth - 1 : maxDepth);
    });
    return sortedObject;
};
module.exports._getSortedObject = $c1b5d8e52ec557d0$var$_getSortedObject;

});
parcelRegister("9mTS6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isTypeMatch = module.exports._typeOf = void 0;
function $6d21820beca1797c$var$_typeOf(input) {
    return Array.isArray(input) ? 'array' : typeof input;
}
module.exports._typeOf = $6d21820beca1797c$var$_typeOf;
function $6d21820beca1797c$var$_isTypeMatch(a, b) {
    const typeOf = (x)=>Array.isArray(x) ? 'array' : x === null ? 'null' : typeof x;
    return typeOf(a) === typeOf(b);
}
module.exports._isTypeMatch = $6d21820beca1797c$var$_isTypeMatch;

});



parcelRegister("aZSmg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkParam = module.exports.NetworkDefault = module.exports.Endpoint = void 0;
module.exports.Endpoint = {
    _initialize: 'initialize',
    _rgstr: 'rgstr',
    _download_config_specs: 'download_config_specs'
};
module.exports.NetworkDefault = {
    [module.exports.Endpoint._rgstr]: 'https://prodregistryv2.org/v1',
    [module.exports.Endpoint._initialize]: 'https://featureassets.org/v1',
    [module.exports.Endpoint._download_config_specs]: 'https://api.statsigcdn.com/v1'
};
module.exports.NetworkParam = {
    EventCount: 'ec',
    SdkKey: 'k',
    SdkType: 'st',
    SdkVersion: 'sv',
    Time: 't',
    SessionID: 'sid',
    StatsigEncoded: 'se',
    IsGzipped: 'gz'
};

});

parcelRegister("e9CWO", function(module, exports) {

var $gIMgJ = parcelRequire("gIMgJ");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getUnloadEvent = module.exports._getCurrentPageUrlSafe = module.exports._addDocumentEventListenerSafe = module.exports._addWindowEventListenerSafe = module.exports._isServerEnv = module.exports._getDocumentSafe = module.exports._getWindowSafe = void 0;
const $a4e01e22206d7306$var$_getWindowSafe = ()=>{
    return typeof window !== 'undefined' ? window : null;
};
module.exports._getWindowSafe = $a4e01e22206d7306$var$_getWindowSafe;
const $a4e01e22206d7306$var$_getDocumentSafe = ()=>{
    var _a;
    const win = (0, module.exports._getWindowSafe)();
    return (_a = win === null || win === void 0 ? void 0 : win.document) !== null && _a !== void 0 ? _a : null;
};
module.exports._getDocumentSafe = $a4e01e22206d7306$var$_getDocumentSafe;
const $a4e01e22206d7306$var$_isServerEnv = ()=>{
    if ((0, module.exports._getDocumentSafe)() !== null) return false;
    const isNode = typeof $gIMgJ !== 'undefined' && $gIMgJ.versions != null && $gIMgJ.versions.node != null;
    const isVercel = typeof EdgeRuntime === 'string';
    return isVercel || isNode;
};
module.exports._isServerEnv = $a4e01e22206d7306$var$_isServerEnv;
const $a4e01e22206d7306$var$_addWindowEventListenerSafe = (key, listener)=>{
    const win = (0, module.exports._getWindowSafe)();
    if (typeof (win === null || win === void 0 ? void 0 : win.addEventListener) === 'function') win.addEventListener(key, listener);
};
module.exports._addWindowEventListenerSafe = $a4e01e22206d7306$var$_addWindowEventListenerSafe;
const $a4e01e22206d7306$var$_addDocumentEventListenerSafe = (key, listener)=>{
    const doc = (0, module.exports._getDocumentSafe)();
    if (typeof (doc === null || doc === void 0 ? void 0 : doc.addEventListener) === 'function') doc.addEventListener(key, listener);
};
module.exports._addDocumentEventListenerSafe = $a4e01e22206d7306$var$_addDocumentEventListenerSafe;
const $a4e01e22206d7306$var$_getCurrentPageUrlSafe = ()=>{
    var _a;
    try {
        return (_a = (0, module.exports._getWindowSafe)()) === null || _a === void 0 ? void 0 : _a.location.href.split(/[?#]/)[0];
    } catch (_b) {
        return;
    }
};
module.exports._getCurrentPageUrlSafe = $a4e01e22206d7306$var$_getCurrentPageUrlSafe;
const $a4e01e22206d7306$var$_getUnloadEvent = ()=>{
    const win = (0, module.exports._getWindowSafe)();
    if (!win) return 'beforeunload';
    const eventType = 'onpagehide' in win ? 'pagehide' : 'beforeunload';
    return eventType;
};
module.exports._getUnloadEvent = $a4e01e22206d7306$var$_getUnloadEvent;

});

parcelRegister("knJV8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._createLayerParameterExposure = module.exports._createConfigExposure = module.exports._mapExposures = module.exports._createGateExposure = module.exports._isExposureEvent = void 0;
const $ed699380f6fb8f75$var$CONFIG_EXPOSURE_NAME = 'statsig::config_exposure';
const $ed699380f6fb8f75$var$GATE_EXPOSURE_NAME = 'statsig::gate_exposure';
const $ed699380f6fb8f75$var$LAYER_EXPOSURE_NAME = 'statsig::layer_exposure';
const $ed699380f6fb8f75$var$_createExposure = (eventName, user, details, metadata, secondaryExposures)=>{
    if (details.bootstrapMetadata) metadata['bootstrapMetadata'] = details.bootstrapMetadata;
    return {
        eventName: eventName,
        user: user,
        value: null,
        metadata: $ed699380f6fb8f75$var$_addEvaluationDetailsToMetadata(details, metadata),
        secondaryExposures: secondaryExposures,
        time: Date.now()
    };
};
const $ed699380f6fb8f75$var$_isExposureEvent = ({ eventName: eventName })=>{
    return eventName === $ed699380f6fb8f75$var$GATE_EXPOSURE_NAME || eventName === $ed699380f6fb8f75$var$CONFIG_EXPOSURE_NAME || eventName === $ed699380f6fb8f75$var$LAYER_EXPOSURE_NAME;
};
module.exports._isExposureEvent = $ed699380f6fb8f75$var$_isExposureEvent;
const $ed699380f6fb8f75$var$_createGateExposure = (user, gate, exposureMapping)=>{
    var _a, _b, _c;
    const metadata = {
        gate: gate.name,
        gateValue: String(gate.value),
        ruleID: gate.ruleID
    };
    if (((_a = gate.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = gate.__evaluation.version;
    return $ed699380f6fb8f75$var$_createExposure($ed699380f6fb8f75$var$GATE_EXPOSURE_NAME, user, gate.details, metadata, $ed699380f6fb8f75$var$_mapExposures((_c = (_b = gate.__evaluation) === null || _b === void 0 ? void 0 : _b.secondary_exposures) !== null && _c !== void 0 ? _c : [], exposureMapping));
};
module.exports._createGateExposure = $ed699380f6fb8f75$var$_createGateExposure;
function $ed699380f6fb8f75$var$_mapExposures(exposures, exposureMapping) {
    return exposures.map((exposure)=>{
        if (typeof exposure === 'string') return (exposureMapping !== null && exposureMapping !== void 0 ? exposureMapping : {})[exposure];
        return exposure;
    }).filter((exposure)=>exposure != null);
}
module.exports._mapExposures = $ed699380f6fb8f75$var$_mapExposures;
const $ed699380f6fb8f75$var$_createConfigExposure = (user, config, exposureMapping)=>{
    var _a, _b, _c, _d;
    const metadata = {
        config: config.name,
        ruleID: config.ruleID
    };
    if (((_a = config.__evaluation) === null || _a === void 0 ? void 0 : _a.version) != null) metadata['configVersion'] = config.__evaluation.version;
    if (((_b = config.__evaluation) === null || _b === void 0 ? void 0 : _b.passed) != null) metadata['rulePassed'] = String(config.__evaluation.passed);
    return $ed699380f6fb8f75$var$_createExposure($ed699380f6fb8f75$var$CONFIG_EXPOSURE_NAME, user, config.details, metadata, $ed699380f6fb8f75$var$_mapExposures((_d = (_c = config.__evaluation) === null || _c === void 0 ? void 0 : _c.secondary_exposures) !== null && _d !== void 0 ? _d : [], exposureMapping));
};
module.exports._createConfigExposure = $ed699380f6fb8f75$var$_createConfigExposure;
const $ed699380f6fb8f75$var$_createLayerParameterExposure = (user, layer, parameterName, exposureMapping)=>{
    var _a, _b, _c, _d, _e, _f, _g;
    const evaluation = layer.__evaluation;
    const isExplicit = ((_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.explicit_parameters) === null || _a === void 0 ? void 0 : _a.includes(parameterName)) === true;
    let allocatedExperiment = '';
    let secondaryExposures = (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.undelegated_secondary_exposures) !== null && _b !== void 0 ? _b : [];
    if (isExplicit) {
        allocatedExperiment = (_c = evaluation.allocated_experiment_name) !== null && _c !== void 0 ? _c : '';
        secondaryExposures = (_d = evaluation.secondary_exposures) !== null && _d !== void 0 ? _d : [];
    }
    const parameterRuleIDs = (_e = layer.__evaluation) === null || _e === void 0 ? void 0 : _e.parameter_rule_ids;
    const metadata = {
        config: layer.name,
        parameterName: parameterName,
        ruleID: (_f = parameterRuleIDs === null || parameterRuleIDs === void 0 ? void 0 : parameterRuleIDs[parameterName]) !== null && _f !== void 0 ? _f : layer.ruleID,
        allocatedExperiment: allocatedExperiment,
        isExplicitParameter: String(isExplicit)
    };
    if (((_g = layer.__evaluation) === null || _g === void 0 ? void 0 : _g.version) != null) metadata['configVersion'] = layer.__evaluation.version;
    return $ed699380f6fb8f75$var$_createExposure($ed699380f6fb8f75$var$LAYER_EXPOSURE_NAME, user, layer.details, metadata, $ed699380f6fb8f75$var$_mapExposures(secondaryExposures, exposureMapping));
};
module.exports._createLayerParameterExposure = $ed699380f6fb8f75$var$_createLayerParameterExposure;
const $ed699380f6fb8f75$var$_addEvaluationDetailsToMetadata = (details, metadata)=>{
    metadata['reason'] = details.reason;
    if (details.lcut) metadata['lcut'] = String(details.lcut);
    if (details.receivedAt) metadata['receivedAt'] = String(details.receivedAt);
    return metadata;
};

});

parcelRegister("9HcT0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.LoggingEnabledOption = module.exports.LogEventCompressionMode = void 0;
module.exports.LogEventCompressionMode = {
    /** Do not compress request bodies */ Disabled: 'd',
    /** Compress request bodies unless a network proxy is configured */ Enabled: 'e',
    /** Always compress request bodies, even when a proxy is configured */ Forced: 'f'
};
module.exports.LoggingEnabledOption = {
    disabled: 'disabled',
    browserOnly: 'browser-only',
    always: 'always'
};

});

parcelRegister("9Kt1W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._setObjectInStorage = module.exports._getObjectFromStorage = module.exports.Storage = void 0;

var $8zS3F = parcelRequire("8zS3F");

var $e9CWO = parcelRequire("e9CWO");
const $718eedbb6d2d190d$var$inMemoryStore = {};
const $718eedbb6d2d190d$var$_inMemoryProvider = {
    isReady: ()=>true,
    isReadyResolver: ()=>null,
    getProviderName: ()=>'InMemory',
    getItem: (key)=>$718eedbb6d2d190d$var$inMemoryStore[key] ? $718eedbb6d2d190d$var$inMemoryStore[key] : null,
    setItem: (key, value)=>{
        $718eedbb6d2d190d$var$inMemoryStore[key] = value;
    },
    removeItem: (key)=>{
        delete $718eedbb6d2d190d$var$inMemoryStore[key];
    },
    getAllKeys: ()=>Object.keys($718eedbb6d2d190d$var$inMemoryStore)
};
let $718eedbb6d2d190d$var$_localStorageProvider = null;
try {
    const win = (0, $e9CWO._getWindowSafe)();
    if (win && win.localStorage && typeof win.localStorage.getItem === 'function') $718eedbb6d2d190d$var$_localStorageProvider = {
        isReady: ()=>true,
        isReadyResolver: ()=>null,
        getProviderName: ()=>'LocalStorage',
        getItem: (key)=>win.localStorage.getItem(key),
        setItem: (key, value)=>win.localStorage.setItem(key, value),
        removeItem: (key)=>win.localStorage.removeItem(key),
        getAllKeys: ()=>Object.keys(win.localStorage)
    };
} catch (error) {
    $8zS3F.Log.warn('Failed to setup localStorageProvider.');
}
let $718eedbb6d2d190d$var$_main = $718eedbb6d2d190d$var$_localStorageProvider !== null && $718eedbb6d2d190d$var$_localStorageProvider !== void 0 ? $718eedbb6d2d190d$var$_localStorageProvider : $718eedbb6d2d190d$var$_inMemoryProvider;
let $718eedbb6d2d190d$var$_current = $718eedbb6d2d190d$var$_main;
function $718eedbb6d2d190d$var$_inMemoryBreaker(action) {
    try {
        return action();
    } catch (error) {
        if (error instanceof Error && error.name === 'SecurityError') {
            module.exports.Storage._setProvider($718eedbb6d2d190d$var$_inMemoryProvider);
            return null;
        }
        throw error;
    }
}
module.exports.Storage = {
    isReady: ()=>$718eedbb6d2d190d$var$_current.isReady(),
    isReadyResolver: ()=>$718eedbb6d2d190d$var$_current.isReadyResolver(),
    getProviderName: ()=>$718eedbb6d2d190d$var$_current.getProviderName(),
    getItem: (key)=>$718eedbb6d2d190d$var$_inMemoryBreaker(()=>$718eedbb6d2d190d$var$_current.getItem(key)),
    setItem: (key, value)=>$718eedbb6d2d190d$var$_inMemoryBreaker(()=>$718eedbb6d2d190d$var$_current.setItem(key, value)),
    removeItem: (key)=>$718eedbb6d2d190d$var$_current.removeItem(key),
    getAllKeys: ()=>$718eedbb6d2d190d$var$_current.getAllKeys(),
    // StorageProviderManagment
    _setProvider: (newProvider)=>{
        $718eedbb6d2d190d$var$_main = newProvider;
        $718eedbb6d2d190d$var$_current = newProvider;
    },
    _setDisabled: (isDisabled)=>{
        if (isDisabled) $718eedbb6d2d190d$var$_current = $718eedbb6d2d190d$var$_inMemoryProvider;
        else $718eedbb6d2d190d$var$_current = $718eedbb6d2d190d$var$_main;
    }
};
function $718eedbb6d2d190d$var$_getObjectFromStorage(key) {
    const value = module.exports.Storage.getItem(key);
    try {
        return JSON.parse(value !== null && value !== void 0 ? value : 'null');
    } catch (e) {
        $8zS3F.Log.error(`Failed to parse value for key "${key}"`);
        return null;
    }
}
module.exports._getObjectFromStorage = $718eedbb6d2d190d$var$_getObjectFromStorage;
function $718eedbb6d2d190d$var$_setObjectInStorage(key, obj) {
    module.exports.Storage.setItem(key, JSON.stringify(obj));
}
module.exports._setObjectInStorage = $718eedbb6d2d190d$var$_setObjectInStorage;

});

parcelRegister("e9Hsx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UrlConfiguration = void 0;

var $gD7am = parcelRequire("gD7am");

var $aZSmg = parcelRequire("aZSmg");
const $a4e39e168a9c6dbd$var$ENDPOINT_DNS_KEY_MAP = {
    [$aZSmg.Endpoint._initialize]: 'i',
    [$aZSmg.Endpoint._rgstr]: 'e',
    [$aZSmg.Endpoint._download_config_specs]: 'd'
};
class $a4e39e168a9c6dbd$var$UrlConfiguration {
    constructor(endpoint, customUrl, customApi, fallbackUrls){
        this.customUrl = null;
        this.fallbackUrls = null;
        this.endpoint = endpoint;
        this.endpointDnsKey = $a4e39e168a9c6dbd$var$ENDPOINT_DNS_KEY_MAP[endpoint];
        if (customUrl) this.customUrl = customUrl;
        if (!customUrl && customApi) this.customUrl = customApi.endsWith('/') ? `${customApi}${endpoint}` : `${customApi}/${endpoint}`;
        if (fallbackUrls) this.fallbackUrls = fallbackUrls;
        const defaultApi = $aZSmg.NetworkDefault[endpoint];
        this.defaultUrl = `${defaultApi}/${endpoint}`;
    }
    getUrl() {
        var _a;
        return (_a = this.customUrl) !== null && _a !== void 0 ? _a : this.defaultUrl;
    }
    getChecksum() {
        var _a;
        const fallbacks = ((_a = this.fallbackUrls) !== null && _a !== void 0 ? _a : []).sort().join(',');
        return (0, $gD7am._DJB2)(this.customUrl + fallbacks);
    }
}
module.exports.UrlConfiguration = $a4e39e168a9c6dbd$var$UrlConfiguration;

});

parcelRegister("4afAt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._notifyVisibilityChanged = module.exports._subscribeToVisiblityChanged = module.exports._isUnloading = module.exports._isCurrentlyVisible = void 0;

var $e9CWO = parcelRequire("e9CWO");
const $30842fedc2d773c4$var$FOREGROUND = 'foreground';
const $30842fedc2d773c4$var$BACKGROUND = 'background';
const $30842fedc2d773c4$var$LISTENERS = [];
let $30842fedc2d773c4$var$current = $30842fedc2d773c4$var$FOREGROUND;
let $30842fedc2d773c4$var$isUnloading = false;
const $30842fedc2d773c4$var$_isCurrentlyVisible = ()=>{
    return $30842fedc2d773c4$var$current === $30842fedc2d773c4$var$FOREGROUND;
};
module.exports._isCurrentlyVisible = $30842fedc2d773c4$var$_isCurrentlyVisible;
const $30842fedc2d773c4$var$_isUnloading = ()=>$30842fedc2d773c4$var$isUnloading;
module.exports._isUnloading = $30842fedc2d773c4$var$_isUnloading;
const $30842fedc2d773c4$var$_subscribeToVisiblityChanged = (listener)=>{
    $30842fedc2d773c4$var$LISTENERS.unshift(listener);
};
module.exports._subscribeToVisiblityChanged = $30842fedc2d773c4$var$_subscribeToVisiblityChanged;
const $30842fedc2d773c4$var$_notifyVisibilityChanged = (visibility)=>{
    if (visibility === $30842fedc2d773c4$var$current) return;
    $30842fedc2d773c4$var$current = visibility;
    $30842fedc2d773c4$var$LISTENERS.forEach((l)=>l(visibility));
};
module.exports._notifyVisibilityChanged = $30842fedc2d773c4$var$_notifyVisibilityChanged;
(0, $e9CWO._addWindowEventListenerSafe)('focus', ()=>{
    $30842fedc2d773c4$var$isUnloading = false;
    (0, module.exports._notifyVisibilityChanged)($30842fedc2d773c4$var$FOREGROUND);
});
(0, $e9CWO._addWindowEventListenerSafe)('blur', ()=>(0, module.exports._notifyVisibilityChanged)($30842fedc2d773c4$var$BACKGROUND));
(0, $e9CWO._addDocumentEventListenerSafe)('visibilitychange', ()=>{
    (0, module.exports._notifyVisibilityChanged)(document.visibilityState === 'visible' ? $30842fedc2d773c4$var$FOREGROUND : $30842fedc2d773c4$var$BACKGROUND);
});
(0, $e9CWO._addWindowEventListenerSafe)((0, $e9CWO._getUnloadEvent)(), ()=>{
    $30842fedc2d773c4$var$isUnloading = true;
    (0, module.exports._notifyVisibilityChanged)($30842fedc2d773c4$var$BACKGROUND);
});

});


parcelRegister("7K2uC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigMetadataProvider = module.exports.SDK_VERSION = void 0;
module.exports.SDK_VERSION = '3.30.2';
let $5a2ec34a7498d93e$var$metadata = {
    sdkVersion: module.exports.SDK_VERSION,
    sdkType: 'js-mono'
};
module.exports.StatsigMetadataProvider = {
    get: ()=>$5a2ec34a7498d93e$var$metadata,
    add: (additions)=>{
        $5a2ec34a7498d93e$var$metadata = Object.assign(Object.assign({}, $5a2ec34a7498d93e$var$metadata), additions);
    }
};

});

parcelRegister("4WEZS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("dRUZU", function(module, exports) {
"use strict";
var $a18c701b23f4916f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeDataAdapterResult = module.exports.DataAdapterCore = void 0;

var $8zS3F = parcelRequire("8zS3F");

var $96q1S = parcelRequire("96q1S");

var $9PGpW = parcelRequire("9PGpW");

var $9Kt1W = parcelRequire("9Kt1W");

var $9jpT3 = parcelRequire("9jpT3");
const $a18c701b23f4916f$var$CACHE_LIMIT = 10;
const $a18c701b23f4916f$var$MAX_CACHE_WRITE_ATTEMPTS = 8;
class $a18c701b23f4916f$var$DataAdapterCore {
    constructor(_adapterName, _cacheSuffix){
        this._adapterName = _adapterName;
        this._cacheSuffix = _cacheSuffix;
        this._options = null;
        this._sdkKey = null;
        this._cacheLimit = $a18c701b23f4916f$var$CACHE_LIMIT;
        this._lastModifiedStoreKey = `statsig.last_modified_time.${_cacheSuffix}`;
        this._inMemoryCache = new $a18c701b23f4916f$var$InMemoryCache();
    }
    attach(sdkKey, options, _network) {
        this._sdkKey = sdkKey;
        this._options = options;
    }
    getDataSync(user) {
        const normalized = user && (0, $9PGpW._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        const inMem = this._inMemoryCache.get(cacheKey, normalized);
        if (inMem && this._getIsCacheValueValid(inMem)) return inMem;
        const cache = this._loadFromCache(cacheKey);
        if (cache && this._getIsCacheValueValid(cache)) {
            this._inMemoryCache.add(cacheKey, cache, this._cacheLimit);
            return this._inMemoryCache.get(cacheKey, normalized);
        }
        return null;
    }
    setData(data, user) {
        const normalized = user && (0, $9PGpW._normalizeUser)(user, this._options);
        const cacheKey = this._getCacheKey(normalized);
        this._inMemoryCache.add(cacheKey, $a18c701b23f4916f$var$_makeDataAdapterResult('Bootstrap', data, null, normalized), this._cacheLimit);
    }
    _getIsCacheValueValid(current) {
        return current.stableID == null || current.stableID === $96q1S.StableID.get(this._getSdkKey());
    }
    _getDataAsyncImpl(current, user, options) {
        return $a18c701b23f4916f$var$__awaiter(this, void 0, void 0, function*() {
            if (!$9Kt1W.Storage.isReady()) yield $9Kt1W.Storage.isReadyResolver();
            const cache = current !== null && current !== void 0 ? current : this.getDataSync(user);
            const ops = [
                this._fetchAndPrepFromNetwork(cache, user, options)
            ];
            if (options === null || options === void 0 ? void 0 : options.timeoutMs) ops.push(new Promise((r)=>setTimeout(r, options.timeoutMs)).then(()=>{
                $8zS3F.Log.debug('Fetching latest value timed out');
                return null;
            }));
            return yield Promise.race(ops);
        });
    }
    _prefetchDataImpl(user, options) {
        return $a18c701b23f4916f$var$__awaiter(this, void 0, void 0, function*() {
            const normalized = user && (0, $9PGpW._normalizeUser)(user, this._options);
            const cacheKey = this._getCacheKey(normalized);
            const result = yield this._getDataAsyncImpl(null, normalized, options);
            if (result) this._inMemoryCache.add(cacheKey, Object.assign(Object.assign({}, result), {
                source: 'Prefetch'
            }), this._cacheLimit);
        });
    }
    _fetchAndPrepFromNetwork(cachedResult, user, options) {
        return $a18c701b23f4916f$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cachedData = (_a = cachedResult === null || cachedResult === void 0 ? void 0 : cachedResult.data) !== null && _a !== void 0 ? _a : null;
            const isCacheValidFor204 = cachedResult != null && this._isCachedResultValidFor204(cachedResult, user);
            const latest = yield this._fetchFromNetwork(cachedData, user, options, isCacheValidFor204);
            if (!latest) {
                $8zS3F.Log.debug('No response returned for latest value');
                return null;
            }
            const response = (0, $9jpT3._typedJsonParse)(latest, 'has_updates', 'Response');
            const sdkKey = this._getSdkKey();
            const stableID = $96q1S.StableID.get(sdkKey);
            let result = null;
            if ((response === null || response === void 0 ? void 0 : response.has_updates) === true) result = $a18c701b23f4916f$var$_makeDataAdapterResult('Network', latest, stableID, user);
            else if (cachedData && (response === null || response === void 0 ? void 0 : response.has_updates) === false) result = $a18c701b23f4916f$var$_makeDataAdapterResult('NetworkNotModified', cachedData, stableID, user);
            else return null;
            const cacheKey = this._getCacheKey(user);
            this._inMemoryCache.add(cacheKey, result, this._cacheLimit);
            this._writeToCache(cacheKey, result);
            return result;
        });
    }
    _getSdkKey() {
        if (this._sdkKey != null) return this._sdkKey;
        $8zS3F.Log.error(`${this._adapterName} is not attached to a Client`);
        return '';
    }
    _loadFromCache(cacheKey) {
        var _a;
        const cache = (_a = $9Kt1W.Storage.getItem) === null || _a === void 0 ? void 0 : _a.call($9Kt1W.Storage, cacheKey);
        if (cache == null) return null;
        const result = (0, $9jpT3._typedJsonParse)(cache, 'source', 'Cached Result');
        return result ? Object.assign(Object.assign({}, result), {
            source: 'Cache'
        }) : null;
    }
    _writeToCache(cacheKey, result) {
        const resultString = JSON.stringify(result);
        for(let i = 0; i < $a18c701b23f4916f$var$MAX_CACHE_WRITE_ATTEMPTS; i++)try {
            $9Kt1W.Storage.setItem(cacheKey, resultString);
            break;
        } catch (error) {
            if (!(error instanceof Error) || !(error.toString().includes('QuotaExceededError') || error.toString().includes('QUOTA_EXCEEDED_ERR')) || this._cacheLimit <= 1) throw error;
            this._cacheLimit = Math.ceil(this._cacheLimit / 2);
            this._runLocalStorageCacheEviction(cacheKey, this._cacheLimit - 1);
        }
        this._runLocalStorageCacheEviction(cacheKey);
    }
    _runLocalStorageCacheEviction(cacheKey, cacheLimit = this._cacheLimit) {
        var _a;
        const lastModifiedTimeMap = (_a = (0, $9Kt1W._getObjectFromStorage)(this._lastModifiedStoreKey)) !== null && _a !== void 0 ? _a : {};
        lastModifiedTimeMap[cacheKey] = Date.now();
        const evictableKeys = $a18c701b23f4916f$var$_getEvictableKeys(lastModifiedTimeMap, cacheLimit);
        for (const evictable of evictableKeys){
            delete lastModifiedTimeMap[evictable];
            $9Kt1W.Storage.removeItem(evictable);
        }
        (0, $9Kt1W._setObjectInStorage)(this._lastModifiedStoreKey, lastModifiedTimeMap);
    }
}
module.exports.DataAdapterCore = $a18c701b23f4916f$var$DataAdapterCore;
function $a18c701b23f4916f$var$_makeDataAdapterResult(source, data, stableID, user) {
    return {
        source: source,
        data: data,
        receivedAt: Date.now(),
        stableID: stableID,
        fullUserHash: (0, $9PGpW._getFullUserHash)(user)
    };
}
module.exports._makeDataAdapterResult = $a18c701b23f4916f$var$_makeDataAdapterResult;
class $a18c701b23f4916f$var$InMemoryCache {
    constructor(){
        this._data = {};
    }
    get(cacheKey, user) {
        var _a;
        const result = this._data[cacheKey];
        const cached = result === null || result === void 0 ? void 0 : result.stableID;
        const provided = (_a = user === null || user === void 0 ? void 0 : user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (provided && cached && provided !== cached) {
            $8zS3F.Log.warn("'StatsigUser.customIDs.stableID' mismatch");
            return null;
        }
        return result;
    }
    add(cacheKey, value, cacheLimit) {
        const evictableKeys = $a18c701b23f4916f$var$_getEvictableKeys(this._data, cacheLimit - 1);
        for (const evictable of evictableKeys)delete this._data[evictable];
        this._data[cacheKey] = value;
    }
    merge(values) {
        this._data = Object.assign(Object.assign({}, this._data), values);
    }
}
function $a18c701b23f4916f$var$_getEvictableKeys(data, limit) {
    const keys = Object.keys(data);
    if (keys.length <= limit) return [];
    if (limit === 0) return keys;
    return keys.sort((keyA, keyB)=>{
        const valueA = data[keyA];
        const valueB = data[keyB];
        if (typeof valueA === 'object' && typeof valueB === 'object') return valueA.receivedAt - valueB.receivedAt;
        return valueA - valueB;
    }).slice(0, keys.length - limit);
}

});
parcelRegister("96q1S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getCookieName = module.exports.StableID = void 0;

var $dOVey = parcelRequire("dOVey");

var $8zS3F = parcelRequire("8zS3F");

var $e9CWO = parcelRequire("e9CWO");

var $9Kt1W = parcelRequire("9Kt1W");

var $axqyl = parcelRequire("axqyl");
const $6a08dd79814f2299$var$PROMISE_MAP = {};
const $6a08dd79814f2299$var$COOKIE_ENABLED_MAP = {};
const $6a08dd79814f2299$var$DISABLED_MAP = {};
module.exports.StableID = {
    cookiesEnabled: false,
    randomID: Math.random().toString(36),
    get: (sdkKey)=>{
        if ($6a08dd79814f2299$var$DISABLED_MAP[sdkKey]) return null;
        if ($6a08dd79814f2299$var$PROMISE_MAP[sdkKey] != null) return $6a08dd79814f2299$var$PROMISE_MAP[sdkKey];
        let stableID = null;
        stableID = $6a08dd79814f2299$var$_loadFromCookie(sdkKey);
        if (stableID != null) {
            $6a08dd79814f2299$var$PROMISE_MAP[sdkKey] = stableID;
            $6a08dd79814f2299$var$_persistToStorage(stableID, sdkKey);
            return stableID;
        }
        stableID = $6a08dd79814f2299$var$_loadFromStorage(sdkKey);
        if (stableID == null) stableID = (0, $axqyl.getUUID)();
        $6a08dd79814f2299$var$_persistToStorage(stableID, sdkKey);
        $6a08dd79814f2299$var$_persistToCookie(stableID, sdkKey);
        $6a08dd79814f2299$var$PROMISE_MAP[sdkKey] = stableID;
        return stableID;
    },
    setOverride: (override, sdkKey)=>{
        $6a08dd79814f2299$var$PROMISE_MAP[sdkKey] = override;
        $6a08dd79814f2299$var$_persistToStorage(override, sdkKey);
        $6a08dd79814f2299$var$_persistToCookie(override, sdkKey);
    },
    _setCookiesEnabled: (sdkKey, cookiesEnabled)=>{
        $6a08dd79814f2299$var$COOKIE_ENABLED_MAP[sdkKey] = cookiesEnabled;
    },
    _setDisabled: (sdkKey, disabled)=>{
        $6a08dd79814f2299$var$DISABLED_MAP[sdkKey] = disabled;
    }
};
function $6a08dd79814f2299$var$_getStableIDStorageKey(sdkKey) {
    return `statsig.stable_id.${(0, $dOVey._getStorageKey)(sdkKey)}`;
}
function $6a08dd79814f2299$var$_persistToStorage(stableID, sdkKey) {
    const storageKey = $6a08dd79814f2299$var$_getStableIDStorageKey(sdkKey);
    try {
        (0, $9Kt1W._setObjectInStorage)(storageKey, stableID);
    } catch (e) {
        $8zS3F.Log.warn('Failed to save StableID to storage');
    }
}
function $6a08dd79814f2299$var$_loadFromStorage(sdkKey) {
    const storageKey = $6a08dd79814f2299$var$_getStableIDStorageKey(sdkKey);
    return (0, $9Kt1W._getObjectFromStorage)(storageKey);
}
function $6a08dd79814f2299$var$_loadFromCookie(sdkKey) {
    if (!$6a08dd79814f2299$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $e9CWO._getDocumentSafe)() == null) return null;
    const cookies = document.cookie.split(';');
    for (const cookie of cookies){
        const [key, value] = cookie.trim().split('=');
        if (key === $6a08dd79814f2299$var$getCookieName(sdkKey)) return decodeURIComponent(value);
    }
    return null;
}
function $6a08dd79814f2299$var$_persistToCookie(stableID, sdkKey) {
    if (!$6a08dd79814f2299$var$COOKIE_ENABLED_MAP[sdkKey] || (0, $e9CWO._getDocumentSafe)() == null) return;
    const expiryDate = new Date();
    expiryDate.setFullYear(expiryDate.getFullYear() + 1);
    document.cookie = `${$6a08dd79814f2299$var$getCookieName(sdkKey)}=${encodeURIComponent(stableID)}; expires=${expiryDate.toUTCString()}; path=/`;
}
function $6a08dd79814f2299$var$getCookieName(sdkKey) {
    return `statsig.stable_id.${(0, $dOVey._getStorageKey)(sdkKey)}`;
}
module.exports.getCookieName = $6a08dd79814f2299$var$getCookieName;

});
parcelRegister("axqyl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUUID = void 0;
function $7ac1954b89aebd3f$var$getUUID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    let d = new Date().getTime();
    let d2 = typeof performance !== 'undefined' && performance.now && performance.now() * 1000 || 0;
    const y = '89ab'[Math.floor(Math.random() * 4)];
    return `xxxxxxxx-xxxx-4xxx-${y}xxx-xxxxxxxxxxxx`.replace(/[xy]/g, (c)=>{
        let r = Math.random() * 16;
        if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
        } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
        }
        return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
    });
}
module.exports.getUUID = $7ac1954b89aebd3f$var$getUUID;

});


parcelRegister("9PGpW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._getFullUserHash = module.exports._normalizeUser = void 0;

var $gD7am = parcelRequire("gD7am");

var $8zS3F = parcelRequire("8zS3F");
function $7289c7ab4a8bfbad$var$_normalizeUser(original, options, fallbackEnvironment) {
    try {
        const copy = JSON.parse(JSON.stringify(original));
        if (options != null && options.environment != null) copy.statsigEnvironment = options.environment;
        else if (fallbackEnvironment != null) copy.statsigEnvironment = {
            tier: fallbackEnvironment
        };
        return copy;
    } catch (error) {
        $8zS3F.Log.error('Failed to JSON.stringify user');
        return {
            statsigEnvironment: undefined
        };
    }
}
module.exports._normalizeUser = $7289c7ab4a8bfbad$var$_normalizeUser;
function $7289c7ab4a8bfbad$var$_getFullUserHash(user) {
    return user ? (0, $gD7am._DJB2Object)(user) : null;
}
module.exports._getFullUserHash = $7289c7ab4a8bfbad$var$_getFullUserHash;

});

parcelRegister("9jpT3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._typedJsonParse = void 0;

var $8zS3F = parcelRequire("8zS3F");
/**
 *
 * @param {string} data The values to parse into T
 * @param {string} guard A field that must exists on the parsed object for the parse to be valid
 * @param {string} error An error to print via Log.error() when parsing fails
 * @returns {T | null} The parse object T or null if it failed
 */ function $6c79f80ab233352e$var$_typedJsonParse(data, guard, typeName) {
    try {
        const result = JSON.parse(data);
        if (result && typeof result === 'object' && guard in result) return result;
    } catch (_a) {
    // noop
    }
    $8zS3F.Log.error(`Failed to parse ${typeName}`);
    return null;
}
module.exports._typedJsonParse = $6c79f80ab233352e$var$_typedJsonParse;

});


parcelRegister("al1Ro", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("bLgjg", function(module, exports) {
"use strict";
var $8900bc3e26cef67f$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorBoundary = module.exports.EXCEPTION_ENDPOINT = void 0;

var $8zS3F = parcelRequire("8zS3F");

var $6LIjG = parcelRequire("6LIjG");

var $7K2uC = parcelRequire("7K2uC");
module.exports.EXCEPTION_ENDPOINT = 'https://statsigapi.net/v1/sdk_exception';
const $8900bc3e26cef67f$var$UNKNOWN_ERROR = '[Statsig] UnknownError';
class $8900bc3e26cef67f$var$ErrorBoundary {
    constructor(_sdkKey, _options, _emitter, _lastSeenError){
        this._sdkKey = _sdkKey;
        this._options = _options;
        this._emitter = _emitter;
        this._lastSeenError = _lastSeenError;
        this._seen = new Set();
    }
    wrap(instance, namePrefix) {
        try {
            const obj = instance;
            $8900bc3e26cef67f$var$_getAllInstanceMethodNames(obj).forEach((name)=>{
                const original = obj[name];
                if ('$EB' in original) return;
                obj[name] = (...args)=>{
                    return this._capture(namePrefix ? `${namePrefix}:${name}` : name, ()=>original.apply(instance, args));
                };
                obj[name].$EB = true;
            });
        } catch (err) {
            this._onError('eb:wrap', err);
        }
    }
    logError(tag, error) {
        this._onError(tag, error);
    }
    getLastSeenErrorAndReset() {
        const tempError = this._lastSeenError;
        this._lastSeenError = undefined;
        return tempError !== null && tempError !== void 0 ? tempError : null;
    }
    attachErrorIfNoneExists(error) {
        if (this._lastSeenError) return;
        this._lastSeenError = $8900bc3e26cef67f$var$_resolveError(error);
    }
    _capture(tag, task) {
        try {
            const res = task();
            if (res && res instanceof Promise) return res.catch((err)=>this._onError(tag, err));
            return res;
        } catch (error) {
            this._onError(tag, error);
            return null;
        }
    }
    _onError(tag, error) {
        try {
            $8zS3F.Log.warn(`Caught error in ${tag}`, {
                error: error
            });
            const impl = ()=>$8900bc3e26cef67f$var$__awaiter(this, void 0, void 0, function*() {
                    var _a, _b, _c, _d, _e, _f, _g;
                    const unwrapped = error ? error : Error($8900bc3e26cef67f$var$UNKNOWN_ERROR);
                    const isError = unwrapped instanceof Error;
                    const name = isError ? unwrapped.name : 'No Name';
                    const resolvedError = $8900bc3e26cef67f$var$_resolveError(unwrapped);
                    this._lastSeenError = resolvedError;
                    if (this._seen.has(name)) return;
                    this._seen.add(name);
                    if ((_b = (_a = this._options) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.preventAllNetworkTraffic) {
                        (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                            name: 'error',
                            error: error,
                            tag: tag
                        });
                        return;
                    }
                    const sdkType = $6LIjG.SDKType._get(this._sdkKey);
                    const statsigMetadata = $7K2uC.StatsigMetadataProvider.get();
                    const info = isError ? unwrapped.stack : $8900bc3e26cef67f$var$_getDescription(unwrapped);
                    const body = Object.assign({
                        tag: tag,
                        exception: name,
                        info: info,
                        statsigOptions: $8900bc3e26cef67f$var$_getStatsigOptionLoggingCopy(this._options)
                    }, Object.assign(Object.assign({}, statsigMetadata), {
                        sdkType: sdkType
                    }));
                    const func = (_f = (_e = (_d = this._options) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.networkOverrideFunc) !== null && _f !== void 0 ? _f : fetch;
                    yield func(module.exports.EXCEPTION_ENDPOINT, {
                        method: 'POST',
                        headers: {
                            'STATSIG-API-KEY': this._sdkKey,
                            'STATSIG-SDK-TYPE': String(sdkType),
                            'STATSIG-SDK-VERSION': String(statsigMetadata.sdkVersion),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(body)
                    });
                    (_g = this._emitter) === null || _g === void 0 || _g.call(this, {
                        name: 'error',
                        error: error,
                        tag: tag
                    });
                });
            impl().then(()=>{
            /* noop */ }).catch(()=>{
            /* noop */ });
        } catch (_error) {
        /* noop */ }
    }
}
module.exports.ErrorBoundary = $8900bc3e26cef67f$var$ErrorBoundary;
function $8900bc3e26cef67f$var$_resolveError(error) {
    if (error instanceof Error) return error;
    else if (typeof error === 'string') return new Error(error);
    else return new Error('An unknown error occurred.');
}
function $8900bc3e26cef67f$var$_getDescription(obj) {
    try {
        return JSON.stringify(obj);
    } catch (_a) {
        return $8900bc3e26cef67f$var$UNKNOWN_ERROR;
    }
}
function $8900bc3e26cef67f$var$_getAllInstanceMethodNames(instance) {
    const names = new Set();
    let proto = Object.getPrototypeOf(instance);
    while(proto && proto !== Object.prototype){
        Object.getOwnPropertyNames(proto).filter((prop)=>typeof (proto === null || proto === void 0 ? void 0 : proto[prop]) === 'function').forEach((name)=>names.add(name));
        proto = Object.getPrototypeOf(proto);
    }
    return Array.from(names);
}
function $8900bc3e26cef67f$var$_getStatsigOptionLoggingCopy(options) {
    if (!options) return {};
    const loggingCopy = {};
    Object.keys(options).forEach((key)=>{
        const option = key;
        const value = options[option];
        const valueType = typeof value;
        switch(valueType){
            case 'number':
            case 'bigint':
            case 'boolean':
                loggingCopy[String(option)] = value;
                break;
            case 'string':
                if (value.length < 50) loggingCopy[String(option)] = value;
                else loggingCopy[String(option)] = 'set';
                break;
            case 'object':
                if (option === 'environment') loggingCopy['environment'] = value;
                else if (option === 'networkConfig') loggingCopy['networkConfig'] = value;
                else loggingCopy[String(option)] = value != null ? 'set' : 'unset';
                break;
            default:
        }
    });
    return loggingCopy;
}

});
parcelRegister("6LIjG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKType = void 0;
const $4ed982337a85d81d$var$SDK_CLIENT = {};
let $4ed982337a85d81d$var$suffix;
module.exports.SDKType = {
    _get: (sdkKey)=>{
        var _a;
        return ((_a = $4ed982337a85d81d$var$SDK_CLIENT[sdkKey]) !== null && _a !== void 0 ? _a : 'js-mono') + ($4ed982337a85d81d$var$suffix !== null && $4ed982337a85d81d$var$suffix !== void 0 ? $4ed982337a85d81d$var$suffix : '');
    },
    _setClientType (sdkKey, client) {
        $4ed982337a85d81d$var$SDK_CLIENT[sdkKey] = client;
    },
    _setBindingType (binding) {
        if (!$4ed982337a85d81d$var$suffix || $4ed982337a85d81d$var$suffix === '-react') $4ed982337a85d81d$var$suffix = '-' + binding;
    }
};

});


parcelRegister("jLdeg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("aPNtF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("RDWWP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("6ktTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createMemoKey = module.exports.MemoPrefix = void 0;
module.exports.MemoPrefix = {
    _gate: 'g',
    _dynamicConfig: 'c',
    _experiment: 'e',
    _configList: 'cl',
    _layer: 'l',
    _paramStore: 'p'
};
const $49bbce2ebd1adb69$var$EXIST_KEYS = new Set([]);
const $49bbce2ebd1adb69$var$DO_NOT_MEMO_KEYS = new Set([
    // Add keys that if exist, should not be memoized
    'userPersistedValues'
]);
function $49bbce2ebd1adb69$var$createMemoKey(prefix, name, options) {
    let cacheKey = `${prefix}|${name}`;
    if (!options) return cacheKey;
    for (const key of Object.keys(options)){
        if ($49bbce2ebd1adb69$var$DO_NOT_MEMO_KEYS.has(key)) return undefined;
        if ($49bbce2ebd1adb69$var$EXIST_KEYS.has(key)) cacheKey += `|${key}=true`;
        else cacheKey += `|${key}=${options[key]}`;
    }
    return cacheKey;
}
module.exports.createMemoKey = $49bbce2ebd1adb69$var$createMemoKey;

});

parcelRegister("dGL4U", function(module, exports) {
"use strict";
var $029261ecd75d3aba$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NetworkCore = void 0;

var $dizc4 = parcelRequire("dizc4");

var $dizc4 = parcelRequire("dizc4");

var $eQLXH = parcelRequire("eQLXH");

var $8zS3F = parcelRequire("8zS3F");

var $aZSmg = parcelRequire("aZSmg");

var $db6sZ = parcelRequire("db6sZ");

var $2hBO7 = parcelRequire("2hBO7");

var $6LIjG = parcelRequire("6LIjG");

var $e9CWO = parcelRequire("e9CWO");

var $9Zsep = parcelRequire("9Zsep");

var $96q1S = parcelRequire("96q1S");

var $f7Pc3 = parcelRequire("f7Pc3");

var $7K2uC = parcelRequire("7K2uC");

var $9HcT0 = parcelRequire("9HcT0");

var $4afAt = parcelRequire("4afAt");
const $029261ecd75d3aba$var$DEFAULT_TIMEOUT_MS = 10000;
const $029261ecd75d3aba$var$BACKOFF_BASE_MS = 500;
const $029261ecd75d3aba$var$BACKOFF_MAX_MS = 30000;
const $029261ecd75d3aba$var$RATE_LIMIT_WINDOW_MS = 1000;
const $029261ecd75d3aba$var$RATE_LIMIT_MAX_REQ_COUNT = 50;
const $029261ecd75d3aba$var$LEAK_RATE = $029261ecd75d3aba$var$RATE_LIMIT_MAX_REQ_COUNT / $029261ecd75d3aba$var$RATE_LIMIT_WINDOW_MS;
const $029261ecd75d3aba$var$RETRYABLE_CODES = new Set([
    408,
    500,
    502,
    503,
    504,
    522,
    524,
    599
]);
class $029261ecd75d3aba$var$NetworkCore {
    constructor(options, _emitter){
        this._emitter = _emitter;
        this._errorBoundary = null;
        this._timeout = $029261ecd75d3aba$var$DEFAULT_TIMEOUT_MS;
        this._netConfig = {};
        this._options = {};
        this._leakyBucket = {};
        this._lastUsedInitUrl = null;
        if (options) this._options = options;
        if (this._options.networkConfig) this._netConfig = this._options.networkConfig;
        if (this._netConfig.networkTimeoutMs) this._timeout = this._netConfig.networkTimeoutMs;
        this._fallbackResolver = new $db6sZ.NetworkFallbackResolver(this._options);
        this.setLogEventCompressionMode(this._getLogEventCompressionMode(options));
    }
    setLogEventCompressionMode(mode) {
        this._options.logEventCompressionMode = mode;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(this._fallbackResolver);
        this._fallbackResolver.setErrorBoundary(errorBoundary);
    }
    isBeaconSupported() {
        return typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function';
    }
    getLastUsedInitUrlAndReset() {
        const tempUrl = this._lastUsedInitUrl;
        this._lastUsedInitUrl = null;
        return tempUrl;
    }
    beacon(args) {
        if (!$029261ecd75d3aba$var$_ensureValidSdkKey(args)) return false;
        const argsInternal = this._getInternalRequestArgs('POST', args);
        const url = this._getPopulatedURL(argsInternal);
        const nav = navigator;
        return nav.sendBeacon.bind(nav)(url, argsInternal.body);
    }
    post(args) {
        return $029261ecd75d3aba$var$__awaiter(this, void 0, void 0, function*() {
            const argsInternal = this._getInternalRequestArgs('POST', args);
            this._tryEncodeBody(argsInternal);
            yield this._tryToCompressBody(argsInternal);
            return this._sendRequest(argsInternal);
        });
    }
    get(args) {
        const argsInternal = this._getInternalRequestArgs('GET', args);
        return this._sendRequest(argsInternal);
    }
    _sendRequest(args) {
        return $029261ecd75d3aba$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d;
            if (!$029261ecd75d3aba$var$_ensureValidSdkKey(args)) return null;
            if (this._netConfig.preventAllNetworkTraffic) return null;
            const { method: method, body: body, retries: retries, attempt: attempt } = args;
            const endpoint = args.urlConfig.endpoint;
            if (this._isRateLimited(endpoint)) {
                $8zS3F.Log.warn(`Request to ${endpoint} was blocked because you are making requests too frequently.`);
                return null;
            }
            const currentAttempt = attempt !== null && attempt !== void 0 ? attempt : 1;
            let reqTimedOut = false;
            const populatedUrl = this._getPopulatedURL(args);
            let response = null;
            const keepalive = (0, $4afAt._isUnloading)();
            try {
                const config = {
                    method: method,
                    body: body,
                    headers: Object.assign({}, args.headers),
                    priority: args.priority,
                    keepalive: keepalive
                };
                $029261ecd75d3aba$var$_tryMarkInitStart(args, currentAttempt);
                const bucket = this._leakyBucket[endpoint];
                if (bucket) {
                    bucket.lastRequestTime = Date.now();
                    this._leakyBucket[endpoint] = bucket;
                }
                const func = (_a = this._netConfig.networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch;
                let timeoutId;
                response = yield Promise.race([
                    func(populatedUrl, config).finally(()=>clearTimeout(timeoutId)),
                    new Promise((_, reject)=>{
                        timeoutId = setTimeout(()=>{
                            reqTimedOut = true;
                            reject(new Error(`Timeout of ${this._timeout}ms expired.`));
                        }, this._timeout);
                    })
                ]);
                if (!response.ok) {
                    const text = yield response.text().catch(()=>'No Text');
                    const err = new Error(`NetworkError: ${populatedUrl} ${text}`);
                    err.name = 'NetworkError';
                    throw err;
                }
                const text = yield response.text();
                $029261ecd75d3aba$var$_tryMarkInitEnd(args, response, currentAttempt, text);
                this._fallbackResolver.tryBumpExpiryTime(args.sdkKey, args.urlConfig);
                return {
                    body: text,
                    code: response.status
                };
            } catch (error) {
                const errorMessage = $029261ecd75d3aba$var$_getErrorMessage(error);
                const timedOut = $029261ecd75d3aba$var$_didTimeout(errorMessage !== null && errorMessage !== void 0 ? errorMessage : '', reqTimedOut);
                $029261ecd75d3aba$var$_tryMarkInitEnd(args, response, currentAttempt, '', error);
                const fallbackUpdated = yield this._fallbackResolver.tryFetchUpdatedFallbackInfo(args.sdkKey, args.urlConfig, errorMessage, timedOut);
                if (fallbackUpdated) args.fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
                if (!retries || currentAttempt > retries || !$029261ecd75d3aba$var$RETRYABLE_CODES.has((_b = response === null || response === void 0 ? void 0 : response.status) !== null && _b !== void 0 ? _b : 500)) {
                    (_c = this._emitter) === null || _c === void 0 || _c.call(this, {
                        name: 'error',
                        error: error,
                        tag: $f7Pc3.ErrorTag.NetworkError,
                        requestArgs: args
                    });
                    const formattedErrorMsg = `A networking error occurred during ${method} request to ${populatedUrl}.`;
                    $8zS3F.Log.error(formattedErrorMsg, errorMessage, error);
                    (_d = this._errorBoundary) === null || _d === void 0 || _d.attachErrorIfNoneExists(formattedErrorMsg);
                    return null;
                }
                yield $029261ecd75d3aba$var$_exponentialBackoff(currentAttempt);
                return this._sendRequest(Object.assign(Object.assign({}, args), {
                    retries: retries,
                    attempt: currentAttempt + 1
                }));
            }
        });
    }
    _getLogEventCompressionMode(options) {
        // Handle backward compatibility for deprecated disableCompression flag
        let compressionMode = options === null || options === void 0 ? void 0 : options.logEventCompressionMode;
        if (!compressionMode && (options === null || options === void 0 ? void 0 : options.disableCompression) === true) compressionMode = $9HcT0.LogEventCompressionMode.Disabled;
        // Default to enabled if unset
        if (!compressionMode) compressionMode = $9HcT0.LogEventCompressionMode.Enabled;
        return compressionMode;
    }
    _isRateLimited(endpoint) {
        var _a;
        const now = Date.now();
        const bucket = (_a = this._leakyBucket[endpoint]) !== null && _a !== void 0 ? _a : {
            count: 0,
            lastRequestTime: now
        };
        const elapsed = now - bucket.lastRequestTime;
        const leakedRequests = Math.floor(elapsed * $029261ecd75d3aba$var$LEAK_RATE);
        bucket.count = Math.max(0, bucket.count - leakedRequests);
        if (bucket.count >= $029261ecd75d3aba$var$RATE_LIMIT_MAX_REQ_COUNT) return true;
        bucket.count += 1;
        bucket.lastRequestTime = now;
        this._leakyBucket[endpoint] = bucket;
        return false;
    }
    _getPopulatedURL(args) {
        var _a;
        const url = (_a = args.fallbackUrl) !== null && _a !== void 0 ? _a : args.urlConfig.getUrl();
        if (args.urlConfig.endpoint === $aZSmg.Endpoint._initialize || args.urlConfig.endpoint === $aZSmg.Endpoint._download_config_specs) this._lastUsedInitUrl = url;
        const params = Object.assign({
            [$aZSmg.NetworkParam.SdkKey]: args.sdkKey,
            [$aZSmg.NetworkParam.SdkType]: $6LIjG.SDKType._get(args.sdkKey),
            [$aZSmg.NetworkParam.SdkVersion]: $7K2uC.SDK_VERSION,
            [$aZSmg.NetworkParam.Time]: String(Date.now()),
            [$aZSmg.NetworkParam.SessionID]: $9Zsep.SessionID.get(args.sdkKey)
        }, args.params);
        const query = Object.keys(params).map((key)=>{
            return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
        }).join('&');
        return `${url}${query ? `?${query}` : ''}`;
    }
    _tryEncodeBody(args) {
        var _a;
        const win = (0, $e9CWO._getWindowSafe)();
        const body = args.body;
        if (!args.isStatsigEncodable || this._options.disableStatsigEncoding || typeof body !== 'string' || (0, $dizc4._getStatsigGlobalFlag)('no-encode') != null || !(win === null || win === void 0 ? void 0 : win.btoa)) return;
        try {
            args.body = win.btoa(body).split('').reverse().join('');
            args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                [$aZSmg.NetworkParam.StatsigEncoded]: '1'
            });
        } catch (e) {
            $8zS3F.Log.warn(`Request encoding failed for ${args.urlConfig.getUrl()}`, e);
        }
    }
    _tryToCompressBody(args) {
        return $029261ecd75d3aba$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const body = args.body;
            if (typeof body !== 'string' || !$029261ecd75d3aba$var$_allowCompression(args, this._options)) return;
            try {
                const bytes = new TextEncoder().encode(body);
                const stream = new CompressionStream('gzip');
                const writer = stream.writable.getWriter();
                writer.write(bytes).catch($8zS3F.Log.error);
                writer.close().catch($8zS3F.Log.error);
                const reader = stream.readable.getReader();
                const chunks = [];
                let result;
                // eslint-disable-next-line no-await-in-loop
                while(!(result = yield reader.read()).done)chunks.push(result.value);
                const totalLength = chunks.reduce((acc, chunk)=>acc + chunk.length, 0);
                const combined = new Uint8Array(totalLength);
                let offset = 0;
                for (const chunk of chunks){
                    combined.set(chunk, offset);
                    offset += chunk.length;
                }
                args.body = combined;
                args.params = Object.assign(Object.assign({}, (_a = args.params) !== null && _a !== void 0 ? _a : {}), {
                    [$aZSmg.NetworkParam.IsGzipped]: '1'
                });
            } catch (e) {
                $8zS3F.Log.warn(`Request compression failed for ${args.urlConfig.getUrl()}`, e);
            }
        });
    }
    _getInternalRequestArgs(method, args) {
        const fallbackUrl = this._fallbackResolver.getActiveFallbackUrl(args.sdkKey, args.urlConfig);
        const result = Object.assign(Object.assign({}, args), {
            method: method,
            fallbackUrl: fallbackUrl
        });
        if ('data' in args) $029261ecd75d3aba$var$_populateRequestBody(result, args.data);
        return result;
    }
}
module.exports.NetworkCore = $029261ecd75d3aba$var$NetworkCore;
const $029261ecd75d3aba$var$_ensureValidSdkKey = (args)=>{
    if (!args.sdkKey) {
        $8zS3F.Log.warn('Unable to make request without an SDK key');
        return false;
    }
    return true;
};
const $029261ecd75d3aba$var$_populateRequestBody = (args, data)=>{
    const { sdkKey: sdkKey, fallbackUrl: fallbackUrl } = args;
    const stableID = $96q1S.StableID.get(sdkKey);
    const sessionID = $9Zsep.SessionID.get(sdkKey);
    const sdkType = $6LIjG.SDKType._get(sdkKey);
    args.body = JSON.stringify(Object.assign(Object.assign({}, data), {
        statsigMetadata: Object.assign(Object.assign({}, $7K2uC.StatsigMetadataProvider.get()), {
            stableID: stableID,
            sessionID: sessionID,
            sdkType: sdkType,
            fallbackUrl: fallbackUrl
        })
    }));
};
function $029261ecd75d3aba$var$_allowCompression(args, options) {
    if (!args.isCompressable) return false;
    // Never compress if 'no-compress' is set globally or required APIs are unavailable
    if ((0, $dizc4._getStatsigGlobalFlag)('no-compress') != null || typeof CompressionStream === 'undefined' || typeof TextEncoder === 'undefined') return false;
    const isProxy = args.urlConfig.customUrl != null || args.urlConfig.fallbackUrls != null;
    const flagEnabled = $2hBO7.SDKFlags.get(args.sdkKey, 'enable_log_event_compression') === true;
    switch(options.logEventCompressionMode){
        case $9HcT0.LogEventCompressionMode.Disabled:
            return false;
        case $9HcT0.LogEventCompressionMode.Enabled:
            // Only compress through proxy if flag is explicitly on
            if (isProxy && !flagEnabled) return false;
            return true;
        case $9HcT0.LogEventCompressionMode.Forced:
            return true;
        default:
            return false;
    }
}
function $029261ecd75d3aba$var$_getErrorMessage(error) {
    if (typeof error === 'string') return error;
    if (error instanceof Error) return `${error.name}: ${error.message}`;
    return 'Unknown Error';
}
function $029261ecd75d3aba$var$_didTimeout(errorMsg, abortedByTimeout) {
    const timeout = errorMsg.includes('Timeout'); // probably not needed but just in case
    return timeout || abortedByTimeout;
}
function $029261ecd75d3aba$var$_tryMarkInitStart(args, attempt) {
    if (args.urlConfig.endpoint !== $aZSmg.Endpoint._initialize) return;
    $eQLXH.Diagnostics._markInitNetworkReqStart(args.sdkKey, {
        attempt: attempt
    });
}
function $029261ecd75d3aba$var$_tryMarkInitEnd(args, response, attempt, body, err) {
    if (args.urlConfig.endpoint !== $aZSmg.Endpoint._initialize) return;
    $eQLXH.Diagnostics._markInitNetworkReqEnd(args.sdkKey, $eQLXH.Diagnostics._getDiagnosticsData(response, attempt, body, err));
}
function $029261ecd75d3aba$var$_exponentialBackoff(attempt) {
    return $029261ecd75d3aba$var$__awaiter(this, void 0, void 0, function*() {
        // 1*1*1000 1s
        // 2*2*1000 4s
        // 3*3*1000 9s
        // 4*4*1000 16s
        // 5*5*1000 25s
        yield new Promise((r)=>setTimeout(r, Math.min($029261ecd75d3aba$var$BACKOFF_BASE_MS * (attempt * attempt), $029261ecd75d3aba$var$BACKOFF_MAX_MS)));
    });
}

});
parcelRegister("db6sZ", function(module, exports) {
"use strict";
var $998151900523f2db$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._isDomainFailure = module.exports.NetworkFallbackResolver = void 0;

var $cZrah = parcelRequire("cZrah");

var $gD7am = parcelRequire("gD7am");

var $8zS3F = parcelRequire("8zS3F");

var $9Kt1W = parcelRequire("9Kt1W");
const $998151900523f2db$var$DEFAULT_TTL_MS = 604800000; // 7 days
const $998151900523f2db$var$COOLDOWN_TIME_MS = 14400000; // 4 hours
class $998151900523f2db$var$NetworkFallbackResolver {
    constructor(options){
        var _a;
        this._fallbackInfo = null;
        this._errorBoundary = null;
        this._dnsQueryCooldowns = {};
        this._networkOverrideFunc = (_a = options.networkConfig) === null || _a === void 0 ? void 0 : _a.networkOverrideFunc;
    }
    setErrorBoundary(errorBoundary) {
        this._errorBoundary = errorBoundary;
    }
    tryBumpExpiryTime(sdkKey, urlConfig) {
        var _a;
        const info = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint];
        if (!info) return;
        info.expiryTime = Date.now() + $998151900523f2db$var$DEFAULT_TTL_MS;
        $998151900523f2db$var$_tryWriteFallbackInfoToCache(sdkKey, Object.assign(Object.assign({}, this._fallbackInfo), {
            [urlConfig.endpoint]: info
        }));
    }
    getActiveFallbackUrl(sdkKey, urlConfig) {
        var _a, _b;
        if (urlConfig.customUrl != null && urlConfig.fallbackUrls != null) return null;
        let info = this._fallbackInfo;
        if (info == null) {
            info = (_a = $998151900523f2db$var$_readFallbackInfoFromCache(sdkKey)) !== null && _a !== void 0 ? _a : {};
            this._fallbackInfo = info;
        }
        const entry = info[urlConfig.endpoint];
        if (!entry || Date.now() > ((_b = entry.expiryTime) !== null && _b !== void 0 ? _b : 0) || urlConfig.getChecksum() !== entry.urlConfigChecksum) {
            delete info[urlConfig.endpoint];
            this._fallbackInfo = info;
            $998151900523f2db$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
            return null;
        }
        if (entry.url) return entry.url;
        return null;
    }
    tryFetchUpdatedFallbackInfo(sdkKey, urlConfig, errorMessage, timedOut) {
        return $998151900523f2db$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            try {
                if (!$998151900523f2db$var$_isDomainFailure(errorMessage, timedOut)) return false;
                const canUseNetworkFallbacks = urlConfig.customUrl == null && urlConfig.fallbackUrls == null;
                const urls = canUseNetworkFallbacks ? yield this._tryFetchFallbackUrlsFromNetwork(urlConfig) : urlConfig.fallbackUrls;
                const newUrl = this._pickNewFallbackUrl((_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[urlConfig.endpoint], urls);
                if (!newUrl) return false;
                this._updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl);
                return true;
            } catch (error) {
                (_b = this._errorBoundary) === null || _b === void 0 || _b.logError('tryFetchUpdatedFallbackInfo', error);
                return false;
            }
        });
    }
    _updateFallbackInfoWithNewUrl(sdkKey, urlConfig, newUrl) {
        var _a, _b, _c;
        const newFallbackInfo = {
            urlConfigChecksum: urlConfig.getChecksum(),
            url: newUrl,
            expiryTime: Date.now() + $998151900523f2db$var$DEFAULT_TTL_MS,
            previous: []
        };
        const endpoint = urlConfig.endpoint;
        const previousInfo = (_a = this._fallbackInfo) === null || _a === void 0 ? void 0 : _a[endpoint];
        if (previousInfo) newFallbackInfo.previous.push(...previousInfo.previous);
        if (newFallbackInfo.previous.length > 10) newFallbackInfo.previous = [];
        const previousUrl = (_c = (_b = this._fallbackInfo) === null || _b === void 0 ? void 0 : _b[endpoint]) === null || _c === void 0 ? void 0 : _c.url;
        if (previousUrl != null) newFallbackInfo.previous.push(previousUrl);
        this._fallbackInfo = Object.assign(Object.assign({}, this._fallbackInfo), {
            [endpoint]: newFallbackInfo
        });
        $998151900523f2db$var$_tryWriteFallbackInfoToCache(sdkKey, this._fallbackInfo);
    }
    _tryFetchFallbackUrlsFromNetwork(urlConfig) {
        return $998151900523f2db$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const cooldown = this._dnsQueryCooldowns[urlConfig.endpoint];
            if (cooldown && Date.now() < cooldown) return null;
            this._dnsQueryCooldowns[urlConfig.endpoint] = Date.now() + $998151900523f2db$var$COOLDOWN_TIME_MS;
            const result = [];
            const records = yield (0, $cZrah._fetchTxtRecords)((_a = this._networkOverrideFunc) !== null && _a !== void 0 ? _a : fetch);
            const path = $998151900523f2db$var$_extractPathFromUrl(urlConfig.defaultUrl);
            for (const record of records){
                if (!record.startsWith(urlConfig.endpointDnsKey + '=')) continue;
                const parts = record.split('=');
                if (parts.length > 1) {
                    let baseUrl = parts[1];
                    if (baseUrl.endsWith('/')) baseUrl = baseUrl.slice(0, -1);
                    result.push(`https://${baseUrl}${path}`);
                }
            }
            return result;
        });
    }
    _pickNewFallbackUrl(currentFallbackInfo, urls) {
        var _a;
        if (urls == null) return null;
        const previouslyUsed = new Set((_a = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.previous) !== null && _a !== void 0 ? _a : []);
        const currentFallbackUrl = currentFallbackInfo === null || currentFallbackInfo === void 0 ? void 0 : currentFallbackInfo.url;
        let found = null;
        for (const loopUrl of urls){
            const url = loopUrl.endsWith('/') ? loopUrl.slice(0, -1) : loopUrl;
            if (!previouslyUsed.has(loopUrl) && url !== currentFallbackUrl) {
                found = url;
                break;
            }
        }
        return found;
    }
}
module.exports.NetworkFallbackResolver = $998151900523f2db$var$NetworkFallbackResolver;
function $998151900523f2db$var$_isDomainFailure(errorMsg, timedOut) {
    var _a;
    const lowerErrorMsg = (_a = errorMsg === null || errorMsg === void 0 ? void 0 : errorMsg.toLowerCase()) !== null && _a !== void 0 ? _a : '';
    return timedOut || lowerErrorMsg.includes('uncaught exception') || lowerErrorMsg.includes('failed to fetch') || lowerErrorMsg.includes('networkerror when attempting to fetch resource');
}
module.exports._isDomainFailure = $998151900523f2db$var$_isDomainFailure;
function $998151900523f2db$var$_getFallbackInfoStorageKey(sdkKey) {
    return `statsig.network_fallback.${(0, $gD7am._DJB2)(sdkKey)}`;
}
function $998151900523f2db$var$_tryWriteFallbackInfoToCache(sdkKey, info) {
    const hashKey = $998151900523f2db$var$_getFallbackInfoStorageKey(sdkKey);
    if (!info || Object.keys(info).length === 0) {
        $9Kt1W.Storage.removeItem(hashKey);
        return;
    }
    $9Kt1W.Storage.setItem(hashKey, JSON.stringify(info));
}
function $998151900523f2db$var$_readFallbackInfoFromCache(sdkKey) {
    const hashKey = $998151900523f2db$var$_getFallbackInfoStorageKey(sdkKey);
    const data = $9Kt1W.Storage.getItem(hashKey);
    if (!data) return null;
    try {
        return JSON.parse(data);
    } catch (_a) {
        $8zS3F.Log.error('Failed to parse FallbackInfo');
        return null;
    }
}
function $998151900523f2db$var$_extractPathFromUrl(urlString) {
    try {
        const url = new URL(urlString);
        return url.pathname;
    } catch (error) {
        return null;
    }
}

});
parcelRegister("cZrah", function(module, exports) {
"use strict";
var $975040ea968cc8b6$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fetchTxtRecords = void 0;
// See example: https://github.com/statsig-io/private-js-client-monorepo/pull/340
const $975040ea968cc8b6$var$FEATURE_ASSETS_DNS_QUERY = new Uint8Array([
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x01,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x00,
    0x0d,
    0x66,
    0x65,
    0x61,
    0x74,
    0x75,
    0x72,
    0x65,
    0x61,
    0x73,
    0x73,
    0x65,
    0x74,
    0x73,
    0x03,
    0x6f,
    0x72,
    0x67,
    0x00,
    0x00,
    0x10,
    0x00,
    0x01
]);
const $975040ea968cc8b6$var$DNS_QUERY_ENDPOINT = 'https://cloudflare-dns.com/dns-query';
const $975040ea968cc8b6$var$DOMAIN_CHARS = [
    'i',
    'e',
    'd'
];
const $975040ea968cc8b6$var$MAX_START_LOOKUP = 200;
function $975040ea968cc8b6$var$_fetchTxtRecords(networkFunc) {
    return $975040ea968cc8b6$var$__awaiter(this, void 0, void 0, function*() {
        const response = yield networkFunc($975040ea968cc8b6$var$DNS_QUERY_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/dns-message',
                Accept: 'application/dns-message'
            },
            body: $975040ea968cc8b6$var$FEATURE_ASSETS_DNS_QUERY
        });
        if (!response.ok) {
            const err = new Error('Failed to fetch TXT records from DNS');
            err.name = 'DnsTxtFetchError';
            throw err;
        }
        const data = yield response.arrayBuffer();
        const bytes = new Uint8Array(data);
        return $975040ea968cc8b6$var$_parseDnsResponse(bytes);
    });
}
module.exports._fetchTxtRecords = $975040ea968cc8b6$var$_fetchTxtRecords;
function $975040ea968cc8b6$var$_parseDnsResponse(input) {
    // loop until we find the first valid domain char. One of [i=, e=, d=]
    const start = input.findIndex((byte, index)=>index < $975040ea968cc8b6$var$MAX_START_LOOKUP && String.fromCharCode(byte) === '=' && $975040ea968cc8b6$var$DOMAIN_CHARS.includes(String.fromCharCode(input[index - 1])));
    if (start === -1) {
        const err = new Error('Failed to parse TXT records from DNS');
        err.name = 'DnsTxtParseError';
        throw err;
    }
    // decode the remaining bytes as a string
    let result = '';
    for(let i = start - 1; i < input.length; i++)result += String.fromCharCode(input[i]);
    return result.split(',');
}

});


parcelRegister("2hBO7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.SDKFlags = void 0;
const $1a9a7f11e8c0c952$var$FLAGMAP = {};
module.exports.SDKFlags = {
    setFlags: (sdkKey, flags)=>{
        $1a9a7f11e8c0c952$var$FLAGMAP[sdkKey] = flags;
    },
    get: (sdkKey, flagKey)=>{
        var _a, _b;
        return (_b = (_a = $1a9a7f11e8c0c952$var$FLAGMAP[sdkKey]) === null || _a === void 0 ? void 0 : _a[flagKey]) !== null && _b !== void 0 ? _b : false;
    }
};

});

parcelRegister("9Zsep", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigSession = module.exports.SessionID = void 0;

var $dizc4 = parcelRequire("dizc4");

var $dOVey = parcelRequire("dOVey");

var $8zS3F = parcelRequire("8zS3F");

var $9Kt1W = parcelRequire("9Kt1W");

var $axqyl = parcelRequire("axqyl");
const $745fb5bf7feea8e8$var$MAX_SESSION_IDLE_TIME = 1800000; // 30 minutes
const $745fb5bf7feea8e8$var$MAX_SESSION_AGE = 14400000; // 4 hours
const $745fb5bf7feea8e8$var$PROMISE_MAP = {};
module.exports.SessionID = {
    get: (sdkKey)=>{
        return module.exports.StatsigSession.get(sdkKey).data.sessionID;
    }
};
module.exports.StatsigSession = {
    get: (sdkKey)=>{
        if ($745fb5bf7feea8e8$var$PROMISE_MAP[sdkKey] == null) $745fb5bf7feea8e8$var$PROMISE_MAP[sdkKey] = $745fb5bf7feea8e8$var$_loadSession(sdkKey);
        const session = $745fb5bf7feea8e8$var$PROMISE_MAP[sdkKey];
        return $745fb5bf7feea8e8$var$_bumpSession(session);
    },
    overrideInitialSessionID: (override, sdkKey)=>{
        $745fb5bf7feea8e8$var$PROMISE_MAP[sdkKey] = $745fb5bf7feea8e8$var$_overrideSessionId(override, sdkKey);
    }
};
function $745fb5bf7feea8e8$var$_loadSession(sdkKey) {
    let data = $745fb5bf7feea8e8$var$_loadFromStorage(sdkKey);
    const now = Date.now();
    if (!data) data = {
        sessionID: (0, $axqyl.getUUID)(),
        startTime: now,
        lastUpdate: now
    };
    return {
        data: data,
        sdkKey: sdkKey
    };
}
function $745fb5bf7feea8e8$var$_overrideSessionId(override, sdkKey) {
    const now = Date.now();
    return {
        data: {
            sessionID: override,
            startTime: now,
            lastUpdate: now
        },
        sdkKey: sdkKey
    };
}
function $745fb5bf7feea8e8$var$_bumpSession(session) {
    const now = Date.now();
    const data = session.data;
    const sdkKey = session.sdkKey;
    if ($745fb5bf7feea8e8$var$_isIdle(data) || $745fb5bf7feea8e8$var$_hasRunTooLong(data)) {
        data.sessionID = (0, $axqyl.getUUID)();
        data.startTime = now;
        const client = __STATSIG__ === null || __STATSIG__ === void 0 ? void 0 : __STATSIG__.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }
    data.lastUpdate = now;
    $745fb5bf7feea8e8$var$_persistToStorage(data, session.sdkKey);
    clearTimeout(session.idleTimeoutID);
    clearTimeout(session.ageTimeoutID);
    const lifetime = now - data.startTime;
    session.idleTimeoutID = $745fb5bf7feea8e8$var$_createSessionTimeout(sdkKey, $745fb5bf7feea8e8$var$MAX_SESSION_IDLE_TIME);
    session.ageTimeoutID = $745fb5bf7feea8e8$var$_createSessionTimeout(sdkKey, $745fb5bf7feea8e8$var$MAX_SESSION_AGE - lifetime);
    return session;
}
function $745fb5bf7feea8e8$var$_createSessionTimeout(sdkKey, duration) {
    return setTimeout(()=>{
        var _a;
        const client = (_a = (0, $dizc4._getStatsigGlobal)()) === null || _a === void 0 ? void 0 : _a.instance(sdkKey);
        if (client) client.$emt({
            name: 'session_expired'
        });
    }, duration);
}
function $745fb5bf7feea8e8$var$_isIdle({ lastUpdate: lastUpdate }) {
    return Date.now() - lastUpdate > $745fb5bf7feea8e8$var$MAX_SESSION_IDLE_TIME;
}
function $745fb5bf7feea8e8$var$_hasRunTooLong({ startTime: startTime }) {
    return Date.now() - startTime > $745fb5bf7feea8e8$var$MAX_SESSION_AGE;
}
function $745fb5bf7feea8e8$var$_getSessionIDStorageKey(sdkKey) {
    return `statsig.session_id.${(0, $dOVey._getStorageKey)(sdkKey)}`;
}
function $745fb5bf7feea8e8$var$_persistToStorage(session, sdkKey) {
    const storageKey = $745fb5bf7feea8e8$var$_getSessionIDStorageKey(sdkKey);
    try {
        (0, $9Kt1W._setObjectInStorage)(storageKey, session);
    } catch (e) {
        $8zS3F.Log.warn('Failed to save SessionID');
    }
}
function $745fb5bf7feea8e8$var$_loadFromStorage(sdkKey) {
    const storageKey = $745fb5bf7feea8e8$var$_getSessionIDStorageKey(sdkKey);
    return (0, $9Kt1W._getObjectFromStorage)(storageKey);
}

});

parcelRegister("f7Pc3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ErrorTag = void 0;
module.exports.ErrorTag = {
    NetworkError: 'NetworkError'
};

});


parcelRegister("m5DF9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("iYRdY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("5f4KD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._fastApproxSizeOf = void 0;
const $3d1209f11b1394fa$var$CURLY_AND_SQUARE_BRACKET_SIZE = 2; // [] for array, {} for object
const $3d1209f11b1394fa$var$APPROX_ADDITIONAL_SIZE = 1; // additional size for comma and stuff
const $3d1209f11b1394fa$var$_fastApproxSizeOf = (obj, max)=>{
    let size = 0;
    const keys = Object.keys(obj);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const value = obj[key];
        size += key.length;
        if (typeof value === 'object' && value !== null) size += (0, module.exports._fastApproxSizeOf)(value, max) + $3d1209f11b1394fa$var$CURLY_AND_SQUARE_BRACKET_SIZE;
        else size += String(value).length + $3d1209f11b1394fa$var$APPROX_ADDITIONAL_SIZE;
        if (size >= max) // exit early if we've exceeded the max
        return size;
    }
    return size;
};
module.exports._fastApproxSizeOf = $3d1209f11b1394fa$var$_fastApproxSizeOf;

});

parcelRegister("96wjI", function(module, exports) {
"use strict";
var $6a0dbe14ecca036e$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigClientBase = void 0;

var $dizc4 = parcelRequire("dizc4");

var $dizc4 = parcelRequire("dizc4");

var $bLgjg = parcelRequire("bLgjg");

var $9yrlC = parcelRequire("9yrlC");

var $8zS3F = parcelRequire("8zS3F");

var $6ktTX = parcelRequire("6ktTX");

var $e9CWO = parcelRequire("e9CWO");

var $9Zsep = parcelRequire("9Zsep");

var $96q1S = parcelRequire("96q1S");

var $9HcT0 = parcelRequire("9HcT0");

var $9Kt1W = parcelRequire("9Kt1W");
const $6a0dbe14ecca036e$var$MAX_MEMO_CACHE_SIZE = 3000;
class $6a0dbe14ecca036e$var$StatsigClientBase {
    constructor(sdkKey, adapter, network, options){
        var _a, _b, _c, _d;
        this.loadingStatus = 'Uninitialized';
        this._initializePromise = null;
        this._listeners = {};
        const emitter = this.$emt.bind(this);
        (options === null || options === void 0 ? void 0 : options.logLevel) != null && ($8zS3F.Log.level = options.logLevel);
        (options === null || options === void 0 ? void 0 : options.disableStorage) && $9Kt1W.Storage._setDisabled(true);
        (options === null || options === void 0 ? void 0 : options.initialSessionID) && $9Zsep.StatsigSession.overrideInitialSessionID(options.initialSessionID, sdkKey);
        (options === null || options === void 0 ? void 0 : options.storageProvider) && $9Kt1W.Storage._setProvider(options.storageProvider);
        (options === null || options === void 0 ? void 0 : options.enableCookies) && $96q1S.StableID._setCookiesEnabled(sdkKey, options.enableCookies);
        (options === null || options === void 0 ? void 0 : options.disableStableID) && $96q1S.StableID._setDisabled(sdkKey, true);
        this._sdkKey = sdkKey;
        this._options = options !== null && options !== void 0 ? options : {};
        this._memoCache = {};
        this.overrideAdapter = (_a = options === null || options === void 0 ? void 0 : options.overrideAdapter) !== null && _a !== void 0 ? _a : null;
        this._logger = new $9yrlC.EventLogger(sdkKey, emitter, network, options);
        this._errorBoundary = new $bLgjg.ErrorBoundary(sdkKey, options, emitter);
        this._errorBoundary.wrap(this);
        this._errorBoundary.wrap(adapter);
        this._errorBoundary.wrap(this._logger);
        network.setErrorBoundary(this._errorBoundary);
        this.dataAdapter = adapter;
        this.dataAdapter.attach(sdkKey, options, network);
        this.storageProvider = $9Kt1W.Storage;
        (_d = (_c = (_b = this.overrideAdapter) === null || _b === void 0 ? void 0 : _b.loadFromStorage) === null || _c === void 0 ? void 0 : _c.call(_b)) === null || _d === void 0 || _d.catch((e)=>this._errorBoundary.logError('OA::loadFromStorage', e));
        this._primeReadyRipcord();
        $6a0dbe14ecca036e$var$_assignGlobalInstance(sdkKey, this);
    }
    /**
     * Updates runtime configuration options for the SDK, allowing toggling of certain behaviors such as logging and storage to comply with user preferences or regulations such as GDPR.
     *
     * @param {StatsigRuntimeMutableOptions} options - The configuration options that dictate the runtime behavior of the SDK.
     */ updateRuntimeOptions(options) {
        if (options.loggingEnabled) {
            this._options.loggingEnabled = options.loggingEnabled;
            this._logger.setLoggingEnabled(options.loggingEnabled);
        } else if (options.disableLogging != null) {
            this._options.disableLogging = options.disableLogging;
            this._logger.setLoggingEnabled(options.disableLogging ? 'disabled' : 'browser-only');
        }
        if (options.disableStorage != null) {
            this._options.disableStorage = options.disableStorage;
            $9Kt1W.Storage._setDisabled(options.disableStorage);
        }
        if (options.enableCookies != null) {
            this._options.enableCookies = options.enableCookies;
            $96q1S.StableID._setCookiesEnabled(this._sdkKey, options.enableCookies);
        }
        if (options.logEventCompressionMode) this._logger.setLogEventCompressionMode(options.logEventCompressionMode);
        else if (options.disableCompression) this._logger.setLogEventCompressionMode($9HcT0.LogEventCompressionMode.Disabled);
    }
    /**
     * Flushes any currently queued events.
     */ flush() {
        return this._logger.flush();
    }
    /**
     * Gracefully shuts down the SDK, ensuring that all pending events are send before the SDK stops.
     * This function emits a 'pre_shutdown' event and then waits for the logger to complete its shutdown process.
     *
     * @returns {Promise<void>} A promise that resolves when all shutdown procedures, including logging shutdown, have been completed.
     */ shutdown() {
        return $6a0dbe14ecca036e$var$__awaiter(this, void 0, void 0, function*() {
            this.$emt({
                name: 'pre_shutdown'
            });
            this._setStatus('Uninitialized', null);
            this._initializePromise = null;
            yield this._logger.stop();
        });
    }
    /**
     * Subscribes a callback function to a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     * Once subscribed, the listener callback will be invoked whenever the specified event is emitted.
     *
     * @param {StatsigClientEventName} event - The name of the event to subscribe to, or '*' to subscribe to all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to execute when the event occurs. The function receives event-specific data as its parameter.
     * @see {@link off} for unsubscribing from events.
     */ on(event, listener) {
        if (!this._listeners[event]) this._listeners[event] = [];
        this._listeners[event].push(listener);
    }
    /**
     * Unsubscribes a previously registered callback function from a specific {@link StatsigClientEvent} or all StatsigClientEvents if the wildcard '*' is used.
     *
     * @param {StatsigClientEventName} event - The name of the event from which to unsubscribe, or '*' to unsubscribe from all events.
     * @param {StatsigClientEventCallback<T>} listener - The callback function to remove from the event's notification list.
     * @see {@link on} for subscribing to events.
     */ off(event, listener) {
        if (this._listeners[event]) {
            const index = this._listeners[event].indexOf(listener);
            if (index !== -1) this._listeners[event].splice(index, 1);
        }
    }
    $on(event, listener) {
        listener.__isInternal = true;
        this.on(event, listener);
    }
    $emt(event) {
        var _a;
        const barrier = (listener)=>{
            try {
                listener(event);
            } catch (error) {
                if (listener.__isInternal === true) {
                    this._errorBoundary.logError(`__emit:${event.name}`, error);
                    return;
                }
                $8zS3F.Log.error(`An error occurred in a StatsigClientEvent listener. This is not an issue with Statsig.`, event);
            }
        };
        if (this._listeners[event.name]) this._listeners[event.name].forEach((l)=>barrier(l));
        (_a = this._listeners['*']) === null || _a === void 0 || _a.forEach(barrier);
    }
    _setStatus(newStatus, values) {
        this.loadingStatus = newStatus;
        this._memoCache = {};
        this.$emt({
            name: 'values_updated',
            status: newStatus,
            values: values
        });
    }
    _enqueueExposure(name, exposure, options) {
        if ((options === null || options === void 0 ? void 0 : options.disableExposureLog) === true) {
            this._logger.incrementNonExposureCount(name);
            return;
        }
        this._logger.enqueue(exposure);
    }
    _memoize(prefix, fn) {
        return (name, options)=>{
            if (this._options.disableEvaluationMemoization) return fn(name, options);
            const memoKey = (0, $6ktTX.createMemoKey)(prefix, name, options);
            if (!memoKey) return fn(name, options);
            if (!(memoKey in this._memoCache)) {
                if (Object.keys(this._memoCache).length >= $6a0dbe14ecca036e$var$MAX_MEMO_CACHE_SIZE) this._memoCache = {};
                this._memoCache[memoKey] = fn(name, options);
            }
            return this._memoCache[memoKey];
        };
    }
}
module.exports.StatsigClientBase = $6a0dbe14ecca036e$var$StatsigClientBase;
function $6a0dbe14ecca036e$var$_assignGlobalInstance(sdkKey, client) {
    var _a;
    if ((0, $e9CWO._isServerEnv)()) return;
    const statsigGlobal = (0, $dizc4._getStatsigGlobal)();
    const instances = (_a = statsigGlobal.instances) !== null && _a !== void 0 ? _a : {};
    const inst = client;
    if (instances[sdkKey] != null) $8zS3F.Log.warn('Creating multiple Statsig clients with the same SDK key can lead to unexpected behavior. Multi-instance support requires different SDK keys.');
    instances[sdkKey] = inst;
    if (!statsigGlobal.firstInstance) statsigGlobal.firstInstance = inst;
    statsigGlobal.instances = instances;
    __STATSIG__ = statsigGlobal;
}

});

parcelRegister("5wjr2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DataAdapterCachePrefix = void 0;
module.exports.DataAdapterCachePrefix = 'statsig.cached';

});

parcelRegister("vMPTB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("eCWJg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeTypedGet = module.exports._mergeOverride = module.exports._makeLayer = module.exports._makeExperiment = module.exports._makeDynamicConfig = module.exports._makeFeatureGate = void 0;

var $8zS3F = parcelRequire("8zS3F");

var $9mTS6 = parcelRequire("9mTS6");
function $aa622ba916b000a0$var$_makeEvaluation(name, details, evaluation, value) {
    var _a;
    return {
        name: name,
        details: details,
        ruleID: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.rule_id) !== null && _a !== void 0 ? _a : '',
        __evaluation: evaluation,
        value: value
    };
}
function $aa622ba916b000a0$var$_makeFeatureGate(name, details, evaluation) {
    var _a;
    return Object.assign(Object.assign({}, $aa622ba916b000a0$var$_makeEvaluation(name, details, evaluation, (evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) === true)), {
        idType: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeFeatureGate = $aa622ba916b000a0$var$_makeFeatureGate;
function $aa622ba916b000a0$var$_makeDynamicConfig(name, details, evaluation) {
    var _a, _b;
    const value = (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, $aa622ba916b000a0$var$_makeEvaluation(name, details, evaluation, value)), {
        idType: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.id_type) !== null && _b !== void 0 ? _b : null,
        get: $aa622ba916b000a0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value)
    });
}
module.exports._makeDynamicConfig = $aa622ba916b000a0$var$_makeDynamicConfig;
function $aa622ba916b000a0$var$_makeExperiment(name, details, evaluation) {
    var _a;
    const result = $aa622ba916b000a0$var$_makeDynamicConfig(name, details, evaluation);
    return Object.assign(Object.assign({}, result), {
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null
    });
}
module.exports._makeExperiment = $aa622ba916b000a0$var$_makeExperiment;
function $aa622ba916b000a0$var$_makeLayer(name, details, evaluation, exposeFunc) {
    var _a, _b;
    return Object.assign(Object.assign({}, $aa622ba916b000a0$var$_makeEvaluation(name, details, evaluation, undefined)), {
        get: $aa622ba916b000a0$var$_makeTypedGet(name, evaluation === null || evaluation === void 0 ? void 0 : evaluation.value, exposeFunc),
        groupName: (_a = evaluation === null || evaluation === void 0 ? void 0 : evaluation.group_name) !== null && _a !== void 0 ? _a : null,
        __value: (_b = evaluation === null || evaluation === void 0 ? void 0 : evaluation.value) !== null && _b !== void 0 ? _b : {}
    });
}
module.exports._makeLayer = $aa622ba916b000a0$var$_makeLayer;
function $aa622ba916b000a0$var$_mergeOverride(original, overridden, value, exposeFunc) {
    return Object.assign(Object.assign(Object.assign({}, original), overridden), {
        get: $aa622ba916b000a0$var$_makeTypedGet(original.name, value, exposeFunc)
    });
}
module.exports._mergeOverride = $aa622ba916b000a0$var$_mergeOverride;
function $aa622ba916b000a0$var$_makeTypedGet(name, value, exposeFunc) {
    return (param, fallback)=>{
        var _a;
        const found = (_a = value === null || value === void 0 ? void 0 : value[param]) !== null && _a !== void 0 ? _a : null;
        if (found == null) return fallback !== null && fallback !== void 0 ? fallback : null;
        if (fallback != null && !(0, $9mTS6._isTypeMatch)(found, fallback)) {
            $8zS3F.Log.warn(`Parameter type mismatch. '${name}.${param}' was found to be type '${typeof found}' but fallback/return type is '${typeof fallback}'. See https://docs.statsig.com/client/javascript-sdk/#typed-getters`);
            return fallback !== null && fallback !== void 0 ? fallback : null;
        }
        exposeFunc === null || exposeFunc === void 0 || exposeFunc(param);
        return found;
    };
}
module.exports._makeTypedGet = $aa622ba916b000a0$var$_makeTypedGet;

});

parcelRegister("irrNm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

});

parcelRegister("cQQIC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = module.exports.createUpdateDetails = void 0;
const $95b33c2f4a2a8261$var$createUpdateDetails = (success, source, initDuration, error, sourceUrl, warnings)=>{
    return {
        duration: initDuration,
        source: source,
        success: success,
        error: error,
        sourceUrl: sourceUrl,
        warnings: warnings
    };
};
module.exports.createUpdateDetails = $95b33c2f4a2a8261$var$createUpdateDetails;
module.exports.UPDATE_DETAIL_ERROR_MESSAGES = {
    NO_NETWORK_DATA: 'No data was returned from the network. This may be due to a network timeout if a timeout value was specified in the options or ad blocker error.'
};

});


parcelRegister("ca1MY", function(module, exports) {
"use strict";
var $8da7ce704e45c337$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $pWbzR = parcelRequire("pWbzR");

var $fRtWd = parcelRequire("fRtWd");

var $kYlBL = parcelRequire("kYlBL");

var $cFhrs = parcelRequire("cFhrs");

var $jkaBK = parcelRequire("jkaBK");
class $8da7ce704e45c337$var$StatsigClient extends $pWbzR.StatsigClientBase {
    /**
     * Retrieves an instance of the StatsigClient based on the provided SDK key.
     *  If no SDK key is provided, the method returns the most recently created instance of the StatsigClient.
     *  The method ensures that each unique SDK key corresponds to a single instance of StatsigClient, effectively implementing a singleton pattern for each key.
     *  If no instance exists for the given SDK key, a new StatsigClient instance will be created and returned.
     *
     * @param {string} [sdkKey] - Optional. The SDK key used to identify a specific instance of the StatsigClient. If omitted, the method returns the last created instance.
     * @returns {StatsigClient} Returns the StatsigClient instance associated with the given SDK key, creating a new one if needed.
     */ static instance(sdkKey) {
        const instance = (0, $pWbzR._getStatsigGlobal)().instance(sdkKey);
        if (instance instanceof $8da7ce704e45c337$var$StatsigClient) return instance;
        $pWbzR.Log.warn((0, $pWbzR._isServerEnv)() ? 'StatsigClient.instance is not supported in server environments' : 'Unable to find StatsigClient instance');
        return new $8da7ce704e45c337$var$StatsigClient(sdkKey !== null && sdkKey !== void 0 ? sdkKey : '', {});
    }
    /**
     * StatsigClient constructor
     *
     * @param {string} sdkKey A Statsig client SDK key. eg "client-xyz123..."
     * @param {StatsigUser} user StatsigUser object containing various attributes related to a user.
     * @param {StatsigOptions | null} options StatsigOptions, used to customize the behavior of the SDK.
     */ constructor(sdkKey, user, options = null){
        var _a, _b;
        $pWbzR.SDKType._setClientType(sdkKey, 'javascript-client');
        const network = new $kYlBL.default(options, (e)=>{
            this.$emt(e);
        });
        super(sdkKey, (_a = options === null || options === void 0 ? void 0 : options.dataAdapter) !== null && _a !== void 0 ? _a : new $jkaBK.StatsigEvaluationsDataAdapter(), network, options);
        this._possibleFirstTouchMetadata = {};
        /**
         * Retrieves the value of a feature gate for the current user, represented as a {@link FeatureGate} object.
         *
         * @param {string} name - The name of the feature gate to retrieve.
         * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {FeatureGate} - The {@link FeatureGate} object representing the gate's current evaluation results for the user.
         */ this.getFeatureGate = this._memoize($pWbzR.MemoPrefix._gate, this._getFeatureGateImpl.bind(this));
        /**
         * Retrieves the value of a dynamic config for the current user.
         *
         * @param {string} name The name of the dynamic config to get.
         * @param {DynamicConfigEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {DynamicConfig} - The {@link DynamicConfig} object representing the dynamic configs's current evaluation results for the user.
         */ this.getDynamicConfig = this._memoize($pWbzR.MemoPrefix._dynamicConfig, this._getDynamicConfigImpl.bind(this));
        /**
         * Retrieves the value of a experiment for the current user.
         *
         * @param {string} name The name of the experiment to get.
         * @param {ExperimentEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Experiment} - The {@link Experiment} object representing the experiments's current evaluation results for the user.
         */ this.getExperiment = this._memoize($pWbzR.MemoPrefix._experiment, this._getExperimentImpl.bind(this));
        /**
         * Retrieves the list of all Dynamic Configs and Experiments for the current user.
         *
         * @returns {string[]} The list of all Dynamic Config and Experiment names for the current user. Note - these will be hashed unless you've disabled hashing.
         * This is intended to be used for debugging.
         */ this.getConfigList = this._memoize($pWbzR.MemoPrefix._configList, this._getConfigListImpl.bind(this));
        /**
         * Retrieves the value of a layer for the current user.
         *
         * @param {string} name The name of the layer to get.
         * @param {LayerEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {Layer} - The {@link Layer} object representing the layers's current evaluation results for the user.
         */ this.getLayer = this._memoize($pWbzR.MemoPrefix._layer, this._getLayerImpl.bind(this));
        /**
         * Retrieves the value of a parameter store for the current user.
         *
         * @param {string} name The name of the parameter store to get.
         * @param {ParameterStoreEvaluationOptions} [options] - Optional. Additional options to customize the method call.
         * @returns {ParameterStore} - The {@link ParameterStore} object representing the parameter store's current mappings for the user.
         */ this.getParameterStore = this._memoize($pWbzR.MemoPrefix._paramStore, this._getParameterStoreImpl.bind(this));
        this._store = new $fRtWd.default(sdkKey);
        this._network = network;
        this._user = this._configureUser(user, options);
        this._sdkInstanceID = (0, $pWbzR.getUUID)();
        const plugins = (_b = options === null || options === void 0 ? void 0 : options.plugins) !== null && _b !== void 0 ? _b : [];
        for (const plugin of plugins)plugin.bind(this);
    }
    /**
     * Initializes the StatsigClient using cached values. This method sets up the client synchronously by utilizing previously cached values.
     * After initialization, cache values are updated in the background for future use, either in subsequent sessions or when `updateUser` is called.
     * This is useful for quickly starting with the last-known-good configurations while refreshing data to keep settings up-to-date.
     *
     * @see {@link initializeAsync} for the asynchronous version of this method.
     */ initializeSync(options) {
        var _a;
        if (this.loadingStatus !== 'Uninitialized') return (0, $pWbzR.createUpdateDetails)(true, this._store.getSource(), -1, null, null, [
            'MultipleInitializations',
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
        this._logger.start();
        return this.updateUserSync(this._user, options);
    }
    /**
     * Initializes the StatsigClient asynchronously by first using cached values and then updating to the latest values from the network.
     * Once the network values are fetched, they replace the existing cached values. If this method's promise is not awaited,
     * there might be a transition from cached to network values during the session, which can affect consistency.
     * This method is useful when it's acceptable to begin with potentially stale data and switch to the latest configuration as it becomes available.
     *
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully initialized with the latest values from the network or a timeout (if set) is hit.
     * @see {@link initializeSync} for the synchronous version of this method.
     */ initializeAsync(options) {
        return $8da7ce704e45c337$var$__awaiter(this, void 0, void 0, function*() {
            if (this._initializePromise) return this._initializePromise;
            this._initializePromise = this._initializeAsyncImpl(options);
            return this._initializePromise;
        });
    }
    /**
     * Synchronously updates the user in the Statsig client and switches the internal state to use cached values for the newly specified user.
     * After the initial switch to cached values, this method updates these values in the background, preparing them for future sessions or subsequent calls to updateUser.
     * This method ensures the client is quickly ready with available data.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @see {@link updateUserAsync} for the asynchronous version of this method.
     */ updateUserSync(user, options) {
        const startTime = performance.now();
        try {
            return this._updateUserSyncImpl(user, options, startTime);
        } catch (e) {
            const err = e instanceof Error ? e : new Error(String(e));
            return this._createErrorUpdateDetails(err, startTime);
        }
    }
    _updateUserSyncImpl(user, options, startTime) {
        var _a;
        const warnings = [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ];
        this._resetForUser(user);
        const result = this.dataAdapter.getDataSync(this._user);
        if (result == null) warnings.push('NoCachedValues');
        this._store.setValues(result, this._user);
        this._finalizeUpdate(result);
        const disable = options === null || options === void 0 ? void 0 : options.disableBackgroundCacheRefresh;
        if (disable === true || disable == null && (result === null || result === void 0 ? void 0 : result.source) === 'Bootstrap') return (0, $pWbzR.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
        this._runPostUpdate(result !== null && result !== void 0 ? result : null, this._user);
        return (0, $pWbzR.createUpdateDetails)(true, this._store.getSource(), performance.now() - startTime, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), warnings);
    }
    /**
     * Asynchronously updates the user in the Statsig client by initially using cached values and then fetching the latest values from the network.
     * When the latest values are fetched, they replace the cached values. If the promise returned by this method is not awaited,
     * the client's state may shift from cached to updated network values during the session, potentially affecting consistency.
     * This method is best used in scenarios where up-to-date configuration is critical and initial delays are acceptable.
     *
     * @param {StatsigUser} user - The new StatsigUser for which the client should update its internal state.
     * @param {AsyncUpdateOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {Promise<void>} A promise that resolves once the client is fully updated with the latest values from the network or a timeout (if set) is hit.
     * @see {@link updateUserSync} for the synchronous version of this method.
     */ updateUserAsync(user, options) {
        return $8da7ce704e45c337$var$__awaiter(this, void 0, void 0, function*() {
            const startTime = performance.now();
            try {
                return yield this._updateUserAsyncImpl(user, options);
            } catch (e) {
                const err = e instanceof Error ? e : new Error(String(e));
                return this._createErrorUpdateDetails(err, startTime);
            }
        });
    }
    _updateUserAsyncImpl(user, options) {
        return $8da7ce704e45c337$var$__awaiter(this, void 0, void 0, function*() {
            this._resetForUser(user);
            const initiator = this._user;
            $pWbzR.Diagnostics._markInitOverallStart(this._sdkKey);
            let result = this.dataAdapter.getDataSync(initiator);
            this._store.setValues(result, this._user);
            this._setStatus('Loading', result);
            result = yield this.dataAdapter.getDataAsync(result, initiator, options);
            // ensure the user hasn't changed while we were waiting
            if (initiator !== this._user) return (0, $pWbzR.createUpdateDetails)(false, this._store.getSource(), -1, new Error('User changed during update'), this._network.getLastUsedInitUrlAndReset());
            let isUsingNetworkValues = false;
            if (result != null) {
                $pWbzR.Diagnostics._markInitProcessStart(this._sdkKey);
                isUsingNetworkValues = this._store.setValues(result, this._user);
                $pWbzR.Diagnostics._markInitProcessEnd(this._sdkKey, {
                    success: isUsingNetworkValues
                });
            }
            this._finalizeUpdate(result);
            if (!isUsingNetworkValues) {
                this._errorBoundary.attachErrorIfNoneExists($pWbzR.UPDATE_DETAIL_ERROR_MESSAGES.NO_NETWORK_DATA);
                this.$emt({
                    name: 'initialization_failure'
                });
            }
            $pWbzR.Diagnostics._markInitOverallEnd(this._sdkKey, isUsingNetworkValues, this._store.getCurrentSourceDetails());
            const initDuration = $pWbzR.Diagnostics._enqueueDiagnosticsEvent(this._user, this._logger, this._sdkKey, this._options);
            return (0, $pWbzR.createUpdateDetails)(isUsingNetworkValues, this._store.getSource(), initDuration, this._errorBoundary.getLastSeenErrorAndReset(), this._network.getLastUsedInitUrlAndReset(), this._store.getWarnings());
        });
    }
    /**
     * Retrieves a synchronous context containing data currently being used by the SDK. Represented as a {@link PrecomputedEvaluationsContext} object.
     *
     * @returns {PrecomputedEvaluationsContext} The current synchronous context for the this StatsigClient instance.
     */ getContext() {
        let user = {};
        try {
            user = JSON.parse(JSON.stringify(this._user));
        } catch (_a) {
            $pWbzR.Log.error('Failed to parse user');
        }
        return {
            sdkKey: this._sdkKey,
            options: this._options,
            values: this._store.getValues(),
            user: user,
            errorBoundary: this._errorBoundary,
            session: $pWbzR.StatsigSession.get(this._sdkKey),
            stableID: $pWbzR.StableID.get(this._sdkKey),
            sdkInstanceID: this._sdkInstanceID
        };
    }
    /**
     * Retrieves the value of a feature gate for the current user, represented as a simple boolean.
     *
     * @param {string} name - The name of the feature gate to retrieve.
     * @param {FeatureGateEvaluationOptions} [options] - Optional. Additional options to customize the method call.
     * @returns {boolean} - The boolean value representing the gate's current evaluation results for the user.
     */ checkGate(name, options) {
        return this.getFeatureGate(name, options).value;
    }
    /**
     * Logs an event to the internal logging system. This function allows logging by either passing a fully formed event object or by specifying the event name with optional value and metadata.
     *
     * @param {StatsigEvent|string} eventOrName - The event object conforming to the StatsigEvent interface, or the name of the event as a string.
     * @param {string|number} value - Optional. The value associated with the event, which can be a string or a number. This parameter is ignored if the first parameter is a StatsigEvent object.
     * @param {Record<string, string>} metadata - Optional. A key-value record containing metadata about the event. This is also ignored if the first parameter is an event object.
     */ logEvent(eventOrName, value, metadata) {
        const event = typeof eventOrName === 'string' ? {
            eventName: eventOrName,
            value: value,
            metadata: metadata
        } : eventOrName;
        this.$emt({
            name: 'log_event_called',
            event: event
        });
        this._logger.enqueue(Object.assign(Object.assign({}, event), {
            user: this._user,
            time: Date.now()
        }));
    }
    /**
     * Updates the user with analytics only metadata. This will override any existing analytics only metadata.
     *
     * @param {Record<string, string | number | boolean>} metadata - The metadata to add to the user.
     */ updateUserWithAnalyticsOnlyMetadata(metadata) {
        this._user = this._configureUser(Object.assign(Object.assign({}, this._user), {
            analyticsOnlyMetadata: metadata
        }), this._options);
    }
    _primeReadyRipcord() {
        this.$on('error', ()=>{
            this.loadingStatus === 'Loading' && this._finalizeUpdate(null);
        });
    }
    _initializeAsyncImpl(options) {
        return $8da7ce704e45c337$var$__awaiter(this, void 0, void 0, function*() {
            if (!$pWbzR.Storage.isReady()) yield $pWbzR.Storage.isReadyResolver();
            this._logger.start();
            return this.updateUserAsync(this._user, options);
        });
    }
    _createErrorUpdateDetails(error, startTime) {
        var _a;
        return (0, $pWbzR.createUpdateDetails)(false, this._store.getSource(), performance.now() - startTime, error, null, [
            ...(_a = this._store.getWarnings()) !== null && _a !== void 0 ? _a : []
        ]);
    }
    _finalizeUpdate(values) {
        this._store.finalize();
        this._setStatus('Ready', values);
    }
    _runPostUpdate(current, user) {
        this.dataAdapter.getDataAsync(current, user, {
            priority: 'low'
        }).catch((err)=>{
            $pWbzR.Log.error('An error occurred after update.', err);
        });
    }
    _resetForUser(user) {
        this._logger.reset();
        this._store.reset();
        this._user = this._configureUser(user, this._options);
    }
    _configureUser(originalUser, options) {
        var _a, _b, _c;
        const user = (0, $pWbzR._normalizeUser)(originalUser, options);
        const stableIdOverride = (_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID;
        if (stableIdOverride) {
            const readyPromise = (_c = (_b = this.storageProvider).isReadyResolver) === null || _c === void 0 ? void 0 : _c.call(_b);
            if (readyPromise) readyPromise.then(()=>$pWbzR.StableID.setOverride(stableIdOverride, this._sdkKey), ()=>$pWbzR.StableID.setOverride(stableIdOverride, this._sdkKey));
            else $pWbzR.StableID.setOverride(stableIdOverride, this._sdkKey);
        }
        // Only attach first touch metadata if it's not empty
        if (Object.keys(this._possibleFirstTouchMetadata).length > 0) user.analyticsOnlyMetadata = Object.assign(Object.assign({}, user.analyticsOnlyMetadata), this._possibleFirstTouchMetadata);
        return user;
    }
    _getFeatureGateImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getGate(name);
        const gate = (0, $pWbzR._makeFeatureGate)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getGateOverride) === null || _b === void 0 ? void 0 : _b.call(_a, gate, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : gate;
        this._enqueueExposure(name, (0, $pWbzR._createGateExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'gate_evaluation',
            gate: result
        });
        return result;
    }
    _getDynamicConfigImpl(name, options) {
        var _a, _b;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const config = (0, $pWbzR._makeDynamicConfig)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getDynamicConfigOverride) === null || _b === void 0 ? void 0 : _b.call(_a, config, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : config;
        this._enqueueExposure(name, (0, $pWbzR._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'dynamic_config_evaluation',
            dynamicConfig: result
        });
        return result;
    }
    _getExperimentImpl(name, options) {
        var _a, _b, _c, _d;
        const { result: evaluation, details: details } = this._store.getConfig(name);
        const experiment = (0, $pWbzR._makeExperiment)(name, details, evaluation);
        if (experiment.__evaluation != null) experiment.__evaluation.secondary_exposures = (0, $pWbzR._mapExposures)((_b = (_a = experiment.__evaluation) === null || _a === void 0 ? void 0 : _a.secondary_exposures) !== null && _b !== void 0 ? _b : [], this._store.getExposureMapping());
        const overridden = (_d = (_c = this.overrideAdapter) === null || _c === void 0 ? void 0 : _c.getExperimentOverride) === null || _d === void 0 ? void 0 : _d.call(_c, experiment, this._user, options);
        const result = overridden !== null && overridden !== void 0 ? overridden : experiment;
        this._enqueueExposure(name, (0, $pWbzR._createConfigExposure)(this._user, result, this._store.getExposureMapping()), options);
        this.$emt({
            name: 'experiment_evaluation',
            experiment: result
        });
        return result;
    }
    _getConfigListImpl() {
        return this._store.getConfigList();
    }
    _getLayerImpl(name, options) {
        var _a, _b, _c;
        const { result: evaluation, details: details } = this._store.getLayer(name);
        const layer = (0, $pWbzR._makeLayer)(name, details, evaluation);
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getLayerOverride) === null || _b === void 0 ? void 0 : _b.call(_a, layer, this._user, options);
        if (options === null || options === void 0 ? void 0 : options.disableExposureLog) this._logger.incrementNonExposureCount(name);
        const result = (0, $pWbzR._mergeOverride)(layer, overridden, (_c = overridden === null || overridden === void 0 ? void 0 : overridden.__value) !== null && _c !== void 0 ? _c : layer.__value, (param)=>{
            if (options === null || options === void 0 ? void 0 : options.disableExposureLog) return;
            this._enqueueExposure(name, (0, $pWbzR._createLayerParameterExposure)(this._user, result, param, this._store.getExposureMapping()), options);
        });
        this.$emt({
            name: 'layer_evaluation',
            layer: result
        });
        return result;
    }
    _getParameterStoreImpl(name, options) {
        var _a, _b;
        const { result: configuration, details: details } = this._store.getParamStore(name);
        this._logger.incrementNonExposureCount(name);
        const paramStore = {
            name: name,
            details: details,
            __configuration: configuration,
            get: (0, $cFhrs._makeParamStoreGetter)(this, configuration, options)
        };
        const overridden = (_b = (_a = this.overrideAdapter) === null || _a === void 0 ? void 0 : _a.getParamStoreOverride) === null || _b === void 0 ? void 0 : _b.call(_a, paramStore, options);
        if (overridden != null) {
            paramStore.__configuration = overridden.config;
            paramStore.details = overridden.details;
            paramStore.get = (0, $cFhrs._makeParamStoreGetter)(this, overridden.config, options);
        }
        return paramStore;
    }
}
module.exports.default = $8da7ce704e45c337$var$StatsigClient;

});
parcelRegister("fRtWd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $pWbzR = parcelRequire("pWbzR");

var $7OmGE = parcelRequire("7OmGE");

var $8ID2h = parcelRequire("8ID2h");
class $b8c3074bd6f92a9a$var$EvaluationStore {
    constructor(_sdkKey){
        this._sdkKey = _sdkKey;
        this._rawValues = null;
        this._values = null;
        this._source = 'Uninitialized';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings = new Set();
    }
    reset() {
        this._values = null;
        this._rawValues = null;
        this._source = 'Loading';
        this._lcut = 0;
        this._receivedAt = 0;
        this._bootstrapMetadata = null;
        this._warnings.clear();
    }
    finalize() {
        if (this._values) return;
        this._source = 'NoValues';
    }
    getValues() {
        return this._rawValues ? (0, $pWbzR._typedJsonParse)(this._rawValues, 'has_updates', 'EvaluationStoreValues') : null;
    }
    setValues(result, user) {
        var _a, _b;
        if (!result) return false;
        const values = (0, $pWbzR._typedJsonParse)(result.data, 'has_updates', 'EvaluationResponse');
        if (values == null) return false;
        this._source = result.source;
        if ((values === null || values === void 0 ? void 0 : values.has_updates) !== true) return true;
        const updatedLcut = (_a = values.time) !== null && _a !== void 0 ? _a : 0;
        if (updatedLcut < this._lcut) return true;
        this._rawValues = result.data;
        this._lcut = values.time;
        this._receivedAt = result.receivedAt;
        if (values.response_format === 'init-v2') this._values = new $8ID2h.V2InitializeContainer(values);
        else this._values = new $7OmGE.V1InitializeContainer(values);
        this._bootstrapMetadata = this._extractBootstrapMetadata(result.source, values);
        if (result.source && values.user) this._setWarningState(user, values);
        $pWbzR.SDKFlags.setFlags(this._sdkKey, (_b = values.sdk_flags) !== null && _b !== void 0 ? _b : {});
        return true;
    }
    getWarnings() {
        if (this._warnings.size === 0) return undefined;
        return Array.from(this._warnings);
    }
    getGate(name) {
        const res = this._values ? this._values.getGate(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfig(name) {
        const res = this._values ? this._values.getConfig(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getConfigList() {
        if (!this._values) return [];
        return this._values.getConfigList();
    }
    getLayer(name) {
        const res = this._values ? this._values.getLayer(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getParamStore(name) {
        const res = this._values ? this._values.getParamStore(name) : null;
        return this._getDetailedStoreResult(res);
    }
    getSource() {
        return this._source;
    }
    getExposureMapping() {
        var _a;
        return (_a = this._values) === null || _a === void 0 ? void 0 : _a.getExposureMapping();
    }
    _extractBootstrapMetadata(source, values) {
        if (source !== 'Bootstrap') return null;
        const bootstrapMetadata = {};
        if (values.user) bootstrapMetadata.user = values.user;
        if (values.sdkInfo) bootstrapMetadata.generatorSDKInfo = values.sdkInfo;
        bootstrapMetadata.lcut = values.time;
        return bootstrapMetadata;
    }
    _getDetailedStoreResult(result) {
        return {
            result: result,
            details: this._getDetails(result == null)
        };
    }
    _setWarningState(user, values) {
        var _a, _b;
        const stableID = $pWbzR.StableID.get(this._sdkKey);
        if (((_a = user.customIDs) === null || _a === void 0 ? void 0 : _a.stableID) !== stableID && // don't throw if they're both undefined
        (((_b = user.customIDs) === null || _b === void 0 ? void 0 : _b.stableID) || stableID)) {
            this._warnings.add('StableIDMismatch');
            return;
        }
        if ('user' in values) {
            const bootstrapUser = values['user'];
            const userForComparison = Object.assign(Object.assign({}, user), {
                analyticsOnlyMetadata: undefined,
                privateAttributes: undefined
            });
            if ((0, $pWbzR._getFullUserHash)(userForComparison) !== (0, $pWbzR._getFullUserHash)(bootstrapUser)) this._warnings.add('PartialUserMatch');
        }
    }
    getCurrentSourceDetails() {
        if (this._source === 'Uninitialized' || this._source === 'NoValues') return {
            reason: this._source
        };
        const sourceDetails = {
            reason: this._source,
            lcut: this._lcut,
            receivedAt: this._receivedAt
        };
        if (this._warnings.size > 0) sourceDetails.warnings = Array.from(this._warnings);
        return sourceDetails;
    }
    _getDetails(isUnrecognized) {
        var _a, _b;
        const sourceDetails = this.getCurrentSourceDetails();
        let reason = sourceDetails.reason;
        const warnings = (_a = sourceDetails.warnings) !== null && _a !== void 0 ? _a : [];
        if (this._source === 'Bootstrap' && warnings.length > 0) reason = reason + warnings[0];
        if (reason !== 'Uninitialized' && reason !== 'NoValues') {
            const subreason = isUnrecognized ? 'Unrecognized' : 'Recognized';
            reason = `${reason}:${subreason}`;
        }
        const bootstrapMetadata = this._source === 'Bootstrap' ? (_b = this._bootstrapMetadata) !== null && _b !== void 0 ? _b : undefined : undefined;
        if (bootstrapMetadata) sourceDetails.bootstrapMetadata = bootstrapMetadata;
        return Object.assign(Object.assign({}, sourceDetails), {
            reason: reason
        });
    }
}
module.exports.default = $b8c3074bd6f92a9a$var$EvaluationStore;

});
parcelRegister("7OmGE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V1InitializeContainer = void 0;

var $pWbzR = parcelRequire("pWbzR");
class $5afecd0e35d0d6d5$var$V1InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        return this._getResultFromLookup(this._values.feature_gates, name);
    }
    getConfig(name) {
        return this._getResultFromLookup(this._values.dynamic_configs, name);
    }
    getLayer(name) {
        return this._getResultFromLookup(this._values.layer_configs, name);
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $pWbzR._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V1InitializeContainer = $5afecd0e35d0d6d5$var$V1InitializeContainer;

});

parcelRegister("8ID2h", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.V2InitializeContainer = void 0;

var $pWbzR = parcelRequire("pWbzR");
class $6590b6773e97f9b4$var$V2InitializeContainer {
    constructor(_values){
        this._values = _values;
    }
    getGate(name) {
        var _a, _b, _c;
        const evalV2 = this._getResultFromLookup(this._values.feature_gates, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: evalV2.v === true,
            rule_id: (_a = evalV2.r) !== null && _a !== void 0 ? _a : 'default',
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : ''
        };
    }
    getConfig(name) {
        var _a, _b, _c, _d;
        const evalV2 = this._getResultFromLookup(this._values.dynamic_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            id_type: (_c = evalV2.i) !== null && _c !== void 0 ? _c : '',
            is_user_in_experiment: evalV2.ue === true ? true : false,
            passed: evalV2.p === true,
            group_name: (_d = evalV2.gn) !== null && _d !== void 0 ? _d : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID'
        };
    }
    getLayer(name) {
        var _a, _b, _c, _d, _e, _f;
        const evalV2 = this._getResultFromLookup(this._values.layer_configs, name);
        if (!evalV2) return null;
        return {
            name: name,
            value: (_a = this._values.values[evalV2.v]) !== null && _a !== void 0 ? _a : {},
            rule_id: evalV2.r,
            secondary_exposures: (_b = evalV2.s) !== null && _b !== void 0 ? _b : [],
            is_user_in_experiment: evalV2.ue === true ? true : false,
            group_name: (_c = evalV2.gn) !== null && _c !== void 0 ? _c : undefined,
            is_experiment_active: evalV2.ea === true ? true : false,
            group: evalV2.r,
            is_device_based: evalV2.i === 'stableID',
            allocated_experiment_name: (_d = evalV2.ae) !== null && _d !== void 0 ? _d : '',
            explicit_parameters: (_e = evalV2.ep) !== null && _e !== void 0 ? _e : [],
            undelegated_secondary_exposures: (_f = evalV2.us) !== null && _f !== void 0 ? _f : [],
            parameter_rule_ids: evalV2.pr
        };
    }
    getParamStore(name) {
        return this._getResultFromLookup(this._values.param_stores, name);
    }
    getConfigList() {
        return Object.keys(this._values.dynamic_configs);
    }
    getExposureMapping() {
        return this._values.exposures;
    }
    _getResultFromLookup(lookup, name) {
        var _a, _b;
        if (!lookup) return null;
        return (_b = (_a = lookup[name]) !== null && _a !== void 0 ? _a : lookup[(0, $pWbzR._DJB2)(name)]) !== null && _b !== void 0 ? _b : null;
    }
}
module.exports.V2InitializeContainer = $6590b6773e97f9b4$var$V2InitializeContainer;

});


parcelRegister("kYlBL", function(module, exports) {
"use strict";
var $f44a2c2cac7cc845$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $pWbzR = parcelRequire("pWbzR");

var $4yirR = parcelRequire("4yirR");
class $f44a2c2cac7cc845$var$StatsigNetwork extends $pWbzR.NetworkCore {
    constructor(options, emitter){
        super(options, emitter);
        const config = options === null || options === void 0 ? void 0 : options.networkConfig;
        this._option = options;
        this._initializeUrlConfig = new $pWbzR.UrlConfiguration($pWbzR.Endpoint._initialize, config === null || config === void 0 ? void 0 : config.initializeUrl, config === null || config === void 0 ? void 0 : config.api, config === null || config === void 0 ? void 0 : config.initializeFallbackUrls);
    }
    fetchEvaluations(sdkKey, current, priority, user, isCacheValidFor204) {
        return $f44a2c2cac7cc845$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b, _c, _d, _e, _f;
            const cache = current ? (0, $pWbzR._typedJsonParse)(current, 'has_updates', 'InitializeResponse') : null;
            let data = {
                user: user,
                hash: (_c = (_b = (_a = this._option) === null || _a === void 0 ? void 0 : _a.networkConfig) === null || _b === void 0 ? void 0 : _b.initializeHashAlgorithm) !== null && _c !== void 0 ? _c : 'djb2',
                deltasResponseRequested: false,
                full_checksum: null
            };
            if (cache === null || cache === void 0 ? void 0 : cache.has_updates) {
                const hasHashChanged = (cache === null || cache === void 0 ? void 0 : cache.hash_used) !== ((_f = (_e = (_d = this._option) === null || _d === void 0 ? void 0 : _d.networkConfig) === null || _e === void 0 ? void 0 : _e.initializeHashAlgorithm) !== null && _f !== void 0 ? _f : 'djb2');
                data = Object.assign(Object.assign({}, data), {
                    sinceTime: isCacheValidFor204 && !hasHashChanged ? cache.time : 0,
                    previousDerivedFields: 'derived_fields' in cache && isCacheValidFor204 ? cache.derived_fields : {},
                    deltasResponseRequested: true,
                    full_checksum: cache.full_checksum,
                    partialUserMatchSinceTime: !hasHashChanged ? cache.time : 0
                });
            }
            return this._fetchEvaluations(sdkKey, cache, data, priority);
        });
    }
    _fetchEvaluations(sdkKey, cache, data, priority) {
        return $f44a2c2cac7cc845$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            const response = yield this.post({
                sdkKey: sdkKey,
                urlConfig: this._initializeUrlConfig,
                data: data,
                retries: 2,
                isStatsigEncodable: true,
                priority: priority
            });
            if ((response === null || response === void 0 ? void 0 : response.code) === 204) return '{"has_updates": false}';
            if ((response === null || response === void 0 ? void 0 : response.code) !== 200) return (_a = response === null || response === void 0 ? void 0 : response.body) !== null && _a !== void 0 ? _a : null;
            if ((cache === null || cache === void 0 ? void 0 : cache.has_updates) !== true || ((_b = response.body) === null || _b === void 0 ? void 0 : _b.includes('"is_delta":true')) !== true || data.deltasResponseRequested !== true) return response.body;
            const result = (0, $4yirR._resolveDeltasResponse)(cache, response.body);
            if (typeof result === 'string') return result;
            // retry without deltas
            return this._fetchEvaluations(sdkKey, cache, Object.assign(Object.assign(Object.assign({}, data), result), {
                deltasResponseRequested: false
            }), priority);
        });
    }
}
module.exports.default = $f44a2c2cac7cc845$var$StatsigNetwork;

});
parcelRegister("4yirR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._resolveDeltasResponse = void 0;

var $pWbzR = parcelRequire("pWbzR");
const $3508a5da14e45af0$var$MAX_DELTAS_SORT_DEPTH = 2;
function $3508a5da14e45af0$var$_resolveDeltasResponse(cache, deltasString) {
    const deltas = (0, $pWbzR._typedJsonParse)(deltasString, 'checksum', 'DeltasEvaluationResponse');
    if (!deltas) return {
        hadBadDeltaChecksum: true
    };
    const merged = $3508a5da14e45af0$var$_mergeDeltasIntoCache(cache, deltas);
    const resolved = $3508a5da14e45af0$var$_handleDeletedEntries(merged);
    const actualChecksum = (0, $pWbzR._DJB2Object)({
        feature_gates: resolved.feature_gates,
        dynamic_configs: resolved.dynamic_configs,
        layer_configs: resolved.layer_configs
    }, $3508a5da14e45af0$var$MAX_DELTAS_SORT_DEPTH);
    const isMatch = actualChecksum === deltas.checksumV2;
    if (!isMatch) return {
        hadBadDeltaChecksum: true,
        badChecksum: actualChecksum,
        badMergedConfigs: resolved,
        badFullResponse: deltas.deltas_full_response
    };
    return JSON.stringify(resolved);
}
module.exports._resolveDeltasResponse = $3508a5da14e45af0$var$_resolveDeltasResponse;
function $3508a5da14e45af0$var$_mergeDeltasIntoCache(cache, deltas) {
    return Object.assign(Object.assign(Object.assign({}, cache), deltas), {
        feature_gates: Object.assign(Object.assign({}, cache.feature_gates), deltas.feature_gates),
        layer_configs: Object.assign(Object.assign({}, cache.layer_configs), deltas.layer_configs),
        dynamic_configs: Object.assign(Object.assign({}, cache.dynamic_configs), deltas.dynamic_configs)
    });
}
function $3508a5da14e45af0$var$_handleDeletedEntries(deltas) {
    const result = deltas;
    $3508a5da14e45af0$var$_deleteEntriesInRecord(deltas.deleted_gates, result.feature_gates);
    delete result.deleted_gates;
    $3508a5da14e45af0$var$_deleteEntriesInRecord(deltas.deleted_configs, result.dynamic_configs);
    delete result.deleted_configs;
    $3508a5da14e45af0$var$_deleteEntriesInRecord(deltas.deleted_layers, result.layer_configs);
    delete result.deleted_layers;
    return result;
}
function $3508a5da14e45af0$var$_deleteEntriesInRecord(keys, values) {
    keys === null || keys === void 0 || keys.forEach((key)=>{
        delete values[key];
    });
}

});


parcelRegister("cFhrs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports._makeParamStoreGetter = void 0;

var $pWbzR = parcelRequire("pWbzR");
const $9386d7f809e87a91$var$NO_EXPOSURE_OPT = {
    disableExposureLog: true
};
function $9386d7f809e87a91$var$_shouldLogExposure(options) {
    return options == null || options.disableExposureLog === false;
}
function $9386d7f809e87a91$var$_shouldReturnFallback(value, fallback) {
    return fallback != null && !(0, $pWbzR._isTypeMatch)(value, fallback);
}
function $9386d7f809e87a91$var$_getMappedStaticValue(param, _options) {
    return param.value;
}
function $9386d7f809e87a91$var$_getMappedGateValue(client, param, options) {
    const gate = client.getFeatureGate(param.gate_name, $9386d7f809e87a91$var$_shouldLogExposure(options) ? undefined : $9386d7f809e87a91$var$NO_EXPOSURE_OPT);
    if (gate.value) return param.pass_value;
    return param.fail_value;
}
function $9386d7f809e87a91$var$_getMappedDynamicConfigValue(client, param, fallback, options) {
    const config = client.getDynamicConfig(param.config_name, $9386d7f809e87a91$var$_shouldLogExposure(options) ? undefined : $9386d7f809e87a91$var$NO_EXPOSURE_OPT);
    const value = config.get(param.param_name);
    if ($9386d7f809e87a91$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9386d7f809e87a91$var$_getMappedExperimentValue(client, param, fallback, options) {
    const experiment = client.getExperiment(param.experiment_name, $9386d7f809e87a91$var$_shouldLogExposure(options) ? undefined : $9386d7f809e87a91$var$NO_EXPOSURE_OPT);
    const value = experiment.get(param.param_name);
    if ($9386d7f809e87a91$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9386d7f809e87a91$var$_getMappedLayerValue(client, param, fallback, options) {
    const layer = client.getLayer(param.layer_name, $9386d7f809e87a91$var$_shouldLogExposure(options) ? undefined : $9386d7f809e87a91$var$NO_EXPOSURE_OPT);
    const value = layer.get(param.param_name);
    if ($9386d7f809e87a91$var$_shouldReturnFallback(value, fallback)) return fallback;
    return value;
}
function $9386d7f809e87a91$var$_makeParamStoreGetter(client, config, options) {
    return (paramName, fallback)=>{
        if (config == null) return fallback;
        const param = config[paramName];
        if (param == null || fallback != null && (0, $pWbzR._typeOf)(fallback) !== param.param_type) return fallback;
        switch(param.ref_type){
            case 'static':
                return $9386d7f809e87a91$var$_getMappedStaticValue(param, options);
            case 'gate':
                return $9386d7f809e87a91$var$_getMappedGateValue(client, param, options);
            case 'dynamic_config':
                return $9386d7f809e87a91$var$_getMappedDynamicConfigValue(client, param, fallback, options);
            case 'experiment':
                return $9386d7f809e87a91$var$_getMappedExperimentValue(client, param, fallback, options);
            case 'layer':
                return $9386d7f809e87a91$var$_getMappedLayerValue(client, param, fallback, options);
            default:
                return fallback;
        }
    };
}
module.exports._makeParamStoreGetter = $9386d7f809e87a91$var$_makeParamStoreGetter;

});

parcelRegister("jkaBK", function(module, exports) {
"use strict";
var $e1181d13d30d0049$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.StatsigEvaluationsDataAdapter = void 0;

var $pWbzR = parcelRequire("pWbzR");

var $kYlBL = parcelRequire("kYlBL");
class $e1181d13d30d0049$var$StatsigEvaluationsDataAdapter extends $pWbzR.DataAdapterCore {
    constructor(){
        super('EvaluationsDataAdapter', 'evaluations');
        this._network = null;
        this._options = null;
    }
    attach(sdkKey, options, network) {
        super.attach(sdkKey, options, network);
        if (network !== null && network instanceof $kYlBL.default) this._network = network;
        else this._network = new $kYlBL.default(options !== null && options !== void 0 ? options : {});
    }
    getDataAsync(current, user, options) {
        return this._getDataAsyncImpl(current, (0, $pWbzR._normalizeUser)(user, this._options), options);
    }
    prefetchData(user, options) {
        return this._prefetchDataImpl(user, options);
    }
    setData(data) {
        const values = (0, $pWbzR._typedJsonParse)(data, 'has_updates', 'data');
        if (values && 'user' in values) super.setData(data, values.user);
        else $pWbzR.Log.error('StatsigUser not found. You may be using an older server SDK version. Please upgrade your SDK or use setDataLegacy.');
    }
    setDataLegacy(data, user) {
        super.setData(data, user);
    }
    _fetchFromNetwork(current, user, options, isCacheValidFor204) {
        return $e1181d13d30d0049$var$__awaiter(this, void 0, void 0, function*() {
            var _a;
            const result = yield (_a = this._network) === null || _a === void 0 ? void 0 : _a.fetchEvaluations(this._getSdkKey(), current, options === null || options === void 0 ? void 0 : options.priority, user, isCacheValidFor204);
            return result !== null && result !== void 0 ? result : null;
        });
    }
    _getCacheKey(user) {
        var _a;
        const key = (0, $pWbzR._getStorageKey)(this._getSdkKey(), user, (_a = this._options) === null || _a === void 0 ? void 0 : _a.customUserCacheKeyFunc);
        return `${$pWbzR.DataAdapterCachePrefix}.${this._cacheSuffix}.${key}`;
    }
    _isCachedResultValidFor204(result, user) {
        return result.fullUserHash != null && result.fullUserHash === (0, $pWbzR._getFullUserHash)(user);
    }
}
module.exports.StatsigEvaluationsDataAdapter = $e1181d13d30d0049$var$StatsigEvaluationsDataAdapter;

});



parcelRegister("a1I0L", function(module, exports) {
'use strict';
var $74cc231aec4c8630$var$has = Object.prototype.hasOwnProperty, $74cc231aec4c8630$var$prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $74cc231aec4c8630$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $74cc231aec4c8630$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $74cc231aec4c8630$var$Events().__proto__) $74cc231aec4c8630$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $74cc231aec4c8630$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $74cc231aec4c8630$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new $74cc231aec4c8630$var$EE(fn, context || emitter, once), evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $74cc231aec4c8630$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $74cc231aec4c8630$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $74cc231aec4c8630$var$EventEmitter() {
    this._events = new $74cc231aec4c8630$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($74cc231aec4c8630$var$has.call(events, name)) names.push($74cc231aec4c8630$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $74cc231aec4c8630$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $74cc231aec4c8630$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $74cc231aec4c8630$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $74cc231aec4c8630$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $74cc231aec4c8630$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $74cc231aec4c8630$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $74cc231aec4c8630$var$prefix ? $74cc231aec4c8630$var$prefix + event : event;
        if (this._events[evt]) $74cc231aec4c8630$var$clearEvent(this, evt);
    } else {
        this._events = new $74cc231aec4c8630$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$74cc231aec4c8630$var$EventEmitter.prototype.off = $74cc231aec4c8630$var$EventEmitter.prototype.removeListener;
$74cc231aec4c8630$var$EventEmitter.prototype.addListener = $74cc231aec4c8630$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$74cc231aec4c8630$var$EventEmitter.prefixed = $74cc231aec4c8630$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$74cc231aec4c8630$var$EventEmitter.EventEmitter = $74cc231aec4c8630$var$EventEmitter;
module.exports = $74cc231aec4c8630$var$EventEmitter;

});

parcelRegister("1uH7N", function(module, exports) {
$parcel$export(module.exports, "di", () => $116a0b7a6125a170$export$479d1ccc5f2ab701);

var $8jwd7 = parcelRequire("8jwd7");

var $8JXjO = parcelRequire("8JXjO");
function $116a0b7a6125a170$export$479d1ccc5f2ab701(target, ...deps) {
    // Read context and grab all the dependencies override Providers in the tree
    const { getDependencies: getDependencies } = // grab value from alt renderer (eg react-test-renderer)
    (0, $8jwd7.Context)._currentRenderer2 && (0, $8jwd7.Context)._currentValue2 || // grab value from default renderer
    (0, $8jwd7.Context)._currentValue || (0, $8JXjO.globalDi);
    return getDependencies(deps, target);
}

});
parcelRegister("8jwd7", function(module, exports) {
$parcel$export(module.exports, "Context", () => $60d9157248e3722c$export$841858b892ce1f4c);

var $euxye = parcelRequire("euxye");

var $8JXjO = parcelRequire("8JXjO");
const $60d9157248e3722c$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createContext({
    getDependencies: (0, $8JXjO.globalDi).getDependencies
});

});
parcelRegister("euxye", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4xMpk"));

});
parcelRegister("4xMpk", function(module, exports) {
$parcel$export(module.exports, "Children", () => $34efcb3c56759942$export$dca3b0875bd9a954, (v) => $34efcb3c56759942$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $34efcb3c56759942$export$16fa2f45be04daa8, (v) => $34efcb3c56759942$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $34efcb3c56759942$export$ffb0004e005737fa, (v) => $34efcb3c56759942$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $34efcb3c56759942$export$e2c29f18771995cb, (v) => $34efcb3c56759942$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $34efcb3c56759942$export$221d75b3f55bb0bd, (v) => $34efcb3c56759942$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $34efcb3c56759942$export$5f8d39834fd61797, (v) => $34efcb3c56759942$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $34efcb3c56759942$export$74bf444e3cd11ea5, (v) => $34efcb3c56759942$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $34efcb3c56759942$export$ae55be85d98224ed, (v) => $34efcb3c56759942$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "act", () => $34efcb3c56759942$export$3ba232387fd5d6dd, (v) => $34efcb3c56759942$export$3ba232387fd5d6dd = v);
$parcel$export(module.exports, "cloneElement", () => $34efcb3c56759942$export$e530037191fcd5d7, (v) => $34efcb3c56759942$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $34efcb3c56759942$export$fd42f52fd3ae1109, (v) => $34efcb3c56759942$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $34efcb3c56759942$export$c8a8987d4410bf2d, (v) => $34efcb3c56759942$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $34efcb3c56759942$export$d38cd72104c1f0e9, (v) => $34efcb3c56759942$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $34efcb3c56759942$export$7d1e3a5e95ceca43, (v) => $34efcb3c56759942$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $34efcb3c56759942$export$257a8862b851cb5b, (v) => $34efcb3c56759942$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $34efcb3c56759942$export$a8257692ac88316c, (v) => $34efcb3c56759942$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $34efcb3c56759942$export$488013bae63b21da, (v) => $34efcb3c56759942$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $34efcb3c56759942$export$7c73462e0d25e514, (v) => $34efcb3c56759942$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $34efcb3c56759942$export$7568632d0d33d16d, (v) => $34efcb3c56759942$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $34efcb3c56759942$export$88948ce120ea2619, (v) => $34efcb3c56759942$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $34efcb3c56759942$export$35808ee640e87ca7, (v) => $34efcb3c56759942$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $34efcb3c56759942$export$fae74005e78b1a27, (v) => $34efcb3c56759942$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $34efcb3c56759942$export$dc8fbce3eb94dc1e, (v) => $34efcb3c56759942$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $34efcb3c56759942$export$6a7bc4e911dc01cf, (v) => $34efcb3c56759942$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $34efcb3c56759942$export$6d9c69b0de29b591, (v) => $34efcb3c56759942$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $34efcb3c56759942$export$f680877a34711e37, (v) => $34efcb3c56759942$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $34efcb3c56759942$export$d5a552a76deda3c2, (v) => $34efcb3c56759942$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $34efcb3c56759942$export$aaabe4eda9ed9969, (v) => $34efcb3c56759942$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $34efcb3c56759942$export$e5c5a5f917a5871c, (v) => $34efcb3c56759942$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $34efcb3c56759942$export$1538c33de8887b59, (v) => $34efcb3c56759942$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $34efcb3c56759942$export$13e3392192263954, (v) => $34efcb3c56759942$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $34efcb3c56759942$export$b8f5890fc79d6aca, (v) => $34efcb3c56759942$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $34efcb3c56759942$export$60241385465d0a34, (v) => $34efcb3c56759942$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $34efcb3c56759942$export$306c0aa65ff9ec16, (v) => $34efcb3c56759942$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $34efcb3c56759942$export$7b286972b8d8ccbf, (v) => $34efcb3c56759942$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $34efcb3c56759942$export$83d89fbfd8236492, (v) => $34efcb3c56759942$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $34efcb3c56759942$export$dca3b0875bd9a954;
var $34efcb3c56759942$export$16fa2f45be04daa8;
var $34efcb3c56759942$export$ffb0004e005737fa;
var $34efcb3c56759942$export$e2c29f18771995cb;
var $34efcb3c56759942$export$221d75b3f55bb0bd;
var $34efcb3c56759942$export$5f8d39834fd61797;
var $34efcb3c56759942$export$74bf444e3cd11ea5;
var $34efcb3c56759942$export$ae55be85d98224ed;
var $34efcb3c56759942$export$3ba232387fd5d6dd;
var $34efcb3c56759942$export$e530037191fcd5d7;
var $34efcb3c56759942$export$fd42f52fd3ae1109;
var $34efcb3c56759942$export$c8a8987d4410bf2d;
var $34efcb3c56759942$export$d38cd72104c1f0e9;
var $34efcb3c56759942$export$7d1e3a5e95ceca43;
var $34efcb3c56759942$export$257a8862b851cb5b;
var $34efcb3c56759942$export$a8257692ac88316c;
var $34efcb3c56759942$export$488013bae63b21da;
var $34efcb3c56759942$export$7c73462e0d25e514;
var $34efcb3c56759942$export$7568632d0d33d16d;
var $34efcb3c56759942$export$88948ce120ea2619;
var $34efcb3c56759942$export$35808ee640e87ca7;
var $34efcb3c56759942$export$fae74005e78b1a27;
var $34efcb3c56759942$export$dc8fbce3eb94dc1e;
var $34efcb3c56759942$export$6a7bc4e911dc01cf;
var $34efcb3c56759942$export$6d9c69b0de29b591;
var $34efcb3c56759942$export$f680877a34711e37;
var $34efcb3c56759942$export$d5a552a76deda3c2;
var $34efcb3c56759942$export$aaabe4eda9ed9969;
var $34efcb3c56759942$export$e5c5a5f917a5871c;
var $34efcb3c56759942$export$1538c33de8887b59;
var $34efcb3c56759942$export$13e3392192263954;
var $34efcb3c56759942$export$b8f5890fc79d6aca;
var $34efcb3c56759942$export$60241385465d0a34;
var $34efcb3c56759942$export$306c0aa65ff9ec16;
var $34efcb3c56759942$export$7b286972b8d8ccbf;
var $34efcb3c56759942$export$83d89fbfd8236492;
'use strict';
var $34efcb3c56759942$var$l = Symbol.for("react.element"), $34efcb3c56759942$var$n = Symbol.for("react.portal"), $34efcb3c56759942$var$p = Symbol.for("react.fragment"), $34efcb3c56759942$var$q = Symbol.for("react.strict_mode"), $34efcb3c56759942$var$r = Symbol.for("react.profiler"), $34efcb3c56759942$var$t = Symbol.for("react.provider"), $34efcb3c56759942$var$u = Symbol.for("react.context"), $34efcb3c56759942$var$v = Symbol.for("react.forward_ref"), $34efcb3c56759942$var$w = Symbol.for("react.suspense"), $34efcb3c56759942$var$x = Symbol.for("react.memo"), $34efcb3c56759942$var$y = Symbol.for("react.lazy"), $34efcb3c56759942$var$z = Symbol.iterator;
function $34efcb3c56759942$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $34efcb3c56759942$var$z && a[$34efcb3c56759942$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $34efcb3c56759942$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $34efcb3c56759942$var$C = Object.assign, $34efcb3c56759942$var$D = {};
function $34efcb3c56759942$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $34efcb3c56759942$var$D;
    this.updater = e || $34efcb3c56759942$var$B;
}
$34efcb3c56759942$var$E.prototype.isReactComponent = {};
$34efcb3c56759942$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$34efcb3c56759942$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $34efcb3c56759942$var$F() {}
$34efcb3c56759942$var$F.prototype = $34efcb3c56759942$var$E.prototype;
function $34efcb3c56759942$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $34efcb3c56759942$var$D;
    this.updater = e || $34efcb3c56759942$var$B;
}
var $34efcb3c56759942$var$H = $34efcb3c56759942$var$G.prototype = new $34efcb3c56759942$var$F;
$34efcb3c56759942$var$H.constructor = $34efcb3c56759942$var$G;
$34efcb3c56759942$var$C($34efcb3c56759942$var$H, $34efcb3c56759942$var$E.prototype);
$34efcb3c56759942$var$H.isPureReactComponent = !0;
var $34efcb3c56759942$var$I = Array.isArray, $34efcb3c56759942$var$J = Object.prototype.hasOwnProperty, $34efcb3c56759942$var$K = {
    current: null
}, $34efcb3c56759942$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $34efcb3c56759942$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$34efcb3c56759942$var$J.call(b, d) && !$34efcb3c56759942$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $34efcb3c56759942$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $34efcb3c56759942$var$K.current
    };
}
function $34efcb3c56759942$var$N(a, b) {
    return {
        $$typeof: $34efcb3c56759942$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $34efcb3c56759942$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $34efcb3c56759942$var$l;
}
function $34efcb3c56759942$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $34efcb3c56759942$var$P = /\/+/g;
function $34efcb3c56759942$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $34efcb3c56759942$var$escape("" + a.key) : b.toString(36);
}
function $34efcb3c56759942$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $34efcb3c56759942$var$l:
                case $34efcb3c56759942$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $34efcb3c56759942$var$Q(h, 0) : d, $34efcb3c56759942$var$I(c) ? (e = "", null != a && (e = a.replace($34efcb3c56759942$var$P, "$&/") + "/"), $34efcb3c56759942$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($34efcb3c56759942$var$O(c) && (c = $34efcb3c56759942$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($34efcb3c56759942$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($34efcb3c56759942$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $34efcb3c56759942$var$Q(k, g);
        h += $34efcb3c56759942$var$R(k, b, e, f, c);
    }
    else if (f = $34efcb3c56759942$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $34efcb3c56759942$var$Q(k, g++), h += $34efcb3c56759942$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $34efcb3c56759942$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $34efcb3c56759942$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $34efcb3c56759942$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $34efcb3c56759942$var$U = {
    current: null
}, $34efcb3c56759942$var$V = {
    transition: null
}, $34efcb3c56759942$var$W = {
    ReactCurrentDispatcher: $34efcb3c56759942$var$U,
    ReactCurrentBatchConfig: $34efcb3c56759942$var$V,
    ReactCurrentOwner: $34efcb3c56759942$var$K
};
function $34efcb3c56759942$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$34efcb3c56759942$export$dca3b0875bd9a954 = {
    map: $34efcb3c56759942$var$S,
    forEach: function(a, b, e) {
        $34efcb3c56759942$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $34efcb3c56759942$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $34efcb3c56759942$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$34efcb3c56759942$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$34efcb3c56759942$export$16fa2f45be04daa8 = $34efcb3c56759942$var$E;
$34efcb3c56759942$export$ffb0004e005737fa = $34efcb3c56759942$var$p;
$34efcb3c56759942$export$e2c29f18771995cb = $34efcb3c56759942$var$r;
$34efcb3c56759942$export$221d75b3f55bb0bd = $34efcb3c56759942$var$G;
$34efcb3c56759942$export$5f8d39834fd61797 = $34efcb3c56759942$var$q;
$34efcb3c56759942$export$74bf444e3cd11ea5 = $34efcb3c56759942$var$w;
$34efcb3c56759942$export$ae55be85d98224ed = $34efcb3c56759942$var$W;
$34efcb3c56759942$export$3ba232387fd5d6dd = $34efcb3c56759942$var$X;
$34efcb3c56759942$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $34efcb3c56759942$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $34efcb3c56759942$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$34efcb3c56759942$var$J.call(b, f) && !$34efcb3c56759942$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $34efcb3c56759942$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$34efcb3c56759942$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $34efcb3c56759942$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $34efcb3c56759942$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$34efcb3c56759942$export$c8a8987d4410bf2d = $34efcb3c56759942$var$M;
$34efcb3c56759942$export$d38cd72104c1f0e9 = function(a) {
    var b = $34efcb3c56759942$var$M.bind(null, a);
    b.type = a;
    return b;
};
$34efcb3c56759942$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$34efcb3c56759942$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $34efcb3c56759942$var$v,
        render: a
    };
};
$34efcb3c56759942$export$a8257692ac88316c = $34efcb3c56759942$var$O;
$34efcb3c56759942$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $34efcb3c56759942$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $34efcb3c56759942$var$T
    };
};
$34efcb3c56759942$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $34efcb3c56759942$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$34efcb3c56759942$export$7568632d0d33d16d = function(a) {
    var b = $34efcb3c56759942$var$V.transition;
    $34efcb3c56759942$var$V.transition = {};
    try {
        a();
    } finally{
        $34efcb3c56759942$var$V.transition = b;
    }
};
$34efcb3c56759942$export$88948ce120ea2619 = $34efcb3c56759942$var$X;
$34efcb3c56759942$export$35808ee640e87ca7 = function(a, b) {
    return $34efcb3c56759942$var$U.current.useCallback(a, b);
};
$34efcb3c56759942$export$fae74005e78b1a27 = function(a) {
    return $34efcb3c56759942$var$U.current.useContext(a);
};
$34efcb3c56759942$export$dc8fbce3eb94dc1e = function() {};
$34efcb3c56759942$export$6a7bc4e911dc01cf = function(a) {
    return $34efcb3c56759942$var$U.current.useDeferredValue(a);
};
$34efcb3c56759942$export$6d9c69b0de29b591 = function(a, b) {
    return $34efcb3c56759942$var$U.current.useEffect(a, b);
};
$34efcb3c56759942$export$f680877a34711e37 = function() {
    return $34efcb3c56759942$var$U.current.useId();
};
$34efcb3c56759942$export$d5a552a76deda3c2 = function(a, b, e) {
    return $34efcb3c56759942$var$U.current.useImperativeHandle(a, b, e);
};
$34efcb3c56759942$export$aaabe4eda9ed9969 = function(a, b) {
    return $34efcb3c56759942$var$U.current.useInsertionEffect(a, b);
};
$34efcb3c56759942$export$e5c5a5f917a5871c = function(a, b) {
    return $34efcb3c56759942$var$U.current.useLayoutEffect(a, b);
};
$34efcb3c56759942$export$1538c33de8887b59 = function(a, b) {
    return $34efcb3c56759942$var$U.current.useMemo(a, b);
};
$34efcb3c56759942$export$13e3392192263954 = function(a, b, e) {
    return $34efcb3c56759942$var$U.current.useReducer(a, b, e);
};
$34efcb3c56759942$export$b8f5890fc79d6aca = function(a) {
    return $34efcb3c56759942$var$U.current.useRef(a);
};
$34efcb3c56759942$export$60241385465d0a34 = function(a) {
    return $34efcb3c56759942$var$U.current.useState(a);
};
$34efcb3c56759942$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $34efcb3c56759942$var$U.current.useSyncExternalStore(a, b, e);
};
$34efcb3c56759942$export$7b286972b8d8ccbf = function() {
    return $34efcb3c56759942$var$U.current.useTransition();
};
$34efcb3c56759942$export$83d89fbfd8236492 = "18.3.1";

});


parcelRegister("8JXjO", function(module, exports) {
$parcel$export(module.exports, "globalDi", () => $65d08a230e2fc806$export$a775919ebd7dd28a);

var $yqQZ8 = parcelRequire("yqQZ8");

var $j9zyD = parcelRequire("j9zyD");
const $65d08a230e2fc806$var$replacementMap = new Map();
const $65d08a230e2fc806$export$a775919ebd7dd28a = {
    getDependencies (realDeps, targetChild) {
        if ($65d08a230e2fc806$var$replacementMap.size) for(let i = 0; i < realDeps.length; i++){
            const replacedInj = (0, $j9zyD.findInjectable)($65d08a230e2fc806$var$replacementMap, realDeps[i], targetChild);
            if (replacedInj) realDeps[i] = replacedInj.value;
        }
        return realDeps;
    },
    use (injs) {
        if ($65d08a230e2fc806$var$replacementMap.size) throw new Error(`${(0, $yqQZ8.PACKAGE_NAME)} has replacements configured already. ` + `Implicit merging is not supported, so please concatenate injectables. ` + `If this is not expected, please file a bug report`);
        injs.forEach((inj)=>(0, $j9zyD.addInjectableToMap)($65d08a230e2fc806$var$replacementMap, inj));
    },
    clear () {
        $65d08a230e2fc806$var$replacementMap.clear();
    },
    _fromProvider (injs, props = {}) {
        injs.forEach((inj)=>{
            if (props.global || (0, $yqQZ8.diRegistry).get(inj).global) (0, $j9zyD.addInjectableToMap)($65d08a230e2fc806$var$replacementMap, inj);
        });
    },
    _remove (injs) {
        injs.forEach((inj)=>(0, $j9zyD.removeInjectableFromMap)($65d08a230e2fc806$var$replacementMap, inj));
    }
};
function $65d08a230e2fc806$export$b887ce09d70113f9(thunk, deps) {
    $65d08a230e2fc806$export$a775919ebd7dd28a.use(deps);
    let result;
    try {
        result = thunk();
        return result;
    } finally{
        // autocleanup dependences if either async or sync
        if (result && typeof result === 'object' && typeof result.then === 'function') // dont use finally as it "multiplies" rejected promises
        result.then($65d08a230e2fc806$export$a775919ebd7dd28a.clear, $65d08a230e2fc806$export$a775919ebd7dd28a.clear);
        else $65d08a230e2fc806$export$a775919ebd7dd28a.clear();
    }
}

});
parcelRegister("yqQZ8", function(module, exports) {
$parcel$export(module.exports, "diRegistry", () => $067801a7edff7510$export$4203fb010fad9bf0);
$parcel$export(module.exports, "PACKAGE_NAME", () => $067801a7edff7510$export$b8b9d90f9e5bd72b);
const $067801a7edff7510$export$4203fb010fad9bf0 = new WeakMap();
const $067801a7edff7510$export$b8b9d90f9e5bd72b = 'react-magnetic-di';

});

parcelRegister("j9zyD", function(module, exports) {
$parcel$export(module.exports, "addInjectableToMap", () => $df1a709286812cdb$export$7a7134bdd2f9ae2e);
$parcel$export(module.exports, "removeInjectableFromMap", () => $df1a709286812cdb$export$8057a2244a849b7b);
$parcel$export(module.exports, "getDisplayName", () => $df1a709286812cdb$export$be63e0664592e141);
$parcel$export(module.exports, "findInjectable", () => $df1a709286812cdb$export$7c436e151c3ee289);

var $yqQZ8 = parcelRequire("yqQZ8");

var $b30Rh = parcelRequire("b30Rh");
let $df1a709286812cdb$var$hasWarned = false;
function $df1a709286812cdb$export$5b28268982f175ba(message) {
    if (!$df1a709286812cdb$var$hasWarned) {
        // eslint-disable-next-line no-console
        console.warn('Warning:', message);
        $df1a709286812cdb$var$hasWarned = true;
    }
}
function $df1a709286812cdb$export$7a7134bdd2f9ae2e(replacementMap, inj) {
    const injObj = (0, $yqQZ8.diRegistry).get(inj);
    if (!injObj) throw new Error(`Seems like you are trying to use "${inj}" as injectable, but magnetic-di needs the return value of "injectable()"`);
    if (injObj.track) (0, $b30Rh.stats).set(injObj);
    if (replacementMap.has(injObj.from)) replacementMap.get(injObj.from).add(injObj);
    else replacementMap.set(injObj.from, new Set([
        injObj
    ]));
    return replacementMap;
}
function $df1a709286812cdb$export$8057a2244a849b7b(replacementMap, inj) {
    const injObj = (0, $yqQZ8.diRegistry).get(inj);
    const injectables = replacementMap.get(injObj.from) || new Set();
    if (injectables.size === 1) replacementMap.delete(injObj.from);
    else injectables.delete(injObj);
}
function $df1a709286812cdb$export$be63e0664592e141(Comp, wrapper = '') {
    const name = Comp.displayName || Comp.name;
    return !name || !wrapper ? name : `${wrapper}(${name})`;
}
function $df1a709286812cdb$export$1c9f709888824e05(fn) {
    const source = fn.toString();
    const [, args] = source.match(/const \[[^\]]+\] = .*di.*\(\w+[,\s]+([^)]+)/) || [];
    return args;
}
function $df1a709286812cdb$export$7c436e151c3ee289(replacementMap, dep, targetChild) {
    const injectables = replacementMap.get(dep);
    if (!injectables) return null;
    // loop all injectables for the dep, with targeted ones preferred
    let anyCandidate = null;
    let targetCandidate = null;
    for (const inj of injectables){
        var _inj$targets;
        if (!inj.targets) anyCandidate = inj;
        if ((_inj$targets = inj.targets) != null && _inj$targets.has(targetChild)) targetCandidate = inj;
    }
    const candidate = targetCandidate || anyCandidate;
    (0, $b30Rh.stats).track(candidate);
    return candidate;
}

});
parcelRegister("b30Rh", function(module, exports) {
$parcel$export(module.exports, "stats", () => $80b0a3f6b107ee5a$export$7804429c45dff272);
const $80b0a3f6b107ee5a$var$createState = ()=>({
        unused: new Map(),
        used: new Set(),
        provided: new Set()
    });
const $80b0a3f6b107ee5a$export$7804429c45dff272 = {
    state: $80b0a3f6b107ee5a$var$createState(),
    set (inj) {
        var _inj$value;
        // allow injectable override without flagging as unused
        for (let unusedInj of this.state.unused.keys())if (unusedInj.from === inj.from) this.state.unused.delete(unusedInj);
        this.state.unused.set(inj, new Error(`Unused "di" injectable: ${((_inj$value = inj.value) == null ? void 0 : _inj$value.displayName) || inj.value}.`, {
            cause: inj.cause
        }));
    },
    track (inj) {
        if (!inj) return;
        this.state.unused.delete(inj);
        this.state.used.add(inj);
        this.state.provided.add(inj.from);
        // reset to avoid potential memory leaks via stack traces
        inj.cause = null;
    },
    reset () {
        this.state = $80b0a3f6b107ee5a$var$createState();
    },
    unused () {
        return Array.from(this.state.unused.entries()).map(([inj, error])=>({
                get: ()=>inj.value,
                error: ()=>error
            }));
    }
};

});





parcelRegister("hz0Ap", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $c15eedef7f059b27$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "initAnalyticsWebClient", () => $c15eedef7f059b27$export$bb0df2ec3a6c8120);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // code-reaper-ignore-file -- Uses different implementations for client and server.

var $7gDzF = parcelRequire("7gDzF");

var $bkT7m = parcelRequire("bkT7m");
const $c15eedef7f059b27$export$e9ba7ef9458d1a4a = (attrs)=>{
    return false ? (0, $7gDzF.getAnalyticsWebClient)(attrs) : (0, $bkT7m.getAnalyticsWebClient)();
};
const $c15eedef7f059b27$export$bb0df2ec3a6c8120 = (attrs)=>{
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return false ? (0, $7gDzF.initAnalyticsWebClient)(attrs) : (0, $bkT7m.initAnalyticsWebClient)(attrs);
};

});
parcelRegister("7gDzF", function(module, exports) {
$parcel$export(module.exports, "getAnalyticsWebClient", () => $e50deaa296ca057c$export$e9ba7ef9458d1a4a);
$parcel$export(module.exports, "initAnalyticsWebClient", () => $e50deaa296ca057c$export$bb0df2ec3a6c8120);
/* eslint-disable jira/filename-case */ const $e50deaa296ca057c$var$mockAnalyticsClient = {
    init: (_attrs)=>false,
    sendEvent: (_event)=>undefined,
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    getInstance: ()=>$e50deaa296ca057c$var$mockAnalyticsClient,
    setSubProduct: (_subproduct)=>undefined,
    setEmbeddedProduct: (_embeddedProduct)=>undefined,
    clearEmbeddedProduct: ()=>undefined,
    stopApdexEvent: ()=>undefined,
    setOriginTracingHandlers: (_originParamHandlerMapping)=>undefined,
    setUIViewedAttributes: (_attributes)=>undefined,
    removeUIViewedAttribute: (_key)=>undefined,
    clearUIViewedAttributes: ()=>undefined,
    isInitialized: ()=>false,
    setUpdateAmplitudeSRClient: ()=>undefined,
    setAmplitudeSRAttributesInjector: ()=>undefined
};
const $e50deaa296ca057c$export$e9ba7ef9458d1a4a = (_attrs)=>$e50deaa296ca057c$var$mockAnalyticsClient;
const $e50deaa296ca057c$export$bb0df2ec3a6c8120 = (_attrs)=>Promise.resolve($e50deaa296ca057c$var$mockAnalyticsClient);

});

parcelRegister("bkT7m", function(module, exports) {
$parcel$export(module.exports, "initAnalyticsWebClient", () => $47bb1dd89d485451$export$bb0df2ec3a6c8120);
$parcel$export(module.exports, "getAnalyticsWebClient", () => $47bb1dd89d485451$export$e9ba7ef9458d1a4a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $3zT69 = parcelRequire("3zT69");

var $6Kdw4 = parcelRequire("6Kdw4");

var $iFM3u = parcelRequire("iFM3u");

var $3SYiP = parcelRequire("3SYiP");
const $47bb1dd89d485451$export$bb0df2ec3a6c8120 = (attrs)=>{
    let internalClientInitialised;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.analyticsWebClient) try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient = false ? (0, $3SYiP.default) : new (0, $iFM3u.default)();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        internalClientInitialised = window.analyticsWebClient.init(attrs);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.analyticsWebClient.setOriginTracingHandlers({
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-expect-error
            atlOrigin: (encodedOrigin)=>{
                const origin = (0, $3zT69.default).fromEncoded(encodedOrigin);
                const attributes = origin.toAnalyticsAttributes();
                return {
                    originTracingAttributes: {
                        id: 'originId' in attributes ? attributes.originId : undefined,
                        product: 'originProduct' in attributes ? attributes.originProduct : undefined,
                        library: attributes.originLibrary
                    },
                    taskSessionId: origin.id ?? undefined
                };
            }
        });
    } catch (err) {
        if (typeof window !== 'undefined') window.reportError(new Error('Failed to initialize analytics client', {
            cause: err
        }));
    }
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    internalClientInitialised = !!window.analyticsWebClient.getInstance();
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion, jira/jira-ssr/no-unchecked-globals-usage
    (0, $6Kdw4.resolveAnalyticsWebClientPromise)(window.analyticsWebClient);
    return internalClientInitialised;
};
const $47bb1dd89d485451$export$e9ba7ef9458d1a4a = ()=>window.analyticsWebClient;

});
parcelRegister("iFM3u", function(module, exports) {
$parcel$export(module.exports, "default", () => $ac1bb8229acccf57$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $fcq2N = parcelRequire("fcq2N");

var $dwKyh = parcelRequire("dwKyh");
var $gL9hl = parcelRequire("gL9hl");
var $hIipg = parcelRequire("hIipg");

var $dJ3NQ = parcelRequire("dJ3NQ");

var $7Il9x = parcelRequire("7Il9x");

var $9Ndfs = parcelRequire("9Ndfs");


var $jUQs3 = parcelRequire("jUQs3");
class $ac1bb8229acccf57$export$2e2bcd8739ae039 {
    resetBlockingDuration() {
        this.eventCount = 0;
        this.blockingDuration = 0;
    }
    init({ tenantId: tenantId, userId: userId, subProduct: subProduct, embeddedProduct: embeddedProduct, product: product, environment: environment, locale: locale, callback: callback, shouldTriggerUIViewed: shouldTriggerUIViewed = true, solutions: solutions, theme: theme, orgId: orgId, workspaceId: workspaceId }) {
        const start = performance.now();
        this.analyticsClient = new (0, $gL9hl.default)({
            env: environment || (0, $hIipg.envType).DEV,
            product: product,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            version: window.BUILD_KEY || 'unknown',
            origin: (0, $hIipg.originType).WEB,
            locale: locale
        }, {
            useStargate: true,
            delayQueueCompressors: [
                new (0, $dwKyh.CompressionRule)((0, $9Ndfs.canCompress), (0, $9Ndfs.buildCompressionFunction)(50))
            ],
            ...(0, $dJ3NQ.default)() ? {
                apiHostProtocol: (0, $7Il9x.default)() ? 'https' : 'http'
            } : {},
            onNewSessionStarted: this.onNewSessionStarted
        });
        if (!this.analyticsClient) return false;
        if (tenantId) this.analyticsClient.setTenantInfo((0, $hIipg.tenantType).CLOUD_ID, tenantId);
        if (userId) this.analyticsClient.setUserInfo((0, $hIipg.userType).ATLASSIAN_ACCOUNT, userId);
        if (subProduct) this.analyticsClient.setSubproduct(subProduct);
        if (orgId) this.analyticsClient.setOrgInfo(orgId);
        if (workspaceId) this.analyticsClient.setWorkspaceInfo(workspaceId);
        this.clearUIViewedAttributes();
        if (solutions || theme) {
            const OStheme = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
            this.setUIViewedAttributes({
                ...solutions && {
                    solutions: solutions
                },
                ...theme && {
                    theme: theme,
                    OStheme: OStheme
                }
            });
        }
        if (embeddedProduct) this.analyticsClient.setEmbeddedProduct(embeddedProduct);
        if (shouldTriggerUIViewed) {
            const callbackFn = typeof callback === 'function' ? callback : (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)));
            this.analyticsClient.startUIViewedEvent(callbackFn);
        }
        // Set init time
        this.initTime = performance.now() - start;
        return true;
    }
    sendEvent(event) {
        if ((0, $jUQs3.isAnalyticsEvent)(event)) {
            const { type: type, payload: payload } = event;
            const start = performance.now();
            if (this.amplitudeSRAttributesInjector) this.amplitudeSRAttributesInjector(payload);
            switch(type){
                case 0, $46f069e6c968f461$export$a1562d08625f5d7e:
                    this.analyticsClient.sendUIEvent(payload);
                    break;
                case 0, $46f069e6c968f461$export$947dac6c72b26f81:
                    this.analyticsClient.sendTrackEvent(payload);
                    break;
                case 0, $46f069e6c968f461$export$12346a674644c156:
                    this.analyticsClient.sendOperationalEvent(payload);
                    break;
                case 0, $46f069e6c968f461$export$f1d537d508d2945a:
                    this.analyticsClient.sendScreenEvent(payload);
                    break;
                default:
                    break;
            }
            // Increment the blocking duration
            this.blockingDuration += performance.now() - start;
            this.eventCount += 1;
        }
    }
    isInitialized() {
        return this.analyticsClient && this.initTime > 0;
    }
    getInstance() {
        return this.analyticsClient;
    }
    setSubProduct(subProduct) {
        this.analyticsClient.setSubproduct(subProduct);
    }
    setUIViewedAttributes(attributes) {
        this.analyticsClient.setUIViewedAttributes({
            ...this.analyticsClient.getUIViewedAttributes(),
            ...attributes
        });
    }
    setEmbeddedProduct(embeddedProduct) {
        this.analyticsClient.setEmbeddedProduct(embeddedProduct);
    }
    removeUIViewedAttribute(key) {
        const { [key]: value, ...rest } = this.analyticsClient.getUIViewedAttributes();
        this.analyticsClient.setUIViewedAttributes({
            ...rest
        });
    }
    clearUIViewedAttributes() {
        this.analyticsClient.clearUIViewedAttributes();
    }
    clearEmbeddedProduct() {
        this.analyticsClient.clearEmbeddedProduct();
    }
    stopApdexEvent(payload) {
        this.analyticsClient.stopApdexEvent(payload);
    }
    setOriginTracingHandlers(originTracingHandlerMapping) {
        this.analyticsClient.setOriginTracingHandlers(originTracingHandlerMapping);
    }
    onNewSessionStarted() {
        this.updateAmplitudeSRClient && this.updateAmplitudeSRClient();
    }
    setUpdateAmplitudeSRClient(callbackFn) {
        this.updateAmplitudeSRClient = callbackFn;
    }
    setAmplitudeSRAttributesInjector(callbackFn) {
        this.amplitudeSRAttributesInjector = callbackFn;
    }
}
$ac1bb8229acccf57$export$2e2bcd8739ae039.displayName = "DefaultAnalyticsWebClient";

});
parcelRegister("7Il9x", function(module, exports) {
$parcel$export(module.exports, "default", () => $56b54569f620ed52$export$2e2bcd8739ae039);
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore - process.env types are cursed
const $56b54569f620ed52$var$pillarEnableHttpsEnv = false;
function $56b54569f620ed52$export$2e2bcd8739ae039() {
    return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    globalThis.localDevContext?.__PILLAR_ENABLE_HTTPS ?? $56b54569f620ed52$var$pillarEnableHttpsEnv);
}

});

/* eslint-disable jira/filename-case */ // SCREENS
const $46f069e6c968f461$export$f636b5b56f1d624a = 'Screen';
const $46f069e6c968f461$export$9d2de6eebf7462b5 = 'Drawer';
const $46f069e6c968f461$export$1171103ea9083ffa = 'Modal';
const $46f069e6c968f461$export$cae2783c9279926 = 'InlineDialog';
const $46f069e6c968f461$export$d1123261ca8831d2 = 'Dropdown';
const $46f069e6c968f461$export$238d30785c4bca84 = 'Banner';
const $46f069e6c968f461$export$a1562d08625f5d7e = 'UI';
const $46f069e6c968f461$export$947dac6c72b26f81 = 'TRACK';
const $46f069e6c968f461$export$f1d537d508d2945a = 'SCREEN';
const $46f069e6c968f461$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("jUQs3", function(module, exports) {
$parcel$export(module.exports, "isAnalyticsEvent", () => $66d774f6edeab367$export$ad4be5c2ec28cecf);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $66d774f6edeab367$export$2bace62c90203a60 = [
    'SCREEN',
    'UI',
    'TRACK',
    'OPERATIONAL'
];
const $66d774f6edeab367$export$ad4be5c2ec28cecf = (value)=>typeof value === 'object' && value !== null && 'type' in value && typeof value.type === 'string' && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $66d774f6edeab367$export$2bace62c90203a60.includes(value.type);

});


parcelRegister("3SYiP", function(module, exports) {
$parcel$export(module.exports, "default", () => $34c5681c4d872932$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $fcq2N = parcelRequire("fcq2N");
const $34c5681c4d872932$var$SSRAnalyticsWebClient = {
    initTime: 0,
    eventCount: 0,
    blockingDuration: 0,
    amplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    updateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    resetBlockingDuration: ()=>undefined,
    init: (attrs)=>!!attrs,
    sendEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    // @ts-expect-error - TS2741 - Property 'prototype' is missing in type '{}' but required in type 'AnalyticsWebClient'.
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    getInstance: ()=>new Proxy({}, {
            get: ()=>()=>{}
        }),
    setSubProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    removeUIViewedAttribute: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    clearUIViewedAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    clearEmbeddedProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    stopApdexEvent: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setOriginTracingHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    onNewSessionStarted: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setUpdateAmplitudeSRClient: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    setAmplitudeSRAttributesInjector: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    isInitialized: ()=>false
};
var $34c5681c4d872932$export$2e2bcd8739ae039 = $34c5681c4d872932$var$SSRAnalyticsWebClient;

});



parcelRegister("3oBOI", function(module, exports) {
$parcel$export(module.exports, "Buffer", () => $2790f2acd64f5946$export$a143d493d941bafc, (v) => $2790f2acd64f5946$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $2790f2acd64f5946$export$e4cf37d7f6fb9e0a, (v) => $2790f2acd64f5946$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $2790f2acd64f5946$export$f99ded8fe4b79145, (v) => $2790f2acd64f5946$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $2790f2acd64f5946$export$599f31c3813fae4d, (v) => $2790f2acd64f5946$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $2790f2acd64f5946$export$a143d493d941bafc;
var $2790f2acd64f5946$export$e4cf37d7f6fb9e0a;
var $2790f2acd64f5946$export$f99ded8fe4b79145;
var $2790f2acd64f5946$export$599f31c3813fae4d;
'use strict';

var $7jj3Q = parcelRequire("7jj3Q");

var $ccxOZ = parcelRequire("ccxOZ");
const $2790f2acd64f5946$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$2790f2acd64f5946$export$a143d493d941bafc = $2790f2acd64f5946$var$Buffer;
$2790f2acd64f5946$export$e4cf37d7f6fb9e0a = $2790f2acd64f5946$var$SlowBuffer;
$2790f2acd64f5946$export$f99ded8fe4b79145 = 50;
const $2790f2acd64f5946$var$K_MAX_LENGTH = 0x7fffffff;
$2790f2acd64f5946$export$599f31c3813fae4d = $2790f2acd64f5946$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $2790f2acd64f5946$var$Buffer.TYPED_ARRAY_SUPPORT = $2790f2acd64f5946$var$typedArraySupport();
if (!$2790f2acd64f5946$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $2790f2acd64f5946$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($2790f2acd64f5946$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$2790f2acd64f5946$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($2790f2acd64f5946$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$2790f2acd64f5946$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $2790f2acd64f5946$var$createBuffer(length) {
    if (length > $2790f2acd64f5946$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $2790f2acd64f5946$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $2790f2acd64f5946$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $2790f2acd64f5946$var$allocUnsafe(arg);
    }
    return $2790f2acd64f5946$var$from(arg, encodingOrOffset, length);
}
$2790f2acd64f5946$var$Buffer.poolSize = 8192; // not used by this implementation
function $2790f2acd64f5946$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $2790f2acd64f5946$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $2790f2acd64f5946$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($2790f2acd64f5946$var$isInstance(value, ArrayBuffer) || value && $2790f2acd64f5946$var$isInstance(value.buffer, ArrayBuffer)) return $2790f2acd64f5946$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($2790f2acd64f5946$var$isInstance(value, SharedArrayBuffer) || value && $2790f2acd64f5946$var$isInstance(value.buffer, SharedArrayBuffer))) return $2790f2acd64f5946$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $2790f2acd64f5946$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $2790f2acd64f5946$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $2790f2acd64f5946$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $2790f2acd64f5946$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $2790f2acd64f5946$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($2790f2acd64f5946$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($2790f2acd64f5946$var$Buffer, Uint8Array);
function $2790f2acd64f5946$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $2790f2acd64f5946$var$alloc(size, fill, encoding) {
    $2790f2acd64f5946$var$assertSize(size);
    if (size <= 0) return $2790f2acd64f5946$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $2790f2acd64f5946$var$createBuffer(size).fill(fill, encoding) : $2790f2acd64f5946$var$createBuffer(size).fill(fill);
    return $2790f2acd64f5946$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $2790f2acd64f5946$var$Buffer.alloc = function(size, fill, encoding) {
    return $2790f2acd64f5946$var$alloc(size, fill, encoding);
};
function $2790f2acd64f5946$var$allocUnsafe(size) {
    $2790f2acd64f5946$var$assertSize(size);
    return $2790f2acd64f5946$var$createBuffer(size < 0 ? 0 : $2790f2acd64f5946$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $2790f2acd64f5946$var$Buffer.allocUnsafe = function(size) {
    return $2790f2acd64f5946$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $2790f2acd64f5946$var$Buffer.allocUnsafeSlow = function(size) {
    return $2790f2acd64f5946$var$allocUnsafe(size);
};
function $2790f2acd64f5946$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$2790f2acd64f5946$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $2790f2acd64f5946$var$byteLength(string, encoding) | 0;
    let buf = $2790f2acd64f5946$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $2790f2acd64f5946$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $2790f2acd64f5946$var$checked(array.length) | 0;
    const buf = $2790f2acd64f5946$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $2790f2acd64f5946$var$fromArrayView(arrayView) {
    if ($2790f2acd64f5946$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $2790f2acd64f5946$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $2790f2acd64f5946$var$fromArrayLike(arrayView);
}
function $2790f2acd64f5946$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $2790f2acd64f5946$var$Buffer.prototype);
    return buf;
}
function $2790f2acd64f5946$var$fromObject(obj) {
    if ($2790f2acd64f5946$var$Buffer.isBuffer(obj)) {
        const len = $2790f2acd64f5946$var$checked(obj.length) | 0;
        const buf = $2790f2acd64f5946$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $2790f2acd64f5946$var$numberIsNaN(obj.length)) return $2790f2acd64f5946$var$createBuffer(0);
        return $2790f2acd64f5946$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $2790f2acd64f5946$var$fromArrayLike(obj.data);
}
function $2790f2acd64f5946$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $2790f2acd64f5946$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $2790f2acd64f5946$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $2790f2acd64f5946$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $2790f2acd64f5946$var$Buffer.alloc(+length);
}
$2790f2acd64f5946$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $2790f2acd64f5946$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$2790f2acd64f5946$var$Buffer.compare = function compare(a, b) {
    if ($2790f2acd64f5946$var$isInstance(a, Uint8Array)) a = $2790f2acd64f5946$var$Buffer.from(a, a.offset, a.byteLength);
    if ($2790f2acd64f5946$var$isInstance(b, Uint8Array)) b = $2790f2acd64f5946$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$2790f2acd64f5946$var$Buffer.isBuffer(a) || !$2790f2acd64f5946$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$2790f2acd64f5946$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$2790f2acd64f5946$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $2790f2acd64f5946$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $2790f2acd64f5946$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($2790f2acd64f5946$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$2790f2acd64f5946$var$Buffer.isBuffer(buf)) buf = $2790f2acd64f5946$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$2790f2acd64f5946$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $2790f2acd64f5946$var$byteLength(string, encoding) {
    if ($2790f2acd64f5946$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $2790f2acd64f5946$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $2790f2acd64f5946$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $2790f2acd64f5946$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $2790f2acd64f5946$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$2790f2acd64f5946$var$Buffer.byteLength = $2790f2acd64f5946$var$byteLength;
function $2790f2acd64f5946$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $2790f2acd64f5946$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $2790f2acd64f5946$var$utf8Slice(this, start, end);
        case 'ascii':
            return $2790f2acd64f5946$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $2790f2acd64f5946$var$latin1Slice(this, start, end);
        case 'base64':
            return $2790f2acd64f5946$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2790f2acd64f5946$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$2790f2acd64f5946$var$Buffer.prototype._isBuffer = true;
function $2790f2acd64f5946$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$2790f2acd64f5946$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$2790f2acd64f5946$var$swap(this, i, i + 1);
    return this;
};
$2790f2acd64f5946$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $2790f2acd64f5946$var$swap(this, i, i + 3);
        $2790f2acd64f5946$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$2790f2acd64f5946$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $2790f2acd64f5946$var$swap(this, i, i + 7);
        $2790f2acd64f5946$var$swap(this, i + 1, i + 6);
        $2790f2acd64f5946$var$swap(this, i + 2, i + 5);
        $2790f2acd64f5946$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$2790f2acd64f5946$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $2790f2acd64f5946$var$utf8Slice(this, 0, length);
    return $2790f2acd64f5946$var$slowToString.apply(this, arguments);
};
$2790f2acd64f5946$var$Buffer.prototype.toLocaleString = $2790f2acd64f5946$var$Buffer.prototype.toString;
$2790f2acd64f5946$var$Buffer.prototype.equals = function equals(b) {
    if (!$2790f2acd64f5946$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $2790f2acd64f5946$var$Buffer.compare(this, b) === 0;
};
$2790f2acd64f5946$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $2790f2acd64f5946$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($2790f2acd64f5946$var$customInspectSymbol) $2790f2acd64f5946$var$Buffer.prototype[$2790f2acd64f5946$var$customInspectSymbol] = $2790f2acd64f5946$var$Buffer.prototype.inspect;
$2790f2acd64f5946$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($2790f2acd64f5946$var$isInstance(target, Uint8Array)) target = $2790f2acd64f5946$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$2790f2acd64f5946$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $2790f2acd64f5946$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset; // Coerce to Number.
    if ($2790f2acd64f5946$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $2790f2acd64f5946$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($2790f2acd64f5946$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $2790f2acd64f5946$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF; // Search for a byte value [0-255]
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $2790f2acd64f5946$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $2790f2acd64f5946$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$2790f2acd64f5946$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$2790f2acd64f5946$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $2790f2acd64f5946$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$2790f2acd64f5946$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $2790f2acd64f5946$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $2790f2acd64f5946$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($2790f2acd64f5946$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $2790f2acd64f5946$var$utf8Write(buf, string, offset, length) {
    return $2790f2acd64f5946$var$blitBuffer($2790f2acd64f5946$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $2790f2acd64f5946$var$asciiWrite(buf, string, offset, length) {
    return $2790f2acd64f5946$var$blitBuffer($2790f2acd64f5946$var$asciiToBytes(string), buf, offset, length);
}
function $2790f2acd64f5946$var$base64Write(buf, string, offset, length) {
    return $2790f2acd64f5946$var$blitBuffer($2790f2acd64f5946$var$base64ToBytes(string), buf, offset, length);
}
function $2790f2acd64f5946$var$ucs2Write(buf, string, offset, length) {
    return $2790f2acd64f5946$var$blitBuffer($2790f2acd64f5946$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$2790f2acd64f5946$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $2790f2acd64f5946$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $2790f2acd64f5946$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $2790f2acd64f5946$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $2790f2acd64f5946$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $2790f2acd64f5946$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$2790f2acd64f5946$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $2790f2acd64f5946$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $7jj3Q.fromByteArray(buf);
    else return $7jj3Q.fromByteArray(buf.slice(start, end));
}
function $2790f2acd64f5946$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $2790f2acd64f5946$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $2790f2acd64f5946$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $2790f2acd64f5946$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $2790f2acd64f5946$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $2790f2acd64f5946$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $2790f2acd64f5946$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $2790f2acd64f5946$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $2790f2acd64f5946$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $2790f2acd64f5946$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $2790f2acd64f5946$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$2790f2acd64f5946$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $2790f2acd64f5946$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $2790f2acd64f5946$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$2790f2acd64f5946$var$Buffer.prototype.readUintLE = $2790f2acd64f5946$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$2790f2acd64f5946$var$Buffer.prototype.readUintBE = $2790f2acd64f5946$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$2790f2acd64f5946$var$Buffer.prototype.readUint8 = $2790f2acd64f5946$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$2790f2acd64f5946$var$Buffer.prototype.readUint16LE = $2790f2acd64f5946$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$2790f2acd64f5946$var$Buffer.prototype.readUint16BE = $2790f2acd64f5946$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$2790f2acd64f5946$var$Buffer.prototype.readUint32LE = $2790f2acd64f5946$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$2790f2acd64f5946$var$Buffer.prototype.readUint32BE = $2790f2acd64f5946$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$2790f2acd64f5946$var$Buffer.prototype.readBigUInt64LE = $2790f2acd64f5946$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $2790f2acd64f5946$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2790f2acd64f5946$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$2790f2acd64f5946$var$Buffer.prototype.readBigUInt64BE = $2790f2acd64f5946$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $2790f2acd64f5946$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2790f2acd64f5946$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$2790f2acd64f5946$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2790f2acd64f5946$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$2790f2acd64f5946$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$2790f2acd64f5946$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2790f2acd64f5946$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$2790f2acd64f5946$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$2790f2acd64f5946$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$2790f2acd64f5946$var$Buffer.prototype.readBigInt64LE = $2790f2acd64f5946$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $2790f2acd64f5946$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2790f2acd64f5946$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$2790f2acd64f5946$var$Buffer.prototype.readBigInt64BE = $2790f2acd64f5946$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $2790f2acd64f5946$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $2790f2acd64f5946$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$2790f2acd64f5946$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return $ccxOZ.read(this, offset, true, 23, 4);
};
$2790f2acd64f5946$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 4, this.length);
    return $ccxOZ.read(this, offset, false, 23, 4);
};
$2790f2acd64f5946$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 8, this.length);
    return $ccxOZ.read(this, offset, true, 52, 8);
};
$2790f2acd64f5946$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkOffset(offset, 8, this.length);
    return $ccxOZ.read(this, offset, false, 52, 8);
};
function $2790f2acd64f5946$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$2790f2acd64f5946$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$2790f2acd64f5946$var$Buffer.prototype.writeUintLE = $2790f2acd64f5946$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2790f2acd64f5946$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUintBE = $2790f2acd64f5946$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $2790f2acd64f5946$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUint8 = $2790f2acd64f5946$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUint16LE = $2790f2acd64f5946$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUint16BE = $2790f2acd64f5946$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUint32LE = $2790f2acd64f5946$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$2790f2acd64f5946$var$Buffer.prototype.writeUint32BE = $2790f2acd64f5946$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $2790f2acd64f5946$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $2790f2acd64f5946$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $2790f2acd64f5946$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $2790f2acd64f5946$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$2790f2acd64f5946$var$Buffer.prototype.writeBigUInt64LE = $2790f2acd64f5946$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $2790f2acd64f5946$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2790f2acd64f5946$var$Buffer.prototype.writeBigUInt64BE = $2790f2acd64f5946$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $2790f2acd64f5946$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$2790f2acd64f5946$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2790f2acd64f5946$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2790f2acd64f5946$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $2790f2acd64f5946$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$2790f2acd64f5946$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$2790f2acd64f5946$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$2790f2acd64f5946$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$2790f2acd64f5946$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$2790f2acd64f5946$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$2790f2acd64f5946$var$Buffer.prototype.writeBigInt64LE = $2790f2acd64f5946$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $2790f2acd64f5946$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$2790f2acd64f5946$var$Buffer.prototype.writeBigInt64BE = $2790f2acd64f5946$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $2790f2acd64f5946$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $2790f2acd64f5946$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $2790f2acd64f5946$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38);
    $ccxOZ.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$2790f2acd64f5946$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $2790f2acd64f5946$var$writeFloat(this, value, offset, true, noAssert);
};
$2790f2acd64f5946$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $2790f2acd64f5946$var$writeFloat(this, value, offset, false, noAssert);
};
function $2790f2acd64f5946$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $2790f2acd64f5946$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157e+308);
    $ccxOZ.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$2790f2acd64f5946$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $2790f2acd64f5946$var$writeDouble(this, value, offset, true, noAssert);
};
$2790f2acd64f5946$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $2790f2acd64f5946$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$2790f2acd64f5946$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$2790f2acd64f5946$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$2790f2acd64f5946$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$2790f2acd64f5946$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $2790f2acd64f5946$var$Buffer.isBuffer(val) ? val : $2790f2acd64f5946$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $2790f2acd64f5946$var$errors = {};
function $2790f2acd64f5946$var$E(sym, getMessage, Base) {
    $2790f2acd64f5946$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack; // eslint-disable-line no-unused-expressions
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$2790f2acd64f5946$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$2790f2acd64f5946$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$2790f2acd64f5946$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $2790f2acd64f5946$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $2790f2acd64f5946$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $2790f2acd64f5946$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $2790f2acd64f5946$var$checkBounds(buf, offset, byteLength) {
    $2790f2acd64f5946$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $2790f2acd64f5946$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $2790f2acd64f5946$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $2790f2acd64f5946$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $2790f2acd64f5946$var$checkBounds(buf, offset, byteLength);
}
function $2790f2acd64f5946$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $2790f2acd64f5946$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $2790f2acd64f5946$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $2790f2acd64f5946$var$validateNumber(value, type);
        throw new $2790f2acd64f5946$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $2790f2acd64f5946$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $2790f2acd64f5946$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $2790f2acd64f5946$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $2790f2acd64f5946$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($2790f2acd64f5946$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $2790f2acd64f5946$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $2790f2acd64f5946$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $2790f2acd64f5946$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $2790f2acd64f5946$var$base64ToBytes(str) {
    return $7jj3Q.toByteArray($2790f2acd64f5946$var$base64clean(str));
}
function $2790f2acd64f5946$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $2790f2acd64f5946$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $2790f2acd64f5946$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $2790f2acd64f5946$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $2790f2acd64f5946$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $2790f2acd64f5946$var$BufferBigIntNotDefined : fn;
}
function $2790f2acd64f5946$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("7jj3Q", function(module, exports) {
$parcel$export(module.exports, "toByteArray", () => $552917e3c1e7e2c0$export$d622b2ad8d90c771, (v) => $552917e3c1e7e2c0$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $552917e3c1e7e2c0$export$6100ba28696e12de, (v) => $552917e3c1e7e2c0$export$6100ba28696e12de = v);
var $552917e3c1e7e2c0$export$a48f0734ac7c2329;
var $552917e3c1e7e2c0$export$d622b2ad8d90c771;
var $552917e3c1e7e2c0$export$6100ba28696e12de;
'use strict';
$552917e3c1e7e2c0$export$a48f0734ac7c2329 = $552917e3c1e7e2c0$var$byteLength;
$552917e3c1e7e2c0$export$d622b2ad8d90c771 = $552917e3c1e7e2c0$var$toByteArray;
$552917e3c1e7e2c0$export$6100ba28696e12de = $552917e3c1e7e2c0$var$fromByteArray;
var $552917e3c1e7e2c0$var$lookup = [];
var $552917e3c1e7e2c0$var$revLookup = [];
var $552917e3c1e7e2c0$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $552917e3c1e7e2c0$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $552917e3c1e7e2c0$var$i = 0, $552917e3c1e7e2c0$var$len = $552917e3c1e7e2c0$var$code.length; $552917e3c1e7e2c0$var$i < $552917e3c1e7e2c0$var$len; ++$552917e3c1e7e2c0$var$i){
    $552917e3c1e7e2c0$var$lookup[$552917e3c1e7e2c0$var$i] = $552917e3c1e7e2c0$var$code[$552917e3c1e7e2c0$var$i];
    $552917e3c1e7e2c0$var$revLookup[$552917e3c1e7e2c0$var$code.charCodeAt($552917e3c1e7e2c0$var$i)] = $552917e3c1e7e2c0$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$552917e3c1e7e2c0$var$revLookup['-'.charCodeAt(0)] = 62;
$552917e3c1e7e2c0$var$revLookup['_'.charCodeAt(0)] = 63;
function $552917e3c1e7e2c0$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $552917e3c1e7e2c0$var$byteLength(b64) {
    var lens = $552917e3c1e7e2c0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $552917e3c1e7e2c0$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $552917e3c1e7e2c0$var$toByteArray(b64) {
    var tmp;
    var lens = $552917e3c1e7e2c0$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $552917e3c1e7e2c0$var$Arr($552917e3c1e7e2c0$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i)] << 18 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i)] << 2 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i)] << 10 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $552917e3c1e7e2c0$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $552917e3c1e7e2c0$var$tripletToBase64(num) {
    return $552917e3c1e7e2c0$var$lookup[num >> 18 & 0x3F] + $552917e3c1e7e2c0$var$lookup[num >> 12 & 0x3F] + $552917e3c1e7e2c0$var$lookup[num >> 6 & 0x3F] + $552917e3c1e7e2c0$var$lookup[num & 0x3F];
}
function $552917e3c1e7e2c0$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($552917e3c1e7e2c0$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $552917e3c1e7e2c0$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($552917e3c1e7e2c0$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($552917e3c1e7e2c0$var$lookup[tmp >> 2] + $552917e3c1e7e2c0$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($552917e3c1e7e2c0$var$lookup[tmp >> 10] + $552917e3c1e7e2c0$var$lookup[tmp >> 4 & 0x3F] + $552917e3c1e7e2c0$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("ccxOZ", function(module, exports) {
$parcel$export(module.exports, "read", () => $8e20d744dae8742f$export$aafa59e2e03f2942, (v) => $8e20d744dae8742f$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $8e20d744dae8742f$export$68d8715fc104d294, (v) => $8e20d744dae8742f$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8e20d744dae8742f$export$aafa59e2e03f2942;
var $8e20d744dae8742f$export$68d8715fc104d294;
$8e20d744dae8742f$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8e20d744dae8742f$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3eUd5", function(module, exports) {
'use strict';

var $kttTJ = parcelRequire("kttTJ");

var $9Y4KE = parcelRequire("9Y4KE");

var $5oS8d = parcelRequire("5oS8d");
module.exports = {
    formats: $5oS8d,
    parse: $9Y4KE,
    stringify: $kttTJ
};

});
parcelRegister("kttTJ", function(module, exports) {
'use strict';

var $ftuPs = parcelRequire("ftuPs");

var $91zTA = parcelRequire("91zTA");

var $5oS8d = parcelRequire("5oS8d");
var $ee7db53360127940$var$has = Object.prototype.hasOwnProperty;
var $ee7db53360127940$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) {
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $ee7db53360127940$var$isArray = Array.isArray;
var $ee7db53360127940$var$push = Array.prototype.push;
var $ee7db53360127940$var$pushToArray = function(arr, valueOrArray) {
    $ee7db53360127940$var$push.apply(arr, $ee7db53360127940$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $ee7db53360127940$var$toISO = Date.prototype.toISOString;
var $ee7db53360127940$var$defaultFormat = $5oS8d.default;
var $ee7db53360127940$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: $91zTA.encode,
    encodeValuesOnly: false,
    format: $ee7db53360127940$var$defaultFormat,
    formatter: $5oS8d.formatters[$ee7db53360127940$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $ee7db53360127940$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $ee7db53360127940$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean' || typeof v === 'symbol' || typeof v === 'bigint';
};
var $ee7db53360127940$var$sentinel = {};
var $ee7db53360127940$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($ee7db53360127940$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== 'undefined') {
            if (pos === step) throw new RangeError('Cyclic object value');
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($ee7db53360127940$var$sentinel) === 'undefined') step = 0;
    }
    if (typeof filter === 'function') obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === 'comma' && $ee7db53360127940$var$isArray(obj)) obj = $91zTA.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $ee7db53360127940$var$defaults.encoder, charset, 'key', format) : prefix;
        obj = '';
    }
    if ($ee7db53360127940$var$isNonNullishPrimitive(obj) || $91zTA.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $ee7db53360127940$var$defaults.encoder, charset, 'key', format);
            return [
                formatter(keyValue) + '=' + formatter(encoder(obj, $ee7db53360127940$var$defaults.encoder, charset, 'value', format))
            ];
        }
        return [
            formatter(prefix) + '=' + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === 'undefined') return values;
    var objKeys;
    if (generateArrayPrefix === 'comma' && $ee7db53360127940$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $91zTA.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(',') || null : void 0
            }
        ];
    } else if ($ee7db53360127940$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var adjustedPrefix = commaRoundTrip && $ee7db53360127940$var$isArray(obj) && obj.length === 1 ? prefix + '[]' : prefix;
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === 'object' && typeof key.value !== 'undefined' ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var keyPrefix = $ee7db53360127940$var$isArray(obj) ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, key) : adjustedPrefix : adjustedPrefix + (allowDots ? '.' + key : '[' + key + ']');
        sideChannel.set(object, step);
        var valueSideChannel = $ftuPs();
        valueSideChannel.set($ee7db53360127940$var$sentinel, sideChannel);
        $ee7db53360127940$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, strictNullHandling, skipNulls, generateArrayPrefix === 'comma' && encodeValuesOnly && $ee7db53360127940$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $ee7db53360127940$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $ee7db53360127940$var$defaults;
    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') throw new TypeError('Encoder has to be a function.');
    var charset = opts.charset || $ee7db53360127940$var$defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var format = $5oS8d.default;
    if (typeof opts.format !== 'undefined') {
        if (!$ee7db53360127940$var$has.call($5oS8d.formatters, opts.format)) throw new TypeError('Unknown format option provided.');
        format = opts.format;
    }
    var formatter = $5oS8d.formatters[format];
    var filter = $ee7db53360127940$var$defaults.filter;
    if (typeof opts.filter === 'function' || $ee7db53360127940$var$isArray(opts.filter)) filter = opts.filter;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : $ee7db53360127940$var$defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? $ee7db53360127940$var$defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $ee7db53360127940$var$defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? $ee7db53360127940$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : $ee7db53360127940$var$defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : $ee7db53360127940$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : $ee7db53360127940$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : $ee7db53360127940$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : $ee7db53360127940$var$defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $ee7db53360127940$var$defaults.strictNullHandling
    };
};
module.exports = function(object, opts) {
    var obj = object;
    var options = $ee7db53360127940$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if ($ee7db53360127940$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== 'object' || obj === null) return '';
    var arrayFormat;
    if (opts && opts.arrayFormat in $ee7db53360127940$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if (opts && 'indices' in opts) arrayFormat = opts.indices ? 'indices' : 'repeat';
    else arrayFormat = 'indices';
    var generateArrayPrefix = $ee7db53360127940$var$arrayPrefixGenerators[arrayFormat];
    if (opts && 'commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
    var commaRoundTrip = generateArrayPrefix === 'comma' && opts && opts.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $ftuPs();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $ee7db53360127940$var$pushToArray(keys, $ee7db53360127940$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.strictNullHandling, options.skipNulls, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';
    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += 'utf8=%26%2310003%3B&';
        else // encodeURIComponent('✓')
        prefix += 'utf8=%E2%9C%93&';
    }
    return joined.length > 0 ? prefix + joined : '';
};

});
parcelRegister("ftuPs", function(module, exports) {
'use strict';

var $ewY92 = parcelRequire("ewY92");

var $74IIy = parcelRequire("74IIy");

var $8K1NG = parcelRequire("8K1NG");

var $dvLVD = parcelRequire("dvLVD");

var $5wzGz = parcelRequire("5wzGz");
var $b4417a735647ff45$var$makeChannel = $5wzGz || $dvLVD || $8K1NG;
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @typedef {ReturnType<typeof getSideChannel>} Channel */ /** @type {Channel | undefined} */ var $channelData;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $ewY92('Side channel does not contain ' + $74IIy(key));
        },
        'delete': function(key) {
            return !!$channelData && $channelData['delete'](key);
        },
        get: function(key) {
            return $channelData && $channelData.get(key);
        },
        has: function(key) {
            return !!$channelData && $channelData.has(key);
        },
        set: function(key, value) {
            if (!$channelData) $channelData = $b4417a735647ff45$var$makeChannel();
            $channelData.set(key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});
parcelRegister("ewY92", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("74IIy", function(module, exports) {
var $526b9821b88a9849$var$hasMap = typeof Map === 'function' && Map.prototype;
var $526b9821b88a9849$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $526b9821b88a9849$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
var $526b9821b88a9849$var$mapSize = $526b9821b88a9849$var$hasMap && $526b9821b88a9849$var$mapSizeDescriptor && typeof $526b9821b88a9849$var$mapSizeDescriptor.get === 'function' ? $526b9821b88a9849$var$mapSizeDescriptor.get : null;
var $526b9821b88a9849$var$mapForEach = $526b9821b88a9849$var$hasMap && Map.prototype.forEach;
var $526b9821b88a9849$var$hasSet = typeof Set === 'function' && Set.prototype;
var $526b9821b88a9849$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $526b9821b88a9849$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
var $526b9821b88a9849$var$setSize = $526b9821b88a9849$var$hasSet && $526b9821b88a9849$var$setSizeDescriptor && typeof $526b9821b88a9849$var$setSizeDescriptor.get === 'function' ? $526b9821b88a9849$var$setSizeDescriptor.get : null;
var $526b9821b88a9849$var$setForEach = $526b9821b88a9849$var$hasSet && Set.prototype.forEach;
var $526b9821b88a9849$var$hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
var $526b9821b88a9849$var$weakMapHas = $526b9821b88a9849$var$hasWeakMap ? WeakMap.prototype.has : null;
var $526b9821b88a9849$var$hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
var $526b9821b88a9849$var$weakSetHas = $526b9821b88a9849$var$hasWeakSet ? WeakSet.prototype.has : null;
var $526b9821b88a9849$var$hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
var $526b9821b88a9849$var$weakRefDeref = $526b9821b88a9849$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $526b9821b88a9849$var$booleanValueOf = Boolean.prototype.valueOf;
var $526b9821b88a9849$var$objectToString = Object.prototype.toString;
var $526b9821b88a9849$var$functionToString = Function.prototype.toString;
var $526b9821b88a9849$var$$match = String.prototype.match;
var $526b9821b88a9849$var$$slice = String.prototype.slice;
var $526b9821b88a9849$var$$replace = String.prototype.replace;
var $526b9821b88a9849$var$$toUpperCase = String.prototype.toUpperCase;
var $526b9821b88a9849$var$$toLowerCase = String.prototype.toLowerCase;
var $526b9821b88a9849$var$$test = RegExp.prototype.test;
var $526b9821b88a9849$var$$concat = Array.prototype.concat;
var $526b9821b88a9849$var$$join = Array.prototype.join;
var $526b9821b88a9849$var$$arrSlice = Array.prototype.slice;
var $526b9821b88a9849$var$$floor = Math.floor;
var $526b9821b88a9849$var$bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
var $526b9821b88a9849$var$gOPS = Object.getOwnPropertySymbols;
var $526b9821b88a9849$var$symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
var $526b9821b88a9849$var$hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
// ie, `has-tostringtag/shams
var $526b9821b88a9849$var$toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === $526b9821b88a9849$var$hasShammedSymbols ? 'object' : 'symbol') ? Symbol.toStringTag : null;
var $526b9821b88a9849$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $526b9821b88a9849$var$gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $526b9821b88a9849$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $526b9821b88a9849$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === 'number') {
        var int = num < 0 ? -$526b9821b88a9849$var$$floor(-num) : $526b9821b88a9849$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $526b9821b88a9849$var$$slice.call(str, intStr.length + 1);
            return $526b9821b88a9849$var$$replace.call(intStr, sepRegex, '$&_') + '.' + $526b9821b88a9849$var$$replace.call($526b9821b88a9849$var$$replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
        }
    }
    return $526b9821b88a9849$var$$replace.call(str, sepRegex, '$&_');
}

var $5MpFc = parcelRequire("5MpFc");
var $526b9821b88a9849$var$inspectCustom = $5MpFc.custom;
var $526b9821b88a9849$var$inspectSymbol = $526b9821b88a9849$var$isSymbol($526b9821b88a9849$var$inspectCustom) ? $526b9821b88a9849$var$inspectCustom : null;
var $526b9821b88a9849$var$quotes = {
    __proto__: null,
    'double': '"',
    single: "'"
};
var $526b9821b88a9849$var$quoteREs = {
    __proto__: null,
    'double': /(["\\])/g,
    single: /(['\\])/g
};
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($526b9821b88a9849$var$has(opts, 'quoteStyle') && !$526b9821b88a9849$var$has($526b9821b88a9849$var$quotes, opts.quoteStyle)) throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($526b9821b88a9849$var$has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number' ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $526b9821b88a9849$var$has(opts, 'customInspect') ? opts.customInspect : true;
    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
    if ($526b9821b88a9849$var$has(opts, 'indent') && opts.indent !== null && opts.indent !== '\t' && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($526b9821b88a9849$var$has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === 'undefined') return 'undefined';
    if (obj === null) return 'null';
    if (typeof obj === 'boolean') return obj ? 'true' : 'false';
    if (typeof obj === 'string') return $526b9821b88a9849$var$inspectString(obj, opts);
    if (typeof obj === 'number') {
        if (obj === 0) return Infinity / obj > 0 ? '0' : '-0';
        var str = String(obj);
        return numericSeparator ? $526b9821b88a9849$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === 'bigint') {
        var bigIntStr = String(obj) + 'n';
        return numericSeparator ? $526b9821b88a9849$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
    if (typeof depth === 'undefined') depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') return $526b9821b88a9849$var$isArray(obj) ? '[Array]' : '[Object]';
    var indent = $526b9821b88a9849$var$getIndent(opts, depth);
    if (typeof seen === 'undefined') seen = [];
    else if ($526b9821b88a9849$var$indexOf(seen, obj) >= 0) return '[Circular]';
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $526b9821b88a9849$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($526b9821b88a9849$var$has(opts, 'quoteStyle')) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === 'function' && !$526b9821b88a9849$var$isRegExp(obj)) {
        var name = $526b9821b88a9849$var$nameOf(obj);
        var keys = $526b9821b88a9849$var$arrObjKeys(obj, inspect);
        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $526b9821b88a9849$var$$join.call(keys, ', ') + ' }' : '');
    }
    if ($526b9821b88a9849$var$isSymbol(obj)) {
        var symString = $526b9821b88a9849$var$hasShammedSymbols ? $526b9821b88a9849$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : $526b9821b88a9849$var$symToString.call(obj);
        return typeof obj === 'object' && !$526b9821b88a9849$var$hasShammedSymbols ? $526b9821b88a9849$var$markBoxed(symString) : symString;
    }
    if ($526b9821b88a9849$var$isElement(obj)) {
        var s = '<' + $526b9821b88a9849$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += ' ' + attrs[i].name + '=' + $526b9821b88a9849$var$wrapQuotes($526b9821b88a9849$var$quote(attrs[i].value), 'double', opts);
        s += '>';
        if (obj.childNodes && obj.childNodes.length) s += '...';
        s += '</' + $526b9821b88a9849$var$$toLowerCase.call(String(obj.nodeName)) + '>';
        return s;
    }
    if ($526b9821b88a9849$var$isArray(obj)) {
        if (obj.length === 0) return '[]';
        var xs = $526b9821b88a9849$var$arrObjKeys(obj, inspect);
        if (indent && !$526b9821b88a9849$var$singleLineValues(xs)) return '[' + $526b9821b88a9849$var$indentedJoin(xs, indent) + ']';
        return '[ ' + $526b9821b88a9849$var$$join.call(xs, ', ') + ' ]';
    }
    if ($526b9821b88a9849$var$isError(obj)) {
        var parts = $526b9821b88a9849$var$arrObjKeys(obj, inspect);
        if (!('cause' in Error.prototype) && 'cause' in obj && !$526b9821b88a9849$var$isEnumerable.call(obj, 'cause')) return '{ [' + String(obj) + '] ' + $526b9821b88a9849$var$$join.call($526b9821b88a9849$var$$concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
        if (parts.length === 0) return '[' + String(obj) + ']';
        return '{ [' + String(obj) + '] ' + $526b9821b88a9849$var$$join.call(parts, ', ') + ' }';
    }
    if (typeof obj === 'object' && customInspect) {
        if ($526b9821b88a9849$var$inspectSymbol && typeof obj[$526b9821b88a9849$var$inspectSymbol] === 'function' && $5MpFc) return $5MpFc(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') return obj.inspect();
    }
    if ($526b9821b88a9849$var$isMap(obj)) {
        var mapParts = [];
        if ($526b9821b88a9849$var$mapForEach) $526b9821b88a9849$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
        });
        return $526b9821b88a9849$var$collectionOf('Map', $526b9821b88a9849$var$mapSize.call(obj), mapParts, indent);
    }
    if ($526b9821b88a9849$var$isSet(obj)) {
        var setParts = [];
        if ($526b9821b88a9849$var$setForEach) $526b9821b88a9849$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $526b9821b88a9849$var$collectionOf('Set', $526b9821b88a9849$var$setSize.call(obj), setParts, indent);
    }
    if ($526b9821b88a9849$var$isWeakMap(obj)) return $526b9821b88a9849$var$weakCollectionOf('WeakMap');
    if ($526b9821b88a9849$var$isWeakSet(obj)) return $526b9821b88a9849$var$weakCollectionOf('WeakSet');
    if ($526b9821b88a9849$var$isWeakRef(obj)) return $526b9821b88a9849$var$weakCollectionOf('WeakRef');
    if ($526b9821b88a9849$var$isNumber(obj)) return $526b9821b88a9849$var$markBoxed(inspect(Number(obj)));
    if ($526b9821b88a9849$var$isBigInt(obj)) return $526b9821b88a9849$var$markBoxed(inspect($526b9821b88a9849$var$bigIntValueOf.call(obj)));
    if ($526b9821b88a9849$var$isBoolean(obj)) return $526b9821b88a9849$var$markBoxed($526b9821b88a9849$var$booleanValueOf.call(obj));
    if ($526b9821b88a9849$var$isString(obj)) return $526b9821b88a9849$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== 'undefined' && obj === window) return '{ [object Window] }';
    if (typeof globalThis !== 'undefined' && obj === globalThis || typeof $parcel$global !== 'undefined' && obj === $parcel$global) return '{ [object globalThis] }';
    if (!$526b9821b88a9849$var$isDate(obj) && !$526b9821b88a9849$var$isRegExp(obj)) {
        var ys = $526b9821b88a9849$var$arrObjKeys(obj, inspect);
        var isPlainObject = $526b9821b88a9849$var$gPO ? $526b9821b88a9849$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? '' : 'null prototype';
        var stringTag = !isPlainObject && $526b9821b88a9849$var$toStringTag && Object(obj) === obj && $526b9821b88a9849$var$toStringTag in obj ? $526b9821b88a9849$var$$slice.call($526b9821b88a9849$var$toStr(obj), 8, -1) : protoTag ? 'Object' : '';
        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
        var tag = constructorTag + (stringTag || protoTag ? '[' + $526b9821b88a9849$var$$join.call($526b9821b88a9849$var$$concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
        if (ys.length === 0) return tag + '{}';
        if (indent) return tag + '{' + $526b9821b88a9849$var$indentedJoin(ys, indent) + '}';
        return tag + '{ ' + $526b9821b88a9849$var$$join.call(ys, ', ') + ' }';
    }
    return String(obj);
};
function $526b9821b88a9849$var$wrapQuotes(s, defaultStyle, opts) {
    var style = opts.quoteStyle || defaultStyle;
    var quoteChar = $526b9821b88a9849$var$quotes[style];
    return quoteChar + s + quoteChar;
}
function $526b9821b88a9849$var$quote(s) {
    return $526b9821b88a9849$var$$replace.call(String(s), /"/g, '&quot;');
}
function $526b9821b88a9849$var$canTrustToString(obj) {
    return !$526b9821b88a9849$var$toStringTag || !(typeof obj === 'object' && ($526b9821b88a9849$var$toStringTag in obj || typeof obj[$526b9821b88a9849$var$toStringTag] !== 'undefined'));
}
function $526b9821b88a9849$var$isArray(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object Array]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isDate(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object Date]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isRegExp(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object RegExp]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isError(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object Error]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isString(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object String]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isNumber(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object Number]' && $526b9821b88a9849$var$canTrustToString(obj);
}
function $526b9821b88a9849$var$isBoolean(obj) {
    return $526b9821b88a9849$var$toStr(obj) === '[object Boolean]' && $526b9821b88a9849$var$canTrustToString(obj);
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $526b9821b88a9849$var$isSymbol(obj) {
    if ($526b9821b88a9849$var$hasShammedSymbols) return obj && typeof obj === 'object' && obj instanceof Symbol;
    if (typeof obj === 'symbol') return true;
    if (!obj || typeof obj !== 'object' || !$526b9821b88a9849$var$symToString) return false;
    try {
        $526b9821b88a9849$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isBigInt(obj) {
    if (!obj || typeof obj !== 'object' || !$526b9821b88a9849$var$bigIntValueOf) return false;
    try {
        $526b9821b88a9849$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $526b9821b88a9849$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $526b9821b88a9849$var$has(obj, key) {
    return $526b9821b88a9849$var$hasOwn.call(obj, key);
}
function $526b9821b88a9849$var$toStr(obj) {
    return $526b9821b88a9849$var$objectToString.call(obj);
}
function $526b9821b88a9849$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $526b9821b88a9849$var$$match.call($526b9821b88a9849$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $526b9821b88a9849$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $526b9821b88a9849$var$isMap(x) {
    if (!$526b9821b88a9849$var$mapSize || !x || typeof x !== 'object') return false;
    try {
        $526b9821b88a9849$var$mapSize.call(x);
        try {
            $526b9821b88a9849$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isWeakMap(x) {
    if (!$526b9821b88a9849$var$weakMapHas || !x || typeof x !== 'object') return false;
    try {
        $526b9821b88a9849$var$weakMapHas.call(x, $526b9821b88a9849$var$weakMapHas);
        try {
            $526b9821b88a9849$var$weakSetHas.call(x, $526b9821b88a9849$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isWeakRef(x) {
    if (!$526b9821b88a9849$var$weakRefDeref || !x || typeof x !== 'object') return false;
    try {
        $526b9821b88a9849$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isSet(x) {
    if (!$526b9821b88a9849$var$setSize || !x || typeof x !== 'object') return false;
    try {
        $526b9821b88a9849$var$setSize.call(x);
        try {
            $526b9821b88a9849$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isWeakSet(x) {
    if (!$526b9821b88a9849$var$weakSetHas || !x || typeof x !== 'object') return false;
    try {
        $526b9821b88a9849$var$weakSetHas.call(x, $526b9821b88a9849$var$weakSetHas);
        try {
            $526b9821b88a9849$var$weakMapHas.call(x, $526b9821b88a9849$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $526b9821b88a9849$var$isElement(x) {
    if (!x || typeof x !== 'object') return false;
    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) return true;
    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
}
function $526b9821b88a9849$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
        return $526b9821b88a9849$var$inspectString($526b9821b88a9849$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    var quoteRE = $526b9821b88a9849$var$quoteREs[opts.quoteStyle || 'single'];
    quoteRE.lastIndex = 0;
    // eslint-disable-next-line no-control-regex
    var s = $526b9821b88a9849$var$$replace.call($526b9821b88a9849$var$$replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, $526b9821b88a9849$var$lowbyte);
    return $526b9821b88a9849$var$wrapQuotes(s, 'single', opts);
}
function $526b9821b88a9849$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: 'b',
        9: 't',
        10: 'n',
        12: 'f',
        13: 'r'
    }[n];
    if (x) return '\\' + x;
    return '\\x' + (n < 0x10 ? '0' : '') + $526b9821b88a9849$var$$toUpperCase.call(n.toString(16));
}
function $526b9821b88a9849$var$markBoxed(str) {
    return 'Object(' + str + ')';
}
function $526b9821b88a9849$var$weakCollectionOf(type) {
    return type + ' { ? }';
}
function $526b9821b88a9849$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $526b9821b88a9849$var$indentedJoin(entries, indent) : $526b9821b88a9849$var$$join.call(entries, ', ');
    return type + ' (' + size + ') {' + joinedEntries + '}';
}
function $526b9821b88a9849$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($526b9821b88a9849$var$indexOf(xs[i], '\n') >= 0) return false;
    }
    return true;
}
function $526b9821b88a9849$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === '\t') baseIndent = '\t';
    else if (typeof opts.indent === 'number' && opts.indent > 0) baseIndent = $526b9821b88a9849$var$$join.call(Array(opts.indent + 1), ' ');
    else return null;
    return {
        base: baseIndent,
        prev: $526b9821b88a9849$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $526b9821b88a9849$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return '';
    var lineJoiner = '\n' + indent.prev + indent.base;
    return lineJoiner + $526b9821b88a9849$var$$join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
}
function $526b9821b88a9849$var$arrObjKeys(obj, inspect) {
    var isArr = $526b9821b88a9849$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $526b9821b88a9849$var$has(obj, i) ? inspect(obj[i], obj) : '';
    }
    var syms = typeof $526b9821b88a9849$var$gOPS === 'function' ? $526b9821b88a9849$var$gOPS(obj) : [];
    var symMap;
    if ($526b9821b88a9849$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap['$' + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$526b9821b88a9849$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($526b9821b88a9849$var$hasShammedSymbols && symMap['$' + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($526b9821b88a9849$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
        else xs.push(key + ': ' + inspect(obj[key], obj));
    }
    if (typeof $526b9821b88a9849$var$gOPS === 'function') {
        for(var j = 0; j < syms.length; j++)if ($526b9821b88a9849$var$isEnumerable.call(obj, syms[j])) xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("5MpFc", function(module, exports) {

});


parcelRegister("8K1NG", function(module, exports) {
'use strict';

var $74IIy = parcelRequire("74IIy");

var $ewY92 = parcelRequire("ewY92");
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
* By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('./list.d.ts').listGetNode} */ // eslint-disable-next-line consistent-return
var $65d4042349aeaa39$var$listGetNode = function(list, key, isDelete) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    // eslint-disable-next-line eqeqeq
    for(; (curr = prev.next) != null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        if (!isDelete) {
            // eslint-disable-next-line no-extra-parens
            curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
            list.next = curr; // eslint-disable-line no-param-reassign
        }
        return curr;
    }
};
/** @type {import('./list.d.ts').listGet} */ var $65d4042349aeaa39$var$listGet = function(objects, key) {
    if (!objects) return void 0;
    var node = $65d4042349aeaa39$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('./list.d.ts').listSet} */ var $65d4042349aeaa39$var$listSet = function(objects, key, value) {
    var node = $65d4042349aeaa39$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('./list.d.ts').listHas} */ var $65d4042349aeaa39$var$listHas = function(objects, key) {
    if (!objects) return false;
    return !!$65d4042349aeaa39$var$listGetNode(objects, key);
};
/** @type {import('./list.d.ts').listDelete} */ // eslint-disable-next-line consistent-return
var $65d4042349aeaa39$var$listDelete = function(objects, key) {
    if (objects) return $65d4042349aeaa39$var$listGetNode(objects, key, true);
};
/** @type {import('.')} */ module.exports = function getSideChannelList() {
    /** @typedef {ReturnType<typeof getSideChannelList>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $ewY92('Side channel does not contain ' + $74IIy(key));
        },
        'delete': function(key) {
            var root = $o && $o.next;
            var deletedNode = $65d4042349aeaa39$var$listDelete($o, key);
            if (deletedNode && root && root === deletedNode) $o = void 0;
            return !!deletedNode;
        },
        get: function(key) {
            return $65d4042349aeaa39$var$listGet($o, key);
        },
        has: function(key) {
            return $65d4042349aeaa39$var$listHas($o, key);
        },
        set: function(key, value) {
            if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
            $o = {
                next: void 0
            };
            // eslint-disable-next-line no-extra-parens
            $65d4042349aeaa39$var$listSet(/** @type {NonNullable<typeof $o>} */ $o, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
};

});

parcelRegister("dvLVD", function(module, exports) {
'use strict';

var $jVgSm = parcelRequire("jVgSm");

var $5hUyV = parcelRequire("5hUyV");

var $74IIy = parcelRequire("74IIy");

var $ewY92 = parcelRequire("ewY92");
var $9d635936ecf5ef4d$var$$Map = $jVgSm('%Map%', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */ var $9d635936ecf5ef4d$var$$mapGet = $5hUyV('Map.prototype.get', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */ var $9d635936ecf5ef4d$var$$mapSet = $5hUyV('Map.prototype.set', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $9d635936ecf5ef4d$var$$mapHas = $5hUyV('Map.prototype.has', true);
/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */ var $9d635936ecf5ef4d$var$$mapDelete = $5hUyV('Map.prototype.delete', true);
/** @type {<K, V>(thisArg: Map<K, V>) => number} */ var $9d635936ecf5ef4d$var$$mapSize = $5hUyV('Map.prototype.size', true);
/** @type {import('.')} */ module.exports = !!$9d635936ecf5ef4d$var$$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
    /** @typedef {ReturnType<typeof getSideChannelMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {Map<K, V> | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $ewY92('Side channel does not contain ' + $74IIy(key));
        },
        'delete': function(key) {
            if ($m) {
                var result = $9d635936ecf5ef4d$var$$mapDelete($m, key);
                if ($9d635936ecf5ef4d$var$$mapSize($m) === 0) $m = void 0;
                return result;
            }
            return false;
        },
        get: function(key) {
            if ($m) return $9d635936ecf5ef4d$var$$mapGet($m, key);
        },
        has: function(key) {
            if ($m) return $9d635936ecf5ef4d$var$$mapHas($m, key);
            return false;
        },
        set: function(key, value) {
            if (!$m) // @ts-expect-error TS can't handle narrowing a variable inside a closure
            $m = new $9d635936ecf5ef4d$var$$Map();
            $9d635936ecf5ef4d$var$$mapSet($m, key, value);
        }
    };
    // @ts-expect-error TODO: figure out why TS is erroring here
    return channel;
};

});
parcelRegister("jVgSm", function(module, exports) {
'use strict';
var $e8106e58bc4414df$var$undefined1;

var $ZSQvF = parcelRequire("ZSQvF");

var $hI9P4 = parcelRequire("hI9P4");

var $8qMP2 = parcelRequire("8qMP2");

var $lCHGO = parcelRequire("lCHGO");

var $6eesP = parcelRequire("6eesP");

var $6kymX = parcelRequire("6kymX");

var $ewY92 = parcelRequire("ewY92");

var $37608 = parcelRequire("37608");

var $6O67W = parcelRequire("6O67W");

var $5TldE = parcelRequire("5TldE");

var $bBuvq = parcelRequire("bBuvq");

var $4BE86 = parcelRequire("4BE86");

var $8esb3 = parcelRequire("8esb3");

var $iESuY = parcelRequire("iESuY");

var $4CRfE = parcelRequire("4CRfE");
var $e8106e58bc4414df$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $e8106e58bc4414df$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $e8106e58bc4414df$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $fgwiZ = parcelRequire("fgwiZ");

var $fhmL4 = parcelRequire("fhmL4");
var $e8106e58bc4414df$var$throwTypeError = function() {
    throw new $ewY92();
};
var $e8106e58bc4414df$var$ThrowTypeError = $fgwiZ ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $e8106e58bc4414df$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $fgwiZ(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $e8106e58bc4414df$var$throwTypeError;
        }
    }
}() : $e8106e58bc4414df$var$throwTypeError;

var $e8106e58bc4414df$var$hasSymbols = (parcelRequire("iYfBX"))();

var $3Y2Zp = parcelRequire("3Y2Zp");

var $aHdJR = parcelRequire("aHdJR");

var $fvIDE = parcelRequire("fvIDE");

var $6z6Ry = parcelRequire("6z6Ry");

var $h6bNL = parcelRequire("h6bNL");
var $e8106e58bc4414df$var$needsEval = {};
var $e8106e58bc4414df$var$TypedArray = typeof Uint8Array === 'undefined' || !$3Y2Zp ? undefined : $3Y2Zp(Uint8Array);
var $e8106e58bc4414df$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $e8106e58bc4414df$var$hasSymbols && $3Y2Zp ? $3Y2Zp([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $e8106e58bc4414df$var$needsEval,
    '%AsyncGenerator%': $e8106e58bc4414df$var$needsEval,
    '%AsyncGeneratorFunction%': $e8106e58bc4414df$var$needsEval,
    '%AsyncIteratorPrototype%': $e8106e58bc4414df$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $hI9P4,
    '%eval%': eval,
    '%EvalError%': $8qMP2,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $e8106e58bc4414df$var$$Function,
    '%GeneratorFunction%': $e8106e58bc4414df$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $e8106e58bc4414df$var$hasSymbols && $3Y2Zp ? $3Y2Zp($3Y2Zp([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$e8106e58bc4414df$var$hasSymbols || !$3Y2Zp ? undefined : $3Y2Zp(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $ZSQvF,
    '%Object.getOwnPropertyDescriptor%': $fgwiZ,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $lCHGO,
    '%ReferenceError%': $6eesP,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$e8106e58bc4414df$var$hasSymbols || !$3Y2Zp ? undefined : $3Y2Zp(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $e8106e58bc4414df$var$hasSymbols && $3Y2Zp ? $3Y2Zp(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $e8106e58bc4414df$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $6kymX,
    '%ThrowTypeError%': $e8106e58bc4414df$var$ThrowTypeError,
    '%TypedArray%': $e8106e58bc4414df$var$TypedArray,
    '%TypeError%': $ewY92,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $37608,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $h6bNL,
    '%Function.prototype.apply%': $6z6Ry,
    '%Object.defineProperty%': $fhmL4,
    '%Object.getPrototypeOf%': $aHdJR,
    '%Math.abs%': $6O67W,
    '%Math.floor%': $5TldE,
    '%Math.max%': $bBuvq,
    '%Math.min%': $4BE86,
    '%Math.pow%': $8esb3,
    '%Math.round%': $iESuY,
    '%Math.sign%': $4CRfE,
    '%Reflect.getPrototypeOf%': $fvIDE
};
if ($3Y2Zp) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $e8106e58bc4414df$var$errorProto = $3Y2Zp($3Y2Zp(e));
    $e8106e58bc4414df$var$INTRINSICS['%Error.prototype%'] = $e8106e58bc4414df$var$errorProto;
}
var $e8106e58bc4414df$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $e8106e58bc4414df$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $e8106e58bc4414df$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $e8106e58bc4414df$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $3Y2Zp) value = $3Y2Zp(gen.prototype);
    }
    $e8106e58bc4414df$var$INTRINSICS[name] = value;
    return value;
};
var $e8106e58bc4414df$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $aW2KH = parcelRequire("aW2KH");

var $9kM6H = parcelRequire("9kM6H");
var $e8106e58bc4414df$var$$concat = $aW2KH.call($h6bNL, Array.prototype.concat);
var $e8106e58bc4414df$var$$spliceApply = $aW2KH.call($6z6Ry, Array.prototype.splice);
var $e8106e58bc4414df$var$$replace = $aW2KH.call($h6bNL, String.prototype.replace);
var $e8106e58bc4414df$var$$strSlice = $aW2KH.call($h6bNL, String.prototype.slice);
var $e8106e58bc4414df$var$$exec = $aW2KH.call($h6bNL, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $e8106e58bc4414df$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $e8106e58bc4414df$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $e8106e58bc4414df$var$stringToPath = function stringToPath(string) {
    var first = $e8106e58bc4414df$var$$strSlice(string, 0, 1);
    var last = $e8106e58bc4414df$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $6kymX('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $6kymX('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $e8106e58bc4414df$var$$replace(string, $e8106e58bc4414df$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $e8106e58bc4414df$var$$replace(subString, $e8106e58bc4414df$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $e8106e58bc4414df$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($9kM6H($e8106e58bc4414df$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $e8106e58bc4414df$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($9kM6H($e8106e58bc4414df$var$INTRINSICS, intrinsicName)) {
        var value = $e8106e58bc4414df$var$INTRINSICS[intrinsicName];
        if (value === $e8106e58bc4414df$var$needsEval) value = $e8106e58bc4414df$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $ewY92('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $6kymX('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $ewY92('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $ewY92('"allowMissing" argument must be a boolean');
    if ($e8106e58bc4414df$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $6kymX('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $e8106e58bc4414df$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $e8106e58bc4414df$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $e8106e58bc4414df$var$$spliceApply(parts, $e8106e58bc4414df$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $e8106e58bc4414df$var$$strSlice(part, 0, 1);
        var last = $e8106e58bc4414df$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $6kymX('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($9kM6H($e8106e58bc4414df$var$INTRINSICS, intrinsicRealName)) value = $e8106e58bc4414df$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $ewY92('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($fgwiZ && i + 1 >= parts.length) {
                var desc = $fgwiZ(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $9kM6H(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $e8106e58bc4414df$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("ZSQvF", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("hI9P4", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("8qMP2", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("lCHGO", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("6eesP", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("6kymX", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("37608", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("6O67W", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("5TldE", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("bBuvq", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("4BE86", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("8esb3", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("iESuY", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("4CRfE", function(module, exports) {
'use strict';

var $15DCA = parcelRequire("15DCA");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($15DCA(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("15DCA", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("fgwiZ", function(module, exports) {
'use strict';

var $85TcQ = parcelRequire("85TcQ");
var $b1d168c8dad21800$require$$gOPD = $85TcQ;
if ($b1d168c8dad21800$require$$gOPD) try {
    $b1d168c8dad21800$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $b1d168c8dad21800$require$$gOPD = null;
}
module.exports = $b1d168c8dad21800$require$$gOPD;

});
parcelRegister("85TcQ", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("fhmL4", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $b1fa18deceac0eab$var$$defineProperty = Object.defineProperty || false;
if ($b1fa18deceac0eab$var$$defineProperty) try {
    $b1fa18deceac0eab$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $b1fa18deceac0eab$var$$defineProperty = false;
}
module.exports = $b1fa18deceac0eab$var$$defineProperty;

});

parcelRegister("iYfBX", function(module, exports) {
'use strict';
var $dcf9f0a126da0bcb$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $73hXS = parcelRequire("73hXS");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $dcf9f0a126da0bcb$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $dcf9f0a126da0bcb$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $73hXS();
};

});
parcelRegister("73hXS", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("3Y2Zp", function(module, exports) {
'use strict';

var $fvIDE = parcelRequire("fvIDE");

var $aHdJR = parcelRequire("aHdJR");

var $6v9Mi = parcelRequire("6v9Mi");
/** @type {import('.')} */ module.exports = $fvIDE ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $fvIDE(O);
} : $aHdJR ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $aHdJR(O);
} : $6v9Mi ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $6v9Mi(O);
} : null;

});
parcelRegister("fvIDE", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("aHdJR", function(module, exports) {
'use strict';

var $ZSQvF = parcelRequire("ZSQvF");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $ZSQvF.getPrototypeOf || null;

});

parcelRegister("6v9Mi", function(module, exports) {
'use strict';

var $2TrMG = parcelRequire("2TrMG");

var $fgwiZ = parcelRequire("fgwiZ");
var $0138bab9ee5f11b6$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $0138bab9ee5f11b6$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $0138bab9ee5f11b6$var$desc = !!$0138bab9ee5f11b6$var$hasProtoAccessor && $fgwiZ && $fgwiZ(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $0138bab9ee5f11b6$var$$Object = Object;
var $0138bab9ee5f11b6$var$$getPrototypeOf = $0138bab9ee5f11b6$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $0138bab9ee5f11b6$var$desc && typeof $0138bab9ee5f11b6$var$desc.get === 'function' ? $2TrMG([
    $0138bab9ee5f11b6$var$desc.get
]) : typeof $0138bab9ee5f11b6$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $0138bab9ee5f11b6$var$$getPrototypeOf(value == null ? value : $0138bab9ee5f11b6$var$$Object(value));
} : false;

});
parcelRegister("2TrMG", function(module, exports) {
'use strict';

var $aW2KH = parcelRequire("aW2KH");

var $ewY92 = parcelRequire("ewY92");

var $h6bNL = parcelRequire("h6bNL");

var $aNcun = parcelRequire("aNcun");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $ewY92('a function is required');
    return $aNcun($aW2KH, $h6bNL, args);
};

});
parcelRegister("aW2KH", function(module, exports) {
'use strict';

var $7aJx7 = parcelRequire("7aJx7");
module.exports = Function.prototype.bind || $7aJx7;

});
parcelRegister("7aJx7", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $538cc97e635a05a0$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $538cc97e635a05a0$var$toStr = Object.prototype.toString;
var $538cc97e635a05a0$var$max = Math.max;
var $538cc97e635a05a0$var$funcType = '[object Function]';
var $538cc97e635a05a0$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $538cc97e635a05a0$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $538cc97e635a05a0$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $538cc97e635a05a0$var$toStr.apply(target) !== $538cc97e635a05a0$var$funcType) throw new TypeError($538cc97e635a05a0$var$ERROR_MESSAGE + target);
    var args = $538cc97e635a05a0$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $538cc97e635a05a0$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $538cc97e635a05a0$var$concatty(args, arguments));
    };
    var boundLength = $538cc97e635a05a0$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $538cc97e635a05a0$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("h6bNL", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("aNcun", function(module, exports) {
'use strict';

var $aW2KH = parcelRequire("aW2KH");

var $6z6Ry = parcelRequire("6z6Ry");

var $h6bNL = parcelRequire("h6bNL");

var $1OSJG = parcelRequire("1OSJG");
/** @type {import('./actualApply')} */ module.exports = $1OSJG || $aW2KH.call($h6bNL, $6z6Ry);

});
parcelRegister("6z6Ry", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("1OSJG", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("9kM6H", function(module, exports) {
'use strict';
var $6cbb4c61d09c3b91$var$call = Function.prototype.call;
var $6cbb4c61d09c3b91$var$$hasOwn = Object.prototype.hasOwnProperty;

var $aW2KH = parcelRequire("aW2KH");
/** @type {import('.')} */ module.exports = $aW2KH.call($6cbb4c61d09c3b91$var$call, $6cbb4c61d09c3b91$var$$hasOwn);

});


parcelRegister("5hUyV", function(module, exports) {
'use strict';

var $jVgSm = parcelRequire("jVgSm");

var $2TrMG = parcelRequire("2TrMG");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $3d9a6a5cc799cfda$var$$indexOf = $2TrMG([
    $jVgSm('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $jVgSm(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $3d9a6a5cc799cfda$var$$indexOf(name, '.prototype.') > -1) return $2TrMG(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});


parcelRegister("5wzGz", function(module, exports) {
'use strict';

var $jVgSm = parcelRequire("jVgSm");

var $5hUyV = parcelRequire("5hUyV");

var $74IIy = parcelRequire("74IIy");

var $dvLVD = parcelRequire("dvLVD");

var $ewY92 = parcelRequire("ewY92");
var $405b9f59667f9529$var$$WeakMap = $jVgSm('%WeakMap%', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */ var $405b9f59667f9529$var$$weakMapGet = $5hUyV('WeakMap.prototype.get', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */ var $405b9f59667f9529$var$$weakMapSet = $5hUyV('WeakMap.prototype.set', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $405b9f59667f9529$var$$weakMapHas = $5hUyV('WeakMap.prototype.has', true);
/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */ var $405b9f59667f9529$var$$weakMapDelete = $5hUyV('WeakMap.prototype.delete', true);
/** @type {import('.')} */ module.exports = $405b9f59667f9529$var$$WeakMap ? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
    /** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */ /** @typedef {Parameters<Channel['get']>[0]} K */ /** @typedef {Parameters<Channel['set']>[1]} V */ /** @type {WeakMap<K & object, V> | undefined} */ var $wm;
    /** @type {Channel | undefined} */ var $m;
    /** @type {Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $ewY92('Side channel does not contain ' + $74IIy(key));
        },
        'delete': function(key) {
            if ($405b9f59667f9529$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $405b9f59667f9529$var$$weakMapDelete($wm, key);
            } else if ($dvLVD) {
                if ($m) return $m['delete'](key);
            }
            return false;
        },
        get: function(key) {
            if ($405b9f59667f9529$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $405b9f59667f9529$var$$weakMapGet($wm, key);
            }
            return $m && $m.get(key);
        },
        has: function(key) {
            if ($405b9f59667f9529$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if ($wm) return $405b9f59667f9529$var$$weakMapHas($wm, key);
            }
            return !!$m && $m.has(key);
        },
        set: function(key, value) {
            if ($405b9f59667f9529$var$$WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
                if (!$wm) $wm = new $405b9f59667f9529$var$$WeakMap();
                $405b9f59667f9529$var$$weakMapSet($wm, key, value);
            } else if ($dvLVD) {
                if (!$m) $m = $dvLVD();
                // eslint-disable-next-line no-extra-parens
                /** @type {NonNullable<typeof $m>} */ $m.set(key, value);
            }
        }
    };
    // @ts-expect-error TODO: figure out why this is erroring
    return channel;
} : $dvLVD;

});


parcelRegister("91zTA", function(module, exports) {
'use strict';

var $5oS8d = parcelRequire("5oS8d");
var $69200d2fcaee5a7b$var$has = Object.prototype.hasOwnProperty;
var $69200d2fcaee5a7b$var$isArray = Array.isArray;
var $69200d2fcaee5a7b$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    return array;
}();
var $69200d2fcaee5a7b$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($69200d2fcaee5a7b$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== 'undefined') compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $69200d2fcaee5a7b$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== 'undefined') obj[i] = source[i];
    return obj;
};
var $69200d2fcaee5a7b$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== 'object') {
        if ($69200d2fcaee5a7b$var$isArray(target)) target.push(source);
        else if (target && typeof target === 'object') {
            if (options && (options.plainObjects || options.allowPrototypes) || !$69200d2fcaee5a7b$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== 'object') return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($69200d2fcaee5a7b$var$isArray(target) && !$69200d2fcaee5a7b$var$isArray(source)) mergeTarget = $69200d2fcaee5a7b$var$arrayToObject(target, options);
    if ($69200d2fcaee5a7b$var$isArray(target) && $69200d2fcaee5a7b$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($69200d2fcaee5a7b$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($69200d2fcaee5a7b$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $69200d2fcaee5a7b$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $69200d2fcaee5a7b$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $69200d2fcaee5a7b$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === 'symbol') string = Symbol.prototype.toString.call(str);
    else if (typeof str !== 'string') string = String(str);
    if (charset === 'iso-8859-1') return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
    });
    var out = '';
    for(var i = 0; i < string.length; ++i){
        var c = string.charCodeAt(i);
        if (c === 0x2D // -
         || c === 0x2E // .
         || c === 0x5F // _
         || c === 0x7E // ~
         || c >= 0x30 && c <= 0x39 // 0-9
         || c >= 0x41 && c <= 0x5A // a-z
         || c >= 0x61 && c <= 0x7A // A-Z
         || format === $5oS8d.RFC1738 && (c === 0x28 || c === 0x29) // ( )
        ) {
            out += string.charAt(i);
            continue;
        }
        if (c < 0x80) {
            out = out + $69200d2fcaee5a7b$var$hexTable[c];
            continue;
        }
        if (c < 0x800) {
            out = out + ($69200d2fcaee5a7b$var$hexTable[0xC0 | c >> 6] + $69200d2fcaee5a7b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        if (c < 0xD800 || c >= 0xE000) {
            out = out + ($69200d2fcaee5a7b$var$hexTable[0xE0 | c >> 12] + $69200d2fcaee5a7b$var$hexTable[0x80 | c >> 6 & 0x3F] + $69200d2fcaee5a7b$var$hexTable[0x80 | c & 0x3F]);
            continue;
        }
        i += 1;
        c = 0x10000 + ((c & 0x3FF) << 10 | string.charCodeAt(i) & 0x3FF);
        /* eslint operator-linebreak: [2, "before"] */ out += $69200d2fcaee5a7b$var$hexTable[0xF0 | c >> 18] + $69200d2fcaee5a7b$var$hexTable[0x80 | c >> 12 & 0x3F] + $69200d2fcaee5a7b$var$hexTable[0x80 | c >> 6 & 0x3F] + $69200d2fcaee5a7b$var$hexTable[0x80 | c & 0x3F];
    }
    return out;
};
var $69200d2fcaee5a7b$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: 'o'
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $69200d2fcaee5a7b$var$compactQueue(queue);
    return value;
};
var $69200d2fcaee5a7b$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};
var $69200d2fcaee5a7b$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $69200d2fcaee5a7b$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $69200d2fcaee5a7b$var$maybeMap = function maybeMap(val, fn) {
    if ($69200d2fcaee5a7b$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
module.exports = {
    arrayToObject: $69200d2fcaee5a7b$var$arrayToObject,
    assign: $69200d2fcaee5a7b$var$assign,
    combine: $69200d2fcaee5a7b$var$combine,
    compact: $69200d2fcaee5a7b$var$compact,
    decode: $69200d2fcaee5a7b$var$decode,
    encode: $69200d2fcaee5a7b$var$encode,
    isBuffer: $69200d2fcaee5a7b$var$isBuffer,
    isRegExp: $69200d2fcaee5a7b$var$isRegExp,
    maybeMap: $69200d2fcaee5a7b$var$maybeMap,
    merge: $69200d2fcaee5a7b$var$merge
};

});
parcelRegister("5oS8d", function(module, exports) {
'use strict';
var $3ee92f01abab8766$var$replace = String.prototype.replace;
var $3ee92f01abab8766$var$percentTwenties = /%20/g;
var $3ee92f01abab8766$var$Format = {
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};
module.exports = {
    'default': $3ee92f01abab8766$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $3ee92f01abab8766$var$replace.call(value, $3ee92f01abab8766$var$percentTwenties, '+');
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $3ee92f01abab8766$var$Format.RFC1738,
    RFC3986: $3ee92f01abab8766$var$Format.RFC3986
};

});



parcelRegister("9Y4KE", function(module, exports) {
'use strict';

var $91zTA = parcelRequire("91zTA");
var $741d67357ecc747a$var$has = Object.prototype.hasOwnProperty;
var $741d67357ecc747a$var$isArray = Array.isArray;
var $741d67357ecc747a$var$defaults = {
    allowDots: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: $91zTA.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};
var $741d67357ecc747a$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $741d67357ecc747a$var$parseArrayValue = function(val, options) {
    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) return val.split(',');
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $741d67357ecc747a$var$isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $741d67357ecc747a$var$charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
var $741d67357ecc747a$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf('utf8=') === 0) {
            if (parts[i] === $741d67357ecc747a$var$charsetSentinel) charset = 'utf-8';
            else if (parts[i] === $741d67357ecc747a$var$isoSentinel) charset = 'iso-8859-1';
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $741d67357ecc747a$var$defaults.decoder, charset, 'key');
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), $741d67357ecc747a$var$defaults.decoder, charset, 'key');
            val = $91zTA.maybeMap($741d67357ecc747a$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $741d67357ecc747a$var$defaults.decoder, charset, 'value');
            });
        }
        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') val = $741d67357ecc747a$var$interpretNumericEntities(val);
        if (part.indexOf('[]=') > -1) val = $741d67357ecc747a$var$isArray(val) ? [
            val
        ] : val;
        if ($741d67357ecc747a$var$has.call(obj, key)) obj[key] = $91zTA.combine(obj[key], val);
        else obj[key] = val;
    }
    return obj;
};
var $741d67357ecc747a$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $741d67357ecc747a$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === '[]' && options.parseArrays) obj = [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== cleanRoot && String(index) === cleanRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (cleanRoot !== '__proto__') obj[cleanRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $741d67357ecc747a$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $741d67357ecc747a$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $741d67357ecc747a$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, just add whatever is left
    if (segment) keys.push('[' + key.slice(segment.index) + ']');
    return $741d67357ecc747a$var$parseObject(keys, val, options, valuesParsed);
};
var $741d67357ecc747a$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $741d67357ecc747a$var$defaults;
    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') throw new TypeError('Decoder has to be a function.');
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    var charset = typeof opts.charset === 'undefined' ? $741d67357ecc747a$var$defaults.charset : opts.charset;
    return {
        allowDots: typeof opts.allowDots === 'undefined' ? $741d67357ecc747a$var$defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : $741d67357ecc747a$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : $741d67357ecc747a$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : $741d67357ecc747a$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : $741d67357ecc747a$var$defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : $741d67357ecc747a$var$defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : $741d67357ecc747a$var$defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || $91zTA.isRegExp(opts.delimiter) ? opts.delimiter : $741d67357ecc747a$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === 'number' || opts.depth === false ? +opts.depth : $741d67357ecc747a$var$defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : $741d67357ecc747a$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : $741d67357ecc747a$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : $741d67357ecc747a$var$defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : $741d67357ecc747a$var$defaults.strictNullHandling
    };
};
module.exports = function(str, opts) {
    var options = $741d67357ecc747a$var$normalizeParseOptions(opts);
    if (str === '' || str === null || typeof str === 'undefined') return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === 'string' ? $741d67357ecc747a$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $741d67357ecc747a$var$parseKeys(key, tempObj[key], options, typeof str === 'string');
        obj = $91zTA.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $91zTA.compact(obj);
};

});


parcelRegister("2M9Wc", function(module, exports) {
'use strict';
module.exports = (str)=>encodeURIComponent(str).replace(/[!'()*]/g, (x)=>`%${x.charCodeAt(0).toString(16).toUpperCase()}`);

});

parcelRegister("e9Lvx", function(module, exports) {
'use strict';
var $a4e6c200ac09b5be$var$token = '%[a-f0-9]{2}';
var $a4e6c200ac09b5be$var$singleMatcher = new RegExp('(' + $a4e6c200ac09b5be$var$token + ')|([^%]+?)', 'gi');
var $a4e6c200ac09b5be$var$multiMatcher = new RegExp('(' + $a4e6c200ac09b5be$var$token + ')+', 'gi');
function $a4e6c200ac09b5be$var$decodeComponents(components, split) {
    try {
        // Try to decode the entire string first
        return [
            decodeURIComponent(components.join(''))
        ];
    } catch (err) {
    // Do nothing
    }
    if (components.length === 1) return components;
    split = split || 1;
    // Split the array in 2 parts
    var left = components.slice(0, split);
    var right = components.slice(split);
    return Array.prototype.concat.call([], $a4e6c200ac09b5be$var$decodeComponents(left), $a4e6c200ac09b5be$var$decodeComponents(right));
}
function $a4e6c200ac09b5be$var$decode(input) {
    try {
        return decodeURIComponent(input);
    } catch (err) {
        var tokens = input.match($a4e6c200ac09b5be$var$singleMatcher) || [];
        for(var i = 1; i < tokens.length; i++){
            input = $a4e6c200ac09b5be$var$decodeComponents(tokens, i).join('');
            tokens = input.match($a4e6c200ac09b5be$var$singleMatcher) || [];
        }
        return input;
    }
}
function $a4e6c200ac09b5be$var$customDecodeURIComponent(input) {
    // Keep track of all the replacements and prefill the map with the `BOM`
    var replaceMap = {
        '%FE%FF': '\uFFFD\uFFFD',
        '%FF%FE': '\uFFFD\uFFFD'
    };
    var match = $a4e6c200ac09b5be$var$multiMatcher.exec(input);
    while(match){
        try {
            // Decode as big chunks as possible
            replaceMap[match[0]] = decodeURIComponent(match[0]);
        } catch (err) {
            var result = $a4e6c200ac09b5be$var$decode(match[0]);
            if (result !== match[0]) replaceMap[match[0]] = result;
        }
        match = $a4e6c200ac09b5be$var$multiMatcher.exec(input);
    }
    // Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
    replaceMap['%C2'] = '\uFFFD';
    var entries = Object.keys(replaceMap);
    for(var i = 0; i < entries.length; i++){
        // Replace all decoded components
        var key = entries[i];
        input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
    }
    return input;
}
module.exports = function(encodedURI) {
    if (typeof encodedURI !== 'string') throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
    try {
        encodedURI = encodedURI.replace(/\+/g, ' ');
        // Try the built in decoder first
        return decodeURIComponent(encodedURI);
    } catch (err) {
        // Fallback to a more advanced decoder
        return $a4e6c200ac09b5be$var$customDecodeURIComponent(encodedURI);
    }
};

});

parcelRegister("c6Dsu", function(module, exports) {
'use strict';
module.exports = (string, separator)=>{
    if (!(typeof string === 'string' && typeof separator === 'string')) throw new TypeError('Expected the arguments to be of type `string`');
    if (separator === '') return [
        string
    ];
    const separatorIndex = string.indexOf(separator);
    if (separatorIndex === -1) return [
        string
    ];
    return [
        string.slice(0, separatorIndex),
        string.slice(separatorIndex + separator.length)
    ];
};

});

parcelRegister("kO9sb", function(module, exports) {
'use strict';
module.exports = function(obj, predicate) {
    var ret = {};
    var keys = Object.keys(obj);
    var isArr = Array.isArray(predicate);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        var val = obj[key];
        if (isArr ? predicate.indexOf(key) !== -1 : predicate(key, val, obj)) ret[key] = val;
    }
    return ret;
};

});

parcelRegister("emCaV", function(module, exports) {
$parcel$export(module.exports, "default", () => $a750bb8e211c7704$export$2e2bcd8739ae039);
var $a750bb8e211c7704$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $a750bb8e211c7704$var$isEqual(first, second) {
    if (first === second) return true;
    if ($a750bb8e211c7704$var$safeIsNaN(first) && $a750bb8e211c7704$var$safeIsNaN(second)) return true;
    return false;
}
function $a750bb8e211c7704$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$a750bb8e211c7704$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $a750bb8e211c7704$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $a750bb8e211c7704$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}

});

parcelRegister("hM7YN", function(module, exports) {
'use strict';

var $a4fvn = parcelRequire("a4fvn");
/**
 * Expose `traverse`.
 */ module.exports = $cf0d1bebe982b20e$var$traverse;
/**
 * Recursively traverse an object or array, and convert
 * all ISO date strings parse into Date objects.
 *
 * @param {Object} input - object, array, or string to convert
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $cf0d1bebe982b20e$var$traverse(input, strict) {
    if (strict === undefined) strict = true;
    if (input && typeof input === 'object') return $cf0d1bebe982b20e$var$traverseObject(input, strict);
    else if (Array.isArray(input)) return $cf0d1bebe982b20e$var$traverseArray(input, strict);
    else if ($a4fvn.is(input, strict)) return $a4fvn.parse(input);
    return input;
}
/**
 * Object traverser helper function.
 *
 * @param {Object} obj - object to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Object}
 */ function $cf0d1bebe982b20e$var$traverseObject(obj, strict) {
    Object.keys(obj).forEach(function(key) {
        obj[key] = $cf0d1bebe982b20e$var$traverse(obj[key], strict);
    });
    return obj;
}
/**
 * Array traverser helper function
 *
 * @param {Array} arr - array to traverse
 * @param {Boolean} strict - only convert strings with year, month, and date
 * @return {Array}
 */ function $cf0d1bebe982b20e$var$traverseArray(arr, strict) {
    arr.forEach(function(value, index) {
        arr[index] = $cf0d1bebe982b20e$var$traverse(value, strict);
    });
    return arr;
}

});
parcelRegister("a4fvn", function(module, exports) {
$parcel$export(module.exports, "parse", () => $75464e1cc7d9f076$export$98e6a39c04603d36, (v) => $75464e1cc7d9f076$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "is", () => $75464e1cc7d9f076$export$226b3eccf92c9ed9, (v) => $75464e1cc7d9f076$export$226b3eccf92c9ed9 = v);
/**
 * Convert an ISO date string to a date. Fallback to native `Date.parse`.
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 *
 * @param {String} iso
 * @return {Date}
 */ var $75464e1cc7d9f076$export$98e6a39c04603d36;
/**
 * Checks whether a `string` is an ISO date string. `strict` mode requires that
 * the date string at least have a year, month and date.
 *
 * @param {String} string
 * @param {Boolean} strict
 * @return {Boolean}
 */ var $75464e1cc7d9f076$export$226b3eccf92c9ed9;
'use strict';
/**
 * Matcher, slightly modified from:
 *
 * https://github.com/csnover/js-iso8601/blob/lax/iso8601.js
 */ var $75464e1cc7d9f076$var$matcher = /^(\d{4})(?:-?(\d{2})(?:-?(\d{2}))?)?(?:([ T])(\d{2}):?(\d{2})(?::?(\d{2})(?:[,\.](\d{1,}))?)?(?:(Z)|([+\-])(\d{2})(?::?(\d{2}))?)?)?$/;
$75464e1cc7d9f076$export$98e6a39c04603d36 = function(iso) {
    var numericKeys = [
        1,
        5,
        6,
        7,
        11,
        12
    ];
    var arr = $75464e1cc7d9f076$var$matcher.exec(iso);
    var offset = 0;
    // fallback to native parsing
    if (!arr) return new Date(iso);
    /* eslint-disable no-cond-assign */ // remove undefined values
    for(var i = 0, val; val = numericKeys[i]; i++)arr[val] = parseInt(arr[val], 10) || 0;
    /* eslint-enable no-cond-assign */ // allow undefined days and months
    arr[2] = parseInt(arr[2], 10) || 1;
    arr[3] = parseInt(arr[3], 10) || 1;
    // month is 0-11
    arr[2]--;
    // allow abitrary sub-second precision
    arr[8] = arr[8] ? (arr[8] + '00').substring(0, 3) : 0;
    // apply timezone if one exists
    if (arr[4] === ' ') offset = new Date().getTimezoneOffset();
    else if (arr[9] !== 'Z' && arr[10]) {
        offset = arr[11] * 60 + arr[12];
        if (arr[10] === '+') offset = 0 - offset;
    }
    var millis = Date.UTC(arr[1], arr[2], arr[3], arr[5], arr[6] + offset, arr[7], arr[8]);
    return new Date(millis);
};
$75464e1cc7d9f076$export$226b3eccf92c9ed9 = function(string, strict) {
    if (typeof string !== 'string') return false;
    if (strict && /^\d{4}-\d{2}-\d{2}/.test(string) === false) return false;
    return $75464e1cc7d9f076$var$matcher.test(string);
};

});


parcelRegister("6CfY5", function(module, exports) {
$parcel$export(module.exports, "default", () => $3283e755f15f15ff$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $66ukR = parcelRequire("66ukR");

var $75sVW = parcelRequire("75sVW");

var $ff8AH = parcelRequire("ff8AH");

var $a1u1w = parcelRequire("a1u1w");

var $9yVW0 = parcelRequire("9yVW0");
const $3283e755f15f15ff$var$MAX_CONCURRENCY_FOR_THROTTLE = 5;
const $3283e755f15f15ff$var$throttleInstance = (0, $a1u1w.default)($3283e755f15f15ff$var$MAX_CONCURRENCY_FOR_THROTTLE);
if (typeof window !== 'undefined') window.addEventListener('beforeunload', $3283e755f15f15ff$var$throttleInstance.flush);
// Each log call passes in a location - a path to the file with '.' separation. This utility will
// prepend 'jira.frontend.' to this location before it is sent.
// For example, 'jira.frontend.issue.state.reducers.entities.reducer'.
//
// Log messages and events must only contain privacy-safe information.
const $3283e755f15f15ff$var$isProduction = ()=>true;
const $3283e755f15f15ff$var$sendToServer = (body, endpoint)=>{
    const fetchOptions = {
        ...(0, $ff8AH.getDefaultOptions)(endpoint),
        method: 'POST',
        body: body
    };
    return fetch(endpoint, fetchOptions);
};
const $3283e755f15f15ff$var$sendToConsole = (body, endpoint, level, message, eventType, event)=>{
    // eslint-disable-next-line no-console
    console[level]('%cJIRA %s %c(POST %s)\n%cMessage\n%c%s\n\n%cEvent body\n%c%s\n\n%cException object and Stack trace (expand to jump to source)\n', 'font-size: 14px; font-weight: bold;', level.toUpperCase(), 'font-size: 10px; font-family: monospace;', endpoint, 'font-family: sans-serif; font-weight: bold; font-size: 12px', 'font-family: sans-serif; font-weight: initial;', message, 'font-family: sans-serif; font-weight: bold;', 'font-family: monospace; font-weight: initial;', body, 'font-family: sans-serif; font-size: 12px; font-weight: bold;', event);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const currentWindow = window;
    if (!$3283e755f15f15ff$var$isProduction() && currentWindow.Cypress) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (!window.cypressSafeErrorsLog) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog = [];
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.cypressSafeErrorsLog.push({
            body: body,
            endpoint: endpoint,
            level: level,
            message: message
        });
    }
    if (eventType !== 'object') {
        const errorMessage = `Invalid log API usage: expected event of type 'object', but was ${eventType}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    if (typeof body !== 'string') {
        const errorMessage = `Invalid log API usage: expected event of type 'string', but was ${eventType}; message will be replaced by: ${String(message)}`;
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
    return Promise.resolve();
};
const $3283e755f15f15ff$var$joinArrayFields = (error)=>Object.fromEntries(Object.entries(error).map(([key, value])=>{
        if (Array.isArray(value)) return [
            key,
            value.join(', ')
        ];
        return [
            key,
            value
        ];
    }));
const $3283e755f15f15ff$var$transformError = (error)=>{
    const commonProperties = {
        message: error.message,
        stack: error.stack
    };
    // Not importing ValidationError and performing instanceof check because it's causing bundle size increase for skeletons.
    // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'. | TS2339 - Property 'errors' does not exist on type 'Error'.
    if (error.name === (0, $75sVW.VALIDATION_ERROR_NAME) && error.errors && error.errors.map) {
        // @ts-expect-error - TS2339 - Property 'errors' does not exist on type 'Error'.
        const { errors: errors, ...otherProperties } = error;
        // @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
        const invalidFields = errors.map((item)=>item.field).join(', ');
        // @ts-expect-error - TS2322 - Type '{ name: string; message: string; stack: string | undefined; invalidFields: any; }' is not assignable to type '{ [key: string]: string | number; }'.
        return {
            ...commonProperties,
            invalidFields: invalidFields,
            ...otherProperties
        };
    }
    const result = {
        ...commonProperties,
        ...error
    };
    return $3283e755f15f15ff$var$joinArrayFields(result);
};
const $3283e755f15f15ff$var$transformData = (location, message, event)=>{
    const { name: browserName, version: browserVersion } = (0, $66ukR.getBrowser)();
    return {
        sentFrom: `jira.frontend.${location}`,
        message: String(message),
        event: event instanceof Error ? $3283e755f15f15ff$var$transformError(event) : event,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        buildKey: window.BUILD_KEY,
        logTime: new Date().toISOString(),
        browserName: browserName,
        browserVersion: browserVersion
    };
};
const $3283e755f15f15ff$var$sendData = async (level, location, message, event = {})=>{
    if (false) {
        switch(level){
            case 'info':
                // eslint-disable-next-line no-console
                console.info({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            case 'warn':
                // eslint-disable-next-line no-console
                console.warn({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            case 'error':
                // eslint-disable-next-line no-console
                console.error({
                    location: location,
                    message: message,
                    event: event
                });
                break;
            default:
                {
                    // Exhaustive check
                    const never = level;
                    return never;
                }
        }
        return;
    }
    const data = $3283e755f15f15ff$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = `/rest/internal/2/log/safe/${level}`;
    if ($3283e755f15f15ff$var$isProduction()) return new Promise((resolve, reject)=>{
        $3283e755f15f15ff$var$throttleInstance.add(()=>$3283e755f15f15ff$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $3283e755f15f15ff$var$sendToConsole(body, endpoint, level, message, typeof event, event);
};
async function $3283e755f15f15ff$var$rateLimitedSendData(level, location, message, event = {}) {
    return (0, $9yVW0.getLoggerRateLimiter)().rateLimit(`${level}.${location}.${String(message).slice(0, 15)}`, ()=>$3283e755f15f15ff$var$sendData(level, location, message, event), ()=>{
        if (!$3283e755f15f15ff$var$isProduction()) // this will be logged to the console because we are in development mode
        return $3283e755f15f15ff$var$sendData('error', 'platform.logging', `Rate limit reached for ${location} - in production log will NOT be sent - ensure you aren't sending too many logs! Original message: ${message}`, event);
    });
}
/** This function logs privacy safe info.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event
 *
 * @example Usage
 * safeInfoWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource INFO "my.location.string"
 */ const $3283e755f15f15ff$var$safeInfoWithoutCustomerData = async (location, message, event)=>{
    await $3283e755f15f15ff$var$rateLimitedSendData('info', location, message, event);
};
/** This function logs privacy safe warnings.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeWarnWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource WARN "my.location.string"
 */ const $3283e755f15f15ff$var$safeWarnWithoutCustomerData = async (location, message, event)=>{
    await $3283e755f15f15ff$var$rateLimitedSendData('warn', location, message, event);
};
/** This function logs privacy safe errors.
 * The content must not include any personally identifiable information (PII) or user generated content (UGC).
 * In Jira, UGC includes issue keys, project keys etc. Please see go/jira-ugc for more information.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 *
 * @example Usage
 * safeErrorWithoutCustomerData('my.code.location', 'Something went wrong');
 * @example Splunk query
 * `micros_jira-prod_all` LoggingResource ERROR "my.location.string"
 */ const $3283e755f15f15ff$var$safeErrorWithoutCustomerData = async (location, message, event)=>{
    await $3283e755f15f15ff$var$rateLimitedSendData('error', location, message, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ const $3283e755f15f15ff$var$unsafeErrorWithCustomerDataNotRateLimited = async (location, message, event = {})=>{
    const data = $3283e755f15f15ff$var$transformData(location, message, event);
    const body = JSON.stringify(data);
    const endpoint = '/rest/internal/2/log/unsafe/frontend-exception';
    if (false) {
        // eslint-disable-next-line no-console
        console.error({
            location: location,
            message: message,
            event: event
        });
        return;
    }
    if ($3283e755f15f15ff$var$isProduction()) return new Promise((resolve, reject)=>{
        $3283e755f15f15ff$var$throttleInstance.add(()=>$3283e755f15f15ff$var$sendToServer(body, endpoint).then(()=>resolve()).catch(reject));
    });
    return $3283e755f15f15ff$var$sendToConsole(body, endpoint, 'error', message, typeof event, event);
};
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 * It is rate limited to ensure that we don't overwhelm the endpoint
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ async function $3283e755f15f15ff$var$unsafeErrorWithCustomerDataRateLimited(location, message, event = {}) {
    return (0, $9yVW0.getLoggerRateLimiter)().rateLimit(`error.${location}${String(message).slice(0, 15)}`, ()=>$3283e755f15f15ff$var$unsafeErrorWithCustomerDataNotRateLimited(location, message, event), ()=>{
        if (!$3283e755f15f15ff$var$isProduction()) // this will be logged to the console because we are in development mode
        return $3283e755f15f15ff$var$sendData('error', 'platform.logging', `Rate limit reached for ${location} - in production log will NOT be sent - ensure you aren't sending too many logs! Original message: ${message}`, event);
    });
}
// This is a stop gap measure until Sentry is fully rolled out
/** This function logs privacy Unsafe warnings.
 * It is rate limited to ensure that we don't overwhelm the endpoint
 *
 * @param location the lower-case, '.' separated path to the file that you are logging from.
 * @param message the message to be logged.
 * @param event the error that is thrown.
 */ async function $3283e755f15f15ff$var$unsafeErrorWithCustomerData(location, message, event = {}) {
    return $3283e755f15f15ff$var$unsafeErrorWithCustomerDataRateLimited(location, message, event);
}
const $3283e755f15f15ff$var$log = {
    safeInfoWithoutCustomerData: $3283e755f15f15ff$var$safeInfoWithoutCustomerData,
    safeWarnWithoutCustomerData: $3283e755f15f15ff$var$safeWarnWithoutCustomerData,
    safeErrorWithoutCustomerData: $3283e755f15f15ff$var$safeErrorWithoutCustomerData,
    unsafeErrorWithCustomerData: $3283e755f15f15ff$var$unsafeErrorWithCustomerData
};
var $3283e755f15f15ff$export$2e2bcd8739ae039 = $3283e755f15f15ff$var$log;

});
parcelRegister("66ukR", function(module, exports) {
$parcel$export(module.exports, "getBrowser", () => $61970779dc0dd772$export$89e15fc796a4a429);
$parcel$export(module.exports, "isIE11", () => $61970779dc0dd772$export$f7bad96d83325a34);
$parcel$export(module.exports, "isEdge", () => $61970779dc0dd772$export$cac3980734d91fbe);
$parcel$export(module.exports, "isChrome", () => $61970779dc0dd772$export$6446a186d09e379e);
$parcel$export(module.exports, "isSafari", () => $61970779dc0dd772$export$95df08bae54cb4df);
$parcel$export(module.exports, "isFirefox", () => $61970779dc0dd772$export$b7d78993b74f766d);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $9njAx = parcelRequire("9njAx");
let $61970779dc0dd772$var$parsedUA;
const $61970779dc0dd772$var$parseUserAgent = ()=>{
    if ($61970779dc0dd772$var$parsedUA === undefined) {
        const userAgent = typeof navigator !== 'undefined' && navigator.userAgent;
        $61970779dc0dd772$var$parsedUA = userAgent ? (0, (/*@__PURE__*/$parcel$interopDefault($9njAx))).getParser(userAgent) : null;
    }
    return $61970779dc0dd772$var$parsedUA;
};
const $61970779dc0dd772$var$getBrowserNameAndVersion = ()=>{
    const browser = $61970779dc0dd772$var$parseUserAgent();
    if (browser) return browser.getBrowser();
    return {
        name: '',
        version: ''
    };
};
const $61970779dc0dd772$var$isGreaterOrEqualToMinimumVersion = (bowserVersion, minimumVersion)=>{
    const parts = bowserVersion.split('.');
    const part1 = parts[0];
    const part2 = parts[1];
    let version;
    if (part2) version = `${part1}.${part2}`;
    else version = part1;
    return Number(version) >= minimumVersion;
};
const $61970779dc0dd772$export$89e15fc796a4a429 = ()=>$61970779dc0dd772$var$getBrowserNameAndVersion();
const $61970779dc0dd772$export$f7bad96d83325a34 = ()=>{
    const { name: name, version: version } = $61970779dc0dd772$var$getBrowserNameAndVersion();
    return name === 'Internet Explorer' && version === '11.0';
};
const $61970779dc0dd772$export$cac3980734d91fbe = (minimumVersion = 0)=>{
    const { name: name, version: version } = $61970779dc0dd772$var$getBrowserNameAndVersion();
    return name === 'Microsoft Edge' && $61970779dc0dd772$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $61970779dc0dd772$export$6446a186d09e379e = (minimumVersion = 0)=>{
    const { name: name, version: version } = $61970779dc0dd772$var$getBrowserNameAndVersion();
    return name === 'Chrome' && $61970779dc0dd772$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $61970779dc0dd772$export$95df08bae54cb4df = (minimumVersion = 0)=>{
    const { name: name, version: version } = $61970779dc0dd772$var$getBrowserNameAndVersion();
    return name === 'Safari' && $61970779dc0dd772$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};
const $61970779dc0dd772$export$b7d78993b74f766d = (minimumVersion = 0)=>{
    const { name: name, version: version } = $61970779dc0dd772$var$getBrowserNameAndVersion();
    return name === 'Firefox' && $61970779dc0dd772$var$isGreaterOrEqualToMinimumVersion(version || '', minimumVersion);
};

});
parcelRegister("9njAx", function(module, exports) {
!function(e, r) {
    module.exports = r();
}(module.exports, function() {
    return function(e) {
        var r = {};
        function t(n) {
            if (r[n]) return r[n].exports;
            var i = r[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, t), i.l = !0, i.exports;
        }
        return t.m = e, t.c = r, t.d = function(e, r, n) {
            t.o(e, r) || Object.defineProperty(e, r, {
                enumerable: !0,
                get: n
            });
        }, t.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, t.t = function(e, r) {
            if (1 & r && (e = t(e)), 8 & r) return e;
            if (4 & r && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (t.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & r && "string" != typeof e) for(var i in e)t.d(n, i, (function(r) {
                return e[r];
            }).bind(null, i));
            return n;
        }, t.n = function(e) {
            var r = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return t.d(r, "a", r), r;
        }, t.o = function(e, r) {
            return Object.prototype.hasOwnProperty.call(e, r);
        }, t.p = "", t(t.s = 0);
    }([
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(1)) && n.__esModule ? n : {
                default: n
            };
            /*!
 * Bowser - a browser detector
 * https://github.com/lancedikson/bowser
 * MIT License | (c) Dustin Diaz 2012-2015
 * MIT License | (c) Denis Demchenko 2015-2019
 */ var o = function() {
                function e() {}
                return e.getParser = function(e, r) {
                    if (void 0 === r && (r = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, r);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            r.__esModule = !0, r.default = void 0;
            var n, i = (n = t(2)) && n.__esModule ? n : {
                default: n
            };
            var o = function() {
                function e(e, r) {
                    if (void 0 === r && (r = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== r && this.parse();
                }
                var r = e.prototype;
                return r.getUA = function() {
                    return this._ua;
                }, r.test = function(e) {
                    return e.test(this._ua);
                }, r.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var r = i.default.find(function(r) {
                        if ("function" == typeof r.test) return r.test(e);
                        if (r.test instanceof Array) return r.test.some(function(r) {
                            return e.test(r);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return r && (this.parsedResult.browser = r.describe(this.getUA())), this.parsedResult.browser;
                }, r.isMobile = function() {
                    return this.test(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i);
                }, r.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, r.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, r.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, r.parse = function() {
                    return this.parseBrowser(), this;
                }, r.getResult = function() {
                    return Object.assign({}, this.parsedResult);
                }, e;
            }();
            r.default = o, e.exports = r.default;
        },
        function(e, r, t) {
            "use strict";
            function n(e, r) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (t) return (t = t.call(e)).next.bind(t);
                if (Array.isArray(e) || (t = function(e, r) {
                    if (!e) return;
                    if ("string" == typeof e) return i(e, r);
                    var t = Object.prototype.toString.call(e).slice(8, -1);
                    "Object" === t && e.constructor && (t = e.constructor.name);
                    if ("Map" === t || "Set" === t) return Array.from(e);
                    if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return i(e, r);
                }(e)) || r && e && "number" == typeof e.length) {
                    t && (e = t);
                    var n = 0;
                    return function() {
                        return n >= e.length ? {
                            done: !0
                        } : {
                            done: !1,
                            value: e[n++]
                        };
                    };
                }
                throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            function i(e, r) {
                (null == r || r > e.length) && (r = e.length);
                for(var t = 0, n = new Array(r); t < r; t++)n[t] = e[t];
                return n;
            }
            r.__esModule = !0, r.default = void 0;
            var o = function(e, r) {
                var t = r.match(e);
                return t && t.length > 0 && t[1] || "";
            }, s = function(e, r) {
                var t = r.match(e);
                return t && t.length > 1 && t[2] || "";
            }, u = /version\/(\d+(\.?_?\d+)+)/i, a = function(e, r) {
                void 0 === e && (e = []);
                for(var t, i = n(e); !(t = i()).done;){
                    var s = t.value, u = o(s, r);
                    if (u) return u;
                }
                return null;
            }, d = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Googlebot",
                            version: a([
                                /googlebot\/(\d+(\.\d+))/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                u,
                                /(?:opera)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera",
                            version: a([
                                /(?:opr|opios)[\s/](\S+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Samsung Internet for Android",
                            version: a([
                                u,
                                /(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        return {
                            name: "NAVER Whale Browser",
                            version: a([
                                u,
                                /(?:whale)[\s/](\d+(?:\.\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Coast",
                            version: a([
                                u,
                                /(?:coast)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Opera Touch",
                            version: a([
                                /(?:opt)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Internet Explorer",
                            version: a([
                                /(?:msie |rv:)(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: a([
                                /\sedg\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Microsoft Edge",
                            version: s(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e)
                        };
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Vivaldi",
                            version: a([
                                /vivaldi\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Tizen",
                            version: a([
                                /(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Firefox",
                            version: a([
                                /(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Electron",
                            version: a([
                                /(?:electron)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chromium",
                            version: a([
                                /(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Chrome",
                            version: a([
                                /(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Google Search",
                            version: a([
                                /(?:GSA)\/(\d+(\.?_?\d+)+)/i
                            ], e)
                        };
                    }
                },
                {
                    test: function(e) {
                        var r = !e.test(/like android/i), t = e.test(/android/i);
                        return r && t;
                    },
                    describe: function(e) {
                        return {
                            name: "Android Browser",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        return {
                            name: "Safari",
                            version: a([
                                u
                            ], e)
                        };
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var r = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: o(r, e),
                            version: s(r, e)
                        };
                    }
                }
            ];
            r.default = d, e.exports = r.default;
        }
    ]);
});

});


parcelRegister("75sVW", function(module, exports) {
$parcel$export(module.exports, "ABORT_ERROR_NAME", () => $dfd15810ef9e1d85$export$41b7a909d5bcdc59);
$parcel$export(module.exports, "VALIDATION_ERROR_NAME", () => $dfd15810ef9e1d85$export$e7d64b75be4ed4e4);
$parcel$export(module.exports, "ValidationError", () => $dfd15810ef9e1d85$export$2191b9da168c6cf0);
$parcel$export(module.exports, "isValidationError", () => $dfd15810ef9e1d85$export$f715db496ec47204);
$parcel$export(module.exports, "default", () => $dfd15810ef9e1d85$export$2e2bcd8739ae039);
$parcel$export(module.exports, "isFetchError", () => $dfd15810ef9e1d85$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isRelayNetworkError", () => $dfd15810ef9e1d85$export$1a949ef92fd30eca);
/* eslint-disable jira/filename-case, max-classes-per-file */ 
var $2KgJI = parcelRequire("2KgJI");
const $dfd15810ef9e1d85$export$764da004e4110fae = 'TypeError';
const $dfd15810ef9e1d85$export$41b7a909d5bcdc59 = 'AbortError';
const $dfd15810ef9e1d85$export$e7d64b75be4ed4e4 = 'ValidationError';
const $dfd15810ef9e1d85$export$83179404a61b001a = 'FetchError';
const $dfd15810ef9e1d85$export$7b6e63f2cd1be6ea = 'RelayNetwork';
class $dfd15810ef9e1d85$export$2191b9da168c6cf0 extends (0, $2KgJI.default) {
    constructor(message, errors = [], statusCode, traceId, originalResponse){
        super(message, {
            cause: errors[0]
        });
        // Setting name to a hardcoded string so it doesn't get obfuscated. This is used for my poor man's instanceof
        // check in common/util/logging/log.js.
        this.name = $dfd15810ef9e1d85$export$e7d64b75be4ed4e4;
        this.errors = errors;
        this.statusCode = statusCode;
        this.skipSentry = true;
        this.traceId = traceId;
        this.originalResponse = originalResponse;
    }
}
$dfd15810ef9e1d85$export$2191b9da168c6cf0.displayName = "ValidationError";
const $dfd15810ef9e1d85$export$f715db496ec47204 = (error)=>error.name === $dfd15810ef9e1d85$export$e7d64b75be4ed4e4;
class $dfd15810ef9e1d85$export$2e2bcd8739ae039 extends (0, $2KgJI.default) {
    constructor(statusCode, message, traceId, originalResponse){
        super(message || `Fetch call failed with status code: ${statusCode}`);
        this.name = $dfd15810ef9e1d85$export$83179404a61b001a;
        this.statusCode = statusCode;
        this.originalResponse = originalResponse;
        this.skipSentry = statusCode === 401;
        if (traceId) this.traceId = traceId;
    }
}
$dfd15810ef9e1d85$export$2e2bcd8739ae039.displayName = "FetchError";
const $dfd15810ef9e1d85$export$96f7e6db4105d70c = (error)=>error instanceof $dfd15810ef9e1d85$export$2e2bcd8739ae039 && error.name === $dfd15810ef9e1d85$export$83179404a61b001a;
const $dfd15810ef9e1d85$export$1a949ef92fd30eca = (error)=>error.name === $dfd15810ef9e1d85$export$7b6e63f2cd1be6ea;

});
parcelRegister("2KgJI", function(module, exports) {
$parcel$export(module.exports, "default", () => $984a99bc0d9dc151$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $984a99bc0d9dc151$export$2e2bcd8739ae039 extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message, options);
        this.name = this.constructor.name;
    }
}
$984a99bc0d9dc151$export$2e2bcd8739ae039.displayName = "ExtensibleError";

});


parcelRegister("ff8AH", function(module, exports) {
$parcel$export(module.exports, "getDefaultOptions", () => $928d23c8ac3ec63a$export$430a3269e24b912e);
$parcel$export(module.exports, "defaultOptions", () => $928d23c8ac3ec63a$export$ba43bf67f3d48107);
/* eslint-disable jira/filename-case */ 
var $5cVSt = parcelRequire("5cVSt");

var $99tc1 = parcelRequire("99tc1");
function $928d23c8ac3ec63a$export$430a3269e24b912e(url) {
    let options = {
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
            // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            Accept: [
                'application/json',
                'text/javascript',
                '*/*'
            ],
            ...false ? {
                // Needed for call to monolith
                'x-ssr-asap-audience': 'jira'
            } : {}
        }
    };
    options = url ? (0, $5cVSt.applyObservabilityHeaders)(url, options) : options;
    if (false) options = (0, $99tc1.applySsrFetchConfigOverrideHeaders)(options);
    return options;
}
const $928d23c8ac3ec63a$export$ba43bf67f3d48107 = {
    credentials: 'same-origin',
    headers: {
        'Content-Type': 'application/json',
        // Flow's RequestOptions type doesn't allow an array here, but it works in practice ¯\_(ツ)_/¯
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        Accept: [
            'application/json',
            'text/javascript',
            '*/*'
        ],
        ...false ? {
            // Needed for call to monolith
            'x-ssr-asap-audience': 'jira'
        } : {}
    }
};

});
parcelRegister("5cVSt", function(module, exports) {
$parcel$export(module.exports, "makeObservabilityHeaders", () => $4ead973202c1af06$export$78a090c6aabf87d6);
$parcel$export(module.exports, "applyObservabilityHeaders", () => $4ead973202c1af06$export$f51f2ccd07af96d8);
/* eslint-disable jira/filename-case */ 
var $21iIq = parcelRequire("21iIq");

var $anDmR = parcelRequire("anDmR");

var $2e4T3 = parcelRequire("2e4T3");


var $lB7xL = parcelRequire("lB7xL");

var $8ebMH = parcelRequire("8ebMH");
const $4ead973202c1af06$export$78a090c6aabf87d6 = ()=>{
    const headers = {};
    const capability = (0, $lB7xL.getCapability)();
    const capabilityHeader = (0, $8ebMH.getEnhancedCapabilityHeader)(capability);
    if (capabilityHeader) headers[0, $0ce01f968965dadd$export$9a80695e72849f84] = capabilityHeader;
    // Check React UFO trace context first - Set by React UFO experiences
    const tracingHeaders = (0, $anDmR.getActiveTraceHttpRequestHeaders)();
    if (tracingHeaders !== null) Object.assign(headers, tracingHeaders);
    else {
        // Check platform trace context next - Set by BM3 and UFOv1 experiences
        const platformActiveTraceHeaders = (0, $2e4T3.getActiveTraceHttpHeaders)();
        if (platformActiveTraceHeaders) Object.assign(headers, platformActiveTraceHeaders);
    }
    if (Object.keys(headers).length === 0) return null;
    return {
        headers: headers
    };
};
const $4ead973202c1af06$export$f51f2ccd07af96d8 = (url, options)=>{
    const endpointUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(url);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!false && endpointUrl.hostname && endpointUrl.hostname !== window.location.hostname) return options;
    const extraHeaders = $4ead973202c1af06$export$78a090c6aabf87d6();
    if (extraHeaders === null) return options;
    return {
        ...options,
        headers: {
            ...options.headers,
            ...extraHeaders.headers
        }
    };
};

});
/* eslint-disable jira/filename-case */ const $0ce01f968965dadd$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $0ce01f968965dadd$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $0ce01f968965dadd$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $0ce01f968965dadd$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $0ce01f968965dadd$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $0ce01f968965dadd$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $0ce01f968965dadd$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $0ce01f968965dadd$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $0ce01f968965dadd$export$4695c1a423ffe431 = 'DASHBOARD';
const $0ce01f968965dadd$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $0ce01f968965dadd$export$49d57bef9ac2550b = 'GLOBAL_ISSUE_CREATE';
const $0ce01f968965dadd$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("lB7xL", function(module, exports) {
$parcel$export(module.exports, "setCapability", () => $79191288c1bc0717$export$60e3f676689faf78);
$parcel$export(module.exports, "getCapability", () => $79191288c1bc0717$export$38805c31c710553c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ let $79191288c1bc0717$var$activeCapability = null;
const $79191288c1bc0717$export$60e3f676689faf78 = (capability)=>{
    $79191288c1bc0717$var$activeCapability = capability;
};
const $79191288c1bc0717$export$38805c31c710553c = ()=>$79191288c1bc0717$var$activeCapability;

});

parcelRegister("8ebMH", function(module, exports) {
$parcel$export(module.exports, "getEnhancedCapabilityHeader", () => $6023dca808325528$export$8660821f7e55d98b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $qqoKJ = parcelRequire("qqoKJ");

var $siTdT = parcelRequire("siTdT");
function $6023dca808325528$export$8660821f7e55d98b(capability) {
    if (capability == null) return capability;
    const defaultCapabilityHeader = `${capability}--other`;
    const interactionId = (0, $qqoKJ.getInteractionId)().current;
    if (!interactionId) return defaultCapabilityHeader;
    const currentInteractionType = (0, $siTdT.getCurrentInteractionType)(interactionId);
    if (currentInteractionType === 'page_load') return `${capability}--page-load`;
    if (currentInteractionType === 'transition') return `${capability}--transition`;
    return defaultCapabilityHeader;
}

});


parcelRegister("99tc1", function(module, exports) {
$parcel$export(module.exports, "applySsrFetchConfigOverrideHeaders", () => $b977a897ab154d77$export$87d0e095d7489e93);
/* eslint-disable jira/filename-case */ // Config moved here from https://bitbucket.org/atlassian/tesseract-runtime/src/3f10e7565def764b620b5c85c92b4dd3275dbd3c/services/deploy-service/src/params.ts#lines-247:249
// so that it is set consistently in regular Tesseract and Tesseract dynamic.
const $b977a897ab154d77$var$SSR_FETCH_CONFIG_OVERRIDES = JSON.stringify({
    atlassianProxy: '/',
    useASAPForAnonymousAtlassianProxy: true,
    atlassianGraphQLGateway: '/gateway/api/graphql'
});
const $b977a897ab154d77$export$87d0e095d7489e93 = (request)=>{
    return {
        ...request,
        headers: {
            ...request.headers,
            'x-ssr-fetch-config-overrides': $b977a897ab154d77$var$SSR_FETCH_CONFIG_OVERRIDES
        }
    };
};

});


parcelRegister("a1u1w", function(module, exports) {
$parcel$export(module.exports, "default", () => $566b6a1efeb31aa1$export$2e2bcd8739ae039);
const $566b6a1efeb31aa1$var$throttleLogs = (limit)=>{
    const queue = [];
    let activeCount = 0;
    const next = ()=>{
        if (queue.length > 0 && activeCount < limit) {
            const fn = queue.shift();
            if (fn) {
                activeCount++;
                fn().finally(()=>{
                    activeCount--;
                    next();
                });
            }
        }
    };
    const add = (fn)=>{
        queue.push(fn);
        next();
    };
    const flush = async ()=>{
        const promises = [];
        while(queue.length > 0){
            const fn = queue.shift();
            if (fn) promises.push(fn());
        }
        await Promise.all(promises);
    };
    return {
        add: add,
        flush: flush
    };
};
var $566b6a1efeb31aa1$export$2e2bcd8739ae039 = $566b6a1efeb31aa1$var$throttleLogs;

});

parcelRegister("9yVW0", function(module, exports) {
$parcel$export(module.exports, "getLoggerRateLimiter", () => $974c6351c00ccec1$export$420cad296e3fe0ba);
/* eslint-disable jira/filename-case */ 
var $jqw9k = parcelRequire("jqw9k");
// each location can only send four requests per minute for each level + location + first 15 chars of message
// This is a upper-bound, not a target so please send less.
const $974c6351c00ccec1$var$rateLimiter = new (0, $jqw9k.RateLimiter)(60, 4);
function $974c6351c00ccec1$export$420cad296e3fe0ba() {
    return $974c6351c00ccec1$var$rateLimiter;
}

});
parcelRegister("jqw9k", function(module, exports) {
$parcel$export(module.exports, "RateLimiter", () => $739d19289bca9f70$export$a2d582f808195701);
// Hello and welcome to your Atlassian backend coding interview
class $739d19289bca9f70$export$a2d582f808195701 {
    constructor(windowSize, dropAfterCount){
        this.lastReset = new Date();
        this.counters = new Map();
        if (dropAfterCount <= 0) throw new Error('dropAfterCount must be greater than 0');
        this.windowSize = windowSize;
        this.dropAfterCount = dropAfterCount;
    }
    async rateLimit(key, fn, onLimited) {
        const now = new Date();
        if (now.getTime() - this.lastReset.getTime() > this.windowSize * 1000) {
            this.lastReset = now;
            this.counters.clear();
        }
        const count = this.counters.get(key) || 0;
        if (count >= this.dropAfterCount) return onLimited();
        this.counters.set(key, count + 1);
        return fn();
    }
}
$739d19289bca9f70$export$a2d582f808195701.displayName = "RateLimiter";

});



parcelRegister("3X4IF", function(module, exports) {
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ module.exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};

});

parcelRegister("f5z4B", function(module, exports) {
$parcel$export(module.exports, "stringify", () => $afc28772f3bd80dc$export$fac44ee5b035f737, (v) => $afc28772f3bd80dc$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parse", () => $afc28772f3bd80dc$export$98e6a39c04603d36, (v) => $afc28772f3bd80dc$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $afc28772f3bd80dc$export$fac44ee5b035f737;
var $afc28772f3bd80dc$export$98e6a39c04603d36;
'use strict';
var $afc28772f3bd80dc$var$has = Object.prototype.hasOwnProperty, $afc28772f3bd80dc$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $afc28772f3bd80dc$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $afc28772f3bd80dc$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $afc28772f3bd80dc$var$querystring(query) {
    var parser = /([^=?&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $afc28772f3bd80dc$var$decode(part[1]), value = $afc28772f3bd80dc$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $afc28772f3bd80dc$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($afc28772f3bd80dc$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $afc28772f3bd80dc$var$undef || isNaN(value))) value = '';
        key = encodeURIComponent(key);
        value = encodeURIComponent(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$afc28772f3bd80dc$export$fac44ee5b035f737 = $afc28772f3bd80dc$var$querystringify;
$afc28772f3bd80dc$export$98e6a39c04603d36 = $afc28772f3bd80dc$var$querystring;

});

parcelRegister("he2vg", function(module, exports) {
$parcel$export(module.exports, "context", () => (parcelRequire("2vgbZ")).context);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 

var $3lwCO = parcelRequire("3lwCO");















var $2vgbZ = parcelRequire("2vgbZ");

var $gxIaJ = parcelRequire("gxIaJ");

var $3q6yr = parcelRequire("3q6yr");

var $lg6ei = parcelRequire("lg6ei");

var $i7RMn = parcelRequire("i7RMn");
var // Default export.
$c8a5af955264ee69$export$2e2bcd8739ae039 = {
    context: (0, $2vgbZ.context),
    diag: (0, $gxIaJ.diag),
    metrics: (0, $3q6yr.metrics),
    propagation: (0, $lg6ei.propagation),
    trace: (0, $i7RMn.trace)
};

});
parcelRegister("3lwCO", function(module, exports) {
$parcel$export(module.exports, "createContextKey", () => $26fca3ec4debc8fc$export$b8c322c5a7cfce78);
$parcel$export(module.exports, "ROOT_CONTEXT", () => $26fca3ec4debc8fc$export$78df28f9b2f9a7dc);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Get a key to uniquely identify a context value */ function $26fca3ec4debc8fc$export$b8c322c5a7cfce78(description) {
    // The specification states that for the same input, multiple calls should
    // return different keys. Due to the nature of the JS dependency management
    // system, this creates problems where multiple versions of some package
    // could hold different keys for the same property.
    //
    // Therefore, we use Symbol.for which returns the same key for the same input.
    return Symbol.for(description);
}
var $26fca3ec4debc8fc$var$BaseContext = /** @class */ function() {
    /**
     * Construct a new context which inherits values from an optional parent context.
     *
     * @param parentContext a context from which to inherit values
     */ function BaseContext(parentContext) {
        // for minification
        var self = this;
        self._currentContext = parentContext ? new Map(parentContext) : new Map();
        self.getValue = function(key) {
            return self._currentContext.get(key);
        };
        self.setValue = function(key, value) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.set(key, value);
            return context;
        };
        self.deleteValue = function(key) {
            var context = new BaseContext(self._currentContext);
            context._currentContext.delete(key);
            return context;
        };
    }
    return BaseContext;
}();
var $26fca3ec4debc8fc$export$78df28f9b2f9a7dc = new $26fca3ec4debc8fc$var$BaseContext();

});

parcelRegister("2vgbZ", function(module, exports) {
$parcel$export(module.exports, "context", () => $1d2b0979c946b6c1$export$a078c61943f9dbbe);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $cY1yN = parcelRequire("cY1yN");
var $1d2b0979c946b6c1$export$a078c61943f9dbbe = (0, $cY1yN.ContextAPI).getInstance();

});
parcelRegister("cY1yN", function(module, exports) {
$parcel$export(module.exports, "ContextAPI", () => $970c4c7afdbbd05d$export$4148866f0a453927);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $tMEwW = parcelRequire("tMEwW");

var $4XRcR = parcelRequire("4XRcR");

var $49jb3 = parcelRequire("49jb3");
var $970c4c7afdbbd05d$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $970c4c7afdbbd05d$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $970c4c7afdbbd05d$var$API_NAME = 'context';
var $970c4c7afdbbd05d$var$NOOP_CONTEXT_MANAGER = new (0, $tMEwW.NoopContextManager)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Context API
 */ var $970c4c7afdbbd05d$export$4148866f0a453927 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function ContextAPI() {}
    /** Get the singleton instance of the Context API */ ContextAPI.getInstance = function() {
        if (!this._instance) this._instance = new ContextAPI();
        return this._instance;
    };
    /**
     * Set the current context manager.
     *
     * @returns true if the context manager was successfully registered, else false
     */ ContextAPI.prototype.setGlobalContextManager = function(contextManager) {
        return (0, $4XRcR.registerGlobal)($970c4c7afdbbd05d$var$API_NAME, contextManager, (0, $49jb3.DiagAPI).instance());
    };
    /**
     * Get the currently active context
     */ ContextAPI.prototype.active = function() {
        return this._getContextManager().active();
    };
    /**
     * Execute a function with an active context
     *
     * @param context context to be active during function execution
     * @param fn function to execute in a context
     * @param thisArg optional receiver to be used for calling fn
     * @param args optional arguments forwarded to fn
     */ ContextAPI.prototype.with = function(context, fn, thisArg) {
        var _a;
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return (_a = this._getContextManager()).with.apply(_a, $970c4c7afdbbd05d$var$__spreadArray([
            context,
            fn,
            thisArg
        ], $970c4c7afdbbd05d$var$__read(args), false));
    };
    /**
     * Bind a context to a target function or event emitter
     *
     * @param context context to bind to the event emitter or function. Defaults to the currently active context
     * @param target function or event emitter to bind
     */ ContextAPI.prototype.bind = function(context, target) {
        return this._getContextManager().bind(context, target);
    };
    ContextAPI.prototype._getContextManager = function() {
        return (0, $4XRcR.getGlobal)($970c4c7afdbbd05d$var$API_NAME) || $970c4c7afdbbd05d$var$NOOP_CONTEXT_MANAGER;
    };
    /** Disable and remove the global context manager */ ContextAPI.prototype.disable = function() {
        this._getContextManager().disable();
        (0, $4XRcR.unregisterGlobal)($970c4c7afdbbd05d$var$API_NAME, (0, $49jb3.DiagAPI).instance());
    };
    return ContextAPI;
}();

});
parcelRegister("tMEwW", function(module, exports) {
$parcel$export(module.exports, "NoopContextManager", () => $059872f6b3edc2c0$export$a27e5df35d1539a6);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3lwCO = parcelRequire("3lwCO");
var $059872f6b3edc2c0$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $059872f6b3edc2c0$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $059872f6b3edc2c0$export$a27e5df35d1539a6 = /** @class */ function() {
    function NoopContextManager() {}
    NoopContextManager.prototype.active = function() {
        return 0, $3lwCO.ROOT_CONTEXT;
    };
    NoopContextManager.prototype.with = function(_context, fn, thisArg) {
        var args = [];
        for(var _i = 3; _i < arguments.length; _i++)args[_i - 3] = arguments[_i];
        return fn.call.apply(fn, $059872f6b3edc2c0$var$__spreadArray([
            thisArg
        ], $059872f6b3edc2c0$var$__read(args), false));
    };
    NoopContextManager.prototype.bind = function(_context, target) {
        return target;
    };
    NoopContextManager.prototype.enable = function() {
        return this;
    };
    NoopContextManager.prototype.disable = function() {
        return this;
    };
    return NoopContextManager;
}();

});

parcelRegister("4XRcR", function(module, exports) {
$parcel$export(module.exports, "registerGlobal", () => $39d5f1ca47389f8c$export$d586ae880b433238);
$parcel$export(module.exports, "getGlobal", () => $39d5f1ca47389f8c$export$a4e55266d2135a7f);
$parcel$export(module.exports, "unregisterGlobal", () => $39d5f1ca47389f8c$export$d42ac835f38d1fb2);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $igwdY = parcelRequire("igwdY");

var $0qr9f = parcelRequire("0qr9f");

var $30mjo = parcelRequire("30mjo");
var $39d5f1ca47389f8c$var$major = (0, $0qr9f.VERSION).split('.')[0];
var $39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY = Symbol.for("opentelemetry.js.api." + $39d5f1ca47389f8c$var$major);
var $39d5f1ca47389f8c$var$_global = (0, $igwdY._globalThis);
function $39d5f1ca47389f8c$export$d586ae880b433238(type, instance, diag, allowOverride) {
    var _a;
    if (allowOverride === void 0) allowOverride = false;
    var api = $39d5f1ca47389f8c$var$_global[$39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY] = (_a = $39d5f1ca47389f8c$var$_global[$39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY]) !== null && _a !== void 0 ? _a : {
        version: (0, $0qr9f.VERSION)
    };
    if (!allowOverride && api[type]) {
        // already registered an API of this type
        var err = new Error("@opentelemetry/api: Attempted duplicate registration of API: " + type);
        diag.error(err.stack || err.message);
        return false;
    }
    if (api.version !== (0, $0qr9f.VERSION)) {
        // All registered APIs must be of the same version exactly
        var err = new Error("@opentelemetry/api: Registration of version v" + api.version + " for " + type + " does not match previously registered API v" + (0, $0qr9f.VERSION));
        diag.error(err.stack || err.message);
        return false;
    }
    api[type] = instance;
    diag.debug("@opentelemetry/api: Registered a global for " + type + " v" + (0, $0qr9f.VERSION) + ".");
    return true;
}
function $39d5f1ca47389f8c$export$a4e55266d2135a7f(type) {
    var _a, _b;
    var globalVersion = (_a = $39d5f1ca47389f8c$var$_global[$39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _a === void 0 ? void 0 : _a.version;
    if (!globalVersion || !(0, $30mjo.isCompatible)(globalVersion)) return;
    return (_b = $39d5f1ca47389f8c$var$_global[$39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY]) === null || _b === void 0 ? void 0 : _b[type];
}
function $39d5f1ca47389f8c$export$d42ac835f38d1fb2(type, diag) {
    diag.debug("@opentelemetry/api: Unregistering a global for " + type + " v" + (0, $0qr9f.VERSION) + ".");
    var api = $39d5f1ca47389f8c$var$_global[$39d5f1ca47389f8c$var$GLOBAL_OPENTELEMETRY_API_KEY];
    if (api) delete api[type];
}

});
parcelRegister("igwdY", function(module, exports) {
$parcel$export(module.exports, "_globalThis", () => $d4c2b7b7bda35e70$export$5c524ddf7208c00c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Updates to this file should also be replicated to @opentelemetry/core too.
/**
 * - globalThis (New standard)
 * - self (Will return the current window instance for supported browsers)
 * - window (fallback for older browser implementations)
 * - global (NodeJS implementation)
 * - <object> (When all else fails)
 */ /** only globals that common to node and browsers are allowed */ // eslint-disable-next-line node/no-unsupported-features/es-builtins, no-undef
var $d4c2b7b7bda35e70$export$5c524ddf7208c00c = typeof globalThis === 'object' ? globalThis : typeof self === 'object' ? self : typeof window === 'object' ? window : typeof $parcel$global === 'object' ? $parcel$global : {};

});

parcelRegister("0qr9f", function(module, exports) {
$parcel$export(module.exports, "VERSION", () => $00148203a485acf7$export$a4ad2735b021c132);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // this is autogenerated file, see scripts/version-update.js
var $00148203a485acf7$export$a4ad2735b021c132 = '1.9.0';

});

parcelRegister("30mjo", function(module, exports) {
$parcel$export(module.exports, "isCompatible", () => $2302add2f03c9a7f$export$7fc0d8c3ab188c4c);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $0qr9f = parcelRequire("0qr9f");
var $2302add2f03c9a7f$var$re = /^(\d+)\.(\d+)\.(\d+)(-(.+))?$/;
function $2302add2f03c9a7f$export$a5733a4d26a1ec61(ownVersion) {
    var acceptedVersions = new Set([
        ownVersion
    ]);
    var rejectedVersions = new Set();
    var myVersionMatch = ownVersion.match($2302add2f03c9a7f$var$re);
    if (!myVersionMatch) // we cannot guarantee compatibility so we always return noop
    return function() {
        return false;
    };
    var ownVersionParsed = {
        major: +myVersionMatch[1],
        minor: +myVersionMatch[2],
        patch: +myVersionMatch[3],
        prerelease: myVersionMatch[4]
    };
    // if ownVersion has a prerelease tag, versions must match exactly
    if (ownVersionParsed.prerelease != null) return function isExactmatch(globalVersion) {
        return globalVersion === ownVersion;
    };
    function _reject(v) {
        rejectedVersions.add(v);
        return false;
    }
    function _accept(v) {
        acceptedVersions.add(v);
        return true;
    }
    return function isCompatible(globalVersion) {
        if (acceptedVersions.has(globalVersion)) return true;
        if (rejectedVersions.has(globalVersion)) return false;
        var globalVersionMatch = globalVersion.match($2302add2f03c9a7f$var$re);
        if (!globalVersionMatch) // cannot parse other version
        // we cannot guarantee compatibility so we always noop
        return _reject(globalVersion);
        var globalVersionParsed = {
            major: +globalVersionMatch[1],
            minor: +globalVersionMatch[2],
            patch: +globalVersionMatch[3],
            prerelease: globalVersionMatch[4]
        };
        // if globalVersion has a prerelease tag, versions must match exactly
        if (globalVersionParsed.prerelease != null) return _reject(globalVersion);
        // major versions must match
        if (ownVersionParsed.major !== globalVersionParsed.major) return _reject(globalVersion);
        if (ownVersionParsed.major === 0) {
            if (ownVersionParsed.minor === globalVersionParsed.minor && ownVersionParsed.patch <= globalVersionParsed.patch) return _accept(globalVersion);
            return _reject(globalVersion);
        }
        if (ownVersionParsed.minor <= globalVersionParsed.minor) return _accept(globalVersion);
        return _reject(globalVersion);
    };
}
var $2302add2f03c9a7f$export$7fc0d8c3ab188c4c = $2302add2f03c9a7f$export$a5733a4d26a1ec61((0, $0qr9f.VERSION));

});


parcelRegister("49jb3", function(module, exports) {
$parcel$export(module.exports, "DiagAPI", () => $3056e0e535f526ff$export$5c8937ffc688cfd3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $lHc6N = parcelRequire("lHc6N");

var $iQ9cR = parcelRequire("iQ9cR");

var $90Lj2 = parcelRequire("90Lj2");

var $4XRcR = parcelRequire("4XRcR");
var $3056e0e535f526ff$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $3056e0e535f526ff$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var $3056e0e535f526ff$var$API_NAME = 'diag';
/**
 * Singleton object which represents the entry point to the OpenTelemetry internal
 * diagnostic API
 */ var $3056e0e535f526ff$export$5c8937ffc688cfd3 = /** @class */ function() {
    /**
     * Private internal constructor
     * @private
     */ function DiagAPI() {
        function _logProxy(funcName) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                var logger = (0, $4XRcR.getGlobal)('diag');
                // shortcut if logger not set
                if (!logger) return;
                return logger[funcName].apply(logger, $3056e0e535f526ff$var$__spreadArray([], $3056e0e535f526ff$var$__read(args), false));
            };
        }
        // Using self local variable for minification purposes as 'this' cannot be minified
        var self = this;
        // DiagAPI specific functions
        var setLogger = function(logger, optionsOrLogLevel) {
            var _a, _b, _c;
            if (optionsOrLogLevel === void 0) optionsOrLogLevel = {
                logLevel: (0, $90Lj2.DiagLogLevel).INFO
            };
            if (logger === self) {
                // There isn't much we can do here.
                // Logging to the console might break the user application.
                // Try to log to self. If a logger was previously registered it will receive the log.
                var err = new Error('Cannot use diag as the logger for itself. Please use a DiagLogger implementation like ConsoleDiagLogger or a custom implementation');
                self.error((_a = err.stack) !== null && _a !== void 0 ? _a : err.message);
                return false;
            }
            if (typeof optionsOrLogLevel === 'number') optionsOrLogLevel = {
                logLevel: optionsOrLogLevel
            };
            var oldLogger = (0, $4XRcR.getGlobal)('diag');
            var newLogger = (0, $iQ9cR.createLogLevelDiagLogger)((_b = optionsOrLogLevel.logLevel) !== null && _b !== void 0 ? _b : (0, $90Lj2.DiagLogLevel).INFO, logger);
            // There already is an logger registered. We'll let it know before overwriting it.
            if (oldLogger && !optionsOrLogLevel.suppressOverrideMessage) {
                var stack = (_c = new Error().stack) !== null && _c !== void 0 ? _c : '<failed to generate stacktrace>';
                oldLogger.warn("Current logger will be overwritten from " + stack);
                newLogger.warn("Current logger will overwrite one already registered from " + stack);
            }
            return (0, $4XRcR.registerGlobal)('diag', newLogger, self, true);
        };
        self.setLogger = setLogger;
        self.disable = function() {
            (0, $4XRcR.unregisterGlobal)($3056e0e535f526ff$var$API_NAME, self);
        };
        self.createComponentLogger = function(options) {
            return new (0, $lHc6N.DiagComponentLogger)(options);
        };
        self.verbose = _logProxy('verbose');
        self.debug = _logProxy('debug');
        self.info = _logProxy('info');
        self.warn = _logProxy('warn');
        self.error = _logProxy('error');
    }
    /** Get the singleton instance of the DiagAPI API */ DiagAPI.instance = function() {
        if (!this._instance) this._instance = new DiagAPI();
        return this._instance;
    };
    return DiagAPI;
}();

});
parcelRegister("lHc6N", function(module, exports) {
$parcel$export(module.exports, "DiagComponentLogger", () => $fcb701a38f13592c$export$b4bccc12f5b13129);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4XRcR = parcelRequire("4XRcR");
var $fcb701a38f13592c$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $fcb701a38f13592c$var$__spreadArray = undefined && undefined.__spreadArray || function(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * Component Logger which is meant to be used as part of any component which
 * will add automatically additional namespace in front of the log message.
 * It will then forward all message to global diag logger
 * @example
 * const cLogger = diag.createComponentLogger({ namespace: '@opentelemetry/instrumentation-http' });
 * cLogger.debug('test');
 * // @opentelemetry/instrumentation-http test
 */ var $fcb701a38f13592c$export$b4bccc12f5b13129 = /** @class */ function() {
    function DiagComponentLogger(props) {
        this._namespace = props.namespace || 'DiagComponentLogger';
    }
    DiagComponentLogger.prototype.debug = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fcb701a38f13592c$var$logProxy('debug', this._namespace, args);
    };
    DiagComponentLogger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fcb701a38f13592c$var$logProxy('error', this._namespace, args);
    };
    DiagComponentLogger.prototype.info = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fcb701a38f13592c$var$logProxy('info', this._namespace, args);
    };
    DiagComponentLogger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fcb701a38f13592c$var$logProxy('warn', this._namespace, args);
    };
    DiagComponentLogger.prototype.verbose = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $fcb701a38f13592c$var$logProxy('verbose', this._namespace, args);
    };
    return DiagComponentLogger;
}();
function $fcb701a38f13592c$var$logProxy(funcName, namespace, args) {
    var logger = (0, $4XRcR.getGlobal)('diag');
    // shortcut if logger not set
    if (!logger) return;
    args.unshift(namespace);
    return logger[funcName].apply(logger, $fcb701a38f13592c$var$__spreadArray([], $fcb701a38f13592c$var$__read(args), false));
}

});

parcelRegister("iQ9cR", function(module, exports) {
$parcel$export(module.exports, "createLogLevelDiagLogger", () => $db743986c1f2ded9$export$9a9cc475abb19689);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $90Lj2 = parcelRequire("90Lj2");
function $db743986c1f2ded9$export$9a9cc475abb19689(maxLevel, logger) {
    if (maxLevel < (0, $90Lj2.DiagLogLevel).NONE) maxLevel = (0, $90Lj2.DiagLogLevel).NONE;
    else if (maxLevel > (0, $90Lj2.DiagLogLevel).ALL) maxLevel = (0, $90Lj2.DiagLogLevel).ALL;
    // In case the logger is null or undefined
    logger = logger || {};
    function _filterFunc(funcName, theLevel) {
        var theFunc = logger[funcName];
        if (typeof theFunc === 'function' && maxLevel >= theLevel) return theFunc.bind(logger);
        return function() {};
    }
    return {
        error: _filterFunc('error', (0, $90Lj2.DiagLogLevel).ERROR),
        warn: _filterFunc('warn', (0, $90Lj2.DiagLogLevel).WARN),
        info: _filterFunc('info', (0, $90Lj2.DiagLogLevel).INFO),
        debug: _filterFunc('debug', (0, $90Lj2.DiagLogLevel).DEBUG),
        verbose: _filterFunc('verbose', (0, $90Lj2.DiagLogLevel).VERBOSE)
    };
}

});
parcelRegister("90Lj2", function(module, exports) {
$parcel$export(module.exports, "DiagLogLevel", () => $68f8cf256ea86519$export$b7d7b4c0f3c95263);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Defines the available internal logging levels for the diagnostic logger, the numeric values
 * of the levels are defined to match the original values from the initial LogLevel to avoid
 * compatibility/migration issues for any implementation that assume the numeric ordering.
 */ var $68f8cf256ea86519$export$b7d7b4c0f3c95263;
(function(DiagLogLevel) {
    /** Diagnostic Logging level setting to disable all logging (except and forced logs) */ DiagLogLevel[DiagLogLevel["NONE"] = 0] = "NONE";
    /** Identifies an error scenario */ DiagLogLevel[DiagLogLevel["ERROR"] = 30] = "ERROR";
    /** Identifies a warning scenario */ DiagLogLevel[DiagLogLevel["WARN"] = 50] = "WARN";
    /** General informational log message */ DiagLogLevel[DiagLogLevel["INFO"] = 60] = "INFO";
    /** General debug log message */ DiagLogLevel[DiagLogLevel["DEBUG"] = 70] = "DEBUG";
    /**
     * Detailed trace level logging should only be used for development, should only be set
     * in a development environment.
     */ DiagLogLevel[DiagLogLevel["VERBOSE"] = 80] = "VERBOSE";
    /** Used to set the logging level to include all logging */ DiagLogLevel[DiagLogLevel["ALL"] = 9999] = "ALL";
})($68f8cf256ea86519$export$b7d7b4c0f3c95263 || ($68f8cf256ea86519$export$b7d7b4c0f3c95263 = {}));

});





parcelRegister("gxIaJ", function(module, exports) {
$parcel$export(module.exports, "diag", () => $c0b1fe0b79a53386$export$c042e7c2f59bc046);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $49jb3 = parcelRequire("49jb3");
var $c0b1fe0b79a53386$export$c042e7c2f59bc046 = (0, $49jb3.DiagAPI).instance();

});

parcelRegister("3q6yr", function(module, exports) {
$parcel$export(module.exports, "metrics", () => $27d8e2665b2f02a9$export$b0c5c2fac8144e54);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $84qxs = parcelRequire("84qxs");
var $27d8e2665b2f02a9$export$b0c5c2fac8144e54 = (0, $84qxs.MetricsAPI).getInstance();

});
parcelRegister("84qxs", function(module, exports) {
$parcel$export(module.exports, "MetricsAPI", () => $5e03487bb5e643db$export$1339f6eb6111c638);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $enB7g = parcelRequire("enB7g");

var $4XRcR = parcelRequire("4XRcR");

var $49jb3 = parcelRequire("49jb3");
var $5e03487bb5e643db$var$API_NAME = 'metrics';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Metrics API
 */ var $5e03487bb5e643db$export$1339f6eb6111c638 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function MetricsAPI() {}
    /** Get the singleton instance of the Metrics API */ MetricsAPI.getInstance = function() {
        if (!this._instance) this._instance = new MetricsAPI();
        return this._instance;
    };
    /**
     * Set the current global meter provider.
     * Returns true if the meter provider was successfully registered, else false.
     */ MetricsAPI.prototype.setGlobalMeterProvider = function(provider) {
        return (0, $4XRcR.registerGlobal)($5e03487bb5e643db$var$API_NAME, provider, (0, $49jb3.DiagAPI).instance());
    };
    /**
     * Returns the global meter provider.
     */ MetricsAPI.prototype.getMeterProvider = function() {
        return (0, $4XRcR.getGlobal)($5e03487bb5e643db$var$API_NAME) || (0, $enB7g.NOOP_METER_PROVIDER);
    };
    /**
     * Returns a meter from the global meter provider.
     */ MetricsAPI.prototype.getMeter = function(name, version, options) {
        return this.getMeterProvider().getMeter(name, version, options);
    };
    /** Remove the global meter provider */ MetricsAPI.prototype.disable = function() {
        (0, $4XRcR.unregisterGlobal)($5e03487bb5e643db$var$API_NAME, (0, $49jb3.DiagAPI).instance());
    };
    return MetricsAPI;
}();

});
parcelRegister("enB7g", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER_PROVIDER", () => $a7800128527aa64f$export$d21fe83355c56e18);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cLmjG = parcelRequire("cLmjG");
/**
 * An implementation of the {@link MeterProvider} which returns an impotent Meter
 * for all calls to `getMeter`
 */ var $a7800128527aa64f$export$51c513ea08316108 = /** @class */ function() {
    function NoopMeterProvider() {}
    NoopMeterProvider.prototype.getMeter = function(_name, _version, _options) {
        return 0, $cLmjG.NOOP_METER;
    };
    return NoopMeterProvider;
}();
var $a7800128527aa64f$export$d21fe83355c56e18 = new $a7800128527aa64f$export$51c513ea08316108();

});
parcelRegister("cLmjG", function(module, exports) {
$parcel$export(module.exports, "NOOP_METER", () => $94ab2f6b5226421b$export$65e277d35235a01f);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $94ab2f6b5226421b$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * NoopMeter is a noop implementation of the {@link Meter} interface. It reuses
 * constant NoopMetrics for all of its methods.
 */ var $94ab2f6b5226421b$export$c23c6f85dd4fc1e9 = /** @class */ function() {
    function NoopMeter() {}
    /**
     * @see {@link Meter.createGauge}
     */ NoopMeter.prototype.createGauge = function(_name, _options) {
        return $94ab2f6b5226421b$export$dd01300aacbcec1c;
    };
    /**
     * @see {@link Meter.createHistogram}
     */ NoopMeter.prototype.createHistogram = function(_name, _options) {
        return $94ab2f6b5226421b$export$689c32a6a552e1a6;
    };
    /**
     * @see {@link Meter.createCounter}
     */ NoopMeter.prototype.createCounter = function(_name, _options) {
        return $94ab2f6b5226421b$export$e6d19fe5233efc54;
    };
    /**
     * @see {@link Meter.createUpDownCounter}
     */ NoopMeter.prototype.createUpDownCounter = function(_name, _options) {
        return $94ab2f6b5226421b$export$2f189cd99d2b7429;
    };
    /**
     * @see {@link Meter.createObservableGauge}
     */ NoopMeter.prototype.createObservableGauge = function(_name, _options) {
        return $94ab2f6b5226421b$export$ea67e3c6ff624776;
    };
    /**
     * @see {@link Meter.createObservableCounter}
     */ NoopMeter.prototype.createObservableCounter = function(_name, _options) {
        return $94ab2f6b5226421b$export$163422b94c3edbcb;
    };
    /**
     * @see {@link Meter.createObservableUpDownCounter}
     */ NoopMeter.prototype.createObservableUpDownCounter = function(_name, _options) {
        return $94ab2f6b5226421b$export$5b8be9ab17b673b3;
    };
    /**
     * @see {@link Meter.addBatchObservableCallback}
     */ NoopMeter.prototype.addBatchObservableCallback = function(_callback, _observables) {};
    /**
     * @see {@link Meter.removeBatchObservableCallback}
     */ NoopMeter.prototype.removeBatchObservableCallback = function(_callback) {};
    return NoopMeter;
}();
var $94ab2f6b5226421b$export$834a616d1cf278b = /** @class */ function() {
    function NoopMetric() {}
    return NoopMetric;
}();
var $94ab2f6b5226421b$export$b556ba0f560c45b = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopCounterMetric, _super);
    function NoopCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopCounterMetric;
}($94ab2f6b5226421b$export$834a616d1cf278b);
var $94ab2f6b5226421b$export$df09a35db160df98 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopUpDownCounterMetric, _super);
    function NoopUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopUpDownCounterMetric.prototype.add = function(_value, _attributes) {};
    return NoopUpDownCounterMetric;
}($94ab2f6b5226421b$export$834a616d1cf278b);
var $94ab2f6b5226421b$export$b7f4a3c7ea16c24 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopGaugeMetric, _super);
    function NoopGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopGaugeMetric.prototype.record = function(_value, _attributes) {};
    return NoopGaugeMetric;
}($94ab2f6b5226421b$export$834a616d1cf278b);
var $94ab2f6b5226421b$export$ef064c3e0426c607 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopHistogramMetric, _super);
    function NoopHistogramMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NoopHistogramMetric.prototype.record = function(_value, _attributes) {};
    return NoopHistogramMetric;
}($94ab2f6b5226421b$export$834a616d1cf278b);
var $94ab2f6b5226421b$export$a5a3e7829c289482 = /** @class */ function() {
    function NoopObservableMetric() {}
    NoopObservableMetric.prototype.addCallback = function(_callback) {};
    NoopObservableMetric.prototype.removeCallback = function(_callback) {};
    return NoopObservableMetric;
}();
var $94ab2f6b5226421b$export$7a7e4b169d5c93a8 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopObservableCounterMetric, _super);
    function NoopObservableCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableCounterMetric;
}($94ab2f6b5226421b$export$a5a3e7829c289482);
var $94ab2f6b5226421b$export$6990a2f90809ffc1 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopObservableGaugeMetric, _super);
    function NoopObservableGaugeMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableGaugeMetric;
}($94ab2f6b5226421b$export$a5a3e7829c289482);
var $94ab2f6b5226421b$export$3ec3555bc6f693a4 = /** @class */ function(_super) {
    $94ab2f6b5226421b$var$__extends(NoopObservableUpDownCounterMetric, _super);
    function NoopObservableUpDownCounterMetric() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NoopObservableUpDownCounterMetric;
}($94ab2f6b5226421b$export$a5a3e7829c289482);
var $94ab2f6b5226421b$export$65e277d35235a01f = new $94ab2f6b5226421b$export$c23c6f85dd4fc1e9();
var $94ab2f6b5226421b$export$e6d19fe5233efc54 = new $94ab2f6b5226421b$export$b556ba0f560c45b();
var $94ab2f6b5226421b$export$dd01300aacbcec1c = new $94ab2f6b5226421b$export$b7f4a3c7ea16c24();
var $94ab2f6b5226421b$export$689c32a6a552e1a6 = new $94ab2f6b5226421b$export$ef064c3e0426c607();
var $94ab2f6b5226421b$export$2f189cd99d2b7429 = new $94ab2f6b5226421b$export$df09a35db160df98();
var $94ab2f6b5226421b$export$163422b94c3edbcb = new $94ab2f6b5226421b$export$7a7e4b169d5c93a8();
var $94ab2f6b5226421b$export$ea67e3c6ff624776 = new $94ab2f6b5226421b$export$6990a2f90809ffc1();
var $94ab2f6b5226421b$export$5b8be9ab17b673b3 = new $94ab2f6b5226421b$export$3ec3555bc6f693a4();
function $94ab2f6b5226421b$export$bc3a498ccbb5c2b5() {
    return $94ab2f6b5226421b$export$65e277d35235a01f;
}

});




parcelRegister("lg6ei", function(module, exports) {
$parcel$export(module.exports, "propagation", () => $f79fecaa39ff8cf8$export$3e49040daa9dba20);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $7IomF = parcelRequire("7IomF");
var $f79fecaa39ff8cf8$export$3e49040daa9dba20 = (0, $7IomF.PropagationAPI).getInstance();

});
parcelRegister("7IomF", function(module, exports) {
$parcel$export(module.exports, "PropagationAPI", () => $59df8ac7153a1f1c$export$471eda0a6213cac9);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4XRcR = parcelRequire("4XRcR");

var $bzVQc = parcelRequire("bzVQc");

var $5M2vP = parcelRequire("5M2vP");

var $lpxYd = parcelRequire("lpxYd");

var $lAJCF = parcelRequire("lAJCF");

var $49jb3 = parcelRequire("49jb3");
var $59df8ac7153a1f1c$var$API_NAME = 'propagation';
var $59df8ac7153a1f1c$var$NOOP_TEXT_MAP_PROPAGATOR = new (0, $bzVQc.NoopTextMapPropagator)();
/**
 * Singleton object which represents the entry point to the OpenTelemetry Propagation API
 */ var $59df8ac7153a1f1c$export$471eda0a6213cac9 = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function PropagationAPI() {
        this.createBaggage = (0, $lAJCF.createBaggage);
        this.getBaggage = (0, $lpxYd.getBaggage);
        this.getActiveBaggage = (0, $lpxYd.getActiveBaggage);
        this.setBaggage = (0, $lpxYd.setBaggage);
        this.deleteBaggage = (0, $lpxYd.deleteBaggage);
    }
    /** Get the singleton instance of the Propagator API */ PropagationAPI.getInstance = function() {
        if (!this._instance) this._instance = new PropagationAPI();
        return this._instance;
    };
    /**
     * Set the current propagator.
     *
     * @returns true if the propagator was successfully registered, else false
     */ PropagationAPI.prototype.setGlobalPropagator = function(propagator) {
        return (0, $4XRcR.registerGlobal)($59df8ac7153a1f1c$var$API_NAME, propagator, (0, $49jb3.DiagAPI).instance());
    };
    /**
     * Inject context into a carrier to be propagated inter-process
     *
     * @param context Context carrying tracing data to inject
     * @param carrier carrier to inject context into
     * @param setter Function used to set values on the carrier
     */ PropagationAPI.prototype.inject = function(context, carrier, setter) {
        if (setter === void 0) setter = (0, $5M2vP.defaultTextMapSetter);
        return this._getGlobalPropagator().inject(context, carrier, setter);
    };
    /**
     * Extract context from a carrier
     *
     * @param context Context which the newly created context will inherit from
     * @param carrier Carrier to extract context from
     * @param getter Function used to extract keys from a carrier
     */ PropagationAPI.prototype.extract = function(context, carrier, getter) {
        if (getter === void 0) getter = (0, $5M2vP.defaultTextMapGetter);
        return this._getGlobalPropagator().extract(context, carrier, getter);
    };
    /**
     * Return a list of all fields which may be used by the propagator.
     */ PropagationAPI.prototype.fields = function() {
        return this._getGlobalPropagator().fields();
    };
    /** Remove the global propagator */ PropagationAPI.prototype.disable = function() {
        (0, $4XRcR.unregisterGlobal)($59df8ac7153a1f1c$var$API_NAME, (0, $49jb3.DiagAPI).instance());
    };
    PropagationAPI.prototype._getGlobalPropagator = function() {
        return (0, $4XRcR.getGlobal)($59df8ac7153a1f1c$var$API_NAME) || $59df8ac7153a1f1c$var$NOOP_TEXT_MAP_PROPAGATOR;
    };
    return PropagationAPI;
}();

});
parcelRegister("bzVQc", function(module, exports) {
$parcel$export(module.exports, "NoopTextMapPropagator", () => $86dfd49753f44789$export$8356c7eb3af7963b);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * No-op implementations of {@link TextMapPropagator}.
 */ var $86dfd49753f44789$export$8356c7eb3af7963b = /** @class */ function() {
    function NoopTextMapPropagator() {}
    /** Noop inject function does nothing */ NoopTextMapPropagator.prototype.inject = function(_context, _carrier) {};
    /** Noop extract function does nothing and returns the input context */ NoopTextMapPropagator.prototype.extract = function(context, _carrier) {
        return context;
    };
    NoopTextMapPropagator.prototype.fields = function() {
        return [];
    };
    return NoopTextMapPropagator;
}();

});

parcelRegister("5M2vP", function(module, exports) {
$parcel$export(module.exports, "defaultTextMapGetter", () => $434362589916136f$export$a0f575f55f38720a);
$parcel$export(module.exports, "defaultTextMapSetter", () => $434362589916136f$export$f70f1d111fccf1c1);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $434362589916136f$export$a0f575f55f38720a = {
    get: function(carrier, key) {
        if (carrier == null) return undefined;
        return carrier[key];
    },
    keys: function(carrier) {
        if (carrier == null) return [];
        return Object.keys(carrier);
    }
};
var $434362589916136f$export$f70f1d111fccf1c1 = {
    set: function(carrier, key, value) {
        if (carrier == null) return;
        carrier[key] = value;
    }
};

});

parcelRegister("lpxYd", function(module, exports) {
$parcel$export(module.exports, "getBaggage", () => $f966489305793b62$export$f3bffa0b5dd10d1e);
$parcel$export(module.exports, "getActiveBaggage", () => $f966489305793b62$export$120a1756099436ee);
$parcel$export(module.exports, "setBaggage", () => $f966489305793b62$export$adc9ca19eab3f500);
$parcel$export(module.exports, "deleteBaggage", () => $f966489305793b62$export$4ca3a8a743c9f633);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cY1yN = parcelRequire("cY1yN");

var $3lwCO = parcelRequire("3lwCO");
/**
 * Baggage key
 */ var $f966489305793b62$var$BAGGAGE_KEY = (0, $3lwCO.createContextKey)('OpenTelemetry Baggage Key');
function $f966489305793b62$export$f3bffa0b5dd10d1e(context) {
    return context.getValue($f966489305793b62$var$BAGGAGE_KEY) || undefined;
}
function $f966489305793b62$export$120a1756099436ee() {
    return $f966489305793b62$export$f3bffa0b5dd10d1e((0, $cY1yN.ContextAPI).getInstance().active());
}
function $f966489305793b62$export$adc9ca19eab3f500(context, baggage) {
    return context.setValue($f966489305793b62$var$BAGGAGE_KEY, baggage);
}
function $f966489305793b62$export$4ca3a8a743c9f633(context) {
    return context.deleteValue($f966489305793b62$var$BAGGAGE_KEY);
}

});

parcelRegister("lAJCF", function(module, exports) {
$parcel$export(module.exports, "createBaggage", () => $fb805977cd30400d$export$1034a425c7384452);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $49jb3 = parcelRequire("49jb3");

var $kKqMU = parcelRequire("kKqMU");

var $8WZcx = parcelRequire("8WZcx");
var $fb805977cd30400d$var$diag = (0, $49jb3.DiagAPI).instance();
function $fb805977cd30400d$export$1034a425c7384452(entries) {
    if (entries === void 0) entries = {};
    return new (0, $kKqMU.BaggageImpl)(new Map(Object.entries(entries)));
}
function $fb805977cd30400d$export$c491cedc1b2b6e9e(str) {
    if (typeof str !== 'string') {
        $fb805977cd30400d$var$diag.error("Cannot create baggage metadata from unknown type: " + typeof str);
        str = '';
    }
    return {
        __TYPE__: (0, $8WZcx.baggageEntryMetadataSymbol),
        toString: function() {
            return str;
        }
    };
}

});
parcelRegister("kKqMU", function(module, exports) {
$parcel$export(module.exports, "BaggageImpl", () => $f1ace208120397e8$export$b8c511fa1a5f4987);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $f1ace208120397e8$var$__read = undefined && undefined.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $f1ace208120397e8$var$__values = undefined && undefined.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $f1ace208120397e8$export$b8c511fa1a5f4987 = /** @class */ function() {
    function BaggageImpl(entries) {
        this._entries = entries ? new Map(entries) : new Map();
    }
    BaggageImpl.prototype.getEntry = function(key) {
        var entry = this._entries.get(key);
        if (!entry) return undefined;
        return Object.assign({}, entry);
    };
    BaggageImpl.prototype.getAllEntries = function() {
        return Array.from(this._entries.entries()).map(function(_a) {
            var _b = $f1ace208120397e8$var$__read(_a, 2), k = _b[0], v = _b[1];
            return [
                k,
                v
            ];
        });
    };
    BaggageImpl.prototype.setEntry = function(key, entry) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.set(key, entry);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntry = function(key) {
        var newBaggage = new BaggageImpl(this._entries);
        newBaggage._entries.delete(key);
        return newBaggage;
    };
    BaggageImpl.prototype.removeEntries = function() {
        var e_1, _a;
        var keys = [];
        for(var _i = 0; _i < arguments.length; _i++)keys[_i] = arguments[_i];
        var newBaggage = new BaggageImpl(this._entries);
        try {
            for(var keys_1 = $f1ace208120397e8$var$__values(keys), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()){
                var key = keys_1_1.value;
                newBaggage._entries.delete(key);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (keys_1_1 && !keys_1_1.done && (_a = keys_1.return)) _a.call(keys_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return newBaggage;
    };
    BaggageImpl.prototype.clear = function() {
        return new BaggageImpl();
    };
    return BaggageImpl;
}();

});

parcelRegister("8WZcx", function(module, exports) {
$parcel$export(module.exports, "baggageEntryMetadataSymbol", () => $684336c7cd2ebe4d$export$92dd2fe8ddb5cb7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Symbol used to make BaggageEntryMetadata an opaque type
 */ var $684336c7cd2ebe4d$export$92dd2fe8ddb5cb7 = Symbol('BaggageEntryMetadata');

});




parcelRegister("i7RMn", function(module, exports) {
$parcel$export(module.exports, "trace", () => $d32298df5d940b80$export$357889f174732d38);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Split module-level variable definition into separate files to allow
// tree-shaking on each api instance.

var $gyl8f = parcelRequire("gyl8f");
var $d32298df5d940b80$export$357889f174732d38 = (0, $gyl8f.TraceAPI).getInstance();

});
parcelRegister("gyl8f", function(module, exports) {
$parcel$export(module.exports, "TraceAPI", () => $031c21ea0fc0ae26$export$2cccde6fcc7b568a);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4XRcR = parcelRequire("4XRcR");

var $9qLVh = parcelRequire("9qLVh");

var $lRVa8 = parcelRequire("lRVa8");

var $lOwqC = parcelRequire("lOwqC");

var $49jb3 = parcelRequire("49jb3");
var $031c21ea0fc0ae26$var$API_NAME = 'trace';
/**
 * Singleton object which represents the entry point to the OpenTelemetry Tracing API
 */ var $031c21ea0fc0ae26$export$2cccde6fcc7b568a = /** @class */ function() {
    /** Empty private constructor prevents end users from constructing a new instance of the API */ function TraceAPI() {
        this._proxyTracerProvider = new (0, $9qLVh.ProxyTracerProvider)();
        this.wrapSpanContext = (0, $lRVa8.wrapSpanContext);
        this.isSpanContextValid = (0, $lRVa8.isSpanContextValid);
        this.deleteSpan = (0, $lOwqC.deleteSpan);
        this.getSpan = (0, $lOwqC.getSpan);
        this.getActiveSpan = (0, $lOwqC.getActiveSpan);
        this.getSpanContext = (0, $lOwqC.getSpanContext);
        this.setSpan = (0, $lOwqC.setSpan);
        this.setSpanContext = (0, $lOwqC.setSpanContext);
    }
    /** Get the singleton instance of the Trace API */ TraceAPI.getInstance = function() {
        if (!this._instance) this._instance = new TraceAPI();
        return this._instance;
    };
    /**
     * Set the current global tracer.
     *
     * @returns true if the tracer provider was successfully registered, else false
     */ TraceAPI.prototype.setGlobalTracerProvider = function(provider) {
        var success = (0, $4XRcR.registerGlobal)($031c21ea0fc0ae26$var$API_NAME, this._proxyTracerProvider, (0, $49jb3.DiagAPI).instance());
        if (success) this._proxyTracerProvider.setDelegate(provider);
        return success;
    };
    /**
     * Returns the global tracer provider.
     */ TraceAPI.prototype.getTracerProvider = function() {
        return (0, $4XRcR.getGlobal)($031c21ea0fc0ae26$var$API_NAME) || this._proxyTracerProvider;
    };
    /**
     * Returns a tracer from the global tracer provider.
     */ TraceAPI.prototype.getTracer = function(name, version) {
        return this.getTracerProvider().getTracer(name, version);
    };
    /** Remove the global tracer provider */ TraceAPI.prototype.disable = function() {
        (0, $4XRcR.unregisterGlobal)($031c21ea0fc0ae26$var$API_NAME, (0, $49jb3.DiagAPI).instance());
        this._proxyTracerProvider = new (0, $9qLVh.ProxyTracerProvider)();
    };
    return TraceAPI;
}();

});
parcelRegister("9qLVh", function(module, exports) {
$parcel$export(module.exports, "ProxyTracerProvider", () => $6ddbb73d7ee35890$export$4137aabcb4254962);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $gpesi = parcelRequire("gpesi");

var $6gQTc = parcelRequire("6gQTc");
var $6ddbb73d7ee35890$var$NOOP_TRACER_PROVIDER = new (0, $6gQTc.NoopTracerProvider)();
/**
 * Tracer provider which provides {@link ProxyTracer}s.
 *
 * Before a delegate is set, tracers provided are NoOp.
 *   When a delegate is set, traces are provided from the delegate.
 *   When a delegate is set after tracers have already been provided,
 *   all tracers already provided will use the provided delegate implementation.
 */ var $6ddbb73d7ee35890$export$4137aabcb4254962 = /** @class */ function() {
    function ProxyTracerProvider() {}
    /**
     * Get a {@link ProxyTracer}
     */ ProxyTracerProvider.prototype.getTracer = function(name, version, options) {
        var _a;
        return (_a = this.getDelegateTracer(name, version, options)) !== null && _a !== void 0 ? _a : new (0, $gpesi.ProxyTracer)(this, name, version, options);
    };
    ProxyTracerProvider.prototype.getDelegate = function() {
        var _a;
        return (_a = this._delegate) !== null && _a !== void 0 ? _a : $6ddbb73d7ee35890$var$NOOP_TRACER_PROVIDER;
    };
    /**
     * Set the delegate tracer provider
     */ ProxyTracerProvider.prototype.setDelegate = function(delegate) {
        this._delegate = delegate;
    };
    ProxyTracerProvider.prototype.getDelegateTracer = function(name, version, options) {
        var _a;
        return (_a = this._delegate) === null || _a === void 0 ? void 0 : _a.getTracer(name, version, options);
    };
    return ProxyTracerProvider;
}();

});
parcelRegister("gpesi", function(module, exports) {
$parcel$export(module.exports, "ProxyTracer", () => $bf1a31adf82dc4f8$export$df2c38268c6bb6b3);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4QRo2 = parcelRequire("4QRo2");
var $bf1a31adf82dc4f8$var$NOOP_TRACER = new (0, $4QRo2.NoopTracer)();
/**
 * Proxy tracer provided by the proxy tracer provider
 */ var $bf1a31adf82dc4f8$export$df2c38268c6bb6b3 = /** @class */ function() {
    function ProxyTracer(_provider, name, version, options) {
        this._provider = _provider;
        this.name = name;
        this.version = version;
        this.options = options;
    }
    ProxyTracer.prototype.startSpan = function(name, options, context) {
        return this._getTracer().startSpan(name, options, context);
    };
    ProxyTracer.prototype.startActiveSpan = function(_name, _options, _context, _fn) {
        var tracer = this._getTracer();
        return Reflect.apply(tracer.startActiveSpan, tracer, arguments);
    };
    /**
     * Try to get a tracer from the proxy tracer provider.
     * If the proxy tracer provider has no delegate, return a noop tracer.
     */ ProxyTracer.prototype._getTracer = function() {
        if (this._delegate) return this._delegate;
        var tracer = this._provider.getDelegateTracer(this.name, this.version, this.options);
        if (!tracer) return $bf1a31adf82dc4f8$var$NOOP_TRACER;
        this._delegate = tracer;
        return this._delegate;
    };
    return ProxyTracer;
}();

});
parcelRegister("4QRo2", function(module, exports) {
$parcel$export(module.exports, "NoopTracer", () => $38856e436de162ef$export$714c1036cabcd223);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $cY1yN = parcelRequire("cY1yN");

var $lOwqC = parcelRequire("lOwqC");

var $h9kcm = parcelRequire("h9kcm");

var $lRVa8 = parcelRequire("lRVa8");
var $38856e436de162ef$var$contextApi = (0, $cY1yN.ContextAPI).getInstance();
/**
 * No-op implementations of {@link Tracer}.
 */ var $38856e436de162ef$export$714c1036cabcd223 = /** @class */ function() {
    function NoopTracer() {}
    // startSpan starts a noop span.
    NoopTracer.prototype.startSpan = function(name, options, context) {
        if (context === void 0) context = $38856e436de162ef$var$contextApi.active();
        var root = Boolean(options === null || options === void 0 ? void 0 : options.root);
        if (root) return new (0, $h9kcm.NonRecordingSpan)();
        var parentFromContext = context && (0, $lOwqC.getSpanContext)(context);
        if ($38856e436de162ef$var$isSpanContext(parentFromContext) && (0, $lRVa8.isSpanContextValid)(parentFromContext)) return new (0, $h9kcm.NonRecordingSpan)(parentFromContext);
        else return new (0, $h9kcm.NonRecordingSpan)();
    };
    NoopTracer.prototype.startActiveSpan = function(name, arg2, arg3, arg4) {
        var opts;
        var ctx;
        var fn;
        if (arguments.length < 2) return;
        else if (arguments.length === 2) fn = arg2;
        else if (arguments.length === 3) {
            opts = arg2;
            fn = arg3;
        } else {
            opts = arg2;
            ctx = arg3;
            fn = arg4;
        }
        var parentContext = ctx !== null && ctx !== void 0 ? ctx : $38856e436de162ef$var$contextApi.active();
        var span = this.startSpan(name, opts, parentContext);
        var contextWithSpanSet = (0, $lOwqC.setSpan)(parentContext, span);
        return $38856e436de162ef$var$contextApi.with(contextWithSpanSet, fn, undefined, span);
    };
    return NoopTracer;
}();
function $38856e436de162ef$var$isSpanContext(spanContext) {
    return typeof spanContext === 'object' && typeof spanContext['spanId'] === 'string' && typeof spanContext['traceId'] === 'string' && typeof spanContext['traceFlags'] === 'number';
}

});
parcelRegister("lOwqC", function(module, exports) {
$parcel$export(module.exports, "getSpan", () => $fe176c1262ac3b6c$export$246e04ba06066af1);
$parcel$export(module.exports, "getActiveSpan", () => $fe176c1262ac3b6c$export$1be426a8e585c83e);
$parcel$export(module.exports, "setSpan", () => $fe176c1262ac3b6c$export$8ab2f2e6ee8ed0a8);
$parcel$export(module.exports, "deleteSpan", () => $fe176c1262ac3b6c$export$a6bbfe9a17f7941c);
$parcel$export(module.exports, "setSpanContext", () => $fe176c1262ac3b6c$export$c90bf5428c14cdb1);
$parcel$export(module.exports, "getSpanContext", () => $fe176c1262ac3b6c$export$1a635f8f0b912781);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3lwCO = parcelRequire("3lwCO");

var $h9kcm = parcelRequire("h9kcm");

var $cY1yN = parcelRequire("cY1yN");
/**
 * span key
 */ var $fe176c1262ac3b6c$var$SPAN_KEY = (0, $3lwCO.createContextKey)('OpenTelemetry Context Key SPAN');
function $fe176c1262ac3b6c$export$246e04ba06066af1(context) {
    return context.getValue($fe176c1262ac3b6c$var$SPAN_KEY) || undefined;
}
function $fe176c1262ac3b6c$export$1be426a8e585c83e() {
    return $fe176c1262ac3b6c$export$246e04ba06066af1((0, $cY1yN.ContextAPI).getInstance().active());
}
function $fe176c1262ac3b6c$export$8ab2f2e6ee8ed0a8(context, span) {
    return context.setValue($fe176c1262ac3b6c$var$SPAN_KEY, span);
}
function $fe176c1262ac3b6c$export$a6bbfe9a17f7941c(context) {
    return context.deleteValue($fe176c1262ac3b6c$var$SPAN_KEY);
}
function $fe176c1262ac3b6c$export$c90bf5428c14cdb1(context, spanContext) {
    return $fe176c1262ac3b6c$export$8ab2f2e6ee8ed0a8(context, new (0, $h9kcm.NonRecordingSpan)(spanContext));
}
function $fe176c1262ac3b6c$export$1a635f8f0b912781(context) {
    var _a;
    return (_a = $fe176c1262ac3b6c$export$246e04ba06066af1(context)) === null || _a === void 0 ? void 0 : _a.spanContext();
}

});
parcelRegister("h9kcm", function(module, exports) {
$parcel$export(module.exports, "NonRecordingSpan", () => $c7c2f1e734cd93b3$export$972d28f7c6a8c6c7);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3NEqn = parcelRequire("3NEqn");
/**
 * The NonRecordingSpan is the default {@link Span} that is used when no Span
 * implementation is available. All operations are no-op including context
 * propagation.
 */ var $c7c2f1e734cd93b3$export$972d28f7c6a8c6c7 = /** @class */ function() {
    function NonRecordingSpan(_spanContext) {
        if (_spanContext === void 0) _spanContext = (0, $3NEqn.INVALID_SPAN_CONTEXT);
        this._spanContext = _spanContext;
    }
    // Returns a SpanContext.
    NonRecordingSpan.prototype.spanContext = function() {
        return this._spanContext;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttribute = function(_key, _value) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setAttributes = function(_attributes) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.addEvent = function(_name, _attributes) {
        return this;
    };
    NonRecordingSpan.prototype.addLink = function(_link) {
        return this;
    };
    NonRecordingSpan.prototype.addLinks = function(_links) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.setStatus = function(_status) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.updateName = function(_name) {
        return this;
    };
    // By default does nothing
    NonRecordingSpan.prototype.end = function(_endTime) {};
    // isRecording always returns false for NonRecordingSpan.
    NonRecordingSpan.prototype.isRecording = function() {
        return false;
    };
    // By default does nothing
    NonRecordingSpan.prototype.recordException = function(_exception, _time) {};
    return NonRecordingSpan;
}();

});
parcelRegister("3NEqn", function(module, exports) {
$parcel$export(module.exports, "INVALID_SPANID", () => $2c454e22d0b55b72$export$55cc39fb0d4bb4c0);
$parcel$export(module.exports, "INVALID_TRACEID", () => $2c454e22d0b55b72$export$22be96e88d95e128);
$parcel$export(module.exports, "INVALID_SPAN_CONTEXT", () => $2c454e22d0b55b72$export$8591e4c852b66703);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $igB35 = parcelRequire("igB35");
var $2c454e22d0b55b72$export$55cc39fb0d4bb4c0 = '0000000000000000';
var $2c454e22d0b55b72$export$22be96e88d95e128 = '00000000000000000000000000000000';
var $2c454e22d0b55b72$export$8591e4c852b66703 = {
    traceId: $2c454e22d0b55b72$export$22be96e88d95e128,
    spanId: $2c454e22d0b55b72$export$55cc39fb0d4bb4c0,
    traceFlags: (0, $igB35.TraceFlags).NONE
};

});
parcelRegister("igB35", function(module, exports) {
$parcel$export(module.exports, "TraceFlags", () => $d4c675b68f8fdc24$export$bf9049ad2b0883ff);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d4c675b68f8fdc24$export$bf9049ad2b0883ff;
(function(TraceFlags) {
    /** Represents no flag set. */ TraceFlags[TraceFlags["NONE"] = 0] = "NONE";
    /** Bit to represent whether trace is sampled in trace flags. */ TraceFlags[TraceFlags["SAMPLED"] = 1] = "SAMPLED";
})($d4c675b68f8fdc24$export$bf9049ad2b0883ff || ($d4c675b68f8fdc24$export$bf9049ad2b0883ff = {}));

});




parcelRegister("lRVa8", function(module, exports) {
$parcel$export(module.exports, "isSpanContextValid", () => $febae37e9f7b5880$export$e4373b9a2c09216c);
$parcel$export(module.exports, "wrapSpanContext", () => $febae37e9f7b5880$export$c19cc0f1911bdb85);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $3NEqn = parcelRequire("3NEqn");

var $h9kcm = parcelRequire("h9kcm");
var $febae37e9f7b5880$var$VALID_TRACEID_REGEX = /^([0-9a-f]{32})$/i;
var $febae37e9f7b5880$var$VALID_SPANID_REGEX = /^[0-9a-f]{16}$/i;
function $febae37e9f7b5880$export$29dd34cf1269f6da(traceId) {
    return $febae37e9f7b5880$var$VALID_TRACEID_REGEX.test(traceId) && traceId !== (0, $3NEqn.INVALID_TRACEID);
}
function $febae37e9f7b5880$export$8e51c6d8f0586aff(spanId) {
    return $febae37e9f7b5880$var$VALID_SPANID_REGEX.test(spanId) && spanId !== (0, $3NEqn.INVALID_SPANID);
}
function $febae37e9f7b5880$export$e4373b9a2c09216c(spanContext) {
    return $febae37e9f7b5880$export$29dd34cf1269f6da(spanContext.traceId) && $febae37e9f7b5880$export$8e51c6d8f0586aff(spanContext.spanId);
}
function $febae37e9f7b5880$export$c19cc0f1911bdb85(spanContext) {
    return new (0, $h9kcm.NonRecordingSpan)(spanContext);
}

});



parcelRegister("6gQTc", function(module, exports) {
$parcel$export(module.exports, "NoopTracerProvider", () => $490d43665f0a4d76$export$87d8e93756f9e86e);
/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $4QRo2 = parcelRequire("4QRo2");
/**
 * An implementation of the {@link TracerProvider} which returns an impotent
 * Tracer for all calls to `getTracer`.
 *
 * All operations are no-op.
 */ var $490d43665f0a4d76$export$87d8e93756f9e86e = /** @class */ function() {
    function NoopTracerProvider() {}
    NoopTracerProvider.prototype.getTracer = function(_name, _version, _options) {
        return new (0, $4QRo2.NoopTracer)();
    };
    return NoopTracerProvider;
}();

});





parcelRegister("e79Pd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("90aPs"));

});
parcelRegister("90aPs", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $68dc838a6bceaa74$export$ffb0004e005737fa, (v) => $68dc838a6bceaa74$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $68dc838a6bceaa74$export$34b9dba7ce09269b, (v) => $68dc838a6bceaa74$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $68dc838a6bceaa74$export$25062201e9e25d76, (v) => $68dc838a6bceaa74$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $68dc838a6bceaa74$export$ffb0004e005737fa;
var $68dc838a6bceaa74$export$34b9dba7ce09269b;
var $68dc838a6bceaa74$export$25062201e9e25d76;
'use strict';

var $euxye = parcelRequire("euxye");
var $68dc838a6bceaa74$var$k = Symbol.for("react.element"), $68dc838a6bceaa74$var$l = Symbol.for("react.fragment"), $68dc838a6bceaa74$var$m = Object.prototype.hasOwnProperty, $68dc838a6bceaa74$var$n = $euxye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $68dc838a6bceaa74$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $68dc838a6bceaa74$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$68dc838a6bceaa74$var$m.call(a, b) && !$68dc838a6bceaa74$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $68dc838a6bceaa74$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $68dc838a6bceaa74$var$n.current
    };
}
$68dc838a6bceaa74$export$ffb0004e005737fa = $68dc838a6bceaa74$var$l;
$68dc838a6bceaa74$export$34b9dba7ce09269b = $68dc838a6bceaa74$var$q;
$68dc838a6bceaa74$export$25062201e9e25d76 = $68dc838a6bceaa74$var$q;

});


parcelRegister("glbdM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $7uFvM = parcelRequire("7uFvM");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $7uFvM.bind;
    }
});

var $55wcf = parcelRequire("55wcf");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $55wcf.bindAll;
    }
});

});
parcelRegister("7uFvM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $574b891935680f4b$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $574b891935680f4b$var$bind;

});

parcelRegister("55wcf", function(module, exports) {
"use strict";
var $3b4664ef6cd5e120$var$__assign = module.exports && module.exports.__assign || function() {
    $3b4664ef6cd5e120$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $3b4664ef6cd5e120$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $7uFvM = parcelRequire("7uFvM");
function $3b4664ef6cd5e120$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $3b4664ef6cd5e120$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $3b4664ef6cd5e120$var$__assign($3b4664ef6cd5e120$var$__assign({}, original), {
        options: $3b4664ef6cd5e120$var$__assign($3b4664ef6cd5e120$var$__assign({}, $3b4664ef6cd5e120$var$toOptions(sharedOptions)), $3b4664ef6cd5e120$var$toOptions(original.options))
    });
    return binding;
}
function $3b4664ef6cd5e120$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $3b4664ef6cd5e120$var$getBinding(original, sharedOptions);
        return (0, $7uFvM.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $3b4664ef6cd5e120$var$bindAll;

});


parcelRegister("dG4s7", function(module, exports) {
/* eslint-disable jira/filename-case */ 
var $lhWE3 = parcelRequire("lhWE3");

var $1awbE = parcelRequire("1awbE");
const $9d5a4dc726856b1e$var$isDevelopment = false;
const { performance: $9d5a4dc726856b1e$var$performance, document: $9d5a4dc726856b1e$var$document } = window || {};
const $9d5a4dc726856b1e$var$assetToShortName = (0, $1awbE.sanitiseAssetName)($9d5a4dc726856b1e$var$isDevelopment);
// defensively check for the necessary APIs, in SSR these would be missing
// OSX El Capitan and earlier: `performance.mark` is not defined [even though `performance` is present]
// https://stackoverflow.com/a/32940166/12146527
if (window && $9d5a4dc726856b1e$var$document && $9d5a4dc726856b1e$var$performance && $9d5a4dc726856b1e$var$performance.mark) /**
	 * We rely on being passed the short basename of the chunk file.
	 * It must not include path or hash but should include ".js" extension.
	 */ // @ts-expect-error - TS2740 - Type '(shortName: string) => void' is missing the following properties from type 'Window': clientInformation, closed, customElements, devicePixelRatio, and 267 more.
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
window[0, $lhWE3.JS_EVAL_API] = (shortName)=>{
    const prefix = shortName.replace(/\.js$/, '.');
    const nodeList = $9d5a4dc726856b1e$var$document.querySelectorAll(`script[src*="${prefix}"]`);
    const scripts = Array.from(nodeList).filter((node)=>$9d5a4dc726856b1e$var$assetToShortName(node.getAttribute('src') ?? '') === shortName);
    if (scripts.length !== 1) {
        $9d5a4dc726856b1e$var$performance.mark(`${shortName}${(0, $lhWE3.JS_EVAL_STOP)}`);
        return;
    }
    const script = scripts[0];
    const onLoaded = ()=>{
        script.removeEventListener('load', onLoaded);
        $9d5a4dc726856b1e$var$performance.mark(`${shortName}${(0, $lhWE3.JS_EVAL_STOP)}`);
        if ($9d5a4dc726856b1e$var$isDevelopment) try {
            // not all scripts are instrumented with eval mark so measure() may error
            $9d5a4dc726856b1e$var$performance.measure(`_${shortName}`, `${shortName}${(0, $lhWE3.JS_EVAL_START)}`, `${shortName}${(0, $lhWE3.JS_EVAL_STOP)}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
        /* do nothing */ }
    };
    script.addEventListener('load', onLoaded);
};

});
parcelRegister("lhWE3", function(module, exports) {
$parcel$export(module.exports, "SPA_SSR_RENDERED_MARK", () => $f7f8ad3529af3f77$export$db6a769879aea97b, (v) => $f7f8ad3529af3f77$export$db6a769879aea97b = v);
$parcel$export(module.exports, "JS_EVAL_START", () => $f7f8ad3529af3f77$export$4719e2a29dbcb33d, (v) => $f7f8ad3529af3f77$export$4719e2a29dbcb33d = v);
$parcel$export(module.exports, "JS_EVAL_STOP", () => $f7f8ad3529af3f77$export$7ee4e0433d720dea, (v) => $f7f8ad3529af3f77$export$7ee4e0433d720dea = v);
$parcel$export(module.exports, "JS_EVAL_API", () => $f7f8ad3529af3f77$export$d619b0b88beaed3d, (v) => $f7f8ad3529af3f77$export$d619b0b88beaed3d = v);
/* eslint-disable jira/filename-case */ /**
 *  IMPORTANT
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ var $f7f8ad3529af3f77$export$db6a769879aea97b;
var $f7f8ad3529af3f77$export$4719e2a29dbcb33d;
var $f7f8ad3529af3f77$export$7ee4e0433d720dea;
var $f7f8ad3529af3f77$export$d619b0b88beaed3d;
$f7f8ad3529af3f77$export$db6a769879aea97b = 'ssr.spa.rendered';
/*::
export type JsEvalStart = ':eval-start';
 */ const $f7f8ad3529af3f77$var$JS_EVAL_START /*:: :JsEvalStart */  = ':eval-start';
$f7f8ad3529af3f77$export$4719e2a29dbcb33d = $f7f8ad3529af3f77$var$JS_EVAL_START;
/*::
export type JsEvalStop = ':eval-stop';
 */ const $f7f8ad3529af3f77$var$JS_EVAL_STOP /*:: :JsEvalStop */  = ':eval-stop';
$f7f8ad3529af3f77$export$7ee4e0433d720dea = $f7f8ad3529af3f77$var$JS_EVAL_STOP;
/*::
export type JsEvalApi = '__jsEvalStop';
*/ const $f7f8ad3529af3f77$var$JS_EVAL_API /*:: :JsEvalApi */  = '__jsEvalStop';
$f7f8ad3529af3f77$export$d619b0b88beaed3d = $f7f8ad3529af3f77$var$JS_EVAL_API;

});

parcelRegister("1awbE", function(module, exports) {
/* eslint-disable jira/filename-case */ const $0d9fb13ea7605167$var$getBaseName = (assetPathOrURL /*:: :string */ )=>assetPathOrURL.split('#')[0].split('?')[0].split('/').pop();
/**
 * Given an asset path or URL isolate the basename and remove the chunk hash and cache-bust integer.
 *
 * IMPORTANT
 *  - this algorithm must exactly match the webpack output filename format in webpack.config.js
 *  - this code must be nodejs compatible as it is also used in the webpack.config.js
 */ const $0d9fb13ea7605167$var$sanitiseAssetName = (isDevelopment /*:: :boolean */ )=>(assetPathOrURL /*:: :string */ )=>{
        const baseName = $0d9fb13ea7605167$var$getBaseName(assetPathOrURL);
        // we desire "[name.with.dots].[ext]"
        // in debug we expect "[name.with.dots].[ext]"
        // in production we expect "[name.with.dots].[hash].[cache-bust].[ext]"
        const split = baseName.split('.');
        if (split.length === 1) // Inline bundles are only an id
        return split[0];
        // Remove the has section from bundles (penultimate section separated by dots)
        // In the case of shared bundles (e.g. shared.hash.js) this will return 'shared.js'.
        // In the case of runtime bundles (e.g. bundle.runtime.hash.js) this will return 'bundle.runtime.js'.
        // This will cause only the first shared bundle loaded to be tracked.
        // In the short term this is desired to prevent too much noise.
        return [
            ...split.slice(0, -2),
            split[split.length - 1]
        ].join('.');
        return isDevelopment || split.length < 4 ? baseName : [
            ...split.slice(0, -3),
            ...split.slice(-1)
        ].join('.');
    };
module.exports = {
    sanitiseAssetName: $0d9fb13ea7605167$var$sanitiseAssetName
};

});


parcelRegister("lzmuA", function(module, exports) {
/* eslint-disable jira/filename-case, @typescript-eslint/no-require-imports */ // Import polyfills first as a safety-net for the remaining imports

parcelRequire("h4gsk");
parcelRequire("85XPu");





parcelRequire("jM31s");
parcelRequire("kY9Lm");
parcelRequire("lGEfm");






parcelRequire("5ySJg");


var $hStPE = parcelRequire("hStPE");
parcelRequire("4GeA1");
var $dc9Ya = parcelRequire("dc9Ya");


parcelRequire("dG4s7");
// Cause emotion side-effects to persists
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $01bc131fe3e14a73$var$emotionSideEffect = [
    (0, $dc9Ya.w),
    (0, $hStPE.withEmotionCache)
];





















































































































// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $01bc131fe3e14a73$var$lazyImports = ()=>{
    (parcelRequire("bHcfq"));
    (parcelRequire("ku3pl"));
    (parcelRequire("iqjLa"));
    (parcelRequire("eY5Cc"));
    (parcelRequire("eT4u6"));
    (parcelRequire("kwMul"));
    (parcelRequire("n67Vb"));
    (parcelRequire("esROC"));
    (parcelRequire("13ZYC"));
    (parcelRequire("lIGkE"));
    (parcelRequire("jCeRw"));
    // rx-js
    (parcelRequire("gtjjB"));
    (parcelRequire("dmX0B"));
    (parcelRequire("jBqw1"));
    (parcelRequire("i4Ttx"));
    (parcelRequire("6jnNj"));
    (parcelRequire("lkLFz"));
    (parcelRequire("63mRS"));
    (parcelRequire("a7T1C"));
    (parcelRequire("kmrto"));
    (parcelRequire("BAW9Z"));
    (parcelRequire("bUurn"));
    (parcelRequire("1bnyb"));
    (parcelRequire("2Jqao"));
    (parcelRequire("cduXI"));
    (parcelRequire("6RFJl"));
    (parcelRequire("dtGoO"));
    (parcelRequire("2Sm07"));
    (parcelRequire("6yvkv"));
    (parcelRequire("kyh9b"));
    (parcelRequire("dULD5"));
    (parcelRequire("gTsuW"));
    (parcelRequire("hW0h6"));
    (parcelRequire("g2200"));
    (parcelRequire("5fRvp"));
    (parcelRequire("2cT7B"));
    (parcelRequire("5ctBA"));
    (parcelRequire("dGHLL"));
    (parcelRequire("a8uTV"));
    (parcelRequire("lPpxH"));
    (parcelRequire("03MJu"));
    (parcelRequire("7E6Tx"));
    (parcelRequire("8IxMu"));
    (parcelRequire("8Qa1F"));
    (parcelRequire("lOt3P"));
    (parcelRequire("6tXhc"));
    (parcelRequire("gCZwk"));
    (parcelRequire("h1ZQy"));
    (parcelRequire("gOcEL"));
    (parcelRequire("f372A"));
    (parcelRequire("21M0S"));
    (parcelRequire("bVM0Z"));
    (parcelRequire("7JUoj"));
    (parcelRequire("8COrN"));
    (parcelRequire("aMktH"));
    (parcelRequire("j0MxL"));
    (parcelRequire("9OJfl"));
    (parcelRequire("kUOnd"));
    (parcelRequire("dE4XR"));
    (parcelRequire("3rwYJ"));
    (parcelRequire("fl212"));
    (parcelRequire("8DGZ7"));
    (parcelRequire("bLTr8"));
    (parcelRequire("hcUL1"));
    (parcelRequire("6HQ8l"));
    (parcelRequire("7RTpP"));
    (parcelRequire("b1U7t"));
    (parcelRequire("n6VNC"));
    (parcelRequire("hyKn9"));
    (parcelRequire("7irfG"));
    (parcelRequire("fiEPr"));
    (parcelRequire("6QEWx"));
    (parcelRequire("lovsQ"));
    (parcelRequire("36tLF"));
    (parcelRequire("iXuhH"));
    (parcelRequire("kKNHV"));
    (parcelRequire("jBlDA"));
    (parcelRequire("gjHmT"));
    (parcelRequire("8aykQ"));
    (parcelRequire("lUckO"));
    (parcelRequire("fQf1q"));
    (parcelRequire("fGjje"));
    (parcelRequire("c50ZS"));
    (parcelRequire("ftCfB"));
    (parcelRequire("1IdMz"));
    (parcelRequire("k6yHK"));
    (parcelRequire("4VJDV"));
    (parcelRequire("7rCt8"));
    (parcelRequire("5l8Be"));
    (parcelRequire("bNRjk"));
    (parcelRequire("4SjFE"));
    (parcelRequire("eoo15"));
    (parcelRequire("hX2bq"));
    (parcelRequire("gZEnP"));
    (parcelRequire("bL5yJ"));
    (parcelRequire("5LUxV"));
    (parcelRequire("7Q1Cb"));
    (parcelRequire("7lzMj"));
    (parcelRequire("4Ckfe"));
    (parcelRequire("j6wl3"));
    (parcelRequire("aCHyH"));
    (parcelRequire("cVEZJ"));
    (parcelRequire("dAes6"));
    (parcelRequire("9XJ4v"));
    (parcelRequire("kRgxc"));
    (parcelRequire("3vdoL"));
    (parcelRequire("hKHA0"));
    (parcelRequire("ilxRZ"));
    (parcelRequire("63IBR"));
    (parcelRequire("fAUL8"));
    (parcelRequire("8tLzs"));
    (parcelRequire("3J3dy"));
    (parcelRequire("e6v8c"));
    (parcelRequire("CuN6i"));
    (parcelRequire("6cf5r"));
    (parcelRequire("jOrSj"));
    (parcelRequire("j5093"));
};

});
parcelRegister("h4gsk", function(module, exports) {
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ parcelRequire("2pkk0");
parcelRequire("a2RcC");
parcelRequire("3pDua");
parcelRequire("lfi7f");

});
parcelRegister("2pkk0", function(module, exports) {
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
/**
 * we inject React as a global to support libraries that expect it to be available globally,
 * for example cases when classic jsx transform was used where modern one was expected
 */ globalThis.React = (0, (/*@__PURE__*/$parcel$interopDefault($euxye)));

});

parcelRegister("a2RcC", function(module, exports) {
/* eslint-disable jira/filename-case */ parcelRequire("euxye");

});

parcelRegister("3pDua", function(module, exports) {
/* eslint-disable jira/filename-case */ 
});

parcelRegister("lfi7f", function(module, exports) {
/* eslint-disable jira/filename-case, @typescript-eslint/no-explicit-any */ /**
 * @fileOverview this is a temporal file to support hydration rollout in Jira
 * It will be removed once the rollout is complete
 */ 
var $euxye = parcelRequire("euxye");
if (typeof window !== 'undefined') {
    const altFlags = new URLSearchParams(window.location.search).get('alt-flags');
    // `no-effects` flag disables all useEffect and useLayoutEffect calls
    // making Jira "static"
    if (altFlags?.includes('no-effects')) {
        // Disable useEffect calls to allow hydration to focus on Structure only
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
        (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useEffect = ()=>{};
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports,@typescript-eslint/no-empty-function
        (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).useLayoutEffect = ()=>{};
        // eslint-disable-next-line no-console
        console.warn("\u26D4\uFE0F React.useEffect is disabled \u26D4\uFE0F");
    }
    // `memo-all` flags causes all components to be wrapped in React.memo
    // React compiler without using compiler
    if (altFlags?.includes('memo-all')) {
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
        const originalCreateElement = (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement;
        const componentMapping = new Map();
        // eslint-disable-next-line @atlassian/tangerine/import/no-implicit-imports
        (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement = (type, ...args)=>{
            // delegate incorrect or plain components
            if (!type || typeof type === 'string') return originalCreateElement(type, ...args);
            // do not handle Class components
            if (type.prototype && (Object.prototype.isPrototypeOf.call((0, $euxye.Component).prototype, type.prototype) || type.prototype.isReactComponent || // with support for React 14(!) components still being in use
            type.prototype.render)) return originalCreateElement(type, ...args);
            if (typeof type === 'function' || typeof type === 'object') {
                let standin = componentMapping.get(type);
                // for every function generate a standin to preserve req equality
                // this is not required for "single pass" render to string, but is a must-have to renderToStream
                if (!standin) {
                    standin = /*#__PURE__*/ (0, $euxye.memo)(type);
                    componentMapping.set(type, standin);
                }
                return originalCreateElement(standin, ...args);
            }
            return originalCreateElement(type, ...args);
        };
    }
}

});


parcelRegister("85XPu", function(module, exports) {
'use strict';
function $5e4d333d0a7de9a0$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($5e4d333d0a7de9a0$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$5e4d333d0a7de9a0$var$checkDCE();

module.exports = (parcelRequire("gu7T2"));

});
parcelRegister("gu7T2", function(module, exports) {
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $c00590d434bbebaf$export$ae55be85d98224ed, (v) => $c00590d434bbebaf$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $c00590d434bbebaf$export$d39a5bbd09211389, (v) => $c00590d434bbebaf$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $c00590d434bbebaf$export$882461b6382ed46c, (v) => $c00590d434bbebaf$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $c00590d434bbebaf$export$466bfc07425424d5, (v) => $c00590d434bbebaf$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $c00590d434bbebaf$export$cd75ccfd720a3cd4, (v) => $c00590d434bbebaf$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $c00590d434bbebaf$export$fa8d919ba61d84db, (v) => $c00590d434bbebaf$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $c00590d434bbebaf$export$757ceba2d55c277e, (v) => $c00590d434bbebaf$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $c00590d434bbebaf$export$b3890eb0ae9dca99, (v) => $c00590d434bbebaf$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $c00590d434bbebaf$export$502457920280e6be, (v) => $c00590d434bbebaf$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $c00590d434bbebaf$export$c78a37762a8d58e1, (v) => $c00590d434bbebaf$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $c00590d434bbebaf$export$dc54d992c10e8a18, (v) => $c00590d434bbebaf$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $c00590d434bbebaf$export$83d89fbfd8236492, (v) => $c00590d434bbebaf$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.profiling.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c00590d434bbebaf$export$ae55be85d98224ed;
var $c00590d434bbebaf$export$d39a5bbd09211389;
var $c00590d434bbebaf$export$882461b6382ed46c;
var $c00590d434bbebaf$export$466bfc07425424d5;
var $c00590d434bbebaf$export$cd75ccfd720a3cd4;
var $c00590d434bbebaf$export$fa8d919ba61d84db;
var $c00590d434bbebaf$export$757ceba2d55c277e;
var $c00590d434bbebaf$export$b3890eb0ae9dca99;
var $c00590d434bbebaf$export$502457920280e6be;
var $c00590d434bbebaf$export$c78a37762a8d58e1;
var $c00590d434bbebaf$export$dc54d992c10e8a18;
var $c00590d434bbebaf$export$83d89fbfd8236492;
'use strict';
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $euxye = parcelRequire("euxye");

var $g8xyD = parcelRequire("g8xyD");
function $c00590d434bbebaf$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $c00590d434bbebaf$var$da = new Set, $c00590d434bbebaf$var$ea = {};
function $c00590d434bbebaf$var$fa(a, b) {
    $c00590d434bbebaf$var$ha(a, b);
    $c00590d434bbebaf$var$ha(a + "Capture", b);
}
function $c00590d434bbebaf$var$ha(a, b) {
    $c00590d434bbebaf$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$c00590d434bbebaf$var$da.add(b[a]);
}
var $c00590d434bbebaf$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $c00590d434bbebaf$var$ja = Object.prototype.hasOwnProperty, $c00590d434bbebaf$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $c00590d434bbebaf$var$la = {}, $c00590d434bbebaf$var$ma = {};
function $c00590d434bbebaf$var$na(a) {
    if ($c00590d434bbebaf$var$ja.call($c00590d434bbebaf$var$ma, a)) return !0;
    if ($c00590d434bbebaf$var$ja.call($c00590d434bbebaf$var$la, a)) return !1;
    if ($c00590d434bbebaf$var$ka.test(a)) return $c00590d434bbebaf$var$ma[a] = !0;
    $c00590d434bbebaf$var$la[a] = !0;
    return !1;
}
function $c00590d434bbebaf$var$oa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $c00590d434bbebaf$var$pa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $c00590d434bbebaf$var$oa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $c00590d434bbebaf$var$qa(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $c00590d434bbebaf$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $c00590d434bbebaf$var$t[b] = new $c00590d434bbebaf$var$qa(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $c00590d434bbebaf$var$ra = /[\-:]([a-z])/g;
function $c00590d434bbebaf$var$ta(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($c00590d434bbebaf$var$ra, $c00590d434bbebaf$var$ta);
    $c00590d434bbebaf$var$t[b] = new $c00590d434bbebaf$var$qa(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($c00590d434bbebaf$var$ra, $c00590d434bbebaf$var$ta);
    $c00590d434bbebaf$var$t[b] = new $c00590d434bbebaf$var$qa(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($c00590d434bbebaf$var$ra, $c00590d434bbebaf$var$ta);
    $c00590d434bbebaf$var$t[b] = new $c00590d434bbebaf$var$qa(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$c00590d434bbebaf$var$t.xlinkHref = new $c00590d434bbebaf$var$qa("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $c00590d434bbebaf$var$t[a] = new $c00590d434bbebaf$var$qa(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $c00590d434bbebaf$var$ua(a, b, c, d) {
    var e = $c00590d434bbebaf$var$t.hasOwnProperty(b) ? $c00590d434bbebaf$var$t[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $c00590d434bbebaf$var$pa(b, c, e, d) && (c = null), d || null === e ? $c00590d434bbebaf$var$na(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $c00590d434bbebaf$var$va = $euxye.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $c00590d434bbebaf$var$wa = Symbol.for("react.element"), $c00590d434bbebaf$var$xa = Symbol.for("react.portal"), $c00590d434bbebaf$var$ya = Symbol.for("react.fragment"), $c00590d434bbebaf$var$za = Symbol.for("react.strict_mode"), $c00590d434bbebaf$var$Aa = Symbol.for("react.profiler"), $c00590d434bbebaf$var$Ba = Symbol.for("react.provider"), $c00590d434bbebaf$var$Ca = Symbol.for("react.context"), $c00590d434bbebaf$var$Da = Symbol.for("react.forward_ref"), $c00590d434bbebaf$var$Ea = Symbol.for("react.suspense"), $c00590d434bbebaf$var$Fa = Symbol.for("react.suspense_list"), $c00590d434bbebaf$var$Ga = Symbol.for("react.memo"), $c00590d434bbebaf$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $c00590d434bbebaf$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $c00590d434bbebaf$var$Ja = Symbol.iterator;
function $c00590d434bbebaf$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $c00590d434bbebaf$var$Ja && a[$c00590d434bbebaf$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $c00590d434bbebaf$var$u = Object.assign, $c00590d434bbebaf$var$La;
function $c00590d434bbebaf$var$Ma(a) {
    if (void 0 === $c00590d434bbebaf$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $c00590d434bbebaf$var$La = b && b[1] || "";
    }
    return "\n" + $c00590d434bbebaf$var$La + a;
}
var $c00590d434bbebaf$var$Na = !1;
function $c00590d434bbebaf$var$Oa(a, b) {
    if (!a || $c00590d434bbebaf$var$Na) return "";
    $c00590d434bbebaf$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $c00590d434bbebaf$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $c00590d434bbebaf$var$Ma(a) : "";
}
function $c00590d434bbebaf$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $c00590d434bbebaf$var$Ma(a.type);
        case 16:
            return $c00590d434bbebaf$var$Ma("Lazy");
        case 13:
            return $c00590d434bbebaf$var$Ma("Suspense");
        case 19:
            return $c00590d434bbebaf$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $c00590d434bbebaf$var$Oa(a.type, !1), a;
        case 11:
            return a = $c00590d434bbebaf$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $c00590d434bbebaf$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $c00590d434bbebaf$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $c00590d434bbebaf$var$ya:
            return "Fragment";
        case $c00590d434bbebaf$var$xa:
            return "Portal";
        case $c00590d434bbebaf$var$Aa:
            return "Profiler";
        case $c00590d434bbebaf$var$za:
            return "StrictMode";
        case $c00590d434bbebaf$var$Ea:
            return "Suspense";
        case $c00590d434bbebaf$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $c00590d434bbebaf$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $c00590d434bbebaf$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $c00590d434bbebaf$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $c00590d434bbebaf$var$Ga:
            return b = a.displayName || null, null !== b ? b : $c00590d434bbebaf$var$Qa(a.type) || "Memo";
        case $c00590d434bbebaf$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $c00590d434bbebaf$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $c00590d434bbebaf$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $c00590d434bbebaf$var$Qa(b);
        case 8:
            return b === $c00590d434bbebaf$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $c00590d434bbebaf$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $c00590d434bbebaf$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $c00590d434bbebaf$var$Ua(a) {
    var b = $c00590d434bbebaf$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $c00590d434bbebaf$var$Va(a) {
    a._valueTracker || (a._valueTracker = $c00590d434bbebaf$var$Ua(a));
}
function $c00590d434bbebaf$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $c00590d434bbebaf$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $c00590d434bbebaf$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $c00590d434bbebaf$var$Ya(a, b) {
    var c = b.checked;
    return $c00590d434bbebaf$var$u({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $c00590d434bbebaf$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $c00590d434bbebaf$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $c00590d434bbebaf$var$$a(a, b) {
    b = b.checked;
    null != b && $c00590d434bbebaf$var$ua(a, "checked", b, !1);
}
function $c00590d434bbebaf$var$ab(a, b) {
    $c00590d434bbebaf$var$$a(a, b);
    var c = $c00590d434bbebaf$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $c00590d434bbebaf$var$bb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $c00590d434bbebaf$var$bb(a, b.type, $c00590d434bbebaf$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $c00590d434bbebaf$var$cb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $c00590d434bbebaf$var$bb(a, b, c) {
    if ("number" !== b || $c00590d434bbebaf$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $c00590d434bbebaf$var$db = Array.isArray;
function $c00590d434bbebaf$var$eb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $c00590d434bbebaf$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $c00590d434bbebaf$var$fb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($c00590d434bbebaf$var$p(91));
    return $c00590d434bbebaf$var$u({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $c00590d434bbebaf$var$gb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($c00590d434bbebaf$var$p(92));
            if ($c00590d434bbebaf$var$db(c)) {
                if (1 < c.length) throw Error($c00590d434bbebaf$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $c00590d434bbebaf$var$Sa(c)
    };
}
function $c00590d434bbebaf$var$hb(a, b) {
    var c = $c00590d434bbebaf$var$Sa(b.value), d = $c00590d434bbebaf$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $c00590d434bbebaf$var$ib(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $c00590d434bbebaf$var$jb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $c00590d434bbebaf$var$kb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $c00590d434bbebaf$var$jb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $c00590d434bbebaf$var$mb, $c00590d434bbebaf$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $c00590d434bbebaf$var$mb = $c00590d434bbebaf$var$mb || document.createElement("div");
        $c00590d434bbebaf$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $c00590d434bbebaf$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $c00590d434bbebaf$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $c00590d434bbebaf$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $c00590d434bbebaf$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($c00590d434bbebaf$var$pb).forEach(function(a) {
    $c00590d434bbebaf$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $c00590d434bbebaf$var$pb[b] = $c00590d434bbebaf$var$pb[a];
    });
});
function $c00590d434bbebaf$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $c00590d434bbebaf$var$pb.hasOwnProperty(a) && $c00590d434bbebaf$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $c00590d434bbebaf$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $c00590d434bbebaf$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $c00590d434bbebaf$var$tb = $c00590d434bbebaf$var$u({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $c00590d434bbebaf$var$ub(a, b) {
    if (b) {
        if ($c00590d434bbebaf$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($c00590d434bbebaf$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($c00590d434bbebaf$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($c00590d434bbebaf$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($c00590d434bbebaf$var$p(62));
    }
}
function $c00590d434bbebaf$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $c00590d434bbebaf$var$wb = null;
function $c00590d434bbebaf$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $c00590d434bbebaf$var$yb = null, $c00590d434bbebaf$var$zb = null, $c00590d434bbebaf$var$Ab = null;
function $c00590d434bbebaf$var$Bb(a) {
    if (a = $c00590d434bbebaf$var$Cb(a)) {
        if ("function" !== typeof $c00590d434bbebaf$var$yb) throw Error($c00590d434bbebaf$var$p(280));
        var b = a.stateNode;
        b && (b = $c00590d434bbebaf$var$Db(b), $c00590d434bbebaf$var$yb(a.stateNode, a.type, b));
    }
}
function $c00590d434bbebaf$var$Eb(a) {
    $c00590d434bbebaf$var$zb ? $c00590d434bbebaf$var$Ab ? $c00590d434bbebaf$var$Ab.push(a) : $c00590d434bbebaf$var$Ab = [
        a
    ] : $c00590d434bbebaf$var$zb = a;
}
function $c00590d434bbebaf$var$Fb() {
    if ($c00590d434bbebaf$var$zb) {
        var a = $c00590d434bbebaf$var$zb, b = $c00590d434bbebaf$var$Ab;
        $c00590d434bbebaf$var$Ab = $c00590d434bbebaf$var$zb = null;
        $c00590d434bbebaf$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$c00590d434bbebaf$var$Bb(b[a]);
    }
}
function $c00590d434bbebaf$var$Gb(a, b) {
    return a(b);
}
function $c00590d434bbebaf$var$Hb() {}
var $c00590d434bbebaf$var$Ib = !1;
function $c00590d434bbebaf$var$Jb(a, b, c) {
    if ($c00590d434bbebaf$var$Ib) return a(b, c);
    $c00590d434bbebaf$var$Ib = !0;
    try {
        return $c00590d434bbebaf$var$Gb(a, b, c);
    } finally{
        if ($c00590d434bbebaf$var$Ib = !1, null !== $c00590d434bbebaf$var$zb || null !== $c00590d434bbebaf$var$Ab) $c00590d434bbebaf$var$Hb(), $c00590d434bbebaf$var$Fb();
    }
}
function $c00590d434bbebaf$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $c00590d434bbebaf$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($c00590d434bbebaf$var$p(231, b, typeof c));
    return c;
}
var $c00590d434bbebaf$var$Lb = !1;
if ($c00590d434bbebaf$var$ia) try {
    var $c00590d434bbebaf$var$Mb = {};
    Object.defineProperty($c00590d434bbebaf$var$Mb, "passive", {
        get: function() {
            $c00590d434bbebaf$var$Lb = !0;
        }
    });
    window.addEventListener("test", $c00590d434bbebaf$var$Mb, $c00590d434bbebaf$var$Mb);
    window.removeEventListener("test", $c00590d434bbebaf$var$Mb, $c00590d434bbebaf$var$Mb);
} catch (a) {
    $c00590d434bbebaf$var$Lb = !1;
}
function $c00590d434bbebaf$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (n) {
        this.onError(n);
    }
}
var $c00590d434bbebaf$var$Ob = !1, $c00590d434bbebaf$var$Pb = null, $c00590d434bbebaf$var$Qb = !1, $c00590d434bbebaf$var$Rb = null, $c00590d434bbebaf$var$Sb = {
    onError: function(a) {
        $c00590d434bbebaf$var$Ob = !0;
        $c00590d434bbebaf$var$Pb = a;
    }
};
function $c00590d434bbebaf$var$Tb(a, b, c, d, e, f, g, h, k) {
    $c00590d434bbebaf$var$Ob = !1;
    $c00590d434bbebaf$var$Pb = null;
    $c00590d434bbebaf$var$Nb.apply($c00590d434bbebaf$var$Sb, arguments);
}
function $c00590d434bbebaf$var$Ub(a, b, c, d, e, f, g, h, k) {
    $c00590d434bbebaf$var$Tb.apply(this, arguments);
    if ($c00590d434bbebaf$var$Ob) {
        if ($c00590d434bbebaf$var$Ob) {
            var l = $c00590d434bbebaf$var$Pb;
            $c00590d434bbebaf$var$Ob = !1;
            $c00590d434bbebaf$var$Pb = null;
        } else throw Error($c00590d434bbebaf$var$p(198));
        $c00590d434bbebaf$var$Qb || ($c00590d434bbebaf$var$Qb = !0, $c00590d434bbebaf$var$Rb = l);
    }
}
function $c00590d434bbebaf$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $c00590d434bbebaf$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $c00590d434bbebaf$var$Xb(a) {
    if ($c00590d434bbebaf$var$Vb(a) !== a) throw Error($c00590d434bbebaf$var$p(188));
}
function $c00590d434bbebaf$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $c00590d434bbebaf$var$Vb(a);
        if (null === b) throw Error($c00590d434bbebaf$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $c00590d434bbebaf$var$Xb(e), a;
                if (f === d) return $c00590d434bbebaf$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($c00590d434bbebaf$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($c00590d434bbebaf$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($c00590d434bbebaf$var$p(190));
    }
    if (3 !== c.tag) throw Error($c00590d434bbebaf$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $c00590d434bbebaf$var$Zb(a) {
    a = $c00590d434bbebaf$var$Yb(a);
    return null !== a ? $c00590d434bbebaf$var$$b(a) : null;
}
function $c00590d434bbebaf$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $c00590d434bbebaf$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $c00590d434bbebaf$var$ac = $g8xyD.unstable_scheduleCallback, $c00590d434bbebaf$var$bc = $g8xyD.unstable_cancelCallback, $c00590d434bbebaf$var$cc = $g8xyD.unstable_shouldYield, $c00590d434bbebaf$var$dc = $g8xyD.unstable_requestPaint, $c00590d434bbebaf$var$A = $g8xyD.unstable_now, $c00590d434bbebaf$var$ec = $g8xyD.unstable_getCurrentPriorityLevel, $c00590d434bbebaf$var$fc = $g8xyD.unstable_ImmediatePriority, $c00590d434bbebaf$var$gc = $g8xyD.unstable_UserBlockingPriority, $c00590d434bbebaf$var$hc = $g8xyD.unstable_NormalPriority, $c00590d434bbebaf$var$ic = $g8xyD.unstable_LowPriority, $c00590d434bbebaf$var$jc = $g8xyD.unstable_IdlePriority, $c00590d434bbebaf$var$kc = null, $c00590d434bbebaf$var$lc = null, $c00590d434bbebaf$var$B = null, $c00590d434bbebaf$var$mc = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__;
function $c00590d434bbebaf$var$nc(a, b) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) {
        globalThis.__ATL_REACT_METRICS.totalCommitCount++;
        if (globalThis.__ATL_REACT_METRICS.onCommitFiberRoot) {
            var c = 128 === (a.current.flags & 128);
            switch(b){
                case 1:
                    var d = $c00590d434bbebaf$var$fc;
                    break;
                case 4:
                    d = $c00590d434bbebaf$var$gc;
                    break;
                case 16:
                    d = $c00590d434bbebaf$var$hc;
                    break;
                case 536870912:
                    d = $c00590d434bbebaf$var$jc;
                    break;
                default:
                    d = $c00590d434bbebaf$var$hc;
            }
            globalThis.__ATL_REACT_METRICS.onCommitFiberRoot($c00590d434bbebaf$var$kc, a, d, c);
        }
    }
    if ($c00590d434bbebaf$var$lc && "function" === typeof $c00590d434bbebaf$var$lc.onCommitFiberRoot) try {
        var c = 128 === (a.current.flags & 128);
        switch(b){
            case 1:
                var d = $c00590d434bbebaf$var$fc;
                break;
            case 4:
                d = $c00590d434bbebaf$var$gc;
                break;
            case 16:
                d = $c00590d434bbebaf$var$hc;
                break;
            case 536870912:
                d = $c00590d434bbebaf$var$jc;
                break;
            default:
                d = $c00590d434bbebaf$var$hc;
        }
        $c00590d434bbebaf$var$lc.onCommitFiberRoot($c00590d434bbebaf$var$kc, a, d, c);
    } catch (e) {}
}
function $c00590d434bbebaf$var$oc(a) {
    $c00590d434bbebaf$var$B = a;
}
function $c00590d434bbebaf$var$pc() {
    for(var a = new Map, b = 1, c = 0; 31 > c; c++){
        var d = $c00590d434bbebaf$var$qc(b);
        a.set(b, d);
        b *= 2;
    }
    return a;
}
function $c00590d434bbebaf$var$rc() {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markCommitStopped && $c00590d434bbebaf$var$B.markCommitStopped();
}
function $c00590d434bbebaf$var$sc(a) {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentRenderStarted && $c00590d434bbebaf$var$B.markComponentRenderStarted(a);
}
function $c00590d434bbebaf$var$tc() {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentRenderStopped && $c00590d434bbebaf$var$B.markComponentRenderStopped();
}
function $c00590d434bbebaf$var$uc(a) {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentLayoutEffectUnmountStarted && $c00590d434bbebaf$var$B.markComponentLayoutEffectUnmountStarted(a);
}
function $c00590d434bbebaf$var$vc() {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentLayoutEffectUnmountStopped && $c00590d434bbebaf$var$B.markComponentLayoutEffectUnmountStopped();
}
function $c00590d434bbebaf$var$wc(a) {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markRenderStarted && $c00590d434bbebaf$var$B.markRenderStarted(a);
}
function $c00590d434bbebaf$var$xc() {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markRenderStopped && $c00590d434bbebaf$var$B.markRenderStopped();
}
function $c00590d434bbebaf$var$yc(a, b) {
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markStateUpdateScheduled && $c00590d434bbebaf$var$B.markStateUpdateScheduled(a, b);
}
var $c00590d434bbebaf$var$Ac = Math.clz32 ? Math.clz32 : $c00590d434bbebaf$var$zc, $c00590d434bbebaf$var$Bc = Math.log, $c00590d434bbebaf$var$Cc = Math.LN2;
function $c00590d434bbebaf$var$zc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($c00590d434bbebaf$var$Bc(a) / $c00590d434bbebaf$var$Cc | 0) | 0;
}
function $c00590d434bbebaf$var$qc(a) {
    if (a & 1) return "Sync";
    if (a & 2) return "InputContinuousHydration";
    if (a & 4) return "InputContinuous";
    if (a & 8) return "DefaultHydration";
    if (a & 16) return "Default";
    if (a & 32) return "TransitionHydration";
    if (a & 4194240) return "Transition";
    if (a & 130023424) return "Retry";
    if (a & 134217728) return "SelectiveHydration";
    if (a & 268435456) return "IdleHydration";
    if (a & 536870912) return "Idle";
    if (a & 1073741824) return "Offscreen";
}
var $c00590d434bbebaf$var$Dc = 64, $c00590d434bbebaf$var$Ec = 4194304;
function $c00590d434bbebaf$var$Fc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $c00590d434bbebaf$var$Gc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $c00590d434bbebaf$var$Fc(h) : (f &= g, 0 !== f && (d = $c00590d434bbebaf$var$Fc(f)));
    } else g = c & ~e, 0 !== g ? d = $c00590d434bbebaf$var$Fc(g) : 0 !== f && (d = $c00590d434bbebaf$var$Fc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240) || globalThis.__ATL_SYNC_HYDRATION_PRIORITY && 16 === e && 0 !== (f & 2143289386))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $c00590d434bbebaf$var$Ac(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $c00590d434bbebaf$var$Hc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $c00590d434bbebaf$var$Ic(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $c00590d434bbebaf$var$Ac(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $c00590d434bbebaf$var$Hc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $c00590d434bbebaf$var$Jc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $c00590d434bbebaf$var$Kc() {
    var a = $c00590d434bbebaf$var$Dc;
    $c00590d434bbebaf$var$Dc <<= 1;
    0 === ($c00590d434bbebaf$var$Dc & 4194240) && ($c00590d434bbebaf$var$Dc = 64);
    return a;
}
function $c00590d434bbebaf$var$Lc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $c00590d434bbebaf$var$Mc(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $c00590d434bbebaf$var$Ac(b);
    a[b] = c;
}
function $c00590d434bbebaf$var$Nc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $c00590d434bbebaf$var$Ac(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $c00590d434bbebaf$var$Oc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $c00590d434bbebaf$var$Ac(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
function $c00590d434bbebaf$var$Pc(a, b, c) {
    if ($c00590d434bbebaf$var$mc) for(a = a.pendingUpdatersLaneMap; 0 < c;){
        var d = 31 - $c00590d434bbebaf$var$Ac(c), e = 1 << d;
        a[d].add(b);
        c &= ~e;
    }
}
function $c00590d434bbebaf$var$Qc(a, b) {
    if ($c00590d434bbebaf$var$mc) for(var c = a.pendingUpdatersLaneMap, d = a.memoizedUpdaters; 0 < b;){
        var e = 31 - $c00590d434bbebaf$var$Ac(b);
        a = 1 << e;
        e = c[e];
        0 < e.size && (e.forEach(function(a) {
            var b = a.alternate;
            null !== b && d.has(b) || d.add(a);
        }), e.clear());
        b &= ~a;
    }
}
var $c00590d434bbebaf$var$E = 0;
function $c00590d434bbebaf$var$Rc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $c00590d434bbebaf$var$Sc, $c00590d434bbebaf$var$Tc, $c00590d434bbebaf$var$Uc, $c00590d434bbebaf$var$Vc, $c00590d434bbebaf$var$Wc, $c00590d434bbebaf$var$Xc = !1, $c00590d434bbebaf$var$Yc = [], $c00590d434bbebaf$var$Zc = null, $c00590d434bbebaf$var$$c = null, $c00590d434bbebaf$var$ad = null, $c00590d434bbebaf$var$bd = new Map, $c00590d434bbebaf$var$cd = new Map, $c00590d434bbebaf$var$dd = [], $c00590d434bbebaf$var$ed = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $c00590d434bbebaf$var$fd(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $c00590d434bbebaf$var$Zc = null;
            break;
        case "dragenter":
        case "dragleave":
            $c00590d434bbebaf$var$$c = null;
            break;
        case "mouseover":
        case "mouseout":
            $c00590d434bbebaf$var$ad = null;
            break;
        case "pointerover":
        case "pointerout":
            $c00590d434bbebaf$var$bd.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $c00590d434bbebaf$var$cd.delete(b.pointerId);
    }
}
function $c00590d434bbebaf$var$gd(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $c00590d434bbebaf$var$Cb(b), null !== b && $c00590d434bbebaf$var$Tc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $c00590d434bbebaf$var$hd(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $c00590d434bbebaf$var$Zc = $c00590d434bbebaf$var$gd($c00590d434bbebaf$var$Zc, a, b, c, d, e), !0;
        case "dragenter":
            return $c00590d434bbebaf$var$$c = $c00590d434bbebaf$var$gd($c00590d434bbebaf$var$$c, a, b, c, d, e), !0;
        case "mouseover":
            return $c00590d434bbebaf$var$ad = $c00590d434bbebaf$var$gd($c00590d434bbebaf$var$ad, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $c00590d434bbebaf$var$bd.set(f, $c00590d434bbebaf$var$gd($c00590d434bbebaf$var$bd.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $c00590d434bbebaf$var$cd.set(f, $c00590d434bbebaf$var$gd($c00590d434bbebaf$var$cd.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $c00590d434bbebaf$var$id(a) {
    var b = $c00590d434bbebaf$var$jd(a.target);
    if (null !== b) {
        var c = $c00590d434bbebaf$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $c00590d434bbebaf$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $c00590d434bbebaf$var$Wc(a.priority, function() {
                        $c00590d434bbebaf$var$Uc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $c00590d434bbebaf$var$kd(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $c00590d434bbebaf$var$ld(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $c00590d434bbebaf$var$wb = d;
            c.target.dispatchEvent(d);
            $c00590d434bbebaf$var$wb = null;
        } else return b = $c00590d434bbebaf$var$Cb(c), null !== b && $c00590d434bbebaf$var$Tc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $c00590d434bbebaf$var$md(a, b, c) {
    $c00590d434bbebaf$var$kd(a) && c.delete(b);
}
function $c00590d434bbebaf$var$nd() {
    $c00590d434bbebaf$var$Xc = !1;
    null !== $c00590d434bbebaf$var$Zc && $c00590d434bbebaf$var$kd($c00590d434bbebaf$var$Zc) && ($c00590d434bbebaf$var$Zc = null);
    null !== $c00590d434bbebaf$var$$c && $c00590d434bbebaf$var$kd($c00590d434bbebaf$var$$c) && ($c00590d434bbebaf$var$$c = null);
    null !== $c00590d434bbebaf$var$ad && $c00590d434bbebaf$var$kd($c00590d434bbebaf$var$ad) && ($c00590d434bbebaf$var$ad = null);
    $c00590d434bbebaf$var$bd.forEach($c00590d434bbebaf$var$md);
    $c00590d434bbebaf$var$cd.forEach($c00590d434bbebaf$var$md);
}
function $c00590d434bbebaf$var$od(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $c00590d434bbebaf$var$Xc || ($c00590d434bbebaf$var$Xc = !0, $g8xyD.unstable_scheduleCallback($g8xyD.unstable_NormalPriority, $c00590d434bbebaf$var$nd)));
}
function $c00590d434bbebaf$var$pd(a) {
    function b(b) {
        return $c00590d434bbebaf$var$od(b, a);
    }
    if (0 < $c00590d434bbebaf$var$Yc.length) {
        $c00590d434bbebaf$var$od($c00590d434bbebaf$var$Yc[0], a);
        for(var c = 1; c < $c00590d434bbebaf$var$Yc.length; c++){
            var d = $c00590d434bbebaf$var$Yc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $c00590d434bbebaf$var$Zc && $c00590d434bbebaf$var$od($c00590d434bbebaf$var$Zc, a);
    null !== $c00590d434bbebaf$var$$c && $c00590d434bbebaf$var$od($c00590d434bbebaf$var$$c, a);
    null !== $c00590d434bbebaf$var$ad && $c00590d434bbebaf$var$od($c00590d434bbebaf$var$ad, a);
    $c00590d434bbebaf$var$bd.forEach(b);
    $c00590d434bbebaf$var$cd.forEach(b);
    for(c = 0; c < $c00590d434bbebaf$var$dd.length; c++)d = $c00590d434bbebaf$var$dd[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $c00590d434bbebaf$var$dd.length && (c = $c00590d434bbebaf$var$dd[0], null === c.blockedOn);)$c00590d434bbebaf$var$id(c), null === c.blockedOn && $c00590d434bbebaf$var$dd.shift();
}
var $c00590d434bbebaf$var$qd = $c00590d434bbebaf$var$va.ReactCurrentBatchConfig, $c00590d434bbebaf$var$rd = !0;
function $c00590d434bbebaf$var$sd(a, b, c, d) {
    var e = $c00590d434bbebaf$var$E, f = $c00590d434bbebaf$var$qd.transition;
    $c00590d434bbebaf$var$qd.transition = null;
    try {
        $c00590d434bbebaf$var$E = 1, $c00590d434bbebaf$var$td(a, b, c, d);
    } finally{
        $c00590d434bbebaf$var$E = e, $c00590d434bbebaf$var$qd.transition = f;
    }
}
function $c00590d434bbebaf$var$ud(a, b, c, d) {
    var e = $c00590d434bbebaf$var$E, f = $c00590d434bbebaf$var$qd.transition;
    $c00590d434bbebaf$var$qd.transition = null;
    try {
        $c00590d434bbebaf$var$E = 4, $c00590d434bbebaf$var$td(a, b, c, d);
    } finally{
        $c00590d434bbebaf$var$E = e, $c00590d434bbebaf$var$qd.transition = f;
    }
}
function $c00590d434bbebaf$var$td(a, b, c, d) {
    if ($c00590d434bbebaf$var$rd) {
        var e = $c00590d434bbebaf$var$ld(a, b, c, d);
        if (null === e) $c00590d434bbebaf$var$vd(a, b, d, $c00590d434bbebaf$var$wd, c), $c00590d434bbebaf$var$fd(a, d);
        else if ($c00590d434bbebaf$var$hd(e, a, b, c, d)) d.stopPropagation();
        else if ($c00590d434bbebaf$var$fd(a, d), b & 4 && -1 < $c00590d434bbebaf$var$ed.indexOf(a)) {
            for(; null !== e;){
                var f = $c00590d434bbebaf$var$Cb(e);
                null !== f && $c00590d434bbebaf$var$Sc(f);
                f = $c00590d434bbebaf$var$ld(a, b, c, d);
                null === f && $c00590d434bbebaf$var$vd(a, b, d, $c00590d434bbebaf$var$wd, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $c00590d434bbebaf$var$vd(a, b, d, null, c);
    }
}
var $c00590d434bbebaf$var$wd = null;
function $c00590d434bbebaf$var$ld(a, b, c, d) {
    $c00590d434bbebaf$var$wd = null;
    a = $c00590d434bbebaf$var$xb(d);
    a = $c00590d434bbebaf$var$jd(a);
    if (null !== a) {
        if (b = $c00590d434bbebaf$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $c00590d434bbebaf$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $c00590d434bbebaf$var$wd = a;
    return null;
}
function $c00590d434bbebaf$var$xd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($c00590d434bbebaf$var$ec()){
                case $c00590d434bbebaf$var$fc:
                    return 1;
                case $c00590d434bbebaf$var$gc:
                    return 4;
                case $c00590d434bbebaf$var$hc:
                case $c00590d434bbebaf$var$ic:
                    return 16;
                case $c00590d434bbebaf$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $c00590d434bbebaf$var$yd = null, $c00590d434bbebaf$var$zd = null, $c00590d434bbebaf$var$Ad = null;
function $c00590d434bbebaf$var$Bd() {
    if ($c00590d434bbebaf$var$Ad) return $c00590d434bbebaf$var$Ad;
    var a, b = $c00590d434bbebaf$var$zd, c = b.length, d, e = "value" in $c00590d434bbebaf$var$yd ? $c00590d434bbebaf$var$yd.value : $c00590d434bbebaf$var$yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $c00590d434bbebaf$var$Ad = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $c00590d434bbebaf$var$Cd(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $c00590d434bbebaf$var$Dd() {
    return !0;
}
function $c00590d434bbebaf$var$Ed() {
    return !1;
}
function $c00590d434bbebaf$var$Fd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $c00590d434bbebaf$var$Dd : $c00590d434bbebaf$var$Ed;
        this.isPropagationStopped = $c00590d434bbebaf$var$Ed;
        return this;
    }
    $c00590d434bbebaf$var$u(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $c00590d434bbebaf$var$Dd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $c00590d434bbebaf$var$Dd);
        },
        persist: function() {},
        isPersistent: $c00590d434bbebaf$var$Dd
    });
    return b;
}
var $c00590d434bbebaf$var$Gd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $c00590d434bbebaf$var$Hd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Gd), $c00590d434bbebaf$var$Id = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Gd, {
    view: 0,
    detail: 0
}), $c00590d434bbebaf$var$Jd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Id), $c00590d434bbebaf$var$Kd, $c00590d434bbebaf$var$Ld, $c00590d434bbebaf$var$Md, $c00590d434bbebaf$var$Od = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Id, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $c00590d434bbebaf$var$Nd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $c00590d434bbebaf$var$Md && ($c00590d434bbebaf$var$Md && "mousemove" === a.type ? ($c00590d434bbebaf$var$Kd = a.screenX - $c00590d434bbebaf$var$Md.screenX, $c00590d434bbebaf$var$Ld = a.screenY - $c00590d434bbebaf$var$Md.screenY) : $c00590d434bbebaf$var$Ld = $c00590d434bbebaf$var$Kd = 0, $c00590d434bbebaf$var$Md = a);
        return $c00590d434bbebaf$var$Kd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $c00590d434bbebaf$var$Ld;
    }
}), $c00590d434bbebaf$var$Pd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Od), $c00590d434bbebaf$var$Qd = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Od, {
    dataTransfer: 0
}), $c00590d434bbebaf$var$Rd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Qd), $c00590d434bbebaf$var$Sd = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Id, {
    relatedTarget: 0
}), $c00590d434bbebaf$var$Td = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Sd), $c00590d434bbebaf$var$Ud = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Gd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c00590d434bbebaf$var$Vd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Ud), $c00590d434bbebaf$var$Wd = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Gd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $c00590d434bbebaf$var$Xd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Wd), $c00590d434bbebaf$var$Yd = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Gd, {
    data: 0
}), $c00590d434bbebaf$var$Zd = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$Yd), $c00590d434bbebaf$var$$d = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $c00590d434bbebaf$var$ae = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $c00590d434bbebaf$var$be = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $c00590d434bbebaf$var$ce(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $c00590d434bbebaf$var$be[a]) ? !!b[a] : !1;
}
function $c00590d434bbebaf$var$Nd() {
    return $c00590d434bbebaf$var$ce;
}
var $c00590d434bbebaf$var$de = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Id, {
    key: function(a) {
        if (a.key) {
            var b = $c00590d434bbebaf$var$$d[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $c00590d434bbebaf$var$Cd(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $c00590d434bbebaf$var$ae[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $c00590d434bbebaf$var$Nd,
    charCode: function(a) {
        return "keypress" === a.type ? $c00590d434bbebaf$var$Cd(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $c00590d434bbebaf$var$Cd(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $c00590d434bbebaf$var$ee = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$de), $c00590d434bbebaf$var$fe = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Od, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $c00590d434bbebaf$var$ge = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$fe), $c00590d434bbebaf$var$he = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Id, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $c00590d434bbebaf$var$Nd
}), $c00590d434bbebaf$var$ie = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$he), $c00590d434bbebaf$var$je = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Gd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $c00590d434bbebaf$var$ke = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$je), $c00590d434bbebaf$var$le = $c00590d434bbebaf$var$u({}, $c00590d434bbebaf$var$Od, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $c00590d434bbebaf$var$me = $c00590d434bbebaf$var$Fd($c00590d434bbebaf$var$le), $c00590d434bbebaf$var$ne = [
    9,
    13,
    27,
    32
], $c00590d434bbebaf$var$oe = $c00590d434bbebaf$var$ia && "CompositionEvent" in window, $c00590d434bbebaf$var$pe = null;
$c00590d434bbebaf$var$ia && "documentMode" in document && ($c00590d434bbebaf$var$pe = document.documentMode);
var $c00590d434bbebaf$var$qe = $c00590d434bbebaf$var$ia && "TextEvent" in window && !$c00590d434bbebaf$var$pe, $c00590d434bbebaf$var$re = $c00590d434bbebaf$var$ia && (!$c00590d434bbebaf$var$oe || $c00590d434bbebaf$var$pe && 8 < $c00590d434bbebaf$var$pe && 11 >= $c00590d434bbebaf$var$pe), $c00590d434bbebaf$var$se = String.fromCharCode(32), $c00590d434bbebaf$var$te = !1;
function $c00590d434bbebaf$var$ue(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $c00590d434bbebaf$var$ne.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $c00590d434bbebaf$var$ve(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $c00590d434bbebaf$var$we = !1;
function $c00590d434bbebaf$var$xe(a, b) {
    switch(a){
        case "compositionend":
            return $c00590d434bbebaf$var$ve(b);
        case "keypress":
            if (32 !== b.which) return null;
            $c00590d434bbebaf$var$te = !0;
            return $c00590d434bbebaf$var$se;
        case "textInput":
            return a = b.data, a === $c00590d434bbebaf$var$se && $c00590d434bbebaf$var$te ? null : a;
        default:
            return null;
    }
}
function $c00590d434bbebaf$var$ye(a, b) {
    if ($c00590d434bbebaf$var$we) return "compositionend" === a || !$c00590d434bbebaf$var$oe && $c00590d434bbebaf$var$ue(a, b) ? (a = $c00590d434bbebaf$var$Bd(), $c00590d434bbebaf$var$Ad = $c00590d434bbebaf$var$zd = $c00590d434bbebaf$var$yd = null, $c00590d434bbebaf$var$we = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $c00590d434bbebaf$var$re && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $c00590d434bbebaf$var$ze = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $c00590d434bbebaf$var$Ae(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$c00590d434bbebaf$var$ze[a.type] : "textarea" === b ? !0 : !1;
}
function $c00590d434bbebaf$var$Be(a, b, c, d) {
    $c00590d434bbebaf$var$Eb(d);
    b = $c00590d434bbebaf$var$Ce(b, "onChange");
    0 < b.length && (c = new $c00590d434bbebaf$var$Hd("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $c00590d434bbebaf$var$De = null, $c00590d434bbebaf$var$Ee = null;
function $c00590d434bbebaf$var$Fe(a) {
    $c00590d434bbebaf$var$Ge(a, 0);
}
function $c00590d434bbebaf$var$He(a) {
    var b = $c00590d434bbebaf$var$Ie(a);
    if ($c00590d434bbebaf$var$Wa(b)) return a;
}
function $c00590d434bbebaf$var$Je(a, b) {
    if ("change" === a) return b;
}
var $c00590d434bbebaf$var$Ke = !1;
if ($c00590d434bbebaf$var$ia) {
    var $c00590d434bbebaf$var$Le;
    if ($c00590d434bbebaf$var$ia) {
        var $c00590d434bbebaf$var$Me = "oninput" in document;
        if (!$c00590d434bbebaf$var$Me) {
            var $c00590d434bbebaf$var$Ne = document.createElement("div");
            $c00590d434bbebaf$var$Ne.setAttribute("oninput", "return;");
            $c00590d434bbebaf$var$Me = "function" === typeof $c00590d434bbebaf$var$Ne.oninput;
        }
        $c00590d434bbebaf$var$Le = $c00590d434bbebaf$var$Me;
    } else $c00590d434bbebaf$var$Le = !1;
    $c00590d434bbebaf$var$Ke = $c00590d434bbebaf$var$Le && (!document.documentMode || 9 < document.documentMode);
}
function $c00590d434bbebaf$var$Oe() {
    $c00590d434bbebaf$var$De && ($c00590d434bbebaf$var$De.detachEvent("onpropertychange", $c00590d434bbebaf$var$Pe), $c00590d434bbebaf$var$Ee = $c00590d434bbebaf$var$De = null);
}
function $c00590d434bbebaf$var$Pe(a) {
    if ("value" === a.propertyName && $c00590d434bbebaf$var$He($c00590d434bbebaf$var$Ee)) {
        var b = [];
        $c00590d434bbebaf$var$Be(b, $c00590d434bbebaf$var$Ee, a, $c00590d434bbebaf$var$xb(a));
        $c00590d434bbebaf$var$Jb($c00590d434bbebaf$var$Fe, b);
    }
}
function $c00590d434bbebaf$var$Qe(a, b, c) {
    "focusin" === a ? ($c00590d434bbebaf$var$Oe(), $c00590d434bbebaf$var$De = b, $c00590d434bbebaf$var$Ee = c, $c00590d434bbebaf$var$De.attachEvent("onpropertychange", $c00590d434bbebaf$var$Pe)) : "focusout" === a && $c00590d434bbebaf$var$Oe();
}
function $c00590d434bbebaf$var$Re(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $c00590d434bbebaf$var$He($c00590d434bbebaf$var$Ee);
}
function $c00590d434bbebaf$var$Se(a, b) {
    if ("click" === a) return $c00590d434bbebaf$var$He(b);
}
function $c00590d434bbebaf$var$Te(a, b) {
    if ("input" === a || "change" === a) return $c00590d434bbebaf$var$He(b);
}
function $c00590d434bbebaf$var$Ue(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $c00590d434bbebaf$var$Ve = "function" === typeof Object.is ? Object.is : $c00590d434bbebaf$var$Ue;
function $c00590d434bbebaf$var$We(a, b) {
    if ($c00590d434bbebaf$var$Ve(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$c00590d434bbebaf$var$ja.call(b, e) || !$c00590d434bbebaf$var$Ve(a[e], b[e])) return !1;
    }
    return !0;
}
function $c00590d434bbebaf$var$Xe(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $c00590d434bbebaf$var$Ye(a, b) {
    var c = $c00590d434bbebaf$var$Xe(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $c00590d434bbebaf$var$Xe(c);
    }
}
function $c00590d434bbebaf$var$Ze(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $c00590d434bbebaf$var$Ze(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $c00590d434bbebaf$var$$e() {
    for(var a = window, b = $c00590d434bbebaf$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $c00590d434bbebaf$var$Xa(a.document);
    }
    return b;
}
function $c00590d434bbebaf$var$af(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $c00590d434bbebaf$var$bf(a) {
    var b = $c00590d434bbebaf$var$$e(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $c00590d434bbebaf$var$Ze(c.ownerDocument.documentElement, c)) {
        if (null !== d && $c00590d434bbebaf$var$af(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $c00590d434bbebaf$var$Ye(c, f);
                var g = $c00590d434bbebaf$var$Ye(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $c00590d434bbebaf$var$cf = $c00590d434bbebaf$var$ia && "documentMode" in document && 11 >= document.documentMode, $c00590d434bbebaf$var$df = null, $c00590d434bbebaf$var$ef = null, $c00590d434bbebaf$var$ff = null, $c00590d434bbebaf$var$gf = !1;
function $c00590d434bbebaf$var$hf(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $c00590d434bbebaf$var$gf || null == $c00590d434bbebaf$var$df || $c00590d434bbebaf$var$df !== $c00590d434bbebaf$var$Xa(d) || (d = $c00590d434bbebaf$var$df, "selectionStart" in d && $c00590d434bbebaf$var$af(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $c00590d434bbebaf$var$ff && $c00590d434bbebaf$var$We($c00590d434bbebaf$var$ff, d) || ($c00590d434bbebaf$var$ff = d, d = $c00590d434bbebaf$var$Ce($c00590d434bbebaf$var$ef, "onSelect"), 0 < d.length && (b = new $c00590d434bbebaf$var$Hd("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $c00590d434bbebaf$var$df)));
}
function $c00590d434bbebaf$var$jf(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $c00590d434bbebaf$var$kf = {
    animationend: $c00590d434bbebaf$var$jf("Animation", "AnimationEnd"),
    animationiteration: $c00590d434bbebaf$var$jf("Animation", "AnimationIteration"),
    animationstart: $c00590d434bbebaf$var$jf("Animation", "AnimationStart"),
    transitionend: $c00590d434bbebaf$var$jf("Transition", "TransitionEnd")
}, $c00590d434bbebaf$var$lf = {}, $c00590d434bbebaf$var$mf = {};
$c00590d434bbebaf$var$ia && ($c00590d434bbebaf$var$mf = document.createElement("div").style, "AnimationEvent" in window || (delete $c00590d434bbebaf$var$kf.animationend.animation, delete $c00590d434bbebaf$var$kf.animationiteration.animation, delete $c00590d434bbebaf$var$kf.animationstart.animation), "TransitionEvent" in window || delete $c00590d434bbebaf$var$kf.transitionend.transition);
function $c00590d434bbebaf$var$nf(a) {
    if ($c00590d434bbebaf$var$lf[a]) return $c00590d434bbebaf$var$lf[a];
    if (!$c00590d434bbebaf$var$kf[a]) return a;
    var b = $c00590d434bbebaf$var$kf[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $c00590d434bbebaf$var$mf) return $c00590d434bbebaf$var$lf[a] = b[c];
    return a;
}
var $c00590d434bbebaf$var$of = $c00590d434bbebaf$var$nf("animationend"), $c00590d434bbebaf$var$pf = $c00590d434bbebaf$var$nf("animationiteration"), $c00590d434bbebaf$var$qf = $c00590d434bbebaf$var$nf("animationstart"), $c00590d434bbebaf$var$rf = $c00590d434bbebaf$var$nf("transitionend"), $c00590d434bbebaf$var$sf = new Map, $c00590d434bbebaf$var$tf = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $c00590d434bbebaf$var$uf(a, b) {
    $c00590d434bbebaf$var$sf.set(a, b);
    $c00590d434bbebaf$var$fa(b, [
        a
    ]);
}
for(var $c00590d434bbebaf$var$vf = 0; $c00590d434bbebaf$var$vf < $c00590d434bbebaf$var$tf.length; $c00590d434bbebaf$var$vf++){
    var $c00590d434bbebaf$var$wf = $c00590d434bbebaf$var$tf[$c00590d434bbebaf$var$vf], $c00590d434bbebaf$var$xf = $c00590d434bbebaf$var$wf.toLowerCase(), $c00590d434bbebaf$var$yf = $c00590d434bbebaf$var$wf[0].toUpperCase() + $c00590d434bbebaf$var$wf.slice(1);
    $c00590d434bbebaf$var$uf($c00590d434bbebaf$var$xf, "on" + $c00590d434bbebaf$var$yf);
}
$c00590d434bbebaf$var$uf($c00590d434bbebaf$var$of, "onAnimationEnd");
$c00590d434bbebaf$var$uf($c00590d434bbebaf$var$pf, "onAnimationIteration");
$c00590d434bbebaf$var$uf($c00590d434bbebaf$var$qf, "onAnimationStart");
$c00590d434bbebaf$var$uf("dblclick", "onDoubleClick");
$c00590d434bbebaf$var$uf("focusin", "onFocus");
$c00590d434bbebaf$var$uf("focusout", "onBlur");
$c00590d434bbebaf$var$uf($c00590d434bbebaf$var$rf, "onTransitionEnd");
$c00590d434bbebaf$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$c00590d434bbebaf$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$c00590d434bbebaf$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$c00590d434bbebaf$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$c00590d434bbebaf$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$c00590d434bbebaf$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$c00590d434bbebaf$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$c00590d434bbebaf$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$c00590d434bbebaf$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$c00590d434bbebaf$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $c00590d434bbebaf$var$zf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $c00590d434bbebaf$var$Af = new Set("cancel close invalid load scroll toggle".split(" ").concat($c00590d434bbebaf$var$zf));
function $c00590d434bbebaf$var$Bf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $c00590d434bbebaf$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $c00590d434bbebaf$var$Ge(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c00590d434bbebaf$var$Bf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $c00590d434bbebaf$var$Bf(e, h, l);
                f = k;
            }
        }
    }
    if ($c00590d434bbebaf$var$Qb) throw a = $c00590d434bbebaf$var$Rb, $c00590d434bbebaf$var$Qb = !1, $c00590d434bbebaf$var$Rb = null, a;
}
function $c00590d434bbebaf$var$F(a, b) {
    var c = b[$c00590d434bbebaf$var$Cf];
    void 0 === c && (c = b[$c00590d434bbebaf$var$Cf] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($c00590d434bbebaf$var$Df(b, a, 2, !1), c.add(d));
}
function $c00590d434bbebaf$var$Ef(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $c00590d434bbebaf$var$Df(c, a, d, b);
}
var $c00590d434bbebaf$var$Ff = "_reactListening" + Math.random().toString(36).slice(2);
function $c00590d434bbebaf$var$Gf(a) {
    if (!a[$c00590d434bbebaf$var$Ff]) {
        a[$c00590d434bbebaf$var$Ff] = !0;
        $c00590d434bbebaf$var$da.forEach(function(b) {
            "selectionchange" !== b && ($c00590d434bbebaf$var$Af.has(b) || $c00590d434bbebaf$var$Ef(b, !1, a), $c00590d434bbebaf$var$Ef(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$c00590d434bbebaf$var$Ff] || (b[$c00590d434bbebaf$var$Ff] = !0, $c00590d434bbebaf$var$Ef("selectionchange", !1, b));
    }
}
function $c00590d434bbebaf$var$Df(a, b, c, d) {
    switch($c00590d434bbebaf$var$xd(b)){
        case 1:
            var e = $c00590d434bbebaf$var$sd;
            break;
        case 4:
            e = $c00590d434bbebaf$var$ud;
            break;
        default:
            e = $c00590d434bbebaf$var$td;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$c00590d434bbebaf$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $c00590d434bbebaf$var$vd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $c00590d434bbebaf$var$jd(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $c00590d434bbebaf$var$Jb(function() {
        var d = f, e = $c00590d434bbebaf$var$xb(c), g = [];
        a: {
            var h = $c00590d434bbebaf$var$sf.get(a);
            if (void 0 !== h) {
                var k = $c00590d434bbebaf$var$Hd, m = a;
                switch(a){
                    case "keypress":
                        if (0 === $c00590d434bbebaf$var$Cd(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $c00590d434bbebaf$var$ee;
                        break;
                    case "focusin":
                        m = "focus";
                        k = $c00590d434bbebaf$var$Td;
                        break;
                    case "focusout":
                        m = "blur";
                        k = $c00590d434bbebaf$var$Td;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $c00590d434bbebaf$var$Td;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $c00590d434bbebaf$var$Pd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $c00590d434bbebaf$var$Rd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $c00590d434bbebaf$var$ie;
                        break;
                    case $c00590d434bbebaf$var$of:
                    case $c00590d434bbebaf$var$pf:
                    case $c00590d434bbebaf$var$qf:
                        k = $c00590d434bbebaf$var$Vd;
                        break;
                    case $c00590d434bbebaf$var$rf:
                        k = $c00590d434bbebaf$var$ke;
                        break;
                    case "scroll":
                        k = $c00590d434bbebaf$var$Jd;
                        break;
                    case "wheel":
                        k = $c00590d434bbebaf$var$me;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $c00590d434bbebaf$var$Xd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $c00590d434bbebaf$var$ge;
                }
                var w = 0 !== (b & 4), C = !w && "scroll" === a, x = w ? null !== h ? h + "Capture" : null : h;
                w = [];
                for(var y = d, v; null !== y;){
                    v = y;
                    var D = v.stateNode;
                    5 === v.tag && null !== D && (v = D, null !== x && (D = $c00590d434bbebaf$var$Kb(y, x), null != D && w.push($c00590d434bbebaf$var$Hf(y, D, v))));
                    if (C) break;
                    y = y.return;
                }
                0 < w.length && (h = new k(h, m, null, c, e), g.push({
                    event: h,
                    listeners: w
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $c00590d434bbebaf$var$wb && (m = c.relatedTarget || c.fromElement) && ($c00590d434bbebaf$var$jd(m) || m[$c00590d434bbebaf$var$If])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (m = c.relatedTarget || c.toElement, k = d, m = m ? $c00590d434bbebaf$var$jd(m) : null, null !== m && (C = $c00590d434bbebaf$var$Vb(m), m !== C || 5 !== m.tag && 6 !== m.tag)) m = null;
                    } else k = null, m = d;
                    if (k !== m) {
                        w = $c00590d434bbebaf$var$Pd;
                        D = "onMouseLeave";
                        x = "onMouseEnter";
                        y = "mouse";
                        if ("pointerout" === a || "pointerover" === a) w = $c00590d434bbebaf$var$ge, D = "onPointerLeave", x = "onPointerEnter", y = "pointer";
                        C = null == k ? h : $c00590d434bbebaf$var$Ie(k);
                        v = null == m ? h : $c00590d434bbebaf$var$Ie(m);
                        h = new w(D, y + "leave", k, c, e);
                        h.target = C;
                        h.relatedTarget = v;
                        D = null;
                        $c00590d434bbebaf$var$jd(e) === d && (w = new w(x, y + "enter", m, c, e), w.target = v, w.relatedTarget = C, D = w);
                        C = D;
                        if (k && m) b: {
                            w = k;
                            x = m;
                            y = 0;
                            for(v = w; v; v = $c00590d434bbebaf$var$Jf(v))y++;
                            v = 0;
                            for(D = x; D; D = $c00590d434bbebaf$var$Jf(D))v++;
                            for(; 0 < y - v;)w = $c00590d434bbebaf$var$Jf(w), y--;
                            for(; 0 < v - y;)x = $c00590d434bbebaf$var$Jf(x), v--;
                            for(; y--;){
                                if (w === x || null !== x && w === x.alternate) break b;
                                w = $c00590d434bbebaf$var$Jf(w);
                                x = $c00590d434bbebaf$var$Jf(x);
                            }
                            w = null;
                        }
                        else w = null;
                        null !== k && $c00590d434bbebaf$var$Kf(g, h, k, w, !1);
                        null !== m && null !== C && $c00590d434bbebaf$var$Kf(g, C, m, w, !0);
                    }
                }
            }
            a: {
                h = d ? $c00590d434bbebaf$var$Ie(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var ca = $c00590d434bbebaf$var$Je;
                else if ($c00590d434bbebaf$var$Ae(h)) {
                    if ($c00590d434bbebaf$var$Ke) ca = $c00590d434bbebaf$var$Te;
                    else {
                        ca = $c00590d434bbebaf$var$Re;
                        var R = $c00590d434bbebaf$var$Qe;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (ca = $c00590d434bbebaf$var$Se);
                if (ca && (ca = ca(a, d))) {
                    $c00590d434bbebaf$var$Be(g, ca, c, e);
                    break a;
                }
                R && R(a, h, d);
                "focusout" === a && (R = h._wrapperState) && R.controlled && "number" === h.type && $c00590d434bbebaf$var$bb(h, "number", h.value);
            }
            R = d ? $c00590d434bbebaf$var$Ie(d) : window;
            switch(a){
                case "focusin":
                    if ($c00590d434bbebaf$var$Ae(R) || "true" === R.contentEditable) $c00590d434bbebaf$var$df = R, $c00590d434bbebaf$var$ef = d, $c00590d434bbebaf$var$ff = null;
                    break;
                case "focusout":
                    $c00590d434bbebaf$var$ff = $c00590d434bbebaf$var$ef = $c00590d434bbebaf$var$df = null;
                    break;
                case "mousedown":
                    $c00590d434bbebaf$var$gf = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $c00590d434bbebaf$var$gf = !1;
                    $c00590d434bbebaf$var$hf(g, c, e);
                    break;
                case "selectionchange":
                    if ($c00590d434bbebaf$var$cf) break;
                case "keydown":
                case "keyup":
                    $c00590d434bbebaf$var$hf(g, c, e);
            }
            var sa;
            if ($c00590d434bbebaf$var$oe) b: {
                switch(a){
                    case "compositionstart":
                        var V = "onCompositionStart";
                        break b;
                    case "compositionend":
                        V = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        V = "onCompositionUpdate";
                        break b;
                }
                V = void 0;
            }
            else $c00590d434bbebaf$var$we ? $c00590d434bbebaf$var$ue(a, c) && (V = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (V = "onCompositionStart");
            V && ($c00590d434bbebaf$var$re && "ko" !== c.locale && ($c00590d434bbebaf$var$we || "onCompositionStart" !== V ? "onCompositionEnd" === V && $c00590d434bbebaf$var$we && (sa = $c00590d434bbebaf$var$Bd()) : ($c00590d434bbebaf$var$yd = e, $c00590d434bbebaf$var$zd = "value" in $c00590d434bbebaf$var$yd ? $c00590d434bbebaf$var$yd.value : $c00590d434bbebaf$var$yd.textContent, $c00590d434bbebaf$var$we = !0)), R = $c00590d434bbebaf$var$Ce(d, V), 0 < R.length && (V = new $c00590d434bbebaf$var$Zd(V, a, null, c, e), g.push({
                event: V,
                listeners: R
            }), sa ? V.data = sa : (sa = $c00590d434bbebaf$var$ve(c), null !== sa && (V.data = sa))));
            if (sa = $c00590d434bbebaf$var$qe ? $c00590d434bbebaf$var$xe(a, c) : $c00590d434bbebaf$var$ye(a, c)) d = $c00590d434bbebaf$var$Ce(d, "onBeforeInput"), 0 < d.length && (e = new $c00590d434bbebaf$var$Zd("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = sa);
        }
        $c00590d434bbebaf$var$Ge(g, b);
    });
}
function $c00590d434bbebaf$var$Hf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $c00590d434bbebaf$var$Ce(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $c00590d434bbebaf$var$Kb(a, c), null != f && d.unshift($c00590d434bbebaf$var$Hf(a, f, e)), f = $c00590d434bbebaf$var$Kb(a, b), null != f && d.push($c00590d434bbebaf$var$Hf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $c00590d434bbebaf$var$Jf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $c00590d434bbebaf$var$Kf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $c00590d434bbebaf$var$Kb(c, f), null != k && g.unshift($c00590d434bbebaf$var$Hf(c, k, h))) : e || (k = $c00590d434bbebaf$var$Kb(c, f), null != k && g.push($c00590d434bbebaf$var$Hf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $c00590d434bbebaf$var$Lf = /\r\n?/g, $c00590d434bbebaf$var$Mf = /\u0000|\uFFFD/g;
function $c00590d434bbebaf$var$Nf(a) {
    return ("string" === typeof a ? a : "" + a).replace($c00590d434bbebaf$var$Lf, "\n").replace($c00590d434bbebaf$var$Mf, "");
}
function $c00590d434bbebaf$var$Of(a, b, c) {
    b = $c00590d434bbebaf$var$Nf(b);
    if ($c00590d434bbebaf$var$Nf(a) !== b && c) throw Error($c00590d434bbebaf$var$p(425));
}
function $c00590d434bbebaf$var$Pf() {}
var $c00590d434bbebaf$var$Qf = null, $c00590d434bbebaf$var$Rf = null;
function $c00590d434bbebaf$var$Sf(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $c00590d434bbebaf$var$Tf = "function" === typeof setTimeout ? setTimeout : void 0, $c00590d434bbebaf$var$Uf = "function" === typeof clearTimeout ? clearTimeout : void 0, $c00590d434bbebaf$var$Vf = "function" === typeof Promise ? Promise : void 0, $c00590d434bbebaf$var$Xf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $c00590d434bbebaf$var$Vf ? function(a) {
    return $c00590d434bbebaf$var$Vf.resolve(null).then(a).catch($c00590d434bbebaf$var$Wf);
} : $c00590d434bbebaf$var$Tf;
function $c00590d434bbebaf$var$Wf(a) {
    setTimeout(function() {
        throw a;
    });
}
function $c00590d434bbebaf$var$Yf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $c00590d434bbebaf$var$pd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $c00590d434bbebaf$var$pd(b);
}
function $c00590d434bbebaf$var$Zf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $c00590d434bbebaf$var$$f(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $c00590d434bbebaf$var$ag = Math.random().toString(36).slice(2), $c00590d434bbebaf$var$bg = "__reactFiber$" + $c00590d434bbebaf$var$ag, $c00590d434bbebaf$var$cg = "__reactProps$" + $c00590d434bbebaf$var$ag, $c00590d434bbebaf$var$If = "__reactContainer$" + $c00590d434bbebaf$var$ag, $c00590d434bbebaf$var$Cf = "__reactEvents$" + $c00590d434bbebaf$var$ag, $c00590d434bbebaf$var$dg = "__reactListeners$" + $c00590d434bbebaf$var$ag, $c00590d434bbebaf$var$eg = "__reactHandles$" + $c00590d434bbebaf$var$ag;
function $c00590d434bbebaf$var$jd(a) {
    var b = a[$c00590d434bbebaf$var$bg];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$c00590d434bbebaf$var$If] || c[$c00590d434bbebaf$var$bg]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $c00590d434bbebaf$var$$f(a); null !== a;){
                if (c = a[$c00590d434bbebaf$var$bg]) return c;
                a = $c00590d434bbebaf$var$$f(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $c00590d434bbebaf$var$Cb(a) {
    a = a[$c00590d434bbebaf$var$bg] || a[$c00590d434bbebaf$var$If];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $c00590d434bbebaf$var$Ie(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($c00590d434bbebaf$var$p(33));
}
function $c00590d434bbebaf$var$Db(a) {
    return a[$c00590d434bbebaf$var$cg] || null;
}
var $c00590d434bbebaf$var$fg = [], $c00590d434bbebaf$var$gg = -1;
function $c00590d434bbebaf$var$hg(a) {
    return {
        current: a
    };
}
function $c00590d434bbebaf$var$G(a) {
    0 > $c00590d434bbebaf$var$gg || (a.current = $c00590d434bbebaf$var$fg[$c00590d434bbebaf$var$gg], $c00590d434bbebaf$var$fg[$c00590d434bbebaf$var$gg] = null, $c00590d434bbebaf$var$gg--);
}
function $c00590d434bbebaf$var$H(a, b) {
    $c00590d434bbebaf$var$gg++;
    $c00590d434bbebaf$var$fg[$c00590d434bbebaf$var$gg] = a.current;
    a.current = b;
}
var $c00590d434bbebaf$var$ig = {}, $c00590d434bbebaf$var$I = $c00590d434bbebaf$var$hg($c00590d434bbebaf$var$ig), $c00590d434bbebaf$var$jg = $c00590d434bbebaf$var$hg(!1), $c00590d434bbebaf$var$kg = $c00590d434bbebaf$var$ig;
function $c00590d434bbebaf$var$lg(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $c00590d434bbebaf$var$ig;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $c00590d434bbebaf$var$mg(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $c00590d434bbebaf$var$ng() {
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg);
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$I);
}
function $c00590d434bbebaf$var$og(a, b, c) {
    if ($c00590d434bbebaf$var$I.current !== $c00590d434bbebaf$var$ig) throw Error($c00590d434bbebaf$var$p(168));
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$I, b);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$jg, c);
}
function $c00590d434bbebaf$var$pg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($c00590d434bbebaf$var$p(108, $c00590d434bbebaf$var$Ra(a) || "Unknown", e));
    return $c00590d434bbebaf$var$u({}, c, d);
}
function $c00590d434bbebaf$var$qg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $c00590d434bbebaf$var$ig;
    $c00590d434bbebaf$var$kg = $c00590d434bbebaf$var$I.current;
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$I, a);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$jg, $c00590d434bbebaf$var$jg.current);
    return !0;
}
function $c00590d434bbebaf$var$rg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($c00590d434bbebaf$var$p(169));
    c ? (a = $c00590d434bbebaf$var$pg(a, b, $c00590d434bbebaf$var$kg), d.__reactInternalMemoizedMergedChildContext = a, $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg), $c00590d434bbebaf$var$G($c00590d434bbebaf$var$I), $c00590d434bbebaf$var$H($c00590d434bbebaf$var$I, a)) : $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$jg, c);
}
var $c00590d434bbebaf$var$sg = null, $c00590d434bbebaf$var$tg = !1, $c00590d434bbebaf$var$ug = !1;
function $c00590d434bbebaf$var$vg(a) {
    null === $c00590d434bbebaf$var$sg ? $c00590d434bbebaf$var$sg = [
        a
    ] : $c00590d434bbebaf$var$sg.push(a);
}
function $c00590d434bbebaf$var$wg(a) {
    $c00590d434bbebaf$var$tg = !0;
    $c00590d434bbebaf$var$vg(a);
}
function $c00590d434bbebaf$var$xg() {
    if (!$c00590d434bbebaf$var$ug && null !== $c00590d434bbebaf$var$sg) {
        $c00590d434bbebaf$var$ug = !0;
        var a = 0, b = $c00590d434bbebaf$var$E;
        try {
            var c = $c00590d434bbebaf$var$sg;
            for($c00590d434bbebaf$var$E = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $c00590d434bbebaf$var$sg = null;
            $c00590d434bbebaf$var$tg = !1;
        } catch (e) {
            throw null !== $c00590d434bbebaf$var$sg && ($c00590d434bbebaf$var$sg = $c00590d434bbebaf$var$sg.slice(a + 1)), $c00590d434bbebaf$var$ac($c00590d434bbebaf$var$fc, $c00590d434bbebaf$var$xg), e;
        } finally{
            $c00590d434bbebaf$var$E = b, $c00590d434bbebaf$var$ug = !1;
        }
    }
    return null;
}
var $c00590d434bbebaf$var$yg = [], $c00590d434bbebaf$var$zg = 0, $c00590d434bbebaf$var$Ag = null, $c00590d434bbebaf$var$Bg = 0, $c00590d434bbebaf$var$Cg = [], $c00590d434bbebaf$var$Dg = 0, $c00590d434bbebaf$var$Eg = null, $c00590d434bbebaf$var$Fg = 1, $c00590d434bbebaf$var$Gg = "";
function $c00590d434bbebaf$var$Hg(a, b) {
    $c00590d434bbebaf$var$yg[$c00590d434bbebaf$var$zg++] = $c00590d434bbebaf$var$Bg;
    $c00590d434bbebaf$var$yg[$c00590d434bbebaf$var$zg++] = $c00590d434bbebaf$var$Ag;
    $c00590d434bbebaf$var$Ag = a;
    $c00590d434bbebaf$var$Bg = b;
}
function $c00590d434bbebaf$var$Ig(a, b, c) {
    $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Fg;
    $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Gg;
    $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Eg;
    $c00590d434bbebaf$var$Eg = a;
    var d = $c00590d434bbebaf$var$Fg;
    a = $c00590d434bbebaf$var$Gg;
    var e = 32 - $c00590d434bbebaf$var$Ac(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $c00590d434bbebaf$var$Ac(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $c00590d434bbebaf$var$Fg = 1 << 32 - $c00590d434bbebaf$var$Ac(b) + e | c << e | d;
        $c00590d434bbebaf$var$Gg = f + a;
    } else $c00590d434bbebaf$var$Fg = 1 << f | c << e | d, $c00590d434bbebaf$var$Gg = a;
}
function $c00590d434bbebaf$var$Jg(a) {
    null !== a.return && ($c00590d434bbebaf$var$Hg(a, 1), $c00590d434bbebaf$var$Ig(a, 1, 0));
}
function $c00590d434bbebaf$var$Kg(a) {
    for(; a === $c00590d434bbebaf$var$Ag;)$c00590d434bbebaf$var$Ag = $c00590d434bbebaf$var$yg[--$c00590d434bbebaf$var$zg], $c00590d434bbebaf$var$yg[$c00590d434bbebaf$var$zg] = null, $c00590d434bbebaf$var$Bg = $c00590d434bbebaf$var$yg[--$c00590d434bbebaf$var$zg], $c00590d434bbebaf$var$yg[$c00590d434bbebaf$var$zg] = null;
    for(; a === $c00590d434bbebaf$var$Eg;)$c00590d434bbebaf$var$Eg = $c00590d434bbebaf$var$Cg[--$c00590d434bbebaf$var$Dg], $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg] = null, $c00590d434bbebaf$var$Gg = $c00590d434bbebaf$var$Cg[--$c00590d434bbebaf$var$Dg], $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg] = null, $c00590d434bbebaf$var$Fg = $c00590d434bbebaf$var$Cg[--$c00590d434bbebaf$var$Dg], $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg] = null;
}
var $c00590d434bbebaf$var$Lg = null, $c00590d434bbebaf$var$Mg = null, $c00590d434bbebaf$var$J = !1, $c00590d434bbebaf$var$Ng = null;
function $c00590d434bbebaf$var$Og(a, b) {
    var c = $c00590d434bbebaf$var$Pg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $c00590d434bbebaf$var$Qg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $c00590d434bbebaf$var$Lg = a, $c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Zf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $c00590d434bbebaf$var$Lg = a, $c00590d434bbebaf$var$Mg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $c00590d434bbebaf$var$Eg ? {
                id: $c00590d434bbebaf$var$Fg,
                overflow: $c00590d434bbebaf$var$Gg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $c00590d434bbebaf$var$Pg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $c00590d434bbebaf$var$Lg = a, $c00590d434bbebaf$var$Mg = null, !0) : !1;
        default:
            return !1;
    }
}
function $c00590d434bbebaf$var$Rg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $c00590d434bbebaf$var$Sg(a) {
    if ($c00590d434bbebaf$var$J) {
        var b = $c00590d434bbebaf$var$Mg;
        if (b) {
            var c = b;
            if (!$c00590d434bbebaf$var$Qg(a, b)) {
                if ($c00590d434bbebaf$var$Rg(a)) throw Error($c00590d434bbebaf$var$p(418));
                b = $c00590d434bbebaf$var$Zf(c.nextSibling);
                var d = $c00590d434bbebaf$var$Lg;
                b && $c00590d434bbebaf$var$Qg(a, b) ? $c00590d434bbebaf$var$Og(d, c) : (a.flags = a.flags & -4097 | 2, $c00590d434bbebaf$var$J = !1, $c00590d434bbebaf$var$Lg = a);
            }
        } else {
            if ($c00590d434bbebaf$var$Rg(a)) throw Error($c00590d434bbebaf$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $c00590d434bbebaf$var$J = !1;
            $c00590d434bbebaf$var$Lg = a;
        }
    }
}
function $c00590d434bbebaf$var$Tg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $c00590d434bbebaf$var$Lg = a;
}
function $c00590d434bbebaf$var$Ug(a) {
    if (a !== $c00590d434bbebaf$var$Lg) return !1;
    if (!$c00590d434bbebaf$var$J) return $c00590d434bbebaf$var$Tg(a), $c00590d434bbebaf$var$J = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$c00590d434bbebaf$var$Sf(a.type, a.memoizedProps));
    if (b && (b = $c00590d434bbebaf$var$Mg)) {
        if ($c00590d434bbebaf$var$Rg(a)) throw $c00590d434bbebaf$var$Vg(), Error($c00590d434bbebaf$var$p(418));
        for(; b;)$c00590d434bbebaf$var$Og(a, b), b = $c00590d434bbebaf$var$Zf(b.nextSibling);
    }
    $c00590d434bbebaf$var$Tg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($c00590d434bbebaf$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Zf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $c00590d434bbebaf$var$Mg = null;
        }
    } else $c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Lg ? $c00590d434bbebaf$var$Zf(a.stateNode.nextSibling) : null;
    return !0;
}
function $c00590d434bbebaf$var$Vg() {
    for(var a = $c00590d434bbebaf$var$Mg; a;)a = $c00590d434bbebaf$var$Zf(a.nextSibling);
}
function $c00590d434bbebaf$var$Wg() {
    $c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Lg = null;
    $c00590d434bbebaf$var$J = !1;
}
function $c00590d434bbebaf$var$Xg(a) {
    null === $c00590d434bbebaf$var$Ng ? $c00590d434bbebaf$var$Ng = [
        a
    ] : $c00590d434bbebaf$var$Ng.push(a);
}
var $c00590d434bbebaf$var$Yg = $c00590d434bbebaf$var$va.ReactCurrentBatchConfig;
function $c00590d434bbebaf$var$Zg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($c00590d434bbebaf$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($c00590d434bbebaf$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($c00590d434bbebaf$var$p(284));
        if (!c._owner) throw Error($c00590d434bbebaf$var$p(290, a));
    }
    return a;
}
function $c00590d434bbebaf$var$$g(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($c00590d434bbebaf$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $c00590d434bbebaf$var$ah(a) {
    var b = a._init;
    return b(a._payload);
}
function $c00590d434bbebaf$var$bh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $c00590d434bbebaf$var$ch(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $c00590d434bbebaf$var$dh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $c00590d434bbebaf$var$ya) return n(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $c00590d434bbebaf$var$Ha && $c00590d434bbebaf$var$ah(f) === b.type)) return d = e(b, c.props), d.ref = $c00590d434bbebaf$var$Zg(a, b, c), d.return = a, d;
        d = $c00590d434bbebaf$var$eh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $c00590d434bbebaf$var$Zg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $c00590d434bbebaf$var$fh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function n(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $c00590d434bbebaf$var$gh(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $c00590d434bbebaf$var$dh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $c00590d434bbebaf$var$wa:
                    return c = $c00590d434bbebaf$var$eh(b.type, b.key, b.props, null, a.mode, c), c.ref = $c00590d434bbebaf$var$Zg(a, null, b), c.return = a, c;
                case $c00590d434bbebaf$var$xa:
                    return b = $c00590d434bbebaf$var$fh(b, a.mode, c), b.return = a, b;
                case $c00590d434bbebaf$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($c00590d434bbebaf$var$db(b) || $c00590d434bbebaf$var$Ka(b)) return b = $c00590d434bbebaf$var$gh(b, a.mode, c, null), b.return = a, b;
            $c00590d434bbebaf$var$$g(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $c00590d434bbebaf$var$wa:
                    return c.key === e ? k(a, b, c, d) : null;
                case $c00590d434bbebaf$var$xa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $c00590d434bbebaf$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($c00590d434bbebaf$var$db(c) || $c00590d434bbebaf$var$Ka(c)) return null !== e ? null : n(a, b, c, d, null);
            $c00590d434bbebaf$var$$g(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $c00590d434bbebaf$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $c00590d434bbebaf$var$xa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $c00590d434bbebaf$var$Ha:
                    var f = d._init;
                    return z(a, b, c, f(d._payload), e);
            }
            if ($c00590d434bbebaf$var$db(d) || $c00590d434bbebaf$var$Ka(d)) return a = a.get(c) || null, n(b, a, d, e, null);
            $c00590d434bbebaf$var$$g(b, d);
        }
        return null;
    }
    function m(e, g, h, k) {
        for(var l = null, v = null, n = g, m = g = 0, y = null; null !== n && m < h.length; m++){
            n.index > m ? (y = n, n = null) : y = n.sibling;
            var x = r(e, n, h[m], k);
            if (null === x) {
                null === n && (n = y);
                break;
            }
            a && n && null === x.alternate && b(e, n);
            g = f(x, g, m);
            null === v ? l = x : v.sibling = x;
            v = x;
            n = y;
        }
        if (m === h.length) return c(e, n), $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, m), l;
        if (null === n) {
            for(; m < h.length; m++)n = q(e, h[m], k), null !== n && (g = f(n, g, m), null === v ? l = n : v.sibling = n, v = n);
            $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, m);
            return l;
        }
        for(n = d(e, n); m < h.length; m++)y = z(n, e, m, h[m], k), null !== y && (a && null !== y.alternate && n.delete(null === y.key ? m : y.key), g = f(y, g, m), null === v ? l = y : v.sibling = y, v = y);
        a && n.forEach(function(a) {
            return b(e, a);
        });
        $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, m);
        return l;
    }
    function w(e, g, h, k) {
        var l = $c00590d434bbebaf$var$Ka(h);
        if ("function" !== typeof l) throw Error($c00590d434bbebaf$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($c00590d434bbebaf$var$p(151));
        for(var n = l = null, m = g, v = g = 0, y = null, x = h.next(); null !== m && !x.done; v++, x = h.next()){
            m.index > v ? (y = m, m = null) : y = m.sibling;
            var w = r(e, m, x.value, k);
            if (null === w) {
                null === m && (m = y);
                break;
            }
            a && m && null === w.alternate && b(e, m);
            g = f(w, g, v);
            null === n ? l = w : n.sibling = w;
            n = w;
            m = y;
        }
        if (x.done) return c(e, m), $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, v), l;
        if (null === m) {
            for(; !x.done; v++, x = h.next())x = q(e, x.value, k), null !== x && (g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
            $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, v);
            return l;
        }
        for(m = d(e, m); !x.done; v++, x = h.next())x = z(m, e, v, x.value, k), null !== x && (a && null !== x.alternate && m.delete(null === x.key ? v : x.key), g = f(x, g, v), null === n ? l = x : n.sibling = x, n = x);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $c00590d434bbebaf$var$J && $c00590d434bbebaf$var$Hg(e, v);
        return l;
    }
    function C(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $c00590d434bbebaf$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $c00590d434bbebaf$var$wa:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $c00590d434bbebaf$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $c00590d434bbebaf$var$Ha && $c00590d434bbebaf$var$ah(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $c00590d434bbebaf$var$Zg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $c00590d434bbebaf$var$ya ? (d = $c00590d434bbebaf$var$gh(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $c00590d434bbebaf$var$eh(f.type, f.key, f.props, null, a.mode, h), h.ref = $c00590d434bbebaf$var$Zg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $c00590d434bbebaf$var$xa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $c00590d434bbebaf$var$fh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $c00590d434bbebaf$var$Ha:
                    return l = f._init, C(a, d, l(f._payload), h);
            }
            if ($c00590d434bbebaf$var$db(f)) return m(a, d, f, h);
            if ($c00590d434bbebaf$var$Ka(f)) return w(a, d, f, h);
            $c00590d434bbebaf$var$$g(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $c00590d434bbebaf$var$dh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return C;
}
var $c00590d434bbebaf$var$hh = $c00590d434bbebaf$var$bh(!0), $c00590d434bbebaf$var$ih = $c00590d434bbebaf$var$bh(!1), $c00590d434bbebaf$var$jh = $c00590d434bbebaf$var$hg(null), $c00590d434bbebaf$var$kh = null, $c00590d434bbebaf$var$lh = null, $c00590d434bbebaf$var$mh = null;
function $c00590d434bbebaf$var$nh() {
    $c00590d434bbebaf$var$mh = $c00590d434bbebaf$var$lh = $c00590d434bbebaf$var$kh = null;
}
function $c00590d434bbebaf$var$oh(a) {
    var b = $c00590d434bbebaf$var$jh.current;
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jh);
    a._currentValue = b;
}
function $c00590d434bbebaf$var$ph(a, b, c) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) globalThis.__ATL_REACT_METRICS.contextUpdateCount++;
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $c00590d434bbebaf$var$qh(a, b) {
    $c00590d434bbebaf$var$kh = a;
    $c00590d434bbebaf$var$mh = $c00590d434bbebaf$var$lh = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($c00590d434bbebaf$var$rh = !0), a.firstContext = null);
}
function $c00590d434bbebaf$var$sh(a) {
    var b = a._currentValue;
    if ($c00590d434bbebaf$var$mh !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $c00590d434bbebaf$var$lh) {
            if (null === $c00590d434bbebaf$var$kh) throw Error($c00590d434bbebaf$var$p(308));
            $c00590d434bbebaf$var$lh = a;
            $c00590d434bbebaf$var$kh.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $c00590d434bbebaf$var$lh = $c00590d434bbebaf$var$lh.next = a;
    }
    return b;
}
var $c00590d434bbebaf$var$th = null;
function $c00590d434bbebaf$var$uh(a) {
    null === $c00590d434bbebaf$var$th ? $c00590d434bbebaf$var$th = [
        a
    ] : $c00590d434bbebaf$var$th.push(a);
}
function $c00590d434bbebaf$var$vh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $c00590d434bbebaf$var$uh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $c00590d434bbebaf$var$wh(a, d);
}
function $c00590d434bbebaf$var$wh(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $c00590d434bbebaf$var$xh = !1;
function $c00590d434bbebaf$var$yh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $c00590d434bbebaf$var$zh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $c00590d434bbebaf$var$Ah(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $c00590d434bbebaf$var$Bh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($c00590d434bbebaf$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $c00590d434bbebaf$var$wh(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $c00590d434bbebaf$var$uh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $c00590d434bbebaf$var$wh(a, c);
}
function $c00590d434bbebaf$var$Ch(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c00590d434bbebaf$var$Oc(a, c);
    }
}
function $c00590d434bbebaf$var$Dh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $c00590d434bbebaf$var$Eh(a, b, c, d) {
    var e = a.updateQueue;
    $c00590d434bbebaf$var$xh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var n = a.alternate;
        null !== n && (n = n.updateQueue, h = n.lastBaseUpdate, h !== g && (null === h ? n.firstBaseUpdate = l : h.next = l, n.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        n = l = k = null;
        h = f;
        do {
            var r = h.lane, z = h.eventTime;
            if ((d & r) === r) {
                null !== n && (n = n.next = {
                    eventTime: z,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var m = a, w = h;
                    r = b;
                    z = c;
                    switch(w.tag){
                        case 1:
                            m = w.payload;
                            if ("function" === typeof m) {
                                q = m.call(z, q, r);
                                break a;
                            }
                            q = m;
                            break a;
                        case 3:
                            m.flags = m.flags & -65537 | 128;
                        case 0:
                            m = w.payload;
                            r = "function" === typeof m ? m.call(z, q, r) : m;
                            if (null === r || void 0 === r) break a;
                            q = $c00590d434bbebaf$var$u({}, q, r);
                            break a;
                        case 2:
                            $c00590d434bbebaf$var$xh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else z = {
                eventTime: z,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === n ? (l = n = z, k = q) : n = n.next = z, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === n && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = n;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $c00590d434bbebaf$var$Fh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $c00590d434bbebaf$var$Gh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($c00590d434bbebaf$var$p(191, e));
            e.call(d);
        }
    }
}
var $c00590d434bbebaf$var$Hh = {}, $c00590d434bbebaf$var$Ih = $c00590d434bbebaf$var$hg($c00590d434bbebaf$var$Hh), $c00590d434bbebaf$var$Jh = $c00590d434bbebaf$var$hg($c00590d434bbebaf$var$Hh), $c00590d434bbebaf$var$Kh = $c00590d434bbebaf$var$hg($c00590d434bbebaf$var$Hh);
function $c00590d434bbebaf$var$Lh(a) {
    if (a === $c00590d434bbebaf$var$Hh) throw Error($c00590d434bbebaf$var$p(174));
    return a;
}
function $c00590d434bbebaf$var$Mh(a, b) {
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Kh, b);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Jh, a);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ih, $c00590d434bbebaf$var$Hh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $c00590d434bbebaf$var$kb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $c00590d434bbebaf$var$kb(b, a);
    }
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Ih);
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ih, b);
}
function $c00590d434bbebaf$var$Nh() {
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Ih);
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Jh);
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Kh);
}
function $c00590d434bbebaf$var$Oh(a) {
    $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Kh.current);
    var b = $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Ih.current);
    var c = $c00590d434bbebaf$var$kb(b, a.type);
    b !== c && ($c00590d434bbebaf$var$H($c00590d434bbebaf$var$Jh, a), $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ih, c));
}
function $c00590d434bbebaf$var$Ph(a) {
    $c00590d434bbebaf$var$Jh.current === a && ($c00590d434bbebaf$var$G($c00590d434bbebaf$var$Ih), $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Jh));
}
var $c00590d434bbebaf$var$L = $c00590d434bbebaf$var$hg(0);
function $c00590d434bbebaf$var$Qh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $c00590d434bbebaf$var$Rh = [];
function $c00590d434bbebaf$var$Sh() {
    for(var a = 0; a < $c00590d434bbebaf$var$Rh.length; a++)$c00590d434bbebaf$var$Rh[a]._workInProgressVersionPrimary = null;
    $c00590d434bbebaf$var$Rh.length = 0;
}
var $c00590d434bbebaf$var$Th = $c00590d434bbebaf$var$va.ReactCurrentDispatcher, $c00590d434bbebaf$var$Uh = $c00590d434bbebaf$var$va.ReactCurrentBatchConfig, $c00590d434bbebaf$var$Vh = 0, $c00590d434bbebaf$var$M = null, $c00590d434bbebaf$var$N = null, $c00590d434bbebaf$var$O = null, $c00590d434bbebaf$var$Wh = !1, $c00590d434bbebaf$var$Xh = !1, $c00590d434bbebaf$var$Yh = 0, $c00590d434bbebaf$var$Zh = 0;
function $c00590d434bbebaf$var$P() {
    throw Error($c00590d434bbebaf$var$p(321));
}
function $c00590d434bbebaf$var$$h(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$c00590d434bbebaf$var$Ve(a[c], b[c])) return !1;
    return !0;
}
function $c00590d434bbebaf$var$ai(a, b, c, d, e, f) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) globalThis.__ATL_REACT_METRICS.componentRenderWithHooksCount++;
    $c00590d434bbebaf$var$Vh = f;
    $c00590d434bbebaf$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $c00590d434bbebaf$var$Th.current = null === a || null === a.memoizedState ? $c00590d434bbebaf$var$bi : $c00590d434bbebaf$var$ci;
    a = c(d, e);
    if ($c00590d434bbebaf$var$Xh) {
        f = 0;
        do {
            $c00590d434bbebaf$var$Xh = !1;
            $c00590d434bbebaf$var$Yh = 0;
            if (25 <= f) throw Error($c00590d434bbebaf$var$p(301));
            f += 1;
            $c00590d434bbebaf$var$O = $c00590d434bbebaf$var$N = null;
            b.updateQueue = null;
            $c00590d434bbebaf$var$Th.current = $c00590d434bbebaf$var$di;
            a = c(d, e);
        }while ($c00590d434bbebaf$var$Xh);
    }
    $c00590d434bbebaf$var$Th.current = $c00590d434bbebaf$var$ei;
    b = null !== $c00590d434bbebaf$var$N && null !== $c00590d434bbebaf$var$N.next;
    $c00590d434bbebaf$var$Vh = 0;
    $c00590d434bbebaf$var$O = $c00590d434bbebaf$var$N = $c00590d434bbebaf$var$M = null;
    $c00590d434bbebaf$var$Wh = !1;
    if (b) throw Error($c00590d434bbebaf$var$p(300));
    return a;
}
function $c00590d434bbebaf$var$fi() {
    var a = 0 !== $c00590d434bbebaf$var$Yh;
    $c00590d434bbebaf$var$Yh = 0;
    return a;
}
function $c00590d434bbebaf$var$gi() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $c00590d434bbebaf$var$O ? $c00590d434bbebaf$var$M.memoizedState = $c00590d434bbebaf$var$O = a : $c00590d434bbebaf$var$O = $c00590d434bbebaf$var$O.next = a;
    return $c00590d434bbebaf$var$O;
}
function $c00590d434bbebaf$var$hi() {
    if (null === $c00590d434bbebaf$var$N) {
        var a = $c00590d434bbebaf$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $c00590d434bbebaf$var$N.next;
    var b = null === $c00590d434bbebaf$var$O ? $c00590d434bbebaf$var$M.memoizedState : $c00590d434bbebaf$var$O.next;
    if (null !== b) $c00590d434bbebaf$var$O = b, $c00590d434bbebaf$var$N = a;
    else {
        if (null === a) throw Error($c00590d434bbebaf$var$p(310));
        $c00590d434bbebaf$var$N = a;
        a = {
            memoizedState: $c00590d434bbebaf$var$N.memoizedState,
            baseState: $c00590d434bbebaf$var$N.baseState,
            baseQueue: $c00590d434bbebaf$var$N.baseQueue,
            queue: $c00590d434bbebaf$var$N.queue,
            next: null
        };
        null === $c00590d434bbebaf$var$O ? $c00590d434bbebaf$var$M.memoizedState = $c00590d434bbebaf$var$O = a : $c00590d434bbebaf$var$O = $c00590d434bbebaf$var$O.next = a;
    }
    return $c00590d434bbebaf$var$O;
}
function $c00590d434bbebaf$var$ii(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $c00590d434bbebaf$var$ji(a) {
    var b = $c00590d434bbebaf$var$hi(), c = b.queue;
    if (null === c) throw Error($c00590d434bbebaf$var$p(311));
    c.lastRenderedReducer = a;
    var d = $c00590d434bbebaf$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var n = l.lane;
            if (($c00590d434bbebaf$var$Vh & n) === n) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: n,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $c00590d434bbebaf$var$M.lanes |= n;
                $c00590d434bbebaf$var$Fh |= n;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $c00590d434bbebaf$var$Ve(d, b.memoizedState) || ($c00590d434bbebaf$var$rh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $c00590d434bbebaf$var$M.lanes |= f, $c00590d434bbebaf$var$Fh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $c00590d434bbebaf$var$ki(a) {
    var b = $c00590d434bbebaf$var$hi(), c = b.queue;
    if (null === c) throw Error($c00590d434bbebaf$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $c00590d434bbebaf$var$Ve(f, b.memoizedState) || ($c00590d434bbebaf$var$rh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $c00590d434bbebaf$var$li() {}
function $c00590d434bbebaf$var$mi(a, b) {
    var c = $c00590d434bbebaf$var$M, d = $c00590d434bbebaf$var$hi(), e = b(), f = !$c00590d434bbebaf$var$Ve(d.memoizedState, e);
    f && (d.memoizedState = e, $c00590d434bbebaf$var$rh = !0);
    d = d.queue;
    $c00590d434bbebaf$var$ni($c00590d434bbebaf$var$oi.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $c00590d434bbebaf$var$O && $c00590d434bbebaf$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $c00590d434bbebaf$var$pi(9, $c00590d434bbebaf$var$qi.bind(null, c, d, e, b), void 0, null);
        if (null === $c00590d434bbebaf$var$Q) throw Error($c00590d434bbebaf$var$p(349));
        0 !== ($c00590d434bbebaf$var$Vh & 30) || $c00590d434bbebaf$var$ri(c, b, e);
    }
    return e;
}
function $c00590d434bbebaf$var$ri(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $c00590d434bbebaf$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c00590d434bbebaf$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $c00590d434bbebaf$var$qi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $c00590d434bbebaf$var$si(b) && $c00590d434bbebaf$var$ti(a);
}
function $c00590d434bbebaf$var$oi(a, b, c) {
    return c(function() {
        $c00590d434bbebaf$var$si(b) && $c00590d434bbebaf$var$ti(a);
    });
}
function $c00590d434bbebaf$var$si(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$c00590d434bbebaf$var$Ve(a, c);
    } catch (d) {
        return !0;
    }
}
function $c00590d434bbebaf$var$ti(a) {
    var b = $c00590d434bbebaf$var$wh(a, 1);
    null !== b && $c00590d434bbebaf$var$ui(b, a, 1, -1);
}
function $c00590d434bbebaf$var$vi(a) {
    var b = $c00590d434bbebaf$var$gi();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $c00590d434bbebaf$var$ii,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $c00590d434bbebaf$var$wi.bind(null, $c00590d434bbebaf$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $c00590d434bbebaf$var$pi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $c00590d434bbebaf$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $c00590d434bbebaf$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $c00590d434bbebaf$var$xi() {
    return $c00590d434bbebaf$var$hi().memoizedState;
}
function $c00590d434bbebaf$var$Ai(a, b, c, d) {
    var e = $c00590d434bbebaf$var$gi();
    $c00590d434bbebaf$var$M.flags |= a;
    e.memoizedState = $c00590d434bbebaf$var$pi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $c00590d434bbebaf$var$Bi(a, b, c, d) {
    var e = $c00590d434bbebaf$var$hi();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $c00590d434bbebaf$var$N) {
        var g = $c00590d434bbebaf$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $c00590d434bbebaf$var$$h(d, g.deps)) {
            e.memoizedState = $c00590d434bbebaf$var$pi(b, c, f, d);
            return;
        }
    }
    $c00590d434bbebaf$var$M.flags |= a;
    e.memoizedState = $c00590d434bbebaf$var$pi(1 | b, c, f, d);
}
function $c00590d434bbebaf$var$Ci(a, b) {
    return $c00590d434bbebaf$var$Ai(8390656, 8, a, b);
}
function $c00590d434bbebaf$var$ni(a, b) {
    return $c00590d434bbebaf$var$Bi(2048, 8, a, b);
}
function $c00590d434bbebaf$var$Di(a, b) {
    return $c00590d434bbebaf$var$Bi(4, 2, a, b);
}
function $c00590d434bbebaf$var$Ei(a, b) {
    return $c00590d434bbebaf$var$Bi(4, 4, a, b);
}
function $c00590d434bbebaf$var$Fi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $c00590d434bbebaf$var$Gi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $c00590d434bbebaf$var$Bi(4, 4, $c00590d434bbebaf$var$Fi.bind(null, b, a), c);
}
function $c00590d434bbebaf$var$Hi() {}
function $c00590d434bbebaf$var$Ii(a, b) {
    var c = $c00590d434bbebaf$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c00590d434bbebaf$var$$h(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c00590d434bbebaf$var$Ji(a, b) {
    var c = $c00590d434bbebaf$var$hi();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $c00590d434bbebaf$var$$h(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $c00590d434bbebaf$var$Ki(a, b, c) {
    if (0 === ($c00590d434bbebaf$var$Vh & 21)) return a.baseState && (a.baseState = !1, $c00590d434bbebaf$var$rh = !0), a.memoizedState = c;
    $c00590d434bbebaf$var$Ve(c, b) || (c = $c00590d434bbebaf$var$Kc(), $c00590d434bbebaf$var$M.lanes |= c, $c00590d434bbebaf$var$Fh |= c, a.baseState = !0);
    return b;
}
function $c00590d434bbebaf$var$Li(a, b) {
    var c = $c00590d434bbebaf$var$E;
    $c00590d434bbebaf$var$E = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $c00590d434bbebaf$var$Uh.transition;
    $c00590d434bbebaf$var$Uh.transition = {};
    try {
        a(!1), b();
    } finally{
        $c00590d434bbebaf$var$E = c, $c00590d434bbebaf$var$Uh.transition = d;
    }
}
function $c00590d434bbebaf$var$Mi() {
    return $c00590d434bbebaf$var$hi().memoizedState;
}
function $c00590d434bbebaf$var$Ni(a, b, c) {
    var d = $c00590d434bbebaf$var$Oi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c00590d434bbebaf$var$Pi(a)) $c00590d434bbebaf$var$Qi(b, c);
    else if (c = $c00590d434bbebaf$var$vh(a, b, c, d), null !== c) {
        var e = $c00590d434bbebaf$var$Ri();
        $c00590d434bbebaf$var$ui(c, a, d, e);
        $c00590d434bbebaf$var$Si(c, b, d);
    }
    $c00590d434bbebaf$var$yc(a, d);
}
function $c00590d434bbebaf$var$wi(a, b, c) {
    var d = $c00590d434bbebaf$var$Oi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($c00590d434bbebaf$var$Pi(a)) $c00590d434bbebaf$var$Qi(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($c00590d434bbebaf$var$Ve(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $c00590d434bbebaf$var$uh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $c00590d434bbebaf$var$vh(a, b, e, d);
        null !== c && (e = $c00590d434bbebaf$var$Ri(), $c00590d434bbebaf$var$ui(c, a, d, e), $c00590d434bbebaf$var$Si(c, b, d));
    }
    $c00590d434bbebaf$var$yc(a, d);
}
function $c00590d434bbebaf$var$Pi(a) {
    var b = a.alternate;
    return a === $c00590d434bbebaf$var$M || null !== b && b === $c00590d434bbebaf$var$M;
}
function $c00590d434bbebaf$var$Qi(a, b) {
    $c00590d434bbebaf$var$Xh = $c00590d434bbebaf$var$Wh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $c00590d434bbebaf$var$Si(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $c00590d434bbebaf$var$Oc(a, c);
    }
}
var $c00590d434bbebaf$var$ei = {
    readContext: $c00590d434bbebaf$var$sh,
    useCallback: $c00590d434bbebaf$var$P,
    useContext: $c00590d434bbebaf$var$P,
    useEffect: $c00590d434bbebaf$var$P,
    useImperativeHandle: $c00590d434bbebaf$var$P,
    useInsertionEffect: $c00590d434bbebaf$var$P,
    useLayoutEffect: $c00590d434bbebaf$var$P,
    useMemo: $c00590d434bbebaf$var$P,
    useReducer: $c00590d434bbebaf$var$P,
    useRef: $c00590d434bbebaf$var$P,
    useState: $c00590d434bbebaf$var$P,
    useDebugValue: $c00590d434bbebaf$var$P,
    useDeferredValue: $c00590d434bbebaf$var$P,
    useTransition: $c00590d434bbebaf$var$P,
    useMutableSource: $c00590d434bbebaf$var$P,
    useSyncExternalStore: $c00590d434bbebaf$var$P,
    useId: $c00590d434bbebaf$var$P,
    unstable_isNewReconciler: !1
}, $c00590d434bbebaf$var$bi = {
    readContext: $c00590d434bbebaf$var$sh,
    useCallback: function(a, b) {
        $c00590d434bbebaf$var$gi().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $c00590d434bbebaf$var$sh,
    useEffect: $c00590d434bbebaf$var$Ci,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $c00590d434bbebaf$var$Ai(4194308, 4, $c00590d434bbebaf$var$Fi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $c00590d434bbebaf$var$Ai(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $c00590d434bbebaf$var$Ai(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $c00590d434bbebaf$var$gi();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $c00590d434bbebaf$var$gi();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $c00590d434bbebaf$var$Ni.bind(null, $c00590d434bbebaf$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $c00590d434bbebaf$var$gi();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $c00590d434bbebaf$var$vi,
    useDebugValue: $c00590d434bbebaf$var$Hi,
    useDeferredValue: function(a) {
        return $c00590d434bbebaf$var$gi().memoizedState = a;
    },
    useTransition: function() {
        var a = $c00590d434bbebaf$var$vi(!1), b = a[0];
        a = $c00590d434bbebaf$var$Li.bind(null, a[1]);
        $c00590d434bbebaf$var$gi().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $c00590d434bbebaf$var$M, e = $c00590d434bbebaf$var$gi();
        if ($c00590d434bbebaf$var$J) {
            if (void 0 === c) throw Error($c00590d434bbebaf$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $c00590d434bbebaf$var$Q) throw Error($c00590d434bbebaf$var$p(349));
            0 !== ($c00590d434bbebaf$var$Vh & 30) || $c00590d434bbebaf$var$ri(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $c00590d434bbebaf$var$Ci($c00590d434bbebaf$var$oi.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $c00590d434bbebaf$var$pi(9, $c00590d434bbebaf$var$qi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $c00590d434bbebaf$var$gi(), b = $c00590d434bbebaf$var$Q.identifierPrefix;
        if ($c00590d434bbebaf$var$J) {
            var c = $c00590d434bbebaf$var$Gg;
            var d = $c00590d434bbebaf$var$Fg;
            c = (d & ~(1 << 32 - $c00590d434bbebaf$var$Ac(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $c00590d434bbebaf$var$Yh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $c00590d434bbebaf$var$Zh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $c00590d434bbebaf$var$ci = {
    readContext: $c00590d434bbebaf$var$sh,
    useCallback: $c00590d434bbebaf$var$Ii,
    useContext: $c00590d434bbebaf$var$sh,
    useEffect: $c00590d434bbebaf$var$ni,
    useImperativeHandle: $c00590d434bbebaf$var$Gi,
    useInsertionEffect: $c00590d434bbebaf$var$Di,
    useLayoutEffect: $c00590d434bbebaf$var$Ei,
    useMemo: $c00590d434bbebaf$var$Ji,
    useReducer: $c00590d434bbebaf$var$ji,
    useRef: $c00590d434bbebaf$var$xi,
    useState: function() {
        return $c00590d434bbebaf$var$ji($c00590d434bbebaf$var$ii);
    },
    useDebugValue: $c00590d434bbebaf$var$Hi,
    useDeferredValue: function(a) {
        var b = $c00590d434bbebaf$var$hi();
        return $c00590d434bbebaf$var$Ki(b, $c00590d434bbebaf$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c00590d434bbebaf$var$ji($c00590d434bbebaf$var$ii)[0], b = $c00590d434bbebaf$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c00590d434bbebaf$var$li,
    useSyncExternalStore: $c00590d434bbebaf$var$mi,
    useId: $c00590d434bbebaf$var$Mi,
    unstable_isNewReconciler: !1
}, $c00590d434bbebaf$var$di = {
    readContext: $c00590d434bbebaf$var$sh,
    useCallback: $c00590d434bbebaf$var$Ii,
    useContext: $c00590d434bbebaf$var$sh,
    useEffect: $c00590d434bbebaf$var$ni,
    useImperativeHandle: $c00590d434bbebaf$var$Gi,
    useInsertionEffect: $c00590d434bbebaf$var$Di,
    useLayoutEffect: $c00590d434bbebaf$var$Ei,
    useMemo: $c00590d434bbebaf$var$Ji,
    useReducer: $c00590d434bbebaf$var$ki,
    useRef: $c00590d434bbebaf$var$xi,
    useState: function() {
        return $c00590d434bbebaf$var$ki($c00590d434bbebaf$var$ii);
    },
    useDebugValue: $c00590d434bbebaf$var$Hi,
    useDeferredValue: function(a) {
        var b = $c00590d434bbebaf$var$hi();
        return null === $c00590d434bbebaf$var$N ? b.memoizedState = a : $c00590d434bbebaf$var$Ki(b, $c00590d434bbebaf$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $c00590d434bbebaf$var$ki($c00590d434bbebaf$var$ii)[0], b = $c00590d434bbebaf$var$hi().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $c00590d434bbebaf$var$li,
    useSyncExternalStore: $c00590d434bbebaf$var$mi,
    useId: $c00590d434bbebaf$var$Mi,
    unstable_isNewReconciler: !1
}, $c00590d434bbebaf$var$Ti = $g8xyD.unstable_now, $c00590d434bbebaf$var$Ui = 0, $c00590d434bbebaf$var$Vi = -1, $c00590d434bbebaf$var$Wi = -1, $c00590d434bbebaf$var$Xi = -1, $c00590d434bbebaf$var$Yi = !1, $c00590d434bbebaf$var$Zi = !1;
function $c00590d434bbebaf$var$$i(a, b) {
    if (0 <= $c00590d434bbebaf$var$Wi) {
        var c = $c00590d434bbebaf$var$Ti() - $c00590d434bbebaf$var$Wi;
        a.actualDuration += c;
        b && (a.selfBaseDuration = c);
        $c00590d434bbebaf$var$Wi = -1;
    }
}
function $c00590d434bbebaf$var$aj(a) {
    if (0 <= $c00590d434bbebaf$var$Vi) {
        var b = $c00590d434bbebaf$var$Ti() - $c00590d434bbebaf$var$Vi;
        $c00590d434bbebaf$var$Vi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a.stateNode.effectDuration += b;
                    return;
                case 12:
                    a.stateNode.effectDuration += b;
                    return;
            }
            a = a.return;
        }
    }
}
function $c00590d434bbebaf$var$bj(a) {
    if (0 <= $c00590d434bbebaf$var$Xi) {
        var b = $c00590d434bbebaf$var$Ti() - $c00590d434bbebaf$var$Xi;
        $c00590d434bbebaf$var$Xi = -1;
        for(a = a.return; null !== a;){
            switch(a.tag){
                case 3:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
                case 12:
                    a = a.stateNode;
                    null !== a && (a.passiveEffectDuration += b);
                    return;
            }
            a = a.return;
        }
    }
}
function $c00590d434bbebaf$var$cj() {
    $c00590d434bbebaf$var$Vi = $c00590d434bbebaf$var$Ti();
}
function $c00590d434bbebaf$var$dj(a) {
    for(var b = a.child; b;)a.actualDuration += b.actualDuration, b = b.sibling;
}
function $c00590d434bbebaf$var$ej(a, b) {
    if (a && a.defaultProps) {
        b = $c00590d434bbebaf$var$u({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $c00590d434bbebaf$var$fj(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $c00590d434bbebaf$var$u({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $c00590d434bbebaf$var$gj = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $c00590d434bbebaf$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c00590d434bbebaf$var$Ri(), e = $c00590d434bbebaf$var$Oi(a), f = $c00590d434bbebaf$var$Ah(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c00590d434bbebaf$var$Bh(a, f, e);
        null !== b && ($c00590d434bbebaf$var$ui(b, a, e, d), $c00590d434bbebaf$var$Ch(b, a, e));
        $c00590d434bbebaf$var$yc(a, e);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $c00590d434bbebaf$var$Ri(), e = $c00590d434bbebaf$var$Oi(a), f = $c00590d434bbebaf$var$Ah(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $c00590d434bbebaf$var$Bh(a, f, e);
        null !== b && ($c00590d434bbebaf$var$ui(b, a, e, d), $c00590d434bbebaf$var$Ch(b, a, e));
        $c00590d434bbebaf$var$yc(a, e);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $c00590d434bbebaf$var$Ri(), d = $c00590d434bbebaf$var$Oi(a), e = $c00590d434bbebaf$var$Ah(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $c00590d434bbebaf$var$Bh(a, e, d);
        null !== b && ($c00590d434bbebaf$var$ui(b, a, d, c), $c00590d434bbebaf$var$Ch(b, a, d));
        null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markForceUpdateScheduled && $c00590d434bbebaf$var$B.markForceUpdateScheduled(a, d);
    }
};
function $c00590d434bbebaf$var$hj(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$c00590d434bbebaf$var$We(c, d) || !$c00590d434bbebaf$var$We(e, f) : !0;
}
function $c00590d434bbebaf$var$ij(a, b, c) {
    var d = !1, e = $c00590d434bbebaf$var$ig;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $c00590d434bbebaf$var$sh(f) : (e = $c00590d434bbebaf$var$mg(b) ? $c00590d434bbebaf$var$kg : $c00590d434bbebaf$var$I.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $c00590d434bbebaf$var$lg(a, e) : $c00590d434bbebaf$var$ig);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $c00590d434bbebaf$var$gj;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $c00590d434bbebaf$var$jj(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $c00590d434bbebaf$var$gj.enqueueReplaceState(b, b.state, null);
}
function $c00590d434bbebaf$var$kj(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $c00590d434bbebaf$var$yh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $c00590d434bbebaf$var$sh(f) : (f = $c00590d434bbebaf$var$mg(b) ? $c00590d434bbebaf$var$kg : $c00590d434bbebaf$var$I.current, e.context = $c00590d434bbebaf$var$lg(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($c00590d434bbebaf$var$fj(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $c00590d434bbebaf$var$gj.enqueueReplaceState(e, e.state, null), $c00590d434bbebaf$var$Eh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $c00590d434bbebaf$var$lj(a, b) {
    try {
        var c = "", d = b;
        do c += $c00590d434bbebaf$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $c00590d434bbebaf$var$mj(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $c00590d434bbebaf$var$nj(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $c00590d434bbebaf$var$oj = "function" === typeof WeakMap ? WeakMap : Map;
function $c00590d434bbebaf$var$pj(a, b, c) {
    c = $c00590d434bbebaf$var$Ah(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $c00590d434bbebaf$var$qj || ($c00590d434bbebaf$var$qj = !0, $c00590d434bbebaf$var$rj = d);
        $c00590d434bbebaf$var$nj(a, b);
    };
    return c;
}
function $c00590d434bbebaf$var$sj(a, b, c) {
    c = $c00590d434bbebaf$var$Ah(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $c00590d434bbebaf$var$nj(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $c00590d434bbebaf$var$nj(a, b);
        "function" !== typeof d && (null === $c00590d434bbebaf$var$tj ? $c00590d434bbebaf$var$tj = new Set([
            this
        ]) : $c00590d434bbebaf$var$tj.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $c00590d434bbebaf$var$uj(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $c00590d434bbebaf$var$oj;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), d = $c00590d434bbebaf$var$vj.bind(null, a, b, c), $c00590d434bbebaf$var$mc && $c00590d434bbebaf$var$wj(a, c), b.then(d, d));
}
function $c00590d434bbebaf$var$xj(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $c00590d434bbebaf$var$yj(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $c00590d434bbebaf$var$Ah(-1, 1), b.tag = 2, $c00590d434bbebaf$var$Bh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $c00590d434bbebaf$var$zj = $c00590d434bbebaf$var$va.ReactCurrentOwner, $c00590d434bbebaf$var$rh = !1;
function $c00590d434bbebaf$var$Aj(a, b, c, d) {
    b.child = null === a ? $c00590d434bbebaf$var$ih(b, null, c, d) : $c00590d434bbebaf$var$hh(b, a.child, c, d);
}
function $c00590d434bbebaf$var$Bj(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $c00590d434bbebaf$var$qh(b, e);
    $c00590d434bbebaf$var$sc(b);
    d = $c00590d434bbebaf$var$ai(a, b, c, d, f, e);
    c = $c00590d434bbebaf$var$fi();
    $c00590d434bbebaf$var$tc();
    if (null !== a && !$c00590d434bbebaf$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c00590d434bbebaf$var$Cj(a, b, e);
    $c00590d434bbebaf$var$J && c && $c00590d434bbebaf$var$Jg(b);
    b.flags |= 1;
    $c00590d434bbebaf$var$Aj(a, b, d, e);
    return b.child;
}
function $c00590d434bbebaf$var$Dj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$c00590d434bbebaf$var$Ej(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $c00590d434bbebaf$var$Fj(a, b, f, d, e);
        a = $c00590d434bbebaf$var$eh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $c00590d434bbebaf$var$We;
        if (c(g, d) && a.ref === b.ref) return $c00590d434bbebaf$var$Cj(a, b, e);
    }
    b.flags |= 1;
    a = $c00590d434bbebaf$var$ch(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $c00590d434bbebaf$var$Fj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($c00590d434bbebaf$var$We(f, d) && a.ref === b.ref) {
            if ($c00590d434bbebaf$var$rh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($c00590d434bbebaf$var$rh = !0);
            else return b.lanes = a.lanes, $c00590d434bbebaf$var$Cj(a, b, e);
        }
    }
    return $c00590d434bbebaf$var$Gj(a, b, c, d, e);
}
function $c00590d434bbebaf$var$Hj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ij, $c00590d434bbebaf$var$Jj), $c00590d434bbebaf$var$Jj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ij, $c00590d434bbebaf$var$Jj), $c00590d434bbebaf$var$Jj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ij, $c00590d434bbebaf$var$Jj);
            $c00590d434bbebaf$var$Jj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $c00590d434bbebaf$var$H($c00590d434bbebaf$var$Ij, $c00590d434bbebaf$var$Jj), $c00590d434bbebaf$var$Jj |= d;
    $c00590d434bbebaf$var$Aj(a, b, e, c);
    return b.child;
}
function $c00590d434bbebaf$var$Kj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $c00590d434bbebaf$var$Gj(a, b, c, d, e) {
    var f = $c00590d434bbebaf$var$mg(c) ? $c00590d434bbebaf$var$kg : $c00590d434bbebaf$var$I.current;
    f = $c00590d434bbebaf$var$lg(b, f);
    $c00590d434bbebaf$var$qh(b, e);
    $c00590d434bbebaf$var$sc(b);
    c = $c00590d434bbebaf$var$ai(a, b, c, d, f, e);
    d = $c00590d434bbebaf$var$fi();
    $c00590d434bbebaf$var$tc();
    if (null !== a && !$c00590d434bbebaf$var$rh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $c00590d434bbebaf$var$Cj(a, b, e);
    $c00590d434bbebaf$var$J && d && $c00590d434bbebaf$var$Jg(b);
    b.flags |= 1;
    $c00590d434bbebaf$var$Aj(a, b, c, e);
    return b.child;
}
function $c00590d434bbebaf$var$Lj(a, b, c, d, e) {
    if ($c00590d434bbebaf$var$mg(c)) {
        var f = !0;
        $c00590d434bbebaf$var$qg(b);
    } else f = !1;
    $c00590d434bbebaf$var$qh(b, e);
    if (null === b.stateNode) $c00590d434bbebaf$var$Mj(a, b), $c00590d434bbebaf$var$ij(b, c, d), $c00590d434bbebaf$var$kj(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $c00590d434bbebaf$var$sh(l) : (l = $c00590d434bbebaf$var$mg(c) ? $c00590d434bbebaf$var$kg : $c00590d434bbebaf$var$I.current, l = $c00590d434bbebaf$var$lg(b, l));
        var n = c.getDerivedStateFromProps, q = "function" === typeof n || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $c00590d434bbebaf$var$jj(b, g, d, l);
        $c00590d434bbebaf$var$xh = !1;
        var r = b.memoizedState;
        g.state = r;
        $c00590d434bbebaf$var$Eh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $c00590d434bbebaf$var$jg.current || $c00590d434bbebaf$var$xh ? ("function" === typeof n && ($c00590d434bbebaf$var$fj(b, c, n, d), k = b.memoizedState), (h = $c00590d434bbebaf$var$xh || $c00590d434bbebaf$var$hj(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $c00590d434bbebaf$var$zh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $c00590d434bbebaf$var$ej(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $c00590d434bbebaf$var$sh(k) : (k = $c00590d434bbebaf$var$mg(c) ? $c00590d434bbebaf$var$kg : $c00590d434bbebaf$var$I.current, k = $c00590d434bbebaf$var$lg(b, k));
        var z = c.getDerivedStateFromProps;
        (n = "function" === typeof z || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $c00590d434bbebaf$var$jj(b, g, d, k);
        $c00590d434bbebaf$var$xh = !1;
        r = b.memoizedState;
        g.state = r;
        $c00590d434bbebaf$var$Eh(b, d, g, e);
        var m = b.memoizedState;
        h !== q || r !== m || $c00590d434bbebaf$var$jg.current || $c00590d434bbebaf$var$xh ? ("function" === typeof z && ($c00590d434bbebaf$var$fj(b, c, z, d), m = b.memoizedState), (l = $c00590d434bbebaf$var$xh || $c00590d434bbebaf$var$hj(b, c, l, d, r, m, k) || !1) ? (n || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, m, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, m, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = m), g.props = d, g.state = m, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $c00590d434bbebaf$var$Nj(a, b, c, d, f, e);
}
function $c00590d434bbebaf$var$Nj(a, b, c, d, e, f) {
    $c00590d434bbebaf$var$Kj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $c00590d434bbebaf$var$rg(b, c, !1), $c00590d434bbebaf$var$Cj(a, b, f);
    d = b.stateNode;
    $c00590d434bbebaf$var$zj.current = b;
    if (g && "function" !== typeof c.getDerivedStateFromError) {
        var h = null;
        $c00590d434bbebaf$var$Wi = -1;
    } else $c00590d434bbebaf$var$sc(b), h = d.render(), $c00590d434bbebaf$var$tc();
    b.flags |= 1;
    null !== a && g ? (g = h, b.child = $c00590d434bbebaf$var$hh(b, a.child, null, f), b.child = $c00590d434bbebaf$var$hh(b, null, g, f)) : $c00590d434bbebaf$var$Aj(a, b, h, f);
    b.memoizedState = d.state;
    e && (globalThis.__ATL_REACT_METRICS && globalThis.__ATL_REACT_METRICS.legacyContextUpdateCount++, $c00590d434bbebaf$var$rg(b, c, !0));
    return b.child;
}
function $c00590d434bbebaf$var$Oj(a) {
    var b = a.stateNode;
    b.pendingContext ? $c00590d434bbebaf$var$og(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $c00590d434bbebaf$var$og(a, b.context, !1);
    $c00590d434bbebaf$var$Mh(a, b.containerInfo);
}
function $c00590d434bbebaf$var$Rj(a, b, c, d, e) {
    $c00590d434bbebaf$var$Wg();
    $c00590d434bbebaf$var$Xg(e);
    b.flags |= 256;
    $c00590d434bbebaf$var$Aj(a, b, c, d);
    return b.child;
}
var $c00590d434bbebaf$var$Sj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $c00590d434bbebaf$var$Tj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $c00590d434bbebaf$var$Uj(a, b, c) {
    var d = b.pendingProps, e = $c00590d434bbebaf$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, e & 1);
    if (null === a) {
        $c00590d434bbebaf$var$Sg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g, b.mode & 2 && (f.actualDuration = 0, f.actualStartTime = -1, f.selfBaseDuration = 0, f.treeBaseDuration = 0)) : f = $c00590d434bbebaf$var$Vj(g, d, 0, null), a = $c00590d434bbebaf$var$gh(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $c00590d434bbebaf$var$Tj(c), b.memoizedState = $c00590d434bbebaf$var$Sj, a) : $c00590d434bbebaf$var$Wj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $c00590d434bbebaf$var$Xj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.mode & 2 && (d.actualDuration = 0, d.actualStartTime = -1, d.selfBaseDuration = e.selfBaseDuration, d.treeBaseDuration = e.treeBaseDuration), b.deletions = null) : (d = $c00590d434bbebaf$var$ch(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $c00590d434bbebaf$var$ch(h, f) : (f = $c00590d434bbebaf$var$gh(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $c00590d434bbebaf$var$Tj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $c00590d434bbebaf$var$Sj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $c00590d434bbebaf$var$ch(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $c00590d434bbebaf$var$Wj(a, b) {
    b = $c00590d434bbebaf$var$Vj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $c00590d434bbebaf$var$Yj(a, b, c, d) {
    null !== d && $c00590d434bbebaf$var$Xg(d);
    $c00590d434bbebaf$var$hh(b, a.child, null, c);
    a = $c00590d434bbebaf$var$Wj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $c00590d434bbebaf$var$Xj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = globalThis.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS ? $c00590d434bbebaf$var$lj(Error($c00590d434bbebaf$var$p(422)), a) : $c00590d434bbebaf$var$mj(Error($c00590d434bbebaf$var$p(422))), $c00590d434bbebaf$var$Yj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $c00590d434bbebaf$var$Vj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $c00590d434bbebaf$var$gh(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $c00590d434bbebaf$var$hh(b, a.child, null, g);
        b.child.memoizedState = $c00590d434bbebaf$var$Tj(g);
        b.memoizedState = $c00590d434bbebaf$var$Sj;
        return f;
    }
    if (0 === (b.mode & 1)) return $c00590d434bbebaf$var$Yj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($c00590d434bbebaf$var$p(419));
        d = $c00590d434bbebaf$var$mj(f, d, void 0);
        return $c00590d434bbebaf$var$Yj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($c00590d434bbebaf$var$rh || (globalThis.__ATL_SKIP_HAS_CONTEXT_CHANGED ? 0 : h)) {
        d = $c00590d434bbebaf$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $c00590d434bbebaf$var$wh(a, e), $c00590d434bbebaf$var$ui(d, a, e, -1));
        }
        $c00590d434bbebaf$var$Zj();
        d = globalThis.__ATL_CAPTURE_HYDRATION_ERROR_DETAILS ? $c00590d434bbebaf$var$lj(Error($c00590d434bbebaf$var$p(421)), a) : $c00590d434bbebaf$var$mj(Error($c00590d434bbebaf$var$p(421)));
        return $c00590d434bbebaf$var$Yj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $c00590d434bbebaf$var$ak.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Zf(e.nextSibling);
    $c00590d434bbebaf$var$Lg = b;
    $c00590d434bbebaf$var$J = !0;
    $c00590d434bbebaf$var$Ng = null;
    null !== a && ($c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Fg, $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Gg, $c00590d434bbebaf$var$Cg[$c00590d434bbebaf$var$Dg++] = $c00590d434bbebaf$var$Eg, $c00590d434bbebaf$var$Fg = a.id, $c00590d434bbebaf$var$Gg = a.overflow, $c00590d434bbebaf$var$Eg = b);
    b = $c00590d434bbebaf$var$Wj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $c00590d434bbebaf$var$bk(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $c00590d434bbebaf$var$ph(a.return, b, c);
}
function $c00590d434bbebaf$var$ck(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $c00590d434bbebaf$var$dk(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $c00590d434bbebaf$var$Aj(a, b, d.children, c);
    d = $c00590d434bbebaf$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $c00590d434bbebaf$var$bk(a, c, b);
            else if (19 === a.tag) $c00590d434bbebaf$var$bk(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $c00590d434bbebaf$var$Qh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $c00590d434bbebaf$var$ck(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $c00590d434bbebaf$var$Qh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $c00590d434bbebaf$var$ck(b, !0, c, null, f);
            break;
        case "together":
            $c00590d434bbebaf$var$ck(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $c00590d434bbebaf$var$Mj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $c00590d434bbebaf$var$Cj(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $c00590d434bbebaf$var$Wi = -1;
    $c00590d434bbebaf$var$Fh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($c00590d434bbebaf$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $c00590d434bbebaf$var$ch(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $c00590d434bbebaf$var$ch(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $c00590d434bbebaf$var$ek(a, b, c) {
    switch(b.tag){
        case 3:
            $c00590d434bbebaf$var$Oj(b);
            $c00590d434bbebaf$var$Wg();
            break;
        case 5:
            $c00590d434bbebaf$var$Oh(b);
            break;
        case 1:
            $c00590d434bbebaf$var$mg(b.type) && $c00590d434bbebaf$var$qg(b);
            break;
        case 4:
            $c00590d434bbebaf$var$Mh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $c00590d434bbebaf$var$H($c00590d434bbebaf$var$jh, d._currentValue);
            d._currentValue = e;
            break;
        case 12:
            0 !== (c & b.childLanes) && (b.flags |= 4);
            d = b.stateNode;
            d.effectDuration = 0;
            d.passiveEffectDuration = 0;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, $c00590d434bbebaf$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $c00590d434bbebaf$var$Uj(a, b, c);
                $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, $c00590d434bbebaf$var$L.current & 1);
                a = $c00590d434bbebaf$var$Cj(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, $c00590d434bbebaf$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $c00590d434bbebaf$var$dk(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, $c00590d434bbebaf$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $c00590d434bbebaf$var$Hj(a, b, c);
    }
    return $c00590d434bbebaf$var$Cj(a, b, c);
}
var $c00590d434bbebaf$var$fk, $c00590d434bbebaf$var$gk, $c00590d434bbebaf$var$hk, $c00590d434bbebaf$var$ik;
$c00590d434bbebaf$var$fk = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$c00590d434bbebaf$var$gk = function() {};
$c00590d434bbebaf$var$hk = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Ih.current);
        var f = null;
        switch(c){
            case "input":
                e = $c00590d434bbebaf$var$Ya(a, e);
                d = $c00590d434bbebaf$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $c00590d434bbebaf$var$u({}, e, {
                    value: void 0
                });
                d = $c00590d434bbebaf$var$u({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $c00590d434bbebaf$var$fb(a, e);
                d = $c00590d434bbebaf$var$fb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $c00590d434bbebaf$var$Pf);
        }
        $c00590d434bbebaf$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($c00590d434bbebaf$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($c00590d434bbebaf$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $c00590d434bbebaf$var$F("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$c00590d434bbebaf$var$ik = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $c00590d434bbebaf$var$jk(a, b) {
    if (!$c00590d434bbebaf$var$J) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $c00590d434bbebaf$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) {
        if (0 !== (a.mode & 2)) {
            for(var e = a.selfBaseDuration, f = a.child; null !== f;)c |= f.lanes | f.childLanes, d |= f.subtreeFlags & 14680064, d |= f.flags & 14680064, e += f.treeBaseDuration, f = f.sibling;
            a.treeBaseDuration = e;
        } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    } else if (0 !== (a.mode & 2)) {
        e = a.actualDuration;
        f = a.selfBaseDuration;
        for(var g = a.child; null !== g;)c |= g.lanes | g.childLanes, d |= g.subtreeFlags, d |= g.flags, e += g.actualDuration, f += g.treeBaseDuration, g = g.sibling;
        a.actualDuration = e;
        a.treeBaseDuration = f;
    } else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $c00590d434bbebaf$var$kk(a, b, c) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) {
        var __m = globalThis.__ATL_REACT_METRICS, __t = b.tag, __m0 = null === a;
        if (__m0) __m.mountWorkCount++;
        else __m.updateWorkCount++;
        if (__t === 0 || __t === 1 || __t === 2 || __t === 11 || __t === 14 || __t === 15) {
            __m.componentWorkCount++;
            __m0 ? __m.componentMountWorkCount++ : __m.componentUpdateWorkCount++;
        } else if (__t === 5 || __t === 6) __m.domWorkCount++;
    }
    var d = b.pendingProps;
    $c00590d434bbebaf$var$Kg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $c00590d434bbebaf$var$S(b), null;
        case 1:
            return $c00590d434bbebaf$var$mg(b.type) && $c00590d434bbebaf$var$ng(), $c00590d434bbebaf$var$S(b), null;
        case 3:
            d = b.stateNode;
            $c00590d434bbebaf$var$Nh();
            $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg);
            $c00590d434bbebaf$var$G($c00590d434bbebaf$var$I);
            $c00590d434bbebaf$var$Sh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $c00590d434bbebaf$var$Ug(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $c00590d434bbebaf$var$Ng && ($c00590d434bbebaf$var$lk($c00590d434bbebaf$var$Ng), $c00590d434bbebaf$var$Ng = null));
            $c00590d434bbebaf$var$gk(a, b);
            $c00590d434bbebaf$var$S(b);
            return null;
        case 5:
            $c00590d434bbebaf$var$Ph(b);
            var e = $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Kh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $c00590d434bbebaf$var$hk(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($c00590d434bbebaf$var$p(166));
                    $c00590d434bbebaf$var$S(b);
                    return null;
                }
                a = $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Ih.current);
                if ($c00590d434bbebaf$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.type;
                    c = b.memoizedProps;
                    d[$c00590d434bbebaf$var$bg] = b;
                    d[$c00590d434bbebaf$var$cg] = c;
                    var f = 0 !== (b.mode & 1);
                    switch(a){
                        case "dialog":
                            $c00590d434bbebaf$var$F("cancel", d);
                            $c00590d434bbebaf$var$F("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $c00590d434bbebaf$var$F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $c00590d434bbebaf$var$zf.length; e++)$c00590d434bbebaf$var$F($c00590d434bbebaf$var$zf[e], d);
                            break;
                        case "source":
                            $c00590d434bbebaf$var$F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $c00590d434bbebaf$var$F("error", d);
                            $c00590d434bbebaf$var$F("load", d);
                            break;
                        case "details":
                            $c00590d434bbebaf$var$F("toggle", d);
                            break;
                        case "input":
                            $c00590d434bbebaf$var$Za(d, c);
                            $c00590d434bbebaf$var$F("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!c.multiple
                            };
                            $c00590d434bbebaf$var$F("invalid", d);
                            break;
                        case "textarea":
                            $c00590d434bbebaf$var$gb(d, c), $c00590d434bbebaf$var$F("invalid", d);
                    }
                    $c00590d434bbebaf$var$ub(a, c);
                    e = null;
                    for(var g in c)if (c.hasOwnProperty(g)) {
                        var h = c[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== c.suppressHydrationWarning && $c00590d434bbebaf$var$Of(d.textContent, h, f), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== c.suppressHydrationWarning && $c00590d434bbebaf$var$Of(d.textContent, h, f), e = [
                            "children",
                            "" + h
                        ]) : $c00590d434bbebaf$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $c00590d434bbebaf$var$F("scroll", d);
                    }
                    switch(a){
                        case "input":
                            $c00590d434bbebaf$var$Va(d);
                            $c00590d434bbebaf$var$cb(d, c, !0);
                            break;
                        case "textarea":
                            $c00590d434bbebaf$var$Va(d);
                            $c00590d434bbebaf$var$ib(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof c.onClick && (d.onclick = $c00590d434bbebaf$var$Pf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $c00590d434bbebaf$var$jb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$c00590d434bbebaf$var$bg] = b;
                    a[$c00590d434bbebaf$var$cg] = d;
                    $c00590d434bbebaf$var$fk(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $c00590d434bbebaf$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $c00590d434bbebaf$var$F("cancel", a);
                                $c00590d434bbebaf$var$F("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $c00590d434bbebaf$var$F("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $c00590d434bbebaf$var$zf.length; e++)$c00590d434bbebaf$var$F($c00590d434bbebaf$var$zf[e], a);
                                e = d;
                                break;
                            case "source":
                                $c00590d434bbebaf$var$F("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $c00590d434bbebaf$var$F("error", a);
                                $c00590d434bbebaf$var$F("load", a);
                                e = d;
                                break;
                            case "details":
                                $c00590d434bbebaf$var$F("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $c00590d434bbebaf$var$Za(a, d);
                                e = $c00590d434bbebaf$var$Ya(a, d);
                                $c00590d434bbebaf$var$F("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $c00590d434bbebaf$var$u({}, d, {
                                    value: void 0
                                });
                                $c00590d434bbebaf$var$F("invalid", a);
                                break;
                            case "textarea":
                                $c00590d434bbebaf$var$gb(a, d);
                                e = $c00590d434bbebaf$var$fb(a, d);
                                $c00590d434bbebaf$var$F("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $c00590d434bbebaf$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $c00590d434bbebaf$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $c00590d434bbebaf$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $c00590d434bbebaf$var$ob(a, k) : "number" === typeof k && $c00590d434bbebaf$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($c00590d434bbebaf$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $c00590d434bbebaf$var$F("scroll", a) : null != k && $c00590d434bbebaf$var$ua(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $c00590d434bbebaf$var$Va(a);
                                $c00590d434bbebaf$var$cb(a, d, !1);
                                break;
                            case "textarea":
                                $c00590d434bbebaf$var$Va(a);
                                $c00590d434bbebaf$var$ib(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $c00590d434bbebaf$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $c00590d434bbebaf$var$eb(a, !!d.multiple, f, !1) : null != d.defaultValue && $c00590d434bbebaf$var$eb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $c00590d434bbebaf$var$Pf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $c00590d434bbebaf$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $c00590d434bbebaf$var$ik(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($c00590d434bbebaf$var$p(166));
                a = $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Kh.current);
                $c00590d434bbebaf$var$Lh($c00590d434bbebaf$var$Ih.current);
                if ($c00590d434bbebaf$var$Ug(b)) {
                    d = b.stateNode;
                    a = b.memoizedProps;
                    d[$c00590d434bbebaf$var$bg] = b;
                    if (c = d.nodeValue !== a) {
                        if (f = $c00590d434bbebaf$var$Lg, null !== f) switch(f.tag){
                            case 3:
                                $c00590d434bbebaf$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                                break;
                            case 5:
                                !0 !== f.memoizedProps.suppressHydrationWarning && $c00590d434bbebaf$var$Of(d.nodeValue, a, 0 !== (f.mode & 1));
                        }
                    }
                    c && (b.flags |= 4);
                } else d = (9 === a.nodeType ? a : a.ownerDocument).createTextNode(d), d[$c00590d434bbebaf$var$bg] = b, b.stateNode = d;
            }
            $c00590d434bbebaf$var$S(b);
            return null;
        case 13:
            $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($c00590d434bbebaf$var$J && null !== $c00590d434bbebaf$var$Mg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $c00590d434bbebaf$var$Vg(), $c00590d434bbebaf$var$Wg(), b.flags |= 98560, f = !1;
                else if (f = $c00590d434bbebaf$var$Ug(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($c00590d434bbebaf$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($c00590d434bbebaf$var$p(317));
                        f[$c00590d434bbebaf$var$bg] = b;
                        $c00590d434bbebaf$var$S(b);
                        0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    } else $c00590d434bbebaf$var$Wg(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4, $c00590d434bbebaf$var$S(b), 0 !== (b.mode & 2) && null !== d && (f = b.child, null !== f && (b.treeBaseDuration -= f.treeBaseDuration));
                    f = !1;
                } else null !== $c00590d434bbebaf$var$Ng && ($c00590d434bbebaf$var$lk($c00590d434bbebaf$var$Ng), $c00590d434bbebaf$var$Ng = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, 0 !== (b.mode & 2) && $c00590d434bbebaf$var$dj(b), b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($c00590d434bbebaf$var$L.current & 1) ? 0 === $c00590d434bbebaf$var$T && ($c00590d434bbebaf$var$T = 3) : $c00590d434bbebaf$var$Zj()));
            null !== b.updateQueue && (b.flags |= 4);
            $c00590d434bbebaf$var$S(b);
            0 !== (b.mode & 2) && d && (d = b.child, null !== d && (b.treeBaseDuration -= d.treeBaseDuration));
            return null;
        case 4:
            return $c00590d434bbebaf$var$Nh(), $c00590d434bbebaf$var$gk(a, b), null === a && $c00590d434bbebaf$var$Gf(b.stateNode.containerInfo), $c00590d434bbebaf$var$S(b), null;
        case 10:
            return $c00590d434bbebaf$var$oh(b.type._context), $c00590d434bbebaf$var$S(b), null;
        case 17:
            return $c00590d434bbebaf$var$mg(b.type) && $c00590d434bbebaf$var$ng(), $c00590d434bbebaf$var$S(b), null;
        case 19:
            $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L);
            f = b.memoizedState;
            if (null === f) return $c00590d434bbebaf$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $c00590d434bbebaf$var$jk(f, !1);
                else {
                    if (0 !== $c00590d434bbebaf$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $c00590d434bbebaf$var$Qh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $c00590d434bbebaf$var$jk(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(a = b.child; null !== a;)c = a, g = d, c.flags &= 14680066, f = c.alternate, null === f ? (c.childLanes = 0, c.lanes = g, c.child = null, c.subtreeFlags = 0, c.memoizedProps = null, c.memoizedState = null, c.updateQueue = null, c.dependencies = null, c.stateNode = null, c.selfBaseDuration = 0, c.treeBaseDuration = 0) : (c.childLanes = f.childLanes, c.lanes = f.lanes, c.child = f.child, c.subtreeFlags = 0, c.deletions = null, c.memoizedProps = f.memoizedProps, c.memoizedState = f.memoizedState, c.updateQueue = f.updateQueue, c.type = f.type, g = f.dependencies, c.dependencies = null === g ? null : {
                                lanes: g.lanes,
                                firstContext: g.firstContext
                            }, c.selfBaseDuration = f.selfBaseDuration, c.treeBaseDuration = f.treeBaseDuration), a = a.sibling;
                            $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, $c00590d434bbebaf$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $c00590d434bbebaf$var$A() > $c00590d434bbebaf$var$mk && (b.flags |= 128, d = !0, $c00590d434bbebaf$var$jk(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $c00590d434bbebaf$var$Qh(g), null !== a) {
                        if (b.flags |= 128, d = !0, a = a.updateQueue, null !== a && (b.updateQueue = a, b.flags |= 4), $c00590d434bbebaf$var$jk(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$c00590d434bbebaf$var$J) return $c00590d434bbebaf$var$S(b), null;
                    } else 2 * $c00590d434bbebaf$var$A() - f.renderingStartTime > $c00590d434bbebaf$var$mk && 1073741824 !== c && (b.flags |= 128, d = !0, $c00590d434bbebaf$var$jk(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (a = f.last, null !== a ? a.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $c00590d434bbebaf$var$A(), b.sibling = null, a = $c00590d434bbebaf$var$L.current, $c00590d434bbebaf$var$H($c00590d434bbebaf$var$L, d ? a & 1 | 2 : a & 1), b;
            $c00590d434bbebaf$var$S(b);
            return null;
        case 22:
        case 23:
            return $c00590d434bbebaf$var$nk(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($c00590d434bbebaf$var$Jj & 1073741824) && ($c00590d434bbebaf$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $c00590d434bbebaf$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($c00590d434bbebaf$var$p(156, b.tag));
}
function $c00590d434bbebaf$var$ok(a, b) {
    $c00590d434bbebaf$var$Kg(b);
    switch(b.tag){
        case 1:
            return $c00590d434bbebaf$var$mg(b.type) && $c00590d434bbebaf$var$ng(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $c00590d434bbebaf$var$dj(b), b) : null;
        case 3:
            return $c00590d434bbebaf$var$Nh(), $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg), $c00590d434bbebaf$var$G($c00590d434bbebaf$var$I), $c00590d434bbebaf$var$Sh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $c00590d434bbebaf$var$Ph(b), null;
        case 13:
            $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($c00590d434bbebaf$var$p(340));
                $c00590d434bbebaf$var$Wg();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, 0 !== (b.mode & 2) && $c00590d434bbebaf$var$dj(b), b) : null;
        case 19:
            return $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L), null;
        case 4:
            return $c00590d434bbebaf$var$Nh(), null;
        case 10:
            return $c00590d434bbebaf$var$oh(b.type._context), null;
        case 22:
        case 23:
            return $c00590d434bbebaf$var$nk(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $c00590d434bbebaf$var$pk = !1, $c00590d434bbebaf$var$qk = !1, $c00590d434bbebaf$var$rk = "function" === typeof WeakSet ? WeakSet : Set, $c00590d434bbebaf$var$U = null, $c00590d434bbebaf$var$sk = null, $c00590d434bbebaf$var$tk = null;
function $c00590d434bbebaf$var$uk(a, b) {
    b.props = a.memoizedProps;
    b.state = a.memoizedState;
    if (a.mode & 2) try {
        $c00590d434bbebaf$var$cj(), b.componentWillUnmount();
    } finally{
        $c00590d434bbebaf$var$aj(a);
    }
    else b.componentWillUnmount();
}
function $c00590d434bbebaf$var$vk(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            if (a.mode & 2) try {
                $c00590d434bbebaf$var$cj(), c(null);
            } finally{
                $c00590d434bbebaf$var$aj(a);
            }
            else c(null);
        } catch (d) {
            $c00590d434bbebaf$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $c00590d434bbebaf$var$wk(a, b, c) {
    try {
        c();
    } catch (d) {
        $c00590d434bbebaf$var$W(a, b, d);
    }
}
var $c00590d434bbebaf$var$xk = !1;
function $c00590d434bbebaf$var$yk(a, b) {
    $c00590d434bbebaf$var$Qf = $c00590d434bbebaf$var$rd;
    a = $c00590d434bbebaf$var$$e();
    if ($c00590d434bbebaf$var$af(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (D) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, n = 0, q = a, r = null;
                b: for(;;){
                    for(var z;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (z = q.firstChild)) break;
                        r = q;
                        q = z;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++n === d && (k = g);
                        if (null !== (z = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = z;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $c00590d434bbebaf$var$Rf = {
        focusedElem: a,
        selectionRange: c
    };
    $c00590d434bbebaf$var$rd = !1;
    for($c00590d434bbebaf$var$U = b; null !== $c00590d434bbebaf$var$U;)if (b = $c00590d434bbebaf$var$U, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $c00590d434bbebaf$var$U = a;
    else for(; null !== $c00590d434bbebaf$var$U;){
        b = $c00590d434bbebaf$var$U;
        try {
            var m = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== m) {
                        var w = m.memoizedProps, C = m.memoizedState, x = b.stateNode, y = x.getSnapshotBeforeUpdate(b.elementType === b.type ? w : $c00590d434bbebaf$var$ej(b.type, w), C);
                        x.__reactInternalSnapshotBeforeUpdate = y;
                    }
                    break;
                case 3:
                    var v = b.stateNode.containerInfo;
                    1 === v.nodeType ? v.textContent = "" : 9 === v.nodeType && v.documentElement && v.removeChild(v.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($c00590d434bbebaf$var$p(163));
            }
        } catch (D) {
            $c00590d434bbebaf$var$W(b, b.return, D);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $c00590d434bbebaf$var$U = a;
            break;
        }
        $c00590d434bbebaf$var$U = b.return;
    }
    m = $c00590d434bbebaf$var$xk;
    $c00590d434bbebaf$var$xk = !1;
    return m;
}
function $c00590d434bbebaf$var$zk(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && (0 !== (a & 8) ? null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentPassiveEffectUnmountStarted && $c00590d434bbebaf$var$B.markComponentPassiveEffectUnmountStarted(b) : 0 !== (a & 4) && $c00590d434bbebaf$var$uc(b), $c00590d434bbebaf$var$wk(b, c, f), 0 !== (a & 8) ? null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentPassiveEffectUnmountStopped && $c00590d434bbebaf$var$B.markComponentPassiveEffectUnmountStopped() : 0 !== (a & 4) && $c00590d434bbebaf$var$vc());
            }
            e = e.next;
        }while (e !== d);
    }
}
function $c00590d434bbebaf$var$Ak(a, b) {
    var c = b.updateQueue;
    c = null !== c ? c.lastEffect : null;
    if (null !== c) {
        var d = c = c.next;
        do {
            if ((d.tag & a) === a) {
                0 !== (a & 8) ? null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentPassiveEffectMountStarted && $c00590d434bbebaf$var$B.markComponentPassiveEffectMountStarted(b) : 0 !== (a & 4) && null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentLayoutEffectMountStarted && $c00590d434bbebaf$var$B.markComponentLayoutEffectMountStarted(b);
                var e = d.create;
                d.destroy = e();
                0 !== (a & 8) ? null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentPassiveEffectMountStopped && $c00590d434bbebaf$var$B.markComponentPassiveEffectMountStopped() : 0 !== (a & 4) && null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentLayoutEffectMountStopped && $c00590d434bbebaf$var$B.markComponentLayoutEffectMountStopped();
            }
            d = d.next;
        }while (d !== c);
    }
}
function $c00590d434bbebaf$var$Bk(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        if ("function" === typeof b) {
            if (a.mode & 2) try {
                $c00590d434bbebaf$var$cj(), b(c);
            } finally{
                $c00590d434bbebaf$var$aj(a);
            }
            else b(c);
        } else b.current = c;
    }
}
function $c00590d434bbebaf$var$Ck(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $c00590d434bbebaf$var$Ck(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$c00590d434bbebaf$var$bg], delete b[$c00590d434bbebaf$var$cg], delete b[$c00590d434bbebaf$var$Cf], delete b[$c00590d434bbebaf$var$dg], delete b[$c00590d434bbebaf$var$eg]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $c00590d434bbebaf$var$Dk(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $c00590d434bbebaf$var$Ek(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $c00590d434bbebaf$var$Dk(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $c00590d434bbebaf$var$Fk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $c00590d434bbebaf$var$Pf));
    else if (4 !== d && (a = a.child, null !== a)) for($c00590d434bbebaf$var$Fk(a, b, c), a = a.sibling; null !== a;)$c00590d434bbebaf$var$Fk(a, b, c), a = a.sibling;
}
function $c00590d434bbebaf$var$Gk(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($c00590d434bbebaf$var$Gk(a, b, c), a = a.sibling; null !== a;)$c00590d434bbebaf$var$Gk(a, b, c), a = a.sibling;
}
var $c00590d434bbebaf$var$X = null, $c00590d434bbebaf$var$Hk = !1;
function $c00590d434bbebaf$var$Ik(a, b, c) {
    for(c = c.child; null !== c;)$c00590d434bbebaf$var$Jk(a, b, c), c = c.sibling;
}
function $c00590d434bbebaf$var$Jk(a, b, c) {
    if ($c00590d434bbebaf$var$lc && "function" === typeof $c00590d434bbebaf$var$lc.onCommitFiberUnmount) try {
        $c00590d434bbebaf$var$lc.onCommitFiberUnmount($c00590d434bbebaf$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $c00590d434bbebaf$var$qk || $c00590d434bbebaf$var$vk(c, b);
        case 6:
            var d = $c00590d434bbebaf$var$X, e = $c00590d434bbebaf$var$Hk;
            $c00590d434bbebaf$var$X = null;
            $c00590d434bbebaf$var$Ik(a, b, c);
            $c00590d434bbebaf$var$X = d;
            $c00590d434bbebaf$var$Hk = e;
            null !== $c00590d434bbebaf$var$X && ($c00590d434bbebaf$var$Hk ? (a = $c00590d434bbebaf$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $c00590d434bbebaf$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $c00590d434bbebaf$var$X && ($c00590d434bbebaf$var$Hk ? (a = $c00590d434bbebaf$var$X, c = c.stateNode, 8 === a.nodeType ? $c00590d434bbebaf$var$Yf(a.parentNode, c) : 1 === a.nodeType && $c00590d434bbebaf$var$Yf(a, c), $c00590d434bbebaf$var$pd(a)) : $c00590d434bbebaf$var$Yf($c00590d434bbebaf$var$X, c.stateNode));
            break;
        case 4:
            d = $c00590d434bbebaf$var$X;
            e = $c00590d434bbebaf$var$Hk;
            $c00590d434bbebaf$var$X = c.stateNode.containerInfo;
            $c00590d434bbebaf$var$Hk = !0;
            $c00590d434bbebaf$var$Ik(a, b, c);
            $c00590d434bbebaf$var$X = d;
            $c00590d434bbebaf$var$Hk = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$c00590d434bbebaf$var$qk && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $c00590d434bbebaf$var$wk(c, b, g) : 0 !== (f & 4) && ($c00590d434bbebaf$var$uc(c), c.mode & 2 ? ($c00590d434bbebaf$var$cj(), $c00590d434bbebaf$var$wk(c, b, g), $c00590d434bbebaf$var$aj(c)) : $c00590d434bbebaf$var$wk(c, b, g), $c00590d434bbebaf$var$vc()));
                    e = e.next;
                }while (e !== d);
            }
            $c00590d434bbebaf$var$Ik(a, b, c);
            break;
        case 1:
            if (!$c00590d434bbebaf$var$qk && ($c00590d434bbebaf$var$vk(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                $c00590d434bbebaf$var$uk(c, d);
            } catch (h) {
                $c00590d434bbebaf$var$W(c, b, h);
            }
            $c00590d434bbebaf$var$Ik(a, b, c);
            break;
        case 21:
            $c00590d434bbebaf$var$Ik(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($c00590d434bbebaf$var$qk = (d = $c00590d434bbebaf$var$qk) || null !== c.memoizedState, $c00590d434bbebaf$var$Ik(a, b, c), $c00590d434bbebaf$var$qk = d) : $c00590d434bbebaf$var$Ik(a, b, c);
            break;
        default:
            $c00590d434bbebaf$var$Ik(a, b, c);
    }
}
function $c00590d434bbebaf$var$Kk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $c00590d434bbebaf$var$rk);
        b.forEach(function(b) {
            var d = $c00590d434bbebaf$var$Lk.bind(null, a, b);
            if (!c.has(b)) {
                c.add(b);
                if ($c00590d434bbebaf$var$mc) {
                    if (null !== $c00590d434bbebaf$var$sk && null !== $c00590d434bbebaf$var$tk) $c00590d434bbebaf$var$wj($c00590d434bbebaf$var$tk, $c00590d434bbebaf$var$sk);
                    else throw Error($c00590d434bbebaf$var$p(413));
                }
                b.then(d, d);
            }
        });
    }
}
function $c00590d434bbebaf$var$Mk(a, b, c) {
    $c00590d434bbebaf$var$sk = c;
    $c00590d434bbebaf$var$tk = a;
    $c00590d434bbebaf$var$Nk(b, a);
    $c00590d434bbebaf$var$tk = $c00590d434bbebaf$var$sk = null;
}
function $c00590d434bbebaf$var$Ok(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $c00590d434bbebaf$var$X = h.stateNode;
                        $c00590d434bbebaf$var$Hk = !1;
                        break a;
                    case 3:
                        $c00590d434bbebaf$var$X = h.stateNode.containerInfo;
                        $c00590d434bbebaf$var$Hk = !0;
                        break a;
                    case 4:
                        $c00590d434bbebaf$var$X = h.stateNode.containerInfo;
                        $c00590d434bbebaf$var$Hk = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $c00590d434bbebaf$var$X) throw Error($c00590d434bbebaf$var$p(160));
            $c00590d434bbebaf$var$Jk(f, g, e);
            $c00590d434bbebaf$var$X = null;
            $c00590d434bbebaf$var$Hk = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $c00590d434bbebaf$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$c00590d434bbebaf$var$Nk(b, a), b = b.sibling;
}
function $c00590d434bbebaf$var$Nk(a, b) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) globalThis.__ATL_REACT_METRICS.commitWorkCount++;
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            if (d & 4) {
                try {
                    $c00590d434bbebaf$var$zk(3, a, a.return), $c00590d434bbebaf$var$Ak(3, a);
                } catch (m) {
                    $c00590d434bbebaf$var$W(a, a.return, m);
                }
                if (a.mode & 2) {
                    try {
                        $c00590d434bbebaf$var$cj(), $c00590d434bbebaf$var$zk(5, a, a.return);
                    } catch (m) {
                        $c00590d434bbebaf$var$W(a, a.return, m);
                    }
                    $c00590d434bbebaf$var$aj(a);
                } else try {
                    $c00590d434bbebaf$var$zk(5, a, a.return);
                } catch (m) {
                    $c00590d434bbebaf$var$W(a, a.return, m);
                }
            }
            break;
        case 1:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            d & 512 && null !== c && $c00590d434bbebaf$var$vk(c, c.return);
            break;
        case 5:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            d & 512 && null !== c && $c00590d434bbebaf$var$vk(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $c00590d434bbebaf$var$ob(e, "");
                } catch (m) {
                    $c00590d434bbebaf$var$W(a, a.return, m);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $c00590d434bbebaf$var$$a(e, f);
                    $c00590d434bbebaf$var$vb(h, g);
                    var l = $c00590d434bbebaf$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var n = k[g], q = k[g + 1];
                        "style" === n ? $c00590d434bbebaf$var$sb(e, q) : "dangerouslySetInnerHTML" === n ? $c00590d434bbebaf$var$nb(e, q) : "children" === n ? $c00590d434bbebaf$var$ob(e, q) : $c00590d434bbebaf$var$ua(e, n, q, l);
                    }
                    switch(h){
                        case "input":
                            $c00590d434bbebaf$var$ab(e, f);
                            break;
                        case "textarea":
                            $c00590d434bbebaf$var$hb(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var z = f.value;
                            null != z ? $c00590d434bbebaf$var$eb(e, !!f.multiple, z, !1) : r !== !!f.multiple && (null != f.defaultValue ? $c00590d434bbebaf$var$eb(e, !!f.multiple, f.defaultValue, !0) : $c00590d434bbebaf$var$eb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$c00590d434bbebaf$var$cg] = f;
                } catch (m) {
                    $c00590d434bbebaf$var$W(a, a.return, m);
                }
            }
            break;
        case 6:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($c00590d434bbebaf$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (m) {
                    $c00590d434bbebaf$var$W(a, a.return, m);
                }
            }
            break;
        case 3:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $c00590d434bbebaf$var$pd(b.containerInfo);
            } catch (m) {
                $c00590d434bbebaf$var$W(a, a.return, m);
            }
            break;
        case 4:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            break;
        case 13:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($c00590d434bbebaf$var$Qk = $c00590d434bbebaf$var$A()));
            d & 4 && $c00590d434bbebaf$var$Kk(a);
            break;
        case 22:
            n = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($c00590d434bbebaf$var$qk = (l = $c00590d434bbebaf$var$qk) || n, $c00590d434bbebaf$var$Ok(b, a), $c00590d434bbebaf$var$qk = l) : $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !n && 0 !== (a.mode & 1)) for($c00590d434bbebaf$var$U = a, n = a.child; null !== n;){
                    for(q = $c00590d434bbebaf$var$U = n; null !== $c00590d434bbebaf$var$U;){
                        r = $c00590d434bbebaf$var$U;
                        z = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                if (r.mode & 2) try {
                                    $c00590d434bbebaf$var$cj(), $c00590d434bbebaf$var$zk(4, r, r.return);
                                } finally{
                                    $c00590d434bbebaf$var$aj(r);
                                }
                                else $c00590d434bbebaf$var$zk(4, r, r.return);
                                break;
                            case 1:
                                $c00590d434bbebaf$var$vk(r, r.return);
                                d = r.stateNode;
                                if ("function" === typeof d.componentWillUnmount) {
                                    c = r;
                                    b = r.return;
                                    try {
                                        $c00590d434bbebaf$var$uk(c, d);
                                    } catch (m) {
                                        $c00590d434bbebaf$var$W(c, b, m);
                                    }
                                }
                                break;
                            case 5:
                                $c00590d434bbebaf$var$vk(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $c00590d434bbebaf$var$Rk(q);
                                    continue;
                                }
                        }
                        null !== z ? (z.return = r, $c00590d434bbebaf$var$U = z) : $c00590d434bbebaf$var$Rk(q);
                    }
                    n = n.sibling;
                }
                a: for(n = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === n) {
                            n = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $c00590d434bbebaf$var$rb("display", g));
                            } catch (m) {
                                $c00590d434bbebaf$var$W(a, a.return, m);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === n) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (m) {
                            $c00590d434bbebaf$var$W(a, a.return, m);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        n === q && (n = null);
                        q = q.return;
                    }
                    n === q && (n = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $c00590d434bbebaf$var$Ok(b, a);
            $c00590d434bbebaf$var$Pk(a);
            d & 4 && $c00590d434bbebaf$var$Kk(a);
            break;
        case 21:
            break;
        default:
            $c00590d434bbebaf$var$Ok(b, a), $c00590d434bbebaf$var$Pk(a);
    }
}
function $c00590d434bbebaf$var$Pk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($c00590d434bbebaf$var$Dk(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($c00590d434bbebaf$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($c00590d434bbebaf$var$ob(e, ""), d.flags &= -33);
                    var f = $c00590d434bbebaf$var$Ek(a);
                    $c00590d434bbebaf$var$Gk(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $c00590d434bbebaf$var$Ek(a);
                    $c00590d434bbebaf$var$Fk(a, h, g);
                    break;
                default:
                    throw Error($c00590d434bbebaf$var$p(161));
            }
        } catch (k) {
            $c00590d434bbebaf$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $c00590d434bbebaf$var$Sk(a, b, c) {
    $c00590d434bbebaf$var$sk = c;
    $c00590d434bbebaf$var$tk = b;
    $c00590d434bbebaf$var$U = a;
    $c00590d434bbebaf$var$Tk(a, b, c);
    $c00590d434bbebaf$var$tk = $c00590d434bbebaf$var$sk = null;
}
function $c00590d434bbebaf$var$Tk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $c00590d434bbebaf$var$U;){
        var e = $c00590d434bbebaf$var$U, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $c00590d434bbebaf$var$pk;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $c00590d434bbebaf$var$qk;
                h = $c00590d434bbebaf$var$pk;
                var l = $c00590d434bbebaf$var$qk;
                $c00590d434bbebaf$var$pk = g;
                if (($c00590d434bbebaf$var$qk = k) && !l) for($c00590d434bbebaf$var$U = e; null !== $c00590d434bbebaf$var$U;)g = $c00590d434bbebaf$var$U, k = g.child, 22 === g.tag && null !== g.memoizedState ? $c00590d434bbebaf$var$Uk(e) : null !== k ? (k.return = g, $c00590d434bbebaf$var$U = k) : $c00590d434bbebaf$var$Uk(e);
                for(; null !== f;)$c00590d434bbebaf$var$U = f, $c00590d434bbebaf$var$Tk(f, b, c), f = f.sibling;
                $c00590d434bbebaf$var$U = e;
                $c00590d434bbebaf$var$pk = h;
                $c00590d434bbebaf$var$qk = l;
            }
            $c00590d434bbebaf$var$Vk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $c00590d434bbebaf$var$U = f) : $c00590d434bbebaf$var$Vk(a, b, c);
    }
}
function $c00590d434bbebaf$var$Vk(a) {
    for(; null !== $c00590d434bbebaf$var$U;){
        var b = $c00590d434bbebaf$var$U;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        if (!$c00590d434bbebaf$var$qk) {
                            if (b.mode & 2) try {
                                $c00590d434bbebaf$var$cj(), $c00590d434bbebaf$var$Ak(5, b);
                            } finally{
                                $c00590d434bbebaf$var$aj(b);
                            }
                            else $c00590d434bbebaf$var$Ak(5, b);
                        }
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$c00590d434bbebaf$var$qk) {
                            if (null === c) {
                                if (b.mode & 2) try {
                                    $c00590d434bbebaf$var$cj(), d.componentDidMount();
                                } finally{
                                    $c00590d434bbebaf$var$aj(b);
                                }
                                else d.componentDidMount();
                            } else {
                                var e = b.elementType === b.type ? c.memoizedProps : $c00590d434bbebaf$var$ej(b.type, c.memoizedProps), f = c.memoizedState;
                                if (b.mode & 2) try {
                                    $c00590d434bbebaf$var$cj(), d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                                } finally{
                                    $c00590d434bbebaf$var$aj(b);
                                }
                                else d.componentDidUpdate(e, f, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var g = b.updateQueue;
                        null !== g && $c00590d434bbebaf$var$Gh(b, g, d);
                        break;
                    case 3:
                        var h = b.updateQueue;
                        if (null !== h) {
                            var k = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    k = b.child.stateNode;
                                    break;
                                case 1:
                                    k = b.child.stateNode;
                            }
                            $c00590d434bbebaf$var$Gh(b, h, k);
                        }
                        break;
                    case 5:
                        var l = b.stateNode;
                        if (null === c && b.flags & 4) {
                            k = l;
                            var n = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    n.autoFocus && k.focus();
                                    break;
                                case "img":
                                    n.src && (k.src = n.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        var q = b.memoizedProps, r = q.onCommit, z = q.onRender, m = b.stateNode.effectDuration;
                        k = $c00590d434bbebaf$var$Ui;
                        c = null === c ? "mount" : "update";
                        $c00590d434bbebaf$var$Yi && (c = "nested-update");
                        "function" === typeof z && z(b.memoizedProps.id, c, b.actualDuration, b.treeBaseDuration, b.actualStartTime, k);
                        "function" === typeof r && r(b.memoizedProps.id, c, m, k);
                        $c00590d434bbebaf$var$Wk(b);
                        var w = b.return;
                        a: for(; null !== w;){
                            switch(w.tag){
                                case 3:
                                    w.stateNode.effectDuration += m;
                                    break a;
                                case 12:
                                    w.stateNode.effectDuration += m;
                                    break a;
                            }
                            w = w.return;
                        }
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var C = b.alternate;
                            if (null !== C) {
                                var x = C.memoizedState;
                                if (null !== x) {
                                    var y = x.dehydrated;
                                    null !== y && $c00590d434bbebaf$var$pd(y);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($c00590d434bbebaf$var$p(163));
                }
                $c00590d434bbebaf$var$qk || b.flags & 512 && $c00590d434bbebaf$var$Bk(b);
            } catch (v) {
                $c00590d434bbebaf$var$W(b, b.return, v);
            }
        }
        if (b === a) {
            $c00590d434bbebaf$var$U = null;
            break;
        }
        k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $c00590d434bbebaf$var$U = k;
            break;
        }
        $c00590d434bbebaf$var$U = b.return;
    }
}
function $c00590d434bbebaf$var$Rk(a) {
    for(; null !== $c00590d434bbebaf$var$U;){
        var b = $c00590d434bbebaf$var$U;
        if (b === a) {
            $c00590d434bbebaf$var$U = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $c00590d434bbebaf$var$U = c;
            break;
        }
        $c00590d434bbebaf$var$U = b.return;
    }
}
function $c00590d434bbebaf$var$Uk(a) {
    for(; null !== $c00590d434bbebaf$var$U;){
        var b = $c00590d434bbebaf$var$U;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    if (b.mode & 2) try {
                        $c00590d434bbebaf$var$cj();
                        var c = b.return;
                        try {
                            $c00590d434bbebaf$var$Ak(4, b);
                        } catch (l) {
                            $c00590d434bbebaf$var$W(b, c, l);
                        }
                    } finally{
                        $c00590d434bbebaf$var$aj(b);
                    }
                    else {
                        var d = b.return;
                        try {
                            $c00590d434bbebaf$var$Ak(4, b);
                        } catch (l) {
                            $c00590d434bbebaf$var$W(b, d, l);
                        }
                    }
                    break;
                case 1:
                    var e = b.stateNode;
                    if ("function" === typeof e.componentDidMount) {
                        var f = b.return;
                        try {
                            e.componentDidMount();
                        } catch (l) {
                            $c00590d434bbebaf$var$W(b, f, l);
                        }
                    }
                    var g = b.return;
                    try {
                        $c00590d434bbebaf$var$Bk(b);
                    } catch (l) {
                        $c00590d434bbebaf$var$W(b, g, l);
                    }
                    break;
                case 5:
                    var h = b.return;
                    try {
                        $c00590d434bbebaf$var$Bk(b);
                    } catch (l) {
                        $c00590d434bbebaf$var$W(b, h, l);
                    }
            }
        } catch (l) {
            $c00590d434bbebaf$var$W(b, b.return, l);
        }
        if (b === a) {
            $c00590d434bbebaf$var$U = null;
            break;
        }
        var k = b.sibling;
        if (null !== k) {
            k.return = b.return;
            $c00590d434bbebaf$var$U = k;
            break;
        }
        $c00590d434bbebaf$var$U = b.return;
    }
}
var $c00590d434bbebaf$var$Xk = Math.ceil, $c00590d434bbebaf$var$Yk = $c00590d434bbebaf$var$va.ReactCurrentDispatcher, $c00590d434bbebaf$var$Zk = $c00590d434bbebaf$var$va.ReactCurrentOwner, $c00590d434bbebaf$var$$k = $c00590d434bbebaf$var$va.ReactCurrentBatchConfig, $c00590d434bbebaf$var$K = 0, $c00590d434bbebaf$var$Q = null, $c00590d434bbebaf$var$Y = null, $c00590d434bbebaf$var$Z = 0, $c00590d434bbebaf$var$Jj = 0, $c00590d434bbebaf$var$Ij = $c00590d434bbebaf$var$hg(0), $c00590d434bbebaf$var$T = 0, $c00590d434bbebaf$var$al = null, $c00590d434bbebaf$var$Fh = 0, $c00590d434bbebaf$var$bl = 0, $c00590d434bbebaf$var$cl = 0, $c00590d434bbebaf$var$dl = null, $c00590d434bbebaf$var$el = null, $c00590d434bbebaf$var$Qk = 0, $c00590d434bbebaf$var$mk = Infinity, $c00590d434bbebaf$var$fl = null, $c00590d434bbebaf$var$qj = !1, $c00590d434bbebaf$var$rj = null, $c00590d434bbebaf$var$tj = null, $c00590d434bbebaf$var$gl = !1, $c00590d434bbebaf$var$hl = null, $c00590d434bbebaf$var$il = 0, $c00590d434bbebaf$var$jl = [], $c00590d434bbebaf$var$kl = 0, $c00590d434bbebaf$var$ll = null, $c00590d434bbebaf$var$ml = -1, $c00590d434bbebaf$var$nl = 0;
function $c00590d434bbebaf$var$Ri() {
    return 0 !== ($c00590d434bbebaf$var$K & 6) ? $c00590d434bbebaf$var$A() : -1 !== $c00590d434bbebaf$var$ml ? $c00590d434bbebaf$var$ml : $c00590d434bbebaf$var$ml = $c00590d434bbebaf$var$A();
}
function $c00590d434bbebaf$var$Oi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($c00590d434bbebaf$var$K & 2) && 0 !== $c00590d434bbebaf$var$Z) return $c00590d434bbebaf$var$Z & -$c00590d434bbebaf$var$Z;
    if (null !== $c00590d434bbebaf$var$Yg.transition) return 0 === $c00590d434bbebaf$var$nl && ($c00590d434bbebaf$var$nl = $c00590d434bbebaf$var$Kc()), $c00590d434bbebaf$var$nl;
    a = $c00590d434bbebaf$var$E;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $c00590d434bbebaf$var$xd(a.type);
    return a;
}
function $c00590d434bbebaf$var$ui(a, b, c, d) {
    if (50 < $c00590d434bbebaf$var$kl) throw $c00590d434bbebaf$var$kl = 0, $c00590d434bbebaf$var$ll = null, Error($c00590d434bbebaf$var$p(185));
    $c00590d434bbebaf$var$Mc(a, c, d);
    if (0 === ($c00590d434bbebaf$var$K & 2) || a !== $c00590d434bbebaf$var$Q) $c00590d434bbebaf$var$mc && $c00590d434bbebaf$var$Pc(a, b, c), a === $c00590d434bbebaf$var$Q && (0 === ($c00590d434bbebaf$var$K & 2) && ($c00590d434bbebaf$var$bl |= c), 4 === $c00590d434bbebaf$var$T && $c00590d434bbebaf$var$ol(a, $c00590d434bbebaf$var$Z)), $c00590d434bbebaf$var$pl(a, d), 1 === c && 0 === $c00590d434bbebaf$var$K && 0 === (b.mode & 1) && ($c00590d434bbebaf$var$mk = $c00590d434bbebaf$var$A() + 500, $c00590d434bbebaf$var$tg && $c00590d434bbebaf$var$xg());
}
function $c00590d434bbebaf$var$pl(a, b) {
    var c = a.callbackNode;
    $c00590d434bbebaf$var$Ic(a, b);
    var d = $c00590d434bbebaf$var$Gc(a, a === $c00590d434bbebaf$var$Q ? $c00590d434bbebaf$var$Z : 0);
    if (0 === d) null !== c && $c00590d434bbebaf$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $c00590d434bbebaf$var$bc(c);
        if (1 === b) 0 === a.tag ? $c00590d434bbebaf$var$wg($c00590d434bbebaf$var$ql.bind(null, a)) : $c00590d434bbebaf$var$vg($c00590d434bbebaf$var$ql.bind(null, a)), $c00590d434bbebaf$var$Xf(function() {
            0 === ($c00590d434bbebaf$var$K & 6) && $c00590d434bbebaf$var$xg();
        }), c = null;
        else {
            switch($c00590d434bbebaf$var$Rc(d)){
                case 1:
                    c = $c00590d434bbebaf$var$fc;
                    break;
                case 4:
                    c = $c00590d434bbebaf$var$gc;
                    break;
                case 16:
                    c = $c00590d434bbebaf$var$hc;
                    break;
                case 536870912:
                    c = $c00590d434bbebaf$var$jc;
                    break;
                default:
                    c = $c00590d434bbebaf$var$hc;
            }
            c = $c00590d434bbebaf$var$rl(c, $c00590d434bbebaf$var$sl.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $c00590d434bbebaf$var$sl(a, b) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) globalThis.__ATL_REACT_METRICS.totalTickCount++;
    $c00590d434bbebaf$var$Zi = $c00590d434bbebaf$var$Yi = !1;
    $c00590d434bbebaf$var$ml = -1;
    $c00590d434bbebaf$var$nl = 0;
    if (0 !== ($c00590d434bbebaf$var$K & 6)) throw Error($c00590d434bbebaf$var$p(327));
    var c = a.callbackNode;
    if ($c00590d434bbebaf$var$tl() && a.callbackNode !== c) return null;
    var d = $c00590d434bbebaf$var$Gc(a, a === $c00590d434bbebaf$var$Q ? $c00590d434bbebaf$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $c00590d434bbebaf$var$ul(a, d);
    else {
        b = d;
        var e = $c00590d434bbebaf$var$K;
        $c00590d434bbebaf$var$K |= 2;
        var f = $c00590d434bbebaf$var$vl();
        if ($c00590d434bbebaf$var$Q !== a || $c00590d434bbebaf$var$Z !== b) {
            if ($c00590d434bbebaf$var$mc) {
                var g = a.memoizedUpdaters;
                0 < g.size && ($c00590d434bbebaf$var$wj(a, $c00590d434bbebaf$var$Z), g.clear());
                $c00590d434bbebaf$var$Qc(a, b);
            }
            $c00590d434bbebaf$var$fl = null;
            $c00590d434bbebaf$var$mk = $c00590d434bbebaf$var$A() + 500;
            $c00590d434bbebaf$var$wl(a, b);
        }
        $c00590d434bbebaf$var$wc(b);
        for(;;)try {
            $c00590d434bbebaf$var$xl();
            break;
        } catch (h) {
            $c00590d434bbebaf$var$yl(a, h);
        }
        $c00590d434bbebaf$var$nh();
        $c00590d434bbebaf$var$Yk.current = f;
        $c00590d434bbebaf$var$K = e;
        null !== $c00590d434bbebaf$var$Y ? (null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markRenderYielded && $c00590d434bbebaf$var$B.markRenderYielded(), b = 0) : ($c00590d434bbebaf$var$xc(), $c00590d434bbebaf$var$Q = null, $c00590d434bbebaf$var$Z = 0, b = $c00590d434bbebaf$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $c00590d434bbebaf$var$Jc(a), 0 !== e && (d = e, b = $c00590d434bbebaf$var$zl(a, e)));
        if (1 === b) throw c = $c00590d434bbebaf$var$al, $c00590d434bbebaf$var$wl(a, 0), $c00590d434bbebaf$var$ol(a, d), $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A()), c;
        if (6 === b) $c00590d434bbebaf$var$ol(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$c00590d434bbebaf$var$Al(e) && (globalThis.__ATL_REACT_METRICS && globalThis.__ATL_REACT_METRICS.externalStoreRestartCount++, b = $c00590d434bbebaf$var$ul(a, d), 2 === b && (f = $c00590d434bbebaf$var$Jc(a), 0 !== f && (d = f, b = $c00590d434bbebaf$var$zl(a, f))), 1 === b)) throw c = $c00590d434bbebaf$var$al, $c00590d434bbebaf$var$wl(a, 0), $c00590d434bbebaf$var$ol(a, d), $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($c00590d434bbebaf$var$p(345));
                case 2:
                    $c00590d434bbebaf$var$Cl(a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl);
                    break;
                case 3:
                    $c00590d434bbebaf$var$ol(a, d);
                    if ((d & 130023424) === d && (b = $c00590d434bbebaf$var$Qk + (globalThis.REACT_FALLBACK_THROTTLE_MS || 500) - $c00590d434bbebaf$var$A(), 10 < b)) {
                        if (0 !== $c00590d434bbebaf$var$Gc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $c00590d434bbebaf$var$Ri();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $c00590d434bbebaf$var$Tf($c00590d434bbebaf$var$Cl.bind(null, a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl), b);
                        break;
                    }
                    $c00590d434bbebaf$var$Cl(a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl);
                    break;
                case 4:
                    $c00590d434bbebaf$var$ol(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;)g = 31 - $c00590d434bbebaf$var$Ac(d), f = 1 << g, g = b[g], g > e && (e = g), d &= ~f;
                    d = e;
                    d = $c00590d434bbebaf$var$A() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $c00590d434bbebaf$var$Xk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $c00590d434bbebaf$var$Tf($c00590d434bbebaf$var$Cl.bind(null, a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl), d);
                        break;
                    }
                    $c00590d434bbebaf$var$Cl(a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl);
                    break;
                case 5:
                    $c00590d434bbebaf$var$Cl(a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl);
                    break;
                default:
                    throw Error($c00590d434bbebaf$var$p(329));
            }
        }
    }
    $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A());
    return a.callbackNode === c ? $c00590d434bbebaf$var$sl.bind(null, a) : null;
}
function $c00590d434bbebaf$var$zl(a, b) {
    var c = $c00590d434bbebaf$var$dl;
    a.current.memoizedState.isDehydrated && ($c00590d434bbebaf$var$wl(a, b).flags |= 256);
    a = $c00590d434bbebaf$var$ul(a, b);
    2 !== a && (b = $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$el = c, null !== b && $c00590d434bbebaf$var$lk(b));
    return a;
}
function $c00590d434bbebaf$var$lk(a) {
    null === $c00590d434bbebaf$var$el ? $c00590d434bbebaf$var$el = a : $c00590d434bbebaf$var$el.push.apply($c00590d434bbebaf$var$el, a);
}
function $c00590d434bbebaf$var$Al(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$c00590d434bbebaf$var$Ve(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $c00590d434bbebaf$var$ol(a, b) {
    b &= ~$c00590d434bbebaf$var$cl;
    b &= ~$c00590d434bbebaf$var$bl;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $c00590d434bbebaf$var$Ac(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $c00590d434bbebaf$var$ql(a) {
    $c00590d434bbebaf$var$Yi = $c00590d434bbebaf$var$Zi;
    $c00590d434bbebaf$var$Zi = !1;
    if (0 !== ($c00590d434bbebaf$var$K & 6)) throw Error($c00590d434bbebaf$var$p(327));
    $c00590d434bbebaf$var$tl();
    var b = $c00590d434bbebaf$var$Gc(a, 0);
    if (0 === (b & 1)) return $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A()), null;
    var c = $c00590d434bbebaf$var$ul(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $c00590d434bbebaf$var$Jc(a);
        0 !== d && (b = d, c = $c00590d434bbebaf$var$zl(a, d));
    }
    if (1 === c) throw c = $c00590d434bbebaf$var$al, $c00590d434bbebaf$var$wl(a, 0), $c00590d434bbebaf$var$ol(a, b), $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A()), c;
    if (6 === c) throw Error($c00590d434bbebaf$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $c00590d434bbebaf$var$Cl(a, $c00590d434bbebaf$var$el, $c00590d434bbebaf$var$fl);
    $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A());
    return null;
}
function $c00590d434bbebaf$var$Dl(a, b) {
    var c = $c00590d434bbebaf$var$K;
    $c00590d434bbebaf$var$K |= 1;
    try {
        return a(b);
    } finally{
        $c00590d434bbebaf$var$K = c, 0 === $c00590d434bbebaf$var$K && ($c00590d434bbebaf$var$mk = $c00590d434bbebaf$var$A() + 500, $c00590d434bbebaf$var$tg && $c00590d434bbebaf$var$xg());
    }
}
function $c00590d434bbebaf$var$El(a) {
    null !== $c00590d434bbebaf$var$hl && 0 === $c00590d434bbebaf$var$hl.tag && 0 === ($c00590d434bbebaf$var$K & 6) && $c00590d434bbebaf$var$tl();
    var b = $c00590d434bbebaf$var$K;
    $c00590d434bbebaf$var$K |= 1;
    var c = $c00590d434bbebaf$var$$k.transition, d = $c00590d434bbebaf$var$E;
    try {
        if ($c00590d434bbebaf$var$$k.transition = null, $c00590d434bbebaf$var$E = 1, a) return a();
    } finally{
        $c00590d434bbebaf$var$E = d, $c00590d434bbebaf$var$$k.transition = c, $c00590d434bbebaf$var$K = b, 0 === ($c00590d434bbebaf$var$K & 6) && $c00590d434bbebaf$var$xg();
    }
}
function $c00590d434bbebaf$var$nk() {
    $c00590d434bbebaf$var$Jj = $c00590d434bbebaf$var$Ij.current;
    $c00590d434bbebaf$var$G($c00590d434bbebaf$var$Ij);
}
function $c00590d434bbebaf$var$wl(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $c00590d434bbebaf$var$Uf(c));
    if (null !== $c00590d434bbebaf$var$Y) for(c = $c00590d434bbebaf$var$Y.return; null !== c;){
        var d = c;
        globalThis.__ATL_REACT_METRICS && globalThis.__ATL_REACT_METRICS.priorityInterruptedWorkCount++;
        $c00590d434bbebaf$var$Kg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $c00590d434bbebaf$var$ng();
                break;
            case 3:
                $c00590d434bbebaf$var$Nh();
                $c00590d434bbebaf$var$G($c00590d434bbebaf$var$jg);
                $c00590d434bbebaf$var$G($c00590d434bbebaf$var$I);
                $c00590d434bbebaf$var$Sh();
                break;
            case 5:
                $c00590d434bbebaf$var$Ph(d);
                break;
            case 4:
                $c00590d434bbebaf$var$Nh();
                break;
            case 13:
                $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L);
                break;
            case 19:
                $c00590d434bbebaf$var$G($c00590d434bbebaf$var$L);
                break;
            case 10:
                $c00590d434bbebaf$var$oh(d.type._context);
                break;
            case 22:
            case 23:
                $c00590d434bbebaf$var$nk();
        }
        c = c.return;
    }
    $c00590d434bbebaf$var$Q = a;
    $c00590d434bbebaf$var$Y = a = $c00590d434bbebaf$var$ch(a.current, null);
    $c00590d434bbebaf$var$Z = $c00590d434bbebaf$var$Jj = b;
    $c00590d434bbebaf$var$T = 0;
    $c00590d434bbebaf$var$al = null;
    $c00590d434bbebaf$var$cl = $c00590d434bbebaf$var$bl = $c00590d434bbebaf$var$Fh = 0;
    $c00590d434bbebaf$var$el = $c00590d434bbebaf$var$dl = null;
    if (null !== $c00590d434bbebaf$var$th) {
        for(b = 0; b < $c00590d434bbebaf$var$th.length; b++)if (c = $c00590d434bbebaf$var$th[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $c00590d434bbebaf$var$th = null;
    }
    return a;
}
function $c00590d434bbebaf$var$yl(a, b) {
    if (typeof globalThis !== "undefined" && globalThis.__ATL_REACT_METRICS) globalThis.__ATL_REACT_METRICS.interruptedWorkCount++;
    do {
        var c = $c00590d434bbebaf$var$Y;
        try {
            $c00590d434bbebaf$var$nh();
            $c00590d434bbebaf$var$Th.current = $c00590d434bbebaf$var$ei;
            if ($c00590d434bbebaf$var$Wh) {
                for(var d = $c00590d434bbebaf$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $c00590d434bbebaf$var$Wh = !1;
            }
            $c00590d434bbebaf$var$Vh = 0;
            $c00590d434bbebaf$var$O = $c00590d434bbebaf$var$N = $c00590d434bbebaf$var$M = null;
            $c00590d434bbebaf$var$Xh = !1;
            $c00590d434bbebaf$var$Yh = 0;
            $c00590d434bbebaf$var$Zk.current = null;
            if (null === c || null === c.return) {
                $c00590d434bbebaf$var$T = 1;
                $c00590d434bbebaf$var$al = b;
                $c00590d434bbebaf$var$Y = null;
                break;
            }
            c.mode & 2 && $c00590d434bbebaf$var$$i(c, !0);
            $c00590d434bbebaf$var$tc();
            if (null !== b && "object" === typeof b && "function" === typeof b.then) {
                var f = b;
                null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentSuspended && $c00590d434bbebaf$var$B.markComponentSuspended(c, f, $c00590d434bbebaf$var$Z);
            } else null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markComponentErrored && $c00590d434bbebaf$var$B.markComponentErrored(c, b, $c00590d434bbebaf$var$Z);
            a: {
                var g = a, h = c.return, k = c;
                f = b;
                b = $c00590d434bbebaf$var$Z;
                k.flags |= 32768;
                $c00590d434bbebaf$var$mc && $c00590d434bbebaf$var$wj(g, b);
                if (null !== f && "object" === typeof f && "function" === typeof f.then) {
                    var l = f, n = k, q = n.tag;
                    if (0 === (n.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = n.alternate;
                        r ? (n.updateQueue = r.updateQueue, n.memoizedState = r.memoizedState, n.lanes = r.lanes) : (n.updateQueue = null, n.memoizedState = null);
                    }
                    var z = $c00590d434bbebaf$var$xj(h);
                    if (null !== z) {
                        z.flags &= -257;
                        $c00590d434bbebaf$var$yj(z, h, k, g, b);
                        z.mode & 1 && $c00590d434bbebaf$var$uj(g, l, b);
                        b = z;
                        f = l;
                        var m = b.updateQueue;
                        if (null === m) {
                            var w = new Set;
                            w.add(f);
                            b.updateQueue = w;
                        } else m.add(f);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $c00590d434bbebaf$var$uj(g, l, b);
                            $c00590d434bbebaf$var$Zj();
                            break a;
                        }
                        f = Error($c00590d434bbebaf$var$p(426));
                    }
                } else if ($c00590d434bbebaf$var$J && k.mode & 1) {
                    var C = $c00590d434bbebaf$var$xj(h);
                    if (null !== C) {
                        0 === (C.flags & 65536) && (C.flags |= 256);
                        $c00590d434bbebaf$var$yj(C, h, k, g, b);
                        $c00590d434bbebaf$var$Xg($c00590d434bbebaf$var$lj(f, k));
                        break a;
                    }
                }
                g = f = $c00590d434bbebaf$var$lj(f, k);
                4 !== $c00590d434bbebaf$var$T && ($c00590d434bbebaf$var$T = 2);
                null === $c00590d434bbebaf$var$dl ? $c00590d434bbebaf$var$dl = [
                    g
                ] : $c00590d434bbebaf$var$dl.push(g);
                g = h;
                do {
                    switch(g.tag){
                        case 3:
                            g.flags |= 65536;
                            b &= -b;
                            g.lanes |= b;
                            var x = $c00590d434bbebaf$var$pj(g, f, b);
                            $c00590d434bbebaf$var$Dh(g, x);
                            break a;
                        case 1:
                            k = f;
                            var y = g.type, v = g.stateNode;
                            if (0 === (g.flags & 128) && ("function" === typeof y.getDerivedStateFromError || null !== v && "function" === typeof v.componentDidCatch && (null === $c00590d434bbebaf$var$tj || !$c00590d434bbebaf$var$tj.has(v)))) {
                                g.flags |= 65536;
                                b &= -b;
                                g.lanes |= b;
                                var D = $c00590d434bbebaf$var$sj(g, k, b);
                                $c00590d434bbebaf$var$Dh(g, D);
                                break a;
                            }
                    }
                    g = g.return;
                }while (null !== g);
            }
            $c00590d434bbebaf$var$Fl(c);
        } catch (ca) {
            b = ca;
            $c00590d434bbebaf$var$Y === c && null !== c && ($c00590d434bbebaf$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $c00590d434bbebaf$var$vl() {
    var a = $c00590d434bbebaf$var$Yk.current;
    $c00590d434bbebaf$var$Yk.current = $c00590d434bbebaf$var$ei;
    return null === a ? $c00590d434bbebaf$var$ei : a;
}
function $c00590d434bbebaf$var$Zj() {
    if (0 === $c00590d434bbebaf$var$T || 3 === $c00590d434bbebaf$var$T || 2 === $c00590d434bbebaf$var$T) $c00590d434bbebaf$var$T = 4;
    null === $c00590d434bbebaf$var$Q || 0 === ($c00590d434bbebaf$var$Fh & 268435455) && 0 === ($c00590d434bbebaf$var$bl & 268435455) || $c00590d434bbebaf$var$ol($c00590d434bbebaf$var$Q, $c00590d434bbebaf$var$Z);
}
function $c00590d434bbebaf$var$ul(a, b) {
    var c = $c00590d434bbebaf$var$K;
    $c00590d434bbebaf$var$K |= 2;
    var d = $c00590d434bbebaf$var$vl();
    if ($c00590d434bbebaf$var$Q !== a || $c00590d434bbebaf$var$Z !== b) {
        if ($c00590d434bbebaf$var$mc) {
            var e = a.memoizedUpdaters;
            0 < e.size && ($c00590d434bbebaf$var$wj(a, $c00590d434bbebaf$var$Z), e.clear());
            $c00590d434bbebaf$var$Qc(a, b);
        }
        $c00590d434bbebaf$var$fl = null;
        $c00590d434bbebaf$var$wl(a, b);
    }
    $c00590d434bbebaf$var$wc(b);
    for(;;)try {
        $c00590d434bbebaf$var$Gl();
        break;
    } catch (f) {
        $c00590d434bbebaf$var$yl(a, f);
    }
    $c00590d434bbebaf$var$nh();
    $c00590d434bbebaf$var$K = c;
    $c00590d434bbebaf$var$Yk.current = d;
    if (null !== $c00590d434bbebaf$var$Y) throw Error($c00590d434bbebaf$var$p(261));
    $c00590d434bbebaf$var$xc();
    $c00590d434bbebaf$var$Q = null;
    $c00590d434bbebaf$var$Z = 0;
    return $c00590d434bbebaf$var$T;
}
function $c00590d434bbebaf$var$Gl() {
    for(; null !== $c00590d434bbebaf$var$Y;)$c00590d434bbebaf$var$Hl($c00590d434bbebaf$var$Y);
}
function $c00590d434bbebaf$var$xl() {
    for(; null !== $c00590d434bbebaf$var$Y && !$c00590d434bbebaf$var$cc();)$c00590d434bbebaf$var$Hl($c00590d434bbebaf$var$Y);
}
function $c00590d434bbebaf$var$Hl(a) {
    var b = a.alternate;
    0 !== (a.mode & 2) ? ($c00590d434bbebaf$var$Wi = $c00590d434bbebaf$var$Ti(), 0 > a.actualStartTime && (a.actualStartTime = $c00590d434bbebaf$var$Ti()), b = $c00590d434bbebaf$var$Il(b, a, $c00590d434bbebaf$var$Jj), $c00590d434bbebaf$var$$i(a, !0)) : b = $c00590d434bbebaf$var$Il(b, a, $c00590d434bbebaf$var$Jj);
    a.memoizedProps = a.pendingProps;
    null === b ? $c00590d434bbebaf$var$Fl(a) : $c00590d434bbebaf$var$Y = b;
    $c00590d434bbebaf$var$Zk.current = null;
}
function $c00590d434bbebaf$var$Fl(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (0 === (b.mode & 2)) c = $c00590d434bbebaf$var$kk(c, b, $c00590d434bbebaf$var$Jj);
            else {
                var d = b;
                $c00590d434bbebaf$var$Wi = $c00590d434bbebaf$var$Ti();
                0 > d.actualStartTime && (d.actualStartTime = $c00590d434bbebaf$var$Ti());
                c = $c00590d434bbebaf$var$kk(c, b, $c00590d434bbebaf$var$Jj);
                $c00590d434bbebaf$var$$i(b, !1);
            }
            if (null !== c) {
                $c00590d434bbebaf$var$Y = c;
                return;
            }
        } else {
            c = $c00590d434bbebaf$var$ok(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $c00590d434bbebaf$var$Y = c;
                return;
            }
            if (0 !== (b.mode & 2)) {
                $c00590d434bbebaf$var$$i(b, !1);
                c = b.actualDuration;
                for(d = b.child; null !== d;)c += d.actualDuration, d = d.sibling;
                b.actualDuration = c;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $c00590d434bbebaf$var$T = 6;
                $c00590d434bbebaf$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $c00590d434bbebaf$var$Y = b;
            return;
        }
        $c00590d434bbebaf$var$Y = b = a;
    }while (null !== b);
    0 === $c00590d434bbebaf$var$T && ($c00590d434bbebaf$var$T = 5);
}
function $c00590d434bbebaf$var$Cl(a, b, c) {
    var d = $c00590d434bbebaf$var$E, e = $c00590d434bbebaf$var$$k.transition;
    try {
        $c00590d434bbebaf$var$$k.transition = null, $c00590d434bbebaf$var$E = 1, $c00590d434bbebaf$var$Jl(a, b, c, d);
    } finally{
        $c00590d434bbebaf$var$$k.transition = e, $c00590d434bbebaf$var$E = d;
    }
    return null;
}
function $c00590d434bbebaf$var$Jl(a, b, c, d) {
    do $c00590d434bbebaf$var$tl();
    while (null !== $c00590d434bbebaf$var$hl);
    if (0 !== ($c00590d434bbebaf$var$K & 6)) throw Error($c00590d434bbebaf$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markCommitStarted && $c00590d434bbebaf$var$B.markCommitStarted(e);
    if (null === c) return $c00590d434bbebaf$var$rc(), null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($c00590d434bbebaf$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $c00590d434bbebaf$var$Nc(a, f);
    a === $c00590d434bbebaf$var$Q && ($c00590d434bbebaf$var$Y = $c00590d434bbebaf$var$Q = null, $c00590d434bbebaf$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $c00590d434bbebaf$var$gl || ($c00590d434bbebaf$var$gl = !0, $c00590d434bbebaf$var$rl($c00590d434bbebaf$var$hc, function() {
        $c00590d434bbebaf$var$tl();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $c00590d434bbebaf$var$$k.transition;
        $c00590d434bbebaf$var$$k.transition = null;
        var g = $c00590d434bbebaf$var$E;
        $c00590d434bbebaf$var$E = 1;
        var h = $c00590d434bbebaf$var$K;
        $c00590d434bbebaf$var$K |= 4;
        $c00590d434bbebaf$var$Zk.current = null;
        $c00590d434bbebaf$var$yk(a, c);
        $c00590d434bbebaf$var$Ui = $c00590d434bbebaf$var$Ti();
        $c00590d434bbebaf$var$Mk(a, c, e);
        $c00590d434bbebaf$var$bf($c00590d434bbebaf$var$Rf);
        $c00590d434bbebaf$var$rd = !!$c00590d434bbebaf$var$Qf;
        $c00590d434bbebaf$var$Rf = $c00590d434bbebaf$var$Qf = null;
        a.current = c;
        null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markLayoutEffectsStarted && $c00590d434bbebaf$var$B.markLayoutEffectsStarted(e);
        $c00590d434bbebaf$var$Sk(c, a, e);
        null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markLayoutEffectsStopped && $c00590d434bbebaf$var$B.markLayoutEffectsStopped();
        $c00590d434bbebaf$var$dc();
        $c00590d434bbebaf$var$K = h;
        $c00590d434bbebaf$var$E = g;
        $c00590d434bbebaf$var$$k.transition = f;
    } else a.current = c, $c00590d434bbebaf$var$Ui = $c00590d434bbebaf$var$Ti();
    $c00590d434bbebaf$var$gl && ($c00590d434bbebaf$var$gl = !1, $c00590d434bbebaf$var$hl = a, $c00590d434bbebaf$var$il = e);
    f = a.pendingLanes;
    0 === f && ($c00590d434bbebaf$var$tj = null);
    $c00590d434bbebaf$var$nc(c.stateNode, d);
    $c00590d434bbebaf$var$mc && a.memoizedUpdaters.clear();
    $c00590d434bbebaf$var$pl(a, $c00590d434bbebaf$var$A());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($c00590d434bbebaf$var$qj) throw $c00590d434bbebaf$var$qj = !1, a = $c00590d434bbebaf$var$rj, $c00590d434bbebaf$var$rj = null, a;
    0 !== ($c00590d434bbebaf$var$il & 1) && 0 !== a.tag && $c00590d434bbebaf$var$tl();
    f = a.pendingLanes;
    0 !== (f & 1) ? ($c00590d434bbebaf$var$Zi = !0, a === $c00590d434bbebaf$var$ll ? $c00590d434bbebaf$var$kl++ : ($c00590d434bbebaf$var$kl = 0, $c00590d434bbebaf$var$ll = a)) : $c00590d434bbebaf$var$kl = 0;
    $c00590d434bbebaf$var$xg();
    $c00590d434bbebaf$var$rc();
    return null;
}
function $c00590d434bbebaf$var$tl() {
    if (null !== $c00590d434bbebaf$var$hl) {
        var a = $c00590d434bbebaf$var$Rc($c00590d434bbebaf$var$il), b = $c00590d434bbebaf$var$$k.transition, c = $c00590d434bbebaf$var$E;
        try {
            $c00590d434bbebaf$var$$k.transition = null;
            $c00590d434bbebaf$var$E = 16 > a ? 16 : a;
            if (null === $c00590d434bbebaf$var$hl) var d = !1;
            else {
                a = $c00590d434bbebaf$var$hl;
                var e = $c00590d434bbebaf$var$il;
                $c00590d434bbebaf$var$hl = null;
                $c00590d434bbebaf$var$il = 0;
                if (0 !== ($c00590d434bbebaf$var$K & 6)) throw Error($c00590d434bbebaf$var$p(331));
                null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markPassiveEffectsStarted && $c00590d434bbebaf$var$B.markPassiveEffectsStarted(e);
                e = $c00590d434bbebaf$var$K;
                $c00590d434bbebaf$var$K |= 4;
                for($c00590d434bbebaf$var$U = a.current; null !== $c00590d434bbebaf$var$U;){
                    var f = $c00590d434bbebaf$var$U, g = f.child;
                    if (0 !== ($c00590d434bbebaf$var$U.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($c00590d434bbebaf$var$U = l; null !== $c00590d434bbebaf$var$U;){
                                    var n = $c00590d434bbebaf$var$U, q = n;
                                    switch(q.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            q.mode & 2 ? ($c00590d434bbebaf$var$Xi = $c00590d434bbebaf$var$Ti(), $c00590d434bbebaf$var$zk(8, q, f), $c00590d434bbebaf$var$bj(q)) : $c00590d434bbebaf$var$zk(8, q, f);
                                    }
                                    var r = n.child;
                                    if (null !== r) r.return = n, $c00590d434bbebaf$var$U = r;
                                    else for(; null !== $c00590d434bbebaf$var$U;){
                                        n = $c00590d434bbebaf$var$U;
                                        var z = n.sibling, m = n.return;
                                        $c00590d434bbebaf$var$Ck(n);
                                        if (n === l) {
                                            $c00590d434bbebaf$var$U = null;
                                            break;
                                        }
                                        if (null !== z) {
                                            z.return = m;
                                            $c00590d434bbebaf$var$U = z;
                                            break;
                                        }
                                        $c00590d434bbebaf$var$U = m;
                                    }
                                }
                            }
                            var w = f.alternate;
                            if (null !== w) {
                                var C = w.child;
                                if (null !== C) {
                                    w.child = null;
                                    do {
                                        var x = C.sibling;
                                        C.sibling = null;
                                        C = x;
                                    }while (null !== C);
                                }
                            }
                            $c00590d434bbebaf$var$U = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $c00590d434bbebaf$var$U = g;
                    else b: for(; null !== $c00590d434bbebaf$var$U;){
                        f = $c00590d434bbebaf$var$U;
                        if (0 !== (f.flags & 2048)) switch(k = f, k.tag){
                            case 0:
                            case 11:
                            case 15:
                                k.mode & 2 ? ($c00590d434bbebaf$var$Xi = $c00590d434bbebaf$var$Ti(), $c00590d434bbebaf$var$zk(9, k, k.return), $c00590d434bbebaf$var$bj(k)) : $c00590d434bbebaf$var$zk(9, k, k.return);
                        }
                        var y = f.sibling;
                        if (null !== y) {
                            y.return = f.return;
                            $c00590d434bbebaf$var$U = y;
                            break b;
                        }
                        $c00590d434bbebaf$var$U = f.return;
                    }
                }
                var v = a.current;
                for($c00590d434bbebaf$var$U = v; null !== $c00590d434bbebaf$var$U;){
                    g = $c00590d434bbebaf$var$U;
                    var D = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== D) D.return = g, $c00590d434bbebaf$var$U = D;
                    else b: for(g = v; null !== $c00590d434bbebaf$var$U;){
                        h = $c00590d434bbebaf$var$U;
                        if (0 !== (h.flags & 2048)) try {
                            switch(l = h, l.tag){
                                case 0:
                                case 11:
                                case 15:
                                    if (l.mode & 2) {
                                        $c00590d434bbebaf$var$Xi = $c00590d434bbebaf$var$Ti();
                                        try {
                                            $c00590d434bbebaf$var$Ak(9, l);
                                        } finally{
                                            $c00590d434bbebaf$var$bj(l);
                                        }
                                    } else $c00590d434bbebaf$var$Ak(9, l);
                            }
                        } catch (Pj) {
                            $c00590d434bbebaf$var$W(h, h.return, Pj);
                        }
                        if (h === g) {
                            $c00590d434bbebaf$var$U = null;
                            break b;
                        }
                        var ca = h.sibling;
                        if (null !== ca) {
                            ca.return = h.return;
                            $c00590d434bbebaf$var$U = ca;
                            break b;
                        }
                        $c00590d434bbebaf$var$U = h.return;
                    }
                }
                v = $c00590d434bbebaf$var$jl;
                $c00590d434bbebaf$var$jl = [];
                for(D = 0; D < v.length; D++){
                    var R = v[D];
                    if (0 !== (R.flags & 4)) switch(R.tag){
                        case 12:
                            var sa = R.stateNode.passiveEffectDuration, V = R.memoizedProps, Bl = V.id, yi = V.onPostCommit;
                            ca = $c00590d434bbebaf$var$Ui;
                            var zi = null === R.alternate ? "mount" : "update";
                            $c00590d434bbebaf$var$Yi && (zi = "nested-update");
                            "function" === typeof yi && yi(Bl, zi, sa, ca);
                            var lb = R.return;
                            b: for(; null !== lb;){
                                switch(lb.tag){
                                    case 3:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                    case 12:
                                        lb.stateNode.passiveEffectDuration += sa;
                                        break b;
                                }
                                lb = lb.return;
                            }
                    }
                }
                null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markPassiveEffectsStopped && $c00590d434bbebaf$var$B.markPassiveEffectsStopped();
                $c00590d434bbebaf$var$K = e;
                $c00590d434bbebaf$var$xg();
                if ($c00590d434bbebaf$var$lc && "function" === typeof $c00590d434bbebaf$var$lc.onPostCommitFiberRoot) try {
                    $c00590d434bbebaf$var$lc.onPostCommitFiberRoot($c00590d434bbebaf$var$kc, a);
                } catch (Pj) {}
                var Qj = a.current.stateNode;
                Qj.effectDuration = 0;
                Qj.passiveEffectDuration = 0;
                d = !0;
            }
            return d;
        } finally{
            $c00590d434bbebaf$var$E = c, $c00590d434bbebaf$var$$k.transition = b;
        }
    }
    return !1;
}
function $c00590d434bbebaf$var$Wk(a) {
    $c00590d434bbebaf$var$jl.push(a);
    $c00590d434bbebaf$var$gl || ($c00590d434bbebaf$var$gl = !0, $c00590d434bbebaf$var$rl($c00590d434bbebaf$var$hc, function() {
        $c00590d434bbebaf$var$tl();
        return null;
    }));
}
function $c00590d434bbebaf$var$Kl(a, b, c) {
    b = $c00590d434bbebaf$var$lj(c, b);
    b = $c00590d434bbebaf$var$pj(a, b, 1);
    a = $c00590d434bbebaf$var$Bh(a, b, 1);
    b = $c00590d434bbebaf$var$Ri();
    null !== a && ($c00590d434bbebaf$var$Mc(a, 1, b), $c00590d434bbebaf$var$pl(a, b));
}
function $c00590d434bbebaf$var$W(a, b, c) {
    if (3 === a.tag) $c00590d434bbebaf$var$Kl(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $c00590d434bbebaf$var$Kl(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $c00590d434bbebaf$var$tj || !$c00590d434bbebaf$var$tj.has(d))) {
                a = $c00590d434bbebaf$var$lj(c, a);
                a = $c00590d434bbebaf$var$sj(b, a, 1);
                b = $c00590d434bbebaf$var$Bh(b, a, 1);
                a = $c00590d434bbebaf$var$Ri();
                null !== b && ($c00590d434bbebaf$var$Mc(b, 1, a), $c00590d434bbebaf$var$pl(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $c00590d434bbebaf$var$vj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $c00590d434bbebaf$var$Ri();
    a.pingedLanes |= a.suspendedLanes & c;
    $c00590d434bbebaf$var$Q === a && ($c00590d434bbebaf$var$Z & c) === c && (4 === $c00590d434bbebaf$var$T || 3 === $c00590d434bbebaf$var$T && ($c00590d434bbebaf$var$Z & 130023424) === $c00590d434bbebaf$var$Z && (globalThis.REACT_FALLBACK_THROTTLE_MS || 500) > $c00590d434bbebaf$var$A() - $c00590d434bbebaf$var$Qk ? $c00590d434bbebaf$var$wl(a, 0) : $c00590d434bbebaf$var$cl |= c);
    $c00590d434bbebaf$var$pl(a, b);
}
function $c00590d434bbebaf$var$Ll(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $c00590d434bbebaf$var$Ec, $c00590d434bbebaf$var$Ec <<= 1, 0 === ($c00590d434bbebaf$var$Ec & 130023424) && ($c00590d434bbebaf$var$Ec = 4194304)));
    var c = $c00590d434bbebaf$var$Ri();
    a = $c00590d434bbebaf$var$wh(a, b);
    null !== a && ($c00590d434bbebaf$var$Mc(a, b, c), $c00590d434bbebaf$var$pl(a, c));
}
function $c00590d434bbebaf$var$ak(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $c00590d434bbebaf$var$Ll(a, c);
}
function $c00590d434bbebaf$var$Lk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($c00590d434bbebaf$var$p(314));
    }
    null !== d && d.delete(b);
    $c00590d434bbebaf$var$Ll(a, c);
}
var $c00590d434bbebaf$var$Il;
$c00590d434bbebaf$var$Il = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $c00590d434bbebaf$var$jg.current) $c00590d434bbebaf$var$rh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $c00590d434bbebaf$var$rh = !1, $c00590d434bbebaf$var$ek(a, b, c);
            $c00590d434bbebaf$var$rh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $c00590d434bbebaf$var$rh = !1, $c00590d434bbebaf$var$J && 0 !== (b.flags & 1048576) && $c00590d434bbebaf$var$Ig(b, $c00590d434bbebaf$var$Bg, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $c00590d434bbebaf$var$Mj(a, b);
            a = b.pendingProps;
            var e = $c00590d434bbebaf$var$lg(b, $c00590d434bbebaf$var$I.current);
            $c00590d434bbebaf$var$qh(b, c);
            $c00590d434bbebaf$var$sc(b);
            e = $c00590d434bbebaf$var$ai(null, b, d, a, e, c);
            var f = $c00590d434bbebaf$var$fi();
            $c00590d434bbebaf$var$tc();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $c00590d434bbebaf$var$mg(d) ? (f = !0, $c00590d434bbebaf$var$qg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $c00590d434bbebaf$var$yh(b), e.updater = $c00590d434bbebaf$var$gj, b.stateNode = e, e._reactInternals = b, $c00590d434bbebaf$var$kj(b, d, a, c), b = $c00590d434bbebaf$var$Nj(null, b, d, !0, f, c)) : (b.tag = 0, $c00590d434bbebaf$var$J && f && $c00590d434bbebaf$var$Jg(b), $c00590d434bbebaf$var$Aj(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $c00590d434bbebaf$var$Mj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $c00590d434bbebaf$var$Ml(d);
                a = $c00590d434bbebaf$var$ej(d, a);
                switch(e){
                    case 0:
                        b = $c00590d434bbebaf$var$Gj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $c00590d434bbebaf$var$Lj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $c00590d434bbebaf$var$Bj(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $c00590d434bbebaf$var$Dj(null, b, d, $c00590d434bbebaf$var$ej(d.type, a), c);
                        break a;
                }
                throw Error($c00590d434bbebaf$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c00590d434bbebaf$var$ej(d, e), $c00590d434bbebaf$var$Gj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c00590d434bbebaf$var$ej(d, e), $c00590d434bbebaf$var$Lj(a, b, d, e, c);
        case 3:
            a: {
                $c00590d434bbebaf$var$Oj(b);
                if (null === a) throw Error($c00590d434bbebaf$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $c00590d434bbebaf$var$zh(a, b);
                $c00590d434bbebaf$var$Eh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $c00590d434bbebaf$var$lj(Error($c00590d434bbebaf$var$p(423)), b);
                        b = $c00590d434bbebaf$var$Rj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $c00590d434bbebaf$var$lj(Error($c00590d434bbebaf$var$p(424)), b);
                        b = $c00590d434bbebaf$var$Rj(a, b, d, c, e);
                        break a;
                    } else for($c00590d434bbebaf$var$Mg = $c00590d434bbebaf$var$Zf(b.stateNode.containerInfo.firstChild), $c00590d434bbebaf$var$Lg = b, $c00590d434bbebaf$var$J = !0, $c00590d434bbebaf$var$Ng = null, c = $c00590d434bbebaf$var$ih(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $c00590d434bbebaf$var$Wg();
                    if (d === e) {
                        b = $c00590d434bbebaf$var$Cj(a, b, c);
                        break a;
                    }
                    $c00590d434bbebaf$var$Aj(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $c00590d434bbebaf$var$Oh(b), null === a && $c00590d434bbebaf$var$Sg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $c00590d434bbebaf$var$Sf(d, e) ? g = null : null !== f && $c00590d434bbebaf$var$Sf(d, f) && (b.flags |= 32), $c00590d434bbebaf$var$Kj(a, b), $c00590d434bbebaf$var$Aj(a, b, g, c), b.child;
        case 6:
            return null === a && $c00590d434bbebaf$var$Sg(b), null;
        case 13:
            return $c00590d434bbebaf$var$Uj(a, b, c);
        case 4:
            return $c00590d434bbebaf$var$Mh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $c00590d434bbebaf$var$hh(b, null, d, c) : $c00590d434bbebaf$var$Aj(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c00590d434bbebaf$var$ej(d, e), $c00590d434bbebaf$var$Bj(a, b, d, e, c);
        case 7:
            return $c00590d434bbebaf$var$Aj(a, b, b.pendingProps, c), b.child;
        case 8:
            return $c00590d434bbebaf$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return b.flags |= 4, d = b.stateNode, d.effectDuration = 0, d.passiveEffectDuration = 0, $c00590d434bbebaf$var$Aj(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $c00590d434bbebaf$var$H($c00590d434bbebaf$var$jh, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($c00590d434bbebaf$var$Ve(f.value, g)) {
                        if (f.children === e.children && !$c00590d434bbebaf$var$jg.current) {
                            b = $c00590d434bbebaf$var$Cj(a, b, c);
                            break a;
                        }
                    } else {
                        if (globalThis.__ATL_REACT_METRICS && globalThis.__ATL_REACT_METRICS.onContextUpdate) globalThis.__ATL_REACT_METRICS.onContextUpdate(b, d, g, f.value);
                        for(f = b.child, null !== f && (f.return = b), globalThis.__ATL_REACT_METRICS && globalThis.__ATL_REACT_METRICS.contextUpdateCount++; null !== f;){
                            var h = f.dependencies;
                            if (null !== h) {
                                g = f.child;
                                for(var k = h.firstContext; null !== k;){
                                    if (k.context === d) {
                                        if (1 === f.tag) {
                                            k = $c00590d434bbebaf$var$Ah(-1, c & -c);
                                            k.tag = 2;
                                            var l = f.updateQueue;
                                            if (null !== l) {
                                                l = l.shared;
                                                var n = l.pending;
                                                null === n ? k.next = k : (k.next = n.next, n.next = k);
                                                l.pending = k;
                                            }
                                        }
                                        f.lanes |= c;
                                        k = f.alternate;
                                        null !== k && (k.lanes |= c);
                                        $c00590d434bbebaf$var$ph(f.return, c, b);
                                        h.lanes |= c;
                                        break;
                                    }
                                    k = k.next;
                                }
                            } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                            else if (18 === f.tag) {
                                g = f.return;
                                if (null === g) throw Error($c00590d434bbebaf$var$p(341));
                                g.lanes |= c;
                                h = g.alternate;
                                null !== h && (h.lanes |= c);
                                $c00590d434bbebaf$var$ph(g, c, b);
                                g = f.sibling;
                            } else g = f.child;
                            if (null !== g) g.return = f;
                            else for(g = f; null !== g;){
                                if (g === b) {
                                    g = null;
                                    break;
                                }
                                f = g.sibling;
                                if (null !== f) {
                                    f.return = g.return;
                                    g = f;
                                    break;
                                }
                                g = g.return;
                            }
                            f = g;
                        }
                    }
                }
                $c00590d434bbebaf$var$Aj(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $c00590d434bbebaf$var$qh(b, c), e = $c00590d434bbebaf$var$sh(e), $c00590d434bbebaf$var$sc(b), d = d(e), $c00590d434bbebaf$var$tc(), b.flags |= 1, $c00590d434bbebaf$var$Aj(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $c00590d434bbebaf$var$ej(d, b.pendingProps), e = $c00590d434bbebaf$var$ej(d.type, e), $c00590d434bbebaf$var$Dj(a, b, d, e, c);
        case 15:
            return $c00590d434bbebaf$var$Fj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $c00590d434bbebaf$var$ej(d, e), $c00590d434bbebaf$var$Mj(a, b), b.tag = 1, $c00590d434bbebaf$var$mg(d) ? (a = !0, $c00590d434bbebaf$var$qg(b)) : a = !1, $c00590d434bbebaf$var$qh(b, c), $c00590d434bbebaf$var$ij(b, d, e), $c00590d434bbebaf$var$kj(b, d, e, c), $c00590d434bbebaf$var$Nj(null, b, d, !0, a, c);
        case 19:
            return $c00590d434bbebaf$var$dk(a, b, c);
        case 22:
            return $c00590d434bbebaf$var$Hj(a, b, c);
    }
    throw Error($c00590d434bbebaf$var$p(156, b.tag));
};
function $c00590d434bbebaf$var$wj(a, b) {
    $c00590d434bbebaf$var$mc && a.memoizedUpdaters.forEach(function(c) {
        $c00590d434bbebaf$var$Pc(a, c, b);
    });
}
function $c00590d434bbebaf$var$rl(a, b) {
    return $c00590d434bbebaf$var$ac(a, b);
}
function $c00590d434bbebaf$var$Nl(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
    this.actualDuration = 0;
    this.actualStartTime = -1;
    this.treeBaseDuration = this.selfBaseDuration = 0;
}
function $c00590d434bbebaf$var$Pg(a, b, c, d) {
    return new $c00590d434bbebaf$var$Nl(a, b, c, d);
}
function $c00590d434bbebaf$var$Ej(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $c00590d434bbebaf$var$Ml(a) {
    if ("function" === typeof a) return $c00590d434bbebaf$var$Ej(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $c00590d434bbebaf$var$Da) return 11;
        if (a === $c00590d434bbebaf$var$Ga) return 14;
    }
    return 2;
}
function $c00590d434bbebaf$var$ch(a, b) {
    var c = a.alternate;
    null === c ? (c = $c00590d434bbebaf$var$Pg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null, c.actualDuration = 0, c.actualStartTime = -1);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    c.selfBaseDuration = a.selfBaseDuration;
    c.treeBaseDuration = a.treeBaseDuration;
    return c;
}
function $c00590d434bbebaf$var$eh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $c00590d434bbebaf$var$Ej(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $c00590d434bbebaf$var$ya:
            return $c00590d434bbebaf$var$gh(c.children, e, f, b);
        case $c00590d434bbebaf$var$za:
            g = 8;
            e |= 8;
            break;
        case $c00590d434bbebaf$var$Aa:
            return a = $c00590d434bbebaf$var$Pg(12, c, b, e | 2), a.elementType = $c00590d434bbebaf$var$Aa, a.lanes = f, a.stateNode = {
                effectDuration: 0,
                passiveEffectDuration: 0
            }, a;
        case $c00590d434bbebaf$var$Ea:
            return a = $c00590d434bbebaf$var$Pg(13, c, b, e), a.elementType = $c00590d434bbebaf$var$Ea, a.lanes = f, a;
        case $c00590d434bbebaf$var$Fa:
            return a = $c00590d434bbebaf$var$Pg(19, c, b, e), a.elementType = $c00590d434bbebaf$var$Fa, a.lanes = f, a;
        case $c00590d434bbebaf$var$Ia:
            return $c00590d434bbebaf$var$Vj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $c00590d434bbebaf$var$Ba:
                    g = 10;
                    break a;
                case $c00590d434bbebaf$var$Ca:
                    g = 9;
                    break a;
                case $c00590d434bbebaf$var$Da:
                    g = 11;
                    break a;
                case $c00590d434bbebaf$var$Ga:
                    g = 14;
                    break a;
                case $c00590d434bbebaf$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($c00590d434bbebaf$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $c00590d434bbebaf$var$Pg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $c00590d434bbebaf$var$gh(a, b, c, d) {
    a = $c00590d434bbebaf$var$Pg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $c00590d434bbebaf$var$Vj(a, b, c, d) {
    a = $c00590d434bbebaf$var$Pg(22, a, d, b);
    a.elementType = $c00590d434bbebaf$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $c00590d434bbebaf$var$dh(a, b, c) {
    a = $c00590d434bbebaf$var$Pg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $c00590d434bbebaf$var$fh(a, b, c) {
    b = $c00590d434bbebaf$var$Pg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $c00590d434bbebaf$var$Ol(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $c00590d434bbebaf$var$Lc(0);
    this.expirationTimes = $c00590d434bbebaf$var$Lc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $c00590d434bbebaf$var$Lc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
    this.passiveEffectDuration = this.effectDuration = 0;
    this.memoizedUpdaters = new Set;
    a = this.pendingUpdatersLaneMap = [];
    for(b = 0; 31 > b; b++)a.push(new Set);
}
function $c00590d434bbebaf$var$Pl(a, b, c, d, e, f, g, h, k) {
    a = new $c00590d434bbebaf$var$Ol(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    $c00590d434bbebaf$var$mc && (b |= 2);
    f = $c00590d434bbebaf$var$Pg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $c00590d434bbebaf$var$yh(f);
    return a;
}
function $c00590d434bbebaf$var$Ql(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $c00590d434bbebaf$var$xa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $c00590d434bbebaf$var$Rl(a) {
    if (!a) return $c00590d434bbebaf$var$ig;
    a = a._reactInternals;
    a: {
        if ($c00590d434bbebaf$var$Vb(a) !== a || 1 !== a.tag) throw Error($c00590d434bbebaf$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($c00590d434bbebaf$var$mg(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($c00590d434bbebaf$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($c00590d434bbebaf$var$mg(c)) return $c00590d434bbebaf$var$pg(a, c, b);
    }
    return b;
}
function $c00590d434bbebaf$var$Sl(a, b, c, d, e, f, g, h, k) {
    a = $c00590d434bbebaf$var$Pl(c, d, !0, a, e, f, g, h, k);
    a.context = $c00590d434bbebaf$var$Rl(null);
    c = a.current;
    d = $c00590d434bbebaf$var$Ri();
    e = $c00590d434bbebaf$var$Oi(c);
    f = $c00590d434bbebaf$var$Ah(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $c00590d434bbebaf$var$Bh(c, f, e);
    a.current.lanes = e;
    $c00590d434bbebaf$var$Mc(a, e, d);
    $c00590d434bbebaf$var$pl(a, d);
    return a;
}
function $c00590d434bbebaf$var$Tl(a, b, c, d) {
    var e = b.current, f = $c00590d434bbebaf$var$Ri(), g = $c00590d434bbebaf$var$Oi(e);
    null !== $c00590d434bbebaf$var$B && "function" === typeof $c00590d434bbebaf$var$B.markRenderScheduled && $c00590d434bbebaf$var$B.markRenderScheduled(g);
    c = $c00590d434bbebaf$var$Rl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $c00590d434bbebaf$var$Ah(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $c00590d434bbebaf$var$Bh(e, b, g);
    null !== a && ($c00590d434bbebaf$var$ui(a, e, g, f), $c00590d434bbebaf$var$Ch(a, e, g));
    return g;
}
function $c00590d434bbebaf$var$Ul(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $c00590d434bbebaf$var$Vl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $c00590d434bbebaf$var$Wl(a, b) {
    $c00590d434bbebaf$var$Vl(a, b);
    (a = a.alternate) && $c00590d434bbebaf$var$Vl(a, b);
}
function $c00590d434bbebaf$var$Xl() {
    return null;
}
var $c00590d434bbebaf$var$Yl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $c00590d434bbebaf$var$Zl(a) {
    this._internalRoot = a;
}
$c00590d434bbebaf$var$$l.prototype.render = $c00590d434bbebaf$var$Zl.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($c00590d434bbebaf$var$p(409));
    $c00590d434bbebaf$var$Tl(a, b, null, null);
};
$c00590d434bbebaf$var$$l.prototype.unmount = $c00590d434bbebaf$var$Zl.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $c00590d434bbebaf$var$El(function() {
            $c00590d434bbebaf$var$Tl(null, a, null, null);
        });
        b[$c00590d434bbebaf$var$If] = null;
    }
};
function $c00590d434bbebaf$var$$l(a) {
    this._internalRoot = a;
}
$c00590d434bbebaf$var$$l.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $c00590d434bbebaf$var$Vc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $c00590d434bbebaf$var$dd.length && 0 !== b && b < $c00590d434bbebaf$var$dd[c].priority; c++);
        $c00590d434bbebaf$var$dd.splice(c, 0, a);
        0 === c && $c00590d434bbebaf$var$id(a);
    }
};
function $c00590d434bbebaf$var$am(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $c00590d434bbebaf$var$bm(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $c00590d434bbebaf$var$cm() {}
function $c00590d434bbebaf$var$dm(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $c00590d434bbebaf$var$Ul(g);
                f.call(a);
            };
        }
        var g = $c00590d434bbebaf$var$Sl(b, d, a, 0, null, !1, !1, "", $c00590d434bbebaf$var$cm);
        a._reactRootContainer = g;
        a[$c00590d434bbebaf$var$If] = g.current;
        $c00590d434bbebaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
        $c00590d434bbebaf$var$El();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $c00590d434bbebaf$var$Ul(k);
            h.call(a);
        };
    }
    var k = $c00590d434bbebaf$var$Pl(a, 0, !1, null, null, !1, !1, "", $c00590d434bbebaf$var$cm);
    a._reactRootContainer = k;
    a[$c00590d434bbebaf$var$If] = k.current;
    $c00590d434bbebaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
    $c00590d434bbebaf$var$El(function() {
        $c00590d434bbebaf$var$Tl(b, k, c, d);
    });
    return k;
}
function $c00590d434bbebaf$var$em(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $c00590d434bbebaf$var$Ul(g);
                h.call(a);
            };
        }
        $c00590d434bbebaf$var$Tl(b, g, a, e);
    } else g = $c00590d434bbebaf$var$dm(c, b, a, e, d);
    return $c00590d434bbebaf$var$Ul(g);
}
$c00590d434bbebaf$var$Sc = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $c00590d434bbebaf$var$Fc(b.pendingLanes);
                0 !== c && ($c00590d434bbebaf$var$Oc(b, c | 1), $c00590d434bbebaf$var$pl(b, $c00590d434bbebaf$var$A()), 0 === ($c00590d434bbebaf$var$K & 6) && ($c00590d434bbebaf$var$mk = $c00590d434bbebaf$var$A() + 500, $c00590d434bbebaf$var$xg()));
            }
            break;
        case 13:
            $c00590d434bbebaf$var$El(function() {
                var b = $c00590d434bbebaf$var$wh(a, 1);
                if (null !== b) {
                    var c = $c00590d434bbebaf$var$Ri();
                    $c00590d434bbebaf$var$ui(b, a, 1, c);
                }
            }), $c00590d434bbebaf$var$Wl(a, 1);
    }
};
$c00590d434bbebaf$var$Tc = function(a) {
    if (13 === a.tag) {
        var b = $c00590d434bbebaf$var$wh(a, 134217728);
        if (null !== b) {
            var c = $c00590d434bbebaf$var$Ri();
            $c00590d434bbebaf$var$ui(b, a, 134217728, c);
        }
        $c00590d434bbebaf$var$Wl(a, 134217728);
    }
};
$c00590d434bbebaf$var$Uc = function(a) {
    if (13 === a.tag) {
        var b = $c00590d434bbebaf$var$Oi(a), c = $c00590d434bbebaf$var$wh(a, b);
        if (null !== c) {
            var d = $c00590d434bbebaf$var$Ri();
            $c00590d434bbebaf$var$ui(c, a, b, d);
        }
        $c00590d434bbebaf$var$Wl(a, b);
    }
};
$c00590d434bbebaf$var$Vc = function() {
    return $c00590d434bbebaf$var$E;
};
$c00590d434bbebaf$var$Wc = function(a, b) {
    var c = $c00590d434bbebaf$var$E;
    try {
        return $c00590d434bbebaf$var$E = a, b();
    } finally{
        $c00590d434bbebaf$var$E = c;
    }
};
$c00590d434bbebaf$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $c00590d434bbebaf$var$ab(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $c00590d434bbebaf$var$Db(d);
                        if (!e) throw Error($c00590d434bbebaf$var$p(90));
                        $c00590d434bbebaf$var$Wa(d);
                        $c00590d434bbebaf$var$ab(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $c00590d434bbebaf$var$hb(a, c);
            break;
        case "select":
            b = c.value, null != b && $c00590d434bbebaf$var$eb(a, !!c.multiple, b, !1);
    }
};
$c00590d434bbebaf$var$Gb = $c00590d434bbebaf$var$Dl;
$c00590d434bbebaf$var$Hb = $c00590d434bbebaf$var$El;
var $c00590d434bbebaf$var$fm = {
    usingClientEntryPoint: !1,
    Events: [
        $c00590d434bbebaf$var$Cb,
        $c00590d434bbebaf$var$Ie,
        $c00590d434bbebaf$var$Db,
        $c00590d434bbebaf$var$Eb,
        $c00590d434bbebaf$var$Fb,
        $c00590d434bbebaf$var$Dl
    ]
}, $c00590d434bbebaf$var$gm = {
    findFiberByHostInstance: $c00590d434bbebaf$var$jd,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
(function(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        a = $c00590d434bbebaf$var$u({}, a, {
            getLaneLabelMap: $c00590d434bbebaf$var$pc,
            injectProfilingHooks: $c00590d434bbebaf$var$oc
        }), $c00590d434bbebaf$var$kc = b.inject(a), $c00590d434bbebaf$var$lc = b;
    } catch (c) {}
    return b.checkDCE ? !0 : !1;
})({
    bundleType: $c00590d434bbebaf$var$gm.bundleType,
    version: $c00590d434bbebaf$var$gm.version,
    rendererPackageName: $c00590d434bbebaf$var$gm.rendererPackageName,
    rendererConfig: $c00590d434bbebaf$var$gm.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $c00590d434bbebaf$var$va.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $c00590d434bbebaf$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $c00590d434bbebaf$var$gm.findFiberByHostInstance || $c00590d434bbebaf$var$Xl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
});
$c00590d434bbebaf$export$ae55be85d98224ed = $c00590d434bbebaf$var$fm;
$c00590d434bbebaf$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$c00590d434bbebaf$var$am(b)) throw Error($c00590d434bbebaf$var$p(200));
    return $c00590d434bbebaf$var$Ql(a, b, null, c);
};
$c00590d434bbebaf$export$882461b6382ed46c = function(a, b) {
    if (!$c00590d434bbebaf$var$am(a)) throw Error($c00590d434bbebaf$var$p(299));
    var c = !1, d = "", e = $c00590d434bbebaf$var$Yl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $c00590d434bbebaf$var$Pl(a, 1, !1, null, null, c, !1, d, e);
    a[$c00590d434bbebaf$var$If] = b.current;
    $c00590d434bbebaf$var$Gf(8 === a.nodeType ? a.parentNode : a);
    return new $c00590d434bbebaf$var$Zl(b);
};
$c00590d434bbebaf$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($c00590d434bbebaf$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($c00590d434bbebaf$var$p(268, a));
    }
    a = $c00590d434bbebaf$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$c00590d434bbebaf$export$cd75ccfd720a3cd4 = function(a) {
    return $c00590d434bbebaf$var$El(a);
};
$c00590d434bbebaf$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$c00590d434bbebaf$var$bm(b)) throw Error($c00590d434bbebaf$var$p(200));
    return $c00590d434bbebaf$var$em(null, a, b, !0, c);
};
$c00590d434bbebaf$export$757ceba2d55c277e = function(a, b, c) {
    if (!$c00590d434bbebaf$var$am(a)) throw Error($c00590d434bbebaf$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $c00590d434bbebaf$var$Yl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $c00590d434bbebaf$var$Sl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$c00590d434bbebaf$var$If] = b.current;
    $c00590d434bbebaf$var$Gf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $c00590d434bbebaf$var$$l(b);
};
$c00590d434bbebaf$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$c00590d434bbebaf$var$bm(b)) throw Error($c00590d434bbebaf$var$p(200));
    return $c00590d434bbebaf$var$em(null, a, b, !1, c);
};
$c00590d434bbebaf$export$502457920280e6be = function(a) {
    if (!$c00590d434bbebaf$var$bm(a)) throw Error($c00590d434bbebaf$var$p(40));
    return a._reactRootContainer ? ($c00590d434bbebaf$var$El(function() {
        $c00590d434bbebaf$var$em(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$c00590d434bbebaf$var$If] = null;
        });
    }), !0) : !1;
};
$c00590d434bbebaf$export$c78a37762a8d58e1 = $c00590d434bbebaf$var$Dl;
$c00590d434bbebaf$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$c00590d434bbebaf$var$bm(c)) throw Error($c00590d434bbebaf$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($c00590d434bbebaf$var$p(38));
    return $c00590d434bbebaf$var$em(a, b, c, !1, d);
};
$c00590d434bbebaf$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";
/* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop === 'function') __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());

});


parcelRegister("lGEfm", function(module, exports) {
/**
 * Expose `pathToRegexp`.
 */ module.exports = $fc9cbd67eb82ef3d$var$pathToRegexp;
module.exports.match = $fc9cbd67eb82ef3d$var$match;
module.exports.regexpToFunction = $fc9cbd67eb82ef3d$var$regexpToFunction;
module.exports.parse = $fc9cbd67eb82ef3d$var$parse;
module.exports.compile = $fc9cbd67eb82ef3d$var$compile;
module.exports.tokensToFunction = $fc9cbd67eb82ef3d$var$tokensToFunction;
module.exports.tokensToRegExp = $fc9cbd67eb82ef3d$var$tokensToRegExp;
/**
 * Default configs.
 */ var $fc9cbd67eb82ef3d$var$DEFAULT_DELIMITER = '/';
/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */ var $fc9cbd67eb82ef3d$var$PATH_REGEXP = new RegExp([
    // Match escaped characters that would otherwise appear in future matches.
    // This allows the user to escape special characters that won't transform.
    '(\\\\.)',
    // Match Express-style parameters and un-named parameters with a prefix
    // and optional suffixes. Matches appear as:
    //
    // ":test(\\d+)?" => ["test", "\d+", undefined, "?"]
    // "(\\d+)"  => [undefined, undefined, "\d+", undefined]
    '(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?'
].join('|'), 'g');
/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */ function $fc9cbd67eb82ef3d$var$parse(str, options) {
    var tokens = [];
    var key = 0;
    var index = 0;
    var path = '';
    var defaultDelimiter = options && options.delimiter || $fc9cbd67eb82ef3d$var$DEFAULT_DELIMITER;
    var whitelist = options && options.whitelist || undefined;
    var pathEscaped = false;
    var res;
    while((res = $fc9cbd67eb82ef3d$var$PATH_REGEXP.exec(str)) !== null){
        var m = res[0];
        var escaped = res[1];
        var offset = res.index;
        path += str.slice(index, offset);
        index = offset + m.length;
        // Ignore already escaped sequences.
        if (escaped) {
            path += escaped[1];
            pathEscaped = true;
            continue;
        }
        var prev = '';
        var name = res[2];
        var capture = res[3];
        var group = res[4];
        var modifier = res[5];
        if (!pathEscaped && path.length) {
            var k = path.length - 1;
            var c = path[k];
            var matches = whitelist ? whitelist.indexOf(c) > -1 : true;
            if (matches) {
                prev = c;
                path = path.slice(0, k);
            }
        }
        // Push the current path onto the tokens.
        if (path) {
            tokens.push(path);
            path = '';
            pathEscaped = false;
        }
        var repeat = modifier === '+' || modifier === '*';
        var optional = modifier === '?' || modifier === '*';
        var pattern = capture || group;
        var delimiter = prev || defaultDelimiter;
        var prevText = prev || (typeof tokens[tokens.length - 1] === 'string' ? tokens[tokens.length - 1] : '');
        tokens.push({
            name: name || key++,
            prefix: prev,
            delimiter: delimiter,
            optional: optional,
            repeat: repeat,
            pattern: pattern ? $fc9cbd67eb82ef3d$var$escapeGroup(pattern) : $fc9cbd67eb82ef3d$var$restrictBacktrack(delimiter, defaultDelimiter, prevText)
        });
    }
    // Push any remaining characters.
    if (path || index < str.length) tokens.push(path + str.substr(index));
    return tokens;
}
function $fc9cbd67eb82ef3d$var$restrictBacktrack(delimiter, defaultDelimiter, prevText) {
    var charGroup = '[^' + $fc9cbd67eb82ef3d$var$escapeString(delimiter === defaultDelimiter ? delimiter : delimiter + defaultDelimiter) + ']';
    if (!prevText || prevText.indexOf(delimiter) > -1 || prevText.indexOf(defaultDelimiter) > -1) return charGroup + '+?';
    return $fc9cbd67eb82ef3d$var$escapeString(prevText) + '|(?:(?!' + $fc9cbd67eb82ef3d$var$escapeString(prevText) + ')' + charGroup + ')+?';
}
/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */ function $fc9cbd67eb82ef3d$var$compile(str, options) {
    return $fc9cbd67eb82ef3d$var$tokensToFunction($fc9cbd67eb82ef3d$var$parse(str, options), options);
}
/**
 * Create path match function from `path-to-regexp` spec.
 */ function $fc9cbd67eb82ef3d$var$match(str, options) {
    var keys = [];
    var re = $fc9cbd67eb82ef3d$var$pathToRegexp(str, keys, options);
    return $fc9cbd67eb82ef3d$var$regexpToFunction(re, keys);
}
/**
 * Create a path match function from `path-to-regexp` output.
 */ function $fc9cbd67eb82ef3d$var$regexpToFunction(re, keys) {
    return function(pathname, options) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0];
        var index = m.index;
        var params = {};
        var decode = options && options.decode || decodeURIComponent;
        for(var i = 1; i < m.length; i++){
            if (m[i] === undefined) continue;
            var key = keys[i - 1];
            if (key.repeat) params[key.name] = m[i].split(key.delimiter).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Expose a method for transforming tokens into the path function.
 */ function $fc9cbd67eb82ef3d$var$tokensToFunction(tokens, options) {
    // Compile all the tokens into regexps.
    var matches = new Array(tokens.length);
    // Compile all the patterns before compilation.
    for(var i = 0; i < tokens.length; i++)if (typeof tokens[i] === 'object') matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', $fc9cbd67eb82ef3d$var$flags(options));
    return function(data, options) {
        var path = '';
        var encode = options && options.encode || encodeURIComponent;
        var validate = options ? options.validate !== false : true;
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var segment;
            if (Array.isArray(value)) {
                if (!token.repeat) throw new TypeError('Expected "' + token.name + '" to not repeat, but got array');
                if (value.length === 0) {
                    if (token.optional) continue;
                    throw new TypeError('Expected "' + token.name + '" to not be empty');
                }
                for(var j = 0; j < value.length; j++){
                    segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '"');
                    path += (j === 0 ? token.prefix : token.delimiter) + segment;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
                segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but got "' + segment + '"');
                path += token.prefix + segment;
                continue;
            }
            if (token.optional) continue;
            throw new TypeError('Expected "' + token.name + '" to be ' + (token.repeat ? 'an array' : 'a string'));
        }
        return path;
    };
}
/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */ function $fc9cbd67eb82ef3d$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */ function $fc9cbd67eb82ef3d$var$escapeGroup(group) {
    return group.replace(/([=!:$/()])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */ function $fc9cbd67eb82ef3d$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {Array=}  keys
 * @return {!RegExp}
 */ function $fc9cbd67eb82ef3d$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    // Use a negative lookahead to match only capturing groups.
    var groups = path.source.match(/\((?!\?)/g);
    if (groups) for(var i = 0; i < groups.length; i++)keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        pattern: null
    });
    return path;
}
/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $fc9cbd67eb82ef3d$var$arrayToRegexp(path, keys, options) {
    var parts = [];
    for(var i = 0; i < path.length; i++)parts.push($fc9cbd67eb82ef3d$var$pathToRegexp(path[i], keys, options).source);
    return new RegExp('(?:' + parts.join('|') + ')', $fc9cbd67eb82ef3d$var$flags(options));
}
/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $fc9cbd67eb82ef3d$var$stringToRegexp(path, keys, options) {
    return $fc9cbd67eb82ef3d$var$tokensToRegExp($fc9cbd67eb82ef3d$var$parse(path, options), keys, options);
}
/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}  tokens
 * @param  {Array=}  keys
 * @param  {Object=} options
 * @return {!RegExp}
 */ function $fc9cbd67eb82ef3d$var$tokensToRegExp(tokens, keys, options) {
    options = options || {};
    var strict = options.strict;
    var start = options.start !== false;
    var end = options.end !== false;
    var delimiter = options.delimiter || $fc9cbd67eb82ef3d$var$DEFAULT_DELIMITER;
    var endsWith = [].concat(options.endsWith || []).map($fc9cbd67eb82ef3d$var$escapeString).concat('$').join('|');
    var route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for(var i = 0; i < tokens.length; i++){
        var token = tokens[i];
        if (typeof token === 'string') route += $fc9cbd67eb82ef3d$var$escapeString(token);
        else {
            var capture = token.repeat ? '(?:' + token.pattern + ')(?:' + $fc9cbd67eb82ef3d$var$escapeString(token.delimiter) + '(?:' + token.pattern + '))*' : token.pattern;
            if (keys) keys.push(token);
            if (token.optional) {
                if (!token.prefix) route += '(' + capture + ')?';
                else route += '(?:' + $fc9cbd67eb82ef3d$var$escapeString(token.prefix) + '(' + capture + '))?';
            } else route += $fc9cbd67eb82ef3d$var$escapeString(token.prefix) + '(' + capture + ')';
        }
    }
    if (end) {
        if (!strict) route += '(?:' + $fc9cbd67eb82ef3d$var$escapeString(delimiter) + ')?';
        route += endsWith === '$' ? '$' : '(?=' + endsWith + ')';
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === 'string' ? endToken[endToken.length - 1] === delimiter : endToken === undefined;
        if (!strict) route += '(?:' + $fc9cbd67eb82ef3d$var$escapeString(delimiter) + '(?=' + endsWith + '))?';
        if (!isEndDelimited) route += '(?=' + $fc9cbd67eb82ef3d$var$escapeString(delimiter) + '|' + endsWith + ')';
    }
    return new RegExp(route, $fc9cbd67eb82ef3d$var$flags(options));
}
/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {Array=}                keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */ function $fc9cbd67eb82ef3d$var$pathToRegexp(path, keys, options) {
    if (path instanceof RegExp) return $fc9cbd67eb82ef3d$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $fc9cbd67eb82ef3d$var$arrayToRegexp(/** @type {!Array} */ path, keys, options);
    return $fc9cbd67eb82ef3d$var$stringToRegexp(/** @type {string} */ path, keys, options);
}

});

parcelRegister("4GeA1", function(module, exports) {
$parcel$export(module.exports, "keyframes", () => $368664f107b84b9d$export$d25ddfdf17c3ad3e);
$parcel$export(module.exports, "ThemeContext", () => (parcelRequire("dc9Ya")).T);
$parcel$export(module.exports, "withEmotionCache", () => (parcelRequire("dc9Ya")).w);
$parcel$export(module.exports, "css", () => (parcelRequire("7U2XI")).default);

var $cvqF7 = parcelRequire("cvqF7");

var $euxye = parcelRequire("euxye");
parcelRequire("4rbcs");

var $dc9Ya = parcelRequire("dc9Ya");

var $hzIUI = parcelRequire("hzIUI");

var $61HZV = parcelRequire("61HZV");

var $5UmqJ = parcelRequire("5UmqJ");

var $7U2XI = parcelRequire("7U2XI");
var $368664f107b84b9d$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $dc9Ya.h).call(props, 'css')) // $FlowFixMe
    return (0, $euxye.createElement).apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $dc9Ya.E);
    createElementArgArray[1] = (0, $dc9Ya.c)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return (0, $euxye.createElement).apply(null, createElementArgArray);
};
var $368664f107b84b9d$var$warnedAboutCssPropForGlobal = false;
var $368664f107b84b9d$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $dc9Ya.w)(function(props, cache) {
    var styles = props.styles;
    if (typeof styles === 'function') return /*#__PURE__*/ (0, $euxye.createElement)((0, $dc9Ya.T).Consumer, null, function(theme) {
        var serialized = (0, $61HZV.serializeStyles)([
            styles(theme)
        ]);
        return /*#__PURE__*/ (0, $euxye.createElement)($368664f107b84b9d$var$InnerGlobal, {
            serialized: serialized,
            cache: cache
        });
    });
    var serialized = (0, $61HZV.serializeStyles)([
        styles
    ]);
    return /*#__PURE__*/ (0, $euxye.createElement)($368664f107b84b9d$var$InnerGlobal, {
        serialized: serialized,
        cache: cache
    });
});
// maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $368664f107b84b9d$var$InnerGlobal = /*#__PURE__*/ function(_React$Component) {
    (0, $cvqF7.default)(InnerGlobal, _React$Component);
    function InnerGlobal(props, context, updater) {
        return _React$Component.call(this, props, context, updater) || this;
    }
    var _proto = InnerGlobal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.sheet = new (0, $5UmqJ.StyleSheet)({
            key: this.props.cache.key + "-global",
            nonce: this.props.cache.sheet.nonce,
            container: this.props.cache.sheet.container
        }); // $FlowFixMe
        var node = document.querySelector("style[data-emotion-" + this.props.cache.key + "=\"" + this.props.serialized.name + "\"]");
        if (node !== null) this.sheet.tags.push(node);
        if (this.props.cache.sheet.tags.length) this.sheet.before = this.props.cache.sheet.tags[0];
        this.insertStyles();
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (prevProps.serialized.name !== this.props.serialized.name) this.insertStyles();
    };
    _proto.insertStyles = function insertStyles$1() {
        if (this.props.serialized.next !== undefined) // insert keyframes
        (0, $hzIUI.insertStyles)(this.props.cache, this.props.serialized.next, true);
        if (this.sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = this.sheet.tags[this.sheet.tags.length - 1].nextElementSibling;
            this.sheet.before = element;
            this.sheet.flush();
        }
        this.props.cache.insert("", this.props.serialized, this.sheet, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.sheet.flush();
    };
    _proto.render = function render() {
        return null;
    };
    return InnerGlobal;
}((0, $euxye.Component));
var $368664f107b84b9d$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = (0, $7U2XI.default).apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $368664f107b84b9d$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $368664f107b84b9d$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $hzIUI.getRegisteredStyles)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $368664f107b84b9d$var$Noop = function Noop() {
    return null;
};
var $368664f107b84b9d$export$9b9c0f9d9f3552b8 = (0, $dc9Ya.w)(function(props, context) {
    return /*#__PURE__*/ (0, $euxye.createElement)((0, $dc9Ya.T).Consumer, null, function(theme) {
        var hasRendered = false;
        var css = function css() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            var serialized = (0, $61HZV.serializeStyles)(args, context.registered);
            (0, $hzIUI.insertStyles)(context, serialized, false);
            return context.key + "-" + serialized.name;
        };
        var cx = function cx() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return $368664f107b84b9d$var$merge(context.registered, css, $368664f107b84b9d$var$classnames(args));
        };
        var content = {
            css: css,
            cx: cx,
            theme: theme
        };
        var ele = props.children(content);
        hasRendered = true;
        var possiblyStyleElement = /*#__PURE__*/ (0, $euxye.createElement)($368664f107b84b9d$var$Noop, null);
        return /*#__PURE__*/ (0, $euxye.createElement)((0, $euxye.Fragment), null, possiblyStyleElement, ele);
    });
});

});
parcelRegister("4rbcs", function(module, exports) {
$parcel$export(module.exports, "default", () => $33b25f227bf9c66e$export$2e2bcd8739ae039);

var $5UmqJ = parcelRequire("5UmqJ");

var $bBBBX = parcelRequire("bBBBX");
parcelRequire("7GMcx");
// https://github.com/thysultan/stylis.js/tree/master/plugins/rule-sheet
// inlined to avoid umd wrapper and peerDep warnings/installing stylis
// since we use stylis after closure compiler
var $33b25f227bf9c66e$var$delimiter = '/*|*/';
var $33b25f227bf9c66e$var$needle = $33b25f227bf9c66e$var$delimiter + '}';
function $33b25f227bf9c66e$var$toSheet(block) {
    if (block) $33b25f227bf9c66e$var$Sheet.current.insert(block + '}');
}
var $33b25f227bf9c66e$var$Sheet = {
    current: null
};
var $33b25f227bf9c66e$var$ruleSheet = function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
    switch(context){
        // property
        case 1:
            switch(content.charCodeAt(0)){
                case 64:
                    // @import
                    $33b25f227bf9c66e$var$Sheet.current.insert(content + ';');
                    return '';
                // charcode for l
                case 108:
                    // charcode for b
                    // this ignores label
                    if (content.charCodeAt(2) === 98) return '';
            }
            break;
        // selector
        case 2:
            if (ns === 0) return content + $33b25f227bf9c66e$var$delimiter;
            break;
        // at-rule
        case 3:
            switch(ns){
                // @font-face, @page
                case 102:
                case 112:
                    $33b25f227bf9c66e$var$Sheet.current.insert(selectors[0] + content);
                    return '';
                default:
                    return content + (at === 0 ? $33b25f227bf9c66e$var$delimiter : '');
            }
        case -2:
            content.split($33b25f227bf9c66e$var$needle).forEach($33b25f227bf9c66e$var$toSheet);
    }
};
var $33b25f227bf9c66e$var$createCache = function createCache(options) {
    if (options === undefined) options = {};
    var key = options.key || 'css';
    var stylisOptions;
    if (options.prefix !== undefined) stylisOptions = {
        prefix: options.prefix
    };
    var stylis = new (0, $bBBBX.default)(stylisOptions);
    var inserted = {}; // $FlowFixMe
    var container;
    container = options.container || document.head;
    var nodes = document.querySelectorAll("style[data-emotion-" + key + "]");
    Array.prototype.forEach.call(nodes, function(node) {
        var attrib = node.getAttribute("data-emotion-" + key); // $FlowFixMe
        attrib.split(' ').forEach(function(id) {
            inserted[id] = true;
        });
        if (node.parentNode !== container) container.appendChild(node);
    });
    var _insert;
    stylis.use(options.stylisPlugins)($33b25f227bf9c66e$var$ruleSheet);
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        var name = serialized.name;
        $33b25f227bf9c66e$var$Sheet.current = sheet;
        var map;
        stylis(selector, serialized.styles);
        if (shouldCache) cache.inserted[name] = true;
    };
    var commentStart, commentEnd;
    var cache = {
        key: key,
        sheet: new (0, $5UmqJ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    return cache;
};
var $33b25f227bf9c66e$export$2e2bcd8739ae039 = $33b25f227bf9c66e$var$createCache;

});
parcelRegister("5UmqJ", function(module, exports) {
$parcel$export(module.exports, "StyleSheet", () => $44d394da84817538$export$9d753cd7ae895cce);
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $44d394da84817538$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $44d394da84817538$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $44d394da84817538$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($44d394da84817538$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $44d394da84817538$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();

});

parcelRegister("bBBBX", function(module, exports) {
$parcel$export(module.exports, "default", () => $87305338fbffba26$export$2e2bcd8739ae039);
function $87305338fbffba26$var$stylis_min(W) {
    function M(d, c, e, h, a) {
        for(var m = 0, b = 0, v = 0, n = 0, q, g, x = 0, K = 0, k, u = k = q = 0, l = 0, r = 0, I = 0, t = 0, B = e.length, J = B - 1, y, f = '', p = '', F = '', G = '', C; l < B;){
            g = e.charCodeAt(l);
            l === J && 0 !== b + n + v + m && (0 !== b && (g = 47 === b ? 10 : 47), n = v = m = 0, B++, J++);
            if (0 === b + n + v + m) {
                if (l === J && (0 < r && (f = f.replace(N, '')), 0 < f.trim().length)) {
                    switch(g){
                        case 32:
                        case 9:
                        case 59:
                        case 13:
                        case 10:
                            break;
                        default:
                            f += e.charAt(l);
                    }
                    g = 59;
                }
                switch(g){
                    case 123:
                        f = f.trim();
                        q = f.charCodeAt(0);
                        k = 1;
                        for(t = ++l; l < B;){
                            switch(g = e.charCodeAt(l)){
                                case 123:
                                    k++;
                                    break;
                                case 125:
                                    k--;
                                    break;
                                case 47:
                                    switch(g = e.charCodeAt(l + 1)){
                                        case 42:
                                        case 47:
                                            a: {
                                                for(u = l + 1; u < J; ++u)switch(e.charCodeAt(u)){
                                                    case 47:
                                                        if (42 === g && 42 === e.charCodeAt(u - 1) && l + 2 !== u) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                        break;
                                                    case 10:
                                                        if (47 === g) {
                                                            l = u + 1;
                                                            break a;
                                                        }
                                                }
                                                l = u;
                                            }
                                    }
                                    break;
                                case 91:
                                    g++;
                                case 40:
                                    g++;
                                case 34:
                                case 39:
                                    for(; l++ < J && e.charCodeAt(l) !== g;);
                            }
                            if (0 === k) break;
                            l++;
                        }
                        k = e.substring(t, l);
                        0 === q && (q = (f = f.replace(ca, '').trim()).charCodeAt(0));
                        switch(q){
                            case 64:
                                0 < r && (f = f.replace(N, ''));
                                g = f.charCodeAt(1);
                                switch(g){
                                    case 100:
                                    case 109:
                                    case 115:
                                    case 45:
                                        r = c;
                                        break;
                                    default:
                                        r = O;
                                }
                                k = M(c, r, k, g, a + 1);
                                t = k.length;
                                0 < A && (r = X(O, f, I), C = H(3, k, r, c, D, z, t, g, a, h), f = r.join(''), void 0 !== C && 0 === (t = (k = C.trim()).length) && (g = 0, k = ''));
                                if (0 < t) switch(g){
                                    case 115:
                                        f = f.replace(da, ea);
                                    case 100:
                                    case 109:
                                    case 45:
                                        k = f + '{' + k + '}';
                                        break;
                                    case 107:
                                        f = f.replace(fa, '$1 $2');
                                        k = f + '{' + k + '}';
                                        k = 1 === w || 2 === w && L('@' + k, 3) ? '@-webkit-' + k + '@' + k : '@' + k;
                                        break;
                                    default:
                                        k = f + k, 112 === h && (k = (p += k, ''));
                                }
                                else k = '';
                                break;
                            default:
                                k = M(c, X(c, f, I), k, h, a + 1);
                        }
                        F += k;
                        k = I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                        break;
                    case 125:
                    case 59:
                        f = (0 < r ? f.replace(N, '') : f).trim();
                        if (1 < (t = f.length)) switch(0 === u && (q = f.charCodeAt(0), 45 === q || 96 < q && 123 > q) && (t = (f = f.replace(' ', ':')).length), 0 < A && void 0 !== (C = H(1, f, c, d, D, z, p.length, h, a, h)) && 0 === (t = (f = C.trim()).length) && (f = '\x00\x00'), q = f.charCodeAt(0), g = f.charCodeAt(1), q){
                            case 0:
                                break;
                            case 64:
                                if (105 === g || 99 === g) {
                                    G += f + e.charAt(l);
                                    break;
                                }
                            default:
                                58 !== f.charCodeAt(t - 1) && (p += P(f, q, g, f.charCodeAt(2)));
                        }
                        I = r = u = q = 0;
                        f = '';
                        g = e.charCodeAt(++l);
                }
            }
            switch(g){
                case 13:
                case 10:
                    47 === b ? b = 0 : 0 === 1 + q && 107 !== h && 0 < f.length && (r = 1, f += '\x00');
                    0 < A * Y && H(0, f, c, d, D, z, p.length, h, a, h);
                    z = 1;
                    D++;
                    break;
                case 59:
                case 125:
                    if (0 === b + n + v + m) {
                        z++;
                        break;
                    }
                default:
                    z++;
                    y = e.charAt(l);
                    switch(g){
                        case 9:
                        case 32:
                            if (0 === n + m + b) switch(x){
                                case 44:
                                case 58:
                                case 9:
                                case 32:
                                    y = '';
                                    break;
                                default:
                                    32 !== g && (y = ' ');
                            }
                            break;
                        case 0:
                            y = '\\0';
                            break;
                        case 12:
                            y = '\\f';
                            break;
                        case 11:
                            y = '\\v';
                            break;
                        case 38:
                            0 === n + b + m && (r = I = 1, y = '\f' + y);
                            break;
                        case 108:
                            if (0 === n + b + m + E && 0 < u) switch(l - u){
                                case 2:
                                    112 === x && 58 === e.charCodeAt(l - 3) && (E = x);
                                case 8:
                                    111 === K && (E = K);
                            }
                            break;
                        case 58:
                            0 === n + b + m && (u = l);
                            break;
                        case 44:
                            0 === b + v + n + m && (r = 1, y += '\r');
                            break;
                        case 34:
                        case 39:
                            0 === b && (n = n === g ? 0 : 0 === n ? g : n);
                            break;
                        case 91:
                            0 === n + b + v && m++;
                            break;
                        case 93:
                            0 === n + b + v && m--;
                            break;
                        case 41:
                            0 === n + b + m && v--;
                            break;
                        case 40:
                            if (0 === n + b + m) {
                                if (0 === q) switch(2 * x + 3 * K){
                                    case 533:
                                        break;
                                    default:
                                        q = 1;
                                }
                                v++;
                            }
                            break;
                        case 64:
                            0 === b + v + n + m + u + k && (k = 1);
                            break;
                        case 42:
                        case 47:
                            if (!(0 < n + m + v)) switch(b){
                                case 0:
                                    switch(2 * g + 3 * e.charCodeAt(l + 1)){
                                        case 235:
                                            b = 47;
                                            break;
                                        case 220:
                                            t = l, b = 42;
                                    }
                                    break;
                                case 42:
                                    47 === g && 42 === x && t + 2 !== l && (33 === e.charCodeAt(t + 2) && (p += e.substring(t, l + 1)), y = '', b = 0);
                            }
                    }
                    0 === b && (f += y);
            }
            K = x;
            x = g;
            l++;
        }
        t = p.length;
        if (0 < t) {
            r = c;
            if (0 < A && (C = H(2, p, r, d, D, z, t, h, a, h), void 0 !== C && 0 === (p = C).length)) return G + p + F;
            p = r.join(',') + '{' + p + '}';
            if (0 !== w * E) {
                2 !== w || L(p, 2) || (E = 0);
                switch(E){
                    case 111:
                        p = p.replace(ha, ':-moz-$1') + p;
                        break;
                    case 112:
                        p = p.replace(Q, '::-webkit-input-$1') + p.replace(Q, '::-moz-$1') + p.replace(Q, ':-ms-input-$1') + p;
                }
                E = 0;
            }
        }
        return G + p + F;
    }
    function X(d, c, e) {
        var h = c.trim().split(ia);
        c = h;
        var a = h.length, m = d.length;
        switch(m){
            case 0:
            case 1:
                var b = 0;
                for(d = 0 === m ? '' : d[0] + ' '; b < a; ++b)c[b] = Z(d, c[b], e).trim();
                break;
            default:
                var v = b = 0;
                for(c = []; b < a; ++b)for(var n = 0; n < m; ++n)c[v++] = Z(d[n] + ' ', h[b], e).trim();
        }
        return c;
    }
    function Z(d, c, e) {
        var h = c.charCodeAt(0);
        33 > h && (h = (c = c.trim()).charCodeAt(0));
        switch(h){
            case 38:
                return c.replace(F, '$1' + d.trim());
            case 58:
                return d.trim() + c.replace(F, '$1' + d.trim());
            default:
                if (0 < 1 * e && 0 < c.indexOf('\f')) return c.replace(F, (58 === d.charCodeAt(0) ? '' : '$1') + d.trim());
        }
        return d + c;
    }
    function P(d, c, e, h) {
        var a = d + ';', m = 2 * c + 3 * e + 4 * h;
        if (944 === m) {
            d = a.indexOf(':', 9) + 1;
            var b = a.substring(d, a.length - 1).trim();
            b = a.substring(0, d).trim() + b + ';';
            return 1 === w || 2 === w && L(b, 1) ? '-webkit-' + b + b : b;
        }
        if (0 === w || 2 === w && !L(a, 1)) return a;
        switch(m){
            case 1015:
                return 97 === a.charCodeAt(10) ? '-webkit-' + a + a : a;
            case 951:
                return 116 === a.charCodeAt(3) ? '-webkit-' + a + a : a;
            case 963:
                return 110 === a.charCodeAt(5) ? '-webkit-' + a + a : a;
            case 1009:
                if (100 !== a.charCodeAt(4)) break;
            case 969:
            case 942:
                return '-webkit-' + a + a;
            case 978:
                return '-webkit-' + a + '-moz-' + a + a;
            case 1019:
            case 983:
                return '-webkit-' + a + '-moz-' + a + '-ms-' + a + a;
            case 883:
                if (45 === a.charCodeAt(8)) return '-webkit-' + a + a;
                if (0 < a.indexOf('image-set(', 11)) return a.replace(ja, '$1-webkit-$2') + a;
                break;
            case 932:
                if (45 === a.charCodeAt(4)) switch(a.charCodeAt(5)){
                    case 103:
                        return '-webkit-box-' + a.replace('-grow', '') + '-webkit-' + a + '-ms-' + a.replace('grow', 'positive') + a;
                    case 115:
                        return '-webkit-' + a + '-ms-' + a.replace('shrink', 'negative') + a;
                    case 98:
                        return '-webkit-' + a + '-ms-' + a.replace('basis', 'preferred-size') + a;
                }
                return '-webkit-' + a + '-ms-' + a + a;
            case 964:
                return '-webkit-' + a + '-ms-flex-' + a + a;
            case 1023:
                if (99 !== a.charCodeAt(8)) break;
                b = a.substring(a.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return '-webkit-box-pack' + b + '-webkit-' + a + '-ms-flex-pack' + b + a;
            case 1005:
                return ka.test(a) ? a.replace(aa, ':-webkit-') + a.replace(aa, ':-moz-') + a : a;
            case 1e3:
                b = a.substring(13).trim();
                c = b.indexOf('-') + 1;
                switch(b.charCodeAt(0) + b.charCodeAt(c)){
                    case 226:
                        b = a.replace(G, 'tb');
                        break;
                    case 232:
                        b = a.replace(G, 'tb-rl');
                        break;
                    case 220:
                        b = a.replace(G, 'lr');
                        break;
                    default:
                        return a;
                }
                return '-webkit-' + a + '-ms-' + b + a;
            case 1017:
                if (-1 === a.indexOf('sticky', 9)) break;
            case 975:
                c = (a = d).length - 10;
                b = (33 === a.charCodeAt(c) ? a.substring(0, c) : a).substring(d.indexOf(':', 7) + 1).trim();
                switch(m = b.charCodeAt(0) + (b.charCodeAt(7) | 0)){
                    case 203:
                        if (111 > b.charCodeAt(8)) break;
                    case 115:
                        a = a.replace(b, '-webkit-' + b) + ';' + a;
                        break;
                    case 207:
                    case 102:
                        a = a.replace(b, '-webkit-' + (102 < m ? 'inline-' : '') + 'box') + ';' + a.replace(b, '-webkit-' + b) + ';' + a.replace(b, '-ms-' + b + 'box') + ';' + a;
                }
                return a + ';';
            case 938:
                if (45 === a.charCodeAt(5)) switch(a.charCodeAt(6)){
                    case 105:
                        return b = a.replace('-items', ''), '-webkit-' + a + '-webkit-box-' + b + '-ms-flex-' + b + a;
                    case 115:
                        return '-webkit-' + a + '-ms-flex-item-' + a.replace(ba, '') + a;
                    default:
                        return '-webkit-' + a + '-ms-flex-line-pack' + a.replace('align-content', '').replace(ba, '') + a;
                }
                break;
            case 973:
            case 989:
                if (45 !== a.charCodeAt(3) || 122 === a.charCodeAt(4)) break;
            case 931:
            case 953:
                if (!0 === la.test(d)) return 115 === (b = d.substring(d.indexOf(':') + 1)).charCodeAt(0) ? P(d.replace('stretch', 'fill-available'), c, e, h).replace(':fill-available', ':stretch') : a.replace(b, '-webkit-' + b) + a.replace(b, '-moz-' + b.replace('fill-', '')) + a;
                break;
            case 962:
                if (a = '-webkit-' + a + (102 === a.charCodeAt(5) ? '-ms-' + a : '') + a, 211 === e + h && 105 === a.charCodeAt(13) && 0 < a.indexOf('transform', 10)) return a.substring(0, a.indexOf(';', 27) + 1).replace(ma, '$1-webkit-$2') + a;
        }
        return a;
    }
    function L(d, c) {
        var e = d.indexOf(1 === c ? ':' : '{'), h = d.substring(0, 3 !== c ? e : 10);
        e = d.substring(e + 1, d.length - 1);
        return R(2 !== c ? h : h.replace(na, '$1'), e, c);
    }
    function ea(d, c) {
        var e = P(c, c.charCodeAt(0), c.charCodeAt(1), c.charCodeAt(2));
        return e !== c + ';' ? e.replace(oa, ' or ($1)').substring(4) : '(' + c + ')';
    }
    function H(d, c, e, h, a, m, b, v, n, q) {
        for(var g = 0, x = c, w; g < A; ++g)switch(w = S[g].call(B, d, x, e, h, a, m, b, v, n, q)){
            case void 0:
            case !1:
            case !0:
            case null:
                break;
            default:
                x = w;
        }
        if (x !== c) return x;
    }
    function T(d) {
        switch(d){
            case void 0:
            case null:
                A = S.length = 0;
                break;
            default:
                if ('function' === typeof d) S[A++] = d;
                else if ('object' === typeof d) for(var c = 0, e = d.length; c < e; ++c)T(d[c]);
                else Y = !!d | 0;
        }
        return T;
    }
    function U(d) {
        d = d.prefix;
        void 0 !== d && (R = null, d ? 'function' !== typeof d ? w = 1 : (w = 2, R = d) : w = 0);
        return U;
    }
    function B(d, c) {
        var e = d;
        33 > e.charCodeAt(0) && (e = e.trim());
        V = e;
        e = [
            V
        ];
        if (0 < A) {
            var h = H(-1, c, e, e, D, z, 0, 0, 0, 0);
            void 0 !== h && 'string' === typeof h && (c = h);
        }
        var a = M(O, e, c, 0, 0);
        0 < A && (h = H(-2, a, e, e, D, z, a.length, 0, 0, 0), void 0 !== h && (a = h));
        V = '';
        E = 0;
        z = D = 1;
        return a;
    }
    var ca = /^\0+/g, N = /[\0\r\f]/g, aa = /: */g, ka = /zoo|gra/, ma = /([,: ])(transform)/g, ia = /,\r+?/g, F = /([\t\r\n ])*\f?&/g, fa = /@(k\w+)\s*(\S*)\s*/, Q = /::(place)/g, ha = /:(read-only)/g, G = /[svh]\w+-[tblr]{2}/, da = /\(\s*(.*)\s*\)/g, oa = /([\s\S]*?);/g, ba = /-self|flex-/g, na = /[^]*?(:[rp][el]a[\w-]+)[^]*/, la = /stretch|:\s*\w+\-(?:conte|avail)/, ja = /([^-])(image-set\()/, z = 1, D = 1, E = 0, w = 1, O = [], S = [], A = 0, R = null, Y = 0, V = '';
    B.use = T;
    B.set = U;
    void 0 !== W && U(W);
    return B;
}
var $87305338fbffba26$export$2e2bcd8739ae039 = $87305338fbffba26$var$stylis_min;

});

parcelRegister("7GMcx", function(module, exports) {
var $5991d8647174f801$var$weakMemoize = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};
var $5991d8647174f801$export$2e2bcd8739ae039 = $5991d8647174f801$var$weakMemoize;

});


parcelRegister("dc9Ya", function(module, exports) {
$parcel$export(module.exports, "h", () => $99b42117a98431a7$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "T", () => $99b42117a98431a7$export$971d5caa766a69d7);
$parcel$export(module.exports, "w", () => $99b42117a98431a7$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "c", () => $99b42117a98431a7$export$db3b6bfb95261072);
$parcel$export(module.exports, "E", () => $99b42117a98431a7$export$a9c23c6ac3fc3eca);
parcelRequire("cvqF7");

var $euxye = parcelRequire("euxye");

var $4rbcs = parcelRequire("4rbcs");

var $hzIUI = parcelRequire("hzIUI");

var $61HZV = parcelRequire("61HZV");
var $99b42117a98431a7$export$dda1d9f60106f0e9 = Object.prototype.hasOwnProperty;
var $99b42117a98431a7$var$EmotionCacheContext = /*#__PURE__*/ (0, $euxye.createContext)(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? (0, $4rbcs.default)() : null);
var $99b42117a98431a7$export$971d5caa766a69d7 = /*#__PURE__*/ (0, $euxye.createContext)({});
var $99b42117a98431a7$export$e7094788287c5e9b = $99b42117a98431a7$var$EmotionCacheContext.Provider;
var $99b42117a98431a7$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    var render = function render(props, ref) {
        return /*#__PURE__*/ (0, $euxye.createElement)($99b42117a98431a7$var$EmotionCacheContext.Consumer, null, function(cache) {
            return func(props, cache, ref);
        });
    }; // $FlowFixMe
    return /*#__PURE__*/ (0, $euxye.forwardRef)(render);
};
// thus we only need to replace what is a valid character for JS, but not for CSS
var $99b42117a98431a7$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $99b42117a98431a7$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $99b42117a98431a7$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $99b42117a98431a7$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($99b42117a98431a7$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$99b42117a98431a7$var$typePropName] = type; // TODO: check if this still works with all of those different JSX functions
    var error, match;
    return newProps;
};
var $99b42117a98431a7$var$Noop = function Noop() {
    return null;
};
var $99b42117a98431a7$var$render = function render(cache, props, theme, ref) {
    var cssProp = theme === null ? props.css : props.css(theme); // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var type = props[$99b42117a98431a7$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $hzIUI.getRegisteredStyles)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $61HZV.serializeStyles)(registeredStyles);
    var labelFromStack;
    var rules = (0, $hzIUI.insertStyles)(cache, serialized, typeof type === 'string');
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($99b42117a98431a7$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $99b42117a98431a7$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    var ele = /*#__PURE__*/ (0, $euxye.createElement)(type, newProps);
    var possiblyStyleElement = /*#__PURE__*/ (0, $euxye.createElement)($99b42117a98431a7$var$Noop, null);
    return /*#__PURE__*/ (0, $euxye.createElement)((0, $euxye.Fragment), null, possiblyStyleElement, ele);
}; // eslint-disable-next-line no-undef
var $99b42117a98431a7$export$a9c23c6ac3fc3eca = /* #__PURE__ */ $99b42117a98431a7$export$efccba1c4a2ef57b(function(props, cache, ref) {
    if (typeof props.css === 'function') return /*#__PURE__*/ (0, $euxye.createElement)($99b42117a98431a7$export$971d5caa766a69d7.Consumer, null, function(theme) {
        return $99b42117a98431a7$var$render(cache, props, theme, ref);
    });
    return $99b42117a98431a7$var$render(cache, props, null, ref);
});

});
parcelRegister("hzIUI", function(module, exports) {
$parcel$export(module.exports, "getRegisteredStyles", () => $ccb88b817c280bc6$export$95d99596f328fd52);
$parcel$export(module.exports, "insertStyles", () => $ccb88b817c280bc6$export$6f077d94b33a01aa);
var $ccb88b817c280bc6$var$isBrowser = true;
function $ccb88b817c280bc6$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className]);
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $ccb88b817c280bc6$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $ccb88b817c280bc6$var$isBrowser === false && cache.compat !== undefined) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            var maybeStyles = cache.insert("." + className, current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};

});

parcelRegister("61HZV", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $4634f71c312a0e97$export$6321afa313b251b5);

var $aGugY = parcelRequire("aGugY");

var $7OPem = parcelRequire("7OPem");

var $gmIOi = parcelRequire("gmIOi");
var $4634f71c312a0e97$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $4634f71c312a0e97$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $4634f71c312a0e97$var$hyphenateRegex = /[A-Z]|^ms/g;
var $4634f71c312a0e97$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $4634f71c312a0e97$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $4634f71c312a0e97$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $4634f71c312a0e97$var$processStyleName = (0, $gmIOi.default)(function(styleName) {
    return $4634f71c312a0e97$var$isCustomProperty(styleName) ? styleName : styleName.replace($4634f71c312a0e97$var$hyphenateRegex, '-$&').toLowerCase();
});
var $4634f71c312a0e97$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($4634f71c312a0e97$var$animationRegex, function(match, p1, p2) {
                $4634f71c312a0e97$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $4634f71c312a0e97$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7OPem.default)[key] !== 1 && !$4634f71c312a0e97$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $4634f71c312a0e97$var$contentValuePattern, $4634f71c312a0e97$var$contentValues, $4634f71c312a0e97$var$oldProcessStyleValue, $4634f71c312a0e97$var$msPattern, $4634f71c312a0e97$var$hyphenPattern, $4634f71c312a0e97$var$hyphenatedCache;
var $4634f71c312a0e97$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $4634f71c312a0e97$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $4634f71c312a0e97$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $4634f71c312a0e97$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $4634f71c312a0e97$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $4634f71c312a0e97$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $4634f71c312a0e97$var$cursor;
                var result = interpolation(mergedProps);
                $4634f71c312a0e97$var$cursor = previousCursor;
                return $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $4634f71c312a0e97$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($4634f71c312a0e97$var$isProcessableValue(value)) string += $4634f71c312a0e97$var$processStyleName(_key) + ":" + $4634f71c312a0e97$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($4634f71c312a0e97$var$isProcessableValue(value[_i])) string += $4634f71c312a0e97$var$processStyleName(_key) + ":" + $4634f71c312a0e97$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $4634f71c312a0e97$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $4634f71c312a0e97$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $4634f71c312a0e97$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $4634f71c312a0e97$var$cursor;
var $4634f71c312a0e97$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $4634f71c312a0e97$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $4634f71c312a0e97$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $4634f71c312a0e97$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $4634f71c312a0e97$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $aGugY.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $4634f71c312a0e97$var$cursor
    };
};

});
parcelRegister("aGugY", function(module, exports) {
$parcel$export(module.exports, "default", () => $7c754f2bbdbfe30b$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $7c754f2bbdbfe30b$var$murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
var $7c754f2bbdbfe30b$export$2e2bcd8739ae039 = $7c754f2bbdbfe30b$var$murmur2;

});

parcelRegister("7OPem", function(module, exports) {
$parcel$export(module.exports, "default", () => $5b14f13cc69ecc7e$export$2e2bcd8739ae039);
var $5b14f13cc69ecc7e$var$unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
var $5b14f13cc69ecc7e$export$2e2bcd8739ae039 = $5b14f13cc69ecc7e$var$unitlessKeys;

});

parcelRegister("gmIOi", function(module, exports) {
$parcel$export(module.exports, "default", () => $bea175cb9fac442c$export$2e2bcd8739ae039);
function $bea175cb9fac442c$var$memoize(fn) {
    var cache = {};
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}
var $bea175cb9fac442c$export$2e2bcd8739ae039 = $bea175cb9fac442c$var$memoize;

});



parcelRegister("7U2XI", function(module, exports) {
$parcel$export(module.exports, "default", () => $5c100f929f3ab226$export$2e2bcd8739ae039);

var $jlVUC = parcelRequire("jlVUC");
function $5c100f929f3ab226$var$css() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $jlVUC.serializeStyles)(args);
}
var $5c100f929f3ab226$export$2e2bcd8739ae039 = $5c100f929f3ab226$var$css;

});
parcelRegister("jlVUC", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $e16ce6a86028a026$export$6321afa313b251b5);

var $aGugY = parcelRequire("aGugY");

var $7OPem = parcelRequire("7OPem");

var $gmIOi = parcelRequire("gmIOi");
var $e16ce6a86028a026$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $e16ce6a86028a026$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $e16ce6a86028a026$var$hyphenateRegex = /[A-Z]|^ms/g;
var $e16ce6a86028a026$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $e16ce6a86028a026$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $e16ce6a86028a026$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $e16ce6a86028a026$var$processStyleName = (0, $gmIOi.default)(function(styleName) {
    return $e16ce6a86028a026$var$isCustomProperty(styleName) ? styleName : styleName.replace($e16ce6a86028a026$var$hyphenateRegex, '-$&').toLowerCase();
});
var $e16ce6a86028a026$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($e16ce6a86028a026$var$animationRegex, function(match, p1, p2) {
                $e16ce6a86028a026$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $e16ce6a86028a026$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7OPem.default)[key] !== 1 && !$e16ce6a86028a026$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $e16ce6a86028a026$var$contentValuePattern, $e16ce6a86028a026$var$contentValues, $e16ce6a86028a026$var$oldProcessStyleValue, $e16ce6a86028a026$var$msPattern, $e16ce6a86028a026$var$hyphenPattern, $e16ce6a86028a026$var$hyphenatedCache;
var $e16ce6a86028a026$var$shouldWarnAboutInterpolatingClassNameFromCss = true;
function $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, interpolation, couldBeSelectorInterpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $e16ce6a86028a026$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $e16ce6a86028a026$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $e16ce6a86028a026$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $e16ce6a86028a026$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $e16ce6a86028a026$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $e16ce6a86028a026$var$cursor;
                var result = interpolation(mergedProps);
                $e16ce6a86028a026$var$cursor = previousCursor;
                return $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, result, couldBeSelectorInterpolation);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined && !couldBeSelectorInterpolation ? cached : interpolation;
}
function $e16ce6a86028a026$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, obj[i], false);
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($e16ce6a86028a026$var$isProcessableValue(value)) string += $e16ce6a86028a026$var$processStyleName(_key) + ":" + $e16ce6a86028a026$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($e16ce6a86028a026$var$isProcessableValue(value[_i])) string += $e16ce6a86028a026$var$processStyleName(_key) + ":" + $e16ce6a86028a026$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, value, false);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $e16ce6a86028a026$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $e16ce6a86028a026$var$labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var $e16ce6a86028a026$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $e16ce6a86028a026$var$cursor;
var $e16ce6a86028a026$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $e16ce6a86028a026$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, strings, false);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $e16ce6a86028a026$var$handleInterpolation(mergedProps, registered, args[i], styles.charCodeAt(styles.length - 1) === 46);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $e16ce6a86028a026$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $e16ce6a86028a026$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $aGugY.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $e16ce6a86028a026$var$cursor
    };
};

});



parcelRegister("kwMul", function(module, exports) {
$parcel$export(module.exports, "connect", () => $c45e4ff92c60cfd4$export$64605811ab45167f);
$parcel$export(module.exports, "Provider8Wrapped", () => $c45e4ff92c60cfd4$export$a55ac1850eecafb9);
$parcel$export(module.exports, "Provider", () => $c45e4ff92c60cfd4$export$2881499e37b75b9a);
$parcel$export(module.exports, "createProvider", () => $c45e4ff92c60cfd4$export$500fbc0cd14cdbaa);
$parcel$export(module.exports, "useStore", () => (parcelRequire("f6mm4")).useStore);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("015iq")).useSelector);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("itMds")).useDispatch);
$parcel$export(module.exports, "extractFactoryFunction", () => (parcelRequire("7qI1K")).extractFactoryFunction);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => (parcelRequire("7qI1K")).mapStateToPropsWithErrorHandling);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");
parcelRequire("kd923");
var $iB0Id = parcelRequire("iB0Id");
var $ea8nr = parcelRequire("ea8nr");
var $itMds = parcelRequire("itMds");
var $015iq = parcelRequire("015iq");
var $f6mm4 = parcelRequire("f6mm4");

var $ikZXr = parcelRequire("ikZXr");

var $7qI1K = parcelRequire("7qI1K");

var $7qI1K = parcelRequire("7qI1K");
const $c45e4ff92c60cfd4$export$64605811ab45167f = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mapDispatchToProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
mergeProps, // eslint-disable-next-line @typescript-eslint/no-explicit-any
options = Object.freeze({}))=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>{
        const { context: context, storeKey: storeKey, forceV8: forceV8, skipStability: skipStability, ...restOptions } = options;
        const stabilizedMapping = skipStability ? mapStateToProps : (0, $ikZXr.withStability)(component, 'mapStateToProps', mapStateToProps);
        const stabilizedMergeProps = skipStability ? mergeProps : (0, $ikZXr.withStability)(component, 'mergeProps', mergeProps);
        const safeMapStateToProps = (0, $7qI1K.mapStateToPropsWithErrorHandling)(stabilizedMapping);
        const ResultComponent = (0, $iB0Id.default)(safeMapStateToProps, mapDispatchToProps, stabilizedMergeProps, {
            context: context,
            ...restOptions
        })(component);
        ResultComponent.displayName = `Connect(${component.displayName || component.name || typeof component})`;
        return ResultComponent;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    };
const $c45e4ff92c60cfd4$export$a55ac1850eecafb9 = ({ store: store, children: children, context: context })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $ea8nr.default), {
        store: store,
        context: context
    }, children);
$c45e4ff92c60cfd4$export$a55ac1850eecafb9.displayName = "Provider8Wrapped";
const $c45e4ff92c60cfd4$export$2881499e37b75b9a = (0, $ea8nr.default);
const $c45e4ff92c60cfd4$var$makeWrappedProvider8 = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(context)=>(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($c45e4ff92c60cfd4$export$2881499e37b75b9a, {
            context: context,
            ...props
        });
const $c45e4ff92c60cfd4$export$500fbc0cd14cdbaa = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
context)=>$c45e4ff92c60cfd4$var$makeWrappedProvider8(context);

});
parcelRegister("kd923", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("iB0Id")).default);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("itMds")).createDispatchHook);
$parcel$export(module.exports, "Provider", () => (parcelRequire("ea8nr")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("itMds")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("015iq")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("f6mm4")).useStore);
// The primary entry point assumes we're working with standard ReactDOM/RN, but
// older versions that do not include `useSyncExternalStore` (React 16.9 - 17.x).
// Because of that, the useSyncExternalStore compat shim is needed.

var $4PfqE = parcelRequire("4PfqE");

var $gK5Py = parcelRequire("gK5Py");
parcelRequire("bmqB8");
var $85XPu = parcelRequire("85XPu");

var $bGfxz = parcelRequire("bGfxz");

var $015iq = parcelRequire("015iq");

var $iB0Id = parcelRequire("iB0Id");
parcelRequire("aJses");
(0, $015iq.initializeUseSelector)((0, $gK5Py.useSyncExternalStoreWithSelector));
(0, $iB0Id.initializeConnect)((0, $4PfqE.useSyncExternalStore)); // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)
(0, $bGfxz.setBatch)((0, $85XPu.unstable_batchedUpdates));

});
parcelRegister("bmqB8", function(module, exports) {
$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("85XPu")).unstable_batchedUpdates);

var $85XPu = parcelRequire("85XPu");

});

parcelRegister("bGfxz", function(module, exports) {
$parcel$export(module.exports, "setBatch", () => $880fabf52a092a60$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $880fabf52a092a60$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $880fabf52a092a60$var$defaultNoopBatch(callback) {
    callback();
}
let $880fabf52a092a60$var$batch = $880fabf52a092a60$var$defaultNoopBatch; // Allow injecting another batching function later
const $880fabf52a092a60$export$4b9874722d0da7bc = (newBatch)=>$880fabf52a092a60$var$batch = newBatch; // Supply a getter just to skip dealing with ESM bindings
const $880fabf52a092a60$export$fc47d4c0ba3bd2c6 = ()=>$880fabf52a092a60$var$batch;

});

parcelRegister("015iq", function(module, exports) {
$parcel$export(module.exports, "initializeUseSelector", () => $003433d4a5e8547c$export$e2e6e3f3f3b782e3);
$parcel$export(module.exports, "useSelector", () => $003433d4a5e8547c$export$2105062e25df4afe);

var $euxye = parcelRequire("euxye");

var $lOPQz = parcelRequire("lOPQz");

var $hR5da = parcelRequire("hR5da");

var $lp0HI = parcelRequire("lp0HI");
let $003433d4a5e8547c$var$useSyncExternalStoreWithSelector = (0, $lp0HI.notInitialized);
const $003433d4a5e8547c$export$e2e6e3f3f3b782e3 = (fn)=>{
    $003433d4a5e8547c$var$useSyncExternalStoreWithSelector = fn;
};
const $003433d4a5e8547c$var$refEquality = (a, b)=>a === b;
function $003433d4a5e8547c$export$2b53f90d2bd1cbfb(context = (0, $hR5da.ReactReduxContext)) {
    const useReduxContext = context === (0, $hR5da.ReactReduxContext) ? (0, $lOPQz.useReduxContext) : (0, $lOPQz.createReduxContextHook)(context);
    return function useSelector(selector, equalityFnOrOptions = {}) {
        const { equalityFn: equalityFn = $003433d4a5e8547c$var$refEquality, stabilityCheck: stabilityCheck, noopCheck: noopCheck } = typeof equalityFnOrOptions === 'function' ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: globalStabilityCheck, noopCheck: globalNoopCheck } = useReduxContext();
        const firstRun = (0, $euxye.useRef)(true);
        const wrappedSelector = (0, $euxye.useCallback)({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            globalStabilityCheck,
            stabilityCheck
        ]);
        const selectedState = $003433d4a5e8547c$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        (0, $euxye.useDebugValue)(selectedState);
        return selectedState;
    };
}
const $003433d4a5e8547c$export$2105062e25df4afe = /*#__PURE__*/ $003433d4a5e8547c$export$2b53f90d2bd1cbfb();

});
parcelRegister("lOPQz", function(module, exports) {
$parcel$export(module.exports, "createReduxContextHook", () => $04196519a73ef9df$export$d4d6226d5fc61558);
$parcel$export(module.exports, "useReduxContext", () => $04196519a73ef9df$export$c1275ca9a6fd3ec5);

var $euxye = parcelRequire("euxye");

var $hR5da = parcelRequire("hR5da");
function $04196519a73ef9df$export$d4d6226d5fc61558(context = (0, $hR5da.ReactReduxContext)) {
    return function useReduxContext() {
        const contextValue = (0, $euxye.useContext)(context);
        return contextValue;
    };
}
const $04196519a73ef9df$export$c1275ca9a6fd3ec5 = /*#__PURE__*/ $04196519a73ef9df$export$d4d6226d5fc61558();

});
parcelRegister("hR5da", function(module, exports) {
$parcel$export(module.exports, "ReactReduxContext", () => $cffb6dc38c7be6fd$export$cc80c08dc91f1c00);

var $euxye = parcelRequire("euxye");
const $cffb6dc38c7be6fd$var$ContextKey = Symbol.for(`react-redux-context`);
const $cffb6dc38c7be6fd$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $cffb6dc38c7be6fd$var$getContext() {
    var _gT$ContextKey;
    if (!$euxye.createContext) return {};
    const contextMap = (_gT$ContextKey = $cffb6dc38c7be6fd$var$gT[$cffb6dc38c7be6fd$var$ContextKey]) != null ? _gT$ContextKey : $cffb6dc38c7be6fd$var$gT[$cffb6dc38c7be6fd$var$ContextKey] = new Map();
    let realContext = contextMap.get($euxye.createContext);
    if (!realContext) {
        realContext = $euxye.createContext(null);
        contextMap.set($euxye.createContext, realContext);
    }
    return realContext;
}
const $cffb6dc38c7be6fd$export$cc80c08dc91f1c00 = /*#__PURE__*/ $cffb6dc38c7be6fd$var$getContext();
var $cffb6dc38c7be6fd$export$2e2bcd8739ae039 = $cffb6dc38c7be6fd$export$cc80c08dc91f1c00;

});


parcelRegister("lp0HI", function(module, exports) {
$parcel$export(module.exports, "notInitialized", () => $f94c7a9bb652aec9$export$20656a4825650bd0);
const $f94c7a9bb652aec9$export$20656a4825650bd0 = ()=>{
    throw new Error('uSES not initialized!');
};

});


parcelRegister("iB0Id", function(module, exports) {
$parcel$export(module.exports, "initializeConnect", () => $d89c3c18ecceced0$export$36d45daa6a4925b8);
$parcel$export(module.exports, "default", () => $d89c3c18ecceced0$export$2e2bcd8739ae039);

var $jimAf = parcelRequire("jimAf");

var $2rVEs = parcelRequire("2rVEs");

var $8hZ0d = parcelRequire("8hZ0d");

var $euxye = parcelRequire("euxye");

var $1wrBc = parcelRequire("1wrBc");

var $eSQDp = parcelRequire("eSQDp");

var $ccAvY = parcelRequire("ccAvY");

var $2P88M = parcelRequire("2P88M");

var $lV57j = parcelRequire("lV57j");

var $1aPa7 = parcelRequire("1aPa7");

var $9HOOw = parcelRequire("9HOOw");

var $9dW1o = parcelRequire("9dW1o");
parcelRequire("iboCO");

var $hR5da = parcelRequire("hR5da");

var $lp0HI = parcelRequire("lp0HI");
const $d89c3c18ecceced0$var$_excluded = [
    "reactReduxForwardedRef"
];
let $d89c3c18ecceced0$var$useSyncExternalStore = (0, $lp0HI.notInitialized);
const $d89c3c18ecceced0$export$36d45daa6a4925b8 = (fn)=>{
    $d89c3c18ecceced0$var$useSyncExternalStore = fn;
}; // Define some constant arrays just to avoid re-creating these
const $d89c3c18ecceced0$var$EMPTY_ARRAY = [
    null,
    0
];
const $d89c3c18ecceced0$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
]; // Attempts to stringify whatever not-really-a-component value we were given
// for logging in an error message
const $d89c3c18ecceced0$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
// This is "just" a `useLayoutEffect`, but with two modifications:
// - we need to fall back to `useEffect` in SSR to avoid annoying warnings
// - we extract this to a separate function to avoid closing over values
//   and causing memory leaks
function $d89c3c18ecceced0$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $9HOOw.useIsomorphicLayoutEffect)(()=>effectFunc(...effectArgs), dependencies);
} // Effect callback, extracted: assign the latest props values to refs for later usage
function $d89c3c18ecceced0$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
} // Effect callback, extracted: subscribe to the Redux store or nearest connected ancestor,
// check for updates after dispatched actions, and trigger re-renders.
function $d89c3c18ecceced0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return ()=>{}; // Capture values for checking if and when this component unmounts
    let didUnsubscribe = false;
    let lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
         // TODO We're currently calling getState ourselves here, rather than letting `uSES` do it
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // TODO This is hacky and not how `uSES` is meant to be used
            // Trigger the React `useSyncExternalStore` subscriber
            additionalSubscribeListener();
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
} // Reducer initial state creation for our update reducer
const $d89c3c18ecceced0$var$initStateUpdates = ()=>$d89c3c18ecceced0$var$EMPTY_ARRAY;
function $d89c3c18ecceced0$var$strictEqual(a, b) {
    return a === b;
}
/**
 * Infers the type of props that a connector will inject into a component.
 */ let $d89c3c18ecceced0$var$hasWarnedAboutDeprecatedPureOption = false;
/**
 * Connects a React component to a Redux store.
 *
 * - Without arguments, just wraps the component, without changing the behavior / props
 *
 * - If 2 params are passed (3rd param, mergeProps, is skipped), default behavior
 * is to override ownProps (as stated in the docs), so what remains is everything that's
 * not a state or dispatch prop
 *
 * - When 3rd param is passed, we don't know if ownProps propagate and whether they
 * should be valid component props, because it depends on mergeProps implementation.
 * As such, it is the user's responsibility to extend ownProps interface from state or
 * dispatch props or both when applicable
 *
 * @param mapStateToProps A function that extracts values from state
 * @param mapDispatchToProps Setup for dispatching actions
 * @param mergeProps Optional callback to merge state and dispatch props together
 * @param options Options for configuring the connection
 *
 */ function $d89c3c18ecceced0$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $d89c3c18ecceced0$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = (0, $9dW1o.default), areStatePropsEqual: areStatePropsEqual = (0, $9dW1o.default), areMergedPropsEqual: areMergedPropsEqual = (0, $9dW1o.default), forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = (0, $hR5da.ReactReduxContext) } = {}) {
    const Context = context;
    const initMapStateToProps = (0, $2P88M.mapStateToPropsFactory)(mapStateToProps);
    const initMapDispatchToProps = (0, $ccAvY.mapDispatchToPropsFactory)(mapDispatchToProps);
    const initMergeProps = (0, $lV57j.mergePropsFactory)(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $euxye.useMemo(()=>{
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                const { reactReduxForwardedRef: reactReduxForwardedRef } = props, wrapperProps = (0, $2rVEs.default)(props, $d89c3c18ecceced0$var$_excluded);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]);
            const ContextToUse = $euxye.useMemo(()=>{
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && // @ts-ignore
                (0, $1wrBc.isContextConsumer)(/*#__PURE__*/ $euxye.createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            const contextValue = $euxye.useContext(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $euxye.useMemo(()=>{
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return (0, $eSQDp.default)(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $euxye.useMemo(()=>{
                if (!shouldHandleStateChanges) return $d89c3c18ecceced0$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                const subscription = (0, $1aPa7.createSubscription)(store, didStoreComeFromProps ? undefined : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                const notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]); // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            const overriddenContextValue = $euxye.useMemo(()=>{
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $jimAf.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // Set up refs to coordinate values between the subscription effect and the render logic
            const lastChildProps = $euxye.useRef();
            const lastWrapperProps = $euxye.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $euxye.useRef();
            const renderIsScheduled = $euxye.useRef(false);
            const isProcessingDispatch = $euxye.useRef(false);
            const isMounted = $euxye.useRef(false);
            const latestSubscriptionCallbackError = $euxye.useRef();
            (0, $9HOOw.useIsomorphicLayoutEffect)(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $euxye.useMemo(()=>{
                const selector = ()=>{
                    // Tricky logic here:
                    // - This render may have been triggered by a Redux store update that produced new child props
                    // - However, we may have gotten new wrapper props after that
                    // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                    // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                    // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                     // TODO We're reading the store directly in render() here. Bad idea?
                    // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                    // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                    // to determine what the child props should be.
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            const subscribeForReact = $euxye.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $d89c3c18ecceced0$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $d89c3c18ecceced0$var$useIsomorphicLayoutEffectWithArgs($d89c3c18ecceced0$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $d89c3c18ecceced0$var$useSyncExternalStore(subscribeForReact, // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `\nThe error may be correlated with this previous error:\n${latestSubscriptionCallbackError.current.stack}\n\n`;
                throw err;
            }
            (0, $9HOOw.useIsomorphicLayoutEffect)(()=>{
                latestSubscriptionCallbackError.current = undefined;
                childPropsFromStoreUpdate.current = undefined;
                lastChildProps.current = actualChildProps;
            }); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            const renderedWrappedComponent = $euxye.useMemo(()=>{
                return(/*#__PURE__*/ // @ts-ignore
                $euxye.createElement(WrappedComponent, (0, $jimAf.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            const renderedChild = $euxye.useMemo(()=>{
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ $euxye.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $euxye.memo(ConnectFunction);
        // Add a hacky cast to get the right output type
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $euxye.forwardRef(function forwardConnectRef(props, ref) {
                // @ts-ignore
                return /*#__PURE__*/ $euxye.createElement(Connect, (0, $jimAf.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($8hZ0d)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($8hZ0d)))(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $d89c3c18ecceced0$export$2e2bcd8739ae039 = $d89c3c18ecceced0$var$connect;

});
parcelRegister("1wrBc", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4Fx6n"));

});
parcelRegister("4Fx6n", function(module, exports) {
$parcel$export(module.exports, "ContextConsumer", () => $3664ab19f4697bdd$export$a7c73072b1a182ae, (v) => $3664ab19f4697bdd$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $3664ab19f4697bdd$export$9f27bc3417b4524d, (v) => $3664ab19f4697bdd$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $3664ab19f4697bdd$export$db77ccec0bb4ccac, (v) => $3664ab19f4697bdd$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $3664ab19f4697bdd$export$8392c0c9d3dcbd35, (v) => $3664ab19f4697bdd$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $3664ab19f4697bdd$export$ffb0004e005737fa, (v) => $3664ab19f4697bdd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $3664ab19f4697bdd$export$b624eff549462981, (v) => $3664ab19f4697bdd$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $3664ab19f4697bdd$export$7897aa7841a5380c, (v) => $3664ab19f4697bdd$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $3664ab19f4697bdd$export$602eac185826482c, (v) => $3664ab19f4697bdd$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $3664ab19f4697bdd$export$e2c29f18771995cb, (v) => $3664ab19f4697bdd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $3664ab19f4697bdd$export$5f8d39834fd61797, (v) => $3664ab19f4697bdd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $3664ab19f4697bdd$export$74bf444e3cd11ea5, (v) => $3664ab19f4697bdd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "SuspenseList", () => $3664ab19f4697bdd$export$998bcd577473dd93, (v) => $3664ab19f4697bdd$export$998bcd577473dd93 = v);
$parcel$export(module.exports, "isAsyncMode", () => $3664ab19f4697bdd$export$92387174baf9b227, (v) => $3664ab19f4697bdd$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $3664ab19f4697bdd$export$ec112efeb987d9c6, (v) => $3664ab19f4697bdd$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $3664ab19f4697bdd$export$b706b080d889d2c9, (v) => $3664ab19f4697bdd$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $3664ab19f4697bdd$export$5be5a87408f70ddc, (v) => $3664ab19f4697bdd$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $3664ab19f4697bdd$export$45a5e7f76e0caa8d, (v) => $3664ab19f4697bdd$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $3664ab19f4697bdd$export$455c2e768291efa6, (v) => $3664ab19f4697bdd$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $3664ab19f4697bdd$export$9522e17588c12572, (v) => $3664ab19f4697bdd$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $3664ab19f4697bdd$export$2110ac352bb060b9, (v) => $3664ab19f4697bdd$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $3664ab19f4697bdd$export$56885ab8b9c456ab, (v) => $3664ab19f4697bdd$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $3664ab19f4697bdd$export$d927fcb6adf8f9de, (v) => $3664ab19f4697bdd$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $3664ab19f4697bdd$export$b82d16f27459e05a, (v) => $3664ab19f4697bdd$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $3664ab19f4697bdd$export$522c17b4f5e123e8, (v) => $3664ab19f4697bdd$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $3664ab19f4697bdd$export$1aabd8a0274ecfd6, (v) => $3664ab19f4697bdd$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isSuspenseList", () => $3664ab19f4697bdd$export$3d6c20d97e46b957, (v) => $3664ab19f4697bdd$export$3d6c20d97e46b957 = v);
$parcel$export(module.exports, "isValidElementType", () => $3664ab19f4697bdd$export$9b621391a187a31a, (v) => $3664ab19f4697bdd$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $3664ab19f4697bdd$export$f5bbd400c2f4426f, (v) => $3664ab19f4697bdd$export$f5bbd400c2f4426f = v);
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $3664ab19f4697bdd$export$a7c73072b1a182ae;
var $3664ab19f4697bdd$export$9f27bc3417b4524d;
var $3664ab19f4697bdd$export$db77ccec0bb4ccac;
var $3664ab19f4697bdd$export$8392c0c9d3dcbd35;
var $3664ab19f4697bdd$export$ffb0004e005737fa;
var $3664ab19f4697bdd$export$b624eff549462981;
var $3664ab19f4697bdd$export$7897aa7841a5380c;
var $3664ab19f4697bdd$export$602eac185826482c;
var $3664ab19f4697bdd$export$e2c29f18771995cb;
var $3664ab19f4697bdd$export$5f8d39834fd61797;
var $3664ab19f4697bdd$export$74bf444e3cd11ea5;
var $3664ab19f4697bdd$export$998bcd577473dd93;
var $3664ab19f4697bdd$export$92387174baf9b227;
var $3664ab19f4697bdd$export$ec112efeb987d9c6;
var $3664ab19f4697bdd$export$b706b080d889d2c9;
var $3664ab19f4697bdd$export$5be5a87408f70ddc;
var $3664ab19f4697bdd$export$45a5e7f76e0caa8d;
var $3664ab19f4697bdd$export$455c2e768291efa6;
var $3664ab19f4697bdd$export$9522e17588c12572;
var $3664ab19f4697bdd$export$2110ac352bb060b9;
var $3664ab19f4697bdd$export$56885ab8b9c456ab;
var $3664ab19f4697bdd$export$d927fcb6adf8f9de;
var $3664ab19f4697bdd$export$b82d16f27459e05a;
var $3664ab19f4697bdd$export$522c17b4f5e123e8;
var $3664ab19f4697bdd$export$1aabd8a0274ecfd6;
var $3664ab19f4697bdd$export$3d6c20d97e46b957;
var $3664ab19f4697bdd$export$9b621391a187a31a;
var $3664ab19f4697bdd$export$f5bbd400c2f4426f;
'use strict';
var $3664ab19f4697bdd$var$b = Symbol.for("react.element"), $3664ab19f4697bdd$var$c = Symbol.for("react.portal"), $3664ab19f4697bdd$var$d = Symbol.for("react.fragment"), $3664ab19f4697bdd$var$e = Symbol.for("react.strict_mode"), $3664ab19f4697bdd$var$f = Symbol.for("react.profiler"), $3664ab19f4697bdd$var$g = Symbol.for("react.provider"), $3664ab19f4697bdd$var$h = Symbol.for("react.context"), $3664ab19f4697bdd$var$k = Symbol.for("react.server_context"), $3664ab19f4697bdd$var$l = Symbol.for("react.forward_ref"), $3664ab19f4697bdd$var$m = Symbol.for("react.suspense"), $3664ab19f4697bdd$var$n = Symbol.for("react.suspense_list"), $3664ab19f4697bdd$var$p = Symbol.for("react.memo"), $3664ab19f4697bdd$var$q = Symbol.for("react.lazy"), $3664ab19f4697bdd$var$t = Symbol.for("react.offscreen"), $3664ab19f4697bdd$var$u;
$3664ab19f4697bdd$var$u = Symbol.for("react.module.reference");
function $3664ab19f4697bdd$var$v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case $3664ab19f4697bdd$var$b:
                switch(a = a.type, a){
                    case $3664ab19f4697bdd$var$d:
                    case $3664ab19f4697bdd$var$f:
                    case $3664ab19f4697bdd$var$e:
                    case $3664ab19f4697bdd$var$m:
                    case $3664ab19f4697bdd$var$n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $3664ab19f4697bdd$var$k:
                            case $3664ab19f4697bdd$var$h:
                            case $3664ab19f4697bdd$var$l:
                            case $3664ab19f4697bdd$var$q:
                            case $3664ab19f4697bdd$var$p:
                            case $3664ab19f4697bdd$var$g:
                                return a;
                            default:
                                return r;
                        }
                }
            case $3664ab19f4697bdd$var$c:
                return r;
        }
    }
}
$3664ab19f4697bdd$export$a7c73072b1a182ae = $3664ab19f4697bdd$var$h;
$3664ab19f4697bdd$export$9f27bc3417b4524d = $3664ab19f4697bdd$var$g;
$3664ab19f4697bdd$export$db77ccec0bb4ccac = $3664ab19f4697bdd$var$b;
$3664ab19f4697bdd$export$8392c0c9d3dcbd35 = $3664ab19f4697bdd$var$l;
$3664ab19f4697bdd$export$ffb0004e005737fa = $3664ab19f4697bdd$var$d;
$3664ab19f4697bdd$export$b624eff549462981 = $3664ab19f4697bdd$var$q;
$3664ab19f4697bdd$export$7897aa7841a5380c = $3664ab19f4697bdd$var$p;
$3664ab19f4697bdd$export$602eac185826482c = $3664ab19f4697bdd$var$c;
$3664ab19f4697bdd$export$e2c29f18771995cb = $3664ab19f4697bdd$var$f;
$3664ab19f4697bdd$export$5f8d39834fd61797 = $3664ab19f4697bdd$var$e;
$3664ab19f4697bdd$export$74bf444e3cd11ea5 = $3664ab19f4697bdd$var$m;
$3664ab19f4697bdd$export$998bcd577473dd93 = $3664ab19f4697bdd$var$n;
$3664ab19f4697bdd$export$92387174baf9b227 = function() {
    return !1;
};
$3664ab19f4697bdd$export$ec112efeb987d9c6 = function() {
    return !1;
};
$3664ab19f4697bdd$export$b706b080d889d2c9 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$h;
};
$3664ab19f4697bdd$export$5be5a87408f70ddc = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$g;
};
$3664ab19f4697bdd$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $3664ab19f4697bdd$var$b;
};
$3664ab19f4697bdd$export$455c2e768291efa6 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$l;
};
$3664ab19f4697bdd$export$9522e17588c12572 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$d;
};
$3664ab19f4697bdd$export$2110ac352bb060b9 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$q;
};
$3664ab19f4697bdd$export$56885ab8b9c456ab = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$p;
};
$3664ab19f4697bdd$export$d927fcb6adf8f9de = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$c;
};
$3664ab19f4697bdd$export$b82d16f27459e05a = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$f;
};
$3664ab19f4697bdd$export$522c17b4f5e123e8 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$e;
};
$3664ab19f4697bdd$export$1aabd8a0274ecfd6 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$m;
};
$3664ab19f4697bdd$export$3d6c20d97e46b957 = function(a) {
    return $3664ab19f4697bdd$var$v(a) === $3664ab19f4697bdd$var$n;
};
$3664ab19f4697bdd$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $3664ab19f4697bdd$var$d || a === $3664ab19f4697bdd$var$f || a === $3664ab19f4697bdd$var$e || a === $3664ab19f4697bdd$var$m || a === $3664ab19f4697bdd$var$n || a === $3664ab19f4697bdd$var$t || "object" === typeof a && null !== a && (a.$$typeof === $3664ab19f4697bdd$var$q || a.$$typeof === $3664ab19f4697bdd$var$p || a.$$typeof === $3664ab19f4697bdd$var$g || a.$$typeof === $3664ab19f4697bdd$var$h || a.$$typeof === $3664ab19f4697bdd$var$l || a.$$typeof === $3664ab19f4697bdd$var$u || void 0 !== a.getModuleId) ? !0 : !1;
};
$3664ab19f4697bdd$export$f5bbd400c2f4426f = $3664ab19f4697bdd$var$v;

});


parcelRegister("eSQDp", function(module, exports) {
$parcel$export(module.exports, "default", () => $ad5eeffeb3e38484$export$2e2bcd8739ae039);

var $2rVEs = parcelRequire("2rVEs");
parcelRequire("gdw0L");
const $ad5eeffeb3e38484$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $ad5eeffeb3e38484$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $ad5eeffeb3e38484$export$2e2bcd8739ae039(dispatch, _ref) {
    let { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _ref, options = (0, $2rVEs.default)(_ref, $ad5eeffeb3e38484$var$_excluded);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $ad5eeffeb3e38484$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("gdw0L", function(module, exports) {

var $iboCO = parcelRequire("iboCO");
function $bce6b1029cafafa0$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $iboCO.default)(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $bce6b1029cafafa0$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps) {
    $bce6b1029cafafa0$var$verify(mapStateToProps, 'mapStateToProps');
    $bce6b1029cafafa0$var$verify(mapDispatchToProps, 'mapDispatchToProps');
    $bce6b1029cafafa0$var$verify(mergeProps, 'mergeProps');
}

});
parcelRegister("iboCO", function(module, exports) {
$parcel$export(module.exports, "default", () => $d3cc5b180c4d3f09$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $d3cc5b180c4d3f09$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});



parcelRegister("ccAvY", function(module, exports) {
$parcel$export(module.exports, "mapDispatchToPropsFactory", () => $8e22ee11dfd74b5b$export$b69a785ceac019a6);

var $jjiMj = parcelRequire("jjiMj");

var $hmgge = parcelRequire("hmgge");

var $h0ArN = parcelRequire("h0ArN");
function $8e22ee11dfd74b5b$export$b69a785ceac019a6(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $hmgge.wrapMapToPropsConstant)((dispatch)=>(0, $jjiMj.default)(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? (0, $hmgge.wrapMapToPropsConstant)((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === 'function' ? (0, $hmgge.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : (0, $h0ArN.createInvalidArgFactory)(mapDispatchToProps, 'mapDispatchToProps');
}

});
parcelRegister("jjiMj", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0ee5b9f767aaaa4$export$2e2bcd8739ae039);
function $e0ee5b9f767aaaa4$export$2e2bcd8739ae039(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}

});

parcelRegister("hmgge", function(module, exports) {
$parcel$export(module.exports, "wrapMapToPropsConstant", () => $ca311acea0497798$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $ca311acea0497798$export$8d46c7f53c8c602f);
parcelRequire("48dO4");
function $ca311acea0497798$export$710f7c60f68acd3e(//  It seems that the dispatch argument
//  could be a dispatch function in some cases (ex: whenMapDispatchToPropsIsMissing)
//  and a state object in some others (ex: whenMapStateToPropsIsMissing)
// eslint-disable-next-line no-unused-vars
getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $ca311acea0497798$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $ca311acea0497798$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, undefined);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $ca311acea0497798$export$e561b938df936d57(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $ca311acea0497798$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("48dO4", function(module, exports) {

var $9vZCw = parcelRequire("9vZCw");

var $iboCO = parcelRequire("iboCO");
function $30229e7e47c9f2ef$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $9vZCw.default)(value)) (0, $iboCO.default)(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}

});
parcelRegister("9vZCw", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ed6cecea7278546$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $6ed6cecea7278546$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    let proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});



parcelRegister("h0ArN", function(module, exports) {
$parcel$export(module.exports, "createInvalidArgFactory", () => $c61eb574051b692a$export$19ef7b929f7e2559);
function $c61eb574051b692a$export$19ef7b929f7e2559(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}

});


parcelRegister("2P88M", function(module, exports) {
$parcel$export(module.exports, "mapStateToPropsFactory", () => $20e6a8c41c7ea2c5$export$e00e93951827eda7);

var $hmgge = parcelRequire("hmgge");

var $h0ArN = parcelRequire("h0ArN");
function $20e6a8c41c7ea2c5$export$e00e93951827eda7(mapStateToProps) {
    return !mapStateToProps ? (0, $hmgge.wrapMapToPropsConstant)(()=>({})) : typeof mapStateToProps === 'function' ? (0, $hmgge.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : (0, $h0ArN.createInvalidArgFactory)(mapStateToProps, 'mapStateToProps');
}

});

parcelRegister("lV57j", function(module, exports) {
$parcel$export(module.exports, "mergePropsFactory", () => $ff52e3f153674f8b$export$17457cf6fa742f84);

var $jimAf = parcelRequire("jimAf");
parcelRequire("48dO4");

var $h0ArN = parcelRequire("h0ArN");
function $ff52e3f153674f8b$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    // @ts-ignore
    return (0, $jimAf.default)({}, ownProps, stateProps, dispatchProps);
}
function $ff52e3f153674f8b$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $ff52e3f153674f8b$export$17457cf6fa742f84(mergeProps) {
    return !mergeProps ? ()=>$ff52e3f153674f8b$export$691c327fc30bc857 : typeof mergeProps === 'function' ? $ff52e3f153674f8b$export$5b105939c84b5234(mergeProps) : (0, $h0ArN.createInvalidArgFactory)(mergeProps, 'mergeProps');
}

});

parcelRegister("1aPa7", function(module, exports) {
$parcel$export(module.exports, "createSubscription", () => $0dae6963e471f205$export$d567d2b9af322f8f);

var $bGfxz = parcelRequire("bGfxz");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $0dae6963e471f205$var$createListenerCollection() {
    const batch = (0, $bGfxz.getBatch)();
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            batch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            let listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            let listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
const $0dae6963e471f205$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $0dae6963e471f205$export$d567d2b9af322f8f(store, parentSub) {
    let unsubscribe;
    let listeners = $0dae6963e471f205$var$nullListeners; // Reasons to keep the subscription active
    let subscriptionsAmount = 0; // Is this specific subscription subscribed (or only nested ones?)
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener); // cleanup nested sub
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $0dae6963e471f205$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $0dae6963e471f205$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}

});

parcelRegister("9HOOw", function(module, exports) {
$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $710f8bcb94250707$export$700979bc83e7db82);

var $euxye = parcelRequire("euxye");
const $710f8bcb94250707$export$71594e8a50f746f4 = !!(typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined');
const $710f8bcb94250707$export$700979bc83e7db82 = $710f8bcb94250707$export$71594e8a50f746f4 ? $euxye.useLayoutEffect : $euxye.useEffect;

});

parcelRegister("9dW1o", function(module, exports) {
$parcel$export(module.exports, "default", () => $01bba68b91ce7910$export$2e2bcd8739ae039);
function $01bba68b91ce7910$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $01bba68b91ce7910$export$2e2bcd8739ae039(objA, objB) {
    if ($01bba68b91ce7910$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$01bba68b91ce7910$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});


parcelRegister("aJses", function(module, exports) {
$parcel$export(module.exports, "Provider", () => (parcelRequire("ea8nr")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("iB0Id")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("itMds")).useDispatch);
$parcel$export(module.exports, "createDispatchHook", () => (parcelRequire("itMds")).createDispatchHook);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("015iq")).useSelector);
$parcel$export(module.exports, "useStore", () => (parcelRequire("f6mm4")).useStore);

var $ea8nr = parcelRequire("ea8nr");

var $iB0Id = parcelRequire("iB0Id");

var $hR5da = parcelRequire("hR5da");

var $itMds = parcelRequire("itMds");

var $015iq = parcelRequire("015iq");

var $f6mm4 = parcelRequire("f6mm4");

var $9dW1o = parcelRequire("9dW1o");
parcelRequire("huqU6");

});
parcelRegister("ea8nr", function(module, exports) {
$parcel$export(module.exports, "default", () => $a4f87f5e506ff849$export$2e2bcd8739ae039);

var $euxye = parcelRequire("euxye");

var $hR5da = parcelRequire("hR5da");

var $1aPa7 = parcelRequire("1aPa7");

var $9HOOw = parcelRequire("9HOOw");
function $a4f87f5e506ff849$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = 'once', noopCheck: noopCheck = 'once' }) {
    const contextValue = $euxye.useMemo(()=>{
        const subscription = (0, $1aPa7.createSubscription)(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : undefined,
            stabilityCheck: stabilityCheck,
            noopCheck: noopCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        noopCheck
    ]);
    const previousState = $euxye.useMemo(()=>store.getState(), [
        store
    ]);
    (0, $9HOOw.useIsomorphicLayoutEffect)(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = undefined;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || (0, $hR5da.ReactReduxContext); // @ts-ignore 'AnyAction' is assignable to the constraint of type 'A', but 'A' could be instantiated with a different subtype
    return /*#__PURE__*/ $euxye.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $a4f87f5e506ff849$export$2e2bcd8739ae039 = $a4f87f5e506ff849$var$Provider;

});

parcelRegister("itMds", function(module, exports) {
$parcel$export(module.exports, "createDispatchHook", () => $d74056278b402a7e$export$bc9b55530897c558);
$parcel$export(module.exports, "useDispatch", () => $d74056278b402a7e$export$8ad76b76a4c905f8);

var $hR5da = parcelRequire("hR5da");

var $f6mm4 = parcelRequire("f6mm4");
function $d74056278b402a7e$export$bc9b55530897c558(context = (0, $hR5da.ReactReduxContext)) {
    const useStore = context === (0, $hR5da.ReactReduxContext) ? (0, $f6mm4.useStore) : (0, $f6mm4.createStoreHook)(context);
    return function useDispatch() {
        const store = useStore(); // @ts-ignore
        return store.dispatch;
    };
}
const $d74056278b402a7e$export$8ad76b76a4c905f8 = /*#__PURE__*/ $d74056278b402a7e$export$bc9b55530897c558();

});
parcelRegister("f6mm4", function(module, exports) {
$parcel$export(module.exports, "createStoreHook", () => $afe8c1c591e16f51$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $afe8c1c591e16f51$export$6ccbb43953eebf8);

var $hR5da = parcelRequire("hR5da");

var $lOPQz = parcelRequire("lOPQz");
function $afe8c1c591e16f51$export$671dba69185d0304(context = (0, $hR5da.ReactReduxContext)) {
    const useReduxContext = context === (0, $hR5da.ReactReduxContext) ? (0, $lOPQz.useReduxContext) : (0, $lOPQz.createReduxContextHook)(context);
    return function useStore() {
        const { store: store } = useReduxContext(); // @ts-ignore
        return store;
    };
}
const $afe8c1c591e16f51$export$6ccbb43953eebf8 = /*#__PURE__*/ $afe8c1c591e16f51$export$671dba69185d0304();

});


parcelRegister("huqU6", function(module, exports) {

});



parcelRegister("ikZXr", function(module, exports) {
$parcel$export(module.exports, "withStability", () => $11859252486e0100$export$717840dc0c82fbbc);
/* eslint-disable jira/filename-case */ 
var $hFtK7 = parcelRequire("hFtK7");

var $1ByIU = parcelRequire("1ByIU");
/* eslint-disable @typescript-eslint/no-explicit-any, func-names */ const $11859252486e0100$var$ARITY = {
    0: (fn)=>function() {
            return fn.call(this);
        },
    1: (fn)=>function(arg1) {
            return fn.call(this, arg1);
        },
    2: (fn)=>function(arg1, arg2) {
            return fn.call(this, arg1, arg2);
        },
    3: (fn)=>function(arg1, arg2, arg3) {
            return fn.call(this, arg1, arg2, arg3);
        }
};
function $11859252486e0100$var$defineArity(arity, fn) {
    if (!$11859252486e0100$var$ARITY[arity]) throw new Error(`Unsupported arity ${arity}`);
    return $11859252486e0100$var$ARITY[arity](fn);
}
const $11859252486e0100$var$getDifference = (a, b)=>{
    const diff = {};
    for(const key in a)if (a[key] !== b[key]) diff[key] = a[key];
    return diff;
};
const $11859252486e0100$var$getTypes = (a)=>{
    const result = {};
    // eslint-disable-next-line guard-for-in
    for(const key in a)result[key] = typeof a[key];
    return result;
};
const $11859252486e0100$var$stability = (component, name, fn)=>{
    const isDevMode = false;
    let override = null;
    return $11859252486e0100$var$defineArity(3, (...args)=>{
        if (override) return override(...args);
        const v1 = fn(...args);
        if (typeof v1 === 'function') {
            override = $11859252486e0100$var$stability(component, `${name}>`, v1);
            return override(...args);
        }
        const v2 = fn(...args);
        if (!(0, $1ByIU.isShallowEqual)(v1, v2)) {
            const displayName = component.displayName || component.name;
            const difference = $11859252486e0100$var$getDifference(v1, v2);
            const stabilityAttributes = {
                component: component,
                selector: fn,
                displayName: displayName,
                name: name,
                difference: difference,
                v1: v1,
                v2: v2,
                differenceTypes: $11859252486e0100$var$getTypes(difference),
                v1Types: $11859252486e0100$var$getTypes(v1),
                v2Types: $11859252486e0100$var$getTypes(v2)
            };
            // only log errors in dev mode
            if (isDevMode) // eslint-disable-next-line no-console
            console.error(`Unstable selector ${displayName}:${name}`, stabilityAttributes);
            const error = new Error(`Unstable selector used for ${displayName}:${name} : ${Object.keys(difference).join(',')}`);
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'stabilityCheck',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                attributes: stabilityAttributes,
                error: error
            });
            // only throw error again in dev mode
            if (isDevMode) throw error;
        }
        return v2;
    });
};
const $11859252486e0100$export$717840dc0c82fbbc = (component, name, fn)=>{
    const isDevMode = false;
    if (!isDevMode || !fn || typeof fn !== 'function') return fn;
    // mergeProps cannot return a factory function
    if (name === 'mergeProps') return $11859252486e0100$var$defineArity(3, $11859252486e0100$var$stability(component, name, fn));
    return $11859252486e0100$var$defineArity(3, ()=>$11859252486e0100$var$stability(component, name, fn));
};

});
parcelRegister("hFtK7", function(module, exports) {
$parcel$export(module.exports, "VIEW_WHITELIST", () => $d7e795a26a6becb1$export$3afedfeaaa65a187);
$parcel$export(module.exports, "isViewSupported", () => $d7e795a26a6becb1$export$a6492bcf97904608);
$parcel$export(module.exports, "isNetworkError", () => $d7e795a26a6becb1$export$476aa014e2fd89d5);
$parcel$export(module.exports, "getStatusCodeGroup", () => $d7e795a26a6becb1$export$d14e9b22afc87cb3);
$parcel$export(module.exports, "fireErrorAnalytics", () => $d7e795a26a6becb1$export$a27c21aa3ed8f0f1);
$parcel$export(module.exports, "trackFetchErrors", () => $d7e795a26a6becb1$export$706c486c6b5abdfb);

var $6jLTU = parcelRequire("6jLTU");

var $3irVK = parcelRequire("3irVK");

var $6CfY5 = parcelRequire("6CfY5");

var $75sVW = parcelRequire("75sVW");

var $lCetP = parcelRequire("lCetP");

var $41zzZ = parcelRequire("41zzZ");

var $aJ81Y = parcelRequire("aJ81Y");
var $7RK6D = parcelRequire("7RK6D");

var $6Kdw4 = parcelRequire("6Kdw4");

var $fEmTm = parcelRequire("fEmTm");

var $i3iX9 = parcelRequire("i3iX9");

var $i860n = parcelRequire("i860n");
const $d7e795a26a6becb1$export$3afedfeaaa65a187 = new Set([
    'project-issue-navigator',
    'jira-router-gin-redirect-entrypoint',
    'jira-business-attachments-app',
    'jira-business-timeline-app',
    'software-list-app',
    'business-list-app',
    'business-calendar',
    'business-calendar-embed',
    'business-calendar-custom-embed',
    'software-calendar',
    'software-calendar-embed',
    'software-calendar-custom-embed',
    'board-app',
    'business-board-app',
    'jira-software-timeline',
    'software-timeline-embed-view'
]);
const $d7e795a26a6becb1$var$EXTENDED_VIEW_WHITELIST = [
    'issue-view-details'
];
const $d7e795a26a6becb1$export$a6492bcf97904608 = (view)=>{
    if ((0, $i860n.fg)('jserrorboundary_analytics_update')) return $d7e795a26a6becb1$export$3afedfeaaa65a187.has(view) || $d7e795a26a6becb1$var$EXTENDED_VIEW_WHITELIST.includes(view);
    return $d7e795a26a6becb1$export$3afedfeaaa65a187.has(view);
};
const $d7e795a26a6becb1$export$476aa014e2fd89d5 = (error)=>{
    // @ts-expect-error - TS2339 - Property 'networkError' does not exist on type 'Error'. | TS2339 - Property 'networkError' does not exist on type 'Error'.
    const errorToCheck = error.networkError ? error.networkError : error;
    return typeof errorToCheck === 'object' && (errorToCheck instanceof (0, $75sVW.default) || errorToCheck instanceof (0, $75sVW.ValidationError) || (0, $lCetP.isRelayNetworkWebCrawlerUserAgentDroppingHeaders)(errorToCheck) || (0, $lCetP.isClientFetchError)(errorToCheck));
};
const $d7e795a26a6becb1$export$d14e9b22afc87cb3 = (error)=>{
    if (error instanceof (0, $75sVW.default)) {
        const { statusCode: statusCode } = error;
        if (statusCode >= 100 && statusCode < 200) return '1xx';
        if (statusCode >= 300 && statusCode < 400) return '3xx';
        if (statusCode >= 400 && statusCode < 500) return '4xx';
        if (statusCode >= 500 && statusCode < 600) return '5xx';
    }
    if (error instanceof (0, $75sVW.ValidationError)) return '4xx';
    if ((0, $lCetP.isRelayNetworkWebCrawlerUserAgentDroppingHeaders)(error)) return '4xx';
    return 'unknown';
};
const $d7e795a26a6becb1$var$getTraceId = (error)=>error instanceof (0, $75sVW.default) ? error.traceId : undefined;
const $d7e795a26a6becb1$var$logErrorToSentry = (event, fullAnalyticsId, error, // eslint-disable-next-line @typescript-eslint/no-explicit-any
details)=>{
    if (event?.context) {
        const fullEvent = (0, $7RK6D.getEvent)(event);
        (0, $fEmTm.captureException)(fullAnalyticsId, error, {
            ...details,
            ...fullEvent.payload
        });
    } else (0, $fEmTm.captureException)(fullAnalyticsId, error, details);
};
const $d7e795a26a6becb1$var$logToPrivacyUnsafeSplunk = (fullAnalyticsId, error, errorInfo, meta)=>{
    const errorToLog = {
        message: error.message,
        stack: error.stack,
        // Include the status code group for network errors
        statusCodeGroup: $d7e795a26a6becb1$export$476aa014e2fd89d5(error) ? $d7e795a26a6becb1$export$d14e9b22afc87cb3(error) : undefined,
        // Include componentStack if present created by React's componentDidCatch
        componentStack: errorInfo ? errorInfo.componentStack : undefined,
        userLocation: (0, $41zzZ.getUserLocation)(),
        teamName: meta?.teamName,
        packageName: meta?.packageName
    };
    (0, $6CfY5.default).unsafeErrorWithCustomerData(fullAnalyticsId, error.message, errorToLog);
};
const $d7e795a26a6becb1$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@\w+/gi, '***@***');
const $d7e795a26a6becb1$export$a27c21aa3ed8f0f1 = async ({ event: event, error: error, errorInfo: errorInfo, meta: meta, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk = false, skipSentry: skipSentry = false, view: view, fallbackType: fallbackType })=>{
    if ((0, $lCetP.isWebCrawlerUserAgentWithAppleBot)() && (0, $i860n.fg)('bento_suppress_bot_web_crawler')) return;
    const networkError = error ? $d7e795a26a6becb1$export$476aa014e2fd89d5(error) : false;
    let eventAttributes;
    const userLocation = (0, $41zzZ.getUserLocation)() || '';
    if (networkError && error) {
        const statusCodeGroup = $d7e795a26a6becb1$export$d14e9b22afc87cb3(error);
        const traceId = $d7e795a26a6becb1$var$getTraceId(error);
        eventAttributes = traceId === null || traceId === undefined ? {
            ...attributes,
            statusCodeGroup: statusCodeGroup
        } : {
            ...attributes,
            statusCodeGroup: statusCodeGroup,
            traceId: traceId
        };
    } else eventAttributes = attributes ?? {};
    const { id: id, packageName: packageName, teamName: teamName } = meta;
    if (false) {
        if (error) throw error;
        else {
            const payload = event && (0, $7RK6D.getEvent)(event).payload;
            throw new Error(JSON.stringify({
                event: payload,
                errorInfo: errorInfo,
                meta: meta,
                attributes: eventAttributes
            }));
        }
    }
    const fullAnalyticsId = packageName !== undefined ? `${packageName}.${id}` : id;
    if (error) {
        if (!networkError && !skipSentry) {
            const details = (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
                ...eventAttributes,
                packageName: packageName,
                teamName: teamName,
                errorInfo: errorInfo
            }, (0, (/*@__PURE__*/$parcel$interopDefault($6jLTU))));
            $d7e795a26a6becb1$var$logErrorToSentry(event, fullAnalyticsId, error, details);
            if (event && event?.handlers?.length > 0 && view && $d7e795a26a6becb1$export$a6492bcf97904608(view)) (0, $aJ81Y.fireOperationalAnalytics)(event, 'jiraViewException caught', {
                ...eventAttributes,
                id: id,
                view: view,
                packageName: packageName,
                teamName: teamName,
                errorMessage: typeof error.message === 'string' ? $d7e795a26a6becb1$export$1bee4e6be783dd26(error.message) : error.message,
                ...(0, $i860n.fg)('jserrorboundary_analytics_update') ? {
                    fallbackType: fallbackType,
                    userLocation: userLocation
                } : {}
            });
        }
        // This is a stop gap measure until Sentry is fully rolled out
        if (sendToPrivacyUnsafeSplunk) $d7e795a26a6becb1$var$logToPrivacyUnsafeSplunk(fullAnalyticsId, error, errorInfo, meta);
        eventAttributes = {
            errorMessage: error.message,
            ...eventAttributes
        };
        if (typeof eventAttributes.errorMessage === 'string') eventAttributes.errorMessage = $d7e795a26a6becb1$export$1bee4e6be783dd26(eventAttributes.errorMessage);
    }
    if (event && event?.handlers?.length > 0 && (0, $i3iX9.getSource)(event) != null) {
        const attrs = eventAttributes;
        (0, $aJ81Y.fireOperationalAnalytics)(event, `${fullAnalyticsId} failed`, attrs);
    } else {
        const gasV3Event = {
            action: 'failed',
            actionSubject: fullAnalyticsId,
            source: 'unknownErrorSource',
            attributes: eventAttributes
        };
        const analyticsClient = await (0, $6Kdw4.getAnalyticsWebClientPromise)();
        analyticsClient.getInstance().sendOperationalEvent(gasV3Event);
    }
};
const $d7e795a26a6becb1$export$706c486c6b5abdfb = async (payload)=>{
    const { event: event, error: error, id: id, packageName: packageName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = payload;
    return $d7e795a26a6becb1$export$a27c21aa3ed8f0f1({
        event: event,
        error: error,
        attributes: attributes,
        meta: {
            packageName: packageName,
            id: id
        },
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});
parcelRegister("lCetP", function(module, exports) {
$parcel$export(module.exports, "isWebCrawlerUserAgentWithAppleBot", () => $499723b9d75f21e6$export$414d9099ca6a5c38);
$parcel$export(module.exports, "isRelayNetworkWebCrawlerUserAgentDroppingHeaders", () => $499723b9d75f21e6$export$d5a150f340af0273);
$parcel$export(module.exports, "isRelayNetworkAuthorizationError", () => $499723b9d75f21e6$export$cb26277b2c5ea376);
$parcel$export(module.exports, "isHttpClientErrorResponse", () => $499723b9d75f21e6$export$2b62e563f0fadcee);
$parcel$export(module.exports, "isHttpAccessErrorResponse", () => $499723b9d75f21e6$export$3bc75de436f6f6fb);
$parcel$export(module.exports, "isHttpNotFoundErrorResponse", () => $499723b9d75f21e6$export$2a8316eb45cf2506);
$parcel$export(module.exports, "isHttpClientErrorStatusCode", () => $499723b9d75f21e6$export$6e82b047ed95d4a2);
$parcel$export(module.exports, "isHttpTooManyRequestsResponse", () => $499723b9d75f21e6$export$9d73d6caff63cf52);
$parcel$export(module.exports, "isClientFetchError", () => $499723b9d75f21e6$export$2e7adc44463c3f4f);
$parcel$export(module.exports, "isBackendAPIError", () => $499723b9d75f21e6$export$c837012eb09638f0);
/* eslint-disable jira/filename-case */ 
var $i860n = parcelRequire("i860n");

var $75sVW = parcelRequire("75sVW");
const $499723b9d75f21e6$var$webCrawlerUserAgents = [
    'googlebot',
    'bingbot',
    'yandexbot',
    'baiduspider',
    'duckduckbot',
    'gptbot'
];
const $499723b9d75f21e6$var$webCrawlerUserAgentsWithAppleBot = [
    ...$499723b9d75f21e6$var$webCrawlerUserAgents,
    'applebot'
];
const $499723b9d75f21e6$export$42997256f812871e = (userAgent = globalThis.navigator?.userAgent)=>{
    const normalisedUserAgent = userAgent?.toLowerCase() || '';
    return $499723b9d75f21e6$var$webCrawlerUserAgents.some((crawler)=>normalisedUserAgent.includes(crawler));
};
const $499723b9d75f21e6$export$414d9099ca6a5c38 = ()=>{
    const userAgent = globalThis.navigator?.userAgent;
    return $499723b9d75f21e6$var$webCrawlerUserAgentsWithAppleBot.some((crawler)=>userAgent?.toLowerCase().includes(crawler));
};
const $499723b9d75f21e6$export$d5a150f340af0273 = (error)=>{
    if (!(0, $75sVW.isRelayNetworkError)(error)) return false;
    return $499723b9d75f21e6$export$42997256f812871e() && error?.source?.errors?.[0]?.extensions?.classification === 'BetaHeaderOptInException' && error?.source?.errors?.[0]?.extensions?.statusCode === 400;
};
const $499723b9d75f21e6$export$cb26277b2c5ea376 = (error)=>{
    if (!(0, $75sVW.isRelayNetworkError)(error)) return false;
    return error?.source?.errors?.[0]?.extensions?.statusCode === 401;
};
const $499723b9d75f21e6$export$2b62e563f0fadcee = (error)=>typeof error === 'object' && 'statusCode' in error && error.statusCode >= 400 && error.statusCode < 500 || // Also explicitly include specific cases of 4xx RelayNetworkErrors we should ignore
    $499723b9d75f21e6$export$d5a150f340af0273(error);
const $499723b9d75f21e6$export$3bc75de436f6f6fb = (error)=>typeof error === 'object' && 'statusCode' in error && (error.statusCode === 401 || error.statusCode === 403);
const $499723b9d75f21e6$export$2a8316eb45cf2506 = (error)=>typeof error === 'object' && 'statusCode' in error && error.statusCode === 404;
const $499723b9d75f21e6$export$6e82b047ed95d4a2 = (statusCode)=>statusCode !== null && statusCode >= 400 && statusCode < 500;
const $499723b9d75f21e6$export$9d73d6caff63cf52 = (error)=>error.statusCode === 429;
const $499723b9d75f21e6$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed',
    'CloseEvent: Ping timeout'
];
const $499723b9d75f21e6$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError',
    'Network error'
];
const $499723b9d75f21e6$var$isClientFetchErrorMessage = (message)=>Boolean(message) && (!!$499723b9d75f21e6$export$c748438cec453c9f.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage)) || message.includes('Curl Error: Failure when receiving data from the peer') && (0, $i860n.fg)('handle_failure_when_receiving_data_from_the_peer'));
const $499723b9d75f21e6$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($499723b9d75f21e6$export$3876cb851aa46193.includes(error.name) || $499723b9d75f21e6$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($499723b9d75f21e6$export$3876cb851aa46193.includes(error.cause.name) || $499723b9d75f21e6$var$isClientFetchErrorMessage(error.cause.message)));
const $499723b9d75f21e6$export$bc51706fabc78ec4 = [
    'authProviderTimedOut',
    'Call to graphql returned empty issue',
    'endpoint failed with status',
    'Exception while fetching data',
    'fetch-error: no data or no data node',
    'FetchError',
    'GraphQL error',
    'GraphQLNoResultsError',
    'HTTP status',
    'java.lang.',
    'java.net.',
    'java.util.',
    'javax.net.',
    'JSON at position',
    'Network error:',
    'not valid JSON',
    'Problem while calling endpoint',
    'RelayNetwork',
    'Response ended with an error',
    'serverForbidden',
    'serverInvalidBody',
    'serverUnauthorized',
    'serverUnexpectedError'
];
class $499723b9d75f21e6$export$d4090828a4396567 extends Error {
    constructor(message, options){
        super(message);
        this.name = 'BackendAPIError';
        this.cause = options?.cause;
    }
}
$499723b9d75f21e6$export$d4090828a4396567.displayName = "BackendAPIError";
const $499723b9d75f21e6$export$c837012eb09638f0 = (error)=>Boolean(error) && typeof error === 'object' && ('statusCode' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'statusCode' in error.cause || 'graphQLErrors' in error || Boolean(error.cause) && typeof error.cause === 'object' && 'graphQLErrors' in error.cause || $499723b9d75f21e6$export$bc51706fabc78ec4.some((v)=>`${error.name}${error.message}${error.cause?.name}${error.cause?.message}`.includes(v)));

});

parcelRegister("41zzZ", function(module, exports) {
$parcel$export(module.exports, "setMatchedRoute", () => $bf02be3477e9639f$export$afe84d55f9496537);
$parcel$export(module.exports, "getMatchedRoute", () => $bf02be3477e9639f$export$a0bca9c6a43bcc94);
$parcel$export(module.exports, "getRouteName", () => $bf02be3477e9639f$export$52f85febe13405);
$parcel$export(module.exports, "getUserLocation", () => $bf02be3477e9639f$export$a17b4f8f942a1896);
$parcel$export(module.exports, "getUfoName", () => $bf02be3477e9639f$export$fd0dcd3ca7f44a0d);
$parcel$export(module.exports, "getBifrostGroup", () => $bf02be3477e9639f$export$ef57e855d1556e79);
$parcel$export(module.exports, "setPreviousRouterState", () => $bf02be3477e9639f$export$335179a30e3b3b9);
$parcel$export(module.exports, "getPreviousRouterState", () => $bf02be3477e9639f$export$c54513a7c3de8fe7);
$parcel$export(module.exports, "getPreviousSubProduct", () => $bf02be3477e9639f$export$20e84c9866aad5d2);
$parcel$export(module.exports, "setSubProduct", () => $bf02be3477e9639f$export$37ee9c58e9a550c6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6Kdw4 = parcelRequire("6Kdw4");
let $bf02be3477e9639f$var$matchedRoute = null;
const $bf02be3477e9639f$export$afe84d55f9496537 = (route, match)=>{
    if (route && match) $bf02be3477e9639f$var$matchedRoute = {
        route: route,
        match: match
    };
};
const $bf02be3477e9639f$export$a0bca9c6a43bcc94 = ()=>$bf02be3477e9639f$var$matchedRoute;
const $bf02be3477e9639f$export$52f85febe13405 = ()=>$bf02be3477e9639f$var$matchedRoute?.route.name ?? 'unknown';
const $bf02be3477e9639f$export$a17b4f8f942a1896 = ()=>`${$bf02be3477e9639f$var$matchedRoute?.route.group ?? 'unknown'}:${$bf02be3477e9639f$export$52f85febe13405()}`;
const $bf02be3477e9639f$export$fd0dcd3ca7f44a0d = ()=>{
    return $bf02be3477e9639f$var$matchedRoute?.route?.ufoName ?? 'unknown';
};
const $bf02be3477e9639f$export$ef57e855d1556e79 = ()=>{
    return $bf02be3477e9639f$var$matchedRoute?.route?.bifrost?.bifrostGroup ?? 'none';
};
let $bf02be3477e9639f$var$previousRouterState = null;
let $bf02be3477e9639f$var$previousSubProduct = '';
const $bf02be3477e9639f$export$335179a30e3b3b9 = (state)=>{
    $bf02be3477e9639f$var$previousRouterState = state;
};
const $bf02be3477e9639f$export$c54513a7c3de8fe7 = ()=>$bf02be3477e9639f$var$previousRouterState;
const $bf02be3477e9639f$export$df8e6f241eebab99 = (subProduct)=>{
    $bf02be3477e9639f$var$previousSubProduct = subProduct || '';
};
const $bf02be3477e9639f$export$20e84c9866aad5d2 = ()=>$bf02be3477e9639f$var$previousSubProduct;
const $bf02be3477e9639f$export$37ee9c58e9a550c6 = (subproduct)=>{
    if (subproduct === null) return;
    if ($bf02be3477e9639f$var$previousSubProduct !== subproduct) $bf02be3477e9639f$export$df8e6f241eebab99(subproduct);
    (0, $6Kdw4.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subproduct);
    });
};

});

parcelRegister("aJ81Y", function(module, exports) {
$parcel$export(module.exports, "fireAnalytics", () => $98d2fd34afef9542$export$34ac71ce24cddec2);
$parcel$export(module.exports, "fireUIAnalytics", () => $98d2fd34afef9542$export$5d00cd31b1bf8e94);
$parcel$export(module.exports, "fireTrackAnalytics", () => $98d2fd34afef9542$export$13990ad4625571ed);
$parcel$export(module.exports, "fireTrackAnalyticsDeferred", () => $98d2fd34afef9542$export$b6c00a2e59d74c5e);
$parcel$export(module.exports, "fireOperationalAnalytics", () => $98d2fd34afef9542$export$79f423cc3fd39762);
$parcel$export(module.exports, "fireOperationalAnalyticsDeferred", () => $98d2fd34afef9542$export$6bb7ef8f82969e8f);
$parcel$export(module.exports, "fireScreenAnalytics", () => $98d2fd34afef9542$export$6f46fb37ad7d962b);
$parcel$export(module.exports, "fireScreenAnalyticsDeferred", () => $98d2fd34afef9542$export$59b89d5a711a4fa);
/* eslint-disable jira/filename-case */ /**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $hlxpN = parcelRequire("hlxpN");


var $i3iX9 = parcelRequire("i3iX9");
const $98d2fd34afef9542$export$34ac71ce24cddec2 = (event, type, eventOverrides = {})=>{
    // Safe check to prevent SSR to trigger and to avoid sentry errors such as https://ops.internal.atlassian.com/jira/browse/HOT-90825
    if (false) return;
    const clonedEvent = event.clone();
    if (clonedEvent) clonedEvent.update({
        ...eventOverrides,
        analyticsType: type
    }).fire('productAnalytics');
};
const $98d2fd34afef9542$var$getActionSubjectFromContext = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))(event.context.map((i)=>i.component || i.componentName).filter(Boolean));
const $98d2fd34afef9542$var$fireEventWhenIdle = (fireFn, event, ...rest)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.requestIdleCallback(()=>fireFn(event, ...rest));
    else fireFn(event, ...rest);
};
const $98d2fd34afef9542$export$5d00cd31b1bf8e94 = (event, ...rest)=>{
    const { action: attrAction, actionSubject: attrSubject, actionSubjectId: actionSubjectId, attributes: attributes } = (0, $i3iX9.getSubjectsFromArguments)(...rest);
    const action = event.payload?.action || attrAction;
    const actionSubject = event.payload?.actionSubject || attrSubject || $98d2fd34afef9542$var$getActionSubjectFromContext(event);
    $98d2fd34afef9542$var$fireAnalyticsOfType(event, (0, $46f069e6c968f461$export$a1562d08625f5d7e), {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    });
};
const $98d2fd34afef9542$var$capitalize = (str)=>`${str.charAt(0).toUpperCase()}${str.slice(1)}`;
const $98d2fd34afef9542$var$fireAnalyticsOfType = (event, eventType, analyticsProps)=>{
    // UI_EVENT_TYPE condition - just not to affect existing events we're sending; not to require update of existing monitoring
    const eventTypeForError = eventType === (0, $46f069e6c968f461$export$a1562d08625f5d7e) ? eventType : $98d2fd34afef9542$var$capitalize(eventType.toLowerCase());
    if (!event.clone) throw Error(`There is no analytics event from atlaskit in ${eventTypeForError} event`);
    if (!analyticsProps.action) throw Error(`Mandatory "action" field is missing from ${eventTypeForError} event`);
    if (!analyticsProps.actionSubject) throw Error(`Mandatory "actionSubject" field is missing from ${eventTypeForError} event`);
    $98d2fd34afef9542$export$34ac71ce24cddec2(event, eventType, analyticsProps);
};
const $98d2fd34afef9542$export$13990ad4625571ed = (event, ...rest)=>{
    const analyticsProps = (0, $i3iX9.getSubjectsFromArguments)(...rest);
    $98d2fd34afef9542$var$fireAnalyticsOfType(event, (0, $46f069e6c968f461$export$947dac6c72b26f81), analyticsProps);
};
const $98d2fd34afef9542$export$b6c00a2e59d74c5e = (event, ...rest)=>$98d2fd34afef9542$var$fireEventWhenIdle($98d2fd34afef9542$export$13990ad4625571ed, event, ...rest);
const $98d2fd34afef9542$export$79f423cc3fd39762 = (event, ...rest)=>{
    const analyticsProps = (0, $i3iX9.getSubjectsFromArguments)(...rest);
    $98d2fd34afef9542$var$fireAnalyticsOfType(event, (0, $46f069e6c968f461$export$12346a674644c156), analyticsProps);
};
const $98d2fd34afef9542$export$6bb7ef8f82969e8f = (event, ...rest)=>$98d2fd34afef9542$var$fireEventWhenIdle($98d2fd34afef9542$export$79f423cc3fd39762, event, ...rest);
const $98d2fd34afef9542$export$6f46fb37ad7d962b = (event, attributes = {})=>{
    if (!event.clone) throw Error('There is no analytics event from atlaskit in Screen event');
    $98d2fd34afef9542$export$34ac71ce24cddec2(event, (0, $46f069e6c968f461$export$f1d537d508d2945a), {
        attributes: attributes
    });
};
const $98d2fd34afef9542$export$59b89d5a711a4fa = (event, attributes = {})=>$98d2fd34afef9542$var$fireEventWhenIdle($98d2fd34afef9542$export$6f46fb37ad7d962b, event, attributes);

});
parcelRegister("i3iX9", function(module, exports) {
$parcel$export(module.exports, "getSubjectsFromArguments", () => $b113f7b063b64ffa$export$c9bdf245bf8922fc);
$parcel$export(module.exports, "getAnalyticsType", () => $b113f7b063b64ffa$export$a3569ac53b82a914);
$parcel$export(module.exports, "getAttributes", () => $b113f7b063b64ffa$export$fe94072fee8a6976);
$parcel$export(module.exports, "getSource", () => $b113f7b063b64ffa$export$dd2b6e807fb37ba3);
$parcel$export(module.exports, "getActionSubject", () => $b113f7b063b64ffa$export$6f40cdf6d42c018d);
$parcel$export(module.exports, "getAction", () => $b113f7b063b64ffa$export$6ca3170acb89054);
$parcel$export(module.exports, "getActionSubjectId", () => $b113f7b063b64ffa$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getContainerId", () => $b113f7b063b64ffa$export$7c8178cc9001d237);
$parcel$export(module.exports, "getContainerType", () => $b113f7b063b64ffa$export$acc6f3e19803b3dc);
$parcel$export(module.exports, "getObjectId", () => $b113f7b063b64ffa$export$fa986b91291934c7);
$parcel$export(module.exports, "getObjectType", () => $b113f7b063b64ffa$export$11cc42aebef2ef3a);
$parcel$export(module.exports, "getTags", () => $b113f7b063b64ffa$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainers", () => $b113f7b063b64ffa$export$ae861c5c02c4c14c);
/* eslint-disable jira/filename-case */ 
var $cIPCk = parcelRequire("cIPCk");

var $808aL = parcelRequire("808aL");

var $hlxpN = parcelRequire("hlxpN");

var $6Fltw = parcelRequire("6Fltw");

var $3irVK = parcelRequire("3irVK");

var $9O1Qa = parcelRequire("9O1Qa");
// TODO remove `| ActionSubjectId` as a type option, from the actionSubjectAndAction, As the usage is deprecated
/**
 * @param string - string with format 'actionSubject action' or 'actionSubjectId'. It is recommended to supply an EventOverrides object instead of actionSubjectId.
 */ const $b113f7b063b64ffa$var$extractDataFromStringAttribute = (actionSubjectAndAction)=>{
    const arr = actionSubjectAndAction.split(' ');
    switch(arr.length){
        /**
		 * @deprecated We no longer support this case as it leads to confusion with how the analytics API should be used.
		 * @see https://hello.atlassian.net/wiki/spaces/TGR/pages/2922733949
		 */ case 1:
            return {
                actionSubject: undefined,
                action: undefined,
                actionSubjectId: arr[0],
                attributes: undefined
            };
        case 2:
            return {
                actionSubject: arr[0],
                action: arr[1],
                actionSubjectId: undefined,
                attributes: undefined
            };
        default:
            throw Error('Event of this type is not supported');
    }
};
const $b113f7b063b64ffa$export$a502e64ed48035b = (obj)=>{
    const keysCount = Object.keys(obj).length;
    if (keysCount === 4) return 'actionSubjectId' in obj && 'attributes' in obj && 'action' in obj && 'actionSubject' in obj;
    return false;
};
/**
 * @param one - can be either string with format 'actionSubject action', AnalyticsAttributes or EventOverrides.
 * @example
 * ```ts
 * extractDataFromOneAttribute('button clicked') // { actionSubject: 'button', action: 'clicked', actionSubjectId: undefined, attributes: undefined }
 * extractDataFromOneAttribute({ foo: 'bar' }) // { actionSubject: undefined, action: undefined, actionSubjectId: undefined, attributes: { foo: 'bar' } }
 * extractDataFromOneAttribute({
 *  action: 'clicked',
 *  actionSubject: 'button',
 *  actionSubjectId: 'foo',
 *  attributes: { foo: 'bar' }
 * }) // { actionSubject: 'button', action: 'clicked', actionSubjectId: 'foo', attributes: { foo: 'bar' } }
 * ```
 */ const $b113f7b063b64ffa$var$extractDataFromOneAttribute = (one)=>{
    if (typeof one === 'string') return $b113f7b063b64ffa$var$extractDataFromStringAttribute(one);
    if ($b113f7b063b64ffa$export$a502e64ed48035b(one)) return one;
    return {
        actionSubject: undefined,
        action: undefined,
        actionSubjectId: undefined,
        attributes: one
    };
};
const $b113f7b063b64ffa$var$extractDataFromTwoAttributes = (actionSubjectAndAction, actionSubjectIdOrAttributes)=>{
    if (typeof actionSubjectIdOrAttributes === 'string') {
        const { action: action, actionSubject: actionSubject } = $b113f7b063b64ffa$var$extractDataFromStringAttribute(actionSubjectAndAction);
        const actionSubjectId = actionSubjectIdOrAttributes;
        return {
            actionSubject: actionSubject,
            action: action,
            actionSubjectId: actionSubjectId,
            attributes: undefined
        };
    }
    const { action: action, actionSubject: actionSubject, actionSubjectId: actionSubjectId } = $b113f7b063b64ffa$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: actionSubjectIdOrAttributes
    };
};
const $b113f7b063b64ffa$var$extractDataFromThreeAttributes = (actionSubjectAndAction, actionSubjectId, attributes)=>{
    const { action: action, actionSubject: actionSubject } = $b113f7b063b64ffa$var$extractDataFromStringAttribute(actionSubjectAndAction);
    return {
        actionSubject: actionSubject,
        action: action,
        actionSubjectId: actionSubjectId,
        attributes: attributes
    };
};
const $b113f7b063b64ffa$var$extractFromContext = (event, property)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    event.context.map((item)=>item[property]);
const $b113f7b063b64ffa$export$c9bdf245bf8922fc = (...attrs)=>{
    if (!attrs || !attrs.length) return {
        action: undefined,
        actionSubject: undefined,
        actionSubjectId: undefined,
        attributes: undefined
    };
    switch(attrs.length){
        case 1:
            return $b113f7b063b64ffa$var$extractDataFromOneAttribute(attrs[0]);
        case 2:
            return $b113f7b063b64ffa$var$extractDataFromTwoAttributes(attrs[0], attrs[1]);
        case 3:
            return $b113f7b063b64ffa$var$extractDataFromThreeAttributes(attrs[0], attrs[1], attrs[2]);
        default:
            throw Error('Can not fire an empty event');
    }
};
const $b113f7b063b64ffa$export$a3569ac53b82a914 = (event)=>event.payload.analyticsType;
const $b113f7b063b64ffa$export$fe94072fee8a6976 = (event)=>{
    const contextAttributes = $b113f7b063b64ffa$var$extractFromContext(event, 'attributes');
    const sources = $b113f7b063b64ffa$var$extractFromContext(event, 'source');
    const payloadAttributes = event.payload.attributes;
    const allAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextAttributes.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraAttributes), {}), payloadAttributes);
    const namespaces = sources.filter(Boolean).join('.');
    return (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
        ...allAttributes,
        namespaces: namespaces
    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
};
const $b113f7b063b64ffa$export$dd2b6e807fb37ba3 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'source').filter(Boolean));
const $b113f7b063b64ffa$export$6f40cdf6d42c018d = (event)=>{
    const { actionSubject: actionSubject } = event.payload;
    if (actionSubject) return actionSubject;
    const component = (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'component').filter(Boolean)) || (0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'componentName').filter(Boolean));
    return component;
};
const $b113f7b063b64ffa$export$6ca3170acb89054 = (event)=>event.payload.action;
const $b113f7b063b64ffa$export$b6f8db3ad0711b02 = (event)=>event.payload.actionSubjectId;
const $b113f7b063b64ffa$export$7c8178cc9001d237 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'containerId').filter(Boolean));
const $b113f7b063b64ffa$export$acc6f3e19803b3dc = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'containerType').filter(Boolean));
const $b113f7b063b64ffa$export$fa986b91291934c7 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'objectId').filter(Boolean));
const $b113f7b063b64ffa$export$11cc42aebef2ef3a = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($hlxpN)))($b113f7b063b64ffa$var$extractFromContext(event, 'objectType').filter(Boolean));
const $b113f7b063b64ffa$export$af63d7414243dad3 = (event)=>{
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($9O1Qa)))((0, (/*@__PURE__*/$parcel$interopDefault($cIPCk)))($b113f7b063b64ffa$var$extractFromContext(event, 'tags'))).filter(Boolean);
    return tags.length ? tags : undefined;
};
const $b113f7b063b64ffa$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $b113f7b063b64ffa$var$extractFromContext(event, 'containers');
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($6Fltw)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("7RK6D", function(module, exports) {
$parcel$export(module.exports, "getEvent", () => $fa3575f6b9b3c6ac$export$ee2085e97a04e027);
/* eslint-disable jira/filename-case */ /**
 * This library is the only place where you'd use raw analytics from atlaskit
 */ 
var $808aL = parcelRequire("808aL");

var $3irVK = parcelRequire("3irVK");


var $i3iX9 = parcelRequire("i3iX9");
const $fa3575f6b9b3c6ac$export$ee2085e97a04e027 = (event)=>{
    const analyticsType = (0, $i3iX9.getAnalyticsType)(event);
    const attributes = (0, $i3iX9.getAttributes)(event);
    const containers = (0, $i3iX9.getContainers)(event);
    const source = (0, $i3iX9.getSource)(event);
    const actionSubject = (0, $i3iX9.getActionSubject)(event);
    if (analyticsType === (0, $46f069e6c968f461$export$f1d537d508d2945a)) return {
        type: (0, $46f069e6c968f461$export$f1d537d508d2945a),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $46f069e6c968f461$export$a1562d08625f5d7e:
        case 0, $46f069e6c968f461$export$947dac6c72b26f81:
        case 0, $46f069e6c968f461$export$12346a674644c156:
            {
                const action = (0, $i3iX9.getAction)(event);
                const actionSubjectId = (0, $i3iX9.getActionSubjectId)(event);
                const containerId = (0, $i3iX9.getContainerId)(event);
                const containerType = (0, $i3iX9.getContainerType)(event);
                const objectId = (0, $i3iX9.getObjectId)(event);
                const objectType = (0, $i3iX9.getObjectType)(event);
                const tags = (0, $i3iX9.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($3irVK)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($808aL))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};

});


parcelRegister("1ByIU", function(module, exports) {
$parcel$export(module.exports, "isShallowEqual", () => $ee80644edd29d573$export$2225b4c39d37f8b3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $ee80644edd29d573$var$hasOwnProp = Object.prototype.hasOwnProperty;
const $ee80644edd29d573$export$2225b4c39d37f8b3 = (a, b, compare = Object.is)=>{
    if (compare(a, b)) return true;
    if (typeof a !== 'object' || typeof b !== 'object' || a === null || b === null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    let i = keysA.length;
    while(i--){
        const key = keysA[i];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'. | TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'unknown'.
        if (!$ee80644edd29d573$var$hasOwnProp.call(b, key) || !compare(a[key], b[key])) return false;
    }
    return true;
};

});


parcelRegister("7qI1K", function(module, exports) {
$parcel$export(module.exports, "extractFactoryFunction", () => $1df380afa450c61e$export$d9a70f5f8c7d4785);
$parcel$export(module.exports, "mapStateToPropsWithErrorHandling", () => $1df380afa450c61e$export$4b8cb2da7a763ee8);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $hFtK7 = parcelRequire("hFtK7");
const $1df380afa450c61e$export$d9a70f5f8c7d4785 = (fn)=>{
    if (!(fn && typeof fn === 'function' && fn.length === 0)) return fn;
    try {
        const result = fn();
        return typeof result === 'function' ? result : fn;
    } catch (e) {
        return fn;
    }
};
const $1df380afa450c61e$export$4b8cb2da7a763ee8 = (mapStateToProps)=>{
    // return non-wrapped mapStateToProps if not a function
    if (!mapStateToProps) return mapStateToProps;
    if (typeof mapStateToProps !== 'function') return mapStateToProps;
    // return wrapped mapStateToProps which catches error, reports it and throws error again
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...props)=>{
        try {
            return mapStateToProps(...props);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $hFtK7.fireErrorAnalytics)({
                meta: {
                    id: 'mapStateToProps',
                    packageName: 'jiraReactRedux',
                    teamName: 'magma'
                },
                error: e
            });
            throw e;
        }
    };
};

});


parcelRegister("n67Vb", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("iq7vU"));

});
parcelRegister("iq7vU", function(module, exports) {
'use strict';

var $hBqK0 = parcelRequire("hBqK0");

var $65VWP = parcelRequire("65VWP");

var $kXVrK = parcelRequire("kXVrK");

var $lXw4I = parcelRequire("lXw4I");

var $c5dR9 = parcelRequire("c5dR9");

var $aZhGa = parcelRequire("aZhGa");

var $bn2Kb = parcelRequire("bn2Kb");

var $bstJU = parcelRequire("bstJU");

var $15gDt = parcelRequire("15gDt");
var $d6907bc23139b4bd$var$loadQuery = $15gDt.loadQuery;

var $bBCVS = parcelRequire("bBCVS");

var $iYrAT = parcelRequire("iYrAT");

var $ew5o4 = parcelRequire("ew5o4");

var $d3iWa = parcelRequire("d3iWa");

var $ahfxy = parcelRequire("ahfxy");

var $b7aL9 = parcelRequire("b7aL9");

var $fReqW = parcelRequire("fReqW");

var $iEuHa = parcelRequire("iEuHa");

var $kwjrX = parcelRequire("kwjrX");

var $SfUsg = parcelRequire("SfUsg");

var $dmWeS = parcelRequire("dmWeS");

var $hj03U = parcelRequire("hj03U");

var $cv6fH = parcelRequire("cv6fH");

var $2S1Dv = parcelRequire("2S1Dv");

var $lLWgl = parcelRequire("lLWgl");

var $lIGkE = parcelRequire("lIGkE");
module.exports = {
    ConnectionHandler: $lIGkE.ConnectionHandler,
    QueryRenderer: $c5dR9,
    LocalQueryRenderer: $kXVrK,
    MutationTypes: $lIGkE.MutationTypes,
    RangeOperations: $lIGkE.RangeOperations,
    ReactRelayContext: $hBqK0,
    applyOptimisticMutation: $lIGkE.applyOptimisticMutation,
    commitLocalUpdate: $lIGkE.commitLocalUpdate,
    commitMutation: $lIGkE.commitMutation,
    createFragmentContainer: $65VWP.createContainer,
    createPaginationContainer: $lXw4I.createContainer,
    createRefetchContainer: $aZhGa.createContainer,
    fetchQuery_DEPRECATED: $lIGkE.fetchQuery_DEPRECATED,
    graphql: $lIGkE.graphql,
    readInlineData: $lIGkE.readInlineData,
    requestSubscription: $lIGkE.requestSubscription,
    EntryPointContainer: $bn2Kb,
    RelayEnvironmentProvider: $iYrAT,
    ProfilerContext: $bBCVS,
    fetchQuery: $lIGkE.fetchQuery,
    loadQuery: $d6907bc23139b4bd$var$loadQuery,
    loadEntryPoint: $bstJU,
    useClientQuery: $ew5o4,
    useFragment: $ahfxy,
    useLazyLoadQuery: $b7aL9,
    useEntryPointLoader: $d3iWa,
    useQueryLoader: $dmWeS,
    useMutation: $fReqW,
    usePaginationFragment: $iEuHa,
    usePreloadedQuery: $SfUsg,
    useRefetchableFragment: $hj03U,
    usePrefetchableForwardPaginationFragment: $kwjrX,
    useRelayEnvironment: $cv6fH,
    useSubscribeToInvalidationState: $2S1Dv,
    useSubscription: $lLWgl
};

});
parcelRegister("hBqK0", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $cd0aa292a4b98cf4$var$createRelayContext = $lIGkE.__internal.createRelayContext;
module.exports = $cd0aa292a4b98cf4$var$createRelayContext($euxye);

});
parcelRegister("lIGkE", function(module, exports) {
/**
 * Relay v20.1.1
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
module.exports = (parcelRequire("j5N5r"));

});
parcelRegister("j5N5r", function(module, exports) {
'use strict';

var $cHXj4 = parcelRequire("cHXj4");
var $de648f8b18ba0670$var$isErrorResult = $cHXj4.isErrorResult, $de648f8b18ba0670$var$isValueResult = $cHXj4.isValueResult;

var $3txKR = parcelRequire("3txKR");

var $8tGFT = parcelRequire("8tGFT");

var $8PXJh = parcelRequire("8PXJh");

var $gRVEw = parcelRequire("gRVEw");

var $56JnL = parcelRequire("56JnL");

var $4UoGp = parcelRequire("4UoGp");

var $4Sxsl = parcelRequire("4Sxsl");

var $5RzQz = parcelRequire("5RzQz");

var $7Xd49 = parcelRequire("7Xd49");

var $9wNSI = parcelRequire("9wNSI");

var $hE4Is = parcelRequire("hE4Is");

var $7Rjp9 = parcelRequire("7Rjp9");

var $ctzoR = parcelRequire("ctzoR");

var $fWLbj = parcelRequire("fWLbj");

var $lQR7T = parcelRequire("lQR7T");

var $6s54L = parcelRequire("6s54L");

var $9eVAj = parcelRequire("9eVAj");
var $de648f8b18ba0670$var$generateClientID = $9eVAj.generateClientID, $de648f8b18ba0670$var$generateUniqueClientID = $9eVAj.generateUniqueClientID, $de648f8b18ba0670$var$isClientID = $9eVAj.isClientID;

var $gUWzw = parcelRequire("gUWzw");

var $cExt9 = parcelRequire("cExt9");

var $55dHj = parcelRequire("55dHj");

var $gJGd4 = parcelRequire("gJGd4");

var $1ocpj = parcelRequire("1ocpj");
var $de648f8b18ba0670$var$isSuspenseSentinel = $1ocpj.isSuspenseSentinel, $de648f8b18ba0670$var$suspenseSentinel = $1ocpj.suspenseSentinel;

var $4Mqmi = parcelRequire("4Mqmi");

var $8FBLb = parcelRequire("8FBLb");

var $cbsiZ = parcelRequire("cbsiZ");

var $342kw = parcelRequire("342kw");

var $1v3vf = parcelRequire("1v3vf");

var $6ZixS = parcelRequire("6ZixS");

var $dPVEr = parcelRequire("dPVEr");

var $kg5Mx = parcelRequire("kg5Mx");

var $bdg1N = parcelRequire("bdg1N");

var $gqyVK = parcelRequire("gqyVK");

var $cvcC4 = parcelRequire("cvcC4");

var $e4ijV = parcelRequire("e4ijV");

var $iOxmF = parcelRequire("iOxmF");

var $6DpFX = parcelRequire("6DpFX");

var $2rPtW = parcelRequire("2rPtW");

var $fHswY = parcelRequire("fHswY");

var $k61LS = parcelRequire("k61LS");

var $7DV09 = parcelRequire("7DV09");

var $65k9J = parcelRequire("65k9J");

var $1mn05 = parcelRequire("1mn05");

var $6Jn6k = parcelRequire("6Jn6k");

var $6Gqui = parcelRequire("6Gqui");

var $91TmW = parcelRequire("91TmW");

var $b0rkD = parcelRequire("b0rkD");

var $fSw0O = parcelRequire("fSw0O");
var $de648f8b18ba0670$var$handlePotentialSnapshotErrors = $fSw0O.handlePotentialSnapshotErrors;

var $3Lb8h = parcelRequire("3Lb8h");

var $dV5wZ = parcelRequire("dV5wZ");

var $fT9vU = parcelRequire("fT9vU");

var $2HvH8 = parcelRequire("2HvH8");

var $5mAhc = parcelRequire("5mAhc");

var $3doX1 = parcelRequire("3doX1");

var $kgraI = parcelRequire("kgraI");

var $jR3oE = parcelRequire("jR3oE");

var $6LM4u = parcelRequire("6LM4u");

var $zM4Yi = parcelRequire("zM4Yi");
var $de648f8b18ba0670$var$hasCycle = $zM4Yi.hasCycle, $de648f8b18ba0670$var$stableCopy = $zM4Yi.stableCopy;

var $ay8VC = parcelRequire("ay8VC");
var $de648f8b18ba0670$var$mapStr, $de648f8b18ba0670$var$setStr, $de648f8b18ba0670$var$promiseStr, $de648f8b18ba0670$var$objStr;
module.exports = {
    Environment: $342kw,
    Network: $7Xd49,
    Observable: $9wNSI,
    QueryResponseCache: $hE4Is,
    RecordSource: $gqyVK,
    Record: $6ZixS,
    ReplaySubject: $6LM4u,
    Store: $kg5Mx,
    areEqualSelectors: $dPVEr.areEqualSelectors,
    createFragmentSpecResolver: $gUWzw,
    createNormalizationSelector: $dPVEr.createNormalizationSelector,
    createOperationDescriptor: $1v3vf.createOperationDescriptor,
    createReaderSelector: $dPVEr.createReaderSelector,
    createRequestDescriptor: $1v3vf.createRequestDescriptor,
    getArgumentValues: $cvcC4.getArgumentValues,
    getDataIDsFromFragment: $dPVEr.getDataIDsFromFragment,
    getDataIDsFromObject: $dPVEr.getDataIDsFromObject,
    getNode: $lQR7T.getNode,
    getFragment: $lQR7T.getFragment,
    getInlineDataFragment: $lQR7T.getInlineDataFragment,
    getModuleComponentKey: $cvcC4.getModuleComponentKey,
    getModuleOperationKey: $cvcC4.getModuleOperationKey,
    getPaginationFragment: $lQR7T.getPaginationFragment,
    getPluralSelector: $dPVEr.getPluralSelector,
    getRefetchableFragment: $lQR7T.getRefetchableFragment,
    getRequest: $lQR7T.getRequest,
    getRequestIdentifier: $91TmW,
    getSelector: $dPVEr.getSelector,
    getSelectorsFromObject: $dPVEr.getSelectorsFromObject,
    getSingularSelector: $dPVEr.getSingularSelector,
    getStorageKey: $cvcC4.getStorageKey,
    getVariablesFromFragment: $dPVEr.getVariablesFromFragment,
    getVariablesFromObject: $dPVEr.getVariablesFromObject,
    getVariablesFromPluralFragment: $dPVEr.getVariablesFromPluralFragment,
    getVariablesFromSingularFragment: $dPVEr.getVariablesFromSingularFragment,
    handlePotentialSnapshotErrors: $de648f8b18ba0670$var$handlePotentialSnapshotErrors,
    graphql: $lQR7T.graphql,
    isErrorResult: $de648f8b18ba0670$var$isErrorResult,
    isValueResult: $de648f8b18ba0670$var$isValueResult,
    isFragment: $lQR7T.isFragment,
    isInlineDataFragment: $lQR7T.isInlineDataFragment,
    isSuspenseSentinel: $de648f8b18ba0670$var$isSuspenseSentinel,
    suspenseSentinel: $de648f8b18ba0670$var$suspenseSentinel,
    isRequest: $lQR7T.isRequest,
    readInlineData: $8FBLb,
    readFragment: $e4ijV.readFragment,
    MutationTypes: $5RzQz.MutationTypes,
    RangeOperations: $5RzQz.RangeOperations,
    DefaultHandlerProvider: $gRVEw,
    ConnectionHandler: $3txKR,
    MutationHandlers: $8PXJh,
    VIEWER_ID: $iOxmF.VIEWER_ID,
    VIEWER_TYPE: $iOxmF.VIEWER_TYPE,
    applyOptimisticMutation: $56JnL,
    commitLocalUpdate: $4UoGp,
    commitMutation: $4Sxsl,
    fetchQuery: $7Rjp9,
    fetchQuery_DEPRECATED: $ctzoR,
    isRelayModernEnvironment: $gJGd4,
    requestSubscription: $6DpFX,
    ConnectionInterface: $8tGFT,
    PreloadableQueryRegistry: $6s54L,
    RelayProfiler: $jR3oE,
    createPayloadFor3DField: $2rPtW,
    RelayConcreteNode: $2HvH8,
    RelayError: $3doX1,
    RelayFeatureFlags: $kgraI,
    DEFAULT_HANDLE_KEY: $5mAhc.DEFAULT_HANDLE_KEY,
    FRAGMENTS_KEY: $cvcC4.FRAGMENTS_KEY,
    FRAGMENT_OWNER_KEY: $cvcC4.FRAGMENT_OWNER_KEY,
    ID_KEY: $cvcC4.ID_KEY,
    REF_KEY: $cvcC4.REF_KEY,
    REFS_KEY: $cvcC4.REFS_KEY,
    ROOT_ID: $cvcC4.ROOT_ID,
    ROOT_TYPE: $cvcC4.ROOT_TYPE,
    TYPENAME_KEY: $cvcC4.TYPENAME_KEY,
    deepFreeze: $fHswY,
    generateClientID: $de648f8b18ba0670$var$generateClientID,
    generateUniqueClientID: $de648f8b18ba0670$var$generateUniqueClientID,
    getRelayHandleKey: $6Gqui,
    isClientID: $de648f8b18ba0670$var$isClientID,
    isPromise: $3Lb8h,
    isScalarAndEqual: $dV5wZ,
    recycleNodesInto: $fT9vU,
    stableCopy: $de648f8b18ba0670$var$stableCopy,
    hasCycle: $de648f8b18ba0670$var$hasCycle,
    getFragmentIdentifier: $k61LS,
    getRefetchMetadata: $6Jn6k,
    getPaginationMetadata: $7DV09,
    getPaginationVariables: $65k9J,
    getPendingOperationsForFragment: $1mn05,
    getValueAtPath: $b0rkD,
    __internal: {
        ResolverFragments: $e4ijV,
        OperationTracker: $bdg1N,
        createRelayContext: $cExt9,
        createRelayLoggingContext: $55dHj,
        getOperationVariables: $cbsiZ.getOperationVariables,
        getLocalVariables: $cbsiZ.getLocalVariables,
        fetchQuery: $fWLbj.fetchQuery,
        fetchQueryDeduped: $fWLbj.fetchQueryDeduped,
        getPromiseForActiveRequest: $fWLbj.getPromiseForActiveRequest,
        getObservableForActiveRequest: $fWLbj.getObservableForActiveRequest,
        normalizeResponse: $4Mqmi,
        withProvidedVariables: $ay8VC
    }
};

});
parcelRegister("cHXj4", function(module, exports) {
'use strict';

var $jQc57 = parcelRequire("jQc57");

var $6CxHn = parcelRequire("6CxHn");
var $9407813ff62dc465$var$observeFragment = $6CxHn.observeFragment;

var $hITKJ = parcelRequire("hITKJ");
var $9407813ff62dc465$var$observeQuery = $hITKJ.observeQuery;

var $ecgq5 = parcelRequire("ecgq5");
var $9407813ff62dc465$var$waitForFragmentData = $ecgq5.waitForFragmentData;
function $9407813ff62dc465$var$isValueResult(input) {
    return input.ok === true;
}
function $9407813ff62dc465$var$isErrorResult(input) {
    return input.ok === false;
}
module.exports = {
    resolverDataInjector: $jQc57,
    isValueResult: $9407813ff62dc465$var$isValueResult,
    isErrorResult: $9407813ff62dc465$var$isErrorResult,
    observeQuery: $9407813ff62dc465$var$observeQuery,
    observeFragment: $9407813ff62dc465$var$observeFragment,
    waitForFragmentData: $9407813ff62dc465$var$waitForFragmentData
};

});
parcelRegister("jQc57", function(module, exports) {
'use strict';

var $e4ijV = parcelRequire("e4ijV");
var $e71c3ec804737db8$var$readFragment = $e4ijV.readFragment;

var $jwy7p = parcelRequire("jwy7p");
function $e71c3ec804737db8$var$resolverDataInjector(fragment, _resolverFn, fieldName, isRequiredField) {
    var resolverFn = _resolverFn;
    return function(fragmentKey, args, resolverContext) {
        var data = $e71c3ec804737db8$var$readFragment(fragment, fragmentKey);
        if (fieldName != null) {
            if (data == null) {
                if (isRequiredField === true) $jwy7p(false);
                else return resolverFn(null, args, resolverContext);
            }
            if (fieldName in data) {
                if (isRequiredField === true) !(data[fieldName] != null) && $jwy7p(false);
                return resolverFn(data[fieldName], args, resolverContext);
            } else $jwy7p(false);
        } else return resolverFn(null, args, resolverContext);
    };
}
module.exports = $e71c3ec804737db8$var$resolverDataInjector;

});
parcelRegister("e4ijV", function(module, exports) {
'use strict';

var $lQR7T = parcelRequire("lQR7T");
var $a3dfa6726874c180$var$getFragment = $lQR7T.getFragment;

var $fSw0O = parcelRequire("fSw0O");
var $a3dfa6726874c180$var$eventShouldThrow = $fSw0O.eventShouldThrow;

var $dPVEr = parcelRequire("dPVEr");
var $a3dfa6726874c180$var$getSelector = $dPVEr.getSelector;

var $jwy7p = parcelRequire("jwy7p");
var $a3dfa6726874c180$var$contextStack = [];
function $a3dfa6726874c180$var$withResolverContext(context, cb) {
    $a3dfa6726874c180$var$contextStack.push(context);
    try {
        return cb();
    } finally{
        $a3dfa6726874c180$var$contextStack.pop();
    }
}
function $a3dfa6726874c180$var$readFragment(fragmentInput, fragmentKey) {
    if (!$a3dfa6726874c180$var$contextStack.length) throw new Error('readFragment should be called only from within a Relay Resolver function.');
    var context = $a3dfa6726874c180$var$contextStack[$a3dfa6726874c180$var$contextStack.length - 1];
    var fragmentNode = $a3dfa6726874c180$var$getFragment(fragmentInput);
    var fragmentSelector = $a3dfa6726874c180$var$getSelector(fragmentNode, fragmentKey);
    !(fragmentSelector != null) && $jwy7p(false);
    !(fragmentSelector.kind === 'SingularReaderSelector') && $jwy7p(false);
    var _context$getDataForRe = context.getDataForResolverFragment(fragmentSelector, fragmentKey), data = _context$getDataForRe.data, isMissingData = _context$getDataForRe.isMissingData, fieldErrors = _context$getDataForRe.fieldErrors;
    if (isMissingData || fieldErrors != null && fieldErrors.some($a3dfa6726874c180$var$eventShouldThrow)) throw $a3dfa6726874c180$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL;
    return data;
}
var $a3dfa6726874c180$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = {};
module.exports = {
    readFragment: $a3dfa6726874c180$var$readFragment,
    withResolverContext: $a3dfa6726874c180$var$withResolverContext,
    RESOLVER_FRAGMENT_ERRORED_SENTINEL: $a3dfa6726874c180$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL
};

});
parcelRegister("lQR7T", function(module, exports) {
'use strict';

var $2HvH8 = parcelRequire("2HvH8");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $fe87aa183d51c6b1$var$graphql(strings) {
    $jwy7p(false);
}
function $fe87aa183d51c6b1$var$getNode(taggedNode) {
    var node = taggedNode;
    if (typeof node === 'function') node = node();
    else if (node["default"]) node = node["default"];
    return node;
}
function $fe87aa183d51c6b1$var$isFragment(node) {
    var fragment = $fe87aa183d51c6b1$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $2HvH8.FRAGMENT;
}
function $fe87aa183d51c6b1$var$isRequest(node) {
    var request = $fe87aa183d51c6b1$var$getNode(node);
    return typeof request === 'object' && request !== null && request.kind === $2HvH8.REQUEST;
}
function $fe87aa183d51c6b1$var$isUpdatableQuery(node) {
    var updatableQuery = $fe87aa183d51c6b1$var$getNode(node);
    return typeof updatableQuery === 'object' && updatableQuery !== null && updatableQuery.kind === $2HvH8.UPDATABLE_QUERY;
}
function $fe87aa183d51c6b1$var$isInlineDataFragment(node) {
    var fragment = $fe87aa183d51c6b1$var$getNode(node);
    return typeof fragment === 'object' && fragment !== null && fragment.kind === $2HvH8.INLINE_DATA_FRAGMENT;
}
function $fe87aa183d51c6b1$var$getFragment(taggedNode) {
    var fragment = $fe87aa183d51c6b1$var$getNode(taggedNode);
    !$fe87aa183d51c6b1$var$isFragment(fragment) && $jwy7p(false);
    return fragment;
}
function $fe87aa183d51c6b1$var$getPaginationFragment(taggedNode) {
    var _fragment$metadata;
    var fragment = $fe87aa183d51c6b1$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.refetch;
    var connection = refetch === null || refetch === void 0 ? void 0 : refetch.connection;
    if (refetch === null || typeof refetch !== 'object' || connection === null || typeof connection !== 'object') return null;
    return fragment;
}
function $fe87aa183d51c6b1$var$getRefetchableFragment(taggedNode) {
    var _fragment$metadata2;
    var fragment = $fe87aa183d51c6b1$var$getFragment(taggedNode);
    var refetch = (_fragment$metadata2 = fragment.metadata) === null || _fragment$metadata2 === void 0 ? void 0 : _fragment$metadata2.refetch;
    if (refetch === null || typeof refetch !== 'object') return null;
    return fragment;
}
function $fe87aa183d51c6b1$var$getRequest(taggedNode) {
    var request = $fe87aa183d51c6b1$var$getNode(taggedNode);
    !$fe87aa183d51c6b1$var$isRequest(request) && $jwy7p(false);
    return request;
}
function $fe87aa183d51c6b1$var$getUpdatableQuery(taggedNode) {
    var updatableQuery = $fe87aa183d51c6b1$var$getNode(taggedNode);
    !$fe87aa183d51c6b1$var$isUpdatableQuery(updatableQuery) && $jwy7p(false);
    return updatableQuery;
}
function $fe87aa183d51c6b1$var$getInlineDataFragment(taggedNode) {
    var fragment = $fe87aa183d51c6b1$var$getNode(taggedNode);
    !$fe87aa183d51c6b1$var$isInlineDataFragment(fragment) && $jwy7p(false);
    return fragment;
}
module.exports = {
    getFragment: $fe87aa183d51c6b1$var$getFragment,
    getNode: $fe87aa183d51c6b1$var$getNode,
    getPaginationFragment: $fe87aa183d51c6b1$var$getPaginationFragment,
    getRefetchableFragment: $fe87aa183d51c6b1$var$getRefetchableFragment,
    getRequest: $fe87aa183d51c6b1$var$getRequest,
    getUpdatableQuery: $fe87aa183d51c6b1$var$getUpdatableQuery,
    getInlineDataFragment: $fe87aa183d51c6b1$var$getInlineDataFragment,
    graphql: $fe87aa183d51c6b1$var$graphql,
    isFragment: $fe87aa183d51c6b1$var$isFragment,
    isRequest: $fe87aa183d51c6b1$var$isRequest,
    isUpdatableQuery: $fe87aa183d51c6b1$var$isUpdatableQuery,
    isInlineDataFragment: $fe87aa183d51c6b1$var$isInlineDataFragment
};

});
parcelRegister("2HvH8", function(module, exports) {
'use strict';
var $1f782edc89b5dfb2$var$RelayConcreteNode = {
    ACTOR_CHANGE: 'ActorChange',
    CATCH_FIELD: 'CatchField',
    CONDITION: 'Condition',
    CLIENT_COMPONENT: 'ClientComponent',
    CLIENT_EDGE_TO_SERVER_OBJECT: 'ClientEdgeToServerObject',
    CLIENT_EDGE_TO_CLIENT_OBJECT: 'ClientEdgeToClientObject',
    CLIENT_EXTENSION: 'ClientExtension',
    DEFER: 'Defer',
    CONNECTION: 'Connection',
    FRAGMENT: 'Fragment',
    FRAGMENT_SPREAD: 'FragmentSpread',
    INLINE_DATA_FRAGMENT_SPREAD: 'InlineDataFragmentSpread',
    INLINE_DATA_FRAGMENT: 'InlineDataFragment',
    INLINE_FRAGMENT: 'InlineFragment',
    LINKED_FIELD: 'LinkedField',
    LINKED_HANDLE: 'LinkedHandle',
    LITERAL: 'Literal',
    LIST_VALUE: 'ListValue',
    LOCAL_ARGUMENT: 'LocalArgument',
    MODULE_IMPORT: 'ModuleImport',
    ALIASED_FRAGMENT_SPREAD: 'AliasedFragmentSpread',
    ALIASED_INLINE_FRAGMENT_SPREAD: 'AliasedInlineFragmentSpread',
    RELAY_RESOLVER: 'RelayResolver',
    RELAY_LIVE_RESOLVER: 'RelayLiveResolver',
    REQUIRED_FIELD: 'RequiredField',
    OBJECT_VALUE: 'ObjectValue',
    OPERATION: 'Operation',
    REQUEST: 'Request',
    ROOT_ARGUMENT: 'RootArgument',
    SCALAR_FIELD: 'ScalarField',
    SCALAR_HANDLE: 'ScalarHandle',
    SPLIT_OPERATION: 'SplitOperation',
    STREAM: 'Stream',
    TYPE_DISCRIMINATOR: 'TypeDiscriminator',
    UPDATABLE_QUERY: 'UpdatableQuery',
    VARIABLE: 'Variable'
};
module.exports = $1f782edc89b5dfb2$var$RelayConcreteNode;

});

parcelRegister("jwy7p", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $e36b78ae9a067421$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = $e36b78ae9a067421$var$invariant;

});

parcelRegister("i0yon", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $2UAbb = parcelRequire("2UAbb");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $d1c2e7a5c12db453$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $d1c2e7a5c12db453$var$warning = $2UAbb;
module.exports = $d1c2e7a5c12db453$var$warning;

});
parcelRegister("2UAbb", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $21ece030e7976023$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $21ece030e7976023$var$emptyFunction = function emptyFunction() {};
$21ece030e7976023$var$emptyFunction.thatReturns = $21ece030e7976023$var$makeEmptyFunction;
$21ece030e7976023$var$emptyFunction.thatReturnsFalse = $21ece030e7976023$var$makeEmptyFunction(false);
$21ece030e7976023$var$emptyFunction.thatReturnsTrue = $21ece030e7976023$var$makeEmptyFunction(true);
$21ece030e7976023$var$emptyFunction.thatReturnsNull = $21ece030e7976023$var$makeEmptyFunction(null);
$21ece030e7976023$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$21ece030e7976023$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $21ece030e7976023$var$emptyFunction;

});



parcelRegister("fSw0O", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $b8f4bb1ee56b863b$var$_interopRequireDefault = $8gviu.default;

var $b8f4bb1ee56b863b$var$_objectSpread2 = $b8f4bb1ee56b863b$var$_interopRequireDefault((parcelRequire("lhogL")));

var $b8f4bb1ee56b863b$var$_createForOfIteratorHelper2 = $b8f4bb1ee56b863b$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $jwy7p = parcelRequire("jwy7p");
function $b8f4bb1ee56b863b$var$handleFieldErrors(environment, fieldErrors, loggingContext) {
    var _iterator = (0, $b8f4bb1ee56b863b$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var fieldError = _step.value;
            environment.relayFieldLogger((0, $b8f4bb1ee56b863b$var$_objectSpread2["default"])((0, $b8f4bb1ee56b863b$var$_objectSpread2["default"])({}, fieldError), {}, {
                uiContext: loggingContext
            }));
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    var _iterator2 = (0, $b8f4bb1ee56b863b$var$_createForOfIteratorHelper2["default"])(fieldErrors), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _fieldError = _step2.value;
            if ($b8f4bb1ee56b863b$var$eventShouldThrow(_fieldError)) switch(_fieldError.kind){
                case 'relay_resolver.error':
                    throw new Error("Relay: Resolver error at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'. Message: ").concat(_fieldError.error.message));
                case 'relay_field_payload.error':
                    throw new Error("Relay: Unexpected response payload - check server logs for details.");
                case 'missing_expected_data.throw':
                    throw new Error("Relay: Missing expected data at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.throw':
                    throw new Error("Relay: Missing @required value at path '".concat(_fieldError.fieldPath, "' in '").concat(_fieldError.owner, "'."));
                case 'missing_required_field.log':
                case 'missing_expected_data.log':
                    break;
                default:
                    _fieldError.kind;
                    $jwy7p(false);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $b8f4bb1ee56b863b$var$eventShouldThrow(event) {
    switch(event.kind){
        case 'relay_resolver.error':
        case 'relay_field_payload.error':
            return event.shouldThrow && !event.handled;
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
            return !event.handled;
        case 'missing_required_field.log':
        case 'missing_expected_data.log':
            return false;
        default:
            event.kind;
            throw new Error('Relay: Unexpected event kind');
    }
}
function $b8f4bb1ee56b863b$var$handlePotentialSnapshotErrors(environment, fieldErrors, loggingContext) {
    if (fieldErrors != null) $b8f4bb1ee56b863b$var$handleFieldErrors(environment, fieldErrors, loggingContext);
}
module.exports = {
    handlePotentialSnapshotErrors: $b8f4bb1ee56b863b$var$handlePotentialSnapshotErrors,
    eventShouldThrow: $b8f4bb1ee56b863b$var$eventShouldThrow
};

});

parcelRegister("dPVEr", function(module, exports) {
'use strict';

var $cbsiZ = parcelRequire("cbsiZ");
var $a12cc21dd54cb0bd$var$getFragmentVariables = $cbsiZ.getFragmentVariables;

var $cvcC4 = parcelRequire("cvcC4");
var $a12cc21dd54cb0bd$var$CLIENT_EDGE_TRAVERSAL_PATH = $cvcC4.CLIENT_EDGE_TRAVERSAL_PATH, $a12cc21dd54cb0bd$var$FRAGMENT_OWNER_KEY = $cvcC4.FRAGMENT_OWNER_KEY, $a12cc21dd54cb0bd$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT = $cvcC4.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT, $a12cc21dd54cb0bd$var$FRAGMENTS_KEY = $cvcC4.FRAGMENTS_KEY, $a12cc21dd54cb0bd$var$ID_KEY = $cvcC4.ID_KEY;

var $3UWLk = parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $a12cc21dd54cb0bd$var$getSingularSelector(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $jwy7p(false);
    var dataID = item[$a12cc21dd54cb0bd$var$ID_KEY];
    var fragments = item[$a12cc21dd54cb0bd$var$FRAGMENTS_KEY];
    var mixedOwner = item[$a12cc21dd54cb0bd$var$FRAGMENT_OWNER_KEY];
    var mixedClientEdgeTraversalPath = item[$a12cc21dd54cb0bd$var$CLIENT_EDGE_TRAVERSAL_PATH];
    if (typeof dataID === 'string' && typeof fragments === 'object' && fragments !== null && typeof fragments[fragment.name] === 'object' && fragments[fragment.name] !== null && typeof mixedOwner === 'object' && mixedOwner !== null && (mixedClientEdgeTraversalPath == null || Array.isArray(mixedClientEdgeTraversalPath))) {
        var owner = mixedOwner;
        var clientEdgeTraversalPath = mixedClientEdgeTraversalPath;
        var argumentVariables = fragments[fragment.name];
        var fragmentVariables = $a12cc21dd54cb0bd$var$getFragmentVariables(fragment, owner.variables, argumentVariables);
        var isWithinUnmatchedTypeRefinement = argumentVariables[$a12cc21dd54cb0bd$var$FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] === true;
        return $a12cc21dd54cb0bd$var$createReaderSelector(fragment, dataID, fragmentVariables, owner, isWithinUnmatchedTypeRefinement, clientEdgeTraversalPath);
    }
    var stringifiedItem;
    return null;
}
function $a12cc21dd54cb0bd$var$getPluralSelector(fragment, items) {
    var selectors = null;
    items.forEach(function(item, ii) {
        var selector = item != null ? $a12cc21dd54cb0bd$var$getSingularSelector(fragment, item) : null;
        if (selector != null) {
            selectors = selectors || [];
            selectors.push(selector);
        }
    });
    if (selectors == null) return null;
    else return {
        kind: 'PluralReaderSelector',
        selectors: selectors
    };
}
function $a12cc21dd54cb0bd$var$getSelector(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getPluralSelector(fragment, item);
    } else {
        !!Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getSingularSelector(fragment, item);
    }
}
function $a12cc21dd54cb0bd$var$getSelectorsFromObject(fragments, object) {
    var selectors = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        selectors[key] = $a12cc21dd54cb0bd$var$getSelector(fragment, item);
    }
    return selectors;
}
function $a12cc21dd54cb0bd$var$getDataIDsFromObject(fragments, object) {
    var ids = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        ids[key] = $a12cc21dd54cb0bd$var$getDataIDsFromFragment(fragment, item);
    }
    return ids;
}
function $a12cc21dd54cb0bd$var$getDataIDsFromFragment(fragment, item) {
    if (item == null) return item;
    else if (fragment.metadata && fragment.metadata.plural === true) {
        !Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getDataIDs(fragment, item);
    } else {
        !!Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getDataID(fragment, item);
    }
}
function $a12cc21dd54cb0bd$var$getDataIDs(fragment, items) {
    var ids = null;
    items.forEach(function(item) {
        var id = item != null ? $a12cc21dd54cb0bd$var$getDataID(fragment, item) : null;
        if (id != null) {
            ids = ids || [];
            ids.push(id);
        }
    });
    return ids;
}
function $a12cc21dd54cb0bd$var$getDataID(fragment, item) {
    !(typeof item === 'object' && item !== null && !Array.isArray(item)) && $jwy7p(false);
    var dataID = item[$a12cc21dd54cb0bd$var$ID_KEY];
    if (typeof dataID === 'string') return dataID;
    return null;
}
function $a12cc21dd54cb0bd$var$getVariablesFromObject(fragments, object) {
    var variables = {};
    for(var key in fragments)if (fragments.hasOwnProperty(key)) {
        var fragment = fragments[key];
        var item = object[key];
        var itemVariables = $a12cc21dd54cb0bd$var$getVariablesFromFragment(fragment, item);
        Object.assign(variables, itemVariables);
    }
    return variables;
}
function $a12cc21dd54cb0bd$var$getVariablesFromFragment(fragment, item) {
    var _fragment$metadata;
    if (item == null) return {};
    else if (((_fragment$metadata = fragment.metadata) === null || _fragment$metadata === void 0 ? void 0 : _fragment$metadata.plural) === true) {
        !Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getVariablesFromPluralFragment(fragment, item);
    } else {
        !!Array.isArray(item) && $jwy7p(false);
        return $a12cc21dd54cb0bd$var$getVariablesFromSingularFragment(fragment, item) || {};
    }
}
function $a12cc21dd54cb0bd$var$getVariablesFromSingularFragment(fragment, item) {
    var selector = $a12cc21dd54cb0bd$var$getSingularSelector(fragment, item);
    if (!selector) return null;
    return selector.variables;
}
function $a12cc21dd54cb0bd$var$getVariablesFromPluralFragment(fragment, items) {
    var variables = {};
    items.forEach(function(value, ii) {
        if (value != null) {
            var itemVariables = $a12cc21dd54cb0bd$var$getVariablesFromSingularFragment(fragment, value);
            if (itemVariables != null) Object.assign(variables, itemVariables);
        }
    });
    return variables;
}
function $a12cc21dd54cb0bd$var$areEqualSingularSelectors(thisSelector, thatSelector) {
    return thisSelector.dataID === thatSelector.dataID && thisSelector.node === thatSelector.node && $3UWLk(thisSelector.variables, thatSelector.variables) && $a12cc21dd54cb0bd$var$areEqualOwners(thisSelector.owner, thatSelector.owner) && thisSelector.isWithinUnmatchedTypeRefinement === thatSelector.isWithinUnmatchedTypeRefinement && $a12cc21dd54cb0bd$var$areEqualClientEdgeTraversalPaths(thisSelector.clientEdgeTraversalPath, thatSelector.clientEdgeTraversalPath);
}
function $a12cc21dd54cb0bd$var$areEqualOwners(thisOwner, thatOwner) {
    if (thisOwner === thatOwner) return true;
    else return thisOwner.identifier === thatOwner.identifier && $3UWLk(thisOwner.cacheConfig, thatOwner.cacheConfig);
}
function $a12cc21dd54cb0bd$var$areEqualClientEdgeTraversalPaths(thisPath, thatPath) {
    if (thisPath === thatPath) return true;
    if (thisPath == null || thatPath == null || thisPath.length !== thatPath.length) return false;
    var idx = thisPath.length;
    while(idx--){
        var a = thisPath[idx];
        var b = thatPath[idx];
        if (a === b) continue;
        if (a == null || b == null || a.clientEdgeDestinationID !== b.clientEdgeDestinationID || a.readerClientEdge !== b.readerClientEdge) return false;
    }
    return true;
}
function $a12cc21dd54cb0bd$var$areEqualSelectors(a, b) {
    if (a === b) return true;
    else if (a == null) return b == null;
    else if (b == null) return a == null;
    else if (a.kind === 'SingularReaderSelector' && b.kind === 'SingularReaderSelector') return $a12cc21dd54cb0bd$var$areEqualSingularSelectors(a, b);
    else if (a.kind === 'PluralReaderSelector' && b.kind === 'PluralReaderSelector') return a.selectors.length === b.selectors.length && a.selectors.every(function(s, i) {
        return $a12cc21dd54cb0bd$var$areEqualSingularSelectors(s, b.selectors[i]);
    });
    else return false;
}
function $a12cc21dd54cb0bd$var$createReaderSelector(fragment, dataID, variables, request) {
    var isWithinUnmatchedTypeRefinement = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var clientEdgeTraversalPath = arguments.length > 5 ? arguments[5] : undefined;
    return {
        kind: 'SingularReaderSelector',
        dataID: dataID,
        isWithinUnmatchedTypeRefinement: isWithinUnmatchedTypeRefinement,
        clientEdgeTraversalPath: clientEdgeTraversalPath !== null && clientEdgeTraversalPath !== void 0 ? clientEdgeTraversalPath : null,
        node: fragment,
        variables: variables,
        owner: request
    };
}
function $a12cc21dd54cb0bd$var$createNormalizationSelector(node, dataID, variables) {
    return {
        dataID: dataID,
        node: node,
        variables: variables
    };
}
module.exports = {
    areEqualSelectors: $a12cc21dd54cb0bd$var$areEqualSelectors,
    createReaderSelector: $a12cc21dd54cb0bd$var$createReaderSelector,
    createNormalizationSelector: $a12cc21dd54cb0bd$var$createNormalizationSelector,
    getDataIDsFromFragment: $a12cc21dd54cb0bd$var$getDataIDsFromFragment,
    getDataIDsFromObject: $a12cc21dd54cb0bd$var$getDataIDsFromObject,
    getSingularSelector: $a12cc21dd54cb0bd$var$getSingularSelector,
    getPluralSelector: $a12cc21dd54cb0bd$var$getPluralSelector,
    getSelector: $a12cc21dd54cb0bd$var$getSelector,
    getSelectorsFromObject: $a12cc21dd54cb0bd$var$getSelectorsFromObject,
    getVariablesFromSingularFragment: $a12cc21dd54cb0bd$var$getVariablesFromSingularFragment,
    getVariablesFromPluralFragment: $a12cc21dd54cb0bd$var$getVariablesFromPluralFragment,
    getVariablesFromFragment: $a12cc21dd54cb0bd$var$getVariablesFromFragment,
    getVariablesFromObject: $a12cc21dd54cb0bd$var$getVariablesFromObject
};

});
parcelRegister("cbsiZ", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $8dec77f8d9387ea3$var$_interopRequireDefault = $8gviu.default;

var $8dec77f8d9387ea3$var$_objectSpread2 = $8dec77f8d9387ea3$var$_interopRequireDefault((parcelRequire("lhogL")));

var $cvcC4 = parcelRequire("cvcC4");
var $8dec77f8d9387ea3$var$getArgumentValues = $cvcC4.getArgumentValues;

var $jwy7p = parcelRequire("jwy7p");
function $8dec77f8d9387ea3$var$getFragmentVariables(fragment, rootVariables, argumentVariables) {
    if (fragment.argumentDefinitions == null) return argumentVariables;
    var variables;
    fragment.argumentDefinitions.forEach(function(definition) {
        if (argumentVariables.hasOwnProperty(definition.name)) return;
        variables = variables || (0, $8dec77f8d9387ea3$var$_objectSpread2["default"])({}, argumentVariables);
        switch(definition.kind){
            case 'LocalArgument':
                variables[definition.name] = definition.defaultValue;
                break;
            case 'RootArgument':
                if (!rootVariables.hasOwnProperty(definition.name)) {
                    variables[definition.name] = undefined;
                    break;
                }
                variables[definition.name] = rootVariables[definition.name];
                break;
            default:
                definition;
                $jwy7p(false);
        }
    });
    return variables || argumentVariables;
}
function $8dec77f8d9387ea3$var$getOperationVariables(operation, providedVariables, variables) {
    var operationVariables = {};
    operation.argumentDefinitions.forEach(function(def) {
        var value = def.defaultValue;
        if (variables[def.name] != null) value = variables[def.name];
        operationVariables[def.name] = value;
    });
    if (providedVariables != null) Object.keys(providedVariables).forEach(function(varName) {
        operationVariables[varName] = providedVariables[varName].get();
    });
    return operationVariables;
}
function $8dec77f8d9387ea3$var$getLocalVariables(currentVariables, argumentDefinitions, args) {
    if (argumentDefinitions == null) return currentVariables;
    var nextVariables = (0, $8dec77f8d9387ea3$var$_objectSpread2["default"])({}, currentVariables);
    var nextArgs = args ? $8dec77f8d9387ea3$var$getArgumentValues(args, currentVariables) : {};
    argumentDefinitions.forEach(function(def) {
        var _nextArgs$def$name;
        var value = (_nextArgs$def$name = nextArgs[def.name]) !== null && _nextArgs$def$name !== void 0 ? _nextArgs$def$name : def.defaultValue;
        nextVariables[def.name] = value;
    });
    return nextVariables;
}
module.exports = {
    getLocalVariables: $8dec77f8d9387ea3$var$getLocalVariables,
    getFragmentVariables: $8dec77f8d9387ea3$var$getFragmentVariables,
    getOperationVariables: $8dec77f8d9387ea3$var$getOperationVariables
};

});
parcelRegister("cvcC4", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $91a229fb65724236$var$_interopRequireDefault = $8gviu.default;

var $91a229fb65724236$var$_toConsumableArray2 = $91a229fb65724236$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $6Gqui = parcelRequire("6Gqui");

var $2HvH8 = parcelRequire("2HvH8");

var $kgraI = parcelRequire("kgraI");

var $zM4Yi = parcelRequire("zM4Yi");
var $91a229fb65724236$var$stableCopy = $zM4Yi.stableCopy;

var $jwy7p = parcelRequire("jwy7p");
var $91a229fb65724236$var$VARIABLE = $2HvH8.VARIABLE, $91a229fb65724236$var$LITERAL = $2HvH8.LITERAL, $91a229fb65724236$var$OBJECT_VALUE = $2HvH8.OBJECT_VALUE, $91a229fb65724236$var$LIST_VALUE = $2HvH8.LIST_VALUE;
var $91a229fb65724236$var$ERRORS_KEY = '__errors';
var $91a229fb65724236$var$MODULE_COMPONENT_KEY_PREFIX = '__module_component_';
var $91a229fb65724236$var$MODULE_OPERATION_KEY_PREFIX = '__module_operation_';
var $91a229fb65724236$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX = '$r:';
function $91a229fb65724236$var$getArgumentValue(arg, variables) {
    if (arg.kind === $91a229fb65724236$var$VARIABLE) return $91a229fb65724236$var$getStableVariableValue(arg.variableName, variables);
    else if (arg.kind === $91a229fb65724236$var$LITERAL) return arg.value;
    else if (arg.kind === $91a229fb65724236$var$OBJECT_VALUE) {
        var value = {};
        arg.fields.forEach(function(field) {
            value[field.name] = $91a229fb65724236$var$getArgumentValue(field, variables);
        });
        return value;
    } else if (arg.kind === $91a229fb65724236$var$LIST_VALUE) {
        var _value = [];
        arg.items.forEach(function(item) {
            item != null && _value.push($91a229fb65724236$var$getArgumentValue(item, variables));
        });
        return _value;
    }
}
function $91a229fb65724236$var$getArgumentValues(args, variables, isWithinUnmatchedTypeRefinement) {
    var values = {};
    if (isWithinUnmatchedTypeRefinement) values[$91a229fb65724236$var$RelayStoreUtils.FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT] = true;
    if (args) args.forEach(function(arg) {
        values[arg.name] = $91a229fb65724236$var$getArgumentValue(arg, variables);
    });
    return values;
}
function $91a229fb65724236$var$getHandleStorageKey(handleField, variables) {
    var dynamicKey = handleField.dynamicKey, handle = handleField.handle, key = handleField.key, name = handleField.name, args = handleField.args, filters = handleField.filters;
    var handleName = $6Gqui(handle, key, name);
    var filterArgs = null;
    if (args && filters && args.length !== 0 && filters.length !== 0) filterArgs = args.filter(function(arg) {
        return filters.indexOf(arg.name) > -1;
    });
    if (dynamicKey) filterArgs = filterArgs != null ? [
        dynamicKey
    ].concat((0, $91a229fb65724236$var$_toConsumableArray2["default"])(filterArgs)) : [
        dynamicKey
    ];
    if (filterArgs === null) return handleName;
    else return $91a229fb65724236$var$formatStorageKey(handleName, $91a229fb65724236$var$getArgumentValues(filterArgs, variables));
}
function $91a229fb65724236$var$getStorageKey(field, variables) {
    if (field.storageKey) return field.storageKey;
    var args = $91a229fb65724236$var$getArguments(field);
    var name = field.name;
    return args && args.length !== 0 ? $91a229fb65724236$var$formatStorageKey(name, $91a229fb65724236$var$getArgumentValues(args, variables)) : name;
}
function $91a229fb65724236$var$getReadTimeResolverStorageKey(field, variables) {
    var storageKey = $91a229fb65724236$var$getStorageKey(field, variables);
    return $kgraI.ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX ? '$r:' + storageKey : storageKey;
}
function $91a229fb65724236$var$getArguments(field) {
    if (field.kind === 'RelayResolver' || field.kind === 'RelayLiveResolver') {
        var _field$fragment2;
        if (field.args == null) {
            var _field$fragment;
            return (_field$fragment = field.fragment) === null || _field$fragment === void 0 ? void 0 : _field$fragment.args;
        }
        if (((_field$fragment2 = field.fragment) === null || _field$fragment2 === void 0 ? void 0 : _field$fragment2.args) == null) return field.args;
        return field.args.concat(field.fragment.args);
    }
    var args = typeof field.args === 'undefined' ? undefined : field.args;
    return args;
}
function $91a229fb65724236$var$getStableStorageKey(name, args) {
    return $91a229fb65724236$var$formatStorageKey(name, $91a229fb65724236$var$stableCopy(args));
}
function $91a229fb65724236$var$formatStorageKey(name, argValues) {
    if (!argValues) return name;
    var values = [];
    for(var argName in argValues)if (argValues.hasOwnProperty(argName)) {
        var value = argValues[argName];
        if (value != null) {
            var _JSON$stringify;
            values.push(argName + ':' + ((_JSON$stringify = JSON.stringify(value)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'undefined'));
        }
    }
    return values.length === 0 ? name : name + "(".concat(values.join(','), ")");
}
function $91a229fb65724236$var$getStableVariableValue(name, variables) {
    !variables.hasOwnProperty(name) && $jwy7p(false);
    return $91a229fb65724236$var$stableCopy(variables[name]);
}
function $91a229fb65724236$var$getModuleComponentKey(documentName) {
    return "".concat($91a229fb65724236$var$MODULE_COMPONENT_KEY_PREFIX).concat(documentName);
}
function $91a229fb65724236$var$getModuleOperationKey(documentName) {
    return "".concat($91a229fb65724236$var$MODULE_OPERATION_KEY_PREFIX).concat(documentName);
}
var $91a229fb65724236$var$RelayStoreUtils = {
    ACTOR_IDENTIFIER_KEY: '__actorIdentifier',
    CLIENT_EDGE_TRAVERSAL_PATH: '__clientEdgeTraversalPath',
    FRAGMENTS_KEY: '__fragments',
    FRAGMENT_OWNER_KEY: '__fragmentOwner',
    FRAGMENT_POINTER_IS_WITHIN_UNMATCHED_TYPE_REFINEMENT: '$isWithinUnmatchedTypeRefinement',
    FRAGMENT_PROP_NAME_KEY: '__fragmentPropName',
    MODULE_COMPONENT_KEY: '__module_component',
    ERRORS_KEY: $91a229fb65724236$var$ERRORS_KEY,
    ID_KEY: '__id',
    REF_KEY: '__ref',
    REFS_KEY: '__refs',
    ROOT_ID: 'client:root',
    ROOT_TYPE: '__Root',
    TYPENAME_KEY: '__typename',
    INVALIDATED_AT_KEY: '__invalidated_at',
    RELAY_RESOLVER_VALUE_KEY: '__resolverValue',
    RELAY_RESOLVER_INVALIDATION_KEY: '__resolverValueMayBeInvalid',
    RELAY_RESOLVER_SNAPSHOT_KEY: '__resolverSnapshot',
    RELAY_RESOLVER_ERROR_KEY: '__resolverError',
    RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS: '__resolverOutputTypeRecordIDs',
    RELAY_READ_TIME_RESOLVER_KEY_PREFIX: $91a229fb65724236$var$RELAY_READ_TIME_RESOLVER_KEY_PREFIX,
    formatStorageKey: $91a229fb65724236$var$formatStorageKey,
    getArgumentValue: $91a229fb65724236$var$getArgumentValue,
    getArgumentValues: $91a229fb65724236$var$getArgumentValues,
    getHandleStorageKey: $91a229fb65724236$var$getHandleStorageKey,
    getStorageKey: $91a229fb65724236$var$getStorageKey,
    getReadTimeResolverStorageKey: $91a229fb65724236$var$getReadTimeResolverStorageKey,
    getStableStorageKey: $91a229fb65724236$var$getStableStorageKey,
    getModuleComponentKey: $91a229fb65724236$var$getModuleComponentKey,
    getModuleOperationKey: $91a229fb65724236$var$getModuleOperationKey
};
module.exports = $91a229fb65724236$var$RelayStoreUtils;

});
parcelRegister("6Gqui", function(module, exports) {
'use strict';

var $5mAhc = parcelRequire("5mAhc");
var $4ddb3636cbda83c2$var$DEFAULT_HANDLE_KEY = $5mAhc.DEFAULT_HANDLE_KEY;

var $jwy7p = parcelRequire("jwy7p");
function $4ddb3636cbda83c2$var$getRelayHandleKey(handleName, key, fieldName) {
    if (key && key !== $4ddb3636cbda83c2$var$DEFAULT_HANDLE_KEY) return "__".concat(key, "_").concat(handleName);
    !(fieldName != null) && $jwy7p(false);
    return "__".concat(fieldName, "_").concat(handleName);
}
module.exports = $4ddb3636cbda83c2$var$getRelayHandleKey;

});
parcelRegister("5mAhc", function(module, exports) {
'use strict';
module.exports = {
    DEFAULT_HANDLE_KEY: ''
};

});


parcelRegister("kgraI", function(module, exports) {
'use strict';
var $ec0a610a9470957e$var$RelayFeatureFlags = {
    ENABLE_VARIABLE_CONNECTION_KEY: false,
    ENABLE_RELAY_RESOLVERS: false,
    ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION: false,
    ENABLE_FRIENDLY_QUERY_NAME_GQL_URL: false,
    ENABLE_DO_NOT_WRAP_LIVE_QUERY: false,
    ENABLE_NOTIFY_SUBSCRIPTION: false,
    BATCH_ASYNC_MODULE_UPDATES_FN: null,
    ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT: false,
    MAX_DATA_ID_LENGTH: null,
    STRING_INTERN_LEVEL: 0,
    LOG_MISSING_RECORDS_IN_PROD: false,
    ENABLE_STORE_ID_COLLISION_LOGGING: false,
    ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS: false,
    ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION: false,
    ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES: false,
    ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE: false,
    PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION: false,
    MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD: false,
    ENABLE_CYLE_DETECTION_IN_VARIABLES: false,
    ENABLE_ACTIVITY_COMPATIBILITY: false,
    ENABLE_READ_TIME_RESOLVER_STORAGE_KEY_PREFIX: true,
    ENABLE_USE_PAGINATION_IS_LOADING_FIX: false,
    DISALLOW_NESTED_UPDATES: false,
    ENABLE_TYPENAME_PREFIXED_DATA_ID: false,
    ENABLE_UI_CONTEXT_ON_RELAY_LOGGER: false,
    CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES: false
};
module.exports = $ec0a610a9470957e$var$RelayFeatureFlags;

});

parcelRegister("zM4Yi", function(module, exports) {
'use strict';
function $06b89086147a939b$var$stableCopy(value) {
    if (!value || typeof value !== 'object') return value;
    if (Array.isArray(value)) return value.map($06b89086147a939b$var$stableCopy);
    var keys = Object.keys(value).sort();
    var stable = {};
    for(var i = 0; i < keys.length; i++)stable[keys[i]] = $06b89086147a939b$var$stableCopy(value[keys[i]]);
    return stable;
}
function $06b89086147a939b$var$hasCycle(value) {
    var parents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    if (!value || typeof value !== 'object') return false;
    if (parents.has(value)) return true;
    var newParents = new Set(parents);
    newParents.add(value);
    var children = Array.isArray(value) ? value : Object.values(value);
    return children.some(function(v) {
        return $06b89086147a939b$var$hasCycle(v, newParents);
    });
}
module.exports = {
    stableCopy: $06b89086147a939b$var$stableCopy,
    hasCycle: $06b89086147a939b$var$hasCycle
};

});



parcelRegister("3UWLk", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $2da42f0977f73582$var$aStackPool = [];
var $2da42f0977f73582$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $2da42f0977f73582$var$areEqual(a, b) {
    var aStack = $2da42f0977f73582$var$aStackPool.length ? $2da42f0977f73582$var$aStackPool.pop() : [];
    var bStack = $2da42f0977f73582$var$bStackPool.length ? $2da42f0977f73582$var$bStackPool.pop() : [];
    var result = $2da42f0977f73582$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $2da42f0977f73582$var$aStackPool.push(aStack);
    $2da42f0977f73582$var$bStackPool.push(bStack);
    return result;
}
function $2da42f0977f73582$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$2da42f0977f73582$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$2da42f0977f73582$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $2da42f0977f73582$var$areEqual;

});




parcelRegister("6CxHn", function(module, exports) {
"use strict";

var $8gviu = parcelRequire("8gviu");
var $4d206e8a9378d38f$var$_interopRequireDefault = $8gviu.default;

var $aMaUD = parcelRequire("aMaUD");
var $4d206e8a9378d38f$require$_asyncToGenerator = $aMaUD.default;

var $4d206e8a9378d38f$var$_createForOfIteratorHelper2 = $4d206e8a9378d38f$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $9wNSI = parcelRequire("9wNSI");

var $fWLbj = parcelRequire("fWLbj");
var $4d206e8a9378d38f$var$getObservableForActiveRequest = $fWLbj.getObservableForActiveRequest;

var $lQR7T = parcelRequire("lQR7T");
var $4d206e8a9378d38f$var$getFragment = $lQR7T.getFragment;

var $fSw0O = parcelRequire("fSw0O");
var $4d206e8a9378d38f$var$handlePotentialSnapshotErrors = $fSw0O.handlePotentialSnapshotErrors;

var $dPVEr = parcelRequire("dPVEr");
var $4d206e8a9378d38f$var$getSelector = $dPVEr.getSelector;

var $jwy7p = parcelRequire("jwy7p");
function $4d206e8a9378d38f$var$waitForFragmentData(_x, _x2, _x3) {
    return $4d206e8a9378d38f$var$_waitForFragmentData.apply(this, arguments);
}
function $4d206e8a9378d38f$var$_waitForFragmentData() {
    $4d206e8a9378d38f$var$_waitForFragmentData = $4d206e8a9378d38f$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $4d206e8a9378d38f$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $4d206e8a9378d38f$var$_waitForFragmentData.apply(this, arguments);
}
function $4d206e8a9378d38f$var$observeFragment(environment, fragment, fragmentRef) {
    var _fragmentNode$metadat;
    var fragmentNode = $4d206e8a9378d38f$var$getFragment(fragment);
    var fragmentSelector = $4d206e8a9378d38f$var$getSelector(fragmentNode, fragmentRef);
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.hasClientEdges) == null) && $jwy7p(false);
    !(fragmentSelector != null) && $jwy7p(false);
    switch(fragmentSelector.kind){
        case 'SingularReaderSelector':
            return $4d206e8a9378d38f$var$observeSingularSelector(environment, fragment, fragmentSelector);
        case 'PluralReaderSelector':
            return $4d206e8a9378d38f$var$observePluralSelector(environment, fragment, fragmentSelector);
    }
    $jwy7p(false);
}
function $4d206e8a9378d38f$var$observeSingularSelector(environment, fragmentNode, fragmentSelector) {
    var snapshot = environment.lookup(fragmentSelector);
    return $9wNSI.create(function(sink) {
        sink.next($4d206e8a9378d38f$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, snapshot));
        var subscription = environment.subscribe(snapshot, function(nextSnapshot) {
            sink.next($4d206e8a9378d38f$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.owner, nextSnapshot));
        });
        return function() {
            return subscription.dispose();
        };
    });
}
function $4d206e8a9378d38f$var$observePluralSelector(environment, fragmentNode, fragmentSelector) {
    var snapshots = fragmentSelector.selectors.map(function(selector) {
        return environment.lookup(selector);
    });
    return $9wNSI.create(function(sink) {
        var states = snapshots.map(function(snapshot, index) {
            return $4d206e8a9378d38f$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, snapshot);
        });
        sink.next($4d206e8a9378d38f$var$mergeFragmentStates(states));
        var subscriptions = snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                states[index] = $4d206e8a9378d38f$var$snapshotToFragmentState(environment, fragmentNode, fragmentSelector.selectors[index].owner, latestSnapshot);
                sink.next($4d206e8a9378d38f$var$mergeFragmentStates(states));
            });
        });
        return function() {
            return subscriptions.forEach(function(subscription) {
                return subscription.dispose();
            });
        };
    });
}
function $4d206e8a9378d38f$var$snapshotToFragmentState(environment, fragmentNode, owner, snapshot) {
    var missingLiveResolverFields = snapshot.missingLiveResolverFields != null && snapshot.missingLiveResolverFields.length > 0;
    var missingClientEdges = snapshot.missingClientEdges != null && snapshot.missingClientEdges.length > 0;
    if (missingLiveResolverFields || missingClientEdges) return {
        state: 'loading'
    };
    if (snapshot.isMissingData) {
        if ($4d206e8a9378d38f$var$getObservableForActiveRequest(environment, owner) != null || environment.getOperationTracker().getPendingOperationsAffectingOwner(owner) != null) return {
            state: 'loading'
        };
    }
    try {
        $4d206e8a9378d38f$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
    } catch (error) {
        return {
            error: error,
            state: 'error'
        };
    }
    !(snapshot.data != null) && $jwy7p(false);
    return {
        state: 'ok',
        value: snapshot.data
    };
}
function $4d206e8a9378d38f$var$mergeFragmentStates(states) {
    var value = [];
    var _iterator = (0, $4d206e8a9378d38f$var$_createForOfIteratorHelper2["default"])(states), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var state = _step.value;
            if (state.state === 'ok') value.push(state.value);
            else return state;
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return {
        state: 'ok',
        value: value
    };
}
module.exports = {
    observeFragment: $4d206e8a9378d38f$var$observeFragment,
    waitForFragmentData: $4d206e8a9378d38f$var$waitForFragmentData
};

});
parcelRegister("9wNSI", function(module, exports) {
'use strict';

var $3Lb8h = parcelRequire("3Lb8h");
var $6efdcba5f45d34d3$var$hostReportError = $6efdcba5f45d34d3$var$swallowError;
var $6efdcba5f45d34d3$var$RelayObservable = /*#__PURE__*/ function() {
    RelayObservable.create = function create(source) {
        return new RelayObservable(source);
    };
    function RelayObservable(source) {
        this._source = source;
    }
    RelayObservable.onUnhandledError = function onUnhandledError(callback) {
        $6efdcba5f45d34d3$var$hostReportError = callback;
    };
    RelayObservable.from = function from(obj) {
        return $6efdcba5f45d34d3$var$isObservable(obj) ? $6efdcba5f45d34d3$var$fromObservable(obj) : $3Lb8h(obj) ? $6efdcba5f45d34d3$var$fromPromise(obj) : $6efdcba5f45d34d3$var$fromValue(obj);
    };
    var _proto = RelayObservable.prototype;
    _proto["catch"] = function _catch(fn) {
        var _this = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            _this.subscribe({
                start: function start(sub) {
                    subscription = sub;
                },
                next: sink.next,
                complete: sink.complete,
                error: function error(_error2) {
                    try {
                        fn(_error2).subscribe({
                            start: function start(sub) {
                                subscription = sub;
                            },
                            next: sink.next,
                            complete: sink.complete,
                            error: sink.error
                        });
                    } catch (error2) {
                        sink.error(error2, true);
                    }
                }
            });
            return function() {
                return subscription.unsubscribe();
            };
        });
    };
    _proto.concat = function concat(next) {
        var _this2 = this;
        return RelayObservable.create(function(sink) {
            var current;
            _this2.subscribe({
                start: function start(subscription) {
                    current = subscription;
                },
                next: sink.next,
                error: sink.error,
                complete: function complete() {
                    current = next.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto["do"] = function _do(observer) {
        var _this3 = this;
        return RelayObservable.create(function(sink) {
            var both = function both(action) {
                return function() {
                    try {
                        observer[action] && observer[action].apply(observer, arguments);
                    } catch (error) {
                        $6efdcba5f45d34d3$var$hostReportError(error, true);
                    }
                    sink[action] && sink[action].apply(sink, arguments);
                };
            };
            return _this3.subscribe({
                start: both('start'),
                next: both('next'),
                error: both('error'),
                complete: both('complete'),
                unsubscribe: both('unsubscribe')
            });
        });
    };
    _proto["finally"] = function _finally(fn) {
        var _this4 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this4.subscribe(sink);
            return function() {
                subscription.unsubscribe();
                fn();
            };
        });
    };
    _proto.ifEmpty = function ifEmpty(alternate) {
        var _this5 = this;
        return RelayObservable.create(function(sink) {
            var hasValue = false;
            var current;
            current = _this5.subscribe({
                next: function next(value) {
                    hasValue = true;
                    sink.next(value);
                },
                error: sink.error,
                complete: function complete() {
                    if (hasValue) sink.complete();
                    else current = alternate.subscribe(sink);
                }
            });
            return function() {
                current && current.unsubscribe();
            };
        });
    };
    _proto.subscribe = function subscribe(observer) {
        return $6efdcba5f45d34d3$var$_subscribe(this._source, observer);
    };
    _proto.map = function map(fn) {
        var _this6 = this;
        return RelayObservable.create(function(sink) {
            var subscription = _this6.subscribe({
                complete: sink.complete,
                error: sink.error,
                next: function next(value) {
                    try {
                        var mapValue = fn(value);
                        sink.next(mapValue);
                    } catch (error) {
                        sink.error(error, true);
                    }
                }
            });
            return function() {
                subscription.unsubscribe();
            };
        });
    };
    _proto.mergeMap = function mergeMap(fn) {
        var _this7 = this;
        return RelayObservable.create(function(sink) {
            var subscriptions = [];
            function start(subscription) {
                this._sub = subscription;
                subscriptions.push(subscription);
            }
            function complete() {
                subscriptions.splice(subscriptions.indexOf(this._sub), 1);
                if (subscriptions.length === 0) sink.complete();
            }
            _this7.subscribe({
                start: start,
                next: function next(value) {
                    try {
                        if (!sink.closed) RelayObservable.from(fn(value)).subscribe({
                            start: start,
                            next: sink.next,
                            error: sink.error,
                            complete: complete
                        });
                    } catch (error) {
                        sink.error(error, true);
                    }
                },
                error: sink.error,
                complete: complete
            });
            return function() {
                subscriptions.forEach(function(sub) {
                    return sub.unsubscribe();
                });
                subscriptions.length = 0;
            };
        });
    };
    _proto.poll = function poll(pollInterval) {
        var _this8 = this;
        return RelayObservable.create(function(sink) {
            var subscription;
            var timeout;
            var poll = function poll() {
                subscription = _this8.subscribe({
                    next: sink.next,
                    error: sink.error,
                    complete: function complete() {
                        timeout = setTimeout(poll, pollInterval);
                    }
                });
            };
            poll();
            return function() {
                clearTimeout(timeout);
                subscription.unsubscribe();
            };
        });
    };
    _proto.toPromise = function toPromise() {
        var _this9 = this;
        return new Promise(function(resolve, reject) {
            var resolved = false;
            _this9.subscribe({
                next: function next(val) {
                    if (!resolved) {
                        resolved = true;
                        resolve(val);
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    return RelayObservable;
}();
function $6efdcba5f45d34d3$var$isObservable(obj) {
    return typeof obj === 'object' && obj !== null && typeof obj.subscribe === 'function';
}
function $6efdcba5f45d34d3$var$fromObservable(obj) {
    return obj instanceof $6efdcba5f45d34d3$var$RelayObservable ? obj : $6efdcba5f45d34d3$var$RelayObservable.create(function(sink) {
        return obj.subscribe(sink);
    });
}
function $6efdcba5f45d34d3$var$fromPromise(promise) {
    return $6efdcba5f45d34d3$var$RelayObservable.create(function(sink) {
        promise.then(function(value) {
            sink.next(value);
            sink.complete();
        }, sink.error);
    });
}
function $6efdcba5f45d34d3$var$fromValue(value) {
    return $6efdcba5f45d34d3$var$RelayObservable.create(function(sink) {
        sink.next(value);
        sink.complete();
    });
}
function $6efdcba5f45d34d3$var$_subscribe(source, observer) {
    var closed = false;
    var cleanup;
    var withClosed = function withClosed(obj) {
        return Object.defineProperty(obj, 'closed', {
            get: function get() {
                return closed;
            }
        });
    };
    function doCleanup() {
        if (cleanup) {
            if (cleanup.unsubscribe) cleanup.unsubscribe();
            else try {
                cleanup();
            } catch (error) {
                $6efdcba5f45d34d3$var$hostReportError(error, true);
            }
            cleanup = undefined;
        }
    }
    var subscription = withClosed({
        unsubscribe: function unsubscribe() {
            if (!closed) {
                closed = true;
                try {
                    observer.unsubscribe && observer.unsubscribe(subscription);
                } catch (error) {
                    $6efdcba5f45d34d3$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        observer.start && observer.start(subscription);
    } catch (error) {
        $6efdcba5f45d34d3$var$hostReportError(error, true);
    }
    if (closed) return subscription;
    var sink = withClosed({
        next: function next(value) {
            if (!closed && observer.next) try {
                observer.next(value);
            } catch (error) {
                $6efdcba5f45d34d3$var$hostReportError(error, true);
            }
        },
        error: function error(_error3, isUncaughtThrownError) {
            if (closed || !observer.error) {
                closed = true;
                $6efdcba5f45d34d3$var$hostReportError(_error3, isUncaughtThrownError || false);
                doCleanup();
            } else {
                closed = true;
                try {
                    observer.error(_error3);
                } catch (error2) {
                    $6efdcba5f45d34d3$var$hostReportError(error2, true);
                } finally{
                    doCleanup();
                }
            }
        },
        complete: function complete() {
            if (!closed) {
                closed = true;
                try {
                    observer.complete && observer.complete();
                } catch (error) {
                    $6efdcba5f45d34d3$var$hostReportError(error, true);
                } finally{
                    doCleanup();
                }
            }
        }
    });
    try {
        cleanup = source(sink);
    } catch (error) {
        sink.error(error, true);
    }
    if (closed) doCleanup();
    return subscription;
}
function $6efdcba5f45d34d3$var$swallowError(_error, _isUncaughtThrownError) {}
module.exports = $6efdcba5f45d34d3$var$RelayObservable;

});
parcelRegister("3Lb8h", function(module, exports) {
'use strict';
function $2bce6590a4077c59$var$isPromise(p) {
    return p != null && typeof p === 'object' && typeof p.then === 'function';
}
module.exports = $2bce6590a4077c59$var$isPromise;

});


parcelRegister("fWLbj", function(module, exports) {
'use strict';

var $9wNSI = parcelRequire("9wNSI");

var $6LM4u = parcelRequire("6LM4u");

var $jwy7p = parcelRequire("jwy7p");
var $b9c0df0650605a67$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $b9c0df0650605a67$var$requestCachesByEnvironment = $b9c0df0650605a67$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $b9c0df0650605a67$var$fetchQuery(environment, operation) {
    return $b9c0df0650605a67$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
        return environment.execute({
            operation: operation
        });
    });
}
function $b9c0df0650605a67$var$fetchQueryDeduped(environment, identifier, fetchFn) {
    return $9wNSI.create(function(sink) {
        var requestCache = $b9c0df0650605a67$var$getRequestCache(environment);
        var cachedRequest = requestCache.get(identifier);
        if (!cachedRequest) fetchFn()["finally"](function() {
            return requestCache["delete"](identifier);
        }).subscribe({
            start: function start(subscription) {
                cachedRequest = {
                    identifier: identifier,
                    subject: new $6LM4u(),
                    subjectForInFlightStatus: new $6LM4u(),
                    subscription: subscription,
                    promise: null
                };
                requestCache.set(identifier, cachedRequest);
            },
            next: function next(response) {
                var cachedReq = $b9c0df0650605a67$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.next(response);
                cachedReq.subjectForInFlightStatus.next(response);
            },
            error: function error(_error) {
                var cachedReq = $b9c0df0650605a67$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.error(_error);
                cachedReq.subjectForInFlightStatus.error(_error);
            },
            complete: function complete() {
                var cachedReq = $b9c0df0650605a67$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.complete();
                cachedReq.subjectForInFlightStatus.complete();
            },
            unsubscribe: function unsubscribe(subscription) {
                var cachedReq = $b9c0df0650605a67$var$getCachedRequest(requestCache, identifier);
                cachedReq.subject.unsubscribe();
                cachedReq.subjectForInFlightStatus.unsubscribe();
            }
        });
        !(cachedRequest != null) && $jwy7p(false);
        return $b9c0df0650605a67$var$getObservableForCachedRequest(requestCache, cachedRequest).subscribe(sink);
    });
}
function $b9c0df0650605a67$var$getObservableForCachedRequest(requestCache, cachedRequest) {
    return $9wNSI.create(function(sink) {
        var subscription = cachedRequest.subject.subscribe(sink);
        return function() {
            subscription.unsubscribe();
            var cachedRequestInstance = requestCache.get(cachedRequest.identifier);
            if (cachedRequestInstance) {
                var requestSubscription = cachedRequestInstance.subscription;
                if (requestSubscription != null && cachedRequestInstance.subject.getObserverCount() === 0) {
                    requestSubscription.unsubscribe();
                    requestCache["delete"](cachedRequest.identifier);
                }
            }
        };
    });
}
function $b9c0df0650605a67$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest) {
    return $9wNSI.create(function(sink) {
        var subscription = cachedRequest.subjectForInFlightStatus.subscribe({
            error: sink.error,
            next: function next(response) {
                if (!environment.isRequestActive(cachedRequest.identifier)) {
                    sink.complete();
                    return;
                }
                sink.next();
            },
            complete: sink.complete,
            unsubscribe: sink.complete
        });
        return function() {
            subscription.unsubscribe();
        };
    });
}
function $b9c0df0650605a67$var$getPromiseForActiveRequest(environment, request) {
    var requestCache = $b9c0df0650605a67$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    var promise = new Promise(function(resolve, reject) {
        var resolveOnNext = false;
        $b9c0df0650605a67$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest).subscribe({
            complete: resolve,
            error: reject,
            next: function next(response) {
                if (resolveOnNext) resolve(response);
            }
        });
        resolveOnNext = true;
    });
    return promise;
}
function $b9c0df0650605a67$var$getObservableForActiveRequest(environment, request) {
    var requestCache = $b9c0df0650605a67$var$getRequestCache(environment);
    var cachedRequest = requestCache.get(request.identifier);
    if (!cachedRequest) return null;
    if (!environment.isRequestActive(cachedRequest.identifier)) return null;
    return $b9c0df0650605a67$var$getActiveStatusObservableForCachedRequest(environment, requestCache, cachedRequest);
}
function $b9c0df0650605a67$var$getRequestCache(environment) {
    var cached = $b9c0df0650605a67$var$requestCachesByEnvironment.get(environment);
    if (cached != null) return cached;
    var requestCache = new Map();
    $b9c0df0650605a67$var$requestCachesByEnvironment.set(environment, requestCache);
    return requestCache;
}
function $b9c0df0650605a67$var$getCachedRequest(requestCache, identifier) {
    var cached = requestCache.get(identifier);
    !(cached != null) && $jwy7p(false);
    return cached;
}
module.exports = {
    fetchQuery: $b9c0df0650605a67$var$fetchQuery,
    fetchQueryDeduped: $b9c0df0650605a67$var$fetchQueryDeduped,
    getPromiseForActiveRequest: $b9c0df0650605a67$var$getPromiseForActiveRequest,
    getObservableForActiveRequest: $b9c0df0650605a67$var$getObservableForActiveRequest
};

});
parcelRegister("6LM4u", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $4edc6bd6f93ad9ed$var$_interopRequireDefault = $8gviu.default;

var $4edc6bd6f93ad9ed$var$_createForOfIteratorHelper2 = $4edc6bd6f93ad9ed$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $4edc6bd6f93ad9ed$var$_defineProperty2 = $4edc6bd6f93ad9ed$var$_interopRequireDefault((parcelRequire("dangC")));

var $9wNSI = parcelRequire("9wNSI");

var $jwy7p = parcelRequire("jwy7p");
var $4edc6bd6f93ad9ed$var$RelayReplaySubject = /*#__PURE__*/ function() {
    function RelayReplaySubject() {
        var _this = this;
        (0, $4edc6bd6f93ad9ed$var$_defineProperty2["default"])(this, "_complete", false);
        (0, $4edc6bd6f93ad9ed$var$_defineProperty2["default"])(this, "_events", []);
        (0, $4edc6bd6f93ad9ed$var$_defineProperty2["default"])(this, "_sinks", new Set());
        (0, $4edc6bd6f93ad9ed$var$_defineProperty2["default"])(this, "_subscription", []);
        this._observable = $9wNSI.create(function(sink) {
            _this._sinks.add(sink);
            var events = _this._events;
            for(var i = 0; i < events.length; i++){
                if (sink.closed) break;
                var event = events[i];
                switch(event.kind){
                    case 'complete':
                        sink.complete();
                        break;
                    case 'error':
                        sink.error(event.error);
                        break;
                    case 'next':
                        sink.next(event.data);
                        break;
                    default:
                        event.kind;
                        $jwy7p(false);
                }
            }
            return function() {
                _this._sinks["delete"](sink);
            };
        });
    }
    var _proto = RelayReplaySubject.prototype;
    _proto.complete = function complete() {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'complete'
        });
        this._sinks.forEach(function(sink) {
            return sink.complete();
        });
    };
    _proto.error = function error(_error) {
        if (this._complete === true) return;
        this._complete = true;
        this._events.push({
            kind: 'error',
            error: _error
        });
        this._sinks.forEach(function(sink) {
            return sink.error(_error);
        });
    };
    _proto.next = function next(data) {
        if (this._complete === true) return;
        this._events.push({
            kind: 'next',
            data: data
        });
        this._sinks.forEach(function(sink) {
            return sink.next(data);
        });
    };
    _proto.subscribe = function subscribe(observer) {
        var subscription = this._observable.subscribe(observer);
        this._subscription.push(subscription);
        return subscription;
    };
    _proto.unsubscribe = function unsubscribe() {
        var _iterator = (0, $4edc6bd6f93ad9ed$var$_createForOfIteratorHelper2["default"])(this._subscription), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var subscription = _step.value;
                subscription.unsubscribe();
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._subscription = [];
    };
    _proto.getObserverCount = function getObserverCount() {
        return this._sinks.size;
    };
    return RelayReplaySubject;
}();
module.exports = $4edc6bd6f93ad9ed$var$RelayReplaySubject;

});



parcelRegister("hITKJ", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $ce71cb1346965e18$var$_interopRequireDefault = $8gviu.default;

var $ce71cb1346965e18$var$_defineProperty2 = $ce71cb1346965e18$var$_interopRequireDefault((parcelRequire("dangC")));

var $6CxHn = parcelRequire("6CxHn");
var $ce71cb1346965e18$var$observeFragment = $6CxHn.observeFragment;

var $1v3vf = parcelRequire("1v3vf");
var $ce71cb1346965e18$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;
function $ce71cb1346965e18$var$observeQuery(environment, gqlQuery, variables) {
    var operation = $ce71cb1346965e18$var$createOperationDescriptor(gqlQuery, variables);
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $ce71cb1346965e18$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    var fragmentNode = operation.request.node.fragment;
    return $ce71cb1346965e18$var$observeFragment(environment, fragmentNode, rootFragmentRef);
}
module.exports = {
    observeQuery: $ce71cb1346965e18$var$observeQuery
};

});
parcelRegister("1v3vf", function(module, exports) {
'use strict';
parcelRequire("fHswY");

var $91TmW = parcelRequire("91TmW");

var $kgraI = parcelRequire("kgraI");

var $zM4Yi = parcelRequire("zM4Yi");
var $117b674bbcfa15d4$var$hasCycle = $zM4Yi.hasCycle;

var $cbsiZ = parcelRequire("cbsiZ");
var $117b674bbcfa15d4$var$getOperationVariables = $cbsiZ.getOperationVariables;

var $dPVEr = parcelRequire("dPVEr");
var $117b674bbcfa15d4$var$createNormalizationSelector = $dPVEr.createNormalizationSelector, $117b674bbcfa15d4$var$createReaderSelector = $dPVEr.createReaderSelector;

var $cvcC4 = parcelRequire("cvcC4");
var $117b674bbcfa15d4$var$ROOT_ID = $cvcC4.ROOT_ID;

var $jwy7p = parcelRequire("jwy7p");
function $117b674bbcfa15d4$var$createOperationDescriptor(request, variables, cacheConfig) {
    var dataID = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $117b674bbcfa15d4$var$ROOT_ID;
    var operation = request.operation;
    var operationVariables = $117b674bbcfa15d4$var$getOperationVariables(operation, request.params.providedVariables, variables);
    if ($kgraI.ENABLE_CYLE_DETECTION_IN_VARIABLES) !!$117b674bbcfa15d4$var$hasCycle(operationVariables) && $jwy7p(false);
    var requestDescriptor = $117b674bbcfa15d4$var$createRequestDescriptor(request, operationVariables, cacheConfig);
    var operationDescriptor = {
        fragment: $117b674bbcfa15d4$var$createReaderSelector(request.fragment, dataID, operationVariables, requestDescriptor),
        request: requestDescriptor,
        root: $117b674bbcfa15d4$var$createNormalizationSelector(operation, dataID, operationVariables)
    };
    return operationDescriptor;
}
function $117b674bbcfa15d4$var$createRequestDescriptor(request, variables, cacheConfig) {
    var requestDescriptor = {
        identifier: $91TmW(request.params, variables),
        node: request,
        variables: variables,
        cacheConfig: cacheConfig
    };
    return requestDescriptor;
}
module.exports = {
    createOperationDescriptor: $117b674bbcfa15d4$var$createOperationDescriptor,
    createRequestDescriptor: $117b674bbcfa15d4$var$createRequestDescriptor
};

});
parcelRegister("fHswY", function(module, exports) {
'use strict';
function $b6e100d0fd2f02ed$var$deepFreeze(object) {
    if (!$b6e100d0fd2f02ed$var$shouldBeFrozen(object)) return object;
    Object.freeze(object);
    Object.getOwnPropertyNames(object).forEach(function(name) {
        var property = object[name];
        if (property && typeof property === 'object' && !Object.isFrozen(property)) $b6e100d0fd2f02ed$var$deepFreeze(property);
    });
    return object;
}
function $b6e100d0fd2f02ed$var$shouldBeFrozen(value) {
    return value != null && (Array.isArray(value) || typeof value === 'object' && value.constructor === Object);
}
module.exports = $b6e100d0fd2f02ed$var$deepFreeze;

});

parcelRegister("91TmW", function(module, exports) {
'use strict';

var $zM4Yi = parcelRequire("zM4Yi");
var $692f28347d64201c$var$stableCopy = $zM4Yi.stableCopy;

var $jwy7p = parcelRequire("jwy7p");
function $692f28347d64201c$var$getRequestIdentifier(parameters, variables) {
    var requestID = parameters.cacheID != null ? parameters.cacheID : parameters.id;
    !(requestID != null) && $jwy7p(false);
    return requestID + JSON.stringify($692f28347d64201c$var$stableCopy(variables));
}
module.exports = $692f28347d64201c$var$getRequestIdentifier;

});



parcelRegister("ecgq5", function(module, exports) {
"use strict";

var $aMaUD = parcelRequire("aMaUD");
var $a55eec4939cd9a69$require$_asyncToGenerator = $aMaUD.default;

var $6CxHn = parcelRequire("6CxHn");
var $a55eec4939cd9a69$var$observeFragment = $6CxHn.observeFragment;
function $a55eec4939cd9a69$var$waitForFragmentData(_x, _x2, _x3) {
    return $a55eec4939cd9a69$var$_waitForFragmentData.apply(this, arguments);
}
function $a55eec4939cd9a69$var$_waitForFragmentData() {
    $a55eec4939cd9a69$var$_waitForFragmentData = $a55eec4939cd9a69$require$_asyncToGenerator(function*(environment, fragment, fragmentRef) {
        var subscription;
        try {
            var _subscription;
            var data = yield new Promise(function(resolve, reject) {
                subscription = $a55eec4939cd9a69$var$observeFragment(environment, fragment, fragmentRef).subscribe({
                    next: function next(val) {
                        if (val.state === 'ok') resolve(val.value);
                        else if (val.state === 'error') reject(val.error);
                    }
                });
            });
            (_subscription = subscription) === null || _subscription === void 0 || _subscription.unsubscribe();
            return data;
        } catch (e) {
            var _subscription2;
            (_subscription2 = subscription) === null || _subscription2 === void 0 || _subscription2.unsubscribe();
            throw e;
        }
    });
    return $a55eec4939cd9a69$var$_waitForFragmentData.apply(this, arguments);
}
module.exports = {
    waitForFragmentData: $a55eec4939cd9a69$var$waitForFragmentData
};

});


parcelRegister("3txKR", function(module, exports) {
'use strict';

var $9eVAj = parcelRequire("9eVAj");
var $287e438c8151f143$var$generateClientID = $9eVAj.generateClientID;

var $cvcC4 = parcelRequire("cvcC4");
var $287e438c8151f143$var$getStableStorageKey = $cvcC4.getStableStorageKey;

var $6Gqui = parcelRequire("6Gqui");

var $8tGFT = parcelRequire("8tGFT");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
var $287e438c8151f143$var$CONNECTION = 'connection';
var $287e438c8151f143$var$NEXT_EDGE_INDEX = '__connection_next_edge_index';
function $287e438c8151f143$var$update(store, payload) {
    var record = store.get(payload.dataID);
    if (!record) return;
    var _ConnectionInterface$ = $8tGFT.get(), EDGES = _ConnectionInterface$.EDGES, END_CURSOR = _ConnectionInterface$.END_CURSOR, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, PAGE_INFO_TYPE = _ConnectionInterface$.PAGE_INFO_TYPE, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var serverConnection = record.getLinkedRecord(payload.fieldKey);
    var serverPageInfo = serverConnection && serverConnection.getLinkedRecord(PAGE_INFO);
    if (!serverConnection) {
        record.setValue(null, payload.handleKey, undefined, record.getErrors(payload.fieldKey));
        return;
    }
    var clientConnectionID = $287e438c8151f143$var$generateClientID(record.getDataID(), payload.handleKey);
    var clientConnectionField = record.getLinkedRecord(payload.handleKey);
    var clientConnection = clientConnectionField !== null && clientConnectionField !== void 0 ? clientConnectionField : store.get(clientConnectionID);
    var clientPageInfo = clientConnection && clientConnection.getLinkedRecord(PAGE_INFO);
    if (!clientConnection) {
        var connection = store.create(clientConnectionID, serverConnection.getType());
        connection.setValue(0, $287e438c8151f143$var$NEXT_EDGE_INDEX);
        connection.copyFieldsFrom(serverConnection);
        var serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (serverEdges) {
            serverEdges = serverEdges.map(function(edge) {
                return $287e438c8151f143$var$buildConnectionEdge(store, connection, edge);
            });
            connection.setLinkedRecords(serverEdges, EDGES);
        }
        record.setLinkedRecord(connection, payload.handleKey);
        clientPageInfo = store.create($287e438c8151f143$var$generateClientID(connection.getDataID(), PAGE_INFO), PAGE_INFO_TYPE);
        clientPageInfo.setValue(false, HAS_NEXT_PAGE);
        clientPageInfo.setValue(false, HAS_PREV_PAGE);
        clientPageInfo.setValue(null, END_CURSOR);
        clientPageInfo.setValue(null, START_CURSOR);
        if (serverPageInfo) clientPageInfo.copyFieldsFrom(serverPageInfo);
        connection.setLinkedRecord(clientPageInfo, PAGE_INFO);
    } else {
        if (clientConnectionField == null) record.setLinkedRecord(clientConnection, payload.handleKey);
        var _connection = clientConnection;
        var _serverEdges = serverConnection.getLinkedRecords(EDGES);
        if (_serverEdges) _serverEdges = _serverEdges.map(function(edge) {
            return $287e438c8151f143$var$buildConnectionEdge(store, _connection, edge);
        });
        var prevEdges = _connection.getLinkedRecords(EDGES);
        var prevPageInfo = _connection.getLinkedRecord(PAGE_INFO);
        _connection.copyFieldsFrom(serverConnection);
        if (prevEdges) _connection.setLinkedRecords(prevEdges, EDGES);
        if (prevPageInfo) _connection.setLinkedRecord(prevPageInfo, PAGE_INFO);
        var nextEdges = [];
        var args = payload.args;
        if (prevEdges && _serverEdges) {
            if (args.after != null) {
                var _clientPageInfo;
                var clientEndCursor = (_clientPageInfo = clientPageInfo) === null || _clientPageInfo === void 0 ? void 0 : _clientPageInfo.getValue(END_CURSOR);
                var serverEndCursor = serverPageInfo === null || serverPageInfo === void 0 ? void 0 : serverPageInfo.getValue(END_CURSOR);
                var isAddingEdgesAfterCurrentPage = clientPageInfo && args.after === clientEndCursor;
                var isFillingOutCurrentPage = clientPageInfo && clientEndCursor === serverEndCursor;
                if (isAddingEdgesAfterCurrentPage || isFillingOutCurrentPage) {
                    var nodeIDs = new Set();
                    $287e438c8151f143$var$mergeEdges(prevEdges, nextEdges, nodeIDs);
                    $287e438c8151f143$var$mergeEdges(_serverEdges, nextEdges, nodeIDs);
                } else return;
            } else if (args.before != null) {
                if (clientPageInfo && args.before === clientPageInfo.getValue(START_CURSOR)) {
                    var _nodeIDs = new Set();
                    $287e438c8151f143$var$mergeEdges(_serverEdges, nextEdges, _nodeIDs);
                    $287e438c8151f143$var$mergeEdges(prevEdges, nextEdges, _nodeIDs);
                } else return;
            } else nextEdges = _serverEdges;
        } else if (_serverEdges) nextEdges = _serverEdges;
        else nextEdges = prevEdges;
        if (nextEdges != null && nextEdges !== prevEdges) _connection.setLinkedRecords(nextEdges, EDGES);
        if (clientPageInfo && serverPageInfo) {
            if (args.after == null && args.before == null) clientPageInfo.copyFieldsFrom(serverPageInfo);
            else if (args.before != null || args.after == null && args.last) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_PREV_PAGE), HAS_PREV_PAGE);
                var startCursor = serverPageInfo.getValue(START_CURSOR);
                if (typeof startCursor === 'string') clientPageInfo.setValue(startCursor, START_CURSOR);
            } else if (args.after != null || args.before == null && args.first) {
                clientPageInfo.setValue(!!serverPageInfo.getValue(HAS_NEXT_PAGE), HAS_NEXT_PAGE);
                var endCursor = serverPageInfo.getValue(END_CURSOR);
                if (typeof endCursor === 'string') clientPageInfo.setValue(endCursor, END_CURSOR);
            }
        }
    }
}
function $287e438c8151f143$var$getConnection(record, key, filters) {
    var handleKey = $6Gqui($287e438c8151f143$var$CONNECTION, key, null);
    return record.getLinkedRecord(handleKey, filters);
}
function $287e438c8151f143$var$getConnectionID(recordID, key, filters) {
    var handleKey = $6Gqui($287e438c8151f143$var$CONNECTION, key, null);
    var storageKey = $287e438c8151f143$var$getStableStorageKey(handleKey, filters);
    return $287e438c8151f143$var$generateClientID(recordID, storageKey);
}
function $287e438c8151f143$var$insertEdgeAfter(record, newEdge, cursor) {
    var _ConnectionInterface$2 = $8tGFT.get(), CURSOR = _ConnectionInterface$2.CURSOR, EDGES = _ConnectionInterface$2.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = edges.concat(newEdge);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            nextEdges.push(edge);
            if (edge == null) continue;
            var edgeCursor = edge.getValue(CURSOR);
            if (cursor === edgeCursor) {
                nextEdges.push(newEdge);
                foundCursor = true;
            }
        }
        if (!foundCursor) nextEdges.push(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $287e438c8151f143$var$createEdge(store, record, node, edgeType) {
    var _ConnectionInterface$3 = $8tGFT.get(), NODE = _ConnectionInterface$3.NODE;
    var edgeID = $287e438c8151f143$var$generateClientID(record.getDataID(), node.getDataID());
    var edge = store.get(edgeID);
    if (!edge) edge = store.create(edgeID, edgeType);
    edge.setLinkedRecord(node, NODE);
    if (edge.getValue('cursor') == null) edge.setValue(null, 'cursor');
    return edge;
}
function $287e438c8151f143$var$insertEdgeBefore(record, newEdge, cursor) {
    var _ConnectionInterface$4 = $8tGFT.get(), CURSOR = _ConnectionInterface$4.CURSOR, EDGES = _ConnectionInterface$4.EDGES;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) {
        record.setLinkedRecords([
            newEdge
        ], EDGES);
        return;
    }
    var nextEdges;
    if (cursor == null) nextEdges = [
        newEdge
    ].concat(edges);
    else {
        nextEdges = [];
        var foundCursor = false;
        for(var ii = 0; ii < edges.length; ii++){
            var edge = edges[ii];
            if (edge != null) {
                var edgeCursor = edge.getValue(CURSOR);
                if (cursor === edgeCursor) {
                    nextEdges.push(newEdge);
                    foundCursor = true;
                }
            }
            nextEdges.push(edge);
        }
        if (!foundCursor) nextEdges.unshift(newEdge);
    }
    record.setLinkedRecords(nextEdges, EDGES);
}
function $287e438c8151f143$var$deleteNode(record, nodeID) {
    var _ConnectionInterface$5 = $8tGFT.get(), EDGES = _ConnectionInterface$5.EDGES, NODE = _ConnectionInterface$5.NODE;
    var edges = record.getLinkedRecords(EDGES);
    if (!edges) return;
    var nextEdges;
    for(var ii = 0; ii < edges.length; ii++){
        var edge = edges[ii];
        var node = edge && edge.getLinkedRecord(NODE);
        if (node != null && node.getDataID() === nodeID) {
            if (nextEdges === undefined) nextEdges = edges.slice(0, ii);
        } else if (nextEdges !== undefined) nextEdges.push(edge);
    }
    if (nextEdges !== undefined) record.setLinkedRecords(nextEdges, EDGES);
}
function $287e438c8151f143$var$buildConnectionEdge(store, connection, edge) {
    if (edge == null) return edge;
    var _ConnectionInterface$6 = $8tGFT.get(), EDGES = _ConnectionInterface$6.EDGES;
    var edgeIndex = connection.getValue($287e438c8151f143$var$NEXT_EDGE_INDEX);
    !(typeof edgeIndex === 'number') && $jwy7p(false);
    var edgeID = $287e438c8151f143$var$generateClientID(connection.getDataID(), EDGES, edgeIndex);
    var connectionEdge = store.create(edgeID, edge.getType());
    connectionEdge.copyFieldsFrom(edge);
    if (connectionEdge.getValue('cursor') == null) connectionEdge.setValue(null, 'cursor');
    connection.setValue(edgeIndex + 1, $287e438c8151f143$var$NEXT_EDGE_INDEX);
    return connectionEdge;
}
function $287e438c8151f143$var$mergeEdges(sourceEdges, targetEdges, nodeIDs) {
    var _ConnectionInterface$7 = $8tGFT.get(), NODE = _ConnectionInterface$7.NODE;
    for(var ii = 0; ii < sourceEdges.length; ii++){
        var edge = sourceEdges[ii];
        if (!edge) continue;
        var node = edge.getLinkedRecord(NODE);
        var nodeID = node && node.getDataID();
        if (nodeID) {
            if (nodeIDs.has(nodeID)) continue;
            nodeIDs.add(nodeID);
        }
        targetEdges.push(edge);
    }
}
module.exports = {
    buildConnectionEdge: $287e438c8151f143$var$buildConnectionEdge,
    createEdge: $287e438c8151f143$var$createEdge,
    deleteNode: $287e438c8151f143$var$deleteNode,
    getConnection: $287e438c8151f143$var$getConnection,
    getConnectionID: $287e438c8151f143$var$getConnectionID,
    insertEdgeAfter: $287e438c8151f143$var$insertEdgeAfter,
    insertEdgeBefore: $287e438c8151f143$var$insertEdgeBefore,
    update: $287e438c8151f143$var$update
};

});
parcelRegister("9eVAj", function(module, exports) {
'use strict';

var $kgraI = parcelRequire("kgraI");

var $4mHYE = parcelRequire("4mHYE");
var $6ba216fdabb8689b$var$intern = $4mHYE.intern;
var $6ba216fdabb8689b$var$PREFIX = 'client:';
function $6ba216fdabb8689b$var$generateClientID(id, storageKey, index) {
    var internedId = $kgraI.STRING_INTERN_LEVEL <= 0 ? id : $6ba216fdabb8689b$var$intern(id, $kgraI.MAX_DATA_ID_LENGTH);
    var key = internedId + ':' + storageKey;
    if (index != null) key += ':' + index;
    if (key.indexOf($6ba216fdabb8689b$var$PREFIX) !== 0) key = $6ba216fdabb8689b$var$PREFIX + key;
    return key;
}
function $6ba216fdabb8689b$var$isClientID(id) {
    return id.indexOf($6ba216fdabb8689b$var$PREFIX) === 0;
}
var $6ba216fdabb8689b$var$localID = 0;
function $6ba216fdabb8689b$var$generateUniqueClientID() {
    return "".concat($6ba216fdabb8689b$var$PREFIX, "local:").concat($6ba216fdabb8689b$var$localID++);
}
function $6ba216fdabb8689b$var$generateClientObjectClientID(typename, localId, index) {
    var key = "".concat($6ba216fdabb8689b$var$PREFIX).concat(typename, ":").concat(localId);
    if (index != null) key += ':' + index;
    return key;
}
module.exports = {
    generateClientID: $6ba216fdabb8689b$var$generateClientID,
    generateClientObjectClientID: $6ba216fdabb8689b$var$generateClientObjectClientID,
    generateUniqueClientID: $6ba216fdabb8689b$var$generateUniqueClientID,
    isClientID: $6ba216fdabb8689b$var$isClientID
};

});
parcelRegister("4mHYE", function(module, exports) {
'use strict';
var $32db547478b97526$var$internTable = new Map();
var $32db547478b97526$var$nextIndex = 1;
var $32db547478b97526$var$digits = $32db547478b97526$var$initDigitTable();
var $32db547478b97526$var$INTERN_PREFIX = '\t';
var $32db547478b97526$var$ESCAPE_PREFIX = '\v';
function $32db547478b97526$var$initDigitTable() {
    var digits = new Set();
    for(var i = 0; i < 10; ++i)digits.add(i.toString());
    return digits;
}
function $32db547478b97526$var$escape(str) {
    if (str[0] === $32db547478b97526$var$INTERN_PREFIX && $32db547478b97526$var$digits.has(str[1]) || str[0] === $32db547478b97526$var$ESCAPE_PREFIX) return $32db547478b97526$var$ESCAPE_PREFIX + str;
    return str;
}
function $32db547478b97526$var$intern(str, limit) {
    if (limit == null || str.length < limit) return $32db547478b97526$var$escape(str);
    var internedString = $32db547478b97526$var$internTable.get(str);
    if (internedString != null) return internedString;
    internedString = $32db547478b97526$var$INTERN_PREFIX + $32db547478b97526$var$nextIndex++;
    $32db547478b97526$var$internTable.set(str, internedString);
    return internedString;
}
module.exports = {
    intern: $32db547478b97526$var$intern
};

});


parcelRegister("8tGFT", function(module, exports) {
'use strict';
var $62c22271f387c418$var$CONNECTION_CALLS = {
    after: true,
    before: true,
    find: true,
    first: true,
    last: true,
    surrounds: true
};
var $62c22271f387c418$var$config = {
    CURSOR: 'cursor',
    EDGES: 'edges',
    END_CURSOR: 'endCursor',
    HAS_NEXT_PAGE: 'hasNextPage',
    HAS_PREV_PAGE: 'hasPreviousPage',
    NODE: 'node',
    PAGE_INFO_TYPE: 'PageInfo',
    PAGE_INFO: 'pageInfo',
    START_CURSOR: 'startCursor'
};
var $62c22271f387c418$var$ConnectionInterface = {
    inject: function inject(newConfig) {
        $62c22271f387c418$var$config = newConfig;
    },
    get: function get() {
        return $62c22271f387c418$var$config;
    },
    isConnectionCall: function isConnectionCall(call) {
        return $62c22271f387c418$var$CONNECTION_CALLS.hasOwnProperty(call.name);
    }
};
module.exports = $62c22271f387c418$var$ConnectionInterface;

});


parcelRegister("8PXJh", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $66f16b26675e117e$var$_interopRequireDefault = $8gviu.default;

var $66f16b26675e117e$var$_createForOfIteratorHelper2 = $66f16b26675e117e$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $3txKR = parcelRequire("3txKR");

var $8tGFT = parcelRequire("8tGFT");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
var $66f16b26675e117e$var$DeleteRecordHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record != null) {
            var idOrIds = record.getValue(payload.fieldKey);
            if (typeof idOrIds === 'string') store["delete"](idOrIds);
            else if (Array.isArray(idOrIds)) idOrIds.forEach(function(id) {
                if (typeof id === 'string') store["delete"](id);
            });
        }
    }
};
var $66f16b26675e117e$var$DeleteEdgeHandler = {
    update: function update(store, payload) {
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $jwy7p(false);
        var idOrIds = record.getValue(payload.fieldKey);
        var idList = Array.isArray(idOrIds) ? idOrIds : [
            idOrIds
        ];
        idList.forEach(function(id) {
            if (typeof id === 'string') {
                var _iterator = (0, $66f16b26675e117e$var$_createForOfIteratorHelper2["default"])(connections), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var connectionID = _step.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        $3txKR.deleteNode(connection, id);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        });
    }
};
var $66f16b26675e117e$var$AppendEdgeHandler = {
    update: $66f16b26675e117e$var$edgeUpdater($3txKR.insertEdgeAfter)
};
var $66f16b26675e117e$var$PrependEdgeHandler = {
    update: $66f16b26675e117e$var$edgeUpdater($3txKR.insertEdgeBefore)
};
var $66f16b26675e117e$var$AppendNodeHandler = {
    update: $66f16b26675e117e$var$nodeUpdater($3txKR.insertEdgeAfter)
};
var $66f16b26675e117e$var$PrependNodeHandler = {
    update: $66f16b26675e117e$var$nodeUpdater($3txKR.insertEdgeBefore)
};
function $66f16b26675e117e$var$edgeUpdater(insertFn) {
    return function(store, payload) {
        var _serverEdges;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var connections = payload.handleArgs.connections;
        !(connections != null) && $jwy7p(false);
        var singleServerEdge, serverEdges;
        try {
            singleServerEdge = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused) {}
        if (!singleServerEdge) try {
            serverEdges = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused2) {}
        if (singleServerEdge == null && serverEdges == null) return;
        var _ConnectionInterface$ = $8tGFT.get(), NODE = _ConnectionInterface$.NODE, EDGES = _ConnectionInterface$.EDGES;
        var serverEdgeList = (_serverEdges = serverEdges) !== null && _serverEdges !== void 0 ? _serverEdges : [
            singleServerEdge
        ];
        var _iterator2 = (0, $66f16b26675e117e$var$_createForOfIteratorHelper2["default"])(serverEdgeList), _step2;
        try {
            var _loop = function _loop() {
                var serverEdge = _step2.value;
                if (serverEdge == null) return "continue";
                var serverNode = serverEdge.getLinkedRecord('node');
                if (!serverNode) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator3 = (0, $66f16b26675e117e$var$_createForOfIteratorHelper2["default"])(connections), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var connectionID = _step3.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked === void 0 ? void 0 : _connection$getLinked.some(function(edge) {
                            var _edge$getLinkedRecord;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord === void 0 ? void 0 : _edge$getLinkedRecord.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $3txKR.buildConnectionEdge(store, connection, serverEdge);
                        !(clientEdge != null) && $jwy7p(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
            };
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _connection$getLinked;
                var _ret = _loop();
                if (_ret === "continue") continue;
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
    };
}
function $66f16b26675e117e$var$nodeUpdater(insertFn) {
    return function(store, payload) {
        var _serverNodes;
        var record = store.get(payload.dataID);
        if (record == null) return;
        var _payload$handleArgs = payload.handleArgs, connections = _payload$handleArgs.connections, edgeTypeName = _payload$handleArgs.edgeTypeName;
        !(connections != null) && $jwy7p(false);
        !(edgeTypeName != null) && $jwy7p(false);
        var singleServerNode;
        var serverNodes;
        try {
            singleServerNode = record.getLinkedRecord(payload.fieldKey);
        } catch (_unused3) {}
        if (!singleServerNode) try {
            serverNodes = record.getLinkedRecords(payload.fieldKey);
        } catch (_unused4) {}
        if (singleServerNode == null && serverNodes == null) return;
        var _ConnectionInterface$2 = $8tGFT.get(), NODE = _ConnectionInterface$2.NODE, EDGES = _ConnectionInterface$2.EDGES;
        var serverNodeList = (_serverNodes = serverNodes) !== null && _serverNodes !== void 0 ? _serverNodes : [
            singleServerNode
        ];
        var _iterator4 = (0, $66f16b26675e117e$var$_createForOfIteratorHelper2["default"])(serverNodeList), _step4;
        try {
            var _loop2 = function _loop2() {
                var serverNode = _step4.value;
                if (serverNode == null) return "continue";
                var serverNodeId = serverNode.getDataID();
                var _iterator5 = (0, $66f16b26675e117e$var$_createForOfIteratorHelper2["default"])(connections), _step5;
                try {
                    for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                        var connectionID = _step5.value;
                        var connection = store.get(connectionID);
                        if (connection == null) continue;
                        var nodeAlreadyExistsInConnection = (_connection$getLinked2 = connection.getLinkedRecords(EDGES)) === null || _connection$getLinked2 === void 0 ? void 0 : _connection$getLinked2.some(function(edge) {
                            var _edge$getLinkedRecord2;
                            return (edge === null || edge === void 0 ? void 0 : (_edge$getLinkedRecord2 = edge.getLinkedRecord(NODE)) === null || _edge$getLinkedRecord2 === void 0 ? void 0 : _edge$getLinkedRecord2.getDataID()) === serverNodeId;
                        });
                        if (nodeAlreadyExistsInConnection) continue;
                        var clientEdge = $3txKR.createEdge(store, connection, serverNode, edgeTypeName);
                        !(clientEdge != null) && $jwy7p(false);
                        insertFn(connection, clientEdge);
                    }
                } catch (err) {
                    _iterator5.e(err);
                } finally{
                    _iterator5.f();
                }
            };
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _connection$getLinked2;
                var _ret2 = _loop2();
                if (_ret2 === "continue") continue;
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
}
module.exports = {
    AppendEdgeHandler: $66f16b26675e117e$var$AppendEdgeHandler,
    DeleteRecordHandler: $66f16b26675e117e$var$DeleteRecordHandler,
    PrependEdgeHandler: $66f16b26675e117e$var$PrependEdgeHandler,
    AppendNodeHandler: $66f16b26675e117e$var$AppendNodeHandler,
    PrependNodeHandler: $66f16b26675e117e$var$PrependNodeHandler,
    DeleteEdgeHandler: $66f16b26675e117e$var$DeleteEdgeHandler
};

});

parcelRegister("gRVEw", function(module, exports) {
'use strict';

var $3txKR = parcelRequire("3txKR");

var $8PXJh = parcelRequire("8PXJh");

var $jwy7p = parcelRequire("jwy7p");
function $c47e5132024b2266$var$RelayDefaultHandlerProvider(handle) {
    switch(handle){
        case 'connection':
            return $3txKR;
        case 'deleteRecord':
            return $8PXJh.DeleteRecordHandler;
        case 'deleteEdge':
            return $8PXJh.DeleteEdgeHandler;
        case 'appendEdge':
            return $8PXJh.AppendEdgeHandler;
        case 'prependEdge':
            return $8PXJh.PrependEdgeHandler;
        case 'appendNode':
            return $8PXJh.AppendNodeHandler;
        case 'prependNode':
            return $8PXJh.PrependNodeHandler;
    }
    $jwy7p(false);
}
module.exports = $c47e5132024b2266$var$RelayDefaultHandlerProvider;

});

parcelRegister("56JnL", function(module, exports) {
'use strict';

var $lQR7T = parcelRequire("lQR7T");
var $3b80b7461c5e0f3b$var$getRequest = $lQR7T.getRequest;

var $gJGd4 = parcelRequire("gJGd4");

var $1v3vf = parcelRequire("1v3vf");
var $3b80b7461c5e0f3b$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;

var $5RzQz = parcelRequire("5RzQz");

var $jwy7p = parcelRequire("jwy7p");
function $3b80b7461c5e0f3b$var$applyOptimisticMutation(environment, config) {
    !$gJGd4(environment) && $jwy7p(false);
    var mutation = $3b80b7461c5e0f3b$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    var optimisticUpdater = config.optimisticUpdater;
    var configs = config.configs, optimisticResponse = config.optimisticResponse, variables = config.variables;
    var operation = $3b80b7461c5e0f3b$var$createOperationDescriptor(mutation, variables);
    if (configs) {
        var _RelayDeclarativeMuta = $5RzQz.convert(configs, mutation, optimisticUpdater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
    }
    return environment.applyMutation({
        operation: operation,
        response: optimisticResponse,
        updater: optimisticUpdater
    });
}
module.exports = $3b80b7461c5e0f3b$var$applyOptimisticMutation;

});
parcelRegister("gJGd4", function(module, exports) {
'use strict';
function $c2f1974a3c3f0227$var$isRelayModernEnvironment(environment) {
    return Boolean(environment && environment['@@RelayModernEnvironment']);
}
module.exports = $c2f1974a3c3f0227$var$isRelayModernEnvironment;

});

parcelRegister("5RzQz", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $444db56f54427adb$var$_interopRequireDefault = $8gviu.default;

var $444db56f54427adb$var$_createForOfIteratorHelper2 = $444db56f54427adb$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $3txKR = parcelRequire("3txKR");
parcelRequire("i0yon");
var $444db56f54427adb$var$MutationTypes = Object.freeze({
    RANGE_ADD: 'RANGE_ADD',
    RANGE_DELETE: 'RANGE_DELETE',
    NODE_DELETE: 'NODE_DELETE'
});
var $444db56f54427adb$var$RangeOperations = Object.freeze({
    APPEND: 'append',
    PREPEND: 'prepend'
});
function $444db56f54427adb$var$convert(configs, request, optimisticUpdater, updater) {
    var configOptimisticUpdates = optimisticUpdater ? [
        optimisticUpdater
    ] : [];
    var configUpdates = updater ? [
        updater
    ] : [];
    configs.forEach(function(config) {
        switch(config.type){
            case 'NODE_DELETE':
                var nodeDeleteResult = $444db56f54427adb$var$nodeDelete(config, request);
                if (nodeDeleteResult) {
                    configOptimisticUpdates.push(nodeDeleteResult);
                    configUpdates.push(nodeDeleteResult);
                }
                break;
            case 'RANGE_ADD':
                var rangeAddResult = $444db56f54427adb$var$rangeAdd(config, request);
                if (rangeAddResult) {
                    configOptimisticUpdates.push(rangeAddResult);
                    configUpdates.push(rangeAddResult);
                }
                break;
            case 'RANGE_DELETE':
                var rangeDeleteResult = $444db56f54427adb$var$rangeDelete(config, request);
                if (rangeDeleteResult) {
                    configOptimisticUpdates.push(rangeDeleteResult);
                    configUpdates.push(rangeDeleteResult);
                }
                break;
        }
    });
    return {
        optimisticUpdater: function optimisticUpdater(store, data) {
            configOptimisticUpdates.forEach(function(eachOptimisticUpdater) {
                eachOptimisticUpdater(store, data);
            });
        },
        updater: function updater(store, data) {
            configUpdates.forEach(function(eachUpdater) {
                eachUpdater(store, data);
            });
        }
    };
}
function $444db56f54427adb$var$nodeDelete(config, request) {
    var deletedIDFieldName = config.deletedIDFieldName;
    var rootField = $444db56f54427adb$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var deleteID = payload.getValue(deletedIDFieldName);
        var deleteIDs = Array.isArray(deleteID) ? deleteID : [
            deleteID
        ];
        deleteIDs.forEach(function(id) {
            if (id && typeof id === 'string') store["delete"](id);
        });
    };
}
function $444db56f54427adb$var$rangeAdd(config, request) {
    var parentID = config.parentID, connectionInfo = config.connectionInfo, edgeName = config.edgeName;
    if (!parentID) return null;
    var rootField = $444db56f54427adb$var$getRootField(request);
    if (!connectionInfo || !rootField) return null;
    return function(store, data) {
        var parent = store.get(parentID);
        if (!parent) return;
        var payload = store.getRootField(rootField);
        if (!payload) return;
        var serverEdge = payload.getLinkedRecord(edgeName);
        var _iterator = (0, $444db56f54427adb$var$_createForOfIteratorHelper2["default"])(connectionInfo), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var info = _step.value;
                if (!serverEdge) continue;
                var connection = $3txKR.getConnection(parent, info.key, info.filters);
                if (!connection) continue;
                var clientEdge = $3txKR.buildConnectionEdge(store, connection, serverEdge);
                if (!clientEdge) continue;
                switch(info.rangeBehavior){
                    case 'append':
                        $3txKR.insertEdgeAfter(connection, clientEdge);
                        break;
                    case 'prepend':
                        $3txKR.insertEdgeBefore(connection, clientEdge);
                        break;
                    default:
                        break;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    };
}
function $444db56f54427adb$var$rangeDelete(config, request) {
    var parentID = config.parentID, connectionKeys = config.connectionKeys, pathToConnection = config.pathToConnection, deletedIDFieldName = config.deletedIDFieldName;
    if (!parentID) return null;
    var rootField = $444db56f54427adb$var$getRootField(request);
    if (!rootField) return null;
    return function(store, data) {
        if (!data) return;
        var deleteIDs = [];
        var deletedIDField = data[rootField];
        if (deletedIDField && Array.isArray(deletedIDFieldName)) {
            var _iterator2 = (0, $444db56f54427adb$var$_createForOfIteratorHelper2["default"])(deletedIDFieldName), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var eachField = _step2.value;
                    if (deletedIDField && typeof deletedIDField === 'object') deletedIDField = deletedIDField[eachField];
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(idObject) {
                if (idObject && idObject.id && typeof idObject === 'object' && typeof idObject.id === 'string') deleteIDs.push(idObject.id);
            });
            else if (deletedIDField && deletedIDField.id && typeof deletedIDField.id === 'string') deleteIDs.push(deletedIDField.id);
        } else if (deletedIDField && typeof deletedIDFieldName === 'string' && typeof deletedIDField === 'object') {
            deletedIDField = deletedIDField[deletedIDFieldName];
            if (typeof deletedIDField === 'string') deleteIDs.push(deletedIDField);
            else if (Array.isArray(deletedIDField)) deletedIDField.forEach(function(id) {
                if (typeof id === 'string') deleteIDs.push(id);
            });
        }
        $444db56f54427adb$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs);
    };
}
function $444db56f54427adb$var$deleteNode(parentID, connectionKeys, pathToConnection, store, deleteIDs) {
    var parent = store.get(parentID);
    if (!parent) return;
    if (pathToConnection.length < 2) return;
    var recordProxy = parent;
    for(var i = 1; i < pathToConnection.length - 1; i++)if (recordProxy) recordProxy = recordProxy.getLinkedRecord(pathToConnection[i]);
    if (!connectionKeys || !recordProxy) return;
    var _iterator3 = (0, $444db56f54427adb$var$_createForOfIteratorHelper2["default"])(connectionKeys), _step3;
    try {
        var _loop = function _loop() {
            var key = _step3.value;
            var connection = $3txKR.getConnection(recordProxy, key.key, key.filters);
            if (connection) deleteIDs.forEach(function(deleteID) {
                $3txKR.deleteNode(connection, deleteID);
            });
        };
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;)_loop();
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $444db56f54427adb$var$getRootField(request) {
    if (request.fragment.selections && request.fragment.selections.length > 0 && request.fragment.selections[0].kind === 'LinkedField') return request.fragment.selections[0].name;
    return null;
}
module.exports = {
    MutationTypes: $444db56f54427adb$var$MutationTypes,
    RangeOperations: $444db56f54427adb$var$RangeOperations,
    convert: $444db56f54427adb$var$convert
};

});


parcelRegister("4UoGp", function(module, exports) {
'use strict';
function $392f89ed177a8fa7$var$commitLocalUpdate(environment, updater) {
    environment.commitUpdate(updater);
}
module.exports = $392f89ed177a8fa7$var$commitLocalUpdate;

});

parcelRegister("4Sxsl", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $38d628401fbbf863$var$_interopRequireDefault = $8gviu.default;

var $38d628401fbbf863$var$_toConsumableArray2 = $38d628401fbbf863$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $lQR7T = parcelRequire("lQR7T");
var $38d628401fbbf863$var$getRequest = $lQR7T.getRequest;

var $9eVAj = parcelRequire("9eVAj");
var $38d628401fbbf863$var$generateUniqueClientID = $9eVAj.generateUniqueClientID;

var $gJGd4 = parcelRequire("gJGd4");

var $1v3vf = parcelRequire("1v3vf");
var $38d628401fbbf863$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;

var $5RzQz = parcelRequire("5RzQz");
parcelRequire("1SaOO");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $38d628401fbbf863$var$commitMutation(environment, config) {
    !$gJGd4(environment) && $jwy7p(false);
    var mutation = $38d628401fbbf863$var$getRequest(config.mutation);
    if (mutation.params.operationKind !== 'mutation') throw new Error('commitMutation: Expected mutation operation');
    if (mutation.kind !== 'Request') throw new Error('commitMutation: Expected mutation to be of type request');
    var optimisticResponse = config.optimisticResponse, optimisticUpdater = config.optimisticUpdater, updater = config.updater;
    var configs = config.configs, cacheConfig = config.cacheConfig, onError = config.onError, onUnsubscribe = config.onUnsubscribe, variables = config.variables, uploadables = config.uploadables;
    var operation = $38d628401fbbf863$var$createOperationDescriptor(mutation, variables, cacheConfig, $38d628401fbbf863$var$generateUniqueClientID());
    if (typeof optimisticResponse === 'function') optimisticResponse = optimisticResponse();
    if (configs) {
        var _RelayDeclarativeMuta = $5RzQz.convert(configs, mutation, optimisticUpdater, updater);
        optimisticUpdater = _RelayDeclarativeMuta.optimisticUpdater;
        updater = _RelayDeclarativeMuta.updater;
    }
    var errors = [];
    var subscription = environment.executeMutation({
        operation: operation,
        optimisticResponse: optimisticResponse,
        optimisticUpdater: optimisticUpdater,
        updater: updater,
        uploadables: uploadables
    }).subscribe({
        next: function next(payload) {
            var _config$onNext;
            if (Array.isArray(payload)) payload.forEach(function(item) {
                if (item.errors) errors.push.apply(errors, (0, $38d628401fbbf863$var$_toConsumableArray2["default"])(item.errors));
            });
            else if (payload.errors) errors.push.apply(errors, (0, $38d628401fbbf863$var$_toConsumableArray2["default"])(payload.errors));
            (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
        },
        complete: function complete() {
            var onCompleted = config.onCompleted;
            if (onCompleted) {
                var snapshot = environment.lookup(operation.fragment);
                onCompleted(snapshot.data, errors.length !== 0 ? errors : null);
            }
        },
        error: onError,
        unsubscribe: onUnsubscribe
    });
    return {
        dispose: subscription.unsubscribe
    };
}
module.exports = $38d628401fbbf863$var$commitMutation;

});
parcelRegister("1SaOO", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $15d339f46e7fa3d6$var$_interopRequireDefault = $8gviu.default;

var $15d339f46e7fa3d6$var$_objectSpread2 = $15d339f46e7fa3d6$var$_interopRequireDefault((parcelRequire("lhogL")));
parcelRequire("i0yon");
var $15d339f46e7fa3d6$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $15d339f46e7fa3d6$var$validateMutation = function validateMutation() {};
var $15d339f46e7fa3d6$var$addFieldToDiff, $15d339f46e7fa3d6$var$validateSelections, $15d339f46e7fa3d6$var$validateSelection, $15d339f46e7fa3d6$var$validateModuleImport, $15d339f46e7fa3d6$var$validateAbstractKey, $15d339f46e7fa3d6$var$validateField, $15d339f46e7fa3d6$var$validateOptimisticResponse;
module.exports = $15d339f46e7fa3d6$var$validateMutation;

});


parcelRegister("7Xd49", function(module, exports) {
'use strict';

var $ay8VC = parcelRequire("ay8VC");

var $k8CQv = parcelRequire("k8CQv");
var $5ca82dbb162fccc4$var$convertFetch = $k8CQv.convertFetch;

var $jwy7p = parcelRequire("jwy7p");
function $5ca82dbb162fccc4$var$create(fetchFn, subscribe) {
    var observeFetch = $5ca82dbb162fccc4$var$convertFetch(fetchFn);
    function execute(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var operationVariables = $ay8VC(variables, request.providedVariables);
        if (request.operationKind === 'subscription') {
            !subscribe && $jwy7p(false);
            !!uploadables && $jwy7p(false);
            return subscribe(request, operationVariables, cacheConfig);
        }
        var pollInterval = cacheConfig.poll;
        if (pollInterval != null) {
            !!uploadables && $jwy7p(false);
            return observeFetch(request, operationVariables, {
                force: true
            }).poll(pollInterval);
        }
        return observeFetch(request, operationVariables, cacheConfig, uploadables, logRequestInfo);
    }
    return {
        execute: execute
    };
}
module.exports = {
    create: $5ca82dbb162fccc4$var$create
};

});
parcelRegister("ay8VC", function(module, exports) {
'use strict';
parcelRequire("3UWLk");
parcelRequire("i0yon");
var $7ae40159225224c4$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
var $7ae40159225224c4$var$debugCache = $7ae40159225224c4$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $7ae40159225224c4$var$withProvidedVariables(userSuppliedVariables, providedVariables) {
    if (providedVariables != null) {
        var operationVariables = {};
        Object.assign(operationVariables, userSuppliedVariables);
        Object.keys(providedVariables).forEach(function(varName) {
            var providerFunction = providedVariables[varName].get;
            var providerResult = providerFunction();
            if (!$7ae40159225224c4$var$debugCache.has(providerFunction)) {
                $7ae40159225224c4$var$debugCache.set(providerFunction, providerResult);
                operationVariables[varName] = providerResult;
            } else {
                var cachedResult = $7ae40159225224c4$var$debugCache.get(providerFunction);
                operationVariables[varName] = cachedResult;
            }
        });
        return operationVariables;
    } else return userSuppliedVariables;
}
$7ae40159225224c4$var$withProvidedVariables.tests_only_resetDebugCache = undefined;
module.exports = $7ae40159225224c4$var$withProvidedVariables;

});

parcelRegister("k8CQv", function(module, exports) {
'use strict';

var $9wNSI = parcelRequire("9wNSI");
function $ea92aff5e65583a7$var$convertFetch(fn) {
    return function fetch(request, variables, cacheConfig, uploadables, logRequestInfo) {
        var result = fn(request, variables, cacheConfig, uploadables, logRequestInfo);
        if (result instanceof Error) return $9wNSI.create(function(sink) {
            return sink.error(result);
        });
        return $9wNSI.from(result);
    };
}
module.exports = {
    convertFetch: $ea92aff5e65583a7$var$convertFetch
};

});


parcelRegister("hE4Is", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $cd89d499ac17f467$var$_interopRequireDefault = $8gviu.default;

var $cd89d499ac17f467$var$_objectSpread2 = $cd89d499ac17f467$var$_interopRequireDefault((parcelRequire("lhogL")));

var $zM4Yi = parcelRequire("zM4Yi");
var $cd89d499ac17f467$var$stableCopy = $zM4Yi.stableCopy;

var $jwy7p = parcelRequire("jwy7p");
var $cd89d499ac17f467$var$RelayQueryResponseCache = /*#__PURE__*/ function() {
    function RelayQueryResponseCache(_ref) {
        var size = _ref.size, ttl = _ref.ttl;
        !(size > 0) && $jwy7p(false);
        !(ttl > 0) && $jwy7p(false);
        this._responses = new Map();
        this._size = size;
        this._ttl = ttl;
    }
    var _proto = RelayQueryResponseCache.prototype;
    _proto.clear = function clear() {
        this._responses.clear();
    };
    _proto.get = function get(queryID, variables) {
        var _this = this;
        var cacheKey = $cd89d499ac17f467$var$getCacheKey(queryID, variables);
        this._responses.forEach(function(response, key) {
            if (!$cd89d499ac17f467$var$isCurrent(response.fetchTime, _this._ttl)) _this._responses["delete"](key);
        });
        var response = this._responses.get(cacheKey);
        if (response == null) return null;
        if (Array.isArray(response.payload)) return response.payload.map(function(payload) {
            return (0, $cd89d499ac17f467$var$_objectSpread2["default"])((0, $cd89d499ac17f467$var$_objectSpread2["default"])({}, payload), {}, {
                extensions: (0, $cd89d499ac17f467$var$_objectSpread2["default"])((0, $cd89d499ac17f467$var$_objectSpread2["default"])({}, payload.extensions), {}, {
                    cacheTimestamp: response.fetchTime
                })
            });
        });
        return (0, $cd89d499ac17f467$var$_objectSpread2["default"])((0, $cd89d499ac17f467$var$_objectSpread2["default"])({}, response.payload), {}, {
            extensions: (0, $cd89d499ac17f467$var$_objectSpread2["default"])((0, $cd89d499ac17f467$var$_objectSpread2["default"])({}, response.payload.extensions), {}, {
                cacheTimestamp: response.fetchTime
            })
        });
    };
    _proto.set = function set(queryID, variables, payload) {
        var fetchTime = Date.now();
        var cacheKey = $cd89d499ac17f467$var$getCacheKey(queryID, variables);
        this._responses["delete"](cacheKey);
        this._responses.set(cacheKey, {
            fetchTime: fetchTime,
            payload: payload
        });
        if (this._responses.size > this._size) {
            var firstKey = this._responses.keys().next();
            if (!firstKey.done) this._responses["delete"](firstKey.value);
        }
    };
    return RelayQueryResponseCache;
}();
function $cd89d499ac17f467$var$getCacheKey(queryID, variables) {
    return JSON.stringify($cd89d499ac17f467$var$stableCopy({
        queryID: queryID,
        variables: variables
    }));
}
function $cd89d499ac17f467$var$isCurrent(fetchTime, ttl) {
    return fetchTime + ttl >= Date.now();
}
module.exports = $cd89d499ac17f467$var$RelayQueryResponseCache;

});

parcelRegister("7Rjp9", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $5b8c8906980dd919$var$_interopRequireDefault = $8gviu.default;

var $5b8c8906980dd919$var$_objectSpread2 = $5b8c8906980dd919$var$_interopRequireDefault((parcelRequire("lhogL")));

var $9wNSI = parcelRequire("9wNSI");

var $1v3vf = parcelRequire("1v3vf");
var $5b8c8906980dd919$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;

var $fSw0O = parcelRequire("fSw0O");
var $5b8c8906980dd919$var$handlePotentialSnapshotErrors = $fSw0O.handlePotentialSnapshotErrors;

var $fWLbj = parcelRequire("fWLbj");

var $lQR7T = parcelRequire("lQR7T");
var $5b8c8906980dd919$var$getRequest = $lQR7T.getRequest;

var $jwy7p = parcelRequire("jwy7p");
function $5b8c8906980dd919$var$fetchQuery(environment, query, variables, options) {
    var _options$fetchPolicy;
    var queryNode = $5b8c8906980dd919$var$getRequest(query);
    !(queryNode.params.operationKind === 'query') && $jwy7p(false);
    var networkCacheConfig = (0, $5b8c8906980dd919$var$_objectSpread2["default"])({
        force: true
    }, options === null || options === void 0 ? void 0 : options.networkCacheConfig);
    var operation = $5b8c8906980dd919$var$createOperationDescriptor(queryNode, variables, networkCacheConfig);
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'network-only';
    function readData(snapshot) {
        $5b8c8906980dd919$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
        return snapshot.data;
    }
    switch(fetchPolicy){
        case 'network-only':
            return $5b8c8906980dd919$var$getNetworkObservable(environment, operation).map(readData);
        case 'store-or-network':
            if (environment.check(operation).status === 'available') return $9wNSI.from(environment.lookup(operation.fragment)).map(readData);
            return $5b8c8906980dd919$var$getNetworkObservable(environment, operation).map(readData);
        default:
            fetchPolicy;
            throw new Error('fetchQuery: Invalid fetchPolicy ' + fetchPolicy);
    }
}
function $5b8c8906980dd919$var$getNetworkObservable(environment, operation) {
    return $fWLbj.fetchQuery(environment, operation).map(function() {
        return environment.lookup(operation.fragment);
    });
}
module.exports = $5b8c8906980dd919$var$fetchQuery;

});

parcelRegister("ctzoR", function(module, exports) {
'use strict';

var $1v3vf = parcelRequire("1v3vf");
var $9153a73049fae9ed$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;

var $lQR7T = parcelRequire("lQR7T");
var $9153a73049fae9ed$var$getRequest = $lQR7T.getRequest;
function $9153a73049fae9ed$var$fetchQuery_DEPRECATED(environment, taggedNode, variables, cacheConfig) {
    var query = $9153a73049fae9ed$var$getRequest(taggedNode);
    if (query.params.operationKind !== 'query') throw new Error('fetchQuery: Expected query operation');
    var operation = $9153a73049fae9ed$var$createOperationDescriptor(query, variables, cacheConfig);
    return environment.execute({
        operation: operation
    }).map(function() {
        return environment.lookup(operation.fragment).data;
    }).toPromise();
}
module.exports = $9153a73049fae9ed$var$fetchQuery_DEPRECATED;

});

parcelRegister("6s54L", function(module, exports) {
'use strict';
var $4b294b92eb257f47$var$PreloadableQueryRegistry = /*#__PURE__*/ function() {
    function PreloadableQueryRegistry() {
        this._preloadableQueries = new Map();
        this._callbacks = new Map();
    }
    var _proto = PreloadableQueryRegistry.prototype;
    _proto.set = function set(key, value) {
        this._preloadableQueries.set(key, value);
        var callbacks = this._callbacks.get(key);
        if (callbacks != null) callbacks.forEach(function(cb) {
            try {
                cb(value);
            } catch (e) {
                setTimeout(function() {
                    throw e;
                }, 0);
            }
        });
    };
    _proto.get = function get(key) {
        return this._preloadableQueries.get(key);
    };
    _proto.onLoad = function onLoad(key, callback) {
        var _this$_callbacks$get;
        var callbacks = (_this$_callbacks$get = this._callbacks.get(key)) !== null && _this$_callbacks$get !== void 0 ? _this$_callbacks$get : new Set();
        callbacks.add(callback);
        var dispose = function dispose() {
            callbacks["delete"](callback);
        };
        this._callbacks.set(key, callbacks);
        return {
            dispose: dispose
        };
    };
    _proto.clear = function clear() {
        this._preloadableQueries.clear();
    };
    return PreloadableQueryRegistry;
}();
var $4b294b92eb257f47$var$preloadableQueryRegistry = new $4b294b92eb257f47$var$PreloadableQueryRegistry();
module.exports = $4b294b92eb257f47$var$preloadableQueryRegistry;

});

parcelRegister("gUWzw", function(module, exports) {
'use strict';

var $i3rTd = parcelRequire("i3rTd");
parcelRequire("i0yon");
function $c50f4f7dd5e605f3$var$createFragmentSpecResolver(context, containerName, fragments, props, rootIsQueryRenderer, callback) {
    var fragmentNames;
    return new $i3rTd(context, fragments, props, callback, rootIsQueryRenderer);
}
module.exports = $c50f4f7dd5e605f3$var$createFragmentSpecResolver;

});
parcelRegister("i3rTd", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $d24e2417c5969d67$var$_interopRequireDefault = $8gviu.default;

var $d24e2417c5969d67$var$_objectSpread2 = $d24e2417c5969d67$var$_interopRequireDefault((parcelRequire("lhogL")));

var $d24e2417c5969d67$var$_defineProperty2 = $d24e2417c5969d67$var$_interopRequireDefault((parcelRequire("dangC")));

var $1mn05 = parcelRequire("1mn05");

var $fSw0O = parcelRequire("fSw0O");
var $d24e2417c5969d67$var$handlePotentialSnapshotErrors = $fSw0O.handlePotentialSnapshotErrors;

var $dV5wZ = parcelRequire("dV5wZ");

var $fT9vU = parcelRequire("fT9vU");

var $kgraI = parcelRequire("kgraI");

var $1v3vf = parcelRequire("1v3vf");
var $d24e2417c5969d67$var$createRequestDescriptor = $1v3vf.createRequestDescriptor;

var $dPVEr = parcelRequire("dPVEr");
var $d24e2417c5969d67$var$areEqualSelectors = $dPVEr.areEqualSelectors, $d24e2417c5969d67$var$createReaderSelector = $dPVEr.createReaderSelector, $d24e2417c5969d67$var$getSelectorsFromObject = $dPVEr.getSelectorsFromObject;

var $3UWLk = parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
var $d24e2417c5969d67$var$RelayModernFragmentSpecResolver = /*#__PURE__*/ function() {
    function RelayModernFragmentSpecResolver(context, fragments, props, callback, rootIsQueryRenderer) {
        var _this = this;
        (0, $d24e2417c5969d67$var$_defineProperty2["default"])(this, "_onChange", function() {
            _this._stale = true;
            if (typeof _this._callback === 'function') _this._callback();
        });
        this._callback = callback;
        this._context = context;
        this._data = {};
        this._fragments = fragments;
        this._props = {};
        this._resolvers = {};
        this._stale = false;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this.setProps(props);
    }
    var _proto = RelayModernFragmentSpecResolver.prototype;
    _proto.dispose = function dispose() {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) $d24e2417c5969d67$var$disposeCallback(this._resolvers[key]);
    };
    _proto.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
                var resolver = this._resolvers[key];
                var prevItem = prevData[key];
                if (resolver) {
                    var nextItem = resolver.resolve();
                    if (nextData || nextItem !== prevItem) {
                        nextData = nextData || (0, $d24e2417c5969d67$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = nextItem;
                    }
                } else {
                    var prop = this._props[key];
                    var _nextItem = prop !== undefined ? prop : null;
                    if (nextData || !$dV5wZ(_nextItem, prevItem)) {
                        nextData = nextData || (0, $d24e2417c5969d67$var$_objectSpread2["default"])({}, prevData);
                        nextData[key] = _nextItem;
                    }
                }
            }
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto.setCallback = function setCallback(props, callback) {
        this._callback = callback;
        if ($kgraI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this.setProps(props);
    };
    _proto.setProps = function setProps(props) {
        this._props = {};
        var ownedSelectors = $d24e2417c5969d67$var$getSelectorsFromObject(this._fragments, props);
        for(var key in ownedSelectors)if (ownedSelectors.hasOwnProperty(key)) {
            var ownedSelector = ownedSelectors[key];
            var resolver = this._resolvers[key];
            if (ownedSelector == null) {
                if (resolver != null) resolver.dispose();
                resolver = null;
            } else if (ownedSelector.kind === 'PluralReaderSelector') {
                if (resolver == null) resolver = new $d24e2417c5969d67$var$SelectorListResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
                else {
                    !(resolver instanceof $d24e2417c5969d67$var$SelectorListResolver) && $jwy7p(false);
                    resolver.setSelector(ownedSelector);
                }
            } else if (resolver == null) resolver = new $d24e2417c5969d67$var$SelectorResolver(this._context.environment, this._rootIsQueryRenderer, ownedSelector, this._callback != null, this._onChange);
            else {
                !(resolver instanceof $d24e2417c5969d67$var$SelectorResolver) && $jwy7p(false);
                resolver.setSelector(ownedSelector);
            }
            this._props[key] = props[key];
            this._resolvers[key] = resolver;
        }
        this._stale = true;
    };
    _proto.setVariables = function setVariables(variables, request) {
        for(var key in this._resolvers)if (this._resolvers.hasOwnProperty(key)) {
            var resolver = this._resolvers[key];
            if (resolver) resolver.setVariables(variables, request);
        }
        this._stale = true;
    };
    return RelayModernFragmentSpecResolver;
}();
var $d24e2417c5969d67$var$SelectorResolver = /*#__PURE__*/ function() {
    function SelectorResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this2 = this;
        (0, $d24e2417c5969d67$var$_defineProperty2["default"])(this, "_onChange", function(snapshot) {
            _this2._data = snapshot.data;
            _this2._isMissingData = snapshot.isMissingData;
            _this2._fieldErrors = snapshot.fieldErrors;
            _this2._callback();
        });
        var _snapshot = environment.lookup(selector);
        this._callback = callback;
        this._data = _snapshot.data;
        this._isMissingData = _snapshot.isMissingData;
        this._fieldErrors = _snapshot.fieldErrors;
        this._environment = environment;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._selector = selector;
        if ($kgraI.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
            if (subscribeOnConstruction) this._subscription = environment.subscribe(_snapshot, this._onChange);
        } else this._subscription = environment.subscribe(_snapshot, this._onChange);
    }
    var _proto2 = SelectorResolver.prototype;
    _proto2.dispose = function dispose() {
        if (this._subscription) {
            this._subscription.dispose();
            this._subscription = null;
        }
    };
    _proto2.resolve = function resolve() {
        if (this._isMissingData === true) {
            var pendingOperationsResult = $1mn05(this._environment, this._selector.node, this._selector.owner);
            var promise = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.promise;
            if (promise != null) {
                if (this._rootIsQueryRenderer) ;
                else {
                    var _pendingOperationsRes;
                    var pendingOperations = (_pendingOperationsRes = pendingOperationsResult === null || pendingOperationsResult === void 0 ? void 0 : pendingOperationsResult.pendingOperations) !== null && _pendingOperationsRes !== void 0 ? _pendingOperationsRes : [];
                    this._environment.__log({
                        name: 'suspense.fragment',
                        data: this._data,
                        fragment: this._selector.node,
                        isRelayHooks: false,
                        isMissingData: this._isMissingData,
                        isPromiseCached: false,
                        pendingOperations: pendingOperations
                    });
                    throw promise;
                }
            }
        }
        $d24e2417c5969d67$var$handlePotentialSnapshotErrors(this._environment, this._fieldErrors);
        return this._data;
    };
    _proto2.setSelector = function setSelector(selector) {
        if (this._subscription != null && $d24e2417c5969d67$var$areEqualSelectors(selector, this._selector)) return;
        this.dispose();
        var snapshot = this._environment.lookup(selector);
        this._data = $fT9vU(this._data, snapshot.data);
        this._isMissingData = snapshot.isMissingData;
        this._fieldErrors = snapshot.fieldErrors;
        this._selector = selector;
        this._subscription = this._environment.subscribe(snapshot, this._onChange);
    };
    _proto2.setVariables = function setVariables(variables, request) {
        if ($3UWLk(variables, this._selector.variables)) return;
        var requestDescriptor = $d24e2417c5969d67$var$createRequestDescriptor(request, variables);
        var selector = $d24e2417c5969d67$var$createReaderSelector(this._selector.node, this._selector.dataID, variables, requestDescriptor);
        this.setSelector(selector);
    };
    return SelectorResolver;
}();
var $d24e2417c5969d67$var$SelectorListResolver = /*#__PURE__*/ function() {
    function SelectorListResolver(environment, rootIsQueryRenderer, selector, subscribeOnConstruction, callback) {
        var _this3 = this;
        (0, $d24e2417c5969d67$var$_defineProperty2["default"])(this, "_onChange", function(data) {
            _this3._stale = true;
            _this3._callback();
        });
        this._callback = callback;
        this._data = [];
        this._environment = environment;
        this._resolvers = [];
        this._stale = true;
        this._rootIsQueryRenderer = rootIsQueryRenderer;
        this._subscribeOnConstruction = subscribeOnConstruction;
        this.setSelector(selector);
    }
    var _proto3 = SelectorListResolver.prototype;
    _proto3.dispose = function dispose() {
        this._resolvers.forEach($d24e2417c5969d67$var$disposeCallback);
    };
    _proto3.resolve = function resolve() {
        if (this._stale) {
            var prevData = this._data;
            var nextData;
            for(var ii = 0; ii < this._resolvers.length; ii++){
                var prevItem = prevData[ii];
                var nextItem = this._resolvers[ii].resolve();
                if (nextData || nextItem !== prevItem) {
                    nextData = nextData || prevData.slice(0, ii);
                    nextData.push(nextItem);
                }
            }
            if (!nextData && this._resolvers.length !== prevData.length) nextData = prevData.slice(0, this._resolvers.length);
            this._data = nextData || prevData;
            this._stale = false;
        }
        return this._data;
    };
    _proto3.setSelector = function setSelector(selector) {
        var selectors = selector.selectors;
        while(this._resolvers.length > selectors.length){
            var resolver = this._resolvers.pop();
            resolver.dispose();
        }
        for(var ii = 0; ii < selectors.length; ii++)if (ii < this._resolvers.length) this._resolvers[ii].setSelector(selectors[ii]);
        else this._resolvers[ii] = new $d24e2417c5969d67$var$SelectorResolver(this._environment, this._rootIsQueryRenderer, selectors[ii], this._subscribeOnConstruction, this._onChange);
        this._stale = true;
    };
    _proto3.setVariables = function setVariables(variables, request) {
        this._resolvers.forEach(function(resolver) {
            return resolver.setVariables(variables, request);
        });
        this._stale = true;
    };
    return SelectorListResolver;
}();
function $d24e2417c5969d67$var$disposeCallback(disposable) {
    disposable && disposable.dispose();
}
module.exports = $d24e2417c5969d67$var$RelayModernFragmentSpecResolver;

});
parcelRegister("1mn05", function(module, exports) {
'use strict';

var $fWLbj = parcelRequire("fWLbj");
var $0fd9afeabd35e551$var$getPromiseForActiveRequest = $fWLbj.getPromiseForActiveRequest;
function $0fd9afeabd35e551$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner) {
    var _pendingOperations$ma, _pendingOperations;
    var pendingOperations = [];
    var promise = $0fd9afeabd35e551$var$getPromiseForActiveRequest(environment, fragmentOwner);
    if (promise != null) pendingOperations = [
        fragmentOwner
    ];
    else {
        var _result$pendingOperat, _result$promise;
        var operationTracker = environment.getOperationTracker();
        var result = operationTracker.getPendingOperationsAffectingOwner(fragmentOwner);
        pendingOperations = (_result$pendingOperat = result === null || result === void 0 ? void 0 : result.pendingOperations) !== null && _result$pendingOperat !== void 0 ? _result$pendingOperat : [];
        promise = (_result$promise = result === null || result === void 0 ? void 0 : result.promise) !== null && _result$promise !== void 0 ? _result$promise : null;
    }
    if (!promise) return null;
    var pendingOperationName = (_pendingOperations$ma = (_pendingOperations = pendingOperations) === null || _pendingOperations === void 0 ? void 0 : _pendingOperations.map(function(op) {
        return op.node.params.name;
    }).join(',')) !== null && _pendingOperations$ma !== void 0 ? _pendingOperations$ma : null;
    if (pendingOperationName == null || pendingOperationName.length === 0) pendingOperationName = 'Unknown pending operation';
    var fragmentName = fragmentNode.name;
    var promiseDisplayName = pendingOperationName === fragmentName ? "Relay(".concat(pendingOperationName, ")") : "Relay(".concat(pendingOperationName, ":").concat(fragmentName, ")");
    promise.displayName = promiseDisplayName;
    environment.__log({
        name: 'pendingoperation.found',
        fragment: fragmentNode,
        fragmentOwner: fragmentOwner,
        pendingOperations: pendingOperations
    });
    return {
        promise: promise,
        pendingOperations: pendingOperations
    };
}
module.exports = $0fd9afeabd35e551$var$getPendingOperationsForFragment;

});

parcelRegister("dV5wZ", function(module, exports) {
'use strict';
function $a224e39d7ee84cae$var$isScalarAndEqual(valueA, valueB) {
    return valueA === valueB && (valueA === null || typeof valueA !== 'object');
}
module.exports = $a224e39d7ee84cae$var$isScalarAndEqual;

});

parcelRegister("fT9vU", function(module, exports) {
'use strict';
function $b9135f48ca77cb9b$var$recycleNodesInto(prevData, nextData) {
    return $b9135f48ca77cb9b$var$recycleNodesIntoImpl(prevData, nextData, true);
}
function $b9135f48ca77cb9b$var$recycleNodesIntoImpl(prevData, nextData, canMutate) {
    if (prevData === nextData || typeof prevData !== 'object' || !prevData || prevData.constructor !== Object && !Array.isArray(prevData) || typeof nextData !== 'object' || !nextData || nextData.constructor !== Object && !Array.isArray(nextData)) return nextData;
    var canRecycle = false;
    var prevArray = Array.isArray(prevData) ? prevData : null;
    var nextArray = Array.isArray(nextData) ? nextData : null;
    if (prevArray && nextArray) {
        var canMutateNext = canMutate && !Object.isFrozen(nextArray);
        canRecycle = nextArray.reduce(function(wasEqual, nextItem, ii) {
            var prevValue = prevArray[ii];
            var nextValue = $b9135f48ca77cb9b$var$recycleNodesIntoImpl(prevValue, nextItem, canMutateNext);
            if (nextValue !== nextArray[ii] && canMutateNext) nextArray[ii] = nextValue;
            return wasEqual && nextValue === prevArray[ii];
        }, true) && prevArray.length === nextArray.length;
    } else if (!prevArray && !nextArray) {
        var prevObject = prevData;
        var nextObject = nextData;
        var prevKeys = Object.keys(prevObject);
        var nextKeys = Object.keys(nextObject);
        var _canMutateNext = canMutate && !Object.isFrozen(nextObject);
        canRecycle = nextKeys.reduce(function(wasEqual, key) {
            var prevValue = prevObject[key];
            var nextValue = $b9135f48ca77cb9b$var$recycleNodesIntoImpl(prevValue, nextObject[key], _canMutateNext);
            if (nextValue !== nextObject[key] && _canMutateNext) nextObject[key] = nextValue;
            return wasEqual && nextValue === prevObject[key];
        }, true) && prevKeys.length === nextKeys.length;
    }
    return canRecycle ? prevData : nextData;
}
module.exports = $b9135f48ca77cb9b$var$recycleNodesInto;

});



parcelRegister("cExt9", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
var $93632ebeb31e067b$var$relayContext;
var $93632ebeb31e067b$var$firstReact;
function $93632ebeb31e067b$var$createRelayContext(react) {
    if (!$93632ebeb31e067b$var$relayContext) {
        $93632ebeb31e067b$var$relayContext = react.createContext(null);
        $93632ebeb31e067b$var$firstReact = react;
    }
    !(react === $93632ebeb31e067b$var$firstReact) && $jwy7p(false);
    return $93632ebeb31e067b$var$relayContext;
}
module.exports = $93632ebeb31e067b$var$createRelayContext;

});

parcelRegister("55dHj", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
var $3b380b6d02394326$var$relayLoggingContext;
var $3b380b6d02394326$var$firstReact;
function $3b380b6d02394326$var$createRelayLoggingContext(react) {
    if (!$3b380b6d02394326$var$relayLoggingContext) {
        $3b380b6d02394326$var$relayLoggingContext = react.createContext(null);
        $3b380b6d02394326$var$firstReact = react;
    }
    !(react === $3b380b6d02394326$var$firstReact) && $jwy7p(false);
    return $3b380b6d02394326$var$relayLoggingContext;
}
module.exports = $3b380b6d02394326$var$createRelayLoggingContext;

});

parcelRegister("1ocpj", function(module, exports) {
'use strict';
var $1031a828ad9964a0$var$LIVE_RESOLVER_SUSPENSE_SENTINEL = Object.freeze({
    __LIVE_RESOLVER_SUSPENSE_SENTINEL: true
});
function $1031a828ad9964a0$var$suspenseSentinel() {
    return $1031a828ad9964a0$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
function $1031a828ad9964a0$var$isSuspenseSentinel(value) {
    return value === $1031a828ad9964a0$var$LIVE_RESOLVER_SUSPENSE_SENTINEL;
}
module.exports = {
    isSuspenseSentinel: $1031a828ad9964a0$var$isSuspenseSentinel,
    suspenseSentinel: $1031a828ad9964a0$var$suspenseSentinel
};

});

parcelRegister("4Mqmi", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $37b0176616c38eb2$var$_interopRequireDefault = $8gviu.default;

var $37b0176616c38eb2$var$_objectSpread2 = $37b0176616c38eb2$var$_interopRequireDefault((parcelRequire("lhogL")));

var $37b0176616c38eb2$var$_RelayModernRecord = $37b0176616c38eb2$var$_interopRequireDefault((parcelRequire("6ZixS")));

var $37b0176616c38eb2$var$_RelayRecordSource = $37b0176616c38eb2$var$_interopRequireDefault((parcelRequire("gqyVK")));

var $37b0176616c38eb2$var$_RelayResponseNormalizer = $37b0176616c38eb2$var$_interopRequireDefault((parcelRequire("7TuZT")));
function $37b0176616c38eb2$var$normalizeResponse(response, selector, typeName, options, useExecTimeResolvers) {
    var _response$extensions;
    var data = response.data, errors = response.errors;
    var source = $37b0176616c38eb2$var$_RelayRecordSource["default"].create();
    var record = $37b0176616c38eb2$var$_RelayModernRecord["default"].create(selector.dataID, typeName);
    source.set(selector.dataID, record);
    var relayPayload = $37b0176616c38eb2$var$_RelayResponseNormalizer["default"].normalize(source, selector, data, options, errors, useExecTimeResolvers);
    return (0, $37b0176616c38eb2$var$_objectSpread2["default"])((0, $37b0176616c38eb2$var$_objectSpread2["default"])({}, relayPayload), {}, {
        isFinal: ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.is_final) === true
    });
}
module.exports = $37b0176616c38eb2$var$normalizeResponse;

});
parcelRegister("6ZixS", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $5166d349cc269302$var$_interopRequireDefault = $8gviu.default;

var $5166d349cc269302$var$_defineProperty2 = $5166d349cc269302$var$_interopRequireDefault((parcelRequire("dangC")));

var $5166d349cc269302$var$_objectWithoutPropertiesLoose2 = $5166d349cc269302$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $5166d349cc269302$var$_toPropertyKey2 = $5166d349cc269302$var$_interopRequireDefault((parcelRequire("hbcmW")));

var $5166d349cc269302$var$_objectSpread2 = $5166d349cc269302$var$_interopRequireDefault((parcelRequire("lhogL")));

var $fHswY = parcelRequire("fHswY");

var $9eVAj = parcelRequire("9eVAj");
var $5166d349cc269302$var$generateClientObjectClientID = $9eVAj.generateClientObjectClientID, $5166d349cc269302$var$isClientID = $9eVAj.isClientID;

var $1ocpj = parcelRequire("1ocpj");
var $5166d349cc269302$var$isSuspenseSentinel = $1ocpj.isSuspenseSentinel;

var $cvcC4 = parcelRequire("cvcC4");
var $5166d349cc269302$var$ACTOR_IDENTIFIER_KEY = $cvcC4.ACTOR_IDENTIFIER_KEY, $5166d349cc269302$var$ERRORS_KEY = $cvcC4.ERRORS_KEY, $5166d349cc269302$var$ID_KEY = $cvcC4.ID_KEY, $5166d349cc269302$var$INVALIDATED_AT_KEY = $cvcC4.INVALIDATED_AT_KEY, $5166d349cc269302$var$REF_KEY = $cvcC4.REF_KEY, $5166d349cc269302$var$REFS_KEY = $cvcC4.REFS_KEY, $5166d349cc269302$var$RELAY_RESOLVER_VALUE_KEY = $cvcC4.RELAY_RESOLVER_VALUE_KEY, $5166d349cc269302$var$ROOT_ID = $cvcC4.ROOT_ID, $5166d349cc269302$var$TYPENAME_KEY = $cvcC4.TYPENAME_KEY;

var $3UWLk = parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $5166d349cc269302$var$clone(record) {
    return (0, $5166d349cc269302$var$_objectSpread2["default"])({}, record);
}
function $5166d349cc269302$var$copyFields(source, sink) {
    for(var key in source){
        if (source.hasOwnProperty(key)) {
            if (key !== $5166d349cc269302$var$ID_KEY && key !== $5166d349cc269302$var$TYPENAME_KEY) sink[key] = source[key];
        }
    }
}
function $5166d349cc269302$var$create(dataID, typeName) {
    var record = {};
    record[$5166d349cc269302$var$ID_KEY] = dataID;
    record[$5166d349cc269302$var$TYPENAME_KEY] = typeName;
    return record;
}
function $5166d349cc269302$var$fromObject(json) {
    return json;
}
function $5166d349cc269302$var$getDataID(record) {
    return record[$5166d349cc269302$var$ID_KEY];
}
function $5166d349cc269302$var$getFields(record) {
    if ($5166d349cc269302$var$ERRORS_KEY in record) return Object.keys(record).filter(function(field) {
        return field !== $5166d349cc269302$var$ERRORS_KEY;
    });
    return Object.keys(record);
}
function $5166d349cc269302$var$getType(record) {
    return record[$5166d349cc269302$var$TYPENAME_KEY];
}
function $5166d349cc269302$var$getErrors(record, storageKey) {
    var _record$ERRORS_KEY;
    return (_record$ERRORS_KEY = record[$5166d349cc269302$var$ERRORS_KEY]) === null || _record$ERRORS_KEY === void 0 ? void 0 : _record$ERRORS_KEY[storageKey];
}
function $5166d349cc269302$var$getValue(record, storageKey) {
    var value = record[storageKey];
    if (value && typeof value === 'object') !(!value.hasOwnProperty($5166d349cc269302$var$REF_KEY) && !value.hasOwnProperty($5166d349cc269302$var$REFS_KEY)) && $jwy7p(false);
    return value;
}
function $5166d349cc269302$var$hasValue(record, storageKey) {
    return storageKey in record;
}
function $5166d349cc269302$var$getLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return maybeLink;
    var link = maybeLink;
    !(typeof link === 'object' && link && typeof link[$5166d349cc269302$var$REF_KEY] === 'string') && $jwy7p(false);
    return link[$5166d349cc269302$var$REF_KEY];
}
function $5166d349cc269302$var$hasLinkedRecordID(record, storageKey) {
    var maybeLink = record[storageKey];
    if (maybeLink == null) return false;
    var link = maybeLink;
    return typeof link === 'object' && link && typeof link[$5166d349cc269302$var$REF_KEY] === 'string';
}
function $5166d349cc269302$var$getLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return links;
    !(typeof links === 'object' && Array.isArray(links[$5166d349cc269302$var$REFS_KEY])) && $jwy7p(false);
    return links[$5166d349cc269302$var$REFS_KEY];
}
function $5166d349cc269302$var$hasLinkedRecordIDs(record, storageKey) {
    var links = record[storageKey];
    if (links == null) return false;
    return typeof links === 'object' && Array.isArray(links[$5166d349cc269302$var$REFS_KEY]) && links[$5166d349cc269302$var$REFS_KEY].every(function(link) {
        return typeof link === 'string';
    });
}
function $5166d349cc269302$var$getInvalidationEpoch(record) {
    if (record == null) return null;
    var invalidatedAt = record[$5166d349cc269302$var$INVALIDATED_AT_KEY];
    if (typeof invalidatedAt !== 'number') return null;
    return invalidatedAt;
}
function $5166d349cc269302$var$update(prevRecord, nextRecord) {
    var _updated2;
    var _getType, _getType2, prevID, nextID, prevType, nextType;
    var prevErrorsByKey = prevRecord[$5166d349cc269302$var$ERRORS_KEY];
    var nextErrorsByKey = nextRecord[$5166d349cc269302$var$ERRORS_KEY];
    var updated = null;
    if (prevErrorsByKey == null && nextErrorsByKey == null) {
        var _updated;
        for(var storageKey in nextRecord)if (updated || !$3UWLk(prevRecord[storageKey], nextRecord[storageKey])) {
            updated = updated !== null ? updated : (0, $5166d349cc269302$var$_objectSpread2["default"])({}, prevRecord);
            updated[storageKey] = nextRecord[storageKey];
        }
        return (_updated = updated) !== null && _updated !== void 0 ? _updated : prevRecord;
    }
    for(var _storageKey2 in nextRecord){
        if (_storageKey2 === $5166d349cc269302$var$ERRORS_KEY) continue;
        var nextValue = nextRecord[_storageKey2];
        var nextErrors = nextErrorsByKey === null || nextErrorsByKey === void 0 ? void 0 : nextErrorsByKey[_storageKey2];
        if (updated == null) {
            var prevValue = prevRecord[_storageKey2];
            var prevErrors = prevErrorsByKey === null || prevErrorsByKey === void 0 ? void 0 : prevErrorsByKey[_storageKey2];
            if ($3UWLk(prevValue, nextValue) && $3UWLk(prevErrors, nextErrors)) continue;
            updated = (0, $5166d349cc269302$var$_objectSpread2["default"])({}, prevRecord);
            if (prevErrorsByKey != null) updated[$5166d349cc269302$var$ERRORS_KEY] = (0, $5166d349cc269302$var$_objectSpread2["default"])({}, prevErrorsByKey);
        }
        $5166d349cc269302$var$setValue(updated, _storageKey2, nextValue);
        $5166d349cc269302$var$setErrors(updated, _storageKey2, nextErrors);
    }
    return (_updated2 = updated) !== null && _updated2 !== void 0 ? _updated2 : prevRecord;
}
function $5166d349cc269302$var$merge(record1, record2) {
    var _getType3, _getType4, prevID, nextID, prevType, nextType;
    if ($5166d349cc269302$var$ERRORS_KEY in record1 || $5166d349cc269302$var$ERRORS_KEY in record2) {
        var errors1 = record1[$5166d349cc269302$var$ERRORS_KEY], fields1 = (0, $5166d349cc269302$var$_objectWithoutPropertiesLoose2["default"])(record1, [
            $5166d349cc269302$var$ERRORS_KEY
        ].map($5166d349cc269302$var$_toPropertyKey2["default"]));
        var errors2 = record2[$5166d349cc269302$var$ERRORS_KEY], fields2 = (0, $5166d349cc269302$var$_objectWithoutPropertiesLoose2["default"])(record2, [
            $5166d349cc269302$var$ERRORS_KEY
        ].map($5166d349cc269302$var$_toPropertyKey2["default"]));
        var updated = (0, $5166d349cc269302$var$_objectSpread2["default"])((0, $5166d349cc269302$var$_objectSpread2["default"])({}, fields1), fields2);
        if (errors1 == null && errors2 == null) return updated;
        var updatedErrors = {};
        for(var storageKey in errors1){
            if (fields2.hasOwnProperty(storageKey)) continue;
            updatedErrors[storageKey] = errors1[storageKey];
        }
        for(var _storageKey3 in errors2)updatedErrors[_storageKey3] = errors2[_storageKey3];
        for(var _storageKey in updatedErrors){
            updated[$5166d349cc269302$var$ERRORS_KEY] = updatedErrors;
            break;
        }
        return updated;
    } else return (0, $5166d349cc269302$var$_objectSpread2["default"])((0, $5166d349cc269302$var$_objectSpread2["default"])({}, record1), record2);
}
function $5166d349cc269302$var$freeze(record) {
    $fHswY(record);
}
function $5166d349cc269302$var$setErrors(record, storageKey, errors) {
    var errorsByStorageKey = record[$5166d349cc269302$var$ERRORS_KEY];
    if (errors != null && errors.length > 0) {
        if (errorsByStorageKey == null) record[$5166d349cc269302$var$ERRORS_KEY] = (0, $5166d349cc269302$var$_defineProperty2["default"])({}, storageKey, errors);
        else errorsByStorageKey[storageKey] = errors;
    } else if (errorsByStorageKey != null) {
        if (delete errorsByStorageKey[storageKey]) {
            for(var otherStorageKey in errorsByStorageKey){
                if (errorsByStorageKey.hasOwnProperty(otherStorageKey)) return;
            }
            delete record[$5166d349cc269302$var$ERRORS_KEY];
        }
    }
}
function $5166d349cc269302$var$setValue(record, storageKey, value) {
    var prevID, _getType5, prevType, nextType;
    record[storageKey] = value;
}
function $5166d349cc269302$var$setLinkedRecordID(record, storageKey, linkedID) {
    var link = {};
    link[$5166d349cc269302$var$REF_KEY] = linkedID;
    record[storageKey] = link;
}
function $5166d349cc269302$var$setLinkedRecordIDs(record, storageKey, linkedIDs) {
    var links = {};
    links[$5166d349cc269302$var$REFS_KEY] = linkedIDs;
    record[storageKey] = links;
}
function $5166d349cc269302$var$setActorLinkedRecordID(record, storageKey, actorIdentifier, linkedID) {
    var link = {};
    link[$5166d349cc269302$var$REF_KEY] = linkedID;
    link[$5166d349cc269302$var$ACTOR_IDENTIFIER_KEY] = actorIdentifier;
    record[storageKey] = link;
}
function $5166d349cc269302$var$getActorLinkedRecordID(record, storageKey) {
    var link = record[storageKey];
    if (link == null) return link;
    !(typeof link === 'object' && typeof link[$5166d349cc269302$var$REF_KEY] === 'string' && link[$5166d349cc269302$var$ACTOR_IDENTIFIER_KEY] != null) && $jwy7p(false);
    return [
        link[$5166d349cc269302$var$ACTOR_IDENTIFIER_KEY],
        link[$5166d349cc269302$var$REF_KEY]
    ];
}
function $5166d349cc269302$var$getResolverLinkedRecordID(record, typeName) {
    var id = $5166d349cc269302$var$getValue(record, $5166d349cc269302$var$RELAY_RESOLVER_VALUE_KEY);
    if (id == null || $5166d349cc269302$var$isSuspenseSentinel(id)) return null;
    if (typeof id === 'object') id = id.id;
    !(typeof id === 'string') && $jwy7p(false);
    return $5166d349cc269302$var$generateClientObjectClientID(typeName, id);
}
function $5166d349cc269302$var$getResolverLinkedRecordIDs(record, typeName) {
    var resolverValue = $5166d349cc269302$var$getValue(record, $5166d349cc269302$var$RELAY_RESOLVER_VALUE_KEY);
    if (resolverValue == null || $5166d349cc269302$var$isSuspenseSentinel(resolverValue)) return null;
    !Array.isArray(resolverValue) && $jwy7p(false);
    return resolverValue.map(function(id) {
        if (id == null) return null;
        if (typeof id === 'object') id = id.id;
        !(typeof id === 'string') && $jwy7p(false);
        return $5166d349cc269302$var$generateClientObjectClientID(typeName, id);
    });
}
function $5166d349cc269302$var$toJSON(record) {
    return record;
}
module.exports = {
    clone: $5166d349cc269302$var$clone,
    copyFields: $5166d349cc269302$var$copyFields,
    create: $5166d349cc269302$var$create,
    freeze: $5166d349cc269302$var$freeze,
    fromObject: $5166d349cc269302$var$fromObject,
    getDataID: $5166d349cc269302$var$getDataID,
    getErrors: $5166d349cc269302$var$getErrors,
    getFields: $5166d349cc269302$var$getFields,
    getInvalidationEpoch: $5166d349cc269302$var$getInvalidationEpoch,
    getLinkedRecordID: $5166d349cc269302$var$getLinkedRecordID,
    getLinkedRecordIDs: $5166d349cc269302$var$getLinkedRecordIDs,
    getType: $5166d349cc269302$var$getType,
    getValue: $5166d349cc269302$var$getValue,
    hasValue: $5166d349cc269302$var$hasValue,
    hasLinkedRecordID: $5166d349cc269302$var$hasLinkedRecordID,
    hasLinkedRecordIDs: $5166d349cc269302$var$hasLinkedRecordIDs,
    merge: $5166d349cc269302$var$merge,
    setErrors: $5166d349cc269302$var$setErrors,
    setValue: $5166d349cc269302$var$setValue,
    setLinkedRecordID: $5166d349cc269302$var$setLinkedRecordID,
    setLinkedRecordIDs: $5166d349cc269302$var$setLinkedRecordIDs,
    update: $5166d349cc269302$var$update,
    getActorLinkedRecordID: $5166d349cc269302$var$getActorLinkedRecordID,
    setActorLinkedRecordID: $5166d349cc269302$var$setActorLinkedRecordID,
    getResolverLinkedRecordID: $5166d349cc269302$var$getResolverLinkedRecordID,
    getResolverLinkedRecordIDs: $5166d349cc269302$var$getResolverLinkedRecordIDs,
    toJSON: $5166d349cc269302$var$toJSON
};

});

parcelRegister("gqyVK", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $bf5a2b8720e9f90a$var$_interopRequireDefault = $8gviu.default;

var $bf5a2b8720e9f90a$var$_createForOfIteratorHelper2 = $bf5a2b8720e9f90a$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $6ZixS = parcelRequire("6ZixS");

var $2O63w = parcelRequire("2O63w");
var $bf5a2b8720e9f90a$var$EXISTENT = $2O63w.EXISTENT, $bf5a2b8720e9f90a$var$NONEXISTENT = $2O63w.NONEXISTENT, $bf5a2b8720e9f90a$var$UNKNOWN = $2O63w.UNKNOWN;
var $bf5a2b8720e9f90a$var$RelayRecordSource = /*#__PURE__*/ function() {
    function RelayRecordSource(records) {
        var _this = this;
        this._records = new Map();
        if (records != null) Object.keys(records).forEach(function(key) {
            var object = records[key];
            var record = $6ZixS.fromObject(object);
            _this._records.set(key, record);
        });
    }
    RelayRecordSource.create = function create(records) {
        return new RelayRecordSource(records);
    };
    var _proto = RelayRecordSource.prototype;
    _proto.clear = function clear() {
        this._records = new Map();
    };
    _proto["delete"] = function _delete(dataID) {
        this._records.set(dataID, null);
    };
    _proto.get = function get(dataID) {
        return this._records.get(dataID);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Array.from(this._records.keys());
    };
    _proto.getStatus = function getStatus(dataID) {
        if (!this._records.has(dataID)) return $bf5a2b8720e9f90a$var$UNKNOWN;
        return this._records.get(dataID) == null ? $bf5a2b8720e9f90a$var$NONEXISTENT : $bf5a2b8720e9f90a$var$EXISTENT;
    };
    _proto.has = function has(dataID) {
        return this._records.has(dataID);
    };
    _proto.remove = function remove(dataID) {
        this._records["delete"](dataID);
    };
    _proto.set = function set(dataID, record) {
        this._records.set(dataID, record);
    };
    _proto.size = function size() {
        return this._records.size;
    };
    _proto.toJSON = function toJSON() {
        var obj = {};
        var _iterator = (0, $bf5a2b8720e9f90a$var$_createForOfIteratorHelper2["default"])(this._records), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var _step$value = _step.value, key = _step$value[0], record = _step$value[1];
                obj[key] = $6ZixS.toJSON(record);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return obj;
    };
    return RelayRecordSource;
}();
module.exports = $bf5a2b8720e9f90a$var$RelayRecordSource;

});
parcelRegister("2O63w", function(module, exports) {
'use strict';
var $20b4f2d87a3a0aa2$var$RelayRecordState = {
    EXISTENT: 'EXISTENT',
    NONEXISTENT: 'NONEXISTENT',
    UNKNOWN: 'UNKNOWN'
};
module.exports = $20b4f2d87a3a0aa2$var$RelayRecordState;

});


parcelRegister("7TuZT", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $5bf5b6e473c8c66d$var$_interopRequireDefault = $8gviu.default;

var $5bf5b6e473c8c66d$var$_createForOfIteratorHelper2 = $5bf5b6e473c8c66d$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $5bf5b6e473c8c66d$var$_toConsumableArray2 = $5bf5b6e473c8c66d$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $iJ4oC = parcelRequire("iJ4oC");
var $5bf5b6e473c8c66d$var$ACTOR_IDENTIFIER_FIELD_NAME = $iJ4oC.ACTOR_IDENTIFIER_FIELD_NAME, $5bf5b6e473c8c66d$var$getActorIdentifierFromPayload = $iJ4oC.getActorIdentifierFromPayload;

var $kgraI = parcelRequire("kgraI");

var $9eVAj = parcelRequire("9eVAj");
var $5bf5b6e473c8c66d$var$generateClientID = $9eVAj.generateClientID, $5bf5b6e473c8c66d$var$isClientID = $9eVAj.isClientID;

var $cbsiZ = parcelRequire("cbsiZ");
var $5bf5b6e473c8c66d$var$getLocalVariables = $cbsiZ.getLocalVariables;

var $abN2l = parcelRequire("abN2l");
var $5bf5b6e473c8c66d$var$buildErrorTrie = $abN2l.buildErrorTrie, $5bf5b6e473c8c66d$var$getErrorsByKey = $abN2l.getErrorsByKey, $5bf5b6e473c8c66d$var$getNestedErrorTrieByKey = $abN2l.getNestedErrorTrieByKey;

var $6ZixS = parcelRequire("6ZixS");

var $dPVEr = parcelRequire("dPVEr");
var $5bf5b6e473c8c66d$var$createNormalizationSelector = $dPVEr.createNormalizationSelector;

var $cvcC4 = parcelRequire("cvcC4");
var $5bf5b6e473c8c66d$var$ROOT_ID = $cvcC4.ROOT_ID, $5bf5b6e473c8c66d$var$TYPENAME_KEY = $cvcC4.TYPENAME_KEY, $5bf5b6e473c8c66d$var$getArgumentValues = $cvcC4.getArgumentValues, $5bf5b6e473c8c66d$var$getHandleStorageKey = $cvcC4.getHandleStorageKey, $5bf5b6e473c8c66d$var$getModuleComponentKey = $cvcC4.getModuleComponentKey, $5bf5b6e473c8c66d$var$getModuleOperationKey = $cvcC4.getModuleOperationKey, $5bf5b6e473c8c66d$var$getStorageKey = $cvcC4.getStorageKey;

var $awaCw = parcelRequire("awaCw");
var $5bf5b6e473c8c66d$var$TYPE_SCHEMA_TYPE = $awaCw.TYPE_SCHEMA_TYPE, $5bf5b6e473c8c66d$var$generateTypeID = $awaCw.generateTypeID;
parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $5bf5b6e473c8c66d$var$normalize(recordSource, selector, response, options, errors, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var normalizer = new $5bf5b6e473c8c66d$var$RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false);
    return normalizer.normalizeResponse(node, dataID, response, errors);
}
var $5bf5b6e473c8c66d$var$RelayResponseNormalizer = /*#__PURE__*/ function() {
    function RelayResponseNormalizer(recordSource, variables, options, useExecTimeResolvers) {
        this._actorIdentifier = options.actorIdentifier;
        this._getDataId = options.getDataID;
        this._handleFieldPayloads = [];
        this._treatMissingFieldsAsNull = options.treatMissingFieldsAsNull;
        this._incrementalPlaceholders = [];
        this._isClientExtension = false;
        this._isUnmatchedAbstractType = false;
        this._useExecTimeResolvers = useExecTimeResolvers;
        this._followupPayloads = [];
        this._path = options.path ? (0, $5bf5b6e473c8c66d$var$_toConsumableArray2["default"])(options.path) : [];
        this._recordSource = recordSource;
        this._variables = variables;
        this._shouldProcessClientComponents = options.shouldProcessClientComponents;
        this._log = options.log;
    }
    var _proto = RelayResponseNormalizer.prototype;
    _proto.normalizeResponse = function normalizeResponse(node, dataID, data, errors) {
        var record = this._recordSource.get(dataID);
        !record && $jwy7p(false);
        this._assignClientAbstractTypes(node);
        this._errorTrie = $5bf5b6e473c8c66d$var$buildErrorTrie(errors);
        this._traverseSelections(node, record, data);
        return {
            errors: errors,
            fieldPayloads: this._handleFieldPayloads,
            incrementalPlaceholders: this._incrementalPlaceholders,
            followupPayloads: this._followupPayloads,
            source: this._recordSource,
            isFinal: false
        };
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator = (0, $5bf5b6e473c8c66d$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var concreteType = _step.value;
                    var typeID = $5bf5b6e473c8c66d$var$generateTypeID(concreteType);
                    var typeRecord = this._recordSource.get(typeID);
                    if (typeRecord == null) {
                        typeRecord = $6ZixS.create(typeID, $5bf5b6e473c8c66d$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(typeID, typeRecord);
                    }
                    $6ZixS.setValue(typeRecord, abstractType, true);
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jwy7p(false);
        return this._variables[name];
    };
    _proto._getRecordType = function _getRecordType(data) {
        var typeName = data[$5bf5b6e473c8c66d$var$TYPENAME_KEY];
        !(typeName != null) && $jwy7p(false);
        return typeName;
    };
    _proto._traverseSelections = function _traverseSelections(node, record, data) {
        for(var i = 0; i < node.selections.length; i++){
            var selection = node.selections[i];
            switch(selection.kind){
                case 'ScalarField':
                case 'LinkedField':
                    this._normalizeField(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) this._traverseSelections(selection, record, data);
                    break;
                case 'FragmentSpread':
                    var prevVariables = this._variables;
                    this._variables = $5bf5b6e473c8c66d$var$getLocalVariables(this._variables, selection.fragment.argumentDefinitions, selection.args);
                    this._traverseSelections(selection.fragment, record, data);
                    this._variables = prevVariables;
                    break;
                case 'InlineFragment':
                    var abstractKey = selection.abstractKey;
                    if (abstractKey == null) {
                        var typeName = $6ZixS.getType(record);
                        if (typeName === selection.type) this._traverseSelections(selection, record, data);
                    } else {
                        var implementsInterface = Object.prototype.hasOwnProperty.call(data, abstractKey);
                        var _typeName = $6ZixS.getType(record);
                        var typeID = $5bf5b6e473c8c66d$var$generateTypeID(_typeName);
                        var typeRecord = this._recordSource.get(typeID);
                        if (typeRecord == null) {
                            typeRecord = $6ZixS.create(typeID, $5bf5b6e473c8c66d$var$TYPE_SCHEMA_TYPE);
                            this._recordSource.set(typeID, typeRecord);
                        }
                        $6ZixS.setValue(typeRecord, abstractKey, implementsInterface);
                        if (implementsInterface) this._traverseSelections(selection, record, data);
                    }
                    break;
                case 'TypeDiscriminator':
                    var _abstractKey = selection.abstractKey;
                    var _implementsInterface = Object.prototype.hasOwnProperty.call(data, _abstractKey);
                    var _typeName2 = $6ZixS.getType(record);
                    var _typeID = $5bf5b6e473c8c66d$var$generateTypeID(_typeName2);
                    var _typeRecord = this._recordSource.get(_typeID);
                    if (_typeRecord == null) {
                        _typeRecord = $6ZixS.create(_typeID, $5bf5b6e473c8c66d$var$TYPE_SCHEMA_TYPE);
                        this._recordSource.set(_typeID, _typeRecord);
                    }
                    $6ZixS.setValue(_typeRecord, _abstractKey, _implementsInterface);
                    break;
                case 'LinkedHandle':
                case 'ScalarHandle':
                    var args = selection.args ? $5bf5b6e473c8c66d$var$getArgumentValues(selection.args, this._variables) : {};
                    var fieldKey = $5bf5b6e473c8c66d$var$getStorageKey(selection, this._variables);
                    var handleKey = $5bf5b6e473c8c66d$var$getHandleStorageKey(selection, this._variables);
                    this._handleFieldPayloads.push({
                        args: args,
                        dataID: $6ZixS.getDataID(record),
                        fieldKey: fieldKey,
                        handle: selection.handle,
                        handleKey: handleKey,
                        handleArgs: selection.handleArgs ? $5bf5b6e473c8c66d$var$getArgumentValues(selection.handleArgs, this._variables) : {}
                    });
                    break;
                case 'ModuleImport':
                    this._normalizeModuleImport(selection, record, data);
                    break;
                case 'Defer':
                    this._normalizeDefer(selection, record, data);
                    break;
                case 'Stream':
                    this._normalizeStream(selection, record, data);
                    break;
                case 'ClientExtension':
                    var isClientExtension = this._isClientExtension;
                    this._isClientExtension = true;
                    this._traverseSelections(selection, record, data);
                    this._isClientExtension = isClientExtension;
                    break;
                case 'ClientComponent':
                    if (this._shouldProcessClientComponents === false) break;
                    this._traverseSelections(selection.fragment, record, data);
                    break;
                case 'ActorChange':
                    this._normalizeActorChange(selection, record, data);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!this._useExecTimeResolvers) this._normalizeResolver(selection.backingField, record, data);
                    break;
                default:
                    selection;
                    $jwy7p(false);
            }
        }
    };
    _proto._normalizeResolver = function _normalizeResolver(resolver, record, data) {
        if (resolver.fragment != null) this._traverseSelections(resolver.fragment, record, data);
    };
    _proto._normalizeDefer = function _normalizeDefer(defer, record, data) {
        var isDeferred = defer["if"] === null || this._getVariableValue(defer["if"]);
        if (isDeferred === false) this._traverseSelections(defer, record, data);
        else this._incrementalPlaceholders.push({
            kind: 'defer',
            data: data,
            label: defer.label,
            path: (0, $5bf5b6e473c8c66d$var$_toConsumableArray2["default"])(this._path),
            selector: $5bf5b6e473c8c66d$var$createNormalizationSelector(defer, $6ZixS.getDataID(record), this._variables),
            typeName: $6ZixS.getType(record),
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeStream = function _normalizeStream(stream, record, data) {
        this._traverseSelections(stream, record, data);
        var isStreamed = stream["if"] === null || this._getVariableValue(stream["if"]);
        if (isStreamed === true) this._incrementalPlaceholders.push({
            kind: 'stream',
            label: stream.label,
            path: (0, $5bf5b6e473c8c66d$var$_toConsumableArray2["default"])(this._path),
            parentID: $6ZixS.getDataID(record),
            node: stream,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeModuleImport = function _normalizeModuleImport(moduleImport, record, data) {
        !(typeof data === 'object' && data) && $jwy7p(false);
        var typeName = $6ZixS.getType(record);
        var componentKey = $5bf5b6e473c8c66d$var$getModuleComponentKey(moduleImport.documentName);
        var componentReference = moduleImport.componentModuleProvider || data[componentKey];
        $6ZixS.setValue(record, componentKey, componentReference !== null && componentReference !== void 0 ? componentReference : null);
        var operationKey = $5bf5b6e473c8c66d$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = moduleImport.operationModuleProvider || data[operationKey];
        $6ZixS.setValue(record, operationKey, operationReference !== null && operationReference !== void 0 ? operationReference : null);
        if (operationReference != null) this._followupPayloads.push({
            kind: 'ModuleImportPayload',
            args: moduleImport.args,
            data: data,
            dataID: $6ZixS.getDataID(record),
            operationReference: operationReference,
            path: (0, $5bf5b6e473c8c66d$var$_toConsumableArray2["default"])(this._path),
            typeName: typeName,
            variables: this._variables,
            actorIdentifier: this._actorIdentifier
        });
    };
    _proto._normalizeField = function _normalizeField(selection, record, data) {
        !(typeof data === 'object' && data) && $jwy7p(false);
        var responseKey = selection.alias || selection.name;
        var storageKey = $5bf5b6e473c8c66d$var$getStorageKey(selection, this._variables);
        var fieldValue = data[responseKey];
        var isNoncompliantlyNullish = $kgraI.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(fieldValue) && fieldValue.length === 0;
        if (fieldValue == null || isNoncompliantlyNullish) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            if (selection.kind === 'ScalarField') this._validateConflictingFieldsWithIdenticalId(record, storageKey, null);
            if (isNoncompliantlyNullish) {
                if (selection.kind === 'LinkedField') $6ZixS.setLinkedRecordIDs(record, storageKey, []);
                else $6ZixS.setValue(record, storageKey, []);
            } else $6ZixS.setValue(record, storageKey, null);
            var errorTrie = this._errorTrie;
            if (errorTrie != null) {
                var errors = $5bf5b6e473c8c66d$var$getErrorsByKey(errorTrie, responseKey);
                if (errors != null) $6ZixS.setErrors(record, storageKey, errors);
            }
            return;
        }
        if (selection.kind === 'ScalarField') {
            this._validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue);
            $6ZixS.setValue(record, storageKey, fieldValue);
        } else if (selection.kind === 'LinkedField') {
            this._path.push(responseKey);
            var oldErrorTrie = this._errorTrie;
            this._errorTrie = oldErrorTrie == null ? null : $5bf5b6e473c8c66d$var$getNestedErrorTrieByKey(oldErrorTrie, responseKey);
            if (selection.plural) this._normalizePluralLink(selection, record, storageKey, fieldValue);
            else this._normalizeLink(selection, record, storageKey, fieldValue);
            this._errorTrie = oldErrorTrie;
            this._path.pop();
        } else {
            selection;
            $jwy7p(false);
        }
    };
    _proto._normalizeActorChange = function _normalizeActorChange(selection, record, data) {
        var _field$concreteType;
        var field = selection.linkedField;
        !(typeof data === 'object' && data) && $jwy7p(false);
        var responseKey = field.alias || field.name;
        var storageKey = $5bf5b6e473c8c66d$var$getStorageKey(field, this._variables);
        var fieldValue = data[responseKey];
        if (fieldValue == null) {
            if (fieldValue === undefined) {
                var isOptionalField = this._isClientExtension || this._isUnmatchedAbstractType;
                if (isOptionalField) return;
                else if (!this._treatMissingFieldsAsNull) return;
            }
            $6ZixS.setValue(record, storageKey, null);
            return;
        }
        var actorIdentifier = $5bf5b6e473c8c66d$var$getActorIdentifierFromPayload(fieldValue);
        if (actorIdentifier == null) {
            $6ZixS.setValue(record, storageKey, null);
            return;
        }
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : this._getRecordType(fieldValue);
        var nextID = this._getDataId(fieldValue, typeName) || $6ZixS.getLinkedRecordID(record, storageKey) || $5bf5b6e473c8c66d$var$generateClientID($6ZixS.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $jwy7p(false);
        $6ZixS.setActorLinkedRecordID(record, storageKey, actorIdentifier, nextID);
        this._followupPayloads.push({
            kind: 'ActorPayload',
            data: fieldValue,
            dataID: nextID,
            path: [].concat((0, $5bf5b6e473c8c66d$var$_toConsumableArray2["default"])(this._path), [
                responseKey
            ]),
            typeName: typeName,
            variables: this._variables,
            node: field,
            actorIdentifier: actorIdentifier
        });
    };
    _proto._normalizeLink = function _normalizeLink(field, record, storageKey, fieldValue) {
        var _field$concreteType2;
        !(typeof fieldValue === 'object' && fieldValue) && $jwy7p(false);
        var nextID = this._getDataId(fieldValue, (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : this._getRecordType(fieldValue)) || $6ZixS.getLinkedRecordID(record, storageKey) || $5bf5b6e473c8c66d$var$generateClientID($6ZixS.getDataID(record), storageKey);
        !(typeof nextID === 'string') && $jwy7p(false);
        this._validateConflictingLinkedFieldsWithIdenticalId($6ZixS.getLinkedRecordID(record, storageKey), nextID, storageKey);
        $6ZixS.setLinkedRecordID(record, storageKey, nextID);
        var nextRecord = this._recordSource.get(nextID);
        if (!nextRecord) {
            var typeName = field.concreteType || this._getRecordType(fieldValue);
            nextRecord = $6ZixS.create(nextID, typeName);
            this._recordSource.set(nextID, nextRecord);
        } else this._validateRecordType(nextRecord, field, fieldValue);
        this._traverseSelections(field, nextRecord, fieldValue);
    };
    _proto._normalizePluralLink = function _normalizePluralLink(field, record, storageKey, fieldValue) {
        var _this = this;
        !Array.isArray(fieldValue) && $jwy7p(false);
        var prevIDs = $6ZixS.getLinkedRecordIDs(record, storageKey);
        var nextIDs = [];
        fieldValue.forEach(function(item, nextIndex) {
            var _field$concreteType3;
            if (item == null) {
                nextIDs.push(item);
                return;
            }
            _this._path.push(String(nextIndex));
            var oldErrorTrie = _this._errorTrie;
            _this._errorTrie = oldErrorTrie == null ? null : $5bf5b6e473c8c66d$var$getNestedErrorTrieByKey(oldErrorTrie, nextIndex);
            !(typeof item === 'object') && $jwy7p(false);
            var nextID = _this._getDataId(item, (_field$concreteType3 = field.concreteType) !== null && _field$concreteType3 !== void 0 ? _field$concreteType3 : _this._getRecordType(item)) || prevIDs && prevIDs[nextIndex] || $5bf5b6e473c8c66d$var$generateClientID($6ZixS.getDataID(record), storageKey, nextIndex);
            !(typeof nextID === 'string') && $jwy7p(false);
            nextIDs.push(nextID);
            var nextRecord = _this._recordSource.get(nextID);
            if (!nextRecord) {
                var typeName = field.concreteType || _this._getRecordType(item);
                nextRecord = $6ZixS.create(nextID, typeName);
                _this._recordSource.set(nextID, nextRecord);
            } else _this._validateRecordType(nextRecord, field, item);
            if (prevIDs) _this._validateConflictingLinkedFieldsWithIdenticalId(prevIDs[nextIndex], nextID, storageKey);
            _this._traverseSelections(field, nextRecord, item);
            _this._errorTrie = oldErrorTrie;
            _this._path.pop();
        });
        $6ZixS.setLinkedRecordIDs(record, storageKey, nextIDs);
    };
    _proto._validateRecordType = function _validateRecordType(record, field, payload) {
        if ($kgraI.ENABLE_STORE_ID_COLLISION_LOGGING) {
            var _field$concreteType4;
            var typeName = (_field$concreteType4 = field.concreteType) !== null && _field$concreteType4 !== void 0 ? _field$concreteType4 : this._getRecordType(payload);
            var dataID = $6ZixS.getDataID(record);
            var expected = $5bf5b6e473c8c66d$var$isClientID(dataID) && dataID !== $5bf5b6e473c8c66d$var$ROOT_ID || $6ZixS.getType(record) === typeName;
            if (!expected) {
                var logEvent = {
                    name: 'idCollision.typename',
                    previous_typename: $6ZixS.getType(record),
                    new_typename: typeName
                };
                if (this._log != null) this._log(logEvent);
            }
        }
        var _field$concreteType5, _typeName3, _dataID, _expected;
    };
    _proto._validateConflictingFieldsWithIdenticalId = function _validateConflictingFieldsWithIdenticalId(record, storageKey, fieldValue) {
        var previousValue, dataID, expected;
    };
    _proto._validateConflictingLinkedFieldsWithIdenticalId = function _validateConflictingLinkedFieldsWithIdenticalId(prevID, nextID, storageKey) {
        var expected;
    };
    return RelayResponseNormalizer;
}();
module.exports = {
    normalize: $5bf5b6e473c8c66d$var$normalize
};

});
parcelRegister("iJ4oC", function(module, exports) {
'use strict';
var $da1fd6f3bd85ea96$var$ACTOR_IDENTIFIER_FIELD_NAME = 'actor_key';

var $j0uPU = parcelRequire("j0uPU");
var $da1fd6f3bd85ea96$var$getActorIdentifier = $j0uPU.getActorIdentifier;
function $da1fd6f3bd85ea96$var$getActorIdentifierFromPayload(payload) {
    if (payload != null && typeof payload === 'object' && typeof payload[$da1fd6f3bd85ea96$var$ACTOR_IDENTIFIER_FIELD_NAME] === 'string') return $da1fd6f3bd85ea96$var$getActorIdentifier(payload[$da1fd6f3bd85ea96$var$ACTOR_IDENTIFIER_FIELD_NAME]);
}
module.exports = {
    ACTOR_IDENTIFIER_FIELD_NAME: $da1fd6f3bd85ea96$var$ACTOR_IDENTIFIER_FIELD_NAME,
    getActorIdentifierFromPayload: $da1fd6f3bd85ea96$var$getActorIdentifierFromPayload
};

});
parcelRegister("j0uPU", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
var $dd65efd22511d3f3$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = 'INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE';
function $dd65efd22511d3f3$var$assertInternalActorIdentifier(actorIdentifier) {
    !(actorIdentifier === $dd65efd22511d3f3$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE) && $jwy7p(false);
}
module.exports = {
    assertInternalActorIdentifier: $dd65efd22511d3f3$var$assertInternalActorIdentifier,
    getActorIdentifier: function getActorIdentifier(actorID) {
        return actorID;
    },
    getDefaultActorIdentifier: function getDefaultActorIdentifier() {
        throw new Error('Not Implemented');
    },
    INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE: $dd65efd22511d3f3$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE
};

});


parcelRegister("abN2l", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $76b0f824bcaebcbd$var$_interopRequireDefault = $8gviu.default;

var $76b0f824bcaebcbd$var$_objectSpread2 = $76b0f824bcaebcbd$var$_interopRequireDefault((parcelRequire("lhogL")));

var $76b0f824bcaebcbd$var$_objectWithoutPropertiesLoose2 = $76b0f824bcaebcbd$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $76b0f824bcaebcbd$var$_createForOfIteratorHelper2 = $76b0f824bcaebcbd$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $76b0f824bcaebcbd$var$_toConsumableArray2 = $76b0f824bcaebcbd$var$_interopRequireDefault((parcelRequire("b0RMC")));
var $76b0f824bcaebcbd$var$_excluded = [
    "path",
    "locations"
];
var $76b0f824bcaebcbd$var$SELF = Symbol('$SELF');
function $76b0f824bcaebcbd$var$buildErrorTrie(errors) {
    if (errors == null) return null;
    var trie = new Map();
    var _iterator = (0, $76b0f824bcaebcbd$var$_createForOfIteratorHelper2["default"])(errors), _step;
    try {
        ERRORS: for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _step$value = _step.value, path = _step$value.path, _ = _step$value.locations, error = (0, $76b0f824bcaebcbd$var$_objectWithoutPropertiesLoose2["default"])(_step$value, $76b0f824bcaebcbd$var$_excluded);
            if (path == null) continue;
            var length = path.length;
            if (length === 0) continue;
            var lastIndex = length - 1;
            var currentTrie = trie;
            for(var index = 0; index < lastIndex; index++){
                var key = path[index];
                var existingValue = currentTrie.get(key);
                if (existingValue instanceof Map) {
                    currentTrie = existingValue;
                    continue;
                }
                var newValue = new Map();
                if (Array.isArray(existingValue)) newValue.set($76b0f824bcaebcbd$var$SELF, existingValue);
                currentTrie.set(key, newValue);
                currentTrie = newValue;
            }
            var lastKey = path[lastIndex];
            var container = currentTrie.get(lastKey);
            if (container instanceof Map) {
                currentTrie = container;
                container = currentTrie.get(lastKey);
                lastKey = $76b0f824bcaebcbd$var$SELF;
            }
            if (Array.isArray(container)) container.push(error);
            else currentTrie.set(lastKey, [
                error
            ]);
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return trie;
}
function $76b0f824bcaebcbd$var$getErrorsByKey(trie, key) {
    var value = trie.get(key);
    if (value == null) return null;
    if (Array.isArray(value)) return value;
    var errors = [];
    $76b0f824bcaebcbd$var$recursivelyCopyErrorsIntoArray(value, errors);
    return errors;
}
function $76b0f824bcaebcbd$var$recursivelyCopyErrorsIntoArray(trieOrSet, errors) {
    var _iterator2 = (0, $76b0f824bcaebcbd$var$_createForOfIteratorHelper2["default"])(trieOrSet), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var _step2$value = _step2.value, childKey = _step2$value[0], value = _step2$value[1];
            var oldLength = errors.length;
            if (Array.isArray(value)) errors.push.apply(errors, (0, $76b0f824bcaebcbd$var$_toConsumableArray2["default"])(value));
            else $76b0f824bcaebcbd$var$recursivelyCopyErrorsIntoArray(value, errors);
            if (childKey === $76b0f824bcaebcbd$var$SELF) continue;
            var newLength = errors.length;
            for(var index = oldLength; index < newLength; index++){
                var error = errors[index];
                if (error.path == null) errors[index] = (0, $76b0f824bcaebcbd$var$_objectSpread2["default"])((0, $76b0f824bcaebcbd$var$_objectSpread2["default"])({}, error), {}, {
                    path: [
                        childKey
                    ]
                });
                else error.path.unshift(childKey);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $76b0f824bcaebcbd$var$getNestedErrorTrieByKey(trie, key) {
    var value = trie.get(key);
    if (value instanceof Map) return value;
    return null;
}
module.exports = {
    SELF: $76b0f824bcaebcbd$var$SELF,
    buildErrorTrie: $76b0f824bcaebcbd$var$buildErrorTrie,
    getNestedErrorTrieByKey: $76b0f824bcaebcbd$var$getNestedErrorTrieByKey,
    getErrorsByKey: $76b0f824bcaebcbd$var$getErrorsByKey
};

});

parcelRegister("awaCw", function(module, exports) {
'use strict';
var $7a852182657e06a0$var$PREFIX = 'client:__type:';
var $7a852182657e06a0$var$TYPE_SCHEMA_TYPE = '__TypeSchema';
function $7a852182657e06a0$var$generateTypeID(typeName) {
    return $7a852182657e06a0$var$PREFIX + typeName;
}
function $7a852182657e06a0$var$isTypeID(id) {
    return id.indexOf($7a852182657e06a0$var$PREFIX) === 0;
}
module.exports = {
    generateTypeID: $7a852182657e06a0$var$generateTypeID,
    isTypeID: $7a852182657e06a0$var$isTypeID,
    TYPE_SCHEMA_TYPE: $7a852182657e06a0$var$TYPE_SCHEMA_TYPE
};

});



parcelRegister("8FBLb", function(module, exports) {
'use strict';

var $lQR7T = parcelRequire("lQR7T");
var $64ff7169c62a5718$var$getInlineDataFragment = $lQR7T.getInlineDataFragment;

var $cvcC4 = parcelRequire("cvcC4");
var $64ff7169c62a5718$var$FRAGMENTS_KEY = $cvcC4.FRAGMENTS_KEY;

var $jwy7p = parcelRequire("jwy7p");
function $64ff7169c62a5718$var$readInlineData(fragment, fragmentRef) {
    var _fragmentRef$FRAGMENT;
    var inlineDataFragment = $64ff7169c62a5718$var$getInlineDataFragment(fragment);
    if (fragmentRef == null) return fragmentRef;
    !(typeof fragmentRef === 'object') && $jwy7p(false);
    var inlineData = (_fragmentRef$FRAGMENT = fragmentRef[$64ff7169c62a5718$var$FRAGMENTS_KEY]) === null || _fragmentRef$FRAGMENT === void 0 ? void 0 : _fragmentRef$FRAGMENT[inlineDataFragment.name];
    !(inlineData != null) && $jwy7p(false);
    return inlineData;
}
module.exports = $64ff7169c62a5718$var$readInlineData;

});

parcelRegister("342kw", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $23b38d7f52b55775$var$_interopRequireDefault = $8gviu.default;

var $23b38d7f52b55775$var$_objectSpread2 = $23b38d7f52b55775$var$_interopRequireDefault((parcelRequire("lhogL")));

var $gRVEw = parcelRequire("gRVEw");

var $j0uPU = parcelRequire("j0uPU");
var $23b38d7f52b55775$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $j0uPU.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $23b38d7f52b55775$var$assertInternalActorIdentifier = $j0uPU.assertInternalActorIdentifier;

var $9wNSI = parcelRequire("9wNSI");

var $hQGnN = parcelRequire("hQGnN");

var $bdg1N = parcelRequire("bdg1N");

var $jsJJJ = parcelRequire("jsJJJ");

var $dZN1a = parcelRequire("dZN1a");

var $atQ8R = parcelRequire("atQ8R");

var $4Mqmi = parcelRequire("4Mqmi");

var $cz8yS = parcelRequire("cz8yS");

var $kg5Mx = parcelRequire("kg5Mx");

var $i9pUG = parcelRequire("i9pUG");

var $gqyVK = parcelRequire("gqyVK");
parcelRequire("jwy7p");
var $23b38d7f52b55775$var$RelayModernEnvironment = /*#__PURE__*/ function() {
    function RelayModernEnvironment(config) {
        var _this = this;
        var _config$store, _config$log, _config$relayFieldLog, _config$UNSTABLE_defa, _config$getDataID, _config$missingFieldH, _config$handlerProvid, _config$scheduler, _config$isServer, _config$normalizeResp, _config$operationTrac;
        this.configName = config.configName;
        this._treatMissingFieldsAsNull = config.treatMissingFieldsAsNull === true;
        var operationLoader = config.operationLoader;
        var store = (_config$store = config.store) !== null && _config$store !== void 0 ? _config$store : new $kg5Mx(new $gqyVK(), {
            log: config.log,
            operationLoader: config.operationLoader,
            getDataID: config.getDataID,
            shouldProcessClientComponents: config.shouldProcessClientComponents
        });
        this.__log = (_config$log = config.log) !== null && _config$log !== void 0 ? _config$log : $23b38d7f52b55775$var$emptyFunction;
        this.relayFieldLogger = (_config$relayFieldLog = config.relayFieldLogger) !== null && _config$relayFieldLog !== void 0 ? _config$relayFieldLog : $atQ8R;
        this._defaultRenderPolicy = (_config$UNSTABLE_defa = config.UNSTABLE_defaultRenderPolicy) !== null && _config$UNSTABLE_defa !== void 0 ? _config$UNSTABLE_defa : 'partial';
        this._operationLoader = operationLoader;
        this._operationExecutions = new Map();
        this._network = $hQGnN(this, config.network);
        this._getDataID = (_config$getDataID = config.getDataID) !== null && _config$getDataID !== void 0 ? _config$getDataID : $dZN1a;
        this._missingFieldHandlers = (_config$missingFieldH = config.missingFieldHandlers) !== null && _config$missingFieldH !== void 0 ? _config$missingFieldH : [];
        this._publishQueue = new $i9pUG(store, (_config$handlerProvid = config.handlerProvider) !== null && _config$handlerProvid !== void 0 ? _config$handlerProvid : $gRVEw, this._getDataID, this._missingFieldHandlers, this.__log);
        this._scheduler = (_config$scheduler = config.scheduler) !== null && _config$scheduler !== void 0 ? _config$scheduler : null;
        this._store = store;
        this.options = config.options;
        this._isServer = (_config$isServer = config.isServer) !== null && _config$isServer !== void 0 ? _config$isServer : false;
        this._normalizeResponse = (_config$normalizeResp = config.normalizeResponse) !== null && _config$normalizeResp !== void 0 ? _config$normalizeResp : $4Mqmi;
        this.__setNet = function(newNet) {
            return _this._network = $hQGnN(_this, newNet);
        };
        var _require2, inspect;
        this._operationTracker = (_config$operationTrac = config.operationTracker) !== null && _config$operationTrac !== void 0 ? _config$operationTrac : new $bdg1N();
        this._shouldProcessClientComponents = config.shouldProcessClientComponents;
        $jsJJJ(this);
    }
    var _proto = RelayModernEnvironment.prototype;
    _proto.getStore = function getStore() {
        return this._store;
    };
    _proto.getNetwork = function getNetwork() {
        return this._network;
    };
    _proto.getOperationTracker = function getOperationTracker() {
        return this._operationTracker;
    };
    _proto.getScheduler = function getScheduler() {
        return this._scheduler;
    };
    _proto.isRequestActive = function isRequestActive(requestIdentifier) {
        var activeState = this._operationExecutions.get(requestIdentifier);
        return activeState === 'active';
    };
    _proto.UNSTABLE_getDefaultRenderPolicy = function UNSTABLE_getDefaultRenderPolicy() {
        return this._defaultRenderPolicy;
    };
    _proto.applyUpdate = function applyUpdate(optimisticUpdate) {
        var _this2 = this;
        var dispose = function dispose() {
            _this2._scheduleUpdates(function() {
                _this2._publishQueue.revertUpdate(optimisticUpdate);
                _this2._publishQueue.run();
            });
        };
        this._scheduleUpdates(function() {
            _this2._publishQueue.applyUpdate(optimisticUpdate);
            _this2._publishQueue.run();
        });
        return {
            dispose: dispose
        };
    };
    _proto.revertUpdate = function revertUpdate(update) {
        var _this3 = this;
        this._scheduleUpdates(function() {
            _this3._publishQueue.revertUpdate(update);
            _this3._publishQueue.run();
        });
    };
    _proto.replaceUpdate = function replaceUpdate(update, newUpdate) {
        var _this4 = this;
        this._scheduleUpdates(function() {
            _this4._publishQueue.revertUpdate(update);
            _this4._publishQueue.applyUpdate(newUpdate);
            _this4._publishQueue.run();
        });
    };
    _proto.applyMutation = function applyMutation(optimisticConfig) {
        var subscription = this._execute({
            createSource: function createSource() {
                return $9wNSI.create(function(_sink) {});
            },
            isClientPayload: false,
            operation: optimisticConfig.operation,
            optimisticConfig: optimisticConfig,
            updater: null
        }).subscribe({});
        return {
            dispose: function dispose() {
                return subscription.unsubscribe();
            }
        };
    };
    _proto.check = function check(operation) {
        if (this._missingFieldHandlers.length === 0 && !$23b38d7f52b55775$var$operationHasClientAbstractTypes(operation)) return this._store.check(operation);
        return this._checkSelectorAndHandleMissingFields(operation, this._missingFieldHandlers);
    };
    _proto.commitPayload = function commitPayload(operation, payload) {
        this._execute({
            createSource: function createSource() {
                return $9wNSI.from({
                    data: payload
                });
            },
            isClientPayload: true,
            operation: operation,
            optimisticConfig: null,
            updater: null
        }).subscribe({});
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        var _this5 = this;
        this._scheduleUpdates(function() {
            _this5._publishQueue.commitUpdate(updater);
            _this5._publishQueue.run();
        });
    };
    _proto.lookup = function lookup(readSelector) {
        return this._store.lookup(readSelector);
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._store.subscribe(snapshot, callback);
    };
    _proto.retain = function retain(operation) {
        return this._store.retain(operation);
    };
    _proto.isServer = function isServer() {
        return this._isServer;
    };
    _proto._checkSelectorAndHandleMissingFields = function _checkSelectorAndHandleMissingFields(operation, handlers) {
        var _this6 = this;
        var target = $gqyVK.create();
        var source = this._store.getSource();
        var result = this._store.check(operation, {
            handlers: handlers,
            defaultActorIdentifier: $23b38d7f52b55775$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
            getSourceForActor: function getSourceForActor(actorIdentifier) {
                $23b38d7f52b55775$var$assertInternalActorIdentifier(actorIdentifier);
                return source;
            },
            getTargetForActor: function getTargetForActor(actorIdentifier) {
                $23b38d7f52b55775$var$assertInternalActorIdentifier(actorIdentifier);
                return target;
            }
        });
        if (target.size() > 0) this._scheduleUpdates(function() {
            _this6._publishQueue.commitSource(target);
            _this6._publishQueue.run();
        });
        return result;
    };
    _proto._scheduleUpdates = function _scheduleUpdates(task) {
        var scheduler = this._scheduler;
        if (scheduler != null) scheduler.schedule(task);
        else task();
    };
    _proto.execute = function execute(_ref) {
        var _this7 = this;
        var operation = _ref.operation;
        return this._execute({
            createSource: function createSource() {
                return _this7.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null, undefined, undefined, undefined, function() {
                    return _this7.check(operation);
                });
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.executeSubscription = function executeSubscription(_ref2) {
        var _this8 = this;
        var operation = _ref2.operation, updater = _ref2.updater;
        return this._execute({
            createSource: function createSource() {
                return _this8.getNetwork().execute(operation.request.node.params, operation.request.variables, operation.request.cacheConfig || {}, null);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: updater
        });
    };
    _proto.executeMutation = function executeMutation(_ref3) {
        var _this9 = this;
        var operation = _ref3.operation, optimisticResponse = _ref3.optimisticResponse, optimisticUpdater = _ref3.optimisticUpdater, updater = _ref3.updater, uploadables = _ref3.uploadables;
        var optimisticConfig;
        if (optimisticResponse || optimisticUpdater) optimisticConfig = {
            operation: operation,
            response: optimisticResponse,
            updater: optimisticUpdater
        };
        return this._execute({
            createSource: function createSource() {
                return _this9.getNetwork().execute(operation.request.node.params, operation.request.variables, (0, $23b38d7f52b55775$var$_objectSpread2["default"])((0, $23b38d7f52b55775$var$_objectSpread2["default"])({}, operation.request.cacheConfig), {}, {
                    force: true
                }), uploadables);
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: optimisticConfig,
            updater: updater
        });
    };
    _proto.executeWithSource = function executeWithSource(_ref4) {
        var operation = _ref4.operation, source = _ref4.source;
        return this._execute({
            createSource: function createSource() {
                return source;
            },
            isClientPayload: false,
            operation: operation,
            optimisticConfig: null,
            updater: null
        });
    };
    _proto.toJSON = function toJSON() {
        var _this$configName;
        return "RelayModernEnvironment(".concat((_this$configName = this.configName) !== null && _this$configName !== void 0 ? _this$configName : '', ")");
    };
    _proto._execute = function _execute(_ref5) {
        var _this10 = this;
        var createSource = _ref5.createSource, isClientPayload = _ref5.isClientPayload, operation = _ref5.operation, optimisticConfig = _ref5.optimisticConfig, updater = _ref5.updater;
        var publishQueue = this._publishQueue;
        var store = this._store;
        return $9wNSI.create(function(sink) {
            var executor = $cz8yS.execute({
                actorIdentifier: $23b38d7f52b55775$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE,
                getDataID: _this10._getDataID,
                isClientPayload: isClientPayload,
                log: _this10.__log,
                operation: operation,
                operationExecutions: _this10._operationExecutions,
                operationLoader: _this10._operationLoader,
                operationTracker: _this10._operationTracker,
                optimisticConfig: optimisticConfig,
                getPublishQueue: function getPublishQueue(actorIdentifier) {
                    $23b38d7f52b55775$var$assertInternalActorIdentifier(actorIdentifier);
                    return publishQueue;
                },
                scheduler: _this10._scheduler,
                shouldProcessClientComponents: _this10._shouldProcessClientComponents,
                sink: sink,
                source: createSource(),
                getStore: function getStore(actorIdentifier) {
                    $23b38d7f52b55775$var$assertInternalActorIdentifier(actorIdentifier);
                    return store;
                },
                treatMissingFieldsAsNull: _this10._treatMissingFieldsAsNull,
                updater: updater,
                normalizeResponse: _this10._normalizeResponse
            });
            return function() {
                return executor.cancel();
            };
        });
    };
    return RelayModernEnvironment;
}();
function $23b38d7f52b55775$var$operationHasClientAbstractTypes(operation) {
    return operation.root.node.kind === 'Operation' && operation.root.node.clientAbstractTypes != null;
}
$23b38d7f52b55775$var$RelayModernEnvironment.prototype['@@RelayModernEnvironment'] = true;
function $23b38d7f52b55775$var$emptyFunction() {}
module.exports = $23b38d7f52b55775$var$RelayModernEnvironment;

});
parcelRegister("hQGnN", function(module, exports) {
'use strict';

var $jyGwJ = parcelRequire("jyGwJ");
function $cfe82b51c00d3e98$var$wrapNetworkWithLogObserver(env, network) {
    return {
        execute: function execute(params, variables, cacheConfig, uploadables, _, encryptedVariables, preprocessResponse, checkOperation) {
            var networkRequestId = $jyGwJ();
            var logObserver = {
                start: function start(subscription) {
                    env.__log({
                        name: 'network.start',
                        networkRequestId: networkRequestId,
                        params: params,
                        variables: variables,
                        cacheConfig: cacheConfig
                    });
                },
                next: function next(response) {
                    env.__log({
                        name: 'network.next',
                        networkRequestId: networkRequestId,
                        response: response
                    });
                },
                error: function error(_error) {
                    env.__log({
                        name: 'network.error',
                        networkRequestId: networkRequestId,
                        error: _error
                    });
                },
                complete: function complete() {
                    env.__log({
                        name: 'network.complete',
                        networkRequestId: networkRequestId
                    });
                },
                unsubscribe: function unsubscribe() {
                    env.__log({
                        name: 'network.unsubscribe',
                        networkRequestId: networkRequestId
                    });
                }
            };
            var logRequestInfo = function logRequestInfo(info) {
                env.__log({
                    name: 'network.info',
                    networkRequestId: networkRequestId,
                    info: info
                });
            };
            return network.execute(params, variables, cacheConfig, uploadables, logRequestInfo, encryptedVariables, preprocessResponse, checkOperation)["do"](logObserver);
        }
    };
}
module.exports = $cfe82b51c00d3e98$var$wrapNetworkWithLogObserver;

});
parcelRegister("jyGwJ", function(module, exports) {
'use strict';
var $e3d22e47e6e2dc50$var$id = 100000;
function $e3d22e47e6e2dc50$var$generateID() {
    return $e3d22e47e6e2dc50$var$id++;
}
module.exports = $e3d22e47e6e2dc50$var$generateID;

});


parcelRegister("bdg1N", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $829d57694dc91bee$var$_interopRequireDefault = $8gviu.default;

var $829d57694dc91bee$var$_createForOfIteratorHelper2 = $829d57694dc91bee$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $jwy7p = parcelRequire("jwy7p");
var $829d57694dc91bee$var$RelayOperationTracker = /*#__PURE__*/ function() {
    function RelayOperationTracker() {
        this._ownersToPendingOperations = new Map();
        this._pendingOperationsToOwners = new Map();
        this._ownersToPendingPromise = new Map();
    }
    var _proto = RelayOperationTracker.prototype;
    _proto.update = function update(pendingOperation, affectedOwners) {
        if (affectedOwners.size === 0) return;
        var pendingOperationIdentifier = pendingOperation.identifier;
        var newlyAffectedOwnersIdentifier = new Set();
        var _iterator = (0, $829d57694dc91bee$var$_createForOfIteratorHelper2["default"])(affectedOwners), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var owner = _step.value;
                var ownerIdentifier = owner.identifier;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (pendingOperationsAffectingOwner != null) {
                    if (!pendingOperationsAffectingOwner.has(pendingOperationIdentifier)) {
                        pendingOperationsAffectingOwner.set(pendingOperationIdentifier, pendingOperation);
                        newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                    }
                } else {
                    this._ownersToPendingOperations.set(ownerIdentifier, new Map([
                        [
                            pendingOperationIdentifier,
                            pendingOperation
                        ]
                    ]));
                    newlyAffectedOwnersIdentifier.add(ownerIdentifier);
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        if (newlyAffectedOwnersIdentifier.size === 0) return;
        var ownersAffectedByPendingOperation = this._pendingOperationsToOwners.get(pendingOperationIdentifier) || new Set();
        var _iterator2 = (0, $829d57694dc91bee$var$_createForOfIteratorHelper2["default"])(newlyAffectedOwnersIdentifier), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var _ownerIdentifier = _step2.value;
                this._resolveOwnerResolvers(_ownerIdentifier);
                ownersAffectedByPendingOperation.add(_ownerIdentifier);
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._pendingOperationsToOwners.set(pendingOperationIdentifier, ownersAffectedByPendingOperation);
    };
    _proto.complete = function complete(pendingOperation) {
        var pendingOperationIdentifier = pendingOperation.identifier;
        var affectedOwnersIdentifier = this._pendingOperationsToOwners.get(pendingOperationIdentifier);
        if (affectedOwnersIdentifier == null) return;
        var completedOwnersIdentifier = new Set();
        var updatedOwnersIdentifier = new Set();
        var _iterator3 = (0, $829d57694dc91bee$var$_createForOfIteratorHelper2["default"])(affectedOwnersIdentifier), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var ownerIdentifier = _step3.value;
                var pendingOperationsAffectingOwner = this._ownersToPendingOperations.get(ownerIdentifier);
                if (!pendingOperationsAffectingOwner) continue;
                pendingOperationsAffectingOwner["delete"](pendingOperationIdentifier);
                if (pendingOperationsAffectingOwner.size > 0) updatedOwnersIdentifier.add(ownerIdentifier);
                else completedOwnersIdentifier.add(ownerIdentifier);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        var _iterator4 = (0, $829d57694dc91bee$var$_createForOfIteratorHelper2["default"])(completedOwnersIdentifier), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var _ownerIdentifier2 = _step4.value;
                this._resolveOwnerResolvers(_ownerIdentifier2);
                this._ownersToPendingOperations["delete"](_ownerIdentifier2);
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
        var _iterator5 = (0, $829d57694dc91bee$var$_createForOfIteratorHelper2["default"])(updatedOwnersIdentifier), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var _ownerIdentifier3 = _step5.value;
                this._resolveOwnerResolvers(_ownerIdentifier3);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._pendingOperationsToOwners["delete"](pendingOperationIdentifier);
    };
    _proto._resolveOwnerResolvers = function _resolveOwnerResolvers(ownerIdentifier) {
        var promiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (promiseEntry != null) promiseEntry.resolve();
        this._ownersToPendingPromise["delete"](ownerIdentifier);
    };
    _proto.getPendingOperationsAffectingOwner = function getPendingOperationsAffectingOwner(owner) {
        var ownerIdentifier = owner.identifier;
        var pendingOperationsForOwner = this._ownersToPendingOperations.get(ownerIdentifier);
        if (pendingOperationsForOwner == null || pendingOperationsForOwner.size === 0) return null;
        var cachedPromiseEntry = this._ownersToPendingPromise.get(ownerIdentifier);
        if (cachedPromiseEntry != null) return {
            promise: cachedPromiseEntry.promise,
            pendingOperations: cachedPromiseEntry.pendingOperations
        };
        var resolve;
        var promise = new Promise(function(r) {
            resolve = r;
        });
        !(resolve != null) && $jwy7p(false);
        var pendingOperations = Array.from(pendingOperationsForOwner.values());
        this._ownersToPendingPromise.set(ownerIdentifier, {
            promise: promise,
            resolve: resolve,
            pendingOperations: pendingOperations
        });
        return {
            promise: promise,
            pendingOperations: pendingOperations
        };
    };
    return RelayOperationTracker;
}();
module.exports = $829d57694dc91bee$var$RelayOperationTracker;

});

parcelRegister("jsJJJ", function(module, exports) {
'use strict';
function $e2b41c2ba88ca101$var$registerEnvironmentWithDevTools(environment) {
    var _global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
    var devToolsHook = _global && _global.__RELAY_DEVTOOLS_HOOK__;
    if (devToolsHook) devToolsHook.registerEnvironment(environment);
}
module.exports = $e2b41c2ba88ca101$var$registerEnvironmentWithDevTools;

});

parcelRegister("dZN1a", function(module, exports) {
'use strict';

var $iOxmF = parcelRequire("iOxmF");
var $a306fec80b90c181$var$VIEWER_ID = $iOxmF.VIEWER_ID, $a306fec80b90c181$var$VIEWER_TYPE = $iOxmF.VIEWER_TYPE;
function $a306fec80b90c181$var$defaultGetDataID(fieldValue, typeName) {
    if (typeName === $a306fec80b90c181$var$VIEWER_TYPE) return fieldValue.id == null ? $a306fec80b90c181$var$VIEWER_ID : fieldValue.id;
    return fieldValue.id;
}
module.exports = $a306fec80b90c181$var$defaultGetDataID;

});
parcelRegister("iOxmF", function(module, exports) {
'use strict';

var $9eVAj = parcelRequire("9eVAj");
var $db26c70bc67a4a30$var$generateClientID = $9eVAj.generateClientID;

var $cvcC4 = parcelRequire("cvcC4");
var $db26c70bc67a4a30$var$ROOT_ID = $cvcC4.ROOT_ID;
var $db26c70bc67a4a30$var$VIEWER_ID = $db26c70bc67a4a30$var$generateClientID($db26c70bc67a4a30$var$ROOT_ID, 'viewer');
var $db26c70bc67a4a30$var$VIEWER_TYPE = 'Viewer';
module.exports = {
    VIEWER_ID: $db26c70bc67a4a30$var$VIEWER_ID,
    VIEWER_TYPE: $db26c70bc67a4a30$var$VIEWER_TYPE
};

});


parcelRegister("atQ8R", function(module, exports) {
'use strict';
var $7a150f1a500e65f0$var$defaultRelayFieldLogger = function defaultRelayFieldLogger(event) {};
module.exports = $7a150f1a500e65f0$var$defaultRelayFieldLogger;

});

parcelRegister("cz8yS", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $925f6509f9b9d1d3$var$_interopRequireDefault = $8gviu.default;

var $925f6509f9b9d1d3$var$_createForOfIteratorHelper2 = $925f6509f9b9d1d3$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $925f6509f9b9d1d3$var$_toConsumableArray2 = $925f6509f9b9d1d3$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $9wNSI = parcelRequire("9wNSI");

var $jyGwJ = parcelRequire("jyGwJ");

var $jxlx4 = parcelRequire("jxlx4");

var $3doX1 = parcelRequire("3doX1");

var $kgraI = parcelRequire("kgraI");

var $zM4Yi = parcelRequire("zM4Yi");
var $925f6509f9b9d1d3$var$stableCopy = $zM4Yi.stableCopy;

var $6lSi2 = parcelRequire("6lSi2");

var $9eVAj = parcelRequire("9eVAj");
var $925f6509f9b9d1d3$var$generateClientID = $9eVAj.generateClientID, $925f6509f9b9d1d3$var$generateUniqueClientID = $9eVAj.generateUniqueClientID;

var $cbsiZ = parcelRequire("cbsiZ");
var $925f6509f9b9d1d3$var$getLocalVariables = $cbsiZ.getLocalVariables;

var $6ZixS = parcelRequire("6ZixS");

var $dPVEr = parcelRequire("dPVEr");
var $925f6509f9b9d1d3$var$createNormalizationSelector = $dPVEr.createNormalizationSelector, $925f6509f9b9d1d3$var$createReaderSelector = $dPVEr.createReaderSelector;

var $gqyVK = parcelRequire("gqyVK");

var $cvcC4 = parcelRequire("cvcC4");
var $925f6509f9b9d1d3$var$ROOT_TYPE = $cvcC4.ROOT_TYPE, $925f6509f9b9d1d3$var$TYPENAME_KEY = $cvcC4.TYPENAME_KEY, $925f6509f9b9d1d3$var$getStorageKey = $cvcC4.getStorageKey;

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $925f6509f9b9d1d3$var$execute(config) {
    return new $925f6509f9b9d1d3$var$Executor(config);
}
var $925f6509f9b9d1d3$var$Executor = /*#__PURE__*/ function() {
    function Executor(_ref3) {
        var _this = this;
        var _ref, _this$_operation$requ, _this$_operation$requ2;
        var actorIdentifier = _ref3.actorIdentifier, getDataID = _ref3.getDataID, getPublishQueue = _ref3.getPublishQueue, getStore = _ref3.getStore, isClientPayload = _ref3.isClientPayload, operation = _ref3.operation, operationExecutions = _ref3.operationExecutions, operationLoader = _ref3.operationLoader, operationTracker = _ref3.operationTracker, optimisticConfig = _ref3.optimisticConfig, scheduler = _ref3.scheduler, shouldProcessClientComponents = _ref3.shouldProcessClientComponents, sink = _ref3.sink, source = _ref3.source, treatMissingFieldsAsNull = _ref3.treatMissingFieldsAsNull, updater = _ref3.updater, log = _ref3.log, normalizeResponse = _ref3.normalizeResponse;
        this._actorIdentifier = actorIdentifier;
        this._getDataID = getDataID;
        this._treatMissingFieldsAsNull = treatMissingFieldsAsNull;
        this._incrementalPayloadsPending = false;
        this._incrementalResults = new Map();
        this._log = log;
        this._executeId = $jyGwJ();
        this._nextSubscriptionId = 0;
        this._operation = operation;
        this._operationExecutions = operationExecutions;
        this._operationLoader = operationLoader;
        this._operationTracker = operationTracker;
        this._operationUpdateEpochs = new Map();
        this._optimisticUpdates = null;
        this._useExecTimeResolvers = (_ref = (_this$_operation$requ = this._operation.request.node.operation.use_exec_time_resolvers) !== null && _this$_operation$requ !== void 0 ? _this$_operation$requ : ((_this$_operation$requ2 = this._operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_operation$requ2 === void 0 ? void 0 : _this$_operation$requ2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._execTimeResolverResponseComplete = false;
        this._pendingModulePayloadsCount = 0;
        this._getPublishQueue = getPublishQueue;
        this._scheduler = scheduler;
        this._sink = sink;
        this._source = new Map();
        this._state = 'started';
        this._getStore = getStore;
        this._subscriptions = new Map();
        this._updater = updater;
        this._isClientPayload = isClientPayload === true;
        this._isSubscriptionOperation = this._operation.request.node.params.operationKind === 'subscription';
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._retainDisposables = new Map();
        this._seenActors = new Set();
        this._completeFns = [];
        this._normalizeResponse = normalizeResponse;
        var id = this._nextSubscriptionId++;
        if ($kgraI.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
        source.subscribe({
            complete: function complete() {
                return _this._complete(id);
            },
            error: function error(_error2) {
                return _this._error(_error2);
            },
            next: function next(response) {
                try {
                    _this._next(id, response);
                } catch (error) {
                    sink.error(error);
                }
            },
            start: function start(subscription) {
                var _this$_operation$requ3;
                _this._start(id, subscription);
                _this._log({
                    name: 'execute.start',
                    executeId: _this._executeId,
                    params: _this._operation.request.node.params,
                    variables: _this._operation.request.variables,
                    cacheConfig: (_this$_operation$requ3 = _this._operation.request.cacheConfig) !== null && _this$_operation$requ3 !== void 0 ? _this$_operation$requ3 : {}
                });
            },
            unsubscribe: function unsubscribe() {
                _this._log({
                    name: 'execute.unsubscribe',
                    executeId: _this._executeId
                });
            }
        });
        if (!$kgraI.PROCESS_OPTIMISTIC_UPDATE_BEFORE_SUBSCRIPTION && optimisticConfig != null) this._processOptimisticResponse(optimisticConfig.response != null ? {
            data: optimisticConfig.response
        } : null, optimisticConfig.updater, false);
    }
    var _proto = Executor.prototype;
    _proto.cancel = function cancel() {
        var _this2 = this;
        if (this._state === 'completed') return;
        this._state = 'completed';
        this._operationExecutions["delete"](this._operation.request.identifier);
        if (this._subscriptions.size !== 0) {
            this._subscriptions.forEach(function(sub) {
                return sub.unsubscribe();
            });
            this._subscriptions.clear();
        }
        var optimisticUpdates = this._optimisticUpdates;
        if (optimisticUpdates !== null) {
            this._optimisticUpdates = null;
            optimisticUpdates.forEach(function(update) {
                return _this2._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._runPublishQueue();
        }
        this._incrementalResults.clear();
        if (this._asyncStoreUpdateDisposable != null) {
            this._asyncStoreUpdateDisposable.dispose();
            this._asyncStoreUpdateDisposable = null;
        }
        this._completeFns = [];
        this._completeOperationTracker();
        this._disposeRetainedData();
    };
    _proto._updateActiveState = function _updateActiveState() {
        var activeState;
        switch(this._state){
            case 'started':
                activeState = 'active';
                break;
            case 'loading_incremental':
                activeState = 'active';
                break;
            case 'completed':
                activeState = 'inactive';
                break;
            case 'loading_final':
                activeState = this._pendingModulePayloadsCount > 0 || this._useExecTimeResolvers && !this._execTimeResolverResponseComplete ? 'active' : 'inactive';
                break;
            default:
                this._state;
                $jwy7p(false);
        }
        this._operationExecutions.set(this._operation.request.identifier, activeState);
    };
    _proto._schedule = function _schedule(task, priority) {
        var _this3 = this;
        var scheduler = this._scheduler;
        if (scheduler != null) {
            var id = this._nextSubscriptionId++;
            $9wNSI.create(function(sink) {
                var cancellationToken = scheduler.schedule(function() {
                    try {
                        task();
                        sink.complete();
                    } catch (error) {
                        sink.error(error);
                    }
                }, priority);
                return function() {
                    return scheduler.cancel(cancellationToken);
                };
            }).subscribe({
                complete: function complete() {
                    return _this3._complete(id);
                },
                error: function error(_error3) {
                    return _this3._error(_error3);
                },
                start: function start(subscription) {
                    return _this3._start(id, subscription);
                }
            });
        } else task();
    };
    _proto._complete = function _complete(id) {
        this._subscriptions["delete"](id);
        if (this._subscriptions.size === 0) {
            this.cancel();
            this._sink.complete();
            this._log({
                name: 'execute.complete',
                executeId: this._executeId
            });
        }
    };
    _proto._error = function _error(error) {
        this.cancel();
        this._sink.error(error);
        this._log({
            name: 'execute.error',
            executeId: this._executeId,
            error: error
        });
    };
    _proto._start = function _start(id, subscription) {
        this._subscriptions.set(id, subscription);
        this._updateActiveState();
    };
    _proto._next = function _next(_id, response) {
        var _this4 = this;
        var priority = this._state === 'loading_incremental' ? 'low' : 'default';
        this._schedule(function() {
            _this4._log({
                name: 'execute.next.start',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
            _this4._handleNext(response);
            _this4._maybeCompleteSubscriptionOperationTracking();
            _this4._log({
                name: 'execute.next.end',
                executeId: _this4._executeId,
                response: response,
                operation: _this4._operation
            });
        }, priority);
    };
    _proto._handleErrorResponse = function _handleErrorResponse(responses) {
        var _this5 = this;
        var results = [];
        responses.forEach(function(response) {
            if (response.data === null && response.extensions != null && !response.hasOwnProperty('errors')) return;
            else if (response.data == null) {
                var errors = response.hasOwnProperty('errors') && response.errors != null ? response.errors : null;
                var messages = errors ? errors.map(function(_ref4) {
                    var message = _ref4.message;
                    return message;
                }).join('\n') : '(No errors)';
                var error = $3doX1.create('RelayNetwork', 'No data returned for operation `' + _this5._operation.request.node.params.name + '`, got error(s):\n' + messages + '\n\nSee the error `source` property for more information.');
                error.source = {
                    errors: errors,
                    operation: _this5._operation.request.node,
                    variables: _this5._operation.request.variables
                };
                error.stack;
                throw error;
            } else {
                var responseWithData = response;
                results.push(responseWithData);
            }
        });
        return results;
    };
    _proto._handleOptimisticResponses = function _handleOptimisticResponses(responses) {
        var _response$extensions;
        if (responses.length > 1) {
            if (responses.some(function(responsePart) {
                var _responsePart$extensi;
                return ((_responsePart$extensi = responsePart.extensions) === null || _responsePart$extensi === void 0 ? void 0 : _responsePart$extensi.isOptimistic) === true;
            })) $jwy7p(false);
            return false;
        }
        var response = responses[0];
        var isOptimistic = ((_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : _response$extensions.isOptimistic) === true;
        if (isOptimistic && this._state !== 'started') $jwy7p(false);
        if (isOptimistic) {
            this._processOptimisticResponse(response, null, this._treatMissingFieldsAsNull);
            this._sink.next(response);
            return true;
        }
        return false;
    };
    _proto._handleNext = function _handleNext(response) {
        if (this._state === 'completed') return;
        this._seenActors.clear();
        var responses = Array.isArray(response) ? response : [
            response
        ];
        var responsesWithData = this._handleErrorResponse(responses);
        if (responsesWithData.length === 0) {
            var isFinal = responses.some(function(x) {
                var _x$extensions;
                return ((_x$extensions = x.extensions) === null || _x$extensions === void 0 ? void 0 : _x$extensions.is_final) === true;
            });
            if (isFinal) {
                this._state = 'loading_final';
                this._updateActiveState();
                this._incrementalPayloadsPending = false;
            }
            this._sink.next(response);
            return;
        }
        var isOptimistic = this._handleOptimisticResponses(responsesWithData);
        if (isOptimistic) return;
        var _partitionGraphQLResp = $925f6509f9b9d1d3$var$partitionGraphQLResponses(responsesWithData), nonIncrementalResponses = _partitionGraphQLResp[0], incrementalResponses = _partitionGraphQLResp[1], normalizedResponses = _partitionGraphQLResp[2];
        var hasNonIncrementalResponses = nonIncrementalResponses.length > 0;
        var hasNormalizedResponses = normalizedResponses.length > 0;
        if (hasNonIncrementalResponses) {
            if (this._isSubscriptionOperation) {
                var nextID = $925f6509f9b9d1d3$var$generateUniqueClientID();
                this._operation = {
                    request: this._operation.request,
                    fragment: $925f6509f9b9d1d3$var$createReaderSelector(this._operation.fragment.node, nextID, this._operation.fragment.variables, this._operation.fragment.owner),
                    root: $925f6509f9b9d1d3$var$createNormalizationSelector(this._operation.root.node, nextID, this._operation.root.variables)
                };
            }
            var payloadFollowups = this._processResponses(nonIncrementalResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
        if (hasNormalizedResponses) {
            var _payloadFollowups = [];
            for(var i = 0; i < normalizedResponses.length; i++){
                var _response$extensions2;
                var _response = normalizedResponses[i];
                var source = new $gqyVK(_response.data);
                var isFinal = ((_response$extensions2 = _response.extensions) === null || _response$extensions2 === void 0 ? void 0 : _response$extensions2.is_final) === true;
                var payload = {
                    errors: [],
                    fieldPayloads: [],
                    followupPayloads: [],
                    incrementalPlaceholders: [],
                    isFinal: isFinal,
                    source: source
                };
                this._getPublishQueueAndSaveActor().commitPayload(this._operation, payload, this._updater);
                _payloadFollowups.push(payload);
                this._execTimeResolverResponseComplete = isFinal;
                if (isFinal) this._updateActiveState();
            }
        }
        if (incrementalResponses.length > 0) {
            var _payloadFollowups2 = this._processIncrementalResponses(incrementalResponses);
            this._processPayloadFollowups(_payloadFollowups2);
        }
        if (this._isSubscriptionOperation) {
            if (responsesWithData[0].extensions == null) responsesWithData[0].extensions = {
                __relay_subscription_root_id: this._operation.fragment.dataID
            };
            else responsesWithData[0].extensions.__relay_subscription_root_id = this._operation.fragment.dataID;
        }
        var updatedOwners = this._runPublishQueue(hasNonIncrementalResponses || hasNormalizedResponses ? this._operation : undefined);
        if (hasNonIncrementalResponses) {
            if (this._incrementalPayloadsPending) this._retainData();
        }
        this._updateOperationTracker(updatedOwners);
        this._sink.next(response);
    };
    _proto._processOptimisticResponse = function _processOptimisticResponse(response, updater, treatMissingFieldsAsNull) {
        var _this6 = this;
        !(this._optimisticUpdates === null) && $jwy7p(false);
        if (response == null && updater == null) return;
        var optimisticUpdates = [];
        if (response) {
            var payload = this._normalizeResponse(response, this._operation.root, $925f6509f9b9d1d3$var$ROOT_TYPE, {
                actorIdentifier: this._actorIdentifier,
                getDataID: this._getDataID,
                log: this._log,
                path: [],
                shouldProcessClientComponents: this._shouldProcessClientComponents,
                treatMissingFieldsAsNull: treatMissingFieldsAsNull
            }, this._useExecTimeResolvers);
            $925f6509f9b9d1d3$var$validateOptimisticResponsePayload(payload);
            optimisticUpdates.push({
                operation: this._operation,
                payload: payload,
                updater: updater
            });
            this._processOptimisticFollowups(payload, optimisticUpdates);
        } else if (updater) optimisticUpdates.push({
            operation: this._operation,
            payload: {
                errors: null,
                fieldPayloads: null,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $gqyVK.create(),
                isFinal: false
            },
            updater: updater
        });
        this._optimisticUpdates = optimisticUpdates;
        optimisticUpdates.forEach(function(update) {
            return _this6._getPublishQueueAndSaveActor().applyUpdate(update);
        });
        var updatedOwners = this._runPublishQueue();
        if ($kgraI.ENABLE_OPERATION_TRACKER_OPTIMISTIC_UPDATES) this._updateOperationTracker(updatedOwners);
    };
    _proto._processOptimisticFollowups = function _processOptimisticFollowups(payload, optimisticUpdates) {
        if (payload.followupPayloads && payload.followupPayloads.length) {
            var followupPayloads = payload.followupPayloads;
            var _iterator = (0, $925f6509f9b9d1d3$var$_createForOfIteratorHelper2["default"])(followupPayloads), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var followupPayload = _step.value;
                    switch(followupPayload.kind){
                        case 'ModuleImportPayload':
                            var operationLoader = this._expectOperationLoader();
                            var operation = operationLoader.get(followupPayload.operationReference);
                            if (operation == null) this._processAsyncOptimisticModuleImport(followupPayload);
                            else {
                                var moduleImportOptimisticUpdates = this._processOptimisticModuleImport(operation, followupPayload);
                                optimisticUpdates.push.apply(optimisticUpdates, (0, $925f6509f9b9d1d3$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                            }
                            break;
                        case 'ActorPayload':
                            break;
                        default:
                            followupPayload;
                            $jwy7p(false);
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    };
    _proto._normalizeFollowupPayload = function _normalizeFollowupPayload(followupPayload, normalizationNode) {
        var variables;
        if (normalizationNode.kind === 'SplitOperation' && followupPayload.kind === 'ModuleImportPayload') variables = $925f6509f9b9d1d3$var$getLocalVariables(followupPayload.variables, normalizationNode.argumentDefinitions, followupPayload.args);
        else variables = followupPayload.variables;
        var selector = $925f6509f9b9d1d3$var$createNormalizationSelector(normalizationNode, followupPayload.dataID, variables);
        var nextResponse = {
            data: followupPayload.data,
            extensions: this._state === 'loading_final' ? {
                is_final: true
            } : undefined
        };
        return this._normalizeResponse(nextResponse, selector, followupPayload.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: followupPayload.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
    };
    _proto._processOptimisticModuleImport = function _processOptimisticModuleImport(normalizationRootNode, moduleImportPayload) {
        var operation = $jxlx4(normalizationRootNode);
        var optimisticUpdates = [];
        var modulePayload = this._normalizeFollowupPayload(moduleImportPayload, operation);
        $925f6509f9b9d1d3$var$validateOptimisticResponsePayload(modulePayload);
        optimisticUpdates.push({
            operation: this._operation,
            payload: modulePayload,
            updater: null
        });
        this._processOptimisticFollowups(modulePayload, optimisticUpdates);
        return optimisticUpdates;
    };
    _proto._processAsyncOptimisticModuleImport = function _processAsyncOptimisticModuleImport(moduleImportPayload) {
        var _this7 = this;
        this._expectOperationLoader().load(moduleImportPayload.operationReference).then(function(operation) {
            if (operation == null || _this7._state !== 'started') return;
            var moduleImportOptimisticUpdates = _this7._processOptimisticModuleImport(operation, moduleImportPayload);
            moduleImportOptimisticUpdates.forEach(function(update) {
                return _this7._getPublishQueueAndSaveActor().applyUpdate(update);
            });
            if (_this7._optimisticUpdates == null) ;
            else {
                var _this$_optimisticUpda;
                (_this$_optimisticUpda = _this7._optimisticUpdates).push.apply(_this$_optimisticUpda, (0, $925f6509f9b9d1d3$var$_toConsumableArray2["default"])(moduleImportOptimisticUpdates));
                _this7._runPublishQueue();
            }
        });
    };
    _proto._processResponses = function _processResponses(responses) {
        var _this8 = this;
        this._log({
            name: 'execute.normalize.start',
            operation: this._operation
        });
        if (this._optimisticUpdates !== null) {
            this._optimisticUpdates.forEach(function(update) {
                _this8._getPublishQueueAndSaveActor().revertUpdate(update);
            });
            this._optimisticUpdates = null;
        }
        this._incrementalPayloadsPending = false;
        this._incrementalResults.clear();
        this._source.clear();
        return responses.map(function(payloadPart) {
            var relayPayload = _this8._normalizeResponse(payloadPart, _this8._operation.root, $925f6509f9b9d1d3$var$ROOT_TYPE, {
                actorIdentifier: _this8._actorIdentifier,
                getDataID: _this8._getDataID,
                log: _this8._log,
                path: [],
                treatMissingFieldsAsNull: _this8._treatMissingFieldsAsNull,
                shouldProcessClientComponents: _this8._shouldProcessClientComponents
            }, _this8._useExecTimeResolvers);
            _this8._getPublishQueueAndSaveActor().commitPayload(_this8._operation, relayPayload, _this8._updater);
            _this8._log({
                name: 'execute.normalize.end',
                operation: _this8._operation
            });
            return relayPayload;
        });
    };
    _proto._processPayloadFollowups = function _processPayloadFollowups(payloads) {
        var _this9 = this;
        if (this._state === 'completed') return;
        payloads.forEach(function(payload) {
            var incrementalPlaceholders = payload.incrementalPlaceholders, followupPayloads = payload.followupPayloads, isFinal = payload.isFinal;
            _this9._state = isFinal ? 'loading_final' : 'loading_incremental';
            _this9._updateActiveState();
            if (isFinal) _this9._incrementalPayloadsPending = false;
            if (followupPayloads && followupPayloads.length !== 0) followupPayloads.forEach(function(followupPayload) {
                var _followupPayload$acto;
                var prevActorIdentifier = _this9._actorIdentifier;
                _this9._actorIdentifier = (_followupPayload$acto = followupPayload.actorIdentifier) !== null && _followupPayload$acto !== void 0 ? _followupPayload$acto : _this9._actorIdentifier;
                _this9._processFollowupPayload(followupPayload);
                _this9._actorIdentifier = prevActorIdentifier;
            });
            if (incrementalPlaceholders && incrementalPlaceholders.length !== 0) {
                _this9._incrementalPayloadsPending = _this9._state !== 'loading_final';
                incrementalPlaceholders.forEach(function(incrementalPlaceholder) {
                    var _incrementalPlacehold;
                    var prevActorIdentifier = _this9._actorIdentifier;
                    _this9._actorIdentifier = (_incrementalPlacehold = incrementalPlaceholder.actorIdentifier) !== null && _incrementalPlacehold !== void 0 ? _incrementalPlacehold : _this9._actorIdentifier;
                    _this9._processIncrementalPlaceholder(payload, incrementalPlaceholder);
                    _this9._actorIdentifier = prevActorIdentifier;
                });
                if (_this9._isClientPayload || _this9._state === 'loading_final') {
                    var relayPayloads = [];
                    incrementalPlaceholders.forEach(function(placeholder) {
                        if (placeholder.kind === 'defer') relayPayloads.push(_this9._processDeferResponse(placeholder.label, placeholder.path, placeholder, {
                            data: placeholder.data,
                            extensions: {
                                is_final: true
                            }
                        }));
                    });
                    if (relayPayloads.length > 0) _this9._processPayloadFollowups(relayPayloads);
                }
            }
        });
    };
    _proto._maybeCompleteSubscriptionOperationTracking = function _maybeCompleteSubscriptionOperationTracking() {
        if (!this._isSubscriptionOperation && !(this._useExecTimeResolvers && this._execTimeResolverResponseComplete && this._state === 'loading_final')) return;
        if (this._pendingModulePayloadsCount === 0 && this._incrementalPayloadsPending === false) this._completeOperationTracker();
    };
    _proto._processFollowupPayload = function _processFollowupPayload(followupPayload) {
        var _this10 = this;
        switch(followupPayload.kind){
            case 'ModuleImportPayload':
                var operationLoader = this._expectOperationLoader();
                var node = operationLoader.get(followupPayload.operationReference);
                if (node != null) this._processFollowupPayloadWithNormalizationNode(followupPayload, $jxlx4(node));
                else {
                    var id = this._nextSubscriptionId++;
                    this._pendingModulePayloadsCount++;
                    var decrementPendingCount = function decrementPendingCount() {
                        _this10._pendingModulePayloadsCount--;
                        _this10._maybeCompleteSubscriptionOperationTracking();
                    };
                    var networkObservable = $9wNSI.from(new Promise(function(resolve, reject) {
                        operationLoader.load(followupPayload.operationReference).then(resolve, reject);
                    }));
                    $9wNSI.create(function(sink) {
                        var cancellationToken;
                        var subscription = networkObservable.subscribe({
                            next: function next(loadedNode) {
                                if (loadedNode != null) {
                                    var publishModuleImportPayload = function publishModuleImportPayload() {
                                        try {
                                            var operation = $jxlx4(loadedNode);
                                            var batchAsyncModuleUpdatesFN = $kgraI.BATCH_ASYNC_MODULE_UPDATES_FN;
                                            var shouldScheduleAsyncStoreUpdate = batchAsyncModuleUpdatesFN != null && _this10._pendingModulePayloadsCount > 1;
                                            var _withStartAndDuration = $6lSi2(function() {
                                                _this10._handleFollowupPayload(followupPayload, operation);
                                                if (shouldScheduleAsyncStoreUpdate) _this10._scheduleAsyncStoreUpdate(batchAsyncModuleUpdatesFN, sink.complete);
                                                else {
                                                    var updatedOwners = _this10._runPublishQueue();
                                                    _this10._updateOperationTracker(updatedOwners);
                                                }
                                            }), _ = _withStartAndDuration[0], duration = _withStartAndDuration[1];
                                            _this10._log({
                                                name: 'execute.async.module',
                                                executeId: _this10._executeId,
                                                operationName: operation.name,
                                                duration: duration
                                            });
                                            if (!shouldScheduleAsyncStoreUpdate) sink.complete();
                                        } catch (error) {
                                            sink.error(error);
                                        }
                                    };
                                    var scheduler = _this10._scheduler;
                                    if (scheduler == null) publishModuleImportPayload();
                                    else cancellationToken = scheduler.schedule(publishModuleImportPayload);
                                } else sink.complete();
                            },
                            error: sink.error
                        });
                        return function() {
                            subscription.unsubscribe();
                            if (_this10._scheduler != null && cancellationToken != null) _this10._scheduler.cancel(cancellationToken);
                        };
                    }).subscribe({
                        complete: function complete() {
                            _this10._complete(id);
                            decrementPendingCount();
                        },
                        error: function error(_error4) {
                            _this10._error(_error4);
                            decrementPendingCount();
                        },
                        start: function start(subscription) {
                            return _this10._start(id, subscription);
                        }
                    });
                }
                break;
            case 'ActorPayload':
                this._processFollowupPayloadWithNormalizationNode(followupPayload, followupPayload.node);
                break;
            default:
                followupPayload;
                $jwy7p(false);
        }
    };
    _proto._processFollowupPayloadWithNormalizationNode = function _processFollowupPayloadWithNormalizationNode(followupPayload, normalizationNode) {
        this._handleFollowupPayload(followupPayload, normalizationNode);
        this._maybeCompleteSubscriptionOperationTracking();
    };
    _proto._handleFollowupPayload = function _handleFollowupPayload(followupPayload, normalizationNode) {
        var relayPayload = this._normalizeFollowupPayload(followupPayload, normalizationNode);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        this._processPayloadFollowups([
            relayPayload
        ]);
    };
    _proto._processIncrementalPlaceholder = function _processIncrementalPlaceholder(relayPayload, placeholder) {
        var _relayPayload$fieldPa;
        var label = placeholder.label, path = placeholder.path;
        var pathKey = path.map(String).join('.');
        var resultForLabel = this._incrementalResults.get(label);
        if (resultForLabel == null) {
            resultForLabel = new Map();
            this._incrementalResults.set(label, resultForLabel);
        }
        var resultForPath = resultForLabel.get(pathKey);
        var pendingResponses = resultForPath != null && resultForPath.kind === 'response' ? resultForPath.responses : null;
        resultForLabel.set(pathKey, {
            kind: 'placeholder',
            placeholder: placeholder
        });
        var parentID;
        if (placeholder.kind === 'stream') parentID = placeholder.parentID;
        else if (placeholder.kind === 'defer') parentID = placeholder.selector.dataID;
        else {
            placeholder;
            $jwy7p(false);
        }
        var parentRecord = relayPayload.source.get(parentID);
        var parentPayloads = ((_relayPayload$fieldPa = relayPayload.fieldPayloads) !== null && _relayPayload$fieldPa !== void 0 ? _relayPayload$fieldPa : []).filter(function(fieldPayload) {
            var fieldID = $925f6509f9b9d1d3$var$generateClientID(fieldPayload.dataID, fieldPayload.fieldKey);
            return fieldPayload.dataID === parentID || fieldID === parentID;
        });
        !(parentRecord != null) && $jwy7p(false);
        var nextParentRecord;
        var nextParentPayloads;
        var previousParentEntry = this._source.get(parentID);
        if (previousParentEntry != null) {
            nextParentRecord = $6ZixS.update(previousParentEntry.record, parentRecord);
            var handlePayloads = new Map();
            var dedupePayload = function dedupePayload(payload) {
                var key = $925f6509f9b9d1d3$var$stableStringify(payload);
                handlePayloads.set(key, payload);
            };
            previousParentEntry.fieldPayloads.forEach(dedupePayload);
            parentPayloads.forEach(dedupePayload);
            nextParentPayloads = Array.from(handlePayloads.values());
        } else {
            nextParentRecord = parentRecord;
            nextParentPayloads = parentPayloads;
        }
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: nextParentPayloads
        });
        if (pendingResponses != null) {
            var payloadFollowups = this._processIncrementalResponses(pendingResponses);
            this._processPayloadFollowups(payloadFollowups);
        }
    };
    _proto._processIncrementalResponses = function _processIncrementalResponses(incrementalResponses) {
        var _this11 = this;
        var relayPayloads = [];
        incrementalResponses.forEach(function(incrementalResponse) {
            var label = incrementalResponse.label, path = incrementalResponse.path, response = incrementalResponse.response;
            var resultForLabel = _this11._incrementalResults.get(label);
            if (resultForLabel == null) {
                resultForLabel = new Map();
                _this11._incrementalResults.set(label, resultForLabel);
            }
            if (label.indexOf('$defer$') !== -1) {
                var pathKey = path.map(String).join('.');
                var resultForPath = resultForLabel.get(pathKey);
                if (resultForPath == null) {
                    resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(pathKey, resultForPath);
                    return;
                } else if (resultForPath.kind === 'response') {
                    resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var placeholder = resultForPath.placeholder;
                !(placeholder.kind === 'defer') && $jwy7p(false);
                relayPayloads.push(_this11._processDeferResponse(label, path, placeholder, response));
            } else {
                var _pathKey = path.slice(0, -2).map(String).join('.');
                var _resultForPath = resultForLabel.get(_pathKey);
                if (_resultForPath == null) {
                    _resultForPath = {
                        kind: 'response',
                        responses: [
                            incrementalResponse
                        ]
                    };
                    resultForLabel.set(_pathKey, _resultForPath);
                    return;
                } else if (_resultForPath.kind === 'response') {
                    _resultForPath.responses.push(incrementalResponse);
                    return;
                }
                var _placeholder = _resultForPath.placeholder;
                !(_placeholder.kind === 'stream') && $jwy7p(false);
                relayPayloads.push(_this11._processStreamResponse(label, path, _placeholder, response));
            }
        });
        return relayPayloads;
    };
    _proto._processDeferResponse = function _processDeferResponse(label, path, placeholder, response) {
        var _placeholder$actorIde;
        var parentID = placeholder.selector.dataID;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = (_placeholder$actorIde = placeholder.actorIdentifier) !== null && _placeholder$actorIde !== void 0 ? _placeholder$actorIde : this._actorIdentifier;
        var relayPayload = this._normalizeResponse(response, placeholder.selector, placeholder.typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: placeholder.path,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $jwy7p(false);
        var fieldPayloads = parentEntry.fieldPayloads;
        if (fieldPayloads.length !== 0) {
            var _response$extensions3;
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $gqyVK.create(),
                isFinal: ((_response$extensions3 = response.extensions) === null || _response$extensions3 === void 0 ? void 0 : _response$extensions3.is_final) === true
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._processStreamResponse = function _processStreamResponse(label, path, placeholder, response) {
        var parentID = placeholder.parentID, node = placeholder.node, variables = placeholder.variables, actorIdentifier = placeholder.actorIdentifier;
        var prevActorIdentifier = this._actorIdentifier;
        this._actorIdentifier = actorIdentifier !== null && actorIdentifier !== void 0 ? actorIdentifier : this._actorIdentifier;
        var field = node.selections[0];
        !(field != null && field.kind === 'LinkedField' && field.plural === true) && $jwy7p(false);
        var _this$_normalizeStrea = this._normalizeStreamItem(response, parentID, field, variables, path, placeholder.path), fieldPayloads = _this$_normalizeStrea.fieldPayloads, itemID = _this$_normalizeStrea.itemID, itemIndex = _this$_normalizeStrea.itemIndex, prevIDs = _this$_normalizeStrea.prevIDs, relayPayload = _this$_normalizeStrea.relayPayload, storageKey = _this$_normalizeStrea.storageKey;
        this._getPublishQueueAndSaveActor().commitPayload(this._operation, relayPayload, function(store) {
            var currentParentRecord = store.get(parentID);
            if (currentParentRecord == null) return;
            var currentItems = currentParentRecord.getLinkedRecords(storageKey);
            if (currentItems == null) return;
            if (currentItems.length !== prevIDs.length || currentItems.some(function(currentItem, index) {
                return prevIDs[index] !== (currentItem && currentItem.getDataID());
            })) return;
            var nextItems = (0, $925f6509f9b9d1d3$var$_toConsumableArray2["default"])(currentItems);
            nextItems[itemIndex] = store.get(itemID);
            currentParentRecord.setLinkedRecords(nextItems, storageKey);
        });
        if (fieldPayloads.length !== 0) {
            var handleFieldsRelayPayload = {
                errors: null,
                fieldPayloads: fieldPayloads,
                incrementalPlaceholders: null,
                followupPayloads: null,
                source: $gqyVK.create(),
                isFinal: false
            };
            this._getPublishQueueAndSaveActor().commitPayload(this._operation, handleFieldsRelayPayload);
        }
        this._actorIdentifier = prevActorIdentifier;
        return relayPayload;
    };
    _proto._normalizeStreamItem = function _normalizeStreamItem(response, parentID, field, variables, path, normalizationPath) {
        var _field$alias, _field$concreteType, _ref2, _this$_getDataID;
        var data = response.data;
        !(typeof data === 'object') && $jwy7p(false);
        var responseKey = (_field$alias = field.alias) !== null && _field$alias !== void 0 ? _field$alias : field.name;
        var storageKey = $925f6509f9b9d1d3$var$getStorageKey(field, variables);
        var parentEntry = this._source.get(parentID);
        !(parentEntry != null) && $jwy7p(false);
        var parentRecord = parentEntry.record, fieldPayloads = parentEntry.fieldPayloads;
        var prevIDs = $6ZixS.getLinkedRecordIDs(parentRecord, storageKey);
        !(prevIDs != null) && $jwy7p(false);
        var finalPathEntry = path[path.length - 1];
        var itemIndex = parseInt(finalPathEntry, 10);
        !(itemIndex === finalPathEntry && itemIndex >= 0) && $jwy7p(false);
        var typeName = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : data[$925f6509f9b9d1d3$var$TYPENAME_KEY];
        !(typeof typeName === 'string') && $jwy7p(false);
        var itemID = (_ref2 = (_this$_getDataID = this._getDataID(data, typeName)) !== null && _this$_getDataID !== void 0 ? _this$_getDataID : prevIDs === null || prevIDs === void 0 ? void 0 : prevIDs[itemIndex]) !== null && _ref2 !== void 0 ? _ref2 : $925f6509f9b9d1d3$var$generateClientID(parentID, storageKey, itemIndex);
        !(typeof itemID === 'string') && $jwy7p(false);
        var selector = $925f6509f9b9d1d3$var$createNormalizationSelector(field, itemID, variables);
        var nextParentRecord = $6ZixS.clone(parentRecord);
        var nextIDs = (0, $925f6509f9b9d1d3$var$_toConsumableArray2["default"])(prevIDs);
        nextIDs[itemIndex] = itemID;
        $6ZixS.setLinkedRecordIDs(nextParentRecord, storageKey, nextIDs);
        this._source.set(parentID, {
            record: nextParentRecord,
            fieldPayloads: fieldPayloads
        });
        var relayPayload = this._normalizeResponse(response, selector, typeName, {
            actorIdentifier: this._actorIdentifier,
            getDataID: this._getDataID,
            log: this._log,
            path: [].concat((0, $925f6509f9b9d1d3$var$_toConsumableArray2["default"])(normalizationPath), [
                responseKey,
                String(itemIndex)
            ]),
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents
        }, this._useExecTimeResolvers);
        return {
            fieldPayloads: fieldPayloads,
            itemID: itemID,
            itemIndex: itemIndex,
            prevIDs: prevIDs,
            relayPayload: relayPayload,
            storageKey: storageKey
        };
    };
    _proto._scheduleAsyncStoreUpdate = function _scheduleAsyncStoreUpdate(scheduleFn, completeFn) {
        var _this12 = this;
        this._completeFns.push(completeFn);
        if (this._asyncStoreUpdateDisposable != null) return;
        this._asyncStoreUpdateDisposable = scheduleFn(function() {
            _this12._asyncStoreUpdateDisposable = null;
            var updatedOwners = _this12._runPublishQueue();
            _this12._updateOperationTracker(updatedOwners);
            var _iterator2 = (0, $925f6509f9b9d1d3$var$_createForOfIteratorHelper2["default"])(_this12._completeFns), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var complete = _step2.value;
                    complete();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            _this12._completeFns = [];
        });
    };
    _proto._updateOperationTracker = function _updateOperationTracker(updatedOwners) {
        if (updatedOwners != null && updatedOwners.length > 0) this._operationTracker.update(this._operation.request, new Set(updatedOwners));
    };
    _proto._completeOperationTracker = function _completeOperationTracker() {
        this._operationTracker.complete(this._operation.request);
    };
    _proto._getPublishQueueAndSaveActor = function _getPublishQueueAndSaveActor() {
        this._seenActors.add(this._actorIdentifier);
        return this._getPublishQueue(this._actorIdentifier);
    };
    _proto._getActorsToVisit = function _getActorsToVisit() {
        if (this._seenActors.size === 0) return new Set([
            this._actorIdentifier
        ]);
        else return this._seenActors;
    };
    _proto._runPublishQueue = function _runPublishQueue(operation) {
        var updatedOwners = new Set();
        var _iterator3 = (0, $925f6509f9b9d1d3$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var actorIdentifier = _step3.value;
                var owners = this._getPublishQueue(actorIdentifier).run(operation);
                owners.forEach(function(owner) {
                    return updatedOwners.add(owner);
                });
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return Array.from(updatedOwners);
    };
    _proto._retainData = function _retainData() {
        var _iterator4 = (0, $925f6509f9b9d1d3$var$_createForOfIteratorHelper2["default"])(this._getActorsToVisit()), _step4;
        try {
            for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                var actorIdentifier = _step4.value;
                if (!this._retainDisposables.has(actorIdentifier)) this._retainDisposables.set(actorIdentifier, this._getStore(actorIdentifier).retain(this._operation));
            }
        } catch (err) {
            _iterator4.e(err);
        } finally{
            _iterator4.f();
        }
    };
    _proto._disposeRetainedData = function _disposeRetainedData() {
        var _iterator5 = (0, $925f6509f9b9d1d3$var$_createForOfIteratorHelper2["default"])(this._retainDisposables.values()), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var disposable = _step5.value;
                disposable.dispose();
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
        this._retainDisposables.clear();
    };
    _proto._expectOperationLoader = function _expectOperationLoader() {
        var operationLoader = this._operationLoader;
        !operationLoader && $jwy7p(false);
        return operationLoader;
    };
    return Executor;
}();
function $925f6509f9b9d1d3$var$partitionGraphQLResponses(responses) {
    var nonIncrementalResponses = [];
    var incrementalResponses = [];
    var normalizedResponses = [];
    responses.forEach(function(response) {
        var _response$extensions4;
        if (response.path != null || response.label != null) {
            var label = response.label, path = response.path;
            if (label == null || path == null) $jwy7p(false);
            incrementalResponses.push({
                label: label,
                path: path,
                response: response
            });
        } else if (((_response$extensions4 = response.extensions) === null || _response$extensions4 === void 0 ? void 0 : _response$extensions4.is_normalized) === true) normalizedResponses.push(response);
        else nonIncrementalResponses.push(response);
    });
    return [
        nonIncrementalResponses,
        incrementalResponses,
        normalizedResponses
    ];
}
function $925f6509f9b9d1d3$var$stableStringify(value) {
    var _JSON$stringify;
    return (_JSON$stringify = JSON.stringify($925f6509f9b9d1d3$var$stableCopy(value))) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : '';
}
function $925f6509f9b9d1d3$var$validateOptimisticResponsePayload(payload) {
    var incrementalPlaceholders = payload.incrementalPlaceholders;
    if (incrementalPlaceholders != null && incrementalPlaceholders.length !== 0) $jwy7p(false);
}
module.exports = {
    execute: $925f6509f9b9d1d3$var$execute
};

});
parcelRegister("jxlx4", function(module, exports) {
'use strict';

var $2HvH8 = parcelRequire("2HvH8");
var $e391cd415fdea595$var$REQUEST = $2HvH8.REQUEST, $e391cd415fdea595$var$SPLIT_OPERATION = $2HvH8.SPLIT_OPERATION;
function $e391cd415fdea595$var$getOperation(node) {
    switch(node.kind){
        case $e391cd415fdea595$var$REQUEST:
            return node.operation;
        case $e391cd415fdea595$var$SPLIT_OPERATION:
        default:
            return node;
    }
}
module.exports = $e391cd415fdea595$var$getOperation;

});

parcelRegister("3doX1", function(module, exports) {
'use strict';
function $2575f0bede534a39$var$createError(type, name, messageFormat) {
    for(var _len = arguments.length, messageParams = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++)messageParams[_key - 3] = arguments[_key];
    var index = 0;
    var message = messageFormat.replace(/%s/g, function() {
        return String(messageParams[index++]);
    });
    var err = new Error(message);
    var error = Object.assign(err, {
        name: name,
        messageFormat: messageFormat,
        messageParams: messageParams,
        type: type,
        taalOpcodes: [
            2,
            2
        ]
    });
    if (error.stack === undefined) try {
        throw error;
    } catch (_unused) {}
    return error;
}
module.exports = {
    create: function create(name, messageFormat) {
        for(var _len2 = arguments.length, messageParams = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++)messageParams[_key2 - 2] = arguments[_key2];
        return $2575f0bede534a39$var$createError.apply(void 0, [
            'error',
            name,
            messageFormat
        ].concat(messageParams));
    },
    createWarning: function createWarning(name, messageFormat) {
        for(var _len3 = arguments.length, messageParams = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)messageParams[_key3 - 2] = arguments[_key3];
        return $2575f0bede534a39$var$createError.apply(void 0, [
            'warn',
            name,
            messageFormat
        ].concat(messageParams));
    }
};

});

parcelRegister("6lSi2", function(module, exports) {
'use strict';
var $49fed11e49788faf$var$_window, $49fed11e49788faf$var$_window$performance;
var $49fed11e49788faf$var$isPerformanceNowAvailable = typeof window !== 'undefined' && typeof (($49fed11e49788faf$var$_window = window) === null || $49fed11e49788faf$var$_window === void 0 ? void 0 : ($49fed11e49788faf$var$_window$performance = $49fed11e49788faf$var$_window.performance) === null || $49fed11e49788faf$var$_window$performance === void 0 ? void 0 : $49fed11e49788faf$var$_window$performance.now) === 'function';
function $49fed11e49788faf$var$currentTimestamp() {
    if ($49fed11e49788faf$var$isPerformanceNowAvailable) return window.performance.now();
    return Date.now();
}
function $49fed11e49788faf$var$withStartAndDuration(cb) {
    var startTime = $49fed11e49788faf$var$currentTimestamp();
    var result = cb();
    return [
        startTime,
        $49fed11e49788faf$var$currentTimestamp() - startTime,
        result
    ];
}
module.exports = $49fed11e49788faf$var$withStartAndDuration;

});


parcelRegister("kg5Mx", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $ebf9c9696db607bf$var$_interopRequireDefault = $8gviu.default;

var $ebf9c9696db607bf$var$_createForOfIteratorHelper2 = $ebf9c9696db607bf$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $ebf9c9696db607bf$var$_defineProperty2 = $ebf9c9696db607bf$var$_interopRequireDefault((parcelRequire("dangC")));

var $j0uPU = parcelRequire("j0uPU");
var $ebf9c9696db607bf$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE = $j0uPU.INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, $ebf9c9696db607bf$var$assertInternalActorIdentifier = $j0uPU.assertInternalActorIdentifier;
parcelRequire("fHswY");

var $44Bj7 = parcelRequire("44Bj7");

var $9lgX6 = parcelRequire("9lgX6");

var $dZN1a = parcelRequire("dZN1a");

var $5tmf5 = parcelRequire("5tmf5");
var $ebf9c9696db607bf$var$LiveResolverCache = $5tmf5.LiveResolverCache, $ebf9c9696db607bf$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = $5tmf5.RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, $ebf9c9696db607bf$var$getUpdatedDataIDs = $5tmf5.getUpdatedDataIDs;

var $6ZixS = parcelRequire("6ZixS");

var $kXH49 = parcelRequire("kXH49");

var $echTe = parcelRequire("echTe");

var $aAIOS = parcelRequire("aAIOS");

var $29zPn = parcelRequire("29zPn");

var $cvcC4 = parcelRequire("cvcC4");

var $cvcC4 = parcelRequire("cvcC4");
var $ebf9c9696db607bf$var$ROOT_ID = $cvcC4.ROOT_ID, $ebf9c9696db607bf$var$ROOT_TYPE = $cvcC4.ROOT_TYPE;

var $jwy7p = parcelRequire("jwy7p");
var $ebf9c9696db607bf$var$DEFAULT_RELEASE_BUFFER_SIZE = 10;
var $ebf9c9696db607bf$var$RelayModernStore = /*#__PURE__*/ function() {
    function RelayModernStore(source, options) {
        var _this = this;
        var _options$gcReleaseBuf, _options$shouldRetain, _options$gcScheduler, _options$getDataID, _options$log, _options$operationLoa, _options$shouldProces, _options$treatMissing;
        (0, $ebf9c9696db607bf$var$_defineProperty2["default"])(this, "_gcStep", function() {
            if (_this._gcRun) {
                if (_this._gcRun.next().done) _this._gcRun = null;
                else _this._gcScheduler(_this._gcStep);
            }
        });
        var storeIDs, ii, record;
        this._currentWriteEpoch = 0;
        this._gcHoldCounter = 0;
        this._gcReleaseBufferSize = (_options$gcReleaseBuf = options === null || options === void 0 ? void 0 : options.gcReleaseBufferSize) !== null && _options$gcReleaseBuf !== void 0 ? _options$gcReleaseBuf : $ebf9c9696db607bf$var$DEFAULT_RELEASE_BUFFER_SIZE;
        this._shouldRetainWithinTTL_EXPERIMENTAL = (_options$shouldRetain = options === null || options === void 0 ? void 0 : options.shouldRetainWithinTTL_EXPERIMENTAL) !== null && _options$shouldRetain !== void 0 ? _options$shouldRetain : false;
        this._gcRun = null;
        this._gcScheduler = (_options$gcScheduler = options === null || options === void 0 ? void 0 : options.gcScheduler) !== null && _options$gcScheduler !== void 0 ? _options$gcScheduler : $44Bj7;
        this._getDataID = (_options$getDataID = options === null || options === void 0 ? void 0 : options.getDataID) !== null && _options$getDataID !== void 0 ? _options$getDataID : $dZN1a;
        this._globalInvalidationEpoch = null;
        this._invalidationSubscriptions = new Set();
        this._invalidatedRecordIDs = new Set();
        this.__log = (_options$log = options === null || options === void 0 ? void 0 : options.log) !== null && _options$log !== void 0 ? _options$log : null;
        this._queryCacheExpirationTime = options === null || options === void 0 ? void 0 : options.queryCacheExpirationTime;
        this._operationLoader = (_options$operationLoa = options === null || options === void 0 ? void 0 : options.operationLoader) !== null && _options$operationLoa !== void 0 ? _options$operationLoa : null;
        this._optimisticSource = null;
        this._recordSource = source;
        this._releaseBuffer = [];
        this._roots = new Map();
        this._shouldScheduleGC = false;
        this._resolverCache = new $ebf9c9696db607bf$var$LiveResolverCache(function() {
            return _this._getMutableRecordSource();
        }, this);
        this._resolverContext = options === null || options === void 0 ? void 0 : options.resolverContext;
        this._storeSubscriptions = new $29zPn(options === null || options === void 0 ? void 0 : options.log, this._resolverCache, this._resolverContext);
        this._updatedRecordIDs = new Set();
        this._shouldProcessClientComponents = (_options$shouldProces = options === null || options === void 0 ? void 0 : options.shouldProcessClientComponents) !== null && _options$shouldProces !== void 0 ? _options$shouldProces : false;
        this._treatMissingFieldsAsNull = (_options$treatMissing = options === null || options === void 0 ? void 0 : options.treatMissingFieldsAsNull) !== null && _options$treatMissing !== void 0 ? _options$treatMissing : false;
        this._actorIdentifier = options === null || options === void 0 ? void 0 : options.actorIdentifier;
        $ebf9c9696db607bf$var$initializeRecordSource(this._recordSource);
    }
    var _proto = RelayModernStore.prototype;
    _proto.getSource = function getSource() {
        var _this$_optimisticSour;
        return (_this$_optimisticSour = this._optimisticSource) !== null && _this$_optimisticSour !== void 0 ? _this$_optimisticSour : this._recordSource;
    };
    _proto.getOperationLoader = function getOperationLoader() {
        return this._operationLoader;
    };
    _proto._getMutableRecordSource = function _getMutableRecordSource() {
        var _this$_optimisticSour2;
        return (_this$_optimisticSour2 = this._optimisticSource) !== null && _this$_optimisticSour2 !== void 0 ? _this$_optimisticSour2 : this._recordSource;
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(recordID) {
        return this._resolverCache.getLiveResolverPromise(recordID);
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        if (this.__log != null) this.__log({
            name: 'liveresolver.batch.start'
        });
        try {
            this._resolverCache.batchLiveStateUpdates(callback);
        } finally{
            if (this.__log != null) this.__log({
                name: 'liveresolver.batch.end'
            });
        }
    };
    _proto.check = function check(operation, options) {
        var _ref, _operation$request$no, _operation$request$no2, _options$handlers, _options$getSourceFor, _options$getTargetFor, _options$defaultActor;
        var selector = operation.root;
        var source = this._getMutableRecordSource();
        var globalInvalidationEpoch = this._globalInvalidationEpoch;
        var useExecTimeResolvers = (_ref = (_operation$request$no = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no !== void 0 ? _operation$request$no : ((_operation$request$no2 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no2 === void 0 ? void 0 : _operation$request$no2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        var rootEntry = this._roots.get(operation.request.identifier);
        var operationLastWrittenAt = rootEntry != null ? rootEntry.epoch : null;
        if (globalInvalidationEpoch != null) {
            if (operationLastWrittenAt == null || operationLastWrittenAt <= globalInvalidationEpoch) return {
                status: 'stale'
            };
        }
        var handlers = (_options$handlers = options === null || options === void 0 ? void 0 : options.handlers) !== null && _options$handlers !== void 0 ? _options$handlers : [];
        var getSourceForActor = (_options$getSourceFor = options === null || options === void 0 ? void 0 : options.getSourceForActor) !== null && _options$getSourceFor !== void 0 ? _options$getSourceFor : function(actorIdentifier) {
            $ebf9c9696db607bf$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var getTargetForActor = (_options$getTargetFor = options === null || options === void 0 ? void 0 : options.getTargetForActor) !== null && _options$getTargetFor !== void 0 ? _options$getTargetFor : function(actorIdentifier) {
            $ebf9c9696db607bf$var$assertInternalActorIdentifier(actorIdentifier);
            return source;
        };
        var operationAvailability = $9lgX6.check(getSourceForActor, getTargetForActor, (_options$defaultActor = options === null || options === void 0 ? void 0 : options.defaultActorIdentifier) !== null && _options$defaultActor !== void 0 ? _options$defaultActor : $ebf9c9696db607bf$var$INTERNAL_ACTOR_IDENTIFIER_DO_NOT_USE, selector, handlers, this._operationLoader, this._getDataID, this._shouldProcessClientComponents, this.__log, useExecTimeResolvers);
        return $ebf9c9696db607bf$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, rootEntry === null || rootEntry === void 0 ? void 0 : rootEntry.fetchTime, this._queryCacheExpirationTime);
    };
    _proto.retain = function retain(operation) {
        var _this2 = this;
        var id = operation.request.identifier;
        var disposed = false;
        var dispose = function dispose() {
            if (disposed) return;
            disposed = true;
            var rootEntry = _this2._roots.get(id);
            if (rootEntry == null) return;
            rootEntry.refCount--;
            if (rootEntry.refCount === 0) {
                var _queryCacheExpirationTime = _this2._queryCacheExpirationTime;
                var rootEntryIsStale = rootEntry.fetchTime != null && _queryCacheExpirationTime != null && rootEntry.fetchTime <= Date.now() - _queryCacheExpirationTime;
                if (rootEntryIsStale) {
                    if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](id);
                    _this2.scheduleGC();
                } else {
                    _this2._releaseBuffer.push(id);
                    if (_this2._releaseBuffer.length > _this2._gcReleaseBufferSize) {
                        var _id = _this2._releaseBuffer.shift();
                        if (!_this2._shouldRetainWithinTTL_EXPERIMENTAL) _this2._roots["delete"](_id);
                        _this2.scheduleGC();
                    }
                }
            }
        };
        var rootEntry = this._roots.get(id);
        if (rootEntry != null) {
            if (rootEntry.refCount === 0) this._releaseBuffer = this._releaseBuffer.filter(function(_id) {
                return _id !== id;
            });
            rootEntry.refCount += 1;
        } else this._roots.set(id, {
            operation: operation,
            refCount: 1,
            epoch: null,
            fetchTime: null
        });
        return {
            dispose: dispose
        };
    };
    _proto.lookup = function lookup(selector) {
        var log = this.__log;
        if (log != null) log({
            name: 'store.lookup.start',
            selector: selector
        });
        var source = this.getSource();
        var snapshot = $echTe.read(source, selector, this._resolverCache, this._resolverContext);
        if (log != null) log({
            name: 'store.lookup.end',
            selector: selector
        });
        return snapshot;
    };
    _proto.notify = function notify(sourceOperation, invalidateStore) {
        var _this3 = this;
        var log = this.__log;
        if (log != null) log({
            name: 'store.notify.start',
            sourceOperation: sourceOperation
        });
        this._currentWriteEpoch++;
        if (invalidateStore === true) this._globalInvalidationEpoch = this._currentWriteEpoch;
        this._resolverCache.invalidateDataIDs(this._updatedRecordIDs);
        var source = this.getSource();
        var updatedOwners = [];
        this._storeSubscriptions.updateSubscriptions(source, this._updatedRecordIDs, updatedOwners, sourceOperation);
        this._invalidationSubscriptions.forEach(function(subscription) {
            _this3._updateInvalidationSubscription(subscription, invalidateStore === true);
        });
        if (sourceOperation != null) {
            var id = sourceOperation.request.identifier;
            var rootEntry = this._roots.get(id);
            if (rootEntry != null) {
                rootEntry.epoch = this._currentWriteEpoch;
                rootEntry.fetchTime = Date.now();
            } else if (sourceOperation.request.node.params.operationKind === 'query' && this._gcReleaseBufferSize > 0 && this._releaseBuffer.length < this._gcReleaseBufferSize) {
                var temporaryRootEntry = {
                    operation: sourceOperation,
                    refCount: 0,
                    epoch: this._currentWriteEpoch,
                    fetchTime: Date.now()
                };
                this._releaseBuffer.push(id);
                this._roots.set(id, temporaryRootEntry);
            }
        }
        if (log != null) log({
            name: 'store.notify.complete',
            sourceOperation: sourceOperation,
            updatedRecordIDs: this._updatedRecordIDs,
            invalidatedRecordIDs: this._invalidatedRecordIDs,
            subscriptionsSize: this._storeSubscriptions.size(),
            updatedOwners: updatedOwners
        });
        this._updatedRecordIDs.clear();
        this._invalidatedRecordIDs.clear();
        return updatedOwners;
    };
    _proto.publish = function publish(source, idsMarkedForInvalidation) {
        var target = this._getMutableRecordSource();
        $ebf9c9696db607bf$var$updateTargetFromSource(target, source, this._currentWriteEpoch + 1, idsMarkedForInvalidation, this._updatedRecordIDs, this._invalidatedRecordIDs);
        var log = this.__log;
        if (log != null) log({
            name: 'store.publish',
            source: source,
            optimistic: target === this._optimisticSource
        });
    };
    _proto.subscribe = function subscribe(snapshot, callback) {
        return this._storeSubscriptions.subscribe(snapshot, callback);
    };
    _proto.holdGC = function holdGC() {
        var _this4 = this;
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._gcHoldCounter++;
        var dispose = function dispose() {
            if (_this4._gcHoldCounter > 0) {
                _this4._gcHoldCounter--;
                if (_this4._gcHoldCounter === 0 && _this4._shouldScheduleGC) {
                    _this4.scheduleGC();
                    _this4._shouldScheduleGC = false;
                }
            }
        };
        return {
            dispose: dispose
        };
    };
    _proto.toJSON = function toJSON() {
        return 'RelayModernStore()';
    };
    _proto.getEpoch = function getEpoch() {
        return this._currentWriteEpoch;
    };
    _proto.__getUpdatedRecordIDs = function __getUpdatedRecordIDs() {
        return this._updatedRecordIDs;
    };
    _proto.lookupInvalidationState = function lookupInvalidationState(dataIDs) {
        var _this5 = this;
        var invalidations = new Map();
        dataIDs.forEach(function(dataID) {
            var _RelayModernRecord$ge;
            var record = _this5.getSource().get(dataID);
            invalidations.set(dataID, (_RelayModernRecord$ge = $6ZixS.getInvalidationEpoch(record)) !== null && _RelayModernRecord$ge !== void 0 ? _RelayModernRecord$ge : null);
        });
        invalidations.set('global', this._globalInvalidationEpoch);
        return {
            dataIDs: dataIDs,
            invalidations: invalidations
        };
    };
    _proto.checkInvalidationState = function checkInvalidationState(prevInvalidationState) {
        var latestInvalidationState = this.lookupInvalidationState(prevInvalidationState.dataIDs);
        var currentInvalidations = latestInvalidationState.invalidations;
        var prevInvalidations = prevInvalidationState.invalidations;
        if (currentInvalidations.get('global') !== prevInvalidations.get('global')) return true;
        var _iterator = (0, $ebf9c9696db607bf$var$_createForOfIteratorHelper2["default"])(prevInvalidationState.dataIDs), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var dataID = _step.value;
                if (currentInvalidations.get(dataID) !== prevInvalidations.get(dataID)) return true;
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return false;
    };
    _proto.subscribeToInvalidationState = function subscribeToInvalidationState(invalidationState, callback) {
        var _this6 = this;
        var subscription = {
            callback: callback,
            invalidationState: invalidationState
        };
        var dispose = function dispose() {
            _this6._invalidationSubscriptions["delete"](subscription);
        };
        this._invalidationSubscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto._updateInvalidationSubscription = function _updateInvalidationSubscription(subscription, invalidatedStore) {
        var _this7 = this;
        var callback = subscription.callback, invalidationState = subscription.invalidationState;
        var dataIDs = invalidationState.dataIDs;
        var isSubscribedToInvalidatedIDs = invalidatedStore || dataIDs.some(function(dataID) {
            return _this7._invalidatedRecordIDs.has(dataID);
        });
        if (!isSubscribedToInvalidatedIDs) return;
        callback();
    };
    _proto.snapshot = function snapshot() {
        !(this._optimisticSource == null) && $jwy7p(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.snapshot'
        });
        this._storeSubscriptions.snapshotSubscriptions(this.getSource());
        if (this._gcRun) {
            this._gcRun = null;
            this._shouldScheduleGC = true;
        }
        this._optimisticSource = $kXH49.create(this.getSource());
    };
    _proto.restore = function restore() {
        var optimisticSource = this._optimisticSource;
        !optimisticSource && $jwy7p(false);
        var log = this.__log;
        if (log != null) log({
            name: 'store.restore'
        });
        var optimisticIDs = $kXH49.getOptimisticRecordIDs(optimisticSource);
        this._resolverCache.unsubscribeFromLiveResolverRecords(optimisticIDs);
        this._optimisticSource = null;
        if (this._shouldScheduleGC) this.scheduleGC();
        this._storeSubscriptions.restoreSubscriptions();
        this._resolverCache.invalidateResolverRecords(optimisticIDs);
    };
    _proto.scheduleGC = function scheduleGC() {
        if (this._gcHoldCounter > 0) {
            this._shouldScheduleGC = true;
            return;
        }
        if (this._gcRun) return;
        this._gcRun = this._collect();
        this._gcScheduler(this._gcStep);
    };
    _proto.__gc = function __gc() {
        if (this._optimisticSource != null) return;
        var gcRun = this._collect();
        while(!gcRun.next().done);
    };
    _proto._collect = function* _collect() {
        if (this._shouldRetainWithinTTL_EXPERIMENTAL && this._queryCacheExpirationTime == null) return;
        var log = this.__log;
        top: while(true){
            if (log != null) log({
                name: 'store.gc.start'
            });
            var startEpoch = this._currentWriteEpoch;
            var references = new Set();
            var _iterator2 = (0, $ebf9c9696db607bf$var$_createForOfIteratorHelper2["default"])(this._roots.entries()), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var _ref2, _operation$request$no3, _operation$request$no4;
                    var _step2$value = _step2.value, _dataID = _step2$value[0], _step2$value$ = _step2$value[1], operation = _step2$value$.operation, refCount = _step2$value$.refCount, fetchTime = _step2$value$.fetchTime;
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) {
                        var _queryCacheExpirationTime = this._queryCacheExpirationTime;
                        !(_queryCacheExpirationTime != null) && $jwy7p(false);
                        var recordHasExpired = fetchTime == null || fetchTime <= Date.now() - _queryCacheExpirationTime;
                        var recordShouldBeCollected = recordHasExpired && refCount === 0 && !this._releaseBuffer.includes(_dataID);
                        if (recordShouldBeCollected) continue;
                    }
                    var selector = operation.root;
                    var useExecTimeResolvers = (_ref2 = (_operation$request$no3 = operation.request.node.operation.use_exec_time_resolvers) !== null && _operation$request$no3 !== void 0 ? _operation$request$no3 : ((_operation$request$no4 = operation.request.node.operation.exec_time_resolvers_enabled_provider) === null || _operation$request$no4 === void 0 ? void 0 : _operation$request$no4.get()) === true) !== null && _ref2 !== void 0 ? _ref2 : false;
                    $aAIOS.mark(this._recordSource, selector, references, this._operationLoader, this._shouldProcessClientComponents, useExecTimeResolvers);
                    yield;
                    if (startEpoch !== this._currentWriteEpoch) {
                        if (log != null) log({
                            name: 'store.gc.interrupted'
                        });
                        continue top;
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
            var storeIDs = this._recordSource.getRecordIDs();
            for(var ii = 0; ii < storeIDs.length; ii++){
                var dataID = storeIDs[ii];
                if (!references.has(dataID)) {
                    var record = this._recordSource.get(dataID);
                    if (record != null) {
                        var maybeResolverSubscription = $6ZixS.getValue(record, $ebf9c9696db607bf$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
                        if (maybeResolverSubscription != null) maybeResolverSubscription();
                    }
                    this._recordSource.remove(dataID);
                    if (this._shouldRetainWithinTTL_EXPERIMENTAL) this._roots["delete"](dataID);
                }
            }
            if (log != null) log({
                name: 'store.gc.end',
                references: references
            });
            return;
        }
    };
    _proto.__getNormalizationOptions = function __getNormalizationOptions(path) {
        return {
            path: path,
            getDataID: this._getDataID,
            log: this.__log,
            treatMissingFieldsAsNull: this._treatMissingFieldsAsNull,
            shouldProcessClientComponents: this._shouldProcessClientComponents,
            actorIdentifier: this._actorIdentifier
        };
    };
    _proto.__notifyUpdatedSubscribers = function __notifyUpdatedSubscribers(updatedRecords) {
        var nextUpdatedRecordIDs = $ebf9c9696db607bf$var$getUpdatedDataIDs(updatedRecords);
        var prevUpdatedRecordIDs = this._updatedRecordIDs;
        this._updatedRecordIDs = nextUpdatedRecordIDs;
        this.notify();
        this._updatedRecordIDs = prevUpdatedRecordIDs;
    };
    return RelayModernStore;
}();
function $ebf9c9696db607bf$var$initializeRecordSource(target) {
    if (!target.has($ebf9c9696db607bf$var$ROOT_ID)) {
        var rootRecord = $6ZixS.create($ebf9c9696db607bf$var$ROOT_ID, $ebf9c9696db607bf$var$ROOT_TYPE);
        target.set($ebf9c9696db607bf$var$ROOT_ID, rootRecord);
    }
}
function $ebf9c9696db607bf$var$updateTargetFromSource(target, source, currentWriteEpoch, idsMarkedForInvalidation, updatedRecordIDs, invalidatedRecordIDs) {
    if (idsMarkedForInvalidation) idsMarkedForInvalidation.forEach(function(dataID) {
        var targetRecord = target.get(dataID);
        var sourceRecord = source.get(dataID);
        if (sourceRecord === null) return;
        var nextRecord;
        if (targetRecord != null) nextRecord = $6ZixS.clone(targetRecord);
        else nextRecord = sourceRecord != null ? $6ZixS.clone(sourceRecord) : null;
        if (!nextRecord) return;
        $6ZixS.setValue(nextRecord, $cvcC4.INVALIDATED_AT_KEY, currentWriteEpoch);
        invalidatedRecordIDs.add(dataID);
        target.set(dataID, nextRecord);
    });
    var dataIDs = source.getRecordIDs();
    for(var ii = 0; ii < dataIDs.length; ii++){
        var dataID = dataIDs[ii];
        var sourceRecord = source.get(dataID);
        var targetRecord = target.get(dataID);
        if (sourceRecord && targetRecord) {
            var nextRecord = $6ZixS.update(targetRecord, sourceRecord);
            if (nextRecord !== targetRecord) {
                updatedRecordIDs.add(dataID);
                target.set(dataID, nextRecord);
            }
        } else if (sourceRecord === null) {
            target["delete"](dataID);
            if (targetRecord !== null) updatedRecordIDs.add(dataID);
        } else if (sourceRecord) {
            target.set(dataID, sourceRecord);
            updatedRecordIDs.add(dataID);
        }
    }
}
function $ebf9c9696db607bf$var$getAvailabilityStatus(operationAvailability, operationLastWrittenAt, operationFetchTime, queryCacheExpirationTime) {
    var mostRecentlyInvalidatedAt = operationAvailability.mostRecentlyInvalidatedAt, status = operationAvailability.status;
    if (typeof mostRecentlyInvalidatedAt === 'number') {
        if (operationLastWrittenAt == null || mostRecentlyInvalidatedAt > operationLastWrittenAt) return {
            status: 'stale'
        };
    }
    if (status === 'missing') return {
        status: 'missing'
    };
    if (operationFetchTime != null && queryCacheExpirationTime != null) {
        var isStale = operationFetchTime <= Date.now() - queryCacheExpirationTime;
        if (isStale) return {
            status: 'stale'
        };
    }
    return {
        status: 'available',
        fetchTime: operationFetchTime !== null && operationFetchTime !== void 0 ? operationFetchTime : null
    };
}
module.exports = $ebf9c9696db607bf$var$RelayModernStore;

});
parcelRegister("44Bj7", function(module, exports) {
'use strict';
var $2f74799f9cfb4e53$var$resolvedPromise = Promise.resolve();
function $2f74799f9cfb4e53$var$resolveImmediate(callback) {
    $2f74799f9cfb4e53$var$resolvedPromise.then(callback)["catch"]($2f74799f9cfb4e53$var$throwNext);
}
function $2f74799f9cfb4e53$var$throwNext(error) {
    setTimeout(function() {
        throw error;
    }, 0);
}
module.exports = $2f74799f9cfb4e53$var$resolveImmediate;

});

parcelRegister("9lgX6", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $6cd3399bae501e63$var$_interopRequireDefault = $8gviu.default;

var $6cd3399bae501e63$var$_createForOfIteratorHelper2 = $6cd3399bae501e63$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $Zx0mT = parcelRequire("Zx0mT");

var $8yw4N = parcelRequire("8yw4N");

var $jxlx4 = parcelRequire("jxlx4");

var $9eVAj = parcelRequire("9eVAj");
var $6cd3399bae501e63$var$isClientID = $9eVAj.isClientID;

var $hacyv = parcelRequire("hacyv");

var $5fb4u = parcelRequire("5fb4u");

var $cbsiZ = parcelRequire("cbsiZ");
var $6cd3399bae501e63$var$getLocalVariables = $cbsiZ.getLocalVariables;

var $6ZixS = parcelRequire("6ZixS");

var $2O63w = parcelRequire("2O63w");
var $6cd3399bae501e63$var$EXISTENT = $2O63w.EXISTENT, $6cd3399bae501e63$var$UNKNOWN = $2O63w.UNKNOWN;

var $cvcC4 = parcelRequire("cvcC4");

var $awaCw = parcelRequire("awaCw");
var $6cd3399bae501e63$var$TYPE_SCHEMA_TYPE = $awaCw.TYPE_SCHEMA_TYPE, $6cd3399bae501e63$var$generateTypeID = $awaCw.generateTypeID;

var $jwy7p = parcelRequire("jwy7p");
var $6cd3399bae501e63$var$getModuleOperationKey = $cvcC4.getModuleOperationKey, $6cd3399bae501e63$var$getStorageKey = $cvcC4.getStorageKey, $6cd3399bae501e63$var$getArgumentValues = $cvcC4.getArgumentValues;
function $6cd3399bae501e63$var$check(getSourceForActor, getTargetForActor, defaultActorIdentifier, selector, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
    if (log != null) log({
        name: 'store.datachecker.start',
        selector: selector
    });
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var checker = new $6cd3399bae501e63$var$DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers);
    var result = checker.check(node, dataID);
    if (log != null) log({
        name: 'store.datachecker.end',
        selector: selector
    });
    return result;
}
var $6cd3399bae501e63$var$DataChecker = /*#__PURE__*/ function() {
    function DataChecker(getSourceForActor, getTargetForActor, defaultActorIdentifier, variables, handlers, operationLoader, getDataID, shouldProcessClientComponents, log, useExecTimeResolvers) {
        this._getSourceForActor = getSourceForActor;
        this._getTargetForActor = getTargetForActor;
        this._getDataID = getDataID;
        this._source = getSourceForActor(defaultActorIdentifier);
        this._mutatorRecordSourceProxyCache = new Map();
        var _this$_getMutatorAndR = this._getMutatorAndRecordProxyForActor(defaultActorIdentifier), mutator = _this$_getMutatorAndR[0], recordSourceProxy = _this$_getMutatorAndR[1];
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._mostRecentlyInvalidatedAt = null;
        this._handlers = handlers;
        this._mutator = mutator;
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._recordSourceProxy = recordSourceProxy;
        this._recordWasMissing = false;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
        this._log = log;
    }
    var _proto = DataChecker.prototype;
    _proto._getMutatorAndRecordProxyForActor = function _getMutatorAndRecordProxyForActor(actorIdentifier) {
        var tuple = this._mutatorRecordSourceProxyCache.get(actorIdentifier);
        if (tuple == null) {
            var target = this._getTargetForActor(actorIdentifier);
            var mutator = new $Zx0mT(this._getSourceForActor(actorIdentifier), target);
            var recordSourceProxy = new $8yw4N(mutator, this._getDataID, undefined, this._handlers, this._log);
            tuple = [
                mutator,
                recordSourceProxy
            ];
            this._mutatorRecordSourceProxyCache.set(actorIdentifier, tuple);
        }
        return tuple;
    };
    _proto.check = function check(node, dataID) {
        this._assignClientAbstractTypes(node);
        this._traverse(node, dataID);
        return this._recordWasMissing === true ? {
            status: 'missing',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        } : {
            status: 'available',
            mostRecentlyInvalidatedAt: this._mostRecentlyInvalidatedAt
        };
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jwy7p(false);
        return this._variables[name];
    };
    _proto._handleMissing = function _handleMissing() {
        this._recordWasMissing = true;
    };
    _proto._handleMissingScalarField = function _handleMissingScalarField(field, dataID) {
        if (field.name === 'id' && field.alias == null && $6cd3399bae501e63$var$isClientID(dataID)) return undefined;
        var args = field.args != undefined ? $6cd3399bae501e63$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator = (0, $6cd3399bae501e63$var$_createForOfIteratorHelper2["default"])(this._handlers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var handler = _step.value;
                if (handler.kind === 'scalar') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined) return newValue;
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingLinkField = function _handleMissingLinkField(field, dataID) {
        var args = field.args != undefined ? $6cd3399bae501e63$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator2 = (0, $6cd3399bae501e63$var$_createForOfIteratorHelper2["default"])(this._handlers), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var handler = _step2.value;
                if (handler.kind === 'linked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue !== undefined && (newValue === null || this._mutator.getStatus(newValue) === $6cd3399bae501e63$var$EXISTENT)) return newValue;
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        this._handleMissing();
    };
    _proto._handleMissingPluralLinkField = function _handleMissingPluralLinkField(field, dataID) {
        var _this = this;
        var args = field.args != undefined ? $6cd3399bae501e63$var$getArgumentValues(field.args, this._variables) : {};
        var _iterator3 = (0, $6cd3399bae501e63$var$_createForOfIteratorHelper2["default"])(this._handlers), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var handler = _step3.value;
                if (handler.kind === 'pluralLinked') {
                    var newValue = handler.handle(field, this._recordSourceProxy.get(dataID), args, this._recordSourceProxy);
                    if (newValue != null) {
                        var allItemsKnown = newValue.every(function(linkedID) {
                            return linkedID != null && _this._mutator.getStatus(linkedID) === $6cd3399bae501e63$var$EXISTENT;
                        });
                        if (allItemsKnown) return newValue;
                    } else if (newValue === null) return null;
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        this._handleMissing();
    };
    _proto._traverse = function _traverse(node, dataID) {
        var status = this._mutator.getStatus(dataID);
        if (status === $6cd3399bae501e63$var$UNKNOWN) this._handleMissing();
        if (status === $6cd3399bae501e63$var$EXISTENT) {
            var record = this._source.get(dataID);
            var invalidatedAt = $6ZixS.getInvalidationEpoch(record);
            if (invalidatedAt != null) this._mostRecentlyInvalidatedAt = this._mostRecentlyInvalidatedAt != null ? Math.max(this._mostRecentlyInvalidatedAt, invalidatedAt) : invalidatedAt;
            this._traverseSelections(node.selections, dataID);
        }
    };
    _proto._traverseSelections = function _traverseSelections(selections, dataID) {
        var _this2 = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ScalarField':
                    _this2._checkScalar(selection, dataID);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this2._checkPluralLink(selection, dataID);
                    else _this2._checkLink(selection, dataID);
                    break;
                case 'ActorChange':
                    _this2._checkActorChange(selection.linkedField, dataID);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this2._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'InlineFragment':
                    var _abstractKey = selection.abstractKey;
                    if (_abstractKey == null) {
                        var typeName = _this2._mutator.getType(dataID);
                        if (typeName === selection.type) _this2._traverseSelections(selection.selections, dataID);
                    } else {
                        var _recordType = _this2._mutator.getType(dataID);
                        !(_recordType != null) && $jwy7p(false);
                        var _typeID = $6cd3399bae501e63$var$generateTypeID(_recordType);
                        var _implementsInterface = _this2._mutator.getValue(_typeID, _abstractKey);
                        if (_implementsInterface === true) _this2._traverseSelections(selection.selections, dataID);
                        else if (_implementsInterface == null) _this2._handleMissing();
                    }
                    break;
                case 'LinkedHandle':
                    var handleField = $hacyv(selection, selections, _this2._variables);
                    if (handleField.plural) _this2._checkPluralLink(handleField, dataID);
                    else _this2._checkLink(handleField, dataID);
                    break;
                case 'ScalarHandle':
                    var _handleField = $5fb4u(selection, selections, _this2._variables);
                    _this2._checkScalar(_handleField, dataID);
                    break;
                case 'ModuleImport':
                    _this2._checkModuleImport(selection, dataID);
                    break;
                case 'Defer':
                case 'Stream':
                    _this2._traverseSelections(selection.selections, dataID);
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this2._variables;
                    _this2._variables = $6cd3399bae501e63$var$getLocalVariables(_this2._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    _this2._variables = prevVariables;
                    break;
                case 'ClientExtension':
                    var recordWasMissing = _this2._recordWasMissing;
                    _this2._traverseSelections(selection.selections, dataID);
                    _this2._recordWasMissing = recordWasMissing;
                    break;
                case 'TypeDiscriminator':
                    var abstractKey = selection.abstractKey;
                    var recordType = _this2._mutator.getType(dataID);
                    !(recordType != null) && $jwy7p(false);
                    var typeID = $6cd3399bae501e63$var$generateTypeID(recordType);
                    var implementsInterface = _this2._mutator.getValue(typeID, abstractKey);
                    if (implementsInterface == null) _this2._handleMissing();
                    break;
                case 'ClientComponent':
                    if (_this2._shouldProcessClientComponents === false) break;
                    _this2._traverseSelections(selection.fragment.selections, dataID);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection, dataID);
                    break;
                case 'ClientEdgeToClientObject':
                    if (!_this2._useExecTimeResolvers) _this2._checkResolver(selection.backingField, dataID);
                    break;
                default:
                    selection;
                    $jwy7p(false);
            }
        });
    };
    _proto._checkResolver = function _checkResolver(resolver, dataID) {
        if (resolver.fragment) this._traverseSelections([
            resolver.fragment
        ], dataID);
    };
    _proto._checkModuleImport = function _checkModuleImport(moduleImport, dataID) {
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $jwy7p(false);
        var operationKey = $6cd3399bae501e63$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = this._mutator.getValue(dataID, operationKey);
        if (operationReference == null) {
            if (operationReference === undefined) this._handleMissing();
            return;
        }
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $jxlx4(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $6cd3399bae501e63$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverse(operation, dataID);
            this._variables = prevVariables;
        } else this._handleMissing();
    };
    _proto._checkScalar = function _checkScalar(field, dataID) {
        var storageKey = $6cd3399bae501e63$var$getStorageKey(field, this._variables);
        var fieldValue = this._mutator.getValue(dataID, storageKey);
        if (fieldValue === undefined) {
            fieldValue = this._handleMissingScalarField(field, dataID);
            if (fieldValue !== undefined) this._mutator.setValue(dataID, storageKey, fieldValue);
        }
    };
    _proto._checkLink = function _checkLink(field, dataID) {
        var storageKey = $6cd3399bae501e63$var$getStorageKey(field, this._variables);
        var linkedID = this._mutator.getLinkedRecordID(dataID, storageKey);
        if (linkedID === undefined) {
            linkedID = this._handleMissingLinkField(field, dataID);
            if (linkedID != null) this._mutator.setLinkedRecordID(dataID, storageKey, linkedID);
            else if (linkedID === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedID != null) this._traverse(field, linkedID);
    };
    _proto._checkPluralLink = function _checkPluralLink(field, dataID) {
        var _this3 = this;
        var storageKey = $6cd3399bae501e63$var$getStorageKey(field, this._variables);
        var linkedIDs = this._mutator.getLinkedRecordIDs(dataID, storageKey);
        if (linkedIDs === undefined) {
            linkedIDs = this._handleMissingPluralLinkField(field, dataID);
            if (linkedIDs != null) this._mutator.setLinkedRecordIDs(dataID, storageKey, linkedIDs);
            else if (linkedIDs === null) this._mutator.setValue(dataID, storageKey, null);
        }
        if (linkedIDs) linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this3._traverse(field, linkedID);
        });
    };
    _proto._checkActorChange = function _checkActorChange(field, dataID) {
        var storageKey = $6cd3399bae501e63$var$getStorageKey(field, this._variables);
        var record = this._source.get(dataID);
        var tuple = record != null ? $6ZixS.getActorLinkedRecordID(record, storageKey) : record;
        if (tuple == null) {
            if (tuple === undefined) this._handleMissing();
        } else {
            var actorIdentifier = tuple[0], linkedID = tuple[1];
            var prevSource = this._source;
            var prevMutator = this._mutator;
            var prevRecordSourceProxy = this._recordSourceProxy;
            var _this$_getMutatorAndR2 = this._getMutatorAndRecordProxyForActor(actorIdentifier), mutator = _this$_getMutatorAndR2[0], recordSourceProxy = _this$_getMutatorAndR2[1];
            this._source = this._getSourceForActor(actorIdentifier);
            this._mutator = mutator;
            this._recordSourceProxy = recordSourceProxy;
            this._assignClientAbstractTypes(field);
            this._traverse(field, linkedID);
            this._source = prevSource;
            this._mutator = prevMutator;
            this._recordSourceProxy = prevRecordSourceProxy;
        }
    };
    _proto._assignClientAbstractTypes = function _assignClientAbstractTypes(node) {
        var clientAbstractTypes = node.clientAbstractTypes;
        if (clientAbstractTypes != null) for(var _i = 0, _Object$keys = Object.keys(clientAbstractTypes); _i < _Object$keys.length; _i++){
            var abstractType = _Object$keys[_i];
            var _iterator4 = (0, $6cd3399bae501e63$var$_createForOfIteratorHelper2["default"])(clientAbstractTypes[abstractType]), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var concreteType = _step4.value;
                    var typeID = $6cd3399bae501e63$var$generateTypeID(concreteType);
                    if (this._source.get(typeID) == null) this._mutator.create(typeID, $6cd3399bae501e63$var$TYPE_SCHEMA_TYPE);
                    if (this._mutator.getValue(typeID, abstractType) == null) this._mutator.setValue(typeID, abstractType, true);
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    return DataChecker;
}();
module.exports = {
    check: $6cd3399bae501e63$var$check
};

});
parcelRegister("Zx0mT", function(module, exports) {
'use strict';

var $6ZixS = parcelRequire("6ZixS");

var $2O63w = parcelRequire("2O63w");
var $0b8f4cb6ae43dbd3$var$EXISTENT = $2O63w.EXISTENT;

var $jwy7p = parcelRequire("jwy7p");
var $0b8f4cb6ae43dbd3$var$RelayRecordSourceMutator = /*#__PURE__*/ function() {
    function RelayRecordSourceMutator(base, sink) {
        this.__sources = [
            sink,
            base
        ];
        this._base = base;
        this._sink = sink;
    }
    var _proto = RelayRecordSourceMutator.prototype;
    _proto.unstable_getRawRecordWithChanges = function unstable_getRawRecordWithChanges(dataID) {
        var baseRecord = this._base.get(dataID);
        var sinkRecord = this._sink.get(dataID);
        if (sinkRecord === undefined) {
            if (baseRecord == null) return baseRecord;
            var nextRecord = $6ZixS.clone(baseRecord);
            return nextRecord;
        } else if (sinkRecord === null) return null;
        else if (baseRecord != null) {
            var _nextRecord = $6ZixS.update(baseRecord, sinkRecord);
            return _nextRecord;
        } else {
            var _nextRecord2 = $6ZixS.clone(sinkRecord);
            return _nextRecord2;
        }
    };
    _proto._getSinkRecord = function _getSinkRecord(dataID) {
        var sinkRecord = this._sink.get(dataID);
        if (!sinkRecord) {
            var baseRecord = this._base.get(dataID);
            !baseRecord && $jwy7p(false);
            sinkRecord = $6ZixS.create(dataID, $6ZixS.getType(baseRecord));
            this._sink.set(dataID, sinkRecord);
        }
        return sinkRecord;
    };
    _proto.copyFields = function copyFields(sourceID, sinkID) {
        var sinkSource = this._sink.get(sourceID);
        var baseSource = this._base.get(sourceID);
        !(sinkSource || baseSource) && $jwy7p(false);
        var sink = this._getSinkRecord(sinkID);
        if (baseSource) $6ZixS.copyFields(baseSource, sink);
        if (sinkSource) $6ZixS.copyFields(sinkSource, sink);
    };
    _proto.copyFieldsFromRecord = function copyFieldsFromRecord(record, sinkID) {
        var sink = this._getSinkRecord(sinkID);
        $6ZixS.copyFields(record, sink);
    };
    _proto.create = function create(dataID, typeName) {
        !(this._base.getStatus(dataID) !== $0b8f4cb6ae43dbd3$var$EXISTENT && this._sink.getStatus(dataID) !== $0b8f4cb6ae43dbd3$var$EXISTENT) && $jwy7p(false);
        var record = $6ZixS.create(dataID, typeName);
        this._sink.set(dataID, record);
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        return this._sink.has(dataID) ? this._sink.getStatus(dataID) : this._base.getStatus(dataID);
    };
    _proto.getType = function getType(dataID) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) return $6ZixS.getType(record);
            else if (record === null) return null;
        }
    };
    _proto.getValue = function getValue(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $6ZixS.getValue(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setValue = function setValue(dataID, storageKey, value) {
        var sinkRecord = this._getSinkRecord(dataID);
        $6ZixS.setValue(sinkRecord, storageKey, value);
    };
    _proto.getErrors = function getErrors(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var value = $6ZixS.getErrors(record, storageKey);
                if (value !== undefined) return value;
            } else if (record === null) return null;
        }
    };
    _proto.setErrors = function setErrors(dataID, storageKey, errors) {
        var sinkRecord = this._getSinkRecord(dataID);
        $6ZixS.setErrors(sinkRecord, storageKey, errors);
    };
    _proto.getLinkedRecordID = function getLinkedRecordID(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedID = $6ZixS.getLinkedRecordID(record, storageKey);
                if (linkedID !== undefined) return linkedID;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordID = function setLinkedRecordID(dataID, storageKey, linkedID) {
        var sinkRecord = this._getSinkRecord(dataID);
        $6ZixS.setLinkedRecordID(sinkRecord, storageKey, linkedID);
    };
    _proto.getLinkedRecordIDs = function getLinkedRecordIDs(dataID, storageKey) {
        for(var ii = 0; ii < this.__sources.length; ii++){
            var record = this.__sources[ii].get(dataID);
            if (record) {
                var linkedIDs = $6ZixS.getLinkedRecordIDs(record, storageKey);
                if (linkedIDs !== undefined) return linkedIDs;
            } else if (record === null) return null;
        }
    };
    _proto.setLinkedRecordIDs = function setLinkedRecordIDs(dataID, storageKey, linkedIDs) {
        var sinkRecord = this._getSinkRecord(dataID);
        $6ZixS.setLinkedRecordIDs(sinkRecord, storageKey, linkedIDs);
    };
    return RelayRecordSourceMutator;
}();
module.exports = $0b8f4cb6ae43dbd3$var$RelayRecordSourceMutator;

});

parcelRegister("8yw4N", function(module, exports) {
'use strict';

var $6ZixS = parcelRequire("6ZixS");

var $2O63w = parcelRequire("2O63w");
var $63aa61630675b53b$var$EXISTENT = $2O63w.EXISTENT, $63aa61630675b53b$var$NONEXISTENT = $2O63w.NONEXISTENT;

var $cvcC4 = parcelRequire("cvcC4");
var $63aa61630675b53b$var$ROOT_ID = $cvcC4.ROOT_ID, $63aa61630675b53b$var$ROOT_TYPE = $cvcC4.ROOT_TYPE;

var $1yI9z = parcelRequire("1yI9z");
var $63aa61630675b53b$var$_readUpdatableFragment = $1yI9z.readUpdatableFragment;

var $g5U5y = parcelRequire("g5U5y");
var $63aa61630675b53b$var$_readUpdatableQuery = $g5U5y.readUpdatableQuery;

var $aI7SA = parcelRequire("aI7SA");

var $jwy7p = parcelRequire("jwy7p");
var $63aa61630675b53b$var$RelayRecordSourceProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceProxy(mutator, getDataID, handlerProvider, missingFieldHandlers, log) {
        this.__mutator = mutator;
        this._handlerProvider = handlerProvider || null;
        this._proxies = {};
        this._getDataID = getDataID;
        this._invalidatedStore = false;
        this._idsMarkedForInvalidation = new Set();
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log !== null && log !== void 0 ? log : function(LogEvent) {};
    }
    var _proto = RelayRecordSourceProxy.prototype;
    _proto.publishSource = function publishSource(source, fieldPayloads) {
        var _this = this;
        var dataIDs = source.getRecordIDs();
        dataIDs.forEach(function(dataID) {
            var status = source.getStatus(dataID);
            if (status === $63aa61630675b53b$var$EXISTENT) {
                var sourceRecord = source.get(dataID);
                if (sourceRecord) {
                    if (_this.__mutator.getStatus(dataID) !== $63aa61630675b53b$var$EXISTENT) _this.create(dataID, $6ZixS.getType(sourceRecord));
                    _this.__mutator.copyFieldsFromRecord(sourceRecord, dataID);
                }
            } else if (status === $63aa61630675b53b$var$NONEXISTENT) _this["delete"](dataID);
        });
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $jwy7p(false);
            handler.update(_this, fieldPayload);
        });
    };
    _proto.create = function create(dataID, typeName) {
        this.__mutator.create(dataID, typeName);
        delete this._proxies[dataID];
        var record = this.get(dataID);
        !record && $jwy7p(false);
        return record;
    };
    _proto["delete"] = function _delete(dataID) {
        !(dataID !== $63aa61630675b53b$var$ROOT_ID) && $jwy7p(false);
        delete this._proxies[dataID];
        this.__mutator["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        if (!this._proxies.hasOwnProperty(dataID)) {
            var status = this.__mutator.getStatus(dataID);
            if (status === $63aa61630675b53b$var$EXISTENT) this._proxies[dataID] = new $aI7SA(this, this.__mutator, dataID);
            else this._proxies[dataID] = status === $63aa61630675b53b$var$NONEXISTENT ? null : undefined;
        }
        return this._proxies[dataID];
    };
    _proto.getRoot = function getRoot() {
        var root = this.get($63aa61630675b53b$var$ROOT_ID);
        if (!root) root = this.create($63aa61630675b53b$var$ROOT_ID, $63aa61630675b53b$var$ROOT_TYPE);
        !(root && root.getType() === $63aa61630675b53b$var$ROOT_TYPE) && $jwy7p(false);
        return root;
    };
    _proto.invalidateStore = function invalidateStore() {
        this._invalidatedStore = true;
    };
    _proto.isStoreMarkedForInvalidation = function isStoreMarkedForInvalidation() {
        return this._invalidatedStore;
    };
    _proto.markIDForInvalidation = function markIDForInvalidation(dataID) {
        this._idsMarkedForInvalidation.add(dataID);
    };
    _proto.getIDsMarkedForInvalidation = function getIDsMarkedForInvalidation() {
        return this._idsMarkedForInvalidation;
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $63aa61630675b53b$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $63aa61630675b53b$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceProxy;
}();
module.exports = $63aa61630675b53b$var$RelayRecordSourceProxy;

});
parcelRegister("1yI9z", function(module, exports) {
'use strict';

var $lQR7T = parcelRequire("lQR7T");
var $122b3758205bf0f5$var$getFragment = $lQR7T.getFragment;

var $dPVEr = parcelRequire("dPVEr");
var $122b3758205bf0f5$var$getVariablesFromFragment = $dPVEr.getVariablesFromFragment;

var $cvcC4 = parcelRequire("cvcC4");
var $122b3758205bf0f5$var$ID_KEY = $cvcC4.ID_KEY;

var $3OiYu = parcelRequire("3OiYu");
var $122b3758205bf0f5$var$createUpdatableProxy = $3OiYu.createUpdatableProxy;

var $jwy7p = parcelRequire("jwy7p");
function $122b3758205bf0f5$var$readUpdatableFragment(fragment, fragmentReference, proxy, missingFieldHandlers) {
    var updatableFragment = $122b3758205bf0f5$var$getFragment(fragment);
    var fragmentVariables = $122b3758205bf0f5$var$getVariablesFromFragment(updatableFragment, fragmentReference);
    var id = fragmentReference[$122b3758205bf0f5$var$ID_KEY];
    var fragmentRoot = proxy.get(id);
    !(fragmentRoot != null) && $jwy7p(false);
    return {
        updatableData: $122b3758205bf0f5$var$createUpdatableProxy(fragmentRoot, fragmentVariables, updatableFragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableFragment: $122b3758205bf0f5$var$readUpdatableFragment
};

});
parcelRegister("3OiYu", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $2c64c29137f84997$var$_interopRequireDefault = $8gviu.default;

var $2c64c29137f84997$var$_createForOfIteratorHelper2 = $2c64c29137f84997$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $cvcC4 = parcelRequire("cvcC4");
var $2c64c29137f84997$var$getArgumentValues = $cvcC4.getArgumentValues;
var $2c64c29137f84997$var$nonUpdatableKeys = [
    'id',
    '__id',
    '__typename',
    'js'
];
function $2c64c29137f84997$var$createUpdatableProxy(updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var mutableUpdatableProxy = {};
    $2c64c29137f84997$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers);
    return mutableUpdatableProxy;
}
function $2c64c29137f84997$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selections, recordSourceProxy, missingFieldHandlers) {
    var _selection$alias3;
    var _iterator = (0, $2c64c29137f84997$var$_createForOfIteratorHelper2["default"])(selections), _step;
    try {
        var _loop = function _loop() {
            var selection = _step.value;
            switch(selection.kind){
                case 'LinkedField':
                    if (selection.plural) Object.defineProperty(mutableUpdatableProxy, (_selection$alias = selection.alias) !== null && _selection$alias !== void 0 ? _selection$alias : selection.name, {
                        get: $2c64c29137f84997$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $2c64c29137f84997$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    else Object.defineProperty(mutableUpdatableProxy, (_selection$alias2 = selection.alias) !== null && _selection$alias2 !== void 0 ? _selection$alias2 : selection.name, {
                        get: $2c64c29137f84997$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers),
                        set: $2c64c29137f84997$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy)
                    });
                    break;
                case 'ScalarField':
                    var scalarFieldName = (_selection$alias3 = selection.alias) !== null && _selection$alias3 !== void 0 ? _selection$alias3 : selection.name;
                    Object.defineProperty(mutableUpdatableProxy, scalarFieldName, {
                        get: function get() {
                            var _selection$args;
                            var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args = selection.args) !== null && _selection$args !== void 0 ? _selection$args : [], variables);
                            var value = updatableProxyRootRecord.getValue(selection.name, newVariables);
                            if (value == null) value = $2c64c29137f84997$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
                            return value;
                        },
                        set: $2c64c29137f84997$var$nonUpdatableKeys.includes(selection.name) ? undefined : function(newValue) {
                            var _selection$args2;
                            var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args2 = selection.args) !== null && _selection$args2 !== void 0 ? _selection$args2 : [], variables);
                            updatableProxyRootRecord.setValue__UNSAFE(newValue, selection.name, newVariables);
                        }
                    });
                    break;
                case 'InlineFragment':
                    if (updatableProxyRootRecord.getType() === selection.type) $2c64c29137f84997$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'ClientExtension':
                    $2c64c29137f84997$var$updateProxyFromSelections(mutableUpdatableProxy, updatableProxyRootRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                    break;
                case 'FragmentSpread':
                    break;
                case 'Condition':
                case 'ActorChange':
                case 'InlineDataFragmentSpread':
                case 'AliasedInlineFragmentSpread':
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                case 'Defer':
                case 'ModuleImport':
                case 'RequiredField':
                case 'CatchField':
                case 'Stream':
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
                default:
                    selection.kind;
                    throw new Error('Encountered an unexpected ReaderSelection variant in RelayRecordSourceProxy. This indicates a bug in Relay.');
            }
        };
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var _selection$alias;
            var _selection$alias2;
            _loop();
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
}
function $2c64c29137f84997$var$createSetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args3;
        var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args3 = selection.args) !== null && _selection$args3 !== void 0 ? _selection$args3 : [], variables);
        if (newValue == null) throw new Error('Do not assign null to plural linked fields; assign an empty array instead.');
        else {
            var recordProxies = newValue.map(function(item) {
                if (item == null) throw new Error('When assigning an array of items, none of the items should be null or undefined.');
                var __id = item.__id;
                if (__id == null) throw new Error('The __id field must be present on each item passed to the setter. This indicates a bug in Relay.');
                var newValueRecord = recordSourceProxy.get(__id);
                if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
                return newValueRecord;
            });
            updatableProxyRootRecord.setLinkedRecords(recordProxies, selection.name, newVariables);
        }
    };
}
function $2c64c29137f84997$var$createSetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy) {
    return function set(newValue) {
        var _selection$args4;
        var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args4 = selection.args) !== null && _selection$args4 !== void 0 ? _selection$args4 : [], variables);
        if (newValue == null) updatableProxyRootRecord.setValue(newValue, selection.name, newVariables);
        else {
            var __id = newValue.__id;
            if (__id == null) throw new Error('The __id field must be present on the argument. This indicates a bug in Relay.');
            var newValueRecord = recordSourceProxy.get(__id);
            if (newValueRecord == null) throw new Error("Did not find item with data id ".concat(__id, " in the store."));
            updatableProxyRootRecord.setLinkedRecord(newValueRecord, selection.name, newVariables);
        }
    };
}
function $2c64c29137f84997$var$createGetterForPluralLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args5;
        var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args5 = selection.args) !== null && _selection$args5 !== void 0 ? _selection$args5 : [], variables);
        var linkedRecords = updatableProxyRootRecord.getLinkedRecords(selection.name, newVariables);
        if (linkedRecords === undefined) linkedRecords = $2c64c29137f84997$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecords != null) return linkedRecords.map(function(linkedRecord) {
            if (linkedRecord != null) {
                var updatableProxy = {};
                $2c64c29137f84997$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
                return updatableProxy;
            } else return linkedRecord;
        });
        else return linkedRecords;
    };
}
function $2c64c29137f84997$var$createGetterForSingularLinkedField(selection, variables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    return function() {
        var _selection$args6;
        var newVariables = $2c64c29137f84997$var$getArgumentValues((_selection$args6 = selection.args) !== null && _selection$args6 !== void 0 ? _selection$args6 : [], variables);
        var linkedRecord = updatableProxyRootRecord.getLinkedRecord(selection.name, newVariables);
        if (linkedRecord === undefined) linkedRecord = $2c64c29137f84997$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers);
        if (linkedRecord != null) {
            var updatableProxy = {};
            $2c64c29137f84997$var$updateProxyFromSelections(updatableProxy, linkedRecord, variables, selection.selections, recordSourceProxy, missingFieldHandlers);
            return updatableProxy;
        } else return linkedRecord;
    };
}
function $2c64c29137f84997$var$getLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator2 = (0, $2c64c29137f84997$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step2;
    try {
        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
            var handler = _step2.value;
            if (handler.kind === 'linked') {
                var newId = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newId != null) return recordSourceProxy.get(newId);
            }
        }
    } catch (err) {
        _iterator2.e(err);
    } finally{
        _iterator2.f();
    }
}
function $2c64c29137f84997$var$getPluralLinkedRecordUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator3 = (0, $2c64c29137f84997$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step3;
    try {
        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
            var handler = _step3.value;
            if (handler.kind === 'pluralLinked') {
                var newIds = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (newIds != null) return newIds.map(function(newId) {
                    if (newId != null) return recordSourceProxy.get(newId);
                });
            }
        }
    } catch (err) {
        _iterator3.e(err);
    } finally{
        _iterator3.f();
    }
}
function $2c64c29137f84997$var$getScalarUsingMissingFieldHandlers(selection, newVariables, updatableProxyRootRecord, recordSourceProxy, missingFieldHandlers) {
    var _iterator4 = (0, $2c64c29137f84997$var$_createForOfIteratorHelper2["default"])(missingFieldHandlers), _step4;
    try {
        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
            var handler = _step4.value;
            if (handler.kind === 'scalar') {
                var value = handler.handle(selection, updatableProxyRootRecord, newVariables, recordSourceProxy);
                if (value !== undefined) return value;
            }
        }
    } catch (err) {
        _iterator4.e(err);
    } finally{
        _iterator4.f();
    }
}
module.exports = {
    createUpdatableProxy: $2c64c29137f84997$var$createUpdatableProxy
};

});


parcelRegister("g5U5y", function(module, exports) {
'use strict';

var $lQR7T = parcelRequire("lQR7T");
var $bb789f0328e3db16$var$getUpdatableQuery = $lQR7T.getUpdatableQuery;

var $3OiYu = parcelRequire("3OiYu");
var $bb789f0328e3db16$var$createUpdatableProxy = $3OiYu.createUpdatableProxy;
function $bb789f0328e3db16$var$readUpdatableQuery(query, variables, proxy, missingFieldHandlers) {
    var updatableQuery = $bb789f0328e3db16$var$getUpdatableQuery(query);
    return {
        updatableData: $bb789f0328e3db16$var$createUpdatableProxy(proxy.getRoot(), variables, updatableQuery.fragment.selections, proxy, missingFieldHandlers)
    };
}
module.exports = {
    readUpdatableQuery: $bb789f0328e3db16$var$readUpdatableQuery
};

});

parcelRegister("aI7SA", function(module, exports) {
'use strict';

var $9eVAj = parcelRequire("9eVAj");
var $7cc4201d9725e599$var$generateClientID = $9eVAj.generateClientID;

var $cvcC4 = parcelRequire("cvcC4");
var $7cc4201d9725e599$var$getStableStorageKey = $cvcC4.getStableStorageKey;

var $jwy7p = parcelRequire("jwy7p");
var $7cc4201d9725e599$var$RelayRecordProxy = /*#__PURE__*/ function() {
    function RelayRecordProxy(source, mutator, dataID) {
        this._dataID = dataID;
        this._mutator = mutator;
        this._source = source;
    }
    var _proto = RelayRecordProxy.prototype;
    _proto.copyFieldsFrom = function copyFieldsFrom(source) {
        this._mutator.copyFields(source.getDataID(), this._dataID);
    };
    _proto.getDataID = function getDataID() {
        return this._dataID;
    };
    _proto.getType = function getType() {
        var type = this._mutator.getType(this._dataID);
        !(type != null) && $jwy7p(false);
        return type;
    };
    _proto.getValue = function getValue(name, args) {
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        return this._mutator.getValue(this._dataID, storageKey);
    };
    _proto.setValue = function setValue(value, name, args, errors) {
        !$7cc4201d9725e599$var$isValidLeafValue(value) && $jwy7p(false);
        return this.setValue__UNSAFE(value, name, args, errors);
    };
    _proto.getErrors = function getErrors(name, args) {
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        return this._mutator.getErrors(this._dataID, storageKey);
    };
    _proto.setValue__UNSAFE = function setValue__UNSAFE(value, name, args, errors) {
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        this._mutator.setValue(this._dataID, storageKey, value);
        if (errors != null) {
            if (errors.length === 0) this._mutator.setErrors(this._dataID, storageKey);
            else this._mutator.setErrors(this._dataID, storageKey, errors);
        }
        return this;
    };
    _proto.getLinkedRecord = function getLinkedRecord(name, args) {
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        var linkedID = this._mutator.getLinkedRecordID(this._dataID, storageKey);
        return linkedID != null ? this._source.get(linkedID) : linkedID;
    };
    _proto.setLinkedRecord = function setLinkedRecord(record, name, args) {
        !(record instanceof RelayRecordProxy) && $jwy7p(false);
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        var linkedID = record.getDataID();
        this._mutator.setLinkedRecordID(this._dataID, storageKey, linkedID);
        return this;
    };
    _proto.getOrCreateLinkedRecord = function getOrCreateLinkedRecord(name, typeName, args) {
        var linkedRecord = this.getLinkedRecord(name, args);
        if (!linkedRecord) {
            var _this$_source$get;
            var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
            var clientID = $7cc4201d9725e599$var$generateClientID(this.getDataID(), storageKey);
            linkedRecord = (_this$_source$get = this._source.get(clientID)) !== null && _this$_source$get !== void 0 ? _this$_source$get : this._source.create(clientID, typeName);
            this.setLinkedRecord(linkedRecord, name, args);
        }
        return linkedRecord;
    };
    _proto.getLinkedRecords = function getLinkedRecords(name, args) {
        var _this = this;
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        var linkedIDs = this._mutator.getLinkedRecordIDs(this._dataID, storageKey);
        if (linkedIDs == null) return linkedIDs;
        return linkedIDs.map(function(linkedID) {
            return linkedID != null ? _this._source.get(linkedID) : linkedID;
        });
    };
    _proto.setLinkedRecords = function setLinkedRecords(records, name, args) {
        !Array.isArray(records) && $jwy7p(false);
        var storageKey = $7cc4201d9725e599$var$getStableStorageKey(name, args);
        var linkedIDs = records.map(function(record) {
            return record && record.getDataID();
        });
        this._mutator.setLinkedRecordIDs(this._dataID, storageKey, linkedIDs);
        return this;
    };
    _proto.invalidateRecord = function invalidateRecord() {
        this._source.markIDForInvalidation(this._dataID);
    };
    return RelayRecordProxy;
}();
function $7cc4201d9725e599$var$isValidLeafValue(value) {
    return value == null || typeof value !== 'object' || Array.isArray(value) && value.every($7cc4201d9725e599$var$isValidLeafValue);
}
module.exports = $7cc4201d9725e599$var$RelayRecordProxy;

});


parcelRegister("hacyv", function(module, exports) {
'use strict';

var $2HvH8 = parcelRequire("2HvH8");
var $c7ed1c202cc914a6$var$LINKED_FIELD = $2HvH8.LINKED_FIELD;

var $cvcC4 = parcelRequire("cvcC4");
var $c7ed1c202cc914a6$var$getHandleStorageKey = $cvcC4.getHandleStorageKey;

var $3UWLk = parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
function $c7ed1c202cc914a6$var$cloneRelayHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $c7ed1c202cc914a6$var$LINKED_FIELD && source.name === handleField.name && source.alias === handleField.alias && $3UWLk(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $c7ed1c202cc914a6$var$LINKED_FIELD) && $jwy7p(false);
    var handleKey = $c7ed1c202cc914a6$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'LinkedField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null,
        concreteType: sourceField.concreteType,
        plural: sourceField.plural,
        selections: sourceField.selections
    };
}
module.exports = $c7ed1c202cc914a6$var$cloneRelayHandleSourceField;

});

parcelRegister("5fb4u", function(module, exports) {
'use strict';

var $2HvH8 = parcelRequire("2HvH8");
var $3d16f10591cf3405$var$SCALAR_FIELD = $2HvH8.SCALAR_FIELD;

var $cvcC4 = parcelRequire("cvcC4");
var $3d16f10591cf3405$var$getHandleStorageKey = $cvcC4.getHandleStorageKey;

var $3UWLk = parcelRequire("3UWLk");

var $jwy7p = parcelRequire("jwy7p");
function $3d16f10591cf3405$var$cloneRelayScalarHandleSourceField(handleField, selections, variables) {
    var sourceField = selections.find(function(source) {
        return source.kind === $3d16f10591cf3405$var$SCALAR_FIELD && source.name === handleField.name && source.alias === handleField.alias && $3UWLk(source.args, handleField.args);
    });
    !(sourceField && sourceField.kind === $3d16f10591cf3405$var$SCALAR_FIELD) && $jwy7p(false);
    var handleKey = $3d16f10591cf3405$var$getHandleStorageKey(handleField, variables);
    return {
        kind: 'ScalarField',
        alias: sourceField.alias,
        name: handleKey,
        storageKey: handleKey,
        args: null
    };
}
module.exports = $3d16f10591cf3405$var$cloneRelayScalarHandleSourceField;

});


parcelRegister("5tmf5", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $3fc0ea0c0128cb7c$var$_interopRequireDefault = $8gviu.default;

var $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2 = $3fc0ea0c0128cb7c$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $fT9vU = parcelRequire("fT9vU");

var $2HvH8 = parcelRequire("2HvH8");
var $3fc0ea0c0128cb7c$var$RELAY_LIVE_RESOLVER = $2HvH8.RELAY_LIVE_RESOLVER;

var $kgraI = parcelRequire("kgraI");

var $lLfW5 = parcelRequire("lLfW5");

var $9eVAj = parcelRequire("9eVAj");
var $3fc0ea0c0128cb7c$var$generateClientID = $9eVAj.generateClientID, $3fc0ea0c0128cb7c$var$generateClientObjectClientID = $9eVAj.generateClientObjectClientID;

var $6ZixS = parcelRequire("6ZixS");

var $dPVEr = parcelRequire("dPVEr");
var $3fc0ea0c0128cb7c$var$createNormalizationSelector = $dPVEr.createNormalizationSelector;

var $gqyVK = parcelRequire("gqyVK");

var $7TuZT = parcelRequire("7TuZT");
var $3fc0ea0c0128cb7c$var$normalize = $7TuZT.normalize;

var $cvcC4 = parcelRequire("cvcC4");
var $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_ERROR_KEY = $cvcC4.RELAY_RESOLVER_ERROR_KEY, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_INVALIDATION_KEY = $cvcC4.RELAY_RESOLVER_INVALIDATION_KEY, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $cvcC4.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_SNAPSHOT_KEY = $cvcC4.RELAY_RESOLVER_SNAPSHOT_KEY, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_VALUE_KEY = $cvcC4.RELAY_RESOLVER_VALUE_KEY, $3fc0ea0c0128cb7c$var$getReadTimeResolverStorageKey = $cvcC4.getReadTimeResolverStorageKey, $3fc0ea0c0128cb7c$var$getStorageKey = $cvcC4.getStorageKey;

var $j87z1 = parcelRequire("j87z1");

var $iw1BP = parcelRequire("iw1BP");

var $1ocpj = parcelRequire("1ocpj");
var $3fc0ea0c0128cb7c$var$isSuspenseSentinel = $1ocpj.isSuspenseSentinel;

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
var $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY = '__resolverLiveStateSubscription';
var $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_VALUE = '__resolverLiveStateValue';
var $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY = '__resolverLiveStateDirty';
var $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_RECORD_TYPENAME = '__RELAY_RESOLVER__';
var $3fc0ea0c0128cb7c$var$MODEL_PROPERTY_NAME = '__relay_model_instance';
function $3fc0ea0c0128cb7c$var$addDependencyEdge(edges, from, to) {
    var set = edges.get(from);
    if (!set) {
        set = new Set();
        edges.set(from, set);
    }
    set.add(to);
}
var $3fc0ea0c0128cb7c$var$LiveResolverCache = /*#__PURE__*/ function() {
    function LiveResolverCache(getRecordSource, store) {
        this._resolverIDToRecordIDs = new Map();
        this._recordIDToResolverIDs = new Map();
        this._getRecordSource = getRecordSource;
        this._store = store;
        this._handlingBatch = false;
        this._liveResolverBatchRecordSource = null;
    }
    var _proto = LiveResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        var recordSource = this._getRecordSource();
        var record = $3fc0ea0c0128cb7c$var$expectRecord(recordSource, recordID);
        var storageKey = $3fc0ea0c0128cb7c$var$getReadTimeResolverStorageKey(field, variables);
        var linkedID = $6ZixS.getLinkedRecordID(record, storageKey);
        var linkedRecord = linkedID == null ? null : recordSource.get(linkedID);
        var updatedDataIDs;
        if (linkedRecord == null || this._isInvalid(linkedRecord, getDataForResolverFragment)) {
            var _linkedID;
            if (linkedRecord != null) $3fc0ea0c0128cb7c$var$maybeUnsubscribeFromLiveState(linkedRecord);
            linkedID = (_linkedID = linkedID) !== null && _linkedID !== void 0 ? _linkedID : $3fc0ea0c0128cb7c$var$generateClientID(recordID, storageKey);
            linkedRecord = $6ZixS.create(linkedID, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_RECORD_TYPENAME);
            var evaluationResult = evaluate();
            $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_SNAPSHOT_KEY, evaluationResult.snapshot);
            $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_ERROR_KEY, evaluationResult.error);
            if (field.kind === $3fc0ea0c0128cb7c$var$RELAY_LIVE_RESOLVER) {
                if (evaluationResult.resolverResult != null) {
                    !(evaluationResult.error == null) && $jwy7p(false);
                    var liveState = evaluationResult.resolverResult;
                    updatedDataIDs = this._setLiveStateValue(linkedRecord, linkedID, liveState, field, variables);
                } else var _evaluationResult$sna;
            } else updatedDataIDs = this._setResolverValue(linkedRecord, evaluationResult.resolverResult, field, variables);
            recordSource.set(linkedID, linkedRecord);
            var currentRecord = $3fc0ea0c0128cb7c$var$expectRecord(recordSource, recordID);
            var nextRecord = $6ZixS.clone(currentRecord);
            $6ZixS.setLinkedRecordID(nextRecord, storageKey, linkedID);
            recordSource.set(recordID, nextRecord);
            if (field.fragment != null) {
                var _evaluationResult$sna2;
                var fragmentStorageKey = $3fc0ea0c0128cb7c$var$getStorageKey(field.fragment, variables);
                var resolverID = $3fc0ea0c0128cb7c$var$generateClientID(recordID, fragmentStorageKey);
                $3fc0ea0c0128cb7c$var$addDependencyEdge(this._resolverIDToRecordIDs, resolverID, linkedID);
                $3fc0ea0c0128cb7c$var$addDependencyEdge(this._recordIDToResolverIDs, recordID, resolverID);
                var seenRecordIds = (_evaluationResult$sna2 = evaluationResult.snapshot) === null || _evaluationResult$sna2 === void 0 ? void 0 : _evaluationResult$sna2.seenRecords;
                if (seenRecordIds != null) {
                    var _iterator = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(seenRecordIds), _step;
                    try {
                        for(_iterator.s(); !(_step = _iterator.n()).done;){
                            var seenRecordID = _step.value;
                            $3fc0ea0c0128cb7c$var$addDependencyEdge(this._recordIDToResolverIDs, seenRecordID, resolverID);
                        }
                    } catch (err) {
                        _iterator.e(err);
                    } finally{
                        _iterator.f();
                    }
                }
            }
        } else if (field.kind === $3fc0ea0c0128cb7c$var$RELAY_LIVE_RESOLVER && $6ZixS.getValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY)) {
            var _linkedID2;
            linkedID = (_linkedID2 = linkedID) !== null && _linkedID2 !== void 0 ? _linkedID2 : $3fc0ea0c0128cb7c$var$generateClientID(recordID, storageKey);
            linkedRecord = $6ZixS.clone(linkedRecord);
            var _liveState = $6ZixS.getValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
            if (!$iw1BP(_liveState)) $jwy7p(false);
            updatedDataIDs = this._setLiveResolverValue(linkedRecord, _liveState, field, variables);
            $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
            recordSource.set(linkedID, linkedRecord);
        }
        var answer = this._getResolverValue(linkedRecord);
        var snapshot = $6ZixS.getValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var error = $6ZixS.getValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_ERROR_KEY);
        var suspenseID = null;
        if ($3fc0ea0c0128cb7c$var$isSuspenseSentinel(answer)) {
            var _linkedID3;
            suspenseID = (_linkedID3 = linkedID) !== null && _linkedID3 !== void 0 ? _linkedID3 : $3fc0ea0c0128cb7c$var$generateClientID(recordID, storageKey);
        }
        return [
            answer,
            linkedID,
            error,
            snapshot,
            suspenseID,
            updatedDataIDs
        ];
    };
    _proto.getLiveResolverPromise = function getLiveResolverPromise(liveStateID) {
        var recordSource = this._getRecordSource();
        var liveStateRecord = recordSource.get(liveStateID);
        !(liveStateRecord != null) && $jwy7p(false);
        var liveState = $6ZixS.getValue(liveStateRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_VALUE);
        return new Promise(function(resolve) {
            var unsubscribe = liveState.subscribe(function() {
                unsubscribe();
                resolve();
            });
        });
    };
    _proto._setLiveStateValue = function _setLiveStateValue(linkedRecord, linkedID, liveState, field, variables) {
        var handler = this._makeLiveStateHandler(linkedID);
        var unsubscribe = liveState.subscribe(handler);
        $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_VALUE, liveState);
        var updatedDataIDs = this._setLiveResolverValue(linkedRecord, liveState, field, variables);
        $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, false);
        $6ZixS.setValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY, unsubscribe);
        return updatedDataIDs;
    };
    _proto._makeLiveStateHandler = function _makeLiveStateHandler(linkedID) {
        var _this = this;
        return function() {
            var currentSource = _this._getRecordSource();
            var currentRecord = currentSource.get(linkedID);
            if (!currentRecord) return;
            if (!$6ZixS.hasValue(currentRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_VALUE)) return;
            var nextRecord = $6ZixS.clone(currentRecord);
            $6ZixS.setValue(nextRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_DIRTY, true);
            _this._setLiveResolverUpdate(linkedID, nextRecord);
        };
    };
    _proto._setLiveResolverUpdate = function _setLiveResolverUpdate(linkedId, record) {
        if (this._handlingBatch) {
            if (this._liveResolverBatchRecordSource == null) this._liveResolverBatchRecordSource = $gqyVK.create();
            this._liveResolverBatchRecordSource.set(linkedId, record);
        } else {
            var nextSource = $gqyVK.create();
            nextSource.set(linkedId, record);
            this._store.publish(nextSource);
            this._store.notify();
        }
    };
    _proto.batchLiveStateUpdates = function batchLiveStateUpdates(callback) {
        !!this._handlingBatch && $jwy7p(false);
        this._handlingBatch = true;
        try {
            callback();
        } finally{
            if (this._liveResolverBatchRecordSource != null) {
                this._store.publish(this._liveResolverBatchRecordSource);
                this._store.notify();
            }
            this._liveResolverBatchRecordSource = null;
            this._handlingBatch = false;
        }
    };
    _proto._setLiveResolverValue = function _setLiveResolverValue(resolverRecord, liveValue, field, variables) {
        var value = null;
        var resolverError = null;
        try {
            value = liveValue.read();
        } catch (e) {
            resolverError = e;
        }
        $6ZixS.setValue(resolverRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_ERROR_KEY, resolverError);
        return this._setResolverValue(resolverRecord, value, field, variables);
    };
    _proto._setResolverValue = function _setResolverValue(resolverRecord, value, field, variables) {
        var normalizationInfo = field.normalizationInfo;
        var updatedDataIDs = null;
        if (value != null && normalizationInfo != null && !$3fc0ea0c0128cb7c$var$isSuspenseSentinel(value)) {
            var resolverValue;
            var prevOutputTypeRecordIDs = $j87z1(resolverRecord);
            var nextOutputTypeRecordIDs = new Set();
            var currentSource = this._getRecordSource();
            if (normalizationInfo.plural) {
                !Array.isArray(value) && $jwy7p(false);
                resolverValue = [];
                var nextSource = $gqyVK.create();
                for(var ii = 0; ii < value.length; ii++){
                    var currentValue = value[ii];
                    if (currentValue == null) continue;
                    !(typeof currentValue === 'object') && $jwy7p(false);
                    var typename = $3fc0ea0c0128cb7c$var$getConcreteTypename(normalizationInfo, currentValue);
                    var outputTypeDataID = $3fc0ea0c0128cb7c$var$generateClientObjectClientID(typename, $6ZixS.getDataID(resolverRecord), ii);
                    var source = this._normalizeOutputTypeValue(outputTypeDataID, currentValue, variables, normalizationInfo, [
                        field.path,
                        String(ii)
                    ], typename);
                    var _iterator2 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(source.getRecordIDs()), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var recordID = _step2.value;
                            nextSource.set(recordID, $3fc0ea0c0128cb7c$var$expectRecord(source, recordID));
                            nextOutputTypeRecordIDs.add(recordID);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    resolverValue.push(outputTypeDataID);
                }
                updatedDataIDs = $3fc0ea0c0128cb7c$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs);
            } else {
                !(typeof value === 'object') && $jwy7p(false);
                var _typename = $3fc0ea0c0128cb7c$var$getConcreteTypename(normalizationInfo, value);
                var _outputTypeDataID = $3fc0ea0c0128cb7c$var$generateClientObjectClientID(_typename, $6ZixS.getDataID(resolverRecord));
                var _nextSource = this._normalizeOutputTypeValue(_outputTypeDataID, value, variables, normalizationInfo, [
                    field.path
                ], _typename);
                var _iterator3 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(_nextSource.getRecordIDs()), _step3;
                try {
                    for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                        var _recordID = _step3.value;
                        nextOutputTypeRecordIDs.add(_recordID);
                    }
                } catch (err) {
                    _iterator3.e(err);
                } finally{
                    _iterator3.f();
                }
                resolverValue = _outputTypeDataID;
                updatedDataIDs = $3fc0ea0c0128cb7c$var$updateCurrentSource(currentSource, _nextSource, prevOutputTypeRecordIDs);
            }
            $6ZixS.setValue(resolverRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS, nextOutputTypeRecordIDs);
            $lLfW5(resolverValue);
            $6ZixS.setValue(resolverRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_VALUE_KEY, resolverValue);
        } else {
            $lLfW5(value);
            $6ZixS.setValue(resolverRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_VALUE_KEY, value);
        }
        return updatedDataIDs;
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {
        this._store.__notifyUpdatedSubscribers(updatedDataIDs);
    };
    _proto._getResolverValue = function _getResolverValue(resolverRecord) {
        return $6ZixS.getValue(resolverRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_VALUE_KEY);
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {
        var recordSource = this._getRecordSource();
        var visited = new Set();
        var recordsToVisit = Array.from(updatedDataIDs);
        while(recordsToVisit.length){
            var recordID = recordsToVisit.pop();
            visited.add(recordID);
            updatedDataIDs.add(recordID);
            var fragmentSet = this._recordIDToResolverIDs.get(recordID);
            if (fragmentSet == null) continue;
            var _iterator4 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(fragmentSet), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var fragment = _step4.value;
                    if (!visited.has(fragment)) {
                        visited.add(fragment);
                        var recordSet = this._resolverIDToRecordIDs.get(fragment);
                        if (recordSet == null) continue;
                        var _iterator5 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(recordSet), _step5;
                        try {
                            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                                var anotherRecordID = _step5.value;
                                $3fc0ea0c0128cb7c$var$markInvalidatedResolverRecord(anotherRecordID, recordSource);
                                if (!visited.has(anotherRecordID)) {
                                    visited.add(anotherRecordID);
                                    recordsToVisit.push(anotherRecordID);
                                }
                            }
                        } catch (err) {
                            _iterator5.e(err);
                        } finally{
                            _iterator5.f();
                        }
                    }
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    };
    _proto._isInvalid = function _isInvalid(record, getDataForResolverFragment) {
        if (!$6ZixS.getValue(record, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_INVALIDATION_KEY)) return false;
        var snapshot = $6ZixS.getValue(record, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_SNAPSHOT_KEY);
        var originalInputs = snapshot === null || snapshot === void 0 ? void 0 : snapshot.data;
        var readerSelector = snapshot === null || snapshot === void 0 ? void 0 : snapshot.selector;
        if (originalInputs == null || readerSelector == null) return true;
        var _getDataForResolverFr = getDataForResolverFragment(readerSelector), latestValues = _getDataForResolverFr.data;
        var recycled = $fT9vU(originalInputs, latestValues);
        if (recycled !== originalInputs) return true;
        if ($kgraI.MARK_RESOLVER_VALUES_AS_CLEAN_AFTER_FRAGMENT_REREAD) {
            var nextRecord = $6ZixS.clone(record);
            $6ZixS.setValue(nextRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_INVALIDATION_KEY, false);
            var recordSource = this._getRecordSource();
            recordSource.set($6ZixS.getDataID(record), nextRecord);
        }
        return false;
    };
    _proto._normalizeOutputTypeValue = function _normalizeOutputTypeValue(outputTypeDataID, value, variables, normalizationInfo, fieldPath, typename) {
        var source = $gqyVK.create();
        switch(normalizationInfo.kind){
            case 'OutputType':
                var record = $6ZixS.create(outputTypeDataID, typename);
                source.set(outputTypeDataID, record);
                var selector = $3fc0ea0c0128cb7c$var$createNormalizationSelector(normalizationInfo.normalizationNode, outputTypeDataID, variables);
                var useExecTimeResolvers = false;
                var normalizationOptions = this._store.__getNormalizationOptions(fieldPath);
                return $3fc0ea0c0128cb7c$var$normalize(source, selector, value, normalizationOptions, undefined, useExecTimeResolvers).source;
            case 'WeakModel':
                var _record = $6ZixS.create(outputTypeDataID, typename);
                $6ZixS.setValue(_record, $3fc0ea0c0128cb7c$var$MODEL_PROPERTY_NAME, value);
                source.set(outputTypeDataID, _record);
                return source;
            default:
                normalizationInfo.kind;
                $jwy7p(false);
        }
    };
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        var key = $3fc0ea0c0128cb7c$var$generateClientObjectClientID(typeName, id);
        var recordSource = this._getRecordSource();
        if (!recordSource.has(key)) {
            var newRecord = $6ZixS.create(key, typeName);
            $6ZixS.setValue(newRecord, 'id', id);
            recordSource.set(key, newRecord);
        }
        return key;
    };
    _proto.unsubscribeFromLiveResolverRecords = function unsubscribeFromLiveResolverRecords(invalidatedDataIDs) {
        return $3fc0ea0c0128cb7c$var$unsubscribeFromLiveResolverRecordsImpl(this._getRecordSource(), invalidatedDataIDs);
    };
    _proto.invalidateResolverRecords = function invalidateResolverRecords(invalidatedDataIDs) {
        if (invalidatedDataIDs.size === 0) return;
        var _iterator6 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step6;
        try {
            for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                var dataID = _step6.value;
                var record = this._getRecordSource().get(dataID);
                if (record != null && $3fc0ea0c0128cb7c$var$isResolverRecord(record)) this._getRecordSource()["delete"](dataID);
            }
        } catch (err) {
            _iterator6.e(err);
        } finally{
            _iterator6.f();
        }
    };
    return LiveResolverCache;
}();
function $3fc0ea0c0128cb7c$var$updateCurrentSource(currentSource, nextSource, prevOutputTypeRecordIDs) {
    var updatedDataIDs = new Set();
    if (prevOutputTypeRecordIDs != null) {
        var _iterator7 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(prevOutputTypeRecordIDs), _step7;
        try {
            for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                var recordID = _step7.value;
                if (!nextSource.has(recordID)) {
                    updatedDataIDs.add(recordID);
                    currentSource.remove(recordID);
                }
            }
        } catch (err) {
            _iterator7.e(err);
        } finally{
            _iterator7.f();
        }
    }
    var _iterator8 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(nextSource.getRecordIDs()), _step8;
    try {
        for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
            var _recordID2 = _step8.value;
            var nextRecord = $3fc0ea0c0128cb7c$var$expectRecord(nextSource, _recordID2);
            if (currentSource.has(_recordID2)) {
                var currentRecord = $3fc0ea0c0128cb7c$var$expectRecord(currentSource, _recordID2);
                var updatedRecord = $6ZixS.update(currentRecord, nextRecord);
                if (updatedRecord !== currentRecord) {
                    updatedDataIDs.add(_recordID2);
                    currentSource.set(_recordID2, updatedRecord);
                    $3fc0ea0c0128cb7c$var$markInvalidatedLinkedResolverRecords(currentRecord, currentSource);
                }
            } else currentSource.set(_recordID2, nextRecord);
        }
    } catch (err) {
        _iterator8.e(err);
    } finally{
        _iterator8.f();
    }
    return updatedDataIDs;
}
function $3fc0ea0c0128cb7c$var$getAllLinkedRecordIds(record) {
    var linkedRecordIDs = new Set();
    $6ZixS.getFields(record).forEach(function(field) {
        if ($6ZixS.hasLinkedRecordID(record, field)) {
            var linkedRecordID = $6ZixS.getLinkedRecordID(record, field);
            if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
        } else if ($6ZixS.hasLinkedRecordIDs(record, field)) {
            var _RelayModernRecord$ge;
            (_RelayModernRecord$ge = $6ZixS.getLinkedRecordIDs(record, field)) === null || _RelayModernRecord$ge === void 0 || _RelayModernRecord$ge.forEach(function(linkedRecordID) {
                if (linkedRecordID != null) linkedRecordIDs.add(linkedRecordID);
            });
        }
    });
    return linkedRecordIDs;
}
function $3fc0ea0c0128cb7c$var$markInvalidatedResolverRecord(dataID, recordSource) {
    var record = recordSource.get(dataID);
    if (!record) return;
    var nextRecord = $6ZixS.clone(record);
    $6ZixS.setValue(nextRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_INVALIDATION_KEY, true);
    recordSource.set(dataID, nextRecord);
}
function $3fc0ea0c0128cb7c$var$markInvalidatedLinkedResolverRecords(record, recordSource) {
    var currentLinkedDataIDs = $3fc0ea0c0128cb7c$var$getAllLinkedRecordIds(record);
    var _iterator9 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(currentLinkedDataIDs), _step9;
    try {
        for(_iterator9.s(); !(_step9 = _iterator9.n()).done;){
            var recordID = _step9.value;
            var _record2 = recordSource.get(recordID);
            if (_record2 != null && $3fc0ea0c0128cb7c$var$isResolverRecord(_record2)) $3fc0ea0c0128cb7c$var$markInvalidatedResolverRecord(recordID, recordSource);
        }
    } catch (err) {
        _iterator9.e(err);
    } finally{
        _iterator9.f();
    }
}
function $3fc0ea0c0128cb7c$var$unsubscribeFromLiveResolverRecordsImpl(recordSource, invalidatedDataIDs) {
    if (invalidatedDataIDs.size === 0) return;
    var _iterator10 = (0, $3fc0ea0c0128cb7c$var$_createForOfIteratorHelper2["default"])(invalidatedDataIDs), _step10;
    try {
        for(_iterator10.s(); !(_step10 = _iterator10.n()).done;){
            var dataID = _step10.value;
            var record = recordSource.get(dataID);
            if (record != null && $3fc0ea0c0128cb7c$var$isResolverRecord(record)) $3fc0ea0c0128cb7c$var$maybeUnsubscribeFromLiveState(record);
        }
    } catch (err) {
        _iterator10.e(err);
    } finally{
        _iterator10.f();
    }
}
function $3fc0ea0c0128cb7c$var$isResolverRecord(record) {
    return $6ZixS.getType(record) === $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_RECORD_TYPENAME;
}
function $3fc0ea0c0128cb7c$var$maybeUnsubscribeFromLiveState(linkedRecord) {
    var previousUnsubscribe = $6ZixS.getValue(linkedRecord, $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY);
    if (previousUnsubscribe != null) previousUnsubscribe();
}
function $3fc0ea0c0128cb7c$var$expectRecord(source, recordID) {
    var record = source.get(recordID);
    !(record != null) && $jwy7p(false);
    return record;
}
function $3fc0ea0c0128cb7c$var$getUpdatedDataIDs(updatedRecords) {
    return updatedRecords;
}
function $3fc0ea0c0128cb7c$var$getConcreteTypename(normalizationInfo, currentValue) {
    var _normalizationInfo$co;
    var typename = (_normalizationInfo$co = normalizationInfo.concreteType) !== null && _normalizationInfo$co !== void 0 ? _normalizationInfo$co : currentValue.__typename;
    !(typename != null) && $jwy7p(false);
    return typename;
}
module.exports = {
    LiveResolverCache: $3fc0ea0c0128cb7c$var$LiveResolverCache,
    getUpdatedDataIDs: $3fc0ea0c0128cb7c$var$getUpdatedDataIDs,
    RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY: $3fc0ea0c0128cb7c$var$RELAY_RESOLVER_LIVE_STATE_SUBSCRIPTION_KEY
};

});
parcelRegister("lLfW5", function(module, exports) {
'use strict';
module.exports = function shallowFreeze(value) {
    if (typeof value === 'object' && value != null && (Array.isArray(value) || value.constructor === Object)) Object.freeze(value);
};

});

parcelRegister("j87z1", function(module, exports) {
'use strict';

var $6ZixS = parcelRequire("6ZixS");

var $cvcC4 = parcelRequire("cvcC4");
var $ded4a1afdb0404d5$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS = $cvcC4.RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS;

var $jwy7p = parcelRequire("jwy7p");
function $ded4a1afdb0404d5$var$getOutputTypeRecordIDs(record) {
    var maybeOutputTypeRecordIDs = $6ZixS.getValue(record, $ded4a1afdb0404d5$var$RELAY_RESOLVER_OUTPUT_TYPE_RECORD_IDS);
    if (maybeOutputTypeRecordIDs == null) return null;
    !(maybeOutputTypeRecordIDs instanceof Set) && $jwy7p(false);
    return maybeOutputTypeRecordIDs;
}
module.exports = $ded4a1afdb0404d5$var$getOutputTypeRecordIDs;

});

parcelRegister("iw1BP", function(module, exports) {
'use strict';
function $d7ac76b458349f3e$var$isLiveStateValue(v) {
    return v != null && typeof v === 'object' && typeof v.read === 'function' && typeof v.subscribe === 'function';
}
module.exports = $d7ac76b458349f3e$var$isLiveStateValue;

});


parcelRegister("kXH49", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $f42ab954517d45ea$var$_interopRequireDefault = $8gviu.default;

var $f42ab954517d45ea$var$_objectSpread2 = $f42ab954517d45ea$var$_interopRequireDefault((parcelRequire("lhogL")));

var $6ZixS = parcelRequire("6ZixS");

var $gqyVK = parcelRequire("gqyVK");

var $jwy7p = parcelRequire("jwy7p");
var $f42ab954517d45ea$var$UNPUBLISH_RECORD_SENTINEL = $6ZixS.fromObject(Object.freeze({
    __UNPUBLISH_RECORD_SENTINEL: true
}));
var $f42ab954517d45ea$var$RelayOptimisticRecordSource = /*#__PURE__*/ function() {
    function RelayOptimisticRecordSource(base) {
        this._base = base;
        this._sink = $gqyVK.create();
    }
    var _proto = RelayOptimisticRecordSource.prototype;
    _proto.has = function has(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            return sinkRecord !== $f42ab954517d45ea$var$UNPUBLISH_RECORD_SENTINEL;
        } else return this._base.has(dataID);
    };
    _proto.get = function get(dataID) {
        if (this._sink.has(dataID)) {
            var sinkRecord = this._sink.get(dataID);
            if (sinkRecord === $f42ab954517d45ea$var$UNPUBLISH_RECORD_SENTINEL) return undefined;
            else return sinkRecord;
        } else return this._base.get(dataID);
    };
    _proto.getStatus = function getStatus(dataID) {
        var record = this.get(dataID);
        if (record === undefined) return 'UNKNOWN';
        else if (record === null) return 'NONEXISTENT';
        else return 'EXISTENT';
    };
    _proto.clear = function clear() {
        this._base = $gqyVK.create();
        this._sink.clear();
    };
    _proto["delete"] = function _delete(dataID) {
        this._sink["delete"](dataID);
    };
    _proto.remove = function remove(dataID) {
        this._sink.set(dataID, $f42ab954517d45ea$var$UNPUBLISH_RECORD_SENTINEL);
    };
    _proto.set = function set(dataID, record) {
        this._sink.set(dataID, record);
    };
    _proto.getRecordIDs = function getRecordIDs() {
        return Object.keys(this.toJSON());
    };
    _proto.size = function size() {
        return Object.keys(this.toJSON()).length;
    };
    _proto.toJSON = function toJSON() {
        var _this = this;
        var merged = (0, $f42ab954517d45ea$var$_objectSpread2["default"])({}, this._base.toJSON());
        this._sink.getRecordIDs().forEach(function(dataID) {
            var record = _this.get(dataID);
            if (record === undefined) delete merged[dataID];
            else merged[dataID] = $6ZixS.toJSON(record);
        });
        return merged;
    };
    _proto.getOptimisticRecordIDs = function getOptimisticRecordIDs() {
        return new Set(this._sink.getRecordIDs());
    };
    return RelayOptimisticRecordSource;
}();
function $f42ab954517d45ea$var$create(base) {
    return new $f42ab954517d45ea$var$RelayOptimisticRecordSource(base);
}
function $f42ab954517d45ea$var$getOptimisticRecordIDs(source) {
    !(source instanceof $f42ab954517d45ea$var$RelayOptimisticRecordSource) && $jwy7p(false);
    return source.getOptimisticRecordIDs();
}
module.exports = {
    create: $f42ab954517d45ea$var$create,
    getOptimisticRecordIDs: $f42ab954517d45ea$var$getOptimisticRecordIDs
};

});

parcelRegister("echTe", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $a560103470afa70e$var$_interopRequireDefault = $8gviu.default;

var $a560103470afa70e$var$_objectSpread2 = $a560103470afa70e$var$_interopRequireDefault((parcelRequire("lhogL")));

var $a560103470afa70e$var$_defineProperty2 = $a560103470afa70e$var$_interopRequireDefault((parcelRequire("dangC")));

var $a560103470afa70e$var$_objectWithoutPropertiesLoose2 = $a560103470afa70e$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $a560103470afa70e$var$_toConsumableArray2 = $a560103470afa70e$var$_interopRequireDefault((parcelRequire("b0RMC")));
var $a560103470afa70e$var$_excluded = [
    "message"
];

var $kgraI = parcelRequire("kgraI");

var $1ocpj = parcelRequire("1ocpj");
var $a560103470afa70e$var$isSuspenseSentinel = $1ocpj.isSuspenseSentinel;

var $cbsiZ = parcelRequire("cbsiZ");

var $6ZixS = parcelRequire("6ZixS");

var $cvcC4 = parcelRequire("cvcC4");
var $a560103470afa70e$var$CLIENT_EDGE_TRAVERSAL_PATH = $cvcC4.CLIENT_EDGE_TRAVERSAL_PATH, $a560103470afa70e$var$FRAGMENT_OWNER_KEY = $cvcC4.FRAGMENT_OWNER_KEY, $a560103470afa70e$var$FRAGMENT_PROP_NAME_KEY = $cvcC4.FRAGMENT_PROP_NAME_KEY, $a560103470afa70e$var$FRAGMENTS_KEY = $cvcC4.FRAGMENTS_KEY, $a560103470afa70e$var$ID_KEY = $cvcC4.ID_KEY, $a560103470afa70e$var$MODULE_COMPONENT_KEY = $cvcC4.MODULE_COMPONENT_KEY, $a560103470afa70e$var$ROOT_ID = $cvcC4.ROOT_ID, $a560103470afa70e$var$getArgumentValues = $cvcC4.getArgumentValues, $a560103470afa70e$var$getModuleComponentKey = $cvcC4.getModuleComponentKey, $a560103470afa70e$var$getStorageKey = $cvcC4.getStorageKey;

var $k9R6Q = parcelRequire("k9R6Q");
var $a560103470afa70e$var$NoopResolverCache = $k9R6Q.NoopResolverCache;

var $e4ijV = parcelRequire("e4ijV");
var $a560103470afa70e$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL = $e4ijV.RESOLVER_FRAGMENT_ERRORED_SENTINEL, $a560103470afa70e$var$withResolverContext = $e4ijV.withResolverContext;

var $awaCw = parcelRequire("awaCw");
var $a560103470afa70e$var$generateTypeID = $awaCw.generateTypeID;

var $jwy7p = parcelRequire("jwy7p");
function $a560103470afa70e$var$read(recordSource, selector, resolverCache, resolverContext) {
    var reader = new $a560103470afa70e$var$RelayReader(recordSource, selector, resolverCache !== null && resolverCache !== void 0 ? resolverCache : new $a560103470afa70e$var$NoopResolverCache(), resolverContext);
    return reader.read();
}
var $a560103470afa70e$var$RelayReader = /*#__PURE__*/ function() {
    function RelayReader(recordSource, selector, resolverCache, resolverContext) {
        var _selector$clientEdgeT, _ref, _this$_owner$node$ope, _this$_owner$node$ope2;
        this._clientEdgeTraversalPath = (_selector$clientEdgeT = selector.clientEdgeTraversalPath) !== null && _selector$clientEdgeT !== void 0 && _selector$clientEdgeT.length ? (0, $a560103470afa70e$var$_toConsumableArray2["default"])(selector.clientEdgeTraversalPath) : [];
        this._missingClientEdges = [];
        this._missingLiveResolverFields = [];
        this._isMissingData = false;
        this._isWithinUnmatchedTypeRefinement = false;
        this._fieldErrors = null;
        this._owner = selector.owner;
        this._useExecTimeResolvers = (_ref = (_this$_owner$node$ope = this._owner.node.operation.use_exec_time_resolvers) !== null && _this$_owner$node$ope !== void 0 ? _this$_owner$node$ope : ((_this$_owner$node$ope2 = this._owner.node.operation.exec_time_resolvers_enabled_provider) === null || _this$_owner$node$ope2 === void 0 ? void 0 : _this$_owner$node$ope2.get()) === true) !== null && _ref !== void 0 ? _ref : false;
        this._recordSource = recordSource;
        this._seenRecords = new Set();
        this._selector = selector;
        this._variables = selector.variables;
        this._resolverCache = resolverCache;
        this._fragmentName = selector.node.name;
        this._updatedDataIDs = new Set();
        this._resolverContext = resolverContext;
    }
    var _proto = RelayReader.prototype;
    _proto.read = function read() {
        var _this$_selector$node$;
        var _this$_selector = this._selector, node = _this$_selector.node, dataID = _this$_selector.dataID, isWithinUnmatchedTypeRefinement = _this$_selector.isWithinUnmatchedTypeRefinement;
        var abstractKey = node.abstractKey;
        var record = this._recordSource.get(dataID);
        var isDataExpectedToBePresent = !isWithinUnmatchedTypeRefinement;
        if (isDataExpectedToBePresent && abstractKey == null && record != null) {
            if (!this._recordMatchesTypeCondition(record, node.type)) isDataExpectedToBePresent = false;
        }
        if (isDataExpectedToBePresent && abstractKey != null && record != null) {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false) isDataExpectedToBePresent = false;
        }
        this._isWithinUnmatchedTypeRefinement = !isDataExpectedToBePresent;
        var data = this._traverse(node, dataID, null);
        var catchTo = (_this$_selector$node$ = this._selector.node.metadata) === null || _this$_selector$node$ === void 0 ? void 0 : _this$_selector$node$.catchTo;
        if (catchTo != null) data = this._catchErrors(data, catchTo, null);
        if (this._updatedDataIDs.size > 0) {
            this._resolverCache.notifyUpdatedSubscribers(this._updatedDataIDs);
            this._updatedDataIDs.clear();
        }
        return {
            data: data,
            isMissingData: this._isMissingData && isDataExpectedToBePresent,
            missingClientEdges: this._missingClientEdges.length ? this._missingClientEdges : null,
            missingLiveResolverFields: this._missingLiveResolverFields,
            seenRecords: this._seenRecords,
            selector: this._selector,
            fieldErrors: this._fieldErrors
        };
    };
    _proto._maybeAddFieldErrors = function _maybeAddFieldErrors(record, storageKey) {
        var errors = $6ZixS.getErrors(record, storageKey);
        if (errors == null) return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        for(var i = 0; i < errors.length; i++){
            var _error$path, _this$_selector$node$2, _this$_selector$node$3;
            var error = errors[i];
            this._fieldErrors.push({
                kind: 'relay_field_payload.error',
                owner: owner,
                fieldPath: ((_error$path = error.path) !== null && _error$path !== void 0 ? _error$path : []).join('.'),
                error: error,
                shouldThrow: (_this$_selector$node$2 = (_this$_selector$node$3 = this._selector.node.metadata) === null || _this$_selector$node$3 === void 0 ? void 0 : _this$_selector$node$3.throwOnFieldError) !== null && _this$_selector$node$2 !== void 0 ? _this$_selector$node$2 : false,
                handled: false,
                uiContext: undefined
            });
        }
    };
    _proto._markDataAsMissing = function _markDataAsMissing(fieldName) {
        var _this$_selector$node$4, _this$_selector$node$5;
        if (this._isWithinUnmatchedTypeRefinement) return;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var owner = this._fragmentName;
        this._fieldErrors.push(((_this$_selector$node$4 = (_this$_selector$node$5 = this._selector.node.metadata) === null || _this$_selector$node$5 === void 0 ? void 0 : _this$_selector$node$5.throwOnFieldError) !== null && _this$_selector$node$4 !== void 0 ? _this$_selector$node$4 : false) ? {
            kind: 'missing_expected_data.throw',
            owner: owner,
            fieldPath: fieldName,
            handled: false,
            uiContext: undefined
        } : {
            kind: 'missing_expected_data.log',
            owner: owner,
            fieldPath: fieldName,
            uiContext: undefined
        });
        this._isMissingData = true;
        if (this._clientEdgeTraversalPath.length) {
            var top = this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1];
            if (top !== null) this._missingClientEdges.push({
                request: top.readerClientEdge.operation,
                clientEdgeDestinationID: top.clientEdgeDestinationID
            });
        }
    };
    _proto._traverse = function _traverse(node, dataID, prevData) {
        var record = this._recordSource.get(dataID);
        this._seenRecords.add(dataID);
        if (record == null) {
            if (record === undefined) this._markDataAsMissing('<record>');
            return record;
        }
        var data = prevData || {};
        var hadRequiredData = this._traverseSelections(node.selections, record, data);
        return hadRequiredData ? data : null;
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jwy7p(false);
        return this._variables[name];
    };
    _proto._maybeReportUnexpectedNull = function _maybeReportUnexpectedNull(selection) {
        if (selection.action === 'NONE') return;
        var owner = this._fragmentName;
        if (this._fieldErrors == null) this._fieldErrors = [];
        var fieldName;
        if (selection.field.linkedField != null) {
            var _selection$field$link;
            fieldName = (_selection$field$link = selection.field.linkedField.alias) !== null && _selection$field$link !== void 0 ? _selection$field$link : selection.field.linkedField.name;
        } else {
            var _selection$field$alia;
            fieldName = (_selection$field$alia = selection.field.alias) !== null && _selection$field$alia !== void 0 ? _selection$field$alia : selection.field.name;
        }
        switch(selection.action){
            case 'THROW':
                this._fieldErrors.push({
                    kind: 'missing_required_field.throw',
                    fieldPath: fieldName,
                    owner: owner,
                    handled: false,
                    uiContext: undefined
                });
                return;
            case 'LOG':
                this._fieldErrors.push({
                    kind: 'missing_required_field.log',
                    fieldPath: fieldName,
                    owner: owner,
                    uiContext: undefined
                });
                return;
            default:
                selection.action;
        }
    };
    _proto._handleRequiredFieldValue = function _handleRequiredFieldValue(selection, value) {
        if (value == null) {
            this._maybeReportUnexpectedNull(selection);
            return false;
        }
        return true;
    };
    _proto._catchErrors = function _catchErrors(_value, to, previousResponseFields) {
        var value = _value;
        switch(to){
            case 'RESULT':
                value = this._asResult(_value);
                break;
            case 'NULL':
                if (this._fieldErrors != null && this._fieldErrors.length > 0) value = null;
                break;
            default:
                to;
        }
        var childrenFieldErrors = this._fieldErrors;
        this._fieldErrors = previousResponseFields;
        if (childrenFieldErrors != null) {
            if (this._fieldErrors == null) this._fieldErrors = [];
            for(var i = 0; i < childrenFieldErrors.length; i++)this._fieldErrors.push($a560103470afa70e$var$markFieldErrorHasHandled(childrenFieldErrors[i]));
        }
        return value;
    };
    _proto._asResult = function _asResult(value) {
        if (this._fieldErrors == null || this._fieldErrors.length === 0) return {
            ok: true,
            value: value
        };
        var errors = this._fieldErrors.map(function(error) {
            switch(error.kind){
                case 'relay_field_payload.error':
                    var _error$error = error.error, message = _error$error.message, displayError = (0, $a560103470afa70e$var$_objectWithoutPropertiesLoose2["default"])(_error$error, $a560103470afa70e$var$_excluded);
                    return displayError;
                case 'missing_expected_data.throw':
                case 'missing_expected_data.log':
                    return {
                        path: error.fieldPath.split('.')
                    };
                case 'relay_resolver.error':
                    return {
                        message: "Relay: Error in resolver for field at ".concat(error.fieldPath, " in ").concat(error.owner)
                    };
                case 'missing_required_field.throw':
                    return {
                        message: "Relay: Missing @required value at path '".concat(error.fieldPath, "' in '").concat(error.owner, "'.")
                    };
                case 'missing_required_field.log':
                    return null;
                default:
                    error.kind;
                    $jwy7p(false);
            }
        }).filter(Boolean);
        return {
            ok: false,
            errors: errors
        };
    };
    _proto._traverseSelections = function _traverseSelections(selections, record, data) {
        for(var i = 0; i < selections.length; i++){
            var selection = selections[i];
            switch(selection.kind){
                case 'RequiredField':
                    var requiredFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    if (!this._handleRequiredFieldValue(selection, requiredFieldValue)) return false;
                    break;
                case 'CatchField':
                    var _selection$field$back, _selection$field, _field$alias;
                    var previousResponseFields = this._fieldErrors;
                    this._fieldErrors = null;
                    var catchFieldValue = this._readClientSideDirectiveField(selection, record, data);
                    var field = (_selection$field$back = (_selection$field = selection.field) === null || _selection$field === void 0 ? void 0 : _selection$field.backingField) !== null && _selection$field$back !== void 0 ? _selection$field$back : selection.field;
                    var fieldName = (_field$alias = field === null || field === void 0 ? void 0 : field.alias) !== null && _field$alias !== void 0 ? _field$alias : field === null || field === void 0 ? void 0 : field.name;
                    !(fieldName != null) && $jwy7p(false);
                    data[fieldName] = this._catchErrors(catchFieldValue, selection.to, previousResponseFields);
                    break;
                case 'ScalarField':
                    this._readScalar(selection, record, data);
                    break;
                case 'LinkedField':
                    if (selection.plural) this._readPluralLink(selection, record, data);
                    else this._readLink(selection, record, data);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) {
                        var hasExpectedData = this._traverseSelections(selection.selections, record, data);
                        if (!hasExpectedData) return false;
                    }
                    break;
                case 'InlineFragment':
                    var _hasExpectedData = this._readInlineFragment(selection, record, data, false);
                    if (_hasExpectedData === false) return false;
                    break;
                case 'RelayLiveResolver':
                case 'RelayResolver':
                    if (this._useExecTimeResolvers) this._readScalar(selection, record, data);
                    else this._readResolverField(selection, record, data);
                    break;
                case 'FragmentSpread':
                    this._createFragmentPointer(selection, record, data);
                    break;
                case 'AliasedInlineFragmentSpread':
                    this._readAliasedInlineFragment(selection, record, data);
                    break;
                case 'ModuleImport':
                    this._readModuleImport(selection, record, data);
                    break;
                case 'InlineDataFragmentSpread':
                    this._createInlineDataOrResolverFragmentPointer(selection, record, data);
                    break;
                case 'Defer':
                case 'ClientExtension':
                    var isMissingData = this._isMissingData;
                    var alreadyMissingClientEdges = this._missingClientEdges.length;
                    this._clientEdgeTraversalPath.push(null);
                    var _hasExpectedData2 = this._traverseSelections(selection.selections, record, data);
                    this._isMissingData = isMissingData || this._missingClientEdges.length > alreadyMissingClientEdges || this._missingLiveResolverFields.length > 0;
                    this._clientEdgeTraversalPath.pop();
                    if (!_hasExpectedData2) return false;
                    break;
                case 'Stream':
                    var _hasExpectedData3 = this._traverseSelections(selection.selections, record, data);
                    if (!_hasExpectedData3) return false;
                    break;
                case 'ActorChange':
                    this._readActorChange(selection, record, data);
                    break;
                case 'ClientEdgeToClientObject':
                case 'ClientEdgeToServerObject':
                    if (this._useExecTimeResolvers && (selection.backingField.kind === 'RelayResolver' || selection.backingField.kind === 'RelayLiveResolver')) {
                        var linkedField = selection.linkedField;
                        if (linkedField.plural) this._readPluralLink(linkedField, record, data);
                        else this._readLink(linkedField, record, data);
                    } else this._readClientEdge(selection, record, data);
                    break;
                default:
                    selection;
                    $jwy7p(false);
            }
        }
        return true;
    };
    _proto._readClientSideDirectiveField = function _readClientSideDirectiveField(selection, record, data) {
        switch(selection.field.kind){
            case 'ScalarField':
                return this._readScalar(selection.field, record, data);
            case 'LinkedField':
                if (selection.field.plural) return this._readPluralLink(selection.field, record, data);
                else return this._readLink(selection.field, record, data);
            case 'RelayResolver':
            case 'RelayLiveResolver':
                if (this._useExecTimeResolvers) return this._readScalar(selection.field, record, data);
                else return this._readResolverField(selection.field, record, data);
            case 'ClientEdgeToClientObject':
            case 'ClientEdgeToServerObject':
                if (this._useExecTimeResolvers && (selection.field.backingField.kind === 'RelayResolver' || selection.field.backingField.kind === 'RelayLiveResolver')) {
                    var field = selection.field;
                    if (field.linkedField.plural) return this._readPluralLink(field.linkedField, record, data);
                    else return this._readLink(field.linkedField, record, data);
                } else return this._readClientEdge(selection.field, record, data);
            case 'AliasedInlineFragmentSpread':
                return this._readAliasedInlineFragment(selection.field, record, data);
            default:
                selection.field.kind;
                $jwy7p(false);
        }
    };
    _proto._readResolverField = function _readResolverField(field, record, data) {
        var _field$alias2;
        var parentRecordID = $6ZixS.getDataID(record);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var result = this._readResolverFieldImpl(field, parentRecordID);
        var fieldName = (_field$alias2 = field.alias) !== null && _field$alias2 !== void 0 ? _field$alias2 : field.name;
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = result;
        return result;
    };
    _proto._readResolverFieldImpl = function _readResolverFieldImpl(field, parentRecordID) {
        var _this = this;
        var fragment = field.fragment;
        var snapshot;
        var getDataForResolverFragment = function getDataForResolverFragment(singularReaderSelector) {
            if (snapshot != null) return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
            snapshot = $a560103470afa70e$var$read(_this._recordSource, singularReaderSelector, _this._resolverCache);
            return {
                data: snapshot.data,
                isMissingData: snapshot.isMissingData,
                fieldErrors: snapshot.fieldErrors
            };
        };
        var evaluate = function evaluate() {
            if (fragment != null) {
                var key = {
                    __id: parentRecordID,
                    __fragmentOwner: _this._owner,
                    __fragments: (0, $a560103470afa70e$var$_defineProperty2["default"])({}, fragment.name, fragment.args ? $a560103470afa70e$var$getArgumentValues(fragment.args, _this._variables) : {})
                };
                if (_this._clientEdgeTraversalPath.length > 0 && _this._clientEdgeTraversalPath[_this._clientEdgeTraversalPath.length - 1] !== null) key[$a560103470afa70e$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $a560103470afa70e$var$_toConsumableArray2["default"])(_this._clientEdgeTraversalPath);
                var resolverContext = {
                    getDataForResolverFragment: getDataForResolverFragment
                };
                return $a560103470afa70e$var$withResolverContext(resolverContext, function() {
                    var _getResolverValue = $a560103470afa70e$var$getResolverValue(field, _this._variables, key, _this._resolverContext), resolverResult = _getResolverValue[0], resolverError = _getResolverValue[1];
                    return {
                        resolverResult: resolverResult,
                        snapshot: snapshot,
                        error: resolverError
                    };
                });
            } else {
                var _getResolverValue2 = $a560103470afa70e$var$getResolverValue(field, _this._variables, null, _this._resolverContext), resolverResult = _getResolverValue2[0], _resolverError = _getResolverValue2[1];
                return {
                    resolverResult: resolverResult,
                    snapshot: undefined,
                    error: _resolverError
                };
            }
        };
        var _this$_resolverCache$ = this._resolverCache.readFromCacheOrEvaluate(parentRecordID, field, this._variables, evaluate, getDataForResolverFragment), result = _this$_resolverCache$[0], seenRecord = _this$_resolverCache$[1], resolverError = _this$_resolverCache$[2], cachedSnapshot = _this$_resolverCache$[3], suspenseID = _this$_resolverCache$[4], updatedDataIDs = _this$_resolverCache$[5];
        this._propagateResolverMetadata(field.path, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs);
        return result;
    };
    _proto._propagateResolverMetadata = function _propagateResolverMetadata(fieldPath, cachedSnapshot, resolverError, seenRecord, suspenseID, updatedDataIDs) {
        var _this2 = this;
        if (cachedSnapshot != null) {
            if (cachedSnapshot.missingClientEdges != null) for(var i = 0; i < cachedSnapshot.missingClientEdges.length; i++){
                var missing = cachedSnapshot.missingClientEdges[i];
                this._missingClientEdges.push(missing);
            }
            if (cachedSnapshot.missingLiveResolverFields != null) {
                this._isMissingData = this._isMissingData || cachedSnapshot.missingLiveResolverFields.length > 0;
                for(var _i = 0; _i < cachedSnapshot.missingLiveResolverFields.length; _i++){
                    var missingResolverField = cachedSnapshot.missingLiveResolverFields[_i];
                    this._missingLiveResolverFields.push(missingResolverField);
                }
            }
            if (cachedSnapshot.fieldErrors != null) {
                if (this._fieldErrors == null) this._fieldErrors = [];
                for(var _i2 = 0; _i2 < cachedSnapshot.fieldErrors.length; _i2++){
                    var _this$_selector$node$6;
                    var error = cachedSnapshot.fieldErrors[_i2];
                    if (((_this$_selector$node$6 = this._selector.node.metadata) === null || _this$_selector$node$6 === void 0 ? void 0 : _this$_selector$node$6.throwOnFieldError) === true) this._fieldErrors.push(error);
                    else this._fieldErrors.push($a560103470afa70e$var$markFieldErrorHasHandled(error));
                }
            }
            this._isMissingData = this._isMissingData || cachedSnapshot.isMissingData;
        }
        if (resolverError) {
            var _this$_selector$node$7, _this$_selector$node$8;
            var errorEvent = {
                kind: 'relay_resolver.error',
                fieldPath: fieldPath,
                owner: this._fragmentName,
                error: resolverError,
                shouldThrow: (_this$_selector$node$7 = (_this$_selector$node$8 = this._selector.node.metadata) === null || _this$_selector$node$8 === void 0 ? void 0 : _this$_selector$node$8.throwOnFieldError) !== null && _this$_selector$node$7 !== void 0 ? _this$_selector$node$7 : false,
                handled: false,
                uiContext: undefined
            };
            if (this._fieldErrors == null) this._fieldErrors = [
                errorEvent
            ];
            else this._fieldErrors.push(errorEvent);
        }
        if (seenRecord != null) this._seenRecords.add(seenRecord);
        if (suspenseID != null) {
            this._isMissingData = true;
            this._missingLiveResolverFields.push(suspenseID);
        }
        if (updatedDataIDs != null) updatedDataIDs.forEach(function(recordID) {
            _this2._updatedDataIDs.add(recordID);
        });
    };
    _proto._readClientEdge = function _readClientEdge(field, record, data) {
        var _this3 = this;
        var _backingField$alias;
        var backingField = field.backingField;
        !(backingField.kind !== 'ClientExtension') && $jwy7p(false);
        var fieldName = (_backingField$alias = backingField.alias) !== null && _backingField$alias !== void 0 ? _backingField$alias : backingField.name;
        var backingFieldData = {};
        this._traverseSelections([
            backingField
        ], record, backingFieldData);
        var clientEdgeResolverResponse = backingFieldData[fieldName];
        if (clientEdgeResolverResponse == null || $a560103470afa70e$var$isSuspenseSentinel(clientEdgeResolverResponse)) {
            data[fieldName] = clientEdgeResolverResponse;
            return clientEdgeResolverResponse;
        }
        if (field.linkedField.plural) {
            !Array.isArray(clientEdgeResolverResponse) && $jwy7p(false);
            var storeIDs;
            !(field.kind === 'ClientEdgeToClientObject') && $jwy7p(false);
            if (field.backingField.normalizationInfo == null) storeIDs = clientEdgeResolverResponse.map(function(itemResponse) {
                var _field$concreteType;
                var concreteType = (_field$concreteType = field.concreteType) !== null && _field$concreteType !== void 0 ? _field$concreteType : itemResponse.__typename;
                !(typeof concreteType === 'string') && $jwy7p(false);
                var localId = $a560103470afa70e$var$extractIdFromResponse(itemResponse, backingField.path, _this3._owner.identifier);
                var id = _this3._resolverCache.ensureClientRecord(localId, concreteType);
                var modelResolvers = field.modelResolvers;
                if (modelResolvers != null) {
                    var modelResolver = modelResolvers[concreteType];
                    !(modelResolver !== undefined) && $jwy7p(false);
                    var model = _this3._readResolverFieldImpl(modelResolver, id);
                    return model != null ? id : null;
                }
                return id;
            });
            else storeIDs = clientEdgeResolverResponse.map(function(obj) {
                return $a560103470afa70e$var$extractIdFromResponse(obj, backingField.path, _this3._owner.identifier);
            });
            this._clientEdgeTraversalPath.push(null);
            var edgeValues = this._readLinkedIds(field.linkedField, storeIDs, record, data);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValues;
            return edgeValues;
        } else {
            var _field$concreteType2;
            var id = $a560103470afa70e$var$extractIdFromResponse(clientEdgeResolverResponse, backingField.path, this._owner.identifier);
            var storeID;
            var concreteType = (_field$concreteType2 = field.concreteType) !== null && _field$concreteType2 !== void 0 ? _field$concreteType2 : clientEdgeResolverResponse.__typename;
            var traversalPathSegment;
            if (field.kind === 'ClientEdgeToClientObject') {
                if (field.backingField.normalizationInfo == null) {
                    !(typeof concreteType === 'string') && $jwy7p(false);
                    storeID = this._resolverCache.ensureClientRecord(id, concreteType);
                    traversalPathSegment = null;
                } else {
                    storeID = id;
                    traversalPathSegment = null;
                }
            } else {
                storeID = id;
                traversalPathSegment = {
                    readerClientEdge: field,
                    clientEdgeDestinationID: id
                };
            }
            var modelResolvers = field.modelResolvers;
            if (modelResolvers != null) {
                !(typeof concreteType === 'string') && $jwy7p(false);
                var modelResolver = modelResolvers[concreteType];
                !(modelResolver !== undefined) && $jwy7p(false);
                var model = this._readResolverFieldImpl(modelResolver, storeID);
                if (model == null) {
                    data[fieldName] = null;
                    return null;
                }
            }
            this._clientEdgeTraversalPath.push(traversalPathSegment);
            var prevData = data[fieldName];
            !(prevData == null || typeof prevData === 'object') && $jwy7p(false);
            var prevErrors = this._fieldErrors;
            this._fieldErrors = null;
            var edgeValue = this._traverse(field.linkedField, storeID, prevData);
            this._prependPreviousErrors(prevErrors, fieldName);
            this._clientEdgeTraversalPath.pop();
            data[fieldName] = edgeValue;
            return edgeValue;
        }
    };
    _proto._readScalar = function _readScalar(field, record, data) {
        var _field$alias3;
        var fieldName = (_field$alias3 = field.alias) !== null && _field$alias3 !== void 0 ? _field$alias3 : field.name;
        var storageKey = $a560103470afa70e$var$getStorageKey(field, this._variables);
        var value = $6ZixS.getValue(record, storageKey);
        if (value === null || $kgraI.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(value) && value.length === 0) this._maybeAddFieldErrors(record, storageKey);
        else if (value === undefined) this._markDataAsMissing(fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._readLink = function _readLink(field, record, data) {
        var _field$alias4;
        var fieldName = (_field$alias4 = field.alias) !== null && _field$alias4 !== void 0 ? _field$alias4 : field.name;
        var storageKey = $a560103470afa70e$var$getStorageKey(field, this._variables);
        var linkedID = $6ZixS.getLinkedRecordID(record, storageKey);
        if (linkedID == null) {
            data[fieldName] = linkedID;
            if (linkedID === null) this._maybeAddFieldErrors(record, storageKey);
            else if (linkedID === undefined) this._markDataAsMissing(fieldName);
            return linkedID;
        }
        var prevData = data[fieldName];
        !(prevData == null || typeof prevData === 'object') && $jwy7p(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var value = this._traverse(field, linkedID, prevData);
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = value;
        return value;
    };
    _proto._prependPreviousErrors = function _prependPreviousErrors(prevErrors, fieldNameOrIndex) {
        if (this._fieldErrors != null) {
            for(var i = 0; i < this._fieldErrors.length; i++){
                var event = this._fieldErrors[i];
                if (event.owner === this._fragmentName && (event.kind === 'missing_expected_data.throw' || event.kind === 'missing_expected_data.log' || event.kind === 'missing_required_field.throw' || event.kind === 'missing_required_field.log')) event.fieldPath = "".concat(fieldNameOrIndex, ".").concat(event.fieldPath);
            }
            if (prevErrors != null) {
                for(var _i3 = this._fieldErrors.length - 1; _i3 >= 0; _i3--)prevErrors.push(this._fieldErrors[_i3]);
                this._fieldErrors = prevErrors;
            }
        } else this._fieldErrors = prevErrors;
    };
    _proto._readActorChange = function _readActorChange(field, record, data) {
        var _field$alias5;
        var fieldName = (_field$alias5 = field.alias) !== null && _field$alias5 !== void 0 ? _field$alias5 : field.name;
        var storageKey = $a560103470afa70e$var$getStorageKey(field, this._variables);
        var externalRef = $6ZixS.getActorLinkedRecordID(record, storageKey);
        if (externalRef == null) {
            data[fieldName] = externalRef;
            if (externalRef === undefined) this._markDataAsMissing(fieldName);
            else if (externalRef === null) this._maybeAddFieldErrors(record, storageKey);
            return data[fieldName];
        }
        var actorIdentifier = externalRef[0], dataID = externalRef[1];
        var fragmentRef = {};
        this._createFragmentPointer(field.fragmentSpread, $6ZixS.fromObject({
            __id: dataID
        }), fragmentRef);
        data[fieldName] = {
            __fragmentRef: fragmentRef,
            __viewer: actorIdentifier
        };
        return data[fieldName];
    };
    _proto._readPluralLink = function _readPluralLink(field, record, data) {
        var storageKey = $a560103470afa70e$var$getStorageKey(field, this._variables);
        var linkedIDs = $6ZixS.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs === null || $kgraI.ENABLE_NONCOMPLIANT_ERROR_HANDLING_ON_LISTS && Array.isArray(linkedIDs) && linkedIDs.length === 0) this._maybeAddFieldErrors(record, storageKey);
        return this._readLinkedIds(field, linkedIDs, record, data);
    };
    _proto._readLinkedIds = function _readLinkedIds(field, linkedIDs, record, data) {
        var _this4 = this;
        var _field$alias6;
        var fieldName = (_field$alias6 = field.alias) !== null && _field$alias6 !== void 0 ? _field$alias6 : field.name;
        if (linkedIDs == null) {
            data[fieldName] = linkedIDs;
            if (linkedIDs === undefined) this._markDataAsMissing(fieldName);
            return linkedIDs;
        }
        var prevData = data[fieldName];
        !(prevData == null || Array.isArray(prevData)) && $jwy7p(false);
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var linkedArray = prevData || [];
        linkedIDs.forEach(function(linkedID, nextIndex) {
            if (linkedID == null) {
                if (linkedID === undefined) _this4._markDataAsMissing(String(nextIndex));
                linkedArray[nextIndex] = linkedID;
                return;
            }
            var prevItem = linkedArray[nextIndex];
            !(prevItem == null || typeof prevItem === 'object') && $jwy7p(false);
            var prevErrors = _this4._fieldErrors;
            _this4._fieldErrors = null;
            linkedArray[nextIndex] = _this4._traverse(field, linkedID, prevItem);
            _this4._prependPreviousErrors(prevErrors, nextIndex);
        });
        this._prependPreviousErrors(prevErrors, fieldName);
        data[fieldName] = linkedArray;
        return linkedArray;
    };
    _proto._readModuleImport = function _readModuleImport(moduleImport, record, data) {
        var componentKey = $a560103470afa70e$var$getModuleComponentKey(moduleImport.documentName);
        var relayStoreComponent = $6ZixS.getValue(record, componentKey);
        var component = relayStoreComponent !== undefined ? relayStoreComponent : moduleImport.componentModuleProvider;
        if (component == null) {
            if (component === undefined) this._markDataAsMissing('<module-import>');
            return;
        }
        this._createFragmentPointer({
            kind: 'FragmentSpread',
            name: moduleImport.fragmentName,
            args: moduleImport.args
        }, record, data);
        data[$a560103470afa70e$var$FRAGMENT_PROP_NAME_KEY] = moduleImport.fragmentPropName;
        data[$a560103470afa70e$var$MODULE_COMPONENT_KEY] = component;
    };
    _proto._readAliasedInlineFragment = function _readAliasedInlineFragment(aliasedInlineFragment, record, data) {
        var prevErrors = this._fieldErrors;
        this._fieldErrors = null;
        var fieldValue = this._readInlineFragment(aliasedInlineFragment.fragment, record, {}, true);
        this._prependPreviousErrors(prevErrors, aliasedInlineFragment.name);
        if (fieldValue === false) fieldValue = null;
        data[aliasedInlineFragment.name] = fieldValue;
    };
    _proto._readInlineFragment = function _readInlineFragment(inlineFragment, record, data, skipUnmatchedAbstractTypes) {
        if (inlineFragment.type == null) {
            var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
            if (hasExpectedData === false) return false;
            return data;
        }
        var abstractKey = inlineFragment.abstractKey;
        if (abstractKey == null) {
            if (!this._recordMatchesTypeCondition(record, inlineFragment.type)) return null;
            else {
                var hasExpectedData = this._traverseSelections(inlineFragment.selections, record, data);
                if (!hasExpectedData) return false;
            }
        } else {
            var implementsInterface = this._implementsInterface(record, abstractKey);
            if (implementsInterface === false && skipUnmatchedAbstractTypes) return null;
            var parentIsMissingData = this._isMissingData;
            var parentIsWithinUnmatchedTypeRefinement = this._isWithinUnmatchedTypeRefinement;
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement || implementsInterface === false;
            var hasMissingData = this._traverseSelections(inlineFragment.selections, record, data);
            this._isWithinUnmatchedTypeRefinement = parentIsWithinUnmatchedTypeRefinement;
            if (implementsInterface === false) {
                this._isMissingData = parentIsMissingData;
                return null;
            } else if (implementsInterface == null) return undefined;
            else if (hasMissingData === false) return false;
        }
        return data;
    };
    _proto._recordMatchesTypeCondition = function _recordMatchesTypeCondition(record, type) {
        var typeName = $6ZixS.getType(record);
        return typeName != null && typeName === type || $6ZixS.getDataID(record) === $a560103470afa70e$var$ROOT_ID;
    };
    _proto._createFragmentPointer = function _createFragmentPointer(fragmentSpread, record, data) {
        var fragmentPointers = data[$a560103470afa70e$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$a560103470afa70e$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $jwy7p(false);
        if (data[$a560103470afa70e$var$ID_KEY] == null) data[$a560103470afa70e$var$ID_KEY] = $6ZixS.getDataID(record);
        fragmentPointers[fragmentSpread.name] = $a560103470afa70e$var$getArgumentValues(fragmentSpread.args, this._variables, this._isWithinUnmatchedTypeRefinement);
        data[$a560103470afa70e$var$FRAGMENT_OWNER_KEY] = this._owner;
        if (this._clientEdgeTraversalPath.length > 0 && this._clientEdgeTraversalPath[this._clientEdgeTraversalPath.length - 1] !== null) data[$a560103470afa70e$var$CLIENT_EDGE_TRAVERSAL_PATH] = (0, $a560103470afa70e$var$_toConsumableArray2["default"])(this._clientEdgeTraversalPath);
    };
    _proto._createInlineDataOrResolverFragmentPointer = function _createInlineDataOrResolverFragmentPointer(fragmentSpreadOrFragment, record, data) {
        var fragmentPointers = data[$a560103470afa70e$var$FRAGMENTS_KEY];
        if (fragmentPointers == null) fragmentPointers = data[$a560103470afa70e$var$FRAGMENTS_KEY] = {};
        !(typeof fragmentPointers === 'object' && fragmentPointers != null) && $jwy7p(false);
        if (data[$a560103470afa70e$var$ID_KEY] == null) data[$a560103470afa70e$var$ID_KEY] = $6ZixS.getDataID(record);
        var inlineData = {};
        var parentFragmentName = this._fragmentName;
        this._fragmentName = fragmentSpreadOrFragment.name;
        var parentVariables = this._variables;
        var argumentVariables = fragmentSpreadOrFragment.args ? $a560103470afa70e$var$getArgumentValues(fragmentSpreadOrFragment.args, this._variables) : {};
        this._variables = $cbsiZ.getFragmentVariables(fragmentSpreadOrFragment, this._owner.variables, argumentVariables);
        this._traverseSelections(fragmentSpreadOrFragment.selections, record, inlineData);
        this._variables = parentVariables;
        this._fragmentName = parentFragmentName;
        fragmentPointers[fragmentSpreadOrFragment.name] = inlineData;
    };
    _proto._implementsInterface = function _implementsInterface(record, abstractKey) {
        var typeName = $6ZixS.getType(record);
        var typeRecord = this._recordSource.get($a560103470afa70e$var$generateTypeID(typeName));
        var implementsInterface = typeRecord != null ? $6ZixS.getValue(typeRecord, abstractKey) : null;
        if (implementsInterface == null) this._markDataAsMissing('<abstract-type-hint>');
        return implementsInterface;
    };
    return RelayReader;
}();
function $a560103470afa70e$var$markFieldErrorHasHandled(event) {
    switch(event.kind){
        case 'missing_expected_data.throw':
        case 'missing_required_field.throw':
        case 'relay_field_payload.error':
        case 'relay_resolver.error':
            return (0, $a560103470afa70e$var$_objectSpread2["default"])((0, $a560103470afa70e$var$_objectSpread2["default"])({}, event), {}, {
                handled: true
            });
        case 'missing_expected_data.log':
        case 'missing_required_field.log':
            return event;
        default:
            event.kind;
            $jwy7p(false);
    }
}
function $a560103470afa70e$var$getResolverValue(field, variables, fragmentKey, resolverContext) {
    var resolverFunction = typeof field.resolverModule === 'function' ? field.resolverModule : field.resolverModule["default"];
    var resolverResult = null;
    var resolverError = null;
    try {
        var resolverFunctionArgs = [];
        if (field.fragment != null) resolverFunctionArgs.push(fragmentKey);
        var args = field.args ? $a560103470afa70e$var$getArgumentValues(field.args, variables) : undefined;
        resolverFunctionArgs.push(args);
        resolverFunctionArgs.push(resolverContext);
        resolverResult = resolverFunction.apply(null, resolverFunctionArgs);
    } catch (e) {
        resolverResult = null;
        if (e !== $a560103470afa70e$var$RESOLVER_FRAGMENT_ERRORED_SENTINEL) resolverError = e;
    }
    return [
        resolverResult,
        resolverError
    ];
}
function $a560103470afa70e$var$extractIdFromResponse(individualResponse, path, owner) {
    if (typeof individualResponse === 'string') return individualResponse;
    else if (typeof individualResponse === 'object' && individualResponse != null && typeof individualResponse.id === 'string') return individualResponse.id;
    $jwy7p(false);
}
module.exports = {
    read: $a560103470afa70e$var$read
};

});
parcelRegister("k9R6Q", function(module, exports) {
'use strict';

var $2HvH8 = parcelRequire("2HvH8");
var $eacdd855e778700e$var$RELAY_LIVE_RESOLVER = $2HvH8.RELAY_LIVE_RESOLVER;

var $jwy7p = parcelRequire("jwy7p");
var $eacdd855e778700e$var$NoopResolverCache = /*#__PURE__*/ function() {
    function NoopResolverCache() {}
    var _proto = NoopResolverCache.prototype;
    _proto.readFromCacheOrEvaluate = function readFromCacheOrEvaluate(recordID, field, variables, evaluate, getDataForResolverFragment) {
        !(field.kind !== $eacdd855e778700e$var$RELAY_LIVE_RESOLVER) && $jwy7p(false);
        var _evaluate = evaluate(), resolverResult = _evaluate.resolverResult, snapshot = _evaluate.snapshot, error = _evaluate.error;
        return [
            resolverResult,
            undefined,
            error,
            snapshot,
            undefined,
            undefined
        ];
    };
    _proto.invalidateDataIDs = function invalidateDataIDs(updatedDataIDs) {};
    _proto.ensureClientRecord = function ensureClientRecord(id, typeName) {
        $jwy7p(false);
    };
    _proto.notifyUpdatedSubscribers = function notifyUpdatedSubscribers(updatedDataIDs) {};
    return NoopResolverCache;
}();
module.exports = {
    NoopResolverCache: $eacdd855e778700e$var$NoopResolverCache
};

});


parcelRegister("aAIOS", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $7b6008675210be49$var$_interopRequireDefault = $8gviu.default;

var $7b6008675210be49$var$_createForOfIteratorHelper2 = $7b6008675210be49$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $jxlx4 = parcelRequire("jxlx4");

var $hacyv = parcelRequire("hacyv");

var $j87z1 = parcelRequire("j87z1");

var $cbsiZ = parcelRequire("cbsiZ");
var $7b6008675210be49$var$getLocalVariables = $cbsiZ.getLocalVariables;

var $6ZixS = parcelRequire("6ZixS");

var $cvcC4 = parcelRequire("cvcC4");

var $awaCw = parcelRequire("awaCw");
var $7b6008675210be49$var$generateTypeID = $awaCw.generateTypeID;

var $jwy7p = parcelRequire("jwy7p");
var $7b6008675210be49$var$getReadTimeResolverStorageKey = $cvcC4.getReadTimeResolverStorageKey, $7b6008675210be49$var$getStorageKey = $cvcC4.getStorageKey, $7b6008675210be49$var$getModuleOperationKey = $cvcC4.getModuleOperationKey;
function $7b6008675210be49$var$mark(recordSource, selector, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
    var dataID = selector.dataID, node = selector.node, variables = selector.variables;
    var marker = new $7b6008675210be49$var$RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers);
    marker.mark(node, dataID);
}
var $7b6008675210be49$var$RelayReferenceMarker = /*#__PURE__*/ function() {
    function RelayReferenceMarker(recordSource, variables, references, operationLoader, shouldProcessClientComponents, useExecTimeResolvers) {
        this._operationLoader = operationLoader !== null && operationLoader !== void 0 ? operationLoader : null;
        this._operationName = null;
        this._useExecTimeResolvers = useExecTimeResolvers !== null && useExecTimeResolvers !== void 0 ? useExecTimeResolvers : false;
        this._recordSource = recordSource;
        this._references = references;
        this._variables = variables;
        this._shouldProcessClientComponents = shouldProcessClientComponents;
    }
    var _proto = RelayReferenceMarker.prototype;
    _proto.mark = function mark(node, dataID) {
        if (node.kind === 'Operation' || node.kind === 'SplitOperation') this._operationName = node.name;
        this._traverse(node, dataID);
    };
    _proto._traverse = function _traverse(node, dataID) {
        this._references.add(dataID);
        var record = this._recordSource.get(dataID);
        if (record == null) return;
        this._traverseSelections(node.selections, record);
    };
    _proto._getVariableValue = function _getVariableValue(name) {
        !this._variables.hasOwnProperty(name) && $jwy7p(false);
        return this._variables[name];
    };
    _proto._traverseSelections = function _traverseSelections(selections, record) {
        var _this = this;
        selections.forEach(function(selection) {
            switch(selection.kind){
                case 'ActorChange':
                    _this._traverseLink(selection.linkedField, record);
                    break;
                case 'LinkedField':
                    if (selection.plural) _this._traversePluralLink(selection, record);
                    else _this._traverseLink(selection, record);
                    break;
                case 'Condition':
                    var conditionValue = Boolean(_this._getVariableValue(selection.condition));
                    if (conditionValue === selection.passingValue) _this._traverseSelections(selection.selections, record);
                    break;
                case 'InlineFragment':
                    if (selection.abstractKey == null) {
                        var typeName = $6ZixS.getType(record);
                        if (typeName != null && typeName === selection.type || typeName === $cvcC4.ROOT_TYPE) _this._traverseSelections(selection.selections, record);
                    } else {
                        var _typeName = $6ZixS.getType(record);
                        var typeID = $7b6008675210be49$var$generateTypeID(_typeName);
                        _this._references.add(typeID);
                        _this._traverseSelections(selection.selections, record);
                    }
                    break;
                case 'FragmentSpread':
                    var prevVariables = _this._variables;
                    _this._variables = $7b6008675210be49$var$getLocalVariables(_this._variables, selection.fragment.argumentDefinitions, selection.args);
                    _this._traverseSelections(selection.fragment.selections, record);
                    _this._variables = prevVariables;
                    break;
                case 'LinkedHandle':
                    var handleField = $hacyv(selection, selections, _this._variables);
                    if (handleField.plural) _this._traversePluralLink(handleField, record);
                    else _this._traverseLink(handleField, record);
                    break;
                case 'Defer':
                case 'Stream':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ScalarField':
                case 'ScalarHandle':
                    break;
                case 'TypeDiscriminator':
                    var _typeName2 = $6ZixS.getType(record);
                    var _typeID = $7b6008675210be49$var$generateTypeID(_typeName2);
                    _this._references.add(_typeID);
                    break;
                case 'ModuleImport':
                    _this._traverseModuleImport(selection, record);
                    break;
                case 'ClientExtension':
                    _this._traverseSelections(selection.selections, record);
                    break;
                case 'ClientComponent':
                    if (_this._shouldProcessClientComponents === false) break;
                    _this._traverseSelections(selection.fragment.selections, record);
                    break;
                case 'RelayResolver':
                case 'RelayLiveResolver':
                    _this._traverseResolverField(selection, record);
                    break;
                case 'ClientEdgeToClientObject':
                    _this._traverseClientEdgeToClientObject(selection, record);
                    break;
                default:
                    selection;
                    $jwy7p(false);
            }
        });
    };
    _proto._traverseClientEdgeToClientObject = function _traverseClientEdgeToClientObject(field, record) {
        if (this._useExecTimeResolvers) {
            this._traverseLink(field.linkedField, record);
            return;
        }
        var dataID = this._traverseResolverField(field.backingField, record);
        if (dataID == null) return;
        var resolverRecord = this._recordSource.get(dataID);
        if (resolverRecord == null) return;
        if (field.backingField.isOutputType) {
            var outputTypeRecordIDs = $j87z1(resolverRecord);
            if (outputTypeRecordIDs != null) {
                var _iterator = (0, $7b6008675210be49$var$_createForOfIteratorHelper2["default"])(outputTypeRecordIDs), _step;
                try {
                    for(_iterator.s(); !(_step = _iterator.n()).done;){
                        var _dataID = _step.value;
                        this._references.add(_dataID);
                    }
                } catch (err) {
                    _iterator.e(err);
                } finally{
                    _iterator.f();
                }
            }
        } else {
            var linkedField = field.linkedField;
            var concreteType = linkedField.concreteType;
            if (concreteType == null) return;
            if (linkedField.plural) {
                var dataIDs = $6ZixS.getResolverLinkedRecordIDs(resolverRecord, concreteType);
                if (dataIDs != null) {
                    var _iterator2 = (0, $7b6008675210be49$var$_createForOfIteratorHelper2["default"])(dataIDs), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var _dataID2 = _step2.value;
                            if (_dataID2 != null) this._traverse(linkedField, _dataID2);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            } else {
                var _dataID3 = $6ZixS.getResolverLinkedRecordID(resolverRecord, concreteType);
                if (_dataID3 != null) this._traverse(linkedField, _dataID3);
            }
        }
    };
    _proto._traverseResolverField = function _traverseResolverField(field, record) {
        if (this._useExecTimeResolvers) return;
        var storageKey = $7b6008675210be49$var$getReadTimeResolverStorageKey(field, this._variables);
        var dataID = $6ZixS.getLinkedRecordID(record, storageKey);
        if (dataID != null) this._references.add(dataID);
        var fragment = field.fragment;
        if (fragment != null) this._traverseSelections([
            fragment
        ], record);
        return dataID;
    };
    _proto._traverseModuleImport = function _traverseModuleImport(moduleImport, record) {
        var _this$_operationName;
        var operationLoader = this._operationLoader;
        !(operationLoader !== null) && $jwy7p(false);
        var operationKey = $7b6008675210be49$var$getModuleOperationKey(moduleImport.documentName);
        var operationReference = $6ZixS.getValue(record, operationKey);
        if (operationReference == null) return;
        var normalizationRootNode = operationLoader.get(operationReference);
        if (normalizationRootNode != null) {
            var operation = $jxlx4(normalizationRootNode);
            var prevVariables = this._variables;
            this._variables = $7b6008675210be49$var$getLocalVariables(this._variables, operation.argumentDefinitions, moduleImport.args);
            this._traverseSelections(operation.selections, record);
            this._variables = prevVariables;
        }
    };
    _proto._traverseLink = function _traverseLink(field, record) {
        var storageKey = $7b6008675210be49$var$getStorageKey(field, this._variables);
        var linkedID = $6ZixS.getLinkedRecordID(record, storageKey);
        if (linkedID == null) return;
        this._traverse(field, linkedID);
    };
    _proto._traversePluralLink = function _traversePluralLink(field, record) {
        var _this2 = this;
        var storageKey = $7b6008675210be49$var$getStorageKey(field, this._variables);
        var linkedIDs = $6ZixS.getLinkedRecordIDs(record, storageKey);
        if (linkedIDs == null) return;
        linkedIDs.forEach(function(linkedID) {
            if (linkedID != null) _this2._traverse(field, linkedID);
        });
    };
    return RelayReferenceMarker;
}();
module.exports = {
    mark: $7b6008675210be49$var$mark
};

});

parcelRegister("29zPn", function(module, exports) {
'use strict';
parcelRequire("fHswY");

var $fT9vU = parcelRequire("fT9vU");

var $kgraI = parcelRequire("kgraI");

var $hP5ju = parcelRequire("hP5ju");

var $aeZu2 = parcelRequire("aeZu2");

var $echTe = parcelRequire("echTe");
var $191836af119701dc$var$RelayStoreSubscriptions = /*#__PURE__*/ function() {
    function RelayStoreSubscriptions(log, resolverCache, resolverContext) {
        this._subscriptions = new Set();
        this.__log = log;
        this._resolverCache = resolverCache;
        this._resolverContext = resolverContext;
    }
    var _proto = RelayStoreSubscriptions.prototype;
    _proto.subscribe = function subscribe(snapshot, callback) {
        var _this = this;
        var subscription = {
            backup: null,
            callback: callback,
            snapshot: snapshot,
            stale: false
        };
        var dispose = function dispose() {
            _this._subscriptions["delete"](subscription);
        };
        this._subscriptions.add(subscription);
        return {
            dispose: dispose
        };
    };
    _proto.snapshotSubscriptions = function snapshotSubscriptions(source) {
        var _this2 = this;
        this._subscriptions.forEach(function(subscription) {
            if (!subscription.stale) {
                subscription.backup = subscription.snapshot;
                return;
            }
            var snapshot = subscription.snapshot;
            var backup = $echTe.read(source, snapshot.selector, _this2._resolverCache, _this2._resolverContext);
            var nextData = $fT9vU(snapshot.data, backup.data);
            backup.data = nextData;
            subscription.backup = backup;
        });
    };
    _proto.restoreSubscriptions = function restoreSubscriptions() {
        this._subscriptions.forEach(function(subscription) {
            var backup = subscription.backup;
            subscription.backup = null;
            if (backup) {
                if (backup.data !== subscription.snapshot.data) subscription.stale = true;
                subscription.snapshot = {
                    data: subscription.snapshot.data,
                    isMissingData: backup.isMissingData,
                    missingClientEdges: backup.missingClientEdges,
                    missingLiveResolverFields: backup.missingLiveResolverFields,
                    seenRecords: backup.seenRecords,
                    selector: backup.selector,
                    fieldErrors: backup.fieldErrors
                };
            } else subscription.stale = true;
        });
    };
    _proto.updateSubscriptions = function updateSubscriptions(source, updatedRecordIDs, updatedOwners, sourceOperation) {
        var _this3 = this;
        var hasUpdatedRecords = updatedRecordIDs.size !== 0;
        this._subscriptions.forEach(function(subscription) {
            var owner = _this3._updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation);
            if (owner != null) updatedOwners.push(owner);
        });
    };
    _proto._updateSubscription = function _updateSubscription(source, subscription, updatedRecordIDs, hasUpdatedRecords, sourceOperation) {
        var backup = subscription.backup, callback = subscription.callback, snapshot = subscription.snapshot, stale = subscription.stale;
        var hasOverlappingUpdates = hasUpdatedRecords && $hP5ju(snapshot.seenRecords, updatedRecordIDs);
        if (!stale && !hasOverlappingUpdates) return;
        var nextSnapshot = hasOverlappingUpdates || !backup ? $echTe.read(source, snapshot.selector, this._resolverCache, this._resolverContext) : backup;
        var nextData = $fT9vU(snapshot.data, nextSnapshot.data);
        nextSnapshot = {
            data: nextData,
            isMissingData: nextSnapshot.isMissingData,
            missingClientEdges: nextSnapshot.missingClientEdges,
            missingLiveResolverFields: nextSnapshot.missingLiveResolverFields,
            seenRecords: nextSnapshot.seenRecords,
            selector: nextSnapshot.selector,
            fieldErrors: nextSnapshot.fieldErrors
        };
        subscription.snapshot = nextSnapshot;
        subscription.stale = false;
        if (nextSnapshot.data !== snapshot.data) {
            if (this.__log && $kgraI.ENABLE_NOTIFY_SUBSCRIPTION) this.__log({
                name: 'store.notify.subscription',
                sourceOperation: sourceOperation,
                snapshot: snapshot,
                nextSnapshot: nextSnapshot
            });
            callback(nextSnapshot);
            return snapshot.selector.owner;
        }
        if ($kgraI.ENABLE_LOOSE_SUBSCRIPTION_ATTRIBUTION && (stale || $aeZu2(snapshot.seenRecords, updatedRecordIDs))) return snapshot.selector.owner;
    };
    _proto.size = function size() {
        return this._subscriptions.size;
    };
    return RelayStoreSubscriptions;
}();
module.exports = $191836af119701dc$var$RelayStoreSubscriptions;

});
parcelRegister("hP5ju", function(module, exports) {
'use strict';
var $cf9b5236e42c5cc8$var$ITERATOR_KEY = Symbol.iterator;
function $cf9b5236e42c5cc8$var$hasOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$cf9b5236e42c5cc8$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key)) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $cf9b5236e42c5cc8$var$hasOverlappingIDs;

});

parcelRegister("aeZu2", function(module, exports) {
'use strict';

var $cvcC4 = parcelRequire("cvcC4");
var $774ae78c69a540a0$var$ROOT_ID = $cvcC4.ROOT_ID;

var $iOxmF = parcelRequire("iOxmF");
var $774ae78c69a540a0$var$VIEWER_ID = $iOxmF.VIEWER_ID;
var $774ae78c69a540a0$var$ITERATOR_KEY = Symbol.iterator;
function $774ae78c69a540a0$var$hasSignificantOverlappingIDs(seenRecords, updatedRecordIDs) {
    var iterator = seenRecords[$774ae78c69a540a0$var$ITERATOR_KEY]();
    var next = iterator.next();
    while(!next.done){
        var key = next.value;
        if (updatedRecordIDs.has(key) && key !== $774ae78c69a540a0$var$ROOT_ID && key !== $774ae78c69a540a0$var$VIEWER_ID) return true;
        next = iterator.next();
    }
    return false;
}
module.exports = $774ae78c69a540a0$var$hasSignificantOverlappingIDs;

});



parcelRegister("i9pUG", function(module, exports) {
'use strict';
var $d36d2b12ee260529$var$_global$ErrorUtils$ap, $d36d2b12ee260529$var$_global$ErrorUtils;

var $Zx0mT = parcelRequire("Zx0mT");

var $8yw4N = parcelRequire("8yw4N");

var $5R0BP = parcelRequire("5R0BP");

var $kgraI = parcelRequire("kgraI");

var $echTe = parcelRequire("echTe");

var $gqyVK = parcelRequire("gqyVK");

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
var $d36d2b12ee260529$var$_global = typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : undefined;
var $d36d2b12ee260529$var$applyWithGuard = ($d36d2b12ee260529$var$_global$ErrorUtils$ap = $d36d2b12ee260529$var$_global === null || $d36d2b12ee260529$var$_global === void 0 ? void 0 : ($d36d2b12ee260529$var$_global$ErrorUtils = $d36d2b12ee260529$var$_global.ErrorUtils) === null || $d36d2b12ee260529$var$_global$ErrorUtils === void 0 ? void 0 : $d36d2b12ee260529$var$_global$ErrorUtils.applyWithGuard) !== null && $d36d2b12ee260529$var$_global$ErrorUtils$ap !== void 0 ? $d36d2b12ee260529$var$_global$ErrorUtils$ap : function(callback, context, args, onError, name) {
    return callback.apply(context, args);
};
var $d36d2b12ee260529$var$RelayPublishQueue = /*#__PURE__*/ function() {
    function RelayPublishQueue(store, handlerProvider, getDataID, missingFieldHandlers, log) {
        this._hasStoreSnapshot = false;
        this._handlerProvider = handlerProvider || null;
        this._pendingBackupRebase = false;
        this._pendingData = new Set();
        this._pendingOptimisticUpdates = new Set();
        this._store = store;
        this._appliedOptimisticUpdates = new Set();
        this._gcHold = null;
        this._getDataID = getDataID;
        this._missingFieldHandlers = missingFieldHandlers;
        this._log = log;
    }
    var _proto = RelayPublishQueue.prototype;
    _proto.applyUpdate = function applyUpdate(updater) {
        !(!this._appliedOptimisticUpdates.has(updater) && !this._pendingOptimisticUpdates.has(updater)) && $jwy7p(false);
        this._pendingOptimisticUpdates.add(updater);
    };
    _proto.revertUpdate = function revertUpdate(updater) {
        if (this._pendingOptimisticUpdates.has(updater)) this._pendingOptimisticUpdates["delete"](updater);
        else if (this._appliedOptimisticUpdates.has(updater)) {
            this._pendingBackupRebase = true;
            this._appliedOptimisticUpdates["delete"](updater);
        }
    };
    _proto.revertAll = function revertAll() {
        this._pendingBackupRebase = true;
        this._pendingOptimisticUpdates.clear();
        this._appliedOptimisticUpdates.clear();
    };
    _proto.commitPayload = function commitPayload(operation, payload, updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'payload',
            operation: operation,
            payload: payload,
            updater: updater
        });
    };
    _proto.commitUpdate = function commitUpdate(updater) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'updater',
            updater: updater
        });
    };
    _proto.commitSource = function commitSource(source) {
        this._pendingBackupRebase = true;
        this._pendingData.add({
            kind: 'source',
            source: source
        });
    };
    _proto.run = function run(sourceOperation) {
        var runWillClearGcHold = this._appliedOptimisticUpdates === 0 && !!this._gcHold;
        var runIsANoop = !this._pendingBackupRebase && this._pendingOptimisticUpdates.size === 0 && !runWillClearGcHold;
        $kgraI.DISALLOW_NESTED_UPDATES && !(this._isRunning !== true) && $jwy7p(false);
        this._isRunning = true;
        if (runIsANoop) {
            this._isRunning = false;
            return [];
        }
        if (this._pendingBackupRebase) {
            if (this._hasStoreSnapshot) {
                this._store.restore();
                this._hasStoreSnapshot = false;
            }
        }
        var invalidatedStore = this._commitData();
        if (this._pendingOptimisticUpdates.size || this._pendingBackupRebase && this._appliedOptimisticUpdates.size) {
            if (!this._hasStoreSnapshot) {
                this._store.snapshot();
                this._hasStoreSnapshot = true;
            }
            this._applyUpdates();
        }
        this._pendingBackupRebase = false;
        if (this._appliedOptimisticUpdates.size > 0) {
            if (!this._gcHold) this._gcHold = this._store.holdGC();
        } else if (this._gcHold) {
            this._gcHold.dispose();
            this._gcHold = null;
        }
        this._isRunning = false;
        return this._store.notify(sourceOperation, invalidatedStore);
    };
    _proto._publishSourceFromPayload = function _publishSourceFromPayload(pendingPayload) {
        var _this = this;
        var payload = pendingPayload.payload, operation = pendingPayload.operation, updater = pendingPayload.updater;
        var source = payload.source, fieldPayloads = payload.fieldPayloads;
        var mutator = new $Zx0mT(this._store.getSource(), source);
        var recordSourceProxy = new $8yw4N(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        if (fieldPayloads && fieldPayloads.length) fieldPayloads.forEach(function(fieldPayload) {
            var handler = _this._handlerProvider && _this._handlerProvider(fieldPayload.handle);
            !handler && $jwy7p(false);
            handler.update(recordSourceProxy, fieldPayload);
        });
        if (updater) {
            var selector = operation.fragment;
            !(selector != null) && $jwy7p(false);
            var recordSourceSelectorProxy = new $5R0BP(mutator, recordSourceProxy, selector, this._missingFieldHandlers);
            var selectorData = $d36d2b12ee260529$var$lookupSelector(source, selector);
            updater(recordSourceSelectorProxy, selectorData);
        }
        var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
        this._store.publish(source, idsMarkedForInvalidation);
        return recordSourceProxy.isStoreMarkedForInvalidation();
    };
    _proto._commitData = function _commitData() {
        var _this2 = this;
        if (!this._pendingData.size) return false;
        var invalidatedStore = false;
        this._pendingData.forEach(function(data) {
            if (data.kind === 'payload') {
                var payloadInvalidatedStore = _this2._publishSourceFromPayload(data);
                invalidatedStore = invalidatedStore || payloadInvalidatedStore;
            } else if (data.kind === 'source') {
                var source = data.source;
                _this2._store.publish(source);
            } else {
                var updater = data.updater;
                var sink = $gqyVK.create();
                var mutator = new $Zx0mT(_this2._store.getSource(), sink);
                var recordSourceProxy = new $8yw4N(mutator, _this2._getDataID, _this2._handlerProvider, _this2._missingFieldHandlers, _this2._log);
                $d36d2b12ee260529$var$applyWithGuard(updater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:commitData');
                invalidatedStore = invalidatedStore || recordSourceProxy.isStoreMarkedForInvalidation();
                var idsMarkedForInvalidation = recordSourceProxy.getIDsMarkedForInvalidation();
                _this2._store.publish(sink, idsMarkedForInvalidation);
            }
        });
        this._pendingData.clear();
        return invalidatedStore;
    };
    _proto._applyUpdates = function _applyUpdates() {
        var _this3 = this;
        var sink = $gqyVK.create();
        var mutator = new $Zx0mT(this._store.getSource(), sink);
        var recordSourceProxy = new $8yw4N(mutator, this._getDataID, this._handlerProvider, this._missingFieldHandlers, this._log);
        var processUpdate = function processUpdate(optimisticUpdate) {
            if (optimisticUpdate.storeUpdater) {
                var storeUpdater = optimisticUpdate.storeUpdater;
                $d36d2b12ee260529$var$applyWithGuard(storeUpdater, null, [
                    recordSourceProxy
                ], null, 'RelayPublishQueue:applyUpdates');
            } else {
                var operation = optimisticUpdate.operation, payload = optimisticUpdate.payload, updater = optimisticUpdate.updater;
                var source = payload.source, fieldPayloads = payload.fieldPayloads;
                if (source) recordSourceProxy.publishSource(source, fieldPayloads);
                if (updater) {
                    var selectorData;
                    if (source) selectorData = $d36d2b12ee260529$var$lookupSelector(source, operation.fragment);
                    var recordSourceSelectorProxy = new $5R0BP(mutator, recordSourceProxy, operation.fragment, _this3._missingFieldHandlers);
                    $d36d2b12ee260529$var$applyWithGuard(updater, null, [
                        recordSourceSelectorProxy,
                        selectorData
                    ], null, 'RelayPublishQueue:applyUpdates');
                }
            }
        };
        if (this._pendingBackupRebase && this._appliedOptimisticUpdates.size) this._appliedOptimisticUpdates.forEach(processUpdate);
        if (this._pendingOptimisticUpdates.size) {
            this._pendingOptimisticUpdates.forEach(function(optimisticUpdate) {
                processUpdate(optimisticUpdate);
                _this3._appliedOptimisticUpdates.add(optimisticUpdate);
            });
            this._pendingOptimisticUpdates.clear();
        }
        this._store.publish(sink);
    };
    return RelayPublishQueue;
}();
function $d36d2b12ee260529$var$lookupSelector(source, selector) {
    var selectorData = $echTe.read(source, selector).data;
    var deepFreeze;
    return selectorData;
}
module.exports = $d36d2b12ee260529$var$RelayPublishQueue;

});
parcelRegister("5R0BP", function(module, exports) {
'use strict';

var $cvcC4 = parcelRequire("cvcC4");
var $44325ff261e1625b$var$ROOT_TYPE = $cvcC4.ROOT_TYPE, $44325ff261e1625b$var$getStorageKey = $cvcC4.getStorageKey;

var $1yI9z = parcelRequire("1yI9z");
var $44325ff261e1625b$var$_readUpdatableFragment = $1yI9z.readUpdatableFragment;

var $g5U5y = parcelRequire("g5U5y");
var $44325ff261e1625b$var$_readUpdatableQuery = $g5U5y.readUpdatableQuery;

var $jwy7p = parcelRequire("jwy7p");
var $44325ff261e1625b$var$RelayRecordSourceSelectorProxy = /*#__PURE__*/ function() {
    function RelayRecordSourceSelectorProxy(mutator, recordSource, readSelector, missingFieldHandlers) {
        this.__mutator = mutator;
        this.__recordSource = recordSource;
        this._readSelector = readSelector;
        this._missingFieldHandlers = missingFieldHandlers;
    }
    var _proto = RelayRecordSourceSelectorProxy.prototype;
    _proto.create = function create(dataID, typeName) {
        return this.__recordSource.create(dataID, typeName);
    };
    _proto["delete"] = function _delete(dataID) {
        this.__recordSource["delete"](dataID);
    };
    _proto.get = function get(dataID) {
        return this.__recordSource.get(dataID);
    };
    _proto.getRoot = function getRoot() {
        return this.__recordSource.getRoot();
    };
    _proto.getOperationRoot = function getOperationRoot() {
        var root = this.__recordSource.get(this._readSelector.dataID);
        if (!root) root = this.__recordSource.create(this._readSelector.dataID, $44325ff261e1625b$var$ROOT_TYPE);
        return root;
    };
    _proto._getRootField = function _getRootField(selector, fieldName, plural) {
        var field = selector.node.selections.find(function(selection) {
            return selection.kind === 'LinkedField' && selection.name === fieldName || selection.kind === 'RequiredField' && selection.field.name === fieldName;
        });
        if (field && field.kind === 'RequiredField') field = field.field;
        !(field && field.kind === 'LinkedField') && $jwy7p(false);
        !(field.plural === plural) && $jwy7p(false);
        return field;
    };
    _proto.getRootField = function getRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, false);
        var storageKey = $44325ff261e1625b$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecord(storageKey);
    };
    _proto.getPluralRootField = function getPluralRootField(fieldName) {
        var field = this._getRootField(this._readSelector, fieldName, true);
        var storageKey = $44325ff261e1625b$var$getStorageKey(field, this._readSelector.variables);
        return this.getOperationRoot().getLinkedRecords(storageKey);
    };
    _proto.invalidateStore = function invalidateStore() {
        this.__recordSource.invalidateStore();
    };
    _proto.readUpdatableQuery = function readUpdatableQuery(query, variables) {
        return $44325ff261e1625b$var$_readUpdatableQuery(query, variables, this, this._missingFieldHandlers);
    };
    _proto.readUpdatableFragment = function readUpdatableFragment(fragment, fragmentReference) {
        return $44325ff261e1625b$var$_readUpdatableFragment(fragment, fragmentReference, this, this._missingFieldHandlers);
    };
    return RelayRecordSourceSelectorProxy;
}();
module.exports = $44325ff261e1625b$var$RelayRecordSourceSelectorProxy;

});



parcelRegister("6DpFX", function(module, exports) {
'use strict';

var $5RzQz = parcelRequire("5RzQz");

var $lQR7T = parcelRequire("lQR7T");
var $4d4a4d4345005ee6$var$getRequest = $lQR7T.getRequest;

var $1v3vf = parcelRequire("1v3vf");
var $4d4a4d4345005ee6$var$createOperationDescriptor = $1v3vf.createOperationDescriptor;

var $dPVEr = parcelRequire("dPVEr");
var $4d4a4d4345005ee6$var$createReaderSelector = $dPVEr.createReaderSelector;
parcelRequire("i0yon");
function $4d4a4d4345005ee6$var$requestSubscription(environment, config) {
    var subscription = $4d4a4d4345005ee6$var$getRequest(config.subscription);
    if (subscription.params.operationKind !== 'subscription') throw new Error('requestSubscription: Must use Subscription operation');
    var configs = config.configs, onCompleted = config.onCompleted, onError = config.onError, onNext = config.onNext, variables = config.variables, cacheConfig = config.cacheConfig;
    var operation = $4d4a4d4345005ee6$var$createOperationDescriptor(subscription, variables, cacheConfig);
    var _ref = configs ? $5RzQz.convert(configs, subscription, null, config.updater) : config, updater = _ref.updater;
    var sub = environment.executeSubscription({
        operation: operation,
        updater: updater
    }).subscribe({
        next: function next(responses) {
            if (onNext != null) {
                var selector = operation.fragment;
                var nextID;
                if (Array.isArray(responses)) {
                    var _responses$, _responses$$extension;
                    nextID = (_responses$ = responses[0]) === null || _responses$ === void 0 ? void 0 : (_responses$$extension = _responses$.extensions) === null || _responses$$extension === void 0 ? void 0 : _responses$$extension.__relay_subscription_root_id;
                } else {
                    var _responses$extensions;
                    nextID = (_responses$extensions = responses.extensions) === null || _responses$extensions === void 0 ? void 0 : _responses$extensions.__relay_subscription_root_id;
                }
                if (typeof nextID === 'string') selector = $4d4a4d4345005ee6$var$createReaderSelector(selector.node, nextID, selector.variables, selector.owner);
                var data = environment.lookup(selector).data;
                onNext(data);
            }
        },
        error: onError,
        complete: onCompleted
    });
    return {
        dispose: sub.unsubscribe
    };
}
module.exports = $4d4a4d4345005ee6$var$requestSubscription;

});

parcelRegister("2rPtW", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $1c8609a660bb0674$var$_interopRequireDefault = $8gviu.default;

var $1c8609a660bb0674$var$_objectSpread2 = $1c8609a660bb0674$var$_interopRequireDefault((parcelRequire("lhogL")));

var $cvcC4 = parcelRequire("cvcC4");
var $1c8609a660bb0674$var$getModuleComponentKey = $cvcC4.getModuleComponentKey, $1c8609a660bb0674$var$getModuleOperationKey = $cvcC4.getModuleOperationKey;
function $1c8609a660bb0674$var$createPayloadFor3DField(name, operation, component, response) {
    var data = (0, $1c8609a660bb0674$var$_objectSpread2["default"])({}, response);
    data[$1c8609a660bb0674$var$getModuleComponentKey(name)] = component;
    data[$1c8609a660bb0674$var$getModuleOperationKey(name)] = operation;
    return data;
}
module.exports = $1c8609a660bb0674$var$createPayloadFor3DField;

});

parcelRegister("k61LS", function(module, exports) {
'use strict';

var $dPVEr = parcelRequire("dPVEr");
var $ea15bde6d70b2537$var$getDataIDsFromFragment = $dPVEr.getDataIDsFromFragment, $ea15bde6d70b2537$var$getSelector = $dPVEr.getSelector, $ea15bde6d70b2537$var$getVariablesFromFragment = $dPVEr.getVariablesFromFragment;

var $bznhw = parcelRequire("bznhw");

var $kgraI = parcelRequire("kgraI");

var $zM4Yi = parcelRequire("zM4Yi");
var $ea15bde6d70b2537$var$stableCopy = $zM4Yi.stableCopy;

var $4mHYE = parcelRequire("4mHYE");
var $ea15bde6d70b2537$var$intern = $4mHYE.intern;
function $ea15bde6d70b2537$var$getFragmentIdentifier(fragmentNode, fragmentRef) {
    var selector = $ea15bde6d70b2537$var$getSelector(fragmentNode, fragmentRef);
    var fragmentOwnerIdentifier = selector == null ? 'null' : selector.kind === 'SingularReaderSelector' ? selector.owner.identifier : '[' + selector.selectors.map(function(sel) {
        return sel.owner.identifier;
    }).join(',') + ']';
    var fragmentVariables = $ea15bde6d70b2537$var$getVariablesFromFragment(fragmentNode, fragmentRef);
    var dataIDs = $ea15bde6d70b2537$var$getDataIDsFromFragment(fragmentNode, fragmentRef);
    if ($kgraI.ENABLE_GETFRAGMENTIDENTIFIER_OPTIMIZATION) {
        var ids = typeof dataIDs === 'undefined' ? 'missing' : dataIDs == null ? 'null' : Array.isArray(dataIDs) ? '[' + dataIDs.join(',') + ']' : dataIDs;
        ids = $kgraI.STRING_INTERN_LEVEL <= 1 ? ids : $ea15bde6d70b2537$var$intern(ids, $kgraI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + (fragmentVariables == null || $bznhw(fragmentVariables) ? '{}' : JSON.stringify($ea15bde6d70b2537$var$stableCopy(fragmentVariables))) + '/' + ids;
    } else {
        var _JSON$stringify;
        var _ids = (_JSON$stringify = JSON.stringify(dataIDs)) !== null && _JSON$stringify !== void 0 ? _JSON$stringify : 'missing';
        _ids = $kgraI.STRING_INTERN_LEVEL <= 1 ? _ids : $ea15bde6d70b2537$var$intern(_ids, $kgraI.MAX_DATA_ID_LENGTH);
        return fragmentOwnerIdentifier + '/' + fragmentNode.name + '/' + JSON.stringify($ea15bde6d70b2537$var$stableCopy(fragmentVariables)) + '/' + _ids;
    }
}
module.exports = $ea15bde6d70b2537$var$getFragmentIdentifier;

});
parcelRegister("bznhw", function(module, exports) {
'use strict';
var $86c505d4227b0f01$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $86c505d4227b0f01$var$isEmptyObject(obj) {
    for(var _key in obj){
        if ($86c505d4227b0f01$var$hasOwnProperty.call(obj, _key)) return false;
    }
    return true;
}
module.exports = $86c505d4227b0f01$var$isEmptyObject;

});


parcelRegister("7DV09", function(module, exports) {
'use strict';

var $6Jn6k = parcelRequire("6Jn6k");

var $jwy7p = parcelRequire("jwy7p");
function $5908643ed2d8546e$var$getPaginationMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var _getRefetchMetadata = $6Jn6k(fragmentNode, componentDisplayName), paginationRequest = _getRefetchMetadata.refetchableRequest, refetchMetadata = _getRefetchMetadata.refetchMetadata;
    var paginationMetadata = refetchMetadata.connection;
    !(paginationMetadata != null) && $jwy7p(false);
    var connectionPathInFragmentData = paginationMetadata.path;
    var connectionMetadata = ((_fragmentNode$metadat = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.connection) !== null && _fragmentNode$metadat !== void 0 ? _fragmentNode$metadat : [])[0];
    !(connectionMetadata != null) && $jwy7p(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    !((identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) == null || typeof identifierInfo.identifierField === 'string') && $jwy7p(false);
    return {
        connectionPathInFragmentData: connectionPathInFragmentData,
        identifierField: identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField,
        paginationRequest: paginationRequest,
        paginationMetadata: paginationMetadata,
        stream: connectionMetadata.stream === true
    };
}
module.exports = $5908643ed2d8546e$var$getPaginationMetadata;

});
parcelRegister("6Jn6k", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
function $4e68dd6cdb59a0fe$var$getRefetchMetadata(fragmentNode, componentDisplayName) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    !(((_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) !== true) && $jwy7p(false);
    var refetchMetadata = (_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.refetch;
    !(refetchMetadata != null) && $jwy7p(false);
    var refetchableRequest = refetchMetadata.operation["default"] ? refetchMetadata.operation["default"] : refetchMetadata.operation;
    var fragmentRefPathInResponse = refetchMetadata.fragmentPathInResult;
    !(typeof refetchableRequest !== 'string') && $jwy7p(false);
    var identifierInfo = refetchMetadata.identifierInfo;
    if (identifierInfo != null) {
        !(identifierInfo.identifierField == null || typeof identifierInfo.identifierField === 'string') && $jwy7p(false);
        !(identifierInfo.identifierQueryVariableName == null || typeof identifierInfo.identifierQueryVariableName === 'string') && $jwy7p(false);
    }
    return {
        fragmentRefPathInResponse: fragmentRefPathInResponse,
        identifierInfo: identifierInfo,
        refetchableRequest: refetchableRequest,
        refetchMetadata: refetchMetadata
    };
}
module.exports = $4e68dd6cdb59a0fe$var$getRefetchMetadata;

});


parcelRegister("65k9J", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $46e2d83f25b12637$var$_interopRequireDefault = $8gviu.default;

var $46e2d83f25b12637$var$_defineProperty2 = $46e2d83f25b12637$var$_interopRequireDefault((parcelRequire("dangC")));

var $46e2d83f25b12637$var$_objectSpread4 = $46e2d83f25b12637$var$_interopRequireDefault((parcelRequire("lhogL")));

var $jwy7p = parcelRequire("jwy7p");
parcelRequire("i0yon");
function $46e2d83f25b12637$var$getPaginationVariables(direction, count, cursor, baseVariables, extraVariables, paginationMetadata) {
    var _objectSpread3;
    var backwardMetadata = paginationMetadata.backward, forwardMetadata = paginationMetadata.forward;
    if (direction === 'backward') {
        var _objectSpread2;
        !(backwardMetadata != null && backwardMetadata.count != null && backwardMetadata.cursor != null) && $jwy7p(false);
        var _paginationVariables = (0, $46e2d83f25b12637$var$_objectSpread4["default"])((0, $46e2d83f25b12637$var$_objectSpread4["default"])((0, $46e2d83f25b12637$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread2 = {}, (0, $46e2d83f25b12637$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.cursor, cursor), (0, $46e2d83f25b12637$var$_defineProperty2["default"])(_objectSpread2, backwardMetadata.count, count), _objectSpread2));
        if (forwardMetadata && forwardMetadata.cursor) _paginationVariables[forwardMetadata.cursor] = null;
        if (forwardMetadata && forwardMetadata.count) _paginationVariables[forwardMetadata.count] = null;
        return _paginationVariables;
    }
    !(forwardMetadata != null && forwardMetadata.count != null && forwardMetadata.cursor != null) && $jwy7p(false);
    var paginationVariables = (0, $46e2d83f25b12637$var$_objectSpread4["default"])((0, $46e2d83f25b12637$var$_objectSpread4["default"])((0, $46e2d83f25b12637$var$_objectSpread4["default"])({}, baseVariables), extraVariables), {}, (_objectSpread3 = {}, (0, $46e2d83f25b12637$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.cursor, cursor), (0, $46e2d83f25b12637$var$_defineProperty2["default"])(_objectSpread3, forwardMetadata.count, count), _objectSpread3));
    if (backwardMetadata && backwardMetadata.cursor) paginationVariables[backwardMetadata.cursor] = null;
    if (backwardMetadata && backwardMetadata.count) paginationVariables[backwardMetadata.count] = null;
    return paginationVariables;
}
module.exports = $46e2d83f25b12637$var$getPaginationVariables;

});

parcelRegister("b0rkD", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $8034e5538f1c9048$var$_interopRequireDefault = $8gviu.default;

var $8034e5538f1c9048$var$_createForOfIteratorHelper2 = $8034e5538f1c9048$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $jwy7p = parcelRequire("jwy7p");
function $8034e5538f1c9048$var$getValueAtPath(data, path) {
    var result = data;
    var _iterator = (0, $8034e5538f1c9048$var$_createForOfIteratorHelper2["default"])(path), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var key = _step.value;
            if (result == null) return null;
            if (typeof key === 'number') {
                !Array.isArray(result) && $jwy7p(false);
                result = result[key];
            } else {
                !(typeof result === 'object' && !Array.isArray(result)) && $jwy7p(false);
                result = result[key];
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return result;
}
module.exports = $8034e5538f1c9048$var$getValueAtPath;

});

parcelRegister("jR3oE", function(module, exports) {
'use strict';
var $e7459a13ab81d49f$var$profileHandlersByName = {};
var $e7459a13ab81d49f$var$defaultProfiler = {
    stop: function stop() {}
};
var $e7459a13ab81d49f$var$RelayProfiler = {
    profile: function profile(name, state) {
        var handlers = $e7459a13ab81d49f$var$profileHandlersByName[name];
        if (handlers && handlers.length > 0) {
            var stopHandlers = [];
            for(var ii = handlers.length - 1; ii >= 0; ii--){
                var stopHandler = handlers[ii](name, state);
                stopHandlers.unshift(stopHandler);
            }
            return {
                stop: function stop(error) {
                    stopHandlers.forEach(function(stopHandler) {
                        return stopHandler(error);
                    });
                }
            };
        }
        return $e7459a13ab81d49f$var$defaultProfiler;
    },
    attachProfileHandler: function attachProfileHandler(name, handler) {
        if (!$e7459a13ab81d49f$var$profileHandlersByName.hasOwnProperty(name)) $e7459a13ab81d49f$var$profileHandlersByName[name] = [];
        $e7459a13ab81d49f$var$profileHandlersByName[name].push(handler);
    },
    detachProfileHandler: function detachProfileHandler(name, handler) {
        if ($e7459a13ab81d49f$var$profileHandlersByName.hasOwnProperty(name)) $e7459a13ab81d49f$var$removeFromArray($e7459a13ab81d49f$var$profileHandlersByName[name], handler);
    }
};
function $e7459a13ab81d49f$var$removeFromArray(array, element) {
    var index = array.indexOf(element);
    if (index !== -1) array.splice(index, 1);
}
module.exports = $e7459a13ab81d49f$var$RelayProfiler;

});




parcelRegister("65VWP", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $470028ede111b721$var$_interopRequireDefault = $8gviu.default;

var $470028ede111b721$var$_extends2 = $470028ede111b721$var$_interopRequireDefault((parcelRequire("a7Fos")));

var $470028ede111b721$var$_objectWithoutPropertiesLoose2 = $470028ede111b721$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $470028ede111b721$var$_assertThisInitialized2 = $470028ede111b721$var$_interopRequireDefault((parcelRequire("dKInO")));

var $470028ede111b721$var$_inheritsLoose2 = $470028ede111b721$var$_interopRequireDefault((parcelRequire("9FsID")));

var $470028ede111b721$var$_defineProperty2 = $470028ede111b721$var$_interopRequireDefault((parcelRequire("dangC")));
var $470028ede111b721$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $aQgPH = parcelRequire("aQgPH");

var $7SzQn = parcelRequire("7SzQn");
var $470028ede111b721$var$getContainerName = $7SzQn.getContainerName;

var $aaS4i = parcelRequire("aaS4i");
var $470028ede111b721$var$assertRelayContext = $aaS4i.assertRelayContext;

var $l5wS4 = parcelRequire("l5wS4");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $470028ede111b721$var$createFragmentSpecResolver = $lIGkE.createFragmentSpecResolver, $470028ede111b721$var$getDataIDsFromObject = $lIGkE.getDataIDsFromObject, $470028ede111b721$var$isScalarAndEqual = $lIGkE.isScalarAndEqual;
function $470028ede111b721$var$createContainerWithFragments(Component, fragments) {
    var _class;
    var containerName = $470028ede111b721$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $470028ede111b721$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $470028ede111b721$var$_defineProperty2["default"])((0, $470028ede111b721$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve(),
                        relayProp: $470028ede111b721$var$getRelayProp(updatedState.relayProp.environment)
                    } : null;
                });
            });
            var relayContext = $470028ede111b721$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            var resolver = $470028ede111b721$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                prevProps: props,
                prevPropsContext: relayContext,
                relayProp: $470028ede111b721$var$getRelayProp(relayContext.environment),
                resolver: resolver
            };
            return _this;
        }
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $470028ede111b721$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $470028ede111b721$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $470028ede111b721$var$getDataIDsFromObject(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$l5wS4(prevIDs, nextIDs)) {
                resolver = $470028ede111b721$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    prevPropsContext: relayContext,
                    prevProps: nextProps,
                    relayProp: $470028ede111b721$var$getRelayProp(relayContext.environment),
                    resolver: resolver
                };
            } else {
                resolver.setProps(nextProps);
                var data = resolver.resolve();
                if (data !== prevState.data) return {
                    data: data,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    relayProp: $470028ede111b721$var$getRelayProp(relayContext.environment)
                };
            }
            return null;
        };
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.state.resolver.dispose();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevPropsContext.environment !== this.state.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$470028ede111b721$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $470028ede111b721$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $470028ede111b721$var$_excluded);
            return /*#__PURE__*/ $euxye.createElement(Component, (0, $470028ede111b721$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            }));
        };
        return _class;
    }($euxye.Component), (0, $470028ede111b721$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $470028ede111b721$var$getRelayProp(environment) {
    return {
        environment: environment
    };
}
function $470028ede111b721$var$createContainer(Component, fragmentSpec) {
    return $aQgPH(Component, fragmentSpec, $470028ede111b721$var$createContainerWithFragments);
}
module.exports = {
    createContainer: $470028ede111b721$var$createContainer
};

});
parcelRegister("aQgPH", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $7e4bd16205b312f8$var$_interopRequireDefault = $8gviu.default;

var $7e4bd16205b312f8$var$_extends2 = $7e4bd16205b312f8$var$_interopRequireDefault((parcelRequire("a7Fos")));

var $10ACh = parcelRequire("10ACh");

var $7SzQn = parcelRequire("7SzQn");
var $7e4bd16205b312f8$var$getComponentName = $7SzQn.getComponentName, $7e4bd16205b312f8$var$getContainerName = $7SzQn.getContainerName;

var $hBqK0 = parcelRequire("hBqK0");

var $i2fgQ = parcelRequire("i2fgQ");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $7e4bd16205b312f8$var$getFragment = $lIGkE.getFragment;
var $7e4bd16205b312f8$var$useContext = $euxye.useContext;
function $7e4bd16205b312f8$var$buildReactRelayContainer(ComponentClass, fragmentSpec, createContainerWithFragments) {
    var containerName = $7e4bd16205b312f8$var$getContainerName(ComponentClass);
    $10ACh($7e4bd16205b312f8$var$getComponentName(ComponentClass), fragmentSpec);
    var fragments = {};
    for(var key in fragmentSpec)fragments[key] = $7e4bd16205b312f8$var$getFragment(fragmentSpec[key]);
    var Container = createContainerWithFragments(ComponentClass, fragments);
    Container.displayName = containerName;
    function ForwardRef(props, ref) {
        var _queryRendererContext;
        var context = $7e4bd16205b312f8$var$useContext($hBqK0);
        !(context != null) && $jwy7p(false);
        var queryRendererContext = $7e4bd16205b312f8$var$useContext($i2fgQ);
        return /*#__PURE__*/ $euxye.createElement(Container, (0, $7e4bd16205b312f8$var$_extends2["default"])({}, props, {
            __relayContext: context,
            __rootIsQueryRenderer: (_queryRendererContext = queryRendererContext === null || queryRendererContext === void 0 ? void 0 : queryRendererContext.rootIsQueryRenderer) !== null && _queryRendererContext !== void 0 ? _queryRendererContext : false,
            componentRef: props.componentRef || ref
        }));
    }
    ForwardRef.displayName = containerName;
    var ForwardContainer = $euxye.forwardRef(ForwardRef);
    return ForwardContainer;
}
module.exports = $7e4bd16205b312f8$var$buildReactRelayContainer;

});
parcelRegister("10ACh", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
function $0bc231c63f31beaf$var$assertFragmentMap(componentName, fragmentSpec) {
    !(fragmentSpec && typeof fragmentSpec === 'object') && $jwy7p(false);
    for(var key in fragmentSpec)if (fragmentSpec.hasOwnProperty(key)) {
        var fragment = fragmentSpec[key];
        !(fragment && (typeof fragment === 'object' || typeof fragment === 'function')) && $jwy7p(false);
    }
}
module.exports = $0bc231c63f31beaf$var$assertFragmentMap;

});

parcelRegister("7SzQn", function(module, exports) {
'use strict';
function $5bc96161a13a0f76$var$getComponentName(component) {
    return component.displayName || component.name || 'Component';
}
function $5bc96161a13a0f76$var$getContainerName(Component) {
    return 'Relay(' + $5bc96161a13a0f76$var$getComponentName(Component) + ')';
}
module.exports = {
    getComponentName: $5bc96161a13a0f76$var$getComponentName,
    getContainerName: $5bc96161a13a0f76$var$getContainerName
};

});

parcelRegister("i2fgQ", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");
module.exports = $euxye.createContext({
    rootIsQueryRenderer: false
});

});


parcelRegister("aaS4i", function(module, exports) {
'use strict';

var $2IKNB = parcelRequire("2IKNB");

var $jwy7p = parcelRequire("jwy7p");
function $7684c7660d527e89$var$assertRelayContext(relay) {
    !$7684c7660d527e89$var$isRelayContext(relay) && $jwy7p(false);
    return relay;
}
function $7684c7660d527e89$var$isRelayContext(context) {
    return typeof context === 'object' && context !== null && !Array.isArray(context) && $2IKNB(context.environment);
}
module.exports = {
    assertRelayContext: $7684c7660d527e89$var$assertRelayContext,
    isRelayContext: $7684c7660d527e89$var$isRelayContext
};

});
parcelRegister("2IKNB", function(module, exports) {
'use strict';
function $1fb3fe2a94d3da2c$var$isRelayEnvironment(environment) {
    return typeof environment === 'object' && environment !== null && typeof environment.check === 'function' && typeof environment.lookup === 'function' && typeof environment.retain === 'function' && typeof environment.execute === 'function' && typeof environment.subscribe === 'function';
}
module.exports = $1fb3fe2a94d3da2c$var$isRelayEnvironment;

});


parcelRegister("l5wS4", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ var $f5a3901ed3b05dea$var$aStackPool = [];
var $f5a3901ed3b05dea$var$bStackPool = [];
/**
 * Checks if two values are equal. Values may be primitives, arrays, or objects.
 * Returns true if both arguments have the same keys and values.
 *
 * @see http://underscorejs.org
 * @copyright 2009-2013 Jeremy Ashkenas, DocumentCloud Inc.
 * @license MIT
 */ function $f5a3901ed3b05dea$var$areEqual(a, b) {
    var aStack = $f5a3901ed3b05dea$var$aStackPool.length ? $f5a3901ed3b05dea$var$aStackPool.pop() : [];
    var bStack = $f5a3901ed3b05dea$var$bStackPool.length ? $f5a3901ed3b05dea$var$bStackPool.pop() : [];
    var result = $f5a3901ed3b05dea$var$eq(a, b, aStack, bStack);
    aStack.length = 0;
    bStack.length = 0;
    $f5a3901ed3b05dea$var$aStackPool.push(aStack);
    $f5a3901ed3b05dea$var$bStackPool.push(bStack);
    return result;
}
function $f5a3901ed3b05dea$var$eq(a, b, aStack, bStack) {
    if (a === b) // Identical objects are equal. `0 === -0`, but they aren't identical.
    return a !== 0 || 1 / a == 1 / b;
    if (a == null || b == null) // a or b can be `null` or `undefined`
    return false;
    if (typeof a != 'object' || typeof b != 'object') return false;
    var objToStr = Object.prototype.toString;
    var className = objToStr.call(a);
    if (className != objToStr.call(b)) return false;
    switch(className){
        case '[object String]':
            return a == String(b);
        case '[object Number]':
            return isNaN(a) || isNaN(b) ? false : a == Number(b);
        case '[object Date]':
        case '[object Boolean]':
            return +a == +b;
        case '[object RegExp]':
            return a.source == b.source && a.global == b.global && a.multiline == b.multiline && a.ignoreCase == b.ignoreCase;
    } // Assume equality for cyclic structures.
    var length = aStack.length;
    while(length--){
        if (aStack[length] == a) return bStack[length] == b;
    }
    aStack.push(a);
    bStack.push(b);
    var size = 0; // Recursively compare objects and arrays.
    if (className === '[object Array]') {
        size = a.length;
        if (size !== b.length) return false;
         // Deep compare the contents, ignoring non-numeric properties.
        while(size--){
            if (!$f5a3901ed3b05dea$var$eq(a[size], b[size], aStack, bStack)) return false;
        }
    } else {
        if (a.constructor !== b.constructor) return false;
        if (a.hasOwnProperty('valueOf') && b.hasOwnProperty('valueOf')) return a.valueOf() == b.valueOf();
        var keys = Object.keys(a);
        if (keys.length != Object.keys(b).length) return false;
        for(var i = 0; i < keys.length; i++){
            if (!$f5a3901ed3b05dea$var$eq(a[keys[i]], b[keys[i]], aStack, bStack)) return false;
        }
    }
    aStack.pop();
    bStack.pop();
    return true;
}
module.exports = $f5a3901ed3b05dea$var$areEqual;

});


parcelRegister("kXVrK", function(module, exports) {
'use strict';

var $hBqK0 = parcelRequire("hBqK0");

var $i2fgQ = parcelRequire("i2fgQ");

var $l5wS4 = parcelRequire("l5wS4");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $f435e10198e4b628$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $f435e10198e4b628$var$deepFreeze = $lIGkE.deepFreeze, $f435e10198e4b628$var$getRequest = $lIGkE.getRequest;
var $f435e10198e4b628$var$useLayoutEffect = $euxye.useLayoutEffect, $f435e10198e4b628$var$useState = $euxye.useState, $f435e10198e4b628$var$useRef = $euxye.useRef, $f435e10198e4b628$var$useMemo = $euxye.useMemo;
var $f435e10198e4b628$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
function $f435e10198e4b628$var$useDeepCompare(value) {
    var latestValue = $euxye.useRef(value);
    if (!$l5wS4(latestValue.current, value)) latestValue.current = value;
    return latestValue.current;
}
function $f435e10198e4b628$var$ReactRelayLocalQueryRenderer(props) {
    var environment = props.environment, query = props.query, variables = props.variables, render = props.render;
    var latestVariables = $f435e10198e4b628$var$useDeepCompare(variables);
    var operation = $f435e10198e4b628$var$useMemo(function() {
        var request = $f435e10198e4b628$var$getRequest(query);
        return $f435e10198e4b628$var$createOperationDescriptor(request, latestVariables);
    }, [
        query,
        latestVariables
    ]);
    var relayContext = $f435e10198e4b628$var$useMemo(function() {
        return {
            environment: environment
        };
    }, [
        environment
    ]);
    var dataRef = $f435e10198e4b628$var$useRef(null);
    var _useState = $f435e10198e4b628$var$useState(null), forceUpdate = _useState[1];
    var cleanupFnRef = $f435e10198e4b628$var$useRef(null);
    var snapshot = $f435e10198e4b628$var$useMemo(function() {
        environment.check(operation);
        var res = environment.lookup(operation.fragment);
        dataRef.current = res.data;
        var retainDisposable = environment.retain(operation);
        var subscribeDisposable = environment.subscribe(res, function(newSnapshot) {
            dataRef.current = newSnapshot.data;
            forceUpdate(dataRef.current);
        });
        var disposed = false;
        function nextCleanupFn() {
            if (!disposed) {
                disposed = true;
                cleanupFnRef.current = null;
                retainDisposable.dispose();
                subscribeDisposable.dispose();
            }
        }
        if (cleanupFnRef.current) cleanupFnRef.current();
        cleanupFnRef.current = nextCleanupFn;
        return res;
    }, [
        environment,
        operation
    ]);
    $f435e10198e4b628$var$useLayoutEffect(function() {
        var cleanupFn = cleanupFnRef.current;
        return function() {
            cleanupFn && cleanupFn();
        };
    }, [
        snapshot
    ]);
    return /*#__PURE__*/ $euxye.createElement($hBqK0.Provider, {
        value: relayContext
    }, /*#__PURE__*/ $euxye.createElement($i2fgQ.Provider, {
        value: $f435e10198e4b628$var$queryRendererContext
    }, render({
        props: dataRef.current
    })));
}
module.exports = $f435e10198e4b628$var$ReactRelayLocalQueryRenderer;

});

parcelRegister("lXw4I", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $ffc7fd1ae1e6977b$var$_interopRequireDefault = $8gviu.default;

var $ffc7fd1ae1e6977b$var$_extends2 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("a7Fos")));

var $ffc7fd1ae1e6977b$var$_objectWithoutPropertiesLoose2 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $ffc7fd1ae1e6977b$var$_assertThisInitialized2 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("dKInO")));

var $ffc7fd1ae1e6977b$var$_inheritsLoose2 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("9FsID")));

var $ffc7fd1ae1e6977b$var$_defineProperty2 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("dangC")));

var $ffc7fd1ae1e6977b$var$_objectSpread3 = $ffc7fd1ae1e6977b$var$_interopRequireDefault((parcelRequire("lhogL")));
var $ffc7fd1ae1e6977b$var$_excluded = [
    "componentRef"
], $ffc7fd1ae1e6977b$var$_excluded2 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
], $ffc7fd1ae1e6977b$var$_excluded3 = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $aQgPH = parcelRequire("aQgPH");

var $8z8Hv = parcelRequire("8z8Hv");

var $7SzQn = parcelRequire("7SzQn");
var $ffc7fd1ae1e6977b$var$getComponentName = $7SzQn.getComponentName, $ffc7fd1ae1e6977b$var$getContainerName = $7SzQn.getContainerName;

var $hBqK0 = parcelRequire("hBqK0");

var $eZrFs = parcelRequire("eZrFs");

var $aaS4i = parcelRequire("aaS4i");
var $ffc7fd1ae1e6977b$var$assertRelayContext = $aaS4i.assertRelayContext;

var $l5wS4 = parcelRequire("l5wS4");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $ffc7fd1ae1e6977b$var$ConnectionInterface = $lIGkE.ConnectionInterface, $ffc7fd1ae1e6977b$var$Observable = $lIGkE.Observable, $ffc7fd1ae1e6977b$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $ffc7fd1ae1e6977b$var$createFragmentSpecResolver = $lIGkE.createFragmentSpecResolver, $ffc7fd1ae1e6977b$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $ffc7fd1ae1e6977b$var$getDataIDsFromObject = $lIGkE.getDataIDsFromObject, $ffc7fd1ae1e6977b$var$getRequest = $lIGkE.getRequest, $ffc7fd1ae1e6977b$var$getVariablesFromObject = $lIGkE.getVariablesFromObject, $ffc7fd1ae1e6977b$var$isScalarAndEqual = $lIGkE.isScalarAndEqual;
parcelRequire("8Xbph");
var $ffc7fd1ae1e6977b$var$FORWARD = 'forward';
function $ffc7fd1ae1e6977b$var$createGetConnectionFromProps(metadata) {
    var path = metadata.path;
    !path && $jwy7p(false);
    return function(props) {
        var data = props[metadata.fragmentName];
        for(var i = 0; i < path.length; i++){
            if (!data || typeof data !== 'object') return null;
            data = data[path[i]];
        }
        return data;
    };
}
function $ffc7fd1ae1e6977b$var$createGetFragmentVariables(metadata) {
    var countVariable = metadata.count;
    !countVariable && $jwy7p(false);
    return function(prevVars, totalCount) {
        return (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, prevVars), {}, (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])({}, countVariable, totalCount));
    };
}
function $ffc7fd1ae1e6977b$var$findConnectionMetadata(fragments) {
    var foundConnectionMetadata = null;
    var isRelayModern = false;
    for(var fragmentName in fragments){
        var fragment = fragments[fragmentName];
        var connectionMetadata = fragment.metadata && fragment.metadata.connection;
        if (fragment.metadata !== undefined) isRelayModern = true;
        if (connectionMetadata) {
            !(connectionMetadata.length === 1) && $jwy7p(false);
            !!foundConnectionMetadata && $jwy7p(false);
            foundConnectionMetadata = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, connectionMetadata[0]), {}, {
                fragmentName: fragmentName
            });
        }
    }
    !(!isRelayModern || foundConnectionMetadata !== null) && $jwy7p(false);
    return foundConnectionMetadata || {};
}
function $ffc7fd1ae1e6977b$var$toObserver(observerOrCallback) {
    return typeof observerOrCallback === 'function' ? {
        error: observerOrCallback,
        complete: observerOrCallback,
        unsubscribe: function unsubscribe(subscription) {
            typeof observerOrCallback === 'function' && observerOrCallback();
        }
    } : observerOrCallback || {};
}
function $ffc7fd1ae1e6977b$var$createContainerWithFragments(Component, fragments, connectionConfig) {
    var _class;
    var componentName = $ffc7fd1ae1e6977b$var$getComponentName(Component);
    var containerName = $ffc7fd1ae1e6977b$var$getContainerName(Component);
    var metadata = $ffc7fd1ae1e6977b$var$findConnectionMetadata(fragments);
    var getConnectionFromProps = connectionConfig.getConnectionFromProps || $ffc7fd1ae1e6977b$var$createGetConnectionFromProps(metadata);
    var direction = connectionConfig.direction || metadata.direction;
    !direction && $jwy7p(false);
    var getFragmentVariables = connectionConfig.getFragmentVariables || $ffc7fd1ae1e6977b$var$createGetFragmentVariables(metadata);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $ffc7fd1ae1e6977b$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])((0, $ffc7fd1ae1e6977b$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                _this.setState({
                    data: _this._resolver.resolve()
                });
            });
            (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])((0, $ffc7fd1ae1e6977b$var$_assertThisInitialized2["default"])(_this), "_hasMore", function() {
                var connectionData = _this._getConnectionData();
                return !!(connectionData && connectionData.hasMore && connectionData.cursor);
            });
            (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])((0, $ffc7fd1ae1e6977b$var$_assertThisInitialized2["default"])(_this), "_isLoading", function() {
                return !!_this._refetchSubscription;
            });
            (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])((0, $ffc7fd1ae1e6977b$var$_assertThisInitialized2["default"])(_this), "_refetchConnection", function(totalCount, observerOrCallback, refetchVariables) {
                if (!_this._canFetchPage('refetchConnection')) return {
                    dispose: function dispose() {}
                };
                _this._refetchVariables = refetchVariables;
                var paginatingVariables = {
                    count: totalCount,
                    cursor: null,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, $ffc7fd1ae1e6977b$var$toObserver(observerOrCallback), {
                    force: true
                });
                return {
                    dispose: fetch.unsubscribe
                };
            });
            (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])((0, $ffc7fd1ae1e6977b$var$_assertThisInitialized2["default"])(_this), "_loadMore", function(pageSize, observerOrCallback, options) {
                if (!_this._canFetchPage('loadMore')) return {
                    dispose: function dispose() {}
                };
                var observer = $ffc7fd1ae1e6977b$var$toObserver(observerOrCallback);
                var connectionData = _this._getConnectionData();
                if (!connectionData) {
                    $ffc7fd1ae1e6977b$var$Observable.create(function(sink) {
                        return sink.complete();
                    }).subscribe(observer);
                    return null;
                }
                var totalCount = connectionData.edgeCount + pageSize;
                if (options && options.force) return _this._refetchConnection(totalCount, observerOrCallback);
                var _ConnectionInterface$ = $ffc7fd1ae1e6977b$var$ConnectionInterface.get(), END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
                var cursor = connectionData.cursor;
                var paginatingVariables = {
                    count: pageSize,
                    cursor: cursor,
                    totalCount: totalCount
                };
                var fetch = _this._fetchPage(paginatingVariables, observer, options);
                return {
                    dispose: fetch.unsubscribe
                };
            });
            var relayContext = $ffc7fd1ae1e6977b$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._isARequestInFlight = false;
            _this._refetchSubscription = null;
            _this._refetchVariables = null;
            if ($ffc7fd1ae1e6977b$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) _this._resolver = $ffc7fd1ae1e6977b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            else _this._resolver = $ffc7fd1ae1e6977b$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer, _this._handleFragmentDataUpdate);
            _this.state = {
                data: _this._resolver.resolve(),
                prevContext: relayContext,
                contextForChildren: relayContext,
                relayProp: _this._buildRelayProp(relayContext),
                resolverGeneration: 0
            };
            _this._isUnmounted = false;
            _this._hasFetched = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            if ($ffc7fd1ae1e6977b$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($ffc7fd1ae1e6977b$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) {
                if (prevState.resolverGeneration !== this.state.resolverGeneration) this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
                else this._rerenderIfStoreHasChanged();
            }
        };
        _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
            var _this2 = this;
            var _nextProps$__rootIsQu;
            var relayContext = $ffc7fd1ae1e6977b$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $ffc7fd1ae1e6977b$var$getDataIDsFromObject(fragments, this.props);
            var nextIDs = $ffc7fd1ae1e6977b$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $8z8Hv(fragments, this.props);
            var nextRootVariables = $8z8Hv(fragments, nextProps);
            if (relayContext.environment !== this.state.prevContext.environment || !$l5wS4(prevRootVariables, nextRootVariables) || !$l5wS4(prevIDs, nextIDs)) {
                this._cleanup();
                if ($ffc7fd1ae1e6977b$var$RelayFeatureFlags.ENABLE_CONTAINERS_SUBSCRIBE_ON_COMMIT === true) this._resolver = $ffc7fd1ae1e6977b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                else this._resolver = $ffc7fd1ae1e6977b$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer, this._handleFragmentDataUpdate);
                this.setState(function(prevState) {
                    return {
                        prevContext: relayContext,
                        contextForChildren: relayContext,
                        relayProp: _this2._buildRelayProp(relayContext),
                        resolverGeneration: prevState.resolverGeneration + 1
                    };
                });
            } else if (!this._hasFetched) this._resolver.setProps(nextProps);
            var data = this._resolver.resolve();
            if (data !== this.state.data) this.setState({
                data: data
            });
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this._cleanup();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp || nextState.resolverGeneration !== this.state.resolverGeneration) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (nextState.prevContext.environment !== this.state.prevContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$ffc7fd1ae1e6977b$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._buildRelayProp = function _buildRelayProp(relayContext) {
            return {
                hasMore: this._hasMore,
                isLoading: this._isLoading,
                loadMore: this._loadMore,
                refetchConnection: this._refetchConnection,
                environment: relayContext.environment
            };
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var data = this.state.data;
            var maybeNewData = this._resolver.resolve();
            this._resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getConnectionData = function _getConnectionData() {
            var _this$props = this.props, _ = _this$props.componentRef, restProps = (0, $ffc7fd1ae1e6977b$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $ffc7fd1ae1e6977b$var$_excluded);
            var props = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var connectionData = getConnectionFromProps(props);
            if (connectionData == null) return null;
            var _ConnectionInterface$2 = $ffc7fd1ae1e6977b$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$2.EDGES, PAGE_INFO = _ConnectionInterface$2.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$2.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$2.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$2.END_CURSOR, START_CURSOR = _ConnectionInterface$2.START_CURSOR;
            !(typeof connectionData === 'object') && $jwy7p(false);
            var edges = connectionData[EDGES];
            var pageInfo = connectionData[PAGE_INFO];
            if (edges == null || pageInfo == null) return null;
            !Array.isArray(edges) && $jwy7p(false);
            !(typeof pageInfo === 'object') && $jwy7p(false);
            var hasMore = direction === $ffc7fd1ae1e6977b$var$FORWARD ? pageInfo[HAS_NEXT_PAGE] : pageInfo[HAS_PREV_PAGE];
            var cursor = direction === $ffc7fd1ae1e6977b$var$FORWARD ? pageInfo[END_CURSOR] : pageInfo[START_CURSOR];
            if (typeof hasMore !== 'boolean' || edges.length !== 0 && typeof cursor === 'undefined') return null;
            return {
                cursor: cursor,
                edgeCount: edges.length,
                hasMore: hasMore
            };
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $eZrFs();
            return this._queryFetcher;
        };
        _proto._canFetchPage = function _canFetchPage(method) {
            if (this._isUnmounted) return false;
            return true;
        };
        _proto._fetchPage = function _fetchPage(paginatingVariables, observer, options) {
            var _this3 = this;
            var _assertRelayContext = $ffc7fd1ae1e6977b$var$assertRelayContext(this.props.__relayContext), environment = _assertRelayContext.environment;
            var _this$props2 = this.props, _ = _this$props2.componentRef, __relayContext = _this$props2.__relayContext, __rootIsQueryRenderer = _this$props2.__rootIsQueryRenderer, restProps = (0, $ffc7fd1ae1e6977b$var$_objectWithoutPropertiesLoose2["default"])(_this$props2, $ffc7fd1ae1e6977b$var$_excluded2);
            var props = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, restProps), this.state.data);
            var fragmentVariables;
            var rootVariables = $8z8Hv(fragments, restProps);
            fragmentVariables = $ffc7fd1ae1e6977b$var$getVariablesFromObject(fragments, restProps);
            fragmentVariables = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, rootVariables), fragmentVariables), this._refetchVariables);
            var fetchVariables = connectionConfig.getVariables(props, {
                count: paginatingVariables.count,
                cursor: paginatingVariables.cursor
            }, fragmentVariables);
            !(typeof fetchVariables === 'object' && fetchVariables !== null) && $jwy7p(false);
            fetchVariables = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, fetchVariables), this._refetchVariables);
            fragmentVariables = (0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])((0, $ffc7fd1ae1e6977b$var$_objectSpread3["default"])({}, fetchVariables), fragmentVariables);
            var cacheConfig = options ? {
                force: !!options.force
            } : undefined;
            if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
            var request = $ffc7fd1ae1e6977b$var$getRequest(connectionConfig.query);
            var operation = $ffc7fd1ae1e6977b$var$createOperationDescriptor(request, fetchVariables, cacheConfig);
            var refetchSubscription = null;
            if (this._refetchSubscription) this._refetchSubscription.unsubscribe();
            this._hasFetched = true;
            var onNext = function onNext(payload, complete) {
                var prevData = _this3._resolver.resolve();
                _this3._resolver.setVariables(getFragmentVariables(fragmentVariables, paginatingVariables.totalCount), operation.request.node);
                var nextData = _this3._resolver.resolve();
                if (!$l5wS4(prevData, nextData)) _this3.setState({
                    data: nextData,
                    contextForChildren: {
                        environment: _this3.props.__relayContext.environment
                    }
                }, complete);
                else complete();
            };
            var cleanup = function cleanup() {
                if (_this3._refetchSubscription === refetchSubscription) {
                    _this3._refetchSubscription = null;
                    _this3._isARequestInFlight = false;
                }
            };
            this._isARequestInFlight = true;
            refetchSubscription = this._getQueryFetcher().execute({
                environment: environment,
                operation: operation,
                preservePreviousReferences: true
            }).mergeMap(function(payload) {
                return $ffc7fd1ae1e6977b$var$Observable.create(function(sink) {
                    onNext(payload, function() {
                        sink.next();
                        sink.complete();
                    });
                });
            })["do"]({
                error: cleanup,
                complete: cleanup,
                unsubscribe: cleanup
            }).subscribe(observer || {});
            this._refetchSubscription = this._isARequestInFlight ? refetchSubscription : null;
            return refetchSubscription;
        };
        _proto._cleanup = function _cleanup() {
            this._resolver.dispose();
            this._refetchVariables = null;
            this._hasFetched = false;
            if (this._refetchSubscription) {
                this._refetchSubscription.unsubscribe();
                this._refetchSubscription = null;
                this._isARequestInFlight = false;
            }
            if (this._queryFetcher) this._queryFetcher.dispose();
        };
        _proto.render = function render() {
            var _this$props3 = this.props, componentRef = _this$props3.componentRef, __relayContext = _this$props3.__relayContext, __rootIsQueryRenderer = _this$props3.__rootIsQueryRenderer, props = (0, $ffc7fd1ae1e6977b$var$_objectWithoutPropertiesLoose2["default"])(_this$props3, $ffc7fd1ae1e6977b$var$_excluded3);
            return /*#__PURE__*/ $euxye.createElement($hBqK0.Provider, {
                value: this.state.contextForChildren
            }, /*#__PURE__*/ $euxye.createElement(Component, (0, $ffc7fd1ae1e6977b$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: this.state.relayProp
            })));
        };
        return _class;
    }($euxye.Component), (0, $ffc7fd1ae1e6977b$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $ffc7fd1ae1e6977b$var$createContainer(Component, fragmentSpec, connectionConfig) {
    return $aQgPH(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $ffc7fd1ae1e6977b$var$createContainerWithFragments(ComponentClass, fragments, connectionConfig);
    });
}
module.exports = {
    createContainer: $ffc7fd1ae1e6977b$var$createContainer
};

});
parcelRegister("8z8Hv", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $63c85769bac17500$var$_interopRequireDefault = $8gviu.default;

var $63c85769bac17500$var$_objectSpread2 = $63c85769bac17500$var$_interopRequireDefault((parcelRequire("lhogL")));

var $lIGkE = parcelRequire("lIGkE");
var $63c85769bac17500$var$getSelector = $lIGkE.getSelector;
function $63c85769bac17500$var$getRootVariablesForFragments(fragments, props) {
    var rootVariables = {};
    Object.keys(fragments).forEach(function(key) {
        var _selector$selectors$, _selector$selectors$2, _selector$owner$varia;
        var fragmentNode = fragments[key];
        var fragmentRef = props[key];
        var selector = $63c85769bac17500$var$getSelector(fragmentNode, fragmentRef);
        var fragmentOwnerVariables = selector != null && selector.kind === 'PluralReaderSelector' ? (_selector$selectors$ = (_selector$selectors$2 = selector.selectors[0]) === null || _selector$selectors$2 === void 0 ? void 0 : _selector$selectors$2.owner.variables) !== null && _selector$selectors$ !== void 0 ? _selector$selectors$ : {} : (_selector$owner$varia = selector === null || selector === void 0 ? void 0 : selector.owner.variables) !== null && _selector$owner$varia !== void 0 ? _selector$owner$varia : {};
        rootVariables = (0, $63c85769bac17500$var$_objectSpread2["default"])((0, $63c85769bac17500$var$_objectSpread2["default"])({}, rootVariables), fragmentOwnerVariables);
    });
    return rootVariables;
}
module.exports = $63c85769bac17500$var$getRootVariablesForFragments;

});

parcelRegister("eZrFs", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $ae9c39690ecddd46$var$_interopRequireDefault = $8gviu.default;

var $ae9c39690ecddd46$var$_defineProperty2 = $ae9c39690ecddd46$var$_interopRequireDefault((parcelRequire("dangC")));

var $jwy7p = parcelRequire("jwy7p");

var $lIGkE = parcelRequire("lIGkE");
var $ae9c39690ecddd46$var$fetchQuery = $lIGkE.__internal.fetchQuery, $ae9c39690ecddd46$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $ae9c39690ecddd46$var$isRelayModernEnvironment = $lIGkE.isRelayModernEnvironment;
var $ae9c39690ecddd46$var$ReactRelayQueryFetcher = /*#__PURE__*/ function() {
    function ReactRelayQueryFetcher(args) {
        (0, $ae9c39690ecddd46$var$_defineProperty2["default"])(this, "_selectionReferences", []);
        (0, $ae9c39690ecddd46$var$_defineProperty2["default"])(this, "_didFetchFinish", false);
        if (args != null) {
            this._cacheSelectionReference = args.cacheSelectionReference;
            this._selectionReferences = args.selectionReferences;
        }
    }
    var _proto = ReactRelayQueryFetcher.prototype;
    _proto.getSelectionReferences = function getSelectionReferences() {
        return {
            cacheSelectionReference: this._cacheSelectionReference,
            selectionReferences: this._selectionReferences
        };
    };
    _proto.lookupInStore = function lookupInStore(environment, operation, fetchPolicy) {
        if (fetchPolicy === 'store-and-network' || fetchPolicy === 'store-or-network') {
            if (environment.check(operation).status === 'available') {
                this._retainCachedOperation(environment, operation);
                return environment.lookup(operation.fragment);
            }
        }
        return null;
    };
    _proto.getFetchResult = function getFetchResult() {
        if (this._didFetchFinish) {
            if (this._error != null) return {
                error: this._error
            };
            else if (this._snapshot != null) return {
                snapshot: this._snapshot
            };
        } else return null;
    };
    _proto.execute = function execute(_ref) {
        var _this = this;
        var environment = _ref.environment, operation = _ref.operation, _ref$preservePrevious = _ref.preservePreviousReferences, preservePreviousReferences = _ref$preservePrevious === void 0 ? false : _ref$preservePrevious;
        var reference = environment.retain(operation);
        var error = function error() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var complete = function complete() {
            if (!preservePreviousReferences) _this.disposeSelectionReferences();
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        var unsubscribe = function unsubscribe() {
            _this._selectionReferences = _this._selectionReferences.concat(reference);
        };
        if (!$ae9c39690ecddd46$var$isRelayModernEnvironment(environment)) return environment.execute({
            operation: operation
        })["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
        return $ae9c39690ecddd46$var$fetchQuery(environment, operation)["do"]({
            error: error,
            complete: complete,
            unsubscribe: unsubscribe
        });
    };
    _proto.setOnDataChange = function setOnDataChange(onDataChange) {
        !this._fetchOptions && $jwy7p(false);
        if (typeof onDataChange === 'function') {
            this._fetchOptions.onDataChangeCallbacks = this._fetchOptions.onDataChangeCallbacks || [];
            this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
            if (this._didFetchFinish) {
                if (this._error != null) onDataChange({
                    error: this._error
                });
                else if (this._snapshot != null) onDataChange({
                    snapshot: this._snapshot
                });
            }
        }
    };
    _proto.fetch = function fetch(fetchOptions, cacheConfigOverride) {
        var _this2 = this;
        var environment = fetchOptions.environment, operation = fetchOptions.operation, onDataChange = fetchOptions.onDataChange;
        var fetchHasReturned = false;
        var _error;
        this.disposeRequest();
        var oldOnDataChangeCallbacks = this._fetchOptions && this._fetchOptions.onDataChangeCallbacks;
        this._fetchOptions = {
            environment: environment,
            onDataChangeCallbacks: oldOnDataChangeCallbacks || [],
            operation: operation
        };
        if (onDataChange && this._fetchOptions.onDataChangeCallbacks.indexOf(onDataChange) === -1) this._fetchOptions.onDataChangeCallbacks.push(onDataChange);
        var operationOverride = cacheConfigOverride ? $ae9c39690ecddd46$var$createOperationDescriptor(operation.request.node, operation.request.variables, cacheConfigOverride) : operation;
        var request = this.execute({
            environment: environment,
            operation: operationOverride
        })["finally"](function() {
            _this2._pendingRequest = null;
        }).subscribe({
            next: function next() {
                _this2._didFetchFinish = true;
                _this2._error = null;
                _this2._onQueryDataAvailable({
                    notifyFirstResult: fetchHasReturned
                });
            },
            error: function error(err) {
                _this2._didFetchFinish = true;
                _this2._error = err;
                _this2._snapshot = null;
                var onDataChangeCallbacks = _this2._fetchOptions && _this2._fetchOptions.onDataChangeCallbacks;
                if (fetchHasReturned) {
                    if (onDataChangeCallbacks) onDataChangeCallbacks.forEach(function(onDataChange) {
                        onDataChange({
                            error: err
                        });
                    });
                } else _error = err;
            }
        });
        this._pendingRequest = {
            dispose: function dispose() {
                request.unsubscribe();
            }
        };
        fetchHasReturned = true;
        if (_error) throw _error;
        return this._snapshot;
    };
    _proto.retry = function retry(cacheConfigOverride) {
        !this._fetchOptions && $jwy7p(false);
        return this.fetch({
            environment: this._fetchOptions.environment,
            operation: this._fetchOptions.operation,
            onDataChange: null
        }, cacheConfigOverride);
    };
    _proto.dispose = function dispose() {
        this.disposeRequest();
        this.disposeSelectionReferences();
    };
    _proto.disposeRequest = function disposeRequest() {
        this._error = null;
        this._snapshot = null;
        if (this._pendingRequest) this._pendingRequest.dispose();
        if (this._rootSubscription) {
            this._rootSubscription.dispose();
            this._rootSubscription = null;
        }
    };
    _proto._retainCachedOperation = function _retainCachedOperation(environment, operation) {
        this._disposeCacheSelectionReference();
        this._cacheSelectionReference = environment.retain(operation);
    };
    _proto._disposeCacheSelectionReference = function _disposeCacheSelectionReference() {
        this._cacheSelectionReference && this._cacheSelectionReference.dispose();
        this._cacheSelectionReference = null;
    };
    _proto.disposeSelectionReferences = function disposeSelectionReferences() {
        this._disposeCacheSelectionReference();
        this._selectionReferences.forEach(function(r) {
            return r.dispose();
        });
        this._selectionReferences = [];
    };
    _proto._onQueryDataAvailable = function _onQueryDataAvailable(_ref2) {
        var _this3 = this;
        var notifyFirstResult = _ref2.notifyFirstResult;
        !this._fetchOptions && $jwy7p(false);
        var _this$_fetchOptions = this._fetchOptions, environment = _this$_fetchOptions.environment, onDataChangeCallbacks = _this$_fetchOptions.onDataChangeCallbacks, operation = _this$_fetchOptions.operation;
        if (this._snapshot) return;
        this._snapshot = environment.lookup(operation.fragment);
        this._rootSubscription = environment.subscribe(this._snapshot, function(snapshot) {
            if (_this3._fetchOptions != null) {
                var maybeNewOnDataChangeCallbacks = _this3._fetchOptions.onDataChangeCallbacks;
                if (Array.isArray(maybeNewOnDataChangeCallbacks)) maybeNewOnDataChangeCallbacks.forEach(function(onDataChange) {
                    return onDataChange({
                        snapshot: snapshot
                    });
                });
            }
        });
        if (this._snapshot && notifyFirstResult && Array.isArray(onDataChangeCallbacks)) {
            var snapshot = this._snapshot;
            onDataChangeCallbacks.forEach(function(onDataChange) {
                return onDataChange({
                    snapshot: snapshot
                });
            });
        }
    };
    return ReactRelayQueryFetcher;
}();
module.exports = $ae9c39690ecddd46$var$ReactRelayQueryFetcher;

});

parcelRegister("8Xbph", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $2S2YM = parcelRequire("2S2YM");
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ function $684cae91b1c20520$var$printWarning(format) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function() {
        return args[argIndex++];
    });
    if (typeof console !== 'undefined') console.error(message);
    try {
        // --- Welcome to debugging React ---
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
    } catch (x) {}
}
var $684cae91b1c20520$var$warning = $2S2YM;
module.exports = $684cae91b1c20520$var$warning;

});
parcelRegister("2S2YM", function(module, exports) {
"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */ function $2172ef91d5bb058b$var$makeEmptyFunction(arg) {
    return function() {
        return arg;
    };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */ var $2172ef91d5bb058b$var$emptyFunction = function emptyFunction() {};
$2172ef91d5bb058b$var$emptyFunction.thatReturns = $2172ef91d5bb058b$var$makeEmptyFunction;
$2172ef91d5bb058b$var$emptyFunction.thatReturnsFalse = $2172ef91d5bb058b$var$makeEmptyFunction(false);
$2172ef91d5bb058b$var$emptyFunction.thatReturnsTrue = $2172ef91d5bb058b$var$makeEmptyFunction(true);
$2172ef91d5bb058b$var$emptyFunction.thatReturnsNull = $2172ef91d5bb058b$var$makeEmptyFunction(null);
$2172ef91d5bb058b$var$emptyFunction.thatReturnsThis = function() {
    return this;
};
$2172ef91d5bb058b$var$emptyFunction.thatReturnsArgument = function(arg) {
    return arg;
};
module.exports = $2172ef91d5bb058b$var$emptyFunction;

});



parcelRegister("c5dR9", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $8cc0b338d15cd1e5$var$_interopRequireDefault = $8gviu.default;

var $8cc0b338d15cd1e5$var$_objectSpread2 = $8cc0b338d15cd1e5$var$_interopRequireDefault((parcelRequire("lhogL")));

var $8cc0b338d15cd1e5$var$_assertThisInitialized2 = $8cc0b338d15cd1e5$var$_interopRequireDefault((parcelRequire("dKInO")));

var $8cc0b338d15cd1e5$var$_inheritsLoose2 = $8cc0b338d15cd1e5$var$_interopRequireDefault((parcelRequire("9FsID")));

var $8cc0b338d15cd1e5$var$_defineProperty2 = $8cc0b338d15cd1e5$var$_interopRequireDefault((parcelRequire("dangC")));

var $hBqK0 = parcelRequire("hBqK0");

var $eZrFs = parcelRequire("eZrFs");

var $i2fgQ = parcelRequire("i2fgQ");

var $l5wS4 = parcelRequire("l5wS4");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $8cc0b338d15cd1e5$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $8cc0b338d15cd1e5$var$deepFreeze = $lIGkE.deepFreeze, $8cc0b338d15cd1e5$var$getRequest = $lIGkE.getRequest;
var $8cc0b338d15cd1e5$var$requestCache = {};
var $8cc0b338d15cd1e5$var$queryRendererContext = {
    rootIsQueryRenderer: true
};
var $8cc0b338d15cd1e5$var$ReactRelayQueryRenderer = /*#__PURE__*/ function(_React$Component) {
    (0, $8cc0b338d15cd1e5$var$_inheritsLoose2["default"])(ReactRelayQueryRenderer, _React$Component);
    function ReactRelayQueryRenderer(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        (0, $8cc0b338d15cd1e5$var$_defineProperty2["default"])((0, $8cc0b338d15cd1e5$var$_assertThisInitialized2["default"])(_this), "_handleDataChange", function(params) {
            var error = params.error == null ? null : params.error;
            var snapshot = params.snapshot == null ? null : params.snapshot;
            _this.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $8cc0b338d15cd1e5$var$requestCache[prevRequestCacheKey];
                if (snapshot === prevState.snapshot && error === prevState.error) return null;
                return {
                    renderProps: $8cc0b338d15cd1e5$var$getRenderProps(error, snapshot, prevState.queryFetcher, prevState.retryCallbacks),
                    snapshot: snapshot,
                    requestCacheKey: null
                };
            });
        });
        var retryCallbacks = {
            handleDataChange: null,
            handleRetryAfterError: null
        };
        var queryFetcher;
        var requestCacheKey;
        if (props.query) {
            var query = props.query;
            var request = $8cc0b338d15cd1e5$var$getRequest(query);
            requestCacheKey = $8cc0b338d15cd1e5$var$getRequestCacheKey(request.params, props.variables);
            queryFetcher = $8cc0b338d15cd1e5$var$requestCache[requestCacheKey] ? $8cc0b338d15cd1e5$var$requestCache[requestCacheKey].queryFetcher : new $eZrFs();
        } else queryFetcher = new $eZrFs();
        _this._maybeHiddenOrFastRefresh = false;
        _this.state = (0, $8cc0b338d15cd1e5$var$_objectSpread2["default"])({
            prevPropsEnvironment: props.environment,
            prevPropsVariables: props.variables,
            prevQuery: props.query,
            queryFetcher: queryFetcher,
            retryCallbacks: retryCallbacks
        }, $8cc0b338d15cd1e5$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey));
        return _this;
    }
    ReactRelayQueryRenderer.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
        if (prevState.prevQuery !== nextProps.query || prevState.prevPropsEnvironment !== nextProps.environment || !$l5wS4(prevState.prevPropsVariables, nextProps.variables)) return $8cc0b338d15cd1e5$var$resetQueryStateForUpdate(nextProps, prevState);
        return null;
    };
    var _proto = ReactRelayQueryRenderer.prototype;
    _proto.componentDidMount = function componentDidMount() {
        var _this2 = this;
        if (this._maybeHiddenOrFastRefresh === true) {
            this._maybeHiddenOrFastRefresh = false;
            this.setState(function(prevState) {
                var newState = $8cc0b338d15cd1e5$var$resetQueryStateForUpdate(_this2.props, prevState);
                var requestCacheKey = newState.requestCacheKey, queryFetcher = newState.queryFetcher;
                if (requestCacheKey != null && $8cc0b338d15cd1e5$var$requestCache[requestCacheKey] != null) queryFetcher.setOnDataChange(_this2._handleDataChange);
                return newState;
            });
            return;
        }
        var _this$state = this.state, retryCallbacks = _this$state.retryCallbacks, queryFetcher = _this$state.queryFetcher, requestCacheKey = _this$state.requestCacheKey;
        if (requestCacheKey) delete $8cc0b338d15cd1e5$var$requestCache[requestCacheKey];
        retryCallbacks.handleDataChange = this._handleDataChange;
        retryCallbacks.handleRetryAfterError = function(error) {
            return _this2.setState(function(prevState) {
                var prevRequestCacheKey = prevState.requestCacheKey;
                if (prevRequestCacheKey) delete $8cc0b338d15cd1e5$var$requestCache[prevRequestCacheKey];
                return {
                    renderProps: $8cc0b338d15cd1e5$var$getLoadingRenderProps(),
                    requestCacheKey: null
                };
            });
        };
        if (this.props.query) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentDidUpdate = function componentDidUpdate(_prevProps, prevState) {
        var _this$state2 = this.state, queryFetcher = _this$state2.queryFetcher, requestCacheKey = _this$state2.requestCacheKey;
        if (requestCacheKey) {
            delete $8cc0b338d15cd1e5$var$requestCache[requestCacheKey];
            delete this.state.requestCacheKey;
        }
        if (this.props.query && queryFetcher !== prevState.queryFetcher) queryFetcher.setOnDataChange(this._handleDataChange);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.state.queryFetcher.dispose();
        this._maybeHiddenOrFastRefresh = true;
    };
    _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextProps.render !== this.props.render || nextState.renderProps !== this.state.renderProps;
    };
    _proto.render = function render() {
        var _this$state3 = this.state, renderProps = _this$state3.renderProps, relayContext = _this$state3.relayContext;
        return /*#__PURE__*/ $euxye.createElement($hBqK0.Provider, {
            value: relayContext
        }, /*#__PURE__*/ $euxye.createElement($i2fgQ.Provider, {
            value: $8cc0b338d15cd1e5$var$queryRendererContext
        }, this.props.render(renderProps)));
    };
    return ReactRelayQueryRenderer;
}($euxye.Component);
function $8cc0b338d15cd1e5$var$getLoadingRenderProps() {
    return {
        error: null,
        props: null,
        retry: null
    };
}
function $8cc0b338d15cd1e5$var$getEmptyRenderProps() {
    return {
        error: null,
        props: {},
        retry: null
    };
}
function $8cc0b338d15cd1e5$var$getRenderProps(error, snapshot, queryFetcher, retryCallbacks) {
    return {
        error: error ? error : null,
        props: snapshot ? snapshot.data : null,
        retry: function retry(cacheConfigOverride) {
            var syncSnapshot = queryFetcher.retry(cacheConfigOverride);
            if (syncSnapshot && typeof retryCallbacks.handleDataChange === 'function') retryCallbacks.handleDataChange({
                snapshot: syncSnapshot
            });
            else if (error && typeof retryCallbacks.handleRetryAfterError === 'function') retryCallbacks.handleRetryAfterError(error);
        }
    };
}
function $8cc0b338d15cd1e5$var$getRequestCacheKey(request, variables) {
    return JSON.stringify({
        id: request.cacheID ? request.cacheID : request.id,
        variables: variables
    });
}
function $8cc0b338d15cd1e5$var$resetQueryStateForUpdate(props, prevState) {
    var query = props.query;
    var prevSelectionReferences = prevState.queryFetcher.getSelectionReferences();
    prevState.queryFetcher.disposeRequest();
    var queryFetcher;
    if (query) {
        var request = $8cc0b338d15cd1e5$var$getRequest(query);
        var requestCacheKey = $8cc0b338d15cd1e5$var$getRequestCacheKey(request.params, props.variables);
        queryFetcher = $8cc0b338d15cd1e5$var$requestCache[requestCacheKey] ? $8cc0b338d15cd1e5$var$requestCache[requestCacheKey].queryFetcher : new $eZrFs(prevSelectionReferences);
    } else queryFetcher = new $eZrFs(prevSelectionReferences);
    return (0, $8cc0b338d15cd1e5$var$_objectSpread2["default"])({
        prevQuery: props.query,
        prevPropsEnvironment: props.environment,
        prevPropsVariables: props.variables,
        queryFetcher: queryFetcher
    }, $8cc0b338d15cd1e5$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, prevState.retryCallbacks));
}
function $8cc0b338d15cd1e5$var$fetchQueryAndComputeStateFromProps(props, queryFetcher, retryCallbacks, requestCacheKey) {
    var environment = props.environment, query = props.query, variables = props.variables, cacheConfig = props.cacheConfig;
    var genericEnvironment = environment;
    if (query) {
        var request = $8cc0b338d15cd1e5$var$getRequest(query);
        var operation = $8cc0b338d15cd1e5$var$createOperationDescriptor(request, variables, cacheConfig);
        var relayContext = {
            environment: genericEnvironment
        };
        if (typeof requestCacheKey === 'string' && $8cc0b338d15cd1e5$var$requestCache[requestCacheKey]) {
            var snapshot = $8cc0b338d15cd1e5$var$requestCache[requestCacheKey].snapshot;
            if (snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $8cc0b338d15cd1e5$var$getRenderProps(null, snapshot, queryFetcher, retryCallbacks),
                snapshot: snapshot,
                requestCacheKey: requestCacheKey
            };
            else return {
                error: null,
                relayContext: relayContext,
                renderProps: $8cc0b338d15cd1e5$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
        try {
            var storeSnapshot = queryFetcher.lookupInStore(genericEnvironment, operation, props.fetchPolicy);
            var querySnapshot = queryFetcher.fetch({
                environment: genericEnvironment,
                onDataChange: null,
                operation: operation
            });
            var _snapshot = querySnapshot || storeSnapshot;
            requestCacheKey = requestCacheKey || $8cc0b338d15cd1e5$var$getRequestCacheKey(request.params, props.variables);
            $8cc0b338d15cd1e5$var$requestCache[requestCacheKey] = {
                queryFetcher: queryFetcher,
                snapshot: _snapshot
            };
            if (!_snapshot) return {
                error: null,
                relayContext: relayContext,
                renderProps: $8cc0b338d15cd1e5$var$getLoadingRenderProps(),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
            return {
                error: null,
                relayContext: relayContext,
                renderProps: $8cc0b338d15cd1e5$var$getRenderProps(null, _snapshot, queryFetcher, retryCallbacks),
                snapshot: _snapshot,
                requestCacheKey: requestCacheKey
            };
        } catch (error) {
            return {
                error: error,
                relayContext: relayContext,
                renderProps: $8cc0b338d15cd1e5$var$getRenderProps(error, null, queryFetcher, retryCallbacks),
                snapshot: null,
                requestCacheKey: requestCacheKey
            };
        }
    } else {
        queryFetcher.dispose();
        var _relayContext = {
            environment: genericEnvironment
        };
        return {
            error: null,
            relayContext: _relayContext,
            renderProps: $8cc0b338d15cd1e5$var$getEmptyRenderProps(),
            requestCacheKey: null
        };
    }
}
module.exports = $8cc0b338d15cd1e5$var$ReactRelayQueryRenderer;

});

parcelRegister("aZhGa", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $7ffd5099c2d3641c$var$_interopRequireDefault = $8gviu.default;

var $7ffd5099c2d3641c$var$_extends2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("a7Fos")));

var $7ffd5099c2d3641c$var$_objectWithoutPropertiesLoose2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("hpjx4")));

var $7ffd5099c2d3641c$var$_objectSpread2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("lhogL")));

var $7ffd5099c2d3641c$var$_assertThisInitialized2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("dKInO")));

var $7ffd5099c2d3641c$var$_inheritsLoose2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("9FsID")));

var $7ffd5099c2d3641c$var$_defineProperty2 = $7ffd5099c2d3641c$var$_interopRequireDefault((parcelRequire("dangC")));
var $7ffd5099c2d3641c$var$_excluded = [
    "componentRef",
    "__relayContext",
    "__rootIsQueryRenderer"
];

var $aQgPH = parcelRequire("aQgPH");

var $8z8Hv = parcelRequire("8z8Hv");

var $7SzQn = parcelRequire("7SzQn");
var $7ffd5099c2d3641c$var$getContainerName = $7SzQn.getContainerName;

var $hBqK0 = parcelRequire("hBqK0");

var $eZrFs = parcelRequire("eZrFs");

var $aaS4i = parcelRequire("aaS4i");
var $7ffd5099c2d3641c$var$assertRelayContext = $aaS4i.assertRelayContext;

var $l5wS4 = parcelRequire("l5wS4");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $7ffd5099c2d3641c$var$Observable = $lIGkE.Observable, $7ffd5099c2d3641c$var$createFragmentSpecResolver = $lIGkE.createFragmentSpecResolver, $7ffd5099c2d3641c$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $7ffd5099c2d3641c$var$getDataIDsFromObject = $lIGkE.getDataIDsFromObject, $7ffd5099c2d3641c$var$getRequest = $lIGkE.getRequest, $7ffd5099c2d3641c$var$getVariablesFromObject = $lIGkE.getVariablesFromObject, $7ffd5099c2d3641c$var$isScalarAndEqual = $lIGkE.isScalarAndEqual;
parcelRequire("8Xbph");
function $7ffd5099c2d3641c$var$createContainerWithFragments(Component, fragments, taggedNode) {
    var _class;
    var containerName = $7ffd5099c2d3641c$var$getContainerName(Component);
    return _class = /*#__PURE__*/ function(_React$Component) {
        (0, $7ffd5099c2d3641c$var$_inheritsLoose2["default"])(_class, _React$Component);
        function _class(props) {
            var _props$__rootIsQueryR, _this;
            _this = _React$Component.call(this, props) || this;
            (0, $7ffd5099c2d3641c$var$_defineProperty2["default"])((0, $7ffd5099c2d3641c$var$_assertThisInitialized2["default"])(_this), "_handleFragmentDataUpdate", function() {
                var resolverFromThisUpdate = _this.state.resolver;
                _this.setState(function(updatedState) {
                    return resolverFromThisUpdate === updatedState.resolver ? {
                        data: updatedState.resolver.resolve()
                    } : null;
                });
            });
            (0, $7ffd5099c2d3641c$var$_defineProperty2["default"])((0, $7ffd5099c2d3641c$var$_assertThisInitialized2["default"])(_this), "_refetch", function(refetchVariables, renderVariables, observerOrCallback, options) {
                if (_this._isUnmounted) return {
                    dispose: function dispose() {}
                };
                var _assertRelayContext = $7ffd5099c2d3641c$var$assertRelayContext(_this.props.__relayContext), environment = _assertRelayContext.environment;
                var rootVariables = $8z8Hv(fragments, _this.props);
                var fetchVariables = typeof refetchVariables === 'function' ? refetchVariables(_this._getFragmentVariables()) : refetchVariables;
                fetchVariables = (0, $7ffd5099c2d3641c$var$_objectSpread2["default"])((0, $7ffd5099c2d3641c$var$_objectSpread2["default"])({}, rootVariables), fetchVariables);
                var fragmentVariables = renderVariables ? (0, $7ffd5099c2d3641c$var$_objectSpread2["default"])((0, $7ffd5099c2d3641c$var$_objectSpread2["default"])({}, fetchVariables), renderVariables) : fetchVariables;
                var cacheConfig = options ? {
                    force: !!options.force
                } : undefined;
                if (cacheConfig != null && (options === null || options === void 0 ? void 0 : options.metadata) != null) cacheConfig.metadata = options === null || options === void 0 ? void 0 : options.metadata;
                var observer = typeof observerOrCallback === 'function' ? {
                    next: observerOrCallback,
                    error: observerOrCallback
                } : observerOrCallback || {};
                var query = $7ffd5099c2d3641c$var$getRequest(taggedNode);
                var operation = $7ffd5099c2d3641c$var$createOperationDescriptor(query, fetchVariables, cacheConfig);
                _this.state.localVariables = fetchVariables;
                _this._refetchSubscription && _this._refetchSubscription.unsubscribe();
                var refetchSubscription;
                var storeSnapshot = _this._getQueryFetcher().lookupInStore(environment, operation, options === null || options === void 0 ? void 0 : options.fetchPolicy);
                if (storeSnapshot != null) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    _this.setState(function(latestState) {
                        return {
                            data: latestState.resolver.resolve(),
                            contextForChildren: {
                                environment: _this.props.__relayContext.environment
                            }
                        };
                    }, function() {
                        observer.next && observer.next();
                        observer.complete && observer.complete();
                    });
                    return {
                        dispose: function dispose() {}
                    };
                }
                _this._getQueryFetcher().execute({
                    environment: environment,
                    operation: operation,
                    preservePreviousReferences: true
                }).mergeMap(function(response) {
                    _this.state.resolver.setVariables(fragmentVariables, operation.request.node);
                    return $7ffd5099c2d3641c$var$Observable.create(function(sink) {
                        return _this.setState(function(latestState) {
                            return {
                                data: latestState.resolver.resolve(),
                                contextForChildren: {
                                    environment: _this.props.__relayContext.environment
                                }
                            };
                        }, function() {
                            sink.next();
                            sink.complete();
                        });
                    });
                })["finally"](function() {
                    if (_this._refetchSubscription === refetchSubscription) _this._refetchSubscription = null;
                }).subscribe((0, $7ffd5099c2d3641c$var$_objectSpread2["default"])((0, $7ffd5099c2d3641c$var$_objectSpread2["default"])({}, observer), {}, {
                    start: function start(subscription) {
                        _this._refetchSubscription = refetchSubscription = subscription;
                        observer.start && observer.start(subscription);
                    }
                }));
                return {
                    dispose: function dispose() {
                        refetchSubscription && refetchSubscription.unsubscribe();
                    }
                };
            });
            var relayContext = $7ffd5099c2d3641c$var$assertRelayContext(props.__relayContext);
            var rootIsQueryRenderer = (_props$__rootIsQueryR = props.__rootIsQueryRenderer) !== null && _props$__rootIsQueryR !== void 0 ? _props$__rootIsQueryR : false;
            _this._refetchSubscription = null;
            var resolver = $7ffd5099c2d3641c$var$createFragmentSpecResolver(relayContext, containerName, fragments, props, rootIsQueryRenderer);
            _this.state = {
                data: resolver.resolve(),
                localVariables: null,
                prevProps: props,
                prevPropsContext: relayContext,
                contextForChildren: relayContext,
                relayProp: $7ffd5099c2d3641c$var$getRelayProp(relayContext.environment, _this._refetch),
                resolver: resolver
            };
            _this._isUnmounted = false;
            return _this;
        }
        var _proto = _class.prototype;
        _proto.componentDidMount = function componentDidMount() {
            this._isUnmounted = false;
            this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if (this.state.resolver !== prevState.resolver) {
                prevState.resolver.dispose();
                this._queryFetcher && this._queryFetcher.dispose();
                this._refetchSubscription && this._refetchSubscription.unsubscribe();
                this._subscribeToNewResolverAndRerenderIfStoreHasChanged();
            } else this._rerenderIfStoreHasChanged();
        };
        _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
            var _nextProps$__rootIsQu;
            var prevProps = prevState.prevProps;
            var relayContext = $7ffd5099c2d3641c$var$assertRelayContext(nextProps.__relayContext);
            var rootIsQueryRenderer = (_nextProps$__rootIsQu = nextProps.__rootIsQueryRenderer) !== null && _nextProps$__rootIsQu !== void 0 ? _nextProps$__rootIsQu : false;
            var prevIDs = $7ffd5099c2d3641c$var$getDataIDsFromObject(fragments, prevProps);
            var nextIDs = $7ffd5099c2d3641c$var$getDataIDsFromObject(fragments, nextProps);
            var prevRootVariables = $8z8Hv(fragments, prevProps);
            var nextRootVariables = $8z8Hv(fragments, nextProps);
            var resolver = prevState.resolver;
            if (prevState.prevPropsContext.environment !== relayContext.environment || !$l5wS4(prevRootVariables, nextRootVariables) || !$l5wS4(prevIDs, nextIDs)) {
                resolver = $7ffd5099c2d3641c$var$createFragmentSpecResolver(relayContext, containerName, fragments, nextProps, rootIsQueryRenderer);
                return {
                    data: resolver.resolve(),
                    localVariables: null,
                    prevProps: nextProps,
                    prevPropsContext: relayContext,
                    contextForChildren: relayContext,
                    relayProp: $7ffd5099c2d3641c$var$getRelayProp(relayContext.environment, prevState.relayProp.refetch),
                    resolver: resolver
                };
            } else if (!prevState.localVariables) resolver.setProps(nextProps);
            var data = resolver.resolve();
            if (data !== prevState.data) return {
                data: data,
                prevProps: nextProps
            };
            return null;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this._isUnmounted = true;
            this.state.resolver.dispose();
            this._queryFetcher && this._queryFetcher.dispose();
            this._refetchSubscription && this._refetchSubscription.unsubscribe();
        };
        _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
            if (nextState.data !== this.state.data || nextState.relayProp !== this.state.relayProp) return true;
            var keys = Object.keys(nextProps);
            for(var ii = 0; ii < keys.length; ii++){
                var key = keys[ii];
                if (key === '__relayContext') {
                    if (this.state.prevPropsContext.environment !== nextState.prevPropsContext.environment) return true;
                } else {
                    if (!fragments.hasOwnProperty(key) && !$7ffd5099c2d3641c$var$isScalarAndEqual(nextProps[key], this.props[key])) return true;
                }
            }
            return false;
        };
        _proto._rerenderIfStoreHasChanged = function _rerenderIfStoreHasChanged() {
            var _this$state = this.state, data = _this$state.data, resolver = _this$state.resolver;
            var maybeNewData = resolver.resolve();
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._subscribeToNewResolverAndRerenderIfStoreHasChanged = function _subscribeToNewResolverAndRerenderIfStoreHasChanged() {
            var _this$state2 = this.state, data = _this$state2.data, resolver = _this$state2.resolver;
            var maybeNewData = resolver.resolve();
            resolver.setCallback(this.props, this._handleFragmentDataUpdate);
            if (data !== maybeNewData) this.setState({
                data: maybeNewData
            });
        };
        _proto._getFragmentVariables = function _getFragmentVariables() {
            return $7ffd5099c2d3641c$var$getVariablesFromObject(fragments, this.props);
        };
        _proto._getQueryFetcher = function _getQueryFetcher() {
            if (!this._queryFetcher) this._queryFetcher = new $eZrFs();
            return this._queryFetcher;
        };
        _proto.render = function render() {
            var _this$props = this.props, componentRef = _this$props.componentRef, __relayContext = _this$props.__relayContext, __rootIsQueryRenderer = _this$props.__rootIsQueryRenderer, props = (0, $7ffd5099c2d3641c$var$_objectWithoutPropertiesLoose2["default"])(_this$props, $7ffd5099c2d3641c$var$_excluded);
            var _this$state3 = this.state, relayProp = _this$state3.relayProp, contextForChildren = _this$state3.contextForChildren;
            return /*#__PURE__*/ $euxye.createElement($hBqK0.Provider, {
                value: contextForChildren
            }, /*#__PURE__*/ $euxye.createElement(Component, (0, $7ffd5099c2d3641c$var$_extends2["default"])({}, props, this.state.data, {
                ref: componentRef,
                relay: relayProp
            })));
        };
        return _class;
    }($euxye.Component), (0, $7ffd5099c2d3641c$var$_defineProperty2["default"])(_class, "displayName", containerName), _class;
}
function $7ffd5099c2d3641c$var$getRelayProp(environment, refetch) {
    return {
        environment: environment,
        refetch: refetch
    };
}
function $7ffd5099c2d3641c$var$createContainer(Component, fragmentSpec, taggedNode) {
    return $aQgPH(Component, fragmentSpec, function(ComponentClass, fragments) {
        return $7ffd5099c2d3641c$var$createContainerWithFragments(ComponentClass, fragments, taggedNode);
    });
}
module.exports = {
    createContainer: $7ffd5099c2d3641c$var$createContainer
};

});

parcelRegister("bn2Kb", function(module, exports) {
'use strict';

var $bBCVS = parcelRequire("bBCVS");

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");

var $euxye = parcelRequire("euxye");
var $8473f88ea6e4d256$var$useContext = $euxye.useContext, $8473f88ea6e4d256$var$useEffect = $euxye.useEffect;
parcelRequire("8Xbph");
function $8473f88ea6e4d256$var$EntryPointContainer(_ref) {
    var entryPointReference = _ref.entryPointReference, props = _ref.props;
    var getComponent = entryPointReference.getComponent, queries = entryPointReference.queries, entryPoints = entryPointReference.entryPoints, extraProps = entryPointReference.extraProps, rootModuleID = entryPointReference.rootModuleID;
    var Component = getComponent();
    var profilerContext = $8473f88ea6e4d256$var$useContext($bBCVS);
    var environment = $cv6fH();
    $8473f88ea6e4d256$var$useEffect(function() {
        environment.__log({
            name: 'entrypoint.root.consume',
            profilerContext: profilerContext,
            rootModuleID: rootModuleID
        });
    }, [
        environment,
        profilerContext,
        rootModuleID
    ]);
    return /*#__PURE__*/ $euxye.createElement(Component, {
        entryPoints: entryPoints,
        extraProps: extraProps,
        props: props,
        queries: queries
    });
}
module.exports = $8473f88ea6e4d256$var$EntryPointContainer;

});
parcelRegister("bBCVS", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");
var $87315994bfbf5588$var$ProfilerContext = $euxye.createContext({
    wrapPrepareQueryResource: function wrapPrepareQueryResource(cb) {
        return cb();
    }
});
module.exports = $87315994bfbf5588$var$ProfilerContext;

});

parcelRegister("cv6fH", function(module, exports) {
'use strict';

var $hBqK0 = parcelRequire("hBqK0");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $919d3adb89d391a8$var$useContext = $euxye.useContext;
function $919d3adb89d391a8$var$useRelayEnvironment() {
    var context = $919d3adb89d391a8$var$useContext($hBqK0);
    !(context != null) && $jwy7p(false);
    return context.environment;
}
module.exports = $919d3adb89d391a8$var$useRelayEnvironment;

});


parcelRegister("bstJU", function(module, exports) {
'use strict';

var $15gDt = parcelRequire("15gDt");
var $857960de0d522641$var$loadQuery = $15gDt.loadQuery;
function $857960de0d522641$var$loadEntryPoint(environmentProvider, entryPoint, entryPointParams) {
    var loadingPromise = null;
    if (entryPoint.root.getModuleIfRequired() == null) loadingPromise = entryPoint.root.load();
    var preloadProps = entryPoint.getPreloadProps(entryPointParams);
    var queries = preloadProps.queries, entryPoints = preloadProps.entryPoints, extraProps = preloadProps.extraProps;
    var preloadedQueries = {};
    var preloadedEntryPoints = {};
    if (queries != null) {
        var queriesPropNames = Object.keys(queries);
        queriesPropNames.forEach(function(queryPropName) {
            var query = queries[queryPropName];
            if (query == null) return;
            var environmentProviderOptions = query.environmentProviderOptions, options = query.options, parameters = query.parameters, variables = query.variables;
            if ((options === null || options === void 0 ? void 0 : options.includeIf) === false) return;
            var environment = environmentProvider.getEnvironment(environmentProviderOptions);
            preloadedQueries[queryPropName] = $857960de0d522641$var$loadQuery(environment, parameters, variables, {
                fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
                networkCacheConfig: options === null || options === void 0 ? void 0 : options.networkCacheConfig,
                __nameForWarning: 'loadEntryPoint'
            }, environmentProviderOptions);
        });
    }
    if (entryPoints != null) {
        var entryPointPropNames = Object.keys(entryPoints);
        entryPointPropNames.forEach(function(entryPointPropName) {
            var entryPointDescription = entryPoints[entryPointPropName];
            if (entryPointDescription == null) return;
            var nestedEntryPoint = entryPointDescription.entryPoint, nestedParams = entryPointDescription.entryPointParams;
            preloadedEntryPoints[entryPointPropName] = $857960de0d522641$var$loadEntryPoint(environmentProvider, nestedEntryPoint, nestedParams);
        });
    }
    var isDisposed = false;
    return {
        dispose: function dispose() {
            if (isDisposed) return;
            if (preloadedQueries != null) Object.values(preloadedQueries).forEach(function(_ref) {
                var innerDispose = _ref.dispose;
                innerDispose();
            });
            if (preloadedEntryPoints != null) Object.values(preloadedEntryPoints).forEach(function(_ref2) {
                var innerDispose = _ref2.dispose;
                innerDispose();
            });
            isDisposed = true;
        },
        entryPoints: preloadedEntryPoints,
        extraProps: extraProps !== null && extraProps !== void 0 ? extraProps : null,
        getComponent: function getComponent() {
            var componentModule = entryPoint.root.getModuleIfRequired();
            if (componentModule == null) {
                var _loadingPromise;
                loadingPromise = (_loadingPromise = loadingPromise) !== null && _loadingPromise !== void 0 ? _loadingPromise : entryPoint.root.load();
                throw loadingPromise;
            }
            var component = componentModule["default"] != null ? componentModule["default"] : componentModule;
            return component;
        },
        get isDisposed () {
            return isDisposed;
        },
        queries: preloadedQueries,
        rootModuleID: entryPoint.root.getModuleId()
    };
}
module.exports = $857960de0d522641$var$loadEntryPoint;

});
parcelRegister("15gDt", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $0ca3299149a54f89$var$_interopRequireDefault = $8gviu.default;

var $0ca3299149a54f89$var$_objectSpread2 = $0ca3299149a54f89$var$_interopRequireDefault((parcelRequire("lhogL")));

var $jwy7p = parcelRequire("jwy7p");

var $lIGkE = parcelRequire("lIGkE");
var $0ca3299149a54f89$var$fetchQueryDeduped = $lIGkE.__internal.fetchQueryDeduped, $0ca3299149a54f89$var$Observable = $lIGkE.Observable, $0ca3299149a54f89$var$PreloadableQueryRegistry = $lIGkE.PreloadableQueryRegistry, $0ca3299149a54f89$var$ReplaySubject = $lIGkE.ReplaySubject, $0ca3299149a54f89$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $0ca3299149a54f89$var$getRequest = $lIGkE.getRequest, $0ca3299149a54f89$var$getRequestIdentifier = $lIGkE.getRequestIdentifier;
var $0ca3299149a54f89$var$fetchKey = 100001;
function $0ca3299149a54f89$var$loadQuery(environment, preloadableRequest, variables, options, environmentProviderOptions) {
    var _options$fetchPolicy;
    $0ca3299149a54f89$var$fetchKey++;
    var fetchPolicy = (_options$fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy) !== null && _options$fetchPolicy !== void 0 ? _options$fetchPolicy : 'store-or-network';
    var networkCacheConfig = (0, $0ca3299149a54f89$var$_objectSpread2["default"])((0, $0ca3299149a54f89$var$_objectSpread2["default"])({}, options === null || options === void 0 ? void 0 : options.networkCacheConfig), {}, {
        force: true
    });
    var retainReference;
    var didExecuteNetworkSource = false;
    var executeWithNetworkSource = function executeWithNetworkSource(operation, networkObservable) {
        didExecuteNetworkSource = true;
        return environment.executeWithSource({
            operation: operation,
            source: networkObservable
        });
    };
    var executionSubject = new $0ca3299149a54f89$var$ReplaySubject();
    var returnedObservable = $0ca3299149a54f89$var$Observable.create(function(sink) {
        return executionSubject.subscribe(sink);
    });
    var unsubscribeFromNetworkRequest;
    var networkError = null;
    var didMakeNetworkRequest = false;
    var makeNetworkRequest = function makeNetworkRequest(params, checkOperation) {
        didMakeNetworkRequest = true;
        var subject = new $0ca3299149a54f89$var$ReplaySubject();
        var identifier = 'raw-network-request-' + $0ca3299149a54f89$var$getRequestIdentifier(params, variables);
        var observable = $0ca3299149a54f89$var$fetchQueryDeduped(environment, identifier, function() {
            var network = environment.getNetwork();
            return network.execute(params, variables, networkCacheConfig, undefined, undefined, undefined, undefined, checkOperation);
        });
        var _observable$subscribe = observable.subscribe({
            error: function error(err) {
                networkError = err;
                subject.error(err);
            },
            next: function next(data) {
                subject.next(data);
            },
            complete: function complete() {
                subject.complete();
            }
        }), unsubscribe = _observable$subscribe.unsubscribe;
        unsubscribeFromNetworkRequest = unsubscribe;
        return $0ca3299149a54f89$var$Observable.create(function(sink) {
            var subjectSubscription = subject.subscribe(sink);
            return function() {
                subjectSubscription.unsubscribe();
                unsubscribeFromNetworkRequest();
            };
        });
    };
    var unsubscribeFromExecution;
    var executeDeduped = function executeDeduped(operation, fetchFn) {
        didMakeNetworkRequest = true;
        var _fetchQueryDeduped$su = $0ca3299149a54f89$var$fetchQueryDeduped(environment, operation.request.identifier, fetchFn).subscribe({
            error: function error(err) {
                executionSubject.error(err);
            },
            next: function next(data) {
                executionSubject.next(data);
            },
            complete: function complete() {
                executionSubject.complete();
            }
        });
        unsubscribeFromExecution = _fetchQueryDeduped$su.unsubscribe;
    };
    var checkAvailabilityAndExecute = function checkAvailabilityAndExecute(concreteRequest) {
        var operation = $0ca3299149a54f89$var$createOperationDescriptor(concreteRequest, variables, networkCacheConfig);
        retainReference = environment.retain(operation);
        if (fetchPolicy === 'store-only') return;
        var shouldFetch = fetchPolicy !== 'store-or-network' || environment.check(operation).status !== 'available';
        if (shouldFetch) executeDeduped(operation, function() {
            var networkObservable = makeNetworkRequest(concreteRequest.params, function() {
                return environment.check(operation);
            });
            var executeObservable = executeWithNetworkSource(operation, networkObservable);
            return executeObservable;
        });
    };
    var params;
    var cancelOnLoadCallback;
    var queryId;
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') {
        var preloadableConcreteRequest = preloadableRequest;
        params = preloadableConcreteRequest.params;
        var _params = params;
        queryId = _params.id;
        !(queryId !== null) && $jwy7p(false);
        var _module = $0ca3299149a54f89$var$PreloadableQueryRegistry.get(queryId);
        if (_module != null) checkAvailabilityAndExecute(_module);
        else {
            var networkObservable = fetchPolicy === 'store-only' ? null : makeNetworkRequest(params);
            var _PreloadableQueryRegi = $0ca3299149a54f89$var$PreloadableQueryRegistry.onLoad(queryId, function(preloadedModule) {
                cancelOnLoadCallback();
                var operation = $0ca3299149a54f89$var$createOperationDescriptor(preloadedModule, variables, networkCacheConfig);
                retainReference = environment.retain(operation);
                if (networkObservable != null) executeDeduped(operation, function() {
                    return executeWithNetworkSource(operation, networkObservable);
                });
            });
            cancelOnLoadCallback = _PreloadableQueryRegi.dispose;
        }
    } else {
        var graphQlTaggedNode = preloadableRequest;
        var request = $0ca3299149a54f89$var$getRequest(graphQlTaggedNode);
        params = request.params;
        queryId = params.cacheID != null ? params.cacheID : params.id;
        checkAvailabilityAndExecute(request);
    }
    var isDisposed = false;
    var isReleased = false;
    var isNetworkRequestCancelled = false;
    var releaseQuery = function releaseQuery() {
        if (isReleased) return;
        retainReference && retainReference.dispose();
        isReleased = true;
    };
    var cancelNetworkRequest = function cancelNetworkRequest() {
        if (isNetworkRequestCancelled) return;
        if (didExecuteNetworkSource) unsubscribeFromExecution && unsubscribeFromExecution();
        else unsubscribeFromNetworkRequest && unsubscribeFromNetworkRequest();
        cancelOnLoadCallback && cancelOnLoadCallback();
        isNetworkRequestCancelled = true;
    };
    return {
        kind: 'PreloadedQuery',
        environment: environment,
        environmentProviderOptions: environmentProviderOptions,
        dispose: function dispose() {
            if (isDisposed) return;
            releaseQuery();
            cancelNetworkRequest();
            isDisposed = true;
        },
        releaseQuery: releaseQuery,
        cancelNetworkRequest: cancelNetworkRequest,
        fetchKey: $0ca3299149a54f89$var$fetchKey,
        id: queryId,
        get isDisposed () {
            return isDisposed || isReleased;
        },
        get networkError () {
            return networkError;
        },
        name: params.name,
        networkCacheConfig: networkCacheConfig,
        fetchPolicy: fetchPolicy,
        source: didMakeNetworkRequest ? returnedObservable : undefined,
        variables: variables
    };
}
module.exports = {
    loadQuery: $0ca3299149a54f89$var$loadQuery
};

});


parcelRegister("iYrAT", function(module, exports) {
'use strict';

var $hBqK0 = parcelRequire("hBqK0");

var $euxye = parcelRequire("euxye");
var $dd033c2ed806ad78$var$useMemo = $euxye.useMemo;
function $dd033c2ed806ad78$var$RelayEnvironmentProvider(props) {
    var children = props.children, environment = props.environment, getEnvironmentForActor = props.getEnvironmentForActor;
    var context = $dd033c2ed806ad78$var$useMemo(function() {
        return {
            environment: environment,
            getEnvironmentForActor: getEnvironmentForActor
        };
    }, [
        environment,
        getEnvironmentForActor
    ]);
    return /*#__PURE__*/ $euxye.createElement($hBqK0.Provider, {
        value: context
    }, children);
}
module.exports = $dd033c2ed806ad78$var$RelayEnvironmentProvider;

});

parcelRegister("ew5o4", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $a9183ba7cea9207c$var$_interopRequireDefault = $8gviu.default;

var $a9183ba7cea9207c$var$_objectSpread2 = $a9183ba7cea9207c$var$_interopRequireDefault((parcelRequire("lhogL")));

var $b7aL9 = parcelRequire("b7aL9");
function $a9183ba7cea9207c$var$useClientQuery(gqlQuery, variables, options) {
    var query = gqlQuery;
    return $b7aL9(query, variables, (0, $a9183ba7cea9207c$var$_objectSpread2["default"])((0, $a9183ba7cea9207c$var$_objectSpread2["default"])({}, options), {}, {
        fetchPolicy: 'store-only'
    }));
}
module.exports = $a9183ba7cea9207c$var$useClientQuery;

});
parcelRegister("b7aL9", function(module, exports) {
'use strict';

var $aUiNI = parcelRequire("aUiNI");

var $Yilcw = parcelRequire("Yilcw");

var $cv6fH = parcelRequire("cv6fH");

var $lIGkE = parcelRequire("lIGkE");
var $8178b1c2c75689c8$var$fetchQuery = $lIGkE.__internal.fetchQuery;
function $8178b1c2c75689c8$var$useLazyLoadQuery(gqlQuery, variables, options) {
    var environment = $cv6fH();
    var query = $Yilcw(gqlQuery, variables, options && options.networkCacheConfig ? options.networkCacheConfig : {
        force: true
    });
    var data = $aUiNI({
        componentDisplayName: 'useLazyLoadQuery()',
        fetchKey: options === null || options === void 0 ? void 0 : options.fetchKey,
        fetchObservable: $8178b1c2c75689c8$var$fetchQuery(environment, query),
        fetchPolicy: options === null || options === void 0 ? void 0 : options.fetchPolicy,
        query: query,
        renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
    });
    return data;
}
module.exports = $8178b1c2c75689c8$var$useLazyLoadQuery;

});
parcelRegister("aUiNI", function(module, exports) {
'use strict';

var $bBCVS = parcelRequire("bBCVS");

var $1pXeZ = parcelRequire("1pXeZ");
var $7f0db7c98e36c1de$var$getQueryCacheIdentifier = $1pXeZ.getQueryCacheIdentifier, $7f0db7c98e36c1de$var$getQueryResourceForEnvironment = $1pXeZ.getQueryResourceForEnvironment;

var $f4Se5 = parcelRequire("f4Se5");

var $fyupQ = parcelRequire("fyupQ");

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");
var $7f0db7c98e36c1de$var$useContext = $euxye.useContext, $7f0db7c98e36c1de$var$useEffect = $euxye.useEffect, $7f0db7c98e36c1de$var$useState = $euxye.useState, $7f0db7c98e36c1de$var$useRef = $euxye.useRef;
function $7f0db7c98e36c1de$var$useLazyLoadQueryNode(_ref) {
    var query = _ref.query, componentDisplayName = _ref.componentDisplayName, fetchObservable = _ref.fetchObservable, fetchPolicy = _ref.fetchPolicy, fetchKey = _ref.fetchKey, renderPolicy = _ref.renderPolicy;
    var environment = $cv6fH();
    var profilerContext = $7f0db7c98e36c1de$var$useContext($bBCVS);
    var QueryResource = $7f0db7c98e36c1de$var$getQueryResourceForEnvironment(environment);
    var _useState = $7f0db7c98e36c1de$var$useState(0), forceUpdateKey = _useState[0], forceUpdate = _useState[1];
    var _useFetchTrackingRef = $f4Se5(), startFetch = _useFetchTrackingRef.startFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var cacheBreaker = "".concat(forceUpdateKey, "-").concat(fetchKey !== null && fetchKey !== void 0 ? fetchKey : '');
    var cacheIdentifier = $7f0db7c98e36c1de$var$getQueryCacheIdentifier(environment, query, fetchPolicy, renderPolicy, cacheBreaker);
    var preparedQueryResult = profilerContext.wrapPrepareQueryResource(function() {
        return QueryResource.prepareWithIdentifier(cacheIdentifier, query, fetchObservable, fetchPolicy, renderPolicy, {
            start: startFetch,
            complete: completeFetch,
            error: completeFetch
        }, profilerContext);
    });
    var maybeHiddenOrFastRefresh = $7f0db7c98e36c1de$var$useRef(false);
    $7f0db7c98e36c1de$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $7f0db7c98e36c1de$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            forceUpdate(function(n) {
                return n + 1;
            });
            return;
        }
        var disposable = QueryResource.retain(preparedQueryResult, profilerContext);
        return function() {
            disposable.dispose();
        };
    }, [
        environment,
        cacheIdentifier
    ]);
    $7f0db7c98e36c1de$var$useEffect(function() {
        QueryResource.releaseTemporaryRetain(preparedQueryResult);
    });
    var fragmentNode = preparedQueryResult.fragmentNode, fragmentRef = preparedQueryResult.fragmentRef;
    var data = $fyupQ(fragmentNode, fragmentRef, componentDisplayName);
    return data;
}
module.exports = $7f0db7c98e36c1de$var$useLazyLoadQueryNode;

});
parcelRegister("1pXeZ", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $10861438369deee4$var$_interopRequireDefault = $8gviu.default;

var $10861438369deee4$var$_objectSpread2 = $10861438369deee4$var$_interopRequireDefault((parcelRequire("lhogL")));

var $10861438369deee4$var$_defineProperty2 = $10861438369deee4$var$_interopRequireDefault((parcelRequire("dangC")));

var $bQV9D = parcelRequire("bQV9D");

var $kRjFC = parcelRequire("kRjFC");

var $jwy7p = parcelRequire("jwy7p");

var $lIGkE = parcelRequire("lIGkE");
var $10861438369deee4$var$isPromise = $lIGkE.isPromise;
parcelRequire("8Xbph");
var $10861438369deee4$var$CACHE_CAPACITY = 1000;
var $10861438369deee4$var$DEFAULT_FETCH_POLICY = 'store-or-network';
var $10861438369deee4$var$DEFAULT_LIVE_FETCH_POLICY = 'store-and-network';
var $10861438369deee4$var$WEAKMAP_SUPPORTED = typeof WeakMap === 'function';
function $10861438369deee4$var$operationIsLiveQuery(operation) {
    return operation.request.node.params.metadata.live !== undefined;
}
function $10861438369deee4$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
    var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $10861438369deee4$var$operationIsLiveQuery(operation) ? $10861438369deee4$var$DEFAULT_LIVE_FETCH_POLICY : $10861438369deee4$var$DEFAULT_FETCH_POLICY;
    var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
    var cacheIdentifier = "".concat(fetchPolicy, "-").concat(renderPolicy, "-").concat(operation.request.identifier);
    if (cacheBreaker != null) return "".concat(cacheIdentifier, "-").concat(cacheBreaker);
    return cacheIdentifier;
}
function $10861438369deee4$var$getQueryResult(operation, cacheIdentifier) {
    var rootFragmentRef = {
        __id: operation.fragment.dataID,
        __fragments: (0, $10861438369deee4$var$_defineProperty2["default"])({}, operation.fragment.node.name, operation.request.variables),
        __fragmentOwner: operation.request
    };
    return {
        cacheIdentifier: cacheIdentifier,
        fragmentNode: operation.request.node.fragment,
        fragmentRef: rootFragmentRef,
        operation: operation
    };
}
var $10861438369deee4$var$nextID = 200000;
function $10861438369deee4$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, onDispose) {
    var isLiveQuery = $10861438369deee4$var$operationIsLiveQuery(operation);
    var currentValue = value;
    var currentNetworkSubscription = networkSubscription;
    var suspenseResource = new $kRjFC(function(environment) {
        var retention = environment.retain(operation);
        return {
            dispose: function dispose() {
                if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
                retention.dispose();
                onDispose(cacheEntry);
            }
        };
    });
    var cacheEntry = {
        cacheIdentifier: cacheIdentifier,
        id: $10861438369deee4$var$nextID++,
        processedPayloadsCount: 0,
        operationAvailability: operationAvailability,
        getValue: function getValue() {
            return currentValue;
        },
        setValue: function setValue(val) {
            currentValue = val;
        },
        setNetworkSubscription: function setNetworkSubscription(subscription) {
            if (isLiveQuery && currentNetworkSubscription != null) currentNetworkSubscription.unsubscribe();
            currentNetworkSubscription = subscription;
        },
        temporaryRetain: function temporaryRetain(environment) {
            return suspenseResource.temporaryRetain(environment);
        },
        permanentRetain: function permanentRetain(environment) {
            return suspenseResource.permanentRetain(environment);
        },
        releaseTemporaryRetain: function releaseTemporaryRetain() {
            suspenseResource.releaseTemporaryRetain();
        }
    };
    return cacheEntry;
}
var $10861438369deee4$var$QueryResourceImpl = /*#__PURE__*/ function() {
    function QueryResourceImpl(environment) {
        var _this = this;
        (0, $10861438369deee4$var$_defineProperty2["default"])(this, "_clearCacheEntry", function(cacheEntry) {
            _this._cache["delete"](cacheEntry.cacheIdentifier);
        });
        this._environment = environment;
        this._cache = $bQV9D.create($10861438369deee4$var$CACHE_CAPACITY);
    }
    var _proto = QueryResourceImpl.prototype;
    _proto.prepare = function prepare(operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, cacheBreaker, profilerContext) {
        var cacheIdentifier = $10861438369deee4$var$getQueryCacheIdentifier(this._environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this.prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext);
    };
    _proto.prepareWithIdentifier = function prepareWithIdentifier(cacheIdentifier, operation, fetchObservable, maybeFetchPolicy, maybeRenderPolicy, observer, profilerContext) {
        var environment = this._environment;
        var fetchPolicy = maybeFetchPolicy !== null && maybeFetchPolicy !== void 0 ? maybeFetchPolicy : $10861438369deee4$var$operationIsLiveQuery(operation) ? $10861438369deee4$var$DEFAULT_LIVE_FETCH_POLICY : $10861438369deee4$var$DEFAULT_FETCH_POLICY;
        var renderPolicy = maybeRenderPolicy !== null && maybeRenderPolicy !== void 0 ? maybeRenderPolicy : environment.UNSTABLE_getDefaultRenderPolicy();
        var cacheEntry = this._cache.get(cacheIdentifier);
        var temporaryRetainDisposable = null;
        var entryWasCached = cacheEntry != null;
        if (cacheEntry == null) cacheEntry = this._fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, (0, $10861438369deee4$var$_objectSpread2["default"])((0, $10861438369deee4$var$_objectSpread2["default"])({}, observer), {}, {
            unsubscribe: function unsubscribe(subscription) {
                if (temporaryRetainDisposable != null) temporaryRetainDisposable.dispose();
                var observerUnsubscribe = observer === null || observer === void 0 ? void 0 : observer.unsubscribe;
                observerUnsubscribe && observerUnsubscribe(subscription);
            }
        }));
        temporaryRetainDisposable = cacheEntry.temporaryRetain(environment);
        var cachedValue = cacheEntry.getValue();
        if ($10861438369deee4$var$isPromise(cachedValue)) {
            environment.__log({
                name: 'suspense.query',
                fetchPolicy: fetchPolicy,
                isPromiseCached: entryWasCached,
                operation: operation,
                queryAvailability: cacheEntry.operationAvailability,
                renderPolicy: renderPolicy
            });
            throw cachedValue;
        }
        if (cachedValue instanceof Error) throw cachedValue;
        return cachedValue;
    };
    _proto.retain = function retain(queryResult, profilerContext) {
        var environment = this._environment;
        var cacheIdentifier = queryResult.cacheIdentifier, operation = queryResult.operation;
        var cacheEntry = this._getOrCreateCacheEntry(cacheIdentifier, operation, null, queryResult, null);
        var disposable = cacheEntry.permanentRetain(environment);
        environment.__log({
            name: 'queryresource.retain',
            profilerContext: profilerContext,
            resourceID: cacheEntry.id
        });
        return {
            dispose: function dispose() {
                disposable.dispose();
            }
        };
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain(queryResult) {
        var cacheEntry = this._cache.get(queryResult.cacheIdentifier);
        if (cacheEntry != null) cacheEntry.releaseTemporaryRetain();
    };
    _proto.TESTS_ONLY__getCacheEntry = function TESTS_ONLY__getCacheEntry(operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker) {
        var environment = this._environment;
        var cacheIdentifier = $10861438369deee4$var$getQueryCacheIdentifier(environment, operation, maybeFetchPolicy, maybeRenderPolicy, cacheBreaker);
        return this._cache.get(cacheIdentifier);
    };
    _proto._getOrCreateCacheEntry = function _getOrCreateCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription) {
        var cacheEntry = this._cache.get(cacheIdentifier);
        if (cacheEntry == null) {
            cacheEntry = $10861438369deee4$var$createCacheEntry(cacheIdentifier, operation, operationAvailability, value, networkSubscription, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, cacheEntry);
        }
        return cacheEntry;
    };
    _proto._fetchAndSaveQuery = function _fetchAndSaveQuery(cacheIdentifier, operation, fetchObservable, fetchPolicy, renderPolicy, profilerContext, observer) {
        var _this2 = this;
        var environment = this._environment;
        var queryAvailability = environment.check(operation);
        var queryStatus = queryAvailability.status;
        var hasFullQuery = queryStatus === 'available';
        var canPartialRender = hasFullQuery || renderPolicy === 'partial' && queryStatus !== 'stale';
        var shouldFetch;
        var shouldAllowRender;
        var resolveNetworkPromise = function resolveNetworkPromise() {};
        switch(fetchPolicy){
            case 'store-only':
                shouldFetch = false;
                shouldAllowRender = true;
                break;
            case 'store-or-network':
                shouldFetch = !hasFullQuery;
                shouldAllowRender = canPartialRender;
                break;
            case 'store-and-network':
                shouldFetch = true;
                shouldAllowRender = canPartialRender;
                break;
            case 'network-only':
            default:
                shouldFetch = true;
                shouldAllowRender = false;
                break;
        }
        if (shouldAllowRender) {
            var queryResult = $10861438369deee4$var$getQueryResult(operation, cacheIdentifier);
            var _cacheEntry = $10861438369deee4$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, queryResult, null, this._clearCacheEntry);
            this._cache.set(cacheIdentifier, _cacheEntry);
        }
        if (shouldFetch) {
            var _queryResult = $10861438369deee4$var$getQueryResult(operation, cacheIdentifier);
            var networkSubscription;
            fetchObservable.subscribe({
                start: function start(subscription) {
                    networkSubscription = subscription;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(networkSubscription);
                    var observerStart = observer === null || observer === void 0 ? void 0 : observer.start;
                    if (observerStart) {
                        var subscriptionWithConditionalCancelation = (0, $10861438369deee4$var$_objectSpread2["default"])((0, $10861438369deee4$var$_objectSpread2["default"])({}, subscription), {}, {
                            unsubscribe: function unsubscribe() {
                                if ($10861438369deee4$var$operationIsLiveQuery(operation)) subscription.unsubscribe();
                            }
                        });
                        observerStart(subscriptionWithConditionalCancelation);
                    }
                },
                next: function next() {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _queryResult, networkSubscription);
                    cacheEntry.processedPayloadsCount += 1;
                    cacheEntry.setValue(_queryResult);
                    resolveNetworkPromise();
                    var observerNext = observer === null || observer === void 0 ? void 0 : observer.next;
                    if (observerNext != null) {
                        var snapshot = environment.lookup(operation.fragment);
                        observerNext(snapshot);
                    }
                },
                error: function error(_error) {
                    var cacheEntry = _this2._getOrCreateCacheEntry(cacheIdentifier, operation, queryAvailability, _error, networkSubscription);
                    if (cacheEntry.processedPayloadsCount === 0) cacheEntry.setValue(_error);
                    resolveNetworkPromise();
                    networkSubscription = null;
                    cacheEntry.setNetworkSubscription(null);
                    var observerError = observer === null || observer === void 0 ? void 0 : observer.error;
                    observerError && observerError(_error);
                },
                complete: function complete() {
                    resolveNetworkPromise();
                    networkSubscription = null;
                    var cacheEntry = _this2._cache.get(cacheIdentifier);
                    if (cacheEntry) cacheEntry.setNetworkSubscription(null);
                    var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
                    observerComplete && observerComplete();
                },
                unsubscribe: observer === null || observer === void 0 ? void 0 : observer.unsubscribe
            });
            var _cacheEntry2 = this._cache.get(cacheIdentifier);
            if (!_cacheEntry2) {
                var networkPromise = new Promise(function(resolve) {
                    resolveNetworkPromise = resolve;
                });
                networkPromise.displayName = 'Relay(' + operation.fragment.node.name + ')';
                _cacheEntry2 = $10861438369deee4$var$createCacheEntry(cacheIdentifier, operation, queryAvailability, networkPromise, networkSubscription, this._clearCacheEntry);
                this._cache.set(cacheIdentifier, _cacheEntry2);
            }
        } else {
            var observerComplete = observer === null || observer === void 0 ? void 0 : observer.complete;
            observerComplete && observerComplete();
        }
        var cacheEntry = this._cache.get(cacheIdentifier);
        !(cacheEntry != null) && $jwy7p(false);
        environment.__log({
            name: 'queryresource.fetch',
            resourceID: cacheEntry.id,
            operation: operation,
            profilerContext: profilerContext,
            fetchPolicy: fetchPolicy,
            renderPolicy: renderPolicy,
            queryAvailability: queryAvailability,
            shouldFetch: shouldFetch
        });
        return cacheEntry;
    };
    return QueryResourceImpl;
}();
function $10861438369deee4$var$createQueryResource(environment) {
    return new $10861438369deee4$var$QueryResourceImpl(environment);
}
var $10861438369deee4$var$dataResources = $10861438369deee4$var$WEAKMAP_SUPPORTED ? new WeakMap() : new Map();
function $10861438369deee4$var$getQueryResourceForEnvironment(environment) {
    var cached = $10861438369deee4$var$dataResources.get(environment);
    if (cached) return cached;
    var newDataResource = $10861438369deee4$var$createQueryResource(environment);
    $10861438369deee4$var$dataResources.set(environment, newDataResource);
    return newDataResource;
}
module.exports = {
    createQueryResource: $10861438369deee4$var$createQueryResource,
    getQueryResourceForEnvironment: $10861438369deee4$var$getQueryResourceForEnvironment,
    getQueryCacheIdentifier: $10861438369deee4$var$getQueryCacheIdentifier
};

});
parcelRegister("bQV9D", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");
var $8a10e2b761b55bed$var$LRUCache = /*#__PURE__*/ function() {
    function LRUCache(capacity) {
        this._capacity = capacity;
        !(this._capacity > 0) && $jwy7p(false);
        this._map = new Map();
    }
    var _proto = LRUCache.prototype;
    _proto.set = function set(key, value) {
        this._map["delete"](key);
        this._map.set(key, value);
        if (this._map.size > this._capacity) {
            var firstKey = this._map.keys().next();
            if (!firstKey.done) this._map["delete"](firstKey.value);
        }
    };
    _proto.get = function get(key) {
        var value = this._map.get(key);
        if (value != null) {
            this._map["delete"](key);
            this._map.set(key, value);
        }
        return value;
    };
    _proto.has = function has(key) {
        return this._map.has(key);
    };
    _proto["delete"] = function _delete(key) {
        this._map["delete"](key);
    };
    _proto.size = function size() {
        return this._map.size;
    };
    _proto.capacity = function capacity() {
        return this._capacity - this._map.size;
    };
    _proto.clear = function clear() {
        this._map.clear();
    };
    return LRUCache;
}();
function $8a10e2b761b55bed$var$create(capacity) {
    return new $8a10e2b761b55bed$var$LRUCache(capacity);
}
module.exports = {
    create: $8a10e2b761b55bed$var$create
};

});

parcelRegister("kRjFC", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $f2f803fc63ac5018$var$_interopRequireDefault = $8gviu.default;

var $f2f803fc63ac5018$var$_defineProperty2 = $f2f803fc63ac5018$var$_interopRequireDefault((parcelRequire("dangC")));
parcelRequire("8Xbph");
var $f2f803fc63ac5018$var$TEMPORARY_RETAIN_DURATION_MS = 300000;
var $f2f803fc63ac5018$var$SuspenseResource = /*#__PURE__*/ function() {
    function SuspenseResource(retain) {
        var _this = this;
        (0, $f2f803fc63ac5018$var$_defineProperty2["default"])(this, "_retainCount", 0);
        (0, $f2f803fc63ac5018$var$_defineProperty2["default"])(this, "_retainDisposable", null);
        (0, $f2f803fc63ac5018$var$_defineProperty2["default"])(this, "_releaseTemporaryRetain", null);
        this._retain = function(environment) {
            _this._retainCount++;
            if (_this._retainCount === 1) _this._retainDisposable = retain(environment);
            return {
                dispose: function dispose() {
                    _this._retainCount = Math.max(0, _this._retainCount - 1);
                    if (_this._retainCount === 0) {
                        if (_this._retainDisposable != null) {
                            _this._retainDisposable.dispose();
                            _this._retainDisposable = null;
                        }
                    }
                }
            };
        };
    }
    var _proto = SuspenseResource.prototype;
    _proto.temporaryRetain = function temporaryRetain(environment) {
        var _this2 = this;
        var _this$_releaseTempora;
        if (environment.isServer()) return {
            dispose: function dispose() {}
        };
        var retention = this._retain(environment);
        var releaseQueryTimeout = null;
        var releaseTemporaryRetain = function releaseTemporaryRetain() {
            clearTimeout(releaseQueryTimeout);
            releaseQueryTimeout = null;
            _this2._releaseTemporaryRetain = null;
            retention.dispose();
        };
        releaseQueryTimeout = setTimeout(releaseTemporaryRetain, $f2f803fc63ac5018$var$TEMPORARY_RETAIN_DURATION_MS);
        (_this$_releaseTempora = this._releaseTemporaryRetain) === null || _this$_releaseTempora === void 0 || _this$_releaseTempora.call(this);
        this._releaseTemporaryRetain = releaseTemporaryRetain;
        return {
            dispose: function dispose() {
                var _this$_releaseTempora2;
                (_this$_releaseTempora2 = _this2._releaseTemporaryRetain) === null || _this$_releaseTempora2 === void 0 || _this$_releaseTempora2.call(_this2);
            }
        };
    };
    _proto.permanentRetain = function permanentRetain(environment) {
        var disposable = this._retain(environment);
        this.releaseTemporaryRetain();
        return disposable;
    };
    _proto.releaseTemporaryRetain = function releaseTemporaryRetain() {
        var _this$_releaseTempora3;
        (_this$_releaseTempora3 = this._releaseTemporaryRetain) === null || _this$_releaseTempora3 === void 0 || _this$_releaseTempora3.call(this);
        this._releaseTemporaryRetain = null;
    };
    _proto.getRetainCount = function getRetainCount() {
        return this._retainCount;
    };
    return SuspenseResource;
}();
module.exports = $f2f803fc63ac5018$var$SuspenseResource;

});


parcelRegister("f4Se5", function(module, exports) {
'use strict';

var $khXE0 = parcelRequire("khXE0");

var $euxye = parcelRequire("euxye");
var $afa14ae83029d71c$var$useCallback = $euxye.useCallback, $afa14ae83029d71c$var$useEffect = $euxye.useEffect;
function $afa14ae83029d71c$var$useFetchTrackingRef() {
    var subscriptionRef = $khXE0(null);
    var isFetchingRef = $khXE0(false);
    var disposeFetch = $afa14ae83029d71c$var$useCallback(function() {
        if (subscriptionRef.current != null) {
            subscriptionRef.current.unsubscribe();
            subscriptionRef.current = null;
        }
        isFetchingRef.current = false;
    }, []);
    var startFetch = $afa14ae83029d71c$var$useCallback(function(subscription) {
        subscriptionRef.current = subscription;
        isFetchingRef.current = true;
    }, []);
    var completeFetch = $afa14ae83029d71c$var$useCallback(function() {
        subscriptionRef.current = null;
        isFetchingRef.current = false;
    }, []);
    $afa14ae83029d71c$var$useEffect(function() {
        return disposeFetch;
    }, [
        disposeFetch
    ]);
    return {
        isFetchingRef: isFetchingRef,
        startFetch: startFetch,
        disposeFetch: disposeFetch,
        completeFetch: completeFetch
    };
}
module.exports = $afa14ae83029d71c$var$useFetchTrackingRef;

});
parcelRegister("khXE0", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");
var $ec53a948d0e53dda$var$useMemo = $euxye.useMemo;
function $ec53a948d0e53dda$var$useUnsafeRef_DEPRECATED(init) {
    return $ec53a948d0e53dda$var$useMemo(function() {
        return {
            current: init
        };
    }, []);
}
module.exports = $ec53a948d0e53dda$var$useUnsafeRef_DEPRECATED;

});


parcelRegister("fyupQ", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $b5319ff234555584$var$_interopRequireDefault = $8gviu.default;

var $b5319ff234555584$var$_useFragmentInternal_CURRENT = $b5319ff234555584$var$_interopRequireDefault((parcelRequire("deEc4")));

var $b5319ff234555584$var$_useFragmentInternal_EXPERIMENTAL = $b5319ff234555584$var$_interopRequireDefault((parcelRequire("3kQxV")));

var $lIGkE = parcelRequire("lIGkE");
function $b5319ff234555584$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    if ($lIGkE.RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return (0, $b5319ff234555584$var$_useFragmentInternal_EXPERIMENTAL["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
    return (0, $b5319ff234555584$var$_useFragmentInternal_CURRENT["default"])(fragmentNode, fragmentRef, hookDisplayName, queryOptions);
}
module.exports = $b5319ff234555584$var$useFragmentInternal;

});
parcelRegister("deEc4", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $9a2bc2ce4aec4a8d$var$_interopRequireDefault = $8gviu.default;

var $9a2bc2ce4aec4a8d$var$_objectSpread2 = $9a2bc2ce4aec4a8d$var$_interopRequireDefault((parcelRequire("lhogL")));

var $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2 = $9a2bc2ce4aec4a8d$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $9a2bc2ce4aec4a8d$var$_toConsumableArray2 = $9a2bc2ce4aec4a8d$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $1pXeZ = parcelRequire("1pXeZ");
var $9a2bc2ce4aec4a8d$var$getQueryResourceForEnvironment = $1pXeZ.getQueryResourceForEnvironment;

var $cv6fH = parcelRequire("cv6fH");

var $gTW1l = parcelRequire("gTW1l");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $9a2bc2ce4aec4a8d$var$useDebugValue = $euxye.useDebugValue, $9a2bc2ce4aec4a8d$var$useEffect = $euxye.useEffect, $9a2bc2ce4aec4a8d$var$useMemo = $euxye.useMemo, $9a2bc2ce4aec4a8d$var$useRef = $euxye.useRef, $9a2bc2ce4aec4a8d$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $9a2bc2ce4aec4a8d$var$_require3$__internal = $lIGkE.__internal, $9a2bc2ce4aec4a8d$var$fetchQueryInternal = $9a2bc2ce4aec4a8d$var$_require3$__internal.fetchQuery, $9a2bc2ce4aec4a8d$var$getPromiseForActiveRequest = $9a2bc2ce4aec4a8d$var$_require3$__internal.getPromiseForActiveRequest, $9a2bc2ce4aec4a8d$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $9a2bc2ce4aec4a8d$var$areEqualSelectors = $lIGkE.areEqualSelectors, $9a2bc2ce4aec4a8d$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $9a2bc2ce4aec4a8d$var$getPendingOperationsForFragment = $lIGkE.getPendingOperationsForFragment, $9a2bc2ce4aec4a8d$var$getSelector = $lIGkE.getSelector, $9a2bc2ce4aec4a8d$var$getVariablesFromFragment = $lIGkE.getVariablesFromFragment, $9a2bc2ce4aec4a8d$var$handlePotentialSnapshotErrors = $lIGkE.handlePotentialSnapshotErrors, $9a2bc2ce4aec4a8d$var$recycleNodesInto = $lIGkE.recycleNodesInto;
parcelRequire("8Xbph");
function $9a2bc2ce4aec4a8d$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $9a2bc2ce4aec4a8d$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $9a2bc2ce4aec4a8d$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $9a2bc2ce4aec4a8d$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $9a2bc2ce4aec4a8d$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $9a2bc2ce4aec4a8d$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $9a2bc2ce4aec4a8d$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $9a2bc2ce4aec4a8d$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $9a2bc2ce4aec4a8d$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $jwy7p(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch
            }
        ];
    }
}
function $9a2bc2ce4aec4a8d$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $9a2bc2ce4aec4a8d$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $9a2bc2ce4aec4a8d$var$_objectSpread2["default"])((0, $9a2bc2ce4aec4a8d$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $9a2bc2ce4aec4a8d$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $9a2bc2ce4aec4a8d$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $9a2bc2ce4aec4a8d$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    return [
        queryResult,
        $9a2bc2ce4aec4a8d$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request)
    ];
}
function $9a2bc2ce4aec4a8d$var$subscribeToSnapshot(environment, state, setState, hasPendingStateChanges) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector) {
                    var updates = $9a2bc2ce4aec4a8d$var$handleMissedUpdates(environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], nextState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        hasPendingStateChanges.current = dataChanged;
                        return dataChanged ? nextState : prevState;
                    } else return prevState;
                }
                hasPendingStateChanges.current = true;
                return {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch()
                };
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector) {
                        var updates = $9a2bc2ce4aec4a8d$var$handleMissedUpdates(environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], nextState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            hasPendingStateChanges.current = hasPendingStateChanges.current || dataChanged;
                            return dataChanged ? nextState : prevState;
                        } else return prevState;
                    }
                    var updated = (0, $9a2bc2ce4aec4a8d$var$_toConsumableArray2["default"])(prevState.snapshots);
                    updated[index] = latestSnapshot;
                    hasPendingStateChanges.current = true;
                    return {
                        kind: 'plural',
                        snapshots: updated,
                        epoch: environment.getStore().getEpoch()
                    };
                });
            });
        });
        return function() {
            var _iterator6 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $9a2bc2ce4aec4a8d$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch()
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $9a2bc2ce4aec4a8d$var$useFragmentInternal(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $9a2bc2ce4aec4a8d$var$useMemo(function() {
        return $9a2bc2ce4aec4a8d$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jwy7p(false);
    else !!Array.isArray(fragmentRef) && $jwy7p(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jwy7p(false);
    var environment = $cv6fH();
    var loggerContext;
    if ($9a2bc2ce4aec4a8d$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $gTW1l();
    var _useState = $9a2bc2ce4aec4a8d$var$useState(function() {
        return $9a2bc2ce4aec4a8d$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var _useState2 = $9a2bc2ce4aec4a8d$var$useState(state), _subscribedState = _useState2[0], setSubscribedState = _useState2[1];
    var subscribedState = _subscribedState;
    var _useState3 = $9a2bc2ce4aec4a8d$var$useState(fragmentSelector), previousFragmentSelector = _useState3[0], setPreviousFragmentSelector = _useState3[1];
    var _useState4 = $9a2bc2ce4aec4a8d$var$useState(environment), previousEnvironment = _useState4[0], setPreviousEnvironment = _useState4[1];
    if (!$9a2bc2ce4aec4a8d$var$areEqualSelectors(fragmentSelector, previousFragmentSelector) || environment !== previousEnvironment) {
        setPreviousFragmentSelector(fragmentSelector);
        setPreviousEnvironment(environment);
        var newState = $9a2bc2ce4aec4a8d$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        setSubscribedState(newState);
        state = newState;
        subscribedState = newState;
    }
    var committedFragmentSelectorRef = $9a2bc2ce4aec4a8d$var$useRef(false);
    $9a2bc2ce4aec4a8d$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $9a2bc2ce4aec4a8d$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $9a2bc2ce4aec4a8d$var$useMemo(function() {
            var missingClientEdges = $9a2bc2ce4aec4a8d$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $9a2bc2ce4aec4a8d$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) throw Promise.all(activeRequestPromises);
        $9a2bc2ce4aec4a8d$var$useEffect(function() {
            var QueryResource = $9a2bc2ce4aec4a8d$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $9a2bc2ce4aec4a8d$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($9a2bc2ce4aec4a8d$var$isMissingData(state)) {
        var suspendingLiveResolvers = $9a2bc2ce4aec4a8d$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) throw Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
            return environment.getStore().getLiveResolverPromise(liveStateID);
        }));
        if ($9a2bc2ce4aec4a8d$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$9a2bc2ce4aec4a8d$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $jwy7p(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $9a2bc2ce4aec4a8d$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $9a2bc2ce4aec4a8d$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var hasPendingStateChanges = $9a2bc2ce4aec4a8d$var$useRef(false);
    $9a2bc2ce4aec4a8d$var$useEffect(function() {
        var currentState = subscribedState;
        var updates = $9a2bc2ce4aec4a8d$var$handleMissedUpdates(environment, subscribedState);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) setState(updatedState);
            currentState = updatedState;
        }
        return $9a2bc2ce4aec4a8d$var$subscribeToSnapshot(environment, currentState, setState, hasPendingStateChanges);
    }, [
        environment,
        subscribedState
    ]);
    if (hasPendingStateChanges.current) {
        var updates = $9a2bc2ce4aec4a8d$var$handleMissedUpdates(environment, state);
        if (updates != null) {
            var hasStateUpdates = updates[0], updatedState = updates[1];
            if (hasStateUpdates) {
                setState(updatedState);
                state = updatedState;
            }
        }
        hasPendingStateChanges.current = false;
    }
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $9a2bc2ce4aec4a8d$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $jwy7p(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $jwy7p(false);
        data = state.snapshot.data;
    }
    if ($9a2bc2ce4aec4a8d$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $9a2bc2ce4aec4a8d$var$useFragmentInternal;

});
parcelRegister("gTW1l", function(module, exports) {
'use strict';

var $jT6hI = parcelRequire("jT6hI");

var $euxye = parcelRequire("euxye");
var $c4deca13636e5732$var$useContext = $euxye.useContext;
function $c4deca13636e5732$var$useRelayLoggingContext() {
    return $c4deca13636e5732$var$useContext($jT6hI);
}
module.exports = $c4deca13636e5732$var$useRelayLoggingContext;

});
parcelRegister("jT6hI", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $e7a8075fdbe8d0d5$var$createRelayLoggingContext = $lIGkE.__internal.createRelayLoggingContext;
module.exports = $e7a8075fdbe8d0d5$var$createRelayLoggingContext($euxye);

});



parcelRegister("3kQxV", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $26dbfff231403927$var$_interopRequireDefault = $8gviu.default;

var $26dbfff231403927$var$_objectSpread2 = $26dbfff231403927$var$_interopRequireDefault((parcelRequire("lhogL")));

var $26dbfff231403927$var$_createForOfIteratorHelper2 = $26dbfff231403927$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $26dbfff231403927$var$_toConsumableArray2 = $26dbfff231403927$var$_interopRequireDefault((parcelRequire("b0RMC")));

var $1pXeZ = parcelRequire("1pXeZ");
var $26dbfff231403927$var$getQueryResourceForEnvironment = $1pXeZ.getQueryResourceForEnvironment;

var $cv6fH = parcelRequire("cv6fH");

var $gTW1l = parcelRequire("gTW1l");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $26dbfff231403927$var$useDebugValue = $euxye.useDebugValue, $26dbfff231403927$var$useEffect = $euxye.useEffect, $26dbfff231403927$var$useMemo = $euxye.useMemo, $26dbfff231403927$var$useRef = $euxye.useRef, $26dbfff231403927$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $26dbfff231403927$var$_require3$__internal = $lIGkE.__internal, $26dbfff231403927$var$fetchQueryInternal = $26dbfff231403927$var$_require3$__internal.fetchQuery, $26dbfff231403927$var$getPromiseForActiveRequest = $26dbfff231403927$var$_require3$__internal.getPromiseForActiveRequest, $26dbfff231403927$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $26dbfff231403927$var$areEqualSelectors = $lIGkE.areEqualSelectors, $26dbfff231403927$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $26dbfff231403927$var$getPendingOperationsForFragment = $lIGkE.getPendingOperationsForFragment, $26dbfff231403927$var$getSelector = $lIGkE.getSelector, $26dbfff231403927$var$getVariablesFromFragment = $lIGkE.getVariablesFromFragment, $26dbfff231403927$var$handlePotentialSnapshotErrors = $lIGkE.handlePotentialSnapshotErrors, $26dbfff231403927$var$recycleNodesInto = $lIGkE.recycleNodesInto;
parcelRequire("8Xbph");
function $26dbfff231403927$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $26dbfff231403927$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $26dbfff231403927$var$getSuspendingLiveResolver(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi2;
        return (_state$snapshot$missi2 = state.snapshot.missingLiveResolverFields) !== null && _state$snapshot$missi2 !== void 0 ? _state$snapshot$missi2 : null;
    } else {
        var missingFields = null;
        var _iterator3 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                if (snapshot.missingLiveResolverFields) {
                    var _missingFields;
                    missingFields = (_missingFields = missingFields) !== null && _missingFields !== void 0 ? _missingFields : [];
                    var _iterator4 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(snapshot.missingLiveResolverFields), _step4;
                    try {
                        for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                            var edge = _step4.value;
                            missingFields.push(edge);
                        }
                    } catch (err) {
                        _iterator4.e(err);
                    } finally{
                        _iterator4.f();
                    }
                }
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
        return missingFields;
    }
}
function $26dbfff231403927$var$handlePotentialSnapshotErrorsForState(environment, state, loggingContext) {
    if (state.kind === 'singular') $26dbfff231403927$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors, loggingContext);
    else if (state.kind === 'plural') {
        var _iterator5 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step5;
        try {
            for(_iterator5.s(); !(_step5 = _iterator5.n()).done;){
                var snapshot = _step5.value;
                $26dbfff231403927$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors, loggingContext);
            }
        } catch (err) {
            _iterator5.e(err);
        } finally{
            _iterator5.f();
        }
    }
}
function $26dbfff231403927$var$handleMissedUpdates(environment, state) {
    if (state.kind === 'bailout') return null;
    var currentEpoch = environment.getStore().getEpoch();
    if (currentEpoch === state.epoch) return null;
    if (state.kind === 'singular') {
        var currentSnapshot = environment.lookup(state.snapshot.selector);
        var updatedData = $26dbfff231403927$var$recycleNodesInto(state.snapshot.data, currentSnapshot.data);
        var updatedCurrentSnapshot = {
            data: updatedData,
            isMissingData: currentSnapshot.isMissingData,
            missingClientEdges: currentSnapshot.missingClientEdges,
            missingLiveResolverFields: currentSnapshot.missingLiveResolverFields,
            seenRecords: currentSnapshot.seenRecords,
            selector: currentSnapshot.selector,
            fieldErrors: currentSnapshot.fieldErrors
        };
        return [
            updatedData !== state.snapshot.data,
            {
                kind: 'singular',
                snapshot: updatedCurrentSnapshot,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    } else {
        var didMissUpdates = false;
        var currentSnapshots = [];
        for(var index = 0; index < state.snapshots.length; index++){
            var snapshot = state.snapshots[index];
            var _currentSnapshot = environment.lookup(snapshot.selector);
            var _updatedData = $26dbfff231403927$var$recycleNodesInto(snapshot.data, _currentSnapshot.data);
            var _updatedCurrentSnapshot = {
                data: _updatedData,
                isMissingData: _currentSnapshot.isMissingData,
                missingClientEdges: _currentSnapshot.missingClientEdges,
                missingLiveResolverFields: _currentSnapshot.missingLiveResolverFields,
                seenRecords: _currentSnapshot.seenRecords,
                selector: _currentSnapshot.selector,
                fieldErrors: _currentSnapshot.fieldErrors
            };
            if (_updatedData !== snapshot.data) didMissUpdates = true;
            currentSnapshots.push(_updatedCurrentSnapshot);
        }
        !(currentSnapshots.length === state.snapshots.length) && $jwy7p(false);
        return [
            didMissUpdates,
            {
                kind: 'plural',
                snapshots: currentSnapshots,
                epoch: currentEpoch,
                selector: state.selector,
                environment: state.environment
            }
        ];
    }
}
function $26dbfff231403927$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $26dbfff231403927$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $26dbfff231403927$var$_objectSpread2["default"])((0, $26dbfff231403927$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $26dbfff231403927$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $26dbfff231403927$var$getQueryResourceForEnvironment(environment);
    var queryResult = QueryResource.prepare(queryOperationDescriptor, $26dbfff231403927$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
    var promise = $26dbfff231403927$var$getPromiseForActiveRequest(environment, queryOperationDescriptor.request);
    if (promise != null && promise.displayName == null) promise.displayName = missingClientEdgeRequestInfo.request.params.name;
    return [
        queryResult,
        promise
    ];
}
function $26dbfff231403927$var$subscribeToSnapshot(environment, state, setState) {
    if (state.kind === 'bailout') return function() {};
    else if (state.kind === 'singular') {
        var disposable = environment.subscribe(state.snapshot, function(latestSnapshot) {
            setState(function(prevState) {
                var nextState = null;
                if (prevState.kind !== 'singular' || prevState.snapshot.selector !== latestSnapshot.selector || prevState.environment !== environment) {
                    var updates = $26dbfff231403927$var$handleMissedUpdates(prevState.environment, prevState);
                    if (updates != null) {
                        var dataChanged = updates[0], updatedState = updates[1];
                        environment.__log({
                            name: 'useFragment.subscription.missedUpdates',
                            hasDataChanges: dataChanged
                        });
                        nextState = dataChanged ? updatedState : prevState;
                    } else nextState = prevState;
                } else nextState = {
                    kind: 'singular',
                    snapshot: latestSnapshot,
                    epoch: environment.getStore().getEpoch(),
                    selector: state.selector,
                    environment: state.environment
                };
                return nextState;
            });
        });
        return function() {
            disposable.dispose();
        };
    } else {
        var disposables = state.snapshots.map(function(snapshot, index) {
            return environment.subscribe(snapshot, function(latestSnapshot) {
                setState(function(prevState) {
                    var _prevState$snapshots$;
                    var nextState = null;
                    if (prevState.kind !== 'plural' || ((_prevState$snapshots$ = prevState.snapshots[index]) === null || _prevState$snapshots$ === void 0 ? void 0 : _prevState$snapshots$.selector) !== latestSnapshot.selector || prevState.environment !== environment) {
                        var updates = $26dbfff231403927$var$handleMissedUpdates(prevState.environment, prevState);
                        if (updates != null) {
                            var dataChanged = updates[0], updatedState = updates[1];
                            environment.__log({
                                name: 'useFragment.subscription.missedUpdates',
                                hasDataChanges: dataChanged
                            });
                            nextState = dataChanged ? updatedState : prevState;
                        } else nextState = prevState;
                    } else {
                        var updated = (0, $26dbfff231403927$var$_toConsumableArray2["default"])(prevState.snapshots);
                        updated[index] = latestSnapshot;
                        nextState = {
                            kind: 'plural',
                            snapshots: updated,
                            epoch: environment.getStore().getEpoch(),
                            selector: state.selector,
                            environment: state.environment
                        };
                    }
                    return nextState;
                });
            });
        });
        return function() {
            var _iterator6 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(disposables), _step6;
            try {
                for(_iterator6.s(); !(_step6 = _iterator6.n()).done;){
                    var d = _step6.value;
                    d.dispose();
                }
            } catch (err) {
                _iterator6.e(err);
            } finally{
                _iterator6.f();
            }
        };
    }
}
function $26dbfff231403927$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout',
        environment: environment
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') return {
        kind: 'plural',
        snapshots: fragmentSelector.selectors.map(function(s) {
            return environment.lookup(s);
        }),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
    else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch(),
        selector: fragmentSelector,
        environment: environment
    };
}
function $26dbfff231403927$var$useFragmentInternal_EXPERIMENTAL(fragmentNode, fragmentRef, hookDisplayName, queryOptions) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $26dbfff231403927$var$useMemo(function() {
        return $26dbfff231403927$var$getSelector(fragmentNode, fragmentRef);
    }, [
        fragmentNode,
        fragmentRef
    ]);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jwy7p(false);
    else !!Array.isArray(fragmentRef) && $jwy7p(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jwy7p(false);
    var environment = $cv6fH();
    var loggerContext;
    if ($26dbfff231403927$var$RelayFeatureFlags.ENABLE_UI_CONTEXT_ON_RELAY_LOGGER) loggerContext = $gTW1l();
    var _useState = $26dbfff231403927$var$useState(function() {
        return $26dbfff231403927$var$getFragmentState(environment, fragmentSelector);
    }), _state = _useState[0], setState = _useState[1];
    var state = _state;
    var previousEnvironment = state.environment;
    if (!$26dbfff231403927$var$areEqualSelectors(fragmentSelector, state.selector) || environment !== state.environment) {
        var newState = $26dbfff231403927$var$getFragmentState(environment, fragmentSelector);
        setState(newState);
        state = newState;
    }
    var committedFragmentSelectorRef = $26dbfff231403927$var$useRef(false);
    $26dbfff231403927$var$useEffect(function() {
        committedFragmentSelectorRef.current = fragmentSelector;
    }, [
        fragmentSelector
    ]);
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $26dbfff231403927$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var _useMemo = $26dbfff231403927$var$useMemo(function() {
            var missingClientEdges = $26dbfff231403927$var$getMissingClientEdges(state);
            var clientEdgeQueries;
            var activeRequestPromises = [];
            if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
                clientEdgeQueries = [];
                var _iterator7 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step7;
                try {
                    for(_iterator7.s(); !(_step7 = _iterator7.n()).done;){
                        var edge = _step7.value;
                        var _handleMissingClientE = $26dbfff231403927$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions), queryResult = _handleMissingClientE[0], requestPromise = _handleMissingClientE[1];
                        clientEdgeQueries.push(queryResult);
                        if (requestPromise != null) activeRequestPromises.push(requestPromise);
                    }
                } catch (err) {
                    _iterator7.e(err);
                } finally{
                    _iterator7.f();
                }
            }
            return [
                clientEdgeQueries,
                activeRequestPromises
            ];
        }, [
            state,
            environment,
            fragmentNode,
            fragmentRef,
            queryOptions
        ]), clientEdgeQueries = _useMemo[0], activeRequestPromises = _useMemo[1];
        if (activeRequestPromises.length) {
            var allPromises = Promise.all(activeRequestPromises);
            allPromises.displayName = "RelayClientEdge(".concat(activeRequestPromises.map(function(promise) {
                return promise.displayName;
            }).join(','), ")");
            throw allPromises;
        }
        $26dbfff231403927$var$useEffect(function() {
            var QueryResource = $26dbfff231403927$var$getQueryResourceForEnvironment(environment);
            if (clientEdgeQueries !== null && clientEdgeQueries !== void 0 && clientEdgeQueries.length) {
                var disposables = [];
                var _iterator8 = (0, $26dbfff231403927$var$_createForOfIteratorHelper2["default"])(clientEdgeQueries), _step8;
                try {
                    for(_iterator8.s(); !(_step8 = _iterator8.n()).done;){
                        var query = _step8.value;
                        disposables.push(QueryResource.retain(query));
                    }
                } catch (err) {
                    _iterator8.e(err);
                } finally{
                    _iterator8.f();
                }
                return function() {
                    for(var _i = 0, _disposables = disposables; _i < _disposables.length; _i++){
                        var disposable = _disposables[_i];
                        disposable.dispose();
                    }
                };
            }
        }, [
            environment,
            clientEdgeQueries
        ]);
    }
    if ($26dbfff231403927$var$isMissingData(state)) {
        var suspendingLiveResolvers = $26dbfff231403927$var$getSuspendingLiveResolver(state);
        if (suspendingLiveResolvers != null && suspendingLiveResolvers.length > 0) {
            var promise = Promise.all(suspendingLiveResolvers.map(function(liveStateID) {
                return environment.getStore().getLiveResolverPromise(liveStateID);
            }));
            promise.displayName = 'RelayLiveResolver(' + fragmentNode.name + ')';
            throw promise;
        }
        if ($26dbfff231403927$var$RelayFeatureFlags.ENABLE_RELAY_OPERATION_TRACKER_SUSPENSE || environment !== previousEnvironment || !committedFragmentSelectorRef.current || !$26dbfff231403927$var$areEqualSelectors(committedFragmentSelectorRef.current, fragmentSelector)) {
            !(fragmentSelector != null) && $jwy7p(false);
            var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
            var pendingOperationsResult = $26dbfff231403927$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
            if (pendingOperationsResult) throw pendingOperationsResult.promise;
        }
    }
    $26dbfff231403927$var$handlePotentialSnapshotErrorsForState(environment, state, loggerContext);
    var storeSubscriptionRef = $26dbfff231403927$var$useRef(null);
    $26dbfff231403927$var$useEffect(function() {
        var storeSubscription = storeSubscriptionRef.current;
        if (storeSubscription != null) {
            if (state.environment === storeSubscription.environment && state.selector === storeSubscription.selector) return;
            else storeSubscription.dispose();
        }
        if (state.kind === 'bailout') return;
        var stateForSubscription = state;
        var updates = $26dbfff231403927$var$handleMissedUpdates(state.environment, state);
        if (updates !== null) {
            var didMissUpdates = updates[0], updatedState = updates[1];
            if (didMissUpdates) {
                setState(updatedState);
                return;
            }
            stateForSubscription = updatedState;
        }
        var dispose = $26dbfff231403927$var$subscribeToSnapshot(state.environment, stateForSubscription, setState);
        storeSubscriptionRef.current = {
            dispose: dispose,
            selector: state.selector,
            environment: state.environment
        };
    }, [
        state
    ]);
    $26dbfff231403927$var$useEffect(function() {
        if (storeSubscriptionRef.current == null && state.kind !== 'bailout') {
            var dispose = $26dbfff231403927$var$subscribeToSnapshot(state.environment, state, setState);
            storeSubscriptionRef.current = {
                dispose: dispose,
                selector: state.selector,
                environment: state.environment
            };
        }
        return function() {
            var _storeSubscriptionRef;
            (_storeSubscriptionRef = storeSubscriptionRef.current) === null || _storeSubscriptionRef === void 0 || _storeSubscriptionRef.dispose();
            storeSubscriptionRef.current = null;
        };
    }, []);
    var data;
    if (isPlural) {
        var fragmentRefIsNullish = fragmentRef == null;
        data = $26dbfff231403927$var$useMemo(function() {
            if (state.kind === 'bailout') return fragmentRefIsNullish ? null : [];
            else {
                !(state.kind === 'plural') && $jwy7p(false);
                return state.snapshots.map(function(s) {
                    return s.data;
                });
            }
        }, [
            state,
            fragmentRefIsNullish
        ]);
    } else if (state.kind === 'bailout') data = null;
    else {
        !(state.kind === 'singular') && $jwy7p(false);
        data = state.snapshot.data;
    }
    if ($26dbfff231403927$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return data;
}
module.exports = $26dbfff231403927$var$useFragmentInternal_EXPERIMENTAL;

});



parcelRegister("Yilcw", function(module, exports) {
'use strict';

var $3twyR = parcelRequire("3twyR");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $0b53d4d7aa5e8e33$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $0b53d4d7aa5e8e33$var$getRequest = $lIGkE.getRequest;
var $0b53d4d7aa5e8e33$var$useMemo = $euxye.useMemo;
function $0b53d4d7aa5e8e33$var$useMemoOperationDescriptor(gqlQuery, variables, cacheConfig) {
    var memoVariables = $3twyR(variables);
    var memoCacheConfig = $3twyR(cacheConfig || {});
    return $0b53d4d7aa5e8e33$var$useMemo(function() {
        return $0b53d4d7aa5e8e33$var$createOperationDescriptor($0b53d4d7aa5e8e33$var$getRequest(gqlQuery), memoVariables, memoCacheConfig);
    }, [
        gqlQuery,
        memoVariables,
        memoCacheConfig
    ]);
}
module.exports = $0b53d4d7aa5e8e33$var$useMemoOperationDescriptor;

});
parcelRegister("3twyR", function(module, exports) {
'use strict';

var $l5wS4 = parcelRequire("l5wS4");

var $euxye = parcelRequire("euxye");
var $287d56828b5b42fb$var$useState = $euxye.useState;
function $287d56828b5b42fb$var$useMemoVariables(variables) {
    var _useState = $287d56828b5b42fb$var$useState(variables), mirroredVariables = _useState[0], setMirroredVariables = _useState[1];
    if ($l5wS4(variables, mirroredVariables)) return mirroredVariables;
    else {
        setMirroredVariables(variables);
        return variables;
    }
}
module.exports = $287d56828b5b42fb$var$useMemoVariables;

});




parcelRegister("d3iWa", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $980a3eb17bb83171$var$_interopRequireDefault = $8gviu.default;

var $980a3eb17bb83171$var$_createForOfIteratorHelper2 = $980a3eb17bb83171$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $bstJU = parcelRequire("bstJU");

var $8IUqP = parcelRequire("8IUqP");

var $euxye = parcelRequire("euxye");
var $980a3eb17bb83171$var$useCallback = $euxye.useCallback, $980a3eb17bb83171$var$useEffect = $euxye.useEffect, $980a3eb17bb83171$var$useRef = $euxye.useRef, $980a3eb17bb83171$var$useState = $euxye.useState;
var $980a3eb17bb83171$var$initialNullEntryPointReferenceState = {
    kind: 'NullEntryPointReference'
};
function $980a3eb17bb83171$var$useLoadEntryPoint(environmentProvider, entryPoint, options) {
    var _options$TEST_ONLY__i, _options$TEST_ONLY__i2, _options$TEST_ONLY__i3, _options$TEST_ONLY__i4;
    var initialEntryPointReferenceInternal = (_options$TEST_ONLY__i = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i2 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i2 === void 0 ? void 0 : _options$TEST_ONLY__i2.entryPointReference) !== null && _options$TEST_ONLY__i !== void 0 ? _options$TEST_ONLY__i : $980a3eb17bb83171$var$initialNullEntryPointReferenceState;
    var initialEntryPointParamsInternal = (_options$TEST_ONLY__i3 = options === null || options === void 0 ? void 0 : (_options$TEST_ONLY__i4 = options.TEST_ONLY__initialEntryPointData) === null || _options$TEST_ONLY__i4 === void 0 ? void 0 : _options$TEST_ONLY__i4.entryPointParams) !== null && _options$TEST_ONLY__i3 !== void 0 ? _options$TEST_ONLY__i3 : null;
    var isMountedRef = $8IUqP();
    var undisposedEntryPointReferencesRef = $980a3eb17bb83171$var$useRef(new Set([
        initialEntryPointReferenceInternal
    ]));
    var _useState = $980a3eb17bb83171$var$useState(initialEntryPointReferenceInternal), entryPointReference = _useState[0], setEntryPointReference = _useState[1];
    var _useState2 = $980a3eb17bb83171$var$useState(initialEntryPointParamsInternal), entryPointParams = _useState2[0], setEntryPointParams = _useState2[1];
    var disposeEntryPoint = $980a3eb17bb83171$var$useCallback(function() {
        if (isMountedRef.current) {
            var nullEntryPointReference = {
                kind: 'NullEntryPointReference'
            };
            undisposedEntryPointReferencesRef.current.add(nullEntryPointReference);
            setEntryPointReference(nullEntryPointReference);
        }
    }, [
        setEntryPointReference,
        isMountedRef
    ]);
    var entryPointLoaderCallback = $980a3eb17bb83171$var$useCallback(function(params) {
        if (isMountedRef.current) {
            var updatedEntryPointReference = $bstJU(environmentProvider, entryPoint, params);
            undisposedEntryPointReferencesRef.current.add(updatedEntryPointReference);
            setEntryPointReference(updatedEntryPointReference);
            setEntryPointParams(params);
        }
    }, [
        environmentProvider,
        entryPoint,
        setEntryPointReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $980a3eb17bb83171$var$useRef(false);
    $980a3eb17bb83171$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $980a3eb17bb83171$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (entryPointReference.kind !== 'NullEntryPointReference' && entryPointParams != null) entryPointLoaderCallback(entryPointParams);
            return;
        }
        var undisposedEntryPointReferences = undisposedEntryPointReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $980a3eb17bb83171$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedEntryPointReference = _step.value;
                    if (undisposedEntryPointReference === entryPointReference) break;
                    undisposedEntryPointReferences["delete"](undisposedEntryPointReference);
                    if (undisposedEntryPointReference.kind !== 'NullEntryPointReference') undisposedEntryPointReference.dispose();
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        entryPointReference,
        entryPointParams,
        entryPointLoaderCallback,
        isMountedRef
    ]);
    $980a3eb17bb83171$var$useEffect(function() {
        return function disposeAllRemainingEntryPointReferences() {
            var _iterator2 = (0, $980a3eb17bb83171$var$_createForOfIteratorHelper2["default"])(undisposedEntryPointReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var unhandledStateChange = _step2.value;
                    if (unhandledStateChange.kind !== 'NullEntryPointReference') unhandledStateChange.dispose();
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, []);
    return [
        entryPointReference.kind === 'NullEntryPointReference' ? null : entryPointReference,
        entryPointLoaderCallback,
        disposeEntryPoint
    ];
}
module.exports = $980a3eb17bb83171$var$useLoadEntryPoint;

});
parcelRegister("8IUqP", function(module, exports) {
'use strict';

var $euxye = parcelRequire("euxye");
var $659e34f887ceea02$var$useEffect = $euxye.useEffect, $659e34f887ceea02$var$useRef = $euxye.useRef;
function $659e34f887ceea02$var$useIsMountedRef() {
    var isMountedRef = $659e34f887ceea02$var$useRef(true);
    $659e34f887ceea02$var$useEffect(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return isMountedRef;
}
module.exports = $659e34f887ceea02$var$useIsMountedRef;

});


parcelRegister("ahfxy", function(module, exports) {
'use strict';

var $fyupQ = parcelRequire("fyupQ");

var $g4pci = parcelRequire("g4pci");

var $euxye = parcelRequire("euxye");
var $77b78be0393e4498$var$useDebugValue = $euxye.useDebugValue;

var $lIGkE = parcelRequire("lIGkE");
var $77b78be0393e4498$var$getFragment = $lIGkE.getFragment;
function $77b78be0393e4498$var$useFragment(fragment, key) {
    var fragmentNode = $77b78be0393e4498$var$getFragment(fragment);
    $g4pci(fragmentNode, 'first argument of useFragment()');
    var data = $fyupQ(fragmentNode, key, 'useFragment()');
    return data;
}
module.exports = $77b78be0393e4498$var$useFragment;

});
parcelRegister("g4pci", function(module, exports) {
'use strict';
parcelRequire("khXE0");
parcelRequire("8Xbph");
function $bb3090be5c93340f$var$useStaticFragmentNodeWarning(fragmentNode, warningContext) {
    var initialPropRef;
}
module.exports = $bb3090be5c93340f$var$useStaticFragmentNodeWarning;

});


parcelRegister("fReqW", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $b8b700720ed1549e$var$_interopRequireDefault = $8gviu.default;

var $b8b700720ed1549e$var$_objectSpread2 = $b8b700720ed1549e$var$_interopRequireDefault((parcelRequire("lhogL")));

var $8IUqP = parcelRequire("8IUqP");

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $b8b700720ed1549e$var$defaultCommitMutation = $lIGkE.commitMutation;
var $b8b700720ed1549e$var$useState = $euxye.useState, $b8b700720ed1549e$var$useEffect = $euxye.useEffect, $b8b700720ed1549e$var$useRef = $euxye.useRef, $b8b700720ed1549e$var$useCallback = $euxye.useCallback;
function $b8b700720ed1549e$var$useMutation(mutation) {
    var commitMutationFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $b8b700720ed1549e$var$defaultCommitMutation;
    var environment = $cv6fH();
    var isMountedRef = $8IUqP();
    var environmentRef = $b8b700720ed1549e$var$useRef(environment);
    var mutationRef = $b8b700720ed1549e$var$useRef(mutation);
    var inFlightMutationsRef = $b8b700720ed1549e$var$useRef(new Set());
    var _useState = $b8b700720ed1549e$var$useState(false), isMutationInFlight = _useState[0], setMutationInFlight = _useState[1];
    var cleanup = $b8b700720ed1549e$var$useCallback(function(disposable) {
        if (environmentRef.current === environment && mutationRef.current === mutation) {
            inFlightMutationsRef.current["delete"](disposable);
            if (isMountedRef.current) setMutationInFlight(inFlightMutationsRef.current.size > 0);
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    $b8b700720ed1549e$var$useEffect(function() {
        if (environmentRef.current !== environment || mutationRef.current !== mutation) {
            inFlightMutationsRef.current = new Set();
            if (isMountedRef.current) setMutationInFlight(false);
            environmentRef.current = environment;
            mutationRef.current = mutation;
        }
    }, [
        environment,
        isMountedRef,
        mutation
    ]);
    var commit = $b8b700720ed1549e$var$useCallback(function(config) {
        if (isMountedRef.current) setMutationInFlight(true);
        var disposable = commitMutationFn(environment, (0, $b8b700720ed1549e$var$_objectSpread2["default"])((0, $b8b700720ed1549e$var$_objectSpread2["default"])({}, config), {}, {
            mutation: mutation,
            onCompleted: function onCompleted(response, errors) {
                var _config$onCompleted;
                cleanup(disposable);
                (_config$onCompleted = config.onCompleted) === null || _config$onCompleted === void 0 || _config$onCompleted.call(config, response, errors);
            },
            onError: function onError(error) {
                var _config$onError;
                cleanup(disposable);
                (_config$onError = config.onError) === null || _config$onError === void 0 || _config$onError.call(config, error);
            },
            onUnsubscribe: function onUnsubscribe() {
                var _config$onUnsubscribe;
                cleanup(disposable);
                (_config$onUnsubscribe = config.onUnsubscribe) === null || _config$onUnsubscribe === void 0 || _config$onUnsubscribe.call(config);
            },
            onNext: function onNext() {
                var _config$onNext;
                (_config$onNext = config.onNext) === null || _config$onNext === void 0 || _config$onNext.call(config);
            }
        }));
        inFlightMutationsRef.current.add(disposable);
        return disposable;
    }, [
        cleanup,
        commitMutationFn,
        environment,
        isMountedRef,
        mutation
    ]);
    return [
        commit,
        isMutationInFlight
    ];
}
module.exports = $b8b700720ed1549e$var$useMutation;

});

parcelRegister("iEuHa", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $d943c5d9c4014d76$var$_interopRequireDefault = $8gviu.default;

var $d943c5d9c4014d76$var$_objectSpread2 = $d943c5d9c4014d76$var$_interopRequireDefault((parcelRequire("lhogL")));

var $jx9DY = parcelRequire("jx9DY");

var $8sPZN = parcelRequire("8sPZN");

var $cv6fH = parcelRequire("cv6fH");

var $g4pci = parcelRequire("g4pci");

var $euxye = parcelRequire("euxye");
var $d943c5d9c4014d76$var$useCallback = $euxye.useCallback, $d943c5d9c4014d76$var$useDebugValue = $euxye.useDebugValue, $d943c5d9c4014d76$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $d943c5d9c4014d76$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $d943c5d9c4014d76$var$getFragment = $lIGkE.getFragment, $d943c5d9c4014d76$var$getFragmentIdentifier = $lIGkE.getFragmentIdentifier, $d943c5d9c4014d76$var$getPaginationMetadata = $lIGkE.getPaginationMetadata;
function $d943c5d9c4014d76$var$usePaginationFragment(fragmentInput, parentFragmentRef) {
    var fragmentNode = $d943c5d9c4014d76$var$getFragment(fragmentInput);
    $g4pci(fragmentNode, 'first argument of usePaginationFragment()');
    var componentDisplayName = 'usePaginationFragment()';
    var _getPaginationMetadat = $d943c5d9c4014d76$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $8sPZN(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $d943c5d9c4014d76$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var _useLoadMore = $d943c5d9c4014d76$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'backward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadPrevious = _useLoadMore[0], hasPrevious = _useLoadMore[1], isLoadingPrevious = _useLoadMore[2], disposeFetchPrevious = _useLoadMore[3];
    var _useLoadMore2 = $d943c5d9c4014d76$var$useLoadMore({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest
    }), loadNext = _useLoadMore2[0], hasNext = _useLoadMore2[1], isLoadingNext = _useLoadMore2[2], disposeFetchNext = _useLoadMore2[3];
    var refetchPagination = $d943c5d9c4014d76$var$useCallback(function(variables, options) {
        disposeFetchNext();
        disposeFetchPrevious();
        return refetch(variables, (0, $d943c5d9c4014d76$var$_objectSpread2["default"])((0, $d943c5d9c4014d76$var$_objectSpread2["default"])({}, options), {}, {
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        disposeFetchPrevious,
        refetch
    ]);
    return {
        data: fragmentData,
        loadNext: loadNext,
        loadPrevious: loadPrevious,
        hasNext: hasNext,
        hasPrevious: hasPrevious,
        isLoadingNext: isLoadingNext,
        isLoadingPrevious: isLoadingPrevious,
        refetch: refetchPagination
    };
}
function $d943c5d9c4014d76$var$useLoadMore(args) {
    var environment = $cv6fH();
    var _useState = $d943c5d9c4014d76$var$useState(false), isLoadingMore = _useState[0], reallySetIsLoadingMore = _useState[1];
    var setIsLoadingMore = function setIsLoadingMore(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    };
    var observer = {
        start: function start() {
            return setIsLoadingMore(true);
        },
        complete: function complete() {
            return setIsLoadingMore(false);
        },
        error: function error() {
            return setIsLoadingMore(false);
        },
        unsubscribe: $d943c5d9c4014d76$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? function() {
            return setIsLoadingMore(false);
        } : undefined
    };
    var handleReset = function handleReset() {
        return setIsLoadingMore(false);
    };
    var _useLoadMoreFunction = $jx9DY((0, $d943c5d9c4014d76$var$_objectSpread2["default"])((0, $d943c5d9c4014d76$var$_objectSpread2["default"])({}, args), {}, {
        observer: observer,
        onReset: handleReset
    })), loadMore = _useLoadMoreFunction[0], hasMore = _useLoadMoreFunction[1], disposeFetch = _useLoadMoreFunction[2];
    return [
        loadMore,
        hasMore,
        isLoadingMore,
        disposeFetch
    ];
}
module.exports = $d943c5d9c4014d76$var$usePaginationFragment;

});
parcelRegister("jx9DY", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $e388946c9a2c3c89$var$_interopRequireDefault = $8gviu.default;

var $e388946c9a2c3c89$var$_objectSpread2 = $e388946c9a2c3c89$var$_interopRequireDefault((parcelRequire("lhogL")));

var $7LyJ3 = parcelRequire("7LyJ3");

var $f4Se5 = parcelRequire("f4Se5");

var $8IUqP = parcelRequire("8IUqP");

var $41tRi = parcelRequire("41tRi");

var $7oNE3 = parcelRequire("7oNE3");

var $cv6fH = parcelRequire("cv6fH");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $e388946c9a2c3c89$var$useCallback = $euxye.useCallback, $e388946c9a2c3c89$var$useEffect = $euxye.useEffect, $e388946c9a2c3c89$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $e388946c9a2c3c89$var$fetchQuery = $lIGkE.__internal.fetchQuery, $e388946c9a2c3c89$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $e388946c9a2c3c89$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $e388946c9a2c3c89$var$getPaginationVariables = $lIGkE.getPaginationVariables, $e388946c9a2c3c89$var$getRefetchMetadata = $lIGkE.getRefetchMetadata, $e388946c9a2c3c89$var$getSelector = $lIGkE.getSelector;
parcelRequire("8Xbph");
function $e388946c9a2c3c89$var$useLoadMoreFunction(args) {
    if ($e388946c9a2c3c89$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $7oNE3(args);
    return $e388946c9a2c3c89$var$useLoadMoreFunction_CURRENT(args);
}
function $e388946c9a2c3c89$var$useLoadMoreFunction_CURRENT(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $cv6fH();
    var _useFetchTrackingRef = $f4Se5(), isFetchingRef = _useFetchTrackingRef.isFetchingRef, startFetch = _useFetchTrackingRef.startFetch, disposeFetch = _useFetchTrackingRef.disposeFetch, completeFetch = _useFetchTrackingRef.completeFetch;
    var _getRefetchMetadata = $e388946c9a2c3c89$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var isMountedRef = $8IUqP();
    var _useState = $e388946c9a2c3c89$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $e388946c9a2c3c89$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $41tRi(fragmentNode, fragmentRef);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        disposeFetch();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $7LyJ3(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    $e388946c9a2c3c89$var$useEffect(function() {
        return function() {
            disposeFetch();
        };
    }, [
        disposeFetch
    ]);
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var loadMore = $e388946c9a2c3c89$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $e388946c9a2c3c89$var$getSelector(fragmentNode, fragmentRef);
        if (isFetchingRef.current === true || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $jwy7p(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $e388946c9a2c3c89$var$_objectSpread2["default"])((0, $e388946c9a2c3c89$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $e388946c9a2c3c89$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $e388946c9a2c3c89$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $e388946c9a2c3c89$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $e388946c9a2c3c89$var$fetchQuery(environment, paginationQuery).subscribe((0, $e388946c9a2c3c89$var$_objectSpread2["default"])((0, $e388946c9a2c3c89$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                startFetch(subscription);
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                completeFetch();
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                completeFetch();
                observer.error && observer.error(_error);
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: disposeFetch
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        startFetch,
        disposeFetch,
        completeFetch,
        isFetchingRef,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        disposeFetch
    ];
}
module.exports = $e388946c9a2c3c89$var$useLoadMoreFunction;

});
parcelRegister("7LyJ3", function(module, exports) {
'use strict';

var $jwy7p = parcelRequire("jwy7p");

var $lIGkE = parcelRequire("lIGkE");
var $01758bce5a5a43cb$var$ConnectionInterface = $lIGkE.ConnectionInterface, $01758bce5a5a43cb$var$getValueAtPath = $lIGkE.getValueAtPath;
function $01758bce5a5a43cb$var$getConnectionState(direction, fragmentNode, fragmentData, connectionPathInFragmentData) {
    var _pageInfo$END_CURSOR, _pageInfo$START_CURSO;
    var _ConnectionInterface$ = $01758bce5a5a43cb$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES, PAGE_INFO = _ConnectionInterface$.PAGE_INFO, HAS_NEXT_PAGE = _ConnectionInterface$.HAS_NEXT_PAGE, HAS_PREV_PAGE = _ConnectionInterface$.HAS_PREV_PAGE, END_CURSOR = _ConnectionInterface$.END_CURSOR, START_CURSOR = _ConnectionInterface$.START_CURSOR;
    var connection = $01758bce5a5a43cb$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
    if (connection == null) return {
        cursor: null,
        hasMore: false
    };
    !(typeof connection === 'object') && $jwy7p(false);
    var edges = connection[EDGES];
    var pageInfo = connection[PAGE_INFO];
    if (edges == null || pageInfo == null) return {
        cursor: null,
        hasMore: false
    };
    !Array.isArray(edges) && $jwy7p(false);
    !(typeof pageInfo === 'object') && $jwy7p(false);
    var cursor = direction === 'forward' ? (_pageInfo$END_CURSOR = pageInfo[END_CURSOR]) !== null && _pageInfo$END_CURSOR !== void 0 ? _pageInfo$END_CURSOR : null : (_pageInfo$START_CURSO = pageInfo[START_CURSOR]) !== null && _pageInfo$START_CURSO !== void 0 ? _pageInfo$START_CURSO : null;
    !(cursor === null || typeof cursor === 'string') && $jwy7p(false);
    var hasMore;
    if (direction === 'forward') hasMore = cursor != null && pageInfo[HAS_NEXT_PAGE] === true;
    else hasMore = cursor != null && pageInfo[HAS_PREV_PAGE] === true;
    return {
        cursor: cursor,
        hasMore: hasMore
    };
}
module.exports = $01758bce5a5a43cb$var$getConnectionState;

});

parcelRegister("41tRi", function(module, exports) {
'use strict';

var $cv6fH = parcelRequire("cv6fH");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");

var $lIGkE = parcelRequire("lIGkE");
var $2ede6aba7859fd72$var$getObservableForActiveRequest = $lIGkE.__internal.getObservableForActiveRequest, $2ede6aba7859fd72$var$getSelector = $lIGkE.getSelector;
var $2ede6aba7859fd72$var$useEffect = $euxye.useEffect, $2ede6aba7859fd72$var$useState = $euxye.useState, $2ede6aba7859fd72$var$useMemo = $euxye.useMemo;
function $2ede6aba7859fd72$var$useIsOperationNodeActive(fragmentNode, fragmentRef) {
    var environment = $cv6fH();
    var observable = $2ede6aba7859fd72$var$useMemo(function() {
        var selector = $2ede6aba7859fd72$var$getSelector(fragmentNode, fragmentRef);
        if (selector == null) return null;
        !(selector.kind === 'SingularReaderSelector') && $jwy7p(false);
        return $2ede6aba7859fd72$var$getObservableForActiveRequest(environment, selector.owner);
    }, [
        environment,
        fragmentNode,
        fragmentRef
    ]);
    var _useState = $2ede6aba7859fd72$var$useState(observable != null), isActive = _useState[0], setIsActive = _useState[1];
    $2ede6aba7859fd72$var$useEffect(function() {
        var subscription;
        setIsActive(observable != null);
        if (observable != null) {
            var onCompleteOrError = function onCompleteOrError() {
                setIsActive(false);
            };
            subscription = observable.subscribe({
                complete: onCompleteOrError,
                error: onCompleteOrError
            });
        }
        return function() {
            if (subscription) subscription.unsubscribe();
        };
    }, [
        observable
    ]);
    return isActive;
}
module.exports = $2ede6aba7859fd72$var$useIsOperationNodeActive;

});

parcelRegister("7oNE3", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $563148c407089954$var$_interopRequireDefault = $8gviu.default;

var $563148c407089954$var$_objectSpread2 = $563148c407089954$var$_interopRequireDefault((parcelRequire("lhogL")));

var $7LyJ3 = parcelRequire("7LyJ3");

var $8IUqP = parcelRequire("8IUqP");

var $41tRi = parcelRequire("41tRi");

var $cv6fH = parcelRequire("cv6fH");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $563148c407089954$var$useCallback = $euxye.useCallback, $563148c407089954$var$useRef = $euxye.useRef, $563148c407089954$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $563148c407089954$var$fetchQuery = $lIGkE.__internal.fetchQuery, $563148c407089954$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $563148c407089954$var$getPaginationVariables = $lIGkE.getPaginationVariables, $563148c407089954$var$getRefetchMetadata = $lIGkE.getRefetchMetadata, $563148c407089954$var$getSelector = $lIGkE.getSelector;
parcelRequire("8Xbph");
function $563148c407089954$var$useLoadMoreFunction_EXPERIMENTAL(args) {
    var direction = args.direction, fragmentNode = args.fragmentNode, fragmentRef = args.fragmentRef, fragmentIdentifier = args.fragmentIdentifier, fragmentData = args.fragmentData, connectionPathInFragmentData = args.connectionPathInFragmentData, paginationRequest = args.paginationRequest, paginationMetadata = args.paginationMetadata, componentDisplayName = args.componentDisplayName, observer = args.observer, onReset = args.onReset;
    var environment = $cv6fH();
    var _getRefetchMetadata = $563148c407089954$var$getRefetchMetadata(fragmentNode, componentDisplayName), identifierInfo = _getRefetchMetadata.identifierInfo;
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    var fetchStatusRef = $563148c407089954$var$useRef({
        kind: 'none'
    });
    var _useState = $563148c407089954$var$useState(environment), mirroredEnvironment = _useState[0], setMirroredEnvironment = _useState[1];
    var _useState2 = $563148c407089954$var$useState(fragmentIdentifier), mirroredFragmentIdentifier = _useState2[0], setMirroredFragmentIdentifier = _useState2[1];
    var isParentQueryActive = $41tRi(fragmentNode, fragmentRef);
    var forceDisposeFn = $563148c407089954$var$useCallback(function() {
        if (fetchStatusRef.current.kind === 'fetching') fetchStatusRef.current.subscription.unsubscribe();
        fetchStatusRef.current = {
            kind: 'none'
        };
    }, []);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    if (shouldReset) {
        forceDisposeFn();
        onReset();
        setMirroredEnvironment(environment);
        setMirroredFragmentIdentifier(fragmentIdentifier);
    }
    var _getConnectionState = $7LyJ3(direction, fragmentNode, fragmentData, connectionPathInFragmentData), cursor = _getConnectionState.cursor, hasMore = _getConnectionState.hasMore;
    var isRequestInvalid = fragmentData == null || isParentQueryActive;
    var isMountedRef = $8IUqP();
    var loadMore = $563148c407089954$var$useCallback(function(count, options) {
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        var fragmentSelector = $563148c407089954$var$getSelector(fragmentNode, fragmentRef);
        if (fetchStatusRef.current.kind === 'fetching' || isRequestInvalid) {
            fragmentSelector;
            if (onComplete) onComplete(null);
            return {
                dispose: function dispose() {}
            };
        }
        !(fragmentSelector != null && fragmentSelector.kind !== 'PluralReaderSelector') && $jwy7p(false);
        var parentVariables = fragmentSelector.owner.variables;
        var fragmentVariables = fragmentSelector.variables;
        var extraVariables = options === null || options === void 0 ? void 0 : options.UNSTABLE_extraVariables;
        var baseVariables = (0, $563148c407089954$var$_objectSpread2["default"])((0, $563148c407089954$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables);
        var paginationVariables = $563148c407089954$var$getPaginationVariables(direction, count, cursor, baseVariables, (0, $563148c407089954$var$_objectSpread2["default"])({}, extraVariables), paginationMetadata);
        if (identifierInfo != null) {
            typeof identifierValue;
            paginationVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var paginationQuery = $563148c407089954$var$createOperationDescriptor(paginationRequest, paginationVariables, {
            force: true
        });
        $563148c407089954$var$fetchQuery(environment, paginationQuery).subscribe((0, $563148c407089954$var$_objectSpread2["default"])((0, $563148c407089954$var$_objectSpread2["default"])({}, observer), {}, {
            start: function start(subscription) {
                fetchStatusRef.current = {
                    kind: 'fetching',
                    subscription: subscription
                };
                observer.start && observer.start(subscription);
            },
            complete: function complete() {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(null);
            },
            error: function error(_error) {
                fetchStatusRef.current = {
                    kind: 'none'
                };
                observer.complete && observer.complete();
                onComplete && onComplete(_error);
            }
        }));
        return {
            dispose: function dispose() {}
        };
    }, [
        environment,
        identifierValue,
        direction,
        cursor,
        isRequestInvalid,
        fragmentNode.name,
        fragmentRef,
        componentDisplayName
    ]);
    return [
        loadMore,
        hasMore,
        forceDisposeFn
    ];
}
module.exports = $563148c407089954$var$useLoadMoreFunction_EXPERIMENTAL;

});


parcelRegister("8sPZN", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $62994580a927118c$var$_interopRequireDefault = $8gviu.default;

var $62994580a927118c$var$_objectSpread2 = $62994580a927118c$var$_interopRequireDefault((parcelRequire("lhogL")));

var $bBCVS = parcelRequire("bBCVS");

var $1pXeZ = parcelRequire("1pXeZ");
var $62994580a927118c$var$getQueryResourceForEnvironment = $1pXeZ.getQueryResourceForEnvironment;

var $1ws05 = parcelRequire("1ws05");

var $fyupQ = parcelRequire("fyupQ");

var $8IUqP = parcelRequire("8IUqP");

var $dmWeS = parcelRequire("dmWeS");

var $cv6fH = parcelRequire("cv6fH");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $62994580a927118c$var$useCallback = $euxye.useCallback, $62994580a927118c$var$useContext = $euxye.useContext, $62994580a927118c$var$useReducer = $euxye.useReducer;

var $lIGkE = parcelRequire("lIGkE");
var $62994580a927118c$var$fetchQuery = $lIGkE.__internal.fetchQuery, $62994580a927118c$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $62994580a927118c$var$getFragmentIdentifier = $lIGkE.getFragmentIdentifier, $62994580a927118c$var$getRefetchMetadata = $lIGkE.getRefetchMetadata, $62994580a927118c$var$getSelector = $lIGkE.getSelector, $62994580a927118c$var$getValueAtPath = $lIGkE.getValueAtPath;
parcelRequire("8Xbph");
function $62994580a927118c$var$reducer(state, action) {
    switch(action.type){
        case 'refetch':
            var _action$refetchEnviro;
            return (0, $62994580a927118c$var$_objectSpread2["default"])((0, $62994580a927118c$var$_objectSpread2["default"])({}, state), {}, {
                fetchPolicy: action.fetchPolicy,
                mirroredEnvironment: (_action$refetchEnviro = action.refetchEnvironment) !== null && _action$refetchEnviro !== void 0 ? _action$refetchEnviro : state.mirroredEnvironment,
                onComplete: action.onComplete,
                refetchEnvironment: action.refetchEnvironment,
                refetchQuery: action.refetchQuery,
                renderPolicy: action.renderPolicy
            });
        case 'reset':
            return {
                fetchPolicy: undefined,
                mirroredEnvironment: action.environment,
                mirroredFragmentIdentifier: action.fragmentIdentifier,
                onComplete: undefined,
                refetchQuery: null,
                renderPolicy: undefined
            };
        default:
            action.type;
            throw new Error('useRefetchableFragmentNode: Unexpected action type');
    }
}
function $62994580a927118c$var$useRefetchableFragmentInternal(fragmentNode, parentFragmentRef, componentDisplayName) {
    var parentEnvironment = $cv6fH();
    var _getRefetchMetadata = $62994580a927118c$var$getRefetchMetadata(fragmentNode, componentDisplayName), refetchableRequest = _getRefetchMetadata.refetchableRequest, fragmentRefPathInResponse = _getRefetchMetadata.fragmentRefPathInResponse, identifierInfo = _getRefetchMetadata.identifierInfo;
    var fragmentIdentifier = $62994580a927118c$var$getFragmentIdentifier(fragmentNode, parentFragmentRef);
    var _useReducer = $62994580a927118c$var$useReducer($62994580a927118c$var$reducer, {
        fetchPolicy: undefined,
        mirroredEnvironment: parentEnvironment,
        mirroredFragmentIdentifier: fragmentIdentifier,
        onComplete: undefined,
        refetchEnvironment: null,
        refetchQuery: null,
        renderPolicy: undefined
    }), refetchState = _useReducer[0], dispatch = _useReducer[1];
    var fetchPolicy = refetchState.fetchPolicy, mirroredEnvironment = refetchState.mirroredEnvironment, mirroredFragmentIdentifier = refetchState.mirroredFragmentIdentifier, onComplete = refetchState.onComplete, refetchEnvironment = refetchState.refetchEnvironment, refetchQuery = refetchState.refetchQuery, renderPolicy = refetchState.renderPolicy;
    var environment = refetchEnvironment !== null && refetchEnvironment !== void 0 ? refetchEnvironment : parentEnvironment;
    var QueryResource = $62994580a927118c$var$getQueryResourceForEnvironment(environment);
    var profilerContext = $62994580a927118c$var$useContext($bBCVS);
    var shouldReset = environment !== mirroredEnvironment || fragmentIdentifier !== mirroredFragmentIdentifier;
    var _useQueryLoader = $dmWeS(refetchableRequest), queryRef = _useQueryLoader[0], loadQuery = _useQueryLoader[1], disposeQuery = _useQueryLoader[2];
    var fragmentRef = parentFragmentRef;
    if (shouldReset) {
        dispatch({
            type: 'reset',
            environment: environment,
            fragmentIdentifier: fragmentIdentifier
        });
        disposeQuery();
    } else if (refetchQuery != null && queryRef != null) {
        var debugPreviousIDAndTypename;
        var handleQueryCompleted = function handleQueryCompleted(maybeError) {
            onComplete && onComplete(maybeError !== null && maybeError !== void 0 ? maybeError : null);
        };
        var fetchObservable = queryRef.source != null ? queryRef.source : $62994580a927118c$var$fetchQuery(environment, refetchQuery);
        var queryResult = profilerContext.wrapPrepareQueryResource(function() {
            return QueryResource.prepare(refetchQuery, fetchObservable, fetchPolicy, renderPolicy, {
                error: handleQueryCompleted,
                complete: function complete() {
                    handleQueryCompleted();
                }
            }, queryRef.fetchKey, profilerContext);
        });
        var queryData = $1ws05(environment, queryResult.fragmentNode, queryResult.fragmentRef, componentDisplayName).data;
        !(queryData != null) && $jwy7p(false);
        var refetchedFragmentRef = $62994580a927118c$var$getValueAtPath(queryData, fragmentRefPathInResponse);
        fragmentRef = refetchedFragmentRef;
    }
    var fragmentData = $fyupQ(fragmentNode, fragmentRef, componentDisplayName);
    var refetch = $62994580a927118c$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest);
    return {
        fragmentData: fragmentData,
        fragmentRef: fragmentRef,
        refetch: refetch
    };
}
function $62994580a927118c$var$useRefetchFunction(componentDisplayName, dispatch, disposeQuery, fragmentData, fragmentIdentifier, fragmentNode, fragmentRefPathInResponse, identifierInfo, loadQuery, parentFragmentRef, refetchableRequest) {
    var isMountedRef = $8IUqP();
    var identifierValue = (identifierInfo === null || identifierInfo === void 0 ? void 0 : identifierInfo.identifierField) != null && fragmentData != null && typeof fragmentData === 'object' ? fragmentData[identifierInfo.identifierField] : null;
    return $62994580a927118c$var$useCallback(function(providedRefetchVariables, options) {
        if (isMountedRef.current !== true) return {
            dispose: function dispose() {}
        };
        parentFragmentRef;
        var refetchEnvironment = options === null || options === void 0 ? void 0 : options.__environment;
        var fetchPolicy = options === null || options === void 0 ? void 0 : options.fetchPolicy;
        var renderPolicy = options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy;
        var onComplete = options === null || options === void 0 ? void 0 : options.onComplete;
        var fragmentSelector = $62994580a927118c$var$getSelector(fragmentNode, parentFragmentRef);
        var parentVariables;
        var fragmentVariables;
        if (fragmentSelector == null) {
            parentVariables = {};
            fragmentVariables = {};
        } else if (fragmentSelector.kind === 'PluralReaderSelector') {
            var _fragmentSelector$sel, _fragmentSelector$sel2, _fragmentSelector$sel3, _fragmentSelector$sel4;
            parentVariables = (_fragmentSelector$sel = (_fragmentSelector$sel2 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel2 === void 0 ? void 0 : _fragmentSelector$sel2.owner.variables) !== null && _fragmentSelector$sel !== void 0 ? _fragmentSelector$sel : {};
            fragmentVariables = (_fragmentSelector$sel3 = (_fragmentSelector$sel4 = fragmentSelector.selectors[0]) === null || _fragmentSelector$sel4 === void 0 ? void 0 : _fragmentSelector$sel4.variables) !== null && _fragmentSelector$sel3 !== void 0 ? _fragmentSelector$sel3 : {};
        } else {
            parentVariables = fragmentSelector.owner.variables;
            fragmentVariables = fragmentSelector.variables;
        }
        var refetchVariables = (0, $62994580a927118c$var$_objectSpread2["default"])((0, $62994580a927118c$var$_objectSpread2["default"])((0, $62994580a927118c$var$_objectSpread2["default"])({}, parentVariables), fragmentVariables), providedRefetchVariables);
        if (identifierInfo != null && !providedRefetchVariables.hasOwnProperty(identifierInfo.identifierQueryVariableName)) {
            typeof identifierValue;
            refetchVariables[identifierInfo.identifierQueryVariableName] = identifierValue;
        }
        var refetchQuery = $62994580a927118c$var$createOperationDescriptor(refetchableRequest, refetchVariables, {
            force: true
        });
        loadQuery(refetchQuery.request.variables, {
            fetchPolicy: fetchPolicy,
            __environment: refetchEnvironment,
            __nameForWarning: 'refetch'
        });
        dispatch({
            type: 'refetch',
            fetchPolicy: fetchPolicy,
            onComplete: onComplete,
            refetchEnvironment: refetchEnvironment,
            refetchQuery: refetchQuery,
            renderPolicy: renderPolicy
        });
        return {
            dispose: disposeQuery
        };
    }, [
        fragmentIdentifier,
        dispatch,
        disposeQuery,
        identifierValue,
        loadQuery
    ]);
}
var $62994580a927118c$var$debugFunctions;
module.exports = $62994580a927118c$var$useRefetchableFragmentInternal;

});
parcelRegister("1ws05", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $11be7fe74549f757$var$_interopRequireDefault = $8gviu.default;

var $11be7fe74549f757$var$_objectSpread2 = $11be7fe74549f757$var$_interopRequireDefault((parcelRequire("lhogL")));

var $11be7fe74549f757$var$_createForOfIteratorHelper2 = $11be7fe74549f757$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $1pXeZ = parcelRequire("1pXeZ");
var $11be7fe74549f757$var$getQueryResourceForEnvironment = $1pXeZ.getQueryResourceForEnvironment;

var $jwy7p = parcelRequire("jwy7p");

var $lIGkE = parcelRequire("lIGkE");
var $11be7fe74549f757$var$fetchQueryInternal = $lIGkE.__internal.fetchQuery, $11be7fe74549f757$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $11be7fe74549f757$var$createOperationDescriptor = $lIGkE.createOperationDescriptor, $11be7fe74549f757$var$getPendingOperationsForFragment = $lIGkE.getPendingOperationsForFragment, $11be7fe74549f757$var$getSelector = $lIGkE.getSelector, $11be7fe74549f757$var$getVariablesFromFragment = $lIGkE.getVariablesFromFragment, $11be7fe74549f757$var$handlePotentialSnapshotErrors = $lIGkE.handlePotentialSnapshotErrors;
parcelRequire("8Xbph");
function $11be7fe74549f757$var$isMissingData(state) {
    if (state.kind === 'bailout') return false;
    else if (state.kind === 'singular') return state.snapshot.isMissingData;
    else return state.snapshots.some(function(s) {
        return s.isMissingData;
    });
}
function $11be7fe74549f757$var$getMissingClientEdges(state) {
    if (state.kind === 'bailout') return null;
    else if (state.kind === 'singular') {
        var _state$snapshot$missi;
        return (_state$snapshot$missi = state.snapshot.missingClientEdges) !== null && _state$snapshot$missi !== void 0 ? _state$snapshot$missi : null;
    } else {
        var edges = null;
        var _iterator = (0, $11be7fe74549f757$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var snapshot = _step.value;
                if (snapshot.missingClientEdges) {
                    var _edges;
                    edges = (_edges = edges) !== null && _edges !== void 0 ? _edges : [];
                    var _iterator2 = (0, $11be7fe74549f757$var$_createForOfIteratorHelper2["default"])(snapshot.missingClientEdges), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var edge = _step2.value;
                            edges.push(edge);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return edges;
    }
}
function $11be7fe74549f757$var$handlePotentialSnapshotErrorsForState(environment, state) {
    if (state.kind === 'singular') $11be7fe74549f757$var$handlePotentialSnapshotErrors(environment, state.snapshot.fieldErrors);
    else if (state.kind === 'plural') {
        var _iterator3 = (0, $11be7fe74549f757$var$_createForOfIteratorHelper2["default"])(state.snapshots), _step3;
        try {
            for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                var snapshot = _step3.value;
                $11be7fe74549f757$var$handlePotentialSnapshotErrors(environment, snapshot.fieldErrors);
            }
        } catch (err) {
            _iterator3.e(err);
        } finally{
            _iterator3.f();
        }
    }
}
function $11be7fe74549f757$var$handleMissingClientEdge(environment, parentFragmentNode, parentFragmentRef, missingClientEdgeRequestInfo, queryOptions) {
    var originalVariables = $11be7fe74549f757$var$getVariablesFromFragment(parentFragmentNode, parentFragmentRef);
    var variables = (0, $11be7fe74549f757$var$_objectSpread2["default"])((0, $11be7fe74549f757$var$_objectSpread2["default"])({}, originalVariables), {}, {
        id: missingClientEdgeRequestInfo.clientEdgeDestinationID
    });
    var queryOperationDescriptor = $11be7fe74549f757$var$createOperationDescriptor(missingClientEdgeRequestInfo.request, variables, queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.networkCacheConfig);
    var QueryResource = $11be7fe74549f757$var$getQueryResourceForEnvironment(environment);
    return QueryResource.prepare(queryOperationDescriptor, $11be7fe74549f757$var$fetchQueryInternal(environment, queryOperationDescriptor), queryOptions === null || queryOptions === void 0 ? void 0 : queryOptions.fetchPolicy);
}
function $11be7fe74549f757$var$getFragmentState(environment, fragmentSelector) {
    if (fragmentSelector == null) return {
        kind: 'bailout'
    };
    else if (fragmentSelector.kind === 'PluralReaderSelector') {
        if (fragmentSelector.selectors.length === 0) return {
            kind: 'bailout'
        };
        else return {
            kind: 'plural',
            snapshots: fragmentSelector.selectors.map(function(s) {
                return environment.lookup(s);
            }),
            epoch: environment.getStore().getEpoch()
        };
    } else return {
        kind: 'singular',
        snapshot: environment.lookup(fragmentSelector),
        epoch: environment.getStore().getEpoch()
    };
}
function $11be7fe74549f757$var$readFragmentInternal(environment, fragmentNode, fragmentRef, hookDisplayName, queryOptions, fragmentKey) {
    var _fragmentNode$metadat, _fragmentNode$metadat2;
    var fragmentSelector = $11be7fe74549f757$var$getSelector(fragmentNode, fragmentRef);
    var isPlural = (fragmentNode === null || fragmentNode === void 0 ? void 0 : (_fragmentNode$metadat = fragmentNode.metadata) === null || _fragmentNode$metadat === void 0 ? void 0 : _fragmentNode$metadat.plural) === true;
    if (isPlural) !(fragmentRef == null || Array.isArray(fragmentRef)) && $jwy7p(false);
    else !!Array.isArray(fragmentRef) && $jwy7p(false);
    !(fragmentRef == null || isPlural && Array.isArray(fragmentRef) && fragmentRef.length === 0 || fragmentSelector != null) && $jwy7p(false);
    var state = $11be7fe74549f757$var$getFragmentState(environment, fragmentSelector);
    var clientEdgeQueries = null;
    if (((_fragmentNode$metadat2 = fragmentNode.metadata) === null || _fragmentNode$metadat2 === void 0 ? void 0 : _fragmentNode$metadat2.hasClientEdges) === true || $11be7fe74549f757$var$RelayFeatureFlags.CHECK_ALL_FRAGMENTS_FOR_MISSING_CLIENT_EDGES) {
        var missingClientEdges = $11be7fe74549f757$var$getMissingClientEdges(state);
        if (missingClientEdges !== null && missingClientEdges !== void 0 && missingClientEdges.length) {
            clientEdgeQueries = [];
            var _iterator4 = (0, $11be7fe74549f757$var$_createForOfIteratorHelper2["default"])(missingClientEdges), _step4;
            try {
                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                    var edge = _step4.value;
                    clientEdgeQueries.push($11be7fe74549f757$var$handleMissingClientEdge(environment, fragmentNode, fragmentRef, edge, queryOptions));
                }
            } catch (err) {
                _iterator4.e(err);
            } finally{
                _iterator4.f();
            }
        }
    }
    if ($11be7fe74549f757$var$isMissingData(state)) {
        !(fragmentSelector != null) && $jwy7p(false);
        var fragmentOwner = fragmentSelector.kind === 'PluralReaderSelector' ? fragmentSelector.selectors[0].owner : fragmentSelector.owner;
        var pendingOperationsResult = $11be7fe74549f757$var$getPendingOperationsForFragment(environment, fragmentNode, fragmentOwner);
        if (pendingOperationsResult) throw pendingOperationsResult.promise;
        $11be7fe74549f757$var$handlePotentialSnapshotErrorsForState(environment, state);
    }
    var data;
    if (state.kind === 'bailout') data = isPlural ? [] : null;
    else if (state.kind === 'singular') data = state.snapshot.data;
    else data = state.snapshots.map(function(s) {
        return s.data;
    });
    if ($11be7fe74549f757$var$RelayFeatureFlags.LOG_MISSING_RECORDS_IN_PROD || false) fragmentRef != null && (data === undefined || Array.isArray(data) && data.length > 0 && data.every(function(d) {
        return d === undefined;
    }));
    return {
        data: data,
        clientEdgeQueries: clientEdgeQueries
    };
}
module.exports = $11be7fe74549f757$var$readFragmentInternal;

});

parcelRegister("dmWeS", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $9bba817e47da9a84$var$_interopRequireDefault = $8gviu.default;

var $9bba817e47da9a84$var$_createForOfIteratorHelper2 = $9bba817e47da9a84$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $15gDt = parcelRequire("15gDt");
var $9bba817e47da9a84$var$loadQuery = $15gDt.loadQuery;

var $8IUqP = parcelRequire("8IUqP");

var $bbEvm = parcelRequire("bbEvm");

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");
var $9bba817e47da9a84$var$useCallback = $euxye.useCallback, $9bba817e47da9a84$var$useEffect = $euxye.useEffect, $9bba817e47da9a84$var$useRef = $euxye.useRef, $9bba817e47da9a84$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $9bba817e47da9a84$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $9bba817e47da9a84$var$getRequest = $lIGkE.getRequest;
var $9bba817e47da9a84$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $9bba817e47da9a84$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $9bba817e47da9a84$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
function $9bba817e47da9a84$var$useQueryLoader(preloadableRequest, initialQueryReference) {
    if ($9bba817e47da9a84$var$RelayFeatureFlags.ENABLE_ACTIVITY_COMPATIBILITY) return $bbEvm(preloadableRequest, initialQueryReference);
    return $9bba817e47da9a84$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference);
}
function $9bba817e47da9a84$var$useQueryLoader_CURRENT(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $9bba817e47da9a84$var$initialNullQueryReferenceState;
    var environment = $cv6fH();
    var isMountedRef = $8IUqP();
    var undisposedQueryReferencesRef = $9bba817e47da9a84$var$useRef(new Set([
        initialQueryReferenceInternal
    ]));
    var _useState = $9bba817e47da9a84$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $9bba817e47da9a84$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        undisposedQueryReferencesRef.current.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $9bba817e47da9a84$var$useCallback(function() {
        if (isMountedRef.current) {
            undisposedQueryReferencesRef.current.add($9bba817e47da9a84$var$initialNullQueryReferenceState);
            setQueryReference($9bba817e47da9a84$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $9bba817e47da9a84$var$useCallback(function(variables, options) {
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        if (isMountedRef.current) {
            var _options$__environmen;
            var updatedQueryReference = $9bba817e47da9a84$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
            undisposedQueryReferencesRef.current.add(updatedQueryReference);
            setQueryReference(updatedQueryReference);
        }
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var maybeHiddenOrFastRefresh = $9bba817e47da9a84$var$useRef(false);
    $9bba817e47da9a84$var$useEffect(function() {
        return function() {
            maybeHiddenOrFastRefresh.current = true;
        };
    }, []);
    $9bba817e47da9a84$var$useEffect(function() {
        if (maybeHiddenOrFastRefresh.current === true) {
            maybeHiddenOrFastRefresh.current = false;
            if (queryReference.kind !== 'NullQueryReference') queryLoaderCallback(queryReference.variables, {
                fetchPolicy: queryReference.fetchPolicy,
                networkCacheConfig: queryReference.networkCacheConfig
            });
            return;
        }
        var undisposedQueryReferences = undisposedQueryReferencesRef.current;
        if (isMountedRef.current) {
            var _iterator = (0, $9bba817e47da9a84$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
            try {
                for(_iterator.s(); !(_step = _iterator.n()).done;){
                    var undisposedQueryReference = _step.value;
                    if (undisposedQueryReference === queryReference) break;
                    undisposedQueryReferences["delete"](undisposedQueryReference);
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($9bba817e47da9a84$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator.e(err);
            } finally{
                _iterator.f();
            }
        }
    }, [
        queryReference,
        isMountedRef,
        queryLoaderCallback,
        preloadableRequest
    ]);
    $9bba817e47da9a84$var$useEffect(function() {
        return function disposeAllRemainingQueryReferences() {
            var _iterator2 = (0, $9bba817e47da9a84$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferencesRef.current), _step2;
            try {
                for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                    var undisposedQueryReference = _step2.value;
                    if (undisposedQueryReference.kind !== 'NullQueryReference') {
                        if ($9bba817e47da9a84$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                        else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                    }
                }
            } catch (err) {
                _iterator2.e(err);
            } finally{
                _iterator2.f();
            }
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $9bba817e47da9a84$var$useQueryLoader;

});
parcelRegister("bbEvm", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $82502435e9e2804b$var$_interopRequireDefault = $8gviu.default;

var $82502435e9e2804b$var$_createForOfIteratorHelper2 = $82502435e9e2804b$var$_interopRequireDefault((parcelRequire("7kgs3")));

var $15gDt = parcelRequire("15gDt");
var $82502435e9e2804b$var$loadQuery = $15gDt.loadQuery;

var $8IUqP = parcelRequire("8IUqP");

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");
var $82502435e9e2804b$var$useCallback = $euxye.useCallback, $82502435e9e2804b$var$useEffect = $euxye.useEffect, $82502435e9e2804b$var$useInsertionEffect = $euxye.useInsertionEffect, $82502435e9e2804b$var$useRef = $euxye.useRef, $82502435e9e2804b$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $82502435e9e2804b$var$getRequest = $lIGkE.getRequest;
var $82502435e9e2804b$var$initialNullQueryReferenceState = {
    kind: 'NullQueryReference'
};
function $82502435e9e2804b$var$requestIsLiveQuery(preloadableRequest) {
    if (preloadableRequest.kind === 'PreloadableConcreteRequest') return preloadableRequest.params.metadata.live !== undefined;
    var request = $82502435e9e2804b$var$getRequest(preloadableRequest);
    return request.params.metadata.live !== undefined;
}
var $82502435e9e2804b$var$CLEANUP_TIMEOUT = 300000;
function $82502435e9e2804b$var$useQueryLoader_EXPERIMENTAL(preloadableRequest, initialQueryReference) {
    var initialQueryReferenceInternal = initialQueryReference !== null && initialQueryReference !== void 0 ? initialQueryReference : $82502435e9e2804b$var$initialNullQueryReferenceState;
    var environment = $cv6fH();
    var isMountedRef = $8IUqP();
    var undisposedQueryReferencesRef = $82502435e9e2804b$var$useRef(null);
    if (undisposedQueryReferencesRef.current == null) undisposedQueryReferencesRef.current = new Set([
        initialQueryReferenceInternal
    ]);
    var _useState = $82502435e9e2804b$var$useState(function() {
        return initialQueryReferenceInternal;
    }), queryReference = _useState[0], setQueryReference = _useState[1];
    var _useState2 = $82502435e9e2804b$var$useState(function() {
        return initialQueryReferenceInternal;
    }), previousInitialQueryReference = _useState2[0], setPreviousInitialQueryReference = _useState2[1];
    if (initialQueryReferenceInternal !== previousInitialQueryReference) {
        var _undisposedQueryRefer;
        (_undisposedQueryRefer = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer === void 0 || _undisposedQueryRefer.add(initialQueryReferenceInternal);
        setPreviousInitialQueryReference(initialQueryReferenceInternal);
        setQueryReference(initialQueryReferenceInternal);
    }
    var disposeQuery = $82502435e9e2804b$var$useCallback(function() {
        if (isMountedRef.current) {
            var _undisposedQueryRefer2;
            (_undisposedQueryRefer2 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer2 === void 0 || _undisposedQueryRefer2.add($82502435e9e2804b$var$initialNullQueryReferenceState);
            setQueryReference($82502435e9e2804b$var$initialNullQueryReferenceState);
        }
    }, [
        isMountedRef
    ]);
    var queryLoaderCallback = $82502435e9e2804b$var$useCallback(function(variables, options) {
        var _options$__environmen, _undisposedQueryRefer3;
        if (!isMountedRef.current) return;
        var mergedOptions = options != null && options.hasOwnProperty('__environment') ? {
            fetchPolicy: options.fetchPolicy,
            networkCacheConfig: options.networkCacheConfig,
            __nameForWarning: options.__nameForWarning
        } : options;
        var updatedQueryReference = $82502435e9e2804b$var$loadQuery((_options$__environmen = options === null || options === void 0 ? void 0 : options.__environment) !== null && _options$__environmen !== void 0 ? _options$__environmen : environment, preloadableRequest, variables, mergedOptions);
        (_undisposedQueryRefer3 = undisposedQueryReferencesRef.current) === null || _undisposedQueryRefer3 === void 0 || _undisposedQueryRefer3.add(updatedQueryReference);
        setQueryReference(updatedQueryReference);
    }, [
        environment,
        preloadableRequest,
        setQueryReference,
        isMountedRef
    ]);
    var disposeAllRemainingQueryReferences = $82502435e9e2804b$var$useCallback(function disposeAllRemainingQueryReferences(preloadableRequest, currentQueryReference) {
        var _undisposedQueryRefer4;
        var undisposedQueryReferences = (_undisposedQueryRefer4 = undisposedQueryReferencesRef.current) !== null && _undisposedQueryRefer4 !== void 0 ? _undisposedQueryRefer4 : new Set();
        var _iterator = (0, $82502435e9e2804b$var$_createForOfIteratorHelper2["default"])(undisposedQueryReferences), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var undisposedQueryReference = _step.value;
                if (undisposedQueryReference === currentQueryReference) continue;
                if (undisposedQueryReference.kind !== 'NullQueryReference') {
                    if ($82502435e9e2804b$var$requestIsLiveQuery(preloadableRequest)) undisposedQueryReference.dispose && undisposedQueryReference.dispose();
                    else undisposedQueryReference.releaseQuery && undisposedQueryReference.releaseQuery();
                }
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
    }, []);
    var cleanupTimerRef = $82502435e9e2804b$var$useRef(null);
    $82502435e9e2804b$var$useEffect(function() {
        disposeAllRemainingQueryReferences(preloadableRequest, queryReference);
        if (cleanupTimerRef.current != null) {
            clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
        }
        return function() {
            cleanupTimerRef.current = setTimeout(function() {
                disposeAllRemainingQueryReferences(preloadableRequest, null);
            }, $82502435e9e2804b$var$CLEANUP_TIMEOUT);
        };
    }, [
        preloadableRequest,
        queryReference
    ]);
    $82502435e9e2804b$var$useInsertionEffect(function() {
        return function() {
            cleanupTimerRef.current && clearTimeout(cleanupTimerRef.current);
            cleanupTimerRef.current = null;
            disposeAllRemainingQueryReferences(preloadableRequest, null);
        };
    }, [
        preloadableRequest
    ]);
    return [
        queryReference.kind === 'NullQueryReference' ? null : queryReference,
        queryLoaderCallback,
        disposeQuery
    ];
}
module.exports = $82502435e9e2804b$var$useQueryLoader_EXPERIMENTAL;

});




parcelRegister("kwjrX", function(module, exports) {
'use strict';

var $8gviu = parcelRequire("8gviu");
var $ef05e22bb360948e$var$_interopRequireDefault = $8gviu.default;

var $ef05e22bb360948e$var$_objectSpread2 = $ef05e22bb360948e$var$_interopRequireDefault((parcelRequire("lhogL")));

var $ahfxy = parcelRequire("ahfxy");

var $jx9DY = parcelRequire("jx9DY");

var $8sPZN = parcelRequire("8sPZN");

var $cv6fH = parcelRequire("cv6fH");

var $g4pci = parcelRequire("g4pci");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $ef05e22bb360948e$var$useCallback = $euxye.useCallback, $ef05e22bb360948e$var$useDebugValue = $euxye.useDebugValue, $ef05e22bb360948e$var$useEffect = $euxye.useEffect, $ef05e22bb360948e$var$useLayoutEffect = $euxye.useLayoutEffect, $ef05e22bb360948e$var$useMemo = $euxye.useMemo, $ef05e22bb360948e$var$useRef = $euxye.useRef, $ef05e22bb360948e$var$useState = $euxye.useState;

var $lIGkE = parcelRequire("lIGkE");
var $ef05e22bb360948e$var$getFragment = $lIGkE.getFragment, $ef05e22bb360948e$var$getFragmentIdentifier = $lIGkE.getFragmentIdentifier, $ef05e22bb360948e$var$getPaginationMetadata = $lIGkE.getPaginationMetadata;

var $lIGkE = parcelRequire("lIGkE");
var $ef05e22bb360948e$var$ConnectionInterface = $lIGkE.ConnectionInterface, $ef05e22bb360948e$var$RelayFeatureFlags = $lIGkE.RelayFeatureFlags, $ef05e22bb360948e$var$getSelector = $lIGkE.getSelector, $ef05e22bb360948e$var$getValueAtPath = $lIGkE.getValueAtPath;
function $ef05e22bb360948e$var$usePrefetchableForwardPaginationFragment(fragmentInput, parentFragmentRef, bufferSize, initialSize, prefetchingLoadMoreOptions) {
    var _fragmentInput$metada, _fragmentInput$metada2;
    var minimalFetchSize = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
    var disablePrefetching = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : false;
    var fragmentNode = $ef05e22bb360948e$var$getFragment(fragmentInput);
    $g4pci(fragmentNode, 'first argument of usePrefetchableForwardPaginationFragment()');
    var componentDisplayName = 'usePrefetchableForwardPaginationFragment()';
    var _getPaginationMetadat = $ef05e22bb360948e$var$getPaginationMetadata(fragmentNode, componentDisplayName), connectionPathInFragmentData = _getPaginationMetadat.connectionPathInFragmentData, paginationRequest = _getPaginationMetadat.paginationRequest, paginationMetadata = _getPaginationMetadat.paginationMetadata;
    var _useRefetchableFragme = $8sPZN(fragmentNode, parentFragmentRef, componentDisplayName), fragmentData = _useRefetchableFragme.fragmentData, fragmentRef = _useRefetchableFragme.fragmentRef, refetch = _useRefetchableFragme.refetch;
    var fragmentIdentifier = $ef05e22bb360948e$var$getFragmentIdentifier(fragmentNode, fragmentRef);
    var edgeKeys = $ef05e22bb360948e$var$useMemo(function() {
        var connection = $ef05e22bb360948e$var$getValueAtPath(fragmentData, connectionPathInFragmentData);
        if (connection == null) return null;
        var _ConnectionInterface$ = $ef05e22bb360948e$var$ConnectionInterface.get(), EDGES = _ConnectionInterface$.EDGES;
        return connection[EDGES];
    }, [
        connectionPathInFragmentData,
        fragmentData
    ]);
    var sourceSize = edgeKeys == null ? -1 : edgeKeys.length;
    var _useState = $ef05e22bb360948e$var$useState(initialSize != null ? initialSize : sourceSize), _numInUse = _useState[0], setNumInUse = _useState[1];
    var numInUse = _numInUse;
    if (_numInUse === -1 && sourceSize !== -1) {
        numInUse = initialSize != null ? initialSize : sourceSize;
        setNumInUse(numInUse);
    }
    var environment = $cv6fH();
    var _useState2 = $ef05e22bb360948e$var$useState(false), isLoadingMore = _useState2[0], reallySetIsLoadingMore = _useState2[1];
    var _useState3 = $ef05e22bb360948e$var$useState(false), isRefetching = _useState3[0], setIsRefetching = _useState3[1];
    var availableSizeRef = $ef05e22bb360948e$var$useRef(0);
    var setIsLoadingMore = $ef05e22bb360948e$var$useCallback(function(value) {
        var _environment$getSched;
        var schedule = (_environment$getSched = environment.getScheduler()) === null || _environment$getSched === void 0 ? void 0 : _environment$getSched.schedule;
        if (schedule) schedule(function() {
            reallySetIsLoadingMore(value);
        });
        else reallySetIsLoadingMore(value);
    }, [
        environment
    ]);
    var isLoadingMoreRef = $ef05e22bb360948e$var$useRef(false);
    var observer = $ef05e22bb360948e$var$useMemo(function() {
        function setIsLoadingFalse() {
            isLoadingMoreRef.current = false;
            setIsLoadingMore(false);
        }
        return {
            start: function start() {
                isLoadingMoreRef.current = true;
                reallySetIsLoadingMore(true);
            },
            complete: setIsLoadingFalse,
            error: setIsLoadingFalse,
            unsubscribe: $ef05e22bb360948e$var$RelayFeatureFlags.ENABLE_USE_PAGINATION_IS_LOADING_FIX ? setIsLoadingFalse : undefined
        };
    }, [
        setIsLoadingMore
    ]);
    var handleReset = $ef05e22bb360948e$var$useCallback(function() {
        if (!isRefetching) {
            var _environment$getSched2;
            var schedule = (_environment$getSched2 = environment.getScheduler()) === null || _environment$getSched2 === void 0 ? void 0 : _environment$getSched2.schedule;
            if (schedule) schedule(function() {
                setNumInUse(-1);
            });
            else setNumInUse(-1);
        }
        isLoadingMoreRef.current = false;
        setIsLoadingMore(false);
    }, [
        environment,
        isRefetching,
        setIsLoadingMore
    ]);
    var _useLoadMoreFunction = $jx9DY({
        componentDisplayName: componentDisplayName,
        connectionPathInFragmentData: connectionPathInFragmentData,
        direction: 'forward',
        fragmentData: fragmentData,
        fragmentIdentifier: fragmentIdentifier,
        fragmentNode: fragmentNode,
        fragmentRef: fragmentRef,
        paginationMetadata: paginationMetadata,
        paginationRequest: paginationRequest,
        observer: observer,
        onReset: handleReset
    }), loadMore = _useLoadMoreFunction[0], hasNext = _useLoadMoreFunction[1], disposeFetchNext = _useLoadMoreFunction[2];
    $ef05e22bb360948e$var$useLayoutEffect(function() {
        availableSizeRef.current = sourceSize - numInUse;
    }, [
        numInUse,
        sourceSize
    ]);
    var prefetchingUNSTABLE_extraVariables = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.UNSTABLE_extraVariables;
    var prefetchingOnComplete = prefetchingLoadMoreOptions === null || prefetchingLoadMoreOptions === void 0 ? void 0 : prefetchingLoadMoreOptions.onComplete;
    var showMore = $ef05e22bb360948e$var$useCallback(function(numToAdd, options) {
        if (!isLoadingMoreRef.current || availableSizeRef.current >= 0) {
            availableSizeRef.current -= numToAdd;
            setNumInUse(function(lastNumInUse) {
                return lastNumInUse + numToAdd;
            });
            if (!isLoadingMoreRef.current && availableSizeRef.current < 0) loadMore(Math.max(minimalFetchSize, Math.min(numToAdd, bufferSize - availableSizeRef.current)), options !== null && options !== void 0 ? options : {
                onComplete: prefetchingOnComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $ef05e22bb360948e$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $jwy7p(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        bufferSize,
        loadMore,
        minimalFetchSize,
        edgeKeys,
        fragmentData,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete
    ]);
    var edgesFragment = (_fragmentInput$metada = fragmentInput.metadata) === null || _fragmentInput$metada === void 0 ? void 0 : (_fragmentInput$metada2 = _fragmentInput$metada.refetch) === null || _fragmentInput$metada2 === void 0 ? void 0 : _fragmentInput$metada2.edgesFragment;
    !(edgesFragment != null) && $jwy7p(false);
    $ef05e22bb360948e$var$useEffect(function() {
        if (!isLoadingMoreRef.current && !isLoadingMore && !isRefetching && !disablePrefetching && hasNext && (sourceSize - numInUse < bufferSize || numInUse > sourceSize)) {
            var onComplete = prefetchingOnComplete;
            loadMore(Math.max(bufferSize - Math.max(sourceSize - numInUse, 0), numInUse - sourceSize, minimalFetchSize), {
                onComplete: onComplete,
                UNSTABLE_extraVariables: typeof prefetchingUNSTABLE_extraVariables === 'function' ? prefetchingUNSTABLE_extraVariables({
                    hasNext: hasNext,
                    data: fragmentData,
                    getServerEdges: function getServerEdges() {
                        var selector = $ef05e22bb360948e$var$getSelector(edgesFragment, edgeKeys);
                        if (selector == null) return [];
                        !(selector.kind === 'PluralReaderSelector') && $jwy7p(false);
                        return selector.selectors.map(function(sel) {
                            return environment.lookup(sel).data;
                        });
                    }
                }) : prefetchingUNSTABLE_extraVariables
            });
        }
    }, [
        hasNext,
        bufferSize,
        isRefetching,
        loadMore,
        numInUse,
        prefetchingUNSTABLE_extraVariables,
        prefetchingOnComplete,
        sourceSize,
        edgeKeys,
        isLoadingMore,
        minimalFetchSize,
        environment,
        edgesFragment
    ]);
    var realNumInUse = Math.min(numInUse, sourceSize);
    var derivedEdgeKeys = $ef05e22bb360948e$var$useMemo(function() {
        var _edgeKeys$slice;
        return (_edgeKeys$slice = edgeKeys === null || edgeKeys === void 0 ? void 0 : edgeKeys.slice(0, realNumInUse)) !== null && _edgeKeys$slice !== void 0 ? _edgeKeys$slice : [];
    }, [
        edgeKeys,
        realNumInUse
    ]);
    var edges = $ahfxy(edgesFragment, derivedEdgeKeys);
    var refetchPagination = $ef05e22bb360948e$var$useCallback(function(variables, options) {
        disposeFetchNext();
        setIsRefetching(true);
        return refetch(variables, (0, $ef05e22bb360948e$var$_objectSpread2["default"])((0, $ef05e22bb360948e$var$_objectSpread2["default"])({}, options), {}, {
            onComplete: function onComplete(maybeError) {
                var _environment$getSched3, _options$onComplete;
                var schedule = (_environment$getSched3 = environment.getScheduler()) === null || _environment$getSched3 === void 0 ? void 0 : _environment$getSched3.schedule;
                if (schedule) schedule(function() {
                    setIsRefetching(false);
                    setNumInUse(-1);
                });
                else {
                    setIsRefetching(false);
                    setNumInUse(-1);
                }
                options === null || options === void 0 || (_options$onComplete = options.onComplete) === null || _options$onComplete === void 0 || _options$onComplete.call(options, maybeError);
            },
            __environment: undefined
        }));
    }, [
        disposeFetchNext,
        environment,
        refetch
    ]);
    return {
        edges: edges,
        data: fragmentData,
        loadNext: showMore,
        hasNext: hasNext || sourceSize > numInUse,
        isLoadingNext: isLoadingMore && numInUse > sourceSize,
        refetch: refetchPagination
    };
}
module.exports = $ef05e22bb360948e$var$usePrefetchableForwardPaginationFragment;

});

parcelRegister("SfUsg", function(module, exports) {
'use strict';

var $aUiNI = parcelRequire("aUiNI");

var $Yilcw = parcelRequire("Yilcw");

var $cv6fH = parcelRequire("cv6fH");

var $jwy7p = parcelRequire("jwy7p");

var $euxye = parcelRequire("euxye");
var $0a3162916341d9bf$var$useDebugValue = $euxye.useDebugValue;

var $lIGkE = parcelRequire("lIGkE");
var $0a3162916341d9bf$var$_require2$__internal = $lIGkE.__internal, $0a3162916341d9bf$var$fetchQueryDeduped = $0a3162916341d9bf$var$_require2$__internal.fetchQueryDeduped, $0a3162916341d9bf$var$fetchQuery = $0a3162916341d9bf$var$_require2$__internal.fetchQuery;
parcelRequire("8Xbph");
function $0a3162916341d9bf$var$usePreloadedQuery(gqlQuery, preloadedQuery, options) {
    var environment = $cv6fH();
    var fetchKey = preloadedQuery.fetchKey, fetchPolicy = preloadedQuery.fetchPolicy, source = preloadedQuery.source, variables = preloadedQuery.variables, networkCacheConfig = preloadedQuery.networkCacheConfig;
    var operation = $Yilcw(gqlQuery, variables, networkCacheConfig);
    var useLazyLoadQueryNodeParams;
    if (preloadedQuery.kind === 'PreloadedQuery_DEPRECATED') {
        !(operation.request.node.params.name === preloadedQuery.name) && $jwy7p(false);
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchKey: fetchKey,
            fetchObservable: $0a3162916341d9bf$var$fetchQueryDeduped(environment, operation.request.identifier, function() {
                if (environment === preloadedQuery.environment && source != null) return environment.executeWithSource({
                    operation: operation,
                    source: source
                });
                else return environment.execute({
                    operation: operation
                });
            }),
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    } else {
        var fallbackFetchObservable = $0a3162916341d9bf$var$fetchQuery(environment, operation);
        var fetchObservable;
        if (source != null && environment === preloadedQuery.environment) fetchObservable = source.ifEmpty(fallbackFetchObservable);
        else if (environment !== preloadedQuery.environment) fetchObservable = fallbackFetchObservable;
        else fetchObservable = fallbackFetchObservable;
        useLazyLoadQueryNodeParams = {
            componentDisplayName: 'usePreloadedQuery()',
            fetchObservable: fetchObservable,
            fetchKey: fetchKey,
            fetchPolicy: fetchPolicy,
            query: operation,
            renderPolicy: options === null || options === void 0 ? void 0 : options.UNSTABLE_renderPolicy
        };
    }
    var data = $aUiNI(useLazyLoadQueryNodeParams);
    return data;
}
module.exports = $0a3162916341d9bf$var$usePreloadedQuery;

});

parcelRegister("hj03U", function(module, exports) {
'use strict';

var $8sPZN = parcelRequire("8sPZN");

var $g4pci = parcelRequire("g4pci");

var $euxye = parcelRequire("euxye");
var $c994425cce230e47$var$useDebugValue = $euxye.useDebugValue;

var $lIGkE = parcelRequire("lIGkE");
var $c994425cce230e47$var$getFragment = $lIGkE.getFragment;
function $c994425cce230e47$var$useRefetchableFragment(fragmentInput, fragmentRef) {
    var fragmentNode = $c994425cce230e47$var$getFragment(fragmentInput);
    $g4pci(fragmentNode, 'first argument of useRefetchableFragment()');
    var _useRefetchableFragme = $8sPZN(fragmentNode, fragmentRef, 'useRefetchableFragment()'), fragmentData = _useRefetchableFragme.fragmentData, refetch = _useRefetchableFragme.refetch;
    return [
        fragmentData,
        refetch
    ];
}
module.exports = $c994425cce230e47$var$useRefetchableFragment;

});

parcelRegister("2S1Dv", function(module, exports) {
'use strict';

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");
var $2171e4d255d61374$var$useEffect = $euxye.useEffect, $2171e4d255d61374$var$useRef = $euxye.useRef;
function $2171e4d255d61374$var$useSubscribeToInvalidationState(dataIDs, callback) {
    var environment = $cv6fH();
    var disposableRef = $2171e4d255d61374$var$useRef(null);
    var stableDataIDs = Array.from(dataIDs).sort().join('');
    $2171e4d255d61374$var$useEffect(function() {
        var store = environment.getStore();
        var invalidationState = store.lookupInvalidationState(dataIDs);
        var disposable = store.subscribeToInvalidationState(invalidationState, callback);
        disposableRef.current = disposable;
        return function() {
            return disposable.dispose();
        };
    }, [
        stableDataIDs,
        callback,
        environment
    ]);
    return {
        dispose: function dispose() {
            if (disposableRef.current != null) disposableRef.current.dispose();
        }
    };
}
module.exports = $2171e4d255d61374$var$useSubscribeToInvalidationState;

});

parcelRegister("lLWgl", function(module, exports) {
'use strict';

var $cv6fH = parcelRequire("cv6fH");

var $euxye = parcelRequire("euxye");
var $fd9b2e7ebfbefd82$var$useEffect = $euxye.useEffect;

var $lIGkE = parcelRequire("lIGkE");
var $fd9b2e7ebfbefd82$var$requestSubscription = $lIGkE.requestSubscription;
function $fd9b2e7ebfbefd82$var$useSubscription(config, requestSubscriptionFn) {
    var actualRequestSubscription = requestSubscriptionFn !== null && requestSubscriptionFn !== void 0 ? requestSubscriptionFn : $fd9b2e7ebfbefd82$var$requestSubscription;
    var environment = $cv6fH();
    $fd9b2e7ebfbefd82$var$useEffect(function() {
        var _actualRequestSubscri = actualRequestSubscription(environment, config), dispose = _actualRequestSubscri.dispose;
        return dispose;
    }, [
        environment,
        config,
        actualRequestSubscription
    ]);
}
module.exports = $fd9b2e7ebfbefd82$var$useSubscription;

});




parcelRegister("7WYgw", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';

var $fludA = parcelRequire("fludA");
var $5c9cb2a796199697$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $5c9cb2a796199697$var$hyphenateStyleName(string) {
    return $fludA(string).replace($5c9cb2a796199697$var$msPattern, '-ms-');
}
module.exports = $5c9cb2a796199697$var$hyphenateStyleName;

});
parcelRegister("fludA", function(module, exports) {
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $b2c041dc5db40a58$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $b2c041dc5db40a58$var$hyphenate(string) {
    return string.replace($b2c041dc5db40a58$var$_uppercasePattern, '-$1').toLowerCase();
}
module.exports = $b2c041dc5db40a58$var$hyphenate;

});


parcelRegister("k2H7I", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $e97571f5bf03dc16$export$2e2bcd8739ae039);
function $e97571f5bf03dc16$var$isAbsolute(pathname) {
    return pathname.charAt(0) === '/';
}
// About 1.5x faster than the two-arg version of Array#splice()
function $e97571f5bf03dc16$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
// This implementation is based heavily on node's url.parse
function $e97571f5bf03dc16$var$resolvePathname(to) {
    var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    var toParts = to && to.split('/') || [];
    var fromParts = from && from.split('/') || [];
    var isToAbs = to && $e97571f5bf03dc16$var$isAbsolute(to);
    var isFromAbs = from && $e97571f5bf03dc16$var$isAbsolute(from);
    var mustEndAbs = isToAbs || isFromAbs;
    if (to && $e97571f5bf03dc16$var$isAbsolute(to)) // to is absolute
    fromParts = toParts;
    else if (toParts.length) {
        // to is relative, drop the filename
        fromParts.pop();
        fromParts = fromParts.concat(toParts);
    }
    if (!fromParts.length) return '/';
    var hasTrailingSlash = void 0;
    if (fromParts.length) {
        var last = fromParts[fromParts.length - 1];
        hasTrailingSlash = last === '.' || last === '..' || last === '';
    } else hasTrailingSlash = false;
    var up = 0;
    for(var i = fromParts.length; i >= 0; i--){
        var part = fromParts[i];
        if (part === '.') $e97571f5bf03dc16$var$spliceOne(fromParts, i);
        else if (part === '..') {
            $e97571f5bf03dc16$var$spliceOne(fromParts, i);
            up++;
        } else if (up) {
            $e97571f5bf03dc16$var$spliceOne(fromParts, i);
            up--;
        }
    }
    if (!mustEndAbs) for(; up--; up)fromParts.unshift('..');
    if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !$e97571f5bf03dc16$var$isAbsolute(fromParts[0]))) fromParts.unshift('');
    var result = fromParts.join('/');
    if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
    return result;
}
var $e97571f5bf03dc16$export$2e2bcd8739ae039 = $e97571f5bf03dc16$var$resolvePathname;

});

parcelRegister("dLZMC", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $a06f96fdde0d7ee3$export$2e2bcd8739ae039);
var $a06f96fdde0d7ee3$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
function $a06f96fdde0d7ee3$var$valueEqual(a, b) {
    if (a === b) return true;
    if (a == null || b == null) return false;
    if (Array.isArray(a)) return Array.isArray(b) && a.length === b.length && a.every(function(item, index) {
        return $a06f96fdde0d7ee3$var$valueEqual(item, b[index]);
    });
    var aType = typeof a === 'undefined' ? 'undefined' : $a06f96fdde0d7ee3$var$_typeof(a);
    var bType = typeof b === 'undefined' ? 'undefined' : $a06f96fdde0d7ee3$var$_typeof(b);
    if (aType !== bType) return false;
    if (aType === 'object') {
        var aValue = a.valueOf();
        var bValue = b.valueOf();
        if (aValue !== a || bValue !== b) return $a06f96fdde0d7ee3$var$valueEqual(aValue, bValue);
        var aKeys = Object.keys(a);
        var bKeys = Object.keys(b);
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every(function(key) {
            return $a06f96fdde0d7ee3$var$valueEqual(a[key], b[key]);
        });
    }
    return false;
}
var $a06f96fdde0d7ee3$export$2e2bcd8739ae039 = $a06f96fdde0d7ee3$var$valueEqual;

});

parcelRegister("gMcNh", function(module, exports) {
$parcel$export(module.exports, "default", () => $c36b0da2814f261c$export$2e2bcd8739ae039);

var $5UmqJ = parcelRequire("5UmqJ");

var $jLYsE = parcelRequire("jLYsE");
var $lLfJi = parcelRequire("lLfJi");
var $aNuGO = parcelRequire("aNuGO");
var $j1tP7 = parcelRequire("j1tP7");
var $26NqB = parcelRequire("26NqB");
var $7xf0I = parcelRequire("7xf0I");
parcelRequire("g1pWA");
parcelRequire("54WhA");
var $c36b0da2814f261c$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $jLYsE.peek)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $jLYsE.token)(character)) break;
        (0, $jLYsE.next)();
    }
    return (0, $jLYsE.slice)(begin, (0, $jLYsE.position));
};
var $c36b0da2814f261c$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $jLYsE.token)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $jLYsE.peek)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $c36b0da2814f261c$var$identifierWithPointTracking((0, $jLYsE.position) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $jLYsE.delimit)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $jLYsE.peek)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $lLfJi.from)(character);
    }
    while (character = (0, $jLYsE.next)());
    return parsed;
};
var $c36b0da2814f261c$var$getRules = function getRules(value, points) {
    return (0, $jLYsE.dealloc)($c36b0da2814f261c$var$toRules((0, $jLYsE.alloc)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $c36b0da2814f261c$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $c36b0da2814f261c$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$c36b0da2814f261c$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $c36b0da2814f261c$var$fixedElements.set(element, true);
    var points = [];
    var rules = $c36b0da2814f261c$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $c36b0da2814f261c$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
/* eslint-disable no-fallthrough */ function $c36b0da2814f261c$var$prefix(value, length) {
    switch((0, $lLfJi.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $j1tP7.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $j1tP7.WEBKIT) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MOZ) + value + (0, $j1tP7.MS) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + value + value;
        // order
        case 6165:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $j1tP7.WEBKIT) + value + (0, $lLfJi.replace)(value, /(\w+).+(:[^]+)/, (0, $j1tP7.WEBKIT) + 'box-$1$2' + (0, $j1tP7.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-item-' + (0, $lLfJi.replace)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-line-pack' + (0, $lLfJi.replace)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $j1tP7.WEBKIT) + 'box-' + (0, $lLfJi.replace)(value, '-grow', '') + (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $j1tP7.WEBKIT) + (0, $lLfJi.replace)(value, /([^-])(transform)/g, '$1' + (0, $j1tP7.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $lLfJi.replace)((0, $lLfJi.replace)((0, $lLfJi.replace)(value, /(zoom-|grab)/, (0, $j1tP7.WEBKIT) + '$1'), /(image-set)/, (0, $j1tP7.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lLfJi.replace)(value, /(image-set\([^]*)/, (0, $j1tP7.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $lLfJi.replace)((0, $lLfJi.replace)(value, /(.+:)(flex-)?(.*)/, (0, $j1tP7.WEBKIT) + 'box-pack:$3' + (0, $j1tP7.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $j1tP7.WEBKIT) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lLfJi.replace)(value, /(.+)-inline(.+)/, (0, $j1tP7.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lLfJi.strlen)(value) - 1 - length > 6) switch((0, $lLfJi.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lLfJi.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lLfJi.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $j1tP7.WEBKIT) + '$2-$3' + '$1' + (0, $j1tP7.MOZ) + ((0, $lLfJi.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lLfJi.indexof)(value, 'stretch') ? $c36b0da2814f261c$var$prefix((0, $lLfJi.replace)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $lLfJi.charat)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $lLfJi.charat)(value, (0, $lLfJi.strlen)(value) - 3 - (~(0, $lLfJi.indexof)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $lLfJi.replace)(value, ':', ':' + (0, $j1tP7.WEBKIT)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $lLfJi.replace)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $j1tP7.WEBKIT) + ((0, $lLfJi.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $j1tP7.WEBKIT) + '$2$3' + '$1' + (0, $j1tP7.MS) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $lLfJi.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + value + value;
    }
    return value;
}
var $c36b0da2814f261c$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $j1tP7.DECLARATION:
                element["return"] = $c36b0da2814f261c$var$prefix(element.value, element.length);
                break;
            case 0, $j1tP7.KEYFRAMES:
                return (0, $7xf0I.serialize)([
                    (0, $jLYsE.copy)(element, {
                        value: (0, $lLfJi.replace)(element.value, '@', '@' + (0, $j1tP7.WEBKIT))
                    })
                ], callback);
            case 0, $j1tP7.RULESET:
                if (element.length) return (0, $lLfJi.combine)(element.props, function(value) {
                    switch((0, $lLfJi.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $7xf0I.serialize)([
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(read-\w+)/, ':' + (0, $j1tP7.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $7xf0I.serialize)([
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, ':' + (0, $j1tP7.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, ':' + (0, $j1tP7.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, (0, $j1tP7.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $c36b0da2814f261c$var$defaultStylisPlugins = [
    $c36b0da2814f261c$var$prefixer
];
var $c36b0da2814f261c$export$2e2bcd8739ae039 = function /*: EmotionCache */ createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $c36b0da2814f261c$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    /* : Node */ var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' ');
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    /*: (
  selector: string,
  serialized: SerializedStyles,
  sheet: StyleSheet,
  shouldCache: boolean
  ) => string | void */ var omnipresentPlugins = [
        $c36b0da2814f261c$var$compat,
        $c36b0da2814f261c$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $7xf0I.stringify),
        (0, $26NqB.rulesheet)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $26NqB.middleware)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $7xf0I.serialize)((0, $aNuGO.compile)(styles), serializer);
    };
    _insert = function /*: void */ insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $5UmqJ.StyleSheet)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};

});
parcelRegister("jLYsE", function(module, exports) {
$parcel$export(module.exports, "position", () => $e6514e71f305903d$export$5880b8b5730aff45);
$parcel$export(module.exports, "node", () => $e6514e71f305903d$export$35059013cd4a06db);
$parcel$export(module.exports, "copy", () => $e6514e71f305903d$export$784d13d8ee351f07);
$parcel$export(module.exports, "char", () => $e6514e71f305903d$export$eba6f6f03b0a92e7);
$parcel$export(module.exports, "prev", () => $e6514e71f305903d$export$232faf9add678146);
$parcel$export(module.exports, "next", () => $e6514e71f305903d$export$48cfd1e771a65c4f);
$parcel$export(module.exports, "peek", () => $e6514e71f305903d$export$4d3fb11e950abb9e);
$parcel$export(module.exports, "caret", () => $e6514e71f305903d$export$e88cb2efb12ae807);
$parcel$export(module.exports, "slice", () => $e6514e71f305903d$export$58adb3bec8346d0f);
$parcel$export(module.exports, "token", () => $e6514e71f305903d$export$9e1725a4cfeada27);
$parcel$export(module.exports, "alloc", () => $e6514e71f305903d$export$2de70f21292aac9e);
$parcel$export(module.exports, "dealloc", () => $e6514e71f305903d$export$45918ac1574455b1);
$parcel$export(module.exports, "delimit", () => $e6514e71f305903d$export$410ac95b9ec204b8);
$parcel$export(module.exports, "tokenize", () => $e6514e71f305903d$export$660b2ee2d4fb4eff);
$parcel$export(module.exports, "whitespace", () => $e6514e71f305903d$export$7af1228ff777d175);
$parcel$export(module.exports, "identifier", () => $e6514e71f305903d$export$c2ab62c7bf24634);
$parcel$export(module.exports, "escaping", () => $e6514e71f305903d$export$955ba06d119e085e);
$parcel$export(module.exports, "commenter", () => $e6514e71f305903d$export$4254d4e2b3745c4c);

var $lLfJi = parcelRequire("lLfJi");
var $e6514e71f305903d$export$53f1d5ea8de3d7c = 1;
var $e6514e71f305903d$export$4e0c71f277ca26b3 = 1;
var $e6514e71f305903d$export$f24224f1c91d8156 = 0;
var $e6514e71f305903d$export$5880b8b5730aff45 = 0;
var $e6514e71f305903d$export$c0306caf338ac095 = 0;
var $e6514e71f305903d$export$30a86d91af8ff6e6 = '';
function $e6514e71f305903d$export$35059013cd4a06db(value, root, parent, type, props, children, length) {
    return {
        value: value,
        root: root,
        parent: parent,
        type: type,
        props: props,
        children: children,
        line: $e6514e71f305903d$export$53f1d5ea8de3d7c,
        column: $e6514e71f305903d$export$4e0c71f277ca26b3,
        length: length,
        return: ''
    };
}
function $e6514e71f305903d$export$784d13d8ee351f07(root, props) {
    return (0, $lLfJi.assign)($e6514e71f305903d$export$35059013cd4a06db('', null, null, '', null, null, 0), root, {
        length: -root.length
    }, props);
}
function $e6514e71f305903d$export$eba6f6f03b0a92e7() {
    return $e6514e71f305903d$export$c0306caf338ac095;
}
function $e6514e71f305903d$export$232faf9add678146() {
    $e6514e71f305903d$export$c0306caf338ac095 = $e6514e71f305903d$export$5880b8b5730aff45 > 0 ? (0, $lLfJi.charat)($e6514e71f305903d$export$30a86d91af8ff6e6, --$e6514e71f305903d$export$5880b8b5730aff45) : 0;
    if ($e6514e71f305903d$export$4e0c71f277ca26b3--, $e6514e71f305903d$export$c0306caf338ac095 === 10) $e6514e71f305903d$export$4e0c71f277ca26b3 = 1, $e6514e71f305903d$export$53f1d5ea8de3d7c--;
    return $e6514e71f305903d$export$c0306caf338ac095;
}
function $e6514e71f305903d$export$48cfd1e771a65c4f() {
    $e6514e71f305903d$export$c0306caf338ac095 = $e6514e71f305903d$export$5880b8b5730aff45 < $e6514e71f305903d$export$f24224f1c91d8156 ? (0, $lLfJi.charat)($e6514e71f305903d$export$30a86d91af8ff6e6, $e6514e71f305903d$export$5880b8b5730aff45++) : 0;
    if ($e6514e71f305903d$export$4e0c71f277ca26b3++, $e6514e71f305903d$export$c0306caf338ac095 === 10) $e6514e71f305903d$export$4e0c71f277ca26b3 = 1, $e6514e71f305903d$export$53f1d5ea8de3d7c++;
    return $e6514e71f305903d$export$c0306caf338ac095;
}
function $e6514e71f305903d$export$4d3fb11e950abb9e() {
    return (0, $lLfJi.charat)($e6514e71f305903d$export$30a86d91af8ff6e6, $e6514e71f305903d$export$5880b8b5730aff45);
}
function $e6514e71f305903d$export$e88cb2efb12ae807() {
    return $e6514e71f305903d$export$5880b8b5730aff45;
}
function $e6514e71f305903d$export$58adb3bec8346d0f(begin, end) {
    return (0, $lLfJi.substr)($e6514e71f305903d$export$30a86d91af8ff6e6, begin, end);
}
function $e6514e71f305903d$export$9e1725a4cfeada27(type) {
    switch(type){
        // \0 \t \n \r \s whitespace token
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        // ! + , / > @ ~ isolate token
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        // ; { } breakpoint token
        case 59:
        case 123:
        case 125:
            return 4;
        // : accompanied token
        case 58:
            return 3;
        // " ' ( [ opening delimit token
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        // ) ] closing delimit token
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $e6514e71f305903d$export$2de70f21292aac9e(value) {
    return $e6514e71f305903d$export$53f1d5ea8de3d7c = $e6514e71f305903d$export$4e0c71f277ca26b3 = 1, $e6514e71f305903d$export$f24224f1c91d8156 = (0, $lLfJi.strlen)($e6514e71f305903d$export$30a86d91af8ff6e6 = value), $e6514e71f305903d$export$5880b8b5730aff45 = 0, [];
}
function $e6514e71f305903d$export$45918ac1574455b1(value) {
    return $e6514e71f305903d$export$30a86d91af8ff6e6 = '', value;
}
function $e6514e71f305903d$export$410ac95b9ec204b8(type) {
    return (0, $lLfJi.trim)($e6514e71f305903d$export$58adb3bec8346d0f($e6514e71f305903d$export$5880b8b5730aff45 - 1, $e6514e71f305903d$export$c889f2fcc19dbf12(type === 91 ? type + 2 : type === 40 ? type + 1 : type)));
}
function $e6514e71f305903d$export$660b2ee2d4fb4eff(value) {
    return $e6514e71f305903d$export$45918ac1574455b1($e6514e71f305903d$export$5f8c09e3ae6f64e1($e6514e71f305903d$export$2de70f21292aac9e(value)));
}
function $e6514e71f305903d$export$7af1228ff777d175(type) {
    while($e6514e71f305903d$export$c0306caf338ac095 = $e6514e71f305903d$export$4d3fb11e950abb9e())if ($e6514e71f305903d$export$c0306caf338ac095 < 33) $e6514e71f305903d$export$48cfd1e771a65c4f();
    else break;
    return $e6514e71f305903d$export$9e1725a4cfeada27(type) > 2 || $e6514e71f305903d$export$9e1725a4cfeada27($e6514e71f305903d$export$c0306caf338ac095) > 3 ? '' : ' ';
}
function $e6514e71f305903d$export$5f8c09e3ae6f64e1(children) {
    while($e6514e71f305903d$export$48cfd1e771a65c4f())switch($e6514e71f305903d$export$9e1725a4cfeada27($e6514e71f305903d$export$c0306caf338ac095)){
        case 0:
            (0, $lLfJi.append)($e6514e71f305903d$export$c2ab62c7bf24634($e6514e71f305903d$export$5880b8b5730aff45 - 1), children);
            break;
        case 2:
            (0, $lLfJi.append)($e6514e71f305903d$export$410ac95b9ec204b8($e6514e71f305903d$export$c0306caf338ac095), children);
            break;
        default:
            (0, $lLfJi.append)((0, $lLfJi.from)($e6514e71f305903d$export$c0306caf338ac095), children);
    }
    return children;
}
function $e6514e71f305903d$export$955ba06d119e085e(index, count) {
    while(--count && $e6514e71f305903d$export$48cfd1e771a65c4f())// not 0-9 A-F a-f
    if ($e6514e71f305903d$export$c0306caf338ac095 < 48 || $e6514e71f305903d$export$c0306caf338ac095 > 102 || $e6514e71f305903d$export$c0306caf338ac095 > 57 && $e6514e71f305903d$export$c0306caf338ac095 < 65 || $e6514e71f305903d$export$c0306caf338ac095 > 70 && $e6514e71f305903d$export$c0306caf338ac095 < 97) break;
    return $e6514e71f305903d$export$58adb3bec8346d0f(index, $e6514e71f305903d$export$e88cb2efb12ae807() + (count < 6 && $e6514e71f305903d$export$4d3fb11e950abb9e() == 32 && $e6514e71f305903d$export$48cfd1e771a65c4f() == 32));
}
function $e6514e71f305903d$export$c889f2fcc19dbf12(type) {
    while($e6514e71f305903d$export$48cfd1e771a65c4f())switch($e6514e71f305903d$export$c0306caf338ac095){
        // ] ) " '
        case type:
            return $e6514e71f305903d$export$5880b8b5730aff45;
        // " '
        case 34:
        case 39:
            if (type !== 34 && type !== 39) $e6514e71f305903d$export$c889f2fcc19dbf12($e6514e71f305903d$export$c0306caf338ac095);
            break;
        // (
        case 40:
            if (type === 41) $e6514e71f305903d$export$c889f2fcc19dbf12(type);
            break;
        // \
        case 92:
            $e6514e71f305903d$export$48cfd1e771a65c4f();
            break;
    }
    return $e6514e71f305903d$export$5880b8b5730aff45;
}
function $e6514e71f305903d$export$4254d4e2b3745c4c(type, index) {
    while($e6514e71f305903d$export$48cfd1e771a65c4f())// //
    if (type + $e6514e71f305903d$export$c0306caf338ac095 === 57) break;
    else if (type + $e6514e71f305903d$export$c0306caf338ac095 === 84 && $e6514e71f305903d$export$4d3fb11e950abb9e() === 47) break;
    return '/*' + $e6514e71f305903d$export$58adb3bec8346d0f(index, $e6514e71f305903d$export$5880b8b5730aff45 - 1) + '*' + (0, $lLfJi.from)(type === 47 ? type : $e6514e71f305903d$export$48cfd1e771a65c4f());
}
function $e6514e71f305903d$export$c2ab62c7bf24634(index) {
    while(!$e6514e71f305903d$export$9e1725a4cfeada27($e6514e71f305903d$export$4d3fb11e950abb9e()))$e6514e71f305903d$export$48cfd1e771a65c4f();
    return $e6514e71f305903d$export$58adb3bec8346d0f(index, $e6514e71f305903d$export$5880b8b5730aff45);
}

});
parcelRegister("lLfJi", function(module, exports) {
$parcel$export(module.exports, "abs", () => $fd7a304e4e8aac15$export$2335f513bbd82c6d);
$parcel$export(module.exports, "from", () => $fd7a304e4e8aac15$export$6788812c4e6611e6);
$parcel$export(module.exports, "assign", () => $fd7a304e4e8aac15$export$e6e34fd1f2686227);
$parcel$export(module.exports, "hash", () => $fd7a304e4e8aac15$export$d6af199866bfb566);
$parcel$export(module.exports, "charat", () => $fd7a304e4e8aac15$export$a9db5e087081082d);
$parcel$export(module.exports, "trim", () => $fd7a304e4e8aac15$export$87c2784dc9fc4ab);
$parcel$export(module.exports, "match", () => $fd7a304e4e8aac15$export$4659b591c19bdf3d);
$parcel$export(module.exports, "replace", () => $fd7a304e4e8aac15$export$77ad94ebf1c2b9ed);
$parcel$export(module.exports, "indexof", () => $fd7a304e4e8aac15$export$f8e21b1e77979a08);
$parcel$export(module.exports, "substr", () => $fd7a304e4e8aac15$export$2f35ab04d2335697);
$parcel$export(module.exports, "strlen", () => $fd7a304e4e8aac15$export$36776f635604f274);
$parcel$export(module.exports, "sizeof", () => $fd7a304e4e8aac15$export$f9084667e487ed46);
$parcel$export(module.exports, "append", () => $fd7a304e4e8aac15$export$10d8903dec122b9d);
$parcel$export(module.exports, "combine", () => $fd7a304e4e8aac15$export$1be1fc439b849fdf);
/**
 * @param {number}
 * @return {number}
 */ var $fd7a304e4e8aac15$export$2335f513bbd82c6d = Math.abs;
var $fd7a304e4e8aac15$export$6788812c4e6611e6 = String.fromCharCode;
var $fd7a304e4e8aac15$export$e6e34fd1f2686227 = Object.assign;
function $fd7a304e4e8aac15$export$d6af199866bfb566(value, length) {
    return $fd7a304e4e8aac15$export$a9db5e087081082d(value, 0) ^ 45 ? (((length << 2 ^ $fd7a304e4e8aac15$export$a9db5e087081082d(value, 0)) << 2 ^ $fd7a304e4e8aac15$export$a9db5e087081082d(value, 1)) << 2 ^ $fd7a304e4e8aac15$export$a9db5e087081082d(value, 2)) << 2 ^ $fd7a304e4e8aac15$export$a9db5e087081082d(value, 3) : 0;
}
function $fd7a304e4e8aac15$export$87c2784dc9fc4ab(value) {
    return value.trim();
}
function $fd7a304e4e8aac15$export$4659b591c19bdf3d(value, pattern) {
    return (value = pattern.exec(value)) ? value[0] : value;
}
function $fd7a304e4e8aac15$export$77ad94ebf1c2b9ed(value, pattern, replacement) {
    return value.replace(pattern, replacement);
}
function $fd7a304e4e8aac15$export$f8e21b1e77979a08(value, search) {
    return value.indexOf(search);
}
function $fd7a304e4e8aac15$export$a9db5e087081082d(value, index) {
    return value.charCodeAt(index) | 0;
}
function $fd7a304e4e8aac15$export$2f35ab04d2335697(value, begin, end) {
    return value.slice(begin, end);
}
function $fd7a304e4e8aac15$export$36776f635604f274(value) {
    return value.length;
}
function $fd7a304e4e8aac15$export$f9084667e487ed46(value) {
    return value.length;
}
function $fd7a304e4e8aac15$export$10d8903dec122b9d(value, array) {
    return array.push(value), value;
}
function $fd7a304e4e8aac15$export$1be1fc439b849fdf(array, callback) {
    return array.map(callback).join('');
}

});


parcelRegister("aNuGO", function(module, exports) {
$parcel$export(module.exports, "compile", () => $7dc6494d64ad52d4$export$ef7acd7185315e22);

var $j1tP7 = parcelRequire("j1tP7");

var $lLfJi = parcelRequire("lLfJi");

var $jLYsE = parcelRequire("jLYsE");
function $7dc6494d64ad52d4$export$ef7acd7185315e22(value) {
    return (0, $jLYsE.dealloc)($7dc6494d64ad52d4$export$98e6a39c04603d36('', null, null, null, [
        ''
    ], value = (0, $jLYsE.alloc)(value), 0, [
        0
    ], value));
}
function $7dc6494d64ad52d4$export$98e6a39c04603d36(value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
    var index = 0;
    var offset = 0;
    var length = pseudo;
    var atrule = 0;
    var property = 0;
    var previous = 0;
    var variable = 1;
    var scanning = 1;
    var ampersand = 1;
    var character = 0;
    var type = '';
    var props = rules;
    var children = rulesets;
    var reference = rule;
    var characters = type;
    while(scanning)switch(previous = character, character = (0, $jLYsE.next)()){
        // (
        case 40:
            if (previous != 108 && (0, $lLfJi.charat)(characters, length - 1) == 58) {
                if ((0, $lLfJi.indexof)(characters += (0, $lLfJi.replace)((0, $jLYsE.delimit)(character), '&', '&\f'), '&\f') != -1) ampersand = -1;
                break;
            }
        // " ' [
        case 34:
        case 39:
        case 91:
            characters += (0, $jLYsE.delimit)(character);
            break;
        // \t \n \r \s
        case 9:
        case 10:
        case 13:
        case 32:
            characters += (0, $jLYsE.whitespace)(previous);
            break;
        // \
        case 92:
            characters += (0, $jLYsE.escaping)((0, $jLYsE.caret)() - 1, 7);
            continue;
        // /
        case 47:
            switch((0, $jLYsE.peek)()){
                case 42:
                case 47:
                    (0, $lLfJi.append)($7dc6494d64ad52d4$export$4a34f930e789283c((0, $jLYsE.commenter)((0, $jLYsE.next)(), (0, $jLYsE.caret)()), root, parent), declarations);
                    break;
                default:
                    characters += '/';
            }
            break;
        // {
        case 123 * variable:
            points[index++] = (0, $lLfJi.strlen)(characters) * ampersand;
        // } ; \0
        case 125 * variable:
        case 59:
        case 0:
            switch(character){
                // \0 }
                case 0:
                case 125:
                    scanning = 0;
                // ;
                case 59 + offset:
                    if (ampersand == -1) characters = (0, $lLfJi.replace)(characters, /\f/g, '');
                    if (property > 0 && (0, $lLfJi.strlen)(characters) - length) (0, $lLfJi.append)(property > 32 ? $7dc6494d64ad52d4$export$f8483753829ec8f3(characters + ';', rule, parent, length - 1) : $7dc6494d64ad52d4$export$f8483753829ec8f3((0, $lLfJi.replace)(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
                    break;
                // @ ;
                case 59:
                    characters += ';';
                // { rule/at-rule
                default:
                    (0, $lLfJi.append)(reference = $7dc6494d64ad52d4$export$3307ffa7023ede1e(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);
                    if (character === 123) {
                        if (offset === 0) $7dc6494d64ad52d4$export$98e6a39c04603d36(characters, root, reference, reference, props, rulesets, length, points, children);
                        else switch(atrule === 99 && (0, $lLfJi.charat)(characters, 3) === 110 ? 100 : atrule){
                            // d l m s
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $7dc6494d64ad52d4$export$98e6a39c04603d36(value, reference, reference, rule && (0, $lLfJi.append)($7dc6494d64ad52d4$export$3307ffa7023ede1e(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
                                break;
                            default:
                                $7dc6494d64ad52d4$export$98e6a39c04603d36(characters, reference, reference, reference, [
                                    ''
                                ], children, 0, points, children);
                        }
                    }
            }
            index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
            break;
        // :
        case 58:
            length = 1 + (0, $lLfJi.strlen)(characters), property = previous;
        default:
            if (variable < 1) {
                if (character == 123) --variable;
                else if (character == 125 && variable++ == 0 && (0, $jLYsE.prev)() == 125) continue;
            }
            switch(characters += (0, $lLfJi.from)(character), character * variable){
                // &
                case 38:
                    ampersand = offset > 0 ? 1 : (characters += '\f', -1);
                    break;
                // ,
                case 44:
                    points[index++] = ((0, $lLfJi.strlen)(characters) - 1) * ampersand, ampersand = 1;
                    break;
                // @
                case 64:
                    // -
                    if ((0, $jLYsE.peek)() === 45) characters += (0, $jLYsE.delimit)((0, $jLYsE.next)());
                    atrule = (0, $jLYsE.peek)(), offset = length = (0, $lLfJi.strlen)(type = characters += (0, $jLYsE.identifier)((0, $jLYsE.caret)())), character++;
                    break;
                // -
                case 45:
                    if (previous === 45 && (0, $lLfJi.strlen)(characters) == 2) variable = 0;
            }
    }
    return rulesets;
}
function $7dc6494d64ad52d4$export$3307ffa7023ede1e(value, root, parent, index, offset, rules, points, type, props, children, length) {
    var post = offset - 1;
    var rule = offset === 0 ? rules : [
        ''
    ];
    var size = (0, $lLfJi.sizeof)(rule);
    for(var i = 0, j = 0, k = 0; i < index; ++i)for(var x = 0, y = (0, $lLfJi.substr)(value, post + 1, post = (0, $lLfJi.abs)(j = points[i])), z = value; x < size; ++x)if (z = (0, $lLfJi.trim)(j > 0 ? rule[x] + ' ' + y : (0, $lLfJi.replace)(y, /&\f/g, rule[x]))) props[k++] = z;
    return (0, $jLYsE.node)(value, root, parent, offset === 0 ? (0, $j1tP7.RULESET) : type, props, children, length);
}
function $7dc6494d64ad52d4$export$4a34f930e789283c(value, root, parent) {
    return (0, $jLYsE.node)(value, root, parent, (0, $j1tP7.COMMENT), (0, $lLfJi.from)((0, $jLYsE.char)()), (0, $lLfJi.substr)(value, 2, -2), 0);
}
function $7dc6494d64ad52d4$export$f8483753829ec8f3(value, root, parent, length) {
    return (0, $jLYsE.node)(value, root, parent, (0, $j1tP7.DECLARATION), (0, $lLfJi.substr)(value, 0, length), (0, $lLfJi.substr)(value, length + 1, -1), length);
}

});
parcelRegister("j1tP7", function(module, exports) {
$parcel$export(module.exports, "MS", () => $dd953ea15407a55e$export$71ad59f2e432cfe8);
$parcel$export(module.exports, "MOZ", () => $dd953ea15407a55e$export$2c0f367103c8d01c);
$parcel$export(module.exports, "WEBKIT", () => $dd953ea15407a55e$export$39dfd62a25e0fe93);
$parcel$export(module.exports, "COMMENT", () => $dd953ea15407a55e$export$a29989082612d0d9);
$parcel$export(module.exports, "RULESET", () => $dd953ea15407a55e$export$aa3a2e812ca8570d);
$parcel$export(module.exports, "DECLARATION", () => $dd953ea15407a55e$export$527d108ccf083c2b);
$parcel$export(module.exports, "IMPORT", () => $dd953ea15407a55e$export$a763edbf796b780a);
$parcel$export(module.exports, "KEYFRAMES", () => $dd953ea15407a55e$export$b44a8529a35fcb60);
$parcel$export(module.exports, "LAYER", () => $dd953ea15407a55e$export$d773506282b3cfe6);
var $dd953ea15407a55e$export$71ad59f2e432cfe8 = '-ms-';
var $dd953ea15407a55e$export$2c0f367103c8d01c = '-moz-';
var $dd953ea15407a55e$export$39dfd62a25e0fe93 = '-webkit-';
var $dd953ea15407a55e$export$a29989082612d0d9 = 'comm';
var $dd953ea15407a55e$export$aa3a2e812ca8570d = 'rule';
var $dd953ea15407a55e$export$527d108ccf083c2b = 'decl';
var $dd953ea15407a55e$export$d3d35020fa5b54f0 = '@page';
var $dd953ea15407a55e$export$500415a86c544f73 = '@media';
var $dd953ea15407a55e$export$a763edbf796b780a = '@import';
var $dd953ea15407a55e$export$2790aeb8b4e5c826 = '@charset';
var $dd953ea15407a55e$export$1cc683e23b84b133 = '@viewport';
var $dd953ea15407a55e$export$9447a5efea57e862 = '@supports';
var $dd953ea15407a55e$export$ef011b4e114b1fba = '@document';
var $dd953ea15407a55e$export$6aad947bda0f3f46 = '@namespace';
var $dd953ea15407a55e$export$b44a8529a35fcb60 = '@keyframes';
var $dd953ea15407a55e$export$2c16de31893252e6 = '@font-face';
var $dd953ea15407a55e$export$3d846dd52e150c6f = '@counter-style';
var $dd953ea15407a55e$export$22314bfbb57653fe = '@font-feature-values';
var $dd953ea15407a55e$export$d773506282b3cfe6 = '@layer';

});


parcelRegister("26NqB", function(module, exports) {
$parcel$export(module.exports, "middleware", () => $18927bab7cd2cf60$export$5a7767152ae0305f);
$parcel$export(module.exports, "rulesheet", () => $18927bab7cd2cf60$export$38bcb760f1d4871c);

var $j1tP7 = parcelRequire("j1tP7");

var $lLfJi = parcelRequire("lLfJi");

var $jLYsE = parcelRequire("jLYsE");

var $7xf0I = parcelRequire("7xf0I");

var $61yIK = parcelRequire("61yIK");
function $18927bab7cd2cf60$export$5a7767152ae0305f(collection) {
    var length = (0, $lLfJi.sizeof)(collection);
    return function(element, index, children, callback) {
        var output = '';
        for(var i = 0; i < length; i++)output += collection[i](element, index, children, callback) || '';
        return output;
    };
}
function $18927bab7cd2cf60$export$38bcb760f1d4871c(callback) {
    return function(element) {
        if (!element.root) {
            if (element = element.return) callback(element);
        }
    };
}
function $18927bab7cd2cf60$export$e08c7d021b829b7a(element, index, children, callback) {
    if (element.length > -1) {
        if (!element.return) switch(element.type){
            case 0, $j1tP7.DECLARATION:
                element.return = (0, $61yIK.prefix)(element.value, element.length, children);
                return;
            case 0, $j1tP7.KEYFRAMES:
                return (0, $7xf0I.serialize)([
                    (0, $jLYsE.copy)(element, {
                        value: (0, $lLfJi.replace)(element.value, '@', '@' + (0, $j1tP7.WEBKIT))
                    })
                ], callback);
            case 0, $j1tP7.RULESET:
                if (element.length) return (0, $lLfJi.combine)(element.props, function(value) {
                    switch((0, $lLfJi.match)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $7xf0I.serialize)([
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(read-\w+)/, ':' + (0, $j1tP7.MOZ) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $7xf0I.serialize)([
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, ':' + (0, $j1tP7.WEBKIT) + 'input-$1')
                                    ]
                                }),
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, ':' + (0, $j1tP7.MOZ) + '$1')
                                    ]
                                }),
                                (0, $jLYsE.copy)(element, {
                                    props: [
                                        (0, $lLfJi.replace)(value, /:(plac\w+)/, (0, $j1tP7.MS) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
}
function $18927bab7cd2cf60$export$76a88f7de6507443(element) {
    switch(element.type){
        case 0, $j1tP7.RULESET:
            element.props = element.props.map(function(value) {
                return (0, $lLfJi.combine)((0, $jLYsE.tokenize)(value), function(value, index, children) {
                    switch((0, $lLfJi.charat)(value, 0)){
                        // \f
                        case 12:
                            return (0, $lLfJi.substr)(value, 1, (0, $lLfJi.strlen)(value));
                        // \0 ( + > ~
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return value;
                        // :
                        case 58:
                            if (children[++index] === 'global') children[index] = '', children[++index] = '\f' + (0, $lLfJi.substr)(children[index], index = 1, -1);
                        // \s
                        case 32:
                            return index === 1 ? '' : value;
                        default:
                            switch(index){
                                case 0:
                                    element = value;
                                    return (0, $lLfJi.sizeof)(children) > 1 ? '' : value;
                                case index = (0, $lLfJi.sizeof)(children) - 1:
                                case 2:
                                    return index === 2 ? value + element + element : value + element;
                                default:
                                    return value;
                            }
                    }
                });
            });
    }
}

});
parcelRegister("7xf0I", function(module, exports) {
$parcel$export(module.exports, "serialize", () => $57c742422406cc54$export$dfdc1655ccc5b9cb);
$parcel$export(module.exports, "stringify", () => $57c742422406cc54$export$fac44ee5b035f737);

var $j1tP7 = parcelRequire("j1tP7");

var $lLfJi = parcelRequire("lLfJi");
function $57c742422406cc54$export$dfdc1655ccc5b9cb(children, callback) {
    var output = '';
    var length = (0, $lLfJi.sizeof)(children);
    for(var i = 0; i < length; i++)output += callback(children[i], i, children, callback) || '';
    return output;
}
function $57c742422406cc54$export$fac44ee5b035f737(element, index, children, callback) {
    switch(element.type){
        case 0, $j1tP7.LAYER:
            if (element.children.length) break;
        case 0, $j1tP7.IMPORT:
        case 0, $j1tP7.DECLARATION:
            return element.return = element.return || element.value;
        case 0, $j1tP7.COMMENT:
            return '';
        case 0, $j1tP7.KEYFRAMES:
            return element.return = element.value + '{' + $57c742422406cc54$export$dfdc1655ccc5b9cb(element.children, callback) + '}';
        case 0, $j1tP7.RULESET:
            element.value = element.props.join(',');
    }
    return (0, $lLfJi.strlen)(children = $57c742422406cc54$export$dfdc1655ccc5b9cb(element.children, callback)) ? element.return = element.value + '{' + children + '}' : '';
}

});

parcelRegister("61yIK", function(module, exports) {
$parcel$export(module.exports, "prefix", () => $462dc4e7834a4945$export$82e9f45cca5ba907);

var $j1tP7 = parcelRequire("j1tP7");

var $lLfJi = parcelRequire("lLfJi");
function $462dc4e7834a4945$export$82e9f45cca5ba907(value, length, children) {
    switch((0, $lLfJi.hash)(value, length)){
        // color-adjust
        case 5103:
            return (0, $j1tP7.WEBKIT) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        // text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        // mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        // background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $j1tP7.WEBKIT) + value + value;
        // tab-size
        case 4789:
            return (0, $j1tP7.MOZ) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MOZ) + value + (0, $j1tP7.MS) + value + value;
        // writing-mode
        case 5936:
            switch((0, $lLfJi.charat)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
        // flex, flex-direction, scroll-snap-type, writing-mode
        case 6828:
        case 4268:
        case 2903:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + value + value;
        // order
        case 6165:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $j1tP7.WEBKIT) + value + (0, $lLfJi.replace)(value, /(\w+).+(:[^]+)/, (0, $j1tP7.WEBKIT) + 'box-$1$2' + (0, $j1tP7.MS) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-item-' + (0, $lLfJi.replace)(value, /flex-|-self/g, '') + (!(0, $lLfJi.match)(value, /flex-|baseline/) ? (0, $j1tP7.MS) + 'grid-row-' + (0, $lLfJi.replace)(value, /flex-|-self/g, '') : '') + value;
        // align-content
        case 4675:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + 'flex-line-pack' + (0, $lLfJi.replace)(value, /align-content|flex-|-self/g, '') + value;
        // flex-shrink
        case 5548:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $j1tP7.WEBKIT) + 'box-' + (0, $lLfJi.replace)(value, '-grow', '') + (0, $j1tP7.WEBKIT) + value + (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $j1tP7.WEBKIT) + (0, $lLfJi.replace)(value, /([^-])(transform)/g, '$1' + (0, $j1tP7.WEBKIT) + '$2') + value;
        // cursor
        case 6187:
            return (0, $lLfJi.replace)((0, $lLfJi.replace)((0, $lLfJi.replace)(value, /(zoom-|grab)/, (0, $j1tP7.WEBKIT) + '$1'), /(image-set)/, (0, $j1tP7.WEBKIT) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $lLfJi.replace)(value, /(image-set\([^]*)/, (0, $j1tP7.WEBKIT) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $lLfJi.replace)((0, $lLfJi.replace)(value, /(.+:)(flex-)?(.*)/, (0, $j1tP7.WEBKIT) + 'box-pack:$3' + (0, $j1tP7.MS) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $j1tP7.WEBKIT) + value + value;
        // justify-self
        case 4200:
            if (!(0, $lLfJi.match)(value, /flex-|baseline/)) return (0, $j1tP7.MS) + 'grid-column-align' + (0, $lLfJi.substr)(value, length) + value;
            break;
        // grid-template-(columns|rows)
        case 2592:
        case 3360:
            return (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, 'template-', '') + value;
        // grid-(row|column)-start
        case 4384:
        case 3616:
            if (children && children.some(function(element, index) {
                return length = index, (0, $lLfJi.match)(element.props, /grid-\w+-end/);
            })) return ~(0, $lLfJi.indexof)(value + (children = children[length].value), 'span') ? value : (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, '-start', '') + value + (0, $j1tP7.MS) + 'grid-row-span:' + (~(0, $lLfJi.indexof)(children, 'span') ? (0, $lLfJi.match)(children, /\d+/) : +(0, $lLfJi.match)(children, /\d+/) - +(0, $lLfJi.match)(value, /\d+/)) + ';';
            return (0, $j1tP7.MS) + (0, $lLfJi.replace)(value, '-start', '') + value;
        // grid-(row|column)-end
        case 4896:
        case 4128:
            return children && children.some(function(element) {
                return (0, $lLfJi.match)(element.props, /grid-\w+-start/);
            }) ? value : (0, $j1tP7.MS) + (0, $lLfJi.replace)((0, $lLfJi.replace)(value, '-end', '-span'), 'span ', '') + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $lLfJi.replace)(value, /(.+)-inline(.+)/, (0, $j1tP7.WEBKIT) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $lLfJi.strlen)(value) - 1 - length > 6) switch((0, $lLfJi.charat)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $lLfJi.charat)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $lLfJi.replace)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $j1tP7.WEBKIT) + '$2-$3' + '$1' + (0, $j1tP7.MOZ) + ((0, $lLfJi.charat)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $lLfJi.indexof)(value, 'stretch') ? $462dc4e7834a4945$export$82e9f45cca5ba907((0, $lLfJi.replace)(value, 'stretch', 'fill-available'), length, children) + value : value;
            }
            break;
        // grid-(column|row)
        case 5152:
        case 5920:
            return (0, $lLfJi.replace)(value, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(_, a, b, c, d, e, f) {
                return (0, $j1tP7.MS) + a + ':' + b + f + (c ? (0, $j1tP7.MS) + a + '-span:' + (d ? e : +e - +b) + f : '') + value;
            });
        // position: sticky
        case 4949:
            // stick(y)?
            if ((0, $lLfJi.charat)(value, length + 6) === 121) return (0, $lLfJi.replace)(value, ':', ':' + (0, $j1tP7.WEBKIT)) + value;
            break;
        // display: (flex|inline-flex|grid|inline-grid)
        case 6444:
            switch((0, $lLfJi.charat)(value, (0, $lLfJi.charat)(value, 14) === 45 ? 18 : 11)){
                // (inline-)?fle(x)
                case 120:
                    return (0, $lLfJi.replace)(value, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, '$1' + (0, $j1tP7.WEBKIT) + ((0, $lLfJi.charat)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $j1tP7.WEBKIT) + '$2$3' + '$1' + (0, $j1tP7.MS) + '$2box$3') + value;
                // (inline-)?gri(d)
                case 100:
                    return (0, $lLfJi.replace)(value, ':', ':' + (0, $j1tP7.MS)) + value;
            }
            break;
        // scroll-margin, scroll-margin-(top|right|bottom|left)
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return (0, $lLfJi.replace)(value, 'scroll-', 'scroll-snap-') + value;
    }
    return value;
}

});


parcelRegister("g1pWA", function(module, exports) {
var $baa0dd434cd15f05$export$2e2bcd8739ae039 = function weakMemoize(func) {
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // Use non-null assertion because we just checked that the cache `has` it
        // This allows us to remove `undefined` from the return value
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("54WhA", function(module, exports) {
function $3b2a89331914fde2$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("aHEYN", function(module, exports) {
$parcel$export(module.exports, "default", () => $7cadb53c976562e2$export$2e2bcd8739ae039);
var $7cadb53c976562e2$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};

});

parcelRegister("7dAX9", function(module, exports) {
$parcel$export(module.exports, "serializeStyles", () => $541669667b0da843$export$6321afa313b251b5);

var $4Ym3O = parcelRequire("4Ym3O");

var $iGvtk = parcelRequire("iGvtk");

var $6h9rV = parcelRequire("6h9rV");
var $541669667b0da843$var$isDevelopment = false;
var $541669667b0da843$var$hyphenateRegex = /[A-Z]|^ms/g;
var $541669667b0da843$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $541669667b0da843$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $541669667b0da843$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $541669667b0da843$var$processStyleName = /* #__PURE__ */ (0, $6h9rV.default)(function(styleName) {
    return $541669667b0da843$var$isCustomProperty(styleName) ? styleName : styleName.replace($541669667b0da843$var$hyphenateRegex, '-$&').toLowerCase();
});
var $541669667b0da843$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($541669667b0da843$var$animationRegex, function(match, p1, p2) {
                $541669667b0da843$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $541669667b0da843$var$cursor
                };
                return p1;
            });
    }
    if ((0, $iGvtk.default)[key] !== 1 && !$541669667b0da843$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $541669667b0da843$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $541669667b0da843$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    var componentSelector = interpolation;
    if (componentSelector.__emotion_styles !== undefined) return componentSelector;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            var keyframes = interpolation;
            if (keyframes.anim === 1) {
                $541669667b0da843$var$cursor = {
                    name: keyframes.name,
                    styles: keyframes.styles,
                    next: $541669667b0da843$var$cursor
                };
                return keyframes.name;
            }
            var serializedStyles = interpolation;
            if (serializedStyles.styles !== undefined) {
                var next = serializedStyles.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $541669667b0da843$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $541669667b0da843$var$cursor
                    };
                    next = next.next;
                }
                var styles = serializedStyles.styles + ";";
                return styles;
            }
            return $541669667b0da843$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $541669667b0da843$var$cursor;
                var result = interpolation(mergedProps);
                $541669667b0da843$var$cursor = previousCursor;
                return $541669667b0da843$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    var asString = interpolation;
    if (registered == null) return asString;
    var cached = registered[asString];
    return cached !== undefined ? cached : asString;
}
function $541669667b0da843$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $541669667b0da843$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var key in obj){
        var value = obj[key];
        if (typeof value !== 'object') {
            var asString = value;
            if (registered != null && registered[asString] !== undefined) string += key + "{" + registered[asString] + "}";
            else if ($541669667b0da843$var$isProcessableValue(asString)) string += $541669667b0da843$var$processStyleName(key) + ":" + $541669667b0da843$var$processStyleValue(key, asString) + ";";
        } else {
            if (key === 'NO_COMPONENT_SELECTOR' && $541669667b0da843$var$isDevelopment) throw new Error($541669667b0da843$var$noComponentSelectorMessage);
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($541669667b0da843$var$isProcessableValue(value[_i])) string += $541669667b0da843$var$processStyleName(key) + ":" + $541669667b0da843$var$processStyleValue(key, value[_i]) + ";";
            } else {
                var interpolated = $541669667b0da843$var$handleInterpolation(mergedProps, registered, value);
                switch(key){
                    case 'animation':
                    case 'animationName':
                        string += $541669667b0da843$var$processStyleName(key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $541669667b0da843$var$labelPattern = /label:\s*([^\s;{]+)\s*(;|$)/g; // this is the cursor for keyframes
// keyframes are stored on the SerializedStyles object as a linked list
var $541669667b0da843$var$cursor;
function $541669667b0da843$export$6321afa313b251b5(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $541669667b0da843$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $541669667b0da843$var$handleInterpolation(mergedProps, registered, strings);
    } else {
        var asTemplateStringsArr = strings;
        styles += asTemplateStringsArr[0];
    } // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $541669667b0da843$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) {
            var templateStringsArr = strings;
            styles += templateStringsArr[i];
        }
    } // using a global regex with .exec is stateful so lastIndex has to be reset each time
    $541669667b0da843$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $541669667b0da843$var$labelPattern.exec(styles)) !== null)identifierName += '-' + match[1];
    var name = (0, $4Ym3O.default)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $541669667b0da843$var$cursor
    };
}

});
parcelRegister("4Ym3O", function(module, exports) {
$parcel$export(module.exports, "default", () => $39ede0c2331b7e7d$export$2e2bcd8739ae039);
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $39ede0c2331b7e7d$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}

});

parcelRegister("iGvtk", function(module, exports) {
$parcel$export(module.exports, "default", () => $d9a48fefd3f4dbe0$export$2e2bcd8739ae039);
var $d9a48fefd3f4dbe0$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    scale: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};

});

parcelRegister("6h9rV", function(module, exports) {
$parcel$export(module.exports, "default", () => $491ba90ad419a455$export$2e2bcd8739ae039);
function $491ba90ad419a455$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}

});


parcelRegister("1hsCE", function(module, exports) {
$parcel$export(module.exports, "useInsertionEffectAlwaysWithSyncFallback", () => $0eed94cfad458df8$export$db21c7ffa21794e7);
$parcel$export(module.exports, "useInsertionEffectWithLayoutFallback", () => $0eed94cfad458df8$export$811a713a7276cb9d);

var $euxye = parcelRequire("euxye");
var $0eed94cfad458df8$var$syncFallback = function syncFallback(create) {
    return create();
};
var $0eed94cfad458df8$var$useInsertionEffect = $euxye.useInsertionEffect ? $euxye.useInsertionEffect : false;
var $0eed94cfad458df8$export$db21c7ffa21794e7 = $0eed94cfad458df8$var$useInsertionEffect || $0eed94cfad458df8$var$syncFallback;
var $0eed94cfad458df8$export$811a713a7276cb9d = $0eed94cfad458df8$var$useInsertionEffect || $euxye.useLayoutEffect;

});

parcelRegister("4jQY2", function(module, exports) {
$parcel$export(module.exports, "default", () => $32520600250bf3bf$export$2e2bcd8739ae039);
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $32520600250bf3bf$var$ATOMIC_GROUP_LENGTH = 5;
function $32520600250bf3bf$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $32520600250bf3bf$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("bsPGV", function(module, exports) {
$parcel$export(module.exports, "useMemoOne", () => $858a680f722f4623$export$b6feb8998cd9b342);
$parcel$export(module.exports, "useCallbackOne", () => $858a680f722f4623$export$33752cf3ee811995);
$parcel$export(module.exports, "useMemo", () => $858a680f722f4623$export$1538c33de8887b59);
$parcel$export(module.exports, "useCallback", () => $858a680f722f4623$export$35808ee640e87ca7);

var $euxye = parcelRequire("euxye");
function $858a680f722f4623$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $858a680f722f4623$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $euxye.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var committed = (0, $euxye.useRef)(initial);
    var isInputMatch = Boolean(inputs && committed.current.inputs && $858a680f722f4623$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = isInputMatch ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $euxye.useEffect)(function() {
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $858a680f722f4623$export$33752cf3ee811995(callback, inputs) {
    return $858a680f722f4623$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $858a680f722f4623$export$1538c33de8887b59 = $858a680f722f4623$export$b6feb8998cd9b342;
var $858a680f722f4623$export$35808ee640e87ca7 = $858a680f722f4623$export$33752cf3ee811995;

});

parcelRegister("7rN3V", function(module, exports) {
$parcel$export(module.exports, "createStrictAPI", () => $56c11cc43a3045fd$export$39716b4af53f4ad);

var $eNf5y = parcelRequire("eNf5y");

var $9S1b6 = parcelRequire("9S1b6");
function $56c11cc43a3045fd$export$39716b4af53f4ad() {
    return {
        css () {
            throw (0, $eNf5y.createStrictSetupError)();
        },
        cssMap () {
            throw (0, $eNf5y.createStrictSetupError)();
        },
        cx: $9S1b6.cx,
        XCSSProp () {
            throw (0, $eNf5y.createStrictSetupError)();
        }
    };
}

});
parcelRegister("eNf5y", function(module, exports) {
$parcel$export(module.exports, "createStrictSetupError", () => $ac515891f20626de$export$c4df1cb0c2b4d77c);
const $ac515891f20626de$export$6c9a87045746941d = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. This could have happened because:

  1. You haven't configured a transformer yet. Visit https://compiledcssinjs.com/docs/installation and follow the instructions.
  2. You have duplicate versions of React and hooks are blowing up. You need to de-duplicate your dependencies.

  Good luck!
`);
};
const $ac515891f20626de$export$c4df1cb0c2b4d77c = ()=>{
    return new Error(`
 \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2557}   \u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2557}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557} \u{2588}\u{2588}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2588}\u{2588}\u{2557}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}   \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}\u{255A}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2554}\u{2550}\u{2550}\u{255D}  \u{2588}\u{2588}\u{2551}  \u{2588}\u{2588}\u{2551}
\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{255A}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}\u{2588}\u{2588}\u{2551} \u{255A}\u{2550}\u{255D} \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2551}     \u{2588}\u{2588}\u{2551}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2557}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2588}\u{2554}\u{255D}
 \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D} \u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{255D}     \u{255A}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}\u{255A}\u{2550}\u{2550}\u{2550}\u{2550}\u{2550}\u{255D}

  @compiled/react

  Code was executed when it shouldn't have. To resolve make sure to:

  1. Set up Compiled.
  2. Configure importSources in your Compiled config to point to the module that exports the output of createStrictAPI().

  For more information visit https://compiledcssinjs.com/docs/installation and follow the instructions.
`);
};

});

parcelRegister("9S1b6", function(module, exports) {
$parcel$export(module.exports, "cx", () => $72fa12207710c401$export$a274e22fb40f762e);

var $4jQY2 = parcelRequire("4jQY2");
const $72fa12207710c401$export$a274e22fb40f762e = (...styles)=>{
    // At runtime TStyles is resolved down to strings, but not at compile time.
    // We circumvent the type system here because of that.
    const actualStyles = styles;
    // The output should be a union type of passed in styles. This ensures the call
    // site of xcss prop can raise violations when disallowed styles have been passed.
    return (0, $4jQY2.default)(actualStyles);
};

});


parcelRegister("6BUH0", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $4d022cbc5a8b9355$var$hasElementType = typeof Element !== 'undefined';
var $4d022cbc5a8b9355$var$hasMap = typeof Map === 'function';
var $4d022cbc5a8b9355$var$hasSet = typeof Set === 'function';
var $4d022cbc5a8b9355$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $4d022cbc5a8b9355$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$4d022cbc5a8b9355$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($4d022cbc5a8b9355$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$4d022cbc5a8b9355$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($4d022cbc5a8b9355$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($4d022cbc5a8b9355$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($4d022cbc5a8b9355$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$4d022cbc5a8b9355$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $4d022cbc5a8b9355$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRegister("1qU3G", function(module, exports) {
$parcel$export(module.exports, "default", () => $10b3b432e9e566aa$export$2e2bcd8739ae039);
var $10b3b432e9e566aa$var$rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
var $10b3b432e9e566aa$export$2e2bcd8739ae039 = $10b3b432e9e566aa$var$rafSchd;

});

parcelRegister("89doV", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $5ee98f2e014ef05e$var$__DEV__ = false;
var $5ee98f2e014ef05e$var$warning = function() {};
if ($5ee98f2e014ef05e$var$__DEV__) {
    var $5ee98f2e014ef05e$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $5ee98f2e014ef05e$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $5ee98f2e014ef05e$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $5ee98f2e014ef05e$var$warning;

});

parcelRegister("dX3fw", function(module, exports) {

var $bGzn3 = parcelRequire("bGzn3");

var $lJFLA = parcelRequire("lJFLA");

var $3J28A = parcelRequire("3J28A");
/** `Object#toString` result references. */ var $a2834e47d410e822$var$objectTag = '[object Object]';
/** Used for built-in method references. */ var $a2834e47d410e822$var$funcProto = Function.prototype, $a2834e47d410e822$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a2834e47d410e822$var$funcToString = $a2834e47d410e822$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a2834e47d410e822$var$hasOwnProperty = $a2834e47d410e822$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $a2834e47d410e822$var$objectCtorString = $a2834e47d410e822$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $a2834e47d410e822$var$isPlainObject(value) {
    if (!$3J28A(value) || $bGzn3(value) != $a2834e47d410e822$var$objectTag) return false;
    var proto = $lJFLA(value);
    if (proto === null) return true;
    var Ctor = $a2834e47d410e822$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $a2834e47d410e822$var$funcToString.call(Ctor) == $a2834e47d410e822$var$objectCtorString;
}
module.exports = $a2834e47d410e822$var$isPlainObject;

});
parcelRegister("bGzn3", function(module, exports) {

var $gyt9S = parcelRequire("gyt9S");

var $VPJ6T = parcelRequire("VPJ6T");

var $l7Wy8 = parcelRequire("l7Wy8");
/** `Object#toString` result references. */ var $881f0de4152995a9$var$nullTag = '[object Null]', $881f0de4152995a9$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $881f0de4152995a9$var$symToStringTag = $gyt9S ? $gyt9S.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $881f0de4152995a9$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $881f0de4152995a9$var$undefinedTag : $881f0de4152995a9$var$nullTag;
    return $881f0de4152995a9$var$symToStringTag && $881f0de4152995a9$var$symToStringTag in Object(value) ? $VPJ6T(value) : $l7Wy8(value);
}
module.exports = $881f0de4152995a9$var$baseGetTag;

});
parcelRegister("gyt9S", function(module, exports) {

var $9oQgX = parcelRequire("9oQgX");
/** Built-in value references. */ var $c0d6708fe7089d11$var$Symbol = $9oQgX.Symbol;
module.exports = $c0d6708fe7089d11$var$Symbol;

});
parcelRegister("9oQgX", function(module, exports) {

var $hHuII = parcelRequire("hHuII");
/** Detect free variable `self`. */ var $6d7ee72bd6010985$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $6d7ee72bd6010985$var$root = $hHuII || $6d7ee72bd6010985$var$freeSelf || Function('return this')();
module.exports = $6d7ee72bd6010985$var$root;

});
parcelRegister("hHuII", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $ce2e48312fe9a9d3$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $ce2e48312fe9a9d3$var$freeGlobal;

});



parcelRegister("VPJ6T", function(module, exports) {

var $gyt9S = parcelRequire("gyt9S");
/** Used for built-in method references. */ var $0add72ced6a9a25c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0add72ced6a9a25c$var$hasOwnProperty = $0add72ced6a9a25c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $0add72ced6a9a25c$var$nativeObjectToString = $0add72ced6a9a25c$var$objectProto.toString;
/** Built-in value references. */ var $0add72ced6a9a25c$var$symToStringTag = $gyt9S ? $gyt9S.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $0add72ced6a9a25c$var$getRawTag(value) {
    var isOwn = $0add72ced6a9a25c$var$hasOwnProperty.call(value, $0add72ced6a9a25c$var$symToStringTag), tag = value[$0add72ced6a9a25c$var$symToStringTag];
    try {
        value[$0add72ced6a9a25c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $0add72ced6a9a25c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$0add72ced6a9a25c$var$symToStringTag] = tag;
        else delete value[$0add72ced6a9a25c$var$symToStringTag];
    }
    return result;
}
module.exports = $0add72ced6a9a25c$var$getRawTag;

});

parcelRegister("l7Wy8", function(module, exports) {
/** Used for built-in method references. */ var $f617ab279599f831$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f617ab279599f831$var$nativeObjectToString = $f617ab279599f831$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $f617ab279599f831$var$objectToString(value) {
    return $f617ab279599f831$var$nativeObjectToString.call(value);
}
module.exports = $f617ab279599f831$var$objectToString;

});


parcelRegister("lJFLA", function(module, exports) {

var $7YeFq = parcelRequire("7YeFq");
/** Built-in value references. */ var $fd2e32e91f2193c8$var$getPrototype = $7YeFq(Object.getPrototypeOf, Object);
module.exports = $fd2e32e91f2193c8$var$getPrototype;

});
parcelRegister("7YeFq", function(module, exports) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $5cd983998e4a776a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = $5cd983998e4a776a$var$overArg;

});


parcelRegister("3J28A", function(module, exports) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2b673b87ca2509db$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = $2b673b87ca2509db$var$isObjectLike;

});


parcelRegister("9WJty", function(module, exports) {
$parcel$export(module.exports, "default", () => $73dcce6047e09eb7$export$2e2bcd8739ae039);
/* global window */ 
var $bRQDP = parcelRequire("bRQDP");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $bRQDP.default)(root);
var $73dcce6047e09eb7$export$2e2bcd8739ae039 = result;

});
parcelRegister("bRQDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $8a3d7a6ed35e0148$export$2e2bcd8739ae039);
function $8a3d7a6ed35e0148$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            result = Symbol('observable');
            Symbol.observable = result;
        }
    } else result = '@@observable';
    return result;
}

});


parcelRegister("lGgbT", function(module, exports) {
$parcel$export(module.exports, "default", () => $fc8a145b95372d33$export$2e2bcd8739ae039);

var $3RMIv = parcelRequire("3RMIv");
function $fc8a145b95372d33$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $3RMIv.default)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}

});
parcelRegister("3RMIv", function(module, exports) {
$parcel$export(module.exports, "default", () => $2d0c1c800eaa452b$export$2e2bcd8739ae039);
/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $2d0c1c800eaa452b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

});


parcelRegister("d5MZw", function(module, exports) {
$parcel$export(module.exports, "default", () => $9881bea07ae82212$export$2e2bcd8739ae039);
function $9881bea07ae82212$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $9881bea07ae82212$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $9881bea07ae82212$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $9881bea07ae82212$var$replaceClassName(element.className && element.className.baseVal || '', className));
}

});

parcelRegister("k11SN", function(module, exports) {
$parcel$export(module.exports, "default", () => $e913fa8d373497f3$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $4LDqh = parcelRequire("4LDqh");

var $hjhet = parcelRequire("hjhet");
let $e913fa8d373497f3$var$cache;
function $e913fa8d373497f3$export$2e2bcd8739ae039(name) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = typeof window !== 'undefined' ? window : globalThis;
    try {
        if (!$e913fa8d373497f3$var$cache) {
            if (false && typeof globalVar.__SSR_SYNC_READ_EXP_VAL__ === 'function' && // if global variable is ready, then don't reach out to native
            // API, stay within js runtime is faster
            !globalVar._statsigValuesReady) try {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const config = globalVar.__SSR_SYNC_READ_EXP_VAL__('killswitch', 'value', []);
                $e913fa8d373497f3$var$cache = new Set(config.map((d)=>d.toLowerCase()));
                return $e913fa8d373497f3$var$cache.has(name.toLowerCase());
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(JSON.stringify({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    message: error.message,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    stack: error.stack
                }));
            }
            else {
                (0, $hjhet.UNSAFE_initIfNeeded)();
                // Using this to access a dynamic parameter
                // Killswitching is known destructive, hence the lack of exposure
                // eslint-disable-next-line jira/ff/use-recommended-utils
                const config = (0, $4LDqh.default).getExperimentValue('killswitch', 'value', [], {
                    fireExperimentExposure: false
                });
                $e913fa8d373497f3$var$cache = new Set(config.map((d)=>d.toLowerCase()));
            }
        }
        return $e913fa8d373497f3$var$cache.has(name.toLowerCase());
    } catch (e) {
        return false;
    }
}

});

parcelRegister("dB6ay", function(module, exports) {
$parcel$export(module.exports, "createContainer", () => $9f843cae4b86054a$export$26ae5ca175b4ec5a);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $i860n = parcelRequire("i860n");

var $jZaOX = parcelRequire("jZaOX");

var $cxKeJ = parcelRequire("cxKeJ");

var $ciIbx = parcelRequire("ciIbx");

var $1IIzs = parcelRequire("1IIzs");
// eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
const $9f843cae4b86054a$var$noop = ()=>()=>{};
function $9f843cae4b86054a$export$26ae5ca175b4ec5a(StoreOrOptions = {}, { onInit: onInit = $9f843cae4b86054a$var$noop, onUpdate: onUpdate = $9f843cae4b86054a$var$noop, onCleanup: onCleanup = $9f843cae4b86054a$var$noop, displayName: displayName = '', getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $9f843cae4b86054a$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore Object.assign expects Object as params
                // but logical expression can return false
                // Ignoring TS to retain original source
                // eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
                handlers: Object.assign({}, onInit !== $9f843cae4b86054a$var$noop && {
                    onInit: ()=>onInit()
                }, onCleanup !== $9f843cae4b86054a$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, // TODO: on next major pass through next/prev props args
                onUpdate !== $9f843cae4b86054a$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            },
            getIsConcurrentSafe: getIsConcurrentSafe
        });
    }
    return $9f843cae4b86054a$var$createFunctionContainer(StoreOrOptions);
}
function $9f843cae4b86054a$var$useRegistry(scope, isGlobal, { globalRegistry: globalRegistry }) {
    return (0, $euxye.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $ciIbx.StoreRegistry)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $9f843cae4b86054a$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // PLEASE CONFIRM THESE DEPENDENCIES ARE CORRECT
    // eslint-disable-next-line react-hooks/exhaustive-deps, @typescript-eslint/no-explicit-any, react-hooks/exhaustive-deps -- PLEASE FIX THIS SUPPRESSION
    const containedStores = (0, $euxye.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $euxye.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store);
        // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $cxKeJ.bindActions)(Store.actions, storeState, config);
            const handlers = (0, $cxKeJ.bindActions)(// eslint-disable-next-line prefer-object-spread -- ERROR TO BE FIXED
            Object.assign({}, Store.handlers, override?.handlers), storeState, config, actions);
            if ((0, $i860n.fg)('rss_add_getcontainerprops_on_contained_store')) containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
                unsubscribe: undefined,
                getContainerProps: config.props
            };
            else containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
                // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
                unsubscribe: undefined
            };
            containedStores.set(Store, containedStore);
            // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
            // @ts-ignore - TS2345 Argument of type '[]' is not assignable to parameter of type 'Parameters<TActions[string]>'.
            if (!isExisting || override) handlers.onInit?.();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $9f843cae4b86054a$var$useApi(check, // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
getContainedStore, { globalRegistry: globalRegistry, retrieveStore: retrieveStore }, isConcurrentSafe) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- ERROR TO BE FIXED
    const retrieveRef = (0, $euxye.useRef)(isConcurrentSafe ? (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store) : undefined);
    if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $euxye.useLayoutEffect)(()=>{
        retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    }, [
        check,
        getContainedStore,
        retrieveStore
    ]);
    else retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store);
    // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    return (0, $euxye.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef?.current?.(s)
        }), [
        globalRegistry
    ]);
}
function $9f843cae4b86054a$var$createFunctionContainer({ displayName: displayName, override: override, getIsConcurrentSafe: getIsConcurrentSafe } = {}) {
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const isConcurrentSafe = getIsConcurrentSafe?.() ?? false;
        const { children: children, ...restProps } = props;
        const { scope: scope, isGlobal: isGlobal, ...subProps } = restProps;
        const ctx = (0, $euxye.useContext)((0, $jZaOX.Context));
        const registry = $9f843cae4b86054a$var$useRegistry(scope, isGlobal, ctx);
        // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $euxye.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        if (!isConcurrentSafe) propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps
        };
        const [containedStores, getContainedStore] = $9f843cae4b86054a$var$useContainedStore(scope, registry, propsRef, check, override);
        // Use a stable object as is passed as value to context Provider
        const api = $9f843cae4b86054a$var$useApi(check, getContainedStore, ctx, isConcurrentSafe);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $euxye.useLayoutEffect)(()=>{
            propsRef.current = {
                prev: propsRef.current.next,
                next: restProps,
                sub: subProps
            };
            if (!(0, $1IIzs.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
                handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
            });
        }, [
            containedStores,
            restProps,
            subProps
        ]);
        else if (!(0, $1IIzs.default)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach(({ handlers: handlers })=>{
            handlers.onContainerUpdate?.(propsRef.current.next, propsRef.current.prev);
        });
        // Every time we add/remove a contained store, we ensure we are subscribed to the updates
        // as an effect to properly handle strict mode
        (0, $euxye.useEffect)(()=>{
            containedStores.forEach((containedStore)=>{
                if (!containedStore.unsubscribe) {
                    const unsub = containedStore.storeState.subscribe(()=>containedStore.handlers.onUpdate?.());
                    // eslint-disable-next-line no-param-reassign
                    containedStore.unsubscribe = ()=>{
                        unsub();
                        // eslint-disable-next-line no-param-reassign
                        containedStore.unsubscribe = undefined;
                    };
                }
            });
        }, [
            containedStores,
            containedStores.size
        ]);
        if (isConcurrentSafe) // eslint-disable-next-line react-hooks/rules-of-hooks
        (0, $euxye.useLayoutEffect)(()=>{
            if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        }, [
            containedStores.size,
            getContainedStore,
            isGlobal,
            scope
        ]);
        else if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
        // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $euxye.useEffect)(()=>()=>{
                containedStores.forEach(({ storeState: storeState, handlers: handlers, unsubscribe: unsubscribe }, Store)=>{
                    // Detatch container from subscription
                    unsubscribe?.();
                    // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify();
                    // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === registry.getStore(Store, scope, null)?.storeState) {
                            handlers.onDestroy?.();
                            // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (!isGlobal) registry.deleteStore(Store, scope);
                        }
                    });
                });
            // no need to reset containedStores as the map is already bound to scope
            }, [
            registry,
            scope,
            containedStores,
            isGlobal
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $jZaOX.Context).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || 'Container';
    return FunctionContainer;
}

});
parcelRegister("jZaOX", function(module, exports) {
$parcel$export(module.exports, "Context", () => $30cab464959abe3e$export$841858b892ce1f4c);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $ciIbx = parcelRequire("ciIbx");
const $30cab464959abe3e$export$841858b892ce1f4c = /*#__PURE__*/ (0, $euxye.createContext)({
    globalRegistry: (0, $ciIbx.defaultRegistry),
    retrieveStore: (Store)=>(0, $ciIbx.defaultRegistry).getStore(Store)
});

});
parcelRegister("ciIbx", function(module, exports) {
$parcel$export(module.exports, "StoreRegistry", () => $5cb813937d8ab668$export$acb47f32da33501e);
$parcel$export(module.exports, "defaultRegistry", () => $5cb813937d8ab668$export$9d726ae4880b1060);
/* eslint-disable jira/filename-case */ 
var $fM6Vb = parcelRequire("fM6Vb");

var $cxKeJ = parcelRequire("cxKeJ");

var $iydz5 = parcelRequire("iydz5");
const $5cb813937d8ab668$export$e4d628ba0054221b = '__global__';
class $5cb813937d8ab668$export$acb47f32da33501e {
    constructor(defaultScope = '__global__'){
        this.defaultScope = defaultScope;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions, behavior: behavior } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + 'While it might still work, it will likely cause unexpected behaviours.');
                if ((0, $fM6Vb.default).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $iydz5.default)(key, initialState, behavior);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $cxKeJ.bindActions)(actions, storeState, config);
                    return boundActions;
                },
                behavior: behavior
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.has(key);
        };
        this.getStore = (Store, scopeId = this.defaultScope, config = {
            props: ()=>({}),
            contained: ()=>false
        })=>{
            const key = this.generateKey(Store, scopeId);
            return this.stores.get(key) || config && this.initStore(key, Store, config);
        };
        this.deleteStore = (Store, scopeId = this.defaultScope)=>{
            const key = this.generateKey(Store, scopeId);
            this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
$5cb813937d8ab668$export$acb47f32da33501e.displayName = "StoreRegistry";
const $5cb813937d8ab668$export$9d726ae4880b1060 = new $5cb813937d8ab668$export$acb47f32da33501e();

});
parcelRegister("fM6Vb", function(module, exports) {
$parcel$export(module.exports, "default", () => $86c53012b6500641$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $86c53012b6500641$var$supports = {
    scheduling () {
        // FIXME: this condition causes tests not to represent the real browser behaviour
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $86c53012b6500641$export$2e2bcd8739ae039 = $86c53012b6500641$var$supports;

});

parcelRegister("cxKeJ", function(module, exports) {
$parcel$export(module.exports, "bindActions", () => $72ea9b8c1e7f5d64$export$5ee1d46cd0883a22);
/* eslint-disable jira/filename-case */ 
var $gXtG2 = parcelRequire("gXtG2");

var $6s4F0 = parcelRequire("6s4F0");
const $72ea9b8c1e7f5d64$var$namedMutator = (// storeState should be StoreState<TState>
// but this mutator's signature doesn't match
// the mutator's actual type of (Partial<TState>) => void
// eslint-disable-next-line @typescript-eslint/no-explicit-any
storeState, actionName)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...arg)=>{
        // eslint-disable-next-line no-param-reassign
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arg);
    };
let $72ea9b8c1e7f5d64$var$warnings = new WeakMap();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $72ea9b8c1e7f5d64$var$warnings = new WeakMap();
});
const $72ea9b8c1e7f5d64$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $6s4F0.default).devtools ? $72ea9b8c1e7f5d64$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - TS2353 actions() is a deprecated API
            get actions () {
                if (!$72ea9b8c1e7f5d64$var$warnings.has(actionFn)) $72ea9b8c1e7f5d64$var$warnings.set(actionFn, // eslint-disable-next-line no-console
                console.warn("react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. " + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (...args)=>callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...args), actionKey);
};
const $72ea9b8c1e7f5d64$export$5ee1d46cd0883a22 = (actions, storeState, config, boundActions = null)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(actions).reduce((acc, k)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        acc[k] = $72ea9b8c1e7f5d64$export$5f944353e69b9bf3(storeState, actions[k], // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        k, config, boundActions || acc);
        return acc;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});

});
parcelRegister("6s4F0", function(module, exports) {
$parcel$export(module.exports, "default", () => $62df27965e5211bc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");
const $62df27965e5211bc$var$defaultMutator = (prevState, partialState)=>// Merge the partial state and the previous state.
    ({
        ...prevState,
        ...partialState
    });
const $62df27965e5211bc$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($euxye))),
    devtools: false,
    middlewares: new Set(),
    mutator: $62df27965e5211bc$var$defaultMutator
};
var $62df27965e5211bc$export$2e2bcd8739ae039 = $62df27965e5211bc$var$defaults;

});


parcelRegister("iydz5", function(module, exports) {
$parcel$export(module.exports, "default", () => $35a82bd072cd0dbe$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $6s4F0 = parcelRequire("6s4F0");

var $dntXz = parcelRequire("dntXz");

var $iFpzN = parcelRequire("iFpzN");

var $5Nsrl = parcelRequire("5Nsrl");
function $35a82bd072cd0dbe$var$createStoreState(key, initialState, behavior) {
    const listeners = new Set();
    const startState = typeof initialState === 'function' ? initialState() : initialState;
    let currentState = startState;
    const storeState = {
        key: key,
        getState () {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
            return currentState;
        },
        setState (nextState) {
            currentState = nextState;
            if (behavior === 'strict' || behavior === 'performance') // In strict mode, we notify all handlers immediately
            // to avoid tearing and sync with other solutions (like Redux) using same model
            // And in performance("concurrent") mode we surrender all state updates to React
            storeState.notify();
            else // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $5Nsrl.default)(storeState.notify);
        },
        resetState () {
            storeState.setState(startState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        },
        // Added to satisfy StoreState<TState> type
        // eslint-disable-next-line @typescript-eslint/no-empty-function -- ERROR TO BE FIXED
        mutator: ()=>{}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
    storeState.mutator = (0, $iFpzN.default)(storeState, (0, $6s4F0.default).middlewares);
    return storeState;
}
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- ERROR TO BE FIXED
$35a82bd072cd0dbe$export$2e2bcd8739ae039 = (0, $dntXz.default)($35a82bd072cd0dbe$var$createStoreState);

});
parcelRegister("dntXz", function(module, exports) {
$parcel$export(module.exports, "default", () => $34a18401d95aa249$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $6s4F0 = parcelRequire("6s4F0");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $34a18401d95aa249$var$connectDevTools = (storeState, config)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true,
        ...config
    });
    devTools.init(storeState.getState());
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') // eslint-disable-next-line default-case
        switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
        }
        else if (message.type === 'ACTION') {
            const action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $34a18401d95aa249$var$withDevtools = // eslint-disable-next-line @typescript-eslint/no-explicit-any
(createStoreState)=>(...args)=>{
        const storeState = createStoreState(...args);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if ((0, $6s4F0.default).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            let devTools;
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $6s4F0.default).devtools === 'function' ? (0, $6s4F0.default).devtools(storeState) : {};
                        devTools = $34a18401d95aa249$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $34a18401d95aa249$export$2e2bcd8739ae039 = $34a18401d95aa249$var$withDevtools;

});

parcelRegister("iFpzN", function(module, exports) {
$parcel$export(module.exports, "default", () => $d74cb2ad6cabf926$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $6s4F0 = parcelRequire("6s4F0");

var $do1O2 = parcelRequire("do1O2");
const $d74cb2ad6cabf926$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $do1O2.default)).reduceRight((next, mw)=>mw(storeState)(next), (0, $6s4F0.default).mutator);
var $d74cb2ad6cabf926$export$2e2bcd8739ae039 = $d74cb2ad6cabf926$var$applyMiddleware;

});
parcelRegister("do1O2", function(module, exports) {
$parcel$export(module.exports, "default", () => $df037ccf4a12a9cc$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $1IIzs = parcelRequire("1IIzs");
const $df037ccf4a12a9cc$var$updateMiddleware = (storeState)=>(next)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (arg)=>{
            let output;
            const state = storeState.getState();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $1IIzs.default)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $df037ccf4a12a9cc$export$2e2bcd8739ae039 = $df037ccf4a12a9cc$var$updateMiddleware;

});
parcelRegister("1IIzs", function(module, exports) {
$parcel$export(module.exports, "default", () => $cc2996c85dba4d5a$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args

var $gXtG2 = parcelRequire("gXtG2");
let $cc2996c85dba4d5a$var$CACHE = new WeakMap();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $cc2996c85dba4d5a$var$CACHE = new WeakMap();
});
function $cc2996c85dba4d5a$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    }
    // Handle Date, RegExp, String, Number, ... and complex objects
    const strA = `${objA}`;
    const strB = `${objB}`;
    if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
    // do object comparison
    let keysA;
    if ($cc2996c85dba4d5a$var$CACHE.has(objA)) keysA = $cc2996c85dba4d5a$var$CACHE.get(objA);
    else {
        keysA = Object.keys(objA);
        $cc2996c85dba4d5a$var$CACHE.set(objA, keysA);
    }
    let keysB;
    if ($cc2996c85dba4d5a$var$CACHE.has(objB)) keysB = $cc2996c85dba4d5a$var$CACHE.get(objB);
    else {
        keysB = Object.keys(objB);
        $cc2996c85dba4d5a$var$CACHE.set(objB, keysB);
    }
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}

});



parcelRegister("5Nsrl", function(module, exports) {
$parcel$export(module.exports, "scheduleSyncFlush", () => $a0b54b5249657596$export$aaf852812ad1ebe4);
$parcel$export(module.exports, "default", () => $a0b54b5249657596$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $gXtG2 = parcelRequire("gXtG2");

var $6s4F0 = parcelRequire("6s4F0");

var $9X2eH = parcelRequire("9X2eH");

var $fM6Vb = parcelRequire("fM6Vb");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a0b54b5249657596$var$SCHEDULE_QUEUE = [];
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $a0b54b5249657596$var$SYNC_QUEUE = $a0b54b5249657596$var$SCHEDULE_QUEUE;
let $a0b54b5249657596$var$scheduled;
let $a0b54b5249657596$var$syncDepth = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $a0b54b5249657596$var$SCHEDULE_QUEUE.length = 0;
    $a0b54b5249657596$var$syncDepth = 0;
});
const $a0b54b5249657596$export$aaf852812ad1ebe4 = (cb)=>{
    try {
        $a0b54b5249657596$var$syncDepth++;
        cb();
    } finally{
        $a0b54b5249657596$var$syncDepth--;
        if ($a0b54b5249657596$var$syncDepth === 0) (0, $9X2eH.executeBatchedUpdate)(()=>{
            let queueFn;
            // eslint-disable-next-line no-cond-assign
            while(queueFn = $a0b54b5249657596$var$SYNC_QUEUE.shift())queueFn();
        });
    }
};
function $a0b54b5249657596$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $6s4F0.default).batchUpdates || !(0, $fM6Vb.default).scheduling()) return (0, $9X2eH.executeBatchedUpdate)(()=>fn());
    if ($a0b54b5249657596$var$syncDepth) {
        // we are in sync mode
        if (!$a0b54b5249657596$var$SYNC_QUEUE.includes(fn)) $a0b54b5249657596$var$SYNC_QUEUE.push(fn);
        return;
    }
    // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$a0b54b5249657596$var$SCHEDULE_QUEUE.includes(fn)) $a0b54b5249657596$var$SCHEDULE_QUEUE.push(fn);
    // if something already started schedule, skip
    if ($a0b54b5249657596$var$scheduled) return;
    $a0b54b5249657596$var$scheduled = (0, $9X2eH.batch)(()=>{
        let queueFn;
        // eslint-disable-next-line no-cond-assign
        while(queueFn = $a0b54b5249657596$var$SCHEDULE_QUEUE.shift())queueFn();
        $a0b54b5249657596$var$scheduled = null;
    });
}

});
parcelRegister("9X2eH", function(module, exports) {
$parcel$export(module.exports, "executeBatchedUpdate", () => $d0f02bce8186111e$export$da0d6fbc8215c86e);
$parcel$export(module.exports, "batch", () => $d0f02bce8186111e$export$712ea50be43a7858);
/* eslint-disable jira/filename-case */ // eslint-disable-next-line camelcase

var $85XPu = parcelRequire("85XPu");

var $g8xyD = parcelRequire("g8xyD");

var $6s4F0 = parcelRequire("6s4F0");

var $fM6Vb = parcelRequire("fM6Vb");
const $d0f02bce8186111e$export$da0d6fbc8215c86e = (fn)=>{
    return (0, $85XPu.unstable_batchedUpdates)(fn);
};
let $d0f02bce8186111e$var$isInsideBatchedSchedule = false;
function $d0f02bce8186111e$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $6s4F0.default).batchUpdates || !(0, $fM6Vb.default).scheduling() || $d0f02bce8186111e$var$isInsideBatchedSchedule) return $d0f02bce8186111e$export$da0d6fbc8215c86e(fn);
    $d0f02bce8186111e$var$isInsideBatchedSchedule = true;
    // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $g8xyD.unstable_scheduleCallback)((0, $g8xyD.unstable_ImmediatePriority), ()=>{
        (0, $85XPu.unstable_batchedUpdates)(fn);
        $d0f02bce8186111e$var$isInsideBatchedSchedule = false;
    });
}

});






parcelRegister("3h1FP", function(module, exports) {
$parcel$export(module.exports, "createHook", () => $c17b1ebd6fcd4e8f$export$e7f733c8fc2b8a24);
$parcel$export(module.exports, "createSelectorHook", () => $c17b1ebd6fcd4e8f$export$2b53f90d2bd1cbfb);
$parcel$export(module.exports, "createActionsHook", () => $c17b1ebd6fcd4e8f$export$7c643e1d6648e418);
$parcel$export(module.exports, "createStateHook", () => $c17b1ebd6fcd4e8f$export$6e4e5611de132e85);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $20zqf = parcelRequire("20zqf");

var $1ByIU = parcelRequire("1ByIU");

var $i860n = parcelRequire("i860n");

var $jZaOX = parcelRequire("jZaOX");

var $2bMj5 = parcelRequire("2bMj5");

var $eyRAl = parcelRequire("eyRAl");
// Remove this and use the new isShallowEqualNew directly when the feature flag is cleaned up.
const $c17b1ebd6fcd4e8f$var$isShallowEqual = (a, b)=>{
    if ((0, $i860n.fg)('rss_use_new_valid_shallow_equal')) return (0, $1ByIU.isShallowEqual)(a, b);
    return (0, $20zqf.default)(a, b);
};
const $c17b1ebd6fcd4e8f$var$EMPTY_SELECTOR = ()=>undefined;
const $c17b1ebd6fcd4e8f$var$DEFAULT_SELECTOR = (state)=>state;
function $c17b1ebd6fcd4e8f$export$e7f733c8fc2b8a24(// eslint-disable-next-line @typescript-eslint/no-explicit-any
Store, // eslint-disable-next-line @typescript-eslint/no-explicit-any
{ selector: selector } = {}) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetState(propsArg) {
        (0, $euxye.useDebugValue)(`RSS: ${Store.key}`);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const { retrieveStore: retrieveStore } = (0, $euxye.useContext)((0, $jZaOX.Context));
        const { storeState: storeState, actions: actions, behavior: behavior } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $euxye.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $euxye.useMemo)(()=>{
            if (selector) return (0, $2bMj5.getSelectorInstance)(selector, storeState, hasPropsArg);
            return selector === null ? $c17b1ebd6fcd4e8f$var$EMPTY_SELECTOR : $c17b1ebd6fcd4e8f$var$DEFAULT_SELECTOR;
        }, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $euxye.useState)({})[1];
        const getSnapshot = (0, $euxye.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $eyRAl.useStoreState)(storeState.subscribe, getSnapshot, behavior);
        return [
            currentState,
            actions
        ];
    };
}
function $c17b1ebd6fcd4e8f$export$2b53f90d2bd1cbfb(Store) {
    return function useSweetState(selector) {
        (0, $euxye.useDebugValue)(`RSS: ${Store.key}`);
        const { retrieveStore: retrieveStore } = (0, $euxye.useContext)((0, $jZaOX.Context));
        const { storeState: storeState, behavior: behavior } = retrieveStore(Store);
        const [, forceUpdate] = (0, $euxye.useState)({});
        const previousSelectorRef = (0, $euxye.useRef)(selector);
        const selectorRef = (0, $euxye.useRef)(selector);
        const selectedStateRef = (0, $euxye.useRef)(selectorRef.current(storeState.getState()));
        const previousState = (0, $euxye.useRef)(storeState.getState());
        (0, $euxye.useEffect)(()=>{
            if (selectorRef.current !== selector) {
                selectorRef.current = selector;
                if (!$c17b1ebd6fcd4e8f$var$isShallowEqual(selectorRef.current(storeState.getState()), selectedStateRef.current)) forceUpdate({});
            }
        }, [
            selector,
            storeState
        ]);
        const getSnapshot = (0, $euxye.useCallback)(()=>{
            const state = storeState.getState();
            if (previousState.current !== state || previousSelectorRef.current !== selectorRef.current) {
                const nextSelectedState = selectorRef.current(state);
                if ($c17b1ebd6fcd4e8f$var$isShallowEqual(nextSelectedState, selectedStateRef.current)) return selectedStateRef.current;
                previousSelectorRef.current = selectorRef.current;
                selectedStateRef.current = nextSelectedState;
                previousState.current = state;
            }
            return selectedStateRef.current;
        }, [
            storeState
        ]);
        return (0, $eyRAl.useStoreState)(storeState.subscribe, getSnapshot, behavior);
    };
}
function $c17b1ebd6fcd4e8f$export$7c643e1d6648e418(Store) {
    const useHook = $c17b1ebd6fcd4e8f$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $c17b1ebd6fcd4e8f$export$6e4e5611de132e85(Store, { selector: selector } = {}) {
    const useHook = $c17b1ebd6fcd4e8f$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}

});
parcelRegister("20zqf", function(module, exports) {
$parcel$export(module.exports, "default", () => $1ba10175f38c2f63$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $b2vuq = parcelRequire("b2vuq");
/**
 * Shallow equal using '===' comparison and one-level array checks.
 *
 * WARNING: This is not a true shallow equal, use @jira/platform__utils-shallow-equal.
 *
 * @see {@link http://go.atlassian.com/shallow-equal}
 *
 * @param {*} obj1
 * @param {*} obj2
 * @returns {boolean}
 */ const $1ba10175f38c2f63$var$isShallowEqual = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    if (!(0, $b2vuq.default)(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const value = obj1[key];
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        return Array.isArray(nextValue) && Array.isArray(value) && (0, $b2vuq.default)(value, nextValue);
    });
    return areValuesEqual;
};
var $1ba10175f38c2f63$export$2e2bcd8739ae039 = $1ba10175f38c2f63$var$isShallowEqual;

});
parcelRegister("b2vuq", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bbe75a77d93bb3f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * Returns true if the two given arrays are equal one level deep
 */ const $9bbe75a77d93bb3f$var$isArrayEqual = (array1 = [], array2 = [])=>{
    // @ts-expect-error - This comparison appears to be unintentional because the types 'readonly T[]' and 'readonly U[]' have no overlap.
    if (array1 === array2) return true;
    // check one level deep
    // @ts-expect-error - This comparison appears to be unintentional because the types 'T' and 'U' have no overlap.
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var $9bbe75a77d93bb3f$export$2e2bcd8739ae039 = $9bbe75a77d93bb3f$var$isArrayEqual;

});


parcelRegister("2bMj5", function(module, exports) {
$parcel$export(module.exports, "getSelectorInstance", () => $199151337f14f1df$export$38d24f3c60944dd5);
/* eslint-disable jira/filename-case */ 
var $gXtG2 = parcelRequire("gXtG2");

var $3K7NP = parcelRequire("3K7NP");
function $199151337f14f1df$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return (0, $3K7NP.createSelector)(dependencies, resultFunc);
}
let $199151337f14f1df$var$cache = new WeakMap();
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $199151337f14f1df$var$cache = new WeakMap();
});
function $199151337f14f1df$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$199151337f14f1df$var$cache.has(storeState)) $199151337f14f1df$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $199151337f14f1df$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $199151337f14f1df$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $199151337f14f1df$export$d2c200d79fc82f8c(selector);
}

});
parcelRegister("3K7NP", function(module, exports) {
$parcel$export(module.exports, "createSelector", () => $73425f254879b085$export$595d22ed68ca2841);
/* eslint-disable jira/filename-case */ 
var $kk5cM = parcelRequire("kk5cM");
function $73425f254879b085$export$595d22ed68ca2841(...funcs) {
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $kk5cM.default)(function memoizedResultFunc() {
        // eslint-disable-next-line prefer-spread, prefer-rest-params -- ERROR TO BE FIXED
        return resultFunc.apply(null, arguments);
    });
    // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $kk5cM.default)(function selector() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)// eslint-disable-next-line prefer-rest-params -- ERROR TO BE FIXED
        params.push(dependencies[i].apply(null, arguments));
        // then call the final func with all them as arguments
        // eslint-disable-next-line prefer-spread -- ERROR TO BE FIXED
        return memoizedResultFunc.apply(null, params);
    }, true);
    // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}

});
parcelRegister("kk5cM", function(module, exports) {
$parcel$export(module.exports, "default", () => $7ae87ab3c9176c4b$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $1IIzs = parcelRequire("1IIzs");
function $7ae87ab3c9176c4b$var$exactEqual(objA, objB) {
    return objA === objB;
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
function $7ae87ab3c9176c4b$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false;
    // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $1IIzs.default)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$7ae87ab3c9176c4b$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
/**
 * Tailor made memoisation
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
const $7ae87ab3c9176c4b$var$memoize = function memoize(resultFn, propsMode = false) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastArgs = [];
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    let lastResult;
    let calledOnce = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- PLEASE FIX THIS SUPPRESSION
    const result = function result() {
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        if (calledOnce && $7ae87ab3c9176c4b$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $1IIzs.default)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        // eslint-disable-next-line prefer-rest-params -- PLEASE FIX THIS SUPPRESSION
        lastArgs = arguments;
        return lastResult;
    };
    return result;
};
var $7ae87ab3c9176c4b$export$2e2bcd8739ae039 = $7ae87ab3c9176c4b$var$memoize;

});



parcelRegister("eyRAl", function(module, exports) {
$parcel$export(module.exports, "useStoreState", () => $5d375aa9287e06be$export$383f6f2f61788070);

var $euxye = parcelRequire("euxye");

var $4PfqE = parcelRequire("4PfqE");
/**
 * functionality is inspired by https://github.com/pmndrs/jotai/blob/main/src/react/useAtomValue.ts
 * the core idea is to "sync" external data via useReducer that is "concurrent" friendly
 * - all "new" connections are reading from "current store state"
 * - all "existing" connections are scheduling updates to later
 */ const $5d375aa9287e06be$var$useConcurrentExternalStore = (subscribe, getSnapshot)=>{
    const [valueFromReducer, rerender] = (0, $euxye.useReducer)((prev)=>{
        const nextValue = getSnapshot();
        if (Object.is(prev, nextValue)) return prev;
        return nextValue;
    }, undefined, ()=>getSnapshot());
    const value = valueFromReducer;
    (0, $euxye.useEffect)(()=>{
        return subscribe(rerender);
    }, [
        subscribe
    ]);
    return value;
};
const $5d375aa9287e06be$export$383f6f2f61788070 = (subscribe, getSnapshot, behavior)=>{
    if (behavior === 'performance') // eslint-disable-next-line react-hooks/rules-of-hooks
    return $5d375aa9287e06be$var$useConcurrentExternalStore(subscribe, getSnapshot);
    // default
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $4PfqE.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
};

});


parcelRegister("iGu4q", function(module, exports) {
$parcel$export(module.exports, "createSubscriber", () => $a07749fd3afc1d78$export$48f338a7e080595c);
/* eslint-disable jira/filename-case, guard-for-in */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $3h1FP = parcelRequire("3h1FP");
function $a07749fd3afc1d78$var$hasAdditionalProps(props) {
    for(const i in props)return true;
    return false;
}
function $a07749fd3afc1d78$export$48f338a7e080595c(Store, { selector: selector, displayName: displayName = '' } = {}) {
    const useStore = (0, $3h1FP.createHook)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber({ children: children, ...rest }) {
        const api = useStore($a07749fd3afc1d78$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}

});

parcelRegister("5QDqc", function(module, exports) {
$parcel$export(module.exports, "createStore", () => $4e573bc67038a897$export$f51a9068ac82ea43);
/* eslint-disable jira/filename-case */ 
var $al7bJ = parcelRequire("al7bJ");
function $4e573bc67038a897$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $al7bJ.default)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
const $4e573bc67038a897$export$67631f492ea189a5 = (actions = {})=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        ...actions,
        dispatch: (action)=>({ dispatch: dispatch })=>dispatch(action)
    });
function $4e573bc67038a897$export$f51a9068ac82ea43({ name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {}, behavior: behavior }) {
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            // eslint-disable-next-line no-return-assign,@typescript-eslint/no-explicit-any
            return key || (key = $4e573bc67038a897$var$createKey(initialState, actions, name));
        },
        initialState: // @ts-expect-error TS2322: Type StateInitializer<TState> is not assignable to type TState
        initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers,
        behavior: behavior
    };
}

});
parcelRegister("al7bJ", function(module, exports) {
$parcel$export(module.exports, "default", () => $48fd87b0ddb0fbf0$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
// eslint-disable-next-line camelcase -- ERROR TO BE FIXED
function $48fd87b0ddb0fbf0$export$2e2bcd8739ae039(str) {
    let l = str.length;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    let h = l ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        str.charCodeAt(i) & 0xff | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 8 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 16 | // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        (str.charCodeAt(++i) & 0xff) << 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k ^= k >>> 24;
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    // eslint-disable-next-line default-case -- ERROR TO BE FIXED
    switch(l){
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        case 3:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment -- ERROR TO BE FIXED
        // @ts-ignore match original source
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 2:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        // eslint-disable-next-line no-fallthrough -- ERROR TO BE FIXED
        case 1:
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h ^= str.charCodeAt(i) & 0xff;
            // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 13;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    h ^= h >>> 15;
    // eslint-disable-next-line no-bitwise -- ERROR TO BE FIXED
    return (h >>> 0).toString(36);
}

});


parcelRegister("dKGGs", function(module, exports) {
'use strict';
module.exports = typeof self === 'object' && self.self === self && self || typeof $parcel$global === 'object' && $parcel$global.global === $parcel$global && $parcel$global || module.exports;

});

parcelRegister("j9yrT", function(module, exports) {
$parcel$export(module.exports, "__extends", () => $df1994690d29dbb1$export$a8ba968b8961cb8a);
$parcel$export(module.exports, "__assign", () => $df1994690d29dbb1$export$18ce0697a983be9b);
$parcel$export(module.exports, "__rest", () => $df1994690d29dbb1$export$3c9a16f847548506);
$parcel$export(module.exports, "__awaiter", () => $df1994690d29dbb1$export$1050f835b63b671e);
$parcel$export(module.exports, "__generator", () => $df1994690d29dbb1$export$67ebef60e6f28a6);
$parcel$export(module.exports, "__exportStar", () => $df1994690d29dbb1$export$f33643c0debef087);
$parcel$export(module.exports, "__values", () => $df1994690d29dbb1$export$19a8beecd37a4c45);
$parcel$export(module.exports, "__read", () => $df1994690d29dbb1$export$8d051b38c9118094);
$parcel$export(module.exports, "__spread", () => $df1994690d29dbb1$export$afc72e2116322959);
$parcel$export(module.exports, "__spreadArrays", () => $df1994690d29dbb1$export$6388937ca91ccae8);
$parcel$export(module.exports, "__spreadArray", () => $df1994690d29dbb1$export$1216008129fb82ed);
$parcel$export(module.exports, "__await", () => $df1994690d29dbb1$export$10c90e4f7922046c);
$parcel$export(module.exports, "__asyncGenerator", () => $df1994690d29dbb1$export$e427f37a30a4de9b);
$parcel$export(module.exports, "__asyncValues", () => $df1994690d29dbb1$export$e3b29a3d6162315f);
$parcel$export(module.exports, "__importStar", () => $df1994690d29dbb1$export$c21735bcef00d192);
$parcel$export(module.exports, "__importDefault", () => $df1994690d29dbb1$export$da59b14a69baef04);
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $df1994690d29dbb1$var$extendStatics = function(d, b) {
    $df1994690d29dbb1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $df1994690d29dbb1$var$extendStatics(d, b);
};
function $df1994690d29dbb1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $df1994690d29dbb1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $df1994690d29dbb1$export$18ce0697a983be9b = function() {
    $df1994690d29dbb1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $df1994690d29dbb1$export$18ce0697a983be9b.apply(this, arguments);
};
function $df1994690d29dbb1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $df1994690d29dbb1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $df1994690d29dbb1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $df1994690d29dbb1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $df1994690d29dbb1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $df1994690d29dbb1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $df1994690d29dbb1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $df1994690d29dbb1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $df1994690d29dbb1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $df1994690d29dbb1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $df1994690d29dbb1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $df1994690d29dbb1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $df1994690d29dbb1$export$45d3717a4c69092e(o, m, p);
}
function $df1994690d29dbb1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $df1994690d29dbb1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $df1994690d29dbb1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($df1994690d29dbb1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $df1994690d29dbb1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $df1994690d29dbb1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $df1994690d29dbb1$export$10c90e4f7922046c(v) {
    return this instanceof $df1994690d29dbb1$export$10c90e4f7922046c ? (this.v = v, this) : new $df1994690d29dbb1$export$10c90e4f7922046c(v);
}
function $df1994690d29dbb1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $df1994690d29dbb1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $df1994690d29dbb1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $df1994690d29dbb1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $df1994690d29dbb1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $df1994690d29dbb1$export$19a8beecd37a4c45 === "function" ? $df1994690d29dbb1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $df1994690d29dbb1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $df1994690d29dbb1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $df1994690d29dbb1$var$ownKeys = function(o) {
    $df1994690d29dbb1$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $df1994690d29dbb1$var$ownKeys(o);
};
function $df1994690d29dbb1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $df1994690d29dbb1$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $df1994690d29dbb1$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $df1994690d29dbb1$var$__setModuleDefault(result, mod);
    return result;
}
function $df1994690d29dbb1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $df1994690d29dbb1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $df1994690d29dbb1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $df1994690d29dbb1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $df1994690d29dbb1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $df1994690d29dbb1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $df1994690d29dbb1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $df1994690d29dbb1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $df1994690d29dbb1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $df1994690d29dbb1$export$2e2bcd8739ae039 = {
    __extends: $df1994690d29dbb1$export$a8ba968b8961cb8a,
    __assign: $df1994690d29dbb1$export$18ce0697a983be9b,
    __rest: $df1994690d29dbb1$export$3c9a16f847548506,
    __decorate: $df1994690d29dbb1$export$29e00dfd3077644b,
    __param: $df1994690d29dbb1$export$d5ad3fd78186038f,
    __esDecorate: $df1994690d29dbb1$export$3a84e1ae4e97e9b0,
    __runInitializers: $df1994690d29dbb1$export$d831c04e792af3d,
    __propKey: $df1994690d29dbb1$export$6a2a36740a146cb8,
    __setFunctionName: $df1994690d29dbb1$export$d1a06452d3489bc7,
    __metadata: $df1994690d29dbb1$export$f1db080c865becb9,
    __awaiter: $df1994690d29dbb1$export$1050f835b63b671e,
    __generator: $df1994690d29dbb1$export$67ebef60e6f28a6,
    __createBinding: $df1994690d29dbb1$export$45d3717a4c69092e,
    __exportStar: $df1994690d29dbb1$export$f33643c0debef087,
    __values: $df1994690d29dbb1$export$19a8beecd37a4c45,
    __read: $df1994690d29dbb1$export$8d051b38c9118094,
    __spread: $df1994690d29dbb1$export$afc72e2116322959,
    __spreadArrays: $df1994690d29dbb1$export$6388937ca91ccae8,
    __spreadArray: $df1994690d29dbb1$export$1216008129fb82ed,
    __await: $df1994690d29dbb1$export$10c90e4f7922046c,
    __asyncGenerator: $df1994690d29dbb1$export$e427f37a30a4de9b,
    __asyncDelegator: $df1994690d29dbb1$export$bbd80228419bb833,
    __asyncValues: $df1994690d29dbb1$export$e3b29a3d6162315f,
    __makeTemplateObject: $df1994690d29dbb1$export$4fb47efe1390b86f,
    __importStar: $df1994690d29dbb1$export$c21735bcef00d192,
    __importDefault: $df1994690d29dbb1$export$da59b14a69baef04,
    __classPrivateFieldGet: $df1994690d29dbb1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $df1994690d29dbb1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $df1994690d29dbb1$export$81fdc39f203e4e04,
    __addDisposableResource: $df1994690d29dbb1$export$88ac25d8e944e405,
    __disposeResources: $df1994690d29dbb1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $df1994690d29dbb1$export$889dfb5d17574b0b
};

});

parcelRegister("dqCTG", function(module, exports) {
$parcel$export(module.exports, "invariant", () => $9c6be035a03cd9af$export$f5708dca728d7177);
$parcel$export(module.exports, "filterProps", () => $9c6be035a03cd9af$export$d697c39a2985a4c);
$parcel$export(module.exports, "DEFAULT_INTL_CONFIG", () => $9c6be035a03cd9af$export$b52f8d6fc0d47415);
$parcel$export(module.exports, "createIntlCache", () => $9c6be035a03cd9af$export$51c4f4e973f2dc00);
$parcel$export(module.exports, "createFormatters", () => $9c6be035a03cd9af$export$c3f4cd5551df13fd);
$parcel$export(module.exports, "getNamedFormat", () => $9c6be035a03cd9af$export$4ee1db8ce44a209b);

var $j9yrT = parcelRequire("j9yrT");

var $eD5g0 = parcelRequire("eD5g0");
parcelRequire("fNZUx");
var $ltA3t = parcelRequire("ltA3t");

var $g9Dhn = parcelRequire("g9Dhn");
function $9c6be035a03cd9af$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $9c6be035a03cd9af$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $9c6be035a03cd9af$var$defaultErrorHandler = function(error) {};
var $9c6be035a03cd9af$var$defaultWarnHandler = function(warning) {};
var $9c6be035a03cd9af$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $9c6be035a03cd9af$var$defaultErrorHandler,
    onWarn: $9c6be035a03cd9af$var$defaultWarnHandler
};
function $9c6be035a03cd9af$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $9c6be035a03cd9af$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $9c6be035a03cd9af$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $9c6be035a03cd9af$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $eD5g0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $eD5g0.strategies).variadic
    });
    var getNumberFormat = (0, $eD5g0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.number),
        strategy: (0, $eD5g0.strategies).variadic
    });
    var getPluralRules = (0, $eD5g0.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $j9yrT.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $eD5g0.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $eD5g0.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $ltA3t.IntlMessageFormat)(message, locales, overrideFormats, (0, $j9yrT.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.message),
            strategy: (0, $eD5g0.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $eD5g0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $eD5g0.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $eD5g0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.list),
            strategy: (0, $eD5g0.strategies).variadic
        }),
        getDisplayNames: (0, $eD5g0.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $9c6be035a03cd9af$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $eD5g0.strategies).variadic
        })
    };
}
function $9c6be035a03cd9af$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $g9Dhn.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}

});
parcelRegister("eD5g0", function(module, exports) {
$parcel$export(module.exports, "memoize", () => $aa68c92fc2f027ea$export$fc10aeed3a532e2a);
$parcel$export(module.exports, "strategies", () => $aa68c92fc2f027ea$export$c5491a8691a23b9e);
//
// Main
//
function $aa68c92fc2f027ea$export$fc10aeed3a532e2a(fn, options) {
    var cache = options && options.cache ? options.cache : $aa68c92fc2f027ea$var$cacheDefault;
    var serializer = options && options.serializer ? options.serializer : $aa68c92fc2f027ea$var$serializerDefault;
    var strategy = options && options.strategy ? options.strategy : $aa68c92fc2f027ea$var$strategyDefault;
    return strategy(fn, {
        cache: cache,
        serializer: serializer
    });
}
//
// Strategy
//
function $aa68c92fc2f027ea$var$isPrimitive(value) {
    return value == null || typeof value === 'number' || typeof value === 'boolean'; // || typeof value === "string" 'unsafe' primitive for our needs
}
function $aa68c92fc2f027ea$var$monadic(fn, cache, serializer, arg) {
    var cacheKey = $aa68c92fc2f027ea$var$isPrimitive(arg) ? arg : serializer(arg);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.call(this, arg);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $aa68c92fc2f027ea$var$variadic(fn, cache, serializer) {
    var args = Array.prototype.slice.call(arguments, 3);
    var cacheKey = serializer(args);
    var computedValue = cache.get(cacheKey);
    if (typeof computedValue === 'undefined') {
        computedValue = fn.apply(this, args);
        cache.set(cacheKey, computedValue);
    }
    return computedValue;
}
function $aa68c92fc2f027ea$var$assemble(fn, context, strategy, cache, serialize) {
    return strategy.bind(context, fn, cache, serialize);
}
function $aa68c92fc2f027ea$var$strategyDefault(fn, options) {
    var strategy = fn.length === 1 ? $aa68c92fc2f027ea$var$monadic : $aa68c92fc2f027ea$var$variadic;
    return $aa68c92fc2f027ea$var$assemble(fn, this, strategy, options.cache.create(), options.serializer);
}
function $aa68c92fc2f027ea$var$strategyVariadic(fn, options) {
    return $aa68c92fc2f027ea$var$assemble(fn, this, $aa68c92fc2f027ea$var$variadic, options.cache.create(), options.serializer);
}
function $aa68c92fc2f027ea$var$strategyMonadic(fn, options) {
    return $aa68c92fc2f027ea$var$assemble(fn, this, $aa68c92fc2f027ea$var$monadic, options.cache.create(), options.serializer);
}
//
// Serializer
//
var $aa68c92fc2f027ea$var$serializerDefault = function() {
    return JSON.stringify(arguments);
};
//
// Cache
//
var $aa68c92fc2f027ea$var$ObjectWithoutPrototypeCache = /** @class */ function() {
    function ObjectWithoutPrototypeCache() {
        this.cache = Object.create(null);
    }
    ObjectWithoutPrototypeCache.prototype.get = function(key) {
        return this.cache[key];
    };
    ObjectWithoutPrototypeCache.prototype.set = function(key, value) {
        this.cache[key] = value;
    };
    return ObjectWithoutPrototypeCache;
}();
var $aa68c92fc2f027ea$var$cacheDefault = {
    create: function create() {
        return new $aa68c92fc2f027ea$var$ObjectWithoutPrototypeCache();
    }
};
var $aa68c92fc2f027ea$export$c5491a8691a23b9e = {
    variadic: $aa68c92fc2f027ea$var$strategyVariadic,
    monadic: $aa68c92fc2f027ea$var$strategyMonadic
};

});

parcelRegister("fNZUx", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("21W70")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("21W70")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("4NJDI")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("ltA3t")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $ltA3t = parcelRequire("ltA3t");
parcelRequire("21W70");
parcelRequire("4NJDI");
var $b81b74dac041d6ca$export$2e2bcd8739ae039 = (0, $ltA3t.IntlMessageFormat);

});
parcelRegister("ltA3t", function(module, exports) {
$parcel$export(module.exports, "IntlMessageFormat", () => $fa28462b194d1a82$export$d342343268debc40);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $j9yrT = parcelRequire("j9yrT");

var $eD5g0 = parcelRequire("eD5g0");

var $e9UO2 = parcelRequire("e9UO2");

var $4NJDI = parcelRequire("4NJDI");
// -- MessageFormat --------------------------------------------------------
function $fa28462b194d1a82$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $fa28462b194d1a82$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $fa28462b194d1a82$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $j9yrT.__assign)({}, defaultConfig));
}
function $fa28462b194d1a82$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $fa28462b194d1a82$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $eD5g0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $fa28462b194d1a82$var$createFastMemoizeCache(cache.number),
            strategy: (0, $eD5g0.strategies).variadic
        }),
        getDateTimeFormat: (0, $eD5g0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $fa28462b194d1a82$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $eD5g0.strategies).variadic
        }),
        getPluralRules: (0, $eD5g0.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $j9yrT.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $fa28462b194d1a82$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $eD5g0.strategies).variadic
        })
    };
}
var $fa28462b194d1a82$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $4NJDI.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $4NJDI.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $j9yrT.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $fa28462b194d1a82$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $fa28462b194d1a82$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $e9UO2.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();

});
parcelRegister("e9UO2", function(module, exports) {
$parcel$export(module.exports, "isArgumentElement", () => (parcelRequire("iAiu6")).isArgumentElement);
$parcel$export(module.exports, "isDateElement", () => (parcelRequire("iAiu6")).isDateElement);
$parcel$export(module.exports, "isDateTimeSkeleton", () => (parcelRequire("iAiu6")).isDateTimeSkeleton);
$parcel$export(module.exports, "isLiteralElement", () => (parcelRequire("iAiu6")).isLiteralElement);
$parcel$export(module.exports, "isNumberElement", () => (parcelRequire("iAiu6")).isNumberElement);
$parcel$export(module.exports, "isNumberSkeleton", () => (parcelRequire("iAiu6")).isNumberSkeleton);
$parcel$export(module.exports, "isPluralElement", () => (parcelRequire("iAiu6")).isPluralElement);
$parcel$export(module.exports, "isPoundElement", () => (parcelRequire("iAiu6")).isPoundElement);
$parcel$export(module.exports, "isSelectElement", () => (parcelRequire("iAiu6")).isSelectElement);
$parcel$export(module.exports, "isTagElement", () => (parcelRequire("iAiu6")).isTagElement);
$parcel$export(module.exports, "isTimeElement", () => (parcelRequire("iAiu6")).isTimeElement);
$parcel$export(module.exports, "TYPE", () => (parcelRequire("iAiu6")).TYPE);
$parcel$export(module.exports, "parse", () => $a4edf8793e132907$export$98e6a39c04603d36);

var $j9yrT = parcelRequire("j9yrT");

var $dHCnf = parcelRequire("dHCnf");

var $afAvn = parcelRequire("afAvn");

var $iAiu6 = parcelRequire("iAiu6");

var $2AbW4 = parcelRequire("2AbW4");
function $a4edf8793e132907$var$pruneLocation(els) {
    els.forEach(function(el) {
        delete el.location;
        if ((0, $iAiu6.isSelectElement)(el) || (0, $iAiu6.isPluralElement)(el)) for(var k in el.options){
            delete el.options[k].location;
            $a4edf8793e132907$var$pruneLocation(el.options[k].value);
        }
        else if ((0, $iAiu6.isNumberElement)(el) && (0, $iAiu6.isNumberSkeleton)(el.style)) delete el.style.location;
        else if (((0, $iAiu6.isDateElement)(el) || (0, $iAiu6.isTimeElement)(el)) && (0, $iAiu6.isDateTimeSkeleton)(el.style)) delete el.style.location;
        else if ((0, $iAiu6.isTagElement)(el)) $a4edf8793e132907$var$pruneLocation(el.children);
    });
}
function $a4edf8793e132907$export$98e6a39c04603d36(message, opts) {
    if (opts === void 0) opts = {};
    opts = (0, $j9yrT.__assign)({
        shouldParseSkeletons: true,
        requiresOtherClause: true
    }, opts);
    var result = new (0, $afAvn.Parser)(message, opts).parse();
    if (result.err) {
        var error = SyntaxError((0, $dHCnf.ErrorKind)[result.err.kind]);
        // @ts-expect-error Assign to error object
        error.location = result.err.location;
        // @ts-expect-error Assign to error object
        error.originalMessage = result.err.message;
        throw error;
    }
    if (!(opts === null || opts === void 0 ? void 0 : opts.captureLocation)) $a4edf8793e132907$var$pruneLocation(result.val);
    return result.val;
}
var $a4edf8793e132907$export$d3c1bfa0f7d806e9 = (0, $afAvn.Parser);

});
parcelRegister("dHCnf", function(module, exports) {
$parcel$export(module.exports, "ErrorKind", () => $9f9d0ec25cd55033$export$896afd8541959ee5);
var $9f9d0ec25cd55033$export$896afd8541959ee5;
(function(ErrorKind) {
    /** Argument is unclosed (e.g. `{0`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_CLOSING_BRACE"] = 1] = "EXPECT_ARGUMENT_CLOSING_BRACE";
    /** Argument is empty (e.g. `{}`). */ ErrorKind[ErrorKind["EMPTY_ARGUMENT"] = 2] = "EMPTY_ARGUMENT";
    /** Argument is malformed (e.g. `{foo!}``) */ ErrorKind[ErrorKind["MALFORMED_ARGUMENT"] = 3] = "MALFORMED_ARGUMENT";
    /** Expect an argument type (e.g. `{foo,}`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_TYPE"] = 4] = "EXPECT_ARGUMENT_TYPE";
    /** Unsupported argument type (e.g. `{foo,foo}`) */ ErrorKind[ErrorKind["INVALID_ARGUMENT_TYPE"] = 5] = "INVALID_ARGUMENT_TYPE";
    /** Expect an argument style (e.g. `{foo, number, }`) */ ErrorKind[ErrorKind["EXPECT_ARGUMENT_STYLE"] = 6] = "EXPECT_ARGUMENT_STYLE";
    /** The number skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_NUMBER_SKELETON"] = 7] = "INVALID_NUMBER_SKELETON";
    /** The date time skeleton is invalid. */ ErrorKind[ErrorKind["INVALID_DATE_TIME_SKELETON"] = 8] = "INVALID_DATE_TIME_SKELETON";
    /** Exepct a number skeleton following the `::` (e.g. `{foo, number, ::}`) */ ErrorKind[ErrorKind["EXPECT_NUMBER_SKELETON"] = 9] = "EXPECT_NUMBER_SKELETON";
    /** Exepct a date time skeleton following the `::` (e.g. `{foo, date, ::}`) */ ErrorKind[ErrorKind["EXPECT_DATE_TIME_SKELETON"] = 10] = "EXPECT_DATE_TIME_SKELETON";
    /** Unmatched apostrophes in the argument style (e.g. `{foo, number, 'test`) */ ErrorKind[ErrorKind["UNCLOSED_QUOTE_IN_ARGUMENT_STYLE"] = 11] = "UNCLOSED_QUOTE_IN_ARGUMENT_STYLE";
    /** Missing select argument options (e.g. `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_OPTIONS"] = 12] = "EXPECT_SELECT_ARGUMENT_OPTIONS";
    /** Expecting an offset value in `plural` or `selectordinal` argument (e.g `{foo, plural, offset}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE"] = 13] = "EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Offset value in `plural` or `selectordinal` is invalid (e.g. `{foo, plural, offset: x}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_OFFSET_VALUE"] = 14] = "INVALID_PLURAL_ARGUMENT_OFFSET_VALUE";
    /** Expecting a selector in `select` argument (e.g `{foo, select}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR"] = 15] = "EXPECT_SELECT_ARGUMENT_SELECTOR";
    /** Expecting a selector in `plural` or `selectordinal` argument (e.g `{foo, plural}`) */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR"] = 16] = "EXPECT_PLURAL_ARGUMENT_SELECTOR";
    /** Expecting a message fragment after the `select` selector (e.g. `{foo, select, apple}`) */ ErrorKind[ErrorKind["EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT"] = 17] = "EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT";
    /**
     * Expecting a message fragment after the `plural` or `selectordinal` selector
     * (e.g. `{foo, plural, one}`)
     */ ErrorKind[ErrorKind["EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT"] = 18] = "EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT";
    /** Selector in `plural` or `selectordinal` is malformed (e.g. `{foo, plural, =x {#}}`) */ ErrorKind[ErrorKind["INVALID_PLURAL_ARGUMENT_SELECTOR"] = 19] = "INVALID_PLURAL_ARGUMENT_SELECTOR";
    /**
     * Duplicate selectors in `plural` or `selectordinal` argument.
     * (e.g. {foo, plural, one {#} one {#}})
     */ ErrorKind[ErrorKind["DUPLICATE_PLURAL_ARGUMENT_SELECTOR"] = 20] = "DUPLICATE_PLURAL_ARGUMENT_SELECTOR";
    /** Duplicate selectors in `select` argument.
     * (e.g. {foo, select, apple {apple} apple {apple}})
     */ ErrorKind[ErrorKind["DUPLICATE_SELECT_ARGUMENT_SELECTOR"] = 21] = "DUPLICATE_SELECT_ARGUMENT_SELECTOR";
    /** Plural or select argument option must have `other` clause. */ ErrorKind[ErrorKind["MISSING_OTHER_CLAUSE"] = 22] = "MISSING_OTHER_CLAUSE";
    /** The tag is malformed. (e.g. `<bold!>foo</bold!>) */ ErrorKind[ErrorKind["INVALID_TAG"] = 23] = "INVALID_TAG";
    /** The tag name is invalid. (e.g. `<123>foo</123>`) */ ErrorKind[ErrorKind["INVALID_TAG_NAME"] = 25] = "INVALID_TAG_NAME";
    /** The closing tag does not match the opening tag. (e.g. `<bold>foo</italic>`) */ ErrorKind[ErrorKind["UNMATCHED_CLOSING_TAG"] = 26] = "UNMATCHED_CLOSING_TAG";
    /** The opening tag has unmatched closing tag. (e.g. `<bold>foo`) */ ErrorKind[ErrorKind["UNCLOSED_TAG"] = 27] = "UNCLOSED_TAG";
})($9f9d0ec25cd55033$export$896afd8541959ee5 || ($9f9d0ec25cd55033$export$896afd8541959ee5 = {}));

});

parcelRegister("afAvn", function(module, exports) {
$parcel$export(module.exports, "Parser", () => $77679f3bab6a1abc$export$7acfa6ed01010e37);

var $j9yrT = parcelRequire("j9yrT");

var $dHCnf = parcelRequire("dHCnf");

var $iAiu6 = parcelRequire("iAiu6");

var $aeOT0 = parcelRequire("aeOT0");
parcelRequire("guF8e");
var $hr14c = parcelRequire("hr14c");
var $ll3qM = parcelRequire("ll3qM");

var $g2ZlY = parcelRequire("g2ZlY");
var $77679f3bab6a1abc$var$_a;
var $77679f3bab6a1abc$var$SPACE_SEPARATOR_START_REGEX = new RegExp("^".concat((0, $aeOT0.SPACE_SEPARATOR_REGEX).source, "*"));
var $77679f3bab6a1abc$var$SPACE_SEPARATOR_END_REGEX = new RegExp("".concat((0, $aeOT0.SPACE_SEPARATOR_REGEX).source, "*$"));
function $77679f3bab6a1abc$var$createLocation(start, end) {
    return {
        start: start,
        end: end
    };
}
// #region Ponyfills
// Consolidate these variables up top for easier toggling during debugging
var $77679f3bab6a1abc$var$hasNativeStartsWith = !!String.prototype.startsWith && '_a'.startsWith('a', 1);
var $77679f3bab6a1abc$var$hasNativeFromCodePoint = !!String.fromCodePoint;
var $77679f3bab6a1abc$var$hasNativeFromEntries = !!Object.fromEntries;
var $77679f3bab6a1abc$var$hasNativeCodePointAt = !!String.prototype.codePointAt;
var $77679f3bab6a1abc$var$hasTrimStart = !!String.prototype.trimStart;
var $77679f3bab6a1abc$var$hasTrimEnd = !!String.prototype.trimEnd;
var $77679f3bab6a1abc$var$hasNativeIsSafeInteger = !!Number.isSafeInteger;
var $77679f3bab6a1abc$var$isSafeInteger = $77679f3bab6a1abc$var$hasNativeIsSafeInteger ? Number.isSafeInteger : function(n) {
    return typeof n === 'number' && isFinite(n) && Math.floor(n) === n && Math.abs(n) <= 0x1fffffffffffff;
};
// IE11 does not support y and u.
var $77679f3bab6a1abc$var$REGEX_SUPPORTS_U_AND_Y = true;
try {
    var $77679f3bab6a1abc$var$re = $77679f3bab6a1abc$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    /**
     * legacy Edge or Xbox One browser
     * Unicode flag support: supported
     * Pattern_Syntax support: not supported
     * See https://github.com/formatjs/formatjs/issues/2822
     */ $77679f3bab6a1abc$var$REGEX_SUPPORTS_U_AND_Y = (($77679f3bab6a1abc$var$_a = $77679f3bab6a1abc$var$re.exec('a')) === null || $77679f3bab6a1abc$var$_a === void 0 ? void 0 : $77679f3bab6a1abc$var$_a[0]) === 'a';
} catch (_) {
    $77679f3bab6a1abc$var$REGEX_SUPPORTS_U_AND_Y = false;
}
var $77679f3bab6a1abc$var$startsWith = $77679f3bab6a1abc$var$hasNativeStartsWith ? function startsWith(s, search, position) {
    return s.startsWith(search, position);
} : function startsWith(s, search, position) {
    return s.slice(position, position + search.length) === search;
};
var $77679f3bab6a1abc$var$fromCodePoint = $77679f3bab6a1abc$var$hasNativeFromCodePoint ? String.fromCodePoint : function fromCodePoint() {
    var codePoints = [];
    for(var _i = 0; _i < arguments.length; _i++)codePoints[_i] = arguments[_i];
    var elements = '';
    var length = codePoints.length;
    var i = 0;
    var code;
    while(length > i){
        code = codePoints[i++];
        if (code > 0x10ffff) throw RangeError(code + ' is not a valid code point');
        elements += code < 0x10000 ? String.fromCharCode(code) : String.fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00);
    }
    return elements;
};
var $77679f3bab6a1abc$var$fromEntries = // native
$77679f3bab6a1abc$var$hasNativeFromEntries ? Object.fromEntries : function fromEntries(entries) {
    var obj = {};
    for(var _i = 0, entries_1 = entries; _i < entries_1.length; _i++){
        var _a = entries_1[_i], k = _a[0], v = _a[1];
        obj[k] = v;
    }
    return obj;
};
var $77679f3bab6a1abc$var$codePointAt = $77679f3bab6a1abc$var$hasNativeCodePointAt ? function codePointAt(s, index) {
    return s.codePointAt(index);
} : function codePointAt(s, index) {
    var size = s.length;
    if (index < 0 || index >= size) return undefined;
    var first = s.charCodeAt(index);
    var second;
    return first < 0xd800 || first > 0xdbff || index + 1 === size || (second = s.charCodeAt(index + 1)) < 0xdc00 || second > 0xdfff ? first : (first - 0xd800 << 10) + (second - 0xdc00) + 0x10000;
};
var $77679f3bab6a1abc$var$trimStart = $77679f3bab6a1abc$var$hasTrimStart ? function trimStart(s) {
    return s.trimStart();
} : function trimStart(s) {
    return s.replace($77679f3bab6a1abc$var$SPACE_SEPARATOR_START_REGEX, '');
};
var $77679f3bab6a1abc$var$trimEnd = $77679f3bab6a1abc$var$hasTrimEnd ? function trimEnd(s) {
    return s.trimEnd();
} : function trimEnd(s) {
    return s.replace($77679f3bab6a1abc$var$SPACE_SEPARATOR_END_REGEX, '');
};
// Prevent minifier to translate new RegExp to literal form that might cause syntax error on IE11.
function $77679f3bab6a1abc$var$RE(s, flag) {
    return new RegExp(s, flag);
}
// #endregion
var $77679f3bab6a1abc$var$matchIdentifierAtIndex;
if ($77679f3bab6a1abc$var$REGEX_SUPPORTS_U_AND_Y) {
    // Native
    var $77679f3bab6a1abc$var$IDENTIFIER_PREFIX_RE_1 = $77679f3bab6a1abc$var$RE('([^\\p{White_Space}\\p{Pattern_Syntax}]*)', 'yu');
    $77679f3bab6a1abc$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
        var _a;
        $77679f3bab6a1abc$var$IDENTIFIER_PREFIX_RE_1.lastIndex = index;
        var match = $77679f3bab6a1abc$var$IDENTIFIER_PREFIX_RE_1.exec(s);
        return (_a = match[1]) !== null && _a !== void 0 ? _a : '';
    };
} else // IE11
$77679f3bab6a1abc$var$matchIdentifierAtIndex = function matchIdentifierAtIndex(s, index) {
    var match = [];
    while(true){
        var c = $77679f3bab6a1abc$var$codePointAt(s, index);
        if (c === undefined || $77679f3bab6a1abc$var$_isWhiteSpace(c) || $77679f3bab6a1abc$var$_isPatternSyntax(c)) break;
        match.push(c);
        index += c >= 0x10000 ? 2 : 1;
    }
    return $77679f3bab6a1abc$var$fromCodePoint.apply(void 0, match);
};
var $77679f3bab6a1abc$export$7acfa6ed01010e37 = /** @class */ function() {
    function Parser(message, options) {
        if (options === void 0) options = {};
        this.message = message;
        this.position = {
            offset: 0,
            line: 1,
            column: 1
        };
        this.ignoreTag = !!options.ignoreTag;
        this.locale = options.locale;
        this.requiresOtherClause = !!options.requiresOtherClause;
        this.shouldParseSkeletons = !!options.shouldParseSkeletons;
    }
    Parser.prototype.parse = function() {
        if (this.offset() !== 0) throw Error('parser can only be used once');
        return this.parseMessage(0, '', false);
    };
    Parser.prototype.parseMessage = function(nestingLevel, parentArgType, expectingCloseTag) {
        var elements = [];
        while(!this.isEOF()){
            var char = this.char();
            if (char === 123 /* `{` */ ) {
                var result = this.parseArgument(nestingLevel, expectingCloseTag);
                if (result.err) return result;
                elements.push(result.val);
            } else if (char === 125 /* `}` */  && nestingLevel > 0) break;
            else if (char === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal')) {
                var position = this.clonePosition();
                this.bump();
                elements.push({
                    type: (0, $iAiu6.TYPE).pound,
                    location: $77679f3bab6a1abc$var$createLocation(position, this.clonePosition())
                });
            } else if (char === 60 /* `<` */  && !this.ignoreTag && this.peek() === 47 // char code for '/'
            ) {
                if (expectingCloseTag) break;
                else return this.error((0, $dHCnf.ErrorKind).UNMATCHED_CLOSING_TAG, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
            } else if (char === 60 /* `<` */  && !this.ignoreTag && $77679f3bab6a1abc$var$_isAlpha(this.peek() || 0)) {
                var result = this.parseTag(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            } else {
                var result = this.parseLiteral(nestingLevel, parentArgType);
                if (result.err) return result;
                elements.push(result.val);
            }
        }
        return {
            val: elements,
            err: null
        };
    };
    /**
     * A tag name must start with an ASCII lower/upper case letter. The grammar is based on the
     * [custom element name][] except that a dash is NOT always mandatory and uppercase letters
     * are accepted:
     *
     * ```
     * tag ::= "<" tagName (whitespace)* "/>" | "<" tagName (whitespace)* ">" message "</" tagName (whitespace)* ">"
     * tagName ::= [a-z] (PENChar)*
     * PENChar ::=
     *     "-" | "." | [0-9] | "_" | [a-z] | [A-Z] | #xB7 | [#xC0-#xD6] | [#xD8-#xF6] | [#xF8-#x37D] |
     *     [#x37F-#x1FFF] | [#x200C-#x200D] | [#x203F-#x2040] | [#x2070-#x218F] | [#x2C00-#x2FEF] |
     *     [#x3001-#xD7FF] | [#xF900-#xFDCF] | [#xFDF0-#xFFFD] | [#x10000-#xEFFFF]
     * ```
     *
     * [custom element name]: https://html.spec.whatwg.org/multipage/custom-elements.html#valid-custom-element-name
     * NOTE: We're a bit more lax here since HTML technically does not allow uppercase HTML element but we do
     * since other tag-based engines like React allow it
     */ Parser.prototype.parseTag = function(nestingLevel, parentArgType) {
        var startPosition = this.clonePosition();
        this.bump(); // `<`
        var tagName = this.parseTagName();
        this.bumpSpace();
        if (this.bumpIf('/>')) // Self closing tag
        return {
            val: {
                type: (0, $iAiu6.TYPE).literal,
                value: "<".concat(tagName, "/>"),
                location: $77679f3bab6a1abc$var$createLocation(startPosition, this.clonePosition())
            },
            err: null
        };
        else if (this.bumpIf('>')) {
            var childrenResult = this.parseMessage(nestingLevel + 1, parentArgType, true);
            if (childrenResult.err) return childrenResult;
            var children = childrenResult.val;
            // Expecting a close tag
            var endTagStartPosition = this.clonePosition();
            if (this.bumpIf('</')) {
                if (this.isEOF() || !$77679f3bab6a1abc$var$_isAlpha(this.char())) return this.error((0, $dHCnf.ErrorKind).INVALID_TAG, $77679f3bab6a1abc$var$createLocation(endTagStartPosition, this.clonePosition()));
                var closingTagNameStartPosition = this.clonePosition();
                var closingTagName = this.parseTagName();
                if (tagName !== closingTagName) return this.error((0, $dHCnf.ErrorKind).UNMATCHED_CLOSING_TAG, $77679f3bab6a1abc$var$createLocation(closingTagNameStartPosition, this.clonePosition()));
                this.bumpSpace();
                if (!this.bumpIf('>')) return this.error((0, $dHCnf.ErrorKind).INVALID_TAG, $77679f3bab6a1abc$var$createLocation(endTagStartPosition, this.clonePosition()));
                return {
                    val: {
                        type: (0, $iAiu6.TYPE).tag,
                        value: tagName,
                        children: children,
                        location: $77679f3bab6a1abc$var$createLocation(startPosition, this.clonePosition())
                    },
                    err: null
                };
            } else return this.error((0, $dHCnf.ErrorKind).UNCLOSED_TAG, $77679f3bab6a1abc$var$createLocation(startPosition, this.clonePosition()));
        } else return this.error((0, $dHCnf.ErrorKind).INVALID_TAG, $77679f3bab6a1abc$var$createLocation(startPosition, this.clonePosition()));
    };
    /**
     * This method assumes that the caller has peeked ahead for the first tag character.
     */ Parser.prototype.parseTagName = function() {
        var startOffset = this.offset();
        this.bump(); // the first tag name character
        while(!this.isEOF() && $77679f3bab6a1abc$var$_isPotentialElementNameChar(this.char()))this.bump();
        return this.message.slice(startOffset, this.offset());
    };
    Parser.prototype.parseLiteral = function(nestingLevel, parentArgType) {
        var start = this.clonePosition();
        var value = '';
        while(true){
            var parseQuoteResult = this.tryParseQuote(parentArgType);
            if (parseQuoteResult) {
                value += parseQuoteResult;
                continue;
            }
            var parseUnquotedResult = this.tryParseUnquoted(nestingLevel, parentArgType);
            if (parseUnquotedResult) {
                value += parseUnquotedResult;
                continue;
            }
            var parseLeftAngleResult = this.tryParseLeftAngleBracket();
            if (parseLeftAngleResult) {
                value += parseLeftAngleResult;
                continue;
            }
            break;
        }
        var location = $77679f3bab6a1abc$var$createLocation(start, this.clonePosition());
        return {
            val: {
                type: (0, $iAiu6.TYPE).literal,
                value: value,
                location: location
            },
            err: null
        };
    };
    Parser.prototype.tryParseLeftAngleBracket = function() {
        if (!this.isEOF() && this.char() === 60 /* `<` */  && (this.ignoreTag || // If at the opening tag or closing tag position, bail.
        !$77679f3bab6a1abc$var$_isAlphaOrSlash(this.peek() || 0))) {
            this.bump(); // `<`
            return '<';
        }
        return null;
    };
    /**
     * Starting with ICU 4.8, an ASCII apostrophe only starts quoted text if it immediately precedes
     * a character that requires quoting (that is, "only where needed"), and works the same in
     * nested messages as on the top level of the pattern. The new behavior is otherwise compatible.
     */ Parser.prototype.tryParseQuote = function(parentArgType) {
        if (this.isEOF() || this.char() !== 39 /* `'` */ ) return null;
        // Parse escaped char following the apostrophe, or early return if there is no escaped char.
        // Check if is valid escaped character
        switch(this.peek()){
            case 39 /* `'` */ :
                // double quote, should return as a single quote.
                this.bump();
                this.bump();
                return "'";
            // '{', '<', '>', '}'
            case 123:
            case 60:
            case 62:
            case 125:
                break;
            case 35:
                if (parentArgType === 'plural' || parentArgType === 'selectordinal') break;
                return null;
            default:
                return null;
        }
        this.bump(); // apostrophe
        var codePoints = [
            this.char()
        ]; // escaped char
        this.bump();
        // read chars until the optional closing apostrophe is found
        while(!this.isEOF()){
            var ch = this.char();
            if (ch === 39 /* `'` */ ) {
                if (this.peek() === 39 /* `'` */ ) {
                    codePoints.push(39);
                    // Bump one more time because we need to skip 2 characters.
                    this.bump();
                } else {
                    // Optional closing apostrophe.
                    this.bump();
                    break;
                }
            } else codePoints.push(ch);
            this.bump();
        }
        return $77679f3bab6a1abc$var$fromCodePoint.apply(void 0, codePoints);
    };
    Parser.prototype.tryParseUnquoted = function(nestingLevel, parentArgType) {
        if (this.isEOF()) return null;
        var ch = this.char();
        if (ch === 60 /* `<` */  || ch === 123 /* `{` */  || ch === 35 /* `#` */  && (parentArgType === 'plural' || parentArgType === 'selectordinal') || ch === 125 /* `}` */  && nestingLevel > 0) return null;
        else {
            this.bump();
            return $77679f3bab6a1abc$var$fromCodePoint(ch);
        }
    };
    Parser.prototype.parseArgument = function(nestingLevel, expectingCloseTag) {
        var openingBracePosition = this.clonePosition();
        this.bump(); // `{`
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        if (this.char() === 125 /* `}` */ ) {
            this.bump();
            return this.error((0, $dHCnf.ErrorKind).EMPTY_ARGUMENT, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        }
        // argument name
        var value = this.parseIdentifierIfPossible().value;
        if (!value) return this.error((0, $dHCnf.ErrorKind).MALFORMED_ARGUMENT, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bumpSpace();
        if (this.isEOF()) return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        switch(this.char()){
            // Simple argument: `{name}`
            case 125 /* `}` */ :
                this.bump(); // `}`
                return {
                    val: {
                        type: (0, $iAiu6.TYPE).argument,
                        // value does not include the opening and closing braces.
                        value: value,
                        location: $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition())
                    },
                    err: null
                };
            // Argument with options: `{name, format, ...}`
            case 44 /* `,` */ :
                this.bump(); // `,`
                this.bumpSpace();
                if (this.isEOF()) return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
                return this.parseArgumentOptions(nestingLevel, expectingCloseTag, value, openingBracePosition);
            default:
                return this.error((0, $dHCnf.ErrorKind).MALFORMED_ARGUMENT, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        }
    };
    /**
     * Advance the parser until the end of the identifier, if it is currently on
     * an identifier character. Return an empty string otherwise.
     */ Parser.prototype.parseIdentifierIfPossible = function() {
        var startingPosition = this.clonePosition();
        var startOffset = this.offset();
        var value = $77679f3bab6a1abc$var$matchIdentifierAtIndex(this.message, startOffset);
        var endOffset = startOffset + value.length;
        this.bumpTo(endOffset);
        var endPosition = this.clonePosition();
        var location = $77679f3bab6a1abc$var$createLocation(startingPosition, endPosition);
        return {
            value: value,
            location: location
        };
    };
    Parser.prototype.parseArgumentOptions = function(nestingLevel, expectingCloseTag, value, openingBracePosition) {
        var _a;
        // Parse this range:
        // {name, type, style}
        //        ^---^
        var typeStartPosition = this.clonePosition();
        var argType = this.parseIdentifierIfPossible().value;
        var typeEndPosition = this.clonePosition();
        switch(argType){
            case '':
                // Expecting a style string number, date, time, plural, selectordinal, or select.
                return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_TYPE, $77679f3bab6a1abc$var$createLocation(typeStartPosition, typeEndPosition));
            case 'number':
            case 'date':
            case 'time':
                // Parse this range:
                // {name, number, style}
                //              ^-------^
                this.bumpSpace();
                var styleAndLocation = null;
                if (this.bumpIf(',')) {
                    this.bumpSpace();
                    var styleStartPosition = this.clonePosition();
                    var result = this.parseSimpleArgStyleIfPossible();
                    if (result.err) return result;
                    var style = $77679f3bab6a1abc$var$trimEnd(result.val);
                    if (style.length === 0) return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_STYLE, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
                    var styleLocation = $77679f3bab6a1abc$var$createLocation(styleStartPosition, this.clonePosition());
                    styleAndLocation = {
                        style: style,
                        styleLocation: styleLocation
                    };
                }
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_1 = $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition());
                // Extract style or skeleton
                if (styleAndLocation && $77679f3bab6a1abc$var$startsWith(styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style, '::', 0)) {
                    // Skeleton starts with `::`.
                    var skeleton = $77679f3bab6a1abc$var$trimStart(styleAndLocation.style.slice(2));
                    if (argType === 'number') {
                        var result = this.parseNumberSkeletonFromString(skeleton, styleAndLocation.styleLocation);
                        if (result.err) return result;
                        return {
                            val: {
                                type: (0, $iAiu6.TYPE).number,
                                value: value,
                                location: location_1,
                                style: result.val
                            },
                            err: null
                        };
                    } else {
                        if (skeleton.length === 0) return this.error((0, $dHCnf.ErrorKind).EXPECT_DATE_TIME_SKELETON, location_1);
                        var dateTimePattern = skeleton;
                        // Get "best match" pattern only if locale is passed, if not, let it
                        // pass as-is where `parseDateTimeSkeleton()` will throw an error
                        // for unsupported patterns.
                        if (this.locale) dateTimePattern = (0, $g2ZlY.getBestPattern)(skeleton, this.locale);
                        var style = {
                            type: (0, $iAiu6.SKELETON_TYPE).dateTime,
                            pattern: dateTimePattern,
                            location: styleAndLocation.styleLocation,
                            parsedOptions: this.shouldParseSkeletons ? (0, $hr14c.parseDateTimeSkeleton)(dateTimePattern) : {}
                        };
                        var type = argType === 'date' ? (0, $iAiu6.TYPE).date : (0, $iAiu6.TYPE).time;
                        return {
                            val: {
                                type: type,
                                value: value,
                                location: location_1,
                                style: style
                            },
                            err: null
                        };
                    }
                }
                // Regular style or no style.
                return {
                    val: {
                        type: argType === 'number' ? (0, $iAiu6.TYPE).number : argType === 'date' ? (0, $iAiu6.TYPE).date : (0, $iAiu6.TYPE).time,
                        value: value,
                        location: location_1,
                        style: (_a = styleAndLocation === null || styleAndLocation === void 0 ? void 0 : styleAndLocation.style) !== null && _a !== void 0 ? _a : null
                    },
                    err: null
                };
            case 'plural':
            case 'selectordinal':
            case 'select':
                // Parse this range:
                // {name, plural, options}
                //              ^---------^
                var typeEndPosition_1 = this.clonePosition();
                this.bumpSpace();
                if (!this.bumpIf(',')) return this.error((0, $dHCnf.ErrorKind).EXPECT_SELECT_ARGUMENT_OPTIONS, $77679f3bab6a1abc$var$createLocation(typeEndPosition_1, (0, $j9yrT.__assign)({}, typeEndPosition_1)));
                this.bumpSpace();
                // Parse offset:
                // {name, plural, offset:1, options}
                //                ^-----^
                //
                // or the first option:
                //
                // {name, plural, one {...} other {...}}
                //                ^--^
                var identifierAndLocation = this.parseIdentifierIfPossible();
                var pluralOffset = 0;
                if (argType !== 'select' && identifierAndLocation.value === 'offset') {
                    if (!this.bumpIf(':')) return this.error((0, $dHCnf.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
                    this.bumpSpace();
                    var result = this.tryParseDecimalInteger((0, $dHCnf.ErrorKind).EXPECT_PLURAL_ARGUMENT_OFFSET_VALUE, (0, $dHCnf.ErrorKind).INVALID_PLURAL_ARGUMENT_OFFSET_VALUE);
                    if (result.err) return result;
                    // Parse another identifier for option parsing
                    this.bumpSpace();
                    identifierAndLocation = this.parseIdentifierIfPossible();
                    pluralOffset = result.val;
                }
                var optionsResult = this.tryParsePluralOrSelectOptions(nestingLevel, argType, expectingCloseTag, identifierAndLocation);
                if (optionsResult.err) return optionsResult;
                var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
                if (argCloseResult.err) return argCloseResult;
                var location_2 = $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition());
                if (argType === 'select') return {
                    val: {
                        type: (0, $iAiu6.TYPE).select,
                        value: value,
                        options: $77679f3bab6a1abc$var$fromEntries(optionsResult.val),
                        location: location_2
                    },
                    err: null
                };
                else return {
                    val: {
                        type: (0, $iAiu6.TYPE).plural,
                        value: value,
                        options: $77679f3bab6a1abc$var$fromEntries(optionsResult.val),
                        offset: pluralOffset,
                        pluralType: argType === 'plural' ? 'cardinal' : 'ordinal',
                        location: location_2
                    },
                    err: null
                };
            default:
                return this.error((0, $dHCnf.ErrorKind).INVALID_ARGUMENT_TYPE, $77679f3bab6a1abc$var$createLocation(typeStartPosition, typeEndPosition));
        }
    };
    Parser.prototype.tryParseArgumentClose = function(openingBracePosition) {
        // Parse: {value, number, ::currency/GBP }
        //
        if (this.isEOF() || this.char() !== 125 /* `}` */ ) return this.error((0, $dHCnf.ErrorKind).EXPECT_ARGUMENT_CLOSING_BRACE, $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition()));
        this.bump(); // `}`
        return {
            val: true,
            err: null
        };
    };
    /**
     * See: https://github.com/unicode-org/icu/blob/af7ed1f6d2298013dc303628438ec4abe1f16479/icu4c/source/common/messagepattern.cpp#L659
     */ Parser.prototype.parseSimpleArgStyleIfPossible = function() {
        var nestedBraces = 0;
        var startPosition = this.clonePosition();
        while(!this.isEOF()){
            var ch = this.char();
            switch(ch){
                case 39 /* `'` */ :
                    // Treat apostrophe as quoting but include it in the style part.
                    // Find the end of the quoted literal text.
                    this.bump();
                    var apostrophePosition = this.clonePosition();
                    if (!this.bumpUntil("'")) return this.error((0, $dHCnf.ErrorKind).UNCLOSED_QUOTE_IN_ARGUMENT_STYLE, $77679f3bab6a1abc$var$createLocation(apostrophePosition, this.clonePosition()));
                    this.bump();
                    break;
                case 123 /* `{` */ :
                    nestedBraces += 1;
                    this.bump();
                    break;
                case 125 /* `}` */ :
                    if (nestedBraces > 0) nestedBraces -= 1;
                    else return {
                        val: this.message.slice(startPosition.offset, this.offset()),
                        err: null
                    };
                    break;
                default:
                    this.bump();
                    break;
            }
        }
        return {
            val: this.message.slice(startPosition.offset, this.offset()),
            err: null
        };
    };
    Parser.prototype.parseNumberSkeletonFromString = function(skeleton, location) {
        var tokens = [];
        try {
            tokens = (0, $ll3qM.parseNumberSkeletonFromString)(skeleton);
        } catch (e) {
            return this.error((0, $dHCnf.ErrorKind).INVALID_NUMBER_SKELETON, location);
        }
        return {
            val: {
                type: (0, $iAiu6.SKELETON_TYPE).number,
                tokens: tokens,
                location: location,
                parsedOptions: this.shouldParseSkeletons ? (0, $ll3qM.parseNumberSkeleton)(tokens) : {}
            },
            err: null
        };
    };
    /**
     * @param nesting_level The current nesting level of messages.
     *     This can be positive when parsing message fragment in select or plural argument options.
     * @param parent_arg_type The parent argument's type.
     * @param parsed_first_identifier If provided, this is the first identifier-like selector of
     *     the argument. It is a by-product of a previous parsing attempt.
     * @param expecting_close_tag If true, this message is directly or indirectly nested inside
     *     between a pair of opening and closing tags. The nested message will not parse beyond
     *     the closing tag boundary.
     */ Parser.prototype.tryParsePluralOrSelectOptions = function(nestingLevel, parentArgType, expectCloseTag, parsedFirstIdentifier) {
        var _a;
        var hasOtherClause = false;
        var options = [];
        var parsedSelectors = new Set();
        var selector = parsedFirstIdentifier.value, selectorLocation = parsedFirstIdentifier.location;
        // Parse:
        // one {one apple}
        // ^--^
        while(true){
            if (selector.length === 0) {
                var startPosition = this.clonePosition();
                if (parentArgType !== 'select' && this.bumpIf('=')) {
                    // Try parse `={number}` selector
                    var result = this.tryParseDecimalInteger((0, $dHCnf.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, (0, $dHCnf.ErrorKind).INVALID_PLURAL_ARGUMENT_SELECTOR);
                    if (result.err) return result;
                    selectorLocation = $77679f3bab6a1abc$var$createLocation(startPosition, this.clonePosition());
                    selector = this.message.slice(startPosition.offset, this.offset());
                } else break;
            }
            // Duplicate selector clauses
            if (parsedSelectors.has(selector)) return this.error(parentArgType === 'select' ? (0, $dHCnf.ErrorKind).DUPLICATE_SELECT_ARGUMENT_SELECTOR : (0, $dHCnf.ErrorKind).DUPLICATE_PLURAL_ARGUMENT_SELECTOR, selectorLocation);
            if (selector === 'other') hasOtherClause = true;
            // Parse:
            // one {one apple}
            //     ^----------^
            this.bumpSpace();
            var openingBracePosition = this.clonePosition();
            if (!this.bumpIf('{')) return this.error(parentArgType === 'select' ? (0, $dHCnf.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR_FRAGMENT : (0, $dHCnf.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR_FRAGMENT, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
            var fragmentResult = this.parseMessage(nestingLevel + 1, parentArgType, expectCloseTag);
            if (fragmentResult.err) return fragmentResult;
            var argCloseResult = this.tryParseArgumentClose(openingBracePosition);
            if (argCloseResult.err) return argCloseResult;
            options.push([
                selector,
                {
                    value: fragmentResult.val,
                    location: $77679f3bab6a1abc$var$createLocation(openingBracePosition, this.clonePosition())
                }
            ]);
            // Keep track of the existing selectors
            parsedSelectors.add(selector);
            // Prep next selector clause.
            this.bumpSpace();
            _a = this.parseIdentifierIfPossible(), selector = _a.value, selectorLocation = _a.location;
        }
        if (options.length === 0) return this.error(parentArgType === 'select' ? (0, $dHCnf.ErrorKind).EXPECT_SELECT_ARGUMENT_SELECTOR : (0, $dHCnf.ErrorKind).EXPECT_PLURAL_ARGUMENT_SELECTOR, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
        if (this.requiresOtherClause && !hasOtherClause) return this.error((0, $dHCnf.ErrorKind).MISSING_OTHER_CLAUSE, $77679f3bab6a1abc$var$createLocation(this.clonePosition(), this.clonePosition()));
        return {
            val: options,
            err: null
        };
    };
    Parser.prototype.tryParseDecimalInteger = function(expectNumberError, invalidNumberError) {
        var sign = 1;
        var startingPosition = this.clonePosition();
        if (this.bumpIf('+')) ;
        else if (this.bumpIf('-')) sign = -1;
        var hasDigits = false;
        var decimal = 0;
        while(!this.isEOF()){
            var ch = this.char();
            if (ch >= 48 /* `0` */  && ch <= 57 /* `9` */ ) {
                hasDigits = true;
                decimal = decimal * 10 + (ch - 48);
                this.bump();
            } else break;
        }
        var location = $77679f3bab6a1abc$var$createLocation(startingPosition, this.clonePosition());
        if (!hasDigits) return this.error(expectNumberError, location);
        decimal *= sign;
        if (!$77679f3bab6a1abc$var$isSafeInteger(decimal)) return this.error(invalidNumberError, location);
        return {
            val: decimal,
            err: null
        };
    };
    Parser.prototype.offset = function() {
        return this.position.offset;
    };
    Parser.prototype.isEOF = function() {
        return this.offset() === this.message.length;
    };
    Parser.prototype.clonePosition = function() {
        // This is much faster than `Object.assign` or spread.
        return {
            offset: this.position.offset,
            line: this.position.line,
            column: this.position.column
        };
    };
    /**
     * Return the code point at the current position of the parser.
     * Throws if the index is out of bound.
     */ Parser.prototype.char = function() {
        var offset = this.position.offset;
        if (offset >= this.message.length) throw Error('out of bound');
        var code = $77679f3bab6a1abc$var$codePointAt(this.message, offset);
        if (code === undefined) throw Error("Offset ".concat(offset, " is at invalid UTF-16 code unit boundary"));
        return code;
    };
    Parser.prototype.error = function(kind, location) {
        return {
            val: null,
            err: {
                kind: kind,
                message: this.message,
                location: location
            }
        };
    };
    /** Bump the parser to the next UTF-16 code unit. */ Parser.prototype.bump = function() {
        if (this.isEOF()) return;
        var code = this.char();
        if (code === 10 /* '\n' */ ) {
            this.position.line += 1;
            this.position.column = 1;
            this.position.offset += 1;
        } else {
            this.position.column += 1;
            // 0 ~ 0x10000 -> unicode BMP, otherwise skip the surrogate pair.
            this.position.offset += code < 0x10000 ? 1 : 2;
        }
    };
    /**
     * If the substring starting at the current position of the parser has
     * the given prefix, then bump the parser to the character immediately
     * following the prefix and return true. Otherwise, don't bump the parser
     * and return false.
     */ Parser.prototype.bumpIf = function(prefix) {
        if ($77679f3bab6a1abc$var$startsWith(this.message, prefix, this.offset())) {
            for(var i = 0; i < prefix.length; i++)this.bump();
            return true;
        }
        return false;
    };
    /**
     * Bump the parser until the pattern character is found and return `true`.
     * Otherwise bump to the end of the file and return `false`.
     */ Parser.prototype.bumpUntil = function(pattern) {
        var currentOffset = this.offset();
        var index = this.message.indexOf(pattern, currentOffset);
        if (index >= 0) {
            this.bumpTo(index);
            return true;
        } else {
            this.bumpTo(this.message.length);
            return false;
        }
    };
    /**
     * Bump the parser to the target offset.
     * If target offset is beyond the end of the input, bump the parser to the end of the input.
     */ Parser.prototype.bumpTo = function(targetOffset) {
        if (this.offset() > targetOffset) throw Error("targetOffset ".concat(targetOffset, " must be greater than or equal to the current offset ").concat(this.offset()));
        targetOffset = Math.min(targetOffset, this.message.length);
        while(true){
            var offset = this.offset();
            if (offset === targetOffset) break;
            if (offset > targetOffset) throw Error("targetOffset ".concat(targetOffset, " is at invalid UTF-16 code unit boundary"));
            this.bump();
            if (this.isEOF()) break;
        }
    };
    /** advance the parser through all whitespace to the next non-whitespace code unit. */ Parser.prototype.bumpSpace = function() {
        while(!this.isEOF() && $77679f3bab6a1abc$var$_isWhiteSpace(this.char()))this.bump();
    };
    /**
     * Peek at the *next* Unicode codepoint in the input without advancing the parser.
     * If the input has been exhausted, then this returns null.
     */ Parser.prototype.peek = function() {
        if (this.isEOF()) return null;
        var code = this.char();
        var offset = this.offset();
        var nextCode = this.message.charCodeAt(offset + (code >= 0x10000 ? 2 : 1));
        return nextCode !== null && nextCode !== void 0 ? nextCode : null;
    };
    return Parser;
}();
/**
 * This check if codepoint is alphabet (lower & uppercase)
 * @param codepoint
 * @returns
 */ function $77679f3bab6a1abc$var$_isAlpha(codepoint) {
    return codepoint >= 97 && codepoint <= 122 || codepoint >= 65 && codepoint <= 90;
}
function $77679f3bab6a1abc$var$_isAlphaOrSlash(codepoint) {
    return $77679f3bab6a1abc$var$_isAlpha(codepoint) || codepoint === 47; /* '/' */ 
}
/** See `parseTag` function docs. */ function $77679f3bab6a1abc$var$_isPotentialElementNameChar(c) {
    return c === 45 /* '-' */  || c === 46 /* '.' */  || c >= 48 && c <= 57 || c === 95 /* '_' */  || c >= 97 && c <= 122 || c >= 65 && c <= 90 || c == 0xb7 || c >= 0xc0 && c <= 0xd6 || c >= 0xd8 && c <= 0xf6 || c >= 0xf8 && c <= 0x37d || c >= 0x37f && c <= 0x1fff || c >= 0x200c && c <= 0x200d || c >= 0x203f && c <= 0x2040 || c >= 0x2070 && c <= 0x218f || c >= 0x2c00 && c <= 0x2fef || c >= 0x3001 && c <= 0xd7ff || c >= 0xf900 && c <= 0xfdcf || c >= 0xfdf0 && c <= 0xfffd || c >= 0x10000 && c <= 0xeffff;
}
/**
 * Code point equivalent of regex `\p{White_Space}`.
 * From: https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $77679f3bab6a1abc$var$_isWhiteSpace(c) {
    return c >= 0x0009 && c <= 0x000d || c === 0x0020 || c === 0x0085 || c >= 0x200e && c <= 0x200f || c === 0x2028 || c === 0x2029;
}
/**
 * Code point equivalent of regex `\p{Pattern_Syntax}`.
 * See https://www.unicode.org/Public/UCD/latest/ucd/PropList.txt
 */ function $77679f3bab6a1abc$var$_isPatternSyntax(c) {
    return c >= 0x0021 && c <= 0x0023 || c === 0x0024 || c >= 0x0025 && c <= 0x0027 || c === 0x0028 || c === 0x0029 || c === 0x002a || c === 0x002b || c === 0x002c || c === 0x002d || c >= 0x002e && c <= 0x002f || c >= 0x003a && c <= 0x003b || c >= 0x003c && c <= 0x003e || c >= 0x003f && c <= 0x0040 || c === 0x005b || c === 0x005c || c === 0x005d || c === 0x005e || c === 0x0060 || c === 0x007b || c === 0x007c || c === 0x007d || c === 0x007e || c === 0x00a1 || c >= 0x00a2 && c <= 0x00a5 || c === 0x00a6 || c === 0x00a7 || c === 0x00a9 || c === 0x00ab || c === 0x00ac || c === 0x00ae || c === 0x00b0 || c === 0x00b1 || c === 0x00b6 || c === 0x00bb || c === 0x00bf || c === 0x00d7 || c === 0x00f7 || c >= 0x2010 && c <= 0x2015 || c >= 0x2016 && c <= 0x2017 || c === 0x2018 || c === 0x2019 || c === 0x201a || c >= 0x201b && c <= 0x201c || c === 0x201d || c === 0x201e || c === 0x201f || c >= 0x2020 && c <= 0x2027 || c >= 0x2030 && c <= 0x2038 || c === 0x2039 || c === 0x203a || c >= 0x203b && c <= 0x203e || c >= 0x2041 && c <= 0x2043 || c === 0x2044 || c === 0x2045 || c === 0x2046 || c >= 0x2047 && c <= 0x2051 || c === 0x2052 || c === 0x2053 || c >= 0x2055 && c <= 0x205e || c >= 0x2190 && c <= 0x2194 || c >= 0x2195 && c <= 0x2199 || c >= 0x219a && c <= 0x219b || c >= 0x219c && c <= 0x219f || c === 0x21a0 || c >= 0x21a1 && c <= 0x21a2 || c === 0x21a3 || c >= 0x21a4 && c <= 0x21a5 || c === 0x21a6 || c >= 0x21a7 && c <= 0x21ad || c === 0x21ae || c >= 0x21af && c <= 0x21cd || c >= 0x21ce && c <= 0x21cf || c >= 0x21d0 && c <= 0x21d1 || c === 0x21d2 || c === 0x21d3 || c === 0x21d4 || c >= 0x21d5 && c <= 0x21f3 || c >= 0x21f4 && c <= 0x22ff || c >= 0x2300 && c <= 0x2307 || c === 0x2308 || c === 0x2309 || c === 0x230a || c === 0x230b || c >= 0x230c && c <= 0x231f || c >= 0x2320 && c <= 0x2321 || c >= 0x2322 && c <= 0x2328 || c === 0x2329 || c === 0x232a || c >= 0x232b && c <= 0x237b || c === 0x237c || c >= 0x237d && c <= 0x239a || c >= 0x239b && c <= 0x23b3 || c >= 0x23b4 && c <= 0x23db || c >= 0x23dc && c <= 0x23e1 || c >= 0x23e2 && c <= 0x2426 || c >= 0x2427 && c <= 0x243f || c >= 0x2440 && c <= 0x244a || c >= 0x244b && c <= 0x245f || c >= 0x2500 && c <= 0x25b6 || c === 0x25b7 || c >= 0x25b8 && c <= 0x25c0 || c === 0x25c1 || c >= 0x25c2 && c <= 0x25f7 || c >= 0x25f8 && c <= 0x25ff || c >= 0x2600 && c <= 0x266e || c === 0x266f || c >= 0x2670 && c <= 0x2767 || c === 0x2768 || c === 0x2769 || c === 0x276a || c === 0x276b || c === 0x276c || c === 0x276d || c === 0x276e || c === 0x276f || c === 0x2770 || c === 0x2771 || c === 0x2772 || c === 0x2773 || c === 0x2774 || c === 0x2775 || c >= 0x2794 && c <= 0x27bf || c >= 0x27c0 && c <= 0x27c4 || c === 0x27c5 || c === 0x27c6 || c >= 0x27c7 && c <= 0x27e5 || c === 0x27e6 || c === 0x27e7 || c === 0x27e8 || c === 0x27e9 || c === 0x27ea || c === 0x27eb || c === 0x27ec || c === 0x27ed || c === 0x27ee || c === 0x27ef || c >= 0x27f0 && c <= 0x27ff || c >= 0x2800 && c <= 0x28ff || c >= 0x2900 && c <= 0x2982 || c === 0x2983 || c === 0x2984 || c === 0x2985 || c === 0x2986 || c === 0x2987 || c === 0x2988 || c === 0x2989 || c === 0x298a || c === 0x298b || c === 0x298c || c === 0x298d || c === 0x298e || c === 0x298f || c === 0x2990 || c === 0x2991 || c === 0x2992 || c === 0x2993 || c === 0x2994 || c === 0x2995 || c === 0x2996 || c === 0x2997 || c === 0x2998 || c >= 0x2999 && c <= 0x29d7 || c === 0x29d8 || c === 0x29d9 || c === 0x29da || c === 0x29db || c >= 0x29dc && c <= 0x29fb || c === 0x29fc || c === 0x29fd || c >= 0x29fe && c <= 0x2aff || c >= 0x2b00 && c <= 0x2b2f || c >= 0x2b30 && c <= 0x2b44 || c >= 0x2b45 && c <= 0x2b46 || c >= 0x2b47 && c <= 0x2b4c || c >= 0x2b4d && c <= 0x2b73 || c >= 0x2b74 && c <= 0x2b75 || c >= 0x2b76 && c <= 0x2b95 || c === 0x2b96 || c >= 0x2b97 && c <= 0x2bff || c >= 0x2e00 && c <= 0x2e01 || c === 0x2e02 || c === 0x2e03 || c === 0x2e04 || c === 0x2e05 || c >= 0x2e06 && c <= 0x2e08 || c === 0x2e09 || c === 0x2e0a || c === 0x2e0b || c === 0x2e0c || c === 0x2e0d || c >= 0x2e0e && c <= 0x2e16 || c === 0x2e17 || c >= 0x2e18 && c <= 0x2e19 || c === 0x2e1a || c === 0x2e1b || c === 0x2e1c || c === 0x2e1d || c >= 0x2e1e && c <= 0x2e1f || c === 0x2e20 || c === 0x2e21 || c === 0x2e22 || c === 0x2e23 || c === 0x2e24 || c === 0x2e25 || c === 0x2e26 || c === 0x2e27 || c === 0x2e28 || c === 0x2e29 || c >= 0x2e2a && c <= 0x2e2e || c === 0x2e2f || c >= 0x2e30 && c <= 0x2e39 || c >= 0x2e3a && c <= 0x2e3b || c >= 0x2e3c && c <= 0x2e3f || c === 0x2e40 || c === 0x2e41 || c === 0x2e42 || c >= 0x2e43 && c <= 0x2e4f || c >= 0x2e50 && c <= 0x2e51 || c === 0x2e52 || c >= 0x2e53 && c <= 0x2e7f || c >= 0x3001 && c <= 0x3003 || c === 0x3008 || c === 0x3009 || c === 0x300a || c === 0x300b || c === 0x300c || c === 0x300d || c === 0x300e || c === 0x300f || c === 0x3010 || c === 0x3011 || c >= 0x3012 && c <= 0x3013 || c === 0x3014 || c === 0x3015 || c === 0x3016 || c === 0x3017 || c === 0x3018 || c === 0x3019 || c === 0x301a || c === 0x301b || c === 0x301c || c === 0x301d || c >= 0x301e && c <= 0x301f || c === 0x3020 || c === 0x3030 || c === 0xfd3e || c === 0xfd3f || c >= 0xfe45 && c <= 0xfe46;
}

});
parcelRegister("iAiu6", function(module, exports) {
$parcel$export(module.exports, "TYPE", () => $d879ed73e44ca3ad$export$b87f371cbc396fcf);
$parcel$export(module.exports, "SKELETON_TYPE", () => $d879ed73e44ca3ad$export$906452485466fa53);
$parcel$export(module.exports, "isLiteralElement", () => $d879ed73e44ca3ad$export$cfa10c5697238752);
$parcel$export(module.exports, "isArgumentElement", () => $d879ed73e44ca3ad$export$4f55724281bdfaf9);
$parcel$export(module.exports, "isNumberElement", () => $d879ed73e44ca3ad$export$e11187b219e191e1);
$parcel$export(module.exports, "isDateElement", () => $d879ed73e44ca3ad$export$32d811605da75f40);
$parcel$export(module.exports, "isTimeElement", () => $d879ed73e44ca3ad$export$34ec46f596b1702f);
$parcel$export(module.exports, "isSelectElement", () => $d879ed73e44ca3ad$export$dcfe1c11d168b5a1);
$parcel$export(module.exports, "isPluralElement", () => $d879ed73e44ca3ad$export$6c796d116f0a4fbc);
$parcel$export(module.exports, "isPoundElement", () => $d879ed73e44ca3ad$export$c0ece297bdd0c082);
$parcel$export(module.exports, "isTagElement", () => $d879ed73e44ca3ad$export$5c83de34745812b);
$parcel$export(module.exports, "isNumberSkeleton", () => $d879ed73e44ca3ad$export$3f9a19cd4152eda3);
$parcel$export(module.exports, "isDateTimeSkeleton", () => $d879ed73e44ca3ad$export$7680c41f1a55f4cf);
var $d879ed73e44ca3ad$export$b87f371cbc396fcf;
(function(TYPE) {
    /**
     * Raw text
     */ TYPE[TYPE["literal"] = 0] = "literal";
    /**
     * Variable w/o any format, e.g `var` in `this is a {var}`
     */ TYPE[TYPE["argument"] = 1] = "argument";
    /**
     * Variable w/ number format
     */ TYPE[TYPE["number"] = 2] = "number";
    /**
     * Variable w/ date format
     */ TYPE[TYPE["date"] = 3] = "date";
    /**
     * Variable w/ time format
     */ TYPE[TYPE["time"] = 4] = "time";
    /**
     * Variable w/ select format
     */ TYPE[TYPE["select"] = 5] = "select";
    /**
     * Variable w/ plural format
     */ TYPE[TYPE["plural"] = 6] = "plural";
    /**
     * Only possible within plural argument.
     * This is the `#` symbol that will be substituted with the count.
     */ TYPE[TYPE["pound"] = 7] = "pound";
    /**
     * XML-like tag
     */ TYPE[TYPE["tag"] = 8] = "tag";
})($d879ed73e44ca3ad$export$b87f371cbc396fcf || ($d879ed73e44ca3ad$export$b87f371cbc396fcf = {}));
var $d879ed73e44ca3ad$export$906452485466fa53;
(function(SKELETON_TYPE) {
    SKELETON_TYPE[SKELETON_TYPE["number"] = 0] = "number";
    SKELETON_TYPE[SKELETON_TYPE["dateTime"] = 1] = "dateTime";
})($d879ed73e44ca3ad$export$906452485466fa53 || ($d879ed73e44ca3ad$export$906452485466fa53 = {}));
function $d879ed73e44ca3ad$export$cfa10c5697238752(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.literal;
}
function $d879ed73e44ca3ad$export$4f55724281bdfaf9(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.argument;
}
function $d879ed73e44ca3ad$export$e11187b219e191e1(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.number;
}
function $d879ed73e44ca3ad$export$32d811605da75f40(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.date;
}
function $d879ed73e44ca3ad$export$34ec46f596b1702f(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.time;
}
function $d879ed73e44ca3ad$export$dcfe1c11d168b5a1(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.select;
}
function $d879ed73e44ca3ad$export$6c796d116f0a4fbc(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.plural;
}
function $d879ed73e44ca3ad$export$c0ece297bdd0c082(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.pound;
}
function $d879ed73e44ca3ad$export$5c83de34745812b(el) {
    return el.type === $d879ed73e44ca3ad$export$b87f371cbc396fcf.tag;
}
function $d879ed73e44ca3ad$export$3f9a19cd4152eda3(el) {
    return !!(el && typeof el === 'object' && el.type === $d879ed73e44ca3ad$export$906452485466fa53.number);
}
function $d879ed73e44ca3ad$export$7680c41f1a55f4cf(el) {
    return !!(el && typeof el === 'object' && el.type === $d879ed73e44ca3ad$export$906452485466fa53.dateTime);
}
function $d879ed73e44ca3ad$export$f0ac572c1121c662(value) {
    return {
        type: $d879ed73e44ca3ad$export$b87f371cbc396fcf.literal,
        value: value
    };
}
function $d879ed73e44ca3ad$export$425e864b0ba114f1(value, style) {
    return {
        type: $d879ed73e44ca3ad$export$b87f371cbc396fcf.number,
        value: value,
        style: style
    };
}

});

parcelRegister("aeOT0", function(module, exports) {
$parcel$export(module.exports, "SPACE_SEPARATOR_REGEX", () => $7742af259653b242$export$523451f94304dd6c);
// @generated from regex-gen.ts
var $7742af259653b242$export$523451f94304dd6c = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;
var $7742af259653b242$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/;

});

parcelRegister("guF8e", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => (parcelRequire("hr14c")).parseDateTimeSkeleton);
$parcel$export(module.exports, "parseNumberSkeleton", () => (parcelRequire("ll3qM")).parseNumberSkeleton);
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => (parcelRequire("ll3qM")).parseNumberSkeletonFromString);
parcelRequire("hr14c");
parcelRequire("ll3qM");

});
parcelRegister("hr14c", function(module, exports) {
$parcel$export(module.exports, "parseDateTimeSkeleton", () => $cb15c91ac17cb135$export$f7b99fb377fe69fa);
/**
 * https://unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * Credit: https://github.com/caridy/intl-datetimeformat-pattern/blob/master/index.js
 * with some tweaks
 */ var $cb15c91ac17cb135$var$DATE_TIME_REGEX = /(?:[Eec]{1,6}|G{1,5}|[Qq]{1,5}|(?:[yYur]+|U{1,5})|[ML]{1,5}|d{1,2}|D{1,3}|F{1}|[abB]{1,5}|[hkHK]{1,2}|w{1,2}|W{1}|m{1,2}|s{1,2}|[zZOvVxX]{1,4})(?=([^']*'[^']*')*[^']*$)/g;
function $cb15c91ac17cb135$export$f7b99fb377fe69fa(skeleton) {
    var result = {};
    skeleton.replace($cb15c91ac17cb135$var$DATE_TIME_REGEX, function(match) {
        var len = match.length;
        switch(match[0]){
            // Era
            case 'G':
                result.era = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            // Year
            case 'y':
                result.year = len === 2 ? '2-digit' : 'numeric';
                break;
            case 'Y':
            case 'u':
            case 'U':
            case 'r':
                throw new RangeError('`Y/u/U/r` (year) patterns are not supported, use `y` instead');
            // Quarter
            case 'q':
            case 'Q':
                throw new RangeError('`q/Q` (quarter) patterns are not supported');
            // Month
            case 'M':
            case 'L':
                result.month = [
                    'numeric',
                    '2-digit',
                    'short',
                    'long',
                    'narrow'
                ][len - 1];
                break;
            // Week
            case 'w':
            case 'W':
                throw new RangeError('`w/W` (week) patterns are not supported');
            case 'd':
                result.day = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'D':
            case 'F':
            case 'g':
                throw new RangeError('`D/F/g` (day) patterns are not supported, use `d` instead');
            // Weekday
            case 'E':
                result.weekday = len === 4 ? 'long' : len === 5 ? 'narrow' : 'short';
                break;
            case 'e':
                if (len < 4) throw new RangeError('`e..eee` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            case 'c':
                if (len < 4) throw new RangeError('`c..ccc` (weekday) patterns are not supported');
                result.weekday = [
                    'short',
                    'long',
                    'narrow',
                    'short'
                ][len - 4];
                break;
            // Period
            case 'a':
                result.hour12 = true;
                break;
            case 'b':
            case 'B':
                throw new RangeError('`b/B` (period) patterns are not supported, use `a` instead');
            // Hour
            case 'h':
                result.hourCycle = 'h12';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'H':
                result.hourCycle = 'h23';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'K':
                result.hourCycle = 'h11';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'k':
                result.hourCycle = 'h24';
                result.hour = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'j':
            case 'J':
            case 'C':
                throw new RangeError('`j/J/C` (hour) patterns are not supported, use `h/H/K/k` instead');
            // Minute
            case 'm':
                result.minute = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            // Second
            case 's':
                result.second = [
                    'numeric',
                    '2-digit'
                ][len - 1];
                break;
            case 'S':
            case 'A':
                throw new RangeError('`S/A` (second) patterns are not supported, use `s` instead');
            // Zone
            case 'z':
                result.timeZoneName = len < 4 ? 'short' : 'long';
                break;
            case 'Z':
            case 'O':
            case 'v':
            case 'V':
            case 'X':
            case 'x':
                throw new RangeError('`Z/O/v/V/X/x` (timeZone) patterns are not supported, use `z` instead');
        }
        return '';
    });
    return result;
}

});

parcelRegister("ll3qM", function(module, exports) {
$parcel$export(module.exports, "parseNumberSkeletonFromString", () => $f88e3873e2d0fd04$export$71cee2f16fba2480);
$parcel$export(module.exports, "parseNumberSkeleton", () => $f88e3873e2d0fd04$export$47c6f8480bda3e11);

var $j9yrT = parcelRequire("j9yrT");

var $9J1Bl = parcelRequire("9J1Bl");
function $f88e3873e2d0fd04$export$71cee2f16fba2480(skeleton) {
    if (skeleton.length === 0) throw new Error('Number skeleton cannot be empty');
    // Parse the skeleton
    var stringTokens = skeleton.split((0, $9J1Bl.WHITE_SPACE_REGEX)).filter(function(x) {
        return x.length > 0;
    });
    var tokens = [];
    for(var _i = 0, stringTokens_1 = stringTokens; _i < stringTokens_1.length; _i++){
        var stringToken = stringTokens_1[_i];
        var stemAndOptions = stringToken.split('/');
        if (stemAndOptions.length === 0) throw new Error('Invalid number skeleton');
        var stem = stemAndOptions[0], options = stemAndOptions.slice(1);
        for(var _a = 0, options_1 = options; _a < options_1.length; _a++){
            var option = options_1[_a];
            if (option.length === 0) throw new Error('Invalid number skeleton');
        }
        tokens.push({
            stem: stem,
            options: options
        });
    }
    return tokens;
}
function $f88e3873e2d0fd04$var$icuUnitToEcma(unit) {
    return unit.replace(/^(.*?)-/, '');
}
var $f88e3873e2d0fd04$var$FRACTION_PRECISION_REGEX = /^\.(?:(0+)(\*)?|(#+)|(0+)(#+))$/g;
var $f88e3873e2d0fd04$var$SIGNIFICANT_PRECISION_REGEX = /^(@+)?(\+|#+)?[rs]?$/g;
var $f88e3873e2d0fd04$var$INTEGER_WIDTH_REGEX = /(\*)(0+)|(#+)(0+)|(0+)/g;
var $f88e3873e2d0fd04$var$CONCISE_INTEGER_WIDTH_REGEX = /^(0+)$/;
function $f88e3873e2d0fd04$var$parseSignificantPrecision(str) {
    var result = {};
    if (str[str.length - 1] === 'r') result.roundingPriority = 'morePrecision';
    else if (str[str.length - 1] === 's') result.roundingPriority = 'lessPrecision';
    str.replace($f88e3873e2d0fd04$var$SIGNIFICANT_PRECISION_REGEX, function(_, g1, g2) {
        // @@@ case
        if (typeof g2 !== 'string') {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length;
        } else if (g2 === '+') result.minimumSignificantDigits = g1.length;
        else if (g1[0] === '#') result.maximumSignificantDigits = g1.length;
        else {
            result.minimumSignificantDigits = g1.length;
            result.maximumSignificantDigits = g1.length + (typeof g2 === 'string' ? g2.length : 0);
        }
        return '';
    });
    return result;
}
function $f88e3873e2d0fd04$var$parseSign(str) {
    switch(str){
        case 'sign-auto':
            return {
                signDisplay: 'auto'
            };
        case 'sign-accounting':
        case '()':
            return {
                currencySign: 'accounting'
            };
        case 'sign-always':
        case '+!':
            return {
                signDisplay: 'always'
            };
        case 'sign-accounting-always':
        case '()!':
            return {
                signDisplay: 'always',
                currencySign: 'accounting'
            };
        case 'sign-except-zero':
        case '+?':
            return {
                signDisplay: 'exceptZero'
            };
        case 'sign-accounting-except-zero':
        case '()?':
            return {
                signDisplay: 'exceptZero',
                currencySign: 'accounting'
            };
        case 'sign-never':
        case '+_':
            return {
                signDisplay: 'never'
            };
    }
}
function $f88e3873e2d0fd04$var$parseConciseScientificAndEngineeringStem(stem) {
    // Engineering
    var result;
    if (stem[0] === 'E' && stem[1] === 'E') {
        result = {
            notation: 'engineering'
        };
        stem = stem.slice(2);
    } else if (stem[0] === 'E') {
        result = {
            notation: 'scientific'
        };
        stem = stem.slice(1);
    }
    if (result) {
        var signDisplay = stem.slice(0, 2);
        if (signDisplay === '+!') {
            result.signDisplay = 'always';
            stem = stem.slice(2);
        } else if (signDisplay === '+?') {
            result.signDisplay = 'exceptZero';
            stem = stem.slice(2);
        }
        if (!$f88e3873e2d0fd04$var$CONCISE_INTEGER_WIDTH_REGEX.test(stem)) throw new Error('Malformed concise eng/scientific notation');
        result.minimumIntegerDigits = stem.length;
    }
    return result;
}
function $f88e3873e2d0fd04$var$parseNotationOptions(opt) {
    var result = {};
    var signOpts = $f88e3873e2d0fd04$var$parseSign(opt);
    if (signOpts) return signOpts;
    return result;
}
function $f88e3873e2d0fd04$export$47c6f8480bda3e11(tokens) {
    var result = {};
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        switch(token.stem){
            case 'percent':
            case '%':
                result.style = 'percent';
                continue;
            case '%x100':
                result.style = 'percent';
                result.scale = 100;
                continue;
            case 'currency':
                result.style = 'currency';
                result.currency = token.options[0];
                continue;
            case 'group-off':
            case ',_':
                result.useGrouping = false;
                continue;
            case 'precision-integer':
            case '.':
                result.maximumFractionDigits = 0;
                continue;
            case 'measure-unit':
            case 'unit':
                result.style = 'unit';
                result.unit = $f88e3873e2d0fd04$var$icuUnitToEcma(token.options[0]);
                continue;
            case 'compact-short':
            case 'K':
                result.notation = 'compact';
                result.compactDisplay = 'short';
                continue;
            case 'compact-long':
            case 'KK':
                result.notation = 'compact';
                result.compactDisplay = 'long';
                continue;
            case 'scientific':
                result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                    notation: 'scientific'
                }), token.options.reduce(function(all, opt) {
                    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, all), $f88e3873e2d0fd04$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'engineering':
                result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                    notation: 'engineering'
                }), token.options.reduce(function(all, opt) {
                    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, all), $f88e3873e2d0fd04$var$parseNotationOptions(opt));
                }, {}));
                continue;
            case 'notation-simple':
                result.notation = 'standard';
                continue;
            // https://github.com/unicode-org/icu/blob/master/icu4c/source/i18n/unicode/unumberformatter.h
            case 'unit-width-narrow':
                result.currencyDisplay = 'narrowSymbol';
                result.unitDisplay = 'narrow';
                continue;
            case 'unit-width-short':
                result.currencyDisplay = 'code';
                result.unitDisplay = 'short';
                continue;
            case 'unit-width-full-name':
                result.currencyDisplay = 'name';
                result.unitDisplay = 'long';
                continue;
            case 'unit-width-iso-code':
                result.currencyDisplay = 'symbol';
                continue;
            case 'scale':
                result.scale = parseFloat(token.options[0]);
                continue;
            case 'rounding-mode-floor':
                result.roundingMode = 'floor';
                continue;
            case 'rounding-mode-ceiling':
                result.roundingMode = 'ceil';
                continue;
            case 'rounding-mode-down':
                result.roundingMode = 'trunc';
                continue;
            case 'rounding-mode-up':
                result.roundingMode = 'expand';
                continue;
            case 'rounding-mode-half-even':
                result.roundingMode = 'halfEven';
                continue;
            case 'rounding-mode-half-down':
                result.roundingMode = 'halfTrunc';
                continue;
            case 'rounding-mode-half-up':
                result.roundingMode = 'halfExpand';
                continue;
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
            case 'integer-width':
                if (token.options.length > 1) throw new RangeError('integer-width stems only accept a single optional option');
                token.options[0].replace($f88e3873e2d0fd04$var$INTEGER_WIDTH_REGEX, function(_, g1, g2, g3, g4, g5) {
                    if (g1) result.minimumIntegerDigits = g2.length;
                    else if (g3 && g4) throw new Error('We currently do not support maximum integer digits');
                    else if (g5) throw new Error('We currently do not support exact integer digits');
                    return '';
                });
                continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#integer-width
        if ($f88e3873e2d0fd04$var$CONCISE_INTEGER_WIDTH_REGEX.test(token.stem)) {
            result.minimumIntegerDigits = token.stem.length;
            continue;
        }
        if ($f88e3873e2d0fd04$var$FRACTION_PRECISION_REGEX.test(token.stem)) {
            // Precision
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#fraction-precision
            // precision-integer case
            if (token.options.length > 1) throw new RangeError('Fraction-precision stems only accept a single optional option');
            token.stem.replace($f88e3873e2d0fd04$var$FRACTION_PRECISION_REGEX, function(_, g1, g2, g3, g4, g5) {
                // .000* case (before ICU67 it was .000+)
                if (g2 === '*') result.minimumFractionDigits = g1.length;
                else if (g3 && g3[0] === '#') result.maximumFractionDigits = g3.length;
                else if (g4 && g5) {
                    result.minimumFractionDigits = g4.length;
                    result.maximumFractionDigits = g4.length + g5.length;
                } else {
                    result.minimumFractionDigits = g1.length;
                    result.maximumFractionDigits = g1.length;
                }
                return '';
            });
            var opt = token.options[0];
            // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#trailing-zero-display
            if (opt === 'w') result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), {
                trailingZeroDisplay: 'stripIfInteger'
            });
            else if (opt) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), $f88e3873e2d0fd04$var$parseSignificantPrecision(opt));
            continue;
        }
        // https://unicode-org.github.io/icu/userguide/format_parse/numbers/skeletons.html#significant-digits-precision
        if ($f88e3873e2d0fd04$var$SIGNIFICANT_PRECISION_REGEX.test(token.stem)) {
            result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), $f88e3873e2d0fd04$var$parseSignificantPrecision(token.stem));
            continue;
        }
        var signOpts = $f88e3873e2d0fd04$var$parseSign(token.stem);
        if (signOpts) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), signOpts);
        var conciseScientificAndEngineeringOpts = $f88e3873e2d0fd04$var$parseConciseScientificAndEngineeringStem(token.stem);
        if (conciseScientificAndEngineeringOpts) result = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, result), conciseScientificAndEngineeringOpts);
    }
    return result;
}

});
parcelRegister("9J1Bl", function(module, exports) {
$parcel$export(module.exports, "WHITE_SPACE_REGEX", () => $71498eff0cace885$export$2b8db14d8bcaece7);
// @generated from regex-gen.ts
var $71498eff0cace885$export$2b8db14d8bcaece7 = /[\t-\r \x85\u200E\u200F\u2028\u2029]/i;

});



parcelRegister("g2ZlY", function(module, exports) {
$parcel$export(module.exports, "getBestPattern", () => $baec6cbe4dfdc5e4$export$29c5368be8904d27);

var $4kKRl = parcelRequire("4kKRl");
function $baec6cbe4dfdc5e4$export$29c5368be8904d27(skeleton, locale) {
    var skeletonCopy = '';
    for(var patternPos = 0; patternPos < skeleton.length; patternPos++){
        var patternChar = skeleton.charAt(patternPos);
        if (patternChar === 'j') {
            var extraLength = 0;
            while(patternPos + 1 < skeleton.length && skeleton.charAt(patternPos + 1) === patternChar){
                extraLength++;
                patternPos++;
            }
            var hourLen = 1 + (extraLength & 1);
            var dayPeriodLen = extraLength < 2 ? 1 : 3 + (extraLength >> 1);
            var dayPeriodChar = 'a';
            var hourChar = $baec6cbe4dfdc5e4$var$getDefaultHourSymbolFromLocale(locale);
            if (hourChar == 'H' || hourChar == 'k') dayPeriodLen = 0;
            while(dayPeriodLen-- > 0)skeletonCopy += dayPeriodChar;
            while(hourLen-- > 0)skeletonCopy = hourChar + skeletonCopy;
        } else if (patternChar === 'J') skeletonCopy += 'H';
        else skeletonCopy += patternChar;
    }
    return skeletonCopy;
}
/**
 * Maps the [hour cycle type](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/Locale/hourCycle)
 * of the given `locale` to the corresponding time pattern.
 * @param locale
 */ function $baec6cbe4dfdc5e4$var$getDefaultHourSymbolFromLocale(locale) {
    var hourCycle = locale.hourCycle;
    if (hourCycle === undefined && // @ts-ignore hourCycle(s) is not identified yet
    locale.hourCycles && // @ts-ignore
    locale.hourCycles.length) // @ts-ignore
    hourCycle = locale.hourCycles[0];
    if (hourCycle) switch(hourCycle){
        case 'h24':
            return 'k';
        case 'h23':
            return 'H';
        case 'h12':
            return 'h';
        case 'h11':
            return 'K';
        default:
            throw new Error('Invalid hourCycle');
    }
    // TODO: Once hourCycle is fully supported remove the following with data generation
    var languageTag = locale.language;
    var regionTag;
    if (languageTag !== 'root') regionTag = locale.maximize().region;
    var hourCycles = (0, $4kKRl.timeData)[regionTag || ''] || (0, $4kKRl.timeData)[languageTag || ''] || (0, $4kKRl.timeData)["".concat(languageTag, "-001")] || (0, $4kKRl.timeData)['001'];
    return hourCycles[0];
}

});
parcelRegister("4kKRl", function(module, exports) {
$parcel$export(module.exports, "timeData", () => $327d60f5392145dd$export$a8c9209db4084317);
// @generated from time-data-gen.ts
// prettier-ignore  
var $327d60f5392145dd$export$a8c9209db4084317 = {
    "001": [
        "H",
        "h"
    ],
    "419": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AD": [
        "H",
        "hB"
    ],
    "AE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "AF": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "AG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "AL": [
        "h",
        "H",
        "hB"
    ],
    "AM": [
        "H",
        "hB"
    ],
    "AO": [
        "H",
        "hB"
    ],
    "AR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "AS": [
        "h",
        "H"
    ],
    "AT": [
        "H",
        "hB"
    ],
    "AU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "AW": [
        "H",
        "hB"
    ],
    "AX": [
        "H"
    ],
    "AZ": [
        "H",
        "hB",
        "h"
    ],
    "BA": [
        "H",
        "hB",
        "h"
    ],
    "BB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BD": [
        "h",
        "hB",
        "H"
    ],
    "BE": [
        "H",
        "hB"
    ],
    "BF": [
        "H",
        "hB"
    ],
    "BG": [
        "H",
        "hB",
        "h"
    ],
    "BH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "BI": [
        "H",
        "h"
    ],
    "BJ": [
        "H",
        "hB"
    ],
    "BL": [
        "H",
        "hB"
    ],
    "BM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BN": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "BO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "BQ": [
        "H"
    ],
    "BR": [
        "H",
        "hB"
    ],
    "BS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "BT": [
        "h",
        "H"
    ],
    "BW": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "BY": [
        "H",
        "h"
    ],
    "BZ": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CA": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "CC": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CD": [
        "hB",
        "H"
    ],
    "CF": [
        "H",
        "h",
        "hB"
    ],
    "CG": [
        "H",
        "hB"
    ],
    "CH": [
        "H",
        "hB",
        "h"
    ],
    "CI": [
        "H",
        "hB"
    ],
    "CK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CL": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CM": [
        "H",
        "h",
        "hB"
    ],
    "CN": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "CO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CP": [
        "H"
    ],
    "CR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CU": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "CV": [
        "H",
        "hB"
    ],
    "CW": [
        "H",
        "hB"
    ],
    "CX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "CY": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "CZ": [
        "H"
    ],
    "DE": [
        "H",
        "hB"
    ],
    "DG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "DJ": [
        "h",
        "H"
    ],
    "DK": [
        "H"
    ],
    "DM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "DO": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "DZ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "EC": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "EE": [
        "H",
        "hB"
    ],
    "EG": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "EH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ER": [
        "h",
        "H"
    ],
    "ES": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "ET": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "FI": [
        "H"
    ],
    "FJ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "FM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "FO": [
        "H",
        "h"
    ],
    "FR": [
        "H",
        "hB"
    ],
    "GA": [
        "H",
        "hB"
    ],
    "GB": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GD": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GE": [
        "H",
        "hB",
        "h"
    ],
    "GF": [
        "H",
        "hB"
    ],
    "GG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GH": [
        "h",
        "H"
    ],
    "GI": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "GL": [
        "H",
        "h"
    ],
    "GM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GN": [
        "H",
        "hB"
    ],
    "GP": [
        "H",
        "hB"
    ],
    "GQ": [
        "H",
        "hB",
        "h",
        "hb"
    ],
    "GR": [
        "h",
        "H",
        "hb",
        "hB"
    ],
    "GT": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "GU": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "GW": [
        "H",
        "hB"
    ],
    "GY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "HK": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "HN": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "HR": [
        "H",
        "hB"
    ],
    "HU": [
        "H",
        "h"
    ],
    "IC": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ID": [
        "H"
    ],
    "IE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IL": [
        "H",
        "hB"
    ],
    "IM": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IN": [
        "h",
        "H"
    ],
    "IO": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "IQ": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "IR": [
        "hB",
        "H"
    ],
    "IS": [
        "H"
    ],
    "IT": [
        "H",
        "hB"
    ],
    "JE": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "JM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "JO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "JP": [
        "H",
        "K",
        "h"
    ],
    "KE": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "KG": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KH": [
        "hB",
        "h",
        "H",
        "hb"
    ],
    "KI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KM": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "KN": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KP": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "KW": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "KY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "KZ": [
        "H",
        "hB"
    ],
    "LA": [
        "H",
        "hb",
        "hB",
        "h"
    ],
    "LB": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "LC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LI": [
        "H",
        "hB",
        "h"
    ],
    "LK": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "LR": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "LS": [
        "h",
        "H"
    ],
    "LT": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "LU": [
        "H",
        "h",
        "hB"
    ],
    "LV": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "LY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "MC": [
        "H",
        "hB"
    ],
    "MD": [
        "H",
        "hB"
    ],
    "ME": [
        "H",
        "hB",
        "h"
    ],
    "MF": [
        "H",
        "hB"
    ],
    "MG": [
        "H",
        "h"
    ],
    "MH": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MK": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ML": [
        "H"
    ],
    "MM": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "MN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MO": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MP": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MQ": [
        "H",
        "hB"
    ],
    "MR": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "MS": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "MT": [
        "H",
        "h"
    ],
    "MU": [
        "H",
        "h"
    ],
    "MV": [
        "H",
        "h"
    ],
    "MW": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "MX": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "MY": [
        "hb",
        "hB",
        "h",
        "H"
    ],
    "MZ": [
        "H",
        "hB"
    ],
    "NA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NC": [
        "H",
        "hB"
    ],
    "NE": [
        "H"
    ],
    "NF": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NG": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NI": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "NL": [
        "H",
        "hB"
    ],
    "NO": [
        "H",
        "h"
    ],
    "NP": [
        "H",
        "h",
        "hB"
    ],
    "NR": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NU": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "NZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "OM": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PA": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PF": [
        "H",
        "h",
        "hB"
    ],
    "PG": [
        "h",
        "H"
    ],
    "PH": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PK": [
        "h",
        "hB",
        "H"
    ],
    "PL": [
        "H",
        "h"
    ],
    "PM": [
        "H",
        "hB"
    ],
    "PN": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "PR": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "PS": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "PT": [
        "H",
        "hB"
    ],
    "PW": [
        "h",
        "H"
    ],
    "PY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "QA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "RE": [
        "H",
        "hB"
    ],
    "RO": [
        "H",
        "hB"
    ],
    "RS": [
        "H",
        "hB",
        "h"
    ],
    "RU": [
        "H"
    ],
    "RW": [
        "H",
        "h"
    ],
    "SA": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SB": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SC": [
        "H",
        "h",
        "hB"
    ],
    "SD": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SE": [
        "H"
    ],
    "SG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SH": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SI": [
        "H",
        "hB"
    ],
    "SJ": [
        "H"
    ],
    "SK": [
        "H"
    ],
    "SL": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "SM": [
        "H",
        "h",
        "hB"
    ],
    "SN": [
        "H",
        "h",
        "hB"
    ],
    "SO": [
        "h",
        "H"
    ],
    "SR": [
        "H",
        "hB"
    ],
    "SS": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ST": [
        "H",
        "hB"
    ],
    "SV": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "SX": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "SY": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "SZ": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "TC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TD": [
        "h",
        "H",
        "hB"
    ],
    "TF": [
        "H",
        "h",
        "hB"
    ],
    "TG": [
        "H",
        "hB"
    ],
    "TH": [
        "H",
        "h"
    ],
    "TJ": [
        "H",
        "h"
    ],
    "TL": [
        "H",
        "hB",
        "hb",
        "h"
    ],
    "TM": [
        "H",
        "h"
    ],
    "TN": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "TO": [
        "h",
        "H"
    ],
    "TR": [
        "H",
        "hB"
    ],
    "TT": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "TW": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "TZ": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UA": [
        "H",
        "hB",
        "h"
    ],
    "UG": [
        "hB",
        "hb",
        "H",
        "h"
    ],
    "UM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "US": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "UY": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "UZ": [
        "H",
        "hB",
        "h"
    ],
    "VA": [
        "H",
        "h",
        "hB"
    ],
    "VC": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VE": [
        "h",
        "H",
        "hB",
        "hb"
    ],
    "VG": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VI": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "VN": [
        "H",
        "h"
    ],
    "VU": [
        "h",
        "H"
    ],
    "WF": [
        "H",
        "hB"
    ],
    "WS": [
        "h",
        "H"
    ],
    "XK": [
        "H",
        "hB",
        "h"
    ],
    "YE": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "YT": [
        "H",
        "hB"
    ],
    "ZA": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "ZM": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "ZW": [
        "H",
        "h"
    ],
    "af-ZA": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "ar-001": [
        "h",
        "hB",
        "hb",
        "H"
    ],
    "ca-ES": [
        "H",
        "h",
        "hB"
    ],
    "en-001": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-HK": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "en-IL": [
        "H",
        "h",
        "hb",
        "hB"
    ],
    "en-MY": [
        "h",
        "hb",
        "H",
        "hB"
    ],
    "es-BR": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-ES": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "es-GQ": [
        "H",
        "h",
        "hB",
        "hb"
    ],
    "fr-CA": [
        "H",
        "h",
        "hB"
    ],
    "gl-ES": [
        "H",
        "h",
        "hB"
    ],
    "gu-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "hi-IN": [
        "hB",
        "h",
        "H"
    ],
    "it-CH": [
        "H",
        "h",
        "hB"
    ],
    "it-IT": [
        "H",
        "h",
        "hB"
    ],
    "kn-IN": [
        "hB",
        "h",
        "H"
    ],
    "ml-IN": [
        "hB",
        "h",
        "H"
    ],
    "mr-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "pa-IN": [
        "hB",
        "hb",
        "h",
        "H"
    ],
    "ta-IN": [
        "hB",
        "h",
        "hb",
        "H"
    ],
    "te-IN": [
        "hB",
        "h",
        "H"
    ],
    "zu-ZA": [
        "H",
        "hB",
        "hb",
        "h"
    ]
};

});



parcelRegister("2AbW4", function(module, exports) {

var $j9yrT = parcelRequire("j9yrT");

var $iAiu6 = parcelRequire("iAiu6");
function $1e1833c088a4f3f8$var$cloneDeep(obj) {
    if (Array.isArray(obj)) // @ts-expect-error meh
    return (0, $j9yrT.__spreadArray)([], obj.map($1e1833c088a4f3f8$var$cloneDeep), true);
    if (obj !== null && typeof obj === 'object') // @ts-expect-error meh
    return Object.keys(obj).reduce(function(cloned, k) {
        // @ts-expect-error meh
        cloned[k] = $1e1833c088a4f3f8$var$cloneDeep(obj[k]);
        return cloned;
    }, {});
    return obj;
}
function $1e1833c088a4f3f8$var$hoistPluralOrSelectElement(ast, el, positionToInject) {
    // pull this out of the ast and move it to the top
    var cloned = $1e1833c088a4f3f8$var$cloneDeep(el);
    var options = cloned.options;
    cloned.options = Object.keys(options).reduce(function(all, k) {
        var newValue = $1e1833c088a4f3f8$export$be5687ba8bbdf416((0, $j9yrT.__spreadArray)((0, $j9yrT.__spreadArray)((0, $j9yrT.__spreadArray)([], ast.slice(0, positionToInject), true), options[k].value, true), ast.slice(positionToInject + 1), true));
        all[k] = {
            value: newValue
        };
        return all;
    }, {});
    return cloned;
}
function $1e1833c088a4f3f8$var$isPluralOrSelectElement(el) {
    return (0, $iAiu6.isPluralElement)(el) || (0, $iAiu6.isSelectElement)(el);
}
function $1e1833c088a4f3f8$var$findPluralOrSelectElement(ast) {
    return !!ast.find(function(el) {
        if ($1e1833c088a4f3f8$var$isPluralOrSelectElement(el)) return true;
        if ((0, $iAiu6.isTagElement)(el)) return $1e1833c088a4f3f8$var$findPluralOrSelectElement(el.children);
        return false;
    });
}
function $1e1833c088a4f3f8$export$be5687ba8bbdf416(ast) {
    for(var i = 0; i < ast.length; i++){
        var el = ast[i];
        if ($1e1833c088a4f3f8$var$isPluralOrSelectElement(el)) return [
            $1e1833c088a4f3f8$var$hoistPluralOrSelectElement(ast, el, i)
        ];
        if ((0, $iAiu6.isTagElement)(el) && $1e1833c088a4f3f8$var$findPluralOrSelectElement([
            el
        ])) throw new Error('Cannot hoist plural/select within a tag element. Please put the tag element inside each plural/select option');
    }
    return ast;
}
/**
 * Collect all variables in an AST to Record<string, TYPE>
 * @param ast AST to collect variables from
 * @param vars Record of variable name to variable type
 */ function $1e1833c088a4f3f8$var$collectVariables(ast, vars) {
    if (vars === void 0) vars = new Map();
    ast.forEach(function(el) {
        if ((0, $iAiu6.isArgumentElement)(el) || (0, $iAiu6.isDateElement)(el) || (0, $iAiu6.isTimeElement)(el) || (0, $iAiu6.isNumberElement)(el)) {
            if (el.value in vars && vars.get(el.value) !== el.type) throw new Error("Variable ".concat(el.value, " has conflicting types"));
            vars.set(el.value, el.type);
        }
        if ((0, $iAiu6.isPluralElement)(el) || (0, $iAiu6.isSelectElement)(el)) {
            vars.set(el.value, el.type);
            Object.keys(el.options).forEach(function(k) {
                $1e1833c088a4f3f8$var$collectVariables(el.options[k].value, vars);
            });
        }
        if ((0, $iAiu6.isTagElement)(el)) {
            vars.set(el.value, el.type);
            $1e1833c088a4f3f8$var$collectVariables(el.children, vars);
        }
    });
}
function $1e1833c088a4f3f8$export$1edd9c892fdd9d27(a, b) {
    var aVars = new Map();
    var bVars = new Map();
    $1e1833c088a4f3f8$var$collectVariables(a, aVars);
    $1e1833c088a4f3f8$var$collectVariables(b, bVars);
    if (aVars.size !== bVars.size) return {
        success: false,
        error: new Error("Different number of variables: [".concat(Array.from(aVars.keys()).join(', '), "] vs [").concat(Array.from(bVars.keys()).join(', '), "]"))
    };
    return Array.from(aVars.entries()).reduce(function(result, _a) {
        var key = _a[0], type = _a[1];
        if (!result.success) return result;
        var bType = bVars.get(key);
        if (bType == null) return {
            success: false,
            error: new Error("Missing variable ".concat(key, " in message"))
        };
        if (bType !== type) return {
            success: false,
            error: new Error("Variable ".concat(key, " has conflicting types: ").concat((0, $iAiu6.TYPE)[type], " vs ").concat((0, $iAiu6.TYPE)[bType]))
        };
        return result;
    }, {
        success: true
    });
}

});


parcelRegister("4NJDI", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $37ef2413f4682c98$export$49694c2877b44c57);
$parcel$export(module.exports, "isFormatXMLElementFn", () => $37ef2413f4682c98$export$df0c12a2d414a163);
$parcel$export(module.exports, "formatToParts", () => $37ef2413f4682c98$export$275d4a3bb5f66fda);
parcelRequire("e9UO2");
var $iAiu6 = parcelRequire("iAiu6");

var $21W70 = parcelRequire("21W70");
var $37ef2413f4682c98$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($37ef2413f4682c98$export$49694c2877b44c57 || ($37ef2413f4682c98$export$49694c2877b44c57 = {}));
function $37ef2413f4682c98$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $37ef2413f4682c98$export$49694c2877b44c57.literal || part.type !== $37ef2413f4682c98$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $37ef2413f4682c98$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $37ef2413f4682c98$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $iAiu6.isLiteralElement)(els[0])) return [
        {
            type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $iAiu6.isLiteralElement)(el)) {
            result.push({
                type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $iAiu6.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $21W70.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $iAiu6.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $37ef2413f4682c98$export$49694c2877b44c57.literal : $37ef2413f4682c98$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $iAiu6.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $iAiu6.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iAiu6.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $iAiu6.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iAiu6.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $iAiu6.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $37ef2413f4682c98$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $iAiu6.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$37ef2413f4682c98$export$df0c12a2d414a163(formatFn)) throw new (0, $21W70.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $37ef2413f4682c98$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $37ef2413f4682c98$export$49694c2877b44c57.literal : $37ef2413f4682c98$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $iAiu6.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $21W70.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $37ef2413f4682c98$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $iAiu6.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $21W70.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $21W70.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $21W70.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $37ef2413f4682c98$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $37ef2413f4682c98$var$mergeLiteral(result);
}

});
parcelRegister("21W70", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $17a8c0971d7c496e$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "FormatError", () => $17a8c0971d7c496e$export$7369836851cc1329);
$parcel$export(module.exports, "InvalidValueError", () => $17a8c0971d7c496e$export$565c3afc07dfa382);
$parcel$export(module.exports, "InvalidValueTypeError", () => $17a8c0971d7c496e$export$cbc0db47c750f7c9);
$parcel$export(module.exports, "MissingValueError", () => $17a8c0971d7c496e$export$8bfc137e4d23fdf0);

var $j9yrT = parcelRequire("j9yrT");
var $17a8c0971d7c496e$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($17a8c0971d7c496e$export$d4e71bc0b80dc0fb || ($17a8c0971d7c496e$export$d4e71bc0b80dc0fb = {}));
var $17a8c0971d7c496e$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $17a8c0971d7c496e$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $17a8c0971d7c496e$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($17a8c0971d7c496e$export$7369836851cc1329);
var $17a8c0971d7c496e$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $17a8c0971d7c496e$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($17a8c0971d7c496e$export$7369836851cc1329);
var $17a8c0971d7c496e$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $17a8c0971d7c496e$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($17a8c0971d7c496e$export$7369836851cc1329);

});




parcelRegister("g9Dhn", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $bc2bf4a5b9f08dbd$export$557d6acb76e8a244);
$parcel$export(module.exports, "IntlError", () => $bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);
$parcel$export(module.exports, "UnsupportedFormatterError", () => $bc2bf4a5b9f08dbd$export$549f97e137a05c90);
$parcel$export(module.exports, "InvalidConfigError", () => $bc2bf4a5b9f08dbd$export$3ca04dd7fb305893);
$parcel$export(module.exports, "MissingDataError", () => $bc2bf4a5b9f08dbd$export$c1eaf877d81384b6);
$parcel$export(module.exports, "IntlFormatError", () => $bc2bf4a5b9f08dbd$export$e3b7eee1dbc44895);
$parcel$export(module.exports, "MessageFormatError", () => $bc2bf4a5b9f08dbd$export$74a601a3d3f31621);
$parcel$export(module.exports, "MissingTranslationError", () => $bc2bf4a5b9f08dbd$export$2ddcb436d0aa3688);

var $j9yrT = parcelRequire("j9yrT");
var $bc2bf4a5b9f08dbd$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($bc2bf4a5b9f08dbd$export$557d6acb76e8a244 || ($bc2bf4a5b9f08dbd$export$557d6acb76e8a244 = {}));
var $bc2bf4a5b9f08dbd$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $bc2bf4a5b9f08dbd$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $bc2bf4a5b9f08dbd$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);
var $bc2bf4a5b9f08dbd$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $bc2bf4a5b9f08dbd$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);
var $bc2bf4a5b9f08dbd$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $bc2bf4a5b9f08dbd$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);
var $bc2bf4a5b9f08dbd$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $bc2bf4a5b9f08dbd$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);
var $bc2bf4a5b9f08dbd$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($bc2bf4a5b9f08dbd$export$e3b7eee1dbc44895);
var $bc2bf4a5b9f08dbd$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $j9yrT.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $bc2bf4a5b9f08dbd$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($bc2bf4a5b9f08dbd$export$c016d36112f6ddf8);

});


parcelRegister("8HoVd", function(module, exports) {
$parcel$export(module.exports, "createIntl", () => $6555abd6b8d19ea3$export$7e4cbedfdd7b4c0d);

var $j9yrT = parcelRequire("j9yrT");

var $jtdDb = parcelRequire("jtdDb");

var $7Lk8z = parcelRequire("7Lk8z");

var $g9Dhn = parcelRequire("g9Dhn");

var $6ZQWh = parcelRequire("6ZQWh");

var $xm57c = parcelRequire("xm57c");

var $9CVUr = parcelRequire("9CVUr");

var $lEdTq = parcelRequire("lEdTq");

var $3b1rk = parcelRequire("3b1rk");

var $dqCTG = parcelRequire("dqCTG");
function $6555abd6b8d19ea3$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $6555abd6b8d19ea3$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $6555abd6b8d19ea3$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $6555abd6b8d19ea3$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $dqCTG.createFormatters)(cache);
    var resolvedConfig = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, (0, $dqCTG.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $g9Dhn.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $g9Dhn.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $g9Dhn.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $6555abd6b8d19ea3$var$verifyConfigMessages(resolvedConfig);
    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $9CVUr.formatNumber).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $9CVUr.formatNumberToParts).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $3b1rk.formatRelativeTime).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $jtdDb.formatDate).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $jtdDb.formatDateToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $jtdDb.formatTime).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $jtdDb.formatDateTimeRange).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $jtdDb.formatTimeToParts).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $lEdTq.formatPlural).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $xm57c.formatMessage).bind(null, resolvedConfig, formatters),
        $t: (0, $xm57c.formatMessage).bind(null, resolvedConfig, formatters),
        formatList: (0, $6ZQWh.formatList).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $6ZQWh.formatListToParts).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $7Lk8z.formatDisplayName).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}

});
parcelRegister("jtdDb", function(module, exports) {
$parcel$export(module.exports, "formatDate", () => $e2cb4c985aa34c17$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatTime", () => $e2cb4c985aa34c17$export$3203edd9e5edd663);
$parcel$export(module.exports, "formatDateTimeRange", () => $e2cb4c985aa34c17$export$a7fc3a91cb2ec376);
$parcel$export(module.exports, "formatDateToParts", () => $e2cb4c985aa34c17$export$dc1f059bce486b1);
$parcel$export(module.exports, "formatTimeToParts", () => $e2cb4c985aa34c17$export$af6e5d7a5c73edeb);

var $j9yrT = parcelRequire("j9yrT");

var $g9Dhn = parcelRequire("g9Dhn");

var $dqCTG = parcelRequire("dqCTG");
var $e2cb4c985aa34c17$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $e2cb4c985aa34c17$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $dqCTG.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $dqCTG.filterProps)(options, $e2cb4c985aa34c17$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $e2cb4c985aa34c17$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e2cb4c985aa34c17$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $e2cb4c985aa34c17$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e2cb4c985aa34c17$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $e2cb4c985aa34c17$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $e2cb4c985aa34c17$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $e2cb4c985aa34c17$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e2cb4c985aa34c17$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $e2cb4c985aa34c17$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $e2cb4c985aa34c17$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}

});

parcelRegister("7Lk8z", function(module, exports) {
$parcel$export(module.exports, "formatDisplayName", () => $5a6c8b0330085521$export$62fe1a4d9e891fa2);

var $dqCTG = parcelRequire("dqCTG");

var $21W70 = parcelRequire("21W70");

var $g9Dhn = parcelRequire("g9Dhn");
var $5a6c8b0330085521$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $5a6c8b0330085521$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $21W70.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $21W70.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dqCTG.filterProps)(options, $5a6c8b0330085521$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $g9Dhn.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

});

parcelRegister("6ZQWh", function(module, exports) {
$parcel$export(module.exports, "formatList", () => $5181812f2b0210fd$export$e8b8be48b45905bb);
$parcel$export(module.exports, "formatListToParts", () => $5181812f2b0210fd$export$6f284aad1934db69);

var $j9yrT = parcelRequire("j9yrT");

var $21W70 = parcelRequire("21W70");

var $g9Dhn = parcelRequire("g9Dhn");

var $dqCTG = parcelRequire("dqCTG");
var $5181812f2b0210fd$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $5181812f2b0210fd$var$now = Date.now();
function $5181812f2b0210fd$var$generateToken(i) {
    return "".concat($5181812f2b0210fd$var$now, "_").concat(i, "_").concat($5181812f2b0210fd$var$now);
}
function $5181812f2b0210fd$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $5181812f2b0210fd$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $5181812f2b0210fd$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $21W70.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $21W70.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dqCTG.filterProps)(options, $5181812f2b0210fd$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $5181812f2b0210fd$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $g9Dhn.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}

});

parcelRegister("xm57c", function(module, exports) {
$parcel$export(module.exports, "formatMessage", () => $0644361bcedcebfb$export$25868d1e8e76735f);

var $j9yrT = parcelRequire("j9yrT");
parcelRequire("e9UO2");
var $iAiu6 = parcelRequire("iAiu6");
parcelRequire("fNZUx");
var $ltA3t = parcelRequire("ltA3t");

var $g9Dhn = parcelRequire("g9Dhn");

var $dqCTG = parcelRequire("dqCTG");
function $0644361bcedcebfb$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $j9yrT.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $0644361bcedcebfb$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $0644361bcedcebfb$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $ltA3t.IntlMessageFormat).formats;
    return (0, $j9yrT.__assign)((0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, mfFormats), f1), {
        date: $0644361bcedcebfb$var$deepMergeOptions($0644361bcedcebfb$var$setTimeZoneInOptions(mfFormats.date, timeZone), $0644361bcedcebfb$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $0644361bcedcebfb$var$deepMergeOptions($0644361bcedcebfb$var$setTimeZoneInOptions(mfFormats.time, timeZone), $0644361bcedcebfb$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $0644361bcedcebfb$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $dqCTG.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $iAiu6.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $j9yrT.__assign)((0, $j9yrT.__assign)({}, defaultRichTextElements), values || {});
    formats = $0644361bcedcebfb$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $0644361bcedcebfb$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $g9Dhn.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $g9Dhn.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $j9yrT.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $g9Dhn.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $g9Dhn.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};

});

parcelRegister("9CVUr", function(module, exports) {
$parcel$export(module.exports, "formatNumber", () => $7024954414a41ed4$export$f5dd818bff069720);
$parcel$export(module.exports, "formatNumberToParts", () => $7024954414a41ed4$export$6871080848f10b2f);

var $g9Dhn = parcelRequire("g9Dhn");

var $dqCTG = parcelRequire("dqCTG");
var $7024954414a41ed4$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $7024954414a41ed4$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $dqCTG.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $dqCTG.filterProps)(options, $7024954414a41ed4$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $7024954414a41ed4$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7024954414a41ed4$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $7024954414a41ed4$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $7024954414a41ed4$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}

});

parcelRegister("lEdTq", function(module, exports) {
$parcel$export(module.exports, "formatPlural", () => $fc281c4204bcf026$export$bbbd05c900f3568d);

var $21W70 = parcelRequire("21W70");

var $g9Dhn = parcelRequire("g9Dhn");

var $dqCTG = parcelRequire("dqCTG");
var $fc281c4204bcf026$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $fc281c4204bcf026$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $21W70.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $21W70.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $dqCTG.filterProps)(options, $fc281c4204bcf026$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $g9Dhn.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}

});

parcelRegister("3b1rk", function(module, exports) {
$parcel$export(module.exports, "formatRelativeTime", () => $2503841c472f5049$export$b4ea3b48dcf921f6);

var $dqCTG = parcelRequire("dqCTG");

var $21W70 = parcelRequire("21W70");

var $g9Dhn = parcelRequire("g9Dhn");
var $2503841c472f5049$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $2503841c472f5049$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $dqCTG.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $dqCTG.filterProps)(options, $2503841c472f5049$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $2503841c472f5049$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $21W70.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $21W70.ErrorCode).MISSING_INTL_API));
    try {
        return $2503841c472f5049$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $g9Dhn.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}

});


parcelRegister("jiTLE", function(module, exports) {
$parcel$export(module.exports, "default", () => $e0daf50b86438d74$export$2e2bcd8739ae039);
var $e0daf50b86438d74$var$isProduction = true;
var $e0daf50b86438d74$var$prefix = 'Invariant failed';
function $e0daf50b86438d74$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($e0daf50b86438d74$var$isProduction) throw new Error($e0daf50b86438d74$var$prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat($e0daf50b86438d74$var$prefix, ": ").concat(provided) : $e0daf50b86438d74$var$prefix;
    throw new Error(value);
}

});

parcelRegister("f2wVS", function(module, exports) {
$parcel$export(module.exports, "getRouterState", () => $032512fe78b71306$export$ebf37f7e180b13a9);
$parcel$export(module.exports, "RouterStore", () => $032512fe78b71306$export$1cf0ecab63b1963c);
$parcel$export(module.exports, "RouterContainer", () => $032512fe78b71306$export$d6b817abe7a77ea5);
$parcel$export(module.exports, "useRouterStore", () => $032512fe78b71306$export$9569010eab09ae9e);
$parcel$export(module.exports, "useRouterStoreActions", () => $032512fe78b71306$export$ada49399abf7a3a1);
$parcel$export(module.exports, "createRouterSelector", () => $032512fe78b71306$export$95ab46bba7ea7a22);
$parcel$export(module.exports, "getRouterStore", () => $032512fe78b71306$export$5ccad187366c8494);
$parcel$export(module.exports, "useIsActiveRoute", () => $032512fe78b71306$export$4273485d5c0831e0);
$parcel$export(module.exports, "addRouteListener", () => $032512fe78b71306$export$6ec8251cd652e31a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $kY9Lm = parcelRequire("kY9Lm");

var $1uH7N = parcelRequire("1uH7N");

var $6CfY5 = parcelRequire("6CfY5");

var $k11SN = parcelRequire("k11SN");

var $9X2eH = parcelRequire("9X2eH");
var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");
var $ciIbx = parcelRequire("ciIbx");

var $j02zx = parcelRequire("j02zx");

var $kQAUa = parcelRequire("kQAUa");

var $881dx = parcelRequire("881dx");

var $8ovy4 = parcelRequire("8ovy4");

var $fJ5g0 = parcelRequire("fJ5g0");

var $7bJ0J = parcelRequire("7bJ0J");

var $eaaiA = parcelRequire("eaaiA");
const $032512fe78b71306$export$36d128238e6b60f5 = {
    action: (0, $j02zx.DEFAULT_ACTION),
    basePath: '',
    location: (0, $j02zx.DEFAULT_HISTORY).location,
    history: (0, $j02zx.DEFAULT_HISTORY),
    match: (0, $j02zx.DEFAULT_MATCH),
    onPrefetch: undefined,
    query: {},
    route: (0, $j02zx.DEFAULT_ROUTE),
    routes: [],
    unlisten: null,
    plugins: [],
    isLazyRoutes: false,
    hasPerformedLazyTransition: false
};
const $032512fe78b71306$var$actions = {
    /**
	 * Bootstraps the store with initial data.
	 *
	 */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins, isLazyRoutes: isLazyRoutes } = props;
            const routerContext = (0, $7bJ0J.findRouterContext)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState({
                ...routerContext,
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins,
                isLazyRoutes: isLazyRoutes,
                hasPerformedLazyTransition: false
            });
            if (!(0, $8ovy4.isServerEnvironment)()) dispatch($032512fe78b71306$var$actions.listen());
        },
    /**
	 * Starts listening to browser history and sets the unlisten function in state.
	 * Will request route resources on route change.
	 *
	 */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery, isLazyRoutes: isLazyRoutes, hasPerformedLazyTransition: hasPerformedLazyTransition } = getState();
                const nextContext = (0, $7bJ0J.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $eaaiA.shouldReload)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                const updateState = ()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad?.({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    // If:
                    // * we are in the "lazy routes experiment",
                    // * we haven't killswitched this logger
                    // * and it's the first transition since loading the route list
                    // - log it as a "successful transition"
                    // This will let us work out a proper(-ish) success metric. Killswitch is just in case the
                    // log volume proves excessive
                    let nextHasPerformedLazyTransition = hasPerformedLazyTransition;
                    if (isLazyRoutes && !hasPerformedLazyTransition) {
                        if (!(0, $k11SN.default)('lazyroute_success_logger')) // Since we're doing a transition, we don't need to await as this _should_ complete
                        // (and we don't want to block)
                        (0, $6CfY5.default).safeInfoWithoutCustomerData('lazy_routes.transition', 'success', {
                            route: nextContext.route.name
                        });
                        nextHasPerformedLazyTransition = true;
                    }
                    setState({
                        ...nextContext,
                        location: location,
                        action: action,
                        hasPerformedLazyTransition: nextHasPerformedLazyTransition
                    });
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad?.({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                };
                updateState();
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            (0, $1uH7N.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $eaaiA.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.assign(path);
            else history.push((0, $eaaiA.getRelativePath)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $kQAUa.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $fJ5g0.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes?.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            (0, $1uH7N.di)(window);
            const { history: history, basePath: basePath } = getState();
            if ((0, $eaaiA.isExternalAbsolutePath)(path)) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.location.replace(path);
            else history.replace((0, $eaaiA.getRelativePath)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $kQAUa.generateLocationFromPath)(route.path, {
                ...attributes,
                basePath: basePath
            });
            (0, $fJ5g0.warmupMatchRouteCache)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes?.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = {
                ...existingQueryParams,
                ...params
            };
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $eaaiA.updateQueryParams)(location, existingQueryParams);
            const updatedPath = (0, $eaaiA.updateQueryParams)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = {
                ...existingPathParams,
                ...params
            };
            const updatedPath = (0, $881dx.generatePath)(pathWithBasePath, updatedPathParams);
            const updatedLocation = {
                ...location,
                pathname: updatedPath
            };
            const existingRelativePath = (0, $eaaiA.getRelativeURLFromLocation)(location);
            const updatedRelativePath = (0, $eaaiA.getRelativeURLFromLocation)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad?.({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $032512fe78b71306$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $eaaiA.isExternalAbsolutePath)(path)) {
                const location = (0, $kY9Lm.parsePath)((0, $eaaiA.getRelativePath)(path, basePath));
                // eslint-disable-next-line no-param-reassign
                nextContext = (0, $7bJ0J.findRouterContext)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $9X2eH.batch)(()=>{
                plugins.forEach((p)=>p.routePrefetch?.({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        },
    setRoutes: (routes)=>({ getState: getState, setState: setState })=>{
            const { routes: currentRoutes, history: history } = getState();
            const currentRoutesByName = Object.fromEntries(currentRoutes.map((r)=>[
                    r.name,
                    r
                ]));
            // To ensure that history is preserved, we need to find any current routes
            // in the new route map, and ensure that object identity for that route
            // is preserved in the new route map
            for(let i = 0; i < routes.length; i++){
                const route = routes[i];
                if (Object.hasOwn(currentRoutesByName, route.name)) // eslint-disable-next-line no-param-reassign
                routes[i] = currentRoutesByName[route.name];
            }
            // Refresh info in history for transition blocking
            history.refreshRoutes && history.refreshRoutes(routes);
            setState({
                routes: routes
            });
        }
};
const $032512fe78b71306$export$1cf0ecab63b1963c = (0, $5QDqc.createStore)({
    initialState: $032512fe78b71306$export$36d128238e6b60f5,
    actions: $032512fe78b71306$var$actions,
    name: 'router'
});
const $032512fe78b71306$export$d6b817abe7a77ea5 = (0, $dB6ay.createContainer)($032512fe78b71306$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($032512fe78b71306$var$actions.bootstrapStore(props));
            !(0, $8ovy4.isServerEnvironment)() && dispatch($032512fe78b71306$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $8ovy4.isServerEnvironment)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $032512fe78b71306$export$9569010eab09ae9e = (0, $3h1FP.createHook)($032512fe78b71306$export$1cf0ecab63b1963c);
const $032512fe78b71306$export$ada49399abf7a3a1 = (0, $3h1FP.createActionsHook)($032512fe78b71306$export$1cf0ecab63b1963c);
function $032512fe78b71306$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $3h1FP.createHook)($032512fe78b71306$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        // @ts-expect-error TS2345
        return useHook(...args)[0];
    };
}
const $032512fe78b71306$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $ciIbx.defaultRegistry).getStore($032512fe78b71306$export$1cf0ecab63b1963c);
const $032512fe78b71306$export$ebf37f7e180b13a9 = ()=>$032512fe78b71306$export$5ccad187366c8494().storeState.getState();
const $032512fe78b71306$export$4273485d5c0831e0 = (routeOrRoutes)=>{
    const selector = $032512fe78b71306$export$95ab46bba7ea7a22(({ route: currentRoute })=>{
        if (typeof routeOrRoutes === 'string') return currentRoute.name === routeOrRoutes;
        return routeOrRoutes.has(currentRoute.name);
    });
    return selector();
};
const $032512fe78b71306$export$6ec8251cd652e31a = (listener)=>{
    const store = $032512fe78b71306$export$5ccad187366c8494();
    const unsubscriber = store.storeState.subscribe(listener);
    return ()=>unsubscriber();
};

});
parcelRegister("j02zx", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_MATCH", () => $3d05be54dd2037b0$export$2de13e891a662beb);
$parcel$export(module.exports, "DEFAULT_ROUTE", () => $3d05be54dd2037b0$export$4eadc79233226325);
$parcel$export(module.exports, "DEFAULT_HISTORY", () => $3d05be54dd2037b0$export$39607c9878cf5148);
$parcel$export(module.exports, "DEFAULT_ACTION", () => $3d05be54dd2037b0$export$fa440ddf675c8a93);
/* eslint-disable jira/filename-case */ 
var $655tw = parcelRequire("655tw");
const $3d05be54dd2037b0$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $3d05be54dd2037b0$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $3d05be54dd2037b0$export$39607c9878cf5148 = (0, $655tw.createLegacyHistory)();
const $3d05be54dd2037b0$export$fa440ddf675c8a93 = 'POP';

});
parcelRegister("655tw", function(module, exports) {
$parcel$export(module.exports, "createLegacyHistory", () => $dc02ec5a5230fd0b$export$883c3f3b6c000133);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $eVMQF = parcelRequire("eVMQF");

var $fcq2N = parcelRequire("fcq2N");

var $kY9Lm = parcelRequire("kY9Lm");

var $1uH7N = parcelRequire("1uH7N");
const $dc02ec5a5230fd0b$var$hasWindow = ()=>typeof window !== 'undefined';
const $dc02ec5a5230fd0b$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
    refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
};
const $dc02ec5a5230fd0b$var$getLocation = ()=>{
    (0, $1uH7N.di)(window);
    // todo - don't force non-optional search and hash
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $dc02ec5a5230fd0b$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $dc02ec5a5230fd0b$var$createLegacyListener = (updateExposedLocation)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const node = document.querySelector('#content');
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const currentHref = window.location.href;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($eVMQF)))(()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (prevHref !== window.location.href) {
            const newLocation = $dc02ec5a5230fd0b$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $dc02ec5a5230fd0b$export$883c3f3b6c000133 = ()=>{
    (0, $1uH7N.di)(window);
    let currentLocation = $dc02ec5a5230fd0b$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return {
        get location () {
            return currentLocation;
        },
        get length () {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            return $dc02ec5a5230fd0b$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        },
        ...$dc02ec5a5230fd0b$var$hasWindow() ? {
            push: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.location.assign(typeof path === 'string' ? path : (0, $kY9Lm.createPath)(path || {})),
            replace: (path)=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                window.history.replaceState({}, // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.title, typeof path === 'string' ? path : (0, $kY9Lm.createPath)(path || {})),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goBack: ()=>window.history.back(),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            goForward: ()=>window.history.forward(),
            listen: $dc02ec5a5230fd0b$var$createLegacyListener(updateExposedLocation),
            block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N))),
            createHref: (location)=>(0, $kY9Lm.createPath)(location),
            refreshRoutes: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($fcq2N)))
        } : $dc02ec5a5230fd0b$var$methodsPlaceholders
    };
};

});


parcelRegister("kQAUa", function(module, exports) {
$parcel$export(module.exports, "generateLocationFromPath", () => $e99a0395ae4d3072$export$37e0729cc751960b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $ed9tH = parcelRequire("ed9tH");
function $e99a0395ae4d3072$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $21iIq.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $ed9tH.compile)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}

});
parcelRegister("ed9tH", function(module, exports) {
$parcel$export(module.exports, "compile", () => $74fcb440cd5f8abc$export$ef7acd7185315e22);
$parcel$export(module.exports, "pathToRegexp", () => $74fcb440cd5f8abc$export$71304158c7e35877);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // Taken from https://github.com/pillarjs/path-to-regexp/blob/v6.2.1/src/index.ts
// To address version mismatch with root package.json
/**
 * Tokenizer results.
 */ /**
 * Tokenize input string.
 */ function $74fcb440cd5f8abc$var$lexer(str) {
    const tokens = [];
    let i = 0;
    while(i < str.length){
        const char = str[i];
        if (char === '*' || char === '+' || char === '?') {
            tokens.push({
                type: 'MODIFIER',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '\\') {
            tokens.push({
                type: 'ESCAPED_CHAR',
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === '{') {
            tokens.push({
                type: 'OPEN',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === '}') {
            tokens.push({
                type: 'CLOSE',
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ':') {
            let name = '';
            let j = i + 1;
            while(j < str.length){
                const code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError(`Missing parameter name at ${i}`);
            tokens.push({
                type: 'NAME',
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === '(') {
            let count = 1;
            let pattern = '';
            let j = i + 1;
            if (str[j] === '?') throw new TypeError(`Pattern cannot start with "?" at ${j}`);
            while(j < str.length){
                if (str[j] === '\\') {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ')') {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === '(') {
                    count++;
                    if (str[j + 1] !== '?') throw new TypeError(`Capturing groups are not allowed at ${j}`);
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError(`Unbalanced pattern at ${i}`);
            if (!pattern) throw new TypeError(`Missing pattern at ${i}`);
            tokens.push({
                type: 'PATTERN',
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: 'CHAR',
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: 'END',
        index: i,
        value: ''
    });
    return tokens;
}
function $74fcb440cd5f8abc$export$98e6a39c04603d36(str, options = {}) {
    const tokens = $74fcb440cd5f8abc$var$lexer(str);
    const { prefixes: prefixes = './' } = options;
    const defaultPattern = `[^${$74fcb440cd5f8abc$var$escapeString(options.delimiter || '/#?')}]+?`;
    const result = [];
    let key = 0;
    let i = 0;
    let path = '';
    const tryConsume = (type)=>{
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    const mustConsume = (type)=>{
        const value = tryConsume(type);
        if (value !== undefined) return value;
        const { type: nextType, index: index } = tokens[i];
        throw new TypeError(`Unexpected ${nextType} at ${index}, expected ${type}`);
    };
    const consumeText = ()=>{
        // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
        let result = '';
        let value;
        // eslint-disable-next-line no-cond-assign -- ERROR TO BE FIXED
        while(value = tryConsume('CHAR') || tryConsume('ESCAPED_CHAR'))result += value;
        return result;
    };
    while(i < tokens.length){
        const char = tryConsume('CHAR');
        const name = tryConsume('NAME');
        const pattern = tryConsume('PATTERN');
        if (name || pattern) {
            let prefix = char || '';
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = '';
            }
            if (path) {
                result.push(path);
                path = '';
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: '',
                pattern: pattern || defaultPattern,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        const value = char || tryConsume('ESCAPED_CHAR');
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = '';
        }
        const open = tryConsume('OPEN');
        if (open) {
            const prefix = consumeText();
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const name = tryConsume('NAME') || '';
            // eslint-disable-next-line @typescript-eslint/no-shadow -- ERROR TO BE FIXED
            const pattern = tryConsume('PATTERN') || '';
            const suffix = consumeText();
            mustConsume('CLOSE');
            result.push({
                name: name || (pattern ? key++ : ''),
                pattern: name && !pattern ? defaultPattern : pattern,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume('MODIFIER') || ''
            });
            continue;
        }
        mustConsume('END');
    }
    return result;
}
function $74fcb440cd5f8abc$export$ef7acd7185315e22(str, options) {
    return $74fcb440cd5f8abc$export$5b9bad9e403cf3d9($74fcb440cd5f8abc$export$98e6a39c04603d36(str, options), options);
}
function $74fcb440cd5f8abc$export$5b9bad9e403cf3d9(tokens, options = {}) {
    const reFlags = $74fcb440cd5f8abc$var$flags(options);
    const { encode: encode = (x)=>x, validate: validate = true } = options;
    // Compile all the tokens into regexps.
    // eslint-disable-next-line array-callback-return -- ERROR TO BE FIXED
    const matches = tokens.map((token)=>{
        // oxlint-disable-next-line array-callback-return
        if (typeof token === 'object') return new RegExp(`^(?:${token.pattern})$`, reFlags);
    });
    return (data)=>{
        let path = '';
        for(let i = 0; i < tokens.length; i++){
            const token = tokens[i];
            if (typeof token === 'string') {
                path += token;
                continue;
            }
            const value = data ? data[token.name] : undefined;
            const optional = token.modifier === '?' || token.modifier === '*';
            const repeat = token.modifier === '*' || token.modifier === '+';
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError(`Expected "${token.name}" to not repeat, but got an array`);
                if (value.length === 0) {
                    // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
                    if (optional) continue;
                    throw new TypeError(`Expected "${token.name}" to not be empty`);
                }
                for(let j = 0; j < value.length; j++){
                    const segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError(`Expected all "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === 'string' || typeof value === 'number') {
                const segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError(`Expected "${token.name}" to match "${token.pattern}", but got "${segment}"`);
                path += token.prefix + segment + token.suffix;
                continue;
            }
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (optional) continue;
            const typeOfMessage = repeat ? 'an array' : 'a string';
            throw new TypeError(`Expected "${token.name}" to be ${typeOfMessage}`);
        }
        return path;
    };
}
function $74fcb440cd5f8abc$export$4659b591c19bdf3d(str, options) {
    const keys = [];
    const re = $74fcb440cd5f8abc$export$71304158c7e35877(str, keys, options);
    return $74fcb440cd5f8abc$export$968e97c88708237a(re, keys, options);
}
function $74fcb440cd5f8abc$export$968e97c88708237a(re, keys, options = {}) {
    const { decode: decode = (x)=>x } = options;
    return function(pathname) {
        const m = re.exec(pathname);
        if (!m) return false;
        const { 0: path, index: index } = m;
        const params = Object.create(null);
        for(let i = 1; i < m.length; i++){
            // eslint-disable-next-line no-continue -- ERROR TO BE FIXED
            if (m[i] === undefined) continue;
            const key = keys[i - 1];
            if (key.modifier === '*' || key.modifier === '+') params[key.name] = m[i].split(key.prefix + key.suffix).map((value)=>decode(value, key));
            else params[key.name] = decode(m[i], key);
        }
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $74fcb440cd5f8abc$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, '\\$1');
}
/**
 * Get the flags for a regexp from the options.
 */ function $74fcb440cd5f8abc$var$flags(options) {
    return options && options.sensitive ? '' : 'i';
}
/**
 * Pull out keys from a regexp.
 */ function $74fcb440cd5f8abc$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    const groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    let index = 0;
    let execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: '',
            suffix: '',
            modifier: '',
            pattern: ''
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $74fcb440cd5f8abc$var$arrayToRegexp(paths, keys, options) {
    const parts = paths.map((path)=>$74fcb440cd5f8abc$export$71304158c7e35877(path, keys, options).source);
    return new RegExp(`(?:${parts.join('|')})`, $74fcb440cd5f8abc$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $74fcb440cd5f8abc$var$stringToRegexp(path, keys, options) {
    return $74fcb440cd5f8abc$export$9a9303716def6456($74fcb440cd5f8abc$export$98e6a39c04603d36(path, options), keys, options);
}
function $74fcb440cd5f8abc$export$9a9303716def6456(tokens, keys, options = {}) {
    const { strict: strict = false, start: start = true, end: end = true, encode: encode = (x)=>x, delimiter: delimiter = '/#?', endsWith: endsWith = '' } = options;
    const endsWithRe = `[${$74fcb440cd5f8abc$var$escapeString(endsWith)}]|$`;
    const delimiterRe = `[${$74fcb440cd5f8abc$var$escapeString(delimiter)}]`;
    let route = start ? '^' : '';
    // Iterate over the tokens and create our regexp string.
    for (const token of tokens)if (typeof token === 'string') route += $74fcb440cd5f8abc$var$escapeString(encode(token));
    else {
        const prefix = $74fcb440cd5f8abc$var$escapeString(encode(token.prefix));
        const suffix = $74fcb440cd5f8abc$var$escapeString(encode(token.suffix));
        if (token.pattern) {
            if (keys) keys.push(token);
            if (prefix || suffix) {
                if (token.modifier === '+' || token.modifier === '*') {
                    const mod = token.modifier === '*' ? '?' : '';
                    route += `(?:${prefix}((?:${token.pattern})(?:${suffix}${prefix}(?:${token.pattern}))*)${suffix})${mod}`;
                } else route += `(?:${prefix}(${token.pattern})${suffix})${token.modifier}`;
            } else if (token.modifier === '+' || token.modifier === '*') route += `((?:${token.pattern})${token.modifier})`;
            else route += `(${token.pattern})${token.modifier}`;
        } else route += `(?:${prefix}${suffix})${token.modifier}`;
    }
    if (end) {
        if (!strict) route += `${delimiterRe}?`;
        route += !options.endsWith ? '$' : `(?=${endsWithRe})`;
    } else {
        const endToken = tokens[tokens.length - 1];
        const isEndDelimited = typeof endToken === 'string' ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += `(?:${delimiterRe}(?=${endsWithRe}))?`;
        if (!isEndDelimited) route += `(?=${delimiterRe}|${endsWithRe})`;
    }
    return new RegExp(route, $74fcb440cd5f8abc$var$flags(options));
}
function $74fcb440cd5f8abc$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $74fcb440cd5f8abc$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $74fcb440cd5f8abc$var$arrayToRegexp(path, keys, options);
    return $74fcb440cd5f8abc$var$stringToRegexp(path, keys, options);
}

});


parcelRegister("881dx", function(module, exports) {
$parcel$export(module.exports, "generatePath", () => $5c36781fa8b20a4a$export$82476f982757e71e);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ed9tH = parcelRequire("ed9tH");
const $5c36781fa8b20a4a$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $ed9tH.compile)(pattern)(params);

});

parcelRegister("8ovy4", function(module, exports) {
$parcel$export(module.exports, "isServerEnvironment", () => $21b9e50de4e4eb48$export$455cc18296abe008);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ /**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $gIMgJ = parcelRequire("gIMgJ");
const $21b9e50de4e4eb48$var$isJsDomEnvironment = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.name === 'nodejs' || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('Node.js') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    navigator?.userAgent.includes('jsdom');
const $21b9e50de4e4eb48$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $gIMgJ !== 'undefined' && $gIMgJ.versions != null && $gIMgJ.versions.node != null) return true;
    if ($21b9e50de4e4eb48$var$isJsDomEnvironment()) return true;
    return false;
};

});

parcelRegister("fJ5g0", function(module, exports) {
$parcel$export(module.exports, "warmupMatchRouteCache", () => $512b8cf5d0746c03$export$4e76f1d455ef7c95);
$parcel$export(module.exports, "default", () => $512b8cf5d0746c03$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $aP7R5 = parcelRequire("aP7R5");

var $htgYP = parcelRequire("htgYP");
const $512b8cf5d0746c03$var$isLegacyRoutes = (routes)=>{
    // a naive way to check if the routes are legacy routes
    return routes[routes.length - 1]?.name === 'legacy-fallback';
};
const $512b8cf5d0746c03$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $512b8cf5d0746c03$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $aP7R5.default) : (0, $htgYP.default);
    return matchRoute(routes, pathname, queryParams, basePath);
};
const $512b8cf5d0746c03$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    // no need to check legacy routes because `warmupMatchRouteCache` is used for SPA only
    return (0, $aP7R5.default)([
        route
    ], pathname, queryParams, basePath);
};
const $512b8cf5d0746c03$var$defaultMatchRoute = (routes, pathname, queryParams, basePath = '')=>{
    const useOrderIndependentMatching = $512b8cf5d0746c03$var$isLegacyRoutes(routes) === false;
    const matchRoute = useOrderIndependentMatching ? (0, $aP7R5.default) : (0, $htgYP.default);
    const matchedRoute = matchRoute(routes, pathname, queryParams, basePath);
    return matchedRoute;
};
var $512b8cf5d0746c03$export$2e2bcd8739ae039 = $512b8cf5d0746c03$var$defaultMatchRoute;

});
parcelRegister("aP7R5", function(module, exports) {
$parcel$export(module.exports, "default", () => $b7b6d2f04ade0285$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $h1u5s = parcelRequire("h1u5s");

var $5rc2K = parcelRequire("5rc2K");

var $cF0jI = parcelRequire("cF0jI");
const $b7b6d2f04ade0285$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const cachedMatch = (0, $cF0jI.matchRouteCache).get(pathname, queryParams, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    const matchedRoute = (0, $h1u5s.default)(routes, pathname, queryParams, basePath);
    if (!matchedRoute) return null;
    (0, $5rc2K.default)(matchedRoute.route);
    (0, $cF0jI.matchRouteCache).set(pathname, queryParams, basePath, matchedRoute);
    return matchedRoute;
};
var $b7b6d2f04ade0285$export$2e2bcd8739ae039 = $b7b6d2f04ade0285$var$matchRoute;

});
parcelRegister("5rc2K", function(module, exports) {
$parcel$export(module.exports, "default", () => $2529d0eb7ff47b0f$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ const $2529d0eb7ff47b0f$var$deduplicateResources = (route)=>{
    // Apply resource de-duping to the route
    if ('resources' in route && Array.isArray(route.resources)) Object.assign(route, {
        resources: [
            ...new Set(route.resources)
        ]
    });
};
const $2529d0eb7ff47b0f$var$extractlazyOpts = (route)=>{
    if ('lazyOpts' in route && typeof route.lazyOpts === 'function') {
        const opts = route.lazyOpts();
        Object.assign(route, opts);
        // eslint-disable-next-line no-param-reassign
        delete route.lazyOpts;
    }
};
// This function mutates the route object by applying a series of transformations.
// such as deduplicating resources
// and calling the lazyOpts function to extract the lazy options and apply them to the route.
// (This is to defer the evaluation of the lazy options until the route is actually matched)
const $2529d0eb7ff47b0f$var$unsafeMutateRoute = (route)=>{
    // make sure `extractlazyOpts` is called before `deduplicateResources`
    // because `resources` is a lazy option
    [
        $2529d0eb7ff47b0f$var$extractlazyOpts,
        $2529d0eb7ff47b0f$var$deduplicateResources
    ].forEach((fn)=>fn(route));
};
var $2529d0eb7ff47b0f$export$2e2bcd8739ae039 = $2529d0eb7ff47b0f$var$unsafeMutateRoute;

});

parcelRegister("cF0jI", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $45f1767341a168f4$export$f594abf16a5ad948);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $45f1767341a168f4$var$MAX_CACHE_SIZE = 1000;
function $45f1767341a168f4$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $45f1767341a168f4$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($45f1767341a168f4$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $45f1767341a168f4$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $45f1767341a168f4$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});


parcelRegister("htgYP", function(module, exports) {
$parcel$export(module.exports, "default", () => $c1c9c05c3c55e6a4$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $5rc2K = parcelRequire("5rc2K");

var $4kbLP = parcelRequire("4kbLP");

var $6Xv1M = parcelRequire("6Xv1M");
/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $c1c9c05c3c55e6a4$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $21iIq.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $6Xv1M.matchRouteCache).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $4kbLP.default)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $5rc2K.default)(matchedRoute.route);
            (0, $6Xv1M.matchRouteCache).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $c1c9c05c3c55e6a4$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>{
    return $c1c9c05c3c55e6a4$var$matchRoute(routes, pathname, queryParams, basePath);
};
const $c1c9c05c3c55e6a4$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    return $c1c9c05c3c55e6a4$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $c1c9c05c3c55e6a4$export$2e2bcd8739ae039 = $c1c9c05c3c55e6a4$var$matchRoute;

});
parcelRegister("4kbLP", function(module, exports) {
$parcel$export(module.exports, "default", () => $7dfc273787596f78$export$2e2bcd8739ae039);
/* eslint-disable jira/filename-case */ 
var $1lTTX = parcelRequire("1lTTX");

var $gcMkE = parcelRequire("gcMkE");
/* This should match what react-router does to compute a root match. */ const $7dfc273787596f78$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $7dfc273787596f78$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $1lTTX.default)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $7dfc273787596f78$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $gcMkE.default)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = {
        ...pathMatch,
        query: {}
    };
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $7dfc273787596f78$export$2e2bcd8739ae039 = $7dfc273787596f78$var$execRouteMatching;

});
parcelRegister("1lTTX", function(module, exports) {
$parcel$export(module.exports, "default", () => $9bb4fbb322d32a69$export$2e2bcd8739ae039);
// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

var $gXtG2 = parcelRequire("gXtG2");

var $ed9tH = parcelRequire("ed9tH");
const $9bb4fbb322d32a69$var$cache = {};
const $9bb4fbb322d32a69$var$cacheLimit = 10000;
let $9bb4fbb322d32a69$var$cacheCount = 0;
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $9bb4fbb322d32a69$var$cacheCount = 0;
});
function $9bb4fbb322d32a69$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $9bb4fbb322d32a69$var$cache[cacheKey] || ($9bb4fbb322d32a69$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $ed9tH.pathToRegexp)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($9bb4fbb322d32a69$var$cacheCount < $9bb4fbb322d32a69$var$cacheLimit) {
        pathCache[path] = result;
        $9bb4fbb322d32a69$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $9bb4fbb322d32a69$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) // eslint-disable-next-line no-param-reassign
    options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $9bb4fbb322d32a69$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            url: path === '/' && url === '' ? '/' : url,
            isExact: isExact,
            params: keys.reduce((memo, key, index)=>{
                // eslint-disable-next-line no-param-reassign
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $9bb4fbb322d32a69$export$2e2bcd8739ae039 = $9bb4fbb322d32a69$var$matchPath;

});

parcelRegister("gcMkE", function(module, exports) {
$parcel$export(module.exports, "default", () => $2f1901969c5b75a1$export$2e2bcd8739ae039);
/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $2f1901969c5b75a1$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? {
        ...pathMatch,
        query: queryMatch
    } : null;
}
var $2f1901969c5b75a1$export$2e2bcd8739ae039 = $2f1901969c5b75a1$var$matchQuery;

});


parcelRegister("6Xv1M", function(module, exports) {
$parcel$export(module.exports, "matchRouteCache", () => $4c8d4002cfbdfdd4$export$f594abf16a5ad948);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4c8d4002cfbdfdd4$var$MAX_CACHE_SIZE = 1000;
function $4c8d4002cfbdfdd4$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!Object.hasOwn(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $4c8d4002cfbdfdd4$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($4c8d4002cfbdfdd4$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $4c8d4002cfbdfdd4$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $4c8d4002cfbdfdd4$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};

});



parcelRegister("7bJ0J", function(module, exports) {
$parcel$export(module.exports, "createRouterContext", () => $02576752114f9c49$export$faed15f35ddc6f99);
$parcel$export(module.exports, "findRouterContext", () => $02576752114f9c49$export$a0bd0313cbeabd49);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $j02zx = parcelRequire("j02zx");

var $881dx = parcelRequire("881dx");

var $fJ5g0 = parcelRequire("fJ5g0");
const $02576752114f9c49$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $881dx.generatePath)(route.path, params);
    const matchedRoute = (0, $fJ5g0.default)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $j02zx.DEFAULT_MATCH),
        query: query
    };
};
const $02576752114f9c49$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $21iIq.qs).parse(search);
    const matchedRoute = (0, $fJ5g0.default)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $j02zx.DEFAULT_ROUTE),
        match: matchedRoute ? matchedRoute.match : (0, $j02zx.DEFAULT_MATCH)
    };
};

});

parcelRegister("eaaiA", function(module, exports) {
$parcel$export(module.exports, "isExternalAbsolutePath", () => $52d403988618a6af$export$2fa6dede99f181e5);
$parcel$export(module.exports, "getRelativePath", () => $52d403988618a6af$export$ae9fda833d91ed65);
$parcel$export(module.exports, "updateQueryParams", () => $52d403988618a6af$export$92377f461a797888);
$parcel$export(module.exports, "getRelativeURLFromLocation", () => $52d403988618a6af$export$9ae1c7c875ef309d);
$parcel$export(module.exports, "shouldReload", () => $52d403988618a6af$export$c9237620ff7fdf7c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $21iIq = parcelRequire("21iIq");

var $8RInu = parcelRequire("8RInu");
const $52d403988618a6af$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $52d403988618a6af$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : `/${path}`;
const $52d403988618a6af$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        // eslint-disable-next-line no-param-reassign
        prefix = $52d403988618a6af$var$stripTrailingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        prefix = $52d403988618a6af$var$addLeadingSlash(prefix);
        // eslint-disable-next-line no-param-reassign
        path = $52d403988618a6af$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $52d403988618a6af$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $52d403988618a6af$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$52d403988618a6af$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(path).hostname;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $52d403988618a6af$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$52d403988618a6af$export$e83e3719fc818ee5(path)) {
        // eslint-disable-next-line no-param-reassign
        path = $52d403988618a6af$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($21iIq)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $52d403988618a6af$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $21iIq.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $52d403988618a6af$export$9ae1c7c875ef309d = (location)=>`${location.pathname}${location.search}${location.hash}`;
const $52d403988618a6af$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $8RInu.isSameRouteMatch)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};

});
parcelRegister("8RInu", function(module, exports) {
$parcel$export(module.exports, "isSameRouteMatch", () => $fde6b2b05f934f07$export$5997e70fc4543270);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $fde6b2b05f934f07$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $fde6b2b05f934f07$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $fde6b2b05f934f07$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $fde6b2b05f934f07$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);

});



parcelRegister("7edbf", function(module, exports) {
$parcel$export(module.exports, "createResource", () => $7ae836fb8cae26cf$export$edd172c6c83c39cc);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
const $7ae836fb8cae26cf$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $7ae836fb8cae26cf$export$edd172c6c83c39cc = (arg)=>({
        type: arg.type,
        getKey: arg.getKey,
        getData: arg.getData ?? $7ae836fb8cae26cf$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $d0b0f317b4f60123$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $d0b0f317b4f60123$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34),
        skipBrowser: typeof arg.skipBrowser === 'boolean' ? arg.skipBrowser : (0, $d0b0f317b4f60123$export$f267d0e9ab3eb265),
        depends: arg.depends ?? null,
        isCritical: typeof arg.isCritical === 'boolean' ? arg.isCritical : (0, $d0b0f317b4f60123$export$c6d9b82b8528dcc3)
    });

});
/* eslint-disable jira/filename-case */ const $d0b0f317b4f60123$export$881d135f98d8d7d0 = 100;
const $d0b0f317b4f60123$export$9ab5bdcb8a1d6c34 = false;
const $d0b0f317b4f60123$export$f267d0e9ab3eb265 = false;
const $d0b0f317b4f60123$export$12c1dc38ea1692da = 0;
const $d0b0f317b4f60123$export$c6d9b82b8528dcc3 = false;


parcelRegister("k6ufm", function(module, exports) {
$parcel$export(module.exports, "useResourceBase", () => $ac93b03de8ee9e17$export$2bfcb6c1e4488bac);
$parcel$export(module.exports, "useResource", () => $ac93b03de8ee9e17$export$9f6abfd74295843b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");

var $f2wVS = parcelRequire("f2wVS");

var $bYonX = parcelRequire("bYonX");

var $fiU0I = parcelRequire("fiU0I");
const $ac93b03de8ee9e17$export$2bfcb6c1e4488bac = (resource, options)=>{
    const actions = (0, $bYonX.useResourceStoreActions)();
    const { getContext: getRouterContext } = (0, $f2wVS.useRouterStoreActions)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $euxye.useMemo)(()=>(0, $3h1FP.createHook)((0, $f2wVS.RouterStore), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    const key = useKey(options?.routerContext)[0];
    const [slice] = (0, $bYonX.useResourceStore)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $euxye.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain, @typescript-eslint/no-non-null-assertion
    ()=>options?.routerContext || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $euxye.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $euxye.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $euxye.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $euxye.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, $euxye.useMemo)(()=>({
            ...slice,
            update: update,
            key: key,
            refresh: refresh,
            clear: clear,
            clearAll: clearAll
        }), [
        clear,
        clearAll,
        key,
        refresh,
        slice,
        update
    ]);
};
const $ac93b03de8ee9e17$export$e5bcff138e5b419e = (resource, options)=>{
    const state = $ac93b03de8ee9e17$export$2bfcb6c1e4488bac(resource, options);
    const { loading: loading, promise: promise } = state;
    if (loading && promise != null) throw promise;
    return state;
};
const $ac93b03de8ee9e17$export$9f6abfd74295843b = (resource, options)=>{
    return (0, $fiU0I.defaultConfiguration).streaming ? $ac93b03de8ee9e17$export$e5bcff138e5b419e(resource, options) : $ac93b03de8ee9e17$export$2bfcb6c1e4488bac(resource, options);
};

});
parcelRegister("bYonX", function(module, exports) {
$parcel$export(module.exports, "getResourceStore", () => $ba502d5e861eff92$export$6f6057d42352becb);
$parcel$export(module.exports, "useResourceStore", () => $ba502d5e861eff92$export$ac3608e0bb357c7);
$parcel$export(module.exports, "useResourceStoreActions", () => $ba502d5e861eff92$export$98e41a62c9bef75e);
$parcel$export(module.exports, "useResourceStoreContext", () => $ba502d5e861eff92$export$e59f52df235ac7b3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3h1FP = parcelRequire("3h1FP");
var $dB6ay = parcelRequire("dB6ay");
var $5QDqc = parcelRequire("5QDqc");
var $iGu4q = parcelRequire("iGu4q");
var $ciIbx = parcelRequire("ciIbx");

var $8ovy4 = parcelRequire("8ovy4");

var $iTrvS = parcelRequire("iTrvS");

var $gjZbp = parcelRequire("gjZbp");

var $7F2m5 = parcelRequire("7F2m5");

var $hmSNA = parcelRequire("hmSNA");

var $kPP7T = parcelRequire("kPP7T");

var $5FNys = parcelRequire("5FNys");

var $k4Pr4 = parcelRequire("k4Pr4");

var $9xwjK = parcelRequire("9xwjK");

var $9y7DN = parcelRequire("9y7DN");

var $bSWZq = parcelRequire("bSWZq");

var $9SL7p = parcelRequire("9SL7p");

var $44wUW = parcelRequire("44wUW");

var $4v7LS = parcelRequire("4v7LS");

const $ba502d5e861eff92$export$3f1be494d407b77a = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $9xwjK.deleteResourceState)(type, key));
                dispatch((0, $hmSNA.executeForDependents)(resource, (dependentResource)=>$ba502d5e861eff92$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $9xwjK.deleteResourceState)(type));
        },
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context, ...resourceStoreState } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $iTrvS.getSliceForResource)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = {
                ...prevSlice,
                ...changes,
                expiresAt: (0, $kPP7T.getExpiresAt)(maxAge),
                accessedAt: (0, $gjZbp.getAccessedAt)()
            };
            dispatch((0, $9xwjK.setResourceState)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $hmSNA.executeForDependents)(resource, (dependentResource)=>$ba502d5e861eff92$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $9xwjK.getResourceState)(type, key));
            if (cached && (0, $bSWZq.shouldUseCache)(cached)) {
                if ((0, $bSWZq.isFromSsr)(cached)) {
                    const withResolvedPromise = (0, $9SL7p.setSsrDataPromise)(cached);
                    cached = (0, $kPP7T.setExpiresAt)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $gjZbp.getAccessedAt)();
                dispatch((0, $9xwjK.setResourceState)(type, key, cached));
                return cached;
            }
            return dispatch($ba502d5e861eff92$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
	 * Request a single resource and update the resource cache.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $9xwjK.getResourceState)(type, key)) || (0, $5FNys.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $k4Pr4.validateLRUCache)(resource, key));
            let loadingSlice = dispatch((0, $9xwjK.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $7F2m5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $hmSNA.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $9xwjK.setResourceState)(type, key, {
                    ...prevSlice,
                    ...loadingSlice,
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $gjZbp.getAccessedAt)()
                }));
                // trigger dependent resources to also load
                dispatch((0, $hmSNA.executeForDependents)(resource, (dependentResource)=>$ba502d5e861eff92$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    const data = loadingSlice.data ?? await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $44wUW.TimeoutError)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        promise: null
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $9xwjK.getResourceState)(type, key));
            const finalSlice = {
                ...recentSlice || prevSlice,
                ...resolvedSlice,
                accessedAt: (0, $gjZbp.getAccessedAt)(),
                expiresAt: (0, $kPP7T.getExpiresAt)(maxAge)
            };
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $9xwjK.setResourceState)(type, key, finalSlice));
            return finalSlice;
        },
    /**
	 * Prefetch a single resource and store in the prefetch cache.
	 */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $9xwjK.getResourceState)(type, key)) || (0, $5FNys.getDefaultStateSlice)();
            // abort request if already in flight
            if (prevSlice.loading) return;
            if (prevSlice.data && prevSlice.expiresAt && prevSlice.expiresAt > Date.now()) // if the resource is not expired, return the current data
            return;
            let loadingSlice = dispatch((0, $9xwjK.getPrefetchSlice)(type, key));
            if (!loadingSlice) loadingSlice = (0, $7F2m5.createLoadingSlice)({
                context: context,
                dependencies: ()=>dispatch((0, $hmSNA.getDependencies)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependents
            dispatch((0, $9xwjK.setPrefetchSlice)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $hmSNA.executeForDependents)(resource, (dependentResource)=>$ba502d5e861eff92$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $ba502d5e861eff92$export$e324594224ef24da = {
    /**
	 * Clears a resource for the current key, or where context is not provided all keys.
	 * Execute such that dependencies on current route will be cleared.
	 */ clearResource: (resource, routerStoreContext)=>(0, $hmSNA.actionWithDependencies)(routerStoreContext?.route?.resources, resource, $ba502d5e861eff92$export$3f1be494d407b77a.clearResource(resource, routerStoreContext ?? null)),
    /**
	 * Update the data property for a resource in the cache and reset expiresAt based
	 * on maxAge.
	 * Execute such that dependencies on current route will be updated.
	 */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $hmSNA.actionWithDependencies)(routerStoreContext.route.resources, resource, $ba502d5e861eff92$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
	 * Get a single resource, either from the cache if it exists and has not expired, or
	 * the remote if it has expired.
	 * Execute such that dependencies on current route will be updated.
	 */ getResource: (resource, routerStoreContext, options)=>(0, $hmSNA.actionWithDependencies)(routerStoreContext.route.resources, resource, $ba502d5e861eff92$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
	 * Request a single resource and update the resource cache.
	 * Execute such that dependencies on current route will be updated.
	 */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $hmSNA.actionWithDependencies)(routerStoreContext.route.resources, resource, $ba502d5e861eff92$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
	 * Request all resources.
	 */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($ba502d5e861eff92$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
	 * Cleans expired resources and resets them back to their initial state.
	 * We need to do this when transitioning into a route.
	 */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $9xwjK.getResourceState)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $9xwjK.deleteResourceState)(type, key));
            });
        },
    /**
	 * Requests a specific set of resources.
	 */ requestResources: (resources, routerStoreContext, options)=>{
        const { onlyGetCritical: onlyGetCritical } = options;
        const predicate = (0, $8ovy4.isServerEnvironment)() ? ({ isBrowserOnly: isBrowserOnly, isCritical: isCritical })=>{
            if (isBrowserOnly) return false;
            /*
					 * Cookie circuit breaker logic - when cookie circuit breaker is OPEN we pass
					 * the onlyGetCritical parameter so that the request doesn't time out
					 * */ // resource is critical, always return
            if (isCritical) return true;
            // resource is not critical and onlyGetCritical option has been passed
            if (onlyGetCritical) return false;
            return true;
        } : ({ skipBrowser: skipBrowser })=>!skipBrowser;
        return (0, $hmSNA.mapActionWithDependencies)(routerStoreContext.route.resources?.filter(predicate), resources.filter(predicate), (resource)=>$ba502d5e861eff92$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
	 * Prefetch a specific set of resources.
	 */ prefetchResources: (resources, routerStoreContext, options)=>(0, $hmSNA.mapActionWithDependencies)(routerStoreContext.route.resources, resources, (resource)=>$ba502d5e861eff92$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, {
                ...options,
                prefetch: true
            })),
    /**
	 * Hydrates the store with state.
	 * Will not override pre-hydrated state.
	 */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $4v7LS.transformData)(getNextStateValue(data, resourceData), ({ error: error, expiresAt: expiresAt, loading: loading, ...rest })=>{
                const deserializedError = !error ? null : (0, $9y7DN.deserializeError)(error);
                const isTimeoutError = deserializedError?.name === 'TimeoutError';
                return {
                    ...rest,
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                };
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
	 * Gets the store's context
	 */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
	 * Returns safe, portable and rehydratable data.
	 */ getSafeData: ()=>({ getState: getState })=>(0, $4v7LS.transformData)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $9y7DN.serializeError)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $44wUW.TimeoutError) ? loading : false
                }))
};
const $ba502d5e861eff92$export$94f50dade551bd01 = (0, $5QDqc.createStore)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $ba502d5e861eff92$export$e324594224ef24da,
    name: 'router-resources'
});
const $ba502d5e861eff92$export$cc90fb9c37c5589d = (0, $dB6ay.createContainer)($ba502d5e861eff92$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $ba502d5e861eff92$export$fee1a6213543bd78 = (0, $iGu4q.createSubscriber)($ba502d5e861eff92$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $iTrvS.getSliceForResource)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $ba502d5e861eff92$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $ciIbx.defaultRegistry).getStore($ba502d5e861eff92$export$94f50dade551bd01);
const $ba502d5e861eff92$export$ac3608e0bb357c7 = (0, $3h1FP.createHook)($ba502d5e861eff92$export$94f50dade551bd01, {
    selector: (0, $iTrvS.getSliceForResource)
});
const $ba502d5e861eff92$export$98e41a62c9bef75e = (0, $3h1FP.createActionsHook)($ba502d5e861eff92$export$94f50dade551bd01);
const $ba502d5e861eff92$export$e59f52df235ac7b3 = (0, $3h1FP.createHook)($ba502d5e861eff92$export$94f50dade551bd01, {
    selector: (0, $iTrvS.getResourceStoreContext)
});

});
parcelRegister("iTrvS", function(module, exports) {
$parcel$export(module.exports, "getSliceForResource", () => $ad6d0942a8110be9$export$c9ed509724feb827);
$parcel$export(module.exports, "getResourceStoreContext", () => $ad6d0942a8110be9$export$6a0b1779210de0ee);
/* eslint-disable jira/filename-case */ 
var $5FNys = parcelRequire("5FNys");
const $ad6d0942a8110be9$var$defaultStateSlice = (0, $5FNys.getDefaultStateSlice)();
const $ad6d0942a8110be9$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    // The return of this needs to be stable object references - no cloning/spreading or new objects
    // otherwise it will cause re-renders in components that use this selector
    return slice || $ad6d0942a8110be9$var$defaultStateSlice;
};
const $ad6d0942a8110be9$export$6a0b1779210de0ee = (state)=>state.context;

});
parcelRegister("5FNys", function(module, exports) {
$parcel$export(module.exports, "getDefaultStateSlice", () => $3009a3b2cb8e8fd0$export$fa8e33c3301e2e94);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $gjZbp = parcelRequire("gjZbp");


var $kPP7T = parcelRequire("kPP7T");

var $1pZJz = parcelRequire("1pZJz");
const $3009a3b2cb8e8fd0$export$fa8e33c3301e2e94 = ()=>({
        ...(0, $1pZJz.BASE_DEFAULT_STATE_SLICE),
        expiresAt: (0, $kPP7T.getExpiresAt)((0, $d0b0f317b4f60123$export$12c1dc38ea1692da)),
        accessedAt: (0, $gjZbp.getAccessedAt)()
    });

});
parcelRegister("gjZbp", function(module, exports) {
$parcel$export(module.exports, "getAccessedAt", () => $f75c02f169f2c431$export$9ccb639b7a119f61);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $f75c02f169f2c431$export$9ccb639b7a119f61 = ()=>Date.now();

});

parcelRegister("kPP7T", function(module, exports) {
$parcel$export(module.exports, "getExpiresAt", () => $7ef321a71c6398c3$export$b65d7ba7fbf150f1);
$parcel$export(module.exports, "setExpiresAt", () => $7ef321a71c6398c3$export$18d1d420fd588368);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $7ef321a71c6398c3$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $7ef321a71c6398c3$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? {
        ...slice,
        expiresAt: $7ef321a71c6398c3$export$b65d7ba7fbf150f1(maxAge)
    } : slice;

});

parcelRegister("1pZJz", function(module, exports) {
$parcel$export(module.exports, "BASE_DEFAULT_STATE_SLICE", () => $a9463be3505cff08$export$2df85a734ff5ed27);
/* eslint-disable jira/filename-case */ /**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $a9463be3505cff08$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};

});



parcelRegister("7F2m5", function(module, exports) {
$parcel$export(module.exports, "createLoadingSlice", () => $893540ec78ffa639$export$dc62515c8f0b52dd);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $ldgHZ = parcelRequire("ldgHZ");


var $kPP7T = parcelRequire("kPP7T");

var $jIarP = parcelRequire("jIarP");

var $44wUW = parcelRequire("44wUW");

var $lnmKX = parcelRequire("lnmKX");
function $893540ec78ffa639$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout, abortSignal: abortSignal } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData({
            ...routerStoreContext,
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }, context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $jIarP.generateTimeGuard)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof promiseOrData?.then === 'function' ? undefined : promiseOrData;
    let promise;
    if ((0, $ldgHZ.isStreamingEnabled)()) {
        // New logic also supports using abortSignal
        if (data !== undefined) // Data is sync, short-circuit resolve
        promise = Promise.resolve(data);
        else if (timeout === undefined && abortSignal === undefined) promise = promiseOrData;
        else promise = new Promise((resolve, reject)=>{
            const rejectWithTimeout = ()=>{
                reject(new (0, $44wUW.TimeoutError)(type));
                cleanup();
            };
            const cleanup = ()=>{
                if (timeoutGuard?.timerId) clearTimeout(timeoutGuard.timerId);
                if (abortSignal) abortSignal.removeEventListener('abort', rejectWithTimeout);
            };
            // Wrap with `Promise.resolve` to ensure is a promise
            Promise.resolve(promiseOrData).then(resolve, reject).then(cleanup, cleanup);
            if (timeoutGuard?.promise) timeoutGuard.promise.then(rejectWithTimeout);
            if (abortSignal) // Reuse same `TimeoutError` as timeout option, assuming that's the only use case for aborts
            abortSignal.addEventListener('abort', rejectWithTimeout);
        });
    } else // eslint-disable-next-line no-nested-ternary
    promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard?.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $44wUW.TimeoutError)(type);
        timeoutGuard?.timerId && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $kPP7T.getExpiresAt)(resource.maxAge ?? (0, $d0b0f317b4f60123$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $kPP7T.getExpiresAt)((0, $lnmKX.DEFAULT_PREFETCH_MAX_AGE))) : resourceMaxAge
    };
}

});
parcelRegister("ldgHZ", function(module, exports) {
$parcel$export(module.exports, "enableStreamingAdvisory", () => $957ebed03dcb1cde$export$18c866616dc0241c);
$parcel$export(module.exports, "isStreamingEnabled", () => $957ebed03dcb1cde$export$3f75873cbcd8557a);
$parcel$export(module.exports, "isStreamingAdvisoryEnabled", () => $957ebed03dcb1cde$export$86c6643260cd67d);

var $gXtG2 = parcelRequire("gXtG2");
const $957ebed03dcb1cde$var$DEFAULT_STATE = {
    enabled: false,
    enableAdvisory: false
};
let $957ebed03dcb1cde$var$state = Object.freeze($957ebed03dcb1cde$var$DEFAULT_STATE);
(0, $gXtG2.autoBeforeEachTest)(()=>{
    $957ebed03dcb1cde$var$state = $957ebed03dcb1cde$var$DEFAULT_STATE;
});
const $957ebed03dcb1cde$export$2d734bcb210e1a75 = ()=>{
    if ($957ebed03dcb1cde$var$state.enabled) throw new Error('Enable Streaming: Streaming already enabled');
    $957ebed03dcb1cde$var$state = {
        ...$957ebed03dcb1cde$var$state,
        enabled: true
    };
};
const $957ebed03dcb1cde$export$18c866616dc0241c = ()=>{
    if ($957ebed03dcb1cde$var$state.enableAdvisory) throw new Error('Enable Streaming Advisory: Streaming Advisory already enabled');
    $957ebed03dcb1cde$var$state = {
        ...$957ebed03dcb1cde$var$state,
        enableAdvisory: true
    };
};
const $957ebed03dcb1cde$export$3f75873cbcd8557a = ()=>{
    return $957ebed03dcb1cde$var$state.enabled;
};
const $957ebed03dcb1cde$export$86c6643260cd67d = ()=>{
    return $957ebed03dcb1cde$var$state.enableAdvisory;
};

});

parcelRegister("jIarP", function(module, exports) {
$parcel$export(module.exports, "generateTimeGuard", () => $0341428be295da17$export$58634b3a58ae66b7);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $0341428be295da17$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};

});

parcelRegister("44wUW", function(module, exports) {
$parcel$export(module.exports, "TimeoutError", () => $0cfdc55e257f5f70$export$66d311bf29d5c89c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ class $0cfdc55e257f5f70$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(`Resource timed out: ${message}`);
        this.name = 'TimeoutError';
    }
}
$0cfdc55e257f5f70$export$66d311bf29d5c89c.displayName = "TimeoutError";

});

parcelRegister("lnmKX", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_PREFETCH_MAX_AGE", () => $f80ba889a7762d98$export$37d3126be6549b13);
/* eslint-disable jira/filename-case */ const $f80ba889a7762d98$export$37d3126be6549b13 = 10000;

});


parcelRegister("hmSNA", function(module, exports) {
$parcel$export(module.exports, "ResourceDependencyError", () => $8836e53e6b2cd9ef$export$492ad57edfe1e919);
$parcel$export(module.exports, "actionWithDependencies", () => $8836e53e6b2cd9ef$export$5f7e1fd85734e71e);
$parcel$export(module.exports, "mapActionWithDependencies", () => $8836e53e6b2cd9ef$export$f71a65c89c987a02);
$parcel$export(module.exports, "executeForDependents", () => $8836e53e6b2cd9ef$export$7d1ffac63c68405d);
$parcel$export(module.exports, "getDependencies", () => $8836e53e6b2cd9ef$export$75915f81f2a6540a);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $5FNys = parcelRequire("5FNys");

var $9xwjK = parcelRequire("9xwjK");
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $8836e53e6b2cd9ef$var$fromEntries = Object.fromEntries ?? ((entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        }))));
const $8836e53e6b2cd9ef$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $8836e53e6b2cd9ef$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
$8836e53e6b2cd9ef$export$492ad57edfe1e919.displayName = "ResourceDependencyError";
const $8836e53e6b2cd9ef$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = routeResources?.some(({ depends: depends })=>depends?.length) ?? false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources?.some($8836e53e6b2cd9ef$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!depends?.some((dependency)=>executableTypes.includes(dependency));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>{
            if (depends) acc.push(...depends);
            acc.push(type);
            return acc;
        }, []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>tuples.find($8836e53e6b2cd9ef$var$matchType(resource)) ?? [
                resource,
                null
            ]);
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            const latestTuple = getState().executing?.[i];
            const [{ type: latestType }, maybeAction] = latestTuple ?? [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($8836e53e6b2cd9ef$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $8836e53e6b2cd9ef$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($8836e53e6b2cd9ef$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $8836e53e6b2cd9ef$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$8836e53e6b2cd9ef$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $8836e53e6b2cd9ef$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = tuples?.findIndex($8836e53e6b2cd9ef$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        const executing = tuples.map((tuple, i)=>{
            const [tupleResource] = tuple;
            return i > indexForResource && tupleResource.depends?.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $8836e53e6b2cd9ef$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!depends?.length) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = tuples?.findIndex($8836e53e6b2cd9ef$var$matchType(resource)) ?? -1;
        if (indexForResource < 0) throw new $8836e53e6b2cd9ef$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map(// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        (dependency)=>[
                dependency,
                tuples.findIndex($8836e53e6b2cd9ef$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $8836e53e6b2cd9ef$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $8836e53e6b2cd9ef$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $8836e53e6b2cd9ef$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $9xwjK.getResourceState)(dependencyType, key)) || (0, $5FNys.getDefaultStateSlice)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $9xwjK.getPrefetchSlice)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = {
                ...slice,
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            };
            return [
                dependencyType,
                slice
            ];
        }));
    };

});
parcelRegister("9xwjK", function(module, exports) {
$parcel$export(module.exports, "getPrefetchSlice", () => $17eab33cfd33e01f$export$11374758be89e40);
$parcel$export(module.exports, "setPrefetchSlice", () => $17eab33cfd33e01f$export$1e32615dc8354436);
$parcel$export(module.exports, "setResourceState", () => $17eab33cfd33e01f$export$704f800f263b050e);
$parcel$export(module.exports, "getResourceState", () => $17eab33cfd33e01f$export$5fc90c33b03fffb);
$parcel$export(module.exports, "deleteResourceState", () => $17eab33cfd33e01f$export$d40f35dc5952864b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $17eab33cfd33e01f$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        const { prefetching: prefetching } = getState();
        const slice = prefetching?.[type]?.[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $17eab33cfd33e01f$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if (prefetching?.[type]?.[key] === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice?.promise?.then((maybeData)=>{
            // eslint-disable-next-line no-param-reassign
            slice.data = maybeData;
        });
        setState({
            prefetching: {
                ...prefetching,
                [type]: {
                    ...prefetching?.[type],
                    [key]: slice
                }
            }
        });
    };
const $17eab33cfd33e01f$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($17eab33cfd33e01f$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: {
                ...data,
                [type]: {
                    ...data[type] || {},
                    [key]: state
                }
            }
        });
    };
const $17eab33cfd33e01f$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType?.[key];
    };
const $17eab33cfd33e01f$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType, ...remainingData } = data;
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const { [key]: _, ...remainingForType } = resourceForType;
            setState({
                data: {
                    ...remainingData,
                    [type]: remainingForType
                }
            });
        }
    };

});


parcelRegister("k4Pr4", function(module, exports) {
$parcel$export(module.exports, "validateLRUCache", () => $ccac3f933b21e653$export$89440b7623c2c75c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9xwjK = parcelRequire("9xwjK");
const $ccac3f933b21e653$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $ccac3f933b21e653$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $ccac3f933b21e653$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $ccac3f933b21e653$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $ccac3f933b21e653$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $9xwjK.deleteResourceState)(type, keyTobeDeleted));
    };

});

parcelRegister("9y7DN", function(module, exports) {
$parcel$export(module.exports, "serializeError", () => $e9a2c8f989835fe3$export$46ff38bc6bdea8fb);
$parcel$export(module.exports, "deserializeError", () => $e9a2c8f989835fe3$export$64cddc1e268e9046);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $e9a2c8f989835fe3$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $e9a2c8f989835fe3$var$NonError);
    }
}
$e9a2c8f989835fe3$var$NonError.displayName = "NonError";
const $e9a2c8f989835fe3$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $e9a2c8f989835fe3$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $e9a2c8f989835fe3$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $e9a2c8f989835fe3$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $e9a2c8f989835fe3$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $e9a2c8f989835fe3$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $e9a2c8f989835fe3$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $e9a2c8f989835fe3$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $e9a2c8f989835fe3$var$NonError(value);
};

});

parcelRegister("bSWZq", function(module, exports) {
$parcel$export(module.exports, "isFromSsr", () => $988214899392a41e$export$b25d2963b8a3488a);
$parcel$export(module.exports, "shouldUseCache", () => $988214899392a41e$export$399de8c43d0ece3c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $988214899392a41e$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $988214899392a41e$var$isFresh = (resource)=>{
    if ($988214899392a41e$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $988214899392a41e$export$399de8c43d0ece3c = (resource)=>{
    if (resource?.error?.name === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($988214899392a41e$var$isFresh(resource)) return true;
    return false;
};

});

parcelRegister("9SL7p", function(module, exports) {
$parcel$export(module.exports, "setSsrDataPromise", () => $e02ab9e8e11c0b82$export$2e4da1b414980956);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $e02ab9e8e11c0b82$export$2e4da1b414980956 = (slice)=>slice.promise === null ? {
        ...slice,
        promise: Promise.resolve(slice.data)
    } : slice;

});

parcelRegister("4v7LS", function(module, exports) {
$parcel$export(module.exports, "transformData", () => $504b82169432fc1d$export$3ceb62baab058c6b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $504b82169432fc1d$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});

});


parcelRegister("fiU0I", function(module, exports) {
$parcel$export(module.exports, "defaultConfiguration", () => $c9076b134397282a$export$78c0028a34264234);
const $c9076b134397282a$export$78c0028a34264234 = {
    streaming: false
};

});


parcelRegister("cpIwU", function(module, exports) {
$parcel$export(module.exports, "default", () => $909a5c800afbd0ca$export$2e2bcd8739ae039);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */ var $909a5c800afbd0ca$var$__assign = function() {
    $909a5c800afbd0ca$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $909a5c800afbd0ca$var$__assign.apply(this, arguments);
};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $909a5c800afbd0ca$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
var $909a5c800afbd0ca$var$isObject_1 = $909a5c800afbd0ca$var$isObject;
var $909a5c800afbd0ca$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
/** Detect free variable `global` from Node.js. */ var $909a5c800afbd0ca$var$freeGlobal = typeof $909a5c800afbd0ca$var$commonjsGlobal == 'object' && $909a5c800afbd0ca$var$commonjsGlobal && $909a5c800afbd0ca$var$commonjsGlobal.Object === Object && $909a5c800afbd0ca$var$commonjsGlobal;
var $909a5c800afbd0ca$var$_freeGlobal = $909a5c800afbd0ca$var$freeGlobal;
/** Detect free variable `self`. */ var $909a5c800afbd0ca$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $909a5c800afbd0ca$var$root = $909a5c800afbd0ca$var$_freeGlobal || $909a5c800afbd0ca$var$freeSelf || Function('return this')();
var $909a5c800afbd0ca$var$_root = $909a5c800afbd0ca$var$root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $909a5c800afbd0ca$var$now = function() {
    return $909a5c800afbd0ca$var$_root.Date.now();
};
var $909a5c800afbd0ca$var$now_1 = $909a5c800afbd0ca$var$now;
/** Built-in value references. */ var $909a5c800afbd0ca$var$Symbol = $909a5c800afbd0ca$var$_root.Symbol;
var $909a5c800afbd0ca$var$_Symbol = $909a5c800afbd0ca$var$Symbol;
/** Used for built-in method references. */ var $909a5c800afbd0ca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $909a5c800afbd0ca$var$hasOwnProperty = $909a5c800afbd0ca$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $909a5c800afbd0ca$var$nativeObjectToString = $909a5c800afbd0ca$var$objectProto.toString;
/** Built-in value references. */ var $909a5c800afbd0ca$var$symToStringTag = $909a5c800afbd0ca$var$_Symbol ? $909a5c800afbd0ca$var$_Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $909a5c800afbd0ca$var$getRawTag(value) {
    var isOwn = $909a5c800afbd0ca$var$hasOwnProperty.call(value, $909a5c800afbd0ca$var$symToStringTag), tag = value[$909a5c800afbd0ca$var$symToStringTag];
    try {
        value[$909a5c800afbd0ca$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $909a5c800afbd0ca$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$909a5c800afbd0ca$var$symToStringTag] = tag;
        else delete value[$909a5c800afbd0ca$var$symToStringTag];
    }
    return result;
}
var $909a5c800afbd0ca$var$_getRawTag = $909a5c800afbd0ca$var$getRawTag;
/** Used for built-in method references. */ var $909a5c800afbd0ca$var$objectProto$1 = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $909a5c800afbd0ca$var$nativeObjectToString$1 = $909a5c800afbd0ca$var$objectProto$1.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $909a5c800afbd0ca$var$objectToString(value) {
    return $909a5c800afbd0ca$var$nativeObjectToString$1.call(value);
}
var $909a5c800afbd0ca$var$_objectToString = $909a5c800afbd0ca$var$objectToString;
/** `Object#toString` result references. */ var $909a5c800afbd0ca$var$nullTag = '[object Null]', $909a5c800afbd0ca$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $909a5c800afbd0ca$var$symToStringTag$1 = $909a5c800afbd0ca$var$_Symbol ? $909a5c800afbd0ca$var$_Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $909a5c800afbd0ca$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $909a5c800afbd0ca$var$undefinedTag : $909a5c800afbd0ca$var$nullTag;
    return $909a5c800afbd0ca$var$symToStringTag$1 && $909a5c800afbd0ca$var$symToStringTag$1 in Object(value) ? $909a5c800afbd0ca$var$_getRawTag(value) : $909a5c800afbd0ca$var$_objectToString(value);
}
var $909a5c800afbd0ca$var$_baseGetTag = $909a5c800afbd0ca$var$baseGetTag;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $909a5c800afbd0ca$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
var $909a5c800afbd0ca$var$isObjectLike_1 = $909a5c800afbd0ca$var$isObjectLike;
/** `Object#toString` result references. */ var $909a5c800afbd0ca$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $909a5c800afbd0ca$var$isSymbol(value) {
    return typeof value == 'symbol' || $909a5c800afbd0ca$var$isObjectLike_1(value) && $909a5c800afbd0ca$var$_baseGetTag(value) == $909a5c800afbd0ca$var$symbolTag;
}
var $909a5c800afbd0ca$var$isSymbol_1 = $909a5c800afbd0ca$var$isSymbol;
/** Used as references for various `Number` constants. */ var $909a5c800afbd0ca$var$NAN = 0 / 0;
/** Used to match leading and trailing whitespace. */ var $909a5c800afbd0ca$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $909a5c800afbd0ca$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $909a5c800afbd0ca$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $909a5c800afbd0ca$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $909a5c800afbd0ca$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $909a5c800afbd0ca$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($909a5c800afbd0ca$var$isSymbol_1(value)) return $909a5c800afbd0ca$var$NAN;
    if ($909a5c800afbd0ca$var$isObject_1(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $909a5c800afbd0ca$var$isObject_1(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($909a5c800afbd0ca$var$reTrim, '');
    var isBinary = $909a5c800afbd0ca$var$reIsBinary.test(value);
    return isBinary || $909a5c800afbd0ca$var$reIsOctal.test(value) ? $909a5c800afbd0ca$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $909a5c800afbd0ca$var$reIsBadHex.test(value) ? $909a5c800afbd0ca$var$NAN : +value;
}
var $909a5c800afbd0ca$var$toNumber_1 = $909a5c800afbd0ca$var$toNumber;
/** Error message constants. */ var $909a5c800afbd0ca$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $909a5c800afbd0ca$var$nativeMax = Math.max, $909a5c800afbd0ca$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $909a5c800afbd0ca$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($909a5c800afbd0ca$var$FUNC_ERROR_TEXT);
    wait = $909a5c800afbd0ca$var$toNumber_1(wait) || 0;
    if ($909a5c800afbd0ca$var$isObject_1(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $909a5c800afbd0ca$var$nativeMax($909a5c800afbd0ca$var$toNumber_1(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $909a5c800afbd0ca$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $909a5c800afbd0ca$var$now_1();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($909a5c800afbd0ca$var$now_1());
    }
    function debounced() {
        var time = $909a5c800afbd0ca$var$now_1(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $909a5c800afbd0ca$var$debounce_1 = $909a5c800afbd0ca$var$debounce;
/** Error message constants. */ var $909a5c800afbd0ca$var$FUNC_ERROR_TEXT$1 = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $909a5c800afbd0ca$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($909a5c800afbd0ca$var$FUNC_ERROR_TEXT$1);
    if ($909a5c800afbd0ca$var$isObject_1(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $909a5c800afbd0ca$var$debounce_1(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
var $909a5c800afbd0ca$var$throttle_1 = $909a5c800afbd0ca$var$throttle;
var $909a5c800afbd0ca$var$windowIdleEvents = [
    'scroll',
    'resize'
];
var $909a5c800afbd0ca$var$documentIdleEvents = [
    'wheel',
    'keydown',
    'keyup',
    'mousedown',
    'mousemove',
    'touchstart',
    'touchmove',
    'click',
    'contextmenu'
];
var $909a5c800afbd0ca$var$BrowserInteractionTime = /** @class */ function() {
    function BrowserInteractionTime(_a) {
        var _b = _a.timeIntervalEllapsedCallbacks, timeIntervalEllapsedCallbacks = _b === void 0 ? [] : _b, _c = _a.absoluteTimeEllapsedCallbacks, absoluteTimeEllapsedCallbacks = _c === void 0 ? [] : _c, _d = _a.checkCallbacksIntervalMs, checkCallbacksIntervalMs = _d === void 0 ? 100 : _d, _e = _a.browserTabInactiveCallbacks, browserTabInactiveCallbacks = _e === void 0 ? [] : _e, _f = _a.idleCallbacks, idleCallbacks = _f === void 0 ? [] : _f, _g = _a.stopTimerOnTabchange, stopTimerOnTabchange = _g === void 0 ? true : _g, _h = _a.activeCallbacks, activeCallbacks = _h === void 0 ? [] : _h, _j = _a.browserTabActiveCallbacks, browserTabActiveCallbacks = _j === void 0 ? [] : _j, _k = _a.idleTimeoutMs, idleTimeoutMs = _k === void 0 ? 3000 : _k;
        var _this = this;
        this.onBrowserTabInactive = function() {
            // if running pause timer
            if (_this.isRunning() && _this.stopTimerOnTabchange) _this.stopTimer();
            _this.browserTabInactiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserTabActive = function() {
            // if not running start timer
            if (!_this.isRunning()) _this.startTimer();
            _this.browserTabActiveCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
        };
        this.onBrowserActiveChange = function() {
            if (document.visibilityState === 'visible') _this.onBrowserTabActive();
            else _this.onBrowserTabInactive();
        };
        this.onTimePassed = function() {
            // check all callbacks time and if passed execute callback
            _this.absoluteTimeEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, pending = _a.pending, timeInMilliseconds = _a.timeInMilliseconds;
                if (pending && timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.absoluteTimeEllapsedCallbacks[index].pending = false;
                }
            });
            _this.timeIntervalEllapsedCallbacks.forEach(function(_a, index) {
                var callback = _a.callback, timeInMilliseconds = _a.timeInMilliseconds, multiplier = _a.multiplier;
                if (timeInMilliseconds <= _this.getTimeInMilliseconds()) {
                    callback(_this.getTimeInMilliseconds());
                    _this.timeIntervalEllapsedCallbacks[index].timeInMilliseconds = multiplier(timeInMilliseconds);
                }
            });
            if (_this.currentIdleTimeMs >= _this.idleTimeoutMs && _this.isRunning()) {
                _this.idle = true;
                _this.stopTimer();
                _this.idleCallbacks.forEach(function(fn) {
                    return fn(_this.getTimeInMilliseconds());
                });
            } else _this.currentIdleTimeMs += _this.checkCallbacksIntervalMs;
        };
        this.resetIdleTime = function() {
            if (_this.idle) _this.startTimer();
            _this.activeCallbacks.forEach(function(fn) {
                return fn(_this.getTimeInMilliseconds());
            });
            _this.idle = false;
            _this.currentIdleTimeMs = 0;
        };
        this.registerEventListeners = function() {
            var documentListenerOptions = {
                passive: true
            };
            var windowListenerOptions = $909a5c800afbd0ca$var$__assign({}, documentListenerOptions, {
                capture: true
            });
            document.addEventListener('visibilitychange', _this.onBrowserActiveChange);
            var throttleResetIdleTime = $909a5c800afbd0ca$var$throttle_1(_this.resetIdleTime, 2000, {
                leading: true,
                trailing: false
            });
            $909a5c800afbd0ca$var$windowIdleEvents.forEach(function(event) {
                window.addEventListener(event, throttleResetIdleTime, windowListenerOptions);
            });
            $909a5c800afbd0ca$var$documentIdleEvents.forEach(function(event) {
                return document.addEventListener(event, throttleResetIdleTime, documentListenerOptions);
            });
        };
        this.unregisterEventListeners = function() {
            document.removeEventListener('visibilitychange', _this.onBrowserActiveChange);
            $909a5c800afbd0ca$var$windowIdleEvents.forEach(function(event) {
                return window.removeEventListener(event, _this.resetIdleTime);
            });
            $909a5c800afbd0ca$var$documentIdleEvents.forEach(function(event) {
                return document.removeEventListener(event, _this.resetIdleTime);
            });
        };
        this.checkCallbacksOnInterval = function() {
            _this.checkCallbackIntervalId = window.setInterval(function() {
                _this.onTimePassed();
            }, _this.checkCallbacksIntervalMs);
        };
        this.startTimer = function() {
            if (!_this.checkCallbackIntervalId) _this.checkCallbacksOnInterval();
            var last = _this.times[_this.times.length - 1];
            if (last && last.stop === null) return;
            _this.times.push({
                start: performance.now(),
                stop: null
            });
            _this.running = true;
        };
        this.stopTimer = function() {
            if (!_this.times.length) return;
            _this.times[_this.times.length - 1].stop = performance.now();
            _this.running = false;
        };
        this.addTimeIntervalEllapsedCallback = function(timeIntervalEllapsedCallback) {
            _this.timeIntervalEllapsedCallbacks.push(timeIntervalEllapsedCallback);
        };
        this.addAbsoluteTimeEllapsedCallback = function(absoluteTimeEllapsedCallback) {
            _this.absoluteTimeEllapsedCallbacks.push(absoluteTimeEllapsedCallback);
        };
        this.addBrowserTabInactiveCallback = function(browserTabInactiveCallback) {
            _this.browserTabInactiveCallbacks.push(browserTabInactiveCallback);
        };
        this.addBrowserTabActiveCallback = function(browserTabActiveCallback) {
            _this.browserTabActiveCallbacks.push(browserTabActiveCallback);
        };
        this.addIdleCallback = function(inactiveCallback) {
            _this.idleCallbacks.push(inactiveCallback);
        };
        this.addActiveCallback = function(activeCallback) {
            _this.activeCallbacks.push(activeCallback);
        };
        this.getTimeInMilliseconds = function() {
            return _this.times.reduce(function(acc, current) {
                if (current.stop) acc = acc + (current.stop - current.start);
                else acc = acc + (performance.now() - current.start);
                return acc;
            }, 0);
        };
        this.isRunning = function() {
            return _this.running;
        };
        this.isIdle = function() {
            return _this.idle;
        };
        this.reset = function() {
            _this.times = [];
        };
        this.destroy = function() {
            _this.unregisterEventListeners();
            if (_this.checkCallbackIntervalId) window.clearInterval(_this.checkCallbackIntervalId);
        };
        this.running = false;
        this.times = [];
        this.idle = false;
        this.currentIdleTimeMs = 0;
        this.marks = {};
        this.measures = {};
        this.stopTimerOnTabchange = stopTimerOnTabchange;
        this.browserTabActiveCallbacks = browserTabActiveCallbacks;
        this.browserTabInactiveCallbacks = browserTabInactiveCallbacks;
        this.checkCallbacksIntervalMs = checkCallbacksIntervalMs;
        this.idleTimeoutMs = idleTimeoutMs;
        this.timeIntervalEllapsedCallbacks = timeIntervalEllapsedCallbacks;
        this.absoluteTimeEllapsedCallbacks = absoluteTimeEllapsedCallbacks;
        this.idleCallbacks = idleCallbacks;
        this.activeCallbacks = activeCallbacks;
        this.registerEventListeners();
    }
    BrowserInteractionTime.prototype.mark = function(key) {
        if (!this.marks[key]) this.marks[key] = [];
        this.marks[key].push({
            time: this.getTimeInMilliseconds()
        });
    };
    BrowserInteractionTime.prototype.getMarks = function(name) {
        if (this.marks[name].length < 1) return;
        return this.marks[name];
    };
    BrowserInteractionTime.prototype.measure = function(name, startMarkName, endMarkName) {
        var startMarks = this.marks[startMarkName];
        var startMark = startMarks[startMarks.length - 1];
        var endMarks = this.marks[endMarkName];
        var endMark = endMarks[endMarks.length - 1];
        if (!this.measures[name]) this.measures[name] = [];
        this.measures[name].push({
            name: name,
            startTime: startMark.time,
            duration: endMark.time - startMark.time
        });
    };
    BrowserInteractionTime.prototype.getMeasures = function(name) {
        if (!this.measures[name] && this.measures[name].length < 1) return;
        return this.measures[name];
    };
    return BrowserInteractionTime;
}();
var $909a5c800afbd0ca$export$2e2bcd8739ae039 = $909a5c800afbd0ca$var$BrowserInteractionTime;

});

parcelRegister("eSI87", function(module, exports) {
$parcel$export(module.exports, "RouterActions", () => $7d2b6bb3b697247a$export$b371fa9cf762ad06);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $55BnK = parcelRequire("55BnK");
const $7d2b6bb3b697247a$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $55BnK.useRouterActions)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children(actions));
};
$7d2b6bb3b697247a$export$b371fa9cf762ad06.displayName = "RouterActions";
$7d2b6bb3b697247a$export$b371fa9cf762ad06.displayName = 'RouterActions';

});
parcelRegister("55BnK", function(module, exports) {
$parcel$export(module.exports, "useRouterActions", () => $1fc785a459914fa0$export$402e82ff1b20594b);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f2wVS = parcelRequire("f2wVS");
const $1fc785a459914fa0$export$402e82ff1b20594b = ()=>(0, $f2wVS.useRouterStoreActions)();

});


parcelRegister("bc9Gj", function(module, exports) {
$parcel$export(module.exports, "useRouter", () => $3c274e6df1889f1a$export$9a302a45f65d0572);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $f2wVS = parcelRequire("f2wVS");
const $3c274e6df1889f1a$export$9a302a45f65d0572 = ()=>(0, $f2wVS.useRouterStore)();

});

parcelRegister("jpPNt", function(module, exports) {
$parcel$export(module.exports, "Link", () => $1253562e73a0341c$export$a6c7ac8248d6e38a);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $kY9Lm = parcelRequire("kY9Lm");

var $kQAUa = parcelRequire("kQAUa");

var $7bJ0J = parcelRequire("7bJ0J");

var $f2wVS = parcelRequire("f2wVS");

var $hFkUL = parcelRequire("hFkUL");

var $lBdQZ = parcelRequire("lBdQZ");
const $1253562e73a0341c$var$PREFETCH_DELAY = 225;
const $1253562e73a0341c$export$a6c7ac8248d6e38a = /*#__PURE__*/ (0, $euxye.forwardRef)(({ children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state, ...rest }, ref)=>{
    const routerActions = (0, $f2wVS.useRouterStoreActions)();
    const { schedule: schedule, cancel: cancel } = (0, $hFkUL.useTimeout)($1253562e73a0341c$var$PREFETCH_DELAY);
    const validLinkType = linkType === 'a' || linkType === 'button' ? linkType : 'a';
    const [route, setRoute] = (0, $euxye.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    (0, $euxye.useEffect)(()=>{
        if (to && typeof to !== 'string' && !route && 'then' in to) // eslint-disable-next-line react-you-might-not-need-an-effect/no-pass-live-state-to-parent
        to.then((r)=>setRoute('default' in r ? r.default : r));
    }, [
        to,
        route
    ]);
    let routeValue = route;
    if (!routeValue && to && typeof to !== 'string' && !('then' in to)) // use the prop instead of the value in useState
    routeValue = to;
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = // eslint-disable-next-line no-nested-ternary
    href != null ? href : typeof to !== 'string' ? routeValue && (0, $kY9Lm.createPath)((0, $kQAUa.generateLocationFromPath)(routeValue.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $euxye.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !routeValue) return;
        const context = typeof to !== 'string' && routeValue ? (0, $7bJ0J.createRouterContext)(routeValue, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        routeValue,
        linkDestination,
        routerActions
    ]);
    (0, $euxye.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $lBdQZ.handleNavigation)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: routeValue && [
                routeValue,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $euxye.createElement)(validLinkType, {
        ...rest,
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }, children);
});
$1253562e73a0341c$export$a6c7ac8248d6e38a.displayName = 'Link';

});
parcelRegister("hFkUL", function(module, exports) {
$parcel$export(module.exports, "useTimeout", () => $2c3fc0ffba25c3da$export$d8e6abf214c9ec0f);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");
const $2c3fc0ffba25c3da$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $euxye.useRef)();
    const schedule = (0, $euxye.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $euxye.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};

});

parcelRegister("lBdQZ", function(module, exports) {
$parcel$export(module.exports, "handleNavigation", () => $5aa656bfe2d27e22$export$706ad1af8096e280);

var $9omAo = parcelRequire("9omAo");
const $5aa656bfe2d27e22$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $9omAo.isKeyboardEvent)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $9omAo.isKeyboardEvent)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $9omAo.isModifiedEvent)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};

});
parcelRegister("9omAo", function(module, exports) {
$parcel$export(module.exports, "isModifiedEvent", () => $4e080cd80abe24ea$export$642c6f14f6d4bbd5);
$parcel$export(module.exports, "isKeyboardEvent", () => $4e080cd80abe24ea$export$130b789831072f4c);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ const $4e080cd80abe24ea$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $4e080cd80abe24ea$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);

});



parcelRegister("dR379", function(module, exports) {
$parcel$export(module.exports, "Router", () => $62fb9b7dc019964d$export$55185c17a0fcbe46);
/* eslint-disable jira/filename-case */ 
var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");
const $62fb9b7dc019964d$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes, isLazyRoutes: isLazyRoutes = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $f2wVS.RouterContainer), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins ?? [],
        routes: routes,
        isLazyRoutes: isLazyRoutes
    }, children);
$62fb9b7dc019964d$export$55185c17a0fcbe46.displayName = "Router";

});

parcelRegister("2ffUK", function(module, exports) {
$parcel$export(module.exports, "useQueryParam", () => $53b9e92013e96fb4$export$ae316f0eeb712a36);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");

var $f2wVS = parcelRequire("f2wVS");
const $53b9e92013e96fb4$var$useCreateQueryParam = (0, $3h1FP.createHook)((0, $f2wVS.RouterStore), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $53b9e92013e96fb4$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $53b9e92013e96fb4$var$useCreateQueryParam({
        paramKey: paramKey
    });
    const setQueryParam = (0, $euxye.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};

});

parcelRegister("cZjb4", function(module, exports) {
$parcel$export(module.exports, "usePathParam", () => $3722189e8a4ed5db$export$8c8591dcd57728e6);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $3h1FP = parcelRequire("3h1FP");

var $f2wVS = parcelRequire("f2wVS");
const $3722189e8a4ed5db$var$useCreatePathParamHook = (0, $3h1FP.createHook)((0, $f2wVS.RouterStore), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $3722189e8a4ed5db$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $3722189e8a4ed5db$var$useCreatePathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $euxye.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};

});

parcelRegister("64mj3", function(module, exports) {
$parcel$export(module.exports, "addResourcesListener", () => $7c12ac3a5da40f3c$export$dee7bf9fc0ff48c3);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ // eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $bYonX = parcelRequire("bYonX");
const $7c12ac3a5da40f3c$export$dee7bf9fc0ff48c3 = (fn)=>(0, $bYonX.getResourceStore)().storeState.subscribe(fn);

});

parcelRegister("gNbXR", function(module, exports) {
$parcel$export(module.exports, "Redirect", () => $62c815148c90a2e0$export$2d8d895a0a0f636e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $kY9Lm = parcelRequire("kY9Lm");

var $aFBfN = parcelRequire("aFBfN");

var $kQAUa = parcelRequire("kQAUa");

var $bc9Gj = parcelRequire("bc9Gj");
// eslint-disable-next-line jira/react/no-class-components
class $62c815148c90a2e0$var$Redirector extends (0, $euxye.Component) {
    static{
        this.defaultProps = {
            push: false
        };
    }
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = // eslint-disable-next-line no-nested-ternary
        typeof to === 'object' ? 'path' in to ? (0, $kY9Lm.createPath)((0, $kQAUa.generateLocationFromPath)(to.path, routeAttributes)) : (0, $kY9Lm.createPath)(to) : to;
        const currentPath = (0, $kY9Lm.createPath)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
$62c815148c90a2e0$var$Redirector.displayName = "Redirector";
const $62c815148c90a2e0$export$c98fd7767e1bf30c = ({ to: to, params: params, query: query })=>{
    const getRedirectPath = ()=>{
        if (typeof to === 'string') return to;
        if ('path' in to) {
            const routeAttributes = {
                params: params,
                query: query
            };
            return (0, $kY9Lm.createPath)((0, $kQAUa.generateLocationFromPath)(to.path, routeAttributes));
        }
        return (0, $kY9Lm.createPath)(to);
    };
    const redirectPath = getRedirectPath();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement("meta", {
        httpEquiv: "refresh",
        content: `0; url=${redirectPath}`,
        "data-testid": "@atlassian/react-resource-router.controllers.redirect.server-redirect-meta"
    });
};
$62c815148c90a2e0$export$c98fd7767e1bf30c.displayName = "ServerRedirect";
const $62c815148c90a2e0$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $bc9Gj.useRouter)();
    return (0, $aFBfN.IS_MODERN_SSR) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($62c815148c90a2e0$export$c98fd7767e1bf30c, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement($62c815148c90a2e0$var$Redirector, {
        actions: actions,
        location: location,
        ...props
    });
};
$62c815148c90a2e0$export$2d8d895a0a0f636e.displayName = "Redirect";

});

parcelRegister("45DC3", function(module, exports) {
$parcel$export(module.exports, "RouterSubscriber", () => $72a55957c9f8dbfd$export$672d721d310ff5f0);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $8ovy4 = parcelRequire("8ovy4");

var $f2wVS = parcelRequire("f2wVS");
const $72a55957c9f8dbfd$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, { listen: listen, ...actions }] = (0, $f2wVS.useRouterStore)();
    if (!state.unlisten && !(0, $8ovy4.isServerEnvironment)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children(state, actions));
};
$72a55957c9f8dbfd$export$672d721d310ff5f0.displayName = "RouterSubscriber";

});

parcelRegister("e2Tle", function(module, exports) {
$parcel$export(module.exports, "withRouter", () => $8ca39ae7306fbe33$export$369b6b2b30582e8e);
/* eslint-disable jira/naming/disallow-filenames */ // eslint-disable-next-line jira/filename-case

var $euxye = parcelRequire("euxye");

var $f2wVS = parcelRequire("f2wVS");
const $8ca39ae7306fbe33$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $8ca39ae7306fbe33$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $8ca39ae7306fbe33$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $f2wVS.useRouterStore)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(Component, {
            ...props,
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        });
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};

});

parcelRegister("2IQF9", function(module, exports) {
/*Copyright (c) 2020 Jason Zissman
Permission is hereby granted, free of charge, to any person obtaining a copy of
this software and associated documentation files (the "Software"), to deal in
the Software without restriction, including without limitation the rights to
use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
the Software, and to permit persons to whom the Software is furnished to do so,
subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
*/ (()=>{
    ((root, factory)=>{
        if (module.exports) // CommonJS
        return module.exports = factory();
        else if (typeof define === 'function' && define.amd) // AMD
        define([], ()=>{
            return root.TimeMe = factory();
        });
        else // Global Variables
        return root.TimeMe = factory();
    })(module.exports, ()=>{
        let TimeMe = {
            startStopTimes: {},
            idleTimeoutMs: 30000,
            currentIdleTimeMs: 0,
            checkIdleStateRateMs: 250,
            isUserCurrentlyOnPage: true,
            isUserCurrentlyIdle: false,
            currentPageName: "default-page-name",
            timeElapsedCallbacks: [],
            userLeftCallbacks: [],
            userReturnCallbacks: [],
            trackTimeOnElement: (elementId)=>{
                let element = document.getElementById(elementId);
                if (element) {
                    element.addEventListener("mouseover", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mousemove", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("mouseleave", ()=>{
                        TimeMe.stopTimer(elementId);
                    });
                    element.addEventListener("keypress", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                    element.addEventListener("focus", ()=>{
                        TimeMe.startTimer(elementId);
                    });
                }
            },
            getTimeOnElementInSeconds: (elementId)=>{
                let time = TimeMe.getTimeOnPageInSeconds(elementId);
                if (time) return time;
                else return 0;
            },
            // startTime is optional. If provided, must be of type Date(). By providing
            // startTime, you are overriding the internal timing mechanism and manually
            // indicating the start time.
            startTimer: (pageName, startTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                if (TimeMe.startStopTimes[pageName] === undefined) TimeMe.startStopTimes[pageName] = [];
                else {
                    let arrayOfTimes = TimeMe.startStopTimes[pageName];
                    let latestStartStopEntry = arrayOfTimes[arrayOfTimes.length - 1];
                    if (latestStartStopEntry !== undefined && latestStartStopEntry.stopTime === undefined) // Can't start new timer until previous finishes.
                    return;
                }
                TimeMe.startStopTimes[pageName].push({
                    "startTime": startTime || new Date(),
                    "stopTime": undefined
                });
            },
            stopAllTimers: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.stopTimer(pageNames[i]);
            },
            // stopTime is optional. If provided, must be of type Date(). By providing
            // stopTime, you are overriding the internal timing mechanism and manually
            // indicating the stop time.
            stopTimer: (pageName, stopTime)=>{
                if (!pageName) pageName = TimeMe.currentPageName;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined || arrayOfTimes.length === 0) // Can't stop timer before you've started it.
                return;
                if (arrayOfTimes[arrayOfTimes.length - 1].stopTime === undefined) arrayOfTimes[arrayOfTimes.length - 1].stopTime = stopTime || new Date();
            },
            getTimeOnCurrentPageInSeconds: ()=>{
                return TimeMe.getTimeOnPageInSeconds(TimeMe.currentPageName);
            },
            getTimeOnPageInSeconds: (pageName)=>{
                let timeInMs = TimeMe.getTimeOnPageInMilliseconds(pageName);
                if (timeInMs === undefined) return undefined;
                else return timeInMs / 1000;
            },
            getTimeOnCurrentPageInMilliseconds: ()=>{
                return TimeMe.getTimeOnPageInMilliseconds(TimeMe.currentPageName);
            },
            getTimeOnPageInMilliseconds: (pageName)=>{
                let totalTimeOnPage = 0;
                let arrayOfTimes = TimeMe.startStopTimes[pageName];
                if (arrayOfTimes === undefined) // Can't get time on page before you've started the timer.
                return;
                let timeSpentOnPageInSeconds = 0;
                for(let i = 0; i < arrayOfTimes.length; i++){
                    let startTime = arrayOfTimes[i].startTime;
                    let stopTime = arrayOfTimes[i].stopTime;
                    if (stopTime === undefined) stopTime = new Date();
                    let difference = stopTime - startTime;
                    timeSpentOnPageInSeconds += difference;
                }
                totalTimeOnPage = Number(timeSpentOnPageInSeconds);
                return totalTimeOnPage;
            },
            getTimeOnAllPagesInSeconds: ()=>{
                let allTimes = [];
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++){
                    let pageName = pageNames[i];
                    let timeOnPage = TimeMe.getTimeOnPageInSeconds(pageName);
                    allTimes.push({
                        "pageName": pageName,
                        "timeOnPage": timeOnPage
                    });
                }
                return allTimes;
            },
            setIdleDurationInSeconds: (duration)=>{
                let durationFloat = parseFloat(duration);
                if (isNaN(durationFloat) === false) TimeMe.idleTimeoutMs = duration * 1000;
                else throw {
                    name: "InvalidDurationException",
                    message: "An invalid duration time (" + duration + ") was provided."
                };
            },
            setCurrentPageName: (pageName)=>{
                TimeMe.currentPageName = pageName;
            },
            resetRecordedPageTime: (pageName)=>{
                delete TimeMe.startStopTimes[pageName];
            },
            resetAllRecordedPageTimes: ()=>{
                let pageNames = Object.keys(TimeMe.startStopTimes);
                for(let i = 0; i < pageNames.length; i++)TimeMe.resetRecordedPageTime(pageNames[i]);
            },
            userActivityDetected: ()=>{
                if (TimeMe.isUserCurrentlyIdle) TimeMe.triggerUserHasReturned();
                TimeMe.resetIdleCountdown();
            },
            resetIdleCountdown: ()=>{
                TimeMe.isUserCurrentlyIdle = false;
                TimeMe.currentIdleTimeMs = 0;
            },
            callWhenUserLeaves: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userLeftCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            callWhenUserReturns: (callback, numberOfTimesToInvoke)=>{
                TimeMe.userReturnCallbacks.push({
                    callback: callback,
                    numberOfTimesToInvoke: numberOfTimesToInvoke
                });
            },
            triggerUserHasReturned: ()=>{
                if (!TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = true;
                    TimeMe.resetIdleCountdown();
                    for(let i = 0; i < TimeMe.userReturnCallbacks.length; i++){
                        let userReturnedCallback = TimeMe.userReturnCallbacks[i];
                        let numberTimes = userReturnedCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userReturnedCallback.numberOfTimesToInvoke -= 1;
                            userReturnedCallback.callback();
                        }
                    }
                }
                TimeMe.startTimer();
            },
            // TODO - we are muddying the waters in between
            // 'user left page' and 'user gone idle'. Really should be
            // two separate concepts entirely. Need to break this into smaller  functions
            // for either scenario.
            triggerUserHasLeftPageOrGoneIdle: ()=>{
                if (TimeMe.isUserCurrentlyOnPage) {
                    TimeMe.isUserCurrentlyOnPage = false;
                    for(let i = 0; i < TimeMe.userLeftCallbacks.length; i++){
                        let userHasLeftCallback = TimeMe.userLeftCallbacks[i];
                        let numberTimes = userHasLeftCallback.numberOfTimesToInvoke;
                        if (isNaN(numberTimes) || numberTimes === undefined || numberTimes > 0) {
                            userHasLeftCallback.numberOfTimesToInvoke -= 1;
                            userHasLeftCallback.callback();
                        }
                    }
                }
                TimeMe.stopAllTimers();
            },
            callAfterTimeElapsedInSeconds: (timeInSeconds, callback)=>{
                TimeMe.timeElapsedCallbacks.push({
                    timeInSeconds: timeInSeconds,
                    callback: callback,
                    pending: true
                });
            },
            checkIdleState: ()=>{
                for(let i = 0; i < TimeMe.timeElapsedCallbacks.length; i++)if (TimeMe.timeElapsedCallbacks[i].pending && TimeMe.getTimeOnCurrentPageInSeconds() > TimeMe.timeElapsedCallbacks[i].timeInSeconds) {
                    TimeMe.timeElapsedCallbacks[i].callback();
                    TimeMe.timeElapsedCallbacks[i].pending = false;
                }
                if (TimeMe.isUserCurrentlyIdle === false && TimeMe.currentIdleTimeMs > TimeMe.idleTimeoutMs) {
                    TimeMe.isUserCurrentlyIdle = true;
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                } else TimeMe.currentIdleTimeMs += TimeMe.checkIdleStateRateMs;
            },
            visibilityChangeEventName: undefined,
            hiddenPropName: undefined,
            listenForVisibilityEvents: (trackWhenUserLeavesPage, trackWhenUserGoesIdle)=>{
                if (trackWhenUserLeavesPage) TimeMe.listenForUserLeavesOrReturnsEvents();
                if (trackWhenUserGoesIdle) TimeMe.listForIdleEvents();
            },
            listenForUserLeavesOrReturnsEvents: ()=>{
                if (typeof document.hidden !== "undefined") {
                    TimeMe.hiddenPropName = "hidden";
                    TimeMe.visibilityChangeEventName = "visibilitychange";
                } else if (typeof document.mozHidden !== "undefined") {
                    TimeMe.hiddenPropName = "mozHidden";
                    TimeMe.visibilityChangeEventName = "mozvisibilitychange";
                } else if (typeof document.msHidden !== "undefined") {
                    TimeMe.hiddenPropName = "msHidden";
                    TimeMe.visibilityChangeEventName = "msvisibilitychange";
                } else if (typeof document.webkitHidden !== "undefined") {
                    TimeMe.hiddenPropName = "webkitHidden";
                    TimeMe.visibilityChangeEventName = "webkitvisibilitychange";
                }
                document.addEventListener(TimeMe.visibilityChangeEventName, ()=>{
                    if (document[TimeMe.hiddenPropName]) TimeMe.triggerUserHasLeftPageOrGoneIdle();
                    else TimeMe.triggerUserHasReturned();
                }, false);
                window.addEventListener('blur', ()=>{
                    TimeMe.triggerUserHasLeftPageOrGoneIdle();
                });
                window.addEventListener('focus', ()=>{
                    TimeMe.triggerUserHasReturned();
                });
            },
            listForIdleEvents: ()=>{
                document.addEventListener("mousemove", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("keyup", ()=>{
                    TimeMe.userActivityDetected();
                });
                document.addEventListener("touchstart", ()=>{
                    TimeMe.userActivityDetected();
                });
                window.addEventListener("scroll", ()=>{
                    TimeMe.userActivityDetected();
                });
                setInterval(()=>{
                    if (TimeMe.isUserCurrentlyIdle !== true) TimeMe.checkIdleState();
                }, TimeMe.checkIdleStateRateMs);
            },
            websocket: undefined,
            websocketHost: undefined,
            setUpWebsocket: (websocketOptions)=>{
                if (window.WebSocket && websocketOptions) {
                    let websocketHost = websocketOptions.websocketHost; // "ws://hostname:port"
                    try {
                        TimeMe.websocket = new WebSocket(websocketHost);
                        window.onbeforeunload = ()=>{
                            TimeMe.sendCurrentTime(websocketOptions.appId);
                        };
                        TimeMe.websocket.onopen = ()=>{
                            TimeMe.sendInitWsRequest(websocketOptions.appId);
                        };
                        TimeMe.websocket.onerror = (error)=>{
                            if (console) console.log("Error occurred in websocket connection: " + error);
                        };
                        TimeMe.websocket.onmessage = (event)=>{
                            if (console) console.log(event.data);
                        };
                    } catch (error) {
                        if (console) console.error("Failed to connect to websocket host.  Error:" + error);
                    }
                }
            },
            websocketSend: (data)=>{
                TimeMe.websocket.send(JSON.stringify(data));
            },
            sendCurrentTime: (appId)=>{
                let timeSpentOnPage = TimeMe.getTimeOnCurrentPageInMilliseconds();
                let data = {
                    type: "INSERT_TIME",
                    appId: appId,
                    timeOnPageMs: timeSpentOnPage,
                    pageName: TimeMe.currentPageName
                };
                TimeMe.websocketSend(data);
            },
            sendInitWsRequest: (appId)=>{
                let data = {
                    type: "INIT",
                    appId: appId
                };
                TimeMe.websocketSend(data);
            },
            initialize: (options)=>{
                let idleTimeoutInSeconds = TimeMe.idleTimeoutMs || 30;
                let currentPageName = TimeMe.currentPageName || "default-page-name";
                let websocketOptions = undefined;
                let initialStartTime = undefined;
                let trackWhenUserLeavesPage = true;
                let trackWhenUserGoesIdle = true;
                if (options) {
                    idleTimeoutInSeconds = options.idleTimeoutInSeconds || idleTimeoutInSeconds;
                    currentPageName = options.currentPageName || currentPageName;
                    websocketOptions = options.websocketOptions;
                    initialStartTime = options.initialStartTime;
                    if (options.trackWhenUserLeavesPage === false) trackWhenUserLeavesPage = false;
                    if (options.trackWhenUserGoesIdle === false) trackWhenUserGoesIdle = false;
                }
                TimeMe.setIdleDurationInSeconds(idleTimeoutInSeconds);
                TimeMe.setCurrentPageName(currentPageName);
                TimeMe.setUpWebsocket(websocketOptions);
                TimeMe.listenForVisibilityEvents(trackWhenUserLeavesPage, trackWhenUserGoesIdle);
                // TODO - only do this if page currently visible.
                TimeMe.startTimer(undefined, initialStartTime);
            }
        };
        return TimeMe;
    });
}).call(module.exports);

});

parcelRegister("8hY69", function(module, exports) {
$parcel$export(module.exports, "MemoryRouter", () => $84c5a2397005e3a7$export$ae46f04cfaffe093);

var $euxye = parcelRequire("euxye");

var $kY9Lm = parcelRequire("kY9Lm");

var $dR379 = parcelRequire("dR379");
function $84c5a2397005e3a7$export$ae46f04cfaffe093(props) {
    const history = (0, $euxye.useMemo)(()=>(0, $kY9Lm.createMemoryHistory)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, $dR379.Router), {
        ...props,
        history: history,
        isGlobal: false,
        plugins: props?.plugins ?? []
    });
}
$84c5a2397005e3a7$export$ae46f04cfaffe093.displayName = "MemoryRouter";

});

parcelRegister("8VyVe", function(module, exports) {
$parcel$export(module.exports, "RouteComponent", () => $e340a93e7d0c59a0$export$7903e4b73fc7d6c3);

var $euxye = parcelRequire("euxye");

var $bc9Gj = parcelRequire("bc9Gj");
const $e340a93e7d0c59a0$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $bc9Gj.useRouter)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};
$e340a93e7d0c59a0$export$7903e4b73fc7d6c3.displayName = "RouteComponent";

});

parcelRegister("a0MAF", function(module, exports) {
$parcel$export(module.exports, "ResourceSubscriber", () => $358b872098497cbe$export$fee1a6213543bd78);
/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */ 
var $euxye = parcelRequire("euxye");

var $k6ufm = parcelRequire("k6ufm");
const $358b872098497cbe$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $k6ufm.useResource)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($euxye))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($euxye))).Fragment, null, children(result));
};
$358b872098497cbe$export$fee1a6213543bd78.displayName = "ResourceSubscriber";

});

const $32f4f7c20d37fe6f$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $32f4f7c20d37fe6f$export$f005e2e9f707cb5f = 'commercial';
const $32f4f7c20d37fe6f$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $32f4f7c20d37fe6f$export$a739cd5aac835909 = 'stg';
const $32f4f7c20d37fe6f$export$42dd0cdd351a4a9 = 'prod';
const $32f4f7c20d37fe6f$export$404582bc18fe4d9e = 'dev';

const $454bc9fe95ddf677$export$42f4885608027d0c = 'non_boolean';

const $a858cae85500b1b2$export$cf090d5281b5ae06 = 10000;
const $a858cae85500b1b2$export$8575e30be0feb909 = 30000;

/**
 * Character key codes which can be used in keyboard events.
 */ const $48dedd10700aff3c$export$390330c10ff2b9a1 = 'ArrowUp';
const $48dedd10700aff3c$export$a80636c6f41931fe = 'ArrowDown';
const $48dedd10700aff3c$export$fc4577f2a2af0ae3 = 'ArrowLeft';
const $48dedd10700aff3c$export$c40f9845adc73fb5 = 'ArrowRight';
const $48dedd10700aff3c$export$4af703091671bc = 'Home';
const $48dedd10700aff3c$export$e2bc30913faa5db7 = 'End';
const $48dedd10700aff3c$export$10f6869ed0a7d75b = 'Tab';
const $48dedd10700aff3c$export$8152f929a25a0ff4 = 'Enter';
const $48dedd10700aff3c$export$e51a3576c045c8d5 = 'Space';
const $48dedd10700aff3c$export$2bb790b9008907b4 = 'Escape';

const $f12a3c5938f2e39b$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
const $f12a3c5938f2e39b$export$72f415121273627e = 'body > .atlaskit-portal-container';
const $f12a3c5938f2e39b$export$13f57c02915787b3 = 'atlaskit-portal';

const $607cd8ed0bd97f9c$export$ed5835cc67e87f72 = 'akPortalMount';
const $607cd8ed0bd97f9c$export$80816bd900e5bd00 = 'akPortalUnmount';

// same types defined in analytics-web-client but avoid creating dependency with that
const $6d4033511f75ada1$export$a1562d08625f5d7e = 'ui';
const $6d4033511f75ada1$export$947dac6c72b26f81 = 'track';
const $6d4033511f75ada1$export$f1d537d508d2945a = 'screen';
const $6d4033511f75ada1$export$12346a674644c156 = 'operational';
const $6d4033511f75ada1$export$b055de0e665cb20c = 'unknown';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $c4e639dc1b853f95$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

const $9eab319dcc173e7e$export$d6830277b06edd6 = 'normal';


$parcel$global.rlb("5qC72")
//# sourceMappingURL=shared~vendor~ar.e3d51730.js.map
